
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9b2c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9b2c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("ctISH", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $2wKOZ = parcelRequire("2wKOZ");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $2wKOZ.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 * @deprecated This function will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        // eslint-disable-next-line deprecation/deprecation
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        // eslint-disable-next-line deprecation/deprecation
        const { cwd } = dynamicRequire(existingModule, 'process');
        // eslint-disable-next-line deprecation/deprecation
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("2wKOZ", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $1d72e3a9e632bed3$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $1d72e3a9e632bed3$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("ikqdL", function(module, exports) {

var $6lBJo = parcelRequire("6lBJo");

var $Xus0v = parcelRequire("Xus0v");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $d57e6f3349076887$var$camelCase = $Xus0v(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $6lBJo(word) : word);
});
module.exports = $d57e6f3349076887$var$camelCase;

});
parcelRegister("6lBJo", function(module, exports) {

var $l6E2L = parcelRequire("l6E2L");

var $iKqE0 = parcelRequire("iKqE0");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $49f1f8db3e260fbf$var$capitalize(string) {
    return $iKqE0($l6E2L(string).toLowerCase());
}
module.exports = $49f1f8db3e260fbf$var$capitalize;

});
parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + '';
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});

parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});




parcelRegister("iKqE0", function(module, exports) {

var $1ammj = parcelRequire("1ammj");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $1ammj('toUpperCase');
module.exports = $da6130e1e4702e32$var$upperFirst;

});
parcelRegister("1ammj", function(module, exports) {

var $hQFv5 = parcelRequire("hQFv5");

var $05hp8 = parcelRequire("05hp8");

var $dgUhg = parcelRequire("dgUhg");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $l6E2L(string);
        var strSymbols = $05hp8(string) ? $dgUhg(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $hQFv5(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $0d9811a54a2f955a$var$createCaseFirst;

});
parcelRegister("hQFv5", function(module, exports) {

var $1quiu = parcelRequire("1quiu");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $1quiu(array, start, end);
}
module.exports = $cfe77c1a7b7c7d6e$var$castSlice;

});
parcelRegister("1quiu", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $109fb88fe59de104$var$baseSlice;

});


parcelRegister("05hp8", function(module, exports) {
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
module.exports = $00fdf7eab00be2e7$var$hasUnicode;

});

parcelRegister("dgUhg", function(module, exports) {

var $5OuFP = parcelRequire("5OuFP");

var $05hp8 = parcelRequire("05hp8");

var $gNXOw = parcelRequire("gNXOw");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $05hp8(string) ? $gNXOw(string) : $5OuFP(string);
}
module.exports = $9a986c87d425808c$var$stringToArray;

});
parcelRegister("5OuFP", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $43b96a6d93895c83$var$asciiToArray;

});

parcelRegister("gNXOw", function(module, exports) {
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = '\\ud800-\\udfff', $c3bf9ebcb1b53b1d$var$rsComboMarksRange = '\\u0300-\\u036f', $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = '[' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsCombo = '[' + $c3bf9ebcb1b53b1d$var$rsComboRange + ']', $c3bf9ebcb1b53b1d$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c3bf9ebcb1b53b1d$var$rsModifier = '(?:' + $c3bf9ebcb1b53b1d$var$rsCombo + '|' + $c3bf9ebcb1b53b1d$var$rsFitz + ')', $c3bf9ebcb1b53b1d$var$rsNonAstral = '[^' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c3bf9ebcb1b53b1d$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c3bf9ebcb1b53b1d$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + '?', $c3bf9ebcb1b53b1d$var$rsOptVar = '[' + $c3bf9ebcb1b53b1d$var$rsVarRange + ']?', $c3bf9ebcb1b53b1d$var$rsOptJoin = '(?:' + $c3bf9ebcb1b53b1d$var$rsZWJ + '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join('|') + ')' + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ')*', $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + '?',
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + '(?=' + $c3bf9ebcb1b53b1d$var$rsFitz + ')|' + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
module.exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;

});





parcelRegister("Xus0v", function(module, exports) {

var $1FZZ3 = parcelRequire("1FZZ3");

var $koe5E = parcelRequire("koe5E");

var $1CRrQ = parcelRequire("1CRrQ");
/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1FZZ3($1CRrQ($koe5E(string).replace($0b2d21aee1d97729$var$reApos, '')), callback, '');
    };
}
module.exports = $0b2d21aee1d97729$var$createCompounder;

});
parcelRegister("1FZZ3", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $1389b3710f5da9e8$var$arrayReduce;

});

parcelRegister("koe5E", function(module, exports) {

var $4qdBK = parcelRequire("4qdBK");

var $l6E2L = parcelRequire("l6E2L");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = '\\u0300-\\u036f', $ed80fa8833e2b532$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ed80fa8833e2b532$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = '[' + $ed80fa8833e2b532$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $l6E2L(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $4qdBK).replace($ed80fa8833e2b532$var$reComboMark, '');
}
module.exports = $ed80fa8833e2b532$var$deburr;

});
parcelRegister("4qdBK", function(module, exports) {

var $iWLIn = parcelRequire("iWLIn");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $iWLIn($3384256242a1b577$var$deburredLetters);
module.exports = $3384256242a1b577$var$deburrLetter;

});
parcelRegister("iWLIn", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $dcb2a7eb44d37cba$var$basePropertyOf;

});



parcelRegister("1CRrQ", function(module, exports) {

var $aP9V7 = parcelRequire("aP9V7");

var $by7Kg = parcelRequire("by7Kg");

var $l6E2L = parcelRequire("l6E2L");

var $4k1Gy = parcelRequire("4k1Gy");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $l6E2L(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $by7Kg(string) ? $4k1Gy(string) : $aP9V7(string);
    return string.match(pattern) || [];
}
module.exports = $12f2ccb7e11b3895$var$words;

});
parcelRegister("aP9V7", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
module.exports = $7e165cbd28a9af51$var$asciiWords;

});

parcelRegister("by7Kg", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
module.exports = $8688e0b23f5a081b$var$hasUnicodeWord;

});

parcelRegister("4k1Gy", function(module, exports) {
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = '\\ud800-\\udfff', $325a565efdffbc96$var$rsComboMarksRange = '\\u0300-\\u036f', $325a565efdffbc96$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $325a565efdffbc96$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = '\\u2700-\\u27bf', $325a565efdffbc96$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $325a565efdffbc96$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $325a565efdffbc96$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $325a565efdffbc96$var$rsPunctuationRange = '\\u2000-\\u206f', $325a565efdffbc96$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $325a565efdffbc96$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $325a565efdffbc96$var$rsVarRange = '\\ufe0e\\ufe0f', $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['\u2019]", $325a565efdffbc96$var$rsBreak = '[' + $325a565efdffbc96$var$rsBreakRange + ']', $325a565efdffbc96$var$rsCombo = '[' + $325a565efdffbc96$var$rsComboRange + ']', $325a565efdffbc96$var$rsDigits = '\\d+', $325a565efdffbc96$var$rsDingbat = '[' + $325a565efdffbc96$var$rsDingbatRange + ']', $325a565efdffbc96$var$rsLower = '[' + $325a565efdffbc96$var$rsLowerRange + ']', $325a565efdffbc96$var$rsMisc = '[^' + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $325a565efdffbc96$var$rsModifier = '(?:' + $325a565efdffbc96$var$rsCombo + '|' + $325a565efdffbc96$var$rsFitz + ')', $325a565efdffbc96$var$rsNonAstral = '[^' + $325a565efdffbc96$var$rsAstralRange + ']', $325a565efdffbc96$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $325a565efdffbc96$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $325a565efdffbc96$var$rsUpper = '[' + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = '(?:' + $325a565efdffbc96$var$rsLower + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsMiscUpper = '(?:' + $325a565efdffbc96$var$rsUpper + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsOptContrLower = '(?:' + $325a565efdffbc96$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $325a565efdffbc96$var$rsOptContrUpper = '(?:' + $325a565efdffbc96$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + '?', $325a565efdffbc96$var$rsOptVar = '[' + $325a565efdffbc96$var$rsVarRange + ']?', $325a565efdffbc96$var$rsOptJoin = '(?:' + $325a565efdffbc96$var$rsZWJ + '(?:' + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ')*', $325a565efdffbc96$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $325a565efdffbc96$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = '(?:' + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsLower + '+' + $325a565efdffbc96$var$rsOptContrLower + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsMiscUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsMiscLower + '+' + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
module.exports = $325a565efdffbc96$var$unicodeWords;

});




parcelRegister("3DXWh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2a738245fbef5f76$export$2e2bcd8739ae039);

var $6dr9s = parcelRequire("6dr9s");
var $2a738245fbef5f76$export$2e2bcd8739ae039 = (0, $6dr9s.default);

});
parcelRegister("6dr9s", function(module, exports) {

$parcel$export(module.exports, "default", () => $486904b4df561ec3$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");

var $iORrr = parcelRequire("iORrr");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("8iiJy");
var $eGxZY = parcelRequire("eGxZY");

var $9gkwb = parcelRequire("9gkwb");

var $fytPh = parcelRequire("fytPh");
var $486904b4df561ec3$var$_excluded = [
    "getContainer"
];
var $486904b4df561ec3$var$seed = 0;
var $486904b4df561ec3$var$now = Date.now();
function $486904b4df561ec3$var$getUuid() {
    var id = $486904b4df561ec3$var$seed;
    $486904b4df561ec3$var$seed += 1;
    return "rcNotification_".concat($486904b4df561ec3$var$now, "_").concat(id);
}
var $486904b4df561ec3$var$Notification = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Notification, _Component);
    var _super = (0, $enfmq.default)(Notification);
    function Notification() {
        var _this;
        (0, $6CZeq.default)(this, Notification);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            notices: []
        };
        _this.hookRefs = new Map();
        _this.add = function(originNotice, holderCallback) {
            var _originNotice$key;
            var key = (_originNotice$key = originNotice.key) !== null && _originNotice$key !== void 0 ? _originNotice$key : $486904b4df561ec3$var$getUuid();
            var notice = (0, $d49SP.default)((0, $d49SP.default)({}, originNotice), {}, {
                key: key
            });
            var maxCount = _this.props.maxCount;
            _this.setState(function(previousState) {
                var notices = previousState.notices;
                var noticeIndex = notices.map(function(v) {
                    return v.notice.key;
                }).indexOf(key);
                var updatedNotices = notices.concat();
                if (noticeIndex !== -1) updatedNotices.splice(noticeIndex, 1, {
                    notice: notice,
                    holderCallback: holderCallback
                });
                else {
                    if (maxCount && notices.length >= maxCount) {
                        // XXX, use key of first item to update new added (let React to move exsiting
                        // instead of remove and mount). Same key was used before for both a) external
                        // manual control and b) internal react 'key' prop , which is not that good.
                        // eslint-disable-next-line no-param-reassign
                        // zombieJ: Not know why use `updateKey`. This makes Notice infinite loop in jest.
                        // Change to `updateMark` for compare instead.
                        // https://github.com/react-component/notification/commit/32299e6be396f94040bfa82517eea940db947ece
                        notice.key = updatedNotices[0].notice.key;
                        notice.updateMark = $486904b4df561ec3$var$getUuid();
                        // zombieJ: That's why. User may close by key directly.
                        // We need record this but not re-render to avoid upper issue
                        // https://github.com/react-component/notification/issues/129
                        notice.userPassKey = key;
                        updatedNotices.shift();
                    }
                    updatedNotices.push({
                        notice: notice,
                        holderCallback: holderCallback
                    });
                }
                return {
                    notices: updatedNotices
                };
            });
        };
        _this.remove = function(removeKey) {
            _this.setState(function(_ref) {
                var notices = _ref.notices;
                return {
                    notices: notices.filter(function(_ref2) {
                        var _ref2$notice = _ref2.notice, key = _ref2$notice.key, userPassKey = _ref2$notice.userPassKey;
                        var mergedKey = userPassKey !== null && userPassKey !== void 0 ? userPassKey : key;
                        return mergedKey !== removeKey;
                    })
                };
            });
        };
        _this.noticePropsMap = {};
        return _this;
    }
    (0, $cHPF9.default)(Notification, [
        {
            key: "getTransitionName",
            value: function getTransitionName() {
                var _this$props = this.props, prefixCls = _this$props.prefixCls, animation = _this$props.animation;
                var transitionName = this.props.transitionName;
                if (!transitionName && animation) transitionName = "".concat(prefixCls, "-").concat(animation);
                return transitionName;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var notices = this.state.notices;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closeIcon = _this$props2.closeIcon, style = _this$props2.style;
                var noticeKeys = [];
                notices.forEach(function(_ref3, index) {
                    var notice = _ref3.notice, holderCallback = _ref3.holderCallback;
                    var updateMark = index === notices.length - 1 ? notice.updateMark : undefined;
                    var key = notice.key, userPassKey = notice.userPassKey;
                    var noticeProps = (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
                        prefixCls: prefixCls,
                        closeIcon: closeIcon
                    }, notice), notice.props), {}, {
                        key: key,
                        noticeKey: userPassKey || key,
                        updateMark: updateMark,
                        onClose: function onClose(noticeKey) {
                            var _notice$onClose;
                            _this2.remove(noticeKey);
                            (_notice$onClose = notice.onClose) === null || _notice$onClose === void 0 || _notice$onClose.call(notice);
                        },
                        onClick: notice.onClick,
                        children: notice.content
                    });
                    // Give to motion
                    noticeKeys.push(key);
                    _this2.noticePropsMap[key] = {
                        props: noticeProps,
                        holderCallback: holderCallback
                    };
                });
                return /*#__PURE__*/ $acw62.createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className),
                    style: style
                }, /*#__PURE__*/ $acw62.createElement((0, $eGxZY.default), {
                    keys: noticeKeys,
                    motionName: this.getTransitionName(),
                    onVisibleChanged: function onVisibleChanged(changedVisible, _ref4) {
                        var key = _ref4.key;
                        if (!changedVisible) delete _this2.noticePropsMap[key];
                    }
                }, function(_ref5) {
                    var key = _ref5.key, motionClassName = _ref5.className, motionStyle = _ref5.style, visible = _ref5.visible;
                    var _this2$noticePropsMap = _this2.noticePropsMap[key], noticeProps = _this2$noticePropsMap.props, holderCallback = _this2$noticePropsMap.holderCallback;
                    if (holderCallback) return /*#__PURE__*/ $acw62.createElement("div", {
                        key: key,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(motionClassName, "".concat(prefixCls, "-hook-holder")),
                        style: (0, $d49SP.default)({}, motionStyle),
                        ref: function ref(div) {
                            if (typeof key === 'undefined') return;
                            if (div) {
                                _this2.hookRefs.set(key, div);
                                holderCallback(div, noticeProps);
                            } else _this2.hookRefs.delete(key);
                        }
                    });
                    return /*#__PURE__*/ $acw62.createElement((0, $9gkwb.default), (0, $8nd05.default)({}, noticeProps, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(motionClassName, noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.className),
                        style: (0, $d49SP.default)((0, $d49SP.default)({}, motionStyle), noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.style),
                        visible: visible
                    }));
                }));
            }
        }
    ]);
    return Notification;
}((0, $acw62.Component));
$486904b4df561ec3$var$Notification.newInstance = void 0;
$486904b4df561ec3$var$Notification.defaultProps = {
    prefixCls: 'rc-notification',
    animation: 'fade',
    style: {
        top: 65,
        left: '50%'
    }
};
$486904b4df561ec3$var$Notification.newInstance = function newNotificationInstance(properties, callback) {
    var _ref6 = properties || {}, getContainer = _ref6.getContainer, props = (0, $9X7IJ.default)(_ref6, $486904b4df561ec3$var$_excluded);
    var div = document.createElement('div');
    if (getContainer) {
        var root = getContainer();
        root.appendChild(div);
    } else document.body.appendChild(div);
    var called = false;
    function ref(notification) {
        if (called) return;
        called = true;
        callback({
            notice: function notice(noticeProps) {
                notification.add(noticeProps);
            },
            removeNotice: function removeNotice(key) {
                notification.remove(key);
            },
            component: notification,
            destroy: function destroy() {
                (0, $iORrr.unmount)(div);
                if (div.parentNode) div.parentNode.removeChild(div);
            },
            // Hooks
            useNotification: function useNotification() {
                return (0, $fytPh.default)(notification);
            }
        });
    }
    (0, $iORrr.render)(/*#__PURE__*/ $acw62.createElement($486904b4df561ec3$var$Notification, (0, $8nd05.default)({}, props, {
        ref: ref
    })), div);
};
var $486904b4df561ec3$export$2e2bcd8739ae039 = $486904b4df561ec3$var$Notification;

});
parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZreY.default)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $VFVve.default)(t, e);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("enfmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76f20fb39fa9d46$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $fhGLX = parcelRequire("fhGLX");

var $9715X = parcelRequire("9715X");
function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $fhGLX.default)();
    return function() {
        var e, o = (0, $jDKKo.default)(t);
        if (r) {
            var s = (0, $jDKKo.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $9715X.default)(this, e);
    };
}

});
parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $fSwVM.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(t);
}

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("iORrr", function(module, exports) {

$parcel$export(module.exports, "render", () => $db3659e597d7eb55$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "unmount", () => $db3659e597d7eb55$export$121e2d597d222bad);

var $cqPKg = parcelRequire("cqPKg");

var $5wm0G = parcelRequire("5wm0G");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $1u0KT = parcelRequire("1u0KT");
// Let compiler not to search module usage
var $db3659e597d7eb55$var$fullClone = (0, $d49SP.default)({}, $1u0KT);
var $db3659e597d7eb55$var$version = $db3659e597d7eb55$var$fullClone.version, $db3659e597d7eb55$var$reactRender = $db3659e597d7eb55$var$fullClone.render, $db3659e597d7eb55$var$unmountComponentAtNode = $db3659e597d7eb55$var$fullClone.unmountComponentAtNode;
var $db3659e597d7eb55$var$createRoot;
try {
    var $db3659e597d7eb55$var$mainVersion = Number(($db3659e597d7eb55$var$version || '').split('.')[0]);
    if ($db3659e597d7eb55$var$mainVersion >= 18) $db3659e597d7eb55$var$createRoot = $db3659e597d7eb55$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $db3659e597d7eb55$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $db3659e597d7eb55$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $fSwVM.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $db3659e597d7eb55$var$MARK = '__rc_react_root__';
// ========================== Render ==========================
function $db3659e597d7eb55$var$modernRender(node, container) {
    $db3659e597d7eb55$var$toggleWarning(true);
    var root = container[$db3659e597d7eb55$var$MARK] || $db3659e597d7eb55$var$createRoot(container);
    $db3659e597d7eb55$var$toggleWarning(false);
    root.render(node);
    container[$db3659e597d7eb55$var$MARK] = root;
}
function $db3659e597d7eb55$var$legacyRender(node, container) {
    $db3659e597d7eb55$var$reactRender === null || $db3659e597d7eb55$var$reactRender === void 0 || $db3659e597d7eb55$var$reactRender(node, container);
}
function $db3659e597d7eb55$export$892c6608f54d7438(node, container) {}
function $db3659e597d7eb55$export$b3890eb0ae9dca99(node, container) {
    if ($db3659e597d7eb55$var$createRoot) {
        $db3659e597d7eb55$var$modernRender(node, container);
        return;
    }
    $db3659e597d7eb55$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $db3659e597d7eb55$var$modernUnmount(_x) {
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_modernUnmount() {
    $db3659e597d7eb55$var$_modernUnmount = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee(container) {
        return (0, $cqPKg.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$db3659e597d7eb55$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$db3659e597d7eb55$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$legacyUnmount(container) {
    $db3659e597d7eb55$var$unmountComponentAtNode(container);
}
function $db3659e597d7eb55$export$fd39fe14445b207a(container) {}
function $db3659e597d7eb55$export$121e2d597d222bad(_x2) {
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_unmount() {
    $db3659e597d7eb55$var$_unmount = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee2(container) {
        return (0, $cqPKg.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($db3659e597d7eb55$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $db3659e597d7eb55$var$modernUnmount(container));
                case 2:
                    $db3659e597d7eb55$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}

});
parcelRegister("cqPKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $90d00d496f52c75c$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $90d00d496f52c75c$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $90d00d496f52c75c$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $fSwVM.default)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $fSwVM.default)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}

});

parcelRegister("5wm0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $4051039ece381ef4$export$2e2bcd8739ae039);
function $4051039ece381ef4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4051039ece381ef4$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});


parcelRegister("8iiJy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $609e894acbce1933$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Provider", () => (parcelRequire("aBcZh")).default);
$parcel$export(module.exports, "CSSMotionList", () => (parcelRequire("eGxZY")).default);

var $I4iWQ = parcelRequire("I4iWQ");

var $eGxZY = parcelRequire("eGxZY");

var $aBcZh = parcelRequire("aBcZh");
var $609e894acbce1933$export$2e2bcd8739ae039 = (0, $I4iWQ.default);

});
parcelRegister("I4iWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $084772fb8d80df29$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $8g1PZ = parcelRequire("8g1PZ");

var $b2dYb = parcelRequire("b2dYb");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $aBcZh = parcelRequire("aBcZh");

var $jwRhB = parcelRequire("jwRhB");

var $2ztka = parcelRequire("2ztka");

var $2zM5O = parcelRequire("2zM5O");

var $1fdez = parcelRequire("1fdez");

var $gGgDs = parcelRequire("gGgDs");
function $084772fb8d80df29$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $fSwVM.default)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $acw62.useContext((0, $aBcZh.Context)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $acw62.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $b2dYb.default)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $2ztka.default)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $eUqlC.default)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $acw62.useCallback(function(node) {
            nodeRef.current = node;
            (0, $85dLH.fillRef)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $d49SP.default)((0, $d49SP.default)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $1fdez.STATUS_NONE)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $d49SP.default)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $d49SP.default)((0, $d49SP.default)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $d49SP.default)((0, $d49SP.default)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $1fdez.STEP_PREPARE)) statusSuffix = 'prepare';
            else if ((0, $2zM5O.isActive)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $1fdez.STEP_START)) statusSuffix = 'start';
            var motionCls = (0, $gGgDs.getTransitionName)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $d49SP.default)((0, $d49SP.default)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $gGgDs.getTransitionName)(motionName, status), (0, $kSlfw.default)((0, $kSlfw.default)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $acw62.isValidElement(motionChildren) && (0, $85dLH.supportRef)(motionChildren)) {
            var originNodeRef = (0, $85dLH.getNodeRef)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $acw62.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $acw62.createElement((0, $jwRhB.default), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $084772fb8d80df29$export$2e2bcd8739ae039 = $084772fb8d80df29$export$e265d52a86a9f199((0, $gGgDs.supportTransition));

});
parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1uEeT.default)(r) || (0, $guSBA.default)(r, e) || (0, $abLc2.default)(r, e) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7K8zV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7K8zV.default)(r, a) : void 0;
    }
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("b2dYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $808ab7b8a87ab771$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $808ab7b8a87ab771$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $fSwVM.default)(node) === 'object' && $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($808ab7b8a87ab771$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $808ab7b8a87ab771$export$2e2bcd8739ae039(node) {
    var domNode = $808ab7b8a87ab771$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))), node);
    }
    return null;
}

});

parcelRegister("85dLH", function(module, exports) {

$parcel$export(module.exports, "fillRef", () => $5e297877593af644$export$f17fd18fa51dcb5b);
$parcel$export(module.exports, "composeRef", () => $5e297877593af644$export$ab452c34e8e05029);
$parcel$export(module.exports, "useComposeRef", () => $5e297877593af644$export$1d1c999670a1285d);
$parcel$export(module.exports, "supportRef", () => $5e297877593af644$export$c1cec34af06bcf7);
$parcel$export(module.exports, "getNodeRef", () => $5e297877593af644$export$7465e5c0bf44f19a);

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $lwoRE = parcelRequire("lwoRE");

var $3Ysvw = parcelRequire("3Ysvw");

var $ims95 = parcelRequire("ims95");
var $5e297877593af644$var$ReactMajorVersion = Number((0, $acw62.version).split('.')[0]);
var $5e297877593af644$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $fSwVM.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $5e297877593af644$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5e297877593af644$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $5e297877593af644$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $3Ysvw.default)(function() {
        return $5e297877593af644$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $5e297877593af644$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($5e297877593af644$var$isReactElement(nodeOrComponent) && $5e297877593af644$var$ReactMajorVersion >= 19) return true;
    var type = (0, $lwoRE.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $lwoRE.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $lwoRE.ForwardRef)) return false;
    return true;
};
function $5e297877593af644$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $ims95.default)(node);
}
var $5e297877593af644$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $5e297877593af644$var$isReactElement(node) && $5e297877593af644$export$c1cec34af06bcf7(node);
};
var $5e297877593af644$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $5e297877593af644$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

});
parcelRegister("lwoRE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iH1gS"));

});
parcelRegister("iH1gS", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $d9bd3a91f40543dd$export$a7c73072b1a182ae, (v) => $d9bd3a91f40543dd$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $d9bd3a91f40543dd$export$9f27bc3417b4524d, (v) => $d9bd3a91f40543dd$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $d9bd3a91f40543dd$export$db77ccec0bb4ccac, (v) => $d9bd3a91f40543dd$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $d9bd3a91f40543dd$export$8392c0c9d3dcbd35, (v) => $d9bd3a91f40543dd$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $d9bd3a91f40543dd$export$ffb0004e005737fa, (v) => $d9bd3a91f40543dd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $d9bd3a91f40543dd$export$b624eff549462981, (v) => $d9bd3a91f40543dd$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $d9bd3a91f40543dd$export$7897aa7841a5380c, (v) => $d9bd3a91f40543dd$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $d9bd3a91f40543dd$export$602eac185826482c, (v) => $d9bd3a91f40543dd$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $d9bd3a91f40543dd$export$e2c29f18771995cb, (v) => $d9bd3a91f40543dd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $d9bd3a91f40543dd$export$5f8d39834fd61797, (v) => $d9bd3a91f40543dd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d9bd3a91f40543dd$export$74bf444e3cd11ea5, (v) => $d9bd3a91f40543dd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $d9bd3a91f40543dd$export$998bcd577473dd93, (v) => $d9bd3a91f40543dd$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $d9bd3a91f40543dd$export$92387174baf9b227, (v) => $d9bd3a91f40543dd$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $d9bd3a91f40543dd$export$ec112efeb987d9c6, (v) => $d9bd3a91f40543dd$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $d9bd3a91f40543dd$export$b706b080d889d2c9, (v) => $d9bd3a91f40543dd$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $d9bd3a91f40543dd$export$5be5a87408f70ddc, (v) => $d9bd3a91f40543dd$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $d9bd3a91f40543dd$export$45a5e7f76e0caa8d, (v) => $d9bd3a91f40543dd$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $d9bd3a91f40543dd$export$455c2e768291efa6, (v) => $d9bd3a91f40543dd$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $d9bd3a91f40543dd$export$9522e17588c12572, (v) => $d9bd3a91f40543dd$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $d9bd3a91f40543dd$export$2110ac352bb060b9, (v) => $d9bd3a91f40543dd$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $d9bd3a91f40543dd$export$56885ab8b9c456ab, (v) => $d9bd3a91f40543dd$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $d9bd3a91f40543dd$export$d927fcb6adf8f9de, (v) => $d9bd3a91f40543dd$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $d9bd3a91f40543dd$export$b82d16f27459e05a, (v) => $d9bd3a91f40543dd$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $d9bd3a91f40543dd$export$522c17b4f5e123e8, (v) => $d9bd3a91f40543dd$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $d9bd3a91f40543dd$export$1aabd8a0274ecfd6, (v) => $d9bd3a91f40543dd$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $d9bd3a91f40543dd$export$3d6c20d97e46b957, (v) => $d9bd3a91f40543dd$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $d9bd3a91f40543dd$export$9b621391a187a31a, (v) => $d9bd3a91f40543dd$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $d9bd3a91f40543dd$export$f5bbd400c2f4426f, (v) => $d9bd3a91f40543dd$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9bd3a91f40543dd$export$a7c73072b1a182ae;
var $d9bd3a91f40543dd$export$9f27bc3417b4524d;
var $d9bd3a91f40543dd$export$db77ccec0bb4ccac;
var $d9bd3a91f40543dd$export$8392c0c9d3dcbd35;
var $d9bd3a91f40543dd$export$ffb0004e005737fa;
var $d9bd3a91f40543dd$export$b624eff549462981;
var $d9bd3a91f40543dd$export$7897aa7841a5380c;
var $d9bd3a91f40543dd$export$602eac185826482c;
var $d9bd3a91f40543dd$export$e2c29f18771995cb;
var $d9bd3a91f40543dd$export$5f8d39834fd61797;
var $d9bd3a91f40543dd$export$74bf444e3cd11ea5;
var $d9bd3a91f40543dd$export$998bcd577473dd93;
var $d9bd3a91f40543dd$export$92387174baf9b227;
var $d9bd3a91f40543dd$export$ec112efeb987d9c6;
var $d9bd3a91f40543dd$export$b706b080d889d2c9;
var $d9bd3a91f40543dd$export$5be5a87408f70ddc;
var $d9bd3a91f40543dd$export$45a5e7f76e0caa8d;
var $d9bd3a91f40543dd$export$455c2e768291efa6;
var $d9bd3a91f40543dd$export$9522e17588c12572;
var $d9bd3a91f40543dd$export$2110ac352bb060b9;
var $d9bd3a91f40543dd$export$56885ab8b9c456ab;
var $d9bd3a91f40543dd$export$d927fcb6adf8f9de;
var $d9bd3a91f40543dd$export$b82d16f27459e05a;
var $d9bd3a91f40543dd$export$522c17b4f5e123e8;
var $d9bd3a91f40543dd$export$1aabd8a0274ecfd6;
var $d9bd3a91f40543dd$export$3d6c20d97e46b957;
var $d9bd3a91f40543dd$export$9b621391a187a31a;
var $d9bd3a91f40543dd$export$f5bbd400c2f4426f;
'use strict';
var $d9bd3a91f40543dd$var$b = Symbol.for("react.element"), $d9bd3a91f40543dd$var$c = Symbol.for("react.portal"), $d9bd3a91f40543dd$var$d = Symbol.for("react.fragment"), $d9bd3a91f40543dd$var$e = Symbol.for("react.strict_mode"), $d9bd3a91f40543dd$var$f = Symbol.for("react.profiler"), $d9bd3a91f40543dd$var$g = Symbol.for("react.provider"), $d9bd3a91f40543dd$var$h = Symbol.for("react.context"), $d9bd3a91f40543dd$var$k = Symbol.for("react.server_context"), $d9bd3a91f40543dd$var$l = Symbol.for("react.forward_ref"), $d9bd3a91f40543dd$var$m = Symbol.for("react.suspense"), $d9bd3a91f40543dd$var$n = Symbol.for("react.suspense_list"), $d9bd3a91f40543dd$var$p = Symbol.for("react.memo"), $d9bd3a91f40543dd$var$q = Symbol.for("react.lazy"), $d9bd3a91f40543dd$var$t = Symbol.for("react.offscreen"), $d9bd3a91f40543dd$var$u;
$d9bd3a91f40543dd$var$u = Symbol.for("react.module.reference");
function $d9bd3a91f40543dd$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d9bd3a91f40543dd$var$b:
                switch(a = a.type, a){
                    case $d9bd3a91f40543dd$var$d:
                    case $d9bd3a91f40543dd$var$f:
                    case $d9bd3a91f40543dd$var$e:
                    case $d9bd3a91f40543dd$var$m:
                    case $d9bd3a91f40543dd$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d9bd3a91f40543dd$var$k:
                            case $d9bd3a91f40543dd$var$h:
                            case $d9bd3a91f40543dd$var$l:
                            case $d9bd3a91f40543dd$var$q:
                            case $d9bd3a91f40543dd$var$p:
                            case $d9bd3a91f40543dd$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d9bd3a91f40543dd$var$c:
                return r;
        }
    }
}
$d9bd3a91f40543dd$export$a7c73072b1a182ae = $d9bd3a91f40543dd$var$h;
$d9bd3a91f40543dd$export$9f27bc3417b4524d = $d9bd3a91f40543dd$var$g;
$d9bd3a91f40543dd$export$db77ccec0bb4ccac = $d9bd3a91f40543dd$var$b;
$d9bd3a91f40543dd$export$8392c0c9d3dcbd35 = $d9bd3a91f40543dd$var$l;
$d9bd3a91f40543dd$export$ffb0004e005737fa = $d9bd3a91f40543dd$var$d;
$d9bd3a91f40543dd$export$b624eff549462981 = $d9bd3a91f40543dd$var$q;
$d9bd3a91f40543dd$export$7897aa7841a5380c = $d9bd3a91f40543dd$var$p;
$d9bd3a91f40543dd$export$602eac185826482c = $d9bd3a91f40543dd$var$c;
$d9bd3a91f40543dd$export$e2c29f18771995cb = $d9bd3a91f40543dd$var$f;
$d9bd3a91f40543dd$export$5f8d39834fd61797 = $d9bd3a91f40543dd$var$e;
$d9bd3a91f40543dd$export$74bf444e3cd11ea5 = $d9bd3a91f40543dd$var$m;
$d9bd3a91f40543dd$export$998bcd577473dd93 = $d9bd3a91f40543dd$var$n;
$d9bd3a91f40543dd$export$92387174baf9b227 = function() {
    return !1;
};
$d9bd3a91f40543dd$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d9bd3a91f40543dd$export$b706b080d889d2c9 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$h;
};
$d9bd3a91f40543dd$export$5be5a87408f70ddc = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$g;
};
$d9bd3a91f40543dd$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d9bd3a91f40543dd$var$b;
};
$d9bd3a91f40543dd$export$455c2e768291efa6 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$l;
};
$d9bd3a91f40543dd$export$9522e17588c12572 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$d;
};
$d9bd3a91f40543dd$export$2110ac352bb060b9 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$q;
};
$d9bd3a91f40543dd$export$56885ab8b9c456ab = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$p;
};
$d9bd3a91f40543dd$export$d927fcb6adf8f9de = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$c;
};
$d9bd3a91f40543dd$export$b82d16f27459e05a = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$f;
};
$d9bd3a91f40543dd$export$522c17b4f5e123e8 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$e;
};
$d9bd3a91f40543dd$export$1aabd8a0274ecfd6 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$m;
};
$d9bd3a91f40543dd$export$3d6c20d97e46b957 = function(a) {
    return $d9bd3a91f40543dd$var$v(a) === $d9bd3a91f40543dd$var$n;
};
$d9bd3a91f40543dd$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d9bd3a91f40543dd$var$d || a === $d9bd3a91f40543dd$var$f || a === $d9bd3a91f40543dd$var$e || a === $d9bd3a91f40543dd$var$m || a === $d9bd3a91f40543dd$var$n || a === $d9bd3a91f40543dd$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d9bd3a91f40543dd$var$q || a.$$typeof === $d9bd3a91f40543dd$var$p || a.$$typeof === $d9bd3a91f40543dd$var$g || a.$$typeof === $d9bd3a91f40543dd$var$h || a.$$typeof === $d9bd3a91f40543dd$var$l || a.$$typeof === $d9bd3a91f40543dd$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d9bd3a91f40543dd$export$f5bbd400c2f4426f = $d9bd3a91f40543dd$var$v;

});


parcelRegister("3Ysvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4d16a6147a082d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $2e4d16a6147a082d$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});

parcelRegister("ims95", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e01d34dc1c3d99$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
var $d5e01d34dc1c3d99$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $d5e01d34dc1c3d99$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $d5e01d34dc1c3d99$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $d5e01d34dc1c3d99$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $fSwVM.default)(object) === 'object' && // React Element type
    (object.$$typeof === $d5e01d34dc1c3d99$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $d5e01d34dc1c3d99$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $d5e01d34dc1c3d99$var$REACT_FRAGMENT_TYPE);
}

});


parcelRegister("aBcZh", function(module, exports) {

$parcel$export(module.exports, "Context", () => $7b776f21b7918d7b$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $7b776f21b7918d7b$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");
var $7b776f21b7918d7b$var$_excluded = [
    "children"
];
var $7b776f21b7918d7b$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
function $7b776f21b7918d7b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $9X7IJ.default)(_ref, $7b776f21b7918d7b$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($7b776f21b7918d7b$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}

});

parcelRegister("jwRhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37a565edd3e4d81$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");
var $e37a565edd3e4d81$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(DomWrapper, _React$Component);
    var _super = (0, $enfmq.default)(DomWrapper);
    function DomWrapper() {
        (0, $6CZeq.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);
var $e37a565edd3e4d81$export$2e2bcd8739ae039 = $e37a565edd3e4d81$var$DomWrapper;

});

parcelRegister("2ztka", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df598d21d8025e6$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");
parcelRequire("gwOwm");
var $a4gyP = parcelRequire("a4gyP");

var $3fDfx = parcelRequire("3fDfx");

var $lO6Vw = parcelRequire("lO6Vw");

var $acw62 = parcelRequire("acw62");

var $1fdez = parcelRequire("1fdez");

var $aIgUv = parcelRequire("aIgUv");

var $lyPxB = parcelRequire("lyPxB");

var $2zM5O = parcelRequire("2zM5O");
function $1df598d21d8025e6$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $3fDfx.default)(), _useState2 = (0, $eUqlC.default)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $lO6Vw.default)((0, $1fdez.STATUS_NONE)), _useSyncState2 = (0, $eUqlC.default)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $3fDfx.default)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $acw62.useRef)(false);
    var deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $1fdez.STATUS_NONE));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $a4gyP.default)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $1fdez.STATUS_NONE)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $1fdez.STATUS_APPEAR) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $1fdez.STATUS_ENTER) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $1fdez.STATUS_LEAVE) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $aIgUv.default)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $eUqlC.default)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $1fdez.STATUS_APPEAR:
                return (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, (0, $1fdez.STEP_PREPARE), onAppearPrepare), (0, $1fdez.STEP_START), onAppearStart), (0, $1fdez.STEP_ACTIVE), onAppearActive);
            case 0, $1fdez.STATUS_ENTER:
                return (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, (0, $1fdez.STEP_PREPARE), onEnterPrepare), (0, $1fdez.STEP_START), onEnterStart), (0, $1fdez.STEP_ACTIVE), onEnterActive);
            case 0, $1fdez.STATUS_LEAVE:
                return (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, (0, $1fdez.STEP_PREPARE), onLeavePrepare), (0, $1fdez.STEP_START), onLeaveStart), (0, $1fdez.STEP_ACTIVE), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $acw62.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $2zM5O.default)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $1fdez.STEP_PREPARE)) {
            var onPrepare = eventHandlers[0, $1fdez.STEP_PREPARE];
            if (!onPrepare) return 0, $2zM5O.SkipStep;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $1fdez.STEP_ACTIVE) && currentStatus !== (0, $1fdez.STATUS_NONE)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $1fdez.STEP_PREPARED)) updateMotionEndStatus();
        return 0, $2zM5O.DoStep;
    }), _useStepQueue2 = (0, $eUqlC.default)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $2zM5O.isActive)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $acw62.useRef)(null);
    // Update with new status
    (0, $lyPxB.default)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $1fdez.STATUS_APPEAR);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $1fdez.STATUS_ENTER);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $1fdez.STATUS_LEAVE);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $1fdez.STEP_PREPARE])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $1fdez.STATUS_NONE));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $1fdez.STATUS_APPEAR) && !motionAppear || // Cancel enter
        currentStatus === (0, $1fdez.STATUS_ENTER) && !motionEnter || // Cancel leave
        currentStatus === (0, $1fdez.STATUS_LEAVE) && !motionLeave) setStatus((0, $1fdez.STATUS_NONE));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $1fdez.STATUS_NONE)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $1fdez.STEP_PREPARE] && step === (0, $1fdez.STEP_START)) mergedStyle = (0, $d49SP.default)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}

});
parcelRegister("gwOwm", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => (parcelRequire("a4gyP")).default);

var $a4gyP = parcelRequire("a4gyP");

var $iSQh8 = parcelRequire("iSQh8");

var $85dLH = parcelRequire("85dLH");

var $23Gye = parcelRequire("23Gye");

var $6vgkH = parcelRequire("6vgkH");

var $u43uR = parcelRequire("u43uR");

});
parcelRegister("a4gyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e43e72865dc583$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $01e43e72865dc583$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

});

parcelRegister("iSQh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $a4gyP = parcelRequire("a4gyP");

var $6hDTM = parcelRequire("6hDTM");

var $3fDfx = parcelRequire("3fDfx");
/** We only think `undefined` is empty */ function $dbf5d1f4f4ecbb6a$var$hasValue(value) {
    return value !== undefined;
}
function $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $3fDfx.default)(function() {
        if ($dbf5d1f4f4ecbb6a$var$hasValue(value)) return value;
        else if ($dbf5d1f4f4ecbb6a$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $eUqlC.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $a4gyP.default)(onChange);
    var _useState3 = (0, $3fDfx.default)([
        mergedValue
    ]), _useState4 = (0, $eUqlC.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $6hDTM.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $6hDTM.useLayoutUpdateEffect)(function() {
        if (!$dbf5d1f4f4ecbb6a$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $a4gyP.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

});
parcelRegister("6hDTM", function(module, exports) {

$parcel$export(module.exports, "useLayoutUpdateEffect", () => $493347a9fd5d8394$export$9283e56bae2f7b0f);
$parcel$export(module.exports, "default", () => $493347a9fd5d8394$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $h4v51 = parcelRequire("h4v51");
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $493347a9fd5d8394$var$useInternalLayoutEffect = (0, $h4v51.default)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $493347a9fd5d8394$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $493347a9fd5d8394$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $493347a9fd5d8394$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $493347a9fd5d8394$export$2e2bcd8739ae039 = $493347a9fd5d8394$var$useLayoutEffect;

});
parcelRegister("h4v51", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6daeb3adc2b0e60$export$2e2bcd8739ae039);
function $c6daeb3adc2b0e60$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

});


parcelRegister("3fDfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e137fc56329ad1$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $25e137fc56329ad1$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

});


parcelRegister("23Gye", function(module, exports) {

$parcel$export(module.exports, "default", () => $17fcde5782384c29$export$2e2bcd8739ae039);
function $17fcde5782384c29$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});

parcelRegister("6vgkH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bc24eaedd2a47a4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "merge", () => $4bc24eaedd2a47a4$export$4950aa0f605343fb);

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $aJJ3v = parcelRequire("aJJ3v");

var $23Gye = parcelRequire("23Gye");
function $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $aJJ3v.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $kbxxf.default)(entity);
    else clone = (0, $d49SP.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $4bc24eaedd2a47a4$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $4bc24eaedd2a47a4$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $23Gye.default)(entity, paths.slice(0, -1))) return entity;
    return $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $4bc24eaedd2a47a4$var$isObject(obj) {
    return (0, $fSwVM.default)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $4bc24eaedd2a47a4$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $4bc24eaedd2a47a4$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $4bc24eaedd2a47a4$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $4bc24eaedd2a47a4$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $23Gye.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $4bc24eaedd2a47a4$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $23Gye.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $fSwVM.default)(originValue) !== 'object') // Init container if not exist
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, $4bc24eaedd2a47a4$var$createEmpty(value));
                    $4bc24eaedd2a47a4$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $kbxxf.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});
parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $cN7Ua.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7K8zV.default)(r);
}

});

parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("aJJ3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d110e739ae14cc6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $7d110e739ae14cc6$export$2e2bcd8739ae039(r) {
    return (0, $1uEeT.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $782Uh.default)();
}

});


parcelRegister("u43uR", function(module, exports) {

$parcel$export(module.exports, "warning", () => $05a5f2c645683a81$export$491112666e282270);
$parcel$export(module.exports, "noteOnce", () => $05a5f2c645683a81$export$89ff31684837bbbf);
$parcel$export(module.exports, "default", () => $05a5f2c645683a81$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $05a5f2c645683a81$var$warned = {};
var $05a5f2c645683a81$var$preWarningFns = [];
var $05a5f2c645683a81$export$61616f168f0e5a05 = function preMessage(fn) {
    $05a5f2c645683a81$var$preWarningFns.push(fn);
};
function $05a5f2c645683a81$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$60eef1277fe463e4() {
    $05a5f2c645683a81$var$warned = {};
}
function $05a5f2c645683a81$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$05a5f2c645683a81$var$warned[message]) {
        method(false, message);
        $05a5f2c645683a81$var$warned[message] = true;
    }
}
function $05a5f2c645683a81$export$82934adf09101657(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$491112666e282270, valid, message);
}
function $05a5f2c645683a81$export$89ff31684837bbbf(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$a92e4c44d367d0af, valid, message);
}
$05a5f2c645683a81$export$82934adf09101657.preMessage = $05a5f2c645683a81$export$61616f168f0e5a05;
$05a5f2c645683a81$export$82934adf09101657.resetWarned = $05a5f2c645683a81$export$60eef1277fe463e4;
$05a5f2c645683a81$export$82934adf09101657.noteOnce = $05a5f2c645683a81$export$89ff31684837bbbf;
var $05a5f2c645683a81$export$2e2bcd8739ae039 = $05a5f2c645683a81$export$82934adf09101657;

});


parcelRegister("lO6Vw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe03a404cc9d1454$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $a4gyP = parcelRequire("a4gyP");
function $fe03a404cc9d1454$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $acw62.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $eUqlC.default)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $acw62.useRef(defaultValue);
    var getValue = (0, $a4gyP.default)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $a4gyP.default)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}

});

parcelRegister("1fdez", function(module, exports) {

$parcel$export(module.exports, "STATUS_NONE", () => $0e817525d7f1f474$export$de71442bbf2143da);
$parcel$export(module.exports, "STATUS_APPEAR", () => $0e817525d7f1f474$export$4fc3521687bcacd2);
$parcel$export(module.exports, "STATUS_ENTER", () => $0e817525d7f1f474$export$5d6af549241fe2e8);
$parcel$export(module.exports, "STATUS_LEAVE", () => $0e817525d7f1f474$export$59b1c493d29f68e4);
$parcel$export(module.exports, "STEP_NONE", () => $0e817525d7f1f474$export$40b34dd77d5522bf);
$parcel$export(module.exports, "STEP_PREPARE", () => $0e817525d7f1f474$export$1b792916a5fac4fc);
$parcel$export(module.exports, "STEP_START", () => $0e817525d7f1f474$export$9563153dd25a3ce8);
$parcel$export(module.exports, "STEP_ACTIVE", () => $0e817525d7f1f474$export$e205886172277ec6);
$parcel$export(module.exports, "STEP_ACTIVATED", () => $0e817525d7f1f474$export$3a846c3d2fac10b8);
$parcel$export(module.exports, "STEP_PREPARED", () => $0e817525d7f1f474$export$98351fa4e6b4f204);
var $0e817525d7f1f474$export$de71442bbf2143da = 'none';
var $0e817525d7f1f474$export$4fc3521687bcacd2 = 'appear';
var $0e817525d7f1f474$export$5d6af549241fe2e8 = 'enter';
var $0e817525d7f1f474$export$59b1c493d29f68e4 = 'leave';
var $0e817525d7f1f474$export$40b34dd77d5522bf = 'none';
var $0e817525d7f1f474$export$1b792916a5fac4fc = 'prepare';
var $0e817525d7f1f474$export$9563153dd25a3ce8 = 'start';
var $0e817525d7f1f474$export$e205886172277ec6 = 'active';
var $0e817525d7f1f474$export$3a846c3d2fac10b8 = 'end';
var $0e817525d7f1f474$export$98351fa4e6b4f204 = 'prepared';

});

parcelRegister("aIgUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ccb217d091ef41f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $gGgDs = parcelRequire("gGgDs");
var $7ccb217d091ef41f$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $acw62.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $gGgDs.transitionEndName), onInternalMotionEnd);
            element.removeEventListener((0, $gGgDs.animationEndName), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $gGgDs.transitionEndName), onInternalMotionEnd);
            element.addEventListener((0, $gGgDs.animationEndName), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};

});
parcelRegister("gGgDs", function(module, exports) {

$parcel$export(module.exports, "supportTransition", () => $c24d790a085c6d93$export$d28133ed3ad06c8b);
$parcel$export(module.exports, "animationEndName", () => $c24d790a085c6d93$export$760cc9769c51b738);
$parcel$export(module.exports, "transitionEndName", () => $c24d790a085c6d93$export$44baea64b8602e3c);
$parcel$export(module.exports, "getTransitionName", () => $c24d790a085c6d93$export$27c72201b1d09951);

var $fSwVM = parcelRequire("fSwVM");

var $h4v51 = parcelRequire("h4v51");
// ================= Transition =================
// Event wrapper. Copy from react source code
function $c24d790a085c6d93$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $c24d790a085c6d93$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $c24d790a085c6d93$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $c24d790a085c6d93$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $c24d790a085c6d93$var$vendorPrefixes = $c24d790a085c6d93$export$6e8b350b1a8958a0((0, $h4v51.default)(), typeof window !== 'undefined' ? window : {});
var $c24d790a085c6d93$var$style = {};
if ((0, $h4v51.default)()) {
    var $c24d790a085c6d93$var$_document$createEleme = document.createElement('div');
    $c24d790a085c6d93$var$style = $c24d790a085c6d93$var$_document$createEleme.style;
}
var $c24d790a085c6d93$var$prefixedEventNames = {};
function $c24d790a085c6d93$export$a032e4f39350c1d8(eventName) {
    if ($c24d790a085c6d93$var$prefixedEventNames[eventName]) return $c24d790a085c6d93$var$prefixedEventNames[eventName];
    var prefixMap = $c24d790a085c6d93$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $c24d790a085c6d93$var$style) {
                $c24d790a085c6d93$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $c24d790a085c6d93$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $c24d790a085c6d93$var$internalAnimationEndName = $c24d790a085c6d93$export$a032e4f39350c1d8('animationend');
var $c24d790a085c6d93$var$internalTransitionEndName = $c24d790a085c6d93$export$a032e4f39350c1d8('transitionend');
var $c24d790a085c6d93$export$d28133ed3ad06c8b = !!($c24d790a085c6d93$var$internalAnimationEndName && $c24d790a085c6d93$var$internalTransitionEndName);
var $c24d790a085c6d93$export$760cc9769c51b738 = $c24d790a085c6d93$var$internalAnimationEndName || 'animationend';
var $c24d790a085c6d93$export$44baea64b8602e3c = $c24d790a085c6d93$var$internalTransitionEndName || 'transitionend';
function $c24d790a085c6d93$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $fSwVM.default)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}

});


parcelRegister("lyPxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb24c0ebe270f6f6$export$2e2bcd8739ae039);

var $h4v51 = parcelRequire("h4v51");

var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect = (0, $h4v51.default)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $fb24c0ebe270f6f6$export$2e2bcd8739ae039 = $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect;

});

parcelRegister("2zM5O", function(module, exports) {

$parcel$export(module.exports, "SkipStep", () => $1e0427d97d69e92c$export$c2029bf6cfdbc28a);
$parcel$export(module.exports, "DoStep", () => $1e0427d97d69e92c$export$dbee1e282e8c4830);
$parcel$export(module.exports, "isActive", () => $1e0427d97d69e92c$export$39e04e72f972b885);
$parcel$export(module.exports, "default", () => $1e0427d97d69e92c$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $3fDfx = parcelRequire("3fDfx");

var $acw62 = parcelRequire("acw62");

var $1fdez = parcelRequire("1fdez");

var $lyPxB = parcelRequire("lyPxB");

var $iZ4W8 = parcelRequire("iZ4W8");
var $1e0427d97d69e92c$var$FULL_STEP_QUEUE = [
    (0, $1fdez.STEP_PREPARE),
    (0, $1fdez.STEP_START),
    (0, $1fdez.STEP_ACTIVE),
    (0, $1fdez.STEP_ACTIVATED)
];
var $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE = [
    (0, $1fdez.STEP_PREPARE),
    (0, $1fdez.STEP_PREPARED)
];
var $1e0427d97d69e92c$export$c2029bf6cfdbc28a = false;
var $1e0427d97d69e92c$export$dbee1e282e8c4830 = true;
function $1e0427d97d69e92c$export$39e04e72f972b885(step) {
    return step === (0, $1fdez.STEP_ACTIVE) || step === (0, $1fdez.STEP_ACTIVATED);
}
var $1e0427d97d69e92c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $3fDfx.default)((0, $1fdez.STEP_NONE)), _useState2 = (0, $eUqlC.default)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $iZ4W8.default)(), _useNextFrame2 = (0, $eUqlC.default)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $1fdez.STEP_PREPARE), true);
    }
    var STEP_QUEUE = prepareOnly ? $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE : $1e0427d97d69e92c$var$FULL_STEP_QUEUE;
    (0, $lyPxB.default)(function() {
        if (step !== (0, $1fdez.STEP_NONE) && step !== (0, $1fdez.STEP_ACTIVATED)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $1e0427d97d69e92c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};

});
parcelRegister("iZ4W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd21c0d0173075f3$export$2e2bcd8739ae039);

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");
var $dd21c0d0173075f3$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $dTiBu.default).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $dTiBu.default)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};

});
parcelRegister("dTiBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ced7b983ea61a4$export$2e2bcd8739ae039);
var $a1ced7b983ea61a4$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $a1ced7b983ea61a4$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $a1ced7b983ea61a4$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $a1ced7b983ea61a4$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $a1ced7b983ea61a4$var$rafUUID = 0;
var $a1ced7b983ea61a4$var$rafIds = new Map();
function $a1ced7b983ea61a4$var$cleanup(id) {
    $a1ced7b983ea61a4$var$rafIds.delete(id);
}
var $a1ced7b983ea61a4$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $a1ced7b983ea61a4$var$rafUUID += 1;
    var id = $a1ced7b983ea61a4$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $a1ced7b983ea61a4$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $a1ced7b983ea61a4$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $a1ced7b983ea61a4$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$a1ced7b983ea61a4$var$wrapperRaf.cancel = function(id) {
    var realId = $a1ced7b983ea61a4$var$rafIds.get(id);
    $a1ced7b983ea61a4$var$cleanup(id);
    return $a1ced7b983ea61a4$var$caf(realId);
};
var $a1ced7b983ea61a4$export$2e2bcd8739ae039 = $a1ced7b983ea61a4$var$wrapperRaf;

});





parcelRegister("eGxZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab0f5c5a9767e13d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $I4iWQ = parcelRequire("I4iWQ");

var $1Wi9G = parcelRequire("1Wi9G");

var $gGgDs = parcelRequire("gGgDs");
var $ab0f5c5a9767e13d$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $ab0f5c5a9767e13d$var$_excluded2 = [
    "status"
];
var $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $I4iWQ.default);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $1gYAD.default)(CSSMotionList, _React$Component);
        var _super = (0, $enfmq.default)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $6CZeq.default)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $d49SP.default)((0, $d49SP.default)({}, entity), {}, {
                            status: (0, $1Wi9G.STATUS_REMOVED)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $1Wi9G.STATUS_REMOVED);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $cHPF9.default)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $9X7IJ.default)(_this$props, $ab0f5c5a9767e13d$var$_excluded);
                    var Component = component || $acw62.Fragment;
                    var motionProps = {};
                    $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $9X7IJ.default)(_ref2, $ab0f5c5a9767e13d$var$_excluded2);
                        var visible = status === (0, $1Wi9G.STATUS_ADD) || status === (0, $1Wi9G.STATUS_KEEP);
                        return /*#__PURE__*/ $acw62.createElement(CSSMotion, (0, $8nd05.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $1Wi9G.parseKeys)(keys);
                    var mixedKeyEntities = (0, $1Wi9G.diffKeys)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $1Wi9G.STATUS_REMOVED) && entity.status === (0, $1Wi9G.STATUS_REMOVE)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($acw62.Component);
    (0, $kSlfw.default)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $ab0f5c5a9767e13d$export$2e2bcd8739ae039 = $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e((0, $gGgDs.supportTransition));

});
parcelRegister("1Wi9G", function(module, exports) {

$parcel$export(module.exports, "STATUS_ADD", () => $16994a73d43ee3a4$export$3904baa009bc026e);
$parcel$export(module.exports, "STATUS_KEEP", () => $16994a73d43ee3a4$export$851162f0adad2cbc);
$parcel$export(module.exports, "STATUS_REMOVE", () => $16994a73d43ee3a4$export$c8b3fb08b68cfc85);
$parcel$export(module.exports, "STATUS_REMOVED", () => $16994a73d43ee3a4$export$2ac1bd1808d2e43a);
$parcel$export(module.exports, "parseKeys", () => $16994a73d43ee3a4$export$84bd7bd42ccc0f72);
$parcel$export(module.exports, "diffKeys", () => $16994a73d43ee3a4$export$14527669107aa301);

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");
var $16994a73d43ee3a4$export$3904baa009bc026e = 'add';
var $16994a73d43ee3a4$export$851162f0adad2cbc = 'keep';
var $16994a73d43ee3a4$export$c8b3fb08b68cfc85 = 'remove';
var $16994a73d43ee3a4$export$2ac1bd1808d2e43a = 'removed';
function $16994a73d43ee3a4$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $fSwVM.default)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $d49SP.default)((0, $d49SP.default)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $16994a73d43ee3a4$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($16994a73d43ee3a4$export$c47fd798e598c85c);
}
function $16994a73d43ee3a4$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $d49SP.default)((0, $d49SP.default)({}, obj), {}, {
                            status: $16994a73d43ee3a4$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $d49SP.default)((0, $d49SP.default)({}, currentKeyObj), {}, {
                    status: $16994a73d43ee3a4$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $d49SP.default)((0, $d49SP.default)({}, keyObj), {}, {
            status: $16994a73d43ee3a4$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $d49SP.default)((0, $d49SP.default)({}, obj), {}, {
            status: $16994a73d43ee3a4$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $16994a73d43ee3a4$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $16994a73d43ee3a4$export$851162f0adad2cbc;
        });
    });
    return list;
}

});



parcelRegister("9gkwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be5862818f90611$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $8g1PZ = parcelRequire("8g1PZ");
var $6be5862818f90611$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Notice, _Component);
    var _super = (0, $enfmq.default)(Notice);
    function Notice() {
        var _this;
        (0, $6CZeq.default)(this, Notice);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.closeTimer = null;
        _this.close = function(e) {
            if (e) e.stopPropagation();
            _this.clearCloseTimer();
            var _this$props = _this.props, onClose = _this$props.onClose, noticeKey = _this$props.noticeKey;
            if (onClose) onClose(noticeKey);
        };
        _this.startCloseTimer = function() {
            if (_this.props.duration) _this.closeTimer = window.setTimeout(function() {
                _this.close();
            }, _this.props.duration * 1000);
        };
        _this.clearCloseTimer = function() {
            if (_this.closeTimer) {
                clearTimeout(_this.closeTimer);
                _this.closeTimer = null;
            }
        };
        return _this;
    }
    (0, $cHPF9.default)(Notice, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCloseTimer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || // Visible again need reset timer
                this.props.visible !== prevProps.visible && this.props.visible) this.restartCloseTimer();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearCloseTimer();
            }
        },
        {
            key: "restartCloseTimer",
            value: function restartCloseTimer() {
                this.clearCloseTimer();
                this.startCloseTimer();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closable = _this$props2.closable, closeIcon = _this$props2.closeIcon, style = _this$props2.style, onClick = _this$props2.onClick, children = _this$props2.children, holder = _this$props2.holder;
                var componentClass = "".concat(prefixCls, "-notice");
                var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(acc, key) {
                    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') acc[key] = _this2.props[key];
                    return acc;
                }, {});
                var node = /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(componentClass, className, (0, $kSlfw.default)({}, "".concat(componentClass, "-closable"), closable)),
                    style: style,
                    onMouseEnter: this.clearCloseTimer,
                    onMouseLeave: this.startCloseTimer,
                    onClick: onClick
                }, dataOrAriaAttributeProps), /*#__PURE__*/ $acw62.createElement("div", {
                    className: "".concat(componentClass, "-content")
                }, children), closable ? /*#__PURE__*/ $acw62.createElement("a", {
                    tabIndex: 0,
                    onClick: this.close,
                    className: "".concat(componentClass, "-close")
                }, closeIcon || /*#__PURE__*/ $acw62.createElement("span", {
                    className: "".concat(componentClass, "-close-x")
                })) : null);
                if (holder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(node, holder);
                return node;
            }
        }
    ]);
    return Notice;
}((0, $acw62.Component));
$6be5862818f90611$export$2e2bcd8739ae039.defaultProps = {
    onClose: function onClose() {},
    duration: 1.5
};

});

parcelRegister("fytPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5312ad231aadb4b$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $9gkwb = parcelRequire("9gkwb");
function $b5312ad231aadb4b$export$2e2bcd8739ae039(notificationInstance) {
    var createdRef = $acw62.useRef({});
    var _React$useState = $acw62.useState([]), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
    function notify(noticeProps) {
        var firstMount = true;
        notificationInstance.add(noticeProps, function(div, props) {
            var key = props.key;
            if (div && (!createdRef.current[key] || firstMount)) {
                var noticeEle = /*#__PURE__*/ $acw62.createElement((0, $9gkwb.default), (0, $8nd05.default)({}, props, {
                    holder: div
                }));
                createdRef.current[key] = noticeEle;
                setElements(function(originElements) {
                    var index = originElements.findIndex(function(ele) {
                        return ele.key === props.key;
                    });
                    if (index === -1) return [].concat((0, $kbxxf.default)(originElements), [
                        noticeEle
                    ]);
                    var cloneList = (0, $kbxxf.default)(originElements);
                    cloneList[index] = noticeEle;
                    return cloneList;
                });
            }
            firstMount = false;
        });
    }
    return [
        notify,
        /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, elements)
    ];
}

});



parcelRegister("cGjF0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $93b8a86f8ed15614$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseInput", () => (parcelRequire("4lB6V")).default);

var $4lB6V = parcelRequire("4lB6V");

var $dsUZF = parcelRequire("dsUZF");
var $93b8a86f8ed15614$export$2e2bcd8739ae039 = (0, $dsUZF.default);

});
parcelRegister("4lB6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $32a5e8fad29dc207$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lKHNk = parcelRequire("lKHNk");
var $32a5e8fad29dc207$var$BaseInput = function BaseInput(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, affixWrapperClassName = props.affixWrapperClassName, groupClassName = props.groupClassName, wrapperClassName = props.wrapperClassName, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden;
    var containerRef = (0, $acw62.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    }; // ================== Clear Icon ================== //
    var getClearIcon = function getClearIcon() {
        var _classNames;
        if (!allowClear) return null;
        var needClear = !disabled && !readOnly && value;
        var clearIconCls = "".concat(prefixCls, "-clear-icon");
        var iconNode = (0, $fSwVM.default)(allowClear) === 'object' && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            onClick: handleReset // Do not trigger onBlur when clear input
            ,
            onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(clearIconCls, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(clearIconCls, "-hidden"), !needClear), (0, $kSlfw.default)(_classNames, "".concat(clearIconCls, "-has-suffix"), !!suffix), _classNames)),
            role: "button",
            tabIndex: -1
        }, iconNode);
    };
    var element = /*#__PURE__*/ (0, $acw62.cloneElement)(inputElement, {
        value: value,
        hidden: hidden
    }); // ================== Prefix & Suffix ================== //
    if ((0, $lKHNk.hasPrefixSuffix)(props)) {
        var _classNames2;
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(affixWrapperPrefixCls, (_classNames2 = {}, (0, $kSlfw.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-focused"), focused), (0, $kSlfw.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), (0, $kSlfw.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _classNames2), !(0, $lKHNk.hasAddon)(props) && className, affixWrapperClassName);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(prefixCls, "-suffix")
        }, getClearIcon(), suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: affixWrapperCls,
            style: style,
            hidden: !(0, $lKHNk.hasAddon)(props) && hidden,
            onClick: onInputClick,
            ref: containerRef
        }, prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(prefixCls, "-prefix")
        }, prefix), /*#__PURE__*/ (0, $acw62.cloneElement)(inputElement, {
            style: null,
            value: value,
            hidden: null
        }), suffixNode);
    } // ================== Addon ================== //
    if ((0, $lKHNk.hasAddon)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-wrapper"), wrapperCls, wrapperClassName);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-group-wrapper"), className, groupClassName); // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: mergedGroupClassName,
            style: style,
            hidden: hidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: addonCls
        }, addonBefore), /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
            style: null,
            hidden: null
        }), addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: addonCls
        }, addonAfter)));
    }
    return element;
};
var $32a5e8fad29dc207$export$2e2bcd8739ae039 = $32a5e8fad29dc207$var$BaseInput;

});
parcelRegister("lKHNk", function(module, exports) {

$parcel$export(module.exports, "hasAddon", () => $fd5fdd8da073bd4e$export$ae6255aa850a31d1);
$parcel$export(module.exports, "hasPrefixSuffix", () => $fd5fdd8da073bd4e$export$a19010aeeaa0c7a);
$parcel$export(module.exports, "resolveOnChange", () => $fd5fdd8da073bd4e$export$c28984794956ddc0);
$parcel$export(module.exports, "triggerFocus", () => $fd5fdd8da073bd4e$export$2b92016deb0b7aad);
$parcel$export(module.exports, "fixControlledValue", () => $fd5fdd8da073bd4e$export$ef94f7f24276a29c);
function $fd5fdd8da073bd4e$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $fd5fdd8da073bd4e$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
function $fd5fdd8da073bd4e$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true); // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = '';
        onChange(event);
        return;
    } // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $fd5fdd8da073bd4e$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option); // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
function $fd5fdd8da073bd4e$export$ef94f7f24276a29c(value) {
    if (typeof value === 'undefined' || value === null) return '';
    return String(value);
}

});


parcelRegister("dsUZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cda19a001f87ecf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $4lB6V = parcelRequire("4lB6V");

var $1pcHX = parcelRequire("1pcHX");

var $lKHNk = parcelRequire("lKHNk");

var $8g1PZ = parcelRequire("8g1PZ");

var $iSQh8 = parcelRequire("iSQh8");
var $9cda19a001f87ecf$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "type",
    "inputClassName"
];
var $9cda19a001f87ecf$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input' : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, inputClassName = props.inputClassName, rest = (0, $9X7IJ.default)(props, $9cda19a001f87ecf$var$_excluded);
    var _useMergedState = (0, $iSQh8.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var inputRef = (0, $acw62.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $lKHNk.triggerFocus)(inputRef.current, option);
    };
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current
        };
    });
    (0, $acw62.useEffect)(function() {
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var handleChange = function handleChange(e) {
        if (props.value === undefined) setValue(e.target.value);
        if (inputRef.current) (0, $lKHNk.resolveOnChange)(inputRef.current, e, onChange);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === 'Enter') onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        if (inputRef.current) (0, $lKHNk.resolveOnChange)(inputRef.current, e, onChange);
    };
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $1pcHX.default)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'affixWrapperClassName',
            'groupClassName',
            'inputClassName',
            'wrapperClassName',
            'htmlSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $8nd05.default)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: handleChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), disabled), inputClassName, !(0, $lKHNk.hasAddon)(props) && !(0, $lKHNk.hasPrefixSuffix)(props) && className),
            ref: inputRef,
            size: htmlSize,
            type: type
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(maxLength) > 0;
        if (suffix || showCount) {
            var val = (0, $lKHNk.fixControlledValue)(value);
            var valueLength = (0, $kbxxf.default)(val).length;
            var dataCount = (0, $fSwVM.default)(showCount) === 'object' ? showCount.formatter({
                value: val,
                count: valueLength,
                maxLength: maxLength
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : '');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !!showCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-show-count-suffix"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix))
            }, dataCount), suffix);
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4lB6V.default), (0, $8nd05.default)({}, rest, {
        prefixCls: prefixCls,
        className: className,
        inputElement: getInputElement(),
        handleReset: handleReset,
        value: (0, $lKHNk.fixControlledValue)(value),
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled
    }));
});
var $9cda19a001f87ecf$export$2e2bcd8739ae039 = $9cda19a001f87ecf$var$Input;

});
parcelRegister("1pcHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1061fbcb6f08086c$export$2e2bcd8739ae039);
function $1061fbcb6f08086c$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

});



parcelRegister("4GwQn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $36948fc6671d6b75$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ResizableTextArea", () => (parcelRequire("4bXyH")).default);

var $8nd05 = parcelRequire("8nd05");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");

var $4bXyH = parcelRequire("4bXyH");
var $36948fc6671d6b75$var$TextArea = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(TextArea, _React$Component);
    var _super = (0, $enfmq.default)(TextArea);
    function TextArea(props) {
        var _this;
        (0, $6CZeq.default)(this, TextArea);
        _this = _super.call(this, props);
        _this.resizableTextArea = void 0;
        _this.focus = function() {
            _this.resizableTextArea.textArea.focus();
        };
        _this.saveTextArea = function(resizableTextArea) {
            _this.resizableTextArea = resizableTextArea;
        };
        _this.handleChange = function(e) {
            var onChange = _this.props.onChange;
            _this.setValue(e.target.value);
            if (onChange) onChange(e);
        };
        _this.handleKeyDown = function(e) {
            var _this$props = _this.props, onPressEnter = _this$props.onPressEnter, onKeyDown = _this$props.onKeyDown;
            if (e.keyCode === 13 && onPressEnter) onPressEnter(e);
            if (onKeyDown) onKeyDown(e);
        };
        var value = typeof props.value === 'undefined' || props.value === null ? props.defaultValue : props.value;
        _this.state = {
            value: value
        };
        return _this;
    }
    (0, $cHPF9.default)(TextArea, [
        {
            key: "setValue",
            value: function setValue(value, callback) {
                if (!('value' in this.props)) this.setState({
                    value: value
                }, callback);
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.resizableTextArea.textArea.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement((0, $4bXyH.default), (0, $8nd05.default)({}, this.props, {
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    ref: this.saveTextArea
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                if ('value' in nextProps) return {
                    value: nextProps.value
                };
                return null;
            }
        }
    ]);
    return TextArea;
}($acw62.Component);
var $36948fc6671d6b75$export$2e2bcd8739ae039 = $36948fc6671d6b75$var$TextArea;

});
parcelRegister("4bXyH", function(module, exports) {

$parcel$export(module.exports, "default", () => $30d6639cbca42aae$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $bVxlN = parcelRequire("bVxlN");

var $6hDTM = parcelRequire("6hDTM");

var $dTiBu = parcelRequire("dTiBu");

var $iSQh8 = parcelRequire("iSQh8");

var $8g1PZ = parcelRequire("8g1PZ");

var $jycHX = parcelRequire("jycHX");
var $30d6639cbca42aae$var$_excluded = [
    "prefixCls",
    "onPressEnter",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $30d6639cbca42aae$var$RESIZE_START = 0;
var $30d6639cbca42aae$var$RESIZE_MEASURING = 1;
var $30d6639cbca42aae$var$RESIZE_STABLE = 2;
var $30d6639cbca42aae$var$ResizableTextArea = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-textarea' : _props$prefixCls, onPressEnter = props.onPressEnter, defaultValue = props.defaultValue, value = props.value, autoSize = props.autoSize, onResize = props.onResize, className = props.className, style = props.style, disabled = props.disabled, onChange = props.onChange, onInternalAutoSize = props.onInternalAutoSize, restProps = (0, $9X7IJ.default)(props, $30d6639cbca42aae$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $iSQh8.default)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : '';
        }
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $acw62.useRef();
    $acw62.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $acw62.useMemo(function() {
        if (autoSize && (0, $fSwVM.default)(autoSize) === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $acw62.useState($30d6639cbca42aae$var$RESIZE_STABLE), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($30d6639cbca42aae$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $6hDTM.default)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $6hDTM.default)(function() {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_START) setResizeState($30d6639cbca42aae$var$RESIZE_MEASURING);
        else if (resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $jycHX.default)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($30d6639cbca42aae$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $acw62.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $dTiBu.default).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $dTiBu.default)(function() {
                    startResize();
                });
            }
        }
    };
    $acw62.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $d49SP.default)((0, $d49SP.default)({}, style), mergedAutoSizeStyle);
    if (resizeState === $30d6639cbca42aae$var$RESIZE_START || resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $acw62.createElement("textarea", (0, $8nd05.default)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $30d6639cbca42aae$export$2e2bcd8739ae039 = $30d6639cbca42aae$var$ResizableTextArea;

});
parcelRegister("bVxlN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8aeee349dead8f85$export$2e2bcd8739ae039);
$parcel$export(module.exports, "_rs", () => (parcelRequire("knKfz"))._rs);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");
parcelRequire("u43uR");

var $42BBK = parcelRequire("42BBK");

var $56fsy = parcelRequire("56fsy");

var $knKfz = parcelRequire("knKfz");
var $8aeee349dead8f85$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $8aeee349dead8f85$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $jWR62.default)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($8aeee349dead8f85$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $acw62.createElement((0, $42BBK.default), (0, $8nd05.default)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $8aeee349dead8f85$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($8aeee349dead8f85$var$ResizeObserver);
$8aeee349dead8f85$var$RefResizeObserver.Collection = (0, $56fsy.Collection);
var $8aeee349dead8f85$export$2e2bcd8739ae039 = $8aeee349dead8f85$var$RefResizeObserver;

});
parcelRegister("jWR62", function(module, exports) {

$parcel$export(module.exports, "default", () => $e85c9ef0f09d251f$export$2e2bcd8739ae039);

var $ims95 = parcelRequire("ims95");

var $acw62 = parcelRequire("acw62");
function $e85c9ef0f09d251f$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child));
        else if ((0, $ims95.default)(child) && child.props) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

});

parcelRegister("42BBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f1485708e9ce0e2$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $b2dYb = parcelRequire("b2dYb");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $56fsy = parcelRequire("56fsy");

var $knKfz = parcelRequire("knKfz");

var $2kud5 = parcelRequire("2kud5");
function $2f1485708e9ce0e2$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var onCollectionResize = $acw62.useContext((0, $56fsy.CollectionContext));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $85dLH.supportRef)(mergedChildren);
    var originRef = canRef ? (0, $85dLH.getNodeRef)(mergedChildren) : null;
    var mergedRef = (0, $85dLH.useComposeRef)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $b2dYb.default)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $fSwVM.default)(elementRef.current) === 'object' ? (0, $b2dYb.default)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $b2dYb.default)(wrapperRef.current);
    };
    $acw62.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $acw62.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $acw62.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $d49SP.default)((0, $d49SP.default)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $acw62.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $knKfz.observe)(currentElement, onInternalResize);
        return function() {
            return (0, $knKfz.unobserve)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $2kud5.default), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $2f1485708e9ce0e2$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($2f1485708e9ce0e2$var$SingleObserver);
var $2f1485708e9ce0e2$export$2e2bcd8739ae039 = $2f1485708e9ce0e2$var$RefSingleObserver;

});
parcelRegister("56fsy", function(module, exports) {

$parcel$export(module.exports, "CollectionContext", () => $3b6981416c8ff0a7$export$db36075d98ba73d3);
$parcel$export(module.exports, "Collection", () => $3b6981416c8ff0a7$export$fb8073518f34e6ec);

var $acw62 = parcelRequire("acw62");
var $3b6981416c8ff0a7$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $3b6981416c8ff0a7$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $acw62.useRef(0);
    var resizeInfosRef = $acw62.useRef([]);
    var onCollectionResize = $acw62.useContext($3b6981416c8ff0a7$export$db36075d98ba73d3);
    var onResize = $acw62.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($3b6981416c8ff0a7$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}

});

parcelRegister("knKfz", function(module, exports) {

$parcel$export(module.exports, "_rs", () => $ed69d4f7f0510fbd$export$524f0fd3b47831a);
$parcel$export(module.exports, "observe", () => $ed69d4f7f0510fbd$export$d1203567a167490e);
$parcel$export(module.exports, "unobserve", () => $ed69d4f7f0510fbd$export$23a2283368c55ea2);

var $bEEfE = parcelRequire("bEEfE");
// =============================== Const ===============================
var $ed69d4f7f0510fbd$var$elementListeners = new Map();
function $ed69d4f7f0510fbd$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $ed69d4f7f0510fbd$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $ed69d4f7f0510fbd$var$resizeObserver = new (0, $bEEfE.default)($ed69d4f7f0510fbd$var$onResize);
var $ed69d4f7f0510fbd$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $ed69d4f7f0510fbd$export$524f0fd3b47831a = null; // eslint-disable-line
function $ed69d4f7f0510fbd$export$d1203567a167490e(element, callback) {
    if (!$ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.set(element, new Set());
        $ed69d4f7f0510fbd$var$resizeObserver.observe(element);
    }
    $ed69d4f7f0510fbd$var$elementListeners.get(element).add(callback);
}
function $ed69d4f7f0510fbd$export$23a2283368c55ea2(element, callback) {
    if ($ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.get(element).delete(callback);
        if (!$ed69d4f7f0510fbd$var$elementListeners.get(element).size) {
            $ed69d4f7f0510fbd$var$resizeObserver.unobserve(element);
            $ed69d4f7f0510fbd$var$elementListeners.delete(element);
        }
    }
}

});
parcelRegister("bEEfE", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c2a74187854fda$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $87c2a74187854fda$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $87c2a74187854fda$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $87c2a74187854fda$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $87c2a74187854fda$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($87c2a74187854fda$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $87c2a74187854fda$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $87c2a74187854fda$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $87c2a74187854fda$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $87c2a74187854fda$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $87c2a74187854fda$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $87c2a74187854fda$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $87c2a74187854fda$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $87c2a74187854fda$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $87c2a74187854fda$var$throttle(this.refresh.bind(this), $87c2a74187854fda$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$87c2a74187854fda$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($87c2a74187854fda$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$87c2a74187854fda$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $87c2a74187854fda$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $87c2a74187854fda$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $87c2a74187854fda$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $87c2a74187854fda$var$global$1;
};
// Placeholder of an empty content rectangle.
var $87c2a74187854fda$var$emptyRect = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $87c2a74187854fda$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $87c2a74187854fda$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $87c2a74187854fda$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $87c2a74187854fda$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $87c2a74187854fda$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $87c2a74187854fda$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $87c2a74187854fda$var$emptyRect;
    var styles = $87c2a74187854fda$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $87c2a74187854fda$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $87c2a74187854fda$var$toFloat(styles.width), height = $87c2a74187854fda$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $87c2a74187854fda$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $87c2a74187854fda$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$87c2a74187854fda$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $87c2a74187854fda$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $87c2a74187854fda$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $87c2a74187854fda$var$isDocumentElement(target) {
    return target === $87c2a74187854fda$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getContentRect(target) {
    if (!$87c2a74187854fda$var$isBrowser) return $87c2a74187854fda$var$emptyRect;
    if ($87c2a74187854fda$var$isSVGGraphicsElement(target)) return $87c2a74187854fda$var$getSVGContentRect(target);
    return $87c2a74187854fda$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $87c2a74187854fda$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $87c2a74187854fda$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $87c2a74187854fda$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $87c2a74187854fda$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $87c2a74187854fda$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $87c2a74187854fda$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $87c2a74187854fda$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $87c2a74187854fda$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $87c2a74187854fda$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $87c2a74187854fda$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $87c2a74187854fda$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $87c2a74187854fda$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $87c2a74187854fda$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $87c2a74187854fda$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $87c2a74187854fda$var$ResizeObserverController.getInstance();
        var observer = new $87c2a74187854fda$var$ResizeObserverSPI(callback, controller, this);
        $87c2a74187854fda$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $87c2a74187854fda$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $87c2a74187854fda$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $87c2a74187854fda$var$index = function() {
    // Export existing implementation if available.
    if (typeof $87c2a74187854fda$var$global$1.ResizeObserver !== 'undefined') return $87c2a74187854fda$var$global$1.ResizeObserver;
    return $87c2a74187854fda$var$ResizeObserver;
}();
var $87c2a74187854fda$export$2e2bcd8739ae039 = $87c2a74187854fda$var$index;

});


parcelRegister("2kud5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b24e2207f75c1d9$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $1b24e2207f75c1d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(DomWrapper, _React$Component);
    var _super = (0, $enfmq.default)(DomWrapper);
    function DomWrapper() {
        (0, $6CZeq.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);

});



parcelRegister("jycHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039);
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $e3bb0cd99ab7a8bc$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break'
];
var $e3bb0cd99ab7a8bc$var$computedStyleCache = {};
var $e3bb0cd99ab7a8bc$var$hiddenTextarea;
function $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef]) return $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    var sizingStyle = $e3bb0cd99ab7a8bc$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$e3bb0cd99ab7a8bc$var$hiddenTextarea) {
        $e3bb0cd99ab7a8bc$var$hiddenTextarea = document.createElement('textarea');
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        document.body.appendChild($e3bb0cd99ab7a8bc$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $e3bb0cd99ab7a8bc$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat($e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE));
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = ' ';
        var singleRowHeight = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}

});



parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("8KbLt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $65dbbed9df0fecca$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Option", () => (parcelRequire("44Iii")).default);
$parcel$export(module.exports, "OptGroup", () => (parcelRequire("hrhZj")).default);
$parcel$export(module.exports, "BaseSelect", () => (parcelRequire("3VCcq")).default);
$parcel$export(module.exports, "useBaseProps", () => (parcelRequire("j4N1P")).default);

var $bOIlc = parcelRequire("bOIlc");

var $44Iii = parcelRequire("44Iii");

var $hrhZj = parcelRequire("hrhZj");

var $3VCcq = parcelRequire("3VCcq");

var $j4N1P = parcelRequire("j4N1P");
var $65dbbed9df0fecca$export$2e2bcd8739ae039 = (0, $bOIlc.default);

});
parcelRegister("bOIlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a6c2622fd5143d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $iSQh8 = parcelRequire("iSQh8");
parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $3VCcq = parcelRequire("3VCcq");

var $crRya = parcelRequire("crRya");

var $6aTT2 = parcelRequire("6aTT2");

var $bx56F = parcelRequire("bx56F");

var $snZJc = parcelRequire("snZJc");

var $lzFkw = parcelRequire("lzFkw");

var $hrhZj = parcelRequire("hrhZj");

var $44Iii = parcelRequire("44Iii");

var $6nzAB = parcelRequire("6nzAB");

var $5UvVe = parcelRequire("5UvVe");

var $cOl8a = parcelRequire("cOl8a");

var $8V0pl = parcelRequire("8V0pl");
parcelRequire("1bH4p");
var $89a6c2622fd5143d$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "listHeight",
    "listItemHeight",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange"
];
var $89a6c2622fd5143d$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $89a6c2622fd5143d$var$isRawValue(value) {
    return !value || (0, $fSwVM.default)(value) !== 'object';
}
var $89a6c2622fd5143d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-select' : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, restProps = (0, $9X7IJ.default)(props, $89a6c2622fd5143d$var$_excluded);
    var mergedId = (0, $bx56F.default)(id);
    var multiple = (0, $3VCcq.isMultiple)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $acw62.useMemo(function() {
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $acw62.useMemo(function() {
        return (0, $8V0pl.fillFieldNames)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $iSQh8.default)('', {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || '';
        }
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $snZJc.default)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $acw62.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $cOl8a.toArray)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($89a6c2622fd5143d$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                var optionLabel;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $iSQh8.default)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $acw62.useMemo(function() {
        var _values$;
        var values = convert2LabelValues(internalValue);
        // combobox no need save value when it's no value
        if (mode === 'combobox' && !((_values$ = values[0]) !== null && _values$ !== void 0 && _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $crRya.default)(rawLabeledValues, valueOptions), _useCache2 = (0, $eUqlC.default)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $acw62.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _item$label;
            return (0, $d49SP.default)((0, $d49SP.default)({}, item), {}, {
                label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
            });
        });
    }, [
        mode,
        mergedValues
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $acw62.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $acw62.useEffect(function() {
        if (mode === 'combobox') {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $cOl8a.hasValue)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $lzFkw.default)(function(val, label) {
        var _ref;
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return _ref = {}, (0, $kSlfw.default)(_ref, mergedFieldNames.value, val), (0, $kSlfw.default)(_ref, mergedFieldNames.label, mergedLabel), _ref;
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $acw62.useMemo(function() {
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $kbxxf.default)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $kbxxf.default)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $6aTT2.default)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $acw62.useMemo(function() {
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || 'value'] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $kbxxf.default)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue
    ]);
    var orderedFilteredOptions = $acw62.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return (0, $kbxxf.default)(filledSearchOptions).sort(function(a, b) {
            return filterSort(a, b);
        });
    }, [
        filledSearchOptions,
        filterSort
    ]);
    var displayOptions = $acw62.useMemo(function() {
        return (0, $8V0pl.flattenOptions)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $8V0pl.injectPropsWithOption)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState(0), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    var onActiveValue = $acw62.useCallback(function(active, index) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? 'keyboard' : _ref2$source;
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $8V0pl.injectPropsWithOption)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $eUqlC.default)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== 'clear') {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $eUqlC.default)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $lzFkw.default)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $kbxxf.default)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') // setSearchValue(String(val));
        setActiveValue('');
        else if (!(0, $3VCcq.isMultiple) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === 'remove' || type === 'clear') values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            var formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $kbxxf.default)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== 'tags') patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $kbxxf.default)(rawValues), (0, $kbxxf.default)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $acw62.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $d49SP.default)((0, $d49SP.default)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData
        });
    }, [
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        listHeight,
        listItemHeight,
        childrenAsData
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $acw62.createElement((0, $5UvVe.default).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $acw62.createElement((0, $3VCcq.default), (0, $8nd05.default)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $89a6c2622fd5143d$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $6nzAB.default),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
var $89a6c2622fd5143d$var$TypedSelect = $89a6c2622fd5143d$var$Select;
$89a6c2622fd5143d$var$TypedSelect.Option = (0, $44Iii.default);
$89a6c2622fd5143d$var$TypedSelect.OptGroup = (0, $hrhZj.default);
var $89a6c2622fd5143d$export$2e2bcd8739ae039 = $89a6c2622fd5143d$var$TypedSelect;

});
parcelRegister("3VCcq", function(module, exports) {

$parcel$export(module.exports, "isMultiple", () => $2dc4538d56993d0c$export$7f654ad2a77ad2ac);
$parcel$export(module.exports, "default", () => $2dc4538d56993d0c$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $6hDTM = parcelRequire("6hDTM");

var $iSQh8 = parcelRequire("iSQh8");

var $ycMhT = parcelRequire("ycMhT");

var $iCi4s = parcelRequire("iCi4s");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $j4N1P = parcelRequire("j4N1P");

var $9keRV = parcelRequire("9keRV");

var $i5RgH = parcelRequire("i5RgH");

var $f0a4e = parcelRequire("f0a4e");

var $7ryVA = parcelRequire("7ryVA");

var $23KWR = parcelRequire("23KWR");

var $9EMjj = parcelRequire("9EMjj");

var $8V0pl = parcelRequire("8V0pl");
var $2dc4538d56993d0c$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "showArrow",
    "inputIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $2dc4538d56993d0c$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'autoFocus',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex'
];
function $2dc4538d56993d0c$export$7f654ad2a77ad2ac(mode) {
    return mode === 'tags' || mode === 'multiple';
}
var $2dc4538d56993d0c$var$BaseSelect = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _customizeRawInputEle, _classNames2;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, showArrow = props.showArrow, inputIcon = props.inputIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $9X7IJ.default)(props, $2dc4538d56993d0c$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $2dc4538d56993d0c$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === 'combobox';
    var domProps = (0, $d49SP.default)({}, restProps);
    $2dc4538d56993d0c$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $acw62.useEffect(function() {
        // Only update on the client side
        setMobile((0, $ycMhT.default)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $acw62.useRef(null);
    var selectorDomRef = $acw62.useRef(null);
    var triggerRef = $acw62.useRef(null);
    var selectorRef = $acw62.useRef(null);
    var listRef = $acw62.useRef(null);
    /** Used for component focused management */ var _useDelayReset = (0, $9keRV.default)(), _useDelayReset2 = (0, $eUqlC.default)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $acw62.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            }
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $acw62.useMemo(function() {
        var _displayValues$;
        if (mode !== 'combobox') return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === 'function' && getRawInputElement();
    var customizeRawInputRef = (0, $85dLH.useComposeRef)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 ? void 0 : (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    var _useMergedState = (0, $iSQh8.default)(undefined, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = innerOpen;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === 'combobox') mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $acw62.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $acw62.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                '\n',
                '\r\n'
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : (0, $8V0pl.getSeparatedContent)(searchText, tokenSeparators);
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Close will clean up single mode search text
    $acw62.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $acw62.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        if (disabled) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $i5RgH.default)(), _useLock2 = (0, $eUqlC.default)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var which = event.which;
        if (which === (0, $iCi4s.default).ENTER) {
            // Do not submit form when type in the input
            if (mode !== 'combobox') event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (which === (0, $iCi4s.default).BACKSPACE && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $kbxxf.default)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen && listRef.current) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen && listRef.current) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $acw62.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        setMockFocused(false, function() {
            focusRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $acw62.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), containerWidth = _React$useState4[0], setContainerWidth = _React$useState4[1];
    var _React$useState5 = $acw62.useState({}), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    (0, $6hDTM.default)(function() {
        if (triggerOpen) {
            var _containerRef$current;
            var newWidth = Math.ceil((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth);
            if (containerWidth !== newWidth && !Number.isNaN(newWidth)) setContainerWidth(newWidth);
        }
    }, [
        triggerOpen
    ]);
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $f0a4e.default)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $acw62.useMemo(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var mergedShowArrow = showArrow !== undefined ? showArrow : loading || !multiple && mode !== 'combobox';
    var arrowNode;
    if (mergedShowArrow) arrowNode = /*#__PURE__*/ $acw62.createElement((0, $9EMjj.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-arrow"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: inputIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var clearNode;
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    if (!disabled && allowClear && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '')) clearNode = /*#__PURE__*/ $acw62.createElement((0, $9EMjj.default), {
        className: "".concat(prefixCls, "-clear"),
        onMouseDown: onClearMouseDown,
        customizeIcon: clearIcon
    }, "\xD7");
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $acw62.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (_classNames2 = {}, (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-multiple"), multiple), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-single"), !multiple), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-show-arrow"), mergedShowArrow), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-loading"), loading), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $acw62.createElement((0, $23KWR.default), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        containerWidth: containerWidth,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode() {
            return selectorDomRef.current;
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $acw62.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $acw62.createElement((0, $7ryVA.default), (0, $8nd05.default)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        },
        "aria-live": "polite"
    }, "".concat(displayValues.map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            'number',
            'string'
        ].includes((0, $fSwVM.default)(label)) ? label : value;
    }).join(', '))), selectorNode, arrowNode, clearNode);
    return /*#__PURE__*/ $acw62.createElement((0, $j4N1P.BaseSelectContext).Provider, {
        value: baseSelectContext
    }, renderNode);
});
var $2dc4538d56993d0c$export$2e2bcd8739ae039 = $2dc4538d56993d0c$var$BaseSelect;

});
parcelRegister("ycMhT", function(module, exports) {

$parcel$export(module.exports, "default", () => $066d1680709fcf3c$export$2e2bcd8739ae039);
var $066d1680709fcf3c$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};

});

parcelRegister("iCi4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d9cb1a28007639$export$2e2bcd8739ae039);
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d8d9cb1a28007639$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d8d9cb1a28007639$var$KeyCode.F1 && keyCode <= $d8d9cb1a28007639$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.ALT:
            case $d8d9cb1a28007639$var$KeyCode.CAPS_LOCK:
            case $d8d9cb1a28007639$var$KeyCode.CONTEXT_MENU:
            case $d8d9cb1a28007639$var$KeyCode.CTRL:
            case $d8d9cb1a28007639$var$KeyCode.DOWN:
            case $d8d9cb1a28007639$var$KeyCode.END:
            case $d8d9cb1a28007639$var$KeyCode.ESC:
            case $d8d9cb1a28007639$var$KeyCode.HOME:
            case $d8d9cb1a28007639$var$KeyCode.INSERT:
            case $d8d9cb1a28007639$var$KeyCode.LEFT:
            case $d8d9cb1a28007639$var$KeyCode.MAC_FF_META:
            case $d8d9cb1a28007639$var$KeyCode.META:
            case $d8d9cb1a28007639$var$KeyCode.NUMLOCK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_CENTER:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_DOWN:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_UP:
            case $d8d9cb1a28007639$var$KeyCode.PAUSE:
            case $d8d9cb1a28007639$var$KeyCode.PRINT_SCREEN:
            case $d8d9cb1a28007639$var$KeyCode.RIGHT:
            case $d8d9cb1a28007639$var$KeyCode.SHIFT:
            case $d8d9cb1a28007639$var$KeyCode.UP:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NINE) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.NUM_ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.A && keyCode <= $d8d9cb1a28007639$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.SPACE:
            case $d8d9cb1a28007639$var$KeyCode.QUESTION_MARK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PLUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_MINUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.NUM_DIVISION:
            case $d8d9cb1a28007639$var$KeyCode.SEMICOLON:
            case $d8d9cb1a28007639$var$KeyCode.DASH:
            case $d8d9cb1a28007639$var$KeyCode.EQUALS:
            case $d8d9cb1a28007639$var$KeyCode.COMMA:
            case $d8d9cb1a28007639$var$KeyCode.PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.SLASH:
            case $d8d9cb1a28007639$var$KeyCode.APOSTROPHE:
            case $d8d9cb1a28007639$var$KeyCode.SINGLE_QUOTE:
            case $d8d9cb1a28007639$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d8d9cb1a28007639$var$KeyCode.BACKSLASH:
            case $d8d9cb1a28007639$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d8d9cb1a28007639$export$2e2bcd8739ae039 = $d8d9cb1a28007639$var$KeyCode;

});

parcelRegister("j4N1P", function(module, exports) {

$parcel$export(module.exports, "BaseSelectContext", () => $de346c10040f695b$export$8234047c0aea33cf);
$parcel$export(module.exports, "default", () => $de346c10040f695b$export$2e2bcd8739ae039);
/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $acw62 = parcelRequire("acw62");
var $de346c10040f695b$export$8234047c0aea33cf = /*#__PURE__*/ $acw62.createContext(null);
function $de346c10040f695b$export$2e2bcd8739ae039() {
    return $acw62.useContext($de346c10040f695b$export$8234047c0aea33cf);
}

});

parcelRegister("9keRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca183ed87ff681f$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $6ca183ed87ff681f$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $acw62.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $acw62.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}

});

parcelRegister("i5RgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c203a0ff231923$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d2c203a0ff231923$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $acw62.useRef(null);
    var timeoutRef = $acw62.useRef(null);
    // Clean up
    $acw62.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}

});

parcelRegister("f0a4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $aebeaa3bc993c458$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $aebeaa3bc993c458$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $acw62.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $acw62.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener('mousedown', onGlobalMouseDown);
        return function() {
            return window.removeEventListener('mousedown', onGlobalMouseDown);
        };
    }, []);
}

});

parcelRegister("7ryVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $56b625f0dbf4c4f8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $iCi4s = parcelRequire("iCi4s");

var $ijRuN = parcelRequire("ijRuN");

var $dKDHe = parcelRequire("dKDHe");

var $i5RgH = parcelRequire("i5RgH");

var $6qBLl = parcelRequire("6qBLl");
var $56b625f0dbf4c4f8$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $acw62.useRef)(null);
    var compositionStatusRef = (0, $acw62.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
    // ======================= Ref =======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                inputRef.current.focus();
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $i5RgH.default)(0), _useLock2 = (0, $eUqlC.default)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        if (which === (0, $iCi4s.default).UP || which === (0, $iCi4s.default).DOWN) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $iCi4s.default).ENTER && mode === 'tags' && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        if ((0, $6qBLl.isValidateOpenKey)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $acw62.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== 'combobox') triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData.getData('text');
        pastedTextRef.current = value;
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        if (event.target !== inputRef.current && !inputMouseDown && mode !== 'combobox') event.preventDefault();
        if (mode !== 'combobox' && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch('', true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd
    };
    var selectNode = mode === 'multiple' || mode === 'tags' ? /*#__PURE__*/ $acw62.createElement((0, $ijRuN.default), (0, $8nd05.default)({}, props, sharedProps)) : /*#__PURE__*/ $acw62.createElement((0, $dKDHe.default), (0, $8nd05.default)({}, props, sharedProps));
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, selectNode);
};
var $56b625f0dbf4c4f8$var$ForwardSelector = /*#__PURE__*/ $acw62.forwardRef($56b625f0dbf4c4f8$var$Selector);
$56b625f0dbf4c4f8$var$ForwardSelector.displayName = 'Selector';
var $56b625f0dbf4c4f8$export$2e2bcd8739ae039 = $56b625f0dbf4c4f8$var$ForwardSelector;

});
parcelRegister("ijRuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5637f77b1efb84d$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $3ryW7 = parcelRequire("3ryW7");

var $6dkAu = parcelRequire("6dkAu");

var $9EMjj = parcelRequire("9EMjj");

var $3BIwc = parcelRequire("3BIwc");

var $8lVtc = parcelRequire("8lVtc");

var $cOl8a = parcelRequire("cOl8a");
function $d5637f77b1efb84d$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $d5637f77b1efb84d$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $d5637f77b1efb84d$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var measureRef = $acw62.useRef(null);
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $eUqlC.default)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $eUqlC.default)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === "multiple" && autoClearSearchValue === false || mode === 'tags' ? searchValue : '';
    var inputEditable = mode === 'tags' || mode === "multiple" && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $8lVtc.default)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(selectionPrefixCls, "-item"), (0, $kSlfw.default)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled)),
            title: (0, $cOl8a.getTitle)(item)
        }, /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $acw62.createElement((0, $9EMjj.default), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $d5637f77b1efb84d$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose) {
        var onMouseDown = function onMouseDown(e) {
            $d5637f77b1efb84d$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $acw62.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose
        }));
    }
    function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
        var content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return defaultRenderSelector({
            title: content
        }, content, false);
    }
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $3BIwc.default), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $3ryW7.default)(props, true)
    }), /*#__PURE__*/ $acw62.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xA0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $d5637f77b1efb84d$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $d5637f77b1efb84d$export$2e2bcd8739ae039 = $d5637f77b1efb84d$var$SelectSelector;

});
parcelRegister("3ryW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $281efe5882c936de$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");
var $281efe5882c936de$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $281efe5882c936de$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $281efe5882c936de$var$propList = "".concat($281efe5882c936de$var$attributes, " ").concat($281efe5882c936de$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $281efe5882c936de$var$ariaPrefix = 'aria-';
var $281efe5882c936de$var$dataPrefix = 'data-';
function $281efe5882c936de$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $281efe5882c936de$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $d49SP.default)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $281efe5882c936de$var$match(key, $281efe5882c936de$var$ariaPrefix)) || // Data
        mergedConfig.data && $281efe5882c936de$var$match(key, $281efe5882c936de$var$dataPrefix) || // Attr
        mergedConfig.attr && $281efe5882c936de$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}

});

parcelRegister("6dkAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4863ed3a14942ec4$export$2e2bcd8739ae039);

var $3unmm = parcelRequire("3unmm");
var $4863ed3a14942ec4$export$2e2bcd8739ae039 = (0, $3unmm.default);

});
parcelRegister("3unmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a64b28232d3cd3$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");

var $6hDTM = parcelRequire("6hDTM");

var $qp3UV = parcelRequire("qp3UV");

var $khBri = parcelRequire("khBri");

var $24COT = parcelRequire("24COT");

var $5MJBM = parcelRequire("5MJBM");
var $28a64b28232d3cd3$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $28a64b28232d3cd3$var$RESPONSIVE = 'responsive';
var $28a64b28232d3cd3$var$INVALIDATE = 'invalidate';
function $28a64b28232d3cd3$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $28a64b28232d3cd3$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $9X7IJ.default)(props, $28a64b28232d3cd3$var$_excluded);
    var fullySSR = ssr === 'full';
    var notifyEffectUpdate = (0, $khBri.useBatcher)();
    var _useEffectState = (0, $khBri.default)(notifyEffectUpdate, null), _useEffectState2 = (0, $eUqlC.default)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $khBri.default)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $eUqlC.default)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $khBri.default)(notifyEffectUpdate, 0), _useEffectState6 = (0, $eUqlC.default)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $khBri.default)(notifyEffectUpdate, 0), _useEffectState8 = (0, $eUqlC.default)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $khBri.default)(notifyEffectUpdate, 0), _useEffectState10 = (0, $eUqlC.default)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $eUqlC.default)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $acw62.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $eUqlC.default)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $28a64b28232d3cd3$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $28a64b28232d3cd3$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    var mergedData = (0, $acw62.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $acw62.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $acw62.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === 'function') return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $acw62.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $6hDTM.default)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $5MJBM.OverflowContext).Provider, {
            key: key,
            value: (0, $d49SP.default)((0, $d49SP.default)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    var mergedRenderRest = renderRest || $28a64b28232d3cd3$var$defaultRenderRest;
    var restNode = renderRawRest ? /*#__PURE__*/ $acw62.createElement((0, $5MJBM.OverflowContext).Provider, {
        value: (0, $d49SP.default)((0, $d49SP.default)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    var overflowNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
var $28a64b28232d3cd3$var$ForwardOverflow = /*#__PURE__*/ $acw62.forwardRef($28a64b28232d3cd3$var$Overflow);
$28a64b28232d3cd3$var$ForwardOverflow.displayName = 'Overflow';
$28a64b28232d3cd3$var$ForwardOverflow.Item = (0, $24COT.default);
$28a64b28232d3cd3$var$ForwardOverflow.RESPONSIVE = $28a64b28232d3cd3$var$RESPONSIVE;
$28a64b28232d3cd3$var$ForwardOverflow.INVALIDATE = $28a64b28232d3cd3$var$INVALIDATE;
var // Convert to generic type
$28a64b28232d3cd3$export$2e2bcd8739ae039 = $28a64b28232d3cd3$var$ForwardOverflow;

});
parcelRegister("qp3UV", function(module, exports) {

$parcel$export(module.exports, "default", () => $04f5dea65135d084$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");
var $04f5dea65135d084$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $04f5dea65135d084$var$UNDEFINED = undefined;
function $04f5dea65135d084$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, restProps = (0, $9X7IJ.default)(props, $04f5dea65135d084$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $acw62.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $04f5dea65135d084$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $04f5dea65135d084$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $04f5dea65135d084$var$UNDEFINED,
        order: responsive ? order : $04f5dea65135d084$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $04f5dea65135d084$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $04f5dea65135d084$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    var itemNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(!invalidate && prefixCls, className),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $04f5dea65135d084$var$Item = /*#__PURE__*/ $acw62.forwardRef($04f5dea65135d084$var$InternalItem);
$04f5dea65135d084$var$Item.displayName = 'Item';
var $04f5dea65135d084$export$2e2bcd8739ae039 = $04f5dea65135d084$var$Item;

});

parcelRegister("khBri", function(module, exports) {

$parcel$export(module.exports, "useBatcher", () => $ec426fd785b0196a$export$eedf51fe9d751c7a);
$parcel$export(module.exports, "default", () => $ec426fd785b0196a$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $a4gyP = parcelRequire("a4gyP");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $gMdgc = parcelRequire("gMdgc");
function $ec426fd785b0196a$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $acw62.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $gMdgc.default)(function() {
                (0, $1u0KT.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $ec426fd785b0196a$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $a4gyP.default)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}

});
parcelRegister("gMdgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36b6a4565c7d957$export$2e2bcd8739ae039);

var $dTiBu = parcelRequire("dTiBu");
function $c36b6a4565c7d957$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $dTiBu.default)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}

});


parcelRegister("24COT", function(module, exports) {

$parcel$export(module.exports, "default", () => $182a1149db3c9d79$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $qp3UV = parcelRequire("qp3UV");

var $5MJBM = parcelRequire("5MJBM");
var $182a1149db3c9d79$var$_excluded = [
    "component"
], $182a1149db3c9d79$var$_excluded2 = [
    "className"
], $182a1149db3c9d79$var$_excluded3 = [
    "className"
];
var $182a1149db3c9d79$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $acw62.useContext((0, $5MJBM.OverflowContext));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _restProps = (0, $9X7IJ.default)(props, $182a1149db3c9d79$var$_excluded);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $9X7IJ.default)(context, $182a1149db3c9d79$var$_excluded2);
    var className = props.className, restProps = (0, $9X7IJ.default)(props, $182a1149db3c9d79$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $acw62.createElement((0, $5MJBM.OverflowContext).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $qp3UV.default), (0, $8nd05.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(contextClassName, className)
    }, restContext, restProps)));
};
var $182a1149db3c9d79$var$RawItem = /*#__PURE__*/ $acw62.forwardRef($182a1149db3c9d79$var$InternalRawItem);
$182a1149db3c9d79$var$RawItem.displayName = 'RawItem';
var $182a1149db3c9d79$export$2e2bcd8739ae039 = $182a1149db3c9d79$var$RawItem;

});
parcelRegister("5MJBM", function(module, exports) {

$parcel$export(module.exports, "OverflowContext", () => $4364d04fa4ed57d4$export$79f16dd643143c25);

var $acw62 = parcelRequire("acw62");
var $4364d04fa4ed57d4$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});




parcelRegister("9EMjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $707d52f2ac65b829$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
var $707d52f2ac65b829$var$TransBtn = function TransBtn(_ref) {
    var className = _ref.className, customizeIcon = _ref.customizeIcon, customizeIconProps = _ref.customizeIconProps, _onMouseDown = _ref.onMouseDown, onClick = _ref.onClick, children = _ref.children;
    var icon;
    if (typeof customizeIcon === 'function') icon = customizeIcon(customizeIconProps);
    else icon = customizeIcon;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            if (_onMouseDown) _onMouseDown(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none'
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $707d52f2ac65b829$export$2e2bcd8739ae039 = $707d52f2ac65b829$var$TransBtn;

});

parcelRegister("3BIwc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a075c3c6c029a86$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $u43uR = parcelRequire("u43uR");
var $2a075c3c6c029a86$var$Input = function Input(_ref, ref) {
    var _inputNode2, _inputNode2$props;
    var prefixCls = _ref.prefixCls, id = _ref.id, inputElement = _ref.inputElement, disabled = _ref.disabled, tabIndex = _ref.tabIndex, autoFocus = _ref.autoFocus, autoComplete = _ref.autoComplete, editable = _ref.editable, activeDescendantId = _ref.activeDescendantId, value = _ref.value, maxLength = _ref.maxLength, _onKeyDown = _ref.onKeyDown, _onMouseDown = _ref.onMouseDown, _onChange = _ref.onChange, onPaste = _ref.onPaste, _onCompositionStart = _ref.onCompositionStart, _onCompositionEnd = _ref.onCompositionEnd, open = _ref.open, attrs = _ref.attrs;
    var inputNode = inputElement || /*#__PURE__*/ $acw62.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, style = originProps.style;
    (0, $u43uR.warning)(!('maxLength' in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $acw62.cloneElement(inputNode, (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
        type: 'search'
    }, originProps), {}, {
        // Override over origin props
        id: id,
        ref: (0, $85dLH.composeRef)(ref, originRef),
        disabled: disabled,
        tabIndex: tabIndex,
        autoComplete: autoComplete || 'off',
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 ? void 0 : (_inputNode2$props = _inputNode2.props) === null || _inputNode2$props === void 0 ? void 0 : _inputNode2$props.className),
        role: 'combobox',
        'aria-expanded': open,
        'aria-haspopup': 'listbox',
        'aria-owns': "".concat(id, "_list"),
        'aria-autocomplete': 'list',
        'aria-controls': "".concat(id, "_list"),
        'aria-activedescendant': activeDescendantId
    }, attrs), {}, {
        value: editable ? value : '',
        maxLength: maxLength,
        readOnly: !editable,
        unselectable: !editable ? 'on' : null,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), {}, {
            opacity: editable ? null : 0
        }),
        onKeyDown: function onKeyDown(event) {
            _onKeyDown(event);
            if (onOriginKeyDown) onOriginKeyDown(event);
        },
        onMouseDown: function onMouseDown(event) {
            _onMouseDown(event);
            if (onOriginMouseDown) onOriginMouseDown(event);
        },
        onChange: function onChange(event) {
            _onChange(event);
            if (onOriginChange) onOriginChange(event);
        },
        onCompositionStart: function onCompositionStart(event) {
            _onCompositionStart(event);
            if (onOriginCompositionStart) onOriginCompositionStart(event);
        },
        onCompositionEnd: function onCompositionEnd(event) {
            _onCompositionEnd(event);
            if (onOriginCompositionEnd) onOriginCompositionEnd(event);
        },
        onPaste: onPaste
    }));
    return inputNode;
};
var $2a075c3c6c029a86$var$RefInput = /*#__PURE__*/ $acw62.forwardRef($2a075c3c6c029a86$var$Input);
$2a075c3c6c029a86$var$RefInput.displayName = 'Input';
var $2a075c3c6c029a86$export$2e2bcd8739ae039 = $2a075c3c6c029a86$var$RefInput;

});

parcelRegister("8lVtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $614cdd3d723d82e4$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/rules-of-hooks */ 
var $acw62 = parcelRequire("acw62");

var $cOl8a = parcelRequire("cOl8a");
function $614cdd3d723d82e4$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $cOl8a.isBrowserClient) /* istanbul ignore next */ $acw62.useLayoutEffect(effect, deps);
    else $acw62.useEffect(effect, deps);
} /* eslint-enable */ 

});
parcelRegister("cOl8a", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $953a8baf84e85e44$export$45b10814cc054894);
$parcel$export(module.exports, "isBrowserClient", () => $953a8baf84e85e44$export$df7146797a248522);
$parcel$export(module.exports, "hasValue", () => $953a8baf84e85e44$export$96bdbc84526f3739);
$parcel$export(module.exports, "getTitle", () => $953a8baf84e85e44$export$70d1bf7729efff40);

var $fSwVM = parcelRequire("fSwVM");
function $953a8baf84e85e44$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $953a8baf84e85e44$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
var $953a8baf84e85e44$export$df7146797a248522 = $953a8baf84e85e44$export$7383f122bf48ec30;
function $953a8baf84e85e44$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $953a8baf84e85e44$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes((0, $fSwVM.default)(title));
}
function $953a8baf84e85e44$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($953a8baf84e85e44$var$isTitleType(item.title)) title = item.title.toString();
        else if ($953a8baf84e85e44$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}

});



parcelRegister("dKDHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a02e5d1ded01272e$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $3ryW7 = parcelRequire("3ryW7");

var $3BIwc = parcelRequire("3BIwc");

var $cOl8a = parcelRequire("cOl8a");
var $a02e5d1ded01272e$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === 'combobox';
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || '';
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $acw62.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== 'combobox' && !open && !showSearch ? false : !!inputValue;
    // Get title
    var title = (0, $cOl8a.getTitle)(item);
    var renderPlaceholder = function renderPlaceholder() {
        if (item) return null;
        var hiddenStyle = hasTextInput ? {
            visibility: 'hidden'
        } : undefined;
        return /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hiddenStyle
        }, placeholder);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $acw62.createElement((0, $3BIwc.default), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $3ryW7.default)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: title,
        style: hasTextInput ? {
            visibility: 'hidden'
        } : undefined
    }, item.label) : null, renderPlaceholder());
};
var $a02e5d1ded01272e$export$2e2bcd8739ae039 = $a02e5d1ded01272e$var$SingleSelector;

});

parcelRegister("6qBLl", function(module, exports) {

$parcel$export(module.exports, "isValidateOpenKey", () => $4ae276a1f02fe75e$export$48ac81d4a07c29c);

var $iCi4s = parcelRequire("iCi4s");
function $4ae276a1f02fe75e$export$48ac81d4a07c29c(currentKeyCode) {
    return ![
        // System function button
        (0, $iCi4s.default).ESC,
        (0, $iCi4s.default).SHIFT,
        (0, $iCi4s.default).BACKSPACE,
        (0, $iCi4s.default).TAB,
        (0, $iCi4s.default).WIN_KEY,
        (0, $iCi4s.default).ALT,
        (0, $iCi4s.default).META,
        (0, $iCi4s.default).WIN_KEY_RIGHT,
        (0, $iCi4s.default).CTRL,
        (0, $iCi4s.default).SEMICOLON,
        (0, $iCi4s.default).EQUALS,
        (0, $iCi4s.default).CAPS_LOCK,
        (0, $iCi4s.default).CONTEXT_MENU,
        // F1-F12
        (0, $iCi4s.default).F1,
        (0, $iCi4s.default).F2,
        (0, $iCi4s.default).F3,
        (0, $iCi4s.default).F4,
        (0, $iCi4s.default).F5,
        (0, $iCi4s.default).F6,
        (0, $iCi4s.default).F7,
        (0, $iCi4s.default).F8,
        (0, $iCi4s.default).F9,
        (0, $iCi4s.default).F10,
        (0, $iCi4s.default).F11,
        (0, $iCi4s.default).F12
    ].includes(currentKeyCode);
}

});


parcelRegister("23KWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1800478cf911b314$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $grQtM = parcelRequire("grQtM");

var $8g1PZ = parcelRequire("8g1PZ");
var $1800478cf911b314$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "containerWidth",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $1800478cf911b314$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        }
    };
};
var $1800478cf911b314$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, containerWidth = props.containerWidth, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? 'ltr' : _props$direction, placement = props.placement, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $9X7IJ.default)(props, $1800478cf911b314$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var builtInPlacements = $acw62.useMemo(function() {
        return $1800478cf911b314$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // ======================= Ref =======================
    var popupRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                return popupRef.current;
            }
        };
    });
    var popupStyle = (0, $d49SP.default)({
        minWidth: containerWidth
    }, dropdownStyle);
    if (typeof dropdownMatchSelectWidth === 'number') popupStyle.width = dropdownMatchSelectWidth;
    else if (dropdownMatchSelectWidth) popupStyle.width = containerWidth;
    return /*#__PURE__*/ $acw62.createElement((0, $grQtM.default), (0, $8nd05.default)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: builtInPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $acw62.createElement("div", {
            ref: popupRef,
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dropdownClassName, (0, $kSlfw.default)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $1800478cf911b314$var$RefSelectTrigger = /*#__PURE__*/ $acw62.forwardRef($1800478cf911b314$var$SelectTrigger);
$1800478cf911b314$var$RefSelectTrigger.displayName = 'SelectTrigger';
var $1800478cf911b314$export$2e2bcd8739ae039 = $1800478cf911b314$var$RefSelectTrigger;

});
parcelRegister("grQtM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf97e04178e2dc31$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $8nd05 = parcelRequire("8nd05");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dTiBu = parcelRequire("dTiBu");

var $d1wDM = parcelRequire("d1wDM");

var $b2dYb = parcelRequire("b2dYb");

var $85dLH = parcelRequire("85dLH");

var $IzXpF = parcelRequire("IzXpF");

var $41Trt = parcelRequire("41Trt");

var $8g1PZ = parcelRequire("8g1PZ");

var $9QMRp = parcelRequire("9QMRp");

var $qKA2g = parcelRequire("qKA2g");

var $4w8Es = parcelRequire("4w8Es");
function $bf97e04178e2dc31$var$noop() {}
function $bf97e04178e2dc31$var$returnEmptyString() {
    return '';
}
function $bf97e04178e2dc31$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $bf97e04178e2dc31$var$ALL_HANDLERS = [
    'onClick',
    'onMouseDown',
    'onTouchStart',
    'onMouseEnter',
    'onMouseLeave',
    'onFocus',
    'onBlur',
    'onContextMenu'
];
function $bf97e04178e2dc31$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $1gYAD.default)(Trigger, _React$Component);
        var _super = (0, $enfmq.default)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $6CZeq.default)(this, Trigger);
            _this = _super.call(this, props);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "popupRef", /*#__PURE__*/ $acw62.createRef());
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "triggerRef", /*#__PURE__*/ $acw62.createRef());
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "portalContainer", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "attachId", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "clickOutsideHandler", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "touchOutsideHandler", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "mouseDownTimeout", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "focusTime", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "preClickTime", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "preTouchTime", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "delayTimer", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "hasPopupMouseDown", void 0);
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents('onMouseEnter', e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onMouseMove", function(e) {
                _this.fireEvents('onMouseMove', e);
                _this.setPoint(e);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onMouseLeave", function(e) {
                _this.fireEvents('onMouseLeave', e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $d1wDM.default)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onFocus", function(e) {
                _this.fireEvents('onFocus', e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onMouseDown", function(e) {
                _this.fireEvents('onMouseDown', e);
                _this.preClickTime = Date.now();
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onTouchStart", function(e) {
                _this.fireEvents('onTouchStart', e);
                _this.preTouchTime = Date.now();
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onBlur", function(e) {
                _this.fireEvents('onBlur', e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents('onContextMenu', e);
                _this.setPopupVisible(true, e);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onClick", function(event) {
                _this.fireEvents('onClick', event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $d1wDM.default)(root, target) || _this.isContextMenuOnly()) && !(0, $d1wDM.default)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $b2dYb.default)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode((0, $hDpcU.default)(_this));
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $9QMRp.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(' ');
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $acw62.createElement((0, $qKA2g.default), (0, $8nd05.default)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === 'function' ? popup() : popup);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "attachParent", function(popupContainer) {
                (0, $dTiBu.default).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $dTiBu.default)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = 'absolute';
                    popupContainer.style.top = '0';
                    popupContainer.style.left = '0';
                    popupContainer.style.width = '100%';
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $kSlfw.default)((0, $hDpcU.default)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ('popupVisible' in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $bf97e04178e2dc31$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $cHPF9.default)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $IzXpF.default)(currentDocument, 'mousedown', this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $IzXpF.default)(currentDocument, 'touchstart', this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $IzXpF.default)(currentDocument, 'scroll', this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $IzXpF.default)(window, 'blur', this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $dTiBu.default).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $9QMRp.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!('popupVisible' in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $acw62.Children.only(children);
                    var newChildProps = {
                        key: 'trigger'
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains('onClick');
                        newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
                        newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains('onFocus');
                        newChildProps.onBlur = this.createTwoChains('onBlur');
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $d49SP.default)({}, newChildProps);
                    if ((0, $85dLH.supportRef)(child)) cloneProps.ref = (0, $85dLH.composeRef)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $acw62.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $acw62.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $acw62.createElement((0, $4w8Es.default).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($acw62.Component);
    (0, $kSlfw.default)(Trigger, "contextType", (0, $4w8Es.default));
    (0, $kSlfw.default)(Trigger, "defaultProps", {
        prefixCls: 'rc-trigger-popup',
        getPopupClassNameFromAlign: $bf97e04178e2dc31$var$returnEmptyString,
        getDocument: $bf97e04178e2dc31$var$returnDocument,
        onPopupVisibleChange: $bf97e04178e2dc31$var$noop,
        afterPopupVisibleChange: $bf97e04178e2dc31$var$noop,
        onPopupAlign: $bf97e04178e2dc31$var$noop,
        popupClassName: '',
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $bf97e04178e2dc31$export$2e2bcd8739ae039 = $bf97e04178e2dc31$export$55e99723d7f71b47((0, $41Trt.default));

});
parcelRegister("d1wDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b4b0194c593c05$export$2e2bcd8739ae039);
function $97b4b0194c593c05$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

});

parcelRegister("IzXpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0860008a706f6e42$export$2e2bcd8739ae039);

var $1u0KT = parcelRequire("1u0KT");
function $0860008a706f6e42$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}

});

parcelRegister("41Trt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef2430b7d6ce3e1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $h4v51 = parcelRequire("h4v51");
var $2ef2430b7d6ce3e1$var$Portal = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $acw62.useRef)();
    var containerRef = (0, $acw62.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $acw62.useRef)(false);
    if (!initRef.current && (0, $h4v51.default)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $acw62.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $acw62.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(children, containerRef.current) : null;
});
var $2ef2430b7d6ce3e1$export$2e2bcd8739ae039 = $2ef2430b7d6ce3e1$var$Portal;

});

parcelRegister("9QMRp", function(module, exports) {

$parcel$export(module.exports, "getAlignFromPlacement", () => $72bedf1023859414$export$44605b74f7c5d944);
$parcel$export(module.exports, "getAlignPopupClassName", () => $72bedf1023859414$export$faa0aa8ed2fe6432);

var $d49SP = parcelRequire("d49SP");
function $72bedf1023859414$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $72bedf1023859414$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $d49SP.default)((0, $d49SP.default)({}, baseAlign), align);
}
function $72bedf1023859414$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($72bedf1023859414$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}

});

parcelRegister("qKA2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $05068faf00eec836$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $ycMhT = parcelRequire("ycMhT");

var $6pWIg = parcelRequire("6pWIg");

var $9CVec = parcelRequire("9CVec");

var $70dqI = parcelRequire("70dqI");
var $05068faf00eec836$var$_excluded = [
    "visible",
    "mobile"
];
var $05068faf00eec836$var$Popup = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $9X7IJ.default)(_ref, $05068faf00eec836$var$_excluded);
    var _useState = (0, $acw62.useState)(visible), _useState2 = (0, $eUqlC.default)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $eUqlC.default)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $acw62.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $ycMhT.default)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $acw62.createElement((0, $70dqI.default), (0, $8nd05.default)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $acw62.createElement((0, $9CVec.default), (0, $8nd05.default)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement((0, $6pWIg.default), cloneProps), popupNode);
});
$05068faf00eec836$var$Popup.displayName = 'Popup';
var $05068faf00eec836$export$2e2bcd8739ae039 = $05068faf00eec836$var$Popup;

});
parcelRegister("6pWIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac29f08ce13555e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $dpDyF = parcelRequire("dpDyF");
function $4ac29f08ce13555e$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $d49SP.default)({
        motionAppear: true
    }, (0, $dpDyF.getMotion)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-mask"), className)
        });
    });
}

});
parcelRegister("dpDyF", function(module, exports) {

$parcel$export(module.exports, "getMotion", () => $9c3c4b97fcaf5e46$export$7b8936ddc277a29a);
function $9c3c4b97fcaf5e46$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}

});


parcelRegister("9CVec", function(module, exports) {

$parcel$export(module.exports, "default", () => $70240df66fd05ad7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $7IlgJ = parcelRequire("7IlgJ");

var $6hDTM = parcelRequire("6hDTM");

var $8iiJy = parcelRequire("8iiJy");

var $8g1PZ = parcelRequire("8g1PZ");

var $928NI = parcelRequire("928NI");

var $dpDyF = parcelRequire("dpDyF");

var $9J0fN = parcelRequire("9J0fN");
var $70240df66fd05ad7$var$PopupInner = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $acw62.useRef)();
    var elementRef = (0, $acw62.useRef)();
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $eUqlC.default)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $9J0fN.default)(stretch), _useStretchStyle2 = (0, $eUqlC.default)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $928NI.default)(visible, doMeasure), _useVisibleStatus2 = (0, $eUqlC.default)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $eUqlC.default)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $acw62.useRef)();
    (0, $6hDTM.default)(function() {
        if (status === 'alignPre') setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === 'align') onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $6hDTM.default)(function() {
        if (status === 'align') {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $d49SP.default)({}, (0, $dpDyF.getMotion)(props));
    [
        'onAppearEnd',
        'onEnterEnd',
        'onLeaveEnd'
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $acw62.useEffect(function() {
        if (!motion.motionName && status === 'motion') goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $d49SP.default)((0, $d49SP.default)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($acw62.Children.count(children) > 1) childNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $acw62.createElement((0, $7IlgJ.default), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $acw62.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $d49SP.default)((0, $d49SP.default)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$70240df66fd05ad7$var$PopupInner.displayName = 'PopupInner';
var $70240df66fd05ad7$export$2e2bcd8739ae039 = $70240df66fd05ad7$var$PopupInner;

});
parcelRegister("7IlgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59dd2406f90550fc$export$2e2bcd8739ae039);
// export this package's api

var $7mQjP = parcelRequire("7mQjP");
var $59dd2406f90550fc$export$2e2bcd8739ae039 = (0, $7mQjP.default);

});
parcelRegister("7mQjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d32bed2871d04e$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $jkCfD = parcelRequire("jkCfD");

var $4AFGH = parcelRequire("4AFGH");

var $IzXpF = parcelRequire("IzXpF");

var $7klNq = parcelRequire("7klNq");

var $6hDTM = parcelRequire("6hDTM");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $dHupf = parcelRequire("dHupf");

var $k7OOW = parcelRequire("k7OOW");
function $55d32bed2871d04e$var$getElement(func) {
    if (typeof func !== 'function') return null;
    return func();
}
function $55d32bed2871d04e$var$getPoint(point) {
    if ((0, $fSwVM.default)(point) !== 'object' || !point) return null;
    return point;
}
var $55d32bed2871d04e$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $dHupf.default)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $55d32bed2871d04e$var$getElement(latestTarget);
            var _point = $55d32bed2871d04e$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $7klNq.default)(_element)) _result = (0, $jkCfD.alignElement)(source, _element, latestAlign);
            else if (_point) _result = (0, $jkCfD.alignPoint)(source, _point, latestAlign);
            (0, $k7OOW.restoreFocus)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $eUqlC.default)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $6hDTM.default)(function() {
        setElement($55d32bed2871d04e$var$getElement(target));
        setPoint($55d32bed2871d04e$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $k7OOW.isSamePoint)(cacheRef.current.point, point) || !(0, $4AFGH.default)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var cancelFn = (0, $k7OOW.monitorResize)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var cancelFn = (0, $k7OOW.monitorResize)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $IzXpF.default)(window, 'resize', _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(childNode, {
        ref: (0, $85dLH.composeRef)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $55d32bed2871d04e$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($55d32bed2871d04e$var$Align);
$55d32bed2871d04e$var$RcAlign.displayName = 'Align';
var $55d32bed2871d04e$export$2e2bcd8739ae039 = $55d32bed2871d04e$var$RcAlign;

});
parcelRegister("jkCfD", function(module, exports) {

$parcel$export(module.exports, "alignElement", () => $e12d8e794315a3f6$export$ec21431d5ee6c534);
$parcel$export(module.exports, "alignPoint", () => $e12d8e794315a3f6$export$38f0e12f0aa28098);
function $e12d8e794315a3f6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e12d8e794315a3f6$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e12d8e794315a3f6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e12d8e794315a3f6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e12d8e794315a3f6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e12d8e794315a3f6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e12d8e794315a3f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e12d8e794315a3f6$var$_typeof(obj);
}
function $e12d8e794315a3f6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e12d8e794315a3f6$var$vendorPrefix;
var $e12d8e794315a3f6$var$jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
};
function $e12d8e794315a3f6$var$getVendorPrefix() {
    if ($e12d8e794315a3f6$var$vendorPrefix !== undefined) return $e12d8e794315a3f6$var$vendorPrefix;
    $e12d8e794315a3f6$var$vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for(var key in $e12d8e794315a3f6$var$jsCssMap)if (key + testProp in style) $e12d8e794315a3f6$var$vendorPrefix = key;
    return $e12d8e794315a3f6$var$vendorPrefix;
}
function $e12d8e794315a3f6$var$getTransitionName() {
    return $e12d8e794315a3f6$var$getVendorPrefix() ? "".concat($e12d8e794315a3f6$var$getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function $e12d8e794315a3f6$var$getTransformName() {
    return $e12d8e794315a3f6$var$getVendorPrefix() ? "".concat($e12d8e794315a3f6$var$getVendorPrefix(), "Transform") : 'transform';
}
function $e12d8e794315a3f6$var$setTransitionProperty(node, value) {
    var name = $e12d8e794315a3f6$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transitionProperty') node.style.transitionProperty = value;
    }
}
function $e12d8e794315a3f6$var$setTransform(node, value) {
    var name = $e12d8e794315a3f6$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transform') node.style.transform = value;
    }
}
function $e12d8e794315a3f6$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$e12d8e794315a3f6$var$getTransitionName()];
}
function $e12d8e794315a3f6$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($e12d8e794315a3f6$var$getTransformName());
    if (transform && transform !== 'none') {
        var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $e12d8e794315a3f6$var$matrix2d = /matrix\((.*)\)/;
var $e12d8e794315a3f6$var$matrix3d = /matrix3d\((.*)\)/;
function $e12d8e794315a3f6$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($e12d8e794315a3f6$var$getTransformName());
    if (transform && transform !== 'none') {
        var arr;
        var match2d = transform.match($e12d8e794315a3f6$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $e12d8e794315a3f6$var$setTransform(node, "matrix(".concat(arr.join(','), ")"));
        } else {
            var match3d = transform.match($e12d8e794315a3f6$var$matrix3d)[1];
            arr = match3d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $e12d8e794315a3f6$var$setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
        }
    } else $e12d8e794315a3f6$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $e12d8e794315a3f6$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $e12d8e794315a3f6$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $e12d8e794315a3f6$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $e12d8e794315a3f6$var$css(el, name, v) {
    var value = v;
    if ($e12d8e794315a3f6$var$_typeof(name) === 'object') {
        for(var i in name)if (name.hasOwnProperty(i)) $e12d8e794315a3f6$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $e12d8e794315a3f6$var$getComputedStyleX(el, name);
}
function $e12d8e794315a3f6$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $e12d8e794315a3f6$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $e12d8e794315a3f6$var$getScrollLeft(w) {
    return $e12d8e794315a3f6$var$getScroll(w);
}
function $e12d8e794315a3f6$var$getScrollTop(w) {
    return $e12d8e794315a3f6$var$getScroll(w, true);
}
function $e12d8e794315a3f6$var$getOffset(el) {
    var pos = $e12d8e794315a3f6$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $e12d8e794315a3f6$var$getScrollLeft(w);
    pos.top += $e12d8e794315a3f6$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $e12d8e794315a3f6$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $e12d8e794315a3f6$var$getDocument(node) {
    if ($e12d8e794315a3f6$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $e12d8e794315a3f6$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = $e12d8e794315a3f6$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $e12d8e794315a3f6$var$_RE_NUM_NO_PX = new RegExp("^(".concat($e12d8e794315a3f6$var$RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var $e12d8e794315a3f6$var$RE_POS = /^(top|right|bottom|left)$/;
var $e12d8e794315a3f6$var$CURRENT_STYLE = 'currentStyle';
var $e12d8e794315a3f6$var$RUNTIME_STYLE = 'runtimeStyle';
var $e12d8e794315a3f6$var$LEFT = 'left';
var $e12d8e794315a3f6$var$PX = 'px';
function $e12d8e794315a3f6$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$e12d8e794315a3f6$var$CURRENT_STYLE] && elem[$e12d8e794315a3f6$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($e12d8e794315a3f6$var$_RE_NUM_NO_PX.test(ret) && !$e12d8e794315a3f6$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$e12d8e794315a3f6$var$LEFT];
        var rsLeft = elem[$e12d8e794315a3f6$var$RUNTIME_STYLE][$e12d8e794315a3f6$var$LEFT];
        // prevent flashing of content
        elem[$e12d8e794315a3f6$var$RUNTIME_STYLE][$e12d8e794315a3f6$var$LEFT] = elem[$e12d8e794315a3f6$var$CURRENT_STYLE][$e12d8e794315a3f6$var$LEFT];
        // Put in the new values to get a computed value out
        style[$e12d8e794315a3f6$var$LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + $e12d8e794315a3f6$var$PX;
        // Revert the changed values
        style[$e12d8e794315a3f6$var$LEFT] = left;
        elem[$e12d8e794315a3f6$var$RUNTIME_STYLE][$e12d8e794315a3f6$var$LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') $e12d8e794315a3f6$var$getComputedStyleX = window.getComputedStyle ? $e12d8e794315a3f6$var$_getComputedStyle : $e12d8e794315a3f6$var$_getComputedStyleIE;
function $e12d8e794315a3f6$var$getOffsetDirection(dir, option) {
    if (dir === 'left') return option.useCssRight ? 'right' : dir;
    return option.useCssBottom ? 'bottom' : dir;
}
function $e12d8e794315a3f6$var$oppositeOffsetDirection(dir) {
    if (dir === 'left') return 'right';
    else if (dir === 'right') return 'left';
    else if (dir === 'top') return 'bottom';
    else if (dir === 'bottom') return 'top';
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $e12d8e794315a3f6$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($e12d8e794315a3f6$var$css(elem, 'position') === 'static') elem.style.position = 'relative';
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $e12d8e794315a3f6$var$getOffsetDirection('left', option);
    var verticalProperty = $e12d8e794315a3f6$var$getOffsetDirection('top', option);
    var oppositeHorizontalProperty = $e12d8e794315a3f6$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $e12d8e794315a3f6$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') presetH = 999;
    if (verticalProperty !== 'top') presetV = 999;
    var originalTransition = '';
    var originalOffset = $e12d8e794315a3f6$var$getOffset(elem);
    if ('left' in offset || 'top' in offset) {
        originalTransition = $e12d8e794315a3f6$var$getTransitionProperty(elem) || '';
        $e12d8e794315a3f6$var$setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
        elem.style[oppositeHorizontalProperty] = '';
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
        elem.style[oppositeVerticalProperty] = '';
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $e12d8e794315a3f6$var$forceRelayout(elem);
    var old = $e12d8e794315a3f6$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $e12d8e794315a3f6$var$getOffsetDirection(key, option);
        var preset = key === 'left' ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $e12d8e794315a3f6$var$css(elem, originalStyle);
    // force relayout
    $e12d8e794315a3f6$var$forceRelayout(elem);
    if ('left' in offset || 'top' in offset) $e12d8e794315a3f6$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $e12d8e794315a3f6$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $e12d8e794315a3f6$var$css(elem, ret);
}
function $e12d8e794315a3f6$var$setTransform$1(elem, offset) {
    var originalOffset = $e12d8e794315a3f6$var$getOffset(elem);
    var originalXY = $e12d8e794315a3f6$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ('left' in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ('top' in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $e12d8e794315a3f6$var$setTransformXY(elem, resultXY);
}
function $e12d8e794315a3f6$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $e12d8e794315a3f6$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $e12d8e794315a3f6$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $e12d8e794315a3f6$var$getTransformName() in document.body.style) $e12d8e794315a3f6$var$setTransform$1(elem, offset);
    else $e12d8e794315a3f6$var$setLeftTop(elem, offset, option);
}
function $e12d8e794315a3f6$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $e12d8e794315a3f6$var$isBorderBoxFn(elem) {
    return $e12d8e794315a3f6$var$getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var $e12d8e794315a3f6$var$BOX_MODELS = [
    'margin',
    'border',
    'padding'
];
var $e12d8e794315a3f6$var$CONTENT_INDEX = -1;
var $e12d8e794315a3f6$var$PADDING_INDEX = 2;
var $e12d8e794315a3f6$var$BORDER_INDEX = 1;
var $e12d8e794315a3f6$var$MARGIN_INDEX = 0;
function $e12d8e794315a3f6$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $e12d8e794315a3f6$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === 'border') cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($e12d8e794315a3f6$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $e12d8e794315a3f6$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$e12d8e794315a3f6$var$each([
    'Width',
    'Height'
], function(name) {
    $e12d8e794315a3f6$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $e12d8e794315a3f6$var$domUtils["viewport".concat(name)](d));
    };
    $e12d8e794315a3f6$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $e12d8e794315a3f6$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($e12d8e794315a3f6$var$isWindow(elem)) return name === 'width' ? $e12d8e794315a3f6$var$domUtils.viewportWidth(elem) : $e12d8e794315a3f6$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === 'width' ? $e12d8e794315a3f6$var$domUtils.docWidth(elem) : $e12d8e794315a3f6$var$domUtils.docHeight(elem);
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $e12d8e794315a3f6$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $e12d8e794315a3f6$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $e12d8e794315a3f6$var$BORDER_INDEX : $e12d8e794315a3f6$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $e12d8e794315a3f6$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $e12d8e794315a3f6$var$getPBMWidth(elem, [
            'border',
            'padding'
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $e12d8e794315a3f6$var$BORDER_INDEX) return val;
        return val + (extra === $e12d8e794315a3f6$var$PADDING_INDEX ? -$e12d8e794315a3f6$var$getPBMWidth(elem, [
            'border'
        ], which) : $e12d8e794315a3f6$var$getPBMWidth(elem, [
            'margin'
        ], which));
    }
    return cssBoxValue + $e12d8e794315a3f6$var$getPBMWidth(elem, $e12d8e794315a3f6$var$BOX_MODELS.slice(extra), which);
}
var $e12d8e794315a3f6$var$cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $e12d8e794315a3f6$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $e12d8e794315a3f6$var$getWH.apply(undefined, args);
    else $e12d8e794315a3f6$var$swap(elem, $e12d8e794315a3f6$var$cssShow, function() {
        val = $e12d8e794315a3f6$var$getWH.apply(undefined, args);
    });
    return val;
}
$e12d8e794315a3f6$var$each([
    'width',
    'height'
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $e12d8e794315a3f6$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $e12d8e794315a3f6$var$getWHIgnoreDisplay(el, name, includeMargin ? $e12d8e794315a3f6$var$MARGIN_INDEX : $e12d8e794315a3f6$var$BORDER_INDEX);
    };
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    $e12d8e794315a3f6$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $e12d8e794315a3f6$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $e12d8e794315a3f6$var$getPBMWidth(elem, [
                    'padding',
                    'border'
                ], which);
                return $e12d8e794315a3f6$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $e12d8e794315a3f6$var$getWHIgnoreDisplay(elem, name, $e12d8e794315a3f6$var$CONTENT_INDEX);
    };
});
function $e12d8e794315a3f6$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $e12d8e794315a3f6$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $e12d8e794315a3f6$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== 'undefined') $e12d8e794315a3f6$var$setOffset(el, value, option || {});
        else return $e12d8e794315a3f6$var$getOffset(el);
    },
    isWindow: $e12d8e794315a3f6$var$isWindow,
    each: $e12d8e794315a3f6$var$each,
    css: $e12d8e794315a3f6$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $e12d8e794315a3f6$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $e12d8e794315a3f6$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $e12d8e794315a3f6$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$e12d8e794315a3f6$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$e12d8e794315a3f6$var$mix($e12d8e794315a3f6$var$utils, $e12d8e794315a3f6$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $e12d8e794315a3f6$var$getParent = $e12d8e794315a3f6$var$utils.getParent;
function $e12d8e794315a3f6$var$getOffsetParent(element) {
    if ($e12d8e794315a3f6$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $e12d8e794315a3f6$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $e12d8e794315a3f6$var$utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) return element.nodeName.toLowerCase() === 'html' ? null : $e12d8e794315a3f6$var$getParent(element);
    for(parent = $e12d8e794315a3f6$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $e12d8e794315a3f6$var$getParent(parent)){
        positionStyle = $e12d8e794315a3f6$var$utils.css(parent, 'position');
        if (positionStyle !== 'static') return parent;
    }
    return null;
}
var $e12d8e794315a3f6$var$getParent$1 = $e12d8e794315a3f6$var$utils.getParent;
function $e12d8e794315a3f6$var$isAncestorFixed(element) {
    if ($e12d8e794315a3f6$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $e12d8e794315a3f6$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $e12d8e794315a3f6$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $e12d8e794315a3f6$var$getParent$1(parent)){
        var positionStyle = $e12d8e794315a3f6$var$utils.css(parent, 'position');
        if (positionStyle === 'fixed') return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $e12d8e794315a3f6$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $e12d8e794315a3f6$var$getOffsetParent(element);
    var doc = $e12d8e794315a3f6$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $e12d8e794315a3f6$var$utils.css(el, 'overflow') !== 'visible') {
            var pos = $e12d8e794315a3f6$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $e12d8e794315a3f6$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$e12d8e794315a3f6$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $e12d8e794315a3f6$var$utils.css(element, 'position');
        if (position === 'absolute') element.style.position = 'fixed';
    }
    var scrollX = $e12d8e794315a3f6$var$utils.getWindowScrollLeft(win);
    var scrollY = $e12d8e794315a3f6$var$utils.getWindowScrollTop(win);
    var viewportWidth = $e12d8e794315a3f6$var$utils.viewportWidth(win);
    var viewportHeight = $e12d8e794315a3f6$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === 'hidden') documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $e12d8e794315a3f6$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $e12d8e794315a3f6$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $e12d8e794315a3f6$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $e12d8e794315a3f6$var$utils.mix(pos, size);
}
function $e12d8e794315a3f6$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$e12d8e794315a3f6$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $e12d8e794315a3f6$var$utils.offset(node);
        w = $e12d8e794315a3f6$var$utils.outerWidth(node);
        h = $e12d8e794315a3f6$var$utils.outerHeight(node);
    } else {
        var win = $e12d8e794315a3f6$var$utils.getWindow(node);
        offset = {
            left: $e12d8e794315a3f6$var$utils.getWindowScrollLeft(win),
            top: $e12d8e794315a3f6$var$utils.getWindowScrollTop(win)
        };
        w = $e12d8e794315a3f6$var$utils.viewportWidth(win);
        h = $e12d8e794315a3f6$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $e12d8e794315a3f6$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') y += h / 2;
    else if (V === 'b') y += h;
    if (H === 'c') x += w / 2;
    else if (H === 'r') x += w;
    return {
        left: x,
        top: y
    };
}
function $e12d8e794315a3f6$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $e12d8e794315a3f6$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $e12d8e794315a3f6$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $e12d8e794315a3f6$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $e12d8e794315a3f6$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $e12d8e794315a3f6$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $e12d8e794315a3f6$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $e12d8e794315a3f6$var$flip(points, reg, map) {
    var ret = [];
    $e12d8e794315a3f6$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $e12d8e794315a3f6$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $e12d8e794315a3f6$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $e12d8e794315a3f6$var$normalizeOffset(offset, el) {
    offset[0] = $e12d8e794315a3f6$var$convertOffset(offset[0], el.width);
    offset[1] = $e12d8e794315a3f6$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $e12d8e794315a3f6$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $e12d8e794315a3f6$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $e12d8e794315a3f6$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $e12d8e794315a3f6$var$normalizeOffset(offset, elRegion);
    $e12d8e794315a3f6$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $e12d8e794315a3f6$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($e12d8e794315a3f6$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $e12d8e794315a3f6$var$flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                });
                // 偏移量也反下
                var newOffset = $e12d8e794315a3f6$var$flipOffset(offset, 0);
                var newTargetOffset = $e12d8e794315a3f6$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$e12d8e794315a3f6$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($e12d8e794315a3f6$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $e12d8e794315a3f6$var$flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                });
                // 偏移量也反下
                var _newOffset = $e12d8e794315a3f6$var$flipOffset(offset, 1);
                var _newTargetOffset = $e12d8e794315a3f6$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$e12d8e794315a3f6$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $e12d8e794315a3f6$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $e12d8e794315a3f6$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $e12d8e794315a3f6$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $e12d8e794315a3f6$var$flip(points, /[lr]/gi, {
                l: 'r',
                r: 'l'
            });
            if (isStillFailY) _newPoints2 = $e12d8e794315a3f6$var$flip(points, /[tb]/gi, {
                t: 'b',
                b: 't'
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $e12d8e794315a3f6$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $e12d8e794315a3f6$var$utils.css(source, 'width', $e12d8e794315a3f6$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $e12d8e794315a3f6$var$utils.css(source, 'height', $e12d8e794315a3f6$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $e12d8e794315a3f6$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $e12d8e794315a3f6$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $e12d8e794315a3f6$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $e12d8e794315a3f6$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $e12d8e794315a3f6$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $e12d8e794315a3f6$var$getRegion(target);
    var isTargetNotOutOfVisible = !$e12d8e794315a3f6$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $e12d8e794315a3f6$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$e12d8e794315a3f6$export$ec21431d5ee6c534.__getOffsetParent = $e12d8e794315a3f6$var$getOffsetParent;
$e12d8e794315a3f6$export$ec21431d5ee6c534.__getVisibleRectForElement = $e12d8e794315a3f6$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $e12d8e794315a3f6$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $e12d8e794315a3f6$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $e12d8e794315a3f6$var$utils.getWindowScrollLeft(win);
    var scrollY = $e12d8e794315a3f6$var$utils.getWindowScrollTop(win);
    var viewportWidth = $e12d8e794315a3f6$var$utils.viewportWidth(win);
    var viewportHeight = $e12d8e794315a3f6$var$utils.viewportHeight(win);
    if ('pageX' in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ('pageY' in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        'cc'
    ];
    return $e12d8e794315a3f6$var$doAlign(el, tgtRegion, $e12d8e794315a3f6$var$_objectSpread2($e12d8e794315a3f6$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $e12d8e794315a3f6$export$2e2bcd8739ae039 = $e12d8e794315a3f6$export$ec21431d5ee6c534;

});

parcelRegister("4AFGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $357adc8667cde522$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $u43uR = parcelRequire("u43uR");
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $357adc8667cde522$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $u43uR.default)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $fSwVM.default)(a) === 'object' && (0, $fSwVM.default)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $357adc8667cde522$export$2e2bcd8739ae039 = $357adc8667cde522$var$isEqual;

});

parcelRegister("7klNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $555b4eee2695f264$export$2e2bcd8739ae039);
var $555b4eee2695f264$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};

});

parcelRegister("dHupf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f96e09361d71c30$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $9f96e09361d71c30$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};

});

parcelRegister("k7OOW", function(module, exports) {

$parcel$export(module.exports, "isSamePoint", () => $ea6be2081db9532e$export$792a4d7b8e9efb33);
$parcel$export(module.exports, "restoreFocus", () => $ea6be2081db9532e$export$2284e449d64b22d5);
$parcel$export(module.exports, "monitorResize", () => $ea6be2081db9532e$export$f56787db9e74dfe);

var $eUqlC = parcelRequire("eUqlC");

var $bEEfE = parcelRequire("bEEfE");

var $d1wDM = parcelRequire("d1wDM");
function $ea6be2081db9532e$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ('pageX' in next && 'pageY' in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ('clientX' in next && 'clientY' in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $ea6be2081db9532e$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $d1wDM.default)(container, activeElement) && typeof activeElement.focus === 'function') activeElement.focus();
}
function $ea6be2081db9532e$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $bEEfE.default)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}

});



parcelRegister("928NI", function(module, exports) {

$parcel$export(module.exports, "default", () => $693b209e865ba00a$export$2e2bcd8739ae039);

var $cqPKg = parcelRequire("cqPKg");

var $5wm0G = parcelRequire("5wm0G");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $dTiBu = parcelRequire("dTiBu");

var $3fDfx = parcelRequire("3fDfx");
/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $693b209e865ba00a$var$StatusQueue = [
    'measure',
    'alignPre',
    'align',
    null,
    'motion'
];
var $693b209e865ba00a$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $3fDfx.default)(null), _useState2 = (0, $eUqlC.default)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $acw62.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $dTiBu.default).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $dTiBu.default)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case 'align':
                        return 'motion';
                    case 'motion':
                        return 'stable';
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $acw62.useEffect)(function() {
        setStatus('measure');
    }, [
        visible
    ]); // Go next status
    (0, $acw62.useEffect)(function() {
        switch(status){
            case 'measure':
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $dTiBu.default)(/*#__PURE__*/ (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee() {
            var index, nextStatus;
            return (0, $cqPKg.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $693b209e865ba00a$var$StatusQueue.indexOf(status);
                        nextStatus = $693b209e865ba00a$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};

});

parcelRegister("9J0fN", function(module, exports) {

$parcel$export(module.exports, "default", () => $714883682f77f849$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
var $714883682f77f849$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $acw62.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $acw62.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf('height') !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf('minHeight') !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf('width') !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf('minWidth') !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};

});


parcelRegister("70dqI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5192f360d8c1ec4e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8iiJy = parcelRequire("8iiJy");

var $8g1PZ = parcelRequire("8g1PZ");
var $5192f360d8c1ec4e$var$MobilePopupInner = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $acw62.useRef(); // ========================= Refs =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $d49SP.default)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($acw62.Children.count(children) > 1) childNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $d49SP.default)((0, $d49SP.default)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$5192f360d8c1ec4e$var$MobilePopupInner.displayName = 'MobilePopupInner';
var $5192f360d8c1ec4e$export$2e2bcd8739ae039 = $5192f360d8c1ec4e$var$MobilePopupInner;

});


parcelRegister("4w8Es", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a0dc940d0dd00d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $34a0dc940d0dd00d$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $34a0dc940d0dd00d$export$2e2bcd8739ae039 = $34a0dc940d0dd00d$var$TriggerContext;

});



parcelRegister("8V0pl", function(module, exports) {

$parcel$export(module.exports, "fillFieldNames", () => $67e3f69030e63308$export$6c519d302dced239);
$parcel$export(module.exports, "flattenOptions", () => $67e3f69030e63308$export$7baa7c13b358b002);
$parcel$export(module.exports, "injectPropsWithOption", () => $67e3f69030e63308$export$d0b21b213c8c013c);
$parcel$export(module.exports, "getSeparatedContent", () => $67e3f69030e63308$export$a09ca2a89e052b14);

var $kbxxf = parcelRequire("kbxxf");

var $aJJ3v = parcelRequire("aJJ3v");

var $d49SP = parcelRequire("d49SP");

var $u43uR = parcelRequire("u43uR");
function $67e3f69030e63308$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ('value' in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $67e3f69030e63308$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options;
    return {
        label: label || (childrenAsData ? 'children' : 'label'),
        value: value || 'value',
        options: options || 'options'
    };
}
function $67e3f69030e63308$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $67e3f69030e63308$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options;
    function dig(list, isGroupOption) {
        list.forEach(function(data) {
            var label = data[fieldLabel];
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $67e3f69030e63308$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: label,
                    value: value
                });
            } else {
                var grpLabel = label;
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $67e3f69030e63308$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $67e3f69030e63308$export$d0b21b213c8c013c(option) {
    var newOption = (0, $d49SP.default)({}, option);
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get: function get() {
            (0, $u43uR.default)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
function $67e3f69030e63308$export$a09ca2a89e052b14(text, tokens) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    function separate(str, _ref3) {
        var _ref4 = (0, $aJJ3v.default)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $kbxxf.default)(prevList), (0, $kbxxf.default)(separate(unitStr, restTokens)));
        }, []).filter(function(unit) {
            return unit;
        });
    }
    var list = separate(text, tokens);
    return match ? list : null;
}

});


parcelRegister("crRya", function(module, exports) {

$parcel$export(module.exports, "default", () => $91018b9a345d68e7$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
var /**
 * Cache `value` related LabeledValue & options.
 */ $91018b9a345d68e7$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $acw62.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $acw62.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $d49SP.default)((0, $d49SP.default)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $acw62.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};

});

parcelRegister("6aTT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ef072d0f92ab84$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $cOl8a = parcelRequire("cOl8a");

var $8V0pl = parcelRequire("8V0pl");
function $47ef072d0f92ab84$var$includes(test, search) {
    return (0, $cOl8a.toArray)(test).join('').toUpperCase().includes(search);
}
var $47ef072d0f92ab84$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $acw62.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === 'function';
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $47ef072d0f92ab84$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $47ef072d0f92ab84$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $47ef072d0f92ab84$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function(opt) {
            return (0, $8V0pl.injectPropsWithOption)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $d49SP.default)((0, $d49SP.default)({}, item), {}, (0, $kSlfw.default)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};

});

parcelRegister("bx56F", function(module, exports) {

$parcel$export(module.exports, "default", () => $8656bcd9ded5e8cf$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $h4v51 = parcelRequire("h4v51");
var $8656bcd9ded5e8cf$var$uuid = 0;
var $8656bcd9ded5e8cf$export$df7146797a248522 = (0, $h4v51.default)();
function $8656bcd9ded5e8cf$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($8656bcd9ded5e8cf$export$df7146797a248522) {
        retId = $8656bcd9ded5e8cf$var$uuid;
        $8656bcd9ded5e8cf$var$uuid += 1;
    } else retId = 'TEST_OR_SSR';
    return retId;
}
function $8656bcd9ded5e8cf$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        setInnerId("rc_select_".concat($8656bcd9ded5e8cf$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}

});

parcelRegister("snZJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $05553a78451953de$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jBhh2 = parcelRequire("jBhh2");
function $05553a78451953de$export$2e2bcd8739ae039(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $acw62.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $jBhh2.convertChildrenToData)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        }
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
}

});
parcelRegister("jBhh2", function(module, exports) {

$parcel$export(module.exports, "convertChildrenToData", () => $e44edf3963c3279c$export$3beca35db74c3985);

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");
var $e44edf3963c3279c$var$_excluded = [
    "children",
    "value"
], $e44edf3963c3279c$var$_excluded2 = [
    "children"
];
function $e44edf3963c3279c$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $9X7IJ.default)(_ref$props, $e44edf3963c3279c$var$_excluded);
    return (0, $d49SP.default)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $e44edf3963c3279c$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $jWR62.default)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $9X7IJ.default)(_ref2$props, $e44edf3963c3279c$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $e44edf3963c3279c$var$convertNodeToOption(node);
        return (0, $d49SP.default)((0, $d49SP.default)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $e44edf3963c3279c$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}

});


parcelRegister("lzFkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4ced1ec5128b6c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $fb4ced1ec5128b6c$export$2e2bcd8739ae039(callback) {
    var funcRef = $acw62.useRef();
    funcRef.current = callback;
    var cacheFn = $acw62.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}

});

parcelRegister("hrhZj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb22e94bdb4eaaa5$export$2e2bcd8739ae039);
/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $cb22e94bdb4eaaa5$var$OptGroup = function OptGroup() {
    return null;
};
$cb22e94bdb4eaaa5$var$OptGroup.isSelectOptGroup = true;
var $cb22e94bdb4eaaa5$export$2e2bcd8739ae039 = $cb22e94bdb4eaaa5$var$OptGroup;

});

parcelRegister("44Iii", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f79e5076b69401d$export$2e2bcd8739ae039);
/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $2f79e5076b69401d$var$Option = function Option() {
    return null;
};
$2f79e5076b69401d$var$Option.isSelectOption = true;
var $2f79e5076b69401d$export$2e2bcd8739ae039 = $2f79e5076b69401d$var$Option;

});

parcelRegister("6nzAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a507f608f30c004$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $iCi4s = parcelRequire("iCi4s");

var $1pcHX = parcelRequire("1pcHX");

var $3ryW7 = parcelRequire("3ryW7");

var $3Ysvw = parcelRequire("3Ysvw");

var $8g1PZ = parcelRequire("8g1PZ");

var $42Ey2 = parcelRequire("42Ey2");

var $9EMjj = parcelRequire("9EMjj");

var $fogjB = parcelRequire("fogjB");

var $j4N1P = parcelRequire("j4N1P");

var $5UvVe = parcelRequire("5UvVe");
var $4a507f608f30c004$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $4a507f608f30c004$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $4a507f608f30c004$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $j4N1P.default)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $acw62.useContext((0, $5UvVe.default)), flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $3Ysvw.default)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $acw62.useRef(null);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        if (listRef.current) listRef.current.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _memoFlattenOptions$c = memoFlattenOptions[current], group = _memoFlattenOptions$c.group, data = _memoFlattenOptions$c.data;
            if (!group && !data.disabled) return current;
        }
        return -1;
    };
    var _React$useState = $acw62.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $acw62.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $acw62.useCallback(function(value) {
        return rawValues.has(value) && mode !== 'combobox';
    }, [
        mode,
        (0, $kbxxf.default)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $acw62.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                var index = memoFlattenOptions.findIndex(function(_ref) {
                    var data = _ref.data;
                    return data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $iCi4s.default).N:
                    case (0, $iCi4s.default).P:
                    case (0, $iCi4s.default).UP:
                    case (0, $iCi4s.default).DOWN:
                        var offset = 0;
                        if (which === (0, $iCi4s.default).UP) offset = -1;
                        else if (which === (0, $iCi4s.default).DOWN) offset = 1;
                        else if ((0, $fogjB.isPlatformMac)() && ctrlKey) {
                            if (which === (0, $iCi4s.default).N) offset = 1;
                            else if (which === (0, $iCi4s.default).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select
                    case (0, $iCi4s.default).ENTER:
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !item.data.disabled) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $iCi4s.default).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $acw62.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $3ryW7.default)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index,
            role: group ? 'presentation' : 'option',
            id: "".concat(id, "_list_").concat(index),
            "aria-selected": isSelected(value)
        }), value) : null;
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }, renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $acw62.createElement((0, $42Ey2.default), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual
    }, function(item, itemIndex) {
        var _classNames;
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $4a507f608f30c004$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemPrefixCls, "".concat(itemPrefixCls, "-group")),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $9X7IJ.default)(data, $4a507f608f30c004$var$_excluded);
        var passedProps = (0, $1pcHX.default)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $4a507f608f30c004$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, (0, $3ryW7.default)(passedProps), {
            "aria-selected": selected,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || disabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!disabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, content), /*#__PURE__*/ $acw62.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $acw62.createElement((0, $9EMjj.default), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $4a507f608f30c004$var$RefOptionList = /*#__PURE__*/ $acw62.forwardRef($4a507f608f30c004$var$OptionList);
$4a507f608f30c004$var$RefOptionList.displayName = 'OptionList';
var $4a507f608f30c004$export$2e2bcd8739ae039 = $4a507f608f30c004$var$RefOptionList;

});
parcelRegister("42Ey2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f16cd4e45d13ddf$export$2e2bcd8739ae039);

var $cuXAm = parcelRequire("cuXAm");
var $2f16cd4e45d13ddf$export$2e2bcd8739ae039 = (0, $cuXAm.default);

});
parcelRegister("cuXAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $919681ceac17068c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");
parcelRequire("gwOwm");
var $a4gyP = parcelRequire("a4gyP");

var $6hDTM = parcelRequire("6hDTM");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $eoVMr = parcelRequire("eoVMr");

var $gIUlx = parcelRequire("gIUlx");

var $ap02g = parcelRequire("ap02g");

var $g8Ujp = parcelRequire("g8Ujp");

var $4z2y6 = parcelRequire("4z2y6");

var $3wRQq = parcelRequire("3wRQq");

var $7pKGP = parcelRequire("7pKGP");

var $5sDrA = parcelRequire("5sDrA");

var $cr8UY = parcelRequire("cr8UY");

var $jS7U4 = parcelRequire("jS7U4");

var $40N91 = parcelRequire("40N91");

var $fvyuU = parcelRequire("fvyuU");
var $919681ceac17068c$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles",
    "showScrollBar"
];
var $919681ceac17068c$var$EMPTY_DATA = [];
var $919681ceac17068c$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $919681ceac17068c$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, _props$showScrollBar = props.showScrollBar, showScrollBar = _props$showScrollBar === void 0 ? 'optional' : _props$showScrollBar, restProps = (0, $9X7IJ.default)(props, $919681ceac17068c$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $acw62.useCallback(function(item) {
        if (typeof itemKey === 'function') return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $3wRQq.default)(getKey, null, null), _useHeights2 = (0, $eUqlC.default)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $acw62.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === 'rtl';
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $919681ceac17068c$var$EMPTY_DATA;
    var componentRef = (0, $acw62.useRef)();
    var fillerInnerRef = (0, $acw62.useRef)();
    var containerRef = (0, $acw62.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $eUqlC.default)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $eUqlC.default)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $eUqlC.default)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $acw62.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $acw62.useRef)();
    var _useDiffItem = (0, $ap02g.default)(mergedData, getKey), _useDiffItem2 = (0, $eUqlC.default)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $acw62.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // When scroll up, first visible item get real height may not same as `itemHeight`,
    // Which will make scroll jump.
    // Let's sync scroll top to avoid jump
    $acw62.useLayoutEffect(function() {
        var changedRecord = heights.getRecord();
        if (changedRecord.size === 1) {
            var recordKey = Array.from(changedRecord)[0];
            // Quick switch data may cause `start` not in `mergedData` anymore
            var startItem = mergedData[start];
            if (startItem) {
                var startIndexKey = getKey(startItem);
                if (startIndexKey === recordKey) {
                    var realStartHeight = heights.get(recordKey);
                    var diffHeight = realStartHeight - itemHeight;
                    syncScrollTop(function(ori) {
                        return ori + diffHeight;
                    });
                }
            }
        }
        heights.resetRecord();
    }, [
        scrollHeight
    ]);
    // ================================= Size =================================
    var _React$useState = $acw62.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $fvyuU.getSpinSize)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $fvyuU.getSpinSize)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $acw62.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $5sDrA.default)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $acw62.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $a4gyP.default)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $d49SP.default)((0, $d49SP.default)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $1u0KT.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $a4gyP.default)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            (0, $1u0KT.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $g8Ujp.default)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $eUqlC.default)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $7pKGP.default)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset, e) {
        var event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault: function preventDefault() {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $cr8UY.default)(inVirtual, componentRef, function(offset) {
        syncScrollTop(function(top) {
            return top + offset;
        });
    });
    (0, $6hDTM.default)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $6hDTM.default)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $jS7U4.default)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $acw62.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $fSwVM.default)(arg) === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $6hDTM.default)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $4z2y6.useGetSize)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $gIUlx.default)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $d49SP.default)((0, $kSlfw.default)({}, fullHeight ? 'height' : 'maxHeight', height), $919681ceac17068c$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        ref: containerRef,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), {}, {
            position: 'relative'
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $acw62.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $acw62.createElement((0, $eoVMr.default), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $acw62.createElement((0, $40N91.default), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb,
        showScrollBar: showScrollBar
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $acw62.createElement((0, $40N91.default), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb,
        showScrollBar: showScrollBar
    }));
}
var $919681ceac17068c$var$List = /*#__PURE__*/ $acw62.forwardRef($919681ceac17068c$export$cc3be4e46e8486ed);
$919681ceac17068c$var$List.displayName = 'List';
var $919681ceac17068c$export$2e2bcd8739ae039 = $919681ceac17068c$var$List;

});
parcelRegister("eoVMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c020883d75d0d6$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $bVxlN = parcelRequire("bVxlN");

var $8g1PZ = parcelRequire("8g1PZ");
/**
 * Fill component to provided the scroll content real height.
 */ var $a7c020883d75d0d6$var$Filler = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = (0, $d49SP.default)((0, $d49SP.default)({}, innerStyle), {}, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$a7c020883d75d0d6$var$Filler.displayName = 'Filler';
var $a7c020883d75d0d6$export$2e2bcd8739ae039 = $a7c020883d75d0d6$var$Filler;

});

parcelRegister("gIUlx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cc76a198e74e0d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hrRMy = parcelRequire("hrRMy");
function $c2cc76a198e74e0d$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $acw62.createElement((0, $hrRMy.Item), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}

});
parcelRegister("hrRMy", function(module, exports) {

$parcel$export(module.exports, "Item", () => $cb3ead46d99b2bdd$export$6d08773d2e66f8f2);

var $acw62 = parcelRequire("acw62");
function $cb3ead46d99b2bdd$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $acw62.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: refFunc
    });
}

});


parcelRegister("ap02g", function(module, exports) {

$parcel$export(module.exports, "default", () => $792c44421728f1ca$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $G8ugd = parcelRequire("G8ugd");
function $792c44421728f1ca$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $acw62.useState(data), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $acw62.useEffect(function() {
        var diff = (0, $G8ugd.findListDiffIndex)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}

});
parcelRegister("G8ugd", function(module, exports) {

$parcel$export(module.exports, "findListDiffIndex", () => $07ea81b6f4a7cb44$export$418b8d8b03eefdf5);
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $07ea81b6f4a7cb44$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $07ea81b6f4a7cb44$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}

});


parcelRegister("g8Ujp", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc091312f55e72d3$export$2e2bcd8739ae039);

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");

var $8zsb9 = parcelRequire("8zsb9");

var $5sDrA = parcelRequire("5sDrA");
function $bc091312f55e72d3$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $acw62.useRef)(0);
    var nextFrameRef = (0, $acw62.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $acw62.useRef)(null);
    var isMouseScrollRef = (0, $acw62.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $5sDrA.default)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $dTiBu.default).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $8zsb9.default)) event.preventDefault();
        nextFrameRef.current = (0, $dTiBu.default)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $8zsb9.default)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $acw62.useRef)(null);
    var wheelDirectionCleanRef = (0, $acw62.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $dTiBu.default).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $dTiBu.default)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}

});
parcelRegister("8zsb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d773591ee5124d$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
var $63d773591ee5124d$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $fSwVM.default)(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
var $63d773591ee5124d$export$2e2bcd8739ae039 = $63d773591ee5124d$var$isFF;

});

parcelRegister("5sDrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f9e2a044ed7754f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $3f9e2a044ed7754f$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $acw62.useRef)(false);
    var lockTimeoutRef = (0, $acw62.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $acw62.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};

});


parcelRegister("4z2y6", function(module, exports) {

$parcel$export(module.exports, "useGetSize", () => $352c687fd82e878a$export$a1d82723752af087);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $352c687fd82e878a$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $acw62.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}

});

parcelRegister("3wRQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $291e20ad7019c1c9$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $5Rh6b = parcelRequire("5Rh6b");
function $291e20ad7019c1c9$var$parseNumber(value) {
    var num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $291e20ad7019c1c9$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $acw62.useState(0), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $acw62.useRef)(new Map());
    var heightsRef = (0, $acw62.useRef)(new (0, $5Rh6b.default)());
    var promiseIdRef = (0, $acw62.useRef)(0);
    function cancelRaf() {
        promiseIdRef.current += 1;
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            var changed = false;
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var offsetHeight = element.offsetHeight;
                    var _getComputedStyle = getComputedStyle(element), marginTop = _getComputedStyle.marginTop, marginBottom = _getComputedStyle.marginBottom;
                    var marginTopNum = $291e20ad7019c1c9$var$parseNumber(marginTop);
                    var marginBottomNum = $291e20ad7019c1c9$var$parseNumber(marginBottom);
                    var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) {
                        heightsRef.current.set(key, totalHeight);
                        changed = true;
                    }
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            if (changed) setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else {
            promiseIdRef.current += 1;
            var id = promiseIdRef.current;
            Promise.resolve().then(function() {
                if (id === promiseIdRef.current) doCollect();
            });
        }
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $acw62.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}

});
parcelRegister("5Rh6b", function(module, exports) {

$parcel$export(module.exports, "default", () => $443f2a75671c17cb$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");
// Firefox has low performance of map.
var $443f2a75671c17cb$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $6CZeq.default)(this, CacheMap);
        (0, $kSlfw.default)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $kSlfw.default)(this, "id", 0);
        (0, $kSlfw.default)(this, "diffKeys", new Set());
        this.maps = Object.create(null);
    }
    (0, $cHPF9.default)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
                this.diffKeys.add(key);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        },
        {
            key: "resetRecord",
            value: function resetRecord() {
                this.diffKeys.clear();
            }
        },
        {
            key: "getRecord",
            value: function getRecord() {
                return this.diffKeys;
            }
        }
    ]);
    return CacheMap;
}();
var $443f2a75671c17cb$export$2e2bcd8739ae039 = $443f2a75671c17cb$var$CacheMap;

});


parcelRegister("7pKGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $565f15d1b93ca0eb$export$2e2bcd8739ae039);

var $6hDTM = parcelRequire("6hDTM");

var $acw62 = parcelRequire("acw62");
var $565f15d1b93ca0eb$var$SMOOTH_PTG = 14 / 15;
function $565f15d1b93ca0eb$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $acw62.useRef)(false);
    var touchXRef = (0, $acw62.useRef)(0);
    var touchYRef = (0, $acw62.useRef)(0);
    var elementRef = (0, $acw62.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $acw62.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $565f15d1b93ca0eb$var$SMOOTH_PTG;
                else offsetY *= $565f15d1b93ca0eb$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $6hDTM.default)(function() {
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}

});

parcelRegister("cr8UY", function(module, exports) {

$parcel$export(module.exports, "getPageXY", () => $90deec9658dde6b5$export$dbd0143e191dc2e5);
$parcel$export(module.exports, "default", () => $90deec9658dde6b5$export$2e2bcd8739ae039);

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");
function $90deec9658dde6b5$var$smoothScrollOffset(offset) {
    return Math.floor(Math.pow(offset, 0.5));
}
function $90deec9658dde6b5$export$dbd0143e191dc2e5(e, horizontal) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function $90deec9658dde6b5$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $acw62.useEffect(function() {
        var ele = componentRef.current;
        if (inVirtual && ele) {
            var mouseDownLock = false;
            var rafId;
            var _offset;
            var stopScroll = function stopScroll() {
                (0, $dTiBu.default).cancel(rafId);
            };
            var continueScroll = function continueScroll() {
                stopScroll();
                rafId = (0, $dTiBu.default)(function() {
                    onScrollOffset(_offset);
                    continueScroll();
                });
            };
            var onMouseDown = function onMouseDown(e) {
                // Skip if element set draggable
                if (e.target.draggable || e.button !== 0) return;
                // Skip if nest List has handled this event
                var event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            var onMouseUp = function onMouseUp() {
                mouseDownLock = false;
                stopScroll();
            };
            var onMouseMove = function onMouseMove(e) {
                if (mouseDownLock) {
                    var mouseY = $90deec9658dde6b5$export$dbd0143e191dc2e5(e, false);
                    var _ele$getBoundingClien = ele.getBoundingClientRect(), top = _ele$getBoundingClien.top, bottom = _ele$getBoundingClien.bottom;
                    if (mouseY <= top) {
                        var diff = top - mouseY;
                        _offset = -$90deec9658dde6b5$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        var _diff = mouseY - bottom;
                        _offset = $90deec9658dde6b5$var$smoothScrollOffset(_diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener('mousedown', onMouseDown);
            ele.ownerDocument.addEventListener('mouseup', onMouseUp);
            ele.ownerDocument.addEventListener('mousemove', onMouseMove);
            return function() {
                ele.removeEventListener('mousedown', onMouseDown);
                ele.ownerDocument.removeEventListener('mouseup', onMouseUp);
                ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}

});

parcelRegister("jS7U4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77930eb0c8ae9f1$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $dTiBu = parcelRequire("dTiBu");

var $6hDTM = parcelRequire("6hDTM");
parcelRequire("gwOwm");
var $e77930eb0c8ae9f1$var$MAX_TIMES = 10;
function $e77930eb0c8ae9f1$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $acw62.useRef();
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $6hDTM.default)(function() {
        if (syncState && syncState.times < $e77930eb0c8ae9f1$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $d49SP.default)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = 'top';
                        else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $d49SP.default)((0, $d49SP.default)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $dTiBu.default).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && (0, $fSwVM.default)(arg) === 'object') {
            var index;
            var align = arg.align;
            if ('index' in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}

});

parcelRegister("40N91", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebd4898b033397e$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");

var $cr8UY = parcelRequire("cr8UY");
var $2ebd4898b033397e$var$ScrollBar = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle, showScrollBar = props.showScrollBar;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $acw62.useRef();
    var thumbRef = $acw62.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $acw62.useState(showScrollBar), _React$useState8 = (0, $eUqlC.default)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $acw62.useRef();
    var delayHidden = function delayHidden() {
        if (showScrollBar === true || showScrollBar === false) return;
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $acw62.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $acw62.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY((0, $cr8UY.getPageXY)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $acw62.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $acw62.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $acw62.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $acw62.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $dTiBu.default).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ((0, $cr8UY.getPageXY)(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $dTiBu.default)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $dTiBu.default).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $acw62.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    var thumbStyle = {
        position: 'absolute',
        background: 'rgba(0, 0, 0, 0.5)',
        borderRadius: 99,
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = '100%';
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = '100%';
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(scrollbarPrefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $kSlfw.default)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $2ebd4898b033397e$export$2e2bcd8739ae039 = $2ebd4898b033397e$var$ScrollBar;

});

parcelRegister("fvyuU", function(module, exports) {

$parcel$export(module.exports, "getSpinSize", () => $b4a482bc5e551190$export$f2ca68955ab35ace);
var $b4a482bc5e551190$var$MIN_SIZE = 20;
function $b4a482bc5e551190$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $b4a482bc5e551190$var$MIN_SIZE);
    return Math.floor(baseSize);
}

});



parcelRegister("fogjB", function(module, exports) {

$parcel$export(module.exports, "isPlatformMac", () => $b345c0bc7d688d6a$export$3bbcfec016973a77);
/* istanbul ignore file */ function $b345c0bc7d688d6a$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}

});

parcelRegister("5UvVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $44daf1c3d5d48cca$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
// Use any here since we do not get the type during compilation
var $44daf1c3d5d48cca$var$SelectContext = /*#__PURE__*/ $acw62.createContext(null);
var $44daf1c3d5d48cca$export$2e2bcd8739ae039 = $44daf1c3d5d48cca$var$SelectContext;

});


parcelRegister("1bH4p", function(module, exports) {

var $fSwVM = parcelRequire("fSwVM");

var $jWR62 = parcelRequire("jWR62");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $3VCcq = parcelRequire("3VCcq");

var $cOl8a = parcelRequire("cOl8a");

var $jBhh2 = parcelRequire("jBhh2");
function $0dd83a53fec15284$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $3VCcq.isMultiple)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    var mergedOptions = options || (0, $jBhh2.convertChildrenToData)(children);
    // `tags` should not set option as disabled
    (0, $u43uR.default)(mode !== 'tags' || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ('value' in opt ? opt.value : opt.key) === 'number';
            });
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $u43uR.default)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $u43uR.default)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $u43uR.default)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $u43uR.default)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $u43uR.noteOnce)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $u43uR.default)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $u43uR.noteOnce)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        var values = (0, $cOl8a.toArray)(value);
        (0, $u43uR.default)(!labelInValue || values.every(function(val) {
            return (0, $fSwVM.default)(val) === 'object' && ('key' in val || 'value' in val);
        }), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $u43uR.default)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $jWR62.default)(children).some(function(node) {
            if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $jWR62.default)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $acw62.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $u43uR.default)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $u43uR.default)(inputValue === undefined, '`inputValue` is deprecated, please use `searchValue` instead.');
    }
}
function $0dd83a53fec15284$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $u43uR.default)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $0dd83a53fec15284$export$2e2bcd8739ae039 = $0dd83a53fec15284$var$warningProps;

});



parcelRegister("4XkeF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $39bc5e7a79a06441$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Summary", () => (parcelRequire("64oV2")).FooterComponents);
$parcel$export(module.exports, "Column", () => (parcelRequire("9hhTZ")).default);
$parcel$export(module.exports, "ColumnGroup", () => (parcelRequire("2VeAL")).default);
$parcel$export(module.exports, "INTERNAL_COL_DEFINE", () => (parcelRequire("aLkKv")).INTERNAL_COL_DEFINE);

var $lLawD = parcelRequire("lLawD");

var $64oV2 = parcelRequire("64oV2");

var $9hhTZ = parcelRequire("9hhTZ");

var $2VeAL = parcelRequire("2VeAL");

var $aLkKv = parcelRequire("aLkKv");
var $39bc5e7a79a06441$export$2e2bcd8739ae039 = (0, $lLawD.default);

});
parcelRegister("lLawD", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_HOOKS", () => $fd7626e42d9e458e$export$91b75cf262680225);
$parcel$export(module.exports, "default", () => $fd7626e42d9e458e$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $7klNq = parcelRequire("7klNq");

var $3ryW7 = parcelRequire("3ryW7");

var $7N6Vd = parcelRequire("7N6Vd");

var $8g1PZ = parcelRequire("8g1PZ");

var $i5C3F = parcelRequire("i5C3F");

var $u43uR = parcelRequire("u43uR");

var $bVxlN = parcelRequire("bVxlN");

var $2SjmF = parcelRequire("2SjmF");

var $2VeAL = parcelRequire("2VeAL");

var $9hhTZ = parcelRequire("9hhTZ");

var $3JHPQ = parcelRequire("3JHPQ");

var $2ZuUE = parcelRequire("2ZuUE");

var $kF8BC = parcelRequire("kF8BC");

var $gKJ9f = parcelRequire("gKJ9f");

var $89kiB = parcelRequire("89kiB");

var $cnAwI = parcelRequire("cnAwI");

var $fgs8V = parcelRequire("fgs8V");

var $biqb2 = parcelRequire("biqb2");

var $gir7Z = parcelRequire("gir7Z");

var $1RXuN = parcelRequire("1RXuN");

var $aLkKv = parcelRequire("aLkKv");

var $iElZM = parcelRequire("iElZM");

var $64oV2 = parcelRequire("64oV2");

var $cr0i5 = parcelRequire("cr0i5");

var $791o7 = parcelRequire("791o7");

var $7Rtk8 = parcelRequire("7Rtk8");

var $hmojQ = parcelRequire("hmojQ");

var $jwTbT = parcelRequire("jwTbT");

var $cdWrX = parcelRequire("cdWrX");

var $irah1 = parcelRequire("irah1");

var $gC73o = parcelRequire("gC73o");

var $8aC4g = parcelRequire("8aC4g");
var $fd7626e42d9e458e$var$EMPTY_DATA = []; // Used for customize scroll
var $fd7626e42d9e458e$var$EMPTY_SCROLL_TARGET = {};
var $fd7626e42d9e458e$export$91b75cf262680225 = 'rc-table-internal-hook';
var $fd7626e42d9e458e$var$MemoTableContent = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(prev, next) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($i5C3F)))(prev.props, next.props)) return false;
     // No additional render when pinged status change.
    // This is not a bug.
    return prev.pingLeft !== next.pingLeft || prev.pingRight !== next.pingRight;
});
function $fd7626e42d9e458e$var$Table(props) {
    var _classNames;
    var prefixCls = props.prefixCls, className = props.className, rowClassName = props.rowClassName, style = props.style, data = props.data, rowKey = props.rowKey, scroll = props.scroll, tableLayout = props.tableLayout, direction = props.direction, title = props.title, footer = props.footer, summary = props.summary, id = props.id, showHeader = props.showHeader, components = props.components, emptyText = props.emptyText, onRow = props.onRow, onHeaderRow = props.onHeaderRow, internalHooks = props.internalHooks, transformColumns = props.transformColumns, internalRefs = props.internalRefs, sticky = props.sticky;
    var mergedData = data || $fd7626e42d9e458e$var$EMPTY_DATA;
    var hasData = !!mergedData.length; // ===================== Warning ======================
    var getComponent = $acw62.useCallback(function(path, defaultComponent) {
        return (0, $fgs8V.getPathValue)(components || {}, path) || defaultComponent;
    }, [
        components
    ]);
    var getRowKey = $acw62.useMemo(function() {
        if (typeof rowKey === 'function') return rowKey;
        return function(record) {
            var key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]); // ====================== Expand ======================
    var expandableConfig = (0, $aLkKv.getExpandableProps)(props);
    var expandIcon = expandableConfig.expandIcon, expandedRowKeys = expandableConfig.expandedRowKeys, defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys, defaultExpandAllRows = expandableConfig.defaultExpandAllRows, expandedRowRender = expandableConfig.expandedRowRender, columnTitle = expandableConfig.columnTitle, onExpand = expandableConfig.onExpand, onExpandedRowsChange = expandableConfig.onExpandedRowsChange, expandRowByClick = expandableConfig.expandRowByClick, rowExpandable = expandableConfig.rowExpandable, expandIconColumnIndex = expandableConfig.expandIconColumnIndex, expandedRowClassName = expandableConfig.expandedRowClassName, childrenColumnName = expandableConfig.childrenColumnName, indentSize = expandableConfig.indentSize;
    var mergedExpandIcon = expandIcon || (0, $cr0i5.renderExpandIcon);
    var mergedChildrenColumnName = childrenColumnName || 'children';
    var expandableType = $acw62.useMemo(function() {
        if (expandedRowRender) return 'row';
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && internalHooks === $fd7626e42d9e458e$export$91b75cf262680225 && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function(record) {
            return record && (0, $fSwVM.default)(record) === 'object' && record[mergedChildrenColumnName];
        })) return 'nest';
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    var _React$useState = $acw62.useState(function() {
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $cr0i5.findAllChildrenKeys)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerExpandedKeys = _React$useState2[0], setInnerExpandedKeys = _React$useState2[1];
    var mergedExpandedKeys = $acw62.useMemo(function() {
        return new Set(expandedRowKeys || innerExpandedKeys || []);
    }, [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    var onTriggerExpand = $acw62.useCallback(function(record) {
        var key = getRowKey(record, mergedData.indexOf(record));
        var newExpandedKeys;
        var hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = (0, $kbxxf.default)(mergedExpandedKeys);
        } else newExpandedKeys = [].concat((0, $kbxxf.default)(mergedExpandedKeys), [
            key
        ]);
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]); // Warning if use `expandedRowRender` and nest children in the same time
    var _React$useState3 = $acw62.useState(0), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), componentWidth = _React$useState4[0], setComponentWidth = _React$useState4[1];
    var _useColumns = (0, $89kiB.default)((0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({}, props), expandableConfig), {}, {
        expandable: !!expandedRowRender,
        columnTitle: columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand: onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandIconColumnIndex,
        direction: direction
    }), internalHooks === $fd7626e42d9e458e$export$91b75cf262680225 ? transformColumns : null), _useColumns2 = (0, $eUqlC.default)(_useColumns, 2), columns = _useColumns2[0], flattenColumns = _useColumns2[1];
    var columnContext = $acw62.useMemo(function() {
        return {
            columns: columns,
            flattenColumns: flattenColumns
        };
    }, [
        columns,
        flattenColumns
    ]); // ====================== Scroll ======================
    var fullTableRef = $acw62.useRef();
    var scrollHeaderRef = $acw62.useRef();
    var scrollBodyRef = $acw62.useRef();
    var scrollBodyContainerRef = $acw62.useRef();
    var scrollSummaryRef = $acw62.useRef();
    var _React$useState5 = $acw62.useState(false), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), pingedLeft = _React$useState6[0], setPingedLeft = _React$useState6[1];
    var _React$useState7 = $acw62.useState(false), _React$useState8 = (0, $eUqlC.default)(_React$useState7, 2), pingedRight = _React$useState8[0], setPingedRight = _React$useState8[1];
    var _useLayoutState = (0, $cnAwI.useLayoutState)(new Map()), _useLayoutState2 = (0, $eUqlC.default)(_useLayoutState, 2), colsWidths = _useLayoutState2[0], updateColsWidths = _useLayoutState2[1]; // Convert map to number width
    var colsKeys = (0, $fgs8V.getColumnsKey)(flattenColumns);
    var pureColWidths = colsKeys.map(function(columnKey) {
        return colsWidths.get(columnKey);
    });
    var colWidths = $acw62.useMemo(function() {
        return pureColWidths;
    }, [
        pureColWidths.join('_')
    ]);
    var stickyOffsets = (0, $gir7Z.default)(colWidths, flattenColumns.length, direction);
    var fixHeader = scroll && (0, $fgs8V.validateValue)(scroll.y);
    var horizonScroll = scroll && (0, $fgs8V.validateValue)(scroll.x) || Boolean(expandableConfig.fixed);
    var fixColumn = horizonScroll && flattenColumns.some(function(_ref2) {
        var fixed = _ref2.fixed;
        return fixed;
    }); // Sticky
    var stickyRef = $acw62.useRef();
    var _useSticky = (0, $hmojQ.default)(sticky, prefixCls), isSticky = _useSticky.isSticky, offsetHeader = _useSticky.offsetHeader, offsetSummary = _useSticky.offsetSummary, offsetScroll = _useSticky.offsetScroll, stickyClassName = _useSticky.stickyClassName, container = _useSticky.container; // Footer (Fix footer must fixed header)
    var summaryNode = summary === null || summary === void 0 ? void 0 : summary(mergedData);
    var fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $acw62.isValidElement(summaryNode) && summaryNode.type === (0, $cdWrX.default) && summaryNode.props.fixed; // Scroll
    var scrollXStyle;
    var scrollYStyle;
    var scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: 'scroll',
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: 'auto'
        }; // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: 'hidden'
        };
        scrollTableStyle = {
            width: (scroll === null || scroll === void 0 ? void 0 : scroll.x) === true ? 'auto' : scroll === null || scroll === void 0 ? void 0 : scroll.x,
            minWidth: '100%'
        };
    }
    var onColumnResize = $acw62.useCallback(function(columnKey, width) {
        if ((0, $7klNq.default)(fullTableRef.current)) updateColsWidths(function(widths) {
            if (widths.get(columnKey) !== width) {
                var newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    var _useTimeoutLock = (0, $cnAwI.useTimeoutLock)(null), _useTimeoutLock2 = (0, $eUqlC.default)(_useTimeoutLock, 2), setScrollTarget = _useTimeoutLock2[0], getScrollTarget = _useTimeoutLock2[1];
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === 'function') target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) // eslint-disable-next-line no-param-reassign
        target.scrollLeft = scrollLeft;
    }
    var onScroll = function onScroll(_ref3) {
        var currentTarget = _ref3.currentTarget, scrollLeft = _ref3.scrollLeft;
        var isRTL = direction === 'rtl';
        var mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
        var compareTarget = currentTarget || $fd7626e42d9e458e$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            var _stickyRef$current;
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
        }
        if (currentTarget) {
            var scrollWidth = currentTarget.scrollWidth, clientWidth = currentTarget.clientWidth; // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setPingedLeft(false);
                setPingedRight(false);
                return;
            }
            if (isRTL) {
                setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
                setPingedRight(-mergedScrollLeft > 0);
            } else {
                setPingedLeft(mergedScrollLeft > 0);
                setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
            }
        }
    };
    var triggerOnScroll = function triggerOnScroll() {
        if (horizonScroll && scrollBodyRef.current) onScroll({
            currentTarget: scrollBodyRef.current
        });
        else {
            setPingedLeft(false);
            setPingedRight(false);
        }
    };
    var onFullTableResize = function onFullTableResize(_ref4) {
        var width = _ref4.width;
        if (width !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(fullTableRef.current ? fullTableRef.current.offsetWidth : width);
        }
    }; // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    var mounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $acw62.useEffect(function() {
        mounted.current = true;
    }, []); // ===================== Effects ======================
    var _React$useState9 = $acw62.useState(0), _React$useState10 = (0, $eUqlC.default)(_React$useState9, 2), scrollbarSize = _React$useState10[0], setScrollbarSize = _React$useState10[1];
    var _React$useState11 = $acw62.useState(true), _React$useState12 = (0, $eUqlC.default)(_React$useState11, 2), supportSticky = _React$useState12[0], setSupportSticky = _React$useState12[1]; // Only IE not support, we mark as support first
    $acw62.useEffect(function() {
        if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $2SjmF.getTargetScrollBarSize)(scrollBodyRef.current).width);
        else setScrollbarSize((0, $2SjmF.getTargetScrollBarSize)(scrollBodyContainerRef.current).width);
        setSupportSticky((0, $7N6Vd.isStyleSupport)('position', 'sticky'));
    }, []); // ================== INTERNAL HOOKS ==================
    $acw62.useEffect(function() {
        if (internalHooks === $fd7626e42d9e458e$export$91b75cf262680225 && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    }); // ====================== Render ======================
    var TableComponent = getComponent([
        'table'
    ], 'table'); // Table layout
    var mergedTableLayout = $acw62.useMemo(function() {
        if (tableLayout) return tableLayout;
         // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return (scroll === null || scroll === void 0 ? void 0 : scroll.x) === 'max-content' ? 'auto' : 'fixed';
        if (fixHeader || isSticky || flattenColumns.some(function(_ref5) {
            var ellipsis = _ref5.ellipsis;
            return ellipsis;
        })) return 'fixed';
        return 'auto';
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    var groupTableNode; // Header props
    var headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    }; // Empty
    var emptyNode = $acw62.useMemo(function() {
        if (hasData) return null;
        if (typeof emptyText === 'function') return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]); // Body
    var bodyTable = /*#__PURE__*/ $acw62.createElement((0, $gKJ9f.default), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky,
        expandedKeys: mergedExpandedKeys,
        rowExpandable: rowExpandable,
        getRowKey: getRowKey,
        onRow: onRow,
        emptyNode: emptyNode,
        childrenColumnName: mergedChildrenColumnName
    });
    var bodyColGroup = /*#__PURE__*/ $acw62.createElement((0, $1RXuN.default), {
        colWidths: flattenColumns.map(function(_ref6) {
            var width = _ref6.width;
            return width;
        }),
        columns: flattenColumns
    });
    var customizeScrollBody = getComponent([
        'body'
    ]);
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        var bodyContent;
        if (typeof customizeScrollBody === 'function') {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onScroll
            });
            headerProps.colWidths = flattenColumns.map(function(_ref7, index) {
                var width = _ref7.width;
                var colWidth = index === columns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) return colWidth;
                (0, $u43uR.default)(false, 'When use `components.body` with render props. Each column should have a fixed `width` value.');
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $acw62.createElement("div", {
            style: (0, $d49SP.default)((0, $d49SP.default)({}, scrollXStyle), scrollYStyle),
            onScroll: onScroll,
            ref: scrollBodyRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-body"))
        }, /*#__PURE__*/ $acw62.createElement(TableComponent, {
            style: (0, $d49SP.default)((0, $d49SP.default)({}, scrollTableStyle), {}, {
                tableLayout: mergedTableLayout
            })
        }, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $acw62.createElement((0, $64oV2.default), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
         // Fixed holder share the props
        var fixedHolderProps = (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && scroll.x === 'max-content'
        }, headerProps), columnContext), {}, {
            direction: direction,
            stickyClassName: stickyClassName,
            onScroll: onScroll
        });
        groupTableNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showHeader !== false && /*#__PURE__*/ $acw62.createElement((0, $jwTbT.default), (0, $8nd05.default)({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: "".concat(prefixCls, "-header"),
            ref: scrollHeaderRef
        }), function(fixedHolderPassProps) {
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $3JHPQ.default), fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/ $acw62.createElement((0, $64oV2.default), fixedHolderPassProps, summaryNode));
        }), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/ $acw62.createElement((0, $jwTbT.default), (0, $8nd05.default)({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: "".concat(prefixCls, "-summary"),
            ref: scrollSummaryRef
        }), function(fixedHolderPassProps) {
            return /*#__PURE__*/ $acw62.createElement((0, $64oV2.default), fixedHolderPassProps, summaryNode);
        }), isSticky && /*#__PURE__*/ $acw62.createElement((0, $7Rtk8.default), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onScroll,
            container: container
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $acw62.createElement("div", {
        style: (0, $d49SP.default)((0, $d49SP.default)({}, scrollXStyle), scrollYStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content")),
        onScroll: onScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $acw62.createElement(TableComponent, {
        style: (0, $d49SP.default)((0, $d49SP.default)({}, scrollTableStyle), {}, {
            tableLayout: mergedTableLayout
        })
    }, bodyColGroup, showHeader !== false && /*#__PURE__*/ $acw62.createElement((0, $3JHPQ.default), (0, $8nd05.default)({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $acw62.createElement((0, $64oV2.default), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    var ariaProps = (0, $3ryW7.default)(props, {
        aria: true,
        data: true
    });
    var fullTable = /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-ping-left"), pingedLeft), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-ping-right"), pingedRight), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-layout-fixed"), tableLayout === 'fixed'), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-fixed-header"), fixHeader), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-fixed-column"), fixColumn), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === 'right'), _classNames)),
        style: style,
        id: id,
        ref: fullTableRef
    }, ariaProps), /*#__PURE__*/ $acw62.createElement($fd7626e42d9e458e$var$MemoTableContent, {
        pingLeft: pingedLeft,
        pingRight: pingedRight,
        props: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            stickyOffsets: stickyOffsets,
            mergedExpandedKeys: mergedExpandedKeys
        })
    }, title && /*#__PURE__*/ $acw62.createElement((0, $iElZM.default), {
        className: "".concat(prefixCls, "-title")
    }, title(mergedData)), /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollBodyContainerRef,
        className: "".concat(prefixCls, "-container")
    }, groupTableNode), footer && /*#__PURE__*/ $acw62.createElement((0, $iElZM.default), {
        className: "".concat(prefixCls, "-footer")
    }, footer(mergedData))));
    if (horizonScroll) fullTable = /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onFullTableResize
    }, fullTable);
    var TableContextValue = $acw62.useMemo(function() {
        return {
            prefixCls: prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: flattenColumns.map(function(_, colIndex) {
                return (0, $791o7.getCellFixedInfo)(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
            }),
            isSticky: isSticky
        };
    }, [
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        flattenColumns,
        stickyOffsets,
        isSticky
    ]);
    var BodyContextValue = $acw62.useMemo(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, columnContext), {}, {
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandRowByClick,
            expandedRowRender: expandedRowRender,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandIconColumnIndex,
            indentSize: indentSize,
            allColumnsFixedLeft: columnContext.flattenColumns.every(function(col) {
                return col.fixed === 'left';
            })
        });
    }, [
        columnContext,
        mergedTableLayout,
        rowClassName,
        expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandRowByClick,
        expandedRowRender,
        onTriggerExpand,
        expandIconColumnIndex,
        indentSize
    ]);
    var ExpandedRowContextValue = $acw62.useMemo(function() {
        return {
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll
        };
    }, [
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll
    ]);
    var ResizeContextValue = $acw62.useMemo(function() {
        return {
            onColumnResize: onColumnResize
        };
    }, [
        onColumnResize
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $irah1.default).Provider, {
        value: supportSticky
    }, /*#__PURE__*/ $acw62.createElement((0, $2ZuUE.default).Provider, {
        value: TableContextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $kF8BC.default).Provider, {
        value: BodyContextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $gC73o.default).Provider, {
        value: ExpandedRowContextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $biqb2.default).Provider, {
        value: ResizeContextValue
    }, fullTable)))));
}
$fd7626e42d9e458e$var$Table.EXPAND_COLUMN = (0, $8aC4g.EXPAND_COLUMN);
$fd7626e42d9e458e$var$Table.Column = (0, $9hhTZ.default);
$fd7626e42d9e458e$var$Table.ColumnGroup = (0, $2VeAL.default);
$fd7626e42d9e458e$var$Table.Summary = (0, $64oV2.FooterComponents);
$fd7626e42d9e458e$var$Table.defaultProps = {
    rowKey: 'key',
    prefixCls: 'rc-table',
    emptyText: function emptyText() {
        return 'No Data';
    }
};
var $fd7626e42d9e458e$export$2e2bcd8739ae039 = $fd7626e42d9e458e$var$Table;

});
parcelRegister("7N6Vd", function(module, exports) {

$parcel$export(module.exports, "isStyleSupport", () => $5ac27a8c1ec0b63e$export$d616d7831008e86c);

var $h4v51 = parcelRequire("h4v51");
var $5ac27a8c1ec0b63e$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $h4v51.default)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $5ac27a8c1ec0b63e$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$5ac27a8c1ec0b63e$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement('div');
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $5ac27a8c1ec0b63e$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $5ac27a8c1ec0b63e$var$isStyleValueSupport(styleName, styleValue);
    return $5ac27a8c1ec0b63e$var$isStyleNameSupport(styleName);
}

});

parcelRegister("i5C3F", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("2SjmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $217fa5593a6718d2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getTargetScrollBarSize", () => $217fa5593a6718d2$export$4f3ef2310365b56a);
/* eslint-disable no-param-reassign */ 
var $4ZrBP = parcelRequire("4ZrBP");
var $217fa5593a6718d2$var$cached;
function $217fa5593a6718d2$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
            (0, $4ZrBP.updateCSS)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $4ZrBP.removeCSS)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $217fa5593a6718d2$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $217fa5593a6718d2$var$cached === undefined) $217fa5593a6718d2$var$cached = $217fa5593a6718d2$var$measureScrollbarSize();
    return $217fa5593a6718d2$var$cached.width;
}
function $217fa5593a6718d2$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $217fa5593a6718d2$var$measureScrollbarSize(target);
}

});
parcelRegister("4ZrBP", function(module, exports) {

$parcel$export(module.exports, "removeCSS", () => $3a22468320d7d808$export$2232e336aecaa80a);
$parcel$export(module.exports, "updateCSS", () => $3a22468320d7d808$export$4d99a2890bb989f0);

var $d49SP = parcelRequire("d49SP");

var $h4v51 = parcelRequire("h4v51");

var $d1wDM = parcelRequire("d1wDM");
var $3a22468320d7d808$var$APPEND_ORDER = 'data-rc-order';
var $3a22468320d7d808$var$APPEND_PRIORITY = 'data-rc-priority';
var $3a22468320d7d808$var$MARK_KEY = "rc-util-key";
var $3a22468320d7d808$var$containerCache = new Map();
function $3a22468320d7d808$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $3a22468320d7d808$var$MARK_KEY;
}
function $3a22468320d7d808$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $3a22468320d7d808$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $3a22468320d7d808$var$findStyles(container) {
    return Array.from(($3a22468320d7d808$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $3a22468320d7d808$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $h4v51.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $3a22468320d7d808$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($3a22468320d7d808$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($3a22468320d7d808$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $3a22468320d7d808$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $3a22468320d7d808$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($3a22468320d7d808$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($3a22468320d7d808$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $3a22468320d7d808$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $3a22468320d7d808$var$getContainer(option);
    return (option.styles || $3a22468320d7d808$var$findStyles(container)).find(function(node) {
        return node.getAttribute($3a22468320d7d808$var$getMark(option)) === key;
    });
}
function $3a22468320d7d808$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var container = $3a22468320d7d808$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $3a22468320d7d808$var$syncRealContainer(container, option) {
    var cachedRealContainer = $3a22468320d7d808$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $d1wDM.default)(document, cachedRealContainer)) {
        var placeholderStyle = $3a22468320d7d808$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $3a22468320d7d808$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $3a22468320d7d808$export$f80df667f2f5a272() {
    $3a22468320d7d808$var$containerCache.clear();
}
function $3a22468320d7d808$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $3a22468320d7d808$var$getContainer(originOption);
    var styles = $3a22468320d7d808$var$findStyles(container);
    var option = (0, $d49SP.default)((0, $d49SP.default)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $3a22468320d7d808$var$syncRealContainer(container, option);
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $3a22468320d7d808$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($3a22468320d7d808$var$getMark(option), key);
    return newNode;
}

});


parcelRegister("2VeAL", function(module, exports) {

$parcel$export(module.exports, "default", () => $220c394bb4cc7b1f$export$2e2bcd8739ae039);
/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $220c394bb4cc7b1f$var$ColumnGroup(_) {
    return null;
}
var $220c394bb4cc7b1f$export$2e2bcd8739ae039 = $220c394bb4cc7b1f$var$ColumnGroup;

});

parcelRegister("9hhTZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13968ac95170e6$export$2e2bcd8739ae039);
/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $6c13968ac95170e6$var$Column(_) {
    return null;
}
var $6c13968ac95170e6$export$2e2bcd8739ae039 = $6c13968ac95170e6$var$Column;

});

parcelRegister("3JHPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8793d7a19e207e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $aAwYB = parcelRequire("aAwYB");

var $2ZuUE = parcelRequire("2ZuUE");
function $2b8793d7a19e207e$var$parseHeaderRows(rootColumns) {
    var rows = [];
    function fillRowCells(columns, colIndex) {
        var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        var currentColIndex = colIndex;
        var colSpans = columns.filter(Boolean).map(function(column) {
            var cell = {
                key: column.key,
                className: column.className || '',
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            var colSpan = 1;
            var subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function(total, count) {
                    return total + count;
                }, 0);
                cell.hasSubColumns = true;
            }
            if ('colSpan' in column) colSpan = column.colSpan;
            if ('rowSpan' in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    } // Generate `rows` cell data
    fillRowCells(rootColumns, 0); // Handle `rowSpan`
    var rowCount = rows.length;
    var _loop = function _loop(rowIndex) {
        rows[rowIndex].forEach(function(cell) {
            if (!('rowSpan' in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
            cell.rowSpan = rowCount - rowIndex;
        });
    };
    for(var rowIndex = 0; rowIndex < rowCount; rowIndex += 1)_loop(rowIndex);
    return rows;
}
function $2b8793d7a19e207e$var$Header(_ref) {
    var stickyOffsets = _ref.stickyOffsets, columns = _ref.columns, flattenColumns = _ref.flattenColumns, onHeaderRow = _ref.onHeaderRow;
    var _React$useContext = $acw62.useContext((0, $2ZuUE.default)), prefixCls = _React$useContext.prefixCls, getComponent = _React$useContext.getComponent;
    var rows = $acw62.useMemo(function() {
        return $2b8793d7a19e207e$var$parseHeaderRows(columns);
    }, [
        columns
    ]);
    var WrapperComponent = getComponent([
        'header',
        'wrapper'
    ], 'thead');
    var trComponent = getComponent([
        'header',
        'row'
    ], 'tr');
    var thComponent = getComponent([
        'header',
        'cell'
    ], 'th');
    return /*#__PURE__*/ $acw62.createElement(WrapperComponent, {
        className: "".concat(prefixCls, "-thead")
    }, rows.map(function(row, rowIndex) {
        var rowNode = /*#__PURE__*/ $acw62.createElement((0, $aAwYB.default), {
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
}
var $2b8793d7a19e207e$export$2e2bcd8739ae039 = $2b8793d7a19e207e$var$Header;

});
parcelRegister("aAwYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b56d8a164a347ab$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3XT7t = parcelRequire("3XT7t");

var $2ZuUE = parcelRequire("2ZuUE");

var $791o7 = parcelRequire("791o7");

var $fgs8V = parcelRequire("fgs8V");
function $7b56d8a164a347ab$var$HeaderRow(_ref) {
    var cells = _ref.cells, stickyOffsets = _ref.stickyOffsets, flattenColumns = _ref.flattenColumns, RowComponent = _ref.rowComponent, CellComponent = _ref.cellComponent, onHeaderRow = _ref.onHeaderRow, index = _ref.index;
    var _React$useContext = $acw62.useContext((0, $2ZuUE.default)), prefixCls = _React$useContext.prefixCls, direction = _React$useContext.direction;
    var rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map(function(cell) {
        return cell.column;
    }), index);
    var columnsKey = (0, $fgs8V.getColumnsKey)(cells.map(function(cell) {
        return cell.column;
    }));
    return /*#__PURE__*/ $acw62.createElement(RowComponent, rowProps, cells.map(function(cell, cellIndex) {
        var column = cell.column;
        var fixedInfo = (0, $791o7.getCellFixedInfo)(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
        var additionalProps;
        if (column && column.onHeaderCell) additionalProps = cell.column.onHeaderCell(column);
        return /*#__PURE__*/ $acw62.createElement((0, $3XT7t.default), (0, $8nd05.default)({}, cell, {
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
}
$7b56d8a164a347ab$var$HeaderRow.displayName = 'HeaderRow';
var $7b56d8a164a347ab$export$2e2bcd8739ae039 = $7b56d8a164a347ab$var$HeaderRow;

});
parcelRegister("3XT7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e31a35df2b3b43c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $i5C3F = parcelRequire("i5C3F");

var $85dLH = parcelRequire("85dLH");

var $fgs8V = parcelRequire("fgs8V");

var $irah1 = parcelRequire("irah1");

var $kLa8K = parcelRequire("kLa8K");

var $kF8BC = parcelRequire("kF8BC");
parcelRequire("u43uR");

var $6V8RQ = parcelRequire("6V8RQ");

var $loJUu = parcelRequire("loJUu");
var $2e31a35df2b3b43c$var$_excluded = [
    "colSpan",
    "rowSpan",
    "style",
    "className"
];
/** Check if cell is in hover range */ function $2e31a35df2b3b43c$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    var cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $2e31a35df2b3b43c$var$isRenderCell(data) {
    return data && (0, $fSwVM.default)(data) === 'object' && !Array.isArray(data) && !/*#__PURE__*/ $acw62.isValidElement(data);
}
function $2e31a35df2b3b43c$var$isRefComponent(component) {
    // String tag component also support ref
    if (typeof component === 'string') return true;
    return (0, $85dLH.supportRef)(component);
}
var $2e31a35df2b3b43c$var$getTitleFromCellRenderChildren = function getTitleFromCellRenderChildren(_ref) {
    var ellipsis = _ref.ellipsis, rowType = _ref.rowType, children = _ref.children;
    var title;
    var ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
        if (typeof children === 'string' || typeof children === 'number') title = children.toString();
        else if (/*#__PURE__*/ $acw62.isValidElement(children) && typeof children.props.children === 'string') title = children.props.children;
    }
    return title;
};
function $2e31a35df2b3b43c$var$Cell(_ref2, ref) {
    var _ref4, _ref5, _classNames;
    var prefixCls = _ref2.prefixCls, className = _ref2.className, record = _ref2.record, index = _ref2.index, renderIndex = _ref2.renderIndex, dataIndex = _ref2.dataIndex, render = _ref2.render, children = _ref2.children, _ref2$component = _ref2.component, Component = _ref2$component === void 0 ? 'td' : _ref2$component, colSpan = _ref2.colSpan, rowSpan = _ref2.rowSpan, fixLeft = _ref2.fixLeft, fixRight = _ref2.fixRight, firstFixLeft = _ref2.firstFixLeft, lastFixLeft = _ref2.lastFixLeft, firstFixRight = _ref2.firstFixRight, lastFixRight = _ref2.lastFixRight, appendNode = _ref2.appendNode, _ref2$additionalProps = _ref2.additionalProps, additionalProps = _ref2$additionalProps === void 0 ? {} : _ref2$additionalProps, ellipsis = _ref2.ellipsis, align = _ref2.align, rowType = _ref2.rowType, isSticky = _ref2.isSticky, hovering = _ref2.hovering, onHover = _ref2.onHover;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var perfRecord = $acw62.useContext((0, $6V8RQ.default));
    var supportSticky = $acw62.useContext((0, $irah1.default));
    var _React$useContext = $acw62.useContext((0, $kF8BC.default)), allColumnsFixedLeft = _React$useContext.allColumnsFixedLeft; // ==================== Child Node ====================
    var _React$useMemo = $acw62.useMemo(function() {
        if ((0, $fgs8V.validateValue)(children)) return [
            children
        ];
        var value = (0, $fgs8V.getPathValue)(record, dataIndex); // Customize render node
        var returnChildNode = value;
        var returnCellProps = undefined;
        if (render) {
            var renderData = render(value, record, renderIndex);
            if ($2e31a35df2b3b43c$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        /* eslint-disable react-hooks/exhaustive-deps */ // Always re-render if `renderWithProps`
        perfRecord.renderWithProps ? Math.random() : 0,
        /* eslint-enable */ children,
        dataIndex,
        perfRecord,
        record,
        render,
        renderIndex
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), childNode = _React$useMemo2[0], legacyCellProps = _React$useMemo2[1];
    var mergedChildNode = childNode; // Not crash if final `childNode` is not validate ReactNode
    if ((0, $fSwVM.default)(mergedChildNode) === 'object' && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $acw62.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (lastFixLeft || firstFixRight)) mergedChildNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(cellPrefixCls, "-content")
    }, mergedChildNode);
    var _ref3 = legacyCellProps || {}, cellColSpan = _ref3.colSpan, cellRowSpan = _ref3.rowSpan, cellStyle = _ref3.style, cellClassName = _ref3.className, restCellProps = (0, $9X7IJ.default)(_ref3, $2e31a35df2b3b43c$var$_excluded);
    var mergedColSpan = (_ref4 = cellColSpan !== undefined ? cellColSpan : colSpan) !== null && _ref4 !== void 0 ? _ref4 : 1;
    var mergedRowSpan = (_ref5 = cellRowSpan !== undefined ? cellRowSpan : rowSpan) !== null && _ref5 !== void 0 ? _ref5 : 1;
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
     // ====================== Fixed =======================
    var fixedStyle = {};
    var isFixLeft = typeof fixLeft === 'number' && supportSticky;
    var isFixRight = typeof fixRight === 'number' && supportSticky;
    if (isFixLeft) {
        fixedStyle.position = 'sticky';
        fixedStyle.left = fixLeft;
    }
    if (isFixRight) {
        fixedStyle.position = 'sticky';
        fixedStyle.right = fixRight;
    } // ====================== Align =======================
    var alignStyle = {};
    if (align) alignStyle.textAlign = align;
     // ====================== Hover =======================
    var onMouseEnter = function onMouseEnter(event) {
        var _additionalProps$onMo;
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo = additionalProps.onMouseEnter) === null || _additionalProps$onMo === void 0 || _additionalProps$onMo.call(additionalProps, event);
    };
    var onMouseLeave = function onMouseLeave(event) {
        var _additionalProps$onMo2;
        if (record) onHover(-1, -1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo2 = additionalProps.onMouseLeave) === null || _additionalProps$onMo2 === void 0 || _additionalProps$onMo2.call(additionalProps, event);
    }; // ====================== Render ======================
    var title = $2e31a35df2b3b43c$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    var componentProps = (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
        title: title
    }, restCellProps), additionalProps), {}, {
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(cellPrefixCls, className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-all"), lastFixLeft && allColumnsFixedLeft && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky), (0, $kSlfw.default)(_classNames, "".concat(cellPrefixCls, "-row-hover"), !legacyCellProps && hovering), _classNames), additionalProps.className, cellClassName),
        style: (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({}, additionalProps.style), alignStyle), fixedStyle), cellStyle),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: $2e31a35df2b3b43c$var$isRefComponent(Component) ? ref : null
    });
    return /*#__PURE__*/ $acw62.createElement(Component, componentProps, appendNode, mergedChildNode);
}
var $2e31a35df2b3b43c$var$RefCell = /*#__PURE__*/ $acw62.forwardRef($2e31a35df2b3b43c$var$Cell);
$2e31a35df2b3b43c$var$RefCell.displayName = 'Cell';
var $2e31a35df2b3b43c$var$comparePropList = [
    'expanded',
    'className',
    'hovering'
];
var $2e31a35df2b3b43c$var$MemoCell = /*#__PURE__*/ $acw62.memo($2e31a35df2b3b43c$var$RefCell, function(prev, next) {
    if (next.shouldCellUpdate) return $2e31a35df2b3b43c$var$comparePropList.every(function(propName) {
        return prev[propName] === next[propName];
    }) && // User control update logic
    !next.shouldCellUpdate(next.record, prev.record);
    return (0, (/*@__PURE__*/$parcel$interopDefault($i5C3F)))(prev, next);
});
/** Inject hover data here, we still wish MemoCell keep simple `shouldCellUpdate` logic */ var $2e31a35df2b3b43c$var$WrappedCell = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var index = props.index, _props$additionalProp = props.additionalProps, additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp, colSpan = props.colSpan, rowSpan = props.rowSpan;
    var cellColSpan = additionalProps.colSpan, cellRowSpan = additionalProps.rowSpan;
    var mergedColSpan = colSpan !== null && colSpan !== void 0 ? colSpan : cellColSpan;
    var mergedRowSpan = rowSpan !== null && rowSpan !== void 0 ? rowSpan : cellRowSpan;
    var _useContextSelector = (0, $loJUu.useContextSelector)((0, $kLa8K.default), function(cxt) {
        var isHovering = $2e31a35df2b3b43c$var$inHoverRange(index, mergedRowSpan || 1, cxt === null || cxt === void 0 ? void 0 : cxt.startRow, cxt === null || cxt === void 0 ? void 0 : cxt.endRow);
        return {
            onHover: cxt === null || cxt === void 0 ? void 0 : cxt.onHover,
            hovering: isHovering
        };
    }), onHover = _useContextSelector.onHover, hovering = _useContextSelector.hovering;
    return /*#__PURE__*/ $acw62.createElement($2e31a35df2b3b43c$var$MemoCell, (0, $8nd05.default)({}, props, {
        colSpan: mergedColSpan,
        rowSpan: mergedRowSpan,
        hovering: hovering,
        ref: ref,
        onHover: onHover
    }));
});
$2e31a35df2b3b43c$var$WrappedCell.displayName = 'WrappedCell';
var $2e31a35df2b3b43c$export$2e2bcd8739ae039 = $2e31a35df2b3b43c$var$WrappedCell;

});
parcelRegister("fgs8V", function(module, exports) {

$parcel$export(module.exports, "getPathValue", () => $b1ce2e4492efd614$export$964131d48d6e4d94);
$parcel$export(module.exports, "getColumnsKey", () => $b1ce2e4492efd614$export$fd2ca5407d9be470);
$parcel$export(module.exports, "validateValue", () => $b1ce2e4492efd614$export$b76e9316566cc26e);
var $b1ce2e4492efd614$var$INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function $b1ce2e4492efd614$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $b1ce2e4492efd614$export$964131d48d6e4d94(record, path) {
    // Skip if path is empty
    if (!path && typeof path !== 'number') return record;
    var pathList = $b1ce2e4492efd614$var$toArray(path);
    var current = record;
    for(var i = 0; i < pathList.length; i += 1){
        if (!current) return null;
        var prop = pathList[i];
        current = current[prop];
    }
    return current;
}
function $b1ce2e4492efd614$export$fd2ca5407d9be470(columns) {
    var columnKeys = [];
    var keys = {};
    columns.forEach(function(column) {
        var _ref = column || {}, key = _ref.key, dataIndex = _ref.dataIndex;
        var mergedKey = key || $b1ce2e4492efd614$var$toArray(dataIndex).join('-') || $b1ce2e4492efd614$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = "".concat(mergedKey, "_next");
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $b1ce2e4492efd614$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}

});

parcelRegister("irah1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c2b7bdc06ac51d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $d6c2b7bdc06ac51d$var$StickyContext = /*#__PURE__*/ $acw62.createContext(false);
var $d6c2b7bdc06ac51d$export$2e2bcd8739ae039 = $d6c2b7bdc06ac51d$var$StickyContext;

});

parcelRegister("kLa8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d0100b7067ce08$export$2e2bcd8739ae039);

var $loJUu = parcelRequire("loJUu");
var $f1d0100b7067ce08$var$HoverContext = (0, $loJUu.createContext)();
var $f1d0100b7067ce08$export$2e2bcd8739ae039 = $f1d0100b7067ce08$var$HoverContext;

});
parcelRegister("loJUu", function(module, exports) {

$parcel$export(module.exports, "createContext", () => $f93f73a456383f4c$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "useContextSelector", () => $f93f73a456383f4c$export$30b2013e16e635d0);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $6hDTM = parcelRequire("6hDTM");

var $a4gyP = parcelRequire("a4gyP");

var $i5C3F = parcelRequire("i5C3F");
function $f93f73a456383f4c$export$fd42f52fd3ae1109() {
    var Context = /*#__PURE__*/ $acw62.createContext(null);
    var Provider = function Provider(_ref) {
        var value = _ref.value, children = _ref.children;
        var valueRef = $acw62.useRef(value);
        valueRef.current = value;
        var _React$useState = $acw62.useState(function() {
            return {
                getValue: function getValue() {
                    return valueRef.current;
                },
                listeners: new Set()
            };
        }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 1), context = _React$useState2[0];
        (0, $6hDTM.default)(function() {
            context.listeners.forEach(function(listener) {
                listener(value);
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider
    };
}
function $f93f73a456383f4c$export$30b2013e16e635d0(holder, selector) {
    var eventSelector = (0, $a4gyP.default)(selector);
    var context = $acw62.useContext(holder === null || holder === void 0 ? void 0 : holder.Context);
    var _ref2 = context || {}, listeners = _ref2.listeners, getValue = _ref2.getValue;
    var _React$useState3 = $acw62.useState(function() {
        return eventSelector(context ? getValue() : null);
    }), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), value = _React$useState4[0], setValue = _React$useState4[1];
    (0, $6hDTM.default)(function() {
        if (!context) return;
        function trigger(nextValue) {
            setValue(function(prev) {
                var selectedValue = eventSelector(nextValue);
                return (0, (/*@__PURE__*/$parcel$interopDefault($i5C3F)))(prev, selectedValue) ? prev : selectedValue;
            });
        }
        listeners.add(trigger);
        return function() {
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return value;
}

});


parcelRegister("kF8BC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ae4fe6ce1711b7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $f0ae4fe6ce1711b7$var$BodyContext = /*#__PURE__*/ $acw62.createContext(null);
var $f0ae4fe6ce1711b7$export$2e2bcd8739ae039 = $f0ae4fe6ce1711b7$var$BodyContext;

});

parcelRegister("6V8RQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $509ef1d103e7af0d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $509ef1d103e7af0d$var$PerfContext = /*#__PURE__*/ $acw62.createContext({
    renderWithProps: false
});
var $509ef1d103e7af0d$export$2e2bcd8739ae039 = $509ef1d103e7af0d$var$PerfContext;

});


parcelRegister("2ZuUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d941e9230e52ce$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $22d941e9230e52ce$var$TableContext = /*#__PURE__*/ $acw62.createContext(null);
var $22d941e9230e52ce$export$2e2bcd8739ae039 = $22d941e9230e52ce$var$TableContext;

});

parcelRegister("791o7", function(module, exports) {

$parcel$export(module.exports, "getCellFixedInfo", () => $533a734f6aca19a1$export$695db918331141f3);
function $533a734f6aca19a1$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets, direction) {
    var startColumn = columns[colStart] || {};
    var endColumn = columns[colEnd] || {};
    var fixLeft;
    var fixRight;
    if (startColumn.fixed === 'left') fixLeft = stickyOffsets.left[colStart];
    else if (endColumn.fixed === 'right') fixRight = stickyOffsets.right[colEnd];
    var lastFixLeft = false;
    var firstFixRight = false;
    var lastFixRight = false;
    var firstFixLeft = false;
    var nextColumn = columns[colEnd + 1];
    var prevColumn = columns[colStart - 1];
    if (direction === 'rtl') {
        if (fixLeft !== undefined) {
            var prevFixLeft = prevColumn && prevColumn.fixed === 'left';
            firstFixLeft = !prevFixLeft;
        } else if (fixRight !== undefined) {
            var nextFixRight = nextColumn && nextColumn.fixed === 'right';
            lastFixRight = !nextFixRight;
        }
    } else if (fixLeft !== undefined) {
        var nextFixLeft = nextColumn && nextColumn.fixed === 'left';
        lastFixLeft = !nextFixLeft;
    } else if (fixRight !== undefined) {
        var prevFixRight = prevColumn && prevColumn.fixed === 'right';
        firstFixRight = !prevFixRight;
    }
    return {
        fixLeft: fixLeft,
        fixRight: fixRight,
        lastFixLeft: lastFixLeft,
        firstFixRight: firstFixRight,
        lastFixRight: lastFixRight,
        firstFixLeft: firstFixLeft,
        isSticky: stickyOffsets.isSticky
    };
}

});



parcelRegister("gKJ9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c323f6b3243a8952$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $2ZuUE = parcelRequire("2ZuUE");

var $bu2BY = parcelRequire("bu2BY");

var $kF8BC = parcelRequire("kF8BC");

var $fgs8V = parcelRequire("fgs8V");

var $biqb2 = parcelRequire("biqb2");

var $4UUd5 = parcelRequire("4UUd5");

var $akTQZ = parcelRequire("akTQZ");

var $kLa8K = parcelRequire("kLa8K");

var $6V8RQ = parcelRequire("6V8RQ");

var $lmBfH = parcelRequire("lmBfH");
function $c323f6b3243a8952$var$Body(_ref) {
    var data = _ref.data, getRowKey = _ref.getRowKey, measureColumnWidth = _ref.measureColumnWidth, expandedKeys = _ref.expandedKeys, onRow = _ref.onRow, rowExpandable = _ref.rowExpandable, emptyNode = _ref.emptyNode, childrenColumnName = _ref.childrenColumnName;
    var _React$useContext = $acw62.useContext((0, $biqb2.default)), onColumnResize = _React$useContext.onColumnResize;
    var _React$useContext2 = $acw62.useContext((0, $2ZuUE.default)), prefixCls = _React$useContext2.prefixCls, getComponent = _React$useContext2.getComponent;
    var _React$useContext3 = $acw62.useContext((0, $kF8BC.default)), flattenColumns = _React$useContext3.flattenColumns;
    var flattenData = (0, $akTQZ.default)(data, childrenColumnName, expandedKeys, getRowKey); // =================== Performance ====================
    var perfRef = $acw62.useRef({
        renderWithProps: false
    }); // ====================== Hover =======================
    var _React$useState = $acw62.useState(-1), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), startRow = _React$useState2[0], setStartRow = _React$useState2[1];
    var _React$useState3 = $acw62.useState(-1), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), endRow = _React$useState4[0], setEndRow = _React$useState4[1];
    var onHover = $acw62.useCallback(function(start, end) {
        setStartRow(start);
        setEndRow(end);
    }, []); // ====================== Render ======================
    var bodyNode = $acw62.useMemo(function() {
        var WrapperComponent = getComponent([
            'body',
            'wrapper'
        ], 'tbody');
        var trComponent = getComponent([
            'body',
            'row'
        ], 'tr');
        var tdComponent = getComponent([
            'body',
            'cell'
        ], 'td');
        var rows;
        if (data.length) rows = flattenData.map(function(item, idx) {
            var record = item.record, indent = item.indent, renderIndex = item.index;
            var key = getRowKey(record, idx);
            return /*#__PURE__*/ $acw62.createElement((0, $4UUd5.default), {
                key: key,
                rowKey: key,
                record: record,
                recordKey: key,
                index: idx,
                renderIndex: renderIndex,
                rowComponent: trComponent,
                cellComponent: tdComponent,
                expandedKeys: expandedKeys,
                onRow: onRow,
                getRowKey: getRowKey,
                rowExpandable: rowExpandable,
                childrenColumnName: childrenColumnName,
                indent: indent
            });
        });
        else rows = /*#__PURE__*/ $acw62.createElement((0, $bu2BY.default), {
            expanded: true,
            className: "".concat(prefixCls, "-placeholder"),
            prefixCls: prefixCls,
            component: trComponent,
            cellComponent: tdComponent,
            colSpan: flattenColumns.length,
            isEmpty: true
        }, emptyNode);
        var columnsKey = (0, $fgs8V.getColumnsKey)(flattenColumns);
        return /*#__PURE__*/ $acw62.createElement(WrapperComponent, {
            className: "".concat(prefixCls, "-tbody")
        }, measureColumnWidth && /*#__PURE__*/ $acw62.createElement((0, $lmBfH.default), {
            prefixCls: prefixCls,
            columnsKey: columnsKey,
            onColumnResize: onColumnResize
        }), rows);
    }, [
        data,
        prefixCls,
        onRow,
        measureColumnWidth,
        expandedKeys,
        getRowKey,
        getComponent,
        emptyNode,
        flattenColumns,
        childrenColumnName,
        onColumnResize,
        rowExpandable,
        flattenData
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $6V8RQ.default).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $acw62.createElement((0, $kLa8K.default).Provider, {
        value: {
            startRow: startRow,
            endRow: endRow,
            onHover: onHover
        }
    }, bodyNode));
}
var $c323f6b3243a8952$var$MemoBody = /*#__PURE__*/ $acw62.memo($c323f6b3243a8952$var$Body);
$c323f6b3243a8952$var$MemoBody.displayName = 'Body';
var $c323f6b3243a8952$export$2e2bcd8739ae039 = $c323f6b3243a8952$var$MemoBody;

});
parcelRegister("bu2BY", function(module, exports) {

$parcel$export(module.exports, "default", () => $85c485a146925ee8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $3XT7t = parcelRequire("3XT7t");

var $2ZuUE = parcelRequire("2ZuUE");

var $gC73o = parcelRequire("gC73o");
function $85c485a146925ee8$var$ExpandedRow(_ref) {
    var prefixCls = _ref.prefixCls, children = _ref.children, Component = _ref.component, cellComponent = _ref.cellComponent, className = _ref.className, expanded = _ref.expanded, colSpan = _ref.colSpan, isEmpty = _ref.isEmpty;
    var _React$useContext = $acw62.useContext((0, $2ZuUE.default)), scrollbarSize = _React$useContext.scrollbarSize;
    var _React$useContext2 = $acw62.useContext((0, $gC73o.default)), fixHeader = _React$useContext2.fixHeader, fixColumn = _React$useContext2.fixColumn, componentWidth = _React$useContext2.componentWidth, horizonScroll = _React$useContext2.horizonScroll; // Cache render node
    return $acw62.useMemo(function() {
        var contentNode = children;
        if (isEmpty ? horizonScroll : fixColumn) contentNode = /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                width: componentWidth - (fixHeader ? scrollbarSize : 0),
                position: 'sticky',
                left: 0,
                overflow: 'hidden'
            },
            className: "".concat(prefixCls, "-expanded-row-fixed")
        }, componentWidth !== 0 && contentNode);
        return /*#__PURE__*/ $acw62.createElement(Component, {
            className: className,
            style: {
                display: expanded ? null : 'none'
            }
        }, /*#__PURE__*/ $acw62.createElement((0, $3XT7t.default), {
            component: cellComponent,
            prefixCls: prefixCls,
            colSpan: colSpan
        }, contentNode));
    }, [
        children,
        Component,
        className,
        expanded,
        colSpan,
        isEmpty,
        scrollbarSize,
        componentWidth,
        fixColumn,
        fixHeader,
        horizonScroll
    ]);
}
var $85c485a146925ee8$export$2e2bcd8739ae039 = $85c485a146925ee8$var$ExpandedRow;

});
parcelRegister("gC73o", function(module, exports) {

$parcel$export(module.exports, "default", () => $c185aaafe5c1cad9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $c185aaafe5c1cad9$var$ExpandedRowContext = /*#__PURE__*/ $acw62.createContext(null);
var $c185aaafe5c1cad9$export$2e2bcd8739ae039 = $c185aaafe5c1cad9$var$ExpandedRowContext;

});


parcelRegister("biqb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8395ae623be3db25$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $8395ae623be3db25$var$ResizeContext = /*#__PURE__*/ $acw62.createContext(null);
var $8395ae623be3db25$export$2e2bcd8739ae039 = $8395ae623be3db25$var$ResizeContext;

});

parcelRegister("4UUd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3947fe8a4b6be6fe$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $3XT7t = parcelRequire("3XT7t");

var $2ZuUE = parcelRequire("2ZuUE");

var $kF8BC = parcelRequire("kF8BC");

var $fgs8V = parcelRequire("fgs8V");

var $bu2BY = parcelRequire("bu2BY");
function $3947fe8a4b6be6fe$var$BodyRow(props) {
    var className = props.className, style = props.style, record = props.record, index = props.index, renderIndex = props.renderIndex, rowKey = props.rowKey, rowExpandable = props.rowExpandable, expandedKeys = props.expandedKeys, onRow = props.onRow, _props$indent = props.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props.rowComponent, cellComponent = props.cellComponent, childrenColumnName = props.childrenColumnName;
    var _React$useContext = $acw62.useContext((0, $2ZuUE.default)), prefixCls = _React$useContext.prefixCls, fixedInfoList = _React$useContext.fixedInfoList;
    var _React$useContext2 = $acw62.useContext((0, $kF8BC.default)), flattenColumns = _React$useContext2.flattenColumns, expandableType = _React$useContext2.expandableType, expandRowByClick = _React$useContext2.expandRowByClick, onTriggerExpand = _React$useContext2.onTriggerExpand, rowClassName = _React$useContext2.rowClassName, expandedRowClassName = _React$useContext2.expandedRowClassName, indentSize = _React$useContext2.indentSize, expandIcon = _React$useContext2.expandIcon, expandedRowRender = _React$useContext2.expandedRowRender, expandIconColumnIndex = _React$useContext2.expandIconColumnIndex;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), expandRended = _React$useState2[0], setExpandRended = _React$useState2[1];
    var expanded = expandedKeys && expandedKeys.has(props.recordKey);
    $acw62.useEffect(function() {
        if (expanded) setExpandRended(true);
    }, [
        expanded
    ]);
    var rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record)); // Only when row is not expandable and `children` exist in record
    var nestExpandable = expandableType === 'nest';
    var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    var mergedExpandable = rowSupportExpand || nestExpandable; // ======================== Expandable =========================
    var onExpandRef = $acw62.useRef(onTriggerExpand);
    onExpandRef.current = onTriggerExpand;
    var onInternalTriggerExpand = function onInternalTriggerExpand() {
        onExpandRef.current.apply(onExpandRef, arguments);
    }; // =========================== onRow ===========================
    var additionalProps = onRow === null || onRow === void 0 ? void 0 : onRow(record, index);
    var onClick = function onClick(event) {
        var _additionalProps$onCl;
        if (expandRowByClick && mergedExpandable) onInternalTriggerExpand(record, event);
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onCl = additionalProps.onClick) === null || _additionalProps$onCl === void 0 || _additionalProps$onCl.call.apply(_additionalProps$onCl, [
            additionalProps,
            event
        ].concat(args));
    }; // ======================== Base tr row ========================
    var computeRowClassName;
    if (typeof rowClassName === 'string') computeRowClassName = rowClassName;
    else if (typeof rowClassName === 'function') computeRowClassName = rowClassName(record, index, indent);
    var columnsKey = (0, $fgs8V.getColumnsKey)(flattenColumns);
    var baseRowNode = /*#__PURE__*/ $acw62.createElement(RowComponent, (0, $8nd05.default)({}, additionalProps, {
        "data-row-key": rowKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), computeRowClassName, additionalProps && additionalProps.className),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), additionalProps ? additionalProps.style : null),
        onClick: onClick
    }), flattenColumns.map(function(column, colIndex) {
        var render = column.render, dataIndex = column.dataIndex, columnClassName = column.className;
        var key = columnsKey[colIndex];
        var fixedInfo = fixedInfoList[colIndex]; // ============= Used for nest expandable =============
        var appendCellNode;
        if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
            style: {
                paddingLeft: "".concat(indentSize * indent, "px")
            },
            className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
        }), expandIcon({
            prefixCls: prefixCls,
            expanded: expanded,
            expandable: hasNestChildren,
            record: record,
            onExpand: onInternalTriggerExpand
        }));
        var additionalCellProps;
        if (column.onCell) additionalCellProps = column.onCell(record, index);
        return /*#__PURE__*/ $acw62.createElement((0, $3XT7t.default), (0, $8nd05.default)({
            className: columnClassName,
            ellipsis: column.ellipsis,
            align: column.align,
            component: cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate,
            expanded: appendCellNode && expanded
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    })); // ======================== Expand Row =========================
    var expandRowNode;
    if (rowSupportExpand && (expandRended || expanded)) {
        var expandContent = expandedRowRender(record, index, indent + 1, expanded);
        var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index, indent);
        expandRowNode = /*#__PURE__*/ $acw62.createElement((0, $bu2BY.default), {
            expanded: expanded,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: flattenColumns.length,
            isEmpty: false
        }, expandContent);
    }
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, baseRowNode, expandRowNode);
}
$3947fe8a4b6be6fe$var$BodyRow.displayName = 'BodyRow';
var $3947fe8a4b6be6fe$export$2e2bcd8739ae039 = $3947fe8a4b6be6fe$var$BodyRow;

});

parcelRegister("akTQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $78671905ff86343f$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");
function $78671905ff86343f$var$flatRecord(record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    var arr = [];
    arr.push({
        record: record,
        indent: indent,
        index: index
    });
    var key = getRowKey(record);
    var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(var i = 0; i < record[childrenColumnName].length; i += 1){
        var tempArr = $78671905ff86343f$var$flatRecord(record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
        arr.push.apply(arr, (0, $kbxxf.default)(tempArr));
    }
    return arr;
}
function $78671905ff86343f$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    var arr = $acw62.useMemo(function() {
        if (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.size) {
            var temp = []; // collect flattened record
            for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i += 1){
                var record = data[i];
                temp.push.apply(temp, (0, $kbxxf.default)($78671905ff86343f$var$flatRecord(record, 0, childrenColumnName, expandedKeys, getRowKey, i)));
            }
            return temp;
        }
        return data === null || data === void 0 ? void 0 : data.map(function(item, index) {
            return {
                record: item,
                indent: 0,
                index: index
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}

});

parcelRegister("lmBfH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d88c93ca218423$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $bVxlN = parcelRequire("bVxlN");

var $1xEuj = parcelRequire("1xEuj");
function $f8d88c93ca218423$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, columnsKey = _ref.columnsKey, onColumnResize = _ref.onColumnResize;
    return /*#__PURE__*/ $acw62.createElement("tr", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-measure-row"),
        style: {
            height: 0,
            fontSize: 0
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default).Collection, {
        onBatchResize: function onBatchResize(infoList) {
            infoList.forEach(function(_ref2) {
                var columnKey = _ref2.data, size = _ref2.size;
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map(function(columnKey) {
        return /*#__PURE__*/ $acw62.createElement((0, $1xEuj.default), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize
        });
    })));
}

});
parcelRegister("1xEuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f84790e7524d63$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $bVxlN = parcelRequire("bVxlN");
function $11f84790e7524d63$export$2e2bcd8739ae039(_ref) {
    var columnKey = _ref.columnKey, onColumnResize = _ref.onColumnResize;
    var cellRef = $acw62.useRef();
    $acw62.useEffect(function() {
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        data: columnKey
    }, /*#__PURE__*/ $acw62.createElement("td", {
        ref: cellRef,
        style: {
            padding: 0,
            border: 0,
            height: 0
        }
    }, /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            height: 0,
            overflow: 'hidden'
        }
    }, "\xA0")));
}

});



parcelRegister("89kiB", function(module, exports) {

$parcel$export(module.exports, "convertChildrenToColumns", () => $5eeee8effa7c2922$export$d87a97eba44e0f9c);
$parcel$export(module.exports, "default", () => $5eeee8effa7c2922$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $u43uR = parcelRequire("u43uR");

var $jWR62 = parcelRequire("jWR62");

var $aLkKv = parcelRequire("aLkKv");

var $8aC4g = parcelRequire("8aC4g");
var $5eeee8effa7c2922$var$_excluded = [
    "children"
], $5eeee8effa7c2922$var$_excluded2 = [
    "fixed"
];
function $5eeee8effa7c2922$export$d87a97eba44e0f9c(children) {
    return (0, $jWR62.default)(children).filter(function(node) {
        return /*#__PURE__*/ $acw62.isValidElement(node);
    }).map(function(_ref) {
        var key = _ref.key, props = _ref.props;
        var nodeChildren = props.children, restProps = (0, $9X7IJ.default)(props, $5eeee8effa7c2922$var$_excluded);
        var column = (0, $d49SP.default)({
            key: key
        }, restProps);
        if (nodeChildren) column.children = $5eeee8effa7c2922$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $5eeee8effa7c2922$var$flatColumns(columns) {
    return columns.reduce(function(list, column) {
        var fixed = column.fixed; // Convert `fixed='true'` to `fixed='left'` instead
        var parsedFixed = fixed === true ? 'left' : fixed;
        var subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [].concat((0, $kbxxf.default)(list), (0, $kbxxf.default)($5eeee8effa7c2922$var$flatColumns(subColumns).map(function(subColum) {
            return (0, $d49SP.default)({
                fixed: parsedFixed
            }, subColum);
        })));
        return [].concat((0, $kbxxf.default)(list), [
            (0, $d49SP.default)((0, $d49SP.default)({}, column), {}, {
                fixed: parsedFixed
            })
        ]);
    }, []);
}
function $5eeee8effa7c2922$var$warningFixed(flattenColumns) {
    var allFixLeft = true;
    for(var i = 0; i < flattenColumns.length; i += 1){
        var col = flattenColumns[i];
        if (allFixLeft && col.fixed !== 'left') allFixLeft = false;
        else if (!allFixLeft && col.fixed === 'left') {
            (0, $u43uR.default)(false, "Index ".concat(i - 1, " of `columns` missing `fixed='left'` prop."));
            break;
        }
    }
    var allFixRight = true;
    for(var _i = flattenColumns.length - 1; _i >= 0; _i -= 1){
        var _col = flattenColumns[_i];
        if (allFixRight && _col.fixed !== 'right') allFixRight = false;
        else if (!allFixRight && _col.fixed === 'right') {
            (0, $u43uR.default)(false, "Index ".concat(_i + 1, " of `columns` missing `fixed='right'` prop."));
            break;
        }
    }
}
function $5eeee8effa7c2922$var$revertForRtl(columns) {
    return columns.map(function(column) {
        var fixed = column.fixed, restProps = (0, $9X7IJ.default)(column, $5eeee8effa7c2922$var$_excluded2); // Convert `fixed='left'` to `fixed='right'` instead
        var parsedFixed = fixed;
        if (fixed === 'left') parsedFixed = 'right';
        else if (fixed === 'right') parsedFixed = 'left';
        return (0, $d49SP.default)({
            fixed: parsedFixed
        }, restProps);
    });
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $5eeee8effa7c2922$var$useColumns(_ref2, transformColumns) {
    var prefixCls = _ref2.prefixCls, columns = _ref2.columns, children = _ref2.children, expandable = _ref2.expandable, expandedKeys = _ref2.expandedKeys, columnTitle = _ref2.columnTitle, getRowKey = _ref2.getRowKey, onTriggerExpand = _ref2.onTriggerExpand, expandIcon = _ref2.expandIcon, rowExpandable = _ref2.rowExpandable, expandIconColumnIndex = _ref2.expandIconColumnIndex, direction = _ref2.direction, expandRowByClick = _ref2.expandRowByClick, columnWidth = _ref2.columnWidth, fixed = _ref2.fixed;
    var baseColumns = $acw62.useMemo(function() {
        return columns || $5eeee8effa7c2922$export$d87a97eba44e0f9c(children);
    }, [
        columns,
        children
    ]); // ========================== Expand ==========================
    var withExpandColumns = $acw62.useMemo(function() {
        if (expandable) {
            var _expandColumn;
            var cloneColumns = baseColumns.slice(); // >>> Warning if use `expandIconColumnIndex`
            if (!cloneColumns.includes((0, $8aC4g.EXPAND_COLUMN))) {
                var expandColIndex = expandIconColumnIndex || 0;
                if (expandColIndex >= 0) cloneColumns.splice(expandColIndex, 0, (0, $8aC4g.EXPAND_COLUMN));
            } // >>> Deduplicate additional expand column
            var expandColumnIndex = cloneColumns.indexOf((0, $8aC4g.EXPAND_COLUMN));
            cloneColumns = cloneColumns.filter(function(column, index) {
                return column !== (0, $8aC4g.EXPAND_COLUMN) || index === expandColumnIndex;
            }); // >>> Check if expand column need to fixed
            var prevColumn = baseColumns[expandColumnIndex];
            var fixedColumn;
            if ((fixed === 'left' || fixed) && !expandIconColumnIndex) fixedColumn = 'left';
            else if ((fixed === 'right' || fixed) && expandIconColumnIndex === baseColumns.length) fixedColumn = 'right';
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
             // >>> Create expandable column
            var expandColumn = (_expandColumn = {}, (0, $kSlfw.default)(_expandColumn, (0, $aLkKv.INTERNAL_COL_DEFINE), {
                className: "".concat(prefixCls, "-expand-icon-col"),
                columnType: 'EXPAND_COLUMN'
            }), (0, $kSlfw.default)(_expandColumn, "title", columnTitle), (0, $kSlfw.default)(_expandColumn, "fixed", fixedColumn), (0, $kSlfw.default)(_expandColumn, "className", "".concat(prefixCls, "-row-expand-icon-cell")), (0, $kSlfw.default)(_expandColumn, "width", columnWidth), (0, $kSlfw.default)(_expandColumn, "render", function render(_, record, index) {
                var rowKey = getRowKey(record, index);
                var expanded = expandedKeys.has(rowKey);
                var recordExpandable = rowExpandable ? rowExpandable(record) : true;
                var icon = expandIcon({
                    prefixCls: prefixCls,
                    expanded: expanded,
                    expandable: recordExpandable,
                    record: record,
                    onExpand: onTriggerExpand
                });
                if (expandRowByClick) return /*#__PURE__*/ $acw62.createElement("span", {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    }
                }, icon);
                return icon;
            }), _expandColumn);
            return cloneColumns.map(function(col) {
                return col === (0, $8aC4g.EXPAND_COLUMN) ? expandColumn : col;
            });
        }
        return baseColumns.filter(function(col) {
            return col !== (0, $8aC4g.EXPAND_COLUMN);
        });
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction
    ]); // ========================= Transform ========================
    var mergedColumns = $acw62.useMemo(function() {
        var finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
         // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: function render() {
                    return null;
                }
            }
        ];
        return finalColumns;
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]); // ========================== Flatten =========================
    var flattenColumns = $acw62.useMemo(function() {
        if (direction === 'rtl') return $5eeee8effa7c2922$var$revertForRtl($5eeee8effa7c2922$var$flatColumns(mergedColumns));
        return $5eeee8effa7c2922$var$flatColumns(mergedColumns);
    }, [
        mergedColumns,
        direction
    ]); // Only check out of production since it's waste for each render
    return [
        mergedColumns,
        flattenColumns
    ];
}
var $5eeee8effa7c2922$export$2e2bcd8739ae039 = $5eeee8effa7c2922$var$useColumns;

});
parcelRegister("aLkKv", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_COL_DEFINE", () => $7d5e637feda74b50$export$f8dba99c0d5b6b87);
$parcel$export(module.exports, "getExpandableProps", () => $7d5e637feda74b50$export$e215b9806eacdfb5);

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");
parcelRequire("u43uR");
var $7d5e637feda74b50$var$_excluded = [
    "expandable"
];
var $7d5e637feda74b50$export$f8dba99c0d5b6b87 = 'RC_TABLE_INTERNAL_COL_DEFINE';
function $7d5e637feda74b50$export$e215b9806eacdfb5(props) {
    var expandable = props.expandable, legacyExpandableConfig = (0, $9X7IJ.default)(props, $7d5e637feda74b50$var$_excluded);
    var config;
    if ('expandable' in props) config = (0, $d49SP.default)((0, $d49SP.default)({}, legacyExpandableConfig), expandable);
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}

});

parcelRegister("8aC4g", function(module, exports) {

$parcel$export(module.exports, "EXPAND_COLUMN", () => $5f2cc95ff3bf4bb6$export$e1053575ddfcb301);
var $5f2cc95ff3bf4bb6$export$e1053575ddfcb301 = {};

});


parcelRegister("cnAwI", function(module, exports) {

$parcel$export(module.exports, "useLayoutState", () => $9033f76e13287b2a$export$510e4dd13e0b67dd);
$parcel$export(module.exports, "useTimeoutLock", () => $9033f76e13287b2a$export$d63c72d5e6d02249);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $9033f76e13287b2a$export$510e4dd13e0b67dd(defaultState) {
    var stateRef = (0, $acw62.useRef)(defaultState);
    var _useState = (0, $acw62.useState)({}), _useState2 = (0, $eUqlC.default)(_useState, 2), forceUpdate = _useState2[1];
    var lastPromiseRef = (0, $acw62.useRef)(null);
    var updateBatchRef = (0, $acw62.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        var promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(function() {
            if (lastPromiseRef.current === promise) {
                var prevBatch = updateBatchRef.current;
                var prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach(function(batchUpdater) {
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $acw62.useEffect)(function() {
        return function() {
            lastPromiseRef.current = null;
        };
    }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $9033f76e13287b2a$export$d63c72d5e6d02249(defaultState) {
    var frameRef = (0, $acw62.useRef)(defaultState || null);
    var timeoutRef = (0, $acw62.useRef)();
    function cleanUp() {
        window.clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = window.setTimeout(function() {
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $acw62.useEffect)(function() {
        return cleanUp;
    }, []);
    return [
        setState,
        getState
    ];
}

});

parcelRegister("gir7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd35ed3b4dc746f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * Get sticky column offset width
 */ function $bdd35ed3b4dc746f$var$useStickyOffsets(colWidths, columnCount, direction) {
    var stickyOffsets = (0, $acw62.useMemo)(function() {
        var leftOffsets = [];
        var rightOffsets = [];
        var left = 0;
        var right = 0;
        for(var start = 0; start < columnCount; start += 1)if (direction === 'rtl') {
            // Left offset
            rightOffsets[start] = right;
            right += colWidths[start] || 0; // Right offset
            var end = columnCount - start - 1;
            leftOffsets[end] = left;
            left += colWidths[end] || 0;
        } else {
            // Left offset
            leftOffsets[start] = left;
            left += colWidths[start] || 0; // Right offset
            var _end = columnCount - start - 1;
            rightOffsets[_end] = right;
            right += colWidths[_end] || 0;
        }
        return {
            left: leftOffsets,
            right: rightOffsets
        };
    }, [
        colWidths,
        columnCount,
        direction
    ]);
    return stickyOffsets;
}
var $bdd35ed3b4dc746f$export$2e2bcd8739ae039 = $bdd35ed3b4dc746f$var$useStickyOffsets;

});

parcelRegister("1RXuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c8e448643b1144$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $aLkKv = parcelRequire("aLkKv");
var $15c8e448643b1144$var$_excluded = [
    "columnType"
];
function $15c8e448643b1144$var$ColGroup(_ref) {
    var colWidths = _ref.colWidths, columns = _ref.columns, columCount = _ref.columCount;
    var cols = [];
    var len = columCount || columns.length; // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    var mustInsert = false;
    for(var i = len - 1; i >= 0; i -= 1){
        var width = colWidths[i];
        var column = columns && columns[i];
        var additionalProps = column && column[0, $aLkKv.INTERNAL_COL_DEFINE];
        if (width || additionalProps || mustInsert) {
            var _ref2 = additionalProps || {}, columnType = _ref2.columnType, restAdditionalProps = (0, $9X7IJ.default)(_ref2, $15c8e448643b1144$var$_excluded);
            cols.unshift(/*#__PURE__*/ $acw62.createElement("col", (0, $8nd05.default)({
                key: i,
                style: {
                    width: width
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return /*#__PURE__*/ $acw62.createElement("colgroup", null, cols);
}
var $15c8e448643b1144$export$2e2bcd8739ae039 = $15c8e448643b1144$var$ColGroup;

});

parcelRegister("iElZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93d063ef9e8de8a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d93d063ef9e8de8a$var$Panel(_ref) {
    var className = _ref.className, children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className
    }, children);
}
var $d93d063ef9e8de8a$export$2e2bcd8739ae039 = $d93d063ef9e8de8a$var$Panel;

});

parcelRegister("64oV2", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b6722da5e5f96e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FooterComponents", () => $46b6722da5e5f96e$export$d605f3af09eef683);

var $acw62 = parcelRequire("acw62");

var $2ZuUE = parcelRequire("2ZuUE");

var $cdWrX = parcelRequire("cdWrX");

var $5SF8e = parcelRequire("5SF8e");
function $46b6722da5e5f96e$var$Footer(_ref) {
    var children = _ref.children, stickyOffsets = _ref.stickyOffsets, flattenColumns = _ref.flattenColumns;
    var tableContext = $acw62.useContext((0, $2ZuUE.default));
    var prefixCls = tableContext.prefixCls;
    var lastColumnIndex = flattenColumns.length - 1;
    var scrollColumn = flattenColumns[lastColumnIndex];
    var summaryContext = $acw62.useMemo(function() {
        return {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: (scrollColumn === null || scrollColumn === void 0 ? void 0 : scrollColumn.scrollbar) ? lastColumnIndex : null
        };
    }, [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $5SF8e.default).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $acw62.createElement("tfoot", {
        className: "".concat(prefixCls, "-summary")
    }, children));
}
var $46b6722da5e5f96e$export$2e2bcd8739ae039 = $46b6722da5e5f96e$var$Footer;
var $46b6722da5e5f96e$export$d605f3af09eef683 = (0, $cdWrX.default);

});
parcelRegister("cdWrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6409dc82717fb8$export$2e2bcd8739ae039);

var $13T4z = parcelRequire("13T4z");

var $d8vHj = parcelRequire("d8vHj");
/**
 * Syntactic sugar. Do not support HOC.
 */ function $8e6409dc82717fb8$var$Summary(_ref) {
    var children = _ref.children;
    return children;
}
$8e6409dc82717fb8$var$Summary.Row = (0, $d8vHj.default);
$8e6409dc82717fb8$var$Summary.Cell = (0, $13T4z.default);
var $8e6409dc82717fb8$export$2e2bcd8739ae039 = $8e6409dc82717fb8$var$Summary;

});
parcelRegister("13T4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c60ca8e95ee6d31$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $5SF8e = parcelRequire("5SF8e");

var $3XT7t = parcelRequire("3XT7t");

var $2ZuUE = parcelRequire("2ZuUE");

var $791o7 = parcelRequire("791o7");
function $0c60ca8e95ee6d31$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, index = _ref.index, children = _ref.children, _ref$colSpan = _ref.colSpan, colSpan = _ref$colSpan === void 0 ? 1 : _ref$colSpan, rowSpan = _ref.rowSpan, align = _ref.align;
    var _React$useContext = $acw62.useContext((0, $2ZuUE.default)), prefixCls = _React$useContext.prefixCls, direction = _React$useContext.direction;
    var _React$useContext2 = $acw62.useContext((0, $5SF8e.default)), scrollColumnIndex = _React$useContext2.scrollColumnIndex, stickyOffsets = _React$useContext2.stickyOffsets, flattenColumns = _React$useContext2.flattenColumns;
    var lastIndex = index + colSpan - 1;
    var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    var fixedInfo = (0, $791o7.getCellFixedInfo)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets, direction);
    return /*#__PURE__*/ $acw62.createElement((0, $3XT7t.default), (0, $8nd05.default)({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: function render() {
            return children;
        }
    }, fixedInfo));
}

});
parcelRegister("5SF8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4481e6c8f03a9146$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4481e6c8f03a9146$var$SummaryContext = /*#__PURE__*/ $acw62.createContext({});
var $4481e6c8f03a9146$export$2e2bcd8739ae039 = $4481e6c8f03a9146$var$SummaryContext;

});


parcelRegister("d8vHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $99049c316d79d591$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");
var $99049c316d79d591$var$_excluded = [
    "children"
];
function $99049c316d79d591$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $9X7IJ.default)(_ref, $99049c316d79d591$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement("tr", props, children);
}

});



parcelRegister("cr0i5", function(module, exports) {

$parcel$export(module.exports, "renderExpandIcon", () => $90d83b5d8e78c871$export$ae14373a7f810e33);
$parcel$export(module.exports, "findAllChildrenKeys", () => $90d83b5d8e78c871$export$49bec56f6055f375);

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
function $90d83b5d8e78c871$export$ae14373a7f810e33(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, record = _ref.record, onExpand = _ref.onExpand, expanded = _ref.expanded, expandable = _ref.expandable;
    var expandClassName = "".concat(prefixCls, "-row-expand-icon");
    if (!expandable) return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
    var onClick = function onClick(event) {
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(expandClassName, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _classNames)),
        onClick: onClick
    });
}
function $90d83b5d8e78c871$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    var keys = [];
    function dig(list) {
        (list || []).forEach(function(item, index) {
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}

});

parcelRegister("7Rtk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b943abb988e72b5$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $IzXpF = parcelRequire("IzXpF");

var $2SjmF = parcelRequire("2SjmF");

var $8g1PZ = parcelRequire("8g1PZ");

var $hvJC5 = parcelRequire("hvJC5");

var $2ZuUE = parcelRequire("2ZuUE");

var $cnAwI = parcelRequire("cnAwI");
var $5b943abb988e72b5$var$StickyScrollBar = function StickyScrollBar(_ref, ref) {
    var _scrollBodyRef$curren, _scrollBodyRef$curren2;
    var scrollBodyRef = _ref.scrollBodyRef, onScroll = _ref.onScroll, offsetScroll = _ref.offsetScroll, container = _ref.container;
    var _React$useContext = $acw62.useContext((0, $2ZuUE.default)), prefixCls = _React$useContext.prefixCls;
    var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
    var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
    var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    var scrollBarRef = $acw62.useRef();
    var _useLayoutState = (0, $cnAwI.useLayoutState)({
        scrollLeft: 0,
        isHiddenScrollBar: false
    }), _useLayoutState2 = (0, $eUqlC.default)(_useLayoutState, 2), scrollState = _useLayoutState2[0], setScrollState = _useLayoutState2[1];
    var refState = $acw62.useRef({
        delta: 0,
        x: 0
    });
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), isActive = _React$useState2[0], setActive = _React$useState2[1];
    var onMouseUp = function onMouseUp() {
        setActive(false);
    };
    var onMouseDown = function onMouseDown(event) {
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    var onMouseMove = function onMouseMove(event) {
        var _window;
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event), buttons = _ref2.buttons;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        if (left <= 0) left = 0;
        if (left + scrollBarWidth >= bodyWidth) left = bodyWidth - scrollBarWidth;
        onScroll({
            scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
        });
        refState.current.x = event.pageX;
    };
    var onContainerScroll = function onContainerScroll() {
        if (!scrollBodyRef.current) return;
        var tableOffsetTop = (0, $hvJC5.getOffset)(scrollBodyRef.current).top;
        var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
        var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $hvJC5.getOffset)(container).top + container.clientHeight;
        if (tableBottomOffset - (0, $2SjmF.default)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState(function(state) {
            return (0, $d49SP.default)((0, $d49SP.default)({}, state), {}, {
                isHiddenScrollBar: true
            });
        });
        else setScrollState(function(state) {
            return (0, $d49SP.default)((0, $d49SP.default)({}, state), {}, {
                isHiddenScrollBar: false
            });
        });
    };
    var setScrollLeft = function setScrollLeft(left) {
        setScrollState(function(state) {
            return (0, $d49SP.default)((0, $d49SP.default)({}, state), {}, {
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            });
        });
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            setScrollLeft: setScrollLeft
        };
    });
    $acw62.useEffect(function() {
        var onMouseUpListener = (0, $IzXpF.default)(document.body, 'mouseup', onMouseUp, false);
        var onMouseMoveListener = (0, $IzXpF.default)(document.body, 'mousemove', onMouseMove, false);
        onContainerScroll();
        return function() {
            onMouseUpListener.remove();
            onMouseMoveListener.remove();
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    $acw62.useEffect(function() {
        var onScrollListener = (0, $IzXpF.default)(container, 'scroll', onContainerScroll, false);
        var onResizeListener = (0, $IzXpF.default)(window, 'resize', onContainerScroll, false);
        return function() {
            onScrollListener.remove();
            onResizeListener.remove();
        };
    }, [
        container
    ]);
    $acw62.useEffect(function() {
        if (!scrollState.isHiddenScrollBar) setScrollState(function(state) {
            var bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return (0, $d49SP.default)((0, $d49SP.default)({}, state), {}, {
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            });
        });
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            height: (0, $2SjmF.default)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: "".concat(prefixCls, "-sticky-scroll")
    }, /*#__PURE__*/ $acw62.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-sticky-scroll-bar"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
        style: {
            width: "".concat(scrollBarWidth, "px"),
            transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
        }
    }));
};
var $5b943abb988e72b5$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($5b943abb988e72b5$var$StickyScrollBar);

});
parcelRegister("hvJC5", function(module, exports) {

$parcel$export(module.exports, "getOffset", () => $cbf8b6c8fd246421$export$622cea445a1c5b7d);
/* eslint-disable no-nested-ternary */ var $cbf8b6c8fd246421$var$PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var $cbf8b6c8fd246421$var$removePixel = {
    left: true,
    top: true
};
var $cbf8b6c8fd246421$var$floatMap = {
    cssFloat: 1,
    styleFloat: 1,
    float: 1
};
function $cbf8b6c8fd246421$var$getComputedStyle(node) {
    return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function $cbf8b6c8fd246421$var$getStyleValue(node, type, value) {
    type = type.toLowerCase();
    if (value === 'auto') {
        if (type === 'height') return node.offsetHeight;
        if (type === 'width') return node.offsetWidth;
    }
    if (!(type in $cbf8b6c8fd246421$var$removePixel)) $cbf8b6c8fd246421$var$removePixel[type] = $cbf8b6c8fd246421$var$PIXEL_PATTERN.test(type);
    return $cbf8b6c8fd246421$var$removePixel[type] ? parseFloat(value) || 0 : value;
}
function $cbf8b6c8fd246421$export$3988ae62b71be9a3(node, name) {
    var length = arguments.length;
    var style = $cbf8b6c8fd246421$var$getComputedStyle(node);
    name = $cbf8b6c8fd246421$var$floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
    return length === 1 ? style : $cbf8b6c8fd246421$var$getStyleValue(node, name, style[name] || node.style[name]);
}
function $cbf8b6c8fd246421$export$adaa4cf7ef1b65be(node, name, value) {
    var length = arguments.length;
    name = $cbf8b6c8fd246421$var$floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
    if (length === 3) {
        if (typeof value === 'number' && $cbf8b6c8fd246421$var$PIXEL_PATTERN.test(name)) value = "".concat(value, "px");
        node.style[name] = value; // Number
        return value;
    }
    for(var x in name)if (name.hasOwnProperty(x)) $cbf8b6c8fd246421$export$adaa4cf7ef1b65be(node, x, name[x]);
    return $cbf8b6c8fd246421$var$getComputedStyle(node);
}
function $cbf8b6c8fd246421$export$18e9b0709c75d4c5(el) {
    if (el === document.body) return document.documentElement.clientWidth;
    return el.offsetWidth;
}
function $cbf8b6c8fd246421$export$3ef1368fc1aa92de(el) {
    if (el === document.body) return window.innerHeight || document.documentElement.clientHeight;
    return el.offsetHeight;
}
function $cbf8b6c8fd246421$export$fddbd22e9c622ca7() {
    var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
    var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    return {
        width: width,
        height: height
    };
}
function $cbf8b6c8fd246421$export$1feb45891927fcb4() {
    var width = document.documentElement.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
}
function $cbf8b6c8fd246421$export$ff41c598de81c14a() {
    return {
        scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
        scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    };
}
function $cbf8b6c8fd246421$export$622cea445a1c5b7d(node) {
    var box = node.getBoundingClientRect();
    var docElem = document.documentElement;
    // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}

});


parcelRegister("hmojQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca375aff0d5eb2f7$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");

var $h4v51 = parcelRequire("h4v51");
var $ca375aff0d5eb2f7$var$defaultContainer = (0, $h4v51.default)() ? window : null;
function $ca375aff0d5eb2f7$export$2e2bcd8739ae039(sticky, prefixCls) {
    var _ref = (0, $fSwVM.default)(sticky) === 'object' ? sticky : {}, _ref$offsetHeader = _ref.offsetHeader, offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader, _ref$offsetSummary = _ref.offsetSummary, offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary, _ref$offsetScroll = _ref.offsetScroll, offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll, _ref$getContainer = _ref.getContainer, getContainer = _ref$getContainer === void 0 ? function() {
        return $ca375aff0d5eb2f7$var$defaultContainer;
    } : _ref$getContainer;
    var container = getContainer() || $ca375aff0d5eb2f7$var$defaultContainer;
    return $acw62.useMemo(function() {
        var isSticky = !!sticky;
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-holder") : '',
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}

});

parcelRegister("jwTbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37bd13d64da95ca$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $1RXuN = parcelRequire("1RXuN");

var $2ZuUE = parcelRequire("2ZuUE");
var $e37bd13d64da95ca$var$_excluded = [
    "className",
    "noData",
    "columns",
    "flattenColumns",
    "colWidths",
    "columCount",
    "stickyOffsets",
    "direction",
    "fixHeader",
    "stickyTopOffset",
    "stickyBottomOffset",
    "stickyClassName",
    "onScroll",
    "maxContentScroll",
    "children"
];
function $e37bd13d64da95ca$var$useColumnWidth(colWidths, columCount) {
    return (0, $acw62.useMemo)(function() {
        var cloneColumns = [];
        for(var i = 0; i < columCount; i += 1){
            var val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join('_'),
        columCount
    ]);
}
var $e37bd13d64da95ca$var$FixedHolder = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var className = _ref.className, noData = _ref.noData, columns = _ref.columns, flattenColumns = _ref.flattenColumns, colWidths = _ref.colWidths, columCount = _ref.columCount, stickyOffsets = _ref.stickyOffsets, direction = _ref.direction, fixHeader = _ref.fixHeader, stickyTopOffset = _ref.stickyTopOffset, stickyBottomOffset = _ref.stickyBottomOffset, stickyClassName = _ref.stickyClassName, onScroll = _ref.onScroll, maxContentScroll = _ref.maxContentScroll, children = _ref.children, props = (0, $9X7IJ.default)(_ref, $e37bd13d64da95ca$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $2ZuUE.default)), prefixCls = _React$useContext.prefixCls, scrollbarSize = _React$useContext.scrollbarSize, isSticky = _React$useContext.isSticky;
    var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize; // Pass wheel to scroll event
    var scrollRef = $acw62.useRef(null);
    var setScrollRef = $acw62.useCallback(function(element) {
        (0, $85dLH.fillRef)(ref, element);
        (0, $85dLH.fillRef)(scrollRef, element);
    }, []);
    $acw62.useEffect(function() {
        var _scrollRef$current;
        function onWheel(e) {
            var currentTarget = e.currentTarget, deltaX = e.deltaX;
            if (deltaX) {
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: currentTarget.scrollLeft + deltaX
                });
                e.preventDefault();
            }
        }
        (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.addEventListener('wheel', onWheel);
        return function() {
            var _scrollRef$current2;
            (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 || _scrollRef$current2.removeEventListener('wheel', onWheel);
        };
    }, []); // Check if all flattenColumns has width
    var allFlattenColumnsWithWidth = $acw62.useMemo(function() {
        return flattenColumns.every(function(column) {
            return column.width >= 0;
        });
    }, [
        flattenColumns
    ]); // Add scrollbar column
    var lastColumn = flattenColumns[flattenColumns.length - 1];
    var ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: function onHeaderCell() {
            return {
                className: "".concat(prefixCls, "-cell-scrollbar")
            };
        }
    };
    var columnsWithScrollbar = (0, $acw62.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $kbxxf.default)(columns), [
            ScrollBarColumn
        ]) : columns;
    }, [
        combinationScrollBarSize,
        columns
    ]);
    var flattenColumnsWithScrollbar = (0, $acw62.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $kbxxf.default)(flattenColumns), [
            ScrollBarColumn
        ]) : flattenColumns;
    }, [
        combinationScrollBarSize,
        flattenColumns
    ]); // Calculate the sticky offsets
    var headerStickyOffsets = (0, $acw62.useMemo)(function() {
        var right = stickyOffsets.right, left = stickyOffsets.left;
        return (0, $d49SP.default)((0, $d49SP.default)({}, stickyOffsets), {}, {
            left: direction === 'rtl' ? [].concat((0, $kbxxf.default)(left.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]) : left,
            right: direction === 'rtl' ? right : [].concat((0, $kbxxf.default)(right.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]),
            isSticky: isSticky
        });
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    var mergedColumnWidth = $e37bd13d64da95ca$var$useColumnWidth(colWidths, columCount);
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: (0, $d49SP.default)({
            overflow: 'hidden'
        }, isSticky ? {
            top: stickyTopOffset,
            bottom: stickyBottomOffset
        } : {}),
        ref: setScrollRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, (0, $kSlfw.default)({}, stickyClassName, !!stickyClassName))
    }, /*#__PURE__*/ $acw62.createElement("table", {
        style: {
            tableLayout: 'fixed',
            visibility: noData || mergedColumnWidth ? null : 'hidden'
        }
    }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /*#__PURE__*/ $acw62.createElement((0, $1RXuN.default), {
        colWidths: mergedColumnWidth ? [].concat((0, $kbxxf.default)(mergedColumnWidth), [
            combinationScrollBarSize
        ]) : [],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children((0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    }))));
});
$e37bd13d64da95ca$var$FixedHolder.displayName = 'FixedHolder';
var $e37bd13d64da95ca$export$2e2bcd8739ae039 = $e37bd13d64da95ca$var$FixedHolder;

});



parcelRegister("kERhB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("2Hl7n")).default);

var $2Hl7n = parcelRequire("2Hl7n");

});
parcelRegister("2Hl7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6ffa8a107637fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $7VWT2 = parcelRequire("7VWT2");

var $lWlBS = parcelRequire("lWlBS");

var $7zAwX = parcelRequire("7zAwX");

var $f5Jy1 = parcelRequire("f5Jy1");
function $1f6ffa8a107637fc$var$noop() {}
function $1f6ffa8a107637fc$var$isInteger(v) {
    var value = Number(v);
    return(// eslint-disable-next-line no-restricted-globals
    typeof value === 'number' && !isNaN(value) && isFinite(value) && Math.floor(value) === value);
}
function $1f6ffa8a107637fc$var$defaultItemRender(page, type, element) {
    return element;
}
function $1f6ffa8a107637fc$var$calculatePage(p, state, props) {
    var pageSize = typeof p === 'undefined' ? state.pageSize : p;
    return Math.floor((props.total - 1) / pageSize) + 1;
}
var $1f6ffa8a107637fc$var$Pagination = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Pagination, _React$Component);
    var _super = (0, $enfmq.default)(Pagination);
    function Pagination(props) {
        var _this;
        (0, $6CZeq.default)(this, Pagination);
        _this = _super.call(this, props);
        _this.getJumpPrevPage = function() {
            return Math.max(1, _this.state.current - (_this.props.showLessItems ? 3 : 5));
        };
        _this.getJumpNextPage = function() {
            return Math.min($1f6ffa8a107637fc$var$calculatePage(undefined, _this.state, _this.props), _this.state.current + (_this.props.showLessItems ? 3 : 5));
        };
        _this.getItemIcon = function(icon, label) {
            var prefixCls = _this.props.prefixCls;
            var iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                "aria-label": label,
                className: "".concat(prefixCls, "-item-link")
            });
            if (typeof icon === 'function') iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(icon, (0, $d49SP.default)({}, _this.props));
            return iconNode;
        };
        _this.savePaginationNode = function(node) {
            _this.paginationNode = node;
        };
        _this.isValid = function(page) {
            var total = _this.props.total;
            return $1f6ffa8a107637fc$var$isInteger(page) && page !== _this.state.current && $1f6ffa8a107637fc$var$isInteger(total) && total > 0;
        };
        _this.shouldDisplayQuickJumper = function() {
            var _this$props = _this.props, showQuickJumper = _this$props.showQuickJumper, total = _this$props.total;
            var pageSize = _this.state.pageSize;
            if (total <= pageSize) return false;
            return showQuickJumper;
        };
        _this.handleKeyDown = function(e) {
            if (e.keyCode === (0, $7zAwX.default).ARROW_UP || e.keyCode === (0, $7zAwX.default).ARROW_DOWN) e.preventDefault();
        };
        _this.handleKeyUp = function(e) {
            var value = _this.getValidValue(e);
            var currentInputValue = _this.state.currentInputValue;
            if (value !== currentInputValue) _this.setState({
                currentInputValue: value
            });
            if (e.keyCode === (0, $7zAwX.default).ENTER) _this.handleChange(value);
            else if (e.keyCode === (0, $7zAwX.default).ARROW_UP) _this.handleChange(value - 1);
            else if (e.keyCode === (0, $7zAwX.default).ARROW_DOWN) _this.handleChange(value + 1);
        };
        _this.handleBlur = function(e) {
            var value = _this.getValidValue(e);
            _this.handleChange(value);
        };
        _this.changePageSize = function(size) {
            var current = _this.state.current;
            var newCurrent = $1f6ffa8a107637fc$var$calculatePage(size, _this.state, _this.props);
            current = current > newCurrent ? newCurrent : current;
            // fix the issue:
            // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
            if (newCurrent === 0) // eslint-disable-next-line prefer-destructuring
            current = _this.state.current;
            if (typeof size === 'number') {
                if (!('pageSize' in _this.props)) _this.setState({
                    pageSize: size
                });
                if (!('current' in _this.props)) _this.setState({
                    current: current,
                    currentInputValue: current
                });
            }
            _this.props.onShowSizeChange(current, size);
            if ('onChange' in _this.props && _this.props.onChange) _this.props.onChange(current, size);
        };
        _this.handleChange = function(page) {
            var _this$props2 = _this.props, disabled = _this$props2.disabled, onChange = _this$props2.onChange;
            var _this$state = _this.state, pageSize = _this$state.pageSize, current = _this$state.current, currentInputValue = _this$state.currentInputValue;
            if (_this.isValid(page) && !disabled) {
                var currentPage = $1f6ffa8a107637fc$var$calculatePage(undefined, _this.state, _this.props);
                var newPage = page;
                if (page > currentPage) newPage = currentPage;
                else if (page < 1) newPage = 1;
                if (!('current' in _this.props)) _this.setState({
                    current: newPage
                });
                if (newPage !== currentInputValue) _this.setState({
                    currentInputValue: newPage
                });
                onChange(newPage, pageSize);
                return newPage;
            }
            return current;
        };
        _this.prev = function() {
            if (_this.hasPrev()) _this.handleChange(_this.state.current - 1);
        };
        _this.next = function() {
            if (_this.hasNext()) _this.handleChange(_this.state.current + 1);
        };
        _this.jumpPrev = function() {
            _this.handleChange(_this.getJumpPrevPage());
        };
        _this.jumpNext = function() {
            _this.handleChange(_this.getJumpNextPage());
        };
        _this.hasPrev = function() {
            return _this.state.current > 1;
        };
        _this.hasNext = function() {
            return _this.state.current < $1f6ffa8a107637fc$var$calculatePage(undefined, _this.state, _this.props);
        };
        _this.runIfEnter = function(event, callback) {
            if (event.key === 'Enter' || event.charCode === 13) {
                for(var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restParams[_key - 2] = arguments[_key];
                callback.apply(void 0, restParams);
            }
        };
        _this.runIfEnterPrev = function(e) {
            _this.runIfEnter(e, _this.prev);
        };
        _this.runIfEnterNext = function(e) {
            _this.runIfEnter(e, _this.next);
        };
        _this.runIfEnterJumpPrev = function(e) {
            _this.runIfEnter(e, _this.jumpPrev);
        };
        _this.runIfEnterJumpNext = function(e) {
            _this.runIfEnter(e, _this.jumpNext);
        };
        _this.handleGoTO = function(e) {
            if (e.keyCode === (0, $7zAwX.default).ENTER || e.type === 'click') _this.handleChange(_this.state.currentInputValue);
        };
        var hasOnChange = props.onChange !== $1f6ffa8a107637fc$var$noop;
        var hasCurrent = 'current' in props;
        if (hasCurrent && !hasOnChange) // eslint-disable-next-line no-console
        console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.');
        var _current = props.defaultCurrent;
        if ('current' in props) // eslint-disable-next-line prefer-destructuring
        _current = props.current;
        var _pageSize = props.defaultPageSize;
        if ('pageSize' in props) // eslint-disable-next-line prefer-destructuring
        _pageSize = props.pageSize;
        _current = Math.min(_current, $1f6ffa8a107637fc$var$calculatePage(_pageSize, undefined, props));
        _this.state = {
            current: _current,
            currentInputValue: _current,
            pageSize: _pageSize
        };
        return _this;
    }
    (0, $cHPF9.default)(Pagination, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // When current page change, fix focused style of prev item
                // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
                var prefixCls = this.props.prefixCls;
                if (prevState.current !== this.state.current && this.paginationNode) {
                    var lastCurrentNode = this.paginationNode.querySelector(".".concat(prefixCls, "-item-").concat(prevState.current));
                    if (lastCurrentNode && document.activeElement === lastCurrentNode) lastCurrentNode.blur();
                }
            }
        },
        {
            key: "getValidValue",
            value: function getValidValue(e) {
                var inputValue = e.target.value;
                var allPages = $1f6ffa8a107637fc$var$calculatePage(undefined, this.state, this.props);
                var currentInputValue = this.state.currentInputValue;
                var value;
                if (inputValue === '') value = inputValue;
                else if (isNaN(Number(inputValue))) value = currentInputValue;
                else if (inputValue >= allPages) value = allPages;
                else value = Number(inputValue);
                return value;
            }
        },
        {
            key: "getShowSizeChanger",
            value: function getShowSizeChanger() {
                var _this$props3 = this.props, showSizeChanger = _this$props3.showSizeChanger, total = _this$props3.total, totalBoundaryShowSizeChanger = _this$props3.totalBoundaryShowSizeChanger;
                if (typeof showSizeChanger !== 'undefined') return showSizeChanger;
                return total > totalBoundaryShowSizeChanger;
            }
        },
        {
            key: "renderPrev",
            value: function renderPrev(prevPage) {
                var _this$props4 = this.props, prevIcon = _this$props4.prevIcon, itemRender = _this$props4.itemRender;
                var prevButton = itemRender(prevPage, 'prev', this.getItemIcon(prevIcon, 'prev page'));
                var disabled = !this.hasPrev();
                return /*#__PURE__*/ (0, $acw62.isValidElement)(prevButton) ? /*#__PURE__*/ (0, $acw62.cloneElement)(prevButton, {
                    disabled: disabled
                }) : prevButton;
            }
        },
        {
            key: "renderNext",
            value: function renderNext(nextPage) {
                var _this$props5 = this.props, nextIcon = _this$props5.nextIcon, itemRender = _this$props5.itemRender;
                var nextButton = itemRender(nextPage, 'next', this.getItemIcon(nextIcon, 'next page'));
                var disabled = !this.hasNext();
                return /*#__PURE__*/ (0, $acw62.isValidElement)(nextButton) ? /*#__PURE__*/ (0, $acw62.cloneElement)(nextButton, {
                    disabled: disabled
                }) : nextButton;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props6 = this.props, prefixCls = _this$props6.prefixCls, className = _this$props6.className, style = _this$props6.style, disabled = _this$props6.disabled, hideOnSinglePage = _this$props6.hideOnSinglePage, total = _this$props6.total, locale = _this$props6.locale, showQuickJumper = _this$props6.showQuickJumper, showLessItems = _this$props6.showLessItems, showTitle = _this$props6.showTitle, showTotal = _this$props6.showTotal, simple = _this$props6.simple, itemRender = _this$props6.itemRender, showPrevNextJumpers = _this$props6.showPrevNextJumpers, jumpPrevIcon = _this$props6.jumpPrevIcon, jumpNextIcon = _this$props6.jumpNextIcon, selectComponentClass = _this$props6.selectComponentClass, selectPrefixCls = _this$props6.selectPrefixCls, pageSizeOptions = _this$props6.pageSizeOptions;
                var _this$state2 = this.state, current = _this$state2.current, pageSize = _this$state2.pageSize, currentInputValue = _this$state2.currentInputValue;
                // When hideOnSinglePage is true and there is only 1 page, hide the pager
                if (hideOnSinglePage === true && total <= pageSize) return null;
                var allPages = $1f6ffa8a107637fc$var$calculatePage(undefined, this.state, this.props);
                var pagerList = [];
                var jumpPrev = null;
                var jumpNext = null;
                var firstPager = null;
                var lastPager = null;
                var gotoButton = null;
                var goButton = showQuickJumper && showQuickJumper.goButton;
                var pageBufferSize = showLessItems ? 1 : 2;
                var prevPage = current - 1 > 0 ? current - 1 : 0;
                var nextPage = current + 1 < allPages ? current + 1 : allPages;
                var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(prev, key) {
                    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') // eslint-disable-next-line no-param-reassign
                    prev[key] = _this2.props[key];
                    return prev;
                }, {});
                var totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    className: "".concat(prefixCls, "-total-text")
                }, showTotal(total, [
                    total === 0 ? 0 : (current - 1) * pageSize + 1,
                    current * pageSize > total ? total : current * pageSize
                ]));
                if (simple) {
                    if (goButton) {
                        if (typeof goButton === 'boolean') gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                            type: "button",
                            onClick: this.handleGoTO,
                            onKeyUp: this.handleGoTO
                        }, locale.jump_to_confirm);
                        else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            onClick: this.handleGoTO,
                            onKeyUp: this.handleGoTO
                        }, goButton);
                        gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                            title: showTitle ? "".concat(locale.jump_to).concat(current, "/").concat(allPages) : null,
                            className: "".concat(prefixCls, "-simple-pager")
                        }, gotoButton);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", (0, $8nd05.default)({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-simple"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), disabled), className),
                        style: style,
                        ref: this.savePaginationNode
                    }, dataOrAriaAttributeProps), totalText, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        title: showTitle ? locale.prev_page : null,
                        onClick: this.prev,
                        tabIndex: this.hasPrev() ? 0 : null,
                        onKeyPress: this.runIfEnterPrev,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-prev"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), !this.hasPrev())),
                        "aria-disabled": !this.hasPrev()
                    }, this.renderPrev(prevPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        title: showTitle ? "".concat(current, "/").concat(allPages) : null,
                        className: "".concat(prefixCls, "-simple-pager")
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        type: "text",
                        value: currentInputValue,
                        disabled: disabled,
                        onKeyDown: this.handleKeyDown,
                        onKeyUp: this.handleKeyUp,
                        onChange: this.handleKeyUp,
                        onBlur: this.handleBlur,
                        size: "3"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: "".concat(prefixCls, "-slash")
                    }, "/"), allPages), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        title: showTitle ? locale.next_page : null,
                        onClick: this.next,
                        tabIndex: this.hasPrev() ? 0 : null,
                        onKeyPress: this.runIfEnterNext,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-next"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), !this.hasNext())),
                        "aria-disabled": !this.hasNext()
                    }, this.renderNext(nextPage)), gotoButton);
                }
                if (allPages <= 3 + pageBufferSize * 2) {
                    var pagerProps = {
                        locale: locale,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        showTitle: showTitle,
                        itemRender: itemRender
                    };
                    if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7VWT2.default), (0, $8nd05.default)({}, pagerProps, {
                        key: "noPager",
                        page: 1,
                        className: "".concat(prefixCls, "-item-disabled")
                    })));
                    for(var i = 1; i <= allPages; i += 1){
                        var active = current === i;
                        pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7VWT2.default), (0, $8nd05.default)({}, pagerProps, {
                            key: i,
                            page: i,
                            active: active
                        })));
                    }
                } else {
                    var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
                    var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
                    if (showPrevNextJumpers) {
                        jumpPrev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                            title: showTitle ? prevItemTitle : null,
                            key: "prev",
                            onClick: this.jumpPrev,
                            tabIndex: "0",
                            onKeyPress: this.runIfEnterJumpPrev,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-jump-prev"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
                        }, itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(jumpPrevIcon, 'prev page')));
                        jumpNext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                            title: showTitle ? nextItemTitle : null,
                            key: "next",
                            tabIndex: "0",
                            onClick: this.jumpNext,
                            onKeyPress: this.runIfEnterJumpNext,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-jump-next"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
                        }, itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(jumpNextIcon, 'next page')));
                    }
                    lastPager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7VWT2.default), {
                        locale: locale,
                        last: true,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        key: allPages,
                        page: allPages,
                        active: false,
                        showTitle: showTitle,
                        itemRender: itemRender
                    });
                    firstPager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7VWT2.default), {
                        locale: locale,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        key: 1,
                        page: 1,
                        active: false,
                        showTitle: showTitle,
                        itemRender: itemRender
                    });
                    var left = Math.max(1, current - pageBufferSize);
                    var right = Math.min(current + pageBufferSize, allPages);
                    if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
                    if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
                    for(var _i = left; _i <= right; _i += 1){
                        var _active = current === _i;
                        pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7VWT2.default), {
                            locale: locale,
                            rootPrefixCls: prefixCls,
                            onClick: this.handleChange,
                            onKeyPress: this.runIfEnter,
                            key: _i,
                            page: _i,
                            active: _active,
                            showTitle: showTitle,
                            itemRender: itemRender
                        }));
                    }
                    if (current - 1 >= pageBufferSize * 2 && current !== 3) {
                        pagerList[0] = /*#__PURE__*/ (0, $acw62.cloneElement)(pagerList[0], {
                            className: "".concat(prefixCls, "-item-after-jump-prev")
                        });
                        pagerList.unshift(jumpPrev);
                    }
                    if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
                        pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, $acw62.cloneElement)(pagerList[pagerList.length - 1], {
                            className: "".concat(prefixCls, "-item-before-jump-next")
                        });
                        pagerList.push(jumpNext);
                    }
                    if (left !== 1) pagerList.unshift(firstPager);
                    if (right !== allPages) pagerList.push(lastPager);
                }
                var prevDisabled = !this.hasPrev() || !allPages;
                var nextDisabled = !this.hasNext() || !allPages;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", (0, $8nd05.default)({
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
                    style: style,
                    ref: this.savePaginationNode
                }, dataOrAriaAttributeProps), totalText, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    title: showTitle ? locale.prev_page : null,
                    onClick: this.prev,
                    tabIndex: prevDisabled ? null : 0,
                    onKeyPress: this.runIfEnterPrev,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-prev"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
                    "aria-disabled": prevDisabled
                }, this.renderPrev(prevPage)), pagerList, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    title: showTitle ? locale.next_page : null,
                    onClick: this.next,
                    tabIndex: nextDisabled ? null : 0,
                    onKeyPress: this.runIfEnterNext,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-next"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
                    "aria-disabled": nextDisabled
                }, this.renderNext(nextPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lWlBS.default), {
                    disabled: disabled,
                    locale: locale,
                    rootPrefixCls: prefixCls,
                    selectComponentClass: selectComponentClass,
                    selectPrefixCls: selectPrefixCls,
                    changeSize: this.getShowSizeChanger() ? this.changePageSize : null,
                    current: current,
                    pageSize: pageSize,
                    pageSizeOptions: pageSizeOptions,
                    quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
                    goButton: goButton
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, prevState) {
                var newState = {};
                if ('current' in props) {
                    newState.current = props.current;
                    if (props.current !== prevState.current) newState.currentInputValue = newState.current;
                }
                if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
                    var current = prevState.current;
                    var newCurrent = $1f6ffa8a107637fc$var$calculatePage(props.pageSize, prevState, props);
                    current = current > newCurrent ? newCurrent : current;
                    if (!('current' in props)) {
                        newState.current = current;
                        newState.currentInputValue = current;
                    }
                    newState.pageSize = props.pageSize;
                }
                return newState;
            }
        }
    ]);
    return Pagination;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$1f6ffa8a107637fc$var$Pagination.defaultProps = {
    defaultCurrent: 1,
    total: 0,
    defaultPageSize: 10,
    onChange: $1f6ffa8a107637fc$var$noop,
    className: '',
    selectPrefixCls: 'rc-select',
    prefixCls: 'rc-pagination',
    selectComponentClass: null,
    hideOnSinglePage: false,
    showPrevNextJumpers: true,
    showQuickJumper: false,
    showLessItems: false,
    showTitle: true,
    onShowSizeChange: $1f6ffa8a107637fc$var$noop,
    locale: (0, $f5Jy1.default),
    style: {},
    itemRender: $1f6ffa8a107637fc$var$defaultItemRender,
    totalBoundaryShowSizeChanger: 50
};
var $1f6ffa8a107637fc$export$2e2bcd8739ae039 = $1f6ffa8a107637fc$var$Pagination;

});
parcelRegister("7VWT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6b88f5a3018b73$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
var $5c6b88f5a3018b73$var$Pager = function Pager(props) {
    var _classNames;
    var prefixCls = "".concat(props.rootPrefixCls, "-item");
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-").concat(props.page), (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-active"), props.active), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-disabled"), !props.page), (0, $kSlfw.default)(_classNames, props.className, !!props.className), _classNames));
    var handleClick = function handleClick() {
        props.onClick(props.page);
    };
    var handleKeyPress = function handleKeyPress(e) {
        props.onKeyPress(e, props.onClick, props.page);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        title: props.showTitle ? props.page : null,
        className: cls,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        tabIndex: "0"
    }, props.itemRender(props.page, 'page', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        rel: "nofollow"
    }, props.page)));
};
var $5c6b88f5a3018b73$export$2e2bcd8739ae039 = $5c6b88f5a3018b73$var$Pager;

});

parcelRegister("lWlBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8fc702e2ff2e68$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $acw62 = parcelRequire("acw62");

var $7zAwX = parcelRequire("7zAwX");
var $ff8fc702e2ff2e68$var$Options = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Options, _React$Component);
    var _super = (0, $enfmq.default)(Options);
    function Options() {
        var _this;
        (0, $6CZeq.default)(this, Options);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            goInputText: ''
        };
        _this.buildOptionText = function(value) {
            return "".concat(value, " ").concat(_this.props.locale.items_per_page);
        };
        _this.changeSize = function(value) {
            _this.props.changeSize(Number(value));
        };
        _this.handleChange = function(e) {
            _this.setState({
                goInputText: e.target.value
            });
        };
        _this.handleBlur = function(e) {
            var _this$props = _this.props, goButton = _this$props.goButton, quickGo = _this$props.quickGo, rootPrefixCls = _this$props.rootPrefixCls;
            var goInputText = _this.state.goInputText;
            if (goButton || goInputText === '') return;
            _this.setState({
                goInputText: ''
            });
            if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) return;
            quickGo(_this.getValidValue());
        };
        _this.go = function(e) {
            var goInputText = _this.state.goInputText;
            if (goInputText === '') return;
            if (e.keyCode === (0, $7zAwX.default).ENTER || e.type === 'click') {
                _this.setState({
                    goInputText: ''
                });
                _this.props.quickGo(_this.getValidValue());
            }
        };
        return _this;
    }
    (0, $cHPF9.default)(Options, [
        {
            key: "getValidValue",
            value: function getValidValue() {
                var goInputText = this.state.goInputText;
                // eslint-disable-next-line no-restricted-globals
                return !goInputText || isNaN(goInputText) ? undefined : Number(goInputText);
            }
        },
        {
            key: "getPageSizeOptions",
            value: function getPageSizeOptions() {
                var _this$props2 = this.props, pageSize = _this$props2.pageSize, pageSizeOptions = _this$props2.pageSizeOptions;
                if (pageSizeOptions.some(function(option) {
                    return option.toString() === pageSize.toString();
                })) return pageSizeOptions;
                return pageSizeOptions.concat([
                    pageSize.toString()
                ]).sort(function(a, b) {
                    // eslint-disable-next-line no-restricted-globals
                    var numberA = isNaN(Number(a)) ? 0 : Number(a);
                    // eslint-disable-next-line no-restricted-globals
                    var numberB = isNaN(Number(b)) ? 0 : Number(b);
                    return numberA - numberB;
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, pageSize = _this$props3.pageSize, locale = _this$props3.locale, rootPrefixCls = _this$props3.rootPrefixCls, changeSize = _this$props3.changeSize, quickGo = _this$props3.quickGo, goButton = _this$props3.goButton, selectComponentClass = _this$props3.selectComponentClass, buildOptionText = _this$props3.buildOptionText, selectPrefixCls = _this$props3.selectPrefixCls, disabled = _this$props3.disabled;
                var goInputText = this.state.goInputText;
                var prefixCls = "".concat(rootPrefixCls, "-options");
                var Select = selectComponentClass;
                var changeSelect = null;
                var goInput = null;
                var gotoButton = null;
                if (!changeSize && !quickGo) return null;
                var pageSizeOptions = this.getPageSizeOptions();
                if (changeSize && Select) {
                    var options = pageSizeOptions.map(function(opt, i) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Select.Option, {
                            key: i,
                            value: opt.toString()
                        }, (buildOptionText || _this2.buildOptionText)(opt));
                    });
                    changeSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Select, {
                        disabled: disabled,
                        prefixCls: selectPrefixCls,
                        showSearch: false,
                        className: "".concat(prefixCls, "-size-changer"),
                        optionLabelProp: "children",
                        dropdownMatchSelectWidth: false,
                        value: (pageSize || pageSizeOptions[0]).toString(),
                        onChange: this.changeSize,
                        getPopupContainer: function getPopupContainer(triggerNode) {
                            return triggerNode.parentNode;
                        },
                        "aria-label": locale.page_size,
                        defaultOpen: false
                    }, options);
                }
                if (quickGo) {
                    if (goButton) gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                        type: "button",
                        onClick: this.go,
                        onKeyUp: this.go,
                        disabled: disabled,
                        className: "".concat(prefixCls, "-quick-jumper-button")
                    }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        onClick: this.go,
                        onKeyUp: this.go
                    }, goButton);
                    goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        className: "".concat(prefixCls, "-quick-jumper")
                    }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        disabled: disabled,
                        type: "text",
                        value: goInputText,
                        onChange: this.handleChange,
                        onKeyUp: this.go,
                        onBlur: this.handleBlur,
                        "aria-label": locale.page
                    }), locale.page, gotoButton);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    className: "".concat(prefixCls)
                }, changeSelect, goInput);
            }
        }
    ]);
    return Options;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ff8fc702e2ff2e68$var$Options.defaultProps = {
    pageSizeOptions: [
        '10',
        '20',
        '50',
        '100'
    ]
};
var $ff8fc702e2ff2e68$export$2e2bcd8739ae039 = $ff8fc702e2ff2e68$var$Options;

});
parcelRegister("7zAwX", function(module, exports) {

$parcel$export(module.exports, "default", () => $583823837df9c79a$export$2e2bcd8739ae039);
var $583823837df9c79a$export$2e2bcd8739ae039 = {
    ZERO: 48,
    NINE: 57,
    NUMPAD_ZERO: 96,
    NUMPAD_NINE: 105,
    BACKSPACE: 8,
    DELETE: 46,
    ENTER: 13,
    ARROW_UP: 38,
    ARROW_DOWN: 40
};

});


parcelRegister("f5Jy1", function(module, exports) {

$parcel$export(module.exports, "default", () => $afcaa77fb9a0c881$export$2e2bcd8739ae039);
var $afcaa77fb9a0c881$export$2e2bcd8739ae039 = {
    // Options.jsx
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination.jsx
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};

});



parcelRegister("iI6LB", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $9nn6T = parcelRequire("9nn6T");

var $iV4PZ = parcelRequire("iV4PZ");
/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $iV4PZ(wait) || 0;
    if ($lsJ54(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($iV4PZ(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $9nn6T();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($9nn6T());
    }
    function debounced() {
        var time = $9nn6T(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $d9f195cb3938646c$var$debounce;

});
parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});

parcelRegister("9nn6T", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
module.exports = $6d38303b9c8735ba$var$now;

});

parcelRegister("iV4PZ", function(module, exports) {

var $s0iWz = parcelRequire("s0iWz");

var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lsJ54(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $s0iWz(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
module.exports = $dc614d828223dea6$var$toNumber;

});
parcelRegister("s0iWz", function(module, exports) {

var $kzo8D = parcelRequire("kzo8D");
/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $kzo8D(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
module.exports = $0542da1d887b1c4d$var$baseTrim;

});
parcelRegister("kzo8D", function(module, exports) {
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ef99cce288c7323e$var$trimmedEndIndex;

});




parcelRegister("4UXHD", function(module, exports) {

var $abgWr = parcelRequire("abgWr");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $394ab417e9bd75cc$var$isEqual(value, other) {
    return $abgWr(value, other);
}
module.exports = $394ab417e9bd75cc$var$isEqual;

});
parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, 'Map');
module.exports = $19b02faa57603249$var$Map;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});

parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});



parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype['delete'] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $c8dKl,
        'map': new ($2cJKd || $iYOpJ),
        'string': new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, 'create');
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});

parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});
parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});


parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});


parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});


parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});




parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, 'DataView');
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, 'Promise');
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, 'Set');
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, 'WeakMap');
module.exports = $aedce50092a1e6a6$var$WeakMap;

});





parcelRegister("fAiwY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Checkbox", () => $b58897a741799cae$export$48513f6b9f8ce62d);
$parcel$export(module.exports, "default", () => $b58897a741799cae$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $iSQh8 = parcelRequire("iSQh8");

var $acw62 = parcelRequire("acw62");
var $b58897a741799cae$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "checked",
    "disabled",
    "defaultChecked",
    "type",
    "onChange"
];
var $b58897a741799cae$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-checkbox' : _props$prefixCls, className = props.className, style = props.style, checked = props.checked, disabled = props.disabled, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$type = props.type, type = _props$type === void 0 ? 'checkbox' : _props$type, onChange = props.onChange, inputProps = (0, $9X7IJ.default)(props, $b58897a741799cae$var$_excluded);
    var inputRef = (0, $acw62.useRef)(null);
    var _useMergedState = (0, $iSQh8.default)(defaultChecked, {
        value: checked
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), rawValue = _useMergedState2[0], setRawValue = _useMergedState2[1];
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            focus: function focus() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
            },
            blur: function blur() {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
            },
            input: inputRef.current
        };
    });
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-checked"), rawValue), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    var handleChange = function handleChange(e) {
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange === null || onChange === void 0 || onChange({
            target: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
                type: type,
                checked: e.target.checked
            }),
            stopPropagation: function stopPropagation() {
                e.stopPropagation();
            },
            preventDefault: function preventDefault() {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: classString,
        style: style
    }, /*#__PURE__*/ $acw62.createElement("input", (0, $8nd05.default)({}, inputProps, {
        className: "".concat(prefixCls, "-input"),
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }));
});
var $b58897a741799cae$export$2e2bcd8739ae039 = $b58897a741799cae$export$48513f6b9f8ce62d;

});

parcelRegister("jtXXN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e2ef3d42b101c489$export$2e2bcd8739ae039);

var $kzwHj = parcelRequire("kzwHj");
var $e2ef3d42b101c489$export$2e2bcd8739ae039 = (0, $kzwHj.default);

});
parcelRegister("kzwHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa0709bbe269de7$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $grQtM = parcelRequire("grQtM");

var $8g1PZ = parcelRequire("8g1PZ");

var $dfVFD = parcelRequire("dfVFD");

var $lKDdC = parcelRequire("lKDdC");
var $efa0709bbe269de7$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus"
];
function $efa0709bbe269de7$var$Dropdown(props, ref) {
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dropdown' : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottomLeft' : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $dfVFD.default) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, autoFocus = props.autoFocus, otherProps = (0, $9X7IJ.default)(props, $efa0709bbe269de7$var$_excluded);
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = 'visible' in props ? visible : triggerVisible;
    var triggerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    (0, $lKDdC.default)({
        visible: mergedVisible,
        setTriggerVisible: setTriggerVisible,
        triggerRef: triggerRef,
        onVisibleChange: props.onVisibleChange,
        autoFocus: autoFocus
    });
    var getOverlayElement = function getOverlayElement() {
        var overlay = props.overlay;
        var overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    };
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var onVisibleChange = function onVisibleChange(newVisible) {
        var onVisibleChangeProp = props.onVisibleChange;
        setTriggerVisible(newVisible);
        if (typeof onVisibleChangeProp === 'function') onVisibleChangeProp(newVisible);
    };
    var getMenuElement = function getMenuElement() {
        var overlayElement = getOverlayElement();
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, arrow && /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-arrow")
        }), overlayElement);
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        var overlay = props.overlay;
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var renderChildren = function renderChildren() {
        var children = props.children;
        var childrenProps = children.props ? children.props : {};
        var childClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(childrenProps.className, getOpenClassName());
        return mergedVisible && children ? /*#__PURE__*/ $acw62.cloneElement(children, {
            className: childClassName
        }) : children;
    };
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ $acw62.createElement((0, $grQtM.default), (0, $d49SP.default)((0, $d49SP.default)({
        builtinPlacements: placements
    }, otherProps), {}, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, (0, $kSlfw.default)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction || [],
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: onVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), renderChildren());
}
var $efa0709bbe269de7$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($efa0709bbe269de7$var$Dropdown);

});
parcelRegister("dfVFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a69693d1b18e39e$export$2e2bcd8739ae039);
var $9a69693d1b18e39e$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $9a69693d1b18e39e$var$targetOffset = [
    0,
    0
];
var $9a69693d1b18e39e$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    topCenter: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomCenter: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    }
};
var $9a69693d1b18e39e$export$2e2bcd8739ae039 = $9a69693d1b18e39e$var$placements;

});

parcelRegister("lKDdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd5c50d68a830e84$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iCi4s = parcelRequire("iCi4s");

var $dTiBu = parcelRequire("dTiBu");

var $77reW = parcelRequire("77reW");
var $fd5c50d68a830e84$var$ESC = (0, $iCi4s.default).ESC, $fd5c50d68a830e84$var$TAB = (0, $iCi4s.default).TAB;
function $fd5c50d68a830e84$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, setTriggerVisible = _ref.setTriggerVisible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus;
    var focusMenuRef = $acw62.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible && triggerRef.current) {
            var _triggerRef$current, _triggerRef$current$t, _triggerRef$current$t2, _triggerRef$current$t3;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$t = _triggerRef$current.triggerRef) === null || _triggerRef$current$t === void 0 || (_triggerRef$current$t2 = _triggerRef$current$t.current) === null || _triggerRef$current$t2 === void 0 || (_triggerRef$current$t3 = _triggerRef$current$t2.focus) === null || _triggerRef$current$t3 === void 0 || _triggerRef$current$t3.call(_triggerRef$current$t2);
            setTriggerVisible(false);
            if (typeof onVisibleChange === 'function') onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _triggerRef$current2, _triggerRef$current2$, _triggerRef$current2$2, _triggerRef$current2$3;
        var elements = (0, $77reW.getFocusNodeList)((_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : (_triggerRef$current2$ = _triggerRef$current2.popupRef) === null || _triggerRef$current2$ === void 0 ? void 0 : (_triggerRef$current2$2 = _triggerRef$current2$.current) === null || _triggerRef$current2$2 === void 0 ? void 0 : (_triggerRef$current2$3 = _triggerRef$current2$2.getElement) === null || _triggerRef$current2$3 === void 0 ? void 0 : _triggerRef$current2$3.call(_triggerRef$current2$2));
        var firstElement = elements[0];
        if (firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus) {
            firstElement.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $fd5c50d68a830e84$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $fd5c50d68a830e84$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $acw62.useEffect(function() {
        if (visible) {
            window.addEventListener('keydown', handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $dTiBu.default)(focusMenu, 3);
            return function() {
                window.removeEventListener('keydown', handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}

});
parcelRegister("77reW", function(module, exports) {

$parcel$export(module.exports, "getFocusNodeList", () => $52ee51206a0899df$export$bbc7b5f11aba534b);

var $kbxxf = parcelRequire("kbxxf");

var $7klNq = parcelRequire("7klNq");
function $52ee51206a0899df$var$focusable(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0, $7klNq.default)(node)) {
        var nodeName = node.nodeName.toLowerCase();
        var isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        var tabIndexAttr = node.getAttribute('tabindex');
        var tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        var tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $52ee51206a0899df$export$bbc7b5f11aba534b(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var res = (0, $kbxxf.default)(node.querySelectorAll('*')).filter(function(child) {
        return $52ee51206a0899df$var$focusable(child, includePositive);
    });
    if ($52ee51206a0899df$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
var $52ee51206a0899df$var$lastFocusElement = null;
function $52ee51206a0899df$export$79fea02f7a83293d() {
    $52ee51206a0899df$var$lastFocusElement = document.activeElement;
}
function $52ee51206a0899df$export$8785654047fe7352() {
    $52ee51206a0899df$var$lastFocusElement = null;
}
function $52ee51206a0899df$export$fac0a9974415d98f() {
    if ($52ee51206a0899df$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $52ee51206a0899df$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $52ee51206a0899df$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        var tabNodeList = $52ee51206a0899df$export$bbc7b5f11aba534b(node);
        var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}

});




parcelRegister("feYPt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b187593cf569a182$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SubMenu", () => (parcelRequire("gASnm")).default);
$parcel$export(module.exports, "Item", () => (parcelRequire("gXR8t")).default);
$parcel$export(module.exports, "MenuItem", () => (parcelRequire("gXR8t")).default);
$parcel$export(module.exports, "MenuItemGroup", () => (parcelRequire("9TcXG")).default);
$parcel$export(module.exports, "ItemGroup", () => (parcelRequire("9TcXG")).default);
$parcel$export(module.exports, "Divider", () => (parcelRequire("iPQJN")).default);
$parcel$export(module.exports, "useFullPath", () => (parcelRequire("a8XZl")).useFullPath);

var $gK11r = parcelRequire("gK11r");

var $gXR8t = parcelRequire("gXR8t");

var $gASnm = parcelRequire("gASnm");

var $9TcXG = parcelRequire("9TcXG");

var $a8XZl = parcelRequire("a8XZl");

var $iPQJN = parcelRequire("iPQJN");
var $b187593cf569a182$var$ExportMenu = (0, $gK11r.default);
$b187593cf569a182$var$ExportMenu.Item = (0, $gXR8t.default);
$b187593cf569a182$var$ExportMenu.SubMenu = (0, $gASnm.default);
$b187593cf569a182$var$ExportMenu.ItemGroup = (0, $9TcXG.default);
$b187593cf569a182$var$ExportMenu.Divider = (0, $iPQJN.default);
var $b187593cf569a182$export$2e2bcd8739ae039 = $b187593cf569a182$var$ExportMenu;

});
parcelRegister("gK11r", function(module, exports) {

$parcel$export(module.exports, "default", () => $c301bc30ecc557ca$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $6dkAu = parcelRequire("6dkAu");

var $iSQh8 = parcelRequire("iSQh8");
parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $4AFGH = parcelRequire("4AFGH");

var $dpnFa = parcelRequire("dpnFa");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");

var $iPTpg = parcelRequire("iPTpg");

var $8SYfi = parcelRequire("8SYfi");

var $cwnCS = parcelRequire("cwnCS");

var $lg5nd = parcelRequire("lg5nd");

var $8krl6 = parcelRequire("8krl6");

var $gXR8t = parcelRequire("gXR8t");

var $gASnm = parcelRequire("gASnm");

var $lvs07 = parcelRequire("lvs07");

var $1zp6Q = parcelRequire("1zp6Q");
var $c301bc30ecc557ca$var$_excluded = [
    "prefixCls",
    "rootClassName",
    "style",
    "className",
    "tabIndex",
    "items",
    "children",
    "direction",
    "id",
    "mode",
    "inlineCollapsed",
    "disabled",
    "disabledOverflow",
    "subMenuOpenDelay",
    "subMenuCloseDelay",
    "forceSubMenuRender",
    "defaultOpenKeys",
    "openKeys",
    "activeKey",
    "defaultActiveFirst",
    "selectable",
    "multiple",
    "defaultSelectedKeys",
    "selectedKeys",
    "onSelect",
    "onDeselect",
    "inlineIndent",
    "motion",
    "defaultMotions",
    "triggerSubMenuAction",
    "builtinPlacements",
    "itemIcon",
    "expandIcon",
    "overflowedIndicator",
    "overflowedIndicatorPopupClassName",
    "getPopupContainer",
    "onClick",
    "onOpenChange",
    "onKeyDown",
    "openAnimation",
    "openTransitionName",
    "_internalRenderMenuItem",
    "_internalRenderSubMenuItem"
];
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
var $c301bc30ecc557ca$var$EMPTY_LIST = [];
var $c301bc30ecc557ca$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _childList$, _classNames;
    var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-menu' : _ref$prefixCls, rootClassName = _ref.rootClassName, style = _ref.style, className = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'vertical' : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? 'hover' : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? '...' : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, restProps = (0, $9X7IJ.default)(_ref, $c301bc30ecc557ca$var$_excluded);
    var childList = $acw62.useMemo(function() {
        return (0, $lvs07.parseItems)(children, items, $c301bc30ecc557ca$var$EMPTY_LIST);
    }, [
        children,
        items
    ]);
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
    var containerRef = $acw62.useRef();
    var uuid = (0, $8krl6.default)(id);
    var isRtl = direction === 'rtl';
    // ========================= Open =========================
    var _useMergedState = (0, $iSQh8.default)(defaultOpenKeys, {
        value: openKeys,
        postState: function postState(keys) {
            return keys || $c301bc30ecc557ca$var$EMPTY_LIST;
        }
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    var triggerOpenKeys = function triggerOpenKeys(keys) {
        var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
        }
        if (forceFlush) (0, $1u0KT.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    var _React$useState3 = $acw62.useState(mergedOpenKeys), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
    var mountRef = $acw62.useRef(false);
    // ========================= Mode =========================
    var _React$useMemo = $acw62.useMemo(function() {
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), mergedMode = _React$useMemo2[0], mergedInlineCollapsed = _React$useMemo2[1];
    var isInlineMode = mergedMode === 'inline';
    var _React$useState5 = $acw62.useState(mergedMode), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
    var _React$useState7 = $acw62.useState(mergedInlineCollapsed), _React$useState8 = (0, $eUqlC.default)(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
    $acw62.useEffect(function() {
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($c301bc30ecc557ca$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    var _React$useState9 = $acw62.useState(0), _React$useState10 = (0, $eUqlC.default)(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
    var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $acw62.useEffect(function() {
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $acw62.useEffect(function() {
        mountRef.current = true;
        return function() {
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    var _useKeyRecords = (0, $cwnCS.default)(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
    var registerPathContext = $acw62.useMemo(function() {
        return {
            registerPath: registerPath,
            unregisterPath: unregisterPath
        };
    }, [
        registerPath,
        unregisterPath
    ]);
    var pathUserContext = $acw62.useMemo(function() {
        return {
            isSubPathKey: isSubPathKey
        };
    }, [
        isSubPathKey
    ]);
    $acw62.useEffect(function() {
        refreshOverflowKeys(allVisible ? $c301bc30ecc557ca$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function(child) {
            return child.key;
        }));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    var _useMergedState3 = (0, $iSQh8.default)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
        value: activeKey
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
    var onActive = (0, $lg5nd.default)(function(key) {
        setMergedActiveKey(key);
    });
    var onInactive = (0, $lg5nd.default)(function() {
        setMergedActiveKey(undefined);
    });
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            list: containerRef.current,
            focus: function focus(options) {
                var _childList$find;
                var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : (_childList$find = childList.find(function(node) {
                    return !node.props.disabled;
                })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
                if (shouldFocusKey) {
                    var _containerRef$current, _containerRef$current2, _containerRef$current3;
                    (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current2 = _containerRef$current.querySelector("li[data-menu-id='".concat((0, $dpnFa.getMenuId)(uuid, shouldFocusKey), "']"))) === null || _containerRef$current2 === void 0 || (_containerRef$current3 = _containerRef$current2.focus) === null || _containerRef$current3 === void 0 || _containerRef$current3.call(_containerRef$current2, options);
                }
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    var _useMergedState5 = (0, $iSQh8.default)(defaultSelectedKeys || [], {
        value: selectedKeys,
        // Legacy convert key to array
        postState: function postState(keys) {
            if (Array.isArray(keys)) return keys;
            if (keys === null || keys === undefined) return $c301bc30ecc557ca$var$EMPTY_LIST;
            return [
                keys
            ];
        }
    }), _useMergedState6 = (0, $eUqlC.default)(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
    // >>>>> Trigger select
    var triggerSelection = function triggerSelection(info) {
        if (selectable) {
            // Insert or Remove
            var targetKey = info.key;
            var exist = mergedSelectKeys.includes(targetKey);
            var newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter(function(key) {
                    return key !== targetKey;
                });
                else newSelectKeys = [].concat((0, $kbxxf.default)(mergedSelectKeys), [
                    targetKey
                ]);
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            var selectInfo = (0, $d49SP.default)((0, $d49SP.default)({}, info), {}, {
                selectedKeys: newSelectKeys
            });
            if (exist) onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
            else onSelect === null || onSelect === void 0 || onSelect(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($c301bc30ecc557ca$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ var onInternalClick = (0, $lg5nd.default)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
        triggerSelection(info);
    });
    var onInternalOpenChange = (0, $lg5nd.default)(function(key, open) {
        var newOpenKeys = mergedOpenKeys.filter(function(k) {
            return k !== key;
        });
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            var subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter(function(k) {
                return !subPathKeys.has(k);
            });
        }
        if (!(0, $4AFGH.default)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    var getInternalPopupContainer = (0, $lg5nd.default)(getPopupContainer);
    // ==================== Accessibility =====================
    var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
        var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    var onInternalKeyDown = (0, $8SYfi.default)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $acw62.useEffect(function() {
        setMounted(true);
    }, []);
    // ======================= Context ========================
    var privateContext = $acw62.useMemo(function() {
        return {
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        };
    }, [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    var wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index) {
        return(/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $acw62.createElement((0, $392Az.default), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex
        }, child));
    });
    // >>>>> Container
    var container = /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default), (0, $8nd05.default)({
        id: id,
        ref: containerRef,
        prefixCls: "".concat(prefixCls, "-overflow"),
        component: "ul",
        itemComponent: (0, $gXR8t.default),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-rtl"), isRtl), _classNames), rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: function renderRawItem(node) {
            return node;
        },
        renderRawRest: function renderRawRest(omitItems) {
            // We use origin list since wrapped list use context to prevent open
            var len = omitItems.length;
            var originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $acw62.createElement((0, $gASnm.default), {
                eventKey: (0, $cwnCS.OVERFLOW_KEY),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $6dkAu.default).INVALIDATE : (0, $6dkAu.default).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: function onVisibleChange(newLastIndex) {
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $iPTpg.default).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $acw62.createElement((0, $dpnFa.IdContext).Provider, {
        value: uuid
    }, /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getInternalPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange
    }, /*#__PURE__*/ $acw62.createElement((0, $a8XZl.PathUserContext).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $acw62.createElement((0, $a8XZl.PathRegisterContext).Provider, {
        value: registerPathContext
    }, childList)))));
});
var $c301bc30ecc557ca$export$2e2bcd8739ae039 = $c301bc30ecc557ca$var$Menu;

});
parcelRegister("dpnFa", function(module, exports) {

$parcel$export(module.exports, "IdContext", () => $9c2ff7221738ac19$export$26537912ea160acd);
$parcel$export(module.exports, "getMenuId", () => $9c2ff7221738ac19$export$80c871fe8d6b896);
$parcel$export(module.exports, "useMenuId", () => $9c2ff7221738ac19$export$a276eb4e9be640f8);

var $acw62 = parcelRequire("acw62");
var $9c2ff7221738ac19$export$26537912ea160acd = /*#__PURE__*/ $acw62.createContext(null);
function $9c2ff7221738ac19$export$80c871fe8d6b896(uuid, eventKey) {
    if (uuid === undefined) return null;
    return "".concat(uuid, "-").concat(eventKey);
}
function $9c2ff7221738ac19$export$a276eb4e9be640f8(eventKey) {
    var id = $acw62.useContext($9c2ff7221738ac19$export$26537912ea160acd);
    return $9c2ff7221738ac19$export$80c871fe8d6b896(id, eventKey);
}

});

parcelRegister("392Az", function(module, exports) {

$parcel$export(module.exports, "MenuContext", () => $24a4386da4a32dce$export$c7e742effb1c51e2);
$parcel$export(module.exports, "default", () => $24a4386da4a32dce$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $3Ysvw = parcelRequire("3Ysvw");

var $4AFGH = parcelRequire("4AFGH");
var $24a4386da4a32dce$var$_excluded = [
    "children",
    "locked"
];
var $24a4386da4a32dce$export$c7e742effb1c51e2 = /*#__PURE__*/ $acw62.createContext(null);
function $24a4386da4a32dce$var$mergeProps(origin, target) {
    var clone = (0, $d49SP.default)({}, origin);
    Object.keys(target).forEach(function(key) {
        var value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $24a4386da4a32dce$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, locked = _ref.locked, restProps = (0, $9X7IJ.default)(_ref, $24a4386da4a32dce$var$_excluded);
    var context = $acw62.useContext($24a4386da4a32dce$export$c7e742effb1c51e2);
    var inheritableContext = (0, $3Ysvw.default)(function() {
        return $24a4386da4a32dce$var$mergeProps(context, restProps);
    }, [
        context,
        restProps
    ], function(prev, next) {
        return !locked && (prev[0] !== next[0] || !(0, $4AFGH.default)(prev[1], next[1], true));
    });
    return /*#__PURE__*/ $acw62.createElement($24a4386da4a32dce$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}

});

parcelRegister("a8XZl", function(module, exports) {

$parcel$export(module.exports, "PathRegisterContext", () => $76292f3495da88ff$export$d9ffb5bfd108b003);
$parcel$export(module.exports, "useMeasure", () => $76292f3495da88ff$export$e295b0c537d32d7d);
$parcel$export(module.exports, "PathTrackerContext", () => $76292f3495da88ff$export$54d9e16aa4c8a7fa);
$parcel$export(module.exports, "useFullPath", () => $76292f3495da88ff$export$d3d2d0a05677870a);
$parcel$export(module.exports, "PathUserContext", () => $76292f3495da88ff$export$f0b9e0db98edfa53);

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");
var $76292f3495da88ff$var$EmptyList = [];
var $76292f3495da88ff$export$d9ffb5bfd108b003 = /*#__PURE__*/ $acw62.createContext(null);
function $76292f3495da88ff$export$e295b0c537d32d7d() {
    return $acw62.useContext($76292f3495da88ff$export$d9ffb5bfd108b003);
}
var $76292f3495da88ff$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $acw62.createContext($76292f3495da88ff$var$EmptyList);
function $76292f3495da88ff$export$d3d2d0a05677870a(eventKey) {
    var parentKeyPath = $acw62.useContext($76292f3495da88ff$export$54d9e16aa4c8a7fa);
    return $acw62.useMemo(function() {
        return eventKey !== undefined ? [].concat((0, $kbxxf.default)(parentKeyPath), [
            eventKey
        ]) : parentKeyPath;
    }, [
        parentKeyPath,
        eventKey
    ]);
}
var $76292f3495da88ff$export$f0b9e0db98edfa53 = /*#__PURE__*/ $acw62.createContext(null);

});

parcelRegister("iPTpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $db67f8032758903f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $db67f8032758903f$var$PrivateContext = /*#__PURE__*/ $acw62.createContext({});
var $db67f8032758903f$export$2e2bcd8739ae039 = $db67f8032758903f$var$PrivateContext;

});

parcelRegister("8SYfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6782197159192667$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $iCi4s = parcelRequire("iCi4s");

var $dTiBu = parcelRequire("dTiBu");

var $77reW = parcelRequire("77reW");

var $dpnFa = parcelRequire("dpnFa");
// destruct to reduce minify size
var $6782197159192667$var$LEFT = (0, $iCi4s.default).LEFT, $6782197159192667$var$RIGHT = (0, $iCi4s.default).RIGHT, $6782197159192667$var$UP = (0, $iCi4s.default).UP, $6782197159192667$var$DOWN = (0, $iCi4s.default).DOWN, $6782197159192667$var$ENTER = (0, $iCi4s.default).ENTER, $6782197159192667$var$ESC = (0, $iCi4s.default).ESC, $6782197159192667$var$HOME = (0, $iCi4s.default).HOME, $6782197159192667$var$END = (0, $iCi4s.default).END;
var $6782197159192667$var$ArrowKeys = [
    $6782197159192667$var$UP,
    $6782197159192667$var$DOWN,
    $6782197159192667$var$LEFT,
    $6782197159192667$var$RIGHT
];
function $6782197159192667$var$getOffset(mode, isRootLevel, isRtl, which) {
    var _inline, _horizontal, _vertical, _offsets;
    var prev = 'prev';
    var next = 'next';
    var children = 'children';
    var parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $6782197159192667$var$ENTER) return {
        inlineTrigger: true
    };
    var inline = (_inline = {}, (0, $kSlfw.default)(_inline, $6782197159192667$var$UP, prev), (0, $kSlfw.default)(_inline, $6782197159192667$var$DOWN, next), _inline);
    var horizontal = (_horizontal = {}, (0, $kSlfw.default)(_horizontal, $6782197159192667$var$LEFT, isRtl ? next : prev), (0, $kSlfw.default)(_horizontal, $6782197159192667$var$RIGHT, isRtl ? prev : next), (0, $kSlfw.default)(_horizontal, $6782197159192667$var$DOWN, children), (0, $kSlfw.default)(_horizontal, $6782197159192667$var$ENTER, children), _horizontal);
    var vertical = (_vertical = {}, (0, $kSlfw.default)(_vertical, $6782197159192667$var$UP, prev), (0, $kSlfw.default)(_vertical, $6782197159192667$var$DOWN, next), (0, $kSlfw.default)(_vertical, $6782197159192667$var$ENTER, children), (0, $kSlfw.default)(_vertical, $6782197159192667$var$ESC, parent), (0, $kSlfw.default)(_vertical, $6782197159192667$var$LEFT, isRtl ? children : parent), (0, $kSlfw.default)(_vertical, $6782197159192667$var$RIGHT, isRtl ? parent : children), _vertical);
    var offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? '' : 'Sub')]) === null || _offsets === void 0 ? void 0 : _offsets[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $6782197159192667$var$findContainerUL(element) {
    var current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $6782197159192667$var$getFocusElement(activeElement, elements) {
    var current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
/**
 * Get focusable elements from the element set under provided container
 */ function $6782197159192667$var$getFocusableElements(container, elements) {
    var list = (0, $77reW.getFocusNodeList)(container, true);
    return list.filter(function(ele) {
        return elements.has(ele);
    });
}
function $6782197159192667$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    var sameLevelFocusableMenuElementList = $6782197159192667$var$getFocusableElements(parentQueryContainer, elements);
    // Find next focus index
    var count = sameLevelFocusableMenuElementList.length;
    var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
        return focusMenuElement === ele;
    });
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
function $6782197159192667$export$2e2bcd8739ae039(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    var rafRef = $acw62.useRef();
    var activeRef = $acw62.useRef();
    activeRef.current = activeKey;
    var cleanRaf = function cleanRaf() {
        (0, $dTiBu.default).cancel(rafRef.current);
    };
    $acw62.useEffect(function() {
        return function() {
            cleanRaf();
        };
    }, []);
    return function(e) {
        var which = e.which;
        if ([].concat($6782197159192667$var$ArrowKeys, [
            $6782197159192667$var$ENTER,
            $6782197159192667$var$ESC,
            $6782197159192667$var$HOME,
            $6782197159192667$var$END
        ]).includes(which)) {
            // Convert key to elements
            var elements;
            var key2element;
            var element2key;
            // >>> Wrap as function since we use raf for some case
            var refreshElements = function refreshElements() {
                elements = new Set();
                key2element = new Map();
                element2key = new Map();
                var keys = getKeys();
                keys.forEach(function(key) {
                    var element = document.querySelector("[data-menu-id='".concat((0, $dpnFa.getMenuId)(id, key), "']"));
                    if (element) {
                        elements.add(element);
                        element2key.set(element, key);
                        key2element.set(key, element);
                    }
                });
                return elements;
            };
            refreshElements();
            // First we should find current focused MenuItem/SubMenu element
            var activeElement = key2element.get(activeKey);
            var focusMenuElement = $6782197159192667$var$getFocusElement(activeElement, elements);
            var focusMenuKey = element2key.get(focusMenuElement);
            var offsetObj = $6782197159192667$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $6782197159192667$var$HOME && which !== $6782197159192667$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($6782197159192667$var$ArrowKeys.includes(which) || [
                $6782197159192667$var$HOME,
                $6782197159192667$var$END
            ].includes(which)) e.preventDefault();
            var tryFocus = function tryFocus(menuElement) {
                if (menuElement) {
                    var focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    var link = menuElement.querySelector('a');
                    if (link !== null && link !== void 0 && link.getAttribute('href')) focusTargetElement = link;
                    var targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $dTiBu.default)(function() {
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $6782197159192667$var$HOME,
                $6782197159192667$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                var parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $6782197159192667$var$findContainerUL(focusMenuElement);
                // Get next focus element
                var targetElement;
                var focusableElements = $6782197159192667$var$getFocusableElements(parentQueryContainer, elements);
                if (which === $6782197159192667$var$HOME) targetElement = focusableElements[0];
                else if (which === $6782197159192667$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $6782197159192667$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $dTiBu.default)(function() {
                    // Async should resync elements
                    refreshElements();
                    var controlId = focusMenuElement.getAttribute('aria-controls');
                    var subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    var targetElement = $6782197159192667$var$getNextFocusElement(subQueryContainer, elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                var keyPath = getKeyPath(focusMenuKey, true);
                var parentKey = keyPath[keyPath.length - 2];
                var parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
    };
}

});

parcelRegister("cwnCS", function(module, exports) {

$parcel$export(module.exports, "OVERFLOW_KEY", () => $91daccd328800b8c$export$20a0132c46ce5b04);
$parcel$export(module.exports, "default", () => $91daccd328800b8c$export$2e2bcd8739ae039);

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
parcelRequire("u43uR");

var $4PkqS = parcelRequire("4PkqS");
var $91daccd328800b8c$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
var $91daccd328800b8c$var$getPathStr = function getPathStr(keyPath) {
    return keyPath.join($91daccd328800b8c$var$PATH_SPLIT);
};
var $91daccd328800b8c$var$getPathKeys = function getPathKeys(keyPathStr) {
    return keyPathStr.split($91daccd328800b8c$var$PATH_SPLIT);
};
var $91daccd328800b8c$export$20a0132c46ce5b04 = 'rc-menu-more';
function $91daccd328800b8c$export$2e2bcd8739ae039() {
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), internalForceUpdate = _React$useState2[1];
    var key2pathRef = (0, $acw62.useRef)(new Map());
    var path2keyRef = (0, $acw62.useRef)(new Map());
    var _React$useState3 = $acw62.useState([]), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
    var updateRef = (0, $acw62.useRef)(0);
    var destroyRef = (0, $acw62.useRef)(false);
    var forceUpdate = function forceUpdate() {
        if (!destroyRef.current) internalForceUpdate({});
    };
    var registerPath = (0, $acw62.useCallback)(function(key, keyPath) {
        // Fill map
        var connectedPath = $91daccd328800b8c$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        var id = updateRef.current;
        (0, $4PkqS.nextSlice)(function() {
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    var unregisterPath = (0, $acw62.useCallback)(function(key, keyPath) {
        var connectedPath = $91daccd328800b8c$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    var refreshOverflowKeys = (0, $acw62.useCallback)(function(keys) {
        setOverflowKeys(keys);
    }, []);
    var getKeyPath = (0, $acw62.useCallback)(function(eventKey, includeOverflow) {
        var fullPath = key2pathRef.current.get(eventKey) || '';
        var keys = $91daccd328800b8c$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($91daccd328800b8c$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    var isSubPathKey = (0, $acw62.useCallback)(function(pathKeys, eventKey) {
        return pathKeys.some(function(pathKey) {
            var pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        });
    }, [
        getKeyPath
    ]);
    var getKeys = function getKeys() {
        var keys = (0, $kbxxf.default)(key2pathRef.current.keys());
        if (overflowKeys.length) keys.push($91daccd328800b8c$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ var getSubPathKeys = (0, $acw62.useCallback)(function(key) {
        var connectedPath = "".concat(key2pathRef.current.get(key)).concat($91daccd328800b8c$var$PATH_SPLIT);
        var pathKeys = new Set();
        (0, $kbxxf.default)(path2keyRef.current.keys()).forEach(function(pathKey) {
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $acw62.useEffect(function() {
        return function() {
            destroyRef.current = true;
        };
    }, []);
    return {
        // Register
        registerPath: registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        // Util
        isSubPathKey: isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}

});
parcelRegister("4PkqS", function(module, exports) {

$parcel$export(module.exports, "nextSlice", () => $383bc652cde1c429$export$7693db51ef834b40);
function $383bc652cde1c429$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}

});


parcelRegister("lg5nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79f42a79a2878d1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $f79f42a79a2878d1$export$2e2bcd8739ae039(func) {
    var funRef = $acw62.useRef(func);
    funRef.current = func;
    var callback = $acw62.useCallback(function() {
        var _funRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [
            funRef
        ].concat(args));
    }, []);
    return func ? callback : undefined;
}

});

parcelRegister("8krl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $610565fd72f5965a$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $iSQh8 = parcelRequire("iSQh8");
var $610565fd72f5965a$var$uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var $610565fd72f5965a$var$internalId = 0;
function $610565fd72f5965a$export$2e2bcd8739ae039(id) {
    var _useMergedState = (0, $iSQh8.default)(id, {
        value: id
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), uuid = _useMergedState2[0], setUUID = _useMergedState2[1];
    $acw62.useEffect(function() {
        $610565fd72f5965a$var$internalId += 1;
        var newId = "".concat($610565fd72f5965a$var$uniquePrefix, "-").concat($610565fd72f5965a$var$internalId);
        setUUID("rc-menu-uuid-".concat(newId));
    }, []);
    return uuid;
}

});

parcelRegister("gXR8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59b5fb169e5cf0f$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $8g1PZ = parcelRequire("8g1PZ");

var $6dkAu = parcelRequire("6dkAu");

var $iCi4s = parcelRequire("iCi4s");

var $1pcHX = parcelRequire("1pcHX");

var $85dLH = parcelRequire("85dLH");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $dpnFa = parcelRequire("dpnFa");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");

var $iPTpg = parcelRequire("iPTpg");

var $eh9jt = parcelRequire("eh9jt");

var $7j6OO = parcelRequire("7j6OO");

var $gO591 = parcelRequire("gO591");

var $1zp6Q = parcelRequire("1zp6Q");
var $c59b5fb169e5cf0f$var$_excluded = [
    "title",
    "attribute",
    "elementRef"
], $c59b5fb169e5cf0f$var$_excluded2 = [
    "style",
    "className",
    "eventKey",
    "warnKey",
    "disabled",
    "itemIcon",
    "children",
    "role",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onKeyDown",
    "onFocus"
], $c59b5fb169e5cf0f$var$_excluded3 = [
    "active"
];
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var $c59b5fb169e5cf0f$var$LegacyMenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(LegacyMenuItem, _React$Component);
    var _super = (0, $enfmq.default)(LegacyMenuItem);
    function LegacyMenuItem() {
        (0, $6CZeq.default)(this, LegacyMenuItem);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(LegacyMenuItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = (0, $9X7IJ.default)(_this$props, $c59b5fb169e5cf0f$var$_excluded);
                // Here the props are eventually passed to the DOM element.
                // React does not recognize non-standard attributes.
                // Therefore, remove the props that is not used here.
                // ref: https://github.com/ant-design/ant-design/issues/41395
                var passedProps = (0, $1pcHX.default)(restProps, [
                    'eventKey',
                    'popupClassName',
                    'popupOffset',
                    'onTitleClick'
                ]);
                (0, $u43uR.default)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
                return /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default).Item, (0, $8nd05.default)({}, attribute, {
                    title: typeof title === 'string' ? title : undefined
                }, passedProps, {
                    ref: elementRef
                }));
            }
        }
    ]);
    return LegacyMenuItem;
}($acw62.Component);
/**
 * Real Menu Item component
 */ var $c59b5fb169e5cf0f$var$InternalMenuItem = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var style = props.style, className = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onFocus = props.onFocus, restProps = (0, $9X7IJ.default)(props, $c59b5fb169e5cf0f$var$_excluded2);
    var domDataId = (0, $dpnFa.useMenuId)(eventKey);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
    var _React$useContext2 = $acw62.useContext((0, $iPTpg.default)), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
    var itemCls = "".concat(prefixCls, "-item");
    var legacyMenuItemRef = $acw62.useRef();
    var elementRef = $acw62.useRef();
    var mergedDisabled = contextDisabled || disabled;
    var mergedEleRef = (0, $85dLH.useComposeRef)(ref, elementRef);
    var connectedKeys = (0, $a8XZl.useFullPath)(eventKey);
    // ============================= Info =============================
    var getEventInfo = function getEventInfo(e) {
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: (0, $kbxxf.default)(connectedKeys).reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    var mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    var _useActive = (0, $eh9jt.default)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = (0, $9X7IJ.default)(_useActive, $c59b5fb169e5cf0f$var$_excluded3);
    // ============================ Select ============================
    var selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    var directionStyle = (0, $7j6OO.default)(connectedKeys.length);
    // ============================ Events ============================
    var onInternalClick = function onInternalClick(e) {
        if (mergedDisabled) return;
        var info = getEventInfo(e);
        onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
        onItemClick(info);
    };
    var onInternalKeyDown = function onInternalKeyDown(e) {
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
        if (e.which === (0, $iCi4s.default).ENTER) {
            var info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus(e) {
        onActive(eventKey);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    // ============================ Render ============================
    var optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    var renderNode = /*#__PURE__*/ $acw62.createElement($c59b5fb169e5cf0f$var$LegacyMenuItem, (0, $8nd05.default)({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, restProps, activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, directionStyle), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemCls, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(itemCls, "-active"), active), (0, $kSlfw.default)(_classNames, "".concat(itemCls, "-selected"), selected), (0, $kSlfw.default)(_classNames, "".concat(itemCls, "-disabled"), mergedDisabled), _classNames), className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $acw62.createElement((0, $gO591.default), {
        props: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            isSelected: selected
        }),
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $c59b5fb169e5cf0f$var$MenuItem(props, ref) {
    var eventKey = props.eventKey;
    // ==================== Record KeyPath ====================
    var measure = (0, $a8XZl.useMeasure)();
    var connectedKeyPath = (0, $a8XZl.useFullPath)(eventKey);
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $acw62.createElement($c59b5fb169e5cf0f$var$InternalMenuItem, (0, $8nd05.default)({}, props, {
        ref: ref
    }));
}
var $c59b5fb169e5cf0f$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($c59b5fb169e5cf0f$var$MenuItem);

});
parcelRegister("eh9jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a649e094df404c52$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $392Az = parcelRequire("392Az");
function $a649e094df404c52$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
    var ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = function(domEvent) {
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = function(domEvent) {
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}

});

parcelRegister("7j6OO", function(module, exports) {

$parcel$export(module.exports, "default", () => $551f98bff3692876$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $392Az = parcelRequire("392Az");
function $551f98bff3692876$export$2e2bcd8739ae039(level) {
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
    if (mode !== 'inline') return null;
    var len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}

});

parcelRegister("gO591", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c54e71b725e1ff$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
function $c3c54e71b725e1ff$export$2e2bcd8739ae039(_ref) {
    var icon = _ref.icon, props = _ref.props, children = _ref.children;
    var iconNode;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $acw62.createElement(icon, (0, $d49SP.default)({}, props));
    else // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}

});

parcelRegister("1zp6Q", function(module, exports) {

$parcel$export(module.exports, "warnItemProp", () => $124c89870f2be225$export$e189bcd94b66c1db);

var $9X7IJ = parcelRequire("9X7IJ");

var $u43uR = parcelRequire("u43uR");
var $124c89870f2be225$var$_excluded = [
    "item"
];
function $124c89870f2be225$export$e189bcd94b66c1db(_ref) {
    var item = _ref.item, restInfo = (0, $9X7IJ.default)(_ref, $124c89870f2be225$var$_excluded);
    Object.defineProperty(restInfo, 'item', {
        get: function get() {
            (0, $u43uR.default)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}

});


parcelRegister("gASnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c14a300ca0685832$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $6dkAu = parcelRequire("6dkAu");
parcelRequire("u43uR");

var $eRb58 = parcelRequire("eRb58");

var $lvs07 = parcelRequire("lvs07");

var $392Az = parcelRequire("392Az");

var $lg5nd = parcelRequire("lg5nd");

var $cUQRe = parcelRequire("cUQRe");

var $gO591 = parcelRequire("gO591");

var $eh9jt = parcelRequire("eh9jt");

var $1zp6Q = parcelRequire("1zp6Q");

var $7j6OO = parcelRequire("7j6OO");

var $1pNez = parcelRequire("1pNez");

var $a8XZl = parcelRequire("a8XZl");

var $dpnFa = parcelRequire("dpnFa");

var $iPTpg = parcelRequire("iPTpg");
var $c14a300ca0685832$var$_excluded = [
    "style",
    "className",
    "title",
    "eventKey",
    "warnKey",
    "disabled",
    "internalPopupClose",
    "children",
    "itemIcon",
    "expandIcon",
    "popupClassName",
    "popupOffset",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onTitleClick",
    "onTitleMouseEnter",
    "onTitleMouseLeave"
], $c14a300ca0685832$var$_excluded2 = [
    "active"
];
var $c14a300ca0685832$var$InternalSubMenu = function InternalSubMenu(props) {
    var _classNames;
    var style = props.style, className = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = (0, $9X7IJ.default)(props, $c14a300ca0685832$var$_excluded);
    var domDataId = (0, $dpnFa.useMenuId)(eventKey);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
    var _React$useContext2 = $acw62.useContext((0, $iPTpg.default)), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
    var _React$useContext3 = $acw62.useContext((0, $a8XZl.PathUserContext)), isSubPathKey = _React$useContext3.isSubPathKey;
    var connectedPath = (0, $a8XZl.useFullPath)();
    var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
    var mergedDisabled = contextDisabled || disabled;
    var elementRef = $acw62.useRef();
    var popupRef = $acw62.useRef();
    // ================================ Icon ================================
    var mergedItemIcon = itemIcon || contextItemIcon;
    var mergedExpandIcon = expandIcon || contextExpandIcon;
    // ================================ Open ================================
    var originOpen = openKeys.includes(eventKey);
    var open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    var childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    var _useActive = (0, $eh9jt.default)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = (0, $9X7IJ.default)(_useActive, $c14a300ca0685832$var$_excluded2);
    // Fallback of active check to avoid hover on menu title or disabled item
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
    var triggerChildrenActive = function triggerChildrenActive(newActive) {
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
        triggerChildrenActive(true);
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
        triggerChildrenActive(false);
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var mergedActive = $acw62.useMemo(function() {
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    var directionStyle = (0, $7j6OO.default)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    var onInternalTitleClick = function onInternalTitleClick(e) {
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick === null || onTitleClick === void 0 || onTitleClick({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    var onMergedItemClick = (0, $lg5nd.default)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $1zp6Q.warnItemProp)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus() {
        onActive(eventKey);
    };
    // =============================== Render ===============================
    var popupId = domDataId && "".concat(domDataId, "-popup");
    // >>>>> Title
    var titleNode = /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        role: "menuitem",
        style: directionStyle,
        className: "".concat(subMenuPrefixCls, "-title"),
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, /*#__PURE__*/ $acw62.createElement((0, $gO591.default), {
        icon: mode !== 'horizontal' ? mergedExpandIcon : null,
        props: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            isOpen: open,
            // [Legacy] Not sure why need this mark
            isSubMenu: true
        })
    }, /*#__PURE__*/ $acw62.createElement("i", {
        className: "".concat(subMenuPrefixCls, "-arrow")
    })));
    // Cache mode if it change to `inline` which do not have popup motion
    var triggerModeRef = $acw62.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    if (!overflowDisabled) {
        var triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $acw62.createElement((0, $cUQRe.default), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popup: /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
                mode: triggerMode === 'horizontal' ? 'vertical' : triggerMode
            }, /*#__PURE__*/ $acw62.createElement((0, $eRb58.default), {
                id: popupId,
                ref: popupRef
            }, children)),
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    var listNode = /*#__PURE__*/ $acw62.createElement((0, $6dkAu.default).Item, (0, $8nd05.default)({
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-open"), open), (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-active"), mergedActive), (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-selected"), childrenSelected), (0, $kSlfw.default)(_classNames, "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled), _classNames)),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $acw62.createElement((0, $1pNez.default), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
};
function $c14a300ca0685832$export$2e2bcd8739ae039(props) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $a8XZl.useFullPath)(eventKey);
    var childList = (0, $lvs07.parseChildren)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    var measure = (0, $a8XZl.useMeasure)();
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    var renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $acw62.createElement($c14a300ca0685832$var$InternalSubMenu, props, childList);
    return /*#__PURE__*/ $acw62.createElement((0, $a8XZl.PathTrackerContext).Provider, {
        value: connectedKeyPath
    }, renderNode);
}

});
parcelRegister("eRb58", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0e9c8fde51e397$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $392Az = parcelRequire("392Az");
var $ad0e9c8fde51e397$var$_excluded = [
    "className",
    "children"
];
var $ad0e9c8fde51e397$var$InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
    var className = _ref.className, children = _ref.children, restProps = (0, $9X7IJ.default)(_ref, $ad0e9c8fde51e397$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
    return /*#__PURE__*/ $acw62.createElement("ul", (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === 'inline' ? 'inline' : 'vertical'), className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
var $ad0e9c8fde51e397$var$SubMenuList = /*#__PURE__*/ $acw62.forwardRef($ad0e9c8fde51e397$var$InternalSubMenuList);
$ad0e9c8fde51e397$var$SubMenuList.displayName = 'SubMenuList';
var $ad0e9c8fde51e397$export$2e2bcd8739ae039 = $ad0e9c8fde51e397$var$SubMenuList;

});

parcelRegister("lvs07", function(module, exports) {

$parcel$export(module.exports, "parseChildren", () => $fa82369bcec373f6$export$cd230e97e668be9);
$parcel$export(module.exports, "parseItems", () => $fa82369bcec373f6$export$50458dc1a9a0f894);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");
parcelRequire("feYPt");
var $iPQJN = parcelRequire("iPQJN");
var $gXR8t = parcelRequire("gXR8t");
var $9TcXG = parcelRequire("9TcXG");
var $gASnm = parcelRequire("gASnm");
var $fa82369bcec373f6$var$_excluded = [
    "label",
    "children",
    "key",
    "type"
];
function $fa82369bcec373f6$export$cd230e97e668be9(children, keyPath) {
    return (0, $jWR62.default)(children).map(function(child, index) {
        if (/*#__PURE__*/ $acw62.isValidElement(child)) {
            var _eventKey, _child$props;
            var key = child.key;
            var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
            var emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = "tmp_key-".concat([].concat((0, $kbxxf.default)(keyPath), [
                index
            ]).join('-'));
            var cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $acw62.cloneElement(child, cloneProps);
        }
        return child;
    });
}
function $fa82369bcec373f6$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && (0, $fSwVM.default)(opt) === 'object') {
            var _ref = opt, label = _ref.label, children = _ref.children, key = _ref.key, type = _ref.type, restProps = (0, $9X7IJ.default)(_ref, $fa82369bcec373f6$var$_excluded);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $acw62.createElement((0, $9TcXG.default), (0, $8nd05.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $fa82369bcec373f6$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $acw62.createElement((0, $gASnm.default), (0, $8nd05.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $fa82369bcec373f6$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $acw62.createElement((0, $iPQJN.default), (0, $8nd05.default)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $acw62.createElement((0, $gXR8t.default), (0, $8nd05.default)({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $fa82369bcec373f6$export$50458dc1a9a0f894(children, items, keyPath) {
    var childNodes = children;
    if (items) childNodes = $fa82369bcec373f6$var$convertItemsToNodes(items);
    return $fa82369bcec373f6$export$cd230e97e668be9(childNodes, keyPath);
}

});

parcelRegister("cUQRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9673b769529d0dd1$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $grQtM = parcelRequire("grQtM");

var $8g1PZ = parcelRequire("8g1PZ");

var $dTiBu = parcelRequire("dTiBu");

var $392Az = parcelRequire("392Az");

var $hNP9x = parcelRequire("hNP9x");

var $eDaQ3 = parcelRequire("eDaQ3");
var $9673b769529d0dd1$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $9673b769529d0dd1$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
    var placement = rtl ? (0, $d49SP.default)((0, $d49SP.default)({}, (0, $hNP9x.placementsRtl)), builtinPlacements) : (0, $d49SP.default)((0, $d49SP.default)({}, (0, $hNP9x.placements)), builtinPlacements);
    var popupPlacement = $9673b769529d0dd1$var$popupPlacementMap[mode];
    var targetMotion = (0, $eDaQ3.getMotion)(mode, motion, defaultMotions);
    var targetMotionRef = $acw62.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    var mergedMotion = (0, $d49SP.default)((0, $d49SP.default)({}, targetMotionRef.current), {}, {
        leavedClassName: "".concat(prefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: true
    });
    // Delay to change visible
    var visibleRef = $acw62.useRef();
    $acw62.useEffect(function() {
        visibleRef.current = (0, $dTiBu.default)(function() {
            setInnerVisible(visible);
        });
        return function() {
            (0, $dTiBu.default).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $grQtM.default), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-popup"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion
    }, children);
}

});
parcelRegister("hNP9x", function(module, exports) {

$parcel$export(module.exports, "placements", () => $cf5eb12962f7aceb$export$803cd8101b6c182b);
$parcel$export(module.exports, "placementsRtl", () => $cf5eb12962f7aceb$export$e2b3f69b0a16e1f);
var $cf5eb12962f7aceb$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $cf5eb12962f7aceb$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            0,
            -7
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            0,
            7
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ]
    }
};
var $cf5eb12962f7aceb$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            0,
            -7
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            0,
            7
        ]
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ]
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ]
    }
};
var $cf5eb12962f7aceb$export$2e2bcd8739ae039 = $cf5eb12962f7aceb$export$803cd8101b6c182b;

});

parcelRegister("eDaQ3", function(module, exports) {

$parcel$export(module.exports, "getMotion", () => $aa6d1d843f423253$export$7b8936ddc277a29a);
function $aa6d1d843f423253$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}

});


parcelRegister("1pNez", function(module, exports) {

$parcel$export(module.exports, "default", () => $107e5113551bc6e9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8iiJy = parcelRequire("8iiJy");

var $eDaQ3 = parcelRequire("eDaQ3");

var $392Az = parcelRequire("392Az");

var $eRb58 = parcelRequire("eRb58");
function $107e5113551bc6e9$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, open = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
    var fixedMode = 'inline';
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
    // Always use latest mode check
    var sameModeRef = $acw62.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    var _React$useState = $acw62.useState(!sameModeRef.current), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), destroy = _React$useState2[0], setDestroy = _React$useState2[1];
    var mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $acw62.useEffect(function() {
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    var mergedMotion = (0, $d49SP.default)({}, (0, $eDaQ3.getMotion)(fixedMode, motion, defaultMotions));
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    var originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = function(newVisible) {
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $392Az.default), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement((0, $eRb58.default), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}

});



parcelRegister("9TcXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $73334e01b4c90e74$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");

var $lvs07 = parcelRequire("lvs07");
var $73334e01b4c90e74$var$_excluded = [
    "className",
    "title",
    "eventKey",
    "children"
], $73334e01b4c90e74$var$_excluded2 = [
    "children"
];
var $73334e01b4c90e74$var$InternalMenuItemGroup = function InternalMenuItemGroup(_ref) {
    var className = _ref.className, title = _ref.title, eventKey = _ref.eventKey, children = _ref.children, restProps = (0, $9X7IJ.default)(_ref, $73334e01b4c90e74$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls;
    var groupPrefixCls = "".concat(prefixCls, "-item-group");
    return /*#__PURE__*/ $acw62.createElement("li", (0, $8nd05.default)({
        role: "presentation"
    }, restProps, {
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $acw62.createElement("div", {
        role: "presentation",
        className: "".concat(groupPrefixCls, "-title"),
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $acw62.createElement("ul", {
        role: "group",
        className: "".concat(groupPrefixCls, "-list")
    }, children));
};
function $73334e01b4c90e74$export$2e2bcd8739ae039(_ref2) {
    var children = _ref2.children, props = (0, $9X7IJ.default)(_ref2, $73334e01b4c90e74$var$_excluded2);
    var connectedKeyPath = (0, $a8XZl.useFullPath)(props.eventKey);
    var childList = (0, $lvs07.parseChildren)(children, connectedKeyPath);
    var measure = (0, $a8XZl.useMeasure)();
    if (measure) return childList;
    return /*#__PURE__*/ $acw62.createElement($73334e01b4c90e74$var$InternalMenuItemGroup, (0, $1pcHX.default)(props, [
        'warnKey'
    ]), childList);
}

});

parcelRegister("iPQJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $db65e601ae4bf633$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $392Az = parcelRequire("392Az");

var $a8XZl = parcelRequire("a8XZl");
function $db65e601ae4bf633$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, style = _ref.style;
    var _React$useContext = $acw62.useContext((0, $392Az.MenuContext)), prefixCls = _React$useContext.prefixCls;
    var measure = (0, $a8XZl.useMeasure)();
    if (measure) return null;
    return /*#__PURE__*/ $acw62.createElement("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-item-divider"), className),
        style: style
    });
}

});


parcelRegister("hRA8u", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d0136ab94ce7f56e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("7v8Xm")).default);

var $bABpZ = parcelRequire("bABpZ");

var $7v8Xm = parcelRequire("7v8Xm");
var $d0136ab94ce7f56e$export$2e2bcd8739ae039 = (0, $bABpZ.default);

});
parcelRegister("bABpZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $870014fb7370caba$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $grQtM = parcelRequire("grQtM");

var $9jtir = parcelRequire("9jtir");

var $7v8Xm = parcelRequire("7v8Xm");
var $870014fb7370caba$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, showArrow = props.showArrow, restProps = (0, $9X7IJ.default)(props, [
        "overlayClassName",
        "trigger",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "prefixCls",
        "children",
        "onVisibleChange",
        "afterVisibleChange",
        "transitionName",
        "animation",
        "motion",
        "placement",
        "align",
        "destroyTooltipOnHide",
        "defaultVisible",
        "getTooltipContainer",
        "overlayInnerStyle",
        "arrowContent",
        "overlay",
        "id",
        "showArrow"
    ]);
    var domRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $d49SP.default)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $acw62.createElement((0, $7v8Xm.default), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === 'boolean') destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $fSwVM.default)(destroyTooltipOnHide) === 'object') {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $grQtM.default), (0, $8nd05.default)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $9jtir.placements),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $870014fb7370caba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.forwardRef)($870014fb7370caba$var$Tooltip);

});
parcelRegister("9jtir", function(module, exports) {

$parcel$export(module.exports, "placements", () => $6c7c9d120875ff76$export$803cd8101b6c182b);
var $6c7c9d120875ff76$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $6c7c9d120875ff76$var$targetOffset = [
    0,
    0
];
var $6c7c9d120875ff76$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    }
};
var $6c7c9d120875ff76$export$2e2bcd8739ae039 = $6c7c9d120875ff76$export$803cd8101b6c182b;

});

parcelRegister("7v8Xm", function(module, exports) {

$parcel$export(module.exports, "default", () => $576260377b469890$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
function $576260377b469890$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === 'function' ? children() : children));
}

});



parcelRegister("8rHfe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $626263d9d009eabc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TreeNode", () => (parcelRequire("5BDlo")).default);

var $6IUOQ = parcelRequire("6IUOQ");

var $5BDlo = parcelRequire("5BDlo");
var $626263d9d009eabc$export$2e2bcd8739ae039 = (0, $6IUOQ.default);

});
parcelRegister("6IUOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $014366ec5d4b5909$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $3ryW7 = parcelRequire("3ryW7");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $02gL0 = parcelRequire("02gL0");

var $5rLy6 = parcelRequire("5rLy6");

var $5hwno = parcelRequire("5hwno");

var $5BDlo = parcelRequire("5BDlo");

var $f4FkX = parcelRequire("f4FkX");

var $6EgAF = parcelRequire("6EgAF");

var $3KPsa = parcelRequire("3KPsa");

var $jh8Np = parcelRequire("jh8Np");
var $014366ec5d4b5909$var$MAX_RETRY_TIMES = 10;
var $014366ec5d4b5909$var$Tree = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Tree, _React$Component);
    var _super = (0, $enfmq.default)(Tree);
    function Tree() {
        var _this;
        (0, $6CZeq.default)(this, Tree);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        _this.destroyed = false;
        _this.delayedDragEnterLogic = void 0;
        _this.loadingRetryTimes = {};
        _this.state = {
            keyEntities: {},
            indent: null,
            selectedKeys: [],
            checkedKeys: [],
            halfCheckedKeys: [],
            loadedKeys: [],
            loadingKeys: [],
            expandedKeys: [],
            draggingNodeKey: null,
            dragChildrenKeys: [],
            // dropTargetKey is the key of abstract-drop-node
            // the abstract-drop-node is the real drop node when drag and drop
            // not the DOM drag over node
            dropTargetKey: null,
            dropPosition: null,
            dropContainerKey: null,
            dropLevelOffset: null,
            dropTargetPos: null,
            dropAllowed: true,
            // the abstract-drag-over-node
            // if mouse is on the bottom of top dom node or no the top of the bottom dom node
            // abstract-drag-over-node is the top node
            dragOverNodeKey: null,
            treeData: [],
            flattenNodes: [],
            focused: false,
            activeKey: null,
            listChanging: false,
            prevProps: null,
            fieldNames: (0, $jh8Np.fillFieldNames)()
        };
        _this.dragStartMousePosition = null;
        _this.dragNode = void 0;
        _this.currentMouseOverDroppableNodeKey = null;
        _this.listRef = /*#__PURE__*/ $acw62.createRef();
        _this.onNodeDragStart = function(event, node) {
            var _this$state = _this.state, expandedKeys = _this$state.expandedKeys, keyEntities = _this$state.keyEntities;
            var onDragStart = _this.props.onDragStart;
            var eventKey = node.props.eventKey;
            _this.dragNode = node;
            _this.dragStartMousePosition = {
                x: event.clientX,
                y: event.clientY
            };
            var newExpandedKeys = (0, $f4FkX.arrDel)(expandedKeys, eventKey);
            _this.setState({
                draggingNodeKey: eventKey,
                dragChildrenKeys: (0, $f4FkX.getDragChildrenKeys)(eventKey, keyEntities),
                indent: _this.listRef.current.getIndentWidth()
            });
            _this.setExpandedKeys(newExpandedKeys);
            window.addEventListener('dragend', _this.onWindowDragEnd);
            onDragStart === null || onDragStart === void 0 || onDragStart({
                event: event,
                node: (0, $jh8Np.convertNodePropsToEventData)(node.props)
            });
        };
        /**
     * [Legacy] Select handler is smaller than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */ _this.onNodeDragEnter = function(event, node) {
            var _this$state2 = _this.state, expandedKeys = _this$state2.expandedKeys, keyEntities = _this$state2.keyEntities, dragChildrenKeys = _this$state2.dragChildrenKeys, flattenNodes = _this$state2.flattenNodes, indent = _this$state2.indent;
            var _this$props = _this.props, onDragEnter = _this$props.onDragEnter, onExpand = _this$props.onExpand, allowDrop = _this$props.allowDrop, direction = _this$props.direction;
            var _node$props = node.props, pos = _node$props.pos, eventKey = _node$props.eventKey;
            var _assertThisInitialize = (0, $hDpcU.default)(_this), dragNode = _assertThisInitialize.dragNode;
            // record the key of node which is latest entered, used in dragleave event.
            if (_this.currentMouseOverDroppableNodeKey !== eventKey) _this.currentMouseOverDroppableNodeKey = eventKey;
            if (!dragNode) {
                _this.resetDragState();
                return;
            }
            var _calcDropPosition = (0, $f4FkX.calcDropPosition)(event, dragNode, node, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition.dropPosition, dropLevelOffset = _calcDropPosition.dropLevelOffset, dropTargetKey = _calcDropPosition.dropTargetKey, dropContainerKey = _calcDropPosition.dropContainerKey, dropTargetPos = _calcDropPosition.dropTargetPos, dropAllowed = _calcDropPosition.dropAllowed, dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
            if (// don't allow drop inside its children
            dragChildrenKeys.indexOf(dropTargetKey) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
            !dropAllowed) {
                _this.resetDragState();
                return;
            }
            // Side effect for delay drag
            if (!_this.delayedDragEnterLogic) _this.delayedDragEnterLogic = {};
            Object.keys(_this.delayedDragEnterLogic).forEach(function(key) {
                clearTimeout(_this.delayedDragEnterLogic[key]);
            });
            if (dragNode.props.eventKey !== node.props.eventKey) {
                // hoist expand logic here
                // since if logic is on the bottom
                // it will be blocked by abstract dragover node check
                //   => if you dragenter from top, you mouse will still be consider as in the top node
                event.persist();
                _this.delayedDragEnterLogic[pos] = window.setTimeout(function() {
                    if (_this.state.draggingNodeKey === null) return;
                    var newExpandedKeys = (0, $kbxxf.default)(expandedKeys);
                    var entity = (0, $3KPsa.default)(keyEntities, node.props.eventKey);
                    if (entity && (entity.children || []).length) newExpandedKeys = (0, $f4FkX.arrAdd)(expandedKeys, node.props.eventKey);
                    if (!('expandedKeys' in _this.props)) _this.setExpandedKeys(newExpandedKeys);
                    onExpand === null || onExpand === void 0 || onExpand(newExpandedKeys, {
                        node: (0, $jh8Np.convertNodePropsToEventData)(node.props),
                        expanded: true,
                        nativeEvent: event.nativeEvent
                    });
                }, 800);
            }
            // Skip if drag node is self
            if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
                _this.resetDragState();
                return;
            }
            // Update drag over node and drag state
            _this.setState({
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed
            });
            onDragEnter === null || onDragEnter === void 0 || onDragEnter({
                event: event,
                node: (0, $jh8Np.convertNodePropsToEventData)(node.props),
                expandedKeys: expandedKeys
            });
        };
        _this.onNodeDragOver = function(event, node) {
            var _this$state3 = _this.state, dragChildrenKeys = _this$state3.dragChildrenKeys, flattenNodes = _this$state3.flattenNodes, keyEntities = _this$state3.keyEntities, expandedKeys = _this$state3.expandedKeys, indent = _this$state3.indent;
            var _this$props2 = _this.props, onDragOver = _this$props2.onDragOver, allowDrop = _this$props2.allowDrop, direction = _this$props2.direction;
            var _assertThisInitialize2 = (0, $hDpcU.default)(_this), dragNode = _assertThisInitialize2.dragNode;
            if (!dragNode) return;
            var _calcDropPosition2 = (0, $f4FkX.calcDropPosition)(event, dragNode, node, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition2.dropPosition, dropLevelOffset = _calcDropPosition2.dropLevelOffset, dropTargetKey = _calcDropPosition2.dropTargetKey, dropContainerKey = _calcDropPosition2.dropContainerKey, dropAllowed = _calcDropPosition2.dropAllowed, dropTargetPos = _calcDropPosition2.dropTargetPos, dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
            if (dragChildrenKeys.indexOf(dropTargetKey) !== -1 || !dropAllowed) // don't allow drop inside its children
            // don't allow drop when drop is not allowed caculated by calcDropPosition
            return;
            // Update drag position
            if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
                if (!(_this.state.dropPosition === null && _this.state.dropLevelOffset === null && _this.state.dropTargetKey === null && _this.state.dropContainerKey === null && _this.state.dropTargetPos === null && _this.state.dropAllowed === false && _this.state.dragOverNodeKey === null)) _this.resetDragState();
            } else if (!(dropPosition === _this.state.dropPosition && dropLevelOffset === _this.state.dropLevelOffset && dropTargetKey === _this.state.dropTargetKey && dropContainerKey === _this.state.dropContainerKey && dropTargetPos === _this.state.dropTargetPos && dropAllowed === _this.state.dropAllowed && dragOverNodeKey === _this.state.dragOverNodeKey)) _this.setState({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed,
                dragOverNodeKey: dragOverNodeKey
            });
            onDragOver === null || onDragOver === void 0 || onDragOver({
                event: event,
                node: (0, $jh8Np.convertNodePropsToEventData)(node.props)
            });
        };
        _this.onNodeDragLeave = function(event, node) {
            // if it is outside the droppable area
            // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
            if (_this.currentMouseOverDroppableNodeKey === node.props.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
                _this.resetDragState();
                _this.currentMouseOverDroppableNodeKey = null;
            }
            var onDragLeave = _this.props.onDragLeave;
            onDragLeave === null || onDragLeave === void 0 || onDragLeave({
                event: event,
                node: (0, $jh8Np.convertNodePropsToEventData)(node.props)
            });
        };
        // since stopPropagation() is called in treeNode
        // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
        _this.onWindowDragEnd = function(event) {
            _this.onNodeDragEnd(event, null, true);
            window.removeEventListener('dragend', _this.onWindowDragEnd);
        };
        // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
        _this.onNodeDragEnd = function(event, node) {
            var onDragEnd = _this.props.onDragEnd;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                event: event,
                node: (0, $jh8Np.convertNodePropsToEventData)(node.props)
            });
            _this.dragNode = null;
            window.removeEventListener('dragend', _this.onWindowDragEnd);
        };
        _this.onNodeDrop = function(event, node) {
            var _this$getActiveItem;
            var outsideTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var _this$state4 = _this.state, dragChildrenKeys = _this$state4.dragChildrenKeys, dropPosition = _this$state4.dropPosition, dropTargetKey = _this$state4.dropTargetKey, dropTargetPos = _this$state4.dropTargetPos, dropAllowed = _this$state4.dropAllowed;
            if (!dropAllowed) return;
            var onDrop = _this.props.onDrop;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            if (dropTargetKey === null) return;
            var abstractDropNodeProps = (0, $d49SP.default)((0, $d49SP.default)({}, (0, $jh8Np.getTreeNodeProps)(dropTargetKey, _this.getTreeNodeRequiredProps())), {}, {
                active: ((_this$getActiveItem = _this.getActiveItem()) === null || _this$getActiveItem === void 0 ? void 0 : _this$getActiveItem.key) === dropTargetKey,
                data: (0, $3KPsa.default)(_this.state.keyEntities, dropTargetKey).node
            });
            var dropToChild = dragChildrenKeys.indexOf(dropTargetKey) !== -1;
            (0, $u43uR.default)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
            var posArr = (0, $f4FkX.posToArr)(dropTargetPos);
            var dropResult = {
                event: event,
                node: (0, $jh8Np.convertNodePropsToEventData)(abstractDropNodeProps),
                dragNode: _this.dragNode ? (0, $jh8Np.convertNodePropsToEventData)(_this.dragNode.props) : null,
                dragNodesKeys: [
                    _this.dragNode.props.eventKey
                ].concat(dragChildrenKeys),
                dropToGap: dropPosition !== 0,
                dropPosition: dropPosition + Number(posArr[posArr.length - 1])
            };
            if (!outsideTree) onDrop === null || onDrop === void 0 || onDrop(dropResult);
            _this.dragNode = null;
        };
        _this.cleanDragState = function() {
            var draggingNodeKey = _this.state.draggingNodeKey;
            if (draggingNodeKey !== null) _this.setState({
                draggingNodeKey: null,
                dropPosition: null,
                dropContainerKey: null,
                dropTargetKey: null,
                dropLevelOffset: null,
                dropAllowed: true,
                dragOverNodeKey: null
            });
            _this.dragStartMousePosition = null;
            _this.currentMouseOverDroppableNodeKey = null;
        };
        _this.triggerExpandActionExpand = function(e, treeNode) {
            var _this$state5 = _this.state, expandedKeys = _this$state5.expandedKeys, flattenNodes = _this$state5.flattenNodes;
            var expanded = treeNode.expanded, key = treeNode.key, isLeaf = treeNode.isLeaf;
            if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
            var node = flattenNodes.filter(function(nodeItem) {
                return nodeItem.key === key;
            })[0];
            var eventNode = (0, $jh8Np.convertNodePropsToEventData)((0, $d49SP.default)((0, $d49SP.default)({}, (0, $jh8Np.getTreeNodeProps)(key, _this.getTreeNodeRequiredProps())), {}, {
                data: node.data
            }));
            _this.setExpandedKeys(expanded ? (0, $f4FkX.arrDel)(expandedKeys, key) : (0, $f4FkX.arrAdd)(expandedKeys, key));
            _this.onNodeExpand(e, eventNode);
        };
        _this.onNodeClick = function(e, treeNode) {
            var _this$props3 = _this.props, onClick = _this$props3.onClick, expandAction = _this$props3.expandAction;
            if (expandAction === 'click') _this.triggerExpandActionExpand(e, treeNode);
            onClick === null || onClick === void 0 || onClick(e, treeNode);
        };
        _this.onNodeDoubleClick = function(e, treeNode) {
            var _this$props4 = _this.props, onDoubleClick = _this$props4.onDoubleClick, expandAction = _this$props4.expandAction;
            if (expandAction === 'doubleClick') _this.triggerExpandActionExpand(e, treeNode);
            onDoubleClick === null || onDoubleClick === void 0 || onDoubleClick(e, treeNode);
        };
        _this.onNodeSelect = function(e, treeNode) {
            var selectedKeys = _this.state.selectedKeys;
            var _this$state6 = _this.state, keyEntities = _this$state6.keyEntities, fieldNames = _this$state6.fieldNames;
            var _this$props5 = _this.props, onSelect = _this$props5.onSelect, multiple = _this$props5.multiple;
            var selected = treeNode.selected;
            var key = treeNode[fieldNames.key];
            var targetSelected = !selected;
            // Update selected keys
            if (!targetSelected) selectedKeys = (0, $f4FkX.arrDel)(selectedKeys, key);
            else if (!multiple) selectedKeys = [
                key
            ];
            else selectedKeys = (0, $f4FkX.arrAdd)(selectedKeys, key);
            // [Legacy] Not found related usage in doc or upper libs
            var selectedNodes = selectedKeys.map(function(selectedKey) {
                var entity = (0, $3KPsa.default)(keyEntities, selectedKey);
                if (!entity) return null;
                return entity.node;
            }).filter(function(node) {
                return node;
            });
            _this.setUncontrolledState({
                selectedKeys: selectedKeys
            });
            onSelect === null || onSelect === void 0 || onSelect(selectedKeys, {
                event: 'select',
                selected: targetSelected,
                node: treeNode,
                selectedNodes: selectedNodes,
                nativeEvent: e.nativeEvent
            });
        };
        _this.onNodeCheck = function(e, treeNode, checked) {
            var _this$state7 = _this.state, keyEntities = _this$state7.keyEntities, oriCheckedKeys = _this$state7.checkedKeys, oriHalfCheckedKeys = _this$state7.halfCheckedKeys;
            var _this$props6 = _this.props, checkStrictly = _this$props6.checkStrictly, onCheck = _this$props6.onCheck;
            var key = treeNode.key;
            // Prepare trigger arguments
            var checkedObj;
            var eventObj = {
                event: 'check',
                node: treeNode,
                checked: checked,
                nativeEvent: e.nativeEvent
            };
            if (checkStrictly) {
                var checkedKeys = checked ? (0, $f4FkX.arrAdd)(oriCheckedKeys, key) : (0, $f4FkX.arrDel)(oriCheckedKeys, key);
                var halfCheckedKeys = (0, $f4FkX.arrDel)(oriHalfCheckedKeys, key);
                checkedObj = {
                    checked: checkedKeys,
                    halfChecked: halfCheckedKeys
                };
                eventObj.checkedNodes = checkedKeys.map(function(checkedKey) {
                    return (0, $3KPsa.default)(keyEntities, checkedKey);
                }).filter(function(entity) {
                    return entity;
                }).map(function(entity) {
                    return entity.node;
                });
                _this.setUncontrolledState({
                    checkedKeys: checkedKeys
                });
            } else {
                // Always fill first
                var _conductCheck = (0, $6EgAF.conductCheck)([].concat((0, $kbxxf.default)(oriCheckedKeys), [
                    key
                ]), true, keyEntities), _checkedKeys = _conductCheck.checkedKeys, _halfCheckedKeys = _conductCheck.halfCheckedKeys;
                // If remove, we do it again to correction
                if (!checked) {
                    var keySet = new Set(_checkedKeys);
                    keySet.delete(key);
                    var _conductCheck2 = (0, $6EgAF.conductCheck)(Array.from(keySet), {
                        checked: false,
                        halfCheckedKeys: _halfCheckedKeys
                    }, keyEntities);
                    _checkedKeys = _conductCheck2.checkedKeys;
                    _halfCheckedKeys = _conductCheck2.halfCheckedKeys;
                }
                checkedObj = _checkedKeys;
                // [Legacy] This is used for `rc-tree-select`
                eventObj.checkedNodes = [];
                eventObj.checkedNodesPositions = [];
                eventObj.halfCheckedKeys = _halfCheckedKeys;
                _checkedKeys.forEach(function(checkedKey) {
                    var entity = (0, $3KPsa.default)(keyEntities, checkedKey);
                    if (!entity) return;
                    var node = entity.node, pos = entity.pos;
                    eventObj.checkedNodes.push(node);
                    eventObj.checkedNodesPositions.push({
                        node: node,
                        pos: pos
                    });
                });
                _this.setUncontrolledState({
                    checkedKeys: _checkedKeys
                }, false, {
                    halfCheckedKeys: _halfCheckedKeys
                });
            }
            onCheck === null || onCheck === void 0 || onCheck(checkedObj, eventObj);
        };
        _this.onNodeLoad = function(treeNode) {
            var key = treeNode.key;
            var loadPromise = new Promise(function(resolve, reject) {
                // We need to get the latest state of loading/loaded keys
                _this.setState(function(_ref) {
                    var _ref$loadedKeys = _ref.loadedKeys, loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys, _ref$loadingKeys = _ref.loadingKeys, loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
                    var _this$props7 = _this.props, loadData = _this$props7.loadData, onLoad = _this$props7.onLoad;
                    if (!loadData || loadedKeys.indexOf(key) !== -1 || loadingKeys.indexOf(key) !== -1) return null;
                    // Process load data
                    var promise = loadData(treeNode);
                    promise.then(function() {
                        var currentLoadedKeys = _this.state.loadedKeys;
                        var newLoadedKeys = (0, $f4FkX.arrAdd)(currentLoadedKeys, key);
                        // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                        // https://github.com/ant-design/ant-design/issues/12464
                        onLoad === null || onLoad === void 0 || onLoad(newLoadedKeys, {
                            event: 'load',
                            node: treeNode
                        });
                        _this.setUncontrolledState({
                            loadedKeys: newLoadedKeys
                        });
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $f4FkX.arrDel)(prevState.loadingKeys, key)
                            };
                        });
                        resolve();
                    }).catch(function(e) {
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $f4FkX.arrDel)(prevState.loadingKeys, key)
                            };
                        });
                        // If exceed max retry times, we give up retry
                        _this.loadingRetryTimes[key] = (_this.loadingRetryTimes[key] || 0) + 1;
                        if (_this.loadingRetryTimes[key] >= $014366ec5d4b5909$var$MAX_RETRY_TIMES) {
                            var currentLoadedKeys = _this.state.loadedKeys;
                            (0, $u43uR.default)(false, 'Retry for `loadData` many times but still failed. No more retry.');
                            _this.setUncontrolledState({
                                loadedKeys: (0, $f4FkX.arrAdd)(currentLoadedKeys, key)
                            });
                            resolve();
                        }
                        reject(e);
                    });
                    return {
                        loadingKeys: (0, $f4FkX.arrAdd)(loadingKeys, key)
                    };
                });
            });
            // Not care warning if we ignore this
            loadPromise.catch(function() {});
            return loadPromise;
        };
        _this.onNodeMouseEnter = function(event, node) {
            var onMouseEnter = _this.props.onMouseEnter;
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                event: event,
                node: node
            });
        };
        _this.onNodeMouseLeave = function(event, node) {
            var onMouseLeave = _this.props.onMouseLeave;
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                event: event,
                node: node
            });
        };
        _this.onNodeContextMenu = function(event, node) {
            var onRightClick = _this.props.onRightClick;
            if (onRightClick) {
                event.preventDefault();
                onRightClick({
                    event: event,
                    node: node
                });
            }
        };
        _this.onFocus = function() {
            var onFocus = _this.props.onFocus;
            _this.setState({
                focused: true
            });
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            onFocus === null || onFocus === void 0 || onFocus.apply(void 0, args);
        };
        _this.onBlur = function() {
            var onBlur = _this.props.onBlur;
            _this.setState({
                focused: false
            });
            _this.onActiveChange(null);
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            onBlur === null || onBlur === void 0 || onBlur.apply(void 0, args);
        };
        _this.getTreeNodeRequiredProps = function() {
            var _this$state8 = _this.state, expandedKeys = _this$state8.expandedKeys, selectedKeys = _this$state8.selectedKeys, loadedKeys = _this$state8.loadedKeys, loadingKeys = _this$state8.loadingKeys, checkedKeys = _this$state8.checkedKeys, halfCheckedKeys = _this$state8.halfCheckedKeys, dragOverNodeKey = _this$state8.dragOverNodeKey, dropPosition = _this$state8.dropPosition, keyEntities = _this$state8.keyEntities;
            return {
                expandedKeys: expandedKeys || [],
                selectedKeys: selectedKeys || [],
                loadedKeys: loadedKeys || [],
                loadingKeys: loadingKeys || [],
                checkedKeys: checkedKeys || [],
                halfCheckedKeys: halfCheckedKeys || [],
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                keyEntities: keyEntities
            };
        };
        // =========================== Expanded ===========================
        /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ _this.setExpandedKeys = function(expandedKeys) {
            var _this$state9 = _this.state, treeData = _this$state9.treeData, fieldNames = _this$state9.fieldNames;
            var flattenNodes = (0, $jh8Np.flattenTreeData)(treeData, expandedKeys, fieldNames);
            _this.setUncontrolledState({
                expandedKeys: expandedKeys,
                flattenNodes: flattenNodes
            }, true);
        };
        _this.onNodeExpand = function(e, treeNode) {
            var expandedKeys = _this.state.expandedKeys;
            var _this$state10 = _this.state, listChanging = _this$state10.listChanging, fieldNames = _this$state10.fieldNames;
            var _this$props8 = _this.props, onExpand = _this$props8.onExpand, loadData = _this$props8.loadData;
            var expanded = treeNode.expanded;
            var key = treeNode[fieldNames.key];
            // Do nothing when motion is in progress
            if (listChanging) return;
            // Update selected keys
            var index = expandedKeys.indexOf(key);
            var targetExpanded = !expanded;
            (0, $u43uR.default)(expanded && index !== -1 || !expanded && index === -1, 'Expand state not sync with index check');
            if (targetExpanded) expandedKeys = (0, $f4FkX.arrAdd)(expandedKeys, key);
            else expandedKeys = (0, $f4FkX.arrDel)(expandedKeys, key);
            _this.setExpandedKeys(expandedKeys);
            onExpand === null || onExpand === void 0 || onExpand(expandedKeys, {
                node: treeNode,
                expanded: targetExpanded,
                nativeEvent: e.nativeEvent
            });
            // Async Load data
            if (targetExpanded && loadData) {
                var loadPromise = _this.onNodeLoad(treeNode);
                if (loadPromise) loadPromise.then(function() {
                    // [Legacy] Refresh logic
                    var newFlattenTreeData = (0, $jh8Np.flattenTreeData)(_this.state.treeData, expandedKeys, fieldNames);
                    _this.setUncontrolledState({
                        flattenNodes: newFlattenTreeData
                    });
                }).catch(function() {
                    var currentExpandedKeys = _this.state.expandedKeys;
                    var expandedKeysToRestore = (0, $f4FkX.arrDel)(currentExpandedKeys, key);
                    _this.setExpandedKeys(expandedKeysToRestore);
                });
            }
        };
        _this.onListChangeStart = function() {
            _this.setUncontrolledState({
                listChanging: true
            });
        };
        _this.onListChangeEnd = function() {
            setTimeout(function() {
                _this.setUncontrolledState({
                    listChanging: false
                });
            });
        };
        // =========================== Keyboard ===========================
        _this.onActiveChange = function(newActiveKey) {
            var activeKey = _this.state.activeKey;
            var onActiveChange = _this.props.onActiveChange;
            if (activeKey === newActiveKey) return;
            _this.setState({
                activeKey: newActiveKey
            });
            if (newActiveKey !== null) _this.scrollTo({
                key: newActiveKey
            });
            onActiveChange === null || onActiveChange === void 0 || onActiveChange(newActiveKey);
        };
        _this.getActiveItem = function() {
            var _this$state11 = _this.state, activeKey = _this$state11.activeKey, flattenNodes = _this$state11.flattenNodes;
            if (activeKey === null) return null;
            return flattenNodes.find(function(_ref2) {
                var key = _ref2.key;
                return key === activeKey;
            }) || null;
        };
        _this.offsetActiveKey = function(offset) {
            var _this$state12 = _this.state, flattenNodes = _this$state12.flattenNodes, activeKey = _this$state12.activeKey;
            var index = flattenNodes.findIndex(function(_ref3) {
                var key = _ref3.key;
                return key === activeKey;
            });
            // Align with index
            if (index === -1 && offset < 0) index = flattenNodes.length;
            index = (index + offset + flattenNodes.length) % flattenNodes.length;
            var item = flattenNodes[index];
            if (item) {
                var key = item.key;
                _this.onActiveChange(key);
            } else _this.onActiveChange(null);
        };
        _this.onKeyDown = function(event) {
            var _this$state13 = _this.state, activeKey = _this$state13.activeKey, expandedKeys = _this$state13.expandedKeys, checkedKeys = _this$state13.checkedKeys, fieldNames = _this$state13.fieldNames;
            var _this$props9 = _this.props, onKeyDown = _this$props9.onKeyDown, checkable = _this$props9.checkable, selectable = _this$props9.selectable;
            // >>>>>>>>>> Direction
            switch(event.which){
                case (0, $iCi4s.default).UP:
                    _this.offsetActiveKey(-1);
                    event.preventDefault();
                    break;
                case (0, $iCi4s.default).DOWN:
                    _this.offsetActiveKey(1);
                    event.preventDefault();
                    break;
            }
            // >>>>>>>>>> Expand & Selection
            var activeItem = _this.getActiveItem();
            if (activeItem && activeItem.data) {
                var treeNodeRequiredProps = _this.getTreeNodeRequiredProps();
                var expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
                var eventNode = (0, $jh8Np.convertNodePropsToEventData)((0, $d49SP.default)((0, $d49SP.default)({}, (0, $jh8Np.getTreeNodeProps)(activeKey, treeNodeRequiredProps)), {}, {
                    data: activeItem.data,
                    active: true
                }));
                switch(event.which){
                    // >>> Expand
                    case (0, $iCi4s.default).LEFT:
                        // Collapse if possible
                        if (expandable && expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.parent) _this.onActiveChange(activeItem.parent.key);
                        event.preventDefault();
                        break;
                    case (0, $iCi4s.default).RIGHT:
                        // Expand if possible
                        if (expandable && !expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.children && activeItem.children.length) _this.onActiveChange(activeItem.children[0].key);
                        event.preventDefault();
                        break;
                    // Selection
                    case (0, $iCi4s.default).ENTER:
                    case (0, $iCi4s.default).SPACE:
                        if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) _this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                        else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) _this.onNodeSelect({}, eventNode);
                        break;
                }
            }
            onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
        };
        /**
     * Only update the value which is not in props
     */ _this.setUncontrolledState = function(state) {
            var atomic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var forceState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (!_this.destroyed) {
                var needSync = false;
                var allPassed = true;
                var newState = {};
                Object.keys(state).forEach(function(name) {
                    if (name in _this.props) {
                        allPassed = false;
                        return;
                    }
                    needSync = true;
                    newState[name] = state[name];
                });
                if (needSync && (!atomic || allPassed)) _this.setState((0, $d49SP.default)((0, $d49SP.default)({}, newState), forceState));
            }
        };
        _this.scrollTo = function(scroll) {
            _this.listRef.current.scrollTo(scroll);
        };
        return _this;
    }
    (0, $cHPF9.default)(Tree, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                this.onUpdated();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.onUpdated();
            }
        },
        {
            key: "onUpdated",
            value: function onUpdated() {
                var activeKey = this.props.activeKey;
                if (activeKey !== undefined && activeKey !== this.state.activeKey) {
                    this.setState({
                        activeKey: activeKey
                    });
                    if (activeKey !== null) this.scrollTo({
                        key: activeKey
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('dragend', this.onWindowDragEnd);
                this.destroyed = true;
            }
        },
        {
            key: "resetDragState",
            value: function resetDragState() {
                this.setState({
                    dragOverNodeKey: null,
                    dropPosition: null,
                    dropLevelOffset: null,
                    dropTargetKey: null,
                    dropContainerKey: null,
                    dropTargetPos: null,
                    dropAllowed: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _classNames;
                var _this$state14 = this.state, focused = _this$state14.focused, flattenNodes = _this$state14.flattenNodes, keyEntities = _this$state14.keyEntities, draggingNodeKey = _this$state14.draggingNodeKey, activeKey = _this$state14.activeKey, dropLevelOffset = _this$state14.dropLevelOffset, dropContainerKey = _this$state14.dropContainerKey, dropTargetKey = _this$state14.dropTargetKey, dropPosition = _this$state14.dropPosition, dragOverNodeKey = _this$state14.dragOverNodeKey, indent = _this$state14.indent;
                var _this$props10 = this.props, prefixCls = _this$props10.prefixCls, className = _this$props10.className, style = _this$props10.style, showLine = _this$props10.showLine, focusable = _this$props10.focusable, _this$props10$tabInde = _this$props10.tabIndex, tabIndex = _this$props10$tabInde === void 0 ? 0 : _this$props10$tabInde, selectable = _this$props10.selectable, showIcon = _this$props10.showIcon, icon = _this$props10.icon, switcherIcon = _this$props10.switcherIcon, draggable = _this$props10.draggable, checkable = _this$props10.checkable, checkStrictly = _this$props10.checkStrictly, disabled = _this$props10.disabled, motion = _this$props10.motion, loadData = _this$props10.loadData, filterTreeNode = _this$props10.filterTreeNode, height = _this$props10.height, itemHeight = _this$props10.itemHeight, virtual = _this$props10.virtual, titleRender = _this$props10.titleRender, dropIndicatorRender = _this$props10.dropIndicatorRender, onContextMenu = _this$props10.onContextMenu, onScroll = _this$props10.onScroll, direction = _this$props10.direction, rootClassName = _this$props10.rootClassName, rootStyle = _this$props10.rootStyle;
                var domProps = (0, $3ryW7.default)(this.props, {
                    aria: true,
                    data: true
                });
                // It's better move to hooks but we just simply keep here
                var draggableConfig;
                if (draggable) {
                    if ((0, $fSwVM.default)(draggable) === 'object') draggableConfig = draggable;
                    else if (typeof draggable === 'function') draggableConfig = {
                        nodeDraggable: draggable
                    };
                    else draggableConfig = {};
                }
                return /*#__PURE__*/ $acw62.createElement((0, $02gL0.TreeContext).Provider, {
                    value: {
                        prefixCls: prefixCls,
                        selectable: selectable,
                        showIcon: showIcon,
                        icon: icon,
                        switcherIcon: switcherIcon,
                        draggable: draggableConfig,
                        draggingNodeKey: draggingNodeKey,
                        checkable: checkable,
                        checkStrictly: checkStrictly,
                        disabled: disabled,
                        keyEntities: keyEntities,
                        dropLevelOffset: dropLevelOffset,
                        dropContainerKey: dropContainerKey,
                        dropTargetKey: dropTargetKey,
                        dropPosition: dropPosition,
                        dragOverNodeKey: dragOverNodeKey,
                        indent: indent,
                        direction: direction,
                        dropIndicatorRender: dropIndicatorRender,
                        loadData: loadData,
                        filterTreeNode: filterTreeNode,
                        titleRender: titleRender,
                        onNodeClick: this.onNodeClick,
                        onNodeDoubleClick: this.onNodeDoubleClick,
                        onNodeExpand: this.onNodeExpand,
                        onNodeSelect: this.onNodeSelect,
                        onNodeCheck: this.onNodeCheck,
                        onNodeLoad: this.onNodeLoad,
                        onNodeMouseEnter: this.onNodeMouseEnter,
                        onNodeMouseLeave: this.onNodeMouseLeave,
                        onNodeContextMenu: this.onNodeContextMenu,
                        onNodeDragStart: this.onNodeDragStart,
                        onNodeDragEnter: this.onNodeDragEnter,
                        onNodeDragOver: this.onNodeDragOver,
                        onNodeDragLeave: this.onNodeDragLeave,
                        onNodeDragEnd: this.onNodeDragEnd,
                        onNodeDrop: this.onNodeDrop
                    }
                }, /*#__PURE__*/ $acw62.createElement("div", {
                    role: "tree",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, rootClassName, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-show-line"), showLine), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-focused"), focused), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-active-focused"), activeKey !== null), _classNames)),
                    style: rootStyle
                }, /*#__PURE__*/ $acw62.createElement((0, $5hwno.default), (0, $8nd05.default)({
                    ref: this.listRef,
                    prefixCls: prefixCls,
                    style: style,
                    data: flattenNodes,
                    disabled: disabled,
                    selectable: selectable,
                    checkable: !!checkable,
                    motion: motion,
                    dragging: draggingNodeKey !== null,
                    height: height,
                    itemHeight: itemHeight,
                    virtual: virtual,
                    focusable: focusable,
                    focused: focused,
                    tabIndex: tabIndex,
                    activeItem: this.getActiveItem(),
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onKeyDown: this.onKeyDown,
                    onActiveChange: this.onActiveChange,
                    onListChangeStart: this.onListChangeStart,
                    onListChangeEnd: this.onListChangeEnd,
                    onContextMenu: onContextMenu,
                    onScroll: onScroll
                }, this.getTreeNodeRequiredProps(), domProps))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, prevState) {
                var prevProps = prevState.prevProps;
                var newState = {
                    prevProps: props
                };
                function needSync(name) {
                    return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
                }
                // ================== Tree Node ==================
                var treeData;
                // fieldNames
                var fieldNames = prevState.fieldNames;
                if (needSync('fieldNames')) {
                    fieldNames = (0, $jh8Np.fillFieldNames)(props.fieldNames);
                    newState.fieldNames = fieldNames;
                }
                // Check if `treeData` or `children` changed and save into the state.
                if (needSync('treeData')) treeData = props.treeData;
                else if (needSync('children')) {
                    (0, $u43uR.default)(false, '`children` of Tree is deprecated. Please use `treeData` instead.');
                    treeData = (0, $jh8Np.convertTreeToData)(props.children);
                }
                // Save flatten nodes info and convert `treeData` into keyEntities
                if (treeData) {
                    newState.treeData = treeData;
                    var entitiesMap = (0, $jh8Np.convertDataToEntities)(treeData, {
                        fieldNames: fieldNames
                    });
                    newState.keyEntities = (0, $d49SP.default)((0, $kSlfw.default)({}, (0, $5hwno.MOTION_KEY), (0, $5hwno.MotionEntity)), entitiesMap.keyEntities);
                }
                var keyEntities = newState.keyEntities || prevState.keyEntities;
                // ================ expandedKeys =================
                if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $f4FkX.conductExpandParent)(props.expandedKeys, keyEntities) : props.expandedKeys;
                else if (!prevProps && props.defaultExpandAll) {
                    var cloneKeyEntities = (0, $d49SP.default)({}, keyEntities);
                    delete cloneKeyEntities[0, $5hwno.MOTION_KEY];
                    newState.expandedKeys = Object.keys(cloneKeyEntities).map(function(key) {
                        return cloneKeyEntities[key].key;
                    });
                } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $f4FkX.conductExpandParent)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
                if (!newState.expandedKeys) delete newState.expandedKeys;
                // ================ flattenNodes =================
                if (treeData || newState.expandedKeys) {
                    var flattenNodes = (0, $jh8Np.flattenTreeData)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
                    newState.flattenNodes = flattenNodes;
                }
                // ================ selectedKeys =================
                if (props.selectable) {
                    if (needSync('selectedKeys')) newState.selectedKeys = (0, $f4FkX.calcSelectedKeys)(props.selectedKeys, props);
                    else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $f4FkX.calcSelectedKeys)(props.defaultSelectedKeys, props);
                }
                // ================= checkedKeys =================
                if (props.checkable) {
                    var checkedKeyEntity;
                    if (needSync('checkedKeys')) checkedKeyEntity = (0, $f4FkX.parseCheckedKeys)(props.checkedKeys) || {};
                    else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $f4FkX.parseCheckedKeys)(props.defaultCheckedKeys) || {};
                    else if (treeData) // If `treeData` changed, we also need check it
                    checkedKeyEntity = (0, $f4FkX.parseCheckedKeys)(props.checkedKeys) || {
                        checkedKeys: prevState.checkedKeys,
                        halfCheckedKeys: prevState.halfCheckedKeys
                    };
                    if (checkedKeyEntity) {
                        var _checkedKeyEntity = checkedKeyEntity, _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys, checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che, _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys, halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
                        if (!props.checkStrictly) {
                            var conductKeys = (0, $6EgAF.conductCheck)(checkedKeys, true, keyEntities);
                            checkedKeys = conductKeys.checkedKeys;
                            halfCheckedKeys = conductKeys.halfCheckedKeys;
                        }
                        newState.checkedKeys = checkedKeys;
                        newState.halfCheckedKeys = halfCheckedKeys;
                    }
                }
                // ================= loadedKeys ==================
                if (needSync('loadedKeys')) newState.loadedKeys = props.loadedKeys;
                return newState;
            }
        }
    ]);
    return Tree;
}($acw62.Component);
$014366ec5d4b5909$var$Tree.defaultProps = {
    prefixCls: 'rc-tree',
    showLine: false,
    showIcon: true,
    selectable: true,
    multiple: false,
    checkable: false,
    disabled: false,
    checkStrictly: false,
    draggable: false,
    defaultExpandParent: true,
    autoExpandParent: false,
    defaultExpandAll: false,
    defaultExpandedKeys: [],
    defaultCheckedKeys: [],
    defaultSelectedKeys: [],
    dropIndicatorRender: (0, $5rLy6.default),
    allowDrop: function allowDrop() {
        return true;
    },
    expandAction: false
};
$014366ec5d4b5909$var$Tree.TreeNode = (0, $5BDlo.default);
var $014366ec5d4b5909$export$2e2bcd8739ae039 = $014366ec5d4b5909$var$Tree;

});
parcelRegister("02gL0", function(module, exports) {

$parcel$export(module.exports, "TreeContext", () => $006d2f9f7167e028$export$dfae7d399eea2568);
/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ 
var $acw62 = parcelRequire("acw62");
var $006d2f9f7167e028$export$dfae7d399eea2568 = /*#__PURE__*/ $acw62.createContext(null);

});

parcelRegister("5rLy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f745b9b85452e9b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $3f745b9b85452e9b$export$2e2bcd8739ae039(_ref) {
    var dropPosition = _ref.dropPosition, dropLevelOffset = _ref.dropLevelOffset, indent = _ref.indent;
    var style = {
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        backgroundColor: 'red',
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: style
    });
}

});

parcelRegister("5hwno", function(module, exports) {

$parcel$export(module.exports, "MOTION_KEY", () => $3d87a790a526c3d0$export$17c02cdd52a7d889);
$parcel$export(module.exports, "MotionEntity", () => $3d87a790a526c3d0$export$2d18abad5109a402);
$parcel$export(module.exports, "default", () => $3d87a790a526c3d0$export$2e2bcd8739ae039);

var $35e8i = parcelRequire("35e8i");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $6hDTM = parcelRequire("6hDTM");

var $42Ey2 = parcelRequire("42Ey2");

var $acw62 = parcelRequire("acw62");

var $01weg = parcelRequire("01weg");

var $7vs5l = parcelRequire("7vs5l");

var $jh8Np = parcelRequire("jh8Np");
var $3d87a790a526c3d0$var$_excluded = [
    "prefixCls",
    "data",
    "selectable",
    "checkable",
    "expandedKeys",
    "selectedKeys",
    "checkedKeys",
    "loadedKeys",
    "loadingKeys",
    "halfCheckedKeys",
    "keyEntities",
    "disabled",
    "dragging",
    "dragOverNodeKey",
    "dropPosition",
    "motion",
    "height",
    "itemHeight",
    "virtual",
    "focusable",
    "activeItem",
    "focused",
    "tabIndex",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onActiveChange",
    "onListChangeStart",
    "onListChangeEnd"
];
var $3d87a790a526c3d0$var$HIDDEN_STYLE = {
    width: 0,
    height: 0,
    display: 'flex',
    overflow: 'hidden',
    opacity: 0,
    border: 0,
    padding: 0,
    margin: 0
};
var $3d87a790a526c3d0$var$noop = function noop() {};
var $3d87a790a526c3d0$export$17c02cdd52a7d889 = "RC_TREE_MOTION_".concat(Math.random());
var $3d87a790a526c3d0$var$MotionNode = {
    key: $3d87a790a526c3d0$export$17c02cdd52a7d889
};
var $3d87a790a526c3d0$export$2d18abad5109a402 = {
    key: $3d87a790a526c3d0$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: '0',
    node: $3d87a790a526c3d0$var$MotionNode,
    nodes: [
        $3d87a790a526c3d0$var$MotionNode
    ]
};
var $3d87a790a526c3d0$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $3d87a790a526c3d0$export$2d18abad5109a402.pos,
    data: $3d87a790a526c3d0$var$MotionNode,
    title: null,
    key: $3d87a790a526c3d0$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $3d87a790a526c3d0$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $3d87a790a526c3d0$var$itemKey(item) {
    var key = item.key, pos = item.pos;
    return (0, $jh8Np.getKey)(key, pos);
}
function $3d87a790a526c3d0$var$getAccessibilityPath(item) {
    var path = String(item.data.key);
    var current = item;
    while(current.parent){
        current = current.parent;
        path = "".concat(current.data.key, " > ").concat(path);
    }
    return path;
}
var $3d87a790a526c3d0$var$NodeList = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, data = props.data, selectable = props.selectable, checkable = props.checkable, expandedKeys = props.expandedKeys, selectedKeys = props.selectedKeys, checkedKeys = props.checkedKeys, loadedKeys = props.loadedKeys, loadingKeys = props.loadingKeys, halfCheckedKeys = props.halfCheckedKeys, keyEntities = props.keyEntities, disabled = props.disabled, dragging = props.dragging, dragOverNodeKey = props.dragOverNodeKey, dropPosition = props.dropPosition, motion = props.motion, height = props.height, itemHeight = props.itemHeight, virtual = props.virtual, focusable = props.focusable, activeItem = props.activeItem, focused = props.focused, tabIndex = props.tabIndex, onKeyDown = props.onKeyDown, onFocus = props.onFocus, onBlur = props.onBlur, onActiveChange = props.onActiveChange, onListChangeStart = props.onListChangeStart, onListChangeEnd = props.onListChangeEnd, domProps = (0, $9X7IJ.default)(props, $3d87a790a526c3d0$var$_excluded);
    // =============================== Ref ================================
    var listRef = $acw62.useRef(null);
    var indentMeasurerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            scrollTo: function scrollTo(scroll) {
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: function getIndentWidth() {
                return indentMeasurerRef.current.offsetWidth;
            }
        };
    });
    // ============================== Motion ==============================
    var _React$useState = $acw62.useState(expandedKeys), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), prevExpandedKeys = _React$useState2[0], setPrevExpandedKeys = _React$useState2[1];
    var _React$useState3 = $acw62.useState(data), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), prevData = _React$useState4[0], setPrevData = _React$useState4[1];
    var _React$useState5 = $acw62.useState(data), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), transitionData = _React$useState6[0], setTransitionData = _React$useState6[1];
    var _React$useState7 = $acw62.useState([]), _React$useState8 = (0, $eUqlC.default)(_React$useState7, 2), transitionRange = _React$useState8[0], setTransitionRange = _React$useState8[1];
    var _React$useState9 = $acw62.useState(null), _React$useState10 = (0, $eUqlC.default)(_React$useState9, 2), motionType = _React$useState10[0], setMotionType = _React$useState10[1];
    // When motion end but data change, this will makes data back to previous one
    var dataRef = $acw62.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        var latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $6hDTM.default)(function() {
        setPrevExpandedKeys(expandedKeys);
        var diffExpanded = (0, $7vs5l.findExpandedKeys)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                var keyIndex = prevData.findIndex(function(_ref) {
                    var key = _ref.key;
                    return key === diffExpanded.key;
                });
                var rangeNodes = $3d87a790a526c3d0$export$435bacc8d7a01e14((0, $7vs5l.getExpandRange)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                var newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $3d87a790a526c3d0$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('show');
            } else {
                var _keyIndex = data.findIndex(function(_ref2) {
                    var key = _ref2.key;
                    return key === diffExpanded.key;
                });
                var _rangeNodes = $3d87a790a526c3d0$export$435bacc8d7a01e14((0, $7vs5l.getExpandRange)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                var _newTransitionData = data.slice();
                _newTransitionData.splice(_keyIndex + 1, 0, $3d87a790a526c3d0$var$MotionFlattenData);
                setTransitionData(_newTransitionData);
                setTransitionRange(_rangeNodes);
                setMotionType('hide');
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $acw62.useEffect(function() {
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    var mergedData = motion ? transitionData : data;
    var treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, focused && activeItem && /*#__PURE__*/ $acw62.createElement("span", {
        style: $3d87a790a526c3d0$var$HIDDEN_STYLE,
        "aria-live": "assertive"
    }, $3d87a790a526c3d0$var$getAccessibilityPath(activeItem)), /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement("input", {
        style: $3d87a790a526c3d0$var$HIDDEN_STYLE,
        disabled: focusable === false || disabled,
        tabIndex: focusable !== false ? tabIndex : null,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        value: "",
        onChange: $3d87a790a526c3d0$var$noop,
        "aria-label": "for screen reader"
    })), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-treenode"),
        "aria-hidden": true,
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            visibility: 'hidden',
            height: 0,
            overflow: 'hidden',
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-indent")
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: indentMeasurerRef,
        className: "".concat(prefixCls, "-indent-unit")
    }))), /*#__PURE__*/ $acw62.createElement((0, $42Ey2.default), (0, $8nd05.default)({}, domProps, {
        data: mergedData,
        itemKey: $3d87a790a526c3d0$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        prefixCls: "".concat(prefixCls, "-list"),
        ref: listRef,
        onVisibleChange: function onVisibleChange(originList, fullList) {
            var originSet = new Set(originList);
            var restList = fullList.filter(function(item) {
                return !originSet.has(item);
            });
            // Motion node is not render. Skip motion
            if (restList.some(function(item) {
                return $3d87a790a526c3d0$var$itemKey(item) === $3d87a790a526c3d0$export$17c02cdd52a7d889;
            })) onMotionEnd();
        }
    }), function(treeNode) {
        var pos = treeNode.pos, restProps = (0, $8nd05.default)({}, ((0, $35e8i.default)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
        var mergedKey = (0, $jh8Np.getKey)(key, pos);
        delete restProps.key;
        delete restProps.children;
        var treeNodeProps = (0, $jh8Np.getTreeNodeProps)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $acw62.createElement((0, $01weg.default), (0, $8nd05.default)({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $3d87a790a526c3d0$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            onMouseMove: function onMouseMove() {
                onActiveChange(null);
            }
        }));
    }));
});
$3d87a790a526c3d0$var$NodeList.displayName = 'NodeList';
var $3d87a790a526c3d0$export$2e2bcd8739ae039 = $3d87a790a526c3d0$var$NodeList;

});
parcelRegister("35e8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $23eccd30fa89cd48$export$2e2bcd8739ae039);
function $23eccd30fa89cd48$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}

});

parcelRegister("01weg", function(module, exports) {

$parcel$export(module.exports, "default", () => $00491823df84b2f1$export$2e2bcd8739ae039);

var $35e8i = parcelRequire("35e8i");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $6hDTM = parcelRequire("6hDTM");

var $acw62 = parcelRequire("acw62");

var $02gL0 = parcelRequire("02gL0");

var $5BDlo = parcelRequire("5BDlo");

var $fpDjX = parcelRequire("fpDjX");

var $jh8Np = parcelRequire("jh8Np");
var $00491823df84b2f1$var$_excluded = [
    "className",
    "style",
    "motion",
    "motionNodes",
    "motionType",
    "onMotionStart",
    "onMotionEnd",
    "active",
    "treeNodeRequiredProps"
];
var $00491823df84b2f1$var$MotionTreeNode = function MotionTreeNode(_ref, ref) {
    var className = _ref.className, style = _ref.style, motion = _ref.motion, motionNodes = _ref.motionNodes, motionType = _ref.motionType, onOriginMotionStart = _ref.onMotionStart, onOriginMotionEnd = _ref.onMotionEnd, active = _ref.active, treeNodeRequiredProps = _ref.treeNodeRequiredProps, props = (0, $9X7IJ.default)(_ref, $00491823df84b2f1$var$_excluded);
    var _React$useState = $acw62.useState(true), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    var _React$useContext = $acw62.useContext((0, $02gL0.TreeContext)), prefixCls = _React$useContext.prefixCls;
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    var targetVisible = motionNodes && motionType !== 'hide';
    (0, $6hDTM.default)(function() {
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    var triggerMotionStart = function triggerMotionStart() {
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    var triggerMotionEndRef = $acw62.useRef(false);
    var triggerMotionEnd = function triggerMotionEnd() {
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $fpDjX.default)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    var onVisibleChanged = function onVisibleChanged(nextVisible) {
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === 'show',
        onVisibleChanged: onVisibleChanged
    }), function(_ref2, motionRef) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: motionRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-treenode-motion"), motionClassName),
            style: motionStyle
        }, motionNodes.map(function(treeNode) {
            var restProps = (0, $8nd05.default)({}, ((0, $35e8i.default)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
            delete restProps.children;
            var treeNodeProps = (0, $jh8Np.getTreeNodeProps)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $acw62.createElement((0, $5BDlo.default), (0, $8nd05.default)({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        }));
    });
    return /*#__PURE__*/ $acw62.createElement((0, $5BDlo.default), (0, $8nd05.default)({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
};
$00491823df84b2f1$var$MotionTreeNode.displayName = 'MotionTreeNode';
var $00491823df84b2f1$var$RefMotionTreeNode = /*#__PURE__*/ $acw62.forwardRef($00491823df84b2f1$var$MotionTreeNode);
var $00491823df84b2f1$export$2e2bcd8739ae039 = $00491823df84b2f1$var$RefMotionTreeNode;

});
parcelRegister("5BDlo", function(module, exports) {

$parcel$export(module.exports, "default", () => $414eed6175d6b51d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $8g1PZ = parcelRequire("8g1PZ");

var $3ryW7 = parcelRequire("3ryW7");

var $acw62 = parcelRequire("acw62");

var $02gL0 = parcelRequire("02gL0");

var $82pqs = parcelRequire("82pqs");

var $3KPsa = parcelRequire("3KPsa");

var $jh8Np = parcelRequire("jh8Np");
var $414eed6175d6b51d$var$_excluded = [
    "eventKey",
    "className",
    "style",
    "dragOver",
    "dragOverGapTop",
    "dragOverGapBottom",
    "isLeaf",
    "isStart",
    "isEnd",
    "expanded",
    "selected",
    "checked",
    "halfChecked",
    "loading",
    "domRef",
    "active",
    "data",
    "onMouseMove",
    "selectable"
];
var $414eed6175d6b51d$var$ICON_OPEN = 'open';
var $414eed6175d6b51d$var$ICON_CLOSE = 'close';
var $414eed6175d6b51d$var$defaultTitle = '---';
var $414eed6175d6b51d$var$InternalTreeNode = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(InternalTreeNode, _React$Component);
    var _super = (0, $enfmq.default)(InternalTreeNode);
    function InternalTreeNode() {
        var _this;
        (0, $6CZeq.default)(this, InternalTreeNode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            dragNodeHighlight: false
        };
        _this.selectHandle = void 0;
        _this.cacheIndent = void 0;
        _this.onSelectorClick = function(e) {
            // Click trigger before select/check operation
            var onNodeClick = _this.props.context.onNodeClick;
            onNodeClick(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props));
            if (_this.isSelectable()) _this.onSelect(e);
            else _this.onCheck(e);
        };
        _this.onSelectorDoubleClick = function(e) {
            var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
            onNodeDoubleClick(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props));
        };
        _this.onSelect = function(e) {
            if (_this.isDisabled()) return;
            var onNodeSelect = _this.props.context.onNodeSelect;
            onNodeSelect(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props));
        };
        _this.onCheck = function(e) {
            if (_this.isDisabled()) return;
            var _this$props = _this.props, disableCheckbox = _this$props.disableCheckbox, checked = _this$props.checked;
            var onNodeCheck = _this.props.context.onNodeCheck;
            if (!_this.isCheckable() || disableCheckbox) return;
            var targetChecked = !checked;
            onNodeCheck(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props), targetChecked);
        };
        _this.onMouseEnter = function(e) {
            var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
            onNodeMouseEnter(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props));
        };
        _this.onMouseLeave = function(e) {
            var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
            onNodeMouseLeave(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props));
        };
        _this.onContextMenu = function(e) {
            var onNodeContextMenu = _this.props.context.onNodeContextMenu;
            onNodeContextMenu(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props));
        };
        _this.onDragStart = function(e) {
            var onNodeDragStart = _this.props.context.onNodeDragStart;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: true
            });
            onNodeDragStart(e, (0, $hDpcU.default)(_this));
            try {
                // ie throw error
                // firefox-need-it
                e.dataTransfer.setData('text/plain', '');
            } catch (error) {
            // empty
            }
        };
        _this.onDragEnter = function(e) {
            var onNodeDragEnter = _this.props.context.onNodeDragEnter;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragEnter(e, (0, $hDpcU.default)(_this));
        };
        _this.onDragOver = function(e) {
            var onNodeDragOver = _this.props.context.onNodeDragOver;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragOver(e, (0, $hDpcU.default)(_this));
        };
        _this.onDragLeave = function(e) {
            var onNodeDragLeave = _this.props.context.onNodeDragLeave;
            e.stopPropagation();
            onNodeDragLeave(e, (0, $hDpcU.default)(_this));
        };
        _this.onDragEnd = function(e) {
            var onNodeDragEnd = _this.props.context.onNodeDragEnd;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDragEnd(e, (0, $hDpcU.default)(_this));
        };
        _this.onDrop = function(e) {
            var onNodeDrop = _this.props.context.onNodeDrop;
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDrop(e, (0, $hDpcU.default)(_this));
        };
        // Disabled item still can be switch
        _this.onExpand = function(e) {
            var _this$props2 = _this.props, loading = _this$props2.loading, onNodeExpand = _this$props2.context.onNodeExpand;
            if (loading) return;
            onNodeExpand(e, (0, $jh8Np.convertNodePropsToEventData)(_this.props));
        };
        // Drag usage
        _this.setSelectHandle = function(node) {
            _this.selectHandle = node;
        };
        _this.getNodeState = function() {
            var expanded = _this.props.expanded;
            if (_this.isLeaf()) return null;
            return expanded ? $414eed6175d6b51d$var$ICON_OPEN : $414eed6175d6b51d$var$ICON_CLOSE;
        };
        _this.hasChildren = function() {
            var eventKey = _this.props.eventKey;
            var keyEntities = _this.props.context.keyEntities;
            var _ref = (0, $3KPsa.default)(keyEntities, eventKey) || {}, children = _ref.children;
            return !!(children || []).length;
        };
        _this.isLeaf = function() {
            var _this$props3 = _this.props, isLeaf = _this$props3.isLeaf, loaded = _this$props3.loaded;
            var loadData = _this.props.context.loadData;
            var hasChildren = _this.hasChildren();
            if (isLeaf === false) return false;
            return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
        };
        _this.isDisabled = function() {
            var disabled = _this.props.disabled;
            var treeDisabled = _this.props.context.disabled;
            return !!(treeDisabled || disabled);
        };
        _this.isCheckable = function() {
            var checkable = _this.props.checkable;
            var treeCheckable = _this.props.context.checkable;
            // Return false if tree or treeNode is not checkable
            if (!treeCheckable || checkable === false) return false;
            return treeCheckable;
        };
        // Load data to avoid default expanded tree without data
        _this.syncLoadData = function(props) {
            var expanded = props.expanded, loading = props.loading, loaded = props.loaded;
            var _this$props$context = _this.props.context, loadData = _this$props$context.loadData, onNodeLoad = _this$props$context.onNodeLoad;
            if (loading) return;
            // read from state to avoid loadData at same time
            if (loadData && expanded && !_this.isLeaf()) // We needn't reload data when has children in sync logic
            // It's only needed in node expanded
            {
                if (!_this.hasChildren() && !loaded) onNodeLoad((0, $jh8Np.convertNodePropsToEventData)(_this.props));
            }
        };
        _this.isDraggable = function() {
            var _this$props4 = _this.props, data = _this$props4.data, draggable = _this$props4.context.draggable;
            return !!(draggable && (!draggable.nodeDraggable || draggable.nodeDraggable(data)));
        };
        // ==================== Render: Drag Handler ====================
        _this.renderDragHandler = function() {
            var _this$props$context2 = _this.props.context, draggable = _this$props$context2.draggable, prefixCls = _this$props$context2.prefixCls;
            return (draggable === null || draggable === void 0 ? void 0 : draggable.icon) ? /*#__PURE__*/ $acw62.createElement("span", {
                className: "".concat(prefixCls, "-draggable-icon")
            }, draggable.icon) : null;
        };
        // ====================== Render: Switcher ======================
        _this.renderSwitcherIconDom = function(isLeaf) {
            var switcherIconFromProps = _this.props.switcherIcon;
            var switcherIconFromCtx = _this.props.context.switcherIcon;
            var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
            // if switcherIconDom is null, no render switcher span
            if (typeof switcherIcon === 'function') return switcherIcon((0, $d49SP.default)((0, $d49SP.default)({}, _this.props), {}, {
                isLeaf: isLeaf
            }));
            return switcherIcon;
        };
        // Switcher
        _this.renderSwitcher = function() {
            var expanded = _this.props.expanded;
            var prefixCls = _this.props.context.prefixCls;
            if (_this.isLeaf()) {
                // if switcherIconDom is null, no render switcher span
                var _switcherIconDom = _this.renderSwitcherIconDom(true);
                return _switcherIconDom !== false ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
                }, _switcherIconDom) : null;
            }
            var switcherCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? $414eed6175d6b51d$var$ICON_OPEN : $414eed6175d6b51d$var$ICON_CLOSE));
            var switcherIconDom = _this.renderSwitcherIconDom(false);
            return switcherIconDom !== false ? /*#__PURE__*/ $acw62.createElement("span", {
                onClick: _this.onExpand,
                className: switcherCls
            }, switcherIconDom) : null;
        };
        // ====================== Render: Checkbox ======================
        // Checkbox
        _this.renderCheckbox = function() {
            var _this$props5 = _this.props, checked = _this$props5.checked, halfChecked = _this$props5.halfChecked, disableCheckbox = _this$props5.disableCheckbox;
            var prefixCls = _this.props.context.prefixCls;
            var disabled = _this.isDisabled();
            var checkable = _this.isCheckable();
            if (!checkable) return null;
            // [Legacy] Custom element should be separate with `checkable` in future
            var $custom = typeof checkable !== 'boolean' ? checkable : null;
            return /*#__PURE__*/ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
                onClick: _this.onCheck
            }, $custom);
        };
        // ==================== Render: Title + Icon ====================
        _this.renderIcon = function() {
            var loading = _this.props.loading;
            var prefixCls = _this.props.context.prefixCls;
            return /*#__PURE__*/ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || 'docu'), loading && "".concat(prefixCls, "-icon_loading"))
            });
        };
        // Icon + Title
        _this.renderSelector = function() {
            var dragNodeHighlight = _this.state.dragNodeHighlight;
            var _this$props6 = _this.props, _this$props6$title = _this$props6.title, title = _this$props6$title === void 0 ? $414eed6175d6b51d$var$defaultTitle : _this$props6$title, selected = _this$props6.selected, icon = _this$props6.icon, loading = _this$props6.loading, data = _this$props6.data;
            var _this$props$context3 = _this.props.context, prefixCls = _this$props$context3.prefixCls, showIcon = _this$props$context3.showIcon, treeIcon = _this$props$context3.icon, loadData = _this$props$context3.loadData, titleRender = _this$props$context3.titleRender;
            var disabled = _this.isDisabled();
            var wrapClass = "".concat(prefixCls, "-node-content-wrapper");
            // Icon - Still show loading icon when loading without showIcon
            var $icon;
            if (showIcon) {
                var currentIcon = icon || treeIcon;
                $icon = currentIcon ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
                }, typeof currentIcon === 'function' ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
            } else if (loadData && loading) $icon = _this.renderIcon();
            // Title
            var titleNode;
            if (typeof title === 'function') titleNode = title(data);
            else if (titleRender) titleNode = titleRender(data);
            else titleNode = title;
            var $title = /*#__PURE__*/ $acw62.createElement("span", {
                className: "".concat(prefixCls, "-title")
            }, titleNode);
            return /*#__PURE__*/ $acw62.createElement("span", {
                ref: _this.setSelectHandle,
                title: typeof title === 'string' ? title : '',
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected")),
                onMouseEnter: _this.onMouseEnter,
                onMouseLeave: _this.onMouseLeave,
                onContextMenu: _this.onContextMenu,
                onClick: _this.onSelectorClick,
                onDoubleClick: _this.onSelectorDoubleClick
            }, $icon, $title, _this.renderDropIndicator());
        };
        // =================== Render: Drop Indicator ===================
        _this.renderDropIndicator = function() {
            var _this$props7 = _this.props, disabled = _this$props7.disabled, eventKey = _this$props7.eventKey;
            var _this$props$context4 = _this.props.context, draggable = _this$props$context4.draggable, dropLevelOffset = _this$props$context4.dropLevelOffset, dropPosition = _this$props$context4.dropPosition, prefixCls = _this$props$context4.prefixCls, indent = _this$props$context4.indent, dropIndicatorRender = _this$props$context4.dropIndicatorRender, dragOverNodeKey = _this$props$context4.dragOverNodeKey, direction = _this$props$context4.direction;
            var rootDraggable = !!draggable;
            // allowDrop is calculated in Tree.tsx, there is no need for calc it here
            var showIndicator = !disabled && rootDraggable && dragOverNodeKey === eventKey;
            // This is a hot fix which is already fixed in
            // https://github.com/react-component/tree/pull/743/files
            // But some case need break point so we hack on this
            // ref https://github.com/ant-design/ant-design/issues/43493
            var mergedIndent = indent !== null && indent !== void 0 ? indent : _this.cacheIndent;
            _this.cacheIndent = indent;
            return showIndicator ? dropIndicatorRender({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                indent: mergedIndent,
                prefixCls: prefixCls,
                direction: direction
            }) : null;
        };
        return _this;
    }
    (0, $cHPF9.default)(InternalTreeNode, [
        {
            key: "componentDidMount",
            value: // Isomorphic needn't load data in server side
            function componentDidMount() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "isSelectable",
            value: function isSelectable() {
                var selectable = this.props.selectable;
                var treeSelectable = this.props.context.selectable;
                // Ignore when selectable is undefined or null
                if (typeof selectable === 'boolean') return selectable;
                return treeSelectable;
            }
        },
        {
            key: "render",
            value: // =========================== Render ===========================
            function render() {
                var _classNames;
                var _this$props8 = this.props, eventKey = _this$props8.eventKey, className = _this$props8.className, style = _this$props8.style, dragOver = _this$props8.dragOver, dragOverGapTop = _this$props8.dragOverGapTop, dragOverGapBottom = _this$props8.dragOverGapBottom, isLeaf = _this$props8.isLeaf, isStart = _this$props8.isStart, isEnd = _this$props8.isEnd, expanded = _this$props8.expanded, selected = _this$props8.selected, checked = _this$props8.checked, halfChecked = _this$props8.halfChecked, loading = _this$props8.loading, domRef = _this$props8.domRef, active = _this$props8.active, data = _this$props8.data, onMouseMove = _this$props8.onMouseMove, selectable = _this$props8.selectable, otherProps = (0, $9X7IJ.default)(_this$props8, $414eed6175d6b51d$var$_excluded);
                var _this$props$context5 = this.props.context, prefixCls = _this$props$context5.prefixCls, filterTreeNode = _this$props$context5.filterTreeNode, keyEntities = _this$props$context5.keyEntities, dropContainerKey = _this$props$context5.dropContainerKey, dropTargetKey = _this$props$context5.dropTargetKey, draggingNodeKey = _this$props$context5.draggingNodeKey;
                var disabled = this.isDisabled();
                var dataOrAriaAttributeProps = (0, $3ryW7.default)(otherProps, {
                    aria: true,
                    data: true
                });
                var _ref2 = (0, $3KPsa.default)(keyEntities, eventKey) || {}, level = _ref2.level;
                var isEndNode = isEnd[isEnd.length - 1];
                var mergedDraggable = this.isDraggable();
                var draggableWithoutDisabled = !disabled && mergedDraggable;
                var dragging = draggingNodeKey === eventKey;
                var ariaSelected = selectable !== undefined ? {
                    'aria-selected': !!selectable
                } : undefined;
                return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
                    ref: domRef,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "".concat(prefixCls, "-treenode"), (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-active"), active), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-leaf-last"), isEndNode), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-treenode-draggable"), mergedDraggable), (0, $kSlfw.default)(_classNames, "dragging", dragging), (0, $kSlfw.default)(_classNames, 'drop-target', dropTargetKey === eventKey), (0, $kSlfw.default)(_classNames, 'drop-container', dropContainerKey === eventKey), (0, $kSlfw.default)(_classNames, 'drag-over', !disabled && dragOver), (0, $kSlfw.default)(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), (0, $kSlfw.default)(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), (0, $kSlfw.default)(_classNames, 'filter-node', filterTreeNode && filterTreeNode((0, $jh8Np.convertNodePropsToEventData)(this.props))), _classNames)),
                    style: style,
                    draggable: draggableWithoutDisabled,
                    "aria-grabbed": dragging,
                    onDragStart: draggableWithoutDisabled ? this.onDragStart : undefined,
                    onDragEnter: mergedDraggable ? this.onDragEnter : undefined,
                    onDragOver: mergedDraggable ? this.onDragOver : undefined,
                    onDragLeave: mergedDraggable ? this.onDragLeave : undefined,
                    onDrop: mergedDraggable ? this.onDrop : undefined,
                    onDragEnd: mergedDraggable ? this.onDragEnd : undefined,
                    onMouseMove: onMouseMove
                }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/ $acw62.createElement((0, $82pqs.default), {
                    prefixCls: prefixCls,
                    level: level,
                    isStart: isStart,
                    isEnd: isEnd
                }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
            }
        }
    ]);
    return InternalTreeNode;
}($acw62.Component);
var $414eed6175d6b51d$var$ContextTreeNode = function ContextTreeNode(props) {
    return /*#__PURE__*/ $acw62.createElement((0, $02gL0.TreeContext).Consumer, null, function(context) {
        return /*#__PURE__*/ $acw62.createElement($414eed6175d6b51d$var$InternalTreeNode, (0, $8nd05.default)({}, props, {
            context: context
        }));
    });
};
$414eed6175d6b51d$var$ContextTreeNode.displayName = 'TreeNode';
$414eed6175d6b51d$var$ContextTreeNode.isTreeNode = 1;
var $414eed6175d6b51d$export$2e2bcd8739ae039 = $414eed6175d6b51d$var$ContextTreeNode;

});
parcelRegister("82pqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5da23ba28fbceb77$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
var $5da23ba28fbceb77$var$Indent = function Indent(_ref) {
    var prefixCls = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
    var baseClassName = "".concat(prefixCls, "-indent-unit");
    var list = [];
    for(var i = 0; i < level; i += 1){
        var _classNames;
        list.push(/*#__PURE__*/ $acw62.createElement("span", {
            key: i,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(baseClassName, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(baseClassName, "-start"), isStart[i]), (0, $kSlfw.default)(_classNames, "".concat(baseClassName, "-end"), isEnd[i]), _classNames))
        }));
    }
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-indent")
    }, list);
};
var $5da23ba28fbceb77$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($5da23ba28fbceb77$var$Indent);

});

parcelRegister("3KPsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bbd948531562d93$export$2e2bcd8739ae039);
function $2bbd948531562d93$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}

});

parcelRegister("jh8Np", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $e0866d8dd7f10128$export$a47fb462a08de82f);
$parcel$export(module.exports, "fillFieldNames", () => $e0866d8dd7f10128$export$6c519d302dced239);
$parcel$export(module.exports, "convertTreeToData", () => $e0866d8dd7f10128$export$6d8b10995563b669);
$parcel$export(module.exports, "flattenTreeData", () => $e0866d8dd7f10128$export$215c1b4f1ba88b23);
$parcel$export(module.exports, "convertDataToEntities", () => $e0866d8dd7f10128$export$e5d831ce033a4615);
$parcel$export(module.exports, "getTreeNodeProps", () => $e0866d8dd7f10128$export$d961fd523a514db5);
$parcel$export(module.exports, "convertNodePropsToEventData", () => $e0866d8dd7f10128$export$7bd1b0fd4a8b540b);

var $fSwVM = parcelRequire("fSwVM");

var $kbxxf = parcelRequire("kbxxf");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $jWR62 = parcelRequire("jWR62");

var $1pcHX = parcelRequire("1pcHX");

var $u43uR = parcelRequire("u43uR");

var $3KPsa = parcelRequire("3KPsa");
var $e0866d8dd7f10128$var$_excluded = [
    "children"
];
function $e0866d8dd7f10128$export$1690e12b840569b9(level, index) {
    return "".concat(level, "-").concat(index);
}
function $e0866d8dd7f10128$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $e0866d8dd7f10128$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $e0866d8dd7f10128$export$6c519d302dced239(fieldNames) {
    var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key = _ref.key, children = _ref.children;
    var mergedTitle = title || 'title';
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || 'key',
        children: children || 'children'
    };
}
function $e0866d8dd7f10128$export$702780ec64d148df(treeData, fieldNames) {
    var keys = new Map();
    function dig(list) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        (list || []).forEach(function(treeNode) {
            var key = treeNode[fieldNames.key];
            var children = treeNode[fieldNames.children];
            (0, $u43uR.default)(key !== null && key !== undefined, "Tree node must have a certain key: [".concat(path).concat(key, "]"));
            var recordKey = String(key);
            (0, $u43uR.default)(!keys.has(recordKey) || key === null || key === undefined, "Same 'key' exist in the Tree: ".concat(recordKey));
            keys.set(recordKey, true);
            dig(children, "".concat(path).concat(recordKey, " > "));
        });
    }
    dig(treeData);
}
function $e0866d8dd7f10128$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        var treeNodes = (0, $jWR62.default)(node);
        return treeNodes.map(function(treeNode) {
            // Filter invalidate node
            if (!$e0866d8dd7f10128$export$1c189858aa1437d7(treeNode)) {
                (0, $u43uR.default)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
                return null;
            }
            var key = treeNode.key;
            var _treeNode$props = treeNode.props, children = _treeNode$props.children, rest = (0, $9X7IJ.default)(_treeNode$props, $e0866d8dd7f10128$var$_excluded);
            var dataNode = (0, $d49SP.default)({
                key: key
            }, rest);
            var parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter(function(dataNode) {
            return dataNode;
        });
    }
    return dig(rootNodes);
}
function $e0866d8dd7f10128$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    var _fillFieldNames = $e0866d8dd7f10128$export$6c519d302dced239(fieldNames), fieldTitles = _fillFieldNames._title, fieldKey = _fillFieldNames.key, fieldChildren = _fillFieldNames.children;
    var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    var flattenList = [];
    function dig(list) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return list.map(function(treeNode, index) {
            var pos = $e0866d8dd7f10128$export$1690e12b840569b9(parent ? parent.pos : '0', index);
            var mergedKey = $e0866d8dd7f10128$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            var mergedTitle;
            for(var i = 0; i < fieldTitles.length; i += 1){
                var fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            var flattenNode = (0, $d49SP.default)((0, $d49SP.default)({}, (0, $1pcHX.default)(treeNode, [].concat((0, $kbxxf.default)(fieldTitles), [
                fieldKey,
                fieldChildren
            ]))), {}, {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [].concat((0, $kbxxf.default)(parent ? parent.isStart : []), [
                    index === 0
                ]),
                isEnd: [].concat((0, $kbxxf.default)(parent ? parent.isEnd : []), [
                    index === list.length - 1
                ])
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $e0866d8dd7f10128$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    var mergedConfig = {};
    if ((0, $fSwVM.default)(config) === 'object') mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
    var _fillFieldNames2 = $e0866d8dd7f10128$export$6c519d302dced239(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
    var mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    var syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === 'string') syntheticGetKey = function syntheticGetKey(node) {
            return node[externalGetKey];
        };
        else if (typeof externalGetKey === 'function') syntheticGetKey = function syntheticGetKey(node) {
            return externalGetKey(node);
        };
    } else syntheticGetKey = function syntheticGetKey(node, pos) {
        return $e0866d8dd7f10128$export$a47fb462a08de82f(node[fieldKey], pos);
    };
    // Process
    function processNode(node, index, parent, pathNodes) {
        var children = node ? node[mergeChildrenPropName] : dataNodes;
        var pos = node ? $e0866d8dd7f10128$export$1690e12b840569b9(parent.pos, index) : '0';
        var connectNodes = node ? [].concat((0, $kbxxf.default)(pathNodes), [
            node
        ]) : [];
        // Process node if is not root
        if (node) {
            var key = syntheticGetKey(node, pos);
            var data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(data);
        }
        // Process children node
        if (children) children.forEach(function(subNode, subIndex) {
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $e0866d8dd7f10128$export$e5d831ce033a4615(dataNodes) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
    var /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey = arguments.length > 2 ? arguments[2] : undefined;
    // Init config
    var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    var posEntities = {};
    var keyEntities = {};
    var wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $e0866d8dd7f10128$export$4b2e27469b557f9d(dataNodes, function(item) {
        var node = item.node, index = item.index, pos = item.pos, key = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
        var entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        var mergedKey = $e0866d8dd7f10128$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $e0866d8dd7f10128$export$d961fd523a514db5(key, _ref3) {
    var expandedKeys = _ref3.expandedKeys, selectedKeys = _ref3.selectedKeys, loadedKeys = _ref3.loadedKeys, loadingKeys = _ref3.loadingKeys, checkedKeys = _ref3.checkedKeys, halfCheckedKeys = _ref3.halfCheckedKeys, dragOverNodeKey = _ref3.dragOverNodeKey, dropPosition = _ref3.dropPosition, keyEntities = _ref3.keyEntities;
    var entity = (0, $3KPsa.default)(keyEntities, key);
    var treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ''),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $e0866d8dd7f10128$export$7bd1b0fd4a8b540b(props) {
    var data = props.data, expanded = props.expanded, selected = props.selected, checked = props.checked, loaded = props.loaded, loading = props.loading, halfChecked = props.halfChecked, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, pos = props.pos, active = props.active, eventKey = props.eventKey;
    var eventData = (0, $d49SP.default)((0, $d49SP.default)({}, data), {}, {
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    });
    if (!('props' in eventData)) Object.defineProperty(eventData, 'props', {
        get: function get() {
            (0, $u43uR.default)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
            return props;
        }
    });
    return eventData;
}

});


parcelRegister("fpDjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b387b11e1bcca75f$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $b387b11e1bcca75f$export$2e2bcd8739ae039(triggerStart, triggerEnd) {
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), firstMount = _React$useState2[0], setFirstMount = _React$useState2[1];
    $acw62.useLayoutEffect(function() {
        if (firstMount) {
            triggerStart();
            return function() {
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    $acw62.useLayoutEffect(function() {
        setFirstMount(true);
        return function() {
            setFirstMount(false);
        };
    }, []);
}

});


parcelRegister("7vs5l", function(module, exports) {

$parcel$export(module.exports, "findExpandedKeys", () => $577136c4898a9394$export$d561f9b5d6be9236);
$parcel$export(module.exports, "getExpandRange", () => $577136c4898a9394$export$d9cfb1169163442d);
function $577136c4898a9394$export$d561f9b5d6be9236() {
    var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var prevLen = prev.length;
    var nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        var cache = new Map();
        shorter.forEach(function(key) {
            cache.set(key, true);
        });
        var keys = longer.filter(function(key) {
            return !cache.has(key);
        });
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $577136c4898a9394$export$d9cfb1169163442d(shorter, longer, key) {
    var shorterStartIndex = shorter.findIndex(function(data) {
        return data.key === key;
    });
    var shorterEndNode = shorter[shorterStartIndex + 1];
    var longerStartIndex = longer.findIndex(function(data) {
        return data.key === key;
    });
    if (shorterEndNode) {
        var longerEndIndex = longer.findIndex(function(data) {
            return data.key === shorterEndNode.key;
        });
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}

});


parcelRegister("f4FkX", function(module, exports) {

$parcel$export(module.exports, "arrDel", () => $af974b6720932c91$export$5bfb9ff497fe2298);
$parcel$export(module.exports, "arrAdd", () => $af974b6720932c91$export$10663f6bbd2fd717);
$parcel$export(module.exports, "posToArr", () => $af974b6720932c91$export$ddaee97dc8907312);
$parcel$export(module.exports, "getDragChildrenKeys", () => $af974b6720932c91$export$b0610c44bcbb051c);
$parcel$export(module.exports, "calcDropPosition", () => $af974b6720932c91$export$78a5519d0fb779c3);
$parcel$export(module.exports, "calcSelectedKeys", () => $af974b6720932c91$export$fffc10811828fd68);
$parcel$export(module.exports, "parseCheckedKeys", () => $af974b6720932c91$export$29d4989c23990d41);
$parcel$export(module.exports, "conductExpandParent", () => $af974b6720932c91$export$fac4a40c345ccd80);

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $5BDlo = parcelRequire("5BDlo");

var $3KPsa = parcelRequire("3KPsa");

var $jh8Np = parcelRequire("jh8Np");
var $af974b6720932c91$var$_excluded = [
    "children"
];
function $af974b6720932c91$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    var clone = list.slice();
    var index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $af974b6720932c91$export$10663f6bbd2fd717(list, value) {
    var clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $af974b6720932c91$export$ddaee97dc8907312(pos) {
    return pos.split('-');
}
function $af974b6720932c91$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    var dragChildrenKeys = [];
    var entity = (0, $3KPsa.default)(keyEntities, dragNodeKey);
    function dig() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        list.forEach(function(_ref) {
            var key = _ref.key, children = _ref.children;
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $af974b6720932c91$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        var posArr = $af974b6720932c91$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $af974b6720932c91$export$b823688e4155eb8d(treeNodeEntity) {
    var posArr = $af974b6720932c91$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $af974b6720932c91$export$78a5519d0fb779c3(event, dragNode, targetNode, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    var _abstractDropNodeEnti;
    var clientX = event.clientX, clientY = event.clientY;
    var _event$target$getBoun = event.target.getBoundingClientRect(), top = _event$target$getBoun.top, height = _event$target$getBoun.height;
    // optional chain for testing
    var horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
    var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // find abstract drop node by horizontal offset
    var abstractDropNodeEntity = (0, $3KPsa.default)(keyEntities, targetNode.props.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
            return flattenedNode.key === abstractDropNodeEntity.key;
        });
        var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        var prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $3KPsa.default)(keyEntities, prevNodeKey);
    }
    var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    var abstractDragOverEntity = abstractDropNodeEntity;
    var dragOverNodeKey = abstractDropNodeEntity.key;
    var dropPosition = 0;
    var dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!expandKeys.includes(initialAbstractDropNodeKey)) for(var i = 0; i < rawDropLevelOffset; i += 1){
        if ($af974b6720932c91$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    var abstractDragDataNode = dragNode.props.data;
    var abstractDropDataNode = abstractDropNodeEntity.node;
    var dropAllowed = true;
    if ($af974b6720932c91$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNode.props.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && expandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
        dropAllowed: dropAllowed
    };
}
function $af974b6720932c91$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    var multiple = props.multiple;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
var $af974b6720932c91$var$internalProcessProps = function internalProcessProps(props) {
    return props;
};
function $af974b6720932c91$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    var _ref2 = processor || {}, _ref2$processProps = _ref2.processProps, processProps = _ref2$processProps === void 0 ? $af974b6720932c91$var$internalProcessProps : _ref2$processProps;
    var list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(function(_ref3) {
        var children = _ref3.children, props = (0, $9X7IJ.default)(_ref3, $af974b6720932c91$var$_excluded);
        var childrenNodes = $af974b6720932c91$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5BDlo.default), (0, $8nd05.default)({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $af974b6720932c91$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    var keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if ((0, $fSwVM.default)(keys) === 'object') keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $u43uR.default)(false, '`checkedKeys` is not an array or an object');
        return null;
    }
    return keyProps;
}
function $af974b6720932c91$export$fac4a40c345ccd80(keyList, keyEntities) {
    var expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        var entity = (0, $3KPsa.default)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        var parent = entity.parent, node = entity.node;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach(function(key) {
        conductUp(key);
    });
    return (0, $kbxxf.default)(expandedKeys);
}

});

parcelRegister("6EgAF", function(module, exports) {

$parcel$export(module.exports, "conductCheck", () => $4d7359063b3a6d19$export$43adf2c483e3e633);

var $u43uR = parcelRequire("u43uR");

var $3KPsa = parcelRequire("3KPsa");
function $4d7359063b3a6d19$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    var filteredKeys = new Set();
    halfCheckedKeys.forEach(function(key) {
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $4d7359063b3a6d19$export$ab01c86170b1dea0(node) {
    var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $4d7359063b3a6d19$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    var visitedKeys = new Set();
    for(var _level = maxLevel; _level >= 0; _level -= 1){
        var _entities = levelEntities.get(_level) || new Set();
        _entities.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref2) {
                var key = _ref2.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($4d7359063b3a6d19$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $4d7359063b3a6d19$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    var visitedKeys = new Set();
    for(var _level2 = maxLevel; _level2 >= 0; _level2 -= 1){
        var _entities2 = levelEntities.get(_level2) || new Set();
        _entities2.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref3) {
                var key = _ref3.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($4d7359063b3a6d19$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $4d7359063b3a6d19$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    var warningMissKeys = [];
    var syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $4d7359063b3a6d19$export$ab01c86170b1dea0;
    // We only handle exist keys
    var keys = new Set(keyList.filter(function(key) {
        var hasEntity = !!(0, $3KPsa.default)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    var levelEntities = new Map();
    var maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach(function(key) {
        var entity = keyEntities[key];
        var level = entity.level;
        var levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $u43uR.default)(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function(key) {
        return "'".concat(key, "'");
    }).join(', ')));
    var result;
    if (checked === true) result = $4d7359063b3a6d19$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $4d7359063b3a6d19$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}

});



parcelRegister("95Dw3", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $69e33bbee66cc7cc$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $69e33bbee66cc7cc$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $69e33bbee66cc7cc$var$_typeof2 = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("41YNz")));

var $69e33bbee66cc7cc$var$_defineProperty2 = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $69e33bbee66cc7cc$var$_extends2 = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $69e33bbee66cc7cc$var$_slicedToArray2 = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $69e33bbee66cc7cc$var$_classnames = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $69e33bbee66cc7cc$var$_rcTable = $69e33bbee66cc7cc$var$_interopRequireWildcard((parcelRequire("4XkeF")));

var $yfNZO = parcelRequire("yfNZO");

var $8e6wL = parcelRequire("8e6wL");

var $69e33bbee66cc7cc$var$_omit = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $69e33bbee66cc7cc$var$React = $69e33bbee66cc7cc$var$_interopRequireWildcard((parcelRequire("acw62")));

var $kGKTK = parcelRequire("kGKTK");

var $69e33bbee66cc7cc$var$_defaultRenderEmpty = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("gAKvZ")));

var $69e33bbee66cc7cc$var$_SizeContext = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("lGUuX")));

var $69e33bbee66cc7cc$var$_useBreakpoint = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("3Qm97")));

var $69e33bbee66cc7cc$var$_en_US = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("5m2JC")));

var $69e33bbee66cc7cc$var$_pagination = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("euWHl")));

var $69e33bbee66cc7cc$var$_spin = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("kocCJ")));

var $69e33bbee66cc7cc$var$_scrollTo = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("eE7eL")));

var $69e33bbee66cc7cc$var$_warning = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $69e33bbee66cc7cc$var$_Column = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("4SWGn")));

var $69e33bbee66cc7cc$var$_ColumnGroup = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("75kfU")));

var $69e33bbee66cc7cc$var$_ExpandIcon = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("e0a4M")));

var $69e33bbee66cc7cc$var$_useFilter3 = $69e33bbee66cc7cc$var$_interopRequireWildcard((parcelRequire("16R5D")));

var $69e33bbee66cc7cc$var$_useLazyKVMap3 = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("dNMvG")));

var $69e33bbee66cc7cc$var$_usePagination3 = $69e33bbee66cc7cc$var$_interopRequireWildcard((parcelRequire("lPwfn")));

var $69e33bbee66cc7cc$var$_useSelection3 = $69e33bbee66cc7cc$var$_interopRequireWildcard((parcelRequire("6MYux")));

var $69e33bbee66cc7cc$var$_useSorter3 = $69e33bbee66cc7cc$var$_interopRequireWildcard((parcelRequire("jeA0l")));

var $69e33bbee66cc7cc$var$_useTitleColumns3 = $69e33bbee66cc7cc$var$_interopRequireDefault((parcelRequire("4XvYz")));
var $69e33bbee66cc7cc$var$EMPTY_LIST = [];
function $69e33bbee66cc7cc$var$InternalTable(props, ref) {
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, customizeSize = props.size, bordered = props.bordered, customizeDropdownPrefixCls = props.dropdownPrefixCls, dataSource = props.dataSource, pagination = props.pagination, rowSelection = props.rowSelection, _props$rowKey = props.rowKey, rowKey = _props$rowKey === void 0 ? 'key' : _props$rowKey, rowClassName = props.rowClassName, columns = props.columns, children = props.children, legacyChildrenColumnName = props.childrenColumnName, onChange = props.onChange, getPopupContainer = props.getPopupContainer, loading = props.loading, expandIcon = props.expandIcon, expandable = props.expandable, expandedRowRender = props.expandedRowRender, expandIconColumnIndex = props.expandIconColumnIndex, indentSize = props.indentSize, scroll = props.scroll, sortDirections = props.sortDirections, locale = props.locale, _props$showSorterTool = props.showSorterTooltip, showSorterTooltip = _props$showSorterTool === void 0 ? true : _props$showSorterTool;
    [
        [
            'filterDropdownVisible',
            'filterDropdownOpen'
        ],
        [
            'onFilterDropdownVisibleChange',
            'onFilterDropdownOpenChange'
        ]
    ].forEach(function(_ref) {
        var _ref2 = (0, $69e33bbee66cc7cc$var$_slicedToArray2["default"])(_ref, 2), deprecatedName = _ref2[0], newName = _ref2[1];
    });
    var baseColumns = $69e33bbee66cc7cc$var$React.useMemo(function() {
        return columns || (0, $yfNZO.convertChildrenToColumns)(children);
    }, [
        columns,
        children
    ]);
    var needResponsive = $69e33bbee66cc7cc$var$React.useMemo(function() {
        return baseColumns.some(function(col) {
            return col.responsive;
        });
    }, [
        baseColumns
    ]);
    var screens = (0, $69e33bbee66cc7cc$var$_useBreakpoint["default"])(needResponsive);
    var mergedColumns = $69e33bbee66cc7cc$var$React.useMemo(function() {
        var matched = new Set(Object.keys(screens).filter(function(m) {
            return screens[m];
        }));
        return baseColumns.filter(function(c) {
            return !c.responsive || c.responsive.some(function(r) {
                return matched.has(r);
            });
        });
    }, [
        baseColumns,
        screens
    ]);
    var tableProps = (0, $69e33bbee66cc7cc$var$_omit["default"])(props, [
        'className',
        'style',
        'columns'
    ]);
    var size = $69e33bbee66cc7cc$var$React.useContext($69e33bbee66cc7cc$var$_SizeContext["default"]);
    var _React$useContext = $69e33bbee66cc7cc$var$React.useContext($kGKTK.ConfigContext), _React$useContext$loc = _React$useContext.locale, contextLocale = _React$useContext$loc === void 0 ? $69e33bbee66cc7cc$var$_en_US["default"] : _React$useContext$loc, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction;
    var mergedSize = customizeSize || size;
    var tableLocale = (0, $69e33bbee66cc7cc$var$_extends2["default"])((0, $69e33bbee66cc7cc$var$_extends2["default"])({}, contextLocale.Table), locale);
    var rawData = dataSource || $69e33bbee66cc7cc$var$EMPTY_LIST;
    var _React$useContext2 = $69e33bbee66cc7cc$var$React.useContext($kGKTK.ConfigContext), getPrefixCls = _React$useContext2.getPrefixCls;
    var prefixCls = getPrefixCls('table', customizePrefixCls);
    var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
    var mergedExpandable = (0, $69e33bbee66cc7cc$var$_extends2["default"])({
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex
    }, expandable);
    var _mergedExpandable$chi = mergedExpandable.childrenColumnName, childrenColumnName = _mergedExpandable$chi === void 0 ? 'children' : _mergedExpandable$chi;
    var expandType = $69e33bbee66cc7cc$var$React.useMemo(function() {
        if (rawData.some(function(item) {
            return item === null || item === void 0 ? void 0 : item[childrenColumnName];
        })) return 'nest';
        if (expandedRowRender || expandable && expandable.expandedRowRender) return 'row';
        return null;
    }, [
        rawData
    ]);
    var internalRefs = {
        body: $69e33bbee66cc7cc$var$React.useRef()
    };
    // ============================ RowKey ============================
    var getRowKey = $69e33bbee66cc7cc$var$React.useMemo(function() {
        if (typeof rowKey === 'function') return rowKey;
        return function(record) {
            return record === null || record === void 0 ? void 0 : record[rowKey];
        };
    }, [
        rowKey
    ]);
    var _useLazyKVMap = (0, $69e33bbee66cc7cc$var$_useLazyKVMap3["default"])(rawData, childrenColumnName, getRowKey), _useLazyKVMap2 = (0, $69e33bbee66cc7cc$var$_slicedToArray2["default"])(_useLazyKVMap, 1), getRecordByKey = _useLazyKVMap2[0];
    // ============================ Events =============================
    var changeEventInfo = {};
    var triggerOnChange = function triggerOnChange(info, action) {
        var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var changeInfo = (0, $69e33bbee66cc7cc$var$_extends2["default"])((0, $69e33bbee66cc7cc$var$_extends2["default"])({}, changeEventInfo), info);
        if (reset) {
            changeEventInfo.resetPagination();
            // Reset event param
            if (changeInfo.pagination.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination && pagination.onChange) pagination.onChange(1, changeInfo.pagination.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) (0, $69e33bbee66cc7cc$var$_scrollTo["default"])(0, {
            getContainer: function getContainer() {
                return internalRefs.body.current;
            }
        });
        onChange === null || onChange === void 0 || onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $69e33bbee66cc7cc$var$_useFilter3.getFilterData)((0, $69e33bbee66cc7cc$var$_useSorter3.getSortData)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    var onSorterChange = function onSorterChange(sorter, sorterStates) {
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, 'sort', false);
    };
    var _useSorter = (0, $69e33bbee66cc7cc$var$_useSorter3["default"])({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            'ascend',
            'descend'
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip
    }), _useSorter2 = (0, $69e33bbee66cc7cc$var$_slicedToArray2["default"])(_useSorter, 4), transformSorterColumns = _useSorter2[0], sortStates = _useSorter2[1], sorterTitleProps = _useSorter2[2], getSorters = _useSorter2[3];
    var sortedData = $69e33bbee66cc7cc$var$React.useMemo(function() {
        return (0, $69e33bbee66cc7cc$var$_useSorter3.getSortData)(rawData, sortStates, childrenColumnName);
    }, [
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    var onFilterChange = function onFilterChange(filters, filterStates) {
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, 'filter', true);
    };
    var _useFilter = (0, $69e33bbee66cc7cc$var$_useFilter3["default"])({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer
    }), _useFilter2 = (0, $69e33bbee66cc7cc$var$_slicedToArray2["default"])(_useFilter, 3), transformFilterColumns = _useFilter2[0], filterStates = _useFilter2[1], filters = _useFilter2[2];
    var mergedData = (0, $69e33bbee66cc7cc$var$_useFilter3.getFilterData)(sortedData, filterStates);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    var columnTitleProps = $69e33bbee66cc7cc$var$React.useMemo(function() {
        var mergedFilters = {};
        Object.keys(filters).forEach(function(filterKey) {
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return (0, $69e33bbee66cc7cc$var$_extends2["default"])((0, $69e33bbee66cc7cc$var$_extends2["default"])({}, sorterTitleProps), {
            filters: mergedFilters
        });
    }, [
        sorterTitleProps,
        filters
    ]);
    var _useTitleColumns = (0, $69e33bbee66cc7cc$var$_useTitleColumns3["default"])(columnTitleProps), _useTitleColumns2 = (0, $69e33bbee66cc7cc$var$_slicedToArray2["default"])(_useTitleColumns, 1), transformTitleColumns = _useTitleColumns2[0];
    // ========================== Pagination ==========================
    var onPaginationChange = function onPaginationChange(current, pageSize) {
        triggerOnChange({
            pagination: (0, $69e33bbee66cc7cc$var$_extends2["default"])((0, $69e33bbee66cc7cc$var$_extends2["default"])({}, changeEventInfo.pagination), {
                current: current,
                pageSize: pageSize
            })
        }, 'paginate');
    };
    var _usePagination = (0, $69e33bbee66cc7cc$var$_usePagination3["default"])(mergedData.length, pagination, onPaginationChange), _usePagination2 = (0, $69e33bbee66cc7cc$var$_slicedToArray2["default"])(_usePagination, 2), mergedPagination = _usePagination2[0], resetPagination = _usePagination2[1];
    changeEventInfo.pagination = pagination === false ? {} : (0, $69e33bbee66cc7cc$var$_usePagination3.getPaginationParam)(pagination, mergedPagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    var pageData = $69e33bbee66cc7cc$var$React.useMemo(function() {
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        var _mergedPagination$cur = mergedPagination.current, current = _mergedPagination$cur === void 0 ? 1 : _mergedPagination$cur, total = mergedPagination.total, _mergedPagination$pag = mergedPagination.pageSize, pageSize = _mergedPagination$pag === void 0 ? $69e33bbee66cc7cc$var$_usePagination3.DEFAULT_PAGE_SIZE : _mergedPagination$pag;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination && mergedPagination.current,
        mergedPagination && mergedPagination.pageSize,
        mergedPagination && mergedPagination.total
    ]);
    // ========================== Selections ==========================
    var _useSelection = (0, $69e33bbee66cc7cc$var$_useSelection3["default"])(rowSelection, {
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer
    }), _useSelection2 = (0, $69e33bbee66cc7cc$var$_slicedToArray2["default"])(_useSelection, 2), transformSelectionColumns = _useSelection2[0], selectedKeySet = _useSelection2[1];
    var internalRowClassName = function internalRowClassName(record, index, indent) {
        var mergedRowClassName;
        if (typeof rowClassName === 'function') mergedRowClassName = (0, $69e33bbee66cc7cc$var$_classnames["default"])(rowClassName(record, index, indent));
        else mergedRowClassName = (0, $69e33bbee66cc7cc$var$_classnames["default"])(rowClassName);
        return (0, $69e33bbee66cc7cc$var$_classnames["default"])((0, $69e33bbee66cc7cc$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-row-selected"), selectedKeySet.has(getRowKey(record, index))), mergedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `rc-table`, this can be removed when refactor with `rc-table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $69e33bbee66cc7cc$var$_ExpandIcon["default"])(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== 'number') mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
    // ============================ Render ============================
    var transformColumns = $69e33bbee66cc7cc$var$React.useCallback(function(innerColumns) {
        return transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns))));
    }, [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    var topPaginationNode;
    var bottomPaginationNode;
    if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
        var paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
        var renderPagination = function renderPagination(position) {
            return /*#__PURE__*/ $69e33bbee66cc7cc$var$React.createElement($69e33bbee66cc7cc$var$_pagination["default"], (0, $69e33bbee66cc7cc$var$_extends2["default"])({}, mergedPagination, {
                className: (0, $69e33bbee66cc7cc$var$_classnames["default"])("".concat(prefixCls, "-pagination ").concat(prefixCls, "-pagination-").concat(position), mergedPagination.className),
                size: paginationSize
            }));
        };
        var defaultPosition = direction === 'rtl' ? 'left' : 'right';
        var position = mergedPagination.position;
        if (position !== null && Array.isArray(position)) {
            var topPos = position.find(function(p) {
                return p.includes('top');
            });
            var bottomPos = position.find(function(p) {
                return p.includes('bottom');
            });
            var isDisable = position.every(function(p) {
                return "".concat(p) === 'none';
            });
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination(defaultPosition);
            if (topPos) topPaginationNode = renderPagination(topPos.toLowerCase().replace('top', ''));
            if (bottomPos) bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace('bottom', ''));
        } else bottomPaginationNode = renderPagination(defaultPosition);
    }
    // >>>>>>>>> Spinning
    var spinProps;
    if (typeof loading === 'boolean') spinProps = {
        spinning: loading
    };
    else if ((0, $69e33bbee66cc7cc$var$_typeof2["default"])(loading) === 'object') spinProps = (0, $69e33bbee66cc7cc$var$_extends2["default"])({
        spinning: true
    }, loading);
    var wrapperClassNames = (0, $69e33bbee66cc7cc$var$_classnames["default"])("".concat(prefixCls, "-wrapper"), (0, $69e33bbee66cc7cc$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $69e33bbee66cc7cc$var$React.createElement("div", {
        ref: ref,
        className: wrapperClassNames,
        style: style
    }, /*#__PURE__*/ $69e33bbee66cc7cc$var$React.createElement($69e33bbee66cc7cc$var$_spin["default"], (0, $69e33bbee66cc7cc$var$_extends2["default"])({
        spinning: false
    }, spinProps), topPaginationNode, /*#__PURE__*/ $69e33bbee66cc7cc$var$React.createElement($69e33bbee66cc7cc$var$_rcTable["default"], (0, $69e33bbee66cc7cc$var$_extends2["default"])({}, tableProps, {
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, $69e33bbee66cc7cc$var$_classnames["default"])((0, $69e33bbee66cc7cc$var$_defineProperty2["default"])((0, $69e33bbee66cc7cc$var$_defineProperty2["default"])((0, $69e33bbee66cc7cc$var$_defineProperty2["default"])((0, $69e33bbee66cc7cc$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-middle"), mergedSize === 'middle'), "".concat(prefixCls, "-small"), mergedSize === 'small'), "".concat(prefixCls, "-bordered"), bordered), "".concat(prefixCls, "-empty"), rawData.length === 0)),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: locale && locale.emptyText || (renderEmpty || $69e33bbee66cc7cc$var$_defaultRenderEmpty["default"])('Table'),
        // Internal
        internalHooks: $8e6wL.INTERNAL_HOOKS,
        internalRefs: internalRefs,
        transformColumns: transformColumns
    })), bottomPaginationNode));
}
var $69e33bbee66cc7cc$var$ForwardTable = /*#__PURE__*/ $69e33bbee66cc7cc$var$React.forwardRef($69e33bbee66cc7cc$var$InternalTable);
var $69e33bbee66cc7cc$var$Table = $69e33bbee66cc7cc$var$ForwardTable;
$69e33bbee66cc7cc$var$Table.SELECTION_COLUMN = $69e33bbee66cc7cc$var$_useSelection3.SELECTION_COLUMN;
$69e33bbee66cc7cc$var$Table.EXPAND_COLUMN = $69e33bbee66cc7cc$var$_rcTable["default"].EXPAND_COLUMN;
$69e33bbee66cc7cc$var$Table.SELECTION_ALL = $69e33bbee66cc7cc$var$_useSelection3.SELECTION_ALL;
$69e33bbee66cc7cc$var$Table.SELECTION_INVERT = $69e33bbee66cc7cc$var$_useSelection3.SELECTION_INVERT;
$69e33bbee66cc7cc$var$Table.SELECTION_NONE = $69e33bbee66cc7cc$var$_useSelection3.SELECTION_NONE;
$69e33bbee66cc7cc$var$Table.Column = $69e33bbee66cc7cc$var$_Column["default"];
$69e33bbee66cc7cc$var$Table.ColumnGroup = $69e33bbee66cc7cc$var$_ColumnGroup["default"];
$69e33bbee66cc7cc$var$Table.Summary = $69e33bbee66cc7cc$var$_rcTable.Summary;
var $69e33bbee66cc7cc$var$_default = module.exports["default"] = $69e33bbee66cc7cc$var$Table;

});
parcelRegister("3pEGv", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $27c3440315f0d929$var$_typeof = $41YNz.default;
function $27c3440315f0d929$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($27c3440315f0d929$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $27c3440315f0d929$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $27c3440315f0d929$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $27c3440315f0d929$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = $27c3440315f0d929$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("yfNZO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertChildrenToColumns = $066f6fb60e667d68$var$convertChildrenToColumns;
module.exports.default = void 0;

var $066f6fb60e667d68$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $066f6fb60e667d68$var$_toConsumableArray2 = $1jnue((parcelRequire("fUHKi")));

var $066f6fb60e667d68$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $066f6fb60e667d68$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $066f6fb60e667d68$var$React = $066f6fb60e667d68$var$_interopRequireWildcard((parcelRequire("acw62")));

var $066f6fb60e667d68$var$_warning = $1jnue((parcelRequire("dtSXD")));

var $066f6fb60e667d68$var$_toArray = $1jnue((parcelRequire("13r7s")));

var $I7oBG = parcelRequire("I7oBG");

var $7Vlkq = parcelRequire("7Vlkq");
var $066f6fb60e667d68$var$_excluded = [
    "children"
], $066f6fb60e667d68$var$_excluded2 = [
    "fixed"
];
function $066f6fb60e667d68$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($066f6fb60e667d68$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $066f6fb60e667d68$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $066f6fb60e667d68$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $066f6fb60e667d68$var$convertChildrenToColumns(children) {
    return (0, $066f6fb60e667d68$var$_toArray.default)(children).filter(function(node) {
        return /*#__PURE__*/ $066f6fb60e667d68$var$React.isValidElement(node);
    }).map(function(_ref) {
        var key = _ref.key, props = _ref.props;
        var nodeChildren = props.children, restProps = (0, $066f6fb60e667d68$var$_objectWithoutProperties2.default)(props, $066f6fb60e667d68$var$_excluded);
        var column = (0, $066f6fb60e667d68$var$_objectSpread2.default)({
            key: key
        }, restProps);
        if (nodeChildren) column.children = $066f6fb60e667d68$var$convertChildrenToColumns(nodeChildren);
        return column;
    });
}
function $066f6fb60e667d68$var$flatColumns(columns) {
    return columns.reduce(function(list, column) {
        var fixed = column.fixed; // Convert `fixed='true'` to `fixed='left'` instead
        var parsedFixed = fixed === true ? 'left' : fixed;
        var subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [].concat((0, $066f6fb60e667d68$var$_toConsumableArray2.default)(list), (0, $066f6fb60e667d68$var$_toConsumableArray2.default)($066f6fb60e667d68$var$flatColumns(subColumns).map(function(subColum) {
            return (0, $066f6fb60e667d68$var$_objectSpread2.default)({
                fixed: parsedFixed
            }, subColum);
        })));
        return [].concat((0, $066f6fb60e667d68$var$_toConsumableArray2.default)(list), [
            (0, $066f6fb60e667d68$var$_objectSpread2.default)((0, $066f6fb60e667d68$var$_objectSpread2.default)({}, column), {}, {
                fixed: parsedFixed
            })
        ]);
    }, []);
}
function $066f6fb60e667d68$var$warningFixed(flattenColumns) {
    var allFixLeft = true;
    for(var i = 0; i < flattenColumns.length; i += 1){
        var col = flattenColumns[i];
        if (allFixLeft && col.fixed !== 'left') allFixLeft = false;
        else if (!allFixLeft && col.fixed === 'left') {
            (0, $066f6fb60e667d68$var$_warning.default)(false, "Index ".concat(i - 1, " of `columns` missing `fixed='left'` prop."));
            break;
        }
    }
    var allFixRight = true;
    for(var _i = flattenColumns.length - 1; _i >= 0; _i -= 1){
        var _col = flattenColumns[_i];
        if (allFixRight && _col.fixed !== 'right') allFixRight = false;
        else if (!allFixRight && _col.fixed === 'right') {
            (0, $066f6fb60e667d68$var$_warning.default)(false, "Index ".concat(_i + 1, " of `columns` missing `fixed='right'` prop."));
            break;
        }
    }
}
function $066f6fb60e667d68$var$revertForRtl(columns) {
    return columns.map(function(column) {
        var fixed = column.fixed, restProps = (0, $066f6fb60e667d68$var$_objectWithoutProperties2.default)(column, $066f6fb60e667d68$var$_excluded2); // Convert `fixed='left'` to `fixed='right'` instead
        var parsedFixed = fixed;
        if (fixed === 'left') parsedFixed = 'right';
        else if (fixed === 'right') parsedFixed = 'left';
        return (0, $066f6fb60e667d68$var$_objectSpread2.default)({
            fixed: parsedFixed
        }, restProps);
    });
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $066f6fb60e667d68$var$useColumns(_ref2, transformColumns) {
    var prefixCls = _ref2.prefixCls, columns = _ref2.columns, children = _ref2.children, expandable = _ref2.expandable, expandedKeys = _ref2.expandedKeys, columnTitle = _ref2.columnTitle, getRowKey = _ref2.getRowKey, onTriggerExpand = _ref2.onTriggerExpand, expandIcon = _ref2.expandIcon, rowExpandable = _ref2.rowExpandable, expandIconColumnIndex = _ref2.expandIconColumnIndex, direction = _ref2.direction, expandRowByClick = _ref2.expandRowByClick, columnWidth = _ref2.columnWidth, fixed = _ref2.fixed;
    var baseColumns = $066f6fb60e667d68$var$React.useMemo(function() {
        return columns || $066f6fb60e667d68$var$convertChildrenToColumns(children);
    }, [
        columns,
        children
    ]); // ========================== Expand ==========================
    var withExpandColumns = $066f6fb60e667d68$var$React.useMemo(function() {
        if (expandable) {
            var _expandColumn;
            var cloneColumns = baseColumns.slice(); // >>> Warning if use `expandIconColumnIndex`
            if (!cloneColumns.includes($7Vlkq.EXPAND_COLUMN)) {
                var expandColIndex = expandIconColumnIndex || 0;
                if (expandColIndex >= 0) cloneColumns.splice(expandColIndex, 0, $7Vlkq.EXPAND_COLUMN);
            } // >>> Deduplicate additional expand column
            var expandColumnIndex = cloneColumns.indexOf($7Vlkq.EXPAND_COLUMN);
            cloneColumns = cloneColumns.filter(function(column, index) {
                return column !== $7Vlkq.EXPAND_COLUMN || index === expandColumnIndex;
            }); // >>> Check if expand column need to fixed
            var prevColumn = baseColumns[expandColumnIndex];
            var fixedColumn;
            if ((fixed === 'left' || fixed) && !expandIconColumnIndex) fixedColumn = 'left';
            else if ((fixed === 'right' || fixed) && expandIconColumnIndex === baseColumns.length) fixedColumn = 'right';
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
             // >>> Create expandable column
            var expandColumn = (_expandColumn = {}, (0, $066f6fb60e667d68$var$_defineProperty2.default)(_expandColumn, $I7oBG.INTERNAL_COL_DEFINE, {
                className: "".concat(prefixCls, "-expand-icon-col"),
                columnType: 'EXPAND_COLUMN'
            }), (0, $066f6fb60e667d68$var$_defineProperty2.default)(_expandColumn, "title", columnTitle), (0, $066f6fb60e667d68$var$_defineProperty2.default)(_expandColumn, "fixed", fixedColumn), (0, $066f6fb60e667d68$var$_defineProperty2.default)(_expandColumn, "className", "".concat(prefixCls, "-row-expand-icon-cell")), (0, $066f6fb60e667d68$var$_defineProperty2.default)(_expandColumn, "width", columnWidth), (0, $066f6fb60e667d68$var$_defineProperty2.default)(_expandColumn, "render", function render(_, record, index) {
                var rowKey = getRowKey(record, index);
                var expanded = expandedKeys.has(rowKey);
                var recordExpandable = rowExpandable ? rowExpandable(record) : true;
                var icon = expandIcon({
                    prefixCls: prefixCls,
                    expanded: expanded,
                    expandable: recordExpandable,
                    record: record,
                    onExpand: onTriggerExpand
                });
                if (expandRowByClick) return /*#__PURE__*/ $066f6fb60e667d68$var$React.createElement("span", {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    }
                }, icon);
                return icon;
            }), _expandColumn);
            return cloneColumns.map(function(col) {
                return col === $7Vlkq.EXPAND_COLUMN ? expandColumn : col;
            });
        }
        return baseColumns.filter(function(col) {
            return col !== $7Vlkq.EXPAND_COLUMN;
        });
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction
    ]); // ========================= Transform ========================
    var mergedColumns = $066f6fb60e667d68$var$React.useMemo(function() {
        var finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
         // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: function render() {
                    return null;
                }
            }
        ];
        return finalColumns;
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]); // ========================== Flatten =========================
    var flattenColumns = $066f6fb60e667d68$var$React.useMemo(function() {
        if (direction === 'rtl') return $066f6fb60e667d68$var$revertForRtl($066f6fb60e667d68$var$flatColumns(mergedColumns));
        return $066f6fb60e667d68$var$flatColumns(mergedColumns);
    }, [
        mergedColumns,
        direction
    ]); // Only check out of production since it's waste for each render
    return [
        mergedColumns,
        flattenColumns
    ];
}
var $066f6fb60e667d68$var$_default = $066f6fb60e667d68$var$useColumns;
module.exports.default = $066f6fb60e667d68$var$_default;

});
parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cbdLd", function(module, exports) {

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8de12fa6a893dcd1$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dtSXD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.call = $9d089dd9d996e7e6$var$call;
module.exports.default = void 0;
module.exports.note = $9d089dd9d996e7e6$var$note;
module.exports.noteOnce = $9d089dd9d996e7e6$var$noteOnce;
module.exports.preMessage = void 0;
module.exports.resetWarned = $9d089dd9d996e7e6$var$resetWarned;
module.exports.warning = $9d089dd9d996e7e6$var$warning;
module.exports.warningOnce = $9d089dd9d996e7e6$var$warningOnce;
/* eslint-disable no-console */ var $9d089dd9d996e7e6$var$warned = {};
var $9d089dd9d996e7e6$var$preWarningFns = [];
/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */ var $9d089dd9d996e7e6$var$preMessage = module.exports.preMessage = function preMessage(fn) {
    $9d089dd9d996e7e6$var$preWarningFns.push(fn);
};
/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */ function $9d089dd9d996e7e6$var$warning(valid, message) {
    var finalMessage;
}
/** @see Similar to {@link warning} */ function $9d089dd9d996e7e6$var$note(valid, message) {
    var finalMessage;
}
function $9d089dd9d996e7e6$var$resetWarned() {
    $9d089dd9d996e7e6$var$warned = {};
}
function $9d089dd9d996e7e6$var$call(method, valid, message) {
    if (!valid && !$9d089dd9d996e7e6$var$warned[message]) {
        method(false, message);
        $9d089dd9d996e7e6$var$warned[message] = true;
    }
}
/** @see Same as {@link warning}, but only warn once for the same message */ function $9d089dd9d996e7e6$var$warningOnce(valid, message) {
    $9d089dd9d996e7e6$var$call($9d089dd9d996e7e6$var$warning, valid, message);
}
/** @see Same as {@link warning}, but only warn once for the same message */ function $9d089dd9d996e7e6$var$noteOnce(valid, message) {
    $9d089dd9d996e7e6$var$call($9d089dd9d996e7e6$var$note, valid, message);
}
$9d089dd9d996e7e6$var$warningOnce.preMessage = $9d089dd9d996e7e6$var$preMessage;
$9d089dd9d996e7e6$var$warningOnce.resetWarned = $9d089dd9d996e7e6$var$resetWarned;
$9d089dd9d996e7e6$var$warningOnce.noteOnce = $9d089dd9d996e7e6$var$noteOnce;
var $9d089dd9d996e7e6$var$_default = module.exports.default = $9d089dd9d996e7e6$var$warningOnce;

});

parcelRegister("13r7s", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0c4b1b9058754b58$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c4b1b9058754b58$var$toArray;

var $0c4b1b9058754b58$var$_isFragment = $0c4b1b9058754b58$require$_interopRequireDefault((parcelRequire("6rbn4")));

var $0c4b1b9058754b58$var$_react = $0c4b1b9058754b58$require$_interopRequireDefault((parcelRequire("acw62")));
function $0c4b1b9058754b58$var$toArray(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    $0c4b1b9058754b58$var$_react.default.Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($0c4b1b9058754b58$var$toArray(child));
        else if ((0, $0c4b1b9058754b58$var$_isFragment.default)(child) && child.props) ret = ret.concat($0c4b1b9058754b58$var$toArray(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

});
parcelRegister("6rbn4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4afe15c0187b1515$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4afe15c0187b1515$var$isFragment;

var $4afe15c0187b1515$var$_typeof2 = $4afe15c0187b1515$require$_interopRequireDefault((parcelRequire("41YNz")));
var $4afe15c0187b1515$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $4afe15c0187b1515$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $4afe15c0187b1515$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
/**
 * Compatible with React 18 or 19 to check if node is a Fragment.
 */ function $4afe15c0187b1515$var$isFragment(object) {
    return(// Base object type
    object && (0, $4afe15c0187b1515$var$_typeof2.default)(object) === 'object' && // React Element type
    (object.$$typeof === $4afe15c0187b1515$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $4afe15c0187b1515$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $4afe15c0187b1515$var$REACT_FRAGMENT_TYPE);
}

});


parcelRegister("I7oBG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INTERNAL_COL_DEFINE = void 0;
module.exports.getExpandableProps = $0849d8d826176e4f$var$getExpandableProps;

var $0849d8d826176e4f$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $0849d8d826176e4f$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $0849d8d826176e4f$var$_warning = $1jnue((parcelRequire("dtSXD")));
var $0849d8d826176e4f$var$_excluded = [
    "expandable"
];
var $0849d8d826176e4f$var$INTERNAL_COL_DEFINE = 'RC_TABLE_INTERNAL_COL_DEFINE';
module.exports.INTERNAL_COL_DEFINE = $0849d8d826176e4f$var$INTERNAL_COL_DEFINE;
function $0849d8d826176e4f$var$getExpandableProps(props) {
    var expandable = props.expandable, legacyExpandableConfig = (0, $0849d8d826176e4f$var$_objectWithoutProperties2.default)(props, $0849d8d826176e4f$var$_excluded);
    var config;
    if ('expandable' in props) config = (0, $0849d8d826176e4f$var$_objectSpread2.default)((0, $0849d8d826176e4f$var$_objectSpread2.default)({}, legacyExpandableConfig), expandable);
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}

});

parcelRegister("7Vlkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EXPAND_COLUMN = void 0;
var $5c4e66a93215e691$var$EXPAND_COLUMN = {};
module.exports.EXPAND_COLUMN = $5c4e66a93215e691$var$EXPAND_COLUMN;

});


parcelRegister("8e6wL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.INTERNAL_HOOKS = void 0;

var $5fd4b1be7d0906fa$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $5fd4b1be7d0906fa$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $5fd4b1be7d0906fa$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $5fd4b1be7d0906fa$var$_toConsumableArray2 = $1jnue((parcelRequire("fUHKi")));

var $5fd4b1be7d0906fa$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $5fd4b1be7d0906fa$var$_typeof2 = $1jnue((parcelRequire("41YNz")));

var $5fd4b1be7d0906fa$var$React = $5fd4b1be7d0906fa$var$_interopRequireWildcard((parcelRequire("acw62")));

var $5fd4b1be7d0906fa$var$_isVisible = $1jnue((parcelRequire("aZdwV")));

var $5fd4b1be7d0906fa$var$_pickAttrs = $1jnue((parcelRequire("7ev53")));

var $cHasD = parcelRequire("cHasD");

var $5fd4b1be7d0906fa$var$_classnames = $1jnue((parcelRequire("8g1PZ")));

var $5fd4b1be7d0906fa$var$_shallowequal = $1jnue((parcelRequire("i5C3F")));

var $5fd4b1be7d0906fa$var$_warning = $1jnue((parcelRequire("dtSXD")));

var $5fd4b1be7d0906fa$var$_rcResizeObserver = $1jnue((parcelRequire("bVxlN")));

var $7iW6R = parcelRequire("7iW6R");

var $5fd4b1be7d0906fa$var$_ColumnGroup = $1jnue((parcelRequire("aXN4U")));

var $5fd4b1be7d0906fa$var$_Column = $1jnue((parcelRequire("679cX")));

var $5fd4b1be7d0906fa$var$_Header = $1jnue((parcelRequire("c5cBV")));

var $5fd4b1be7d0906fa$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $5fd4b1be7d0906fa$var$_BodyContext = $1jnue((parcelRequire("tM68H")));

var $5fd4b1be7d0906fa$var$_Body = $1jnue((parcelRequire("aqIni")));

var $5fd4b1be7d0906fa$var$_useColumns3 = $1jnue((parcelRequire("yfNZO")));

var $6aIFd = parcelRequire("6aIFd");

var $6aHZn = parcelRequire("6aHZn");

var $5fd4b1be7d0906fa$var$_ResizeContext = $1jnue((parcelRequire("1ivOa")));

var $5fd4b1be7d0906fa$var$_useStickyOffsets = $1jnue((parcelRequire("4dM0d")));

var $5fd4b1be7d0906fa$var$_ColGroup = $1jnue((parcelRequire("6Jiv3")));

var $I7oBG = parcelRequire("I7oBG");

var $5fd4b1be7d0906fa$var$_Panel = $1jnue((parcelRequire("8mRoi")));

var $5fd4b1be7d0906fa$var$_Footer = $5fd4b1be7d0906fa$var$_interopRequireWildcard((parcelRequire("gDLr1")));

var $clzrv = parcelRequire("clzrv");

var $7TgHo = parcelRequire("7TgHo");

var $5fd4b1be7d0906fa$var$_stickyScrollBar = $1jnue((parcelRequire("89aJo")));

var $5fd4b1be7d0906fa$var$_useSticky2 = $1jnue((parcelRequire("7V9P2")));

var $5fd4b1be7d0906fa$var$_FixedHolder = $1jnue((parcelRequire("e5mD3")));

var $5fd4b1be7d0906fa$var$_Summary = $1jnue((parcelRequire("lh8Xp")));

var $5fd4b1be7d0906fa$var$_StickyContext = $1jnue((parcelRequire("92g94")));

var $5fd4b1be7d0906fa$var$_ExpandedRowContext = $1jnue((parcelRequire("fHLYC")));

var $7Vlkq = parcelRequire("7Vlkq");
function $5fd4b1be7d0906fa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5fd4b1be7d0906fa$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5fd4b1be7d0906fa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (parcelRequire("41YNz"))(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5fd4b1be7d0906fa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Feature:
 *  - fixed not need to set width
 *  - support `rowExpandable` to config row expand logic
 *  - add `summary` to support `() => ReactNode`
 *
 * Update:
 *  - `dataIndex` is `array[]` now
 *  - `expandable` wrap all the expand related props
 *
 * Removed:
 *  - expandIconAsCell
 *  - useFixedHeader
 *  - rowRef
 *  - columns[number].onCellClick
 *  - onRowClick
 *  - onRowDoubleClick
 *  - onRowMouseEnter
 *  - onRowMouseLeave
 *  - getBodyWrapper
 *  - bodyStyle
 *
 * Deprecated:
 *  - All expanded props, move into expandable
 */ // Used for conditions cache
var $5fd4b1be7d0906fa$var$EMPTY_DATA = []; // Used for customize scroll
var $5fd4b1be7d0906fa$var$EMPTY_SCROLL_TARGET = {};
var $5fd4b1be7d0906fa$var$INTERNAL_HOOKS = 'rc-table-internal-hook';
module.exports.INTERNAL_HOOKS = $5fd4b1be7d0906fa$var$INTERNAL_HOOKS;
var $5fd4b1be7d0906fa$var$MemoTableContent = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(prev, next) {
    if (!(0, $5fd4b1be7d0906fa$var$_shallowequal.default)(prev.props, next.props)) return false;
     // No additional render when pinged status change.
    // This is not a bug.
    return prev.pingLeft !== next.pingLeft || prev.pingRight !== next.pingRight;
});
function $5fd4b1be7d0906fa$var$Table(props) {
    var _classNames;
    var prefixCls = props.prefixCls, className = props.className, rowClassName = props.rowClassName, style = props.style, data = props.data, rowKey = props.rowKey, scroll = props.scroll, tableLayout = props.tableLayout, direction = props.direction, title = props.title, footer = props.footer, summary = props.summary, id = props.id, showHeader = props.showHeader, components = props.components, emptyText = props.emptyText, onRow = props.onRow, onHeaderRow = props.onHeaderRow, internalHooks = props.internalHooks, transformColumns = props.transformColumns, internalRefs = props.internalRefs, sticky = props.sticky;
    var mergedData = data || $5fd4b1be7d0906fa$var$EMPTY_DATA;
    var hasData = !!mergedData.length; // ===================== Warning ======================
    var getComponent = $5fd4b1be7d0906fa$var$React.useCallback(function(path, defaultComponent) {
        return (0, $6aHZn.getPathValue)(components || {}, path) || defaultComponent;
    }, [
        components
    ]);
    var getRowKey = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        if (typeof rowKey === 'function') return rowKey;
        return function(record) {
            var key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]); // ====================== Expand ======================
    var expandableConfig = (0, $I7oBG.getExpandableProps)(props);
    var expandIcon = expandableConfig.expandIcon, expandedRowKeys = expandableConfig.expandedRowKeys, defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys, defaultExpandAllRows = expandableConfig.defaultExpandAllRows, expandedRowRender = expandableConfig.expandedRowRender, columnTitle = expandableConfig.columnTitle, onExpand = expandableConfig.onExpand, onExpandedRowsChange = expandableConfig.onExpandedRowsChange, expandRowByClick = expandableConfig.expandRowByClick, rowExpandable = expandableConfig.rowExpandable, expandIconColumnIndex = expandableConfig.expandIconColumnIndex, expandedRowClassName = expandableConfig.expandedRowClassName, childrenColumnName = expandableConfig.childrenColumnName, indentSize = expandableConfig.indentSize;
    var mergedExpandIcon = expandIcon || $clzrv.renderExpandIcon;
    var mergedChildrenColumnName = childrenColumnName || 'children';
    var expandableType = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        if (expandedRowRender) return 'row';
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && internalHooks === $5fd4b1be7d0906fa$var$INTERNAL_HOOKS && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function(record) {
            return record && (0, $5fd4b1be7d0906fa$var$_typeof2.default)(record) === 'object' && record[mergedChildrenColumnName];
        })) return 'nest';
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    var _React$useState = $5fd4b1be7d0906fa$var$React.useState(function() {
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $clzrv.findAllChildrenKeys)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    }), _React$useState2 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_React$useState, 2), innerExpandedKeys = _React$useState2[0], setInnerExpandedKeys = _React$useState2[1];
    var mergedExpandedKeys = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        return new Set(expandedRowKeys || innerExpandedKeys || []);
    }, [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    var onTriggerExpand = $5fd4b1be7d0906fa$var$React.useCallback(function(record) {
        var key = getRowKey(record, mergedData.indexOf(record));
        var newExpandedKeys;
        var hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = (0, $5fd4b1be7d0906fa$var$_toConsumableArray2.default)(mergedExpandedKeys);
        } else newExpandedKeys = [].concat((0, $5fd4b1be7d0906fa$var$_toConsumableArray2.default)(mergedExpandedKeys), [
            key
        ]);
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]); // Warning if use `expandedRowRender` and nest children in the same time
    var _React$useState3 = $5fd4b1be7d0906fa$var$React.useState(0), _React$useState4 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_React$useState3, 2), componentWidth = _React$useState4[0], setComponentWidth = _React$useState4[1];
    var _useColumns = (0, $5fd4b1be7d0906fa$var$_useColumns3.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({}, props), expandableConfig), {}, {
        expandable: !!expandedRowRender,
        columnTitle: columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand: onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandIconColumnIndex,
        direction: direction
    }), internalHooks === $5fd4b1be7d0906fa$var$INTERNAL_HOOKS ? transformColumns : null), _useColumns2 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_useColumns, 2), columns = _useColumns2[0], flattenColumns = _useColumns2[1];
    var columnContext = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        return {
            columns: columns,
            flattenColumns: flattenColumns
        };
    }, [
        columns,
        flattenColumns
    ]); // ====================== Scroll ======================
    var fullTableRef = $5fd4b1be7d0906fa$var$React.useRef();
    var scrollHeaderRef = $5fd4b1be7d0906fa$var$React.useRef();
    var scrollBodyRef = $5fd4b1be7d0906fa$var$React.useRef();
    var scrollBodyContainerRef = $5fd4b1be7d0906fa$var$React.useRef();
    var scrollSummaryRef = $5fd4b1be7d0906fa$var$React.useRef();
    var _React$useState5 = $5fd4b1be7d0906fa$var$React.useState(false), _React$useState6 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_React$useState5, 2), pingedLeft = _React$useState6[0], setPingedLeft = _React$useState6[1];
    var _React$useState7 = $5fd4b1be7d0906fa$var$React.useState(false), _React$useState8 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_React$useState7, 2), pingedRight = _React$useState8[0], setPingedRight = _React$useState8[1];
    var _useLayoutState = (0, $6aIFd.useLayoutState)(new Map()), _useLayoutState2 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_useLayoutState, 2), colsWidths = _useLayoutState2[0], updateColsWidths = _useLayoutState2[1]; // Convert map to number width
    var colsKeys = (0, $6aHZn.getColumnsKey)(flattenColumns);
    var pureColWidths = colsKeys.map(function(columnKey) {
        return colsWidths.get(columnKey);
    });
    var colWidths = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        return pureColWidths;
    }, [
        pureColWidths.join('_')
    ]);
    var stickyOffsets = (0, $5fd4b1be7d0906fa$var$_useStickyOffsets.default)(colWidths, flattenColumns.length, direction);
    var fixHeader = scroll && (0, $6aHZn.validateValue)(scroll.y);
    var horizonScroll = scroll && (0, $6aHZn.validateValue)(scroll.x) || Boolean(expandableConfig.fixed);
    var fixColumn = horizonScroll && flattenColumns.some(function(_ref2) {
        var fixed = _ref2.fixed;
        return fixed;
    }); // Sticky
    var stickyRef = $5fd4b1be7d0906fa$var$React.useRef();
    var _useSticky = (0, $5fd4b1be7d0906fa$var$_useSticky2.default)(sticky, prefixCls), isSticky = _useSticky.isSticky, offsetHeader = _useSticky.offsetHeader, offsetSummary = _useSticky.offsetSummary, offsetScroll = _useSticky.offsetScroll, stickyClassName = _useSticky.stickyClassName, container = _useSticky.container; // Footer (Fix footer must fixed header)
    var summaryNode = summary === null || summary === void 0 ? void 0 : summary(mergedData);
    var fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.isValidElement(summaryNode) && summaryNode.type === $5fd4b1be7d0906fa$var$_Summary.default && summaryNode.props.fixed; // Scroll
    var scrollXStyle;
    var scrollYStyle;
    var scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: 'scroll',
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: 'auto'
        }; // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: 'hidden'
        };
        scrollTableStyle = {
            width: (scroll === null || scroll === void 0 ? void 0 : scroll.x) === true ? 'auto' : scroll === null || scroll === void 0 ? void 0 : scroll.x,
            minWidth: '100%'
        };
    }
    var onColumnResize = $5fd4b1be7d0906fa$var$React.useCallback(function(columnKey, width) {
        if ((0, $5fd4b1be7d0906fa$var$_isVisible.default)(fullTableRef.current)) updateColsWidths(function(widths) {
            if (widths.get(columnKey) !== width) {
                var newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    var _useTimeoutLock = (0, $6aIFd.useTimeoutLock)(null), _useTimeoutLock2 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_useTimeoutLock, 2), setScrollTarget = _useTimeoutLock2[0], getScrollTarget = _useTimeoutLock2[1];
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === 'function') target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) // eslint-disable-next-line no-param-reassign
        target.scrollLeft = scrollLeft;
    }
    var onScroll = function onScroll(_ref3) {
        var currentTarget = _ref3.currentTarget, scrollLeft = _ref3.scrollLeft;
        var isRTL = direction === 'rtl';
        var mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
        var compareTarget = currentTarget || $5fd4b1be7d0906fa$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            var _stickyRef$current;
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
        }
        if (currentTarget) {
            var scrollWidth = currentTarget.scrollWidth, clientWidth = currentTarget.clientWidth; // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setPingedLeft(false);
                setPingedRight(false);
                return;
            }
            if (isRTL) {
                setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
                setPingedRight(-mergedScrollLeft > 0);
            } else {
                setPingedLeft(mergedScrollLeft > 0);
                setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
            }
        }
    };
    var triggerOnScroll = function triggerOnScroll() {
        if (horizonScroll && scrollBodyRef.current) onScroll({
            currentTarget: scrollBodyRef.current
        });
        else {
            setPingedLeft(false);
            setPingedRight(false);
        }
    };
    var onFullTableResize = function onFullTableResize(_ref4) {
        var width = _ref4.width;
        if (width !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(fullTableRef.current ? fullTableRef.current.offsetWidth : width);
        }
    }; // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    var mounted = $5fd4b1be7d0906fa$var$React.useRef(false);
    $5fd4b1be7d0906fa$var$React.useEffect(function() {
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $5fd4b1be7d0906fa$var$React.useEffect(function() {
        mounted.current = true;
    }, []); // ===================== Effects ======================
    var _React$useState9 = $5fd4b1be7d0906fa$var$React.useState(0), _React$useState10 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_React$useState9, 2), scrollbarSize = _React$useState10[0], setScrollbarSize = _React$useState10[1];
    var _React$useState11 = $5fd4b1be7d0906fa$var$React.useState(true), _React$useState12 = (0, $5fd4b1be7d0906fa$var$_slicedToArray2.default)(_React$useState11, 2), supportSticky = _React$useState12[0], setSupportSticky = _React$useState12[1]; // Only IE not support, we mark as support first
    $5fd4b1be7d0906fa$var$React.useEffect(function() {
        if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $7iW6R.getTargetScrollBarSize)(scrollBodyRef.current).width);
        else setScrollbarSize((0, $7iW6R.getTargetScrollBarSize)(scrollBodyContainerRef.current).width);
        setSupportSticky((0, $cHasD.isStyleSupport)('position', 'sticky'));
    }, []); // ================== INTERNAL HOOKS ==================
    $5fd4b1be7d0906fa$var$React.useEffect(function() {
        if (internalHooks === $5fd4b1be7d0906fa$var$INTERNAL_HOOKS && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    }); // ====================== Render ======================
    var TableComponent = getComponent([
        'table'
    ], 'table'); // Table layout
    var mergedTableLayout = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        if (tableLayout) return tableLayout;
         // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return (scroll === null || scroll === void 0 ? void 0 : scroll.x) === 'max-content' ? 'auto' : 'fixed';
        if (fixHeader || isSticky || flattenColumns.some(function(_ref5) {
            var ellipsis = _ref5.ellipsis;
            return ellipsis;
        })) return 'fixed';
        return 'auto';
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    var groupTableNode; // Header props
    var headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    }; // Empty
    var emptyNode = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        if (hasData) return null;
        if (typeof emptyText === 'function') return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]); // Body
    var bodyTable = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Body.default, {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky,
        expandedKeys: mergedExpandedKeys,
        rowExpandable: rowExpandable,
        getRowKey: getRowKey,
        onRow: onRow,
        emptyNode: emptyNode,
        childrenColumnName: mergedChildrenColumnName
    });
    var bodyColGroup = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_ColGroup.default, {
        colWidths: flattenColumns.map(function(_ref6) {
            var width = _ref6.width;
            return width;
        }),
        columns: flattenColumns
    });
    var customizeScrollBody = getComponent([
        'body'
    ]);
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        var bodyContent;
        if (typeof customizeScrollBody === 'function') {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onScroll
            });
            headerProps.colWidths = flattenColumns.map(function(_ref7, index) {
                var width = _ref7.width;
                var colWidth = index === columns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) return colWidth;
                (0, $5fd4b1be7d0906fa$var$_warning.default)(false, 'When use `components.body` with render props. Each column should have a fixed `width` value.');
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement("div", {
            style: (0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({}, scrollXStyle), scrollYStyle),
            onScroll: onScroll,
            ref: scrollBodyRef,
            className: (0, $5fd4b1be7d0906fa$var$_classnames.default)("".concat(prefixCls, "-body"))
        }, /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement(TableComponent, {
            style: (0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({}, scrollTableStyle), {}, {
                tableLayout: mergedTableLayout
            })
        }, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Footer.default, {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
         // Fixed holder share the props
        var fixedHolderProps = (0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && scroll.x === 'max-content'
        }, headerProps), columnContext), {}, {
            direction: direction,
            stickyClassName: stickyClassName,
            onScroll: onScroll
        });
        groupTableNode = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$React.Fragment, null, showHeader !== false && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_FixedHolder.default, (0, $5fd4b1be7d0906fa$var$_extends2.default)({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: "".concat(prefixCls, "-header"),
            ref: scrollHeaderRef
        }), function(fixedHolderPassProps) {
            return /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$React.Fragment, null, /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Header.default, fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Footer.default, fixedHolderPassProps, summaryNode));
        }), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_FixedHolder.default, (0, $5fd4b1be7d0906fa$var$_extends2.default)({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: "".concat(prefixCls, "-summary"),
            ref: scrollSummaryRef
        }), function(fixedHolderPassProps) {
            return /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Footer.default, fixedHolderPassProps, summaryNode);
        }), isSticky && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_stickyScrollBar.default, {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onScroll,
            container: container
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement("div", {
        style: (0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({}, scrollXStyle), scrollYStyle),
        className: (0, $5fd4b1be7d0906fa$var$_classnames.default)("".concat(prefixCls, "-content")),
        onScroll: onScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement(TableComponent, {
        style: (0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({}, scrollTableStyle), {}, {
            tableLayout: mergedTableLayout
        })
    }, bodyColGroup, showHeader !== false && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Header.default, (0, $5fd4b1be7d0906fa$var$_extends2.default)({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Footer.default, {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    var ariaProps = (0, $5fd4b1be7d0906fa$var$_pickAttrs.default)(props, {
        aria: true,
        data: true
    });
    var fullTable = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement("div", (0, $5fd4b1be7d0906fa$var$_extends2.default)({
        className: (0, $5fd4b1be7d0906fa$var$_classnames.default)(prefixCls, className, (_classNames = {}, (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-ping-left"), pingedLeft), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-ping-right"), pingedRight), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-layout-fixed"), tableLayout === 'fixed'), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-fixed-header"), fixHeader), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-fixed-column"), fixColumn), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), (0, $5fd4b1be7d0906fa$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === 'right'), _classNames)),
        style: style,
        id: id,
        ref: fullTableRef
    }, ariaProps), /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$MemoTableContent, {
        pingLeft: pingedLeft,
        pingRight: pingedRight,
        props: (0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({}, props), {}, {
            stickyOffsets: stickyOffsets,
            mergedExpandedKeys: mergedExpandedKeys
        })
    }, title && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Panel.default, {
        className: "".concat(prefixCls, "-title")
    }, title(mergedData)), /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement("div", {
        ref: scrollBodyContainerRef,
        className: "".concat(prefixCls, "-container")
    }, groupTableNode), footer && /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_Panel.default, {
        className: "".concat(prefixCls, "-footer")
    }, footer(mergedData))));
    if (horizonScroll) fullTable = /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_rcResizeObserver.default, {
        onResize: onFullTableResize
    }, fullTable);
    var TableContextValue = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        return {
            prefixCls: prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: flattenColumns.map(function(_, colIndex) {
                return (0, $7TgHo.getCellFixedInfo)(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
            }),
            isSticky: isSticky
        };
    }, [
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        flattenColumns,
        stickyOffsets,
        isSticky
    ]);
    var BodyContextValue = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        return (0, $5fd4b1be7d0906fa$var$_objectSpread2.default)((0, $5fd4b1be7d0906fa$var$_objectSpread2.default)({}, columnContext), {}, {
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandRowByClick,
            expandedRowRender: expandedRowRender,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandIconColumnIndex,
            indentSize: indentSize,
            allColumnsFixedLeft: columnContext.flattenColumns.every(function(col) {
                return col.fixed === 'left';
            })
        });
    }, [
        columnContext,
        mergedTableLayout,
        rowClassName,
        expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandRowByClick,
        expandedRowRender,
        onTriggerExpand,
        expandIconColumnIndex,
        indentSize
    ]);
    var ExpandedRowContextValue = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        return {
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll
        };
    }, [
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll
    ]);
    var ResizeContextValue = $5fd4b1be7d0906fa$var$React.useMemo(function() {
        return {
            onColumnResize: onColumnResize
        };
    }, [
        onColumnResize
    ]);
    return /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_StickyContext.default.Provider, {
        value: supportSticky
    }, /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_TableContext.default.Provider, {
        value: TableContextValue
    }, /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_BodyContext.default.Provider, {
        value: BodyContextValue
    }, /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_ExpandedRowContext.default.Provider, {
        value: ExpandedRowContextValue
    }, /*#__PURE__*/ $5fd4b1be7d0906fa$var$React.createElement($5fd4b1be7d0906fa$var$_ResizeContext.default.Provider, {
        value: ResizeContextValue
    }, fullTable)))));
}
$5fd4b1be7d0906fa$var$Table.EXPAND_COLUMN = $7Vlkq.EXPAND_COLUMN;
$5fd4b1be7d0906fa$var$Table.Column = $5fd4b1be7d0906fa$var$_Column.default;
$5fd4b1be7d0906fa$var$Table.ColumnGroup = $5fd4b1be7d0906fa$var$_ColumnGroup.default;
$5fd4b1be7d0906fa$var$Table.Summary = $5fd4b1be7d0906fa$var$_Footer.FooterComponents;
$5fd4b1be7d0906fa$var$Table.defaultProps = {
    rowKey: 'key',
    prefixCls: 'rc-table',
    emptyText: function emptyText() {
        return 'No Data';
    }
};
var $5fd4b1be7d0906fa$var$_default = $5fd4b1be7d0906fa$var$Table;
module.exports.default = $5fd4b1be7d0906fa$var$_default;

});
parcelRegister("aZdwV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7ffa18aeb0645c84$var$_default = module.exports.default = function _default(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};

});

parcelRegister("7ev53", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5441f328d6cda15d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5441f328d6cda15d$var$pickAttrs;

var $5441f328d6cda15d$var$_objectSpread2 = $5441f328d6cda15d$require$_interopRequireDefault((parcelRequire("cbdLd")));
var $5441f328d6cda15d$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $5441f328d6cda15d$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $5441f328d6cda15d$var$propList = "".concat($5441f328d6cda15d$var$attributes, " ").concat($5441f328d6cda15d$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $5441f328d6cda15d$var$ariaPrefix = 'aria-';
var $5441f328d6cda15d$var$dataPrefix = 'data-';
function $5441f328d6cda15d$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */ function $5441f328d6cda15d$var$pickAttrs(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $5441f328d6cda15d$var$_objectSpread2.default)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $5441f328d6cda15d$var$match(key, $5441f328d6cda15d$var$ariaPrefix)) || // Data
        mergedConfig.data && $5441f328d6cda15d$var$match(key, $5441f328d6cda15d$var$dataPrefix) || // Attr
        mergedConfig.attr && $5441f328d6cda15d$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}

});

parcelRegister("cHasD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $93e19d81b8c0d064$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isStyleSupport = $93e19d81b8c0d064$var$isStyleSupport;

var $93e19d81b8c0d064$var$_canUseDom = $93e19d81b8c0d064$require$_interopRequireDefault((parcelRequire("fpCN2")));
var $93e19d81b8c0d064$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $93e19d81b8c0d064$var$_canUseDom.default)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $93e19d81b8c0d064$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$93e19d81b8c0d064$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement('div');
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $93e19d81b8c0d064$var$isStyleSupport(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $93e19d81b8c0d064$var$isStyleValueSupport(styleName, styleValue);
    return $93e19d81b8c0d064$var$isStyleNameSupport(styleName);
}

});
parcelRegister("fpCN2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b38747b139154017$var$canUseDom;
function $b38747b139154017$var$canUseDom() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

});


parcelRegister("7iW6R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55174a32de099a0d$var$getScrollBarSize;
module.exports.getTargetScrollBarSize = $55174a32de099a0d$var$getTargetScrollBarSize;

var $1Sv8Y = parcelRequire("1Sv8Y");
/* eslint-disable no-param-reassign */ var $55174a32de099a0d$var$cached;
function $55174a32de099a0d$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
            (0, $1Sv8Y.updateCSS)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $1Sv8Y.removeCSS)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $55174a32de099a0d$var$getScrollBarSize(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $55174a32de099a0d$var$cached === undefined) $55174a32de099a0d$var$cached = $55174a32de099a0d$var$measureScrollbarSize();
    return $55174a32de099a0d$var$cached.width;
}
function $55174a32de099a0d$var$getTargetScrollBarSize(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $55174a32de099a0d$var$measureScrollbarSize(target);
}

});
parcelRegister("1Sv8Y", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $15e2fe1087ff15a4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearContainerCache = $15e2fe1087ff15a4$var$clearContainerCache;
module.exports.injectCSS = $15e2fe1087ff15a4$var$injectCSS;
module.exports.removeCSS = $15e2fe1087ff15a4$var$removeCSS;
module.exports.updateCSS = $15e2fe1087ff15a4$var$updateCSS;

var $15e2fe1087ff15a4$var$_objectSpread2 = $15e2fe1087ff15a4$require$_interopRequireDefault((parcelRequire("cbdLd")));

var $15e2fe1087ff15a4$var$_canUseDom = $15e2fe1087ff15a4$require$_interopRequireDefault((parcelRequire("fpCN2")));

var $15e2fe1087ff15a4$var$_contains = $15e2fe1087ff15a4$require$_interopRequireDefault((parcelRequire("9HGvI")));
var $15e2fe1087ff15a4$var$APPEND_ORDER = 'data-rc-order';
var $15e2fe1087ff15a4$var$APPEND_PRIORITY = 'data-rc-priority';
var $15e2fe1087ff15a4$var$MARK_KEY = "rc-util-key";
var $15e2fe1087ff15a4$var$containerCache = new Map();
function $15e2fe1087ff15a4$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $15e2fe1087ff15a4$var$MARK_KEY;
}
function $15e2fe1087ff15a4$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $15e2fe1087ff15a4$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $15e2fe1087ff15a4$var$findStyles(container) {
    return Array.from(($15e2fe1087ff15a4$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $15e2fe1087ff15a4$var$injectCSS(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $15e2fe1087ff15a4$var$_canUseDom.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $15e2fe1087ff15a4$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($15e2fe1087ff15a4$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($15e2fe1087ff15a4$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $15e2fe1087ff15a4$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $15e2fe1087ff15a4$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($15e2fe1087ff15a4$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($15e2fe1087ff15a4$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $15e2fe1087ff15a4$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $15e2fe1087ff15a4$var$getContainer(option);
    return (option.styles || $15e2fe1087ff15a4$var$findStyles(container)).find(function(node) {
        return node.getAttribute($15e2fe1087ff15a4$var$getMark(option)) === key;
    });
}
function $15e2fe1087ff15a4$var$removeCSS(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $15e2fe1087ff15a4$var$findExistNode(key, option);
    if (existNode) {
        var container = $15e2fe1087ff15a4$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $15e2fe1087ff15a4$var$syncRealContainer(container, option) {
    var cachedRealContainer = $15e2fe1087ff15a4$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $15e2fe1087ff15a4$var$_contains.default)(document, cachedRealContainer)) {
        var placeholderStyle = $15e2fe1087ff15a4$var$injectCSS('', option);
        var parentNode = placeholderStyle.parentNode;
        $15e2fe1087ff15a4$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
/**
 * manually clear container cache to avoid global cache in unit testes
 */ function $15e2fe1087ff15a4$var$clearContainerCache() {
    $15e2fe1087ff15a4$var$containerCache.clear();
}
function $15e2fe1087ff15a4$var$updateCSS(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $15e2fe1087ff15a4$var$getContainer(originOption);
    var styles = $15e2fe1087ff15a4$var$findStyles(container);
    var option = (0, $15e2fe1087ff15a4$var$_objectSpread2.default)((0, $15e2fe1087ff15a4$var$_objectSpread2.default)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $15e2fe1087ff15a4$var$syncRealContainer(container, option);
    var existNode = $15e2fe1087ff15a4$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $15e2fe1087ff15a4$var$injectCSS(css, option);
    newNode.setAttribute($15e2fe1087ff15a4$var$getMark(option), key);
    return newNode;
}

});
parcelRegister("9HGvI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71091ae8ea16d450$var$contains;
function $71091ae8ea16d450$var$contains(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

});



parcelRegister("aXN4U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $7fb57bff48253c62$var$ColumnGroup(_) {
    return null;
}
var $7fb57bff48253c62$var$_default = $7fb57bff48253c62$var$ColumnGroup;
module.exports.default = $7fb57bff48253c62$var$_default;

});

parcelRegister("679cX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $473a8a0f828dadd2$var$Column(_) {
    return null;
}
var $473a8a0f828dadd2$var$_default = $473a8a0f828dadd2$var$Column;
module.exports.default = $473a8a0f828dadd2$var$_default;

});

parcelRegister("c5cBV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $024528312f65a411$var$React = $024528312f65a411$var$_interopRequireWildcard((parcelRequire("acw62")));

var $024528312f65a411$var$_HeaderRow = $1jnue((parcelRequire("g2Xls")));

var $024528312f65a411$var$_TableContext = $1jnue((parcelRequire("8BTXE")));
function $024528312f65a411$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($024528312f65a411$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $024528312f65a411$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $024528312f65a411$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $024528312f65a411$var$parseHeaderRows(rootColumns) {
    var rows = [];
    function fillRowCells(columns, colIndex) {
        var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        var currentColIndex = colIndex;
        var colSpans = columns.filter(Boolean).map(function(column) {
            var cell = {
                key: column.key,
                className: column.className || '',
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            var colSpan = 1;
            var subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function(total, count) {
                    return total + count;
                }, 0);
                cell.hasSubColumns = true;
            }
            if ('colSpan' in column) colSpan = column.colSpan;
            if ('rowSpan' in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    } // Generate `rows` cell data
    fillRowCells(rootColumns, 0); // Handle `rowSpan`
    var rowCount = rows.length;
    var _loop = function _loop(rowIndex) {
        rows[rowIndex].forEach(function(cell) {
            if (!('rowSpan' in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
            cell.rowSpan = rowCount - rowIndex;
        });
    };
    for(var rowIndex = 0; rowIndex < rowCount; rowIndex += 1)_loop(rowIndex);
    return rows;
}
function $024528312f65a411$var$Header(_ref) {
    var stickyOffsets = _ref.stickyOffsets, columns = _ref.columns, flattenColumns = _ref.flattenColumns, onHeaderRow = _ref.onHeaderRow;
    var _React$useContext = $024528312f65a411$var$React.useContext($024528312f65a411$var$_TableContext.default), prefixCls = _React$useContext.prefixCls, getComponent = _React$useContext.getComponent;
    var rows = $024528312f65a411$var$React.useMemo(function() {
        return $024528312f65a411$var$parseHeaderRows(columns);
    }, [
        columns
    ]);
    var WrapperComponent = getComponent([
        'header',
        'wrapper'
    ], 'thead');
    var trComponent = getComponent([
        'header',
        'row'
    ], 'tr');
    var thComponent = getComponent([
        'header',
        'cell'
    ], 'th');
    return /*#__PURE__*/ $024528312f65a411$var$React.createElement(WrapperComponent, {
        className: "".concat(prefixCls, "-thead")
    }, rows.map(function(row, rowIndex) {
        var rowNode = /*#__PURE__*/ $024528312f65a411$var$React.createElement($024528312f65a411$var$_HeaderRow.default, {
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
}
var $024528312f65a411$var$_default = $024528312f65a411$var$Header;
module.exports.default = $024528312f65a411$var$_default;

});
parcelRegister("g2Xls", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $baeaddedf0945c12$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $baeaddedf0945c12$var$React = $baeaddedf0945c12$var$_interopRequireWildcard((parcelRequire("acw62")));

var $baeaddedf0945c12$var$_Cell = $1jnue((parcelRequire("jtACz")));

var $baeaddedf0945c12$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $7TgHo = parcelRequire("7TgHo");

var $6aHZn = parcelRequire("6aHZn");
function $baeaddedf0945c12$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($baeaddedf0945c12$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $baeaddedf0945c12$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $baeaddedf0945c12$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $baeaddedf0945c12$var$HeaderRow(_ref) {
    var cells = _ref.cells, stickyOffsets = _ref.stickyOffsets, flattenColumns = _ref.flattenColumns, RowComponent = _ref.rowComponent, CellComponent = _ref.cellComponent, onHeaderRow = _ref.onHeaderRow, index = _ref.index;
    var _React$useContext = $baeaddedf0945c12$var$React.useContext($baeaddedf0945c12$var$_TableContext.default), prefixCls = _React$useContext.prefixCls, direction = _React$useContext.direction;
    var rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map(function(cell) {
        return cell.column;
    }), index);
    var columnsKey = (0, $6aHZn.getColumnsKey)(cells.map(function(cell) {
        return cell.column;
    }));
    return /*#__PURE__*/ $baeaddedf0945c12$var$React.createElement(RowComponent, rowProps, cells.map(function(cell, cellIndex) {
        var column = cell.column;
        var fixedInfo = (0, $7TgHo.getCellFixedInfo)(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
        var additionalProps;
        if (column && column.onHeaderCell) additionalProps = cell.column.onHeaderCell(column);
        return /*#__PURE__*/ $baeaddedf0945c12$var$React.createElement($baeaddedf0945c12$var$_Cell.default, (0, $baeaddedf0945c12$var$_extends2.default)({}, cell, {
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
}
$baeaddedf0945c12$var$HeaderRow.displayName = 'HeaderRow';
var $baeaddedf0945c12$var$_default = $baeaddedf0945c12$var$HeaderRow;
module.exports.default = $baeaddedf0945c12$var$_default;

});
parcelRegister("jtACz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2dd21eecb536d7c$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $e2dd21eecb536d7c$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $e2dd21eecb536d7c$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $e2dd21eecb536d7c$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $e2dd21eecb536d7c$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $e2dd21eecb536d7c$var$_typeof2 = $1jnue((parcelRequire("41YNz")));

var $e2dd21eecb536d7c$var$React = $e2dd21eecb536d7c$var$_interopRequireWildcard((parcelRequire("acw62")));

var $e2dd21eecb536d7c$var$_classnames = $1jnue((parcelRequire("8g1PZ")));

var $e2dd21eecb536d7c$var$_shallowequal = $1jnue((parcelRequire("i5C3F")));

var $1XVSR = parcelRequire("1XVSR");

var $6aHZn = parcelRequire("6aHZn");

var $e2dd21eecb536d7c$var$_StickyContext = $1jnue((parcelRequire("92g94")));

var $e2dd21eecb536d7c$var$_HoverContext = $1jnue((parcelRequire("2TfIw")));

var $e2dd21eecb536d7c$var$_BodyContext = $1jnue((parcelRequire("tM68H")));

var $e2dd21eecb536d7c$var$_warning = $1jnue((parcelRequire("dtSXD")));

var $e2dd21eecb536d7c$var$_PerfContext = $1jnue((parcelRequire("cLBqm")));

var $meshS = parcelRequire("meshS");
var $e2dd21eecb536d7c$var$_excluded = [
    "colSpan",
    "rowSpan",
    "style",
    "className"
];
function $e2dd21eecb536d7c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e2dd21eecb536d7c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e2dd21eecb536d7c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (parcelRequire("41YNz"))(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e2dd21eecb536d7c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/** Check if cell is in hover range */ function $e2dd21eecb536d7c$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    var cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $e2dd21eecb536d7c$var$isRenderCell(data) {
    return data && (0, $e2dd21eecb536d7c$var$_typeof2.default)(data) === 'object' && !Array.isArray(data) && !/*#__PURE__*/ $e2dd21eecb536d7c$var$React.isValidElement(data);
}
function $e2dd21eecb536d7c$var$isRefComponent(component) {
    // String tag component also support ref
    if (typeof component === 'string') return true;
    return (0, $1XVSR.supportRef)(component);
}
var $e2dd21eecb536d7c$var$getTitleFromCellRenderChildren = function getTitleFromCellRenderChildren(_ref) {
    var ellipsis = _ref.ellipsis, rowType = _ref.rowType, children = _ref.children;
    var title;
    var ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
        if (typeof children === 'string' || typeof children === 'number') title = children.toString();
        else if (/*#__PURE__*/ $e2dd21eecb536d7c$var$React.isValidElement(children) && typeof children.props.children === 'string') title = children.props.children;
    }
    return title;
};
function $e2dd21eecb536d7c$var$Cell(_ref2, ref) {
    var _ref4, _ref5, _classNames;
    var prefixCls = _ref2.prefixCls, className = _ref2.className, record = _ref2.record, index = _ref2.index, renderIndex = _ref2.renderIndex, dataIndex = _ref2.dataIndex, render = _ref2.render, children = _ref2.children, _ref2$component = _ref2.component, Component = _ref2$component === void 0 ? 'td' : _ref2$component, colSpan = _ref2.colSpan, rowSpan = _ref2.rowSpan, fixLeft = _ref2.fixLeft, fixRight = _ref2.fixRight, firstFixLeft = _ref2.firstFixLeft, lastFixLeft = _ref2.lastFixLeft, firstFixRight = _ref2.firstFixRight, lastFixRight = _ref2.lastFixRight, appendNode = _ref2.appendNode, _ref2$additionalProps = _ref2.additionalProps, additionalProps = _ref2$additionalProps === void 0 ? {} : _ref2$additionalProps, ellipsis = _ref2.ellipsis, align = _ref2.align, rowType = _ref2.rowType, isSticky = _ref2.isSticky, hovering = _ref2.hovering, onHover = _ref2.onHover;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var perfRecord = $e2dd21eecb536d7c$var$React.useContext($e2dd21eecb536d7c$var$_PerfContext.default);
    var supportSticky = $e2dd21eecb536d7c$var$React.useContext($e2dd21eecb536d7c$var$_StickyContext.default);
    var _React$useContext = $e2dd21eecb536d7c$var$React.useContext($e2dd21eecb536d7c$var$_BodyContext.default), allColumnsFixedLeft = _React$useContext.allColumnsFixedLeft; // ==================== Child Node ====================
    var _React$useMemo = $e2dd21eecb536d7c$var$React.useMemo(function() {
        if ((0, $6aHZn.validateValue)(children)) return [
            children
        ];
        var value = (0, $6aHZn.getPathValue)(record, dataIndex); // Customize render node
        var returnChildNode = value;
        var returnCellProps = undefined;
        if (render) {
            var renderData = render(value, record, renderIndex);
            if ($e2dd21eecb536d7c$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        /* eslint-disable react-hooks/exhaustive-deps */ // Always re-render if `renderWithProps`
        perfRecord.renderWithProps ? Math.random() : 0,
        /* eslint-enable */ children,
        dataIndex,
        perfRecord,
        record,
        render,
        renderIndex
    ]), _React$useMemo2 = (0, $e2dd21eecb536d7c$var$_slicedToArray2.default)(_React$useMemo, 2), childNode = _React$useMemo2[0], legacyCellProps = _React$useMemo2[1];
    var mergedChildNode = childNode; // Not crash if final `childNode` is not validate ReactNode
    if ((0, $e2dd21eecb536d7c$var$_typeof2.default)(mergedChildNode) === 'object' && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $e2dd21eecb536d7c$var$React.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (lastFixLeft || firstFixRight)) mergedChildNode = /*#__PURE__*/ $e2dd21eecb536d7c$var$React.createElement("span", {
        className: "".concat(cellPrefixCls, "-content")
    }, mergedChildNode);
    var _ref3 = legacyCellProps || {}, cellColSpan = _ref3.colSpan, cellRowSpan = _ref3.rowSpan, cellStyle = _ref3.style, cellClassName = _ref3.className, restCellProps = (0, $e2dd21eecb536d7c$var$_objectWithoutProperties2.default)(_ref3, $e2dd21eecb536d7c$var$_excluded);
    var mergedColSpan = (_ref4 = cellColSpan !== undefined ? cellColSpan : colSpan) !== null && _ref4 !== void 0 ? _ref4 : 1;
    var mergedRowSpan = (_ref5 = cellRowSpan !== undefined ? cellRowSpan : rowSpan) !== null && _ref5 !== void 0 ? _ref5 : 1;
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
     // ====================== Fixed =======================
    var fixedStyle = {};
    var isFixLeft = typeof fixLeft === 'number' && supportSticky;
    var isFixRight = typeof fixRight === 'number' && supportSticky;
    if (isFixLeft) {
        fixedStyle.position = 'sticky';
        fixedStyle.left = fixLeft;
    }
    if (isFixRight) {
        fixedStyle.position = 'sticky';
        fixedStyle.right = fixRight;
    } // ====================== Align =======================
    var alignStyle = {};
    if (align) alignStyle.textAlign = align;
     // ====================== Hover =======================
    var onMouseEnter = function onMouseEnter(event) {
        var _additionalProps$onMo;
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo = additionalProps.onMouseEnter) === null || _additionalProps$onMo === void 0 || _additionalProps$onMo.call(additionalProps, event);
    };
    var onMouseLeave = function onMouseLeave(event) {
        var _additionalProps$onMo2;
        if (record) onHover(-1, -1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo2 = additionalProps.onMouseLeave) === null || _additionalProps$onMo2 === void 0 || _additionalProps$onMo2.call(additionalProps, event);
    }; // ====================== Render ======================
    var title = $e2dd21eecb536d7c$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    var componentProps = (0, $e2dd21eecb536d7c$var$_objectSpread2.default)((0, $e2dd21eecb536d7c$var$_objectSpread2.default)((0, $e2dd21eecb536d7c$var$_objectSpread2.default)({
        title: title
    }, restCellProps), additionalProps), {}, {
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null,
        className: (0, $e2dd21eecb536d7c$var$_classnames.default)(cellPrefixCls, className, (_classNames = {}, (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-all"), lastFixLeft && allColumnsFixedLeft && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky), (0, $e2dd21eecb536d7c$var$_defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-row-hover"), !legacyCellProps && hovering), _classNames), additionalProps.className, cellClassName),
        style: (0, $e2dd21eecb536d7c$var$_objectSpread2.default)((0, $e2dd21eecb536d7c$var$_objectSpread2.default)((0, $e2dd21eecb536d7c$var$_objectSpread2.default)((0, $e2dd21eecb536d7c$var$_objectSpread2.default)({}, additionalProps.style), alignStyle), fixedStyle), cellStyle),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: $e2dd21eecb536d7c$var$isRefComponent(Component) ? ref : null
    });
    return /*#__PURE__*/ $e2dd21eecb536d7c$var$React.createElement(Component, componentProps, appendNode, mergedChildNode);
}
var $e2dd21eecb536d7c$var$RefCell = /*#__PURE__*/ $e2dd21eecb536d7c$var$React.forwardRef($e2dd21eecb536d7c$var$Cell);
$e2dd21eecb536d7c$var$RefCell.displayName = 'Cell';
var $e2dd21eecb536d7c$var$comparePropList = [
    'expanded',
    'className',
    'hovering'
];
var $e2dd21eecb536d7c$var$MemoCell = /*#__PURE__*/ $e2dd21eecb536d7c$var$React.memo($e2dd21eecb536d7c$var$RefCell, function(prev, next) {
    if (next.shouldCellUpdate) return $e2dd21eecb536d7c$var$comparePropList.every(function(propName) {
        return prev[propName] === next[propName];
    }) && // User control update logic
    !next.shouldCellUpdate(next.record, prev.record);
    return (0, $e2dd21eecb536d7c$var$_shallowequal.default)(prev, next);
});
/** Inject hover data here, we still wish MemoCell keep simple `shouldCellUpdate` logic */ var $e2dd21eecb536d7c$var$WrappedCell = /*#__PURE__*/ $e2dd21eecb536d7c$var$React.forwardRef(function(props, ref) {
    var index = props.index, _props$additionalProp = props.additionalProps, additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp, colSpan = props.colSpan, rowSpan = props.rowSpan;
    var cellColSpan = additionalProps.colSpan, cellRowSpan = additionalProps.rowSpan;
    var mergedColSpan = colSpan !== null && colSpan !== void 0 ? colSpan : cellColSpan;
    var mergedRowSpan = rowSpan !== null && rowSpan !== void 0 ? rowSpan : cellRowSpan;
    var _useContextSelector = (0, $meshS.useContextSelector)($e2dd21eecb536d7c$var$_HoverContext.default, function(cxt) {
        var isHovering = $e2dd21eecb536d7c$var$inHoverRange(index, mergedRowSpan || 1, cxt === null || cxt === void 0 ? void 0 : cxt.startRow, cxt === null || cxt === void 0 ? void 0 : cxt.endRow);
        return {
            onHover: cxt === null || cxt === void 0 ? void 0 : cxt.onHover,
            hovering: isHovering
        };
    }), onHover = _useContextSelector.onHover, hovering = _useContextSelector.hovering;
    return /*#__PURE__*/ $e2dd21eecb536d7c$var$React.createElement($e2dd21eecb536d7c$var$MemoCell, (0, $e2dd21eecb536d7c$var$_extends2.default)({}, props, {
        colSpan: mergedColSpan,
        rowSpan: mergedRowSpan,
        hovering: hovering,
        ref: ref,
        onHover: onHover
    }));
});
$e2dd21eecb536d7c$var$WrappedCell.displayName = 'WrappedCell';
var $e2dd21eecb536d7c$var$_default = $e2dd21eecb536d7c$var$WrappedCell;
module.exports.default = $e2dd21eecb536d7c$var$_default;

});
parcelRegister("1XVSR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $16e833a4d9384c32$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useComposeRef = module.exports.supportRef = module.exports.supportNodeRef = module.exports.getNodeRef = module.exports.fillRef = module.exports.composeRef = void 0;

var $16e833a4d9384c32$var$_typeof2 = $16e833a4d9384c32$require$_interopRequireDefault((parcelRequire("41YNz")));

var $acw62 = parcelRequire("acw62");

var $lwoRE = parcelRequire("lwoRE");

var $16e833a4d9384c32$var$_useMemo = $16e833a4d9384c32$require$_interopRequireDefault((parcelRequire("hf6LW")));

var $16e833a4d9384c32$var$_isFragment = $16e833a4d9384c32$require$_interopRequireDefault((parcelRequire("6rbn4")));
var $16e833a4d9384c32$var$ReactMajorVersion = Number($acw62.version.split('.')[0]);
var $16e833a4d9384c32$var$fillRef = module.exports.fillRef = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $16e833a4d9384c32$var$_typeof2.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
/**
 * Merge refs into one ref function to support ref passing.
 */ var $16e833a4d9384c32$var$composeRef = module.exports.composeRef = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $16e833a4d9384c32$var$fillRef(ref, node);
        });
    };
};
var $16e833a4d9384c32$var$useComposeRef = module.exports.useComposeRef = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $16e833a4d9384c32$var$_useMemo.default)(function() {
        return $16e833a4d9384c32$var$composeRef.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $16e833a4d9384c32$var$supportRef = module.exports.supportRef = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($16e833a4d9384c32$var$isReactElement(nodeOrComponent) && $16e833a4d9384c32$var$ReactMajorVersion >= 19) return true;
    var type = (0, $lwoRE.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== $lwoRE.ForwardRef) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== $lwoRE.ForwardRef) return false;
    return true;
};
function $16e833a4d9384c32$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $16e833a4d9384c32$var$_isFragment.default)(node);
}
var $16e833a4d9384c32$var$supportNodeRef = module.exports.supportNodeRef = function supportNodeRef(node) {
    return $16e833a4d9384c32$var$isReactElement(node) && $16e833a4d9384c32$var$supportRef(node);
};
/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */ var $16e833a4d9384c32$var$getNodeRef = module.exports.getNodeRef = function getNodeRef(node) {
    if (node && $16e833a4d9384c32$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

});
parcelRegister("hf6LW", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c8d91731e31bb96c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8d91731e31bb96c$var$useMemo;

var $c8d91731e31bb96c$var$React = $c8d91731e31bb96c$require$_interopRequireWildcard((parcelRequire("acw62")));
function $c8d91731e31bb96c$var$useMemo(getValue, condition, shouldUpdate) {
    var cacheRef = $c8d91731e31bb96c$var$React.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});


parcelRegister("6aHZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getColumnsKey = $47e5cc89a731e74a$var$getColumnsKey;
module.exports.getPathValue = $47e5cc89a731e74a$var$getPathValue;
module.exports.validateValue = $47e5cc89a731e74a$var$validateValue;
var $47e5cc89a731e74a$var$INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function $47e5cc89a731e74a$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $47e5cc89a731e74a$var$getPathValue(record, path) {
    // Skip if path is empty
    if (!path && typeof path !== 'number') return record;
    var pathList = $47e5cc89a731e74a$var$toArray(path);
    var current = record;
    for(var i = 0; i < pathList.length; i += 1){
        if (!current) return null;
        var prop = pathList[i];
        current = current[prop];
    }
    return current;
}
function $47e5cc89a731e74a$var$getColumnsKey(columns) {
    var columnKeys = [];
    var keys = {};
    columns.forEach(function(column) {
        var _ref = column || {}, key = _ref.key, dataIndex = _ref.dataIndex;
        var mergedKey = key || $47e5cc89a731e74a$var$toArray(dataIndex).join('-') || $47e5cc89a731e74a$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = "".concat(mergedKey, "_next");
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $47e5cc89a731e74a$var$validateValue(val) {
    return val !== null && val !== undefined;
}

});

parcelRegister("92g94", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6940d31844fe9da5$var$React = $6940d31844fe9da5$var$_interopRequireWildcard((parcelRequire("acw62")));
function $6940d31844fe9da5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6940d31844fe9da5$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6940d31844fe9da5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6940d31844fe9da5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// Tell cell that browser support sticky
var $6940d31844fe9da5$var$StickyContext = /*#__PURE__*/ $6940d31844fe9da5$var$React.createContext(false);
var $6940d31844fe9da5$var$_default = $6940d31844fe9da5$var$StickyContext;
module.exports.default = $6940d31844fe9da5$var$_default;

});

parcelRegister("2TfIw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $meshS = parcelRequire("meshS");
var $21ace8e4ec65d7ce$var$HoverContext = (0, $meshS.createContext)();
var $21ace8e4ec65d7ce$var$_default = $21ace8e4ec65d7ce$var$HoverContext;
module.exports.default = $21ace8e4ec65d7ce$var$_default;

});
parcelRegister("meshS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createContext = $042d44b319a1987a$var$createContext;
module.exports.useContextSelector = $042d44b319a1987a$var$useContextSelector;

var $042d44b319a1987a$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $042d44b319a1987a$var$React = $042d44b319a1987a$var$_interopRequireWildcard((parcelRequire("acw62")));

var $042d44b319a1987a$var$_useLayoutEffect = $1jnue((parcelRequire("5Xs2K")));

var $042d44b319a1987a$var$_useEvent = $1jnue((parcelRequire("VcZYb")));

var $042d44b319a1987a$var$_shallowequal = $1jnue((parcelRequire("i5C3F")));
function $042d44b319a1987a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($042d44b319a1987a$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $042d44b319a1987a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $042d44b319a1987a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $042d44b319a1987a$var$createContext() {
    var Context = /*#__PURE__*/ $042d44b319a1987a$var$React.createContext(null);
    var Provider = function Provider(_ref) {
        var value = _ref.value, children = _ref.children;
        var valueRef = $042d44b319a1987a$var$React.useRef(value);
        valueRef.current = value;
        var _React$useState = $042d44b319a1987a$var$React.useState(function() {
            return {
                getValue: function getValue() {
                    return valueRef.current;
                },
                listeners: new Set()
            };
        }), _React$useState2 = (0, $042d44b319a1987a$var$_slicedToArray2.default)(_React$useState, 1), context = _React$useState2[0];
        (0, $042d44b319a1987a$var$_useLayoutEffect.default)(function() {
            context.listeners.forEach(function(listener) {
                listener(value);
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $042d44b319a1987a$var$React.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider
    };
}
function $042d44b319a1987a$var$useContextSelector(holder, selector) {
    var eventSelector = (0, $042d44b319a1987a$var$_useEvent.default)(selector);
    var context = $042d44b319a1987a$var$React.useContext(holder === null || holder === void 0 ? void 0 : holder.Context);
    var _ref2 = context || {}, listeners = _ref2.listeners, getValue = _ref2.getValue;
    var _React$useState3 = $042d44b319a1987a$var$React.useState(function() {
        return eventSelector(context ? getValue() : null);
    }), _React$useState4 = (0, $042d44b319a1987a$var$_slicedToArray2.default)(_React$useState3, 2), value = _React$useState4[0], setValue = _React$useState4[1];
    (0, $042d44b319a1987a$var$_useLayoutEffect.default)(function() {
        if (!context) return;
        function trigger(nextValue) {
            setValue(function(prev) {
                var selectedValue = eventSelector(nextValue);
                return (0, $042d44b319a1987a$var$_shallowequal.default)(prev, selectedValue) ? prev : selectedValue;
            });
        }
        listeners.add(trigger);
        return function() {
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return value;
}

});
parcelRegister("5Xs2K", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $45683740cc2854f7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $45683740cc2854f7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLayoutUpdateEffect = module.exports.default = void 0;

var $45683740cc2854f7$var$React = $45683740cc2854f7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $45683740cc2854f7$var$_canUseDom = $45683740cc2854f7$require$_interopRequireDefault((parcelRequire("fpCN2")));
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $45683740cc2854f7$var$useInternalLayoutEffect = (0, $45683740cc2854f7$var$_canUseDom.default)() ? $45683740cc2854f7$var$React.useLayoutEffect : $45683740cc2854f7$var$React.useEffect;
var $45683740cc2854f7$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $45683740cc2854f7$var$React.useRef(true);
    $45683740cc2854f7$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $45683740cc2854f7$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $45683740cc2854f7$var$useLayoutUpdateEffect = module.exports.useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
    $45683740cc2854f7$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $45683740cc2854f7$var$_default = module.exports.default = $45683740cc2854f7$var$useLayoutEffect;

});

parcelRegister("VcZYb", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0abf68383e9612df$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0abf68383e9612df$var$useEvent;

var $0abf68383e9612df$var$React = $0abf68383e9612df$require$_interopRequireWildcard((parcelRequire("acw62")));
function $0abf68383e9612df$var$useEvent(callback) {
    var fnRef = $0abf68383e9612df$var$React.useRef();
    fnRef.current = callback;
    var memoFn = $0abf68383e9612df$var$React.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

});



parcelRegister("tM68H", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $059804d01646693f$var$React = $059804d01646693f$var$_interopRequireWildcard((parcelRequire("acw62")));
function $059804d01646693f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($059804d01646693f$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $059804d01646693f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $059804d01646693f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $059804d01646693f$var$BodyContext = /*#__PURE__*/ $059804d01646693f$var$React.createContext(null);
var $059804d01646693f$var$_default = $059804d01646693f$var$BodyContext;
module.exports.default = $059804d01646693f$var$_default;

});

parcelRegister("cLBqm", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94b6e77fe589ad2b$var$React = $94b6e77fe589ad2b$var$_interopRequireWildcard((parcelRequire("acw62")));
function $94b6e77fe589ad2b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($94b6e77fe589ad2b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $94b6e77fe589ad2b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $94b6e77fe589ad2b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $94b6e77fe589ad2b$var$PerfContext = /*#__PURE__*/ $94b6e77fe589ad2b$var$React.createContext({
    renderWithProps: false
});
var $94b6e77fe589ad2b$var$_default = $94b6e77fe589ad2b$var$PerfContext;
module.exports.default = $94b6e77fe589ad2b$var$_default;

});


parcelRegister("8BTXE", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $644d301f57d247ba$var$React = $644d301f57d247ba$var$_interopRequireWildcard((parcelRequire("acw62")));
function $644d301f57d247ba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($644d301f57d247ba$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $644d301f57d247ba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $644d301f57d247ba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $644d301f57d247ba$var$TableContext = /*#__PURE__*/ $644d301f57d247ba$var$React.createContext(null);
var $644d301f57d247ba$var$_default = $644d301f57d247ba$var$TableContext;
module.exports.default = $644d301f57d247ba$var$_default;

});

parcelRegister("7TgHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCellFixedInfo = $5bea9f7e4fd8c25c$var$getCellFixedInfo;
function $5bea9f7e4fd8c25c$var$getCellFixedInfo(colStart, colEnd, columns, stickyOffsets, direction) {
    var startColumn = columns[colStart] || {};
    var endColumn = columns[colEnd] || {};
    var fixLeft;
    var fixRight;
    if (startColumn.fixed === 'left') fixLeft = stickyOffsets.left[colStart];
    else if (endColumn.fixed === 'right') fixRight = stickyOffsets.right[colEnd];
    var lastFixLeft = false;
    var firstFixRight = false;
    var lastFixRight = false;
    var firstFixLeft = false;
    var nextColumn = columns[colEnd + 1];
    var prevColumn = columns[colStart - 1];
    if (direction === 'rtl') {
        if (fixLeft !== undefined) {
            var prevFixLeft = prevColumn && prevColumn.fixed === 'left';
            firstFixLeft = !prevFixLeft;
        } else if (fixRight !== undefined) {
            var nextFixRight = nextColumn && nextColumn.fixed === 'right';
            lastFixRight = !nextFixRight;
        }
    } else if (fixLeft !== undefined) {
        var nextFixLeft = nextColumn && nextColumn.fixed === 'left';
        lastFixLeft = !nextFixLeft;
    } else if (fixRight !== undefined) {
        var prevFixRight = prevColumn && prevColumn.fixed === 'right';
        firstFixRight = !prevFixRight;
    }
    return {
        fixLeft: fixLeft,
        fixRight: fixRight,
        lastFixLeft: lastFixLeft,
        firstFixRight: firstFixRight,
        lastFixRight: lastFixRight,
        firstFixLeft: firstFixLeft,
        isSticky: stickyOffsets.isSticky
    };
}

});



parcelRegister("aqIni", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $797ec0fbd0d5f371$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $797ec0fbd0d5f371$var$React = $797ec0fbd0d5f371$var$_interopRequireWildcard((parcelRequire("acw62")));

var $797ec0fbd0d5f371$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $797ec0fbd0d5f371$var$_ExpandedRow = $1jnue((parcelRequire("31zSK")));

var $797ec0fbd0d5f371$var$_BodyContext = $1jnue((parcelRequire("tM68H")));

var $6aHZn = parcelRequire("6aHZn");

var $797ec0fbd0d5f371$var$_ResizeContext = $1jnue((parcelRequire("1ivOa")));

var $797ec0fbd0d5f371$var$_BodyRow = $1jnue((parcelRequire("c3PA1")));

var $797ec0fbd0d5f371$var$_useFlattenRecords = $1jnue((parcelRequire("feZYP")));

var $797ec0fbd0d5f371$var$_HoverContext = $1jnue((parcelRequire("2TfIw")));

var $797ec0fbd0d5f371$var$_PerfContext = $1jnue((parcelRequire("cLBqm")));

var $797ec0fbd0d5f371$var$_MeasureRow = $1jnue((parcelRequire("7HOD5")));
function $797ec0fbd0d5f371$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($797ec0fbd0d5f371$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $797ec0fbd0d5f371$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $797ec0fbd0d5f371$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $797ec0fbd0d5f371$var$Body(_ref) {
    var data = _ref.data, getRowKey = _ref.getRowKey, measureColumnWidth = _ref.measureColumnWidth, expandedKeys = _ref.expandedKeys, onRow = _ref.onRow, rowExpandable = _ref.rowExpandable, emptyNode = _ref.emptyNode, childrenColumnName = _ref.childrenColumnName;
    var _React$useContext = $797ec0fbd0d5f371$var$React.useContext($797ec0fbd0d5f371$var$_ResizeContext.default), onColumnResize = _React$useContext.onColumnResize;
    var _React$useContext2 = $797ec0fbd0d5f371$var$React.useContext($797ec0fbd0d5f371$var$_TableContext.default), prefixCls = _React$useContext2.prefixCls, getComponent = _React$useContext2.getComponent;
    var _React$useContext3 = $797ec0fbd0d5f371$var$React.useContext($797ec0fbd0d5f371$var$_BodyContext.default), flattenColumns = _React$useContext3.flattenColumns;
    var flattenData = (0, $797ec0fbd0d5f371$var$_useFlattenRecords.default)(data, childrenColumnName, expandedKeys, getRowKey); // =================== Performance ====================
    var perfRef = $797ec0fbd0d5f371$var$React.useRef({
        renderWithProps: false
    }); // ====================== Hover =======================
    var _React$useState = $797ec0fbd0d5f371$var$React.useState(-1), _React$useState2 = (0, $797ec0fbd0d5f371$var$_slicedToArray2.default)(_React$useState, 2), startRow = _React$useState2[0], setStartRow = _React$useState2[1];
    var _React$useState3 = $797ec0fbd0d5f371$var$React.useState(-1), _React$useState4 = (0, $797ec0fbd0d5f371$var$_slicedToArray2.default)(_React$useState3, 2), endRow = _React$useState4[0], setEndRow = _React$useState4[1];
    var onHover = $797ec0fbd0d5f371$var$React.useCallback(function(start, end) {
        setStartRow(start);
        setEndRow(end);
    }, []); // ====================== Render ======================
    var bodyNode = $797ec0fbd0d5f371$var$React.useMemo(function() {
        var WrapperComponent = getComponent([
            'body',
            'wrapper'
        ], 'tbody');
        var trComponent = getComponent([
            'body',
            'row'
        ], 'tr');
        var tdComponent = getComponent([
            'body',
            'cell'
        ], 'td');
        var rows;
        if (data.length) rows = flattenData.map(function(item, idx) {
            var record = item.record, indent = item.indent, renderIndex = item.index;
            var key = getRowKey(record, idx);
            return /*#__PURE__*/ $797ec0fbd0d5f371$var$React.createElement($797ec0fbd0d5f371$var$_BodyRow.default, {
                key: key,
                rowKey: key,
                record: record,
                recordKey: key,
                index: idx,
                renderIndex: renderIndex,
                rowComponent: trComponent,
                cellComponent: tdComponent,
                expandedKeys: expandedKeys,
                onRow: onRow,
                getRowKey: getRowKey,
                rowExpandable: rowExpandable,
                childrenColumnName: childrenColumnName,
                indent: indent
            });
        });
        else rows = /*#__PURE__*/ $797ec0fbd0d5f371$var$React.createElement($797ec0fbd0d5f371$var$_ExpandedRow.default, {
            expanded: true,
            className: "".concat(prefixCls, "-placeholder"),
            prefixCls: prefixCls,
            component: trComponent,
            cellComponent: tdComponent,
            colSpan: flattenColumns.length,
            isEmpty: true
        }, emptyNode);
        var columnsKey = (0, $6aHZn.getColumnsKey)(flattenColumns);
        return /*#__PURE__*/ $797ec0fbd0d5f371$var$React.createElement(WrapperComponent, {
            className: "".concat(prefixCls, "-tbody")
        }, measureColumnWidth && /*#__PURE__*/ $797ec0fbd0d5f371$var$React.createElement($797ec0fbd0d5f371$var$_MeasureRow.default, {
            prefixCls: prefixCls,
            columnsKey: columnsKey,
            onColumnResize: onColumnResize
        }), rows);
    }, [
        data,
        prefixCls,
        onRow,
        measureColumnWidth,
        expandedKeys,
        getRowKey,
        getComponent,
        emptyNode,
        flattenColumns,
        childrenColumnName,
        onColumnResize,
        rowExpandable,
        flattenData
    ]);
    return /*#__PURE__*/ $797ec0fbd0d5f371$var$React.createElement($797ec0fbd0d5f371$var$_PerfContext.default.Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $797ec0fbd0d5f371$var$React.createElement($797ec0fbd0d5f371$var$_HoverContext.default.Provider, {
        value: {
            startRow: startRow,
            endRow: endRow,
            onHover: onHover
        }
    }, bodyNode));
}
var $797ec0fbd0d5f371$var$MemoBody = /*#__PURE__*/ $797ec0fbd0d5f371$var$React.memo($797ec0fbd0d5f371$var$Body);
$797ec0fbd0d5f371$var$MemoBody.displayName = 'Body';
var $797ec0fbd0d5f371$var$_default = $797ec0fbd0d5f371$var$MemoBody;
module.exports.default = $797ec0fbd0d5f371$var$_default;

});
parcelRegister("31zSK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $233d4c8039004dd5$var$React = $233d4c8039004dd5$var$_interopRequireWildcard((parcelRequire("acw62")));

var $233d4c8039004dd5$var$_Cell = $1jnue((parcelRequire("jtACz")));

var $233d4c8039004dd5$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $233d4c8039004dd5$var$_ExpandedRowContext = $1jnue((parcelRequire("fHLYC")));
function $233d4c8039004dd5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($233d4c8039004dd5$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $233d4c8039004dd5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $233d4c8039004dd5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $233d4c8039004dd5$var$ExpandedRow(_ref) {
    var prefixCls = _ref.prefixCls, children = _ref.children, Component = _ref.component, cellComponent = _ref.cellComponent, className = _ref.className, expanded = _ref.expanded, colSpan = _ref.colSpan, isEmpty = _ref.isEmpty;
    var _React$useContext = $233d4c8039004dd5$var$React.useContext($233d4c8039004dd5$var$_TableContext.default), scrollbarSize = _React$useContext.scrollbarSize;
    var _React$useContext2 = $233d4c8039004dd5$var$React.useContext($233d4c8039004dd5$var$_ExpandedRowContext.default), fixHeader = _React$useContext2.fixHeader, fixColumn = _React$useContext2.fixColumn, componentWidth = _React$useContext2.componentWidth, horizonScroll = _React$useContext2.horizonScroll; // Cache render node
    return $233d4c8039004dd5$var$React.useMemo(function() {
        var contentNode = children;
        if (isEmpty ? horizonScroll : fixColumn) contentNode = /*#__PURE__*/ $233d4c8039004dd5$var$React.createElement("div", {
            style: {
                width: componentWidth - (fixHeader ? scrollbarSize : 0),
                position: 'sticky',
                left: 0,
                overflow: 'hidden'
            },
            className: "".concat(prefixCls, "-expanded-row-fixed")
        }, componentWidth !== 0 && contentNode);
        return /*#__PURE__*/ $233d4c8039004dd5$var$React.createElement(Component, {
            className: className,
            style: {
                display: expanded ? null : 'none'
            }
        }, /*#__PURE__*/ $233d4c8039004dd5$var$React.createElement($233d4c8039004dd5$var$_Cell.default, {
            component: cellComponent,
            prefixCls: prefixCls,
            colSpan: colSpan
        }, contentNode));
    }, [
        children,
        Component,
        className,
        expanded,
        colSpan,
        isEmpty,
        scrollbarSize,
        componentWidth,
        fixColumn,
        fixHeader,
        horizonScroll
    ]);
}
var $233d4c8039004dd5$var$_default = $233d4c8039004dd5$var$ExpandedRow;
module.exports.default = $233d4c8039004dd5$var$_default;

});
parcelRegister("fHLYC", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6f01658595dfe3c$var$React = $b6f01658595dfe3c$var$_interopRequireWildcard((parcelRequire("acw62")));
function $b6f01658595dfe3c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b6f01658595dfe3c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b6f01658595dfe3c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b6f01658595dfe3c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $b6f01658595dfe3c$var$ExpandedRowContext = /*#__PURE__*/ $b6f01658595dfe3c$var$React.createContext(null);
var $b6f01658595dfe3c$var$_default = $b6f01658595dfe3c$var$ExpandedRowContext;
module.exports.default = $b6f01658595dfe3c$var$_default;

});


parcelRegister("1ivOa", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f2025518521db0e$var$React = $0f2025518521db0e$var$_interopRequireWildcard((parcelRequire("acw62")));
function $0f2025518521db0e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0f2025518521db0e$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0f2025518521db0e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0f2025518521db0e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $0f2025518521db0e$var$ResizeContext = /*#__PURE__*/ $0f2025518521db0e$var$React.createContext(null);
var $0f2025518521db0e$var$_default = $0f2025518521db0e$var$ResizeContext;
module.exports.default = $0f2025518521db0e$var$_default;

});

parcelRegister("c3PA1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c7dc68ca3264be3$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $8c7dc68ca3264be3$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $8c7dc68ca3264be3$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $8c7dc68ca3264be3$var$React = $8c7dc68ca3264be3$var$_interopRequireWildcard((parcelRequire("acw62")));

var $8c7dc68ca3264be3$var$_classnames = $1jnue((parcelRequire("8g1PZ")));

var $8c7dc68ca3264be3$var$_Cell = $1jnue((parcelRequire("jtACz")));

var $8c7dc68ca3264be3$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $8c7dc68ca3264be3$var$_BodyContext = $1jnue((parcelRequire("tM68H")));

var $6aHZn = parcelRequire("6aHZn");

var $8c7dc68ca3264be3$var$_ExpandedRow = $1jnue((parcelRequire("31zSK")));
function $8c7dc68ca3264be3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8c7dc68ca3264be3$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8c7dc68ca3264be3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8c7dc68ca3264be3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8c7dc68ca3264be3$var$BodyRow(props) {
    var className = props.className, style = props.style, record = props.record, index = props.index, renderIndex = props.renderIndex, rowKey = props.rowKey, rowExpandable = props.rowExpandable, expandedKeys = props.expandedKeys, onRow = props.onRow, _props$indent = props.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props.rowComponent, cellComponent = props.cellComponent, childrenColumnName = props.childrenColumnName;
    var _React$useContext = $8c7dc68ca3264be3$var$React.useContext($8c7dc68ca3264be3$var$_TableContext.default), prefixCls = _React$useContext.prefixCls, fixedInfoList = _React$useContext.fixedInfoList;
    var _React$useContext2 = $8c7dc68ca3264be3$var$React.useContext($8c7dc68ca3264be3$var$_BodyContext.default), flattenColumns = _React$useContext2.flattenColumns, expandableType = _React$useContext2.expandableType, expandRowByClick = _React$useContext2.expandRowByClick, onTriggerExpand = _React$useContext2.onTriggerExpand, rowClassName = _React$useContext2.rowClassName, expandedRowClassName = _React$useContext2.expandedRowClassName, indentSize = _React$useContext2.indentSize, expandIcon = _React$useContext2.expandIcon, expandedRowRender = _React$useContext2.expandedRowRender, expandIconColumnIndex = _React$useContext2.expandIconColumnIndex;
    var _React$useState = $8c7dc68ca3264be3$var$React.useState(false), _React$useState2 = (0, $8c7dc68ca3264be3$var$_slicedToArray2.default)(_React$useState, 2), expandRended = _React$useState2[0], setExpandRended = _React$useState2[1];
    var expanded = expandedKeys && expandedKeys.has(props.recordKey);
    $8c7dc68ca3264be3$var$React.useEffect(function() {
        if (expanded) setExpandRended(true);
    }, [
        expanded
    ]);
    var rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record)); // Only when row is not expandable and `children` exist in record
    var nestExpandable = expandableType === 'nest';
    var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    var mergedExpandable = rowSupportExpand || nestExpandable; // ======================== Expandable =========================
    var onExpandRef = $8c7dc68ca3264be3$var$React.useRef(onTriggerExpand);
    onExpandRef.current = onTriggerExpand;
    var onInternalTriggerExpand = function onInternalTriggerExpand() {
        onExpandRef.current.apply(onExpandRef, arguments);
    }; // =========================== onRow ===========================
    var additionalProps = onRow === null || onRow === void 0 ? void 0 : onRow(record, index);
    var onClick = function onClick(event) {
        var _additionalProps$onCl;
        if (expandRowByClick && mergedExpandable) onInternalTriggerExpand(record, event);
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onCl = additionalProps.onClick) === null || _additionalProps$onCl === void 0 || _additionalProps$onCl.call.apply(_additionalProps$onCl, [
            additionalProps,
            event
        ].concat(args));
    }; // ======================== Base tr row ========================
    var computeRowClassName;
    if (typeof rowClassName === 'string') computeRowClassName = rowClassName;
    else if (typeof rowClassName === 'function') computeRowClassName = rowClassName(record, index, indent);
    var columnsKey = (0, $6aHZn.getColumnsKey)(flattenColumns);
    var baseRowNode = /*#__PURE__*/ $8c7dc68ca3264be3$var$React.createElement(RowComponent, (0, $8c7dc68ca3264be3$var$_extends2.default)({}, additionalProps, {
        "data-row-key": rowKey,
        className: (0, $8c7dc68ca3264be3$var$_classnames.default)(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), computeRowClassName, additionalProps && additionalProps.className),
        style: (0, $8c7dc68ca3264be3$var$_objectSpread2.default)((0, $8c7dc68ca3264be3$var$_objectSpread2.default)({}, style), additionalProps ? additionalProps.style : null),
        onClick: onClick
    }), flattenColumns.map(function(column, colIndex) {
        var render = column.render, dataIndex = column.dataIndex, columnClassName = column.className;
        var key = columnsKey[colIndex];
        var fixedInfo = fixedInfoList[colIndex]; // ============= Used for nest expandable =============
        var appendCellNode;
        if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $8c7dc68ca3264be3$var$React.createElement($8c7dc68ca3264be3$var$React.Fragment, null, /*#__PURE__*/ $8c7dc68ca3264be3$var$React.createElement("span", {
            style: {
                paddingLeft: "".concat(indentSize * indent, "px")
            },
            className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
        }), expandIcon({
            prefixCls: prefixCls,
            expanded: expanded,
            expandable: hasNestChildren,
            record: record,
            onExpand: onInternalTriggerExpand
        }));
        var additionalCellProps;
        if (column.onCell) additionalCellProps = column.onCell(record, index);
        return /*#__PURE__*/ $8c7dc68ca3264be3$var$React.createElement($8c7dc68ca3264be3$var$_Cell.default, (0, $8c7dc68ca3264be3$var$_extends2.default)({
            className: columnClassName,
            ellipsis: column.ellipsis,
            align: column.align,
            component: cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate,
            expanded: appendCellNode && expanded
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    })); // ======================== Expand Row =========================
    var expandRowNode;
    if (rowSupportExpand && (expandRended || expanded)) {
        var expandContent = expandedRowRender(record, index, indent + 1, expanded);
        var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index, indent);
        expandRowNode = /*#__PURE__*/ $8c7dc68ca3264be3$var$React.createElement($8c7dc68ca3264be3$var$_ExpandedRow.default, {
            expanded: expanded,
            className: (0, $8c7dc68ca3264be3$var$_classnames.default)("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: flattenColumns.length,
            isEmpty: false
        }, expandContent);
    }
    return /*#__PURE__*/ $8c7dc68ca3264be3$var$React.createElement($8c7dc68ca3264be3$var$React.Fragment, null, baseRowNode, expandRowNode);
}
$8c7dc68ca3264be3$var$BodyRow.displayName = 'BodyRow';
var $8c7dc68ca3264be3$var$_default = $8c7dc68ca3264be3$var$BodyRow;
module.exports.default = $8c7dc68ca3264be3$var$_default;

});

parcelRegister("feZYP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1883dc3f2685d6b$var$useFlattenRecords;

var $b1883dc3f2685d6b$var$_toConsumableArray2 = $1jnue((parcelRequire("fUHKi")));

var $b1883dc3f2685d6b$var$React = $b1883dc3f2685d6b$var$_interopRequireWildcard((parcelRequire("acw62")));
function $b1883dc3f2685d6b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b1883dc3f2685d6b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b1883dc3f2685d6b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b1883dc3f2685d6b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// recursion (flat tree structure)
function $b1883dc3f2685d6b$var$flatRecord(record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    var arr = [];
    arr.push({
        record: record,
        indent: indent,
        index: index
    });
    var key = getRowKey(record);
    var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(var i = 0; i < record[childrenColumnName].length; i += 1){
        var tempArr = $b1883dc3f2685d6b$var$flatRecord(record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
        arr.push.apply(arr, (0, $b1883dc3f2685d6b$var$_toConsumableArray2.default)(tempArr));
    }
    return arr;
}
/**
 * flat tree data on expanded state
 *
 * @export
 * @template T
 * @param {*} data : table data
 * @param {string} childrenColumnName : 指定树形结构的列名
 * @param {Set<Key>} expandedKeys : 展开的行对应的keys
 * @param {GetRowKey<T>} getRowKey  : 获取当前rowKey的方法
 * @returns flattened data
 */ function $b1883dc3f2685d6b$var$useFlattenRecords(data, childrenColumnName, expandedKeys, getRowKey) {
    var arr = $b1883dc3f2685d6b$var$React.useMemo(function() {
        if (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.size) {
            var temp = []; // collect flattened record
            for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i += 1){
                var record = data[i];
                temp.push.apply(temp, (0, $b1883dc3f2685d6b$var$_toConsumableArray2.default)($b1883dc3f2685d6b$var$flatRecord(record, 0, childrenColumnName, expandedKeys, getRowKey, i)));
            }
            return temp;
        }
        return data === null || data === void 0 ? void 0 : data.map(function(item, index) {
            return {
                record: item,
                indent: 0,
                index: index
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}

});

parcelRegister("7HOD5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59c3d27bd22f0769$var$MeasureRow;

var $59c3d27bd22f0769$var$React = $59c3d27bd22f0769$var$_interopRequireWildcard((parcelRequire("acw62")));

var $59c3d27bd22f0769$var$_rcResizeObserver = $1jnue((parcelRequire("bVxlN")));

var $59c3d27bd22f0769$var$_MeasureCell = $1jnue((parcelRequire("5zrQW")));
function $59c3d27bd22f0769$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($59c3d27bd22f0769$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $59c3d27bd22f0769$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $59c3d27bd22f0769$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $59c3d27bd22f0769$var$MeasureRow(_ref) {
    var prefixCls = _ref.prefixCls, columnsKey = _ref.columnsKey, onColumnResize = _ref.onColumnResize;
    return /*#__PURE__*/ $59c3d27bd22f0769$var$React.createElement("tr", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-measure-row"),
        style: {
            height: 0,
            fontSize: 0
        }
    }, /*#__PURE__*/ $59c3d27bd22f0769$var$React.createElement($59c3d27bd22f0769$var$_rcResizeObserver.default.Collection, {
        onBatchResize: function onBatchResize(infoList) {
            infoList.forEach(function(_ref2) {
                var columnKey = _ref2.data, size = _ref2.size;
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map(function(columnKey) {
        return /*#__PURE__*/ $59c3d27bd22f0769$var$React.createElement($59c3d27bd22f0769$var$_MeasureCell.default, {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize
        });
    })));
}

});
parcelRegister("5zrQW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40e5d3a0abf2961d$var$MeasureCell;

var $40e5d3a0abf2961d$var$React = $40e5d3a0abf2961d$var$_interopRequireWildcard((parcelRequire("acw62")));

var $40e5d3a0abf2961d$var$_rcResizeObserver = $1jnue((parcelRequire("bVxlN")));
function $40e5d3a0abf2961d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($40e5d3a0abf2961d$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $40e5d3a0abf2961d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $40e5d3a0abf2961d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $40e5d3a0abf2961d$var$MeasureCell(_ref) {
    var columnKey = _ref.columnKey, onColumnResize = _ref.onColumnResize;
    var cellRef = $40e5d3a0abf2961d$var$React.useRef();
    $40e5d3a0abf2961d$var$React.useEffect(function() {
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $40e5d3a0abf2961d$var$React.createElement($40e5d3a0abf2961d$var$_rcResizeObserver.default, {
        data: columnKey
    }, /*#__PURE__*/ $40e5d3a0abf2961d$var$React.createElement("td", {
        ref: cellRef,
        style: {
            padding: 0,
            border: 0,
            height: 0
        }
    }, /*#__PURE__*/ $40e5d3a0abf2961d$var$React.createElement("div", {
        style: {
            height: 0,
            overflow: 'hidden'
        }
    }, "\xA0")));
}

});



parcelRegister("6aIFd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLayoutState = $47e6529064fcaccf$var$useLayoutState;
module.exports.useTimeoutLock = $47e6529064fcaccf$var$useTimeoutLock;

var $47e6529064fcaccf$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $acw62 = parcelRequire("acw62");
/**
 * Execute code before next frame but async
 */ function $47e6529064fcaccf$var$useLayoutState(defaultState) {
    var stateRef = (0, $acw62.useRef)(defaultState);
    var _useState = (0, $acw62.useState)({}), _useState2 = (0, $47e6529064fcaccf$var$_slicedToArray2.default)(_useState, 2), forceUpdate = _useState2[1];
    var lastPromiseRef = (0, $acw62.useRef)(null);
    var updateBatchRef = (0, $acw62.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        var promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(function() {
            if (lastPromiseRef.current === promise) {
                var prevBatch = updateBatchRef.current;
                var prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach(function(batchUpdater) {
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $acw62.useEffect)(function() {
        return function() {
            lastPromiseRef.current = null;
        };
    }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
/** Lock frame, when frame pass reset the lock. */ function $47e6529064fcaccf$var$useTimeoutLock(defaultState) {
    var frameRef = (0, $acw62.useRef)(defaultState || null);
    var timeoutRef = (0, $acw62.useRef)();
    function cleanUp() {
        window.clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = window.setTimeout(function() {
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $acw62.useEffect)(function() {
        return cleanUp;
    }, []);
    return [
        setState,
        getState
    ];
}

});

parcelRegister("4dM0d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acw62 = parcelRequire("acw62");
/**
 * Get sticky column offset width
 */ function $312d9c987dfd8be0$var$useStickyOffsets(colWidths, columnCount, direction) {
    var stickyOffsets = (0, $acw62.useMemo)(function() {
        var leftOffsets = [];
        var rightOffsets = [];
        var left = 0;
        var right = 0;
        for(var start = 0; start < columnCount; start += 1)if (direction === 'rtl') {
            // Left offset
            rightOffsets[start] = right;
            right += colWidths[start] || 0; // Right offset
            var end = columnCount - start - 1;
            leftOffsets[end] = left;
            left += colWidths[end] || 0;
        } else {
            // Left offset
            leftOffsets[start] = left;
            left += colWidths[start] || 0; // Right offset
            var _end = columnCount - start - 1;
            rightOffsets[_end] = right;
            right += colWidths[_end] || 0;
        }
        return {
            left: leftOffsets,
            right: rightOffsets
        };
    }, [
        colWidths,
        columnCount,
        direction
    ]);
    return stickyOffsets;
}
var $312d9c987dfd8be0$var$_default = $312d9c987dfd8be0$var$useStickyOffsets;
module.exports.default = $312d9c987dfd8be0$var$_default;

});

parcelRegister("6Jiv3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e654bc2bdee89a6$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $4e654bc2bdee89a6$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $4e654bc2bdee89a6$var$React = $4e654bc2bdee89a6$var$_interopRequireWildcard((parcelRequire("acw62")));

var $I7oBG = parcelRequire("I7oBG");
var $4e654bc2bdee89a6$var$_excluded = [
    "columnType"
];
function $4e654bc2bdee89a6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4e654bc2bdee89a6$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4e654bc2bdee89a6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4e654bc2bdee89a6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4e654bc2bdee89a6$var$ColGroup(_ref) {
    var colWidths = _ref.colWidths, columns = _ref.columns, columCount = _ref.columCount;
    var cols = [];
    var len = columCount || columns.length; // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    var mustInsert = false;
    for(var i = len - 1; i >= 0; i -= 1){
        var width = colWidths[i];
        var column = columns && columns[i];
        var additionalProps = column && column[$I7oBG.INTERNAL_COL_DEFINE];
        if (width || additionalProps || mustInsert) {
            var _ref2 = additionalProps || {}, columnType = _ref2.columnType, restAdditionalProps = (0, $4e654bc2bdee89a6$var$_objectWithoutProperties2.default)(_ref2, $4e654bc2bdee89a6$var$_excluded);
            cols.unshift(/*#__PURE__*/ $4e654bc2bdee89a6$var$React.createElement("col", (0, $4e654bc2bdee89a6$var$_extends2.default)({
                key: i,
                style: {
                    width: width
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return /*#__PURE__*/ $4e654bc2bdee89a6$var$React.createElement("colgroup", null, cols);
}
var $4e654bc2bdee89a6$var$_default = $4e654bc2bdee89a6$var$ColGroup;
module.exports.default = $4e654bc2bdee89a6$var$_default;

});

parcelRegister("8mRoi", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6179cb212e6e4b14$var$React = $6179cb212e6e4b14$var$_interopRequireWildcard((parcelRequire("acw62")));
function $6179cb212e6e4b14$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6179cb212e6e4b14$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6179cb212e6e4b14$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6179cb212e6e4b14$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6179cb212e6e4b14$var$Panel(_ref) {
    var className = _ref.className, children = _ref.children;
    return /*#__PURE__*/ $6179cb212e6e4b14$var$React.createElement("div", {
        className: className
    }, children);
}
var $6179cb212e6e4b14$var$_default = $6179cb212e6e4b14$var$Panel;
module.exports.default = $6179cb212e6e4b14$var$_default;

});

parcelRegister("gDLr1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.FooterComponents = void 0;

var $c1d5156eeb607546$var$React = $c1d5156eeb607546$var$_interopRequireWildcard((parcelRequire("acw62")));

var $c1d5156eeb607546$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $c1d5156eeb607546$var$_Summary = $1jnue((parcelRequire("lh8Xp")));

var $c1d5156eeb607546$var$_SummaryContext = $1jnue((parcelRequire("2oG74")));
function $c1d5156eeb607546$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c1d5156eeb607546$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c1d5156eeb607546$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c1d5156eeb607546$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c1d5156eeb607546$var$Footer(_ref) {
    var children = _ref.children, stickyOffsets = _ref.stickyOffsets, flattenColumns = _ref.flattenColumns;
    var tableContext = $c1d5156eeb607546$var$React.useContext($c1d5156eeb607546$var$_TableContext.default);
    var prefixCls = tableContext.prefixCls;
    var lastColumnIndex = flattenColumns.length - 1;
    var scrollColumn = flattenColumns[lastColumnIndex];
    var summaryContext = $c1d5156eeb607546$var$React.useMemo(function() {
        return {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: (scrollColumn === null || scrollColumn === void 0 ? void 0 : scrollColumn.scrollbar) ? lastColumnIndex : null
        };
    }, [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $c1d5156eeb607546$var$React.createElement($c1d5156eeb607546$var$_SummaryContext.default.Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $c1d5156eeb607546$var$React.createElement("tfoot", {
        className: "".concat(prefixCls, "-summary")
    }, children));
}
var $c1d5156eeb607546$var$_default = $c1d5156eeb607546$var$Footer;
module.exports.default = $c1d5156eeb607546$var$_default;
var $c1d5156eeb607546$var$FooterComponents = $c1d5156eeb607546$var$_Summary.default;
module.exports.FooterComponents = $c1d5156eeb607546$var$FooterComponents;

});
parcelRegister("lh8Xp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7d22234968d2619$var$_Cell = $1jnue((parcelRequire("4zv9e")));

var $f7d22234968d2619$var$_Row = $1jnue((parcelRequire("4fAc4")));
/**
 * Syntactic sugar. Do not support HOC.
 */ function $f7d22234968d2619$var$Summary(_ref) {
    var children = _ref.children;
    return children;
}
$f7d22234968d2619$var$Summary.Row = $f7d22234968d2619$var$_Row.default;
$f7d22234968d2619$var$Summary.Cell = $f7d22234968d2619$var$_Cell.default;
var $f7d22234968d2619$var$_default = $f7d22234968d2619$var$Summary;
module.exports.default = $f7d22234968d2619$var$_default;

});
parcelRegister("4zv9e", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $354297a4a355da17$var$SummaryCell;

var $354297a4a355da17$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $354297a4a355da17$var$React = $354297a4a355da17$var$_interopRequireWildcard((parcelRequire("acw62")));

var $354297a4a355da17$var$_SummaryContext = $1jnue((parcelRequire("2oG74")));

var $354297a4a355da17$var$_Cell = $1jnue((parcelRequire("jtACz")));

var $354297a4a355da17$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $7TgHo = parcelRequire("7TgHo");
function $354297a4a355da17$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($354297a4a355da17$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $354297a4a355da17$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $354297a4a355da17$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $354297a4a355da17$var$SummaryCell(_ref) {
    var className = _ref.className, index = _ref.index, children = _ref.children, _ref$colSpan = _ref.colSpan, colSpan = _ref$colSpan === void 0 ? 1 : _ref$colSpan, rowSpan = _ref.rowSpan, align = _ref.align;
    var _React$useContext = $354297a4a355da17$var$React.useContext($354297a4a355da17$var$_TableContext.default), prefixCls = _React$useContext.prefixCls, direction = _React$useContext.direction;
    var _React$useContext2 = $354297a4a355da17$var$React.useContext($354297a4a355da17$var$_SummaryContext.default), scrollColumnIndex = _React$useContext2.scrollColumnIndex, stickyOffsets = _React$useContext2.stickyOffsets, flattenColumns = _React$useContext2.flattenColumns;
    var lastIndex = index + colSpan - 1;
    var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    var fixedInfo = (0, $7TgHo.getCellFixedInfo)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets, direction);
    return /*#__PURE__*/ $354297a4a355da17$var$React.createElement($354297a4a355da17$var$_Cell.default, (0, $354297a4a355da17$var$_extends2.default)({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: function render() {
            return children;
        }
    }, fixedInfo));
}

});
parcelRegister("2oG74", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bee7d68b81fd3fa$var$React = $1bee7d68b81fd3fa$var$_interopRequireWildcard((parcelRequire("acw62")));
function $1bee7d68b81fd3fa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1bee7d68b81fd3fa$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1bee7d68b81fd3fa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1bee7d68b81fd3fa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $1bee7d68b81fd3fa$var$SummaryContext = /*#__PURE__*/ $1bee7d68b81fd3fa$var$React.createContext({});
var $1bee7d68b81fd3fa$var$_default = $1bee7d68b81fd3fa$var$SummaryContext;
module.exports.default = $1bee7d68b81fd3fa$var$_default;

});


parcelRegister("4fAc4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3184a37247604e74$var$FooterRow;

var $3184a37247604e74$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $3184a37247604e74$var$React = $3184a37247604e74$var$_interopRequireWildcard((parcelRequire("acw62")));
var $3184a37247604e74$var$_excluded = [
    "children"
];
function $3184a37247604e74$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3184a37247604e74$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3184a37247604e74$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3184a37247604e74$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3184a37247604e74$var$FooterRow(_ref) {
    var children = _ref.children, props = (0, $3184a37247604e74$var$_objectWithoutProperties2.default)(_ref, $3184a37247604e74$var$_excluded);
    return /*#__PURE__*/ $3184a37247604e74$var$React.createElement("tr", props, children);
}

});



parcelRegister("clzrv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAllChildrenKeys = $8fd2f06077e3bf8b$var$findAllChildrenKeys;
module.exports.renderExpandIcon = $8fd2f06077e3bf8b$var$renderExpandIcon;

var $8fd2f06077e3bf8b$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $8fd2f06077e3bf8b$var$React = $8fd2f06077e3bf8b$var$_interopRequireWildcard((parcelRequire("acw62")));

var $8fd2f06077e3bf8b$var$_classnames = $1jnue((parcelRequire("8g1PZ")));
function $8fd2f06077e3bf8b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8fd2f06077e3bf8b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8fd2f06077e3bf8b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8fd2f06077e3bf8b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8fd2f06077e3bf8b$var$renderExpandIcon(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, record = _ref.record, onExpand = _ref.onExpand, expanded = _ref.expanded, expandable = _ref.expandable;
    var expandClassName = "".concat(prefixCls, "-row-expand-icon");
    if (!expandable) return /*#__PURE__*/ $8fd2f06077e3bf8b$var$React.createElement("span", {
        className: (0, $8fd2f06077e3bf8b$var$_classnames.default)(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
    var onClick = function onClick(event) {
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $8fd2f06077e3bf8b$var$React.createElement("span", {
        className: (0, $8fd2f06077e3bf8b$var$_classnames.default)(expandClassName, (_classNames = {}, (0, $8fd2f06077e3bf8b$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), (0, $8fd2f06077e3bf8b$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _classNames)),
        onClick: onClick
    });
}
function $8fd2f06077e3bf8b$var$findAllChildrenKeys(data, getRowKey, childrenColumnName) {
    var keys = [];
    function dig(list) {
        (list || []).forEach(function(item, index) {
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}

});

parcelRegister("89aJo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ee77cf77bea3e63$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $5ee77cf77bea3e63$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $5ee77cf77bea3e63$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $5ee77cf77bea3e63$var$React = $5ee77cf77bea3e63$var$_interopRequireWildcard((parcelRequire("acw62")));

var $5ee77cf77bea3e63$var$_addEventListener = $1jnue((parcelRequire("5ZEjk")));

var $5ee77cf77bea3e63$var$_getScrollBarSize = $1jnue((parcelRequire("7iW6R")));

var $5ee77cf77bea3e63$var$_classnames = $1jnue((parcelRequire("8g1PZ")));

var $cmULN = parcelRequire("cmULN");

var $5ee77cf77bea3e63$var$_TableContext = $1jnue((parcelRequire("8BTXE")));

var $6aIFd = parcelRequire("6aIFd");
function $5ee77cf77bea3e63$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5ee77cf77bea3e63$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5ee77cf77bea3e63$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5ee77cf77bea3e63$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $5ee77cf77bea3e63$var$StickyScrollBar = function StickyScrollBar(_ref, ref) {
    var _scrollBodyRef$curren, _scrollBodyRef$curren2;
    var scrollBodyRef = _ref.scrollBodyRef, onScroll = _ref.onScroll, offsetScroll = _ref.offsetScroll, container = _ref.container;
    var _React$useContext = $5ee77cf77bea3e63$var$React.useContext($5ee77cf77bea3e63$var$_TableContext.default), prefixCls = _React$useContext.prefixCls;
    var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
    var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
    var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    var scrollBarRef = $5ee77cf77bea3e63$var$React.useRef();
    var _useLayoutState = (0, $6aIFd.useLayoutState)({
        scrollLeft: 0,
        isHiddenScrollBar: false
    }), _useLayoutState2 = (0, $5ee77cf77bea3e63$var$_slicedToArray2.default)(_useLayoutState, 2), scrollState = _useLayoutState2[0], setScrollState = _useLayoutState2[1];
    var refState = $5ee77cf77bea3e63$var$React.useRef({
        delta: 0,
        x: 0
    });
    var _React$useState = $5ee77cf77bea3e63$var$React.useState(false), _React$useState2 = (0, $5ee77cf77bea3e63$var$_slicedToArray2.default)(_React$useState, 2), isActive = _React$useState2[0], setActive = _React$useState2[1];
    var onMouseUp = function onMouseUp() {
        setActive(false);
    };
    var onMouseDown = function onMouseDown(event) {
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    var onMouseMove = function onMouseMove(event) {
        var _window;
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event), buttons = _ref2.buttons;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        if (left <= 0) left = 0;
        if (left + scrollBarWidth >= bodyWidth) left = bodyWidth - scrollBarWidth;
        onScroll({
            scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
        });
        refState.current.x = event.pageX;
    };
    var onContainerScroll = function onContainerScroll() {
        if (!scrollBodyRef.current) return;
        var tableOffsetTop = (0, $cmULN.getOffset)(scrollBodyRef.current).top;
        var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
        var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $cmULN.getOffset)(container).top + container.clientHeight;
        if (tableBottomOffset - (0, $5ee77cf77bea3e63$var$_getScrollBarSize.default)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState(function(state) {
            return (0, $5ee77cf77bea3e63$var$_objectSpread2.default)((0, $5ee77cf77bea3e63$var$_objectSpread2.default)({}, state), {}, {
                isHiddenScrollBar: true
            });
        });
        else setScrollState(function(state) {
            return (0, $5ee77cf77bea3e63$var$_objectSpread2.default)((0, $5ee77cf77bea3e63$var$_objectSpread2.default)({}, state), {}, {
                isHiddenScrollBar: false
            });
        });
    };
    var setScrollLeft = function setScrollLeft(left) {
        setScrollState(function(state) {
            return (0, $5ee77cf77bea3e63$var$_objectSpread2.default)((0, $5ee77cf77bea3e63$var$_objectSpread2.default)({}, state), {}, {
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            });
        });
    };
    $5ee77cf77bea3e63$var$React.useImperativeHandle(ref, function() {
        return {
            setScrollLeft: setScrollLeft
        };
    });
    $5ee77cf77bea3e63$var$React.useEffect(function() {
        var onMouseUpListener = (0, $5ee77cf77bea3e63$var$_addEventListener.default)(document.body, 'mouseup', onMouseUp, false);
        var onMouseMoveListener = (0, $5ee77cf77bea3e63$var$_addEventListener.default)(document.body, 'mousemove', onMouseMove, false);
        onContainerScroll();
        return function() {
            onMouseUpListener.remove();
            onMouseMoveListener.remove();
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    $5ee77cf77bea3e63$var$React.useEffect(function() {
        var onScrollListener = (0, $5ee77cf77bea3e63$var$_addEventListener.default)(container, 'scroll', onContainerScroll, false);
        var onResizeListener = (0, $5ee77cf77bea3e63$var$_addEventListener.default)(window, 'resize', onContainerScroll, false);
        return function() {
            onScrollListener.remove();
            onResizeListener.remove();
        };
    }, [
        container
    ]);
    $5ee77cf77bea3e63$var$React.useEffect(function() {
        if (!scrollState.isHiddenScrollBar) setScrollState(function(state) {
            var bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return (0, $5ee77cf77bea3e63$var$_objectSpread2.default)((0, $5ee77cf77bea3e63$var$_objectSpread2.default)({}, state), {}, {
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            });
        });
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $5ee77cf77bea3e63$var$React.createElement("div", {
        style: {
            height: (0, $5ee77cf77bea3e63$var$_getScrollBarSize.default)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: "".concat(prefixCls, "-sticky-scroll")
    }, /*#__PURE__*/ $5ee77cf77bea3e63$var$React.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, $5ee77cf77bea3e63$var$_classnames.default)("".concat(prefixCls, "-sticky-scroll-bar"), (0, $5ee77cf77bea3e63$var$_defineProperty2.default)({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
        style: {
            width: "".concat(scrollBarWidth, "px"),
            transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
        }
    }));
};
var $5ee77cf77bea3e63$var$_default = /*#__PURE__*/ $5ee77cf77bea3e63$var$React.forwardRef($5ee77cf77bea3e63$var$StickyScrollBar);
module.exports.default = $5ee77cf77bea3e63$var$_default;

});
parcelRegister("5ZEjk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $45d1eb26c9fd0e8c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45d1eb26c9fd0e8c$var$addEventListenerWrap;

var $45d1eb26c9fd0e8c$var$_reactDom = $45d1eb26c9fd0e8c$require$_interopRequireDefault((parcelRequire("1u0KT")));
function $45d1eb26c9fd0e8c$var$addEventListenerWrap(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = $45d1eb26c9fd0e8c$var$_reactDom.default.unstable_batchedUpdates ? function run(e) {
        $45d1eb26c9fd0e8c$var$_reactDom.default.unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}

});

parcelRegister("cmULN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.get = $90139370c496f639$var$get;
module.exports.getClientSize = $90139370c496f639$var$getClientSize;
module.exports.getDocSize = $90139370c496f639$var$getDocSize;
module.exports.getOffset = $90139370c496f639$var$getOffset;
module.exports.getOuterHeight = $90139370c496f639$var$getOuterHeight;
module.exports.getOuterWidth = $90139370c496f639$var$getOuterWidth;
module.exports.getScroll = $90139370c496f639$var$getScroll;
module.exports.set = $90139370c496f639$var$set;
/* eslint-disable no-nested-ternary */ var $90139370c496f639$var$PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var $90139370c496f639$var$removePixel = {
    left: true,
    top: true
};
var $90139370c496f639$var$floatMap = {
    cssFloat: 1,
    styleFloat: 1,
    float: 1
};
function $90139370c496f639$var$getComputedStyle(node) {
    return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function $90139370c496f639$var$getStyleValue(node, type, value) {
    type = type.toLowerCase();
    if (value === 'auto') {
        if (type === 'height') return node.offsetHeight;
        if (type === 'width') return node.offsetWidth;
    }
    if (!(type in $90139370c496f639$var$removePixel)) $90139370c496f639$var$removePixel[type] = $90139370c496f639$var$PIXEL_PATTERN.test(type);
    return $90139370c496f639$var$removePixel[type] ? parseFloat(value) || 0 : value;
}
function $90139370c496f639$var$get(node, name) {
    var length = arguments.length;
    var style = $90139370c496f639$var$getComputedStyle(node);
    name = $90139370c496f639$var$floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
    return length === 1 ? style : $90139370c496f639$var$getStyleValue(node, name, style[name] || node.style[name]);
}
function $90139370c496f639$var$set(node, name, value) {
    var length = arguments.length;
    name = $90139370c496f639$var$floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
    if (length === 3) {
        if (typeof value === 'number' && $90139370c496f639$var$PIXEL_PATTERN.test(name)) value = "".concat(value, "px");
        node.style[name] = value; // Number
        return value;
    }
    for(var x in name)if (name.hasOwnProperty(x)) $90139370c496f639$var$set(node, x, name[x]);
    return $90139370c496f639$var$getComputedStyle(node);
}
function $90139370c496f639$var$getOuterWidth(el) {
    if (el === document.body) return document.documentElement.clientWidth;
    return el.offsetWidth;
}
function $90139370c496f639$var$getOuterHeight(el) {
    if (el === document.body) return window.innerHeight || document.documentElement.clientHeight;
    return el.offsetHeight;
}
function $90139370c496f639$var$getDocSize() {
    var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
    var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    return {
        width: width,
        height: height
    };
}
function $90139370c496f639$var$getClientSize() {
    var width = document.documentElement.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
}
function $90139370c496f639$var$getScroll() {
    return {
        scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
        scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    };
}
function $90139370c496f639$var$getOffset(node) {
    var box = node.getBoundingClientRect();
    var docElem = document.documentElement;
    // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}

});


parcelRegister("7V9P2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c4579c24a79f917$var$useSticky;

var $5c4579c24a79f917$var$_typeof2 = $1jnue((parcelRequire("41YNz")));

var $5c4579c24a79f917$var$React = $5c4579c24a79f917$var$_interopRequireWildcard((parcelRequire("acw62")));

var $5c4579c24a79f917$var$_canUseDom = $1jnue((parcelRequire("fpCN2")));
function $5c4579c24a79f917$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5c4579c24a79f917$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5c4579c24a79f917$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (parcelRequire("41YNz"))(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5c4579c24a79f917$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// fix ssr render
var $5c4579c24a79f917$var$defaultContainer = (0, $5c4579c24a79f917$var$_canUseDom.default)() ? window : null;
/** Sticky header hooks */ function $5c4579c24a79f917$var$useSticky(sticky, prefixCls) {
    var _ref = (0, $5c4579c24a79f917$var$_typeof2.default)(sticky) === 'object' ? sticky : {}, _ref$offsetHeader = _ref.offsetHeader, offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader, _ref$offsetSummary = _ref.offsetSummary, offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary, _ref$offsetScroll = _ref.offsetScroll, offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll, _ref$getContainer = _ref.getContainer, getContainer = _ref$getContainer === void 0 ? function() {
        return $5c4579c24a79f917$var$defaultContainer;
    } : _ref$getContainer;
    var container = getContainer() || $5c4579c24a79f917$var$defaultContainer;
    return $5c4579c24a79f917$var$React.useMemo(function() {
        var isSticky = !!sticky;
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-holder") : '',
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}

});

parcelRegister("e5mD3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41315f6b446485a$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $a41315f6b446485a$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $a41315f6b446485a$var$_toConsumableArray2 = $1jnue((parcelRequire("fUHKi")));

var $a41315f6b446485a$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $a41315f6b446485a$var$React = $a41315f6b446485a$var$_interopRequireWildcard((parcelRequire("acw62")));

var $a41315f6b446485a$var$_classnames = $1jnue((parcelRequire("8g1PZ")));

var $1XVSR = parcelRequire("1XVSR");

var $a41315f6b446485a$var$_ColGroup = $1jnue((parcelRequire("6Jiv3")));

var $a41315f6b446485a$var$_TableContext = $1jnue((parcelRequire("8BTXE")));
var $a41315f6b446485a$var$_excluded = [
    "className",
    "noData",
    "columns",
    "flattenColumns",
    "colWidths",
    "columCount",
    "stickyOffsets",
    "direction",
    "fixHeader",
    "stickyTopOffset",
    "stickyBottomOffset",
    "stickyClassName",
    "onScroll",
    "maxContentScroll",
    "children"
];
function $a41315f6b446485a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a41315f6b446485a$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a41315f6b446485a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a41315f6b446485a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a41315f6b446485a$var$useColumnWidth(colWidths, columCount) {
    return (0, $a41315f6b446485a$var$React.useMemo)(function() {
        var cloneColumns = [];
        for(var i = 0; i < columCount; i += 1){
            var val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join('_'),
        columCount
    ]);
}
var $a41315f6b446485a$var$FixedHolder = /*#__PURE__*/ $a41315f6b446485a$var$React.forwardRef(function(_ref, ref) {
    var className = _ref.className, noData = _ref.noData, columns = _ref.columns, flattenColumns = _ref.flattenColumns, colWidths = _ref.colWidths, columCount = _ref.columCount, stickyOffsets = _ref.stickyOffsets, direction = _ref.direction, fixHeader = _ref.fixHeader, stickyTopOffset = _ref.stickyTopOffset, stickyBottomOffset = _ref.stickyBottomOffset, stickyClassName = _ref.stickyClassName, onScroll = _ref.onScroll, maxContentScroll = _ref.maxContentScroll, children = _ref.children, props = (0, $a41315f6b446485a$var$_objectWithoutProperties2.default)(_ref, $a41315f6b446485a$var$_excluded);
    var _React$useContext = $a41315f6b446485a$var$React.useContext($a41315f6b446485a$var$_TableContext.default), prefixCls = _React$useContext.prefixCls, scrollbarSize = _React$useContext.scrollbarSize, isSticky = _React$useContext.isSticky;
    var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize; // Pass wheel to scroll event
    var scrollRef = $a41315f6b446485a$var$React.useRef(null);
    var setScrollRef = $a41315f6b446485a$var$React.useCallback(function(element) {
        (0, $1XVSR.fillRef)(ref, element);
        (0, $1XVSR.fillRef)(scrollRef, element);
    }, []);
    $a41315f6b446485a$var$React.useEffect(function() {
        var _scrollRef$current;
        function onWheel(e) {
            var currentTarget = e.currentTarget, deltaX = e.deltaX;
            if (deltaX) {
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: currentTarget.scrollLeft + deltaX
                });
                e.preventDefault();
            }
        }
        (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.addEventListener('wheel', onWheel);
        return function() {
            var _scrollRef$current2;
            (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 || _scrollRef$current2.removeEventListener('wheel', onWheel);
        };
    }, []); // Check if all flattenColumns has width
    var allFlattenColumnsWithWidth = $a41315f6b446485a$var$React.useMemo(function() {
        return flattenColumns.every(function(column) {
            return column.width >= 0;
        });
    }, [
        flattenColumns
    ]); // Add scrollbar column
    var lastColumn = flattenColumns[flattenColumns.length - 1];
    var ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: function onHeaderCell() {
            return {
                className: "".concat(prefixCls, "-cell-scrollbar")
            };
        }
    };
    var columnsWithScrollbar = (0, $a41315f6b446485a$var$React.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $a41315f6b446485a$var$_toConsumableArray2.default)(columns), [
            ScrollBarColumn
        ]) : columns;
    }, [
        combinationScrollBarSize,
        columns
    ]);
    var flattenColumnsWithScrollbar = (0, $a41315f6b446485a$var$React.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $a41315f6b446485a$var$_toConsumableArray2.default)(flattenColumns), [
            ScrollBarColumn
        ]) : flattenColumns;
    }, [
        combinationScrollBarSize,
        flattenColumns
    ]); // Calculate the sticky offsets
    var headerStickyOffsets = (0, $a41315f6b446485a$var$React.useMemo)(function() {
        var right = stickyOffsets.right, left = stickyOffsets.left;
        return (0, $a41315f6b446485a$var$_objectSpread2.default)((0, $a41315f6b446485a$var$_objectSpread2.default)({}, stickyOffsets), {}, {
            left: direction === 'rtl' ? [].concat((0, $a41315f6b446485a$var$_toConsumableArray2.default)(left.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]) : left,
            right: direction === 'rtl' ? right : [].concat((0, $a41315f6b446485a$var$_toConsumableArray2.default)(right.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]),
            isSticky: isSticky
        });
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    var mergedColumnWidth = $a41315f6b446485a$var$useColumnWidth(colWidths, columCount);
    return /*#__PURE__*/ $a41315f6b446485a$var$React.createElement("div", {
        style: (0, $a41315f6b446485a$var$_objectSpread2.default)({
            overflow: 'hidden'
        }, isSticky ? {
            top: stickyTopOffset,
            bottom: stickyBottomOffset
        } : {}),
        ref: setScrollRef,
        className: (0, $a41315f6b446485a$var$_classnames.default)(className, (0, $a41315f6b446485a$var$_defineProperty2.default)({}, stickyClassName, !!stickyClassName))
    }, /*#__PURE__*/ $a41315f6b446485a$var$React.createElement("table", {
        style: {
            tableLayout: 'fixed',
            visibility: noData || mergedColumnWidth ? null : 'hidden'
        }
    }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /*#__PURE__*/ $a41315f6b446485a$var$React.createElement($a41315f6b446485a$var$_ColGroup.default, {
        colWidths: mergedColumnWidth ? [].concat((0, $a41315f6b446485a$var$_toConsumableArray2.default)(mergedColumnWidth), [
            combinationScrollBarSize
        ]) : [],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children((0, $a41315f6b446485a$var$_objectSpread2.default)((0, $a41315f6b446485a$var$_objectSpread2.default)({}, props), {}, {
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    }))));
});
$a41315f6b446485a$var$FixedHolder.displayName = 'FixedHolder';
var $a41315f6b446485a$var$_default = $a41315f6b446485a$var$FixedHolder;
module.exports.default = $a41315f6b446485a$var$_default;

});


parcelRegister("cPSVu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9584daae64d77a8e$var$omit;
function $9584daae64d77a8e$var$omit(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

});

parcelRegister("kGKTK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f0fc1be1e7f51864$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f0fc1be1e7f51864$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigContext = module.exports.ConfigConsumer = void 0;
module.exports.withConfigConsumer = $f0fc1be1e7f51864$var$withConfigConsumer;

var $f0fc1be1e7f51864$var$_extends2 = $f0fc1be1e7f51864$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $f0fc1be1e7f51864$var$React = $f0fc1be1e7f51864$var$_interopRequireWildcard((parcelRequire("acw62")));
var $f0fc1be1e7f51864$var$defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : 'ant';
};
// zombieJ: 🚨 Do not pass `defaultRenderEmpty` here since it will case circular dependency.
var $f0fc1be1e7f51864$var$ConfigContext = module.exports.ConfigContext = /*#__PURE__*/ $f0fc1be1e7f51864$var$React.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $f0fc1be1e7f51864$var$defaultGetPrefixCls
});
var $f0fc1be1e7f51864$var$ConfigConsumer = module.exports.ConfigConsumer = $f0fc1be1e7f51864$var$ConfigContext.Consumer;
/** @deprecated Use hooks instead. This is a legacy function */ function $f0fc1be1e7f51864$var$withConfigConsumer(config) {
    return function withConfigConsumerFunc(Component) {
        // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
        var SFC = function SFC(props) {
            return /*#__PURE__*/ $f0fc1be1e7f51864$var$React.createElement($f0fc1be1e7f51864$var$ConfigConsumer, null, function(configProps) {
                var basicPrefixCls = config.prefixCls;
                var getPrefixCls = configProps.getPrefixCls;
                var customizePrefixCls = props.prefixCls;
                var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
                return /*#__PURE__*/ $f0fc1be1e7f51864$var$React.createElement(Component, (0, $f0fc1be1e7f51864$var$_extends2["default"])({}, configProps, props, {
                    prefixCls: prefixCls
                }));
            });
        };
        var cons = Component.constructor;
        var name = cons && cons.displayName || Component.name || 'Component';
        return SFC;
    };
}

});

parcelRegister("gAKvZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c1441703c6371529$var$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c1441703c6371529$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c1441703c6371529$var$React = $c1441703c6371529$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $c1441703c6371529$var$_empty = $c1441703c6371529$var$_interopRequireDefault((parcelRequire("dJr7p")));
var $c1441703c6371529$var$defaultRenderEmpty = function defaultRenderEmpty(componentName) {
    return /*#__PURE__*/ $c1441703c6371529$var$React.createElement($qBua1.ConfigConsumer, null, function(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefix = getPrefixCls('empty');
        switch(componentName){
            case 'Table':
            case 'List':
                return /*#__PURE__*/ $c1441703c6371529$var$React.createElement($c1441703c6371529$var$_empty["default"], {
                    image: $c1441703c6371529$var$_empty["default"].PRESENTED_IMAGE_SIMPLE
                });
            case 'Select':
            case 'TreeSelect':
            case 'Cascader':
            case 'Transfer':
            case 'Mentions':
                return /*#__PURE__*/ $c1441703c6371529$var$React.createElement($c1441703c6371529$var$_empty["default"], {
                    image: $c1441703c6371529$var$_empty["default"].PRESENTED_IMAGE_SIMPLE,
                    className: "".concat(prefix, "-small")
                });
            /* istanbul ignore next */ default:
                // Should never hit if we take all the component into consider.
                return /*#__PURE__*/ $c1441703c6371529$var$React.createElement($c1441703c6371529$var$_empty["default"], null);
        }
    });
};
var $c1441703c6371529$var$_default = module.exports["default"] = $c1441703c6371529$var$defaultRenderEmpty;

});
parcelRegister("qBua1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $04ff81a79192e0de$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $04ff81a79192e0de$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ConfigConsumer", {
    enumerable: true,
    get: function get() {
        return $kGKTK.ConfigConsumer;
    }
});
Object.defineProperty(module.exports, "ConfigContext", {
    enumerable: true,
    get: function get() {
        return $kGKTK.ConfigContext;
    }
});
module.exports.globalConfig = module.exports.defaultPrefixCls = module.exports.defaultIconPrefixCls = module.exports["default"] = module.exports.configConsumerProps = void 0;

var $04ff81a79192e0de$var$_extends2 = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $04ff81a79192e0de$var$_Context = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("9yTV7")));

var $04ff81a79192e0de$var$_useMemo = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("hf6LW")));

var $04ff81a79192e0de$var$React = $04ff81a79192e0de$var$_interopRequireWildcard((parcelRequire("acw62")));

var $kgPNT = parcelRequire("kgPNT");

var $04ff81a79192e0de$var$_validateMessagesContext = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("56IGl")));

var $04ff81a79192e0de$var$_localeProvider = $04ff81a79192e0de$var$_interopRequireWildcard((parcelRequire("k9dAI")));

var $04ff81a79192e0de$var$_LocaleReceiver = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("6DWWH")));

var $04ff81a79192e0de$var$_default2 = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("ca9uZ")));

var $04ff81a79192e0de$var$_message = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("eXn2O")));

var $04ff81a79192e0de$var$_notification = $04ff81a79192e0de$var$_interopRequireDefault((parcelRequire("jWQit")));

var $kGKTK = parcelRequire("kGKTK");

var $4YAqU = parcelRequire("4YAqU");

var $bzUGe = parcelRequire("bzUGe");

var $04ff81a79192e0de$var$_SizeContext = $04ff81a79192e0de$var$_interopRequireWildcard((parcelRequire("lGUuX")));
var $04ff81a79192e0de$var$configConsumerProps = module.exports.configConsumerProps = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale',
    'pageHeader'
];
// These props is used by `useContext` directly in sub component
var $04ff81a79192e0de$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'pageHeader',
    'input',
    'pagination',
    'form'
];
var $04ff81a79192e0de$var$defaultPrefixCls = module.exports.defaultPrefixCls = 'ant';
var $04ff81a79192e0de$var$defaultIconPrefixCls = module.exports.defaultIconPrefixCls = 'anticon';
var $04ff81a79192e0de$var$globalPrefixCls;
var $04ff81a79192e0de$var$globalIconPrefixCls;
function $04ff81a79192e0de$var$getGlobalPrefixCls() {
    return $04ff81a79192e0de$var$globalPrefixCls || $04ff81a79192e0de$var$defaultPrefixCls;
}
function $04ff81a79192e0de$var$getGlobalIconPrefixCls() {
    return $04ff81a79192e0de$var$globalIconPrefixCls || $04ff81a79192e0de$var$defaultIconPrefixCls;
}
var $04ff81a79192e0de$var$setGlobalConfig = function setGlobalConfig(_ref) {
    var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, theme = _ref.theme;
    if (prefixCls !== undefined) $04ff81a79192e0de$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $04ff81a79192e0de$var$globalIconPrefixCls = iconPrefixCls;
    if (theme) (0, $4YAqU.registerTheme)($04ff81a79192e0de$var$getGlobalPrefixCls(), theme);
};
var $04ff81a79192e0de$var$globalConfig = module.exports.globalConfig = function globalConfig() {
    return {
        getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? "".concat($04ff81a79192e0de$var$getGlobalPrefixCls(), "-").concat(suffixCls) : $04ff81a79192e0de$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $04ff81a79192e0de$var$getGlobalIconPrefixCls,
        getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
            // Customize rootPrefixCls is first priority
            if (rootPrefixCls) return rootPrefixCls;
            // If Global prefixCls provided, use this
            if ($04ff81a79192e0de$var$globalPrefixCls) return $04ff81a79192e0de$var$globalPrefixCls;
            // [Legacy] If customize prefixCls provided, we cut it to get the prefixCls
            if (customizePrefixCls && customizePrefixCls.includes('-')) return customizePrefixCls.replace(/^(.*)-[^-]*$/, '$1');
            // Fallback to default prefixCls
            return $04ff81a79192e0de$var$getGlobalPrefixCls();
        }
    };
};
var $04ff81a79192e0de$var$ProviderChildren = function ProviderChildren(props) {
    var children = props.children, csp = props.csp, autoInsertSpaceInButton = props.autoInsertSpaceInButton, form = props.form, locale = props.locale, componentSize = props.componentSize, direction = props.direction, space = props.space, virtual = props.virtual, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, legacyLocale = props.legacyLocale, parentContext = props.parentContext, iconPrefixCls = props.iconPrefixCls, componentDisabled = props.componentDisabled;
    var getPrefixCls = $04ff81a79192e0de$var$React.useCallback(function(suffixCls, customizePrefixCls) {
        var prefixCls = props.prefixCls;
        if (customizePrefixCls) return customizePrefixCls;
        var mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    var config = (0, $04ff81a79192e0de$var$_extends2["default"])((0, $04ff81a79192e0de$var$_extends2["default"])({}, parentContext), {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        getPrefixCls: getPrefixCls
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $04ff81a79192e0de$var$PASSED_PROPS.forEach(function(propName) {
        var propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    // https://github.com/ant-design/ant-design/issues/27617
    var memoedConfig = (0, $04ff81a79192e0de$var$_useMemo["default"])(function() {
        return config;
    }, config, function(prevConfig, currentConfig) {
        var prevKeys = Object.keys(prevConfig);
        var currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some(function(key) {
            return prevConfig[key] !== currentConfig[key];
        });
    });
    var memoIconContextValue = $04ff81a79192e0de$var$React.useMemo(function() {
        return {
            prefixCls: iconPrefixCls,
            csp: csp
        };
    }, [
        iconPrefixCls,
        csp
    ]);
    var childNode = children;
    var validateMessages = $04ff81a79192e0de$var$React.useMemo(function() {
        var _a, _b, _c, _d;
        return (0, $kgPNT.merge)(((_a = $04ff81a79192e0de$var$_default2["default"].Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($04ff81a79192e0de$var$_validateMessagesContext["default"].Provider, {
        value: validateMessages
    }, children);
    if (locale) childNode = /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($04ff81a79192e0de$var$_localeProvider["default"], {
        locale: locale,
        _ANT_MARK__: $04ff81a79192e0de$var$_localeProvider.ANT_MARK
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($04ff81a79192e0de$var$_Context["default"].Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($04ff81a79192e0de$var$_SizeContext.SizeContextProvider, {
        size: componentSize
    }, childNode);
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($bzUGe.DisabledContextProvider, {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($kGKTK.ConfigContext.Provider, {
        value: memoedConfig
    }, childNode);
};
var $04ff81a79192e0de$var$ConfigProvider = function ConfigProvider(props) {
    $04ff81a79192e0de$var$React.useEffect(function() {
        if (props.direction) {
            $04ff81a79192e0de$var$_message["default"].config({
                rtl: props.direction === 'rtl'
            });
            $04ff81a79192e0de$var$_notification["default"].config({
                rtl: props.direction === 'rtl'
            });
        }
    }, [
        props.direction
    ]);
    return /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($04ff81a79192e0de$var$_LocaleReceiver["default"], null, function(_, __, legacyLocale) {
        return /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($kGKTK.ConfigConsumer, null, function(context) {
            return /*#__PURE__*/ $04ff81a79192e0de$var$React.createElement($04ff81a79192e0de$var$ProviderChildren, (0, $04ff81a79192e0de$var$_extends2["default"])({
                parentContext: context,
                legacyLocale: legacyLocale
            }, props));
        });
    });
};
/** @private internal Usage. do not use in your production */ $04ff81a79192e0de$var$ConfigProvider.ConfigContext = $kGKTK.ConfigContext;
$04ff81a79192e0de$var$ConfigProvider.SizeContext = $04ff81a79192e0de$var$_SizeContext["default"];
$04ff81a79192e0de$var$ConfigProvider.config = $04ff81a79192e0de$var$setGlobalConfig;
var $04ff81a79192e0de$var$_default = module.exports["default"] = $04ff81a79192e0de$var$ConfigProvider;

});
parcelRegister("9yTV7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acw62 = parcelRequire("acw62");
var $6f62aaa45c3b60fe$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $6f62aaa45c3b60fe$var$_default = module.exports.default = $6f62aaa45c3b60fe$var$IconContext;

});

parcelRegister("kgPNT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ec1d7c6462d3209c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec1d7c6462d3209c$var$set;
module.exports.merge = $ec1d7c6462d3209c$var$merge;

var $ec1d7c6462d3209c$var$_typeof2 = $ec1d7c6462d3209c$require$_interopRequireDefault((parcelRequire("41YNz")));

var $ec1d7c6462d3209c$var$_objectSpread2 = $ec1d7c6462d3209c$require$_interopRequireDefault((parcelRequire("cbdLd")));

var $ec1d7c6462d3209c$var$_toConsumableArray2 = $ec1d7c6462d3209c$require$_interopRequireDefault((parcelRequire("fUHKi")));

var $ec1d7c6462d3209c$var$_toArray2 = $ec1d7c6462d3209c$require$_interopRequireDefault((parcelRequire("6PNir")));

var $ec1d7c6462d3209c$var$_get = $ec1d7c6462d3209c$require$_interopRequireDefault((parcelRequire("5Yz80")));
function $ec1d7c6462d3209c$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $ec1d7c6462d3209c$var$_toArray2.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $ec1d7c6462d3209c$var$_toConsumableArray2.default)(entity);
    else clone = (0, $ec1d7c6462d3209c$var$_objectSpread2.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $ec1d7c6462d3209c$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $ec1d7c6462d3209c$var$set(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $ec1d7c6462d3209c$var$_get.default)(entity, paths.slice(0, -1))) return entity;
    return $ec1d7c6462d3209c$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $ec1d7c6462d3209c$var$isObject(obj) {
    return (0, $ec1d7c6462d3209c$var$_typeof2.default)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $ec1d7c6462d3209c$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $ec1d7c6462d3209c$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
/**
 * Merge objects which will create
 */ function $ec1d7c6462d3209c$var$merge() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $ec1d7c6462d3209c$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $ec1d7c6462d3209c$var$_get.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $ec1d7c6462d3209c$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $ec1d7c6462d3209c$var$_get.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $ec1d7c6462d3209c$var$set(clone, path, []);
                    else if (!originValue || (0, $ec1d7c6462d3209c$var$_typeof2.default)(originValue) !== 'object') // Init container if not exist
                    clone = $ec1d7c6462d3209c$var$set(clone, path, $ec1d7c6462d3209c$var$createEmpty(value));
                    $ec1d7c6462d3209c$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $ec1d7c6462d3209c$var$_toConsumableArray2.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $ec1d7c6462d3209c$var$set(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});
parcelRegister("6PNir", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $4f9dbec1aa6260dc$var$_toArray(r) {
    return $gpDEB(r) || $hAHB6(r) || $72a6v(r) || $dIU5s();
}
module.exports = $4f9dbec1aa6260dc$var$_toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5Yz80", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $459dce0b3bc7dfbe$var$get;
function $459dce0b3bc7dfbe$var$get(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});


parcelRegister("56IGl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $acw62 = parcelRequire("acw62");
// ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
var $3b802c31672b7c22$var$_default = module.exports["default"] = /*#__PURE__*/ (0, $acw62.createContext)(undefined);

});

parcelRegister("k9dAI", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $eaaf30daaf3f5815$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eaaf30daaf3f5815$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.ANT_MARK = void 0;

var $eaaf30daaf3f5815$var$_extends2 = $eaaf30daaf3f5815$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $eaaf30daaf3f5815$var$React = $eaaf30daaf3f5815$var$_interopRequireWildcard((parcelRequire("acw62")));

var $eaaf30daaf3f5815$var$_warning = $eaaf30daaf3f5815$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $gDn4h = parcelRequire("gDn4h");

var $eaaf30daaf3f5815$var$_context = $eaaf30daaf3f5815$var$_interopRequireDefault((parcelRequire("abVHj")));
var $eaaf30daaf3f5815$var$ANT_MARK = module.exports.ANT_MARK = 'internalMark';
var $eaaf30daaf3f5815$var$LocaleProvider = function LocaleProvider(props) {
    var _props$locale = props.locale, locale = _props$locale === void 0 ? {} : _props$locale, children = props.children, _ANT_MARK__ = props._ANT_MARK__;
    $eaaf30daaf3f5815$var$React.useEffect(function() {
        (0, $gDn4h.changeConfirmLocale)(locale && locale.Modal);
        return function() {
            (0, $gDn4h.changeConfirmLocale)();
        };
    }, [
        locale
    ]);
    var getMemoizedContextValue = $eaaf30daaf3f5815$var$React.useMemo(function() {
        return (0, $eaaf30daaf3f5815$var$_extends2["default"])((0, $eaaf30daaf3f5815$var$_extends2["default"])({}, locale), {
            exist: true
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ $eaaf30daaf3f5815$var$React.createElement($eaaf30daaf3f5815$var$_context["default"].Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $eaaf30daaf3f5815$var$_default = module.exports["default"] = $eaaf30daaf3f5815$var$LocaleProvider;

});
parcelRegister("3bEAF", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2521e295c67ab622$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
module.exports.noop = $2521e295c67ab622$var$noop;
Object.defineProperty(module.exports, "resetWarned", {
    enumerable: true,
    get: function get() {
        return $2521e295c67ab622$var$_warning.resetWarned;
    }
});

var $2521e295c67ab622$var$_warning = $2521e295c67ab622$var$_interopRequireWildcard((parcelRequire("dtSXD")));
function $2521e295c67ab622$var$noop() {}
// eslint-disable-next-line import/no-mutable-exports
var $2521e295c67ab622$var$warning = $2521e295c67ab622$var$noop;
var $2521e295c67ab622$var$_default = module.exports["default"] = $2521e295c67ab622$var$warning;

});

parcelRegister("gDn4h", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c1c22eb6b480a0e7$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.changeConfirmLocale = $c1c22eb6b480a0e7$var$changeConfirmLocale;
module.exports.getConfirmLocale = $c1c22eb6b480a0e7$var$getConfirmLocale;

var $c1c22eb6b480a0e7$var$_extends2 = $c1c22eb6b480a0e7$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $c1c22eb6b480a0e7$var$_default = $c1c22eb6b480a0e7$var$_interopRequireDefault((parcelRequire("ca9uZ")));
var $c1c22eb6b480a0e7$var$runtimeLocale = (0, $c1c22eb6b480a0e7$var$_extends2["default"])({}, $c1c22eb6b480a0e7$var$_default["default"].Modal);
function $c1c22eb6b480a0e7$var$changeConfirmLocale(newLocale) {
    if (newLocale) $c1c22eb6b480a0e7$var$runtimeLocale = (0, $c1c22eb6b480a0e7$var$_extends2["default"])((0, $c1c22eb6b480a0e7$var$_extends2["default"])({}, $c1c22eb6b480a0e7$var$runtimeLocale), newLocale);
    else $c1c22eb6b480a0e7$var$runtimeLocale = (0, $c1c22eb6b480a0e7$var$_extends2["default"])({}, $c1c22eb6b480a0e7$var$_default["default"].Modal);
}
function $c1c22eb6b480a0e7$var$getConfirmLocale() {
    return $c1c22eb6b480a0e7$var$runtimeLocale;
}

});
parcelRegister("ca9uZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8dadc97f27db4a23$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8dadc97f27db4a23$var$_en_US = $8dadc97f27db4a23$var$_interopRequireDefault((parcelRequire("33no6")));

var $8dadc97f27db4a23$var$_en_US2 = $8dadc97f27db4a23$var$_interopRequireDefault((parcelRequire("i6KeB")));

var $8dadc97f27db4a23$var$_en_US3 = $8dadc97f27db4a23$var$_interopRequireDefault((parcelRequire("gwWQR")));

var $8dadc97f27db4a23$var$_en_US4 = $8dadc97f27db4a23$var$_interopRequireDefault((parcelRequire("3U3yH")));
/* eslint-disable no-template-curly-in-string */ var $8dadc97f27db4a23$var$typeTemplate = '${label} is not a valid ${type}';
var $8dadc97f27db4a23$var$localeValues = {
    locale: 'en',
    Pagination: $8dadc97f27db4a23$var$_en_US["default"],
    DatePicker: $8dadc97f27db4a23$var$_en_US3["default"],
    TimePicker: $8dadc97f27db4a23$var$_en_US4["default"],
    Calendar: $8dadc97f27db4a23$var$_en_US2["default"],
    global: {
        placeholder: 'Please select'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckall: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand'
    },
    PageHeader: {
        back: 'Back'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            "default": 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            "enum": '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $8dadc97f27db4a23$var$typeTemplate,
                method: $8dadc97f27db4a23$var$typeTemplate,
                array: $8dadc97f27db4a23$var$typeTemplate,
                object: $8dadc97f27db4a23$var$typeTemplate,
                number: $8dadc97f27db4a23$var$typeTemplate,
                date: $8dadc97f27db4a23$var$typeTemplate,
                "boolean": $8dadc97f27db4a23$var$typeTemplate,
                integer: $8dadc97f27db4a23$var$typeTemplate,
                "float": $8dadc97f27db4a23$var$typeTemplate,
                regexp: $8dadc97f27db4a23$var$typeTemplate,
                email: $8dadc97f27db4a23$var$typeTemplate,
                url: $8dadc97f27db4a23$var$typeTemplate,
                hex: $8dadc97f27db4a23$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    }
};
var $8dadc97f27db4a23$var$_default = module.exports["default"] = $8dadc97f27db4a23$var$localeValues;

});
parcelRegister("33no6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2393cb34fb63d455$var$_default = {
    // Options.jsx
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination.jsx
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
module.exports.default = $2393cb34fb63d455$var$_default;

});

parcelRegister("i6KeB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2eca6c0f308b69e$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d2eca6c0f308b69e$var$_en_US = $d2eca6c0f308b69e$var$_interopRequireDefault((parcelRequire("gwWQR")));
var $d2eca6c0f308b69e$var$_default = module.exports["default"] = $d2eca6c0f308b69e$var$_en_US["default"];

});
parcelRegister("gwWQR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c08d492d8efb32a0$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c08d492d8efb32a0$var$_extends2 = $c08d492d8efb32a0$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $c08d492d8efb32a0$var$_en_US = $c08d492d8efb32a0$var$_interopRequireDefault((parcelRequire("eUQkk")));

var $c08d492d8efb32a0$var$_en_US2 = $c08d492d8efb32a0$var$_interopRequireDefault((parcelRequire("3U3yH")));
// Merge into a locale object
var $c08d492d8efb32a0$var$locale = {
    lang: (0, $c08d492d8efb32a0$var$_extends2["default"])({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, $c08d492d8efb32a0$var$_en_US["default"]),
    timePickerLocale: (0, $c08d492d8efb32a0$var$_extends2["default"])({}, $c08d492d8efb32a0$var$_en_US2["default"])
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
var $c08d492d8efb32a0$var$_default = module.exports["default"] = $c08d492d8efb32a0$var$locale;

});
parcelRegister("eUQkk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $adbee2a7ae687442$var$locale = {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    yearFormat: 'YYYY',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
};
var $adbee2a7ae687442$var$_default = $adbee2a7ae687442$var$locale;
module.exports.default = $adbee2a7ae687442$var$_default;

});

parcelRegister("3U3yH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $2d795cbf897d95e2$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $2d795cbf897d95e2$var$_default = module.exports["default"] = $2d795cbf897d95e2$var$locale;

});





parcelRegister("abVHj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $acw62 = parcelRequire("acw62");
var $76b7b002fd97cbfe$var$LocaleContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $76b7b002fd97cbfe$var$_default = module.exports["default"] = $76b7b002fd97cbfe$var$LocaleContext;

});


parcelRegister("6DWWH", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4d641c000781dc74$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4d641c000781dc74$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocaleReceiver = module.exports["default"] = void 0;

var $4d641c000781dc74$var$_extends2 = $4d641c000781dc74$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $4d641c000781dc74$var$React = $4d641c000781dc74$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4d641c000781dc74$var$_context = $4d641c000781dc74$var$_interopRequireDefault((parcelRequire("abVHj")));

var $4d641c000781dc74$var$_default2 = $4d641c000781dc74$var$_interopRequireDefault((parcelRequire("4h0pm")));
var $4d641c000781dc74$var$LocaleReceiver = function LocaleReceiver(props) {
    var _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? 'global' : _props$componentName, defaultLocale = props.defaultLocale, children = props.children;
    var antLocale = $4d641c000781dc74$var$React.useContext($4d641c000781dc74$var$_context["default"]);
    var getLocale = $4d641c000781dc74$var$React.useMemo(function() {
        var _a;
        var locale = defaultLocale || $4d641c000781dc74$var$_default2["default"][componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $4d641c000781dc74$var$_extends2["default"])((0, $4d641c000781dc74$var$_extends2["default"])({}, locale instanceof Function ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    var getLocaleCode = $4d641c000781dc74$var$React.useMemo(function() {
        var localeCode = antLocale && antLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (antLocale && antLocale.exist && !localeCode) return $4d641c000781dc74$var$_default2["default"].locale;
        return localeCode;
    }, [
        antLocale
    ]);
    return children(getLocale, getLocaleCode, antLocale);
};
var $4d641c000781dc74$var$_default = module.exports["default"] = $4d641c000781dc74$var$LocaleReceiver;
var $4d641c000781dc74$var$useLocaleReceiver = module.exports.useLocaleReceiver = function useLocaleReceiver(componentName, defaultLocale) {
    var antLocale = $4d641c000781dc74$var$React.useContext($4d641c000781dc74$var$_context["default"]);
    var getLocale = $4d641c000781dc74$var$React.useMemo(function() {
        var _a;
        var locale = defaultLocale || $4d641c000781dc74$var$_default2["default"][componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $4d641c000781dc74$var$_extends2["default"])((0, $4d641c000781dc74$var$_extends2["default"])({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    return [
        getLocale
    ];
};

});
parcelRegister("4h0pm", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $31c910fd1c90fd03$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $31c910fd1c90fd03$var$_default2 = $31c910fd1c90fd03$var$_interopRequireDefault((parcelRequire("ca9uZ")));
var $31c910fd1c90fd03$var$_default = module.exports["default"] = $31c910fd1c90fd03$var$_default2["default"];

});


parcelRegister("eXn2O", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $02cf5cb3b6446455$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $02cf5cb3b6446455$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attachTypeApi = $02cf5cb3b6446455$var$attachTypeApi;
module.exports.getInstance = module.exports["default"] = void 0;
module.exports.getKeyThenIncreaseKey = $02cf5cb3b6446455$var$getKeyThenIncreaseKey;
module.exports.typeList = void 0;

var $02cf5cb3b6446455$var$_extends2 = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $02cf5cb3b6446455$var$_defineProperty2 = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $02cf5cb3b6446455$var$_CheckCircleFilled = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("hibZs")));

var $02cf5cb3b6446455$var$_CloseCircleFilled = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("coSzL")));

var $02cf5cb3b6446455$var$_ExclamationCircleFilled = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("b53i3")));

var $02cf5cb3b6446455$var$_InfoCircleFilled = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("7rMuR")));

var $02cf5cb3b6446455$var$_LoadingOutlined = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("53y9T")));

var $02cf5cb3b6446455$var$_classnames = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $02cf5cb3b6446455$var$_rcNotification = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("3DXWh")));

var $02cf5cb3b6446455$var$React = $02cf5cb3b6446455$var$_interopRequireWildcard((parcelRequire("acw62")));

var $02cf5cb3b6446455$var$_configProvider = $02cf5cb3b6446455$var$_interopRequireWildcard((parcelRequire("qBua1")));

var $02cf5cb3b6446455$var$_useMessage = $02cf5cb3b6446455$var$_interopRequireDefault((parcelRequire("BDu88")));
var $02cf5cb3b6446455$var$messageInstance;
var $02cf5cb3b6446455$var$defaultDuration = 3;
var $02cf5cb3b6446455$var$defaultTop;
var $02cf5cb3b6446455$var$key = 1;
var $02cf5cb3b6446455$var$localPrefixCls = '';
var $02cf5cb3b6446455$var$transitionName = 'move-up';
var $02cf5cb3b6446455$var$hasTransitionName = false;
var $02cf5cb3b6446455$var$getContainer;
var $02cf5cb3b6446455$var$maxCount;
var $02cf5cb3b6446455$var$rtl = false;
function $02cf5cb3b6446455$var$getKeyThenIncreaseKey() {
    return $02cf5cb3b6446455$var$key++;
}
function $02cf5cb3b6446455$var$setMessageConfig(options) {
    if (options.top !== undefined) {
        $02cf5cb3b6446455$var$defaultTop = options.top;
        $02cf5cb3b6446455$var$messageInstance = null; // delete messageInstance for new defaultTop
    }
    if (options.duration !== undefined) $02cf5cb3b6446455$var$defaultDuration = options.duration;
    if (options.prefixCls !== undefined) $02cf5cb3b6446455$var$localPrefixCls = options.prefixCls;
    if (options.getContainer !== undefined) {
        $02cf5cb3b6446455$var$getContainer = options.getContainer;
        $02cf5cb3b6446455$var$messageInstance = null; // delete messageInstance for new getContainer
    }
    if (options.transitionName !== undefined) {
        $02cf5cb3b6446455$var$transitionName = options.transitionName;
        $02cf5cb3b6446455$var$messageInstance = null; // delete messageInstance for new transitionName
        $02cf5cb3b6446455$var$hasTransitionName = true;
    }
    if (options.maxCount !== undefined) {
        $02cf5cb3b6446455$var$maxCount = options.maxCount;
        $02cf5cb3b6446455$var$messageInstance = null;
    }
    if (options.rtl !== undefined) $02cf5cb3b6446455$var$rtl = options.rtl;
}
function $02cf5cb3b6446455$var$getRCNotificationInstance(args, callback) {
    var customizePrefixCls = args.prefixCls, getContextPopupContainer = args.getPopupContainer;
    var _globalConfig = (0, $02cf5cb3b6446455$var$_configProvider.globalConfig)(), getPrefixCls = _globalConfig.getPrefixCls, getRootPrefixCls = _globalConfig.getRootPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls('message', customizePrefixCls || $02cf5cb3b6446455$var$localPrefixCls);
    var rootPrefixCls = getRootPrefixCls(args.rootPrefixCls, prefixCls);
    var iconPrefixCls = getIconPrefixCls();
    if ($02cf5cb3b6446455$var$messageInstance) {
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: $02cf5cb3b6446455$var$messageInstance
        });
        return;
    }
    var instanceConfig = {
        prefixCls: prefixCls,
        transitionName: $02cf5cb3b6446455$var$hasTransitionName ? $02cf5cb3b6446455$var$transitionName : "".concat(rootPrefixCls, "-").concat($02cf5cb3b6446455$var$transitionName),
        style: {
            top: $02cf5cb3b6446455$var$defaultTop
        },
        getContainer: $02cf5cb3b6446455$var$getContainer || getContextPopupContainer,
        maxCount: $02cf5cb3b6446455$var$maxCount
    };
    $02cf5cb3b6446455$var$_rcNotification["default"].newInstance(instanceConfig, function(instance) {
        if ($02cf5cb3b6446455$var$messageInstance) {
            callback({
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                instance: $02cf5cb3b6446455$var$messageInstance
            });
            return;
        }
        $02cf5cb3b6446455$var$messageInstance = instance;
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: instance
        });
    });
}
var $02cf5cb3b6446455$var$typeToIcon = {
    info: $02cf5cb3b6446455$var$_InfoCircleFilled["default"],
    success: $02cf5cb3b6446455$var$_CheckCircleFilled["default"],
    error: $02cf5cb3b6446455$var$_CloseCircleFilled["default"],
    warning: $02cf5cb3b6446455$var$_ExclamationCircleFilled["default"],
    loading: $02cf5cb3b6446455$var$_LoadingOutlined["default"]
};
var $02cf5cb3b6446455$var$typeList = module.exports.typeList = Object.keys($02cf5cb3b6446455$var$typeToIcon);
function $02cf5cb3b6446455$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var duration = args.duration !== undefined ? args.duration : $02cf5cb3b6446455$var$defaultDuration;
    var IconComponent = $02cf5cb3b6446455$var$typeToIcon[args.type];
    var messageClass = (0, $02cf5cb3b6446455$var$_classnames["default"])("".concat(prefixCls, "-custom-content"), (0, $02cf5cb3b6446455$var$_defineProperty2["default"])((0, $02cf5cb3b6446455$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-").concat(args.type), args.type), "".concat(prefixCls, "-rtl"), $02cf5cb3b6446455$var$rtl === true));
    return {
        key: args.key,
        duration: duration,
        style: args.style || {},
        className: args.className,
        content: /*#__PURE__*/ $02cf5cb3b6446455$var$React.createElement($02cf5cb3b6446455$var$_configProvider["default"], {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $02cf5cb3b6446455$var$React.createElement("div", {
            className: messageClass
        }, args.icon || IconComponent && /*#__PURE__*/ $02cf5cb3b6446455$var$React.createElement(IconComponent, null), /*#__PURE__*/ $02cf5cb3b6446455$var$React.createElement("span", null, args.content))),
        onClose: args.onClose,
        onClick: args.onClick
    };
}
function $02cf5cb3b6446455$var$notice(args) {
    var target = args.key || $02cf5cb3b6446455$var$getKeyThenIncreaseKey();
    var closePromise = new Promise(function(resolve) {
        var callback = function callback() {
            if (typeof args.onClose === 'function') args.onClose();
            return resolve(true);
        };
        $02cf5cb3b6446455$var$getRCNotificationInstance(args, function(_ref) {
            var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
            instance.notice($02cf5cb3b6446455$var$getRCNoticeProps((0, $02cf5cb3b6446455$var$_extends2["default"])((0, $02cf5cb3b6446455$var$_extends2["default"])({}, args), {
                key: target,
                onClose: callback
            }), prefixCls, iconPrefixCls));
        });
    });
    var result = function result() {
        var _a;
        if ($02cf5cb3b6446455$var$messageInstance) {
            $02cf5cb3b6446455$var$messageInstance.removeNotice(target);
            (_a = args.onClose) === null || _a === void 0 || _a.call(args);
        }
    };
    result.then = function(filled, rejected) {
        return closePromise.then(filled, rejected);
    };
    result.promise = closePromise;
    return result;
}
function $02cf5cb3b6446455$var$isArgsProps(content) {
    return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}
var $02cf5cb3b6446455$var$api = {
    open: $02cf5cb3b6446455$var$notice,
    config: $02cf5cb3b6446455$var$setMessageConfig,
    destroy: function destroy(messageKey) {
        if ($02cf5cb3b6446455$var$messageInstance) {
            if (messageKey) {
                var _messageInstance = $02cf5cb3b6446455$var$messageInstance, removeNotice = _messageInstance.removeNotice;
                removeNotice(messageKey);
            } else {
                var _messageInstance2 = $02cf5cb3b6446455$var$messageInstance, destroy = _messageInstance2.destroy;
                destroy();
                $02cf5cb3b6446455$var$messageInstance = null;
            }
        }
    }
};
function $02cf5cb3b6446455$var$attachTypeApi(originalApi, type) {
    originalApi[type] = function(content, duration, onClose) {
        if ($02cf5cb3b6446455$var$isArgsProps(content)) return originalApi.open((0, $02cf5cb3b6446455$var$_extends2["default"])((0, $02cf5cb3b6446455$var$_extends2["default"])({}, content), {
            type: type
        }));
        if (typeof duration === 'function') {
            onClose = duration;
            duration = undefined;
        }
        return originalApi.open({
            content: content,
            duration: duration,
            type: type,
            onClose: onClose
        });
    };
}
$02cf5cb3b6446455$var$typeList.forEach(function(type) {
    return $02cf5cb3b6446455$var$attachTypeApi($02cf5cb3b6446455$var$api, type);
});
$02cf5cb3b6446455$var$api.warn = $02cf5cb3b6446455$var$api.warning;
$02cf5cb3b6446455$var$api.useMessage = (0, $02cf5cb3b6446455$var$_useMessage["default"])($02cf5cb3b6446455$var$getRCNotificationInstance, $02cf5cb3b6446455$var$getRCNoticeProps);
/** @internal test Only function. Not work on production */ var $02cf5cb3b6446455$var$getInstance = module.exports.getInstance = function getInstance() {
    return null;
};
var $02cf5cb3b6446455$var$_default = module.exports["default"] = $02cf5cb3b6446455$var$api;

});
parcelRegister("hibZs", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c96d6b21e35f6645$var$_CheckCircleFilled = $c96d6b21e35f6645$var$_interopRequireDefault((parcelRequire("3prbj")));
function $c96d6b21e35f6645$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $c96d6b21e35f6645$var$_default = $c96d6b21e35f6645$var$_CheckCircleFilled;
module.exports.default = $c96d6b21e35f6645$var$_default;
module.exports = $c96d6b21e35f6645$var$_default;

});
parcelRegister("3prbj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27b8ca97a81870e3$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $27b8ca97a81870e3$var$React = $27b8ca97a81870e3$var$_interopRequireWildcard((parcelRequire("acw62")));

var $27b8ca97a81870e3$var$_CheckCircleFilled = $1jnue((parcelRequire("4s9Vx")));

var $27b8ca97a81870e3$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $27b8ca97a81870e3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($27b8ca97a81870e3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $27b8ca97a81870e3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $27b8ca97a81870e3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $27b8ca97a81870e3$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $27b8ca97a81870e3$var$React.createElement($27b8ca97a81870e3$var$_AntdIcon.default, (0, $27b8ca97a81870e3$var$_objectSpread2.default)((0, $27b8ca97a81870e3$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $27b8ca97a81870e3$var$_CheckCircleFilled.default
    }));
};
var $27b8ca97a81870e3$var$RefIcon = /*#__PURE__*/ $27b8ca97a81870e3$var$React.forwardRef($27b8ca97a81870e3$var$CheckCircleFilled);
var $27b8ca97a81870e3$var$_default = module.exports.default = $27b8ca97a81870e3$var$RefIcon;

});
parcelRegister("4s9Vx", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $33e17a3cc0332dbb$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
module.exports.default = $33e17a3cc0332dbb$var$CheckCircleFilled;

});

parcelRegister("8RiIQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6731cbcdc45ad955$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $6731cbcdc45ad955$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $6731cbcdc45ad955$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $6731cbcdc45ad955$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $6731cbcdc45ad955$var$React = $6731cbcdc45ad955$var$_interopRequireWildcard((parcelRequire("acw62")));

var $6731cbcdc45ad955$var$_classnames = $1jnue((parcelRequire("8g1PZ")));

var $6731cbcdc45ad955$var$_Context = $1jnue((parcelRequire("9yTV7")));

var $6731cbcdc45ad955$var$_IconBase = $1jnue((parcelRequire("jbjU4")));

var $2TKXA = parcelRequire("2TKXA");

var $atw3k = parcelRequire("atw3k");
var $6731cbcdc45ad955$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
function $6731cbcdc45ad955$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6731cbcdc45ad955$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6731cbcdc45ad955$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $6731cbcdc45ad955$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// Initial setting
// should move it to antd main repo?
(0, $2TKXA.setTwoToneColor)('#1890ff');
var $6731cbcdc45ad955$var$Icon = /*#__PURE__*/ $6731cbcdc45ad955$var$React.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $6731cbcdc45ad955$var$_objectWithoutProperties2.default)(props, $6731cbcdc45ad955$var$_excluded);
    var _React$useContext = $6731cbcdc45ad955$var$React.useContext($6731cbcdc45ad955$var$_Context.default), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, $6731cbcdc45ad955$var$_classnames.default)(rootClassName, prefixCls, (0, $6731cbcdc45ad955$var$_defineProperty2.default)((0, $6731cbcdc45ad955$var$_defineProperty2.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $atw3k.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $6731cbcdc45ad955$var$_slicedToArray2.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $6731cbcdc45ad955$var$React.createElement("span", (0, $6731cbcdc45ad955$var$_objectSpread2.default)((0, $6731cbcdc45ad955$var$_objectSpread2.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps), {}, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $6731cbcdc45ad955$var$React.createElement($6731cbcdc45ad955$var$_IconBase.default, {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$6731cbcdc45ad955$var$Icon.displayName = 'AntdIcon';
$6731cbcdc45ad955$var$Icon.getTwoToneColor = $2TKXA.getTwoToneColor;
$6731cbcdc45ad955$var$Icon.setTwoToneColor = $2TKXA.setTwoToneColor;
var $6731cbcdc45ad955$var$_default = module.exports.default = $6731cbcdc45ad955$var$Icon;

});
parcelRegister("jbjU4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df6e7bcafa69b979$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $df6e7bcafa69b979$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $atw3k = parcelRequire("atw3k");
var $df6e7bcafa69b979$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $df6e7bcafa69b979$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $df6e7bcafa69b979$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $df6e7bcafa69b979$var$twoToneColorPalette.primaryColor = primaryColor;
    $df6e7bcafa69b979$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $atw3k.getSecondaryColor)(primaryColor);
    $df6e7bcafa69b979$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $df6e7bcafa69b979$var$getTwoToneColors() {
    return (0, $df6e7bcafa69b979$var$_objectSpread2.default)({}, $df6e7bcafa69b979$var$twoToneColorPalette);
}
var $df6e7bcafa69b979$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $df6e7bcafa69b979$var$_objectWithoutProperties2.default)(props, $df6e7bcafa69b979$var$_excluded);
    var colors = $df6e7bcafa69b979$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $atw3k.getSecondaryColor)(primaryColor)
    };
    (0, $atw3k.useInsertStyles)();
    (0, $atw3k.warning)((0, $atw3k.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $atw3k.isIconDefinition)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $df6e7bcafa69b979$var$_objectSpread2.default)((0, $df6e7bcafa69b979$var$_objectSpread2.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $atw3k.generate)(target.icon, "svg-".concat(target.name), (0, $df6e7bcafa69b979$var$_objectSpread2.default)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps));
};
$df6e7bcafa69b979$var$IconBase.displayName = 'IconReact';
$df6e7bcafa69b979$var$IconBase.getTwoToneColors = $df6e7bcafa69b979$var$getTwoToneColors;
$df6e7bcafa69b979$var$IconBase.setTwoToneColors = $df6e7bcafa69b979$var$setTwoToneColors;
var $df6e7bcafa69b979$var$_default = module.exports.default = $df6e7bcafa69b979$var$IconBase;

});
parcelRegister("atw3k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generate = $7a0579ceef65277b$var$generate;
module.exports.getSecondaryColor = $7a0579ceef65277b$var$getSecondaryColor;
module.exports.iconStyles = void 0;
module.exports.isIconDefinition = $7a0579ceef65277b$var$isIconDefinition;
module.exports.normalizeAttrs = $7a0579ceef65277b$var$normalizeAttrs;
module.exports.normalizeTwoToneColors = $7a0579ceef65277b$var$normalizeTwoToneColors;
module.exports.useInsertStyles = module.exports.svgBaseProps = void 0;
module.exports.warning = $7a0579ceef65277b$var$warning;

var $7a0579ceef65277b$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $7a0579ceef65277b$var$_typeof2 = $1jnue((parcelRequire("41YNz")));

var $dnPM8 = parcelRequire("dnPM8");

var $7a0579ceef65277b$var$_react = $7a0579ceef65277b$var$_interopRequireWildcard((parcelRequire("acw62")));

var $7a0579ceef65277b$var$_warning = $1jnue((parcelRequire("dtSXD")));

var $1Sv8Y = parcelRequire("1Sv8Y");

var $7a0579ceef65277b$var$_Context = $1jnue((parcelRequire("9yTV7")));

var $7a0579ceef65277b$var$_camelCase = $1jnue((parcelRequire("ikqdL")));
function $7a0579ceef65277b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7a0579ceef65277b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7a0579ceef65277b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (parcelRequire("41YNz"))(e) && "function" != typeof e) return {
        default: e
    };
    var t = $7a0579ceef65277b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $7a0579ceef65277b$var$warning(valid, message) {
    (0, $7a0579ceef65277b$var$_warning.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $7a0579ceef65277b$var$isIconDefinition(target) {
    return (0, $7a0579ceef65277b$var$_typeof2.default)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $7a0579ceef65277b$var$_typeof2.default)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $7a0579ceef65277b$var$normalizeAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[(0, $7a0579ceef65277b$var$_camelCase.default)(key)] = val;
        }
        return acc;
    }, {});
}
function $7a0579ceef65277b$var$generate(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ $7a0579ceef65277b$var$_react.default.createElement(node.tag, (0, $7a0579ceef65277b$var$_objectSpread2.default)({
        key: key
    }, $7a0579ceef65277b$var$normalizeAttrs(node.attrs)), (node.children || []).map(function(child, index) {
        return $7a0579ceef65277b$var$generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ $7a0579ceef65277b$var$_react.default.createElement(node.tag, (0, $7a0579ceef65277b$var$_objectSpread2.default)((0, $7a0579ceef65277b$var$_objectSpread2.default)({
        key: key
    }, $7a0579ceef65277b$var$normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $7a0579ceef65277b$var$generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $7a0579ceef65277b$var$getSecondaryColor(primaryColor) {
    // choose the second color
    return (0, $dnPM8.generate)(primaryColor)[0];
}
function $7a0579ceef65277b$var$normalizeTwoToneColors(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var $7a0579ceef65277b$var$svgBaseProps = module.exports.svgBaseProps = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $7a0579ceef65277b$var$iconStyles = module.exports.iconStyles = "\n.anticon {\n  display: inline-flex;\n  alignItems: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $7a0579ceef65277b$var$useInsertStyles = module.exports.useInsertStyles = function useInsertStyles() {
    var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $7a0579ceef65277b$var$iconStyles;
    var _useContext = (0, $7a0579ceef65277b$var$_react.useContext)($7a0579ceef65277b$var$_Context.default), csp = _useContext.csp;
    (0, $7a0579ceef65277b$var$_react.useEffect)(function() {
        (0, $1Sv8Y.updateCSS)(styleStr, '@ant-design-icons', {
            prepend: true,
            csp: csp
        });
    }, []);
};

});
parcelRegister("dnPM8", function(module, exports) {

$parcel$export(module.exports, "generate", () => $9be595d6876ce7ed$export$80d376111cc09ad7);

var $5BsRb = parcelRequire("5BsRb");
var $82UWo = parcelRequire("82UWo");
var $9be595d6876ce7ed$var$hueStep = 2; // 色相阶梯
var $9be595d6876ce7ed$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $9be595d6876ce7ed$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $9be595d6876ce7ed$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $9be595d6876ce7ed$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $9be595d6876ce7ed$var$lightColorCount = 5; // 浅色数量，主色上
var $9be595d6876ce7ed$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $9be595d6876ce7ed$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $9be595d6876ce7ed$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $82UWo.rgbToHsv)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $9be595d6876ce7ed$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $82UWo.rgbToHex)(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $9be595d6876ce7ed$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $9be595d6876ce7ed$var$getHue(hsv, i, light) {
    var hue; // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $9be595d6876ce7ed$var$hueStep * i : Math.round(hsv.h) + $9be595d6876ce7ed$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $9be595d6876ce7ed$var$hueStep * i : Math.round(hsv.h) - $9be595d6876ce7ed$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $9be595d6876ce7ed$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $9be595d6876ce7ed$var$saturationStep * i;
    else if (i === $9be595d6876ce7ed$var$darkColorCount) saturation = hsv.s + $9be595d6876ce7ed$var$saturationStep;
    else saturation = hsv.s + $9be595d6876ce7ed$var$saturationStep2 * i;
     // 边界值修正
    if (saturation > 1) saturation = 1;
     // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $9be595d6876ce7ed$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $9be595d6876ce7ed$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $9be595d6876ce7ed$var$brightnessStep1 * i;
    else value = hsv.v - $9be595d6876ce7ed$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $9be595d6876ce7ed$export$80d376111cc09ad7(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $5BsRb.inputToRGB)(color);
    for(var i = $9be595d6876ce7ed$var$lightColorCount; i > 0; i -= 1){
        var hsv = $9be595d6876ce7ed$var$toHsv(pColor);
        var colorString = $9be595d6876ce7ed$var$toHex((0, $5BsRb.inputToRGB)({
            h: $9be595d6876ce7ed$var$getHue(hsv, i, true),
            s: $9be595d6876ce7ed$var$getSaturation(hsv, i, true),
            v: $9be595d6876ce7ed$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($9be595d6876ce7ed$var$toHex(pColor));
    for(var _i = 1; _i <= $9be595d6876ce7ed$var$darkColorCount; _i += 1){
        var _hsv = $9be595d6876ce7ed$var$toHsv(pColor);
        var _colorString = $9be595d6876ce7ed$var$toHex((0, $5BsRb.inputToRGB)({
            h: $9be595d6876ce7ed$var$getHue(_hsv, _i),
            s: $9be595d6876ce7ed$var$getSaturation(_hsv, _i),
            v: $9be595d6876ce7ed$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    } // dark theme patterns
    if (opts.theme === 'dark') return $9be595d6876ce7ed$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $9be595d6876ce7ed$var$toHex($9be595d6876ce7ed$var$mix((0, $5BsRb.inputToRGB)(opts.backgroundColor || '#141414'), (0, $5BsRb.inputToRGB)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}
var $9be595d6876ce7ed$export$3968a3afc810b5f5 = {
    red: '#F5222D',
    volcano: '#FA541C',
    orange: '#FA8C16',
    gold: '#FAAD14',
    yellow: '#FADB14',
    lime: '#A0D911',
    green: '#52C41A',
    cyan: '#13C2C2',
    blue: '#1890FF',
    geekblue: '#2F54EB',
    purple: '#722ED1',
    magenta: '#EB2F96',
    grey: '#666666'
};
var $9be595d6876ce7ed$export$36ad6df0f83f284d = {};
var $9be595d6876ce7ed$export$24617255e4daf647 = {};
Object.keys($9be595d6876ce7ed$export$3968a3afc810b5f5).forEach(function(key) {
    $9be595d6876ce7ed$export$36ad6df0f83f284d[key] = $9be595d6876ce7ed$export$80d376111cc09ad7($9be595d6876ce7ed$export$3968a3afc810b5f5[key]);
    $9be595d6876ce7ed$export$36ad6df0f83f284d[key].primary = $9be595d6876ce7ed$export$36ad6df0f83f284d[key][5]; // dark presetPalettes
    $9be595d6876ce7ed$export$24617255e4daf647[key] = $9be595d6876ce7ed$export$80d376111cc09ad7($9be595d6876ce7ed$export$3968a3afc810b5f5[key], {
        theme: 'dark',
        backgroundColor: '#141414'
    });
    $9be595d6876ce7ed$export$24617255e4daf647[key].primary = $9be595d6876ce7ed$export$24617255e4daf647[key][5];
});
var $9be595d6876ce7ed$export$a90204d1394caf30 = $9be595d6876ce7ed$export$36ad6df0f83f284d.red;
var $9be595d6876ce7ed$export$e63a1643b2f79b16 = $9be595d6876ce7ed$export$36ad6df0f83f284d.volcano;
var $9be595d6876ce7ed$export$c24201f7fe3571d8 = $9be595d6876ce7ed$export$36ad6df0f83f284d.gold;
var $9be595d6876ce7ed$export$ad766f34ace1cafd = $9be595d6876ce7ed$export$36ad6df0f83f284d.orange;
var $9be595d6876ce7ed$export$594c5a8758200c32 = $9be595d6876ce7ed$export$36ad6df0f83f284d.yellow;
var $9be595d6876ce7ed$export$221d31baf2636aad = $9be595d6876ce7ed$export$36ad6df0f83f284d.lime;
var $9be595d6876ce7ed$export$955a2ebd2fb142ae = $9be595d6876ce7ed$export$36ad6df0f83f284d.green;
var $9be595d6876ce7ed$export$7474046f446842ee = $9be595d6876ce7ed$export$36ad6df0f83f284d.cyan;
var $9be595d6876ce7ed$export$2aa0182783e7e9de = $9be595d6876ce7ed$export$36ad6df0f83f284d.blue;
var $9be595d6876ce7ed$export$4138d3aeddcbf415 = $9be595d6876ce7ed$export$36ad6df0f83f284d.geekblue;
var $9be595d6876ce7ed$export$e13cce2a2d16a9d4 = $9be595d6876ce7ed$export$36ad6df0f83f284d.purple;
var $9be595d6876ce7ed$export$2a9ca2e383622e18 = $9be595d6876ce7ed$export$36ad6df0f83f284d.magenta;
var $9be595d6876ce7ed$export$e4c89085febbc618 = $9be595d6876ce7ed$export$36ad6df0f83f284d.grey;

});
parcelRegister("5BsRb", function(module, exports) {

$parcel$export(module.exports, "inputToRGB", () => $4146cacf0fc753c3$export$87de337d8199f22c);
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 
var $82UWo = parcelRequire("82UWo");

var $aErMP = parcelRequire("aErMP");

var $bPjXA = parcelRequire("bPjXA");
function $4146cacf0fc753c3$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') color = $4146cacf0fc753c3$export$56237d872eed15a0(color);
    if (typeof color === 'object') {
        if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.r) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.g) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $82UWo.rgbToRgb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.v)) {
            s = (0, $bPjXA.convertToPercentage)(color.s);
            v = (0, $bPjXA.convertToPercentage)(color.v);
            rgb = (0, $82UWo.hsvToRgb)(color.h, s, v);
            ok = true;
            format = 'hsv';
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.l)) {
            s = (0, $bPjXA.convertToPercentage)(color.s);
            l = (0, $bPjXA.convertToPercentage)(color.l);
            rgb = (0, $82UWo.hslToRgb)(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) a = color.a;
    }
    a = (0, $bPjXA.boundAlpha)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $4146cacf0fc753c3$var$CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var $4146cacf0fc753c3$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $4146cacf0fc753c3$var$CSS_UNIT = "(?:".concat($4146cacf0fc753c3$var$CSS_NUMBER, ")|(?:").concat($4146cacf0fc753c3$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$matchers = {
    CSS_UNIT: new RegExp($4146cacf0fc753c3$var$CSS_UNIT),
    rgb: new RegExp('rgb' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $4146cacf0fc753c3$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $aErMP.names)[color]) {
        color = (0, $aErMP.names)[color];
        named = true;
    } else if (color === 'transparent') return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: 'name'
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $4146cacf0fc753c3$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3]),
        a: (0, $82UWo.convertHexToDecimal)(match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $4146cacf0fc753c3$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3]),
        format: named ? 'name' : 'hex'
    };
    match = $4146cacf0fc753c3$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1] + match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2] + match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3] + match[3]),
        a: (0, $82UWo.convertHexToDecimal)(match[4] + match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $4146cacf0fc753c3$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $82UWo.parseIntFromHex)(match[1] + match[1]),
        g: (0, $82UWo.parseIntFromHex)(match[2] + match[2]),
        b: (0, $82UWo.parseIntFromHex)(match[3] + match[3]),
        format: named ? 'name' : 'hex'
    };
    return false;
}
function $4146cacf0fc753c3$export$80d4d71a83d4526d(color) {
    return Boolean($4146cacf0fc753c3$var$matchers.CSS_UNIT.exec(String(color)));
}

});
parcelRegister("82UWo", function(module, exports) {

$parcel$export(module.exports, "rgbToRgb", () => $5dbaaddf372549d4$export$1a0d7f039f803cb);
$parcel$export(module.exports, "rgbToHsl", () => $5dbaaddf372549d4$export$c85ca4f4753af384);
$parcel$export(module.exports, "hslToRgb", () => $5dbaaddf372549d4$export$29fb7152bd3f781a);
$parcel$export(module.exports, "rgbToHsv", () => $5dbaaddf372549d4$export$f76e85ca00a47f5c);
$parcel$export(module.exports, "hsvToRgb", () => $5dbaaddf372549d4$export$210753cfeec758a5);
$parcel$export(module.exports, "rgbToHex", () => $5dbaaddf372549d4$export$34d09c4a771c46ef);
$parcel$export(module.exports, "rgbaToHex", () => $5dbaaddf372549d4$export$ffee5509a14af63d);
$parcel$export(module.exports, "convertHexToDecimal", () => $5dbaaddf372549d4$export$616da979ad1c2414);
$parcel$export(module.exports, "parseIntFromHex", () => $5dbaaddf372549d4$export$262b3ba788b4d07c);
$parcel$export(module.exports, "numberInputToObject", () => $5dbaaddf372549d4$export$4076ec82b665900d);

var $bPjXA = parcelRequire("bPjXA");
function $5dbaaddf372549d4$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $bPjXA.bound01)(r, 255) * 255,
        g: (0, $bPjXA.bound01)(g, 255) * 255,
        b: (0, $bPjXA.bound01)(b, 255) * 255
    };
}
function $5dbaaddf372549d4$export$c85ca4f4753af384(r, g, b) {
    r = (0, $bPjXA.bound01)(r, 255);
    g = (0, $bPjXA.bound01)(g, 255);
    b = (0, $bPjXA.bound01)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $5dbaaddf372549d4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5dbaaddf372549d4$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $bPjXA.bound01)(h, 360);
    s = (0, $bPjXA.bound01)(s, 100);
    l = (0, $bPjXA.bound01)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $5dbaaddf372549d4$var$hue2rgb(p, q, h + 1 / 3);
        g = $5dbaaddf372549d4$var$hue2rgb(p, q, h);
        b = $5dbaaddf372549d4$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $bPjXA.bound01)(r, 255);
    g = (0, $bPjXA.bound01)(g, 255);
    b = (0, $bPjXA.bound01)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $5dbaaddf372549d4$export$210753cfeec758a5(h, s, v) {
    h = (0, $bPjXA.bound01)(h, 360) * 6;
    s = (0, $bPjXA.bound01)(s, 100);
    v = (0, $bPjXA.bound01)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $bPjXA.pad2)(Math.round(r).toString(16)),
        (0, $bPjXA.pad2)(Math.round(g).toString(16)),
        (0, $bPjXA.pad2)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join('');
}
function $5dbaaddf372549d4$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $bPjXA.pad2)(Math.round(r).toString(16)),
        (0, $bPjXA.pad2)(Math.round(g).toString(16)),
        (0, $bPjXA.pad2)(Math.round(b).toString(16)),
        (0, $bPjXA.pad2)($5dbaaddf372549d4$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join('');
}
function $5dbaaddf372549d4$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $bPjXA.pad2)($5dbaaddf372549d4$export$51dcdea396f3aff6(a)),
        (0, $bPjXA.pad2)(Math.round(r).toString(16)),
        (0, $bPjXA.pad2)(Math.round(g).toString(16)),
        (0, $bPjXA.pad2)(Math.round(b).toString(16))
    ];
    return hex.join('');
}
function $5dbaaddf372549d4$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $5dbaaddf372549d4$export$616da979ad1c2414(h) {
    return $5dbaaddf372549d4$export$262b3ba788b4d07c(h) / 255;
}
function $5dbaaddf372549d4$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $5dbaaddf372549d4$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}

});
parcelRegister("bPjXA", function(module, exports) {

$parcel$export(module.exports, "bound01", () => $89c3f0c2cde0477f$export$b0e60b43d1d059f0);
$parcel$export(module.exports, "clamp01", () => $89c3f0c2cde0477f$export$5c5ee632c52bc4a2);
$parcel$export(module.exports, "boundAlpha", () => $89c3f0c2cde0477f$export$3ae665204365318d);
$parcel$export(module.exports, "convertToPercentage", () => $89c3f0c2cde0477f$export$8ba0754c08bd5ca8);
$parcel$export(module.exports, "pad2", () => $89c3f0c2cde0477f$export$9decc9dc70e2c76f);
/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $89c3f0c2cde0477f$export$b0e60b43d1d059f0(n, max) {
    if ($89c3f0c2cde0477f$export$7bf7d6849640691b(n)) n = '100%';
    var isPercent = $89c3f0c2cde0477f$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $89c3f0c2cde0477f$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $89c3f0c2cde0477f$export$7bf7d6849640691b(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
function $89c3f0c2cde0477f$export$d86432a85610ea90(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
function $89c3f0c2cde0477f$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $89c3f0c2cde0477f$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $89c3f0c2cde0477f$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? '0' + c : String(c);
}

});


parcelRegister("aErMP", function(module, exports) {

$parcel$export(module.exports, "names", () => $7c1331a6b98e7de3$export$e4b2ac9215619f8d);
// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $7c1331a6b98e7de3$export$e4b2ac9215619f8d = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};

});





parcelRegister("2TKXA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTwoToneColor = $21c5251cd6723396$var$getTwoToneColor;
module.exports.setTwoToneColor = $21c5251cd6723396$var$setTwoToneColor;

var $21c5251cd6723396$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $21c5251cd6723396$var$_IconBase = $1jnue((parcelRequire("jbjU4")));

var $atw3k = parcelRequire("atw3k");
function $21c5251cd6723396$var$setTwoToneColor(twoToneColor) {
    var _normalizeTwoToneColo = (0, $atw3k.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $21c5251cd6723396$var$_slicedToArray2.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return $21c5251cd6723396$var$_IconBase.default.setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $21c5251cd6723396$var$getTwoToneColor() {
    var colors = $21c5251cd6723396$var$_IconBase.default.getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}

});




parcelRegister("coSzL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90720f8d7b580f98$var$_CloseCircleFilled = $90720f8d7b580f98$var$_interopRequireDefault((parcelRequire("jmhGN")));
function $90720f8d7b580f98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $90720f8d7b580f98$var$_default = $90720f8d7b580f98$var$_CloseCircleFilled;
module.exports.default = $90720f8d7b580f98$var$_default;
module.exports = $90720f8d7b580f98$var$_default;

});
parcelRegister("jmhGN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e17dcb16f89bd3f3$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $e17dcb16f89bd3f3$var$React = $e17dcb16f89bd3f3$var$_interopRequireWildcard((parcelRequire("acw62")));

var $e17dcb16f89bd3f3$var$_CloseCircleFilled = $1jnue((parcelRequire("cN35z")));

var $e17dcb16f89bd3f3$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $e17dcb16f89bd3f3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e17dcb16f89bd3f3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e17dcb16f89bd3f3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $e17dcb16f89bd3f3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $e17dcb16f89bd3f3$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $e17dcb16f89bd3f3$var$React.createElement($e17dcb16f89bd3f3$var$_AntdIcon.default, (0, $e17dcb16f89bd3f3$var$_objectSpread2.default)((0, $e17dcb16f89bd3f3$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $e17dcb16f89bd3f3$var$_CloseCircleFilled.default
    }));
};
var $e17dcb16f89bd3f3$var$RefIcon = /*#__PURE__*/ $e17dcb16f89bd3f3$var$React.forwardRef($e17dcb16f89bd3f3$var$CloseCircleFilled);
var $e17dcb16f89bd3f3$var$_default = module.exports.default = $e17dcb16f89bd3f3$var$RefIcon;

});
parcelRegister("cN35z", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94fc7507c820822c$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
module.exports.default = $94fc7507c820822c$var$CloseCircleFilled;

});



parcelRegister("b53i3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8112b6b10d772ef1$var$_ExclamationCircleFilled = $8112b6b10d772ef1$var$_interopRequireDefault((parcelRequire("fXT0x")));
function $8112b6b10d772ef1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $8112b6b10d772ef1$var$_default = $8112b6b10d772ef1$var$_ExclamationCircleFilled;
module.exports.default = $8112b6b10d772ef1$var$_default;
module.exports = $8112b6b10d772ef1$var$_default;

});
parcelRegister("fXT0x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9f70912a90082d7$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $b9f70912a90082d7$var$React = $b9f70912a90082d7$var$_interopRequireWildcard((parcelRequire("acw62")));

var $b9f70912a90082d7$var$_ExclamationCircleFilled = $1jnue((parcelRequire("5dp9h")));

var $b9f70912a90082d7$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $b9f70912a90082d7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b9f70912a90082d7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b9f70912a90082d7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $b9f70912a90082d7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $b9f70912a90082d7$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $b9f70912a90082d7$var$React.createElement($b9f70912a90082d7$var$_AntdIcon.default, (0, $b9f70912a90082d7$var$_objectSpread2.default)((0, $b9f70912a90082d7$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $b9f70912a90082d7$var$_ExclamationCircleFilled.default
    }));
};
var $b9f70912a90082d7$var$RefIcon = /*#__PURE__*/ $b9f70912a90082d7$var$React.forwardRef($b9f70912a90082d7$var$ExclamationCircleFilled);
var $b9f70912a90082d7$var$_default = module.exports.default = $b9f70912a90082d7$var$RefIcon;

});
parcelRegister("5dp9h", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3cc1aca113655947$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
module.exports.default = $3cc1aca113655947$var$ExclamationCircleFilled;

});



parcelRegister("7rMuR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56c0ac78767c91b4$var$_InfoCircleFilled = $56c0ac78767c91b4$var$_interopRequireDefault((parcelRequire("3cXBE")));
function $56c0ac78767c91b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $56c0ac78767c91b4$var$_default = $56c0ac78767c91b4$var$_InfoCircleFilled;
module.exports.default = $56c0ac78767c91b4$var$_default;
module.exports = $56c0ac78767c91b4$var$_default;

});
parcelRegister("3cXBE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2560baa6e91139b8$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $2560baa6e91139b8$var$React = $2560baa6e91139b8$var$_interopRequireWildcard((parcelRequire("acw62")));

var $2560baa6e91139b8$var$_InfoCircleFilled = $1jnue((parcelRequire("ieXiX")));

var $2560baa6e91139b8$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $2560baa6e91139b8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2560baa6e91139b8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2560baa6e91139b8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $2560baa6e91139b8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $2560baa6e91139b8$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $2560baa6e91139b8$var$React.createElement($2560baa6e91139b8$var$_AntdIcon.default, (0, $2560baa6e91139b8$var$_objectSpread2.default)((0, $2560baa6e91139b8$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $2560baa6e91139b8$var$_InfoCircleFilled.default
    }));
};
var $2560baa6e91139b8$var$RefIcon = /*#__PURE__*/ $2560baa6e91139b8$var$React.forwardRef($2560baa6e91139b8$var$InfoCircleFilled);
var $2560baa6e91139b8$var$_default = module.exports.default = $2560baa6e91139b8$var$RefIcon;

});
parcelRegister("ieXiX", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d477897d317677ce$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
module.exports.default = $d477897d317677ce$var$InfoCircleFilled;

});



parcelRegister("53y9T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ae7bac38648742f$var$_LoadingOutlined = $3ae7bac38648742f$var$_interopRequireDefault((parcelRequire("k8EDE")));
function $3ae7bac38648742f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $3ae7bac38648742f$var$_default = $3ae7bac38648742f$var$_LoadingOutlined;
module.exports.default = $3ae7bac38648742f$var$_default;
module.exports = $3ae7bac38648742f$var$_default;

});
parcelRegister("k8EDE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea9413f46b72253e$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $ea9413f46b72253e$var$React = $ea9413f46b72253e$var$_interopRequireWildcard((parcelRequire("acw62")));

var $ea9413f46b72253e$var$_LoadingOutlined = $1jnue((parcelRequire("k49ny")));

var $ea9413f46b72253e$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $ea9413f46b72253e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ea9413f46b72253e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ea9413f46b72253e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $ea9413f46b72253e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $ea9413f46b72253e$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $ea9413f46b72253e$var$React.createElement($ea9413f46b72253e$var$_AntdIcon.default, (0, $ea9413f46b72253e$var$_objectSpread2.default)((0, $ea9413f46b72253e$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $ea9413f46b72253e$var$_LoadingOutlined.default
    }));
};
var $ea9413f46b72253e$var$RefIcon = /*#__PURE__*/ $ea9413f46b72253e$var$React.forwardRef($ea9413f46b72253e$var$LoadingOutlined);
var $ea9413f46b72253e$var$_default = module.exports.default = $ea9413f46b72253e$var$RefIcon;

});
parcelRegister("k49ny", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e9bb74d32a92b2b6$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
module.exports.default = $e9bb74d32a92b2b6$var$LoadingOutlined;

});



parcelRegister("BDu88", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $071215b55bcf7ce2$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $071215b55bcf7ce2$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $071215b55bcf7ce2$var$createUseMessage;

var $071215b55bcf7ce2$var$_extends2 = $071215b55bcf7ce2$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $071215b55bcf7ce2$var$_slicedToArray2 = $071215b55bcf7ce2$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $071215b55bcf7ce2$var$_useNotification = $071215b55bcf7ce2$var$_interopRequireDefault((parcelRequire("4dg8O")));

var $071215b55bcf7ce2$var$React = $071215b55bcf7ce2$var$_interopRequireWildcard((parcelRequire("acw62")));

var $eXn2O = parcelRequire("eXn2O");

var $qBua1 = parcelRequire("qBua1");
function $071215b55bcf7ce2$var$createUseMessage(getRcNotificationInstance, getRCNoticeProps) {
    var useMessage = function useMessage() {
        // We can only get content by render
        var getPrefixCls;
        var getPopupContainer;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $071215b55bcf7ce2$var$_useNotification["default"])(proxy), _useRCNotification2 = (0, $071215b55bcf7ce2$var$_slicedToArray2["default"])(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls('message', customizePrefixCls);
            var rootPrefixCls = getPrefixCls();
            var target = args.key || (0, $eXn2O.getKeyThenIncreaseKey)();
            var closePromise = new Promise(function(resolve) {
                var callback = function callback() {
                    if (typeof args.onClose === 'function') args.onClose();
                    return resolve(true);
                };
                getRcNotificationInstance((0, $071215b55bcf7ce2$var$_extends2["default"])((0, $071215b55bcf7ce2$var$_extends2["default"])({}, args), {
                    prefixCls: mergedPrefixCls,
                    rootPrefixCls: rootPrefixCls,
                    getPopupContainer: getPopupContainer
                }), function(_ref) {
                    var prefixCls = _ref.prefixCls, instance = _ref.instance;
                    innerInstance = instance;
                    hookNotify(getRCNoticeProps((0, $071215b55bcf7ce2$var$_extends2["default"])((0, $071215b55bcf7ce2$var$_extends2["default"])({}, args), {
                        key: target,
                        onClose: callback
                    }), prefixCls));
                });
            });
            var result = function result() {
                if (innerInstance) innerInstance.removeNotice(target);
            };
            result.then = function(filled, rejected) {
                return closePromise.then(filled, rejected);
            };
            result.promise = closePromise;
            return result;
        }
        // Fill functions
        var hookApiRef = $071215b55bcf7ce2$var$React.useRef({});
        hookApiRef.current.open = notify;
        $eXn2O.typeList.forEach(function(type) {
            return (0, $eXn2O.attachTypeApi)(hookApiRef.current, type);
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $071215b55bcf7ce2$var$React.createElement($qBua1.ConfigConsumer, {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                getPopupContainer = context.getPopupContainer;
                return holder;
            })
        ];
    };
    return useMessage;
}

});
parcelRegister("4dg8O", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3114e59d64101978$var$useNotification;

var $3114e59d64101978$var$_toConsumableArray2 = $1jnue((parcelRequire("fUHKi")));

var $3114e59d64101978$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $3114e59d64101978$var$_slicedToArray2 = $1jnue((parcelRequire("02Ztr")));

var $3114e59d64101978$var$React = $3114e59d64101978$var$_interopRequireWildcard((parcelRequire("acw62")));

var $3114e59d64101978$var$_Notice = $1jnue((parcelRequire("76j0J")));
function $3114e59d64101978$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3114e59d64101978$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3114e59d64101978$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3114e59d64101978$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3114e59d64101978$var$useNotification(notificationInstance) {
    var createdRef = $3114e59d64101978$var$React.useRef({});
    var _React$useState = $3114e59d64101978$var$React.useState([]), _React$useState2 = (0, $3114e59d64101978$var$_slicedToArray2.default)(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
    function notify(noticeProps) {
        var firstMount = true;
        notificationInstance.add(noticeProps, function(div, props) {
            var key = props.key;
            if (div && (!createdRef.current[key] || firstMount)) {
                var noticeEle = /*#__PURE__*/ $3114e59d64101978$var$React.createElement($3114e59d64101978$var$_Notice.default, (0, $3114e59d64101978$var$_extends2.default)({}, props, {
                    holder: div
                }));
                createdRef.current[key] = noticeEle;
                setElements(function(originElements) {
                    var index = originElements.findIndex(function(ele) {
                        return ele.key === props.key;
                    });
                    if (index === -1) return [].concat((0, $3114e59d64101978$var$_toConsumableArray2.default)(originElements), [
                        noticeEle
                    ]);
                    var cloneList = (0, $3114e59d64101978$var$_toConsumableArray2.default)(originElements);
                    cloneList[index] = noticeEle;
                    return cloneList;
                });
            }
            firstMount = false;
        });
    }
    return [
        notify,
        /*#__PURE__*/ $3114e59d64101978$var$React.createElement($3114e59d64101978$var$React.Fragment, null, elements)
    ];
}

});
parcelRegister("76j0J", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52b7d71ba21131bc$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $52b7d71ba21131bc$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $52b7d71ba21131bc$var$_classCallCheck2 = $1jnue((parcelRequire("fu0YK")));

var $52b7d71ba21131bc$var$_createClass2 = $1jnue((parcelRequire("lR7jo")));

var $52b7d71ba21131bc$var$_inherits2 = $1jnue((parcelRequire("f8wIT")));

var $52b7d71ba21131bc$var$_createSuper2 = $1jnue((parcelRequire("9jKhT")));

var $52b7d71ba21131bc$var$React = $52b7d71ba21131bc$var$_interopRequireWildcard((parcelRequire("acw62")));

var $52b7d71ba21131bc$var$_reactDom = $1jnue((parcelRequire("1u0KT")));

var $52b7d71ba21131bc$var$_classnames = $1jnue((parcelRequire("8g1PZ")));
function $52b7d71ba21131bc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($52b7d71ba21131bc$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $52b7d71ba21131bc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $52b7d71ba21131bc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $52b7d71ba21131bc$var$Notice = /*#__PURE__*/ function(_Component) {
    (0, $52b7d71ba21131bc$var$_inherits2.default)(Notice, _Component);
    var _super = (0, $52b7d71ba21131bc$var$_createSuper2.default)(Notice);
    function Notice() {
        var _this;
        (0, $52b7d71ba21131bc$var$_classCallCheck2.default)(this, Notice);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.closeTimer = null;
        _this.close = function(e) {
            if (e) e.stopPropagation();
            _this.clearCloseTimer();
            var _this$props = _this.props, onClose = _this$props.onClose, noticeKey = _this$props.noticeKey;
            if (onClose) onClose(noticeKey);
        };
        _this.startCloseTimer = function() {
            if (_this.props.duration) _this.closeTimer = window.setTimeout(function() {
                _this.close();
            }, _this.props.duration * 1000);
        };
        _this.clearCloseTimer = function() {
            if (_this.closeTimer) {
                clearTimeout(_this.closeTimer);
                _this.closeTimer = null;
            }
        };
        return _this;
    }
    (0, $52b7d71ba21131bc$var$_createClass2.default)(Notice, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCloseTimer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || // Visible again need reset timer
                this.props.visible !== prevProps.visible && this.props.visible) this.restartCloseTimer();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearCloseTimer();
            }
        },
        {
            key: "restartCloseTimer",
            value: function restartCloseTimer() {
                this.clearCloseTimer();
                this.startCloseTimer();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closable = _this$props2.closable, closeIcon = _this$props2.closeIcon, style = _this$props2.style, onClick = _this$props2.onClick, children = _this$props2.children, holder = _this$props2.holder;
                var componentClass = "".concat(prefixCls, "-notice");
                var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(acc, key) {
                    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') acc[key] = _this2.props[key];
                    return acc;
                }, {});
                var node = /*#__PURE__*/ $52b7d71ba21131bc$var$React.createElement("div", (0, $52b7d71ba21131bc$var$_extends2.default)({
                    className: (0, $52b7d71ba21131bc$var$_classnames.default)(componentClass, className, (0, $52b7d71ba21131bc$var$_defineProperty2.default)({}, "".concat(componentClass, "-closable"), closable)),
                    style: style,
                    onMouseEnter: this.clearCloseTimer,
                    onMouseLeave: this.startCloseTimer,
                    onClick: onClick
                }, dataOrAriaAttributeProps), /*#__PURE__*/ $52b7d71ba21131bc$var$React.createElement("div", {
                    className: "".concat(componentClass, "-content")
                }, children), closable ? /*#__PURE__*/ $52b7d71ba21131bc$var$React.createElement("a", {
                    tabIndex: 0,
                    onClick: this.close,
                    className: "".concat(componentClass, "-close")
                }, closeIcon || /*#__PURE__*/ $52b7d71ba21131bc$var$React.createElement("span", {
                    className: "".concat(componentClass, "-close-x")
                })) : null);
                if (holder) return /*#__PURE__*/ $52b7d71ba21131bc$var$_reactDom.default.createPortal(node, holder);
                return node;
            }
        }
    ]);
    return Notice;
}($52b7d71ba21131bc$var$React.Component);
module.exports.default = $52b7d71ba21131bc$var$Notice;
$52b7d71ba21131bc$var$Notice.defaultProps = {
    onClose: function onClose() {},
    duration: 1.5
};

});
parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aAhot(t, e);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9jKhT", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");

var $5HCVq = parcelRequire("5HCVq");

var $eN9hz = parcelRequire("eN9hz");
function $6c89cb228f797fa5$var$_createSuper(t) {
    var r = $5HCVq();
    return function() {
        var e, o = $cGTaw(t);
        if (r) {
            var s = $cGTaw(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $eN9hz(this, e);
    };
}
module.exports = $6c89cb228f797fa5$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5HCVq", function(module, exports) {
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(t);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});







parcelRegister("jWQit", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e85c0034da0e22af$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e85c0034da0e22af$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getInstance = module.exports["default"] = void 0;

var $e85c0034da0e22af$var$_regeneratorRuntime2 = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("8HV7i")));

var $e85c0034da0e22af$var$_extends2 = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $e85c0034da0e22af$var$_defineProperty2 = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $e85c0034da0e22af$var$_CheckCircleOutlined = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("aK8KR")));

var $e85c0034da0e22af$var$_CloseCircleOutlined = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("a8Kmz")));

var $e85c0034da0e22af$var$_CloseOutlined = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("hdfxO")));

var $e85c0034da0e22af$var$_ExclamationCircleOutlined = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("eFhc9")));

var $e85c0034da0e22af$var$_InfoCircleOutlined = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("bqIIO")));

var $e85c0034da0e22af$var$_classnames = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $e85c0034da0e22af$var$_rcNotification = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("3DXWh")));

var $e85c0034da0e22af$var$React = $e85c0034da0e22af$var$_interopRequireWildcard((parcelRequire("acw62")));

var $e85c0034da0e22af$var$_configProvider = $e85c0034da0e22af$var$_interopRequireWildcard((parcelRequire("qBua1")));

var $e85c0034da0e22af$var$_useNotification = $e85c0034da0e22af$var$_interopRequireDefault((parcelRequire("bj1gC")));
var $e85c0034da0e22af$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e85c0034da0e22af$var$notificationInstance = {};
var $e85c0034da0e22af$var$defaultDuration = 4.5;
var $e85c0034da0e22af$var$defaultTop = 24;
var $e85c0034da0e22af$var$defaultBottom = 24;
var $e85c0034da0e22af$var$defaultPrefixCls = '';
var $e85c0034da0e22af$var$defaultPlacement = 'topRight';
var $e85c0034da0e22af$var$defaultGetContainer;
var $e85c0034da0e22af$var$defaultCloseIcon;
var $e85c0034da0e22af$var$rtl = false;
var $e85c0034da0e22af$var$maxCount;
function $e85c0034da0e22af$var$setNotificationConfig(options) {
    var duration = options.duration, placement = options.placement, bottom = options.bottom, top = options.top, getContainer = options.getContainer, closeIcon = options.closeIcon, prefixCls = options.prefixCls;
    if (prefixCls !== undefined) $e85c0034da0e22af$var$defaultPrefixCls = prefixCls;
    if (duration !== undefined) $e85c0034da0e22af$var$defaultDuration = duration;
    if (placement !== undefined) $e85c0034da0e22af$var$defaultPlacement = placement;
    else if (options.rtl) $e85c0034da0e22af$var$defaultPlacement = 'topLeft';
    if (bottom !== undefined) $e85c0034da0e22af$var$defaultBottom = bottom;
    if (top !== undefined) $e85c0034da0e22af$var$defaultTop = top;
    if (getContainer !== undefined) $e85c0034da0e22af$var$defaultGetContainer = getContainer;
    if (closeIcon !== undefined) $e85c0034da0e22af$var$defaultCloseIcon = closeIcon;
    if (options.rtl !== undefined) $e85c0034da0e22af$var$rtl = options.rtl;
    if (options.maxCount !== undefined) $e85c0034da0e22af$var$maxCount = options.maxCount;
}
function $e85c0034da0e22af$var$getPlacementStyle(placement) {
    var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e85c0034da0e22af$var$defaultTop;
    var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e85c0034da0e22af$var$defaultBottom;
    var style;
    switch(placement){
        case 'top':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topLeft':
            style = {
                left: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'bottom':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: 'auto',
                bottom: bottom
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
    }
    return style;
}
function $e85c0034da0e22af$var$getNotificationInstance(args, callback) {
    var _args$placement = args.placement, placement = _args$placement === void 0 ? $e85c0034da0e22af$var$defaultPlacement : _args$placement, top = args.top, bottom = args.bottom, _args$getContainer = args.getContainer, getContainer = _args$getContainer === void 0 ? $e85c0034da0e22af$var$defaultGetContainer : _args$getContainer, customizePrefixCls = args.prefixCls;
    var _globalConfig = (0, $e85c0034da0e22af$var$_configProvider.globalConfig)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls('notification', customizePrefixCls || $e85c0034da0e22af$var$defaultPrefixCls);
    var iconPrefixCls = getIconPrefixCls();
    var cacheKey = "".concat(prefixCls, "-").concat(placement);
    var cacheInstance = $e85c0034da0e22af$var$notificationInstance[cacheKey];
    if (cacheInstance) {
        Promise.resolve(cacheInstance).then(function(instance) {
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: instance
            });
        });
        return;
    }
    var notificationClass = (0, $e85c0034da0e22af$var$_classnames["default"])("".concat(prefixCls, "-").concat(placement), (0, $e85c0034da0e22af$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), $e85c0034da0e22af$var$rtl === true));
    $e85c0034da0e22af$var$notificationInstance[cacheKey] = new Promise(function(resolve) {
        $e85c0034da0e22af$var$_rcNotification["default"].newInstance({
            prefixCls: prefixCls,
            className: notificationClass,
            style: $e85c0034da0e22af$var$getPlacementStyle(placement, top, bottom),
            getContainer: getContainer,
            maxCount: $e85c0034da0e22af$var$maxCount
        }, function(notification) {
            resolve(notification);
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: notification
            });
        });
    });
}
var $e85c0034da0e22af$var$typeToIcon = {
    success: $e85c0034da0e22af$var$_CheckCircleOutlined["default"],
    info: $e85c0034da0e22af$var$_InfoCircleOutlined["default"],
    error: $e85c0034da0e22af$var$_CloseCircleOutlined["default"],
    warning: $e85c0034da0e22af$var$_ExclamationCircleOutlined["default"]
};
function $e85c0034da0e22af$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var durationArg = args.duration, icon = args.icon, type = args.type, description = args.description, message = args.message, btn = args.btn, onClose = args.onClose, onClick = args.onClick, key = args.key, style = args.style, className = args.className, _args$closeIcon = args.closeIcon, closeIcon = _args$closeIcon === void 0 ? $e85c0034da0e22af$var$defaultCloseIcon : _args$closeIcon, props = args.props;
    var duration = durationArg === undefined ? $e85c0034da0e22af$var$defaultDuration : durationArg;
    var iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, args.icon);
    else if (type) iconNode = /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement($e85c0034da0e22af$var$typeToIcon[type] || null, {
        className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(type)
    });
    var closeIconToRender = typeof closeIcon === 'undefined' ? /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement($e85c0034da0e22af$var$_CloseOutlined["default"], {
        className: "".concat(prefixCls, "-close-icon")
    })) : closeIcon;
    var autoMarginTag = !description && iconNode ? /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement("span", {
        className: "".concat(prefixCls, "-message-single-line-auto-margin")
    }) : null;
    return {
        content: /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement($e85c0034da0e22af$var$_configProvider["default"], {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement("div", {
            className: iconNode ? "".concat(prefixCls, "-with-icon") : '',
            role: "alert"
        }, iconNode, /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, autoMarginTag, message), /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description), btn ? /*#__PURE__*/ $e85c0034da0e22af$var$React.createElement("span", {
            className: "".concat(prefixCls, "-btn")
        }, btn) : null)),
        duration: duration,
        closable: true,
        closeIcon: closeIconToRender,
        onClose: onClose,
        onClick: onClick,
        key: key,
        style: style || {},
        className: (0, $e85c0034da0e22af$var$_classnames["default"])(className, (0, $e85c0034da0e22af$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-").concat(type), !!type)),
        props: props
    };
}
function $e85c0034da0e22af$var$notice(args) {
    $e85c0034da0e22af$var$getNotificationInstance(args, function(_ref) {
        var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
        instance.notice($e85c0034da0e22af$var$getRCNoticeProps(args, prefixCls, iconPrefixCls));
    });
}
var $e85c0034da0e22af$var$api = {
    open: $e85c0034da0e22af$var$notice,
    close: function close(key) {
        Object.keys($e85c0034da0e22af$var$notificationInstance).forEach(function(cacheKey) {
            return Promise.resolve($e85c0034da0e22af$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.removeNotice(key);
            });
        });
    },
    config: $e85c0034da0e22af$var$setNotificationConfig,
    destroy: function destroy() {
        Object.keys($e85c0034da0e22af$var$notificationInstance).forEach(function(cacheKey) {
            Promise.resolve($e85c0034da0e22af$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.destroy();
            });
            delete $e85c0034da0e22af$var$notificationInstance[cacheKey]; // lgtm[js/missing-await]
        });
    }
};
[
    'success',
    'info',
    'warning',
    'error'
].forEach(function(type) {
    $e85c0034da0e22af$var$api[type] = function(args) {
        return $e85c0034da0e22af$var$api.open((0, $e85c0034da0e22af$var$_extends2["default"])((0, $e85c0034da0e22af$var$_extends2["default"])({}, args), {
            type: type
        }));
    };
});
$e85c0034da0e22af$var$api.warn = $e85c0034da0e22af$var$api.warning;
$e85c0034da0e22af$var$api.useNotification = (0, $e85c0034da0e22af$var$_useNotification["default"])($e85c0034da0e22af$var$getNotificationInstance, $e85c0034da0e22af$var$getRCNoticeProps);
/** @internal test Only function. Not work on production */ var $e85c0034da0e22af$var$getInstance = module.exports.getInstance = function getInstance(cacheKey) {
    return $e85c0034da0e22af$var$__awaiter(void 0, void 0, void 0, /*#__PURE__*/ (0, $e85c0034da0e22af$var$_regeneratorRuntime2["default"])().mark(function _callee() {
        return (0, $e85c0034da0e22af$var$_regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", null);
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
};
var $e85c0034da0e22af$var$_default = module.exports["default"] = $e85c0034da0e22af$var$api;

});
parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aK8KR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d24fdc3cdcc96e9$var$_CheckCircleOutlined = $7d24fdc3cdcc96e9$var$_interopRequireDefault((parcelRequire("axPzO")));
function $7d24fdc3cdcc96e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $7d24fdc3cdcc96e9$var$_default = $7d24fdc3cdcc96e9$var$_CheckCircleOutlined;
module.exports.default = $7d24fdc3cdcc96e9$var$_default;
module.exports = $7d24fdc3cdcc96e9$var$_default;

});
parcelRegister("axPzO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ad4fe7cec54ba23$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $7ad4fe7cec54ba23$var$React = $7ad4fe7cec54ba23$var$_interopRequireWildcard((parcelRequire("acw62")));

var $7ad4fe7cec54ba23$var$_CheckCircleOutlined = $1jnue((parcelRequire("gVrbo")));

var $7ad4fe7cec54ba23$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $7ad4fe7cec54ba23$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7ad4fe7cec54ba23$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $7ad4fe7cec54ba23$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $7ad4fe7cec54ba23$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $7ad4fe7cec54ba23$var$CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
    return /*#__PURE__*/ $7ad4fe7cec54ba23$var$React.createElement($7ad4fe7cec54ba23$var$_AntdIcon.default, (0, $7ad4fe7cec54ba23$var$_objectSpread2.default)((0, $7ad4fe7cec54ba23$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $7ad4fe7cec54ba23$var$_CheckCircleOutlined.default
    }));
};
var $7ad4fe7cec54ba23$var$RefIcon = /*#__PURE__*/ $7ad4fe7cec54ba23$var$React.forwardRef($7ad4fe7cec54ba23$var$CheckCircleOutlined);
var $7ad4fe7cec54ba23$var$_default = module.exports.default = $7ad4fe7cec54ba23$var$RefIcon;

});
parcelRegister("gVrbo", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c5270e1f50619bae$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
module.exports.default = $c5270e1f50619bae$var$CheckCircleOutlined;

});



parcelRegister("a8Kmz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $761e9d740e0ae57b$var$_CloseCircleOutlined = $761e9d740e0ae57b$var$_interopRequireDefault((parcelRequire("46XWy")));
function $761e9d740e0ae57b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $761e9d740e0ae57b$var$_default = $761e9d740e0ae57b$var$_CloseCircleOutlined;
module.exports.default = $761e9d740e0ae57b$var$_default;
module.exports = $761e9d740e0ae57b$var$_default;

});
parcelRegister("46XWy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fe6387a6d853268$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $2fe6387a6d853268$var$React = $2fe6387a6d853268$var$_interopRequireWildcard((parcelRequire("acw62")));

var $2fe6387a6d853268$var$_CloseCircleOutlined = $1jnue((parcelRequire("2gXCH")));

var $2fe6387a6d853268$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $2fe6387a6d853268$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2fe6387a6d853268$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2fe6387a6d853268$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $2fe6387a6d853268$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $2fe6387a6d853268$var$CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
    return /*#__PURE__*/ $2fe6387a6d853268$var$React.createElement($2fe6387a6d853268$var$_AntdIcon.default, (0, $2fe6387a6d853268$var$_objectSpread2.default)((0, $2fe6387a6d853268$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $2fe6387a6d853268$var$_CloseCircleOutlined.default
    }));
};
var $2fe6387a6d853268$var$RefIcon = /*#__PURE__*/ $2fe6387a6d853268$var$React.forwardRef($2fe6387a6d853268$var$CloseCircleOutlined);
var $2fe6387a6d853268$var$_default = module.exports.default = $2fe6387a6d853268$var$RefIcon;

});
parcelRegister("2gXCH", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1a7b53570bb27416$var$CloseCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "outlined"
};
module.exports.default = $1a7b53570bb27416$var$CloseCircleOutlined;

});



parcelRegister("hdfxO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c87fb5573cbc402c$var$_CloseOutlined = $c87fb5573cbc402c$var$_interopRequireDefault((parcelRequire("j6r5S")));
function $c87fb5573cbc402c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $c87fb5573cbc402c$var$_default = $c87fb5573cbc402c$var$_CloseOutlined;
module.exports.default = $c87fb5573cbc402c$var$_default;
module.exports = $c87fb5573cbc402c$var$_default;

});
parcelRegister("j6r5S", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de83981f52bbde7b$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $de83981f52bbde7b$var$React = $de83981f52bbde7b$var$_interopRequireWildcard((parcelRequire("acw62")));

var $de83981f52bbde7b$var$_CloseOutlined = $1jnue((parcelRequire("2aieC")));

var $de83981f52bbde7b$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $de83981f52bbde7b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($de83981f52bbde7b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $de83981f52bbde7b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $de83981f52bbde7b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $de83981f52bbde7b$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $de83981f52bbde7b$var$React.createElement($de83981f52bbde7b$var$_AntdIcon.default, (0, $de83981f52bbde7b$var$_objectSpread2.default)((0, $de83981f52bbde7b$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $de83981f52bbde7b$var$_CloseOutlined.default
    }));
};
var $de83981f52bbde7b$var$RefIcon = /*#__PURE__*/ $de83981f52bbde7b$var$React.forwardRef($de83981f52bbde7b$var$CloseOutlined);
var $de83981f52bbde7b$var$_default = module.exports.default = $de83981f52bbde7b$var$RefIcon;

});
parcelRegister("2aieC", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $193aa8f83f7e0720$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
module.exports.default = $193aa8f83f7e0720$var$CloseOutlined;

});



parcelRegister("eFhc9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aad23b97d5fba945$var$_ExclamationCircleOutlined = $aad23b97d5fba945$var$_interopRequireDefault((parcelRequire("jS8X4")));
function $aad23b97d5fba945$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $aad23b97d5fba945$var$_default = $aad23b97d5fba945$var$_ExclamationCircleOutlined;
module.exports.default = $aad23b97d5fba945$var$_default;
module.exports = $aad23b97d5fba945$var$_default;

});
parcelRegister("jS8X4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e77a0117718a7fcd$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $e77a0117718a7fcd$var$React = $e77a0117718a7fcd$var$_interopRequireWildcard((parcelRequire("acw62")));

var $e77a0117718a7fcd$var$_ExclamationCircleOutlined = $1jnue((parcelRequire("jllhB")));

var $e77a0117718a7fcd$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $e77a0117718a7fcd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e77a0117718a7fcd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e77a0117718a7fcd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $e77a0117718a7fcd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $e77a0117718a7fcd$var$ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
    return /*#__PURE__*/ $e77a0117718a7fcd$var$React.createElement($e77a0117718a7fcd$var$_AntdIcon.default, (0, $e77a0117718a7fcd$var$_objectSpread2.default)((0, $e77a0117718a7fcd$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $e77a0117718a7fcd$var$_ExclamationCircleOutlined.default
    }));
};
var $e77a0117718a7fcd$var$RefIcon = /*#__PURE__*/ $e77a0117718a7fcd$var$React.forwardRef($e77a0117718a7fcd$var$ExclamationCircleOutlined);
var $e77a0117718a7fcd$var$_default = module.exports.default = $e77a0117718a7fcd$var$RefIcon;

});
parcelRegister("jllhB", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e1507cd089d6f6d1$var$ExclamationCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "outlined"
};
module.exports.default = $e1507cd089d6f6d1$var$ExclamationCircleOutlined;

});



parcelRegister("bqIIO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8524d04082bf8fc3$var$_InfoCircleOutlined = $8524d04082bf8fc3$var$_interopRequireDefault((parcelRequire("6mTkU")));
function $8524d04082bf8fc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $8524d04082bf8fc3$var$_default = $8524d04082bf8fc3$var$_InfoCircleOutlined;
module.exports.default = $8524d04082bf8fc3$var$_default;
module.exports = $8524d04082bf8fc3$var$_default;

});
parcelRegister("6mTkU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a2fb8c04bcf44b6$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $4a2fb8c04bcf44b6$var$React = $4a2fb8c04bcf44b6$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4a2fb8c04bcf44b6$var$_InfoCircleOutlined = $1jnue((parcelRequire("7VE8K")));

var $4a2fb8c04bcf44b6$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $4a2fb8c04bcf44b6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4a2fb8c04bcf44b6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4a2fb8c04bcf44b6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $4a2fb8c04bcf44b6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $4a2fb8c04bcf44b6$var$InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
    return /*#__PURE__*/ $4a2fb8c04bcf44b6$var$React.createElement($4a2fb8c04bcf44b6$var$_AntdIcon.default, (0, $4a2fb8c04bcf44b6$var$_objectSpread2.default)((0, $4a2fb8c04bcf44b6$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $4a2fb8c04bcf44b6$var$_InfoCircleOutlined.default
    }));
};
var $4a2fb8c04bcf44b6$var$RefIcon = /*#__PURE__*/ $4a2fb8c04bcf44b6$var$React.forwardRef($4a2fb8c04bcf44b6$var$InfoCircleOutlined);
var $4a2fb8c04bcf44b6$var$_default = module.exports.default = $4a2fb8c04bcf44b6$var$RefIcon;

});
parcelRegister("7VE8K", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5c5cfe41c783af1b$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
module.exports.default = $5c5cfe41c783af1b$var$InfoCircleOutlined;

});



parcelRegister("bj1gC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $83b273a5c982d9fb$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $83b273a5c982d9fb$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $83b273a5c982d9fb$var$createUseNotification;

var $83b273a5c982d9fb$var$_extends2 = $83b273a5c982d9fb$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $83b273a5c982d9fb$var$_slicedToArray2 = $83b273a5c982d9fb$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $83b273a5c982d9fb$var$_useNotification = $83b273a5c982d9fb$var$_interopRequireDefault((parcelRequire("4dg8O")));

var $83b273a5c982d9fb$var$React = $83b273a5c982d9fb$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");
function $83b273a5c982d9fb$var$createUseNotification(getNotificationInstance, getRCNoticeProps) {
    var useNotification = function useNotification() {
        // We can only get content by render
        var getPrefixCls;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $83b273a5c982d9fb$var$_useNotification["default"])(proxy), _useRCNotification2 = (0, $83b273a5c982d9fb$var$_slicedToArray2["default"])(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls('notification', customizePrefixCls);
            getNotificationInstance((0, $83b273a5c982d9fb$var$_extends2["default"])((0, $83b273a5c982d9fb$var$_extends2["default"])({}, args), {
                prefixCls: mergedPrefixCls
            }), function(_ref) {
                var prefixCls = _ref.prefixCls, instance = _ref.instance;
                innerInstance = instance;
                hookNotify(getRCNoticeProps(args, prefixCls));
            });
        }
        // Fill functions
        var hookApiRef = $83b273a5c982d9fb$var$React.useRef({});
        hookApiRef.current.open = notify;
        [
            'success',
            'info',
            'warning',
            'error'
        ].forEach(function(type) {
            hookApiRef.current[type] = function(args) {
                return hookApiRef.current.open((0, $83b273a5c982d9fb$var$_extends2["default"])((0, $83b273a5c982d9fb$var$_extends2["default"])({}, args), {
                    type: type
                }));
            };
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $83b273a5c982d9fb$var$React.createElement($qBua1.ConfigConsumer, {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                return holder;
            })
        ];
    };
    return useNotification;
}

});


parcelRegister("4YAqU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $39f906e0ba47eaa9$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getStyle = $39f906e0ba47eaa9$var$getStyle;
module.exports.registerTheme = $39f906e0ba47eaa9$var$registerTheme;

var $dnPM8 = parcelRequire("dnPM8");

var $9nbKF = parcelRequire("9nbKF");

var $39f906e0ba47eaa9$var$_canUseDom = $39f906e0ba47eaa9$var$_interopRequireDefault((parcelRequire("fpCN2")));

var $1Sv8Y = parcelRequire("1Sv8Y");

var $39f906e0ba47eaa9$var$_warning = $39f906e0ba47eaa9$var$_interopRequireDefault((parcelRequire("3bEAF")));
/* eslint-disable import/prefer-default-export, prefer-destructuring */ var $39f906e0ba47eaa9$var$dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function $39f906e0ba47eaa9$var$getStyle(globalPrefixCls, theme) {
    var variables = {};
    var formatColor = function formatColor(color, updater) {
        var clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    var fillColor = function fillColor(colorVal, type) {
        var baseColor = new $9nbKF.TinyColor(colorVal);
        var colorPalettes = (0, $dnPM8.generate)(baseColor.toRgbString());
        variables["".concat(type, "-color")] = formatColor(baseColor);
        variables["".concat(type, "-color-disabled")] = colorPalettes[1];
        variables["".concat(type, "-color-hover")] = colorPalettes[4];
        variables["".concat(type, "-color-active")] = colorPalettes[6];
        variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[0];
        variables["".concat(type, "-color-deprecated-border")] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        var primaryColor = new $9nbKF.TinyColor(theme.primaryColor);
        var primaryColors = (0, $dnPM8.generate)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach(function(color, index) {
            variables["primary-".concat(index + 1)] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, function(c) {
            return c.lighten(35);
        });
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, function(c) {
            return c.lighten(20);
        });
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, function(c) {
            return c.tint(20);
        });
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, function(c) {
            return c.tint(50);
        });
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.12);
        });
        var primaryActiveColor = new $9nbKF.TinyColor(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.3);
        });
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, function(c) {
            return c.darken(2);
        });
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    var cssList = Object.keys(variables).map(function(key) {
        return "--".concat(globalPrefixCls, "-").concat(key, ": ").concat(variables[key], ";");
    });
    return "\n  :root {\n    ".concat(cssList.join('\n'), "\n  }\n  ").trim();
}
function $39f906e0ba47eaa9$var$registerTheme(globalPrefixCls, theme) {
    var style = $39f906e0ba47eaa9$var$getStyle(globalPrefixCls, theme);
    if ((0, $39f906e0ba47eaa9$var$_canUseDom["default"])()) (0, $1Sv8Y.updateCSS)(style, "".concat($39f906e0ba47eaa9$var$dynamicStyleMark, "-dynamic-theme"));
}

});
parcelRegister("9nbKF", function(module, exports) {

$parcel$export(module.exports, "TinyColor", () => $6d2f60b2591128fc$export$d850312fc213f33e);

var $82UWo = parcelRequire("82UWo");

var $aErMP = parcelRequire("aErMP");

var $5BsRb = parcelRequire("5BsRb");

var $bPjXA = parcelRequire("bPjXA");
var $6d2f60b2591128fc$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = '';
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === 'number') color = (0, $82UWo.numberInputToObject)(color);
        this.originalInput = color;
        var rgb = (0, $5BsRb.inputToRGB)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $bPjXA.boundAlpha)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $82UWo.rgbToHsv)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $82UWo.rgbToHsv)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $82UWo.rgbToHsl)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $82UWo.rgbToHsl)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $82UWo.rgbToHex)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return '#' + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $82UWo.rgbaToHex)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return '#' + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function(x) {
            return "".concat(Math.round((0, $bPjXA.bound01)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function(x) {
            return Math.round((0, $bPjXA.bound01)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return 'transparent';
        if (this.a < 1) return false;
        var hex = '#' + (0, $82UWo.rgbToHex)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $aErMP.names)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith('hex') || format === 'name');
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === 'name' && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === 'rgb') formattedString = this.toRgbString();
        if (format === 'prgb') formattedString = this.toPercentageRgbString();
        if (format === 'hex' || format === 'hex6') formattedString = this.toHexString();
        if (format === 'hex3') formattedString = this.toHexString(true);
        if (format === 'hex4') formattedString = this.toHex8String(true);
        if (format === 'hex8') formattedString = this.toHex8String();
        if (format === 'name') formattedString = this.toName();
        if (format === 'hsl') formattedString = this.toHslString();
        if (format === 'hsv') formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $bPjXA.clamp01)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $bPjXA.clamp01)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix('white', amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix('black', amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $bPjXA.clamp01)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $bPjXA.clamp01)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $6d2f60b2591128fc$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = '';
    if (opts === void 0) opts = {};
    return new $6d2f60b2591128fc$export$d850312fc213f33e(color, opts);
}

});


parcelRegister("bzUGe", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $86deee1d570827c9$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DisabledContextProvider = void 0;

var $86deee1d570827c9$var$React = $86deee1d570827c9$var$_interopRequireWildcard((parcelRequire("acw62")));
var $86deee1d570827c9$var$DisabledContext = /*#__PURE__*/ $86deee1d570827c9$var$React.createContext(false);
var $86deee1d570827c9$var$DisabledContextProvider = module.exports.DisabledContextProvider = function DisabledContextProvider(_ref) {
    var children = _ref.children, disabled = _ref.disabled;
    var originDisabled = $86deee1d570827c9$var$React.useContext($86deee1d570827c9$var$DisabledContext);
    return /*#__PURE__*/ $86deee1d570827c9$var$React.createElement($86deee1d570827c9$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $86deee1d570827c9$var$_default = module.exports["default"] = $86deee1d570827c9$var$DisabledContext;

});

parcelRegister("lGUuX", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fca9589fb543dd16$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.SizeContextProvider = void 0;

var $fca9589fb543dd16$var$React = $fca9589fb543dd16$var$_interopRequireWildcard((parcelRequire("acw62")));
var $fca9589fb543dd16$var$SizeContext = /*#__PURE__*/ $fca9589fb543dd16$var$React.createContext(undefined);
var $fca9589fb543dd16$var$SizeContextProvider = module.exports.SizeContextProvider = function SizeContextProvider(_ref) {
    var children = _ref.children, size = _ref.size;
    return /*#__PURE__*/ $fca9589fb543dd16$var$React.createElement($fca9589fb543dd16$var$SizeContext.Consumer, null, function(originSize) {
        return /*#__PURE__*/ $fca9589fb543dd16$var$React.createElement($fca9589fb543dd16$var$SizeContext.Provider, {
            value: size || originSize
        }, children);
    });
};
var $fca9589fb543dd16$var$_default = module.exports["default"] = $fca9589fb543dd16$var$SizeContext;

});


parcelRegister("dJr7p", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9ff4837feead4511$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9ff4837feead4511$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9ff4837feead4511$var$_defineProperty2 = $9ff4837feead4511$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $9ff4837feead4511$var$_extends2 = $9ff4837feead4511$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $9ff4837feead4511$var$_classnames = $9ff4837feead4511$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $9ff4837feead4511$var$React = $9ff4837feead4511$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $9ff4837feead4511$var$_LocaleReceiver = $9ff4837feead4511$var$_interopRequireDefault((parcelRequire("6DWWH")));

var $9ff4837feead4511$var$_empty = $9ff4837feead4511$var$_interopRequireDefault((parcelRequire("9oePt")));

var $9ff4837feead4511$var$_simple = $9ff4837feead4511$var$_interopRequireDefault((parcelRequire("7WbI9")));
var $9ff4837feead4511$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9ff4837feead4511$var$defaultEmptyImg = /*#__PURE__*/ $9ff4837feead4511$var$React.createElement($9ff4837feead4511$var$_empty["default"], null);
var $9ff4837feead4511$var$simpleEmptyImg = /*#__PURE__*/ $9ff4837feead4511$var$React.createElement($9ff4837feead4511$var$_simple["default"], null);
var $9ff4837feead4511$var$Empty = function Empty(_a) {
    var className = _a.className, customizePrefixCls = _a.prefixCls, _a$image = _a.image, image = _a$image === void 0 ? $9ff4837feead4511$var$defaultEmptyImg : _a$image, description = _a.description, children = _a.children, imageStyle = _a.imageStyle, restProps = $9ff4837feead4511$var$__rest(_a, [
        "className",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle"
    ]);
    var _React$useContext = $9ff4837feead4511$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    return /*#__PURE__*/ $9ff4837feead4511$var$React.createElement($9ff4837feead4511$var$_LocaleReceiver["default"], {
        componentName: "Empty"
    }, function(contextLocale) {
        var prefixCls = getPrefixCls('empty', customizePrefixCls);
        var des = typeof description !== 'undefined' ? description : contextLocale.description;
        var alt = typeof des === 'string' ? des : 'empty';
        var imageNode = null;
        if (typeof image === 'string') imageNode = /*#__PURE__*/ $9ff4837feead4511$var$React.createElement("img", {
            alt: alt,
            src: image
        });
        else imageNode = image;
        return /*#__PURE__*/ $9ff4837feead4511$var$React.createElement("div", (0, $9ff4837feead4511$var$_extends2["default"])({
            className: (0, $9ff4837feead4511$var$_classnames["default"])(prefixCls, (0, $9ff4837feead4511$var$_defineProperty2["default"])((0, $9ff4837feead4511$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-normal"), image === $9ff4837feead4511$var$simpleEmptyImg), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className)
        }, restProps), /*#__PURE__*/ $9ff4837feead4511$var$React.createElement("div", {
            className: "".concat(prefixCls, "-image"),
            style: imageStyle
        }, imageNode), des && /*#__PURE__*/ $9ff4837feead4511$var$React.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, des), children && /*#__PURE__*/ $9ff4837feead4511$var$React.createElement("div", {
            className: "".concat(prefixCls, "-footer")
        }, children));
    });
};
$9ff4837feead4511$var$Empty.PRESENTED_IMAGE_DEFAULT = $9ff4837feead4511$var$defaultEmptyImg;
$9ff4837feead4511$var$Empty.PRESENTED_IMAGE_SIMPLE = $9ff4837feead4511$var$simpleEmptyImg;
var $9ff4837feead4511$var$_default = module.exports["default"] = $9ff4837feead4511$var$Empty;

});
parcelRegister("9oePt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d61dbb96aa107ff$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6d61dbb96aa107ff$var$React = $6d61dbb96aa107ff$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");
var $6d61dbb96aa107ff$var$Empty = function Empty() {
    var _React$useContext = $6d61dbb96aa107ff$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('empty-img-default');
    return /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("svg", {
        className: prefixCls,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("path", {
        className: "".concat(prefixCls, "-path-1"),
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
    }), /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("path", {
        className: "".concat(prefixCls, "-path-2"),
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("path", {
        className: "".concat(prefixCls, "-path-3"),
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
    }), /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("path", {
        className: "".concat(prefixCls, "-path-4"),
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
    })), /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("path", {
        className: "".concat(prefixCls, "-path-5"),
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
    }), /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        transform: "translate(149.65 15.383)"
    }, /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $6d61dbb96aa107ff$var$React.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $6d61dbb96aa107ff$var$_default = module.exports["default"] = $6d61dbb96aa107ff$var$Empty;

});

parcelRegister("7WbI9", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5c7708be4df83c8e$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5c7708be4df83c8e$var$React = $5c7708be4df83c8e$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");
var $5c7708be4df83c8e$var$Simple = function Simple() {
    var _React$useContext = $5c7708be4df83c8e$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('empty-img-simple');
    return /*#__PURE__*/ $5c7708be4df83c8e$var$React.createElement("svg", {
        className: prefixCls,
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $5c7708be4df83c8e$var$React.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5c7708be4df83c8e$var$React.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $5c7708be4df83c8e$var$React.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        fillRule: "nonzero"
    }, /*#__PURE__*/ $5c7708be4df83c8e$var$React.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $5c7708be4df83c8e$var$React.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        className: "".concat(prefixCls, "-path")
    }))));
};
var $5c7708be4df83c8e$var$_default = module.exports["default"] = $5c7708be4df83c8e$var$Simple;

});



parcelRegister("3Qm97", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2cc7682addd25c75$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $acw62 = parcelRequire("acw62");

var $2cc7682addd25c75$var$_useForceUpdate = $2cc7682addd25c75$var$_interopRequireDefault((parcelRequire("dnwR1")));

var $2cc7682addd25c75$var$_responsiveObserve = $2cc7682addd25c75$var$_interopRequireDefault((parcelRequire("8ZEbx")));
function $2cc7682addd25c75$var$useBreakpoint() {
    var refreshOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var screensRef = (0, $acw62.useRef)({});
    var forceUpdate = (0, $2cc7682addd25c75$var$_useForceUpdate["default"])();
    (0, $acw62.useEffect)(function() {
        var token = $2cc7682addd25c75$var$_responsiveObserve["default"].subscribe(function(supportScreens) {
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return function() {
            return $2cc7682addd25c75$var$_responsiveObserve["default"].unsubscribe(token);
        };
    }, []);
    return screensRef.current;
}
var $2cc7682addd25c75$var$_default = module.exports["default"] = $2cc7682addd25c75$var$useBreakpoint;

});
parcelRegister("dnwR1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9bd6e885099dfaa5$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9bd6e885099dfaa5$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9bd6e885099dfaa5$var$useForceUpdate;

var $9bd6e885099dfaa5$var$_slicedToArray2 = $9bd6e885099dfaa5$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $9bd6e885099dfaa5$var$React = $9bd6e885099dfaa5$var$_interopRequireWildcard((parcelRequire("acw62")));
function $9bd6e885099dfaa5$var$useForceUpdate() {
    var _React$useReducer = $9bd6e885099dfaa5$var$React.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $9bd6e885099dfaa5$var$_slicedToArray2["default"])(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    return forceUpdate;
}

});

parcelRegister("8ZEbx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $68c3312c7b2ec14d$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.responsiveMap = module.exports.responsiveArray = module.exports["default"] = void 0;

var $68c3312c7b2ec14d$var$_defineProperty2 = $68c3312c7b2ec14d$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $68c3312c7b2ec14d$var$_extends3 = $68c3312c7b2ec14d$var$_interopRequireDefault((parcelRequire("3p9rK")));
var $68c3312c7b2ec14d$var$responsiveArray = module.exports.responsiveArray = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $68c3312c7b2ec14d$var$responsiveMap = module.exports.responsiveMap = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1600px)'
};
var $68c3312c7b2ec14d$var$subscribers = new Map();
var $68c3312c7b2ec14d$var$subUid = -1;
var $68c3312c7b2ec14d$var$screens = {};
var $68c3312c7b2ec14d$var$responsiveObserve = {
    matchHandlers: {},
    dispatch: function dispatch(pointMap) {
        $68c3312c7b2ec14d$var$screens = pointMap;
        $68c3312c7b2ec14d$var$subscribers.forEach(function(func) {
            return func($68c3312c7b2ec14d$var$screens);
        });
        return $68c3312c7b2ec14d$var$subscribers.size >= 1;
    },
    subscribe: function subscribe(func) {
        if (!$68c3312c7b2ec14d$var$subscribers.size) this.register();
        $68c3312c7b2ec14d$var$subUid += 1;
        $68c3312c7b2ec14d$var$subscribers.set($68c3312c7b2ec14d$var$subUid, func);
        func($68c3312c7b2ec14d$var$screens);
        return $68c3312c7b2ec14d$var$subUid;
    },
    unsubscribe: function unsubscribe(token) {
        $68c3312c7b2ec14d$var$subscribers["delete"](token);
        if (!$68c3312c7b2ec14d$var$subscribers.size) this.unregister();
    },
    unregister: function unregister() {
        var _this = this;
        Object.keys($68c3312c7b2ec14d$var$responsiveMap).forEach(function(screen) {
            var matchMediaQuery = $68c3312c7b2ec14d$var$responsiveMap[screen];
            var handler = _this.matchHandlers[matchMediaQuery];
            handler === null || handler === void 0 || handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        $68c3312c7b2ec14d$var$subscribers.clear();
    },
    register: function register() {
        var _this2 = this;
        Object.keys($68c3312c7b2ec14d$var$responsiveMap).forEach(function(screen) {
            var matchMediaQuery = $68c3312c7b2ec14d$var$responsiveMap[screen];
            var listener = function listener(_ref) {
                var matches = _ref.matches;
                _this2.dispatch((0, $68c3312c7b2ec14d$var$_extends3["default"])((0, $68c3312c7b2ec14d$var$_extends3["default"])({}, $68c3312c7b2ec14d$var$screens), (0, $68c3312c7b2ec14d$var$_defineProperty2["default"])({}, screen, matches)));
            };
            var mql = window.matchMedia(matchMediaQuery);
            mql.addListener(listener);
            _this2.matchHandlers[matchMediaQuery] = {
                mql: mql,
                listener: listener
            };
            listener(mql);
        });
    }
};
var $68c3312c7b2ec14d$var$_default = module.exports["default"] = $68c3312c7b2ec14d$var$responsiveObserve;

});


parcelRegister("5m2JC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e6120e3591da5f4$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3e6120e3591da5f4$var$_default2 = $3e6120e3591da5f4$var$_interopRequireDefault((parcelRequire("ca9uZ")));
var $3e6120e3591da5f4$var$_default = module.exports["default"] = $3e6120e3591da5f4$var$_default2["default"];

});

parcelRegister("euWHl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8e1663bcc2045eb$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a8e1663bcc2045eb$var$_Pagination = $a8e1663bcc2045eb$var$_interopRequireDefault((parcelRequire("9R9TD")));
var $a8e1663bcc2045eb$var$_default = module.exports["default"] = $a8e1663bcc2045eb$var$_Pagination["default"];

});
parcelRegister("9R9TD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $72d0bd7e3e32670a$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $72d0bd7e3e32670a$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $72d0bd7e3e32670a$var$_defineProperty2 = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $72d0bd7e3e32670a$var$_extends2 = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $72d0bd7e3e32670a$var$_DoubleLeftOutlined = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("hbRkH")));

var $72d0bd7e3e32670a$var$_DoubleRightOutlined = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("h7cEc")));

var $72d0bd7e3e32670a$var$_LeftOutlined = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("117pG")));

var $72d0bd7e3e32670a$var$_RightOutlined = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("hHiha")));

var $72d0bd7e3e32670a$var$_classnames = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $72d0bd7e3e32670a$var$_rcPagination = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("kERhB")));

var $72d0bd7e3e32670a$var$_en_US = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("33no6")));

var $72d0bd7e3e32670a$var$React = $72d0bd7e3e32670a$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $72d0bd7e3e32670a$var$_useBreakpoint2 = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("3Qm97")));

var $72d0bd7e3e32670a$var$_LocaleReceiver = $72d0bd7e3e32670a$var$_interopRequireDefault((parcelRequire("6DWWH")));

var $8NtLv = parcelRequire("8NtLv");
var $72d0bd7e3e32670a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $72d0bd7e3e32670a$var$Pagination = function Pagination(_a) {
    var customizePrefixCls = _a.prefixCls, customizeSelectPrefixCls = _a.selectPrefixCls, className = _a.className, size = _a.size, customLocale = _a.locale, selectComponentClass = _a.selectComponentClass, responsive = _a.responsive, showSizeChanger = _a.showSizeChanger, restProps = $72d0bd7e3e32670a$var$__rest(_a, [
        "prefixCls",
        "selectPrefixCls",
        "className",
        "size",
        "locale",
        "selectComponentClass",
        "responsive",
        "showSizeChanger"
    ]);
    var _useBreakpoint = (0, $72d0bd7e3e32670a$var$_useBreakpoint2["default"])(responsive), xs = _useBreakpoint.xs;
    var _React$useContext = $72d0bd7e3e32670a$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, _React$useContext$pag = _React$useContext.pagination, pagination = _React$useContext$pag === void 0 ? {} : _React$useContext$pag;
    var prefixCls = getPrefixCls('pagination', customizePrefixCls);
    var mergedShowSizeChanger = showSizeChanger !== null && showSizeChanger !== void 0 ? showSizeChanger : pagination.showSizeChanger;
    var getIconsProps = function getIconsProps() {
        var ellipsis = /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement("span", {
            className: "".concat(prefixCls, "-item-ellipsis")
        }, "\u2022\u2022\u2022");
        var prevIcon = /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement($72d0bd7e3e32670a$var$_LeftOutlined["default"], null));
        var nextIcon = /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement($72d0bd7e3e32670a$var$_RightOutlined["default"], null));
        var jumpPrevIcon = /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement($72d0bd7e3e32670a$var$_DoubleLeftOutlined["default"], {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        var jumpNextIcon = /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement($72d0bd7e3e32670a$var$_DoubleRightOutlined["default"], {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        // change arrows direction in right-to-left direction
        if (direction === 'rtl') {
            var _ref = [
                nextIcon,
                prevIcon
            ];
            prevIcon = _ref[0];
            nextIcon = _ref[1];
            var _ref2 = [
                jumpNextIcon,
                jumpPrevIcon
            ];
            jumpPrevIcon = _ref2[0];
            jumpNextIcon = _ref2[1];
        }
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    };
    return /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement($72d0bd7e3e32670a$var$_LocaleReceiver["default"], {
        componentName: "Pagination",
        defaultLocale: $72d0bd7e3e32670a$var$_en_US["default"]
    }, function(contextLocale) {
        var locale = (0, $72d0bd7e3e32670a$var$_extends2["default"])((0, $72d0bd7e3e32670a$var$_extends2["default"])({}, contextLocale), customLocale);
        var isSmall = size === 'small' || !!(xs && !size && responsive);
        var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        var extendedClassName = (0, $72d0bd7e3e32670a$var$_classnames["default"])((0, $72d0bd7e3e32670a$var$_defineProperty2["default"])((0, $72d0bd7e3e32670a$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-mini"), isSmall), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
        return /*#__PURE__*/ $72d0bd7e3e32670a$var$React.createElement($72d0bd7e3e32670a$var$_rcPagination["default"], (0, $72d0bd7e3e32670a$var$_extends2["default"])({}, getIconsProps(), restProps, {
            prefixCls: prefixCls,
            selectPrefixCls: selectPrefixCls,
            className: extendedClassName,
            selectComponentClass: selectComponentClass || (isSmall ? $8NtLv.MiniSelect : $8NtLv.MiddleSelect),
            locale: locale,
            showSizeChanger: mergedShowSizeChanger
        }));
    });
};
var $72d0bd7e3e32670a$var$_default = module.exports["default"] = $72d0bd7e3e32670a$var$Pagination;

});
parcelRegister("hbRkH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c83cd587e13e788a$var$_DoubleLeftOutlined = $c83cd587e13e788a$var$_interopRequireDefault((parcelRequire("hxuHS")));
function $c83cd587e13e788a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $c83cd587e13e788a$var$_default = $c83cd587e13e788a$var$_DoubleLeftOutlined;
module.exports.default = $c83cd587e13e788a$var$_default;
module.exports = $c83cd587e13e788a$var$_default;

});
parcelRegister("hxuHS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc4d5671c5ad44a2$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $cc4d5671c5ad44a2$var$React = $cc4d5671c5ad44a2$var$_interopRequireWildcard((parcelRequire("acw62")));

var $cc4d5671c5ad44a2$var$_DoubleLeftOutlined = $1jnue((parcelRequire("aXvNu")));

var $cc4d5671c5ad44a2$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $cc4d5671c5ad44a2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cc4d5671c5ad44a2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cc4d5671c5ad44a2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $cc4d5671c5ad44a2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $cc4d5671c5ad44a2$var$DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
    return /*#__PURE__*/ $cc4d5671c5ad44a2$var$React.createElement($cc4d5671c5ad44a2$var$_AntdIcon.default, (0, $cc4d5671c5ad44a2$var$_objectSpread2.default)((0, $cc4d5671c5ad44a2$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $cc4d5671c5ad44a2$var$_DoubleLeftOutlined.default
    }));
};
var $cc4d5671c5ad44a2$var$RefIcon = /*#__PURE__*/ $cc4d5671c5ad44a2$var$React.forwardRef($cc4d5671c5ad44a2$var$DoubleLeftOutlined);
var $cc4d5671c5ad44a2$var$_default = module.exports.default = $cc4d5671c5ad44a2$var$RefIcon;

});
parcelRegister("aXvNu", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7fa8144fb8739902$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
module.exports.default = $7fa8144fb8739902$var$DoubleLeftOutlined;

});



parcelRegister("h7cEc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c75ce69feb0822ad$var$_DoubleRightOutlined = $c75ce69feb0822ad$var$_interopRequireDefault((parcelRequire("3lqnL")));
function $c75ce69feb0822ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $c75ce69feb0822ad$var$_default = $c75ce69feb0822ad$var$_DoubleRightOutlined;
module.exports.default = $c75ce69feb0822ad$var$_default;
module.exports = $c75ce69feb0822ad$var$_default;

});
parcelRegister("3lqnL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26f7cc3dcb788f0f$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $26f7cc3dcb788f0f$var$React = $26f7cc3dcb788f0f$var$_interopRequireWildcard((parcelRequire("acw62")));

var $26f7cc3dcb788f0f$var$_DoubleRightOutlined = $1jnue((parcelRequire("cSlhE")));

var $26f7cc3dcb788f0f$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $26f7cc3dcb788f0f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($26f7cc3dcb788f0f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $26f7cc3dcb788f0f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $26f7cc3dcb788f0f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $26f7cc3dcb788f0f$var$DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
    return /*#__PURE__*/ $26f7cc3dcb788f0f$var$React.createElement($26f7cc3dcb788f0f$var$_AntdIcon.default, (0, $26f7cc3dcb788f0f$var$_objectSpread2.default)((0, $26f7cc3dcb788f0f$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $26f7cc3dcb788f0f$var$_DoubleRightOutlined.default
    }));
};
var $26f7cc3dcb788f0f$var$RefIcon = /*#__PURE__*/ $26f7cc3dcb788f0f$var$React.forwardRef($26f7cc3dcb788f0f$var$DoubleRightOutlined);
var $26f7cc3dcb788f0f$var$_default = module.exports.default = $26f7cc3dcb788f0f$var$RefIcon;

});
parcelRegister("cSlhE", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $95fb09b45e2d2ed6$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
module.exports.default = $95fb09b45e2d2ed6$var$DoubleRightOutlined;

});



parcelRegister("117pG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bdba28cafeb3844$var$_LeftOutlined = $0bdba28cafeb3844$var$_interopRequireDefault((parcelRequire("iEuJS")));
function $0bdba28cafeb3844$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $0bdba28cafeb3844$var$_default = $0bdba28cafeb3844$var$_LeftOutlined;
module.exports.default = $0bdba28cafeb3844$var$_default;
module.exports = $0bdba28cafeb3844$var$_default;

});
parcelRegister("iEuJS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d943ce85e1f3ead5$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $d943ce85e1f3ead5$var$React = $d943ce85e1f3ead5$var$_interopRequireWildcard((parcelRequire("acw62")));

var $d943ce85e1f3ead5$var$_LeftOutlined = $1jnue((parcelRequire("em0uB")));

var $d943ce85e1f3ead5$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $d943ce85e1f3ead5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d943ce85e1f3ead5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d943ce85e1f3ead5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $d943ce85e1f3ead5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $d943ce85e1f3ead5$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $d943ce85e1f3ead5$var$React.createElement($d943ce85e1f3ead5$var$_AntdIcon.default, (0, $d943ce85e1f3ead5$var$_objectSpread2.default)((0, $d943ce85e1f3ead5$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $d943ce85e1f3ead5$var$_LeftOutlined.default
    }));
};
var $d943ce85e1f3ead5$var$RefIcon = /*#__PURE__*/ $d943ce85e1f3ead5$var$React.forwardRef($d943ce85e1f3ead5$var$LeftOutlined);
var $d943ce85e1f3ead5$var$_default = module.exports.default = $d943ce85e1f3ead5$var$RefIcon;

});
parcelRegister("em0uB", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a73380902f1cc06b$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
module.exports.default = $a73380902f1cc06b$var$LeftOutlined;

});



parcelRegister("hHiha", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce24a10cab8da264$var$_RightOutlined = $ce24a10cab8da264$var$_interopRequireDefault((parcelRequire("1JyaP")));
function $ce24a10cab8da264$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $ce24a10cab8da264$var$_default = $ce24a10cab8da264$var$_RightOutlined;
module.exports.default = $ce24a10cab8da264$var$_default;
module.exports = $ce24a10cab8da264$var$_default;

});
parcelRegister("1JyaP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $143480921e68d0d3$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $143480921e68d0d3$var$React = $143480921e68d0d3$var$_interopRequireWildcard((parcelRequire("acw62")));

var $143480921e68d0d3$var$_RightOutlined = $1jnue((parcelRequire("1egJf")));

var $143480921e68d0d3$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $143480921e68d0d3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($143480921e68d0d3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $143480921e68d0d3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $143480921e68d0d3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $143480921e68d0d3$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $143480921e68d0d3$var$React.createElement($143480921e68d0d3$var$_AntdIcon.default, (0, $143480921e68d0d3$var$_objectSpread2.default)((0, $143480921e68d0d3$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $143480921e68d0d3$var$_RightOutlined.default
    }));
};
var $143480921e68d0d3$var$RefIcon = /*#__PURE__*/ $143480921e68d0d3$var$React.forwardRef($143480921e68d0d3$var$RightOutlined);
var $143480921e68d0d3$var$_default = module.exports.default = $143480921e68d0d3$var$RefIcon;

});
parcelRegister("1egJf", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0e541342327ba5e6$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
module.exports.default = $0e541342327ba5e6$var$RightOutlined;

});



parcelRegister("8NtLv", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6679fd1c8a9a107f$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6679fd1c8a9a107f$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MiniSelect = module.exports.MiddleSelect = void 0;

var $6679fd1c8a9a107f$var$_extends2 = $6679fd1c8a9a107f$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $6679fd1c8a9a107f$var$React = $6679fd1c8a9a107f$var$_interopRequireWildcard((parcelRequire("acw62")));

var $6679fd1c8a9a107f$var$_select = $6679fd1c8a9a107f$var$_interopRequireDefault((parcelRequire("2fGEV")));
var $6679fd1c8a9a107f$var$MiniSelect = module.exports.MiniSelect = function MiniSelect(props) {
    return /*#__PURE__*/ $6679fd1c8a9a107f$var$React.createElement($6679fd1c8a9a107f$var$_select["default"], (0, $6679fd1c8a9a107f$var$_extends2["default"])({}, props, {
        size: "small"
    }));
};
var $6679fd1c8a9a107f$var$MiddleSelect = module.exports.MiddleSelect = function MiddleSelect(props) {
    return /*#__PURE__*/ $6679fd1c8a9a107f$var$React.createElement($6679fd1c8a9a107f$var$_select["default"], (0, $6679fd1c8a9a107f$var$_extends2["default"])({}, props, {
        size: "middle"
    }));
};
$6679fd1c8a9a107f$var$MiniSelect.Option = $6679fd1c8a9a107f$var$_select["default"].Option;
$6679fd1c8a9a107f$var$MiddleSelect.Option = $6679fd1c8a9a107f$var$_select["default"].Option;

});
parcelRegister("2fGEV", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1a3e12b62433f043$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1a3e12b62433f043$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1a3e12b62433f043$var$_defineProperty2 = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $1a3e12b62433f043$var$_extends2 = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $1a3e12b62433f043$var$_classnames = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $1a3e12b62433f043$var$_rcSelect = $1a3e12b62433f043$var$_interopRequireWildcard((parcelRequire("8KbLt")));

var $1a3e12b62433f043$var$_omit = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $1a3e12b62433f043$var$_react = $1a3e12b62433f043$var$_interopRequireWildcard((parcelRequire("acw62")));
var $1a3e12b62433f043$var$React = $1a3e12b62433f043$var$_react;

var $qBua1 = parcelRequire("qBua1");

var $1a3e12b62433f043$var$_defaultRenderEmpty = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("gAKvZ")));

var $1a3e12b62433f043$var$_DisabledContext = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("bzUGe")));

var $1a3e12b62433f043$var$_SizeContext = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("lGUuX")));

var $gJD51 = parcelRequire("gJD51");

var $2F6xM = parcelRequire("2F6xM");

var $fFWOB = parcelRequire("fFWOB");

var $1a3e12b62433f043$var$_iconUtil = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("c515c")));

var $1a3e12b62433f043$var$_warning = $1a3e12b62433f043$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $hvVUy = parcelRequire("hvVUy");
// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
var $1a3e12b62433f043$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1a3e12b62433f043$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
var $1a3e12b62433f043$var$InternalSelect = function InternalSelect(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, className = _a.className, getPopupContainer = _a.getPopupContainer, dropdownClassName = _a.dropdownClassName, popupClassName = _a.popupClassName, _a$listHeight = _a.listHeight, listHeight = _a$listHeight === void 0 ? 256 : _a$listHeight, placement = _a.placement, _a$listItemHeight = _a.listItemHeight, listItemHeight = _a$listItemHeight === void 0 ? 32 : _a$listItemHeight, customizeSize = _a.size, customDisabled = _a.disabled, notFoundContent = _a.notFoundContent, customStatus = _a.status, showArrow = _a.showArrow, props = $1a3e12b62433f043$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "className",
        "getPopupContainer",
        "dropdownClassName",
        "popupClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "showArrow"
    ]);
    var _React$useContext = $1a3e12b62433f043$var$React.useContext($qBua1.ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction, virtual = _React$useContext.virtual, dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;
    var size = $1a3e12b62433f043$var$React.useContext($1a3e12b62433f043$var$_SizeContext["default"]);
    var prefixCls = getPrefixCls('select', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var _useCompactItemContex = (0, $hvVUy.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var mode = $1a3e12b62433f043$var$React.useMemo(function() {
        var m = props.mode;
        if (m === 'combobox') return undefined;
        if (m === $1a3e12b62433f043$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    var isMultiple = mode === 'multiple' || mode === 'tags';
    var mergedShowArrow = showArrow !== undefined ? showArrow : props.loading || !(isMultiple || mode === 'combobox');
    // ===================== Form Status =====================
    var _useContext = (0, $1a3e12b62433f043$var$_react.useContext)($gJD51.FormItemInputContext), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, isFormItemInput = _useContext.isFormItemInput, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $fFWOB.getMergedStatus)(contextStatus, customStatus);
    // ===================== Empty =====================
    var mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = (renderEmpty || $1a3e12b62433f043$var$_defaultRenderEmpty["default"])('Select');
    // ===================== Icons =====================
    var _getIcons = (0, $1a3e12b62433f043$var$_iconUtil["default"])((0, $1a3e12b62433f043$var$_extends2["default"])((0, $1a3e12b62433f043$var$_extends2["default"])({}, props), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showArrow: mergedShowArrow,
        prefixCls: prefixCls
    })), suffixIcon = _getIcons.suffixIcon, itemIcon = _getIcons.itemIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
    var selectProps = (0, $1a3e12b62433f043$var$_omit["default"])(props, [
        'suffixIcon',
        'itemIcon'
    ]);
    var rcSelectRtlDropdownClassName = (0, $1a3e12b62433f043$var$_classnames["default"])(popupClassName || dropdownClassName, (0, $1a3e12b62433f043$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-dropdown-").concat(direction), direction === 'rtl'));
    var mergedSize = compactSize || customizeSize || size;
    // ===================== Disabled =====================
    var disabled = $1a3e12b62433f043$var$React.useContext($1a3e12b62433f043$var$_DisabledContext["default"]);
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var mergedClassName = (0, $1a3e12b62433f043$var$_classnames["default"])((0, $1a3e12b62433f043$var$_defineProperty2["default"])((0, $1a3e12b62433f043$var$_defineProperty2["default"])((0, $1a3e12b62433f043$var$_defineProperty2["default"])((0, $1a3e12b62433f043$var$_defineProperty2["default"])((0, $1a3e12b62433f043$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-lg"), mergedSize === 'large'), "".concat(prefixCls, "-sm"), mergedSize === 'small'), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-borderless"), !bordered), "".concat(prefixCls, "-in-form-item"), isFormItemInput), (0, $fFWOB.getStatusClassNames)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, className);
    // ===================== Placement =====================
    var getPlacement = function getPlacement() {
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    };
    return /*#__PURE__*/ $1a3e12b62433f043$var$React.createElement($1a3e12b62433f043$var$_rcSelect["default"], (0, $1a3e12b62433f043$var$_extends2["default"])({
        ref: ref,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }, selectProps, {
        transitionName: (0, $2F6xM.getTransitionName)(rootPrefixCls, (0, $2F6xM.getTransitionDirection)(placement), props.transitionName),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: getPlacement(),
        direction: direction,
        inputIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        clearIcon: clearIcon,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: rcSelectRtlDropdownClassName,
        showArrow: hasFeedback || showArrow,
        disabled: mergedDisabled
    }));
};
var $1a3e12b62433f043$var$Select = /*#__PURE__*/ $1a3e12b62433f043$var$React.forwardRef($1a3e12b62433f043$var$InternalSelect);
$1a3e12b62433f043$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $1a3e12b62433f043$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$1a3e12b62433f043$var$Select.Option = $1a3e12b62433f043$var$_rcSelect.Option;
$1a3e12b62433f043$var$Select.OptGroup = $1a3e12b62433f043$var$_rcSelect.OptGroup;
var $1a3e12b62433f043$var$_default = module.exports["default"] = $1a3e12b62433f043$var$Select;

});
parcelRegister("gJD51", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c2ef29c7afd2266c$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c2ef29c7afd2266c$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoStyleItemContext = module.exports.NoFormStyle = module.exports.FormProvider = module.exports.FormItemPrefixContext = module.exports.FormItemInputContext = module.exports.FormContext = void 0;

var $c2ef29c7afd2266c$var$_extends2 = $c2ef29c7afd2266c$var$_interopRequireDefault((parcelRequire("3p9rK")));
parcelRequire("8a8Nr");
var $144QO = parcelRequire("144QO");

var $c2ef29c7afd2266c$var$_omit = $c2ef29c7afd2266c$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $c2ef29c7afd2266c$var$_react = $c2ef29c7afd2266c$var$_interopRequireWildcard((parcelRequire("acw62")));
var $c2ef29c7afd2266c$var$React = $c2ef29c7afd2266c$var$_react;
var $c2ef29c7afd2266c$var$FormContext = module.exports.FormContext = /*#__PURE__*/ $c2ef29c7afd2266c$var$React.createContext({
    labelAlign: 'right',
    vertical: false,
    itemRef: function itemRef() {}
});
var $c2ef29c7afd2266c$var$NoStyleItemContext = module.exports.NoStyleItemContext = /*#__PURE__*/ $c2ef29c7afd2266c$var$React.createContext(null);
var $c2ef29c7afd2266c$var$FormProvider = module.exports.FormProvider = function FormProvider(props) {
    var providerProps = (0, $c2ef29c7afd2266c$var$_omit["default"])(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $c2ef29c7afd2266c$var$React.createElement($144QO.FormProvider, (0, $c2ef29c7afd2266c$var$_extends2["default"])({}, providerProps));
};
var $c2ef29c7afd2266c$var$FormItemPrefixContext = module.exports.FormItemPrefixContext = /*#__PURE__*/ $c2ef29c7afd2266c$var$React.createContext({
    prefixCls: ''
});
var $c2ef29c7afd2266c$var$FormItemInputContext = module.exports.FormItemInputContext = /*#__PURE__*/ $c2ef29c7afd2266c$var$React.createContext({});
var $c2ef29c7afd2266c$var$NoFormStyle = module.exports.NoFormStyle = function NoFormStyle(_ref) {
    var children = _ref.children, status = _ref.status, override = _ref.override;
    var formItemInputContext = (0, $c2ef29c7afd2266c$var$_react.useContext)($c2ef29c7afd2266c$var$FormItemInputContext);
    var newFormItemInputContext = (0, $c2ef29c7afd2266c$var$_react.useMemo)(function() {
        var newContext = (0, $c2ef29c7afd2266c$var$_extends2["default"])({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $c2ef29c7afd2266c$var$React.createElement($c2ef29c7afd2266c$var$FormItemInputContext.Provider, {
        value: newFormItemInputContext
    }, children);
};

});
parcelRegister("8a8Nr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1614ae44e69c1b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Field", () => (parcelRequire("4llrF")).default);
$parcel$export(module.exports, "List", () => (parcelRequire("2iMfo")).default);
$parcel$export(module.exports, "useForm", () => (parcelRequire("dRl3b")).default);
$parcel$export(module.exports, "FormProvider", () => (parcelRequire("144QO")).FormProvider);
$parcel$export(module.exports, "FieldContext", () => (parcelRequire("260BS")).default);
$parcel$export(module.exports, "ListContext", () => (parcelRequire("livSf")).default);
$parcel$export(module.exports, "useWatch", () => (parcelRequire("gPDhi")).default);

var $acw62 = parcelRequire("acw62");

var $4llrF = parcelRequire("4llrF");

var $2iMfo = parcelRequire("2iMfo");

var $dRl3b = parcelRequire("dRl3b");

var $akLVU = parcelRequire("akLVU");

var $144QO = parcelRequire("144QO");

var $260BS = parcelRequire("260BS");

var $livSf = parcelRequire("livSf");

var $gPDhi = parcelRequire("gPDhi");
var $5f1614ae44e69c1b$var$InternalForm = /*#__PURE__*/ $acw62.forwardRef((0, $akLVU.default));
var $5f1614ae44e69c1b$var$RefForm = $5f1614ae44e69c1b$var$InternalForm;
$5f1614ae44e69c1b$var$RefForm.FormProvider = (0, $144QO.FormProvider);
$5f1614ae44e69c1b$var$RefForm.Field = (0, $4llrF.default);
$5f1614ae44e69c1b$var$RefForm.List = (0, $2iMfo.default);
$5f1614ae44e69c1b$var$RefForm.useForm = (0, $dRl3b.default);
$5f1614ae44e69c1b$var$RefForm.useWatch = (0, $gPDhi.default);
var $5f1614ae44e69c1b$export$2e2bcd8739ae039 = $5f1614ae44e69c1b$var$RefForm;

});
parcelRegister("4llrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3299c229146a7fb5$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $cqPKg = parcelRequire("cqPKg");

var $5wm0G = parcelRequire("5wm0G");

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $jWR62 = parcelRequire("jWR62");

var $4AFGH = parcelRequire("4AFGH");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $260BS = parcelRequire("260BS");

var $livSf = parcelRequire("livSf");

var $hhXFI = parcelRequire("hhXFI");

var $8MG7S = parcelRequire("8MG7S");

var $kFGlN = parcelRequire("kFGlN");
var $23Gye = parcelRequire("23Gye");
var $3299c229146a7fb5$var$_excluded = [
    "name"
];
var $3299c229146a7fb5$var$EMPTY_ERRORS = [];
function $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $3299c229146a7fb5$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Field, _React$Component);
    var _super = (0, $enfmq.default)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $6CZeq.default)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "state", {
            resetCount: 0
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "cancelRegisterFunc", null);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $kSlfw.default)((0, $hDpcU.default)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $kSlfw.default)((0, $hDpcU.default)(_this), "dirty", false);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "validatePromise", void 0);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "prevValidating", void 0);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "errors", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "warnings", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $kFGlN.getNamePath)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $kbxxf.default)(prefixName), (0, $kbxxf.default)(name)) : [];
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === 'function') return rule(fieldContext);
                return rule;
            });
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "metaCache", null);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $d49SP.default)((0, $d49SP.default)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $4AFGH.default)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $kFGlN.containsNamePath)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === 'valueUpdate' && info.source === 'external' && prevValue !== curValue) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case 'reset':
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case 'remove':
                    if (shouldUpdate) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'setField':
                    var data = info.data;
                    if (namePathMatch) {
                        if ('touched' in data) _this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) _this.errors = data.errors || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        if ('warnings' in data) _this.warnings = data.warnings || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ('value' in data && (0, $kFGlN.containsNamePath)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'dependenciesUpdate':
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $kFGlN.getNamePath));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $kFGlN.containsNamePath)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $cqPKg.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $hhXFI.toArray)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $8MG7S.validateRules)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3299c229146a7fb5$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $3299c229146a7fb5$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $kbxxf.default)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $kbxxf.default)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $260BS.HOOK_MARK)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === 'function') {
                var _meta2 = _this.getMeta();
                return (0, $d49SP.default)((0, $d49SP.default)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $jWR62.default)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $acw62.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $23Gye.default)(store || getFieldsValue(true), namePath);
        });
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $260BS.HOOK_MARK)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $kSlfw.default)({}, valuePropName, val);
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var originTriggerFunc = childProps[trigger];
            var control = (0, $d49SP.default)((0, $d49SP.default)({}, childProps), mergedGetValueProps(value));
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $kFGlN.defaultGetValueFromEvent).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                dispatch({
                    type: 'updateValue',
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $hhXFI.toArray)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: 'validateField',
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $260BS.HOOK_MARK)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $hDpcU.default)(_this));
        }
        return _this;
    }
    (0, $cHPF9.default)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $260BS.HOOK_MARK)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $acw62.isValidElement(child)) returnChildNode = /*#__PURE__*/ $acw62.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $u43uR.default)(!child, '`children` of Field is not validate ReactElement.');
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($acw62.Component);
(0, $kSlfw.default)($3299c229146a7fb5$var$Field, "contextType", (0, $260BS.default));
(0, $kSlfw.default)($3299c229146a7fb5$var$Field, "defaultProps", {
    trigger: 'onChange',
    valuePropName: 'value'
});
function $3299c229146a7fb5$var$WrapperField(_ref6) {
    var name = _ref6.name, restProps = (0, $9X7IJ.default)(_ref6, $3299c229146a7fb5$var$_excluded);
    var fieldContext = $acw62.useContext((0, $260BS.default));
    var listContext = $acw62.useContext((0, $livSf.default));
    var namePath = name !== undefined ? (0, $kFGlN.getNamePath)(name) : undefined;
    var key = 'keep';
    if (!restProps.isListField) key = "_".concat((namePath || []).join('_'));
    return /*#__PURE__*/ $acw62.createElement($3299c229146a7fb5$var$Field, (0, $8nd05.default)({
        key: key,
        name: namePath,
        isListField: !!listContext
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $3299c229146a7fb5$export$2e2bcd8739ae039 = $3299c229146a7fb5$var$WrapperField;

});
parcelRegister("260BS", function(module, exports) {

$parcel$export(module.exports, "HOOK_MARK", () => $186c9d6ed579317b$export$24829b7c0e49e9f7);
$parcel$export(module.exports, "default", () => $186c9d6ed579317b$export$2e2bcd8739ae039);

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");
var $186c9d6ed579317b$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $186c9d6ed579317b$var$warningFunc = function warningFunc() {
    (0, $u43uR.default)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var $186c9d6ed579317b$var$Context = /*#__PURE__*/ $acw62.createContext({
    getFieldValue: $186c9d6ed579317b$var$warningFunc,
    getFieldsValue: $186c9d6ed579317b$var$warningFunc,
    getFieldError: $186c9d6ed579317b$var$warningFunc,
    getFieldWarning: $186c9d6ed579317b$var$warningFunc,
    getFieldsError: $186c9d6ed579317b$var$warningFunc,
    isFieldsTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldValidating: $186c9d6ed579317b$var$warningFunc,
    isFieldsValidating: $186c9d6ed579317b$var$warningFunc,
    resetFields: $186c9d6ed579317b$var$warningFunc,
    setFields: $186c9d6ed579317b$var$warningFunc,
    setFieldValue: $186c9d6ed579317b$var$warningFunc,
    setFieldsValue: $186c9d6ed579317b$var$warningFunc,
    validateFields: $186c9d6ed579317b$var$warningFunc,
    submit: $186c9d6ed579317b$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $186c9d6ed579317b$var$warningFunc();
        return {
            dispatch: $186c9d6ed579317b$var$warningFunc,
            initEntityValue: $186c9d6ed579317b$var$warningFunc,
            registerField: $186c9d6ed579317b$var$warningFunc,
            useSubscribe: $186c9d6ed579317b$var$warningFunc,
            setInitialValues: $186c9d6ed579317b$var$warningFunc,
            destroyForm: $186c9d6ed579317b$var$warningFunc,
            setCallbacks: $186c9d6ed579317b$var$warningFunc,
            registerWatch: $186c9d6ed579317b$var$warningFunc,
            getFields: $186c9d6ed579317b$var$warningFunc,
            setValidateMessages: $186c9d6ed579317b$var$warningFunc,
            setPreserve: $186c9d6ed579317b$var$warningFunc,
            getInitialValue: $186c9d6ed579317b$var$warningFunc
        };
    }
});
var $186c9d6ed579317b$export$2e2bcd8739ae039 = $186c9d6ed579317b$var$Context;

});

parcelRegister("livSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f81400e90cbb2e33$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $f81400e90cbb2e33$var$ListContext = /*#__PURE__*/ $acw62.createContext(null);
var $f81400e90cbb2e33$export$2e2bcd8739ae039 = $f81400e90cbb2e33$var$ListContext;

});

parcelRegister("hhXFI", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $c9624fc8667843e4$export$45b10814cc054894);
$parcel$export(module.exports, "isFormInstance", () => $c9624fc8667843e4$export$717b316e73068e8d);
function $c9624fc8667843e4$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $c9624fc8667843e4$export$717b316e73068e8d(form) {
    return form && !!form._init;
}

});

parcelRegister("8MG7S", function(module, exports) {

$parcel$export(module.exports, "validateRules", () => $66537bc44202668a$export$e1fc4b442d0297dd);

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $cqPKg = parcelRequire("cqPKg");

var $d49SP = parcelRequire("d49SP");

var $5wm0G = parcelRequire("5wm0G");

var $62Vkp = parcelRequire("62Vkp");

var $acw62 = parcelRequire("acw62");

var $u43uR = parcelRequire("u43uR");

var $kg8Ze = parcelRequire("kg8Ze");

var $6vgkH = parcelRequire("6vgkH");
// Remove incorrect original ts define
var $66537bc44202668a$var$AsyncValidator = (0, $62Vkp.default);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $66537bc44202668a$var$replaceMessage(template, kv) {
    return template.replace(/\$\{\w+\}/g, function(str) {
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $66537bc44202668a$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
function $66537bc44202668a$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $66537bc44202668a$var$_validateRule() {
    $66537bc44202668a$var$_validateRule = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $cqPKg.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $d49SP.default)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $66537bc44202668a$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($66537bc44202668a$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $66537bc44202668a$var$AsyncValidator((0, $kSlfw.default)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $6vgkH.merge)((0, $kg8Ze.defaultValidateMessages), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $kSlfw.default)({}, name, value), (0, $d49SP.default)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $66537bc44202668a$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $acw62.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $acw62.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $66537bc44202668a$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $kbxxf.default)(prev), (0, $kbxxf.default)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $d49SP.default)((0, $d49SP.default)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(', ')
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === 'string') return $66537bc44202668a$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
function $66537bc44202668a$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join('.');
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $d49SP.default)((0, $d49SP.default)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $u43uR.default)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $u43uR.default)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $cqPKg.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $66537bc44202668a$var$finishOnFirstFailed(rulePromises) : $66537bc44202668a$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $66537bc44202668a$var$finishOnAllFailed(_x8) {
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnAllFailed() {
    $66537bc44202668a$var$_finishOnAllFailed = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee3(rulePromises) {
        return (0, $cqPKg.default)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $kbxxf.default)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$finishOnFirstFailed(_x9) {
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnFirstFailed() {
    $66537bc44202668a$var$_finishOnFirstFailed = (0, $5wm0G.default)(/*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $cqPKg.default)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}

});
parcelRegister("62Vkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $466f66254aa75085$export$2e2bcd8739ae039);
function $466f66254aa75085$var$_extends() {
    $466f66254aa75085$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $466f66254aa75085$var$_extends.apply(this, arguments);
}
function $466f66254aa75085$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $466f66254aa75085$var$_setPrototypeOf(subClass, superClass);
}
function $466f66254aa75085$var$_getPrototypeOf(o) {
    $466f66254aa75085$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $466f66254aa75085$var$_getPrototypeOf(o);
}
function $466f66254aa75085$var$_setPrototypeOf(o, p) {
    $466f66254aa75085$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $466f66254aa75085$var$_setPrototypeOf(o, p);
}
function $466f66254aa75085$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $466f66254aa75085$var$_construct(Parent, args, Class) {
    if ($466f66254aa75085$var$_isNativeReflectConstruct()) $466f66254aa75085$var$_construct = Reflect.construct.bind();
    else $466f66254aa75085$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $466f66254aa75085$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $466f66254aa75085$var$_construct.apply(null, arguments);
}
function $466f66254aa75085$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $466f66254aa75085$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $466f66254aa75085$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$466f66254aa75085$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $466f66254aa75085$var$_construct(Class, arguments, $466f66254aa75085$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $466f66254aa75085$var$_setPrototypeOf(Wrapper, Class);
    };
    return $466f66254aa75085$var$_wrapNativeSuper(Class);
}
/* eslint no-console:0 */ var $466f66254aa75085$var$formatRegExp = /%[sdj%]/g;
var $466f66254aa75085$var$warning = function warning() {}; // don't print warning message when in production env or node runtime
function $466f66254aa75085$var$convertFieldsError(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $466f66254aa75085$var$format(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($466f66254aa75085$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $466f66254aa75085$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function $466f66254aa75085$var$isEmptyValue(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($466f66254aa75085$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $466f66254aa75085$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $466f66254aa75085$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $466f66254aa75085$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, objArr[k] || []);
    });
    return ret;
}
var $466f66254aa75085$var$AsyncValidationError = /*#__PURE__*/ function(_Error) {
    $466f66254aa75085$var$_inheritsLoose(AsyncValidationError, _Error);
    function AsyncValidationError(errors, fields) {
        var _this;
        _this = _Error.call(this, 'Async Validation Error') || this;
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return AsyncValidationError;
}(/*#__PURE__*/ $466f66254aa75085$var$_wrapNativeSuper(Error));
function $466f66254aa75085$var$asyncMap(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $466f66254aa75085$var$AsyncValidationError(errors, $466f66254aa75085$var$convertFieldsError(errors))) : resolve(source);
            };
            var flattenArr = $466f66254aa75085$var$flattenObjArr(objArr);
            $466f66254aa75085$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending["catch"](function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $466f66254aa75085$var$AsyncValidationError(results, $466f66254aa75085$var$convertFieldsError(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $466f66254aa75085$var$asyncSerialArray(arr, func, next);
            else $466f66254aa75085$var$asyncParallelArray(arr, func, next);
        });
    });
    pending["catch"](function(e) {
        return e;
    });
    return pending;
}
function $466f66254aa75085$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $466f66254aa75085$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $466f66254aa75085$var$complementError(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $466f66254aa75085$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($466f66254aa75085$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $466f66254aa75085$var$deepMerge(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if (typeof value === 'object' && typeof target[s] === 'object') target[s] = $466f66254aa75085$var$_extends({}, target[s], value);
            else target[s] = value;
        }
    }
    return target;
}
var $466f66254aa75085$var$required$1 = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || $466f66254aa75085$var$isEmptyValue(value, type || rule.type))) errors.push($466f66254aa75085$var$format(options.messages.required, rule.fullField));
};
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $466f66254aa75085$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push($466f66254aa75085$var$format(options.messages.whitespace, rule.fullField));
};
// https://github.com/kevva/url-regex/blob/master/index.js
var $466f66254aa75085$var$urlReg;
var $466f66254aa75085$var$getUrlRegex = function() {
    if ($466f66254aa75085$var$urlReg) return $466f66254aa75085$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
    var v4exact = new RegExp("^" + v4 + "$");
    var v6exact = new RegExp("^" + v6 + "$");
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
    $466f66254aa75085$var$urlReg = new RegExp("(?:^" + regex + "$)", 'i');
    return $466f66254aa75085$var$urlReg;
};
/* eslint max-len:0 */ var $466f66254aa75085$var$pattern$2 = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $466f66254aa75085$var$types = {
    integer: function integer(value) {
        return $466f66254aa75085$var$types.number(value) && parseInt(value, 10) === value;
    },
    "float": function float(value) {
        return $466f66254aa75085$var$types.number(value) && !$466f66254aa75085$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return typeof value === 'object' && !$466f66254aa75085$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($466f66254aa75085$var$pattern$2.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match($466f66254aa75085$var$getUrlRegex());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($466f66254aa75085$var$pattern$2.hex);
    }
};
var $466f66254aa75085$var$type$1 = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        $466f66254aa75085$var$required$1(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$466f66254aa75085$var$types[ruleType](value)) errors.push($466f66254aa75085$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
         // straight typeof check
    } else if (ruleType && typeof value !== rule.type) errors.push($466f66254aa75085$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $466f66254aa75085$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
     // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push($466f66254aa75085$var$format(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push($466f66254aa75085$var$format(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push($466f66254aa75085$var$format(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push($466f66254aa75085$var$format(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $466f66254aa75085$var$ENUM$1 = 'enum';
var $466f66254aa75085$var$enumerable$1 = function enumerable(rule, value, source, errors, options) {
    rule[$466f66254aa75085$var$ENUM$1] = Array.isArray(rule[$466f66254aa75085$var$ENUM$1]) ? rule[$466f66254aa75085$var$ENUM$1] : [];
    if (rule[$466f66254aa75085$var$ENUM$1].indexOf(value) === -1) errors.push($466f66254aa75085$var$format(options.messages[$466f66254aa75085$var$ENUM$1], rule.fullField, rule[$466f66254aa75085$var$ENUM$1].join(', ')));
};
var $466f66254aa75085$var$pattern$1 = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push($466f66254aa75085$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push($466f66254aa75085$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $466f66254aa75085$var$rules = {
    required: $466f66254aa75085$var$required$1,
    whitespace: $466f66254aa75085$var$whitespace,
    type: $466f66254aa75085$var$type$1,
    range: $466f66254aa75085$var$range,
    "enum": $466f66254aa75085$var$enumerable$1,
    pattern: $466f66254aa75085$var$pattern$1
};
var $466f66254aa75085$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, 'string') && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, 'string');
        if (!$466f66254aa75085$var$isEmptyValue(value, 'string')) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) $466f66254aa75085$var$rules.whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') value = undefined;
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$_boolean = function _boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value)) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$ENUM = 'enum';
var $466f66254aa75085$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules[$466f66254aa75085$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, 'string') && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value, 'string')) $466f66254aa75085$var$rules.pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, 'date') && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            $466f66254aa75085$var$rules.type(rule, dateObject, source, errors, options);
            if (dateObject) $466f66254aa75085$var$rules.range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : typeof value;
    $466f66254aa75085$var$rules.required(rule, value, source, errors, options, type);
    callback(errors);
};
var $466f66254aa75085$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, ruleType) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, ruleType);
        if (!$466f66254aa75085$var$isEmptyValue(value, ruleType)) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$validators = {
    string: $466f66254aa75085$var$string,
    method: $466f66254aa75085$var$method,
    number: $466f66254aa75085$var$number,
    "boolean": $466f66254aa75085$var$_boolean,
    regexp: $466f66254aa75085$var$regexp,
    integer: $466f66254aa75085$var$integer,
    "float": $466f66254aa75085$var$floatFn,
    array: $466f66254aa75085$var$array,
    object: $466f66254aa75085$var$object,
    "enum": $466f66254aa75085$var$enumerable,
    pattern: $466f66254aa75085$var$pattern,
    date: $466f66254aa75085$var$date,
    url: $466f66254aa75085$var$type,
    hex: $466f66254aa75085$var$type,
    email: $466f66254aa75085$var$type,
    required: $466f66254aa75085$var$required,
    any: $466f66254aa75085$var$any
};
function $466f66254aa75085$var$newMessages() {
    return {
        "default": 'Validation error on field %s',
        required: '%s is required',
        "enum": '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            "boolean": '%s is not a %s',
            integer: '%s is not an %s',
            "float": '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $466f66254aa75085$var$messages = $466f66254aa75085$var$newMessages();
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $466f66254aa75085$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // ========================= Static =========================
    // ======================== Instance ========================
    function Schema(descriptor) {
        this.rules = null;
        this._messages = $466f66254aa75085$var$messages;
        this.define(descriptor);
    }
    var _proto = Schema.prototype;
    _proto.define = function define(rules) {
        var _this = this;
        if (!rules) throw new Error('Cannot configure a schema with no rules');
        if (typeof rules !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
        this.rules = {};
        Object.keys(rules).forEach(function(name) {
            var item = rules[name];
            _this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    };
    _proto.messages = function messages(_messages) {
        if (_messages) this._messages = $466f66254aa75085$var$deepMerge($466f66254aa75085$var$newMessages(), _messages);
        return this._messages;
    };
    _proto.validate = function validate(source_, o, oc) {
        var _this2 = this;
        if (o === void 0) o = {};
        if (oc === void 0) oc = function oc() {};
        var source = source_;
        var options = o;
        var callback = oc;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            var errors = [];
            var fields = {};
            function add(e) {
                if (Array.isArray(e)) {
                    var _errors;
                    errors = (_errors = errors).concat.apply(_errors, e);
                } else errors.push(e);
            }
            for(var i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = $466f66254aa75085$var$convertFieldsError(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            var messages$1 = this.messages();
            if (messages$1 === $466f66254aa75085$var$messages) messages$1 = $466f66254aa75085$var$newMessages();
            $466f66254aa75085$var$deepMerge(messages$1, options.messages);
            options.messages = messages$1;
        } else options.messages = this.messages();
        var series = {};
        var keys = options.keys || Object.keys(this.rules);
        keys.forEach(function(z) {
            var arr = _this2.rules[z];
            var value = source[z];
            arr.forEach(function(r) {
                var rule = r;
                if (typeof rule.transform === 'function') {
                    if (source === source_) source = $466f66254aa75085$var$_extends({}, source);
                    value = source[z] = rule.transform(value);
                }
                if (typeof rule === 'function') rule = {
                    validator: rule
                };
                else rule = $466f66254aa75085$var$_extends({}, rule);
                 // Fill validator. Skip if nothing need to validate
                rule.validator = _this2.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = _this2.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        var errorFields = {};
        return $466f66254aa75085$var$asyncMap(series, options, function(data, doIt) {
            var rule = data.rule;
            var deep = (rule.type === 'object' || rule.type === 'array') && (typeof rule.fields === 'object' || typeof rule.defaultField === 'object');
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return $466f66254aa75085$var$_extends({}, schema, {
                    fullField: rule.fullField + "." + key,
                    fullFields: rule.fullFields ? [].concat(rule.fullFields, [
                        key
                    ]) : [
                        key
                    ]
                });
            }
            function cb(e) {
                if (e === void 0) e = [];
                var errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                 // Fill error info
                var filledErrors = errorList.map($466f66254aa75085$var$complementError(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map($466f66254aa75085$var$complementError(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, $466f66254aa75085$var$format(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    var fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map(function(key) {
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = $466f66254aa75085$var$_extends({}, fieldsSchema, data.rule.fields);
                    var paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach(function(field) {
                        var fieldSchema = fieldsSchema[field];
                        var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    var schema = new Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, function(errs) {
                        var finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, filledErrors);
                        if (errs && errs.length) finalErrors.push.apply(finalErrors, errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            var res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error == null || console.error(error); // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(function() {
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(function() {
                return cb();
            }, function(e) {
                return cb(e);
            });
        }, function(results) {
            complete(results);
        }, source);
    };
    _proto.getType = function getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
        if (typeof rule.validator !== 'function' && rule.type && !$466f66254aa75085$var$validators.hasOwnProperty(rule.type)) throw new Error($466f66254aa75085$var$format('Unknown rule type %s', rule.type));
        return rule.type || 'string';
    };
    _proto.getValidationMethod = function getValidationMethod(rule) {
        if (typeof rule.validator === 'function') return rule.validator;
        var keys = Object.keys(rule);
        var messageIndex = keys.indexOf('message');
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === 'required') return $466f66254aa75085$var$validators.required;
        return $466f66254aa75085$var$validators[this.getType(rule)] || undefined;
    };
    return Schema;
}();
$466f66254aa75085$export$2e2bcd8739ae039.register = function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    $466f66254aa75085$var$validators[type] = validator;
};
$466f66254aa75085$export$2e2bcd8739ae039.warning = $466f66254aa75085$var$warning;
$466f66254aa75085$export$2e2bcd8739ae039.messages = $466f66254aa75085$var$messages;
$466f66254aa75085$export$2e2bcd8739ae039.validators = $466f66254aa75085$var$validators;

});

parcelRegister("kg8Ze", function(module, exports) {

$parcel$export(module.exports, "defaultValidateMessages", () => $ebfc45d3b86f29a2$export$c86b939816b8fbf8);
var $ebfc45d3b86f29a2$var$typeTemplate = "'${name}' is not a valid ${type}";
var $ebfc45d3b86f29a2$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $ebfc45d3b86f29a2$var$typeTemplate,
        method: $ebfc45d3b86f29a2$var$typeTemplate,
        array: $ebfc45d3b86f29a2$var$typeTemplate,
        object: $ebfc45d3b86f29a2$var$typeTemplate,
        number: $ebfc45d3b86f29a2$var$typeTemplate,
        date: $ebfc45d3b86f29a2$var$typeTemplate,
        boolean: $ebfc45d3b86f29a2$var$typeTemplate,
        integer: $ebfc45d3b86f29a2$var$typeTemplate,
        float: $ebfc45d3b86f29a2$var$typeTemplate,
        regexp: $ebfc45d3b86f29a2$var$typeTemplate,
        email: $ebfc45d3b86f29a2$var$typeTemplate,
        url: $ebfc45d3b86f29a2$var$typeTemplate,
        hex: $ebfc45d3b86f29a2$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};

});


parcelRegister("kFGlN", function(module, exports) {

$parcel$export(module.exports, "getNamePath", () => $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9);
$parcel$export(module.exports, "cloneByNamePathList", () => $f0c87cef6ee60bcb$export$f5be6dfb30403c59);
$parcel$export(module.exports, "containsNamePath", () => $f0c87cef6ee60bcb$export$646d5504364ae55b);
$parcel$export(module.exports, "matchNamePath", () => $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a);
$parcel$export(module.exports, "isSimilar", () => $f0c87cef6ee60bcb$export$dfcec05bb7372a54);
$parcel$export(module.exports, "defaultGetValueFromEvent", () => $f0c87cef6ee60bcb$export$6eeac3c5b406fb30);
$parcel$export(module.exports, "move", () => $f0c87cef6ee60bcb$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "getValue", () => (parcelRequire("23Gye")).default);
$parcel$export(module.exports, "setValue", () => (parcelRequire("6vgkH")).default);

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

var $23Gye = parcelRequire("23Gye");

var $6vgkH = parcelRequire("6vgkH");

var $hhXFI = parcelRequire("hhXFI");
function $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9(path) {
    return (0, $hhXFI.toArray)(path);
}
function $f0c87cef6ee60bcb$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $23Gye.default)(store, namePath);
        newStore = (0, $6vgkH.default)(newStore, namePath, value);
    });
    return newStore;
}
function $f0c87cef6ee60bcb$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $f0c87cef6ee60bcb$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $fSwVM.default)(source) !== 'object' || (0, $fSwVM.default)(target) !== 'object') return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $kbxxf.default)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $f0c87cef6ee60bcb$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $fSwVM.default)(event.target) === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $f0c87cef6ee60bcb$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $kbxxf.default)(array.slice(0, toIndex)), [
        item
    ], (0, $kbxxf.default)(array.slice(toIndex, moveIndex)), (0, $kbxxf.default)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $kbxxf.default)(array.slice(0, moveIndex)), (0, $kbxxf.default)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $kbxxf.default)(array.slice(toIndex + 1, length)));
    return array;
}

});


parcelRegister("2iMfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad2b0235e0eb0b7$export$2e2bcd8739ae039);

var $d49SP = parcelRequire("d49SP");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $u43uR = parcelRequire("u43uR");

var $260BS = parcelRequire("260BS");

var $4llrF = parcelRequire("4llrF");

var $kFGlN = parcelRequire("kFGlN");

var $livSf = parcelRequire("livSf");
function $1ad2b0235e0eb0b7$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $acw62.useContext((0, $260BS.default));
    var wrapperListContext = $acw62.useContext((0, $livSf.default));
    var keyRef = $acw62.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $acw62.useMemo(function() {
        var parentPrefixName = (0, $kFGlN.getNamePath)(context.prefixName) || [];
        return [].concat((0, $kbxxf.default)(parentPrefixName), (0, $kbxxf.default)((0, $kFGlN.getNamePath)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $acw62.useMemo(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $acw62.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $u43uR.default)(false, 'Form.List only accepts function as children.');
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $acw62.createElement((0, $livSf.default).Provider, {
        value: listContext
    }, /*#__PURE__*/ $acw62.createElement((0, $260BS.default).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $acw62.createElement((0, $4llrF.default), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $kbxxf.default)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $kbxxf.default)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $kbxxf.default)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $kbxxf.default)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $kbxxf.default)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $kbxxf.default)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $kFGlN.move)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $kFGlN.move)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $1ad2b0235e0eb0b7$export$2e2bcd8739ae039 = $1ad2b0235e0eb0b7$var$List;

});

parcelRegister("dRl3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1708dc7c20669c0$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

var $cHPF9 = parcelRequire("cHPF9");

var $6CZeq = parcelRequire("6CZeq");

var $kSlfw = parcelRequire("kSlfw");

var $u43uR = parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $260BS = parcelRequire("260BS");

var $2yepO = parcelRequire("2yepO");

var $6vgkH = parcelRequire("6vgkH");

var $kg8Ze = parcelRequire("kg8Ze");

var $g2KHW = parcelRequire("g2KHW");

var $kFGlN = parcelRequire("kFGlN");
var $23Gye = parcelRequire("23Gye");
var $6vgkH = parcelRequire("6vgkH");
var $a1708dc7c20669c0$var$_excluded = [
    "name"
];
var $a1708dc7c20669c0$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $cHPF9.default)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $6CZeq.default)(this, FormStore);
    (0, $kSlfw.default)(this, "formHooked", false);
    (0, $kSlfw.default)(this, "forceRootUpdate", void 0);
    (0, $kSlfw.default)(this, "subscribable", true);
    (0, $kSlfw.default)(this, "store", {});
    (0, $kSlfw.default)(this, "fieldEntities", []);
    (0, $kSlfw.default)(this, "initialValues", {});
    (0, $kSlfw.default)(this, "callbacks", {});
    (0, $kSlfw.default)(this, "validateMessages", null);
    (0, $kSlfw.default)(this, "preserve", null);
    (0, $kSlfw.default)(this, "lastValidatePromise", null);
    (0, $kSlfw.default)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $kSlfw.default)(this, "getInternalHooks", function(key) {
        if (key === (0, $260BS.HOOK_MARK)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $u43uR.default)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    });
    (0, $kSlfw.default)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $kSlfw.default)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $kSlfw.default)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $6vgkH.merge)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $6vgkH.default)(nextStore, namePath, (0, $23Gye.default)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $kSlfw.default)(this, "destroyForm", function() {
        var prevWithoutPreserves = new (0, $g2KHW.default)();
        _this.getFieldEntities(true).forEach(function(entity) {
            if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
        });
        _this.prevWithoutPreserves = prevWithoutPreserves;
    });
    (0, $kSlfw.default)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $23Gye.default)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $6vgkH.merge)(initValue) : initValue;
    });
    (0, $kSlfw.default)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $kSlfw.default)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $kSlfw.default)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $kSlfw.default)(this, "watchList", []);
    (0, $kSlfw.default)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $kSlfw.default)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $kSlfw.default)(this, "timeoutId", null);
    (0, $kSlfw.default)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $kSlfw.default)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $kSlfw.default)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $kSlfw.default)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $g2KHW.default)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $kSlfw.default)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $kFGlN.getNamePath)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $kFGlN.getNamePath)(name)
            };
        });
    });
    (0, $kSlfw.default)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $fSwVM.default)(nameList) === 'object') {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $kFGlN.cloneByNamePathList)(_this.store, filteredNameList.map((0, $kFGlN.getNamePath)));
    });
    (0, $kSlfw.default)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $kFGlN.getNamePath)(name);
        return (0, $23Gye.default)(_this.store, namePath);
    });
    (0, $kSlfw.default)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !('INVALIDATE_NAME_PATH' in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $kFGlN.getNamePath)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $kSlfw.default)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $kFGlN.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $kSlfw.default)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $kFGlN.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $kSlfw.default)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $kFGlN.getNamePath));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $kFGlN.getNamePath));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $g2KHW.default)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $kbxxf.default)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $kSlfw.default)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $kSlfw.default)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $kFGlN.getNamePath));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $kFGlN.containsNamePath)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $kSlfw.default)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $kSlfw.default)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $g2KHW.default)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $u43uR.default)(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $u43uR.default)(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            // Set `initialValue`
                            if (!info.skipExist || originValue === undefined) _this.updateStore((0, $6vgkH.default)(_this.store, namePath, (0, $kbxxf.default)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $kbxxf.default)((0, $kbxxf.default)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $kSlfw.default)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $6vgkH.merge)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $kFGlN.getNamePath));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $6vgkH.default)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        _this.notifyWatch(namePathList);
    });
    (0, $kSlfw.default)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $9X7IJ.default)(fieldData, $a1708dc7c20669c0$var$_excluded);
            var namePath = (0, $kFGlN.getNamePath)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) _this.updateStore((0, $6vgkH.default)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $kSlfw.default)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $d49SP.default)((0, $d49SP.default)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $kSlfw.default)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $23Gye.default)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $6vgkH.default)(_this.store, namePath, initialValue));
        }
    });
    (0, $kSlfw.default)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $kSlfw.default)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $kFGlN.matchNamePath)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $6vgkH.default)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $kSlfw.default)(this, "dispatch", function(action) {
        switch(action.type){
            case 'updateValue':
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case 'validateField':
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $kSlfw.default)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $d49SP.default)((0, $d49SP.default)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $kSlfw.default)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath
            ].concat((0, $kbxxf.default)(childrenFields))
        });
        return childrenFields;
    });
    (0, $kSlfw.default)(this, "updateValue", function(name, value) {
        var namePath = (0, $kFGlN.getNamePath)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $6vgkH.default)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $kFGlN.cloneByNamePathList)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $kbxxf.default)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $kSlfw.default)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $6vgkH.merge)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        _this.notifyWatch();
    });
    (0, $kSlfw.default)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value
            }
        ]);
    });
    (0, $kSlfw.default)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $g2KHW.default)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $kFGlN.getNamePath)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $kSlfw.default)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $g2KHW.default)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $kFGlN.containsNamePath)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $kSlfw.default)(this, "validateFields", function(arg1, arg2) {
        var _options;
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $kFGlN.getNamePath)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var recursive = (_options = options) === null || _options === void 0 ? void 0 : _options.recursive;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $kFGlN.containsNamePath)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $d49SP.default)({
                    validateMessages: (0, $d49SP.default)((0, $d49SP.default)({}, (0, $kg8Ze.defaultValidateMessages)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref8) {
                        var warningOnly = _ref8.rule.warningOnly, errors = _ref8.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $kbxxf.default)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $kbxxf.default)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $2yepO.allPromiseFinish)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref9) {
                var name = _ref9.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $kSlfw.default)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $a1708dc7c20669c0$var$useForm(form) {
    var formRef = $acw62.useRef();
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $a1708dc7c20669c0$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $a1708dc7c20669c0$export$2e2bcd8739ae039 = $a1708dc7c20669c0$var$useForm;

});
parcelRegister("2yepO", function(module, exports) {

$parcel$export(module.exports, "allPromiseFinish", () => $1db9f053670497ce$export$6152adfdcc6be2b5);
function $1db9f053670497ce$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}

});

parcelRegister("g2KHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae1107165a0db1c$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");

var $fSwVM = parcelRequire("fSwVM");
var $bae1107165a0db1c$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $bae1107165a0db1c$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $fSwVM.default)(cell), ":").concat(cell);
    })// Magic split
    .join($bae1107165a0db1c$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $bae1107165a0db1c$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $6CZeq.default)(this, NameMap);
        (0, $kSlfw.default)(this, "kvs", new Map());
    }
    (0, $cHPF9.default)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($bae1107165a0db1c$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $kbxxf.default)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $eUqlC.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($bae1107165a0db1c$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $eUqlC.default)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === 'number' ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join('.')] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $bae1107165a0db1c$export$2e2bcd8739ae039 = $bae1107165a0db1c$var$NameMap;

});


parcelRegister("akLVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7860f41d917f18d2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $dRl3b = parcelRequire("dRl3b");

var $260BS = parcelRequire("260BS");

var $144QO = parcelRequire("144QO");

var $kFGlN = parcelRequire("kFGlN");

var $livSf = parcelRequire("livSf");
var $7860f41d917f18d2$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed"
];
var $7860f41d917f18d2$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? 'form' : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, restProps = (0, $9X7IJ.default)(_ref, $7860f41d917f18d2$var$_excluded);
    var formContext = $acw62.useContext((0, $144QO.default));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $dRl3b.default)(form), _useForm2 = (0, $eUqlC.default)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $260BS.HOOK_MARK)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $acw62.useImperativeHandle(ref, function() {
        return formInstance;
    });
    // Register form into Context
    $acw62.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $d49SP.default)((0, $d49SP.default)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $acw62.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $acw62.useEffect(function() {
        return destroyForm;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $acw62.useRef();
    $acw62.useEffect(function() {
        if (!(0, $kFGlN.isSimilar)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $acw62.useMemo(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $acw62.createElement((0, $livSf.default).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $260BS.default).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({}, restProps, {
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $7860f41d917f18d2$export$2e2bcd8739ae039 = $7860f41d917f18d2$var$Form;

});
parcelRegister("144QO", function(module, exports) {

$parcel$export(module.exports, "FormProvider", () => $0c69ed761f95e1b0$export$8ce1ff4f94d08846);
$parcel$export(module.exports, "default", () => $0c69ed761f95e1b0$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
var $0c69ed761f95e1b0$var$FormContext = /*#__PURE__*/ $acw62.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $0c69ed761f95e1b0$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $acw62.useContext($0c69ed761f95e1b0$var$FormContext);
    var formsRef = $acw62.useRef({});
    return /*#__PURE__*/ $acw62.createElement($0c69ed761f95e1b0$var$FormContext.Provider, {
        value: (0, $d49SP.default)((0, $d49SP.default)({}, formContext), {}, {
            validateMessages: (0, $d49SP.default)((0, $d49SP.default)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $d49SP.default)((0, $d49SP.default)({}, formsRef.current), {}, (0, $kSlfw.default)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $d49SP.default)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $0c69ed761f95e1b0$export$2e2bcd8739ae039 = $0c69ed761f95e1b0$var$FormContext;

});


parcelRegister("gPDhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c40fe08ecbe59c71$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");
parcelRequire("u43uR");

var $acw62 = parcelRequire("acw62");

var $260BS = parcelRequire("260BS");

var $hhXFI = parcelRequire("hhXFI");

var $kFGlN = parcelRequire("kFGlN");
var $23Gye = parcelRequire("23Gye");
function $c40fe08ecbe59c71$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $c40fe08ecbe59c71$var$useWatchWarning = function() {};
function $c40fe08ecbe59c71$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var _args$ = args[0], dependencies = _args$ === void 0 ? [] : _args$, _args$2 = args[1], _form = _args$2 === void 0 ? {} : _args$2;
    var options = (0, $hhXFI.isFormInstance)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $eUqlC.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $acw62.useMemo)(function() {
        return $c40fe08ecbe59c71$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $acw62.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $acw62.useContext)((0, $260BS.default));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $kFGlN.getNamePath)(dependencies);
    var namePathRef = (0, $acw62.useRef)(namePath);
    namePathRef.current = namePath;
    $c40fe08ecbe59c71$var$useWatchWarning(namePath);
    (0, $acw62.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $260BS.HOOK_MARK)), registerWatch = _getInternalHooks.registerWatch;
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = (0, $23Gye.default)(options.preserve ? allValues : values, namePathRef.current);
            var nextValueStr = $c40fe08ecbe59c71$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = (0, $23Gye.default)(options.preserve ? getFieldsValue(true) : getFieldsValue(), namePathRef.current);
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $c40fe08ecbe59c71$export$2e2bcd8739ae039 = $c40fe08ecbe59c71$var$useWatch;

});



parcelRegister("2F6xM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransitionName = module.exports.getTransitionDirection = module.exports["default"] = void 0;

var $3YGhB = parcelRequire("3YGhB");
// ================== Collapse Motion ==================
var $1f047c95bbfe3242$var$getCollapsedHeight = function getCollapsedHeight() {
    return {
        height: 0,
        opacity: 0
    };
};
var $1f047c95bbfe3242$var$getRealHeight = function getRealHeight(node) {
    var scrollHeight = node.scrollHeight;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
var $1f047c95bbfe3242$var$getCurrentHeight = function getCurrentHeight(node) {
    return {
        height: node ? node.offsetHeight : 0
    };
};
var $1f047c95bbfe3242$var$skipOpacityTransition = function skipOpacityTransition(_, event) {
    return (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
};
var $1f047c95bbfe3242$var$collapseMotion = {
    motionName: 'ant-motion-collapse',
    onAppearStart: $1f047c95bbfe3242$var$getCollapsedHeight,
    onEnterStart: $1f047c95bbfe3242$var$getCollapsedHeight,
    onAppearActive: $1f047c95bbfe3242$var$getRealHeight,
    onEnterActive: $1f047c95bbfe3242$var$getRealHeight,
    onLeaveStart: $1f047c95bbfe3242$var$getCurrentHeight,
    onLeaveActive: $1f047c95bbfe3242$var$getCollapsedHeight,
    onAppearEnd: $1f047c95bbfe3242$var$skipOpacityTransition,
    onEnterEnd: $1f047c95bbfe3242$var$skipOpacityTransition,
    onLeaveEnd: $1f047c95bbfe3242$var$skipOpacityTransition,
    motionDeadline: 500
};
var $1f047c95bbfe3242$var$SelectPlacements = (0, $3YGhB.tuple)('bottomLeft', 'bottomRight', 'topLeft', 'topRight');
var $1f047c95bbfe3242$var$getTransitionDirection = module.exports.getTransitionDirection = function getTransitionDirection(placement) {
    if (placement !== undefined && (placement === 'topLeft' || placement === 'topRight')) return "slide-down";
    return "slide-up";
};
var $1f047c95bbfe3242$var$getTransitionName = module.exports.getTransitionName = function getTransitionName(rootPrefixCls, motion, transitionName) {
    if (transitionName !== undefined) return transitionName;
    return "".concat(rootPrefixCls, "-").concat(motion);
};
var $1f047c95bbfe3242$var$_default = module.exports["default"] = $1f047c95bbfe3242$var$collapseMotion;

});
parcelRegister("3YGhB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tupleNum = module.exports.tuple = void 0;
// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var $2e57c631c2f9a565$var$tuple = module.exports.tuple = function tuple() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args;
};
var $2e57c631c2f9a565$var$tupleNum = module.exports.tupleNum = function tupleNum() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return args;
};

});


parcelRegister("fFWOB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b6984ecd2be0e5c6$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMergedStatus = void 0;
module.exports.getStatusClassNames = $b6984ecd2be0e5c6$var$getStatusClassNames;

var $b6984ecd2be0e5c6$var$_defineProperty2 = $b6984ecd2be0e5c6$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $b6984ecd2be0e5c6$var$_classnames = $b6984ecd2be0e5c6$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $3YGhB = parcelRequire("3YGhB");
var $b6984ecd2be0e5c6$var$InputStatuses = (0, $3YGhB.tuple)('warning', 'error', '');
function $b6984ecd2be0e5c6$var$getStatusClassNames(prefixCls, status, hasFeedback) {
    return (0, $b6984ecd2be0e5c6$var$_classnames["default"])((0, $b6984ecd2be0e5c6$var$_defineProperty2["default"])((0, $b6984ecd2be0e5c6$var$_defineProperty2["default"])((0, $b6984ecd2be0e5c6$var$_defineProperty2["default"])((0, $b6984ecd2be0e5c6$var$_defineProperty2["default"])((0, $b6984ecd2be0e5c6$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-status-success"), status === 'success'), "".concat(prefixCls, "-status-warning"), status === 'warning'), "".concat(prefixCls, "-status-error"), status === 'error'), "".concat(prefixCls, "-status-validating"), status === 'validating'), "".concat(prefixCls, "-has-feedback"), hasFeedback));
}
var $b6984ecd2be0e5c6$var$getMergedStatus = module.exports.getMergedStatus = function getMergedStatus(contextStatus, customStatus) {
    return customStatus || contextStatus;
};

});

parcelRegister("c515c", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8cb6cab8ab5c7804$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $8cb6cab8ab5c7804$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8cb6cab8ab5c7804$var$getIcons;

var $8cb6cab8ab5c7804$var$_CheckOutlined = $8cb6cab8ab5c7804$var$_interopRequireDefault((parcelRequire("ECbol")));

var $8cb6cab8ab5c7804$var$_CloseCircleFilled = $8cb6cab8ab5c7804$var$_interopRequireDefault((parcelRequire("coSzL")));

var $8cb6cab8ab5c7804$var$_CloseOutlined = $8cb6cab8ab5c7804$var$_interopRequireDefault((parcelRequire("hdfxO")));

var $8cb6cab8ab5c7804$var$_DownOutlined = $8cb6cab8ab5c7804$var$_interopRequireDefault((parcelRequire("3TR7r")));

var $8cb6cab8ab5c7804$var$_LoadingOutlined = $8cb6cab8ab5c7804$var$_interopRequireDefault((parcelRequire("53y9T")));

var $8cb6cab8ab5c7804$var$_SearchOutlined = $8cb6cab8ab5c7804$var$_interopRequireDefault((parcelRequire("cDmoh")));

var $8cb6cab8ab5c7804$var$React = $8cb6cab8ab5c7804$var$_interopRequireWildcard((parcelRequire("acw62")));
function $8cb6cab8ab5c7804$var$getIcons(_ref) {
    var suffixIcon = _ref.suffixIcon, clearIcon = _ref.clearIcon, menuItemSelectedIcon = _ref.menuItemSelectedIcon, removeIcon = _ref.removeIcon, loading = _ref.loading, multiple = _ref.multiple, hasFeedback = _ref.hasFeedback, prefixCls = _ref.prefixCls, showArrow = _ref.showArrow, feedbackIcon = _ref.feedbackIcon;
    // Clear Icon
    var mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $8cb6cab8ab5c7804$var$React.createElement($8cb6cab8ab5c7804$var$_CloseCircleFilled["default"], null);
    // Validation Feedback Icon
    var getSuffixIconNode = function getSuffixIconNode(arrowIcon) {
        return /*#__PURE__*/ $8cb6cab8ab5c7804$var$React.createElement($8cb6cab8ab5c7804$var$React.Fragment, null, showArrow !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    var mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $8cb6cab8ab5c7804$var$React.createElement($8cb6cab8ab5c7804$var$_LoadingOutlined["default"], {
        spin: true
    }));
    else {
        var iconCls = "".concat(prefixCls, "-suffix");
        mergedSuffixIcon = function mergedSuffixIcon(_ref2) {
            var open = _ref2.open, showSearch = _ref2.showSearch;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $8cb6cab8ab5c7804$var$React.createElement($8cb6cab8ab5c7804$var$_SearchOutlined["default"], {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $8cb6cab8ab5c7804$var$React.createElement($8cb6cab8ab5c7804$var$_DownOutlined["default"], {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    var mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $8cb6cab8ab5c7804$var$React.createElement($8cb6cab8ab5c7804$var$_CheckOutlined["default"], null);
    else mergedItemIcon = null;
    var mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $8cb6cab8ab5c7804$var$React.createElement($8cb6cab8ab5c7804$var$_CloseOutlined["default"], null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}

});
parcelRegister("ECbol", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07a15ad66e18b78e$var$_CheckOutlined = $07a15ad66e18b78e$var$_interopRequireDefault((parcelRequire("4KfqN")));
function $07a15ad66e18b78e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $07a15ad66e18b78e$var$_default = $07a15ad66e18b78e$var$_CheckOutlined;
module.exports.default = $07a15ad66e18b78e$var$_default;
module.exports = $07a15ad66e18b78e$var$_default;

});
parcelRegister("4KfqN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37476d9d66116053$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $37476d9d66116053$var$React = $37476d9d66116053$var$_interopRequireWildcard((parcelRequire("acw62")));

var $37476d9d66116053$var$_CheckOutlined = $1jnue((parcelRequire("43elk")));

var $37476d9d66116053$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $37476d9d66116053$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($37476d9d66116053$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $37476d9d66116053$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $37476d9d66116053$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $37476d9d66116053$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $37476d9d66116053$var$React.createElement($37476d9d66116053$var$_AntdIcon.default, (0, $37476d9d66116053$var$_objectSpread2.default)((0, $37476d9d66116053$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $37476d9d66116053$var$_CheckOutlined.default
    }));
};
var $37476d9d66116053$var$RefIcon = /*#__PURE__*/ $37476d9d66116053$var$React.forwardRef($37476d9d66116053$var$CheckOutlined);
var $37476d9d66116053$var$_default = module.exports.default = $37476d9d66116053$var$RefIcon;

});
parcelRegister("43elk", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2f329179fc350e3a$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
module.exports.default = $2f329179fc350e3a$var$CheckOutlined;

});



parcelRegister("3TR7r", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d6fb67b04d85515$var$_DownOutlined = $2d6fb67b04d85515$var$_interopRequireDefault((parcelRequire("h6tcO")));
function $2d6fb67b04d85515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $2d6fb67b04d85515$var$_default = $2d6fb67b04d85515$var$_DownOutlined;
module.exports.default = $2d6fb67b04d85515$var$_default;
module.exports = $2d6fb67b04d85515$var$_default;

});
parcelRegister("h6tcO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c739a6d5e65eb5f3$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $c739a6d5e65eb5f3$var$React = $c739a6d5e65eb5f3$var$_interopRequireWildcard((parcelRequire("acw62")));

var $c739a6d5e65eb5f3$var$_DownOutlined = $1jnue((parcelRequire("1vH6q")));

var $c739a6d5e65eb5f3$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $c739a6d5e65eb5f3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c739a6d5e65eb5f3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c739a6d5e65eb5f3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $c739a6d5e65eb5f3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $c739a6d5e65eb5f3$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $c739a6d5e65eb5f3$var$React.createElement($c739a6d5e65eb5f3$var$_AntdIcon.default, (0, $c739a6d5e65eb5f3$var$_objectSpread2.default)((0, $c739a6d5e65eb5f3$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $c739a6d5e65eb5f3$var$_DownOutlined.default
    }));
};
var $c739a6d5e65eb5f3$var$RefIcon = /*#__PURE__*/ $c739a6d5e65eb5f3$var$React.forwardRef($c739a6d5e65eb5f3$var$DownOutlined);
var $c739a6d5e65eb5f3$var$_default = module.exports.default = $c739a6d5e65eb5f3$var$RefIcon;

});
parcelRegister("1vH6q", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $119a1ef5c61e9227$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
module.exports.default = $119a1ef5c61e9227$var$DownOutlined;

});



parcelRegister("cDmoh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $932a7edc202afe11$var$_SearchOutlined = $932a7edc202afe11$var$_interopRequireDefault((parcelRequire("krDjN")));
function $932a7edc202afe11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $932a7edc202afe11$var$_default = $932a7edc202afe11$var$_SearchOutlined;
module.exports.default = $932a7edc202afe11$var$_default;
module.exports = $932a7edc202afe11$var$_default;

});
parcelRegister("krDjN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee24d40f8d390c4d$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $ee24d40f8d390c4d$var$React = $ee24d40f8d390c4d$var$_interopRequireWildcard((parcelRequire("acw62")));

var $ee24d40f8d390c4d$var$_SearchOutlined = $1jnue((parcelRequire("rMD8G")));

var $ee24d40f8d390c4d$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $ee24d40f8d390c4d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ee24d40f8d390c4d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ee24d40f8d390c4d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $ee24d40f8d390c4d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $ee24d40f8d390c4d$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $ee24d40f8d390c4d$var$React.createElement($ee24d40f8d390c4d$var$_AntdIcon.default, (0, $ee24d40f8d390c4d$var$_objectSpread2.default)((0, $ee24d40f8d390c4d$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $ee24d40f8d390c4d$var$_SearchOutlined.default
    }));
};
var $ee24d40f8d390c4d$var$RefIcon = /*#__PURE__*/ $ee24d40f8d390c4d$var$React.forwardRef($ee24d40f8d390c4d$var$SearchOutlined);
var $ee24d40f8d390c4d$var$_default = module.exports.default = $ee24d40f8d390c4d$var$RefIcon;

});
parcelRegister("rMD8G", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $05383eb0ddd55aa2$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
module.exports.default = $05383eb0ddd55aa2$var$SearchOutlined;

});




parcelRegister("hvVUy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cc0240d8c681408b$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cc0240d8c681408b$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useCompactItemContext = module.exports["default"] = module.exports.SpaceCompactItemContext = module.exports.NoCompactStyle = void 0;

var $cc0240d8c681408b$var$_extends2 = $cc0240d8c681408b$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $cc0240d8c681408b$var$_defineProperty2 = $cc0240d8c681408b$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $cc0240d8c681408b$var$_classnames = $cc0240d8c681408b$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $cc0240d8c681408b$var$_toArray = $cc0240d8c681408b$var$_interopRequireDefault((parcelRequire("13r7s")));

var $cc0240d8c681408b$var$React = $cc0240d8c681408b$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");
var $cc0240d8c681408b$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cc0240d8c681408b$var$SpaceCompactItemContext = module.exports.SpaceCompactItemContext = /*#__PURE__*/ $cc0240d8c681408b$var$React.createContext(null);
var $cc0240d8c681408b$var$useCompactItemContext = module.exports.useCompactItemContext = function useCompactItemContext(prefixCls, direction) {
    var compactItemContext = $cc0240d8c681408b$var$React.useContext($cc0240d8c681408b$var$SpaceCompactItemContext);
    var compactItemClassnames = $cc0240d8c681408b$var$React.useMemo(function() {
        if (!compactItemContext) return '';
        var compactDirection = compactItemContext.compactDirection, isFirstItem = compactItemContext.isFirstItem, isLastItem = compactItemContext.isLastItem;
        var separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, $cc0240d8c681408b$var$_classnames["default"])((0, $cc0240d8c681408b$var$_defineProperty2["default"])((0, $cc0240d8c681408b$var$_defineProperty2["default"])((0, $cc0240d8c681408b$var$_defineProperty2["default"])((0, $cc0240d8c681408b$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-compact").concat(separator, "item"), true), "".concat(prefixCls, "-compact").concat(separator, "first-item"), isFirstItem), "".concat(prefixCls, "-compact").concat(separator, "last-item"), isLastItem), "".concat(prefixCls, "-compact").concat(separator, "item-rtl"), direction === 'rtl'));
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
var $cc0240d8c681408b$var$NoCompactStyle = module.exports.NoCompactStyle = function NoCompactStyle(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $cc0240d8c681408b$var$React.createElement($cc0240d8c681408b$var$SpaceCompactItemContext.Provider, {
        value: null
    }, children);
};
var $cc0240d8c681408b$var$CompactItem = function CompactItem(_a) {
    var children = _a.children, otherProps = $cc0240d8c681408b$var$__rest(_a, [
        "children"
    ]);
    return /*#__PURE__*/ $cc0240d8c681408b$var$React.createElement($cc0240d8c681408b$var$SpaceCompactItemContext.Provider, {
        value: otherProps
    }, children);
};
var $cc0240d8c681408b$var$Compact = function Compact(props) {
    var _React$useContext = $cc0240d8c681408b$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, directionConfig = _React$useContext.direction;
    var _props$size = props.size, size = _props$size === void 0 ? 'middle' : _props$size, direction = props.direction, block = props.block, customizePrefixCls = props.prefixCls, className = props.className, children = props.children, restProps = $cc0240d8c681408b$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "children"
    ]);
    var prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    var clx = (0, $cc0240d8c681408b$var$_classnames["default"])(prefixCls, (0, $cc0240d8c681408b$var$_defineProperty2["default"])((0, $cc0240d8c681408b$var$_defineProperty2["default"])((0, $cc0240d8c681408b$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), directionConfig === 'rtl'), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-vertical"), direction === 'vertical'), className);
    var compactItemContext = $cc0240d8c681408b$var$React.useContext($cc0240d8c681408b$var$SpaceCompactItemContext);
    var childNodes = (0, $cc0240d8c681408b$var$_toArray["default"])(children);
    var nodes = $cc0240d8c681408b$var$React.useMemo(function() {
        return childNodes.map(function(child, i) {
            var key = child && child.key || "".concat(prefixCls, "-item-").concat(i);
            return /*#__PURE__*/ $cc0240d8c681408b$var$React.createElement($cc0240d8c681408b$var$CompactItem, {
                key: key,
                compactSize: size,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        });
    }, [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $cc0240d8c681408b$var$React.createElement("div", (0, $cc0240d8c681408b$var$_extends2["default"])({
        className: clx
    }, restProps), nodes);
};
var $cc0240d8c681408b$var$_default = module.exports["default"] = $cc0240d8c681408b$var$Compact;

});





parcelRegister("kocCJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ed7fd75dceedabf1$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ed7fd75dceedabf1$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ed7fd75dceedabf1$var$_extends2 = $ed7fd75dceedabf1$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $ed7fd75dceedabf1$var$_defineProperty2 = $ed7fd75dceedabf1$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $ed7fd75dceedabf1$var$_slicedToArray2 = $ed7fd75dceedabf1$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $ed7fd75dceedabf1$var$_classnames = $ed7fd75dceedabf1$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $ed7fd75dceedabf1$var$_debounce = $ed7fd75dceedabf1$var$_interopRequireDefault((parcelRequire("iI6LB")));

var $ed7fd75dceedabf1$var$_omit = $ed7fd75dceedabf1$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $ed7fd75dceedabf1$var$React = $ed7fd75dceedabf1$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $8hTO8 = parcelRequire("8hTO8");

var $3YGhB = parcelRequire("3YGhB");
var $ed7fd75dceedabf1$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ed7fd75dceedabf1$var$SpinSizes = (0, $3YGhB.tuple)('small', 'default', 'large');
// Render indicator
var $ed7fd75dceedabf1$var$defaultIndicator = null;
function $ed7fd75dceedabf1$var$renderIndicator(prefixCls, props) {
    var indicator = props.indicator;
    var dotClassName = "".concat(prefixCls, "-dot");
    // should not be render default indicator when indicator value is null
    if (indicator === null) return null;
    if ((0, $8hTO8.isValidElement)(indicator)) return (0, $8hTO8.cloneElement)(indicator, {
        className: (0, $ed7fd75dceedabf1$var$_classnames["default"])(indicator.props.className, dotClassName)
    });
    if ((0, $8hTO8.isValidElement)($ed7fd75dceedabf1$var$defaultIndicator)) return (0, $8hTO8.cloneElement)($ed7fd75dceedabf1$var$defaultIndicator, {
        className: (0, $ed7fd75dceedabf1$var$_classnames["default"])($ed7fd75dceedabf1$var$defaultIndicator.props.className, dotClassName)
    });
    return /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("span", {
        className: (0, $ed7fd75dceedabf1$var$_classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
    }, /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }));
}
function $ed7fd75dceedabf1$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
}
var $ed7fd75dceedabf1$var$Spin = function Spin(props) {
    var prefixCls = props.spinPrefixCls, _props$spinning = props.spinning, customSpinning = _props$spinning === void 0 ? true : _props$spinning, delay = props.delay, className = props.className, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size, tip = props.tip, wrapperClassName = props.wrapperClassName, style = props.style, children = props.children, restProps = $ed7fd75dceedabf1$var$__rest(props, [
        "spinPrefixCls",
        "spinning",
        "delay",
        "className",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children"
    ]);
    var _React$useState = $ed7fd75dceedabf1$var$React.useState(function() {
        return customSpinning && !$ed7fd75dceedabf1$var$shouldDelay(customSpinning, delay);
    }), _React$useState2 = (0, $ed7fd75dceedabf1$var$_slicedToArray2["default"])(_React$useState, 2), spinning = _React$useState2[0], setSpinning = _React$useState2[1];
    $ed7fd75dceedabf1$var$React.useEffect(function() {
        var updateSpinning = (0, $ed7fd75dceedabf1$var$_debounce["default"])(function() {
            setSpinning(customSpinning);
        }, delay);
        updateSpinning();
        return function() {
            var _a;
            (_a = updateSpinning === null || updateSpinning === void 0 ? void 0 : updateSpinning.cancel) === null || _a === void 0 || _a.call(updateSpinning);
        };
    }, [
        delay,
        customSpinning
    ]);
    var isNestedPattern = function isNestedPattern() {
        return typeof children !== 'undefined';
    };
    var renderSpin = function renderSpin(_ref) {
        var direction = _ref.direction;
        var spinClassName = (0, $ed7fd75dceedabf1$var$_classnames["default"])(prefixCls, (0, $ed7fd75dceedabf1$var$_defineProperty2["default"])((0, $ed7fd75dceedabf1$var$_defineProperty2["default"])((0, $ed7fd75dceedabf1$var$_defineProperty2["default"])((0, $ed7fd75dceedabf1$var$_defineProperty2["default"])((0, $ed7fd75dceedabf1$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-spinning"), spinning), "".concat(prefixCls, "-show-text"), !!tip), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
        // fix https://fb.me/react-unknown-prop
        var divProps = (0, $ed7fd75dceedabf1$var$_omit["default"])(restProps, [
            'indicator',
            'prefixCls'
        ]);
        var spinElement = /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("div", (0, $ed7fd75dceedabf1$var$_extends2["default"])({}, divProps, {
            style: style,
            className: spinClassName,
            "aria-live": "polite",
            "aria-busy": spinning
        }), $ed7fd75dceedabf1$var$renderIndicator(prefixCls, props), tip ? /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("div", {
            className: "".concat(prefixCls, "-text")
        }, tip) : null);
        if (isNestedPattern()) {
            var containerClassName = (0, $ed7fd75dceedabf1$var$_classnames["default"])("".concat(prefixCls, "-container"), (0, $ed7fd75dceedabf1$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-blur"), spinning));
            return /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("div", (0, $ed7fd75dceedabf1$var$_extends2["default"])({}, divProps, {
                className: (0, $ed7fd75dceedabf1$var$_classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
            }), spinning && /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("div", {
                key: "loading"
            }, spinElement), /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement("div", {
                className: containerClassName,
                key: "container"
            }, children));
        }
        return spinElement;
    };
    return /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement($qBua1.ConfigConsumer, null, renderSpin);
};
var $ed7fd75dceedabf1$var$SpinFC = function SpinFC(props) {
    var customizePrefixCls = props.prefixCls;
    var _React$useContext = $ed7fd75dceedabf1$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
    var spinPrefixCls = getPrefixCls('spin', customizePrefixCls);
    var spinClassProps = (0, $ed7fd75dceedabf1$var$_extends2["default"])((0, $ed7fd75dceedabf1$var$_extends2["default"])({}, props), {
        spinPrefixCls: spinPrefixCls
    });
    return /*#__PURE__*/ $ed7fd75dceedabf1$var$React.createElement($ed7fd75dceedabf1$var$Spin, (0, $ed7fd75dceedabf1$var$_extends2["default"])({}, spinClassProps));
};
$ed7fd75dceedabf1$var$SpinFC.setDefaultIndicator = function(indicator) {
    $ed7fd75dceedabf1$var$defaultIndicator = indicator;
};
var $ed7fd75dceedabf1$var$_default = module.exports["default"] = $ed7fd75dceedabf1$var$SpinFC;

});
parcelRegister("8hTO8", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $608b337d249798e8$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneElement = $608b337d249798e8$var$cloneElement;
module.exports.isFragment = $608b337d249798e8$var$isFragment;
module.exports.isValidElement = void 0;
module.exports.replaceElement = $608b337d249798e8$var$replaceElement;

var $608b337d249798e8$var$React = $608b337d249798e8$var$_interopRequireWildcard((parcelRequire("acw62")));
var $608b337d249798e8$var$isValidElement = module.exports.isValidElement = $608b337d249798e8$var$React.isValidElement;
function $608b337d249798e8$var$isFragment(child) {
    return child && $608b337d249798e8$var$isValidElement(child) && child.type === $608b337d249798e8$var$React.Fragment;
}
function $608b337d249798e8$var$replaceElement(element, replacement, props) {
    if (!$608b337d249798e8$var$isValidElement(element)) return replacement;
    return /*#__PURE__*/ $608b337d249798e8$var$React.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
function $608b337d249798e8$var$cloneElement(element, props) {
    return $608b337d249798e8$var$replaceElement(element, element, props);
}

});


parcelRegister("eE7eL", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $aa9a6a3f3bf62e3e$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $aa9a6a3f3bf62e3e$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $aa9a6a3f3bf62e3e$var$scrollTo;

var $aa9a6a3f3bf62e3e$var$_raf = $aa9a6a3f3bf62e3e$var$_interopRequireDefault((parcelRequire("iSXDb")));

var $9oLmw = parcelRequire("9oLmw");

var $aa9a6a3f3bf62e3e$var$_getScroll = $aa9a6a3f3bf62e3e$var$_interopRequireWildcard((parcelRequire("83JNB")));
function $aa9a6a3f3bf62e3e$var$scrollTo(y) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$getContainer = options.getContainer, getContainer = _options$getContainer === void 0 ? function() {
        return window;
    } : _options$getContainer, callback = options.callback, _options$duration = options.duration, duration = _options$duration === void 0 ? 450 : _options$duration;
    var container = getContainer();
    var scrollTop = (0, $aa9a6a3f3bf62e3e$var$_getScroll["default"])(container, true);
    var startTime = Date.now();
    var frameFunc = function frameFunc() {
        var timestamp = Date.now();
        var time = timestamp - startTime;
        var nextScrollTop = (0, $9oLmw.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $aa9a6a3f3bf62e3e$var$_getScroll.isWindow)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === 'HTMLDocument') container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) (0, $aa9a6a3f3bf62e3e$var$_raf["default"])(frameFunc);
        else if (typeof callback === 'function') callback();
    };
    (0, $aa9a6a3f3bf62e3e$var$_raf["default"])(frameFunc);
}

});
parcelRegister("iSXDb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dbfb8698ee65cbf9$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $dbfb8698ee65cbf9$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $dbfb8698ee65cbf9$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $dbfb8698ee65cbf9$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $dbfb8698ee65cbf9$var$rafUUID = 0;
var $dbfb8698ee65cbf9$var$rafIds = new Map();
function $dbfb8698ee65cbf9$var$cleanup(id) {
    $dbfb8698ee65cbf9$var$rafIds.delete(id);
}
var $dbfb8698ee65cbf9$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $dbfb8698ee65cbf9$var$rafUUID += 1;
    var id = $dbfb8698ee65cbf9$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $dbfb8698ee65cbf9$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $dbfb8698ee65cbf9$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $dbfb8698ee65cbf9$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$dbfb8698ee65cbf9$var$wrapperRaf.cancel = function(id) {
    var realId = $dbfb8698ee65cbf9$var$rafIds.get(id);
    $dbfb8698ee65cbf9$var$cleanup(id);
    return $dbfb8698ee65cbf9$var$caf(realId);
};
var $dbfb8698ee65cbf9$var$_default = module.exports.default = $dbfb8698ee65cbf9$var$wrapperRaf;

});

parcelRegister("9oLmw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.easeInOutCubic = $6d7b181698ef7e5b$var$easeInOutCubic;
// eslint-disable-next-line import/prefer-default-export
function $6d7b181698ef7e5b$var$easeInOutCubic(t, b, c, d) {
    var cc = c - b;
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // eslint-disable-next-line no-return-assign
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}

});

parcelRegister("83JNB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5de2214926eb8105$var$getScroll;
module.exports.isWindow = $5de2214926eb8105$var$isWindow;
function $5de2214926eb8105$var$isWindow(obj) {
    return obj !== null && obj !== undefined && obj === obj.window;
}
function $5de2214926eb8105$var$getScroll(target, top) {
    var _a, _b;
    if (typeof window === 'undefined') return 0;
    var method = top ? 'scrollTop' : 'scrollLeft';
    var result = 0;
    if ($5de2214926eb8105$var$isWindow(target)) result = target[top ? 'pageYOffset' : 'pageXOffset'];
    else if (target instanceof Document) result = target.documentElement[method];
    else if (target instanceof HTMLElement) result = target[method];
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    result = target[method];
    if (target && !$5de2214926eb8105$var$isWindow(target) && typeof result !== 'number') result = (_b = ((_a = target.ownerDocument) !== null && _a !== void 0 ? _a : target).documentElement) === null || _b === void 0 ? void 0 : _b[method];
    return result;
}

});


parcelRegister("4SWGn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $38e9b9b093458717$var$Column(_) {
    return null;
}
var $38e9b9b093458717$var$_default = module.exports["default"] = $38e9b9b093458717$var$Column;

});

parcelRegister("75kfU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $5288b65cec8d0054$var$ColumnGroup(_) {
    return null;
}
var $5288b65cec8d0054$var$_default = module.exports["default"] = $5288b65cec8d0054$var$ColumnGroup;

});

parcelRegister("e0a4M", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a318e1ac047165f2$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a318e1ac047165f2$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a318e1ac047165f2$var$_defineProperty2 = $a318e1ac047165f2$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $a318e1ac047165f2$var$_classnames = $a318e1ac047165f2$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $a318e1ac047165f2$var$React = $a318e1ac047165f2$var$_interopRequireWildcard((parcelRequire("acw62")));
function $a318e1ac047165f2$var$renderExpandIcon(locale) {
    return function expandIcon(_ref) {
        var prefixCls = _ref.prefixCls, onExpand = _ref.onExpand, record = _ref.record, expanded = _ref.expanded, expandable = _ref.expandable;
        var iconPrefix = "".concat(prefixCls, "-row-expand-icon");
        return /*#__PURE__*/ $a318e1ac047165f2$var$React.createElement("button", {
            type: "button",
            onClick: function onClick(e) {
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, $a318e1ac047165f2$var$_classnames["default"])(iconPrefix, (0, $a318e1ac047165f2$var$_defineProperty2["default"])((0, $a318e1ac047165f2$var$_defineProperty2["default"])((0, $a318e1ac047165f2$var$_defineProperty2["default"])({}, "".concat(iconPrefix, "-spaced"), !expandable), "".concat(iconPrefix, "-expanded"), expandable && expanded), "".concat(iconPrefix, "-collapsed"), expandable && !expanded)),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $a318e1ac047165f2$var$_default = module.exports["default"] = $a318e1ac047165f2$var$renderExpandIcon;

});

parcelRegister("16R5D", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0cef8884efc79e9a$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0cef8884efc79e9a$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
module.exports.flattenKeys = $0cef8884efc79e9a$var$flattenKeys;
module.exports.getFilterData = $0cef8884efc79e9a$var$getFilterData;

var $0cef8884efc79e9a$var$_slicedToArray2 = $0cef8884efc79e9a$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $0cef8884efc79e9a$var$_extends2 = $0cef8884efc79e9a$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $0cef8884efc79e9a$var$_toConsumableArray2 = $0cef8884efc79e9a$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $0cef8884efc79e9a$var$React = $0cef8884efc79e9a$var$_interopRequireWildcard((parcelRequire("acw62")));

var $0cef8884efc79e9a$var$_warning = $0cef8884efc79e9a$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $ciy96 = parcelRequire("ciy96");

var $0cef8884efc79e9a$var$_FilterDropdown = $0cef8884efc79e9a$var$_interopRequireDefault((parcelRequire("ekMP6")));
function $0cef8884efc79e9a$var$collectFilterStates(columns, init, pos) {
    var filterStates = [];
    (columns || []).forEach(function(column, index) {
        var _a;
        var columnPos = (0, $ciy96.getColumnPos)(index, pos);
        if (column.filters || 'filterDropdown' in column || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                var filteredValues = column.filteredValue;
                if (!('filterDropdown' in column)) filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $ciy96.getColumnKey)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $ciy96.getColumnKey)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ('children' in column) filterStates = [].concat((0, $0cef8884efc79e9a$var$_toConsumableArray2["default"])(filterStates), (0, $0cef8884efc79e9a$var$_toConsumableArray2["default"])($0cef8884efc79e9a$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
}
function $0cef8884efc79e9a$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, triggerFilter, getPopupContainer, locale, pos) {
    return columns.map(function(column, index) {
        var columnPos = (0, $ciy96.getColumnPos)(index, pos);
        var _column$filterMultipl = column.filterMultiple, filterMultiple = _column$filterMultipl === void 0 ? true : _column$filterMultipl, filterMode = column.filterMode, filterSearch = column.filterSearch;
        var newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            var columnKey = (0, $ciy96.getColumnKey)(newColumn, columnPos);
            var filterState = filterStates.find(function(_ref) {
                var key = _ref.key;
                return columnKey === key;
            });
            newColumn = (0, $0cef8884efc79e9a$var$_extends2["default"])((0, $0cef8884efc79e9a$var$_extends2["default"])({}, newColumn), {
                title: function title(renderProps) {
                    return /*#__PURE__*/ $0cef8884efc79e9a$var$React.createElement($0cef8884efc79e9a$var$_FilterDropdown["default"], {
                        tablePrefixCls: prefixCls,
                        prefixCls: "".concat(prefixCls, "-filter"),
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer
                    }, (0, $ciy96.renderColumnTitle)(column.title, renderProps));
                }
            });
        }
        if ('children' in newColumn) newColumn = (0, $0cef8884efc79e9a$var$_extends2["default"])((0, $0cef8884efc79e9a$var$_extends2["default"])({}, newColumn), {
            children: $0cef8884efc79e9a$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, triggerFilter, getPopupContainer, locale, columnPos)
        });
        return newColumn;
    });
}
function $0cef8884efc79e9a$var$flattenKeys(filters) {
    var keys = [];
    (filters || []).forEach(function(_ref2) {
        var value = _ref2.value, children = _ref2.children;
        keys.push(value);
        if (children) keys = [].concat((0, $0cef8884efc79e9a$var$_toConsumableArray2["default"])(keys), (0, $0cef8884efc79e9a$var$_toConsumableArray2["default"])($0cef8884efc79e9a$var$flattenKeys(children)));
    });
    return keys;
}
function $0cef8884efc79e9a$var$generateFilterInfo(filterStates) {
    var currentFilters = {};
    filterStates.forEach(function(_ref3) {
        var key = _ref3.key, filteredKeys = _ref3.filteredKeys, column = _ref3.column;
        var keyAsString = key;
        var filters = column.filters, filterDropdown = column.filterDropdown;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            var keys = $0cef8884efc79e9a$var$flattenKeys(filters);
            currentFilters[keyAsString] = keys.filter(function(originKey) {
                return filteredKeys.includes(String(originKey));
            });
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
}
function $0cef8884efc79e9a$var$getFilterData(data, filterStates) {
    return filterStates.reduce(function(currentData, filterState) {
        var _filterState$column = filterState.column, onFilter = _filterState$column.onFilter, filters = _filterState$column.filters, filteredKeys = filterState.filteredKeys;
        if (onFilter && filteredKeys && filteredKeys.length) return currentData.filter(function(record) {
            return filteredKeys.some(function(key) {
                var keys = $0cef8884efc79e9a$var$flattenKeys(filters);
                var keyIndex = keys.findIndex(function(k) {
                    return String(k) === String(key);
                });
                var realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                return onFilter(realKey, record);
            });
        });
        return currentData;
    }, data);
}
function $0cef8884efc79e9a$var$useFilter(_ref4) {
    var prefixCls = _ref4.prefixCls, dropdownPrefixCls = _ref4.dropdownPrefixCls, mergedColumns = _ref4.mergedColumns, onFilterChange = _ref4.onFilterChange, getPopupContainer = _ref4.getPopupContainer, tableLocale = _ref4.locale;
    var _React$useState = $0cef8884efc79e9a$var$React.useState(function() {
        return $0cef8884efc79e9a$var$collectFilterStates(mergedColumns, true);
    }), _React$useState2 = (0, $0cef8884efc79e9a$var$_slicedToArray2["default"])(_React$useState, 2), filterStates = _React$useState2[0], setFilterStates = _React$useState2[1];
    var mergedFilterStates = $0cef8884efc79e9a$var$React.useMemo(function() {
        var collectedStates = $0cef8884efc79e9a$var$collectFilterStates(mergedColumns, false);
        var filteredKeysIsAllNotControlled = true;
        var filteredKeysIsAllControlled = true;
        collectedStates.forEach(function(_ref5) {
            var filteredKeys = _ref5.filteredKeys;
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) return filterStates;
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    var filters = $0cef8884efc79e9a$var$React.useMemo(function() {
        return $0cef8884efc79e9a$var$generateFilterInfo(mergedFilterStates);
    }, [
        mergedFilterStates
    ]);
    var triggerFilter = function triggerFilter(filterState) {
        var newFilterStates = mergedFilterStates.filter(function(_ref6) {
            var key = _ref6.key;
            return key !== filterState.key;
        });
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($0cef8884efc79e9a$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    var transformColumns = function transformColumns(innerColumns) {
        return $0cef8884efc79e9a$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, triggerFilter, getPopupContainer, tableLocale);
    };
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
}
var $0cef8884efc79e9a$var$_default = module.exports["default"] = $0cef8884efc79e9a$var$useFilter;

});
parcelRegister("ciy96", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getColumnKey = $8f41a71b0b0ceafa$var$getColumnKey;
module.exports.getColumnPos = $8f41a71b0b0ceafa$var$getColumnPos;
module.exports.renderColumnTitle = $8f41a71b0b0ceafa$var$renderColumnTitle;
module.exports.safeColumnTitle = $8f41a71b0b0ceafa$var$safeColumnTitle;
function $8f41a71b0b0ceafa$var$getColumnKey(column, defaultKey) {
    if ('key' in column && column.key !== undefined && column.key !== null) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
    return defaultKey;
}
function $8f41a71b0b0ceafa$var$getColumnPos(index, pos) {
    return pos ? "".concat(pos, "-").concat(index) : "".concat(index);
}
function $8f41a71b0b0ceafa$var$renderColumnTitle(title, props) {
    if (typeof title === 'function') return title(props);
    return title;
}
/**
 * Safe get column title
 *
 * Should filter [object Object]
 *
 * @param title
 * @returns
 */ function $8f41a71b0b0ceafa$var$safeColumnTitle(title, props) {
    var res = $8f41a71b0b0ceafa$var$renderColumnTitle(title, props);
    if (Object.prototype.toString.call(res) === '[object Object]') return '';
    return res;
}

});

parcelRegister("ekMP6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a6f8ce39536b6615$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a6f8ce39536b6615$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a6f8ce39536b6615$var$_extends2 = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $a6f8ce39536b6615$var$_defineProperty2 = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $a6f8ce39536b6615$var$_slicedToArray2 = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $a6f8ce39536b6615$var$_FilterFilled = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("jma92")));

var $a6f8ce39536b6615$var$_classnames = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $a6f8ce39536b6615$var$_isEqual = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("4UXHD")));

var $a6f8ce39536b6615$var$React = $a6f8ce39536b6615$var$_interopRequireWildcard((parcelRequire("acw62")));

var $16R5D = parcelRequire("16R5D");

var $a6f8ce39536b6615$var$_button = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("efUnK")));

var $a6f8ce39536b6615$var$_checkbox = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("kycNO")));

var $kGKTK = parcelRequire("kGKTK");

var $a6f8ce39536b6615$var$_dropdown = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("lVObl")));

var $a6f8ce39536b6615$var$_empty = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("dJr7p")));

var $a6f8ce39536b6615$var$_menu = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("lI0Ie")));

var $jYLoz = parcelRequire("jYLoz");

var $a6f8ce39536b6615$var$_radio = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("9wjAb")));

var $a6f8ce39536b6615$var$_tree = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("hgdOL")));

var $a6f8ce39536b6615$var$_useSyncState3 = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("avewK")));

var $a6f8ce39536b6615$var$_FilterSearch = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("gWOpQ")));

var $a6f8ce39536b6615$var$_FilterWrapper = $a6f8ce39536b6615$var$_interopRequireDefault((parcelRequire("dpKMn")));
function $a6f8ce39536b6615$var$hasSubMenu(filters) {
    return filters.some(function(_ref) {
        var children = _ref.children;
        return children;
    });
}
function $a6f8ce39536b6615$var$searchValueMatched(searchValue, text) {
    if (typeof text === 'string' || typeof text === 'number') return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    return false;
}
function $a6f8ce39536b6615$var$renderFilterItems(_ref2) {
    var filters = _ref2.filters, prefixCls = _ref2.prefixCls, filteredKeys = _ref2.filteredKeys, filterMultiple = _ref2.filterMultiple, searchValue = _ref2.searchValue, filterSearch = _ref2.filterSearch;
    return filters.map(function(filter, index) {
        var key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: "".concat(prefixCls, "-dropdown-submenu"),
            children: $a6f8ce39536b6615$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                filterSearch: filterSearch
            })
        };
        var Component = filterMultiple ? $a6f8ce39536b6615$var$_checkbox["default"] : $a6f8ce39536b6615$var$_radio["default"];
        var item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$React.Fragment, null, /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement("span", null, filter.text))
        };
        if (searchValue.trim()) {
            if (typeof filterSearch === 'function') return filterSearch(searchValue, filter) ? item : null;
            return $a6f8ce39536b6615$var$searchValueMatched(searchValue, filter.text) ? item : null;
        }
        return item;
    });
}
function $a6f8ce39536b6615$var$wrapStringListType(keys) {
    return keys || [];
}
function $a6f8ce39536b6615$var$FilterDropdown(props) {
    var _a;
    var tablePrefixCls = props.tablePrefixCls, prefixCls = props.prefixCls, column = props.column, dropdownPrefixCls = props.dropdownPrefixCls, columnKey = props.columnKey, filterMultiple = props.filterMultiple, _props$filterMode = props.filterMode, filterMode = _props$filterMode === void 0 ? 'menu' : _props$filterMode, _props$filterSearch = props.filterSearch, filterSearch = _props$filterSearch === void 0 ? false : _props$filterSearch, filterState = props.filterState, triggerFilter = props.triggerFilter, locale = props.locale, children = props.children, getPopupContainer = props.getPopupContainer;
    var filterDropdownOpen = column.filterDropdownOpen, onFilterDropdownOpenChange = column.onFilterDropdownOpenChange, filterDropdownVisible = column.filterDropdownVisible, onFilterDropdownVisibleChange = column.onFilterDropdownVisibleChange, filterResetToDefaultFilteredValue = column.filterResetToDefaultFilteredValue, defaultFilteredValue = column.defaultFilteredValue;
    var _React$useState = $a6f8ce39536b6615$var$React.useState(false), _React$useState2 = (0, $a6f8ce39536b6615$var$_slicedToArray2["default"])(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    var filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
    var triggerVisible = function triggerVisible(newVisible) {
        setVisible(newVisible);
        onFilterDropdownOpenChange === null || onFilterDropdownOpenChange === void 0 || onFilterDropdownOpenChange(newVisible);
        onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 || onFilterDropdownVisibleChange(newVisible);
    };
    var mergedVisible;
    if (typeof filterDropdownOpen === 'boolean') mergedVisible = filterDropdownOpen;
    else mergedVisible = typeof filterDropdownVisible === 'boolean' ? filterDropdownVisible : visible;
    // ===================== Select Keys =====================
    var propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
    var _useSyncState = (0, $a6f8ce39536b6615$var$_useSyncState3["default"])($a6f8ce39536b6615$var$wrapStringListType(propFilteredKeys)), _useSyncState2 = (0, $a6f8ce39536b6615$var$_slicedToArray2["default"])(_useSyncState, 2), getFilteredKeysSync = _useSyncState2[0], setFilteredKeysSync = _useSyncState2[1];
    var onSelectKeys = function onSelectKeys(_ref3) {
        var selectedKeys = _ref3.selectedKeys;
        setFilteredKeysSync(selectedKeys);
    };
    var onCheck = function onCheck(keys, _ref4) {
        var node = _ref4.node, checked = _ref4.checked;
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $a6f8ce39536b6615$var$React.useEffect(function() {
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $a6f8ce39536b6615$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    var _React$useState3 = $a6f8ce39536b6615$var$React.useState([]), _React$useState4 = (0, $a6f8ce39536b6615$var$_slicedToArray2["default"])(_React$useState3, 2), openKeys = _React$useState4[0], setOpenKeys = _React$useState4[1];
    var onOpenChange = function onOpenChange(keys) {
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    var _React$useState5 = $a6f8ce39536b6615$var$React.useState(''), _React$useState6 = (0, $a6f8ce39536b6615$var$_slicedToArray2["default"])(_React$useState5, 2), searchValue = _React$useState6[0], setSearchValue = _React$useState6[1];
    var onSearch = function onSearch(e) {
        var value = e.target.value;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $a6f8ce39536b6615$var$React.useEffect(function() {
        if (!visible) setSearchValue('');
    }, [
        visible
    ]);
    // ======================= Submit ========================
    var internalTriggerFilter = function internalTriggerFilter(keys) {
        var mergedKeys = keys && keys.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, $a6f8ce39536b6615$var$_isEqual["default"])(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    var onConfirm = function onConfirm() {
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onReset = function onReset() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            confirm: false,
            closeDropdown: false
        }, confirm = _ref5.confirm, closeDropdown = _ref5.closeDropdown;
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue('');
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map(function(key) {
            return String(key);
        }));
        else setFilteredKeysSync([]);
    };
    var doFilter = function doFilter() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            closeDropdown: true
        }, closeDropdown = _ref6.closeDropdown;
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onVisibleChange = function onVisibleChange(newVisible) {
        if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefiend)
        setFilteredKeysSync($a6f8ce39536b6615$var$wrapStringListType(propFilteredKeys));
        triggerVisible(newVisible);
        // Default will filter when closed
        if (!newVisible && !column.filterDropdown) onConfirm();
    };
    // ======================== Style ========================
    var dropdownMenuClass = (0, $a6f8ce39536b6615$var$_classnames["default"])((0, $a6f8ce39536b6615$var$_defineProperty2["default"])({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !$a6f8ce39536b6615$var$hasSubMenu(column.filters || [])));
    var onCheckAll = function onCheckAll(e) {
        if (e.target.checked) {
            var allFilterKeys = (0, $16R5D.flattenKeys)(column === null || column === void 0 ? void 0 : column.filters).map(function(key) {
                return String(key);
            });
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    var getTreeData = function getTreeData(_ref7) {
        var filters = _ref7.filters;
        return (filters || []).map(function(filter, index) {
            var key = String(filter.value);
            var item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    };
    var getFilterData = function getFilterData(node) {
        var _a;
        return (0, $a6f8ce39536b6615$var$_extends2["default"])((0, $a6f8ce39536b6615$var$_extends2["default"])({}, node), {
            text: node.title,
            value: node.key,
            children: ((_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function(item) {
                return getFilterData(item);
            })) || []
        });
    };
    var dropdownContent;
    if (typeof column.filterDropdown === 'function') dropdownContent = column.filterDropdown({
        prefixCls: "".concat(dropdownPrefixCls, "-custom"),
        setSelectedKeys: function setSelectedKeys(selectedKeys) {
            return onSelectKeys({
                selectedKeys: selectedKeys
            });
        },
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: function close() {
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        var selectedKeys = getFilteredKeysSync() || [];
        var getFilterComponent = function getFilterComponent() {
            if ((column.filters || []).length === 0) return /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_empty["default"], {
                image: $a6f8ce39536b6615$var$_empty["default"].PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                imageStyle: {
                    height: 24
                },
                style: {
                    margin: 0,
                    padding: '16px 0'
                }
            });
            if (filterMode === 'tree') return /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$React.Fragment, null, /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_FilterSearch["default"], {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement("div", {
                className: "".concat(tablePrefixCls, "-filter-dropdown-tree")
            }, filterMultiple ? /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_checkbox["default"], {
                checked: selectedKeys.length === (0, $16R5D.flattenKeys)(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < (0, $16R5D.flattenKeys)(column.filters).length,
                className: "".concat(tablePrefixCls, "-filter-dropdown-checkall"),
                onChange: onCheckAll
            }, locale.filterCheckall) : null, /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_tree["default"], {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: "".concat(dropdownPrefixCls, "-menu"),
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: searchValue.trim() ? function(node) {
                    if (typeof filterSearch === 'function') return filterSearch(searchValue, getFilterData(node));
                    return $a6f8ce39536b6615$var$searchValueMatched(searchValue, node.title);
                } : undefined
            })));
            return /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$React.Fragment, null, /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_FilterSearch["default"], {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_menu["default"], {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: "".concat(dropdownPrefixCls, "-menu"),
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: $a6f8ce39536b6615$var$renderFilterItems({
                    filters: column.filters || [],
                    filterSearch: filterSearch,
                    prefixCls: prefixCls,
                    filteredKeys: getFilteredKeysSync(),
                    filterMultiple: filterMultiple,
                    searchValue: searchValue
                })
            }));
        };
        var getResetDisabled = function getResetDisabled() {
            if (filterResetToDefaultFilteredValue) return (0, $a6f8ce39536b6615$var$_isEqual["default"])((defaultFilteredValue || []).map(function(key) {
                return String(key);
            }), selectedKeys);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$React.Fragment, null, getFilterComponent(), /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement("div", {
            className: "".concat(prefixCls, "-dropdown-btns")
        }, /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_button["default"], {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: function onClick() {
                return onReset();
            }
        }, locale.filterReset), /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_button["default"], {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($jYLoz.OverrideProvider, {
        selectable: undefined
    }, dropdownContent);
    var menu = function menu() {
        return /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_FilterWrapper["default"], {
            className: "".concat(prefixCls, "-dropdown")
        }, dropdownContent);
    };
    var filterIcon;
    if (typeof column.filterIcon === 'function') filterIcon = column.filterIcon(filtered);
    else if (column.filterIcon) filterIcon = column.filterIcon;
    else filterIcon = /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_FilterFilled["default"], null);
    var _React$useContext = $a6f8ce39536b6615$var$React.useContext($kGKTK.ConfigContext), direction = _React$useContext.direction;
    return /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement("div", {
        className: "".concat(prefixCls, "-column")
    }, /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement("span", {
        className: "".concat(tablePrefixCls, "-column-title")
    }, children), /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement($a6f8ce39536b6615$var$_dropdown["default"], {
        dropdownRender: menu,
        trigger: [
            'click'
        ],
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        getPopupContainer: getPopupContainer,
        placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight'
    }, /*#__PURE__*/ $a6f8ce39536b6615$var$React.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: (0, $a6f8ce39536b6615$var$_classnames["default"])("".concat(prefixCls, "-trigger"), {
            active: filtered
        }),
        onClick: function onClick(e) {
            e.stopPropagation();
        }
    }, filterIcon)));
}
var $a6f8ce39536b6615$var$_default = module.exports["default"] = $a6f8ce39536b6615$var$FilterDropdown;

});
parcelRegister("jma92", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e177f0f05b900657$var$_FilterFilled = $e177f0f05b900657$var$_interopRequireDefault((parcelRequire("72Wqj")));
function $e177f0f05b900657$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $e177f0f05b900657$var$_default = $e177f0f05b900657$var$_FilterFilled;
module.exports.default = $e177f0f05b900657$var$_default;
module.exports = $e177f0f05b900657$var$_default;

});
parcelRegister("72Wqj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $521609fd3b721dea$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $521609fd3b721dea$var$React = $521609fd3b721dea$var$_interopRequireWildcard((parcelRequire("acw62")));

var $521609fd3b721dea$var$_FilterFilled = $1jnue((parcelRequire("3DplS")));

var $521609fd3b721dea$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $521609fd3b721dea$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($521609fd3b721dea$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $521609fd3b721dea$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $521609fd3b721dea$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $521609fd3b721dea$var$FilterFilled = function FilterFilled(props, ref) {
    return /*#__PURE__*/ $521609fd3b721dea$var$React.createElement($521609fd3b721dea$var$_AntdIcon.default, (0, $521609fd3b721dea$var$_objectSpread2.default)((0, $521609fd3b721dea$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $521609fd3b721dea$var$_FilterFilled.default
    }));
};
var $521609fd3b721dea$var$RefIcon = /*#__PURE__*/ $521609fd3b721dea$var$React.forwardRef($521609fd3b721dea$var$FilterFilled);
var $521609fd3b721dea$var$_default = module.exports.default = $521609fd3b721dea$var$RefIcon;

});
parcelRegister("3DplS", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2a58adf0bd911790$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
module.exports.default = $2a58adf0bd911790$var$FilterFilled;

});



parcelRegister("efUnK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a60e33ae6255ba89$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a60e33ae6255ba89$var$_button = $a60e33ae6255ba89$var$_interopRequireDefault((parcelRequire("lUEbW")));
var $a60e33ae6255ba89$var$_default = module.exports["default"] = $a60e33ae6255ba89$var$_button["default"];

});
parcelRegister("lUEbW", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ff3e0126ef42a7cf$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ff3e0126ef42a7cf$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertLegacyProps = $ff3e0126ef42a7cf$var$convertLegacyProps;
module.exports["default"] = void 0;

var $ff3e0126ef42a7cf$var$_extends2 = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $ff3e0126ef42a7cf$var$_defineProperty2 = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $ff3e0126ef42a7cf$var$_slicedToArray2 = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $ff3e0126ef42a7cf$var$_typeof2 = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("41YNz")));

var $ff3e0126ef42a7cf$var$_classnames = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $ff3e0126ef42a7cf$var$_omit = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $ff3e0126ef42a7cf$var$React = $ff3e0126ef42a7cf$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $ff3e0126ef42a7cf$var$_DisabledContext = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("bzUGe")));

var $ff3e0126ef42a7cf$var$_SizeContext = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("lGUuX")));

var $hvVUy = parcelRequire("hvVUy");

var $8hTO8 = parcelRequire("8hTO8");

var $3YGhB = parcelRequire("3YGhB");

var $ff3e0126ef42a7cf$var$_warning = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $ff3e0126ef42a7cf$var$_wave = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("mRFzC")));

var $ff3e0126ef42a7cf$var$_buttonGroup = $ff3e0126ef42a7cf$var$_interopRequireWildcard((parcelRequire("ePUJz")));

var $ff3e0126ef42a7cf$var$_LoadingIcon = $ff3e0126ef42a7cf$var$_interopRequireDefault((parcelRequire("8z6y5")));
var $ff3e0126ef42a7cf$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/* eslint-disable react/button-has-type */ var $ff3e0126ef42a7cf$var$rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var $ff3e0126ef42a7cf$var$isTwoCNChar = $ff3e0126ef42a7cf$var$rxTwoCNChar.test.bind($ff3e0126ef42a7cf$var$rxTwoCNChar);
function $ff3e0126ef42a7cf$var$isString(str) {
    return typeof str === 'string';
}
function $ff3e0126ef42a7cf$var$isUnBorderedButtonType(type) {
    return type === 'text' || type === 'link';
}
// Insert one space between two chinese characters automatically.
function $ff3e0126ef42a7cf$var$insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child === null || child === undefined) return;
    var SPACE = needInserted ? ' ' : '';
    // strictNullChecks oops.
    if (typeof child !== 'string' && typeof child !== 'number' && $ff3e0126ef42a7cf$var$isString(child.type) && $ff3e0126ef42a7cf$var$isTwoCNChar(child.props.children)) return (0, $8hTO8.cloneElement)(child, {
        children: child.props.children.split('').join(SPACE)
    });
    if (typeof child === 'string') return $ff3e0126ef42a7cf$var$isTwoCNChar(child) ? /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createElement("span", null, child);
    if ((0, $8hTO8.isFragment)(child)) return /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createElement("span", null, child);
    return child;
}
function $ff3e0126ef42a7cf$var$spaceChildren(children, needInserted) {
    var isPrevChildPure = false;
    var childList = [];
    $ff3e0126ef42a7cf$var$React.Children.forEach(children, function(child) {
        var type = (0, $ff3e0126ef42a7cf$var$_typeof2["default"])(child);
        var isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            var lastIndex = childList.length - 1;
            var lastChild = childList[lastIndex];
            childList[lastIndex] = "".concat(lastChild).concat(child);
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    // Pass to React.Children.map to auto fill key
    return $ff3e0126ef42a7cf$var$React.Children.map(childList, function(child) {
        return $ff3e0126ef42a7cf$var$insertSpace(child, needInserted);
    });
}
var $ff3e0126ef42a7cf$var$ButtonTypes = (0, $3YGhB.tuple)('default', 'primary', 'ghost', 'dashed', 'link', 'text');
var $ff3e0126ef42a7cf$var$ButtonShapes = (0, $3YGhB.tuple)('default', 'circle', 'round');
var $ff3e0126ef42a7cf$var$ButtonHTMLTypes = (0, $3YGhB.tuple)('submit', 'button', 'reset');
function $ff3e0126ef42a7cf$var$convertLegacyProps(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
var $ff3e0126ef42a7cf$var$InternalButton = function InternalButton(props, ref) {
    var _classNames;
    var _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? 'default' : _props$type, danger = props.danger, _props$shape = props.shape, shape = _props$shape === void 0 ? 'default' : _props$shape, customizeSize = props.size, customDisabled = props.disabled, className = props.className, children = props.children, icon = props.icon, _props$ghost = props.ghost, ghost = _props$ghost === void 0 ? false : _props$ghost, _props$block = props.block, block = _props$block === void 0 ? false : _props$block, _props$htmlType = props.htmlType, htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType, rest = $ff3e0126ef42a7cf$var$__rest(props, [
        "loading",
        "prefixCls",
        "type",
        "danger",
        "shape",
        "size",
        "disabled",
        "className",
        "children",
        "icon",
        "ghost",
        "block",
        "htmlType"
    ]);
    var size = $ff3e0126ef42a7cf$var$React.useContext($ff3e0126ef42a7cf$var$_SizeContext["default"]);
    // ===================== Disabled =====================
    var disabled = $ff3e0126ef42a7cf$var$React.useContext($ff3e0126ef42a7cf$var$_DisabledContext["default"]);
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var groupSize = $ff3e0126ef42a7cf$var$React.useContext($ff3e0126ef42a7cf$var$_buttonGroup.GroupSizeContext);
    var _React$useState = $ff3e0126ef42a7cf$var$React.useState(!!loading), _React$useState2 = (0, $ff3e0126ef42a7cf$var$_slicedToArray2["default"])(_React$useState, 2), innerLoading = _React$useState2[0], setLoading = _React$useState2[1];
    var _React$useState3 = $ff3e0126ef42a7cf$var$React.useState(false), _React$useState4 = (0, $ff3e0126ef42a7cf$var$_slicedToArray2["default"])(_React$useState3, 2), hasTwoCNChar = _React$useState4[0], setHasTwoCNChar = _React$useState4[1];
    var _React$useContext = $ff3e0126ef42a7cf$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, autoInsertSpaceInButton = _React$useContext.autoInsertSpaceInButton, direction = _React$useContext.direction;
    var buttonRef = ref || /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createRef();
    var isNeedInserted = function isNeedInserted() {
        return $ff3e0126ef42a7cf$var$React.Children.count(children) === 1 && !icon && !$ff3e0126ef42a7cf$var$isUnBorderedButtonType(type);
    };
    var fixTwoCNChar = function fixTwoCNChar() {
        // Fix for HOC usage like <FormatMessage />
        if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) return;
        var buttonText = buttonRef.current.textContent;
        if (isNeedInserted() && $ff3e0126ef42a7cf$var$isTwoCNChar(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    };
    // =============== Update Loading ===============
    var loadingOrDelay = typeof loading === 'boolean' ? loading : (loading === null || loading === void 0 ? void 0 : loading.delay) || true;
    $ff3e0126ef42a7cf$var$React.useEffect(function() {
        var delayTimer = null;
        if (typeof loadingOrDelay === 'number') delayTimer = window.setTimeout(function() {
            delayTimer = null;
            setLoading(loadingOrDelay);
        }, loadingOrDelay);
        else setLoading(loadingOrDelay);
        return function() {
            if (delayTimer) {
                // in order to not perform a React state update on an unmounted component
                // and clear timer after 'loadingOrDelay' updated.
                window.clearTimeout(delayTimer);
                delayTimer = null;
            }
        };
    }, [
        loadingOrDelay
    ]);
    $ff3e0126ef42a7cf$var$React.useEffect(fixTwoCNChar, [
        buttonRef
    ]);
    var handleClick = function handleClick(e) {
        var onClick = props.onClick;
        // https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    var prefixCls = getPrefixCls('btn', customizePrefixCls);
    var autoInsertSpace = autoInsertSpaceInButton !== false;
    var _useCompactItemContex = (0, $hvVUy.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    var sizeFullname = compactSize || groupSize || customizeSize || size;
    var sizeCls = sizeFullname ? sizeClassNameMap[sizeFullname] || '' : '';
    var iconType = innerLoading ? 'loading' : icon;
    var linkButtonRestProps = (0, $ff3e0126ef42a7cf$var$_omit["default"])(rest, [
        'navigate'
    ]);
    var classes = (0, $ff3e0126ef42a7cf$var$_classnames["default"])(prefixCls, (_classNames = {}, (0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])((0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(shape), shape !== 'default' && shape), "".concat(prefixCls, "-").concat(type), type), "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-icon-only"), !children && children !== 0 && !!iconType), "".concat(prefixCls, "-background-ghost"), ghost && !$ff3e0126ef42a7cf$var$isUnBorderedButtonType(type)), "".concat(prefixCls, "-loading"), innerLoading), "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace && !innerLoading), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-dangerous"), !!danger), "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, $ff3e0126ef42a7cf$var$_defineProperty2["default"])(_classNames, "".concat(prefixCls, "-disabled"), linkButtonRestProps.href !== undefined && mergedDisabled)), compactItemClassnames, className);
    var iconNode = icon && !innerLoading ? icon : /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createElement($ff3e0126ef42a7cf$var$_LoadingIcon["default"], {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: !!innerLoading
    });
    var kids = children || children === 0 ? $ff3e0126ef42a7cf$var$spaceChildren(children, isNeedInserted() && autoInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createElement("a", (0, $ff3e0126ef42a7cf$var$_extends2["default"])({}, linkButtonRestProps, {
        className: classes,
        onClick: handleClick,
        ref: buttonRef
    }), iconNode, kids);
    var buttonNode = /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createElement("button", (0, $ff3e0126ef42a7cf$var$_extends2["default"])({}, rest, {
        type: htmlType,
        className: classes,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: buttonRef
    }), iconNode, kids);
    if ($ff3e0126ef42a7cf$var$isUnBorderedButtonType(type)) return buttonNode;
    return /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.createElement($ff3e0126ef42a7cf$var$_wave["default"], {
        disabled: !!innerLoading
    }, buttonNode);
};
var $ff3e0126ef42a7cf$var$Button = /*#__PURE__*/ $ff3e0126ef42a7cf$var$React.forwardRef($ff3e0126ef42a7cf$var$InternalButton);
$ff3e0126ef42a7cf$var$Button.Group = $ff3e0126ef42a7cf$var$_buttonGroup["default"];
$ff3e0126ef42a7cf$var$Button.__ANT_BUTTON = true;
var $ff3e0126ef42a7cf$var$_default = module.exports["default"] = $ff3e0126ef42a7cf$var$Button;

});
parcelRegister("mRFzC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $044bafd75d0fd095$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $044bafd75d0fd095$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $044bafd75d0fd095$var$_classCallCheck2 = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("fu0YK")));

var $044bafd75d0fd095$var$_createClass2 = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("lR7jo")));

var $044bafd75d0fd095$var$_possibleConstructorReturn2 = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("eN9hz")));

var $044bafd75d0fd095$var$_isNativeReflectConstruct2 = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("5HCVq")));

var $044bafd75d0fd095$var$_getPrototypeOf2 = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("cGTaw")));

var $044bafd75d0fd095$var$_assertThisInitialized2 = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $044bafd75d0fd095$var$_inherits2 = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("f8wIT")));

var $1Sv8Y = parcelRequire("1Sv8Y");

var $1XVSR = parcelRequire("1XVSR");

var $044bafd75d0fd095$var$React = $044bafd75d0fd095$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $044bafd75d0fd095$var$_raf = $044bafd75d0fd095$var$_interopRequireDefault((parcelRequire("7OknB")));

var $8hTO8 = parcelRequire("8hTO8");
function $044bafd75d0fd095$var$_callSuper(t, o, e) {
    return o = (0, $044bafd75d0fd095$var$_getPrototypeOf2["default"])(o), (0, $044bafd75d0fd095$var$_possibleConstructorReturn2["default"])(t, (0, $044bafd75d0fd095$var$_isNativeReflectConstruct2["default"])() ? Reflect.construct(o, e || [], (0, $044bafd75d0fd095$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
var $044bafd75d0fd095$var$styleForPseudo;
// Where el is the DOM element you'd like to test for visibility
function $044bafd75d0fd095$var$isHidden(element) {
    return !element || element.offsetParent === null || element.hidden;
}
function $044bafd75d0fd095$var$getValidateContainer(nodeRoot) {
    if (nodeRoot instanceof Document) return nodeRoot.body;
    return Array.from(nodeRoot.childNodes).find(function(ele) {
        return (ele === null || ele === void 0 ? void 0 : ele.nodeType) === Node.ELEMENT_NODE;
    });
}
function $044bafd75d0fd095$var$isNotGrey(color) {
    // eslint-disable-next-line no-useless-escape
    var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
    if (match && match[1] && match[2] && match[3]) return !(match[1] === match[2] && match[2] === match[3]);
    return true;
}
var $044bafd75d0fd095$var$Wave = /*#__PURE__*/ function(_React$Component) {
    (0, $044bafd75d0fd095$var$_inherits2["default"])(Wave, _React$Component);
    function Wave() {
        var _this;
        (0, $044bafd75d0fd095$var$_classCallCheck2["default"])(this, Wave);
        _this = $044bafd75d0fd095$var$_callSuper(this, Wave, arguments);
        _this.containerRef = /*#__PURE__*/ $044bafd75d0fd095$var$React.createRef();
        _this.animationStart = false;
        _this.destroyed = false;
        _this.onClick = function(node, waveColor) {
            var _a, _b;
            var _this$props = _this.props, insertExtraNode = _this$props.insertExtraNode, disabled = _this$props.disabled;
            if (disabled || !node || $044bafd75d0fd095$var$isHidden(node) || node.className.includes('-leave')) return;
            _this.extraNode = document.createElement('div');
            var _assertThisInitialize = (0, $044bafd75d0fd095$var$_assertThisInitialized2["default"])(_this), extraNode = _assertThisInitialize.extraNode;
            var getPrefixCls = _this.context.getPrefixCls;
            extraNode.className = "".concat(getPrefixCls(''), "-click-animating-node");
            var attributeName = _this.getAttributeName();
            node.setAttribute(attributeName, 'true');
            // Not white or transparent or grey
            if (waveColor && waveColor !== '#fff' && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && waveColor !== 'rgba(255, 255, 255, 1)' && $044bafd75d0fd095$var$isNotGrey(waveColor) && !/rgba\((?:\d*, ){3}0\)/.test(waveColor) && // any transparent rgba color
            waveColor !== 'transparent') {
                extraNode.style.borderColor = waveColor;
                var nodeRoot = ((_a = node.getRootNode) === null || _a === void 0 ? void 0 : _a.call(node)) || node.ownerDocument;
                var nodeBody = (_b = $044bafd75d0fd095$var$getValidateContainer(nodeRoot)) !== null && _b !== void 0 ? _b : nodeRoot;
                $044bafd75d0fd095$var$styleForPseudo = (0, $1Sv8Y.updateCSS)("\n      [".concat(getPrefixCls(''), "-click-animating-without-extra-node='true']::after, .").concat(getPrefixCls(''), "-click-animating-node {\n        --antd-wave-shadow-color: ").concat(waveColor, ";\n      }"), 'antd-wave', {
                    csp: _this.csp,
                    attachTo: nodeBody
                });
            }
            if (insertExtraNode) node.appendChild(extraNode);
            [
                'transition',
                'animation'
            ].forEach(function(name) {
                node.addEventListener("".concat(name, "start"), _this.onTransitionStart);
                node.addEventListener("".concat(name, "end"), _this.onTransitionEnd);
            });
        };
        _this.onTransitionStart = function(e) {
            if (_this.destroyed) return;
            var node = _this.containerRef.current;
            if (!e || e.target !== node || _this.animationStart) return;
            _this.resetEffect(node);
        };
        _this.onTransitionEnd = function(e) {
            if (!e || e.animationName !== 'fadeEffect') return;
            _this.resetEffect(e.target);
        };
        _this.bindAnimationEvent = function(node) {
            if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.includes('disabled')) return;
            var onClick = function onClick(e) {
                // Fix radio button click twice
                if (e.target.tagName === 'INPUT' || $044bafd75d0fd095$var$isHidden(e.target)) return;
                _this.resetEffect(node);
                // Get wave color from target
                var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
                getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
                _this.clickWaveTimeoutId = window.setTimeout(function() {
                    return _this.onClick(node, waveColor);
                }, 0);
                $044bafd75d0fd095$var$_raf["default"].cancel(_this.animationStartId);
                _this.animationStart = true;
                // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
                _this.animationStartId = (0, $044bafd75d0fd095$var$_raf["default"])(function() {
                    _this.animationStart = false;
                }, 10);
            };
            node.addEventListener('click', onClick, true);
            return {
                cancel: function cancel() {
                    node.removeEventListener('click', onClick, true);
                }
            };
        };
        _this.renderWave = function(_ref) {
            var csp = _ref.csp;
            var children = _this.props.children;
            _this.csp = csp;
            if (!/*#__PURE__*/ $044bafd75d0fd095$var$React.isValidElement(children)) return children;
            var ref = _this.containerRef;
            if ((0, $1XVSR.supportRef)(children)) ref = (0, $1XVSR.composeRef)(children.ref, _this.containerRef);
            return (0, $8hTO8.cloneElement)(children, {
                ref: ref
            });
        };
        return _this;
    }
    (0, $044bafd75d0fd095$var$_createClass2["default"])(Wave, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                var node = this.containerRef.current;
                if (!node || node.nodeType !== 1) return;
                this.instance = this.bindAnimationEvent(node);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.instance) this.instance.cancel();
                if (this.clickWaveTimeoutId) clearTimeout(this.clickWaveTimeoutId);
                this.destroyed = true;
            }
        },
        {
            key: "getAttributeName",
            value: function getAttributeName() {
                var getPrefixCls = this.context.getPrefixCls;
                var insertExtraNode = this.props.insertExtraNode;
                return insertExtraNode ? "".concat(getPrefixCls(''), "-click-animating") : "".concat(getPrefixCls(''), "-click-animating-without-extra-node");
            }
        },
        {
            key: "resetEffect",
            value: function resetEffect(node) {
                var _this2 = this;
                if (!node || node === this.extraNode || !(node instanceof Element)) return;
                var insertExtraNode = this.props.insertExtraNode;
                var attributeName = this.getAttributeName();
                node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
                if ($044bafd75d0fd095$var$styleForPseudo) $044bafd75d0fd095$var$styleForPseudo.innerHTML = '';
                if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) node.removeChild(this.extraNode);
                [
                    'transition',
                    'animation'
                ].forEach(function(name) {
                    node.removeEventListener("".concat(name, "start"), _this2.onTransitionStart);
                    node.removeEventListener("".concat(name, "end"), _this2.onTransitionEnd);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $044bafd75d0fd095$var$React.createElement($qBua1.ConfigConsumer, null, this.renderWave);
            }
        }
    ]);
    return Wave;
}($044bafd75d0fd095$var$React.Component);
$044bafd75d0fd095$var$Wave.contextType = $qBua1.ConfigContext;
var $044bafd75d0fd095$var$_default = module.exports["default"] = $044bafd75d0fd095$var$Wave;

});
parcelRegister("7OknB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5afd02e6d0eeedca$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5afd02e6d0eeedca$var$wrapperRaf;

var $5afd02e6d0eeedca$var$_raf = $5afd02e6d0eeedca$var$_interopRequireDefault((parcelRequire("iSXDb")));
var $5afd02e6d0eeedca$var$id = 0;
var $5afd02e6d0eeedca$var$ids = {};
// Support call raf with delay specified frame
function $5afd02e6d0eeedca$var$wrapperRaf(callback) {
    var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var myId = $5afd02e6d0eeedca$var$id++;
    var restFrames = delayFrames;
    function internalCallback() {
        restFrames -= 1;
        if (restFrames <= 0) {
            callback();
            delete $5afd02e6d0eeedca$var$ids[myId];
        } else $5afd02e6d0eeedca$var$ids[myId] = (0, $5afd02e6d0eeedca$var$_raf["default"])(internalCallback);
    }
    $5afd02e6d0eeedca$var$ids[myId] = (0, $5afd02e6d0eeedca$var$_raf["default"])(internalCallback);
    return myId;
}
$5afd02e6d0eeedca$var$wrapperRaf.cancel = function cancel(pid) {
    if (pid === undefined) return;
    $5afd02e6d0eeedca$var$_raf["default"].cancel($5afd02e6d0eeedca$var$ids[pid]);
    delete $5afd02e6d0eeedca$var$ids[pid];
};
$5afd02e6d0eeedca$var$wrapperRaf.ids = $5afd02e6d0eeedca$var$ids; // export this for test usage

});


parcelRegister("ePUJz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $acd1d64d3103811e$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $acd1d64d3103811e$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GroupSizeContext = void 0;

var $acd1d64d3103811e$var$_extends2 = $acd1d64d3103811e$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $acd1d64d3103811e$var$_defineProperty2 = $acd1d64d3103811e$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $acd1d64d3103811e$var$_classnames = $acd1d64d3103811e$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $acd1d64d3103811e$var$React = $acd1d64d3103811e$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $acd1d64d3103811e$var$_warning = $acd1d64d3103811e$var$_interopRequireDefault((parcelRequire("3bEAF")));
var $acd1d64d3103811e$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $acd1d64d3103811e$var$GroupSizeContext = module.exports.GroupSizeContext = /*#__PURE__*/ $acd1d64d3103811e$var$React.createContext(undefined);
var $acd1d64d3103811e$var$ButtonGroup = function ButtonGroup(props) {
    var _React$useContext = $acd1d64d3103811e$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, size = props.size, className = props.className, others = $acd1d64d3103811e$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    var prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    // large => lg
    // small => sm
    var sizeCls = '';
    switch(size){
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        case 'middle':
        case undefined:
            break;
        default:
    }
    var classes = (0, $acd1d64d3103811e$var$_classnames["default"])(prefixCls, (0, $acd1d64d3103811e$var$_defineProperty2["default"])((0, $acd1d64d3103811e$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $acd1d64d3103811e$var$React.createElement($acd1d64d3103811e$var$GroupSizeContext.Provider, {
        value: size
    }, /*#__PURE__*/ $acd1d64d3103811e$var$React.createElement("div", (0, $acd1d64d3103811e$var$_extends2["default"])({}, others, {
        className: classes
    })));
};
var $acd1d64d3103811e$var$_default = module.exports["default"] = $acd1d64d3103811e$var$ButtonGroup;

});

parcelRegister("8z6y5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $63c6ac16fbe57da7$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $63c6ac16fbe57da7$var$_LoadingOutlined = $63c6ac16fbe57da7$var$_interopRequireDefault((parcelRequire("53y9T")));

var $63c6ac16fbe57da7$var$_rcMotion = $63c6ac16fbe57da7$var$_interopRequireDefault((parcelRequire("8iiJy")));

var $63c6ac16fbe57da7$var$_react = $63c6ac16fbe57da7$var$_interopRequireDefault((parcelRequire("acw62")));
var $63c6ac16fbe57da7$var$getCollapsedWidth = function getCollapsedWidth() {
    return {
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    };
};
var $63c6ac16fbe57da7$var$getRealWidth = function getRealWidth(node) {
    return {
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    };
};
var $63c6ac16fbe57da7$var$LoadingIcon = function LoadingIcon(_ref) {
    var prefixCls = _ref.prefixCls, loading = _ref.loading, existIcon = _ref.existIcon;
    var visible = !!loading;
    if (existIcon) return /*#__PURE__*/ $63c6ac16fbe57da7$var$_react["default"].createElement("span", {
        className: "".concat(prefixCls, "-loading-icon")
    }, /*#__PURE__*/ $63c6ac16fbe57da7$var$_react["default"].createElement($63c6ac16fbe57da7$var$_LoadingOutlined["default"], null));
    return /*#__PURE__*/ $63c6ac16fbe57da7$var$_react["default"].createElement($63c6ac16fbe57da7$var$_rcMotion["default"], {
        visible: visible,
        // We do not really use this motionName
        motionName: "".concat(prefixCls, "-loading-icon-motion"),
        removeOnLeave: true,
        onAppearStart: $63c6ac16fbe57da7$var$getCollapsedWidth,
        onAppearActive: $63c6ac16fbe57da7$var$getRealWidth,
        onEnterStart: $63c6ac16fbe57da7$var$getCollapsedWidth,
        onEnterActive: $63c6ac16fbe57da7$var$getRealWidth,
        onLeaveStart: $63c6ac16fbe57da7$var$getRealWidth,
        onLeaveActive: $63c6ac16fbe57da7$var$getCollapsedWidth
    }, function(_ref2, ref) {
        var className = _ref2.className, style = _ref2.style;
        return /*#__PURE__*/ $63c6ac16fbe57da7$var$_react["default"].createElement("span", {
            className: "".concat(prefixCls, "-loading-icon"),
            style: style,
            ref: ref
        }, /*#__PURE__*/ $63c6ac16fbe57da7$var$_react["default"].createElement($63c6ac16fbe57da7$var$_LoadingOutlined["default"], {
            className: className
        }));
    });
};
var $63c6ac16fbe57da7$var$_default = module.exports["default"] = $63c6ac16fbe57da7$var$LoadingIcon;

});



parcelRegister("kycNO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ef60e9e85765f875$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ef60e9e85765f875$var$_Checkbox = $ef60e9e85765f875$var$_interopRequireDefault((parcelRequire("2Kl4A")));

var $ef60e9e85765f875$var$_Group = $ef60e9e85765f875$var$_interopRequireDefault((parcelRequire("eo1En")));
var $ef60e9e85765f875$var$Checkbox = $ef60e9e85765f875$var$_Checkbox["default"];
$ef60e9e85765f875$var$Checkbox.Group = $ef60e9e85765f875$var$_Group["default"];
$ef60e9e85765f875$var$Checkbox.__ANT_CHECKBOX = true;
var $ef60e9e85765f875$var$_default = module.exports["default"] = $ef60e9e85765f875$var$Checkbox;

});
parcelRegister("2Kl4A", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $20003951da94ef65$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $20003951da94ef65$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $20003951da94ef65$var$_defineProperty2 = $20003951da94ef65$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $20003951da94ef65$var$_extends2 = $20003951da94ef65$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $20003951da94ef65$var$_classnames = $20003951da94ef65$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $20003951da94ef65$var$_rcCheckbox = $20003951da94ef65$var$_interopRequireDefault((parcelRequire("fAiwY")));

var $20003951da94ef65$var$_react = $20003951da94ef65$var$_interopRequireWildcard((parcelRequire("acw62")));
var $20003951da94ef65$var$React = $20003951da94ef65$var$_react;

var $qBua1 = parcelRequire("qBua1");

var $gJD51 = parcelRequire("gJD51");

var $20003951da94ef65$var$_warning = $20003951da94ef65$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $eo1En = parcelRequire("eo1En");

var $20003951da94ef65$var$_DisabledContext = $20003951da94ef65$var$_interopRequireDefault((parcelRequire("bzUGe")));
var $20003951da94ef65$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $20003951da94ef65$var$InternalCheckbox = function InternalCheckbox(_a, ref) {
    var _b;
    var customizePrefixCls = _a.prefixCls, className = _a.className, children = _a.children, _a$indeterminate = _a.indeterminate, indeterminate = _a$indeterminate === void 0 ? false : _a$indeterminate, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _a$skipGroup = _a.skipGroup, skipGroup = _a$skipGroup === void 0 ? false : _a$skipGroup, disabled = _a.disabled, restProps = $20003951da94ef65$var$__rest(_a, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "disabled"
    ]);
    var _React$useContext = $20003951da94ef65$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var checkboxGroup = $20003951da94ef65$var$React.useContext($eo1En.GroupContext);
    var _useContext = (0, $20003951da94ef65$var$_react.useContext)($gJD51.FormItemInputContext), isFormItemInput = _useContext.isFormItemInput;
    var contextDisabled = (0, $20003951da94ef65$var$_react.useContext)($20003951da94ef65$var$_DisabledContext["default"]);
    var mergedDisabled = (_b = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _b !== void 0 ? _b : contextDisabled;
    var prevValue = $20003951da94ef65$var$React.useRef(restProps.value);
    $20003951da94ef65$var$React.useEffect(function() {
        checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
    }, []);
    $20003951da94ef65$var$React.useEffect(function() {
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        restProps.value
    ]);
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var checkboxProps = (0, $20003951da94ef65$var$_extends2["default"])({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            if (restProps.onChange) restProps.onChange.apply(restProps, arguments);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    var classString = (0, $20003951da94ef65$var$_classnames["default"])((0, $20003951da94ef65$var$_defineProperty2["default"])((0, $20003951da94ef65$var$_defineProperty2["default"])((0, $20003951da94ef65$var$_defineProperty2["default"])((0, $20003951da94ef65$var$_defineProperty2["default"])((0, $20003951da94ef65$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-wrapper"), true), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), "".concat(prefixCls, "-wrapper-disabled"), mergedDisabled), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    var checkboxClass = (0, $20003951da94ef65$var$_classnames["default"])((0, $20003951da94ef65$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    var ariaChecked = indeterminate ? 'mixed' : undefined;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $20003951da94ef65$var$React.createElement("label", {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ $20003951da94ef65$var$React.createElement($20003951da94ef65$var$_rcCheckbox["default"], (0, $20003951da94ef65$var$_extends2["default"])({
        "aria-checked": ariaChecked
    }, checkboxProps, {
        prefixCls: prefixCls,
        className: checkboxClass,
        disabled: mergedDisabled,
        ref: ref
    })), children !== undefined && /*#__PURE__*/ $20003951da94ef65$var$React.createElement("span", null, children)));
};
var $20003951da94ef65$var$Checkbox = /*#__PURE__*/ $20003951da94ef65$var$React.forwardRef($20003951da94ef65$var$InternalCheckbox);
var $20003951da94ef65$var$_default = module.exports["default"] = $20003951da94ef65$var$Checkbox;

});
parcelRegister("eo1En", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a7949648d82fc7ba$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a7949648d82fc7ba$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GroupContext = void 0;

var $a7949648d82fc7ba$var$_extends2 = $a7949648d82fc7ba$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $a7949648d82fc7ba$var$_defineProperty2 = $a7949648d82fc7ba$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $a7949648d82fc7ba$var$_toConsumableArray2 = $a7949648d82fc7ba$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $a7949648d82fc7ba$var$_slicedToArray2 = $a7949648d82fc7ba$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $a7949648d82fc7ba$var$_classnames = $a7949648d82fc7ba$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $a7949648d82fc7ba$var$_omit = $a7949648d82fc7ba$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $a7949648d82fc7ba$var$React = $a7949648d82fc7ba$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $a7949648d82fc7ba$var$_Checkbox = $a7949648d82fc7ba$var$_interopRequireDefault((parcelRequire("2Kl4A")));
var $a7949648d82fc7ba$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a7949648d82fc7ba$var$GroupContext = module.exports.GroupContext = /*#__PURE__*/ $a7949648d82fc7ba$var$React.createContext(null);
var $a7949648d82fc7ba$var$InternalCheckboxGroup = function InternalCheckboxGroup(_a, ref) {
    var defaultValue = _a.defaultValue, children = _a.children, _a$options = _a.options, options = _a$options === void 0 ? [] : _a$options, customizePrefixCls = _a.prefixCls, className = _a.className, style = _a.style, onChange = _a.onChange, restProps = $a7949648d82fc7ba$var$__rest(_a, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var _React$useContext = $a7949648d82fc7ba$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState = $a7949648d82fc7ba$var$React.useState(restProps.value || defaultValue || []), _React$useState2 = (0, $a7949648d82fc7ba$var$_slicedToArray2["default"])(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    var _React$useState3 = $a7949648d82fc7ba$var$React.useState([]), _React$useState4 = (0, $a7949648d82fc7ba$var$_slicedToArray2["default"])(_React$useState3, 2), registeredValues = _React$useState4[0], setRegisteredValues = _React$useState4[1];
    $a7949648d82fc7ba$var$React.useEffect(function() {
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    var getOptions = function getOptions() {
        return options.map(function(option) {
            if (typeof option === 'string' || typeof option === 'number') return {
                label: option,
                value: option
            };
            return option;
        });
    };
    var cancelValue = function cancelValue(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function registerValue(val) {
        setRegisteredValues(function(prevValues) {
            return [].concat((0, $a7949648d82fc7ba$var$_toConsumableArray2["default"])(prevValues), [
                val
            ]);
        });
    };
    var toggleOption = function toggleOption(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0, $a7949648d82fc7ba$var$_toConsumableArray2["default"])(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        var opts = getOptions();
        onChange === null || onChange === void 0 || onChange(newValue.filter(function(val) {
            return registeredValues.includes(val);
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0, $a7949648d82fc7ba$var$_omit["default"])(restProps, [
        'value',
        'disabled'
    ]);
    if (options && options.length > 0) children = getOptions().map(function(option) {
        return /*#__PURE__*/ $a7949648d82fc7ba$var$React.createElement($a7949648d82fc7ba$var$_Checkbox["default"], {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: "".concat(groupPrefixCls, "-item"),
            style: option.style
        }, option.label);
    });
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = (0, $a7949648d82fc7ba$var$_classnames["default"])(groupPrefixCls, (0, $a7949648d82fc7ba$var$_defineProperty2["default"])({}, "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $a7949648d82fc7ba$var$React.createElement("div", (0, $a7949648d82fc7ba$var$_extends2["default"])({
        className: classString,
        style: style
    }, domProps, {
        ref: ref
    }), /*#__PURE__*/ $a7949648d82fc7ba$var$React.createElement($a7949648d82fc7ba$var$GroupContext.Provider, {
        value: context
    }, children));
};
var $a7949648d82fc7ba$var$CheckboxGroup = /*#__PURE__*/ $a7949648d82fc7ba$var$React.forwardRef($a7949648d82fc7ba$var$InternalCheckboxGroup);
var $a7949648d82fc7ba$var$_default = module.exports["default"] = /*#__PURE__*/ $a7949648d82fc7ba$var$React.memo($a7949648d82fc7ba$var$CheckboxGroup);

});



parcelRegister("lVObl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ff75d8ec3f77d7e5$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ff75d8ec3f77d7e5$var$_dropdown = $ff75d8ec3f77d7e5$var$_interopRequireDefault((parcelRequire("11Ahf")));
var $ff75d8ec3f77d7e5$var$_default = module.exports["default"] = $ff75d8ec3f77d7e5$var$_dropdown["default"];

});
parcelRegister("11Ahf", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0bf2064ff3cce6a2$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0bf2064ff3cce6a2$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0bf2064ff3cce6a2$var$_extends2 = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $0bf2064ff3cce6a2$var$_typeof2 = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("41YNz")));

var $0bf2064ff3cce6a2$var$_defineProperty2 = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $0bf2064ff3cce6a2$var$_slicedToArray2 = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $0bf2064ff3cce6a2$var$_RightOutlined = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("hHiha")));

var $0bf2064ff3cce6a2$var$_classnames = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0bf2064ff3cce6a2$var$_rcDropdown = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("jtXXN")));

var $0bf2064ff3cce6a2$var$_useEvent = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("VcZYb")));

var $0bf2064ff3cce6a2$var$_useMergedState3 = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("7CJZj")));

var $0bf2064ff3cce6a2$var$React = $0bf2064ff3cce6a2$var$_interopRequireWildcard((parcelRequire("acw62")));

var $0bf2064ff3cce6a2$var$_menu = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("lI0Ie")));

var $qBua1 = parcelRequire("qBua1");

var $jYLoz = parcelRequire("jYLoz");

var $0bf2064ff3cce6a2$var$_placements = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("9D74w")));

var $8hTO8 = parcelRequire("8hTO8");

var $3YGhB = parcelRequire("3YGhB");

var $0bf2064ff3cce6a2$var$_warning = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $0bf2064ff3cce6a2$var$_dropdownButton = $0bf2064ff3cce6a2$var$_interopRequireDefault((parcelRequire("lJ7by")));

var $hvVUy = parcelRequire("hvVUy");
var $0bf2064ff3cce6a2$var$Placements = (0, $3YGhB.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight', 'top', 'bottom');
var $0bf2064ff3cce6a2$var$Dropdown = function Dropdown(props) {
    var _React$useContext = $0bf2064ff3cce6a2$var$React.useContext($qBua1.ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var getTransitionName = function getTransitionName() {
        var rootPrefixCls = getPrefixCls();
        var _props$placement = props.placement, placement = _props$placement === void 0 ? '' : _props$placement, transitionName = props.transitionName;
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return "".concat(rootPrefixCls, "-slide-down");
        return "".concat(rootPrefixCls, "-slide-up");
    };
    var getPlacement = function getPlacement() {
        var placement = props.placement;
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) {
            var newPlacement = placement.slice(0, placement.indexOf('Center'));
            return newPlacement;
        }
        return placement;
    };
    var menu = props.menu, arrow = props.arrow, customizePrefixCls = props.prefixCls, children = props.children, trigger = props.trigger, disabled = props.disabled, dropdownRender = props.dropdownRender, getPopupContainer = props.getPopupContainer, overlayClassName = props.overlayClassName, visible = props.visible, open = props.open, onVisibleChange = props.onVisibleChange, onOpenChange = props.onOpenChange, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.15 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, _props$autoAdjustOver = props.autoAdjustOverflow, autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver;
    var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    var child = $0bf2064ff3cce6a2$var$React.Children.only(children);
    var dropdownTrigger = (0, $8hTO8.cloneElement)(child, {
        className: (0, $0bf2064ff3cce6a2$var$_classnames["default"])("".concat(prefixCls, "-trigger"), (0, $0bf2064ff3cce6a2$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), child.props.className),
        disabled: disabled
    });
    var triggerActions = disabled ? [] : trigger;
    var alignPoint;
    if (triggerActions && triggerActions.includes('contextMenu')) alignPoint = true;
    // =========================== Visible ============================
    var _useMergedState = (0, $0bf2064ff3cce6a2$var$_useMergedState3["default"])(false, {
        value: open !== undefined ? open : visible
    }), _useMergedState2 = (0, $0bf2064ff3cce6a2$var$_slicedToArray2["default"])(_useMergedState, 2), mergedOpen = _useMergedState2[0], setOpen = _useMergedState2[1];
    var onInnerOpenChange = (0, $0bf2064ff3cce6a2$var$_useEvent["default"])(function(nextOpen) {
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(nextOpen);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen);
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    var overlayClassNameCustomized = (0, $0bf2064ff3cce6a2$var$_classnames["default"])(overlayClassName, (0, $0bf2064ff3cce6a2$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'));
    var builtinPlacements = (0, $0bf2064ff3cce6a2$var$_placements["default"])({
        arrowPointAtCenter: (0, $0bf2064ff3cce6a2$var$_typeof2["default"])(arrow) === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow
    });
    var onMenuClick = $0bf2064ff3cce6a2$var$React.useCallback(function() {
        setOpen(false);
    }, []);
    var renderOverlay = function renderOverlay() {
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        var overlay = props.overlay;
        var overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) overlayNode = /*#__PURE__*/ $0bf2064ff3cce6a2$var$React.createElement($0bf2064ff3cce6a2$var$_menu["default"], (0, $0bf2064ff3cce6a2$var$_extends2["default"])({}, menu));
        else if (typeof overlay === 'function') overlayNode = overlay();
        else overlayNode = overlay;
        if (dropdownRender) overlayNode = dropdownRender(overlayNode);
        overlayNode = $0bf2064ff3cce6a2$var$React.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $0bf2064ff3cce6a2$var$React.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $0bf2064ff3cce6a2$var$React.createElement($jYLoz.OverrideProvider, {
            prefixCls: "".concat(prefixCls, "-menu"),
            expandIcon: /*#__PURE__*/ $0bf2064ff3cce6a2$var$React.createElement("span", {
                className: "".concat(prefixCls, "-menu-submenu-arrow")
            }, /*#__PURE__*/ $0bf2064ff3cce6a2$var$React.createElement($0bf2064ff3cce6a2$var$_RightOutlined["default"], {
                className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: function validator(_ref3) {
                var mode = _ref3.mode;
            }
        }, /*#__PURE__*/ $0bf2064ff3cce6a2$var$React.createElement($hvVUy.NoCompactStyle, null, overlayNode));
    };
    // ============================ Render ============================
    return /*#__PURE__*/ $0bf2064ff3cce6a2$var$React.createElement($0bf2064ff3cce6a2$var$_rcDropdown["default"], (0, $0bf2064ff3cce6a2$var$_extends2["default"])({
        alignPoint: alignPoint
    }, props, {
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: getTransitionName(),
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: getPlacement(),
        onVisibleChange: onInnerOpenChange
    }), dropdownTrigger);
};
$0bf2064ff3cce6a2$var$Dropdown.Button = $0bf2064ff3cce6a2$var$_dropdownButton["default"];
var $0bf2064ff3cce6a2$var$_default = module.exports["default"] = $0bf2064ff3cce6a2$var$Dropdown;

});
parcelRegister("7CJZj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $58cfc13e55c17ef0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58cfc13e55c17ef0$var$useMergedState;

var $58cfc13e55c17ef0$var$_slicedToArray2 = $58cfc13e55c17ef0$require$_interopRequireDefault((parcelRequire("02Ztr")));

var $58cfc13e55c17ef0$var$_useEvent = $58cfc13e55c17ef0$require$_interopRequireDefault((parcelRequire("VcZYb")));

var $5Xs2K = parcelRequire("5Xs2K");

var $58cfc13e55c17ef0$var$_useState5 = $58cfc13e55c17ef0$require$_interopRequireDefault((parcelRequire("4nC1V")));
/** We only think `undefined` is empty */ function $58cfc13e55c17ef0$var$hasValue(value) {
    return value !== undefined;
}
/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */ function $58cfc13e55c17ef0$var$useMergedState(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $58cfc13e55c17ef0$var$_useState5.default)(function() {
        if ($58cfc13e55c17ef0$var$hasValue(value)) return value;
        else if ($58cfc13e55c17ef0$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $58cfc13e55c17ef0$var$_slicedToArray2.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $58cfc13e55c17ef0$var$_useEvent.default)(onChange);
    var _useState3 = (0, $58cfc13e55c17ef0$var$_useState5.default)([
        mergedValue
    ]), _useState4 = (0, $58cfc13e55c17ef0$var$_slicedToArray2.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $5Xs2K.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $5Xs2K.useLayoutUpdateEffect)(function() {
        if (!$58cfc13e55c17ef0$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $58cfc13e55c17ef0$var$_useEvent.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

});
parcelRegister("4nC1V", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3306cf680d01d973$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3306cf680d01d973$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3306cf680d01d973$var$useSafeState;

var $3306cf680d01d973$var$_slicedToArray2 = $3306cf680d01d973$require$_interopRequireDefault((parcelRequire("02Ztr")));

var $3306cf680d01d973$var$React = $3306cf680d01d973$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */ function $3306cf680d01d973$var$useSafeState(defaultValue) {
    var destroyRef = $3306cf680d01d973$var$React.useRef(false);
    var _React$useState = $3306cf680d01d973$var$React.useState(defaultValue), _React$useState2 = (0, $3306cf680d01d973$var$_slicedToArray2.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $3306cf680d01d973$var$React.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

});


parcelRegister("lI0Ie", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fcde427bbb4e4a46$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fcde427bbb4e4a46$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $fcde427bbb4e4a46$var$_classCallCheck2 = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("fu0YK")));

var $fcde427bbb4e4a46$var$_createClass2 = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("lR7jo")));

var $fcde427bbb4e4a46$var$_possibleConstructorReturn2 = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("eN9hz")));

var $fcde427bbb4e4a46$var$_isNativeReflectConstruct2 = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("5HCVq")));

var $fcde427bbb4e4a46$var$_getPrototypeOf2 = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("cGTaw")));

var $fcde427bbb4e4a46$var$_inherits2 = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("f8wIT")));

var $fcde427bbb4e4a46$var$_extends2 = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $fcde427bbb4e4a46$var$_EllipsisOutlined = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("4B3PS")));

var $fcde427bbb4e4a46$var$_classnames = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $fcde427bbb4e4a46$var$_rcMenu = $fcde427bbb4e4a46$var$_interopRequireWildcard((parcelRequire("feYPt")));

var $fcde427bbb4e4a46$var$_useEvent = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("VcZYb")));

var $fcde427bbb4e4a46$var$_omit = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $fcde427bbb4e4a46$var$_react = $fcde427bbb4e4a46$var$_interopRequireWildcard((parcelRequire("acw62")));
var $fcde427bbb4e4a46$var$React = $fcde427bbb4e4a46$var$_react;

var $qBua1 = parcelRequire("qBua1");

var $91G8f = parcelRequire("91G8f");

var $fcde427bbb4e4a46$var$_motion = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("2F6xM")));

var $8hTO8 = parcelRequire("8hTO8");

var $fcde427bbb4e4a46$var$_warning = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $fcde427bbb4e4a46$var$_useItems = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("6whPS")));

var $fcde427bbb4e4a46$var$_MenuContext = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("9UAmG")));

var $fcde427bbb4e4a46$var$_MenuDivider = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("eJjh0")));

var $fcde427bbb4e4a46$var$_MenuItem = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("cAk2t")));

var $fcde427bbb4e4a46$var$_OverrideContext = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("jYLoz")));

var $fcde427bbb4e4a46$var$_SubMenu = $fcde427bbb4e4a46$var$_interopRequireDefault((parcelRequire("feMq6")));
function $fcde427bbb4e4a46$var$_callSuper(t, o, e) {
    return o = (0, $fcde427bbb4e4a46$var$_getPrototypeOf2["default"])(o), (0, $fcde427bbb4e4a46$var$_possibleConstructorReturn2["default"])(t, (0, $fcde427bbb4e4a46$var$_isNativeReflectConstruct2["default"])() ? Reflect.construct(o, e || [], (0, $fcde427bbb4e4a46$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
var $fcde427bbb4e4a46$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fcde427bbb4e4a46$var$InternalMenu = /*#__PURE__*/ (0, $fcde427bbb4e4a46$var$_react.forwardRef)(function(props, ref) {
    var _a;
    var override = $fcde427bbb4e4a46$var$React.useContext($fcde427bbb4e4a46$var$_OverrideContext["default"]) || {};
    var _React$useContext = $fcde427bbb4e4a46$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, getPopupContainer = _React$useContext.getPopupContainer, direction = _React$useContext.direction;
    var rootPrefixCls = getPrefixCls();
    var customizePrefixCls = props.prefixCls, className = props.className, _props$theme = props.theme, theme = _props$theme === void 0 ? 'light' : _props$theme, expandIcon = props.expandIcon, _internalDisableMenuItemTitleTooltip = props._internalDisableMenuItemTitleTooltip, inlineCollapsed = props.inlineCollapsed, siderCollapsed = props.siderCollapsed, items = props.items, children = props.children, mode = props.mode, selectable = props.selectable, onClick = props.onClick, restProps = $fcde427bbb4e4a46$var$__rest(props, [
        "prefixCls",
        "className",
        "theme",
        "expandIcon",
        "_internalDisableMenuItemTitleTooltip",
        "inlineCollapsed",
        "siderCollapsed",
        "items",
        "children",
        "mode",
        "selectable",
        "onClick"
    ]);
    var passedProps = (0, $fcde427bbb4e4a46$var$_omit["default"])(restProps, [
        'collapsedWidth'
    ]);
    // ========================= Items ===========================
    var mergedChildren = (0, $fcde427bbb4e4a46$var$_useItems["default"])(items) || children;
    (_a = override.validator) === null || _a === void 0 || _a.call(override, {
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    var onItemClick = (0, $fcde427bbb4e4a46$var$_useEvent["default"])(function() {
        var _a;
        onClick === null || onClick === void 0 || onClick.apply(void 0, arguments);
        (_a = override === null || override === void 0 ? void 0 : override.onClick) === null || _a === void 0 || _a.call(override);
    });
    // ========================== Mode ===========================
    var mergedMode = override.mode || mode;
    // ======================= Selectable ========================
    var mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : override.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    var mergedInlineCollapsed = $fcde427bbb4e4a46$var$React.useMemo(function() {
        if (siderCollapsed !== undefined) return siderCollapsed;
        return inlineCollapsed;
    }, [
        inlineCollapsed,
        siderCollapsed
    ]);
    var defaultMotions = {
        horizontal: {
            motionName: "".concat(rootPrefixCls, "-slide-up")
        },
        inline: $fcde427bbb4e4a46$var$_motion["default"],
        other: {
            motionName: "".concat(rootPrefixCls, "-zoom-big")
        }
    };
    var prefixCls = getPrefixCls('menu', customizePrefixCls || override.prefixCls);
    var menuClassName = (0, $fcde427bbb4e4a46$var$_classnames["default"])("".concat(prefixCls, "-").concat(theme), className);
    // ====================== Expand Icon ========================
    var mergedExpandIcon;
    if (typeof expandIcon === 'function') mergedExpandIcon = expandIcon;
    else mergedExpandIcon = (0, $8hTO8.cloneElement)(expandIcon || override.expandIcon, {
        className: "".concat(prefixCls, "-submenu-expand-icon")
    });
    // ======================== Context ==========================
    var contextValue = $fcde427bbb4e4a46$var$React.useMemo(function() {
        return {
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            antdMenuTheme: theme,
            direction: direction,
            firstLevel: true,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
        };
    }, [
        prefixCls,
        mergedInlineCollapsed,
        theme,
        direction,
        _internalDisableMenuItemTitleTooltip
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $fcde427bbb4e4a46$var$React.createElement($fcde427bbb4e4a46$var$_OverrideContext["default"].Provider, {
        value: null
    }, /*#__PURE__*/ $fcde427bbb4e4a46$var$React.createElement($fcde427bbb4e4a46$var$_MenuContext["default"].Provider, {
        value: contextValue
    }, /*#__PURE__*/ $fcde427bbb4e4a46$var$React.createElement($fcde427bbb4e4a46$var$_rcMenu["default"], (0, $fcde427bbb4e4a46$var$_extends2["default"])({
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $fcde427bbb4e4a46$var$React.createElement($fcde427bbb4e4a46$var$_EllipsisOutlined["default"], null),
        overflowedIndicatorPopupClassName: "".concat(prefixCls, "-").concat(theme),
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick
    }, passedProps, {
        inlineCollapsed: mergedInlineCollapsed,
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref
    }), mergedChildren)));
});
// We should keep this as ref-able
var $fcde427bbb4e4a46$var$Menu = /*#__PURE__*/ function(_React$Component) {
    (0, $fcde427bbb4e4a46$var$_inherits2["default"])(Menu, _React$Component);
    function Menu() {
        var _this;
        (0, $fcde427bbb4e4a46$var$_classCallCheck2["default"])(this, Menu);
        _this = $fcde427bbb4e4a46$var$_callSuper(this, Menu, arguments);
        _this.focus = function(options) {
            var _a;
            (_a = _this.menu) === null || _a === void 0 || _a.focus(options);
        };
        return _this;
    }
    (0, $fcde427bbb4e4a46$var$_createClass2["default"])(Menu, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                return /*#__PURE__*/ $fcde427bbb4e4a46$var$React.createElement($91G8f.SiderContext.Consumer, null, function(context) {
                    return /*#__PURE__*/ $fcde427bbb4e4a46$var$React.createElement($fcde427bbb4e4a46$var$InternalMenu, (0, $fcde427bbb4e4a46$var$_extends2["default"])({
                        ref: function ref(node) {
                            _this2.menu = node;
                        }
                    }, _this2.props, context));
                });
            }
        }
    ]);
    return Menu;
}($fcde427bbb4e4a46$var$React.Component);
$fcde427bbb4e4a46$var$Menu.Divider = $fcde427bbb4e4a46$var$_MenuDivider["default"];
$fcde427bbb4e4a46$var$Menu.Item = $fcde427bbb4e4a46$var$_MenuItem["default"];
$fcde427bbb4e4a46$var$Menu.SubMenu = $fcde427bbb4e4a46$var$_SubMenu["default"];
$fcde427bbb4e4a46$var$Menu.ItemGroup = $fcde427bbb4e4a46$var$_rcMenu.ItemGroup;
var $fcde427bbb4e4a46$var$_default = module.exports["default"] = $fcde427bbb4e4a46$var$Menu;

});
parcelRegister("4B3PS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $358d97cbaa861b75$var$_EllipsisOutlined = $358d97cbaa861b75$var$_interopRequireDefault((parcelRequire("gX20l")));
function $358d97cbaa861b75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $358d97cbaa861b75$var$_default = $358d97cbaa861b75$var$_EllipsisOutlined;
module.exports.default = $358d97cbaa861b75$var$_default;
module.exports = $358d97cbaa861b75$var$_default;

});
parcelRegister("gX20l", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c573b61487efded8$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $c573b61487efded8$var$React = $c573b61487efded8$var$_interopRequireWildcard((parcelRequire("acw62")));

var $c573b61487efded8$var$_EllipsisOutlined = $1jnue((parcelRequire("2hkvS")));

var $c573b61487efded8$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $c573b61487efded8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c573b61487efded8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c573b61487efded8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $c573b61487efded8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $c573b61487efded8$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $c573b61487efded8$var$React.createElement($c573b61487efded8$var$_AntdIcon.default, (0, $c573b61487efded8$var$_objectSpread2.default)((0, $c573b61487efded8$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $c573b61487efded8$var$_EllipsisOutlined.default
    }));
};
var $c573b61487efded8$var$RefIcon = /*#__PURE__*/ $c573b61487efded8$var$React.forwardRef($c573b61487efded8$var$EllipsisOutlined);
var $c573b61487efded8$var$_default = module.exports.default = $c573b61487efded8$var$RefIcon;

});
parcelRegister("2hkvS", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1a8d14cbc053374d$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
module.exports.default = $1a8d14cbc053374d$var$EllipsisOutlined;

});



parcelRegister("91G8f", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6924e394695c9111$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6924e394695c9111$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.SiderContext = void 0;

var $6924e394695c9111$var$_defineProperty2 = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $6924e394695c9111$var$_extends2 = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $6924e394695c9111$var$_slicedToArray2 = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $6924e394695c9111$var$_BarsOutlined = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("2j1H5")));

var $6924e394695c9111$var$_LeftOutlined = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("117pG")));

var $6924e394695c9111$var$_RightOutlined = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("hHiha")));

var $6924e394695c9111$var$_classnames = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $6924e394695c9111$var$_omit = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $6924e394695c9111$var$_react = $6924e394695c9111$var$_interopRequireWildcard((parcelRequire("acw62")));
var $6924e394695c9111$var$React = $6924e394695c9111$var$_react;

var $qBua1 = parcelRequire("qBua1");

var $6924e394695c9111$var$_isNumeric = $6924e394695c9111$var$_interopRequireDefault((parcelRequire("k9Vva")));

var $k5Jkn = parcelRequire("k5Jkn");
var $6924e394695c9111$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6924e394695c9111$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
var $6924e394695c9111$var$SiderContext = module.exports.SiderContext = /*#__PURE__*/ $6924e394695c9111$var$React.createContext({});
var $6924e394695c9111$var$generateId = function() {
    var i = 0;
    return function() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        i += 1;
        return "".concat(prefix).concat(i);
    };
}();
var $6924e394695c9111$var$Sider = /*#__PURE__*/ $6924e394695c9111$var$React.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, trigger = _a.trigger, children = _a.children, _a$defaultCollapsed = _a.defaultCollapsed, defaultCollapsed = _a$defaultCollapsed === void 0 ? false : _a$defaultCollapsed, _a$theme = _a.theme, theme = _a$theme === void 0 ? 'dark' : _a$theme, _a$style = _a.style, style = _a$style === void 0 ? {} : _a$style, _a$collapsible = _a.collapsible, collapsible = _a$collapsible === void 0 ? false : _a$collapsible, _a$reverseArrow = _a.reverseArrow, reverseArrow = _a$reverseArrow === void 0 ? false : _a$reverseArrow, _a$width = _a.width, width = _a$width === void 0 ? 200 : _a$width, _a$collapsedWidth = _a.collapsedWidth, collapsedWidth = _a$collapsedWidth === void 0 ? 80 : _a$collapsedWidth, zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle, breakpoint = _a.breakpoint, onCollapse = _a.onCollapse, onBreakpoint = _a.onBreakpoint, props = $6924e394695c9111$var$__rest(_a, [
        "prefixCls",
        "className",
        "trigger",
        "children",
        "defaultCollapsed",
        "theme",
        "style",
        "collapsible",
        "reverseArrow",
        "width",
        "collapsedWidth",
        "zeroWidthTriggerStyle",
        "breakpoint",
        "onCollapse",
        "onBreakpoint"
    ]);
    var _useContext = (0, $6924e394695c9111$var$_react.useContext)($k5Jkn.LayoutContext), siderHook = _useContext.siderHook;
    var _useState = (0, $6924e394695c9111$var$_react.useState)('collapsed' in props ? props.collapsed : defaultCollapsed), _useState2 = (0, $6924e394695c9111$var$_slicedToArray2["default"])(_useState, 2), collapsed = _useState2[0], setCollapsed = _useState2[1];
    var _useState3 = (0, $6924e394695c9111$var$_react.useState)(false), _useState4 = (0, $6924e394695c9111$var$_slicedToArray2["default"])(_useState3, 2), below = _useState4[0], setBelow = _useState4[1];
    (0, $6924e394695c9111$var$_react.useEffect)(function() {
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    var handleSetCollapsed = function handleSetCollapsed(value, type) {
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse === null || onCollapse === void 0 || onCollapse(value, type);
    };
    // ========================= Responsive =========================
    var responsiveHandlerRef = (0, $6924e394695c9111$var$_react.useRef)();
    responsiveHandlerRef.current = function(mql) {
        setBelow(mql.matches);
        onBreakpoint === null || onBreakpoint === void 0 || onBreakpoint(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $6924e394695c9111$var$_react.useEffect)(function() {
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current(mql);
        }
        var mql;
        if (typeof window !== 'undefined') {
            var _window = window, matchMedia = _window.matchMedia;
            if (matchMedia && breakpoint && breakpoint in $6924e394695c9111$var$dimensionMaxMap) {
                mql = matchMedia("(max-width: ".concat($6924e394695c9111$var$dimensionMaxMap[breakpoint], ")"));
                try {
                    mql.addEventListener('change', responsiveHandler);
                } catch (error) {
                    mql.addListener(responsiveHandler);
                }
                responsiveHandler(mql);
            }
        }
        return function() {
            try {
                mql === null || mql === void 0 || mql.removeEventListener('change', responsiveHandler);
            } catch (error) {
                mql === null || mql === void 0 || mql.removeListener(responsiveHandler);
            }
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $6924e394695c9111$var$_react.useEffect)(function() {
        var uniqueId = $6924e394695c9111$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return function() {
            return siderHook.removeSider(uniqueId);
        };
    }, []);
    var toggle = function toggle() {
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    var _useContext2 = (0, $6924e394695c9111$var$_react.useContext)($qBua1.ConfigContext), getPrefixCls = _useContext2.getPrefixCls;
    var renderSider = function renderSider() {
        var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
        var divProps = (0, $6924e394695c9111$var$_omit["default"])(props, [
            'collapsed'
        ]);
        var rawWidth = collapsed ? collapsedWidth : width;
        // use "px" as fallback unit for width
        var siderWidth = (0, $6924e394695c9111$var$_isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth);
        // special trigger when collapsedWidth == 0
        var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $6924e394695c9111$var$React.createElement("span", {
            onClick: toggle,
            className: (0, $6924e394695c9111$var$_classnames["default"])("".concat(prefixCls, "-zero-width-trigger"), "".concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left')),
            style: zeroWidthTriggerStyle
        }, trigger || /*#__PURE__*/ $6924e394695c9111$var$React.createElement($6924e394695c9111$var$_BarsOutlined["default"], null)) : null;
        var iconObj = {
            expanded: reverseArrow ? /*#__PURE__*/ $6924e394695c9111$var$React.createElement($6924e394695c9111$var$_RightOutlined["default"], null) : /*#__PURE__*/ $6924e394695c9111$var$React.createElement($6924e394695c9111$var$_LeftOutlined["default"], null),
            collapsed: reverseArrow ? /*#__PURE__*/ $6924e394695c9111$var$React.createElement($6924e394695c9111$var$_LeftOutlined["default"], null) : /*#__PURE__*/ $6924e394695c9111$var$React.createElement($6924e394695c9111$var$_RightOutlined["default"], null)
        };
        var status = collapsed ? 'collapsed' : 'expanded';
        var defaultTrigger = iconObj[status];
        var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $6924e394695c9111$var$React.createElement("div", {
            className: "".concat(prefixCls, "-trigger"),
            onClick: toggle,
            style: {
                width: siderWidth
            }
        }, trigger || defaultTrigger) : null;
        var divStyle = (0, $6924e394695c9111$var$_extends2["default"])((0, $6924e394695c9111$var$_extends2["default"])({}, style), {
            flex: "0 0 ".concat(siderWidth),
            maxWidth: siderWidth,
            minWidth: siderWidth,
            width: siderWidth
        });
        var siderCls = (0, $6924e394695c9111$var$_classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(theme), (0, $6924e394695c9111$var$_defineProperty2["default"])((0, $6924e394695c9111$var$_defineProperty2["default"])((0, $6924e394695c9111$var$_defineProperty2["default"])((0, $6924e394695c9111$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-collapsed"), !!collapsed), "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), "".concat(prefixCls, "-below"), !!below), "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), className);
        return /*#__PURE__*/ $6924e394695c9111$var$React.createElement("aside", (0, $6924e394695c9111$var$_extends2["default"])({
            className: siderCls
        }, divProps, {
            style: divStyle,
            ref: ref
        }), /*#__PURE__*/ $6924e394695c9111$var$React.createElement("div", {
            className: "".concat(prefixCls, "-children")
        }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null);
    };
    var contextValue = $6924e394695c9111$var$React.useMemo(function() {
        return {
            siderCollapsed: collapsed
        };
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ $6924e394695c9111$var$React.createElement($6924e394695c9111$var$SiderContext.Provider, {
        value: contextValue
    }, renderSider());
});
var $6924e394695c9111$var$_default = module.exports["default"] = $6924e394695c9111$var$Sider;

});
parcelRegister("2j1H5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1adeab83b2e42c65$var$_BarsOutlined = $1adeab83b2e42c65$var$_interopRequireDefault((parcelRequire("eccN2")));
function $1adeab83b2e42c65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $1adeab83b2e42c65$var$_default = $1adeab83b2e42c65$var$_BarsOutlined;
module.exports.default = $1adeab83b2e42c65$var$_default;
module.exports = $1adeab83b2e42c65$var$_default;

});
parcelRegister("eccN2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55c1b7a303ff512$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $a55c1b7a303ff512$var$React = $a55c1b7a303ff512$var$_interopRequireWildcard((parcelRequire("acw62")));

var $a55c1b7a303ff512$var$_BarsOutlined = $1jnue((parcelRequire("e38ow")));

var $a55c1b7a303ff512$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $a55c1b7a303ff512$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a55c1b7a303ff512$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a55c1b7a303ff512$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $a55c1b7a303ff512$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $a55c1b7a303ff512$var$BarsOutlined = function BarsOutlined(props, ref) {
    return /*#__PURE__*/ $a55c1b7a303ff512$var$React.createElement($a55c1b7a303ff512$var$_AntdIcon.default, (0, $a55c1b7a303ff512$var$_objectSpread2.default)((0, $a55c1b7a303ff512$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $a55c1b7a303ff512$var$_BarsOutlined.default
    }));
};
var $a55c1b7a303ff512$var$RefIcon = /*#__PURE__*/ $a55c1b7a303ff512$var$React.forwardRef($a55c1b7a303ff512$var$BarsOutlined);
var $a55c1b7a303ff512$var$_default = module.exports.default = $a55c1b7a303ff512$var$RefIcon;

});
parcelRegister("e38ow", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a3a7db76eed29818$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
module.exports.default = $a3a7db76eed29818$var$BarsOutlined;

});



parcelRegister("k9Vva", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $ead1408f01adcdc2$var$isNumeric = function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
var $ead1408f01adcdc2$var$_default = module.exports["default"] = $ead1408f01adcdc2$var$isNumeric;

});

parcelRegister("k5Jkn", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ea076f6cdadc1314$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ea076f6cdadc1314$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.LayoutContext = module.exports.Header = module.exports.Footer = module.exports.Content = void 0;

var $ea076f6cdadc1314$var$_toConsumableArray2 = $ea076f6cdadc1314$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $ea076f6cdadc1314$var$_defineProperty2 = $ea076f6cdadc1314$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $ea076f6cdadc1314$var$_slicedToArray2 = $ea076f6cdadc1314$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $ea076f6cdadc1314$var$_extends2 = $ea076f6cdadc1314$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $ea076f6cdadc1314$var$_classnames = $ea076f6cdadc1314$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $ea076f6cdadc1314$var$React = $ea076f6cdadc1314$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");
var $ea076f6cdadc1314$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ea076f6cdadc1314$var$LayoutContext = module.exports.LayoutContext = /*#__PURE__*/ $ea076f6cdadc1314$var$React.createContext({
    siderHook: {
        addSider: function addSider() {
            return null;
        },
        removeSider: function removeSider() {
            return null;
        }
    }
});
function $ea076f6cdadc1314$var$generator(_ref) {
    var suffixCls = _ref.suffixCls, tagName = _ref.tagName, displayName = _ref.displayName;
    return function(BasicComponent) {
        var Adapter = /*#__PURE__*/ $ea076f6cdadc1314$var$React.forwardRef(function(props, ref) {
            var _React$useContext = $ea076f6cdadc1314$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
            var customizePrefixCls = props.prefixCls;
            var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
            return /*#__PURE__*/ $ea076f6cdadc1314$var$React.createElement(BasicComponent, (0, $ea076f6cdadc1314$var$_extends2["default"])({
                ref: ref,
                prefixCls: prefixCls,
                tagName: tagName
            }, props));
        });
        return Adapter;
    };
}
var $ea076f6cdadc1314$var$Basic = /*#__PURE__*/ $ea076f6cdadc1314$var$React.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, children = props.children, tagName = props.tagName, others = $ea076f6cdadc1314$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "tagName"
    ]);
    var classString = (0, $ea076f6cdadc1314$var$_classnames["default"])(prefixCls, className);
    return /*#__PURE__*/ $ea076f6cdadc1314$var$React.createElement(tagName, (0, $ea076f6cdadc1314$var$_extends2["default"])((0, $ea076f6cdadc1314$var$_extends2["default"])({
        className: classString
    }, others), {
        ref: ref
    }), children);
});
var $ea076f6cdadc1314$var$BasicLayout = /*#__PURE__*/ $ea076f6cdadc1314$var$React.forwardRef(function(props, ref) {
    var _React$useContext2 = $ea076f6cdadc1314$var$React.useContext($qBua1.ConfigContext), direction = _React$useContext2.direction;
    var _React$useState = $ea076f6cdadc1314$var$React.useState([]), _React$useState2 = (0, $ea076f6cdadc1314$var$_slicedToArray2["default"])(_React$useState, 2), siders = _React$useState2[0], setSiders = _React$useState2[1];
    var prefixCls = props.prefixCls, className = props.className, children = props.children, hasSider = props.hasSider, Tag = props.tagName, others = $ea076f6cdadc1314$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "hasSider",
        "tagName"
    ]);
    var classString = (0, $ea076f6cdadc1314$var$_classnames["default"])(prefixCls, (0, $ea076f6cdadc1314$var$_defineProperty2["default"])((0, $ea076f6cdadc1314$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : siders.length > 0), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var contextValue = $ea076f6cdadc1314$var$React.useMemo(function() {
        return {
            siderHook: {
                addSider: function addSider(id) {
                    setSiders(function(prev) {
                        return [].concat((0, $ea076f6cdadc1314$var$_toConsumableArray2["default"])(prev), [
                            id
                        ]);
                    });
                },
                removeSider: function removeSider(id) {
                    setSiders(function(prev) {
                        return prev.filter(function(currentId) {
                            return currentId !== id;
                        });
                    });
                }
            }
        };
    }, []);
    return /*#__PURE__*/ $ea076f6cdadc1314$var$React.createElement($ea076f6cdadc1314$var$LayoutContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $ea076f6cdadc1314$var$React.createElement(Tag, (0, $ea076f6cdadc1314$var$_extends2["default"])({
        ref: ref,
        className: classString
    }, others), children));
});
var $ea076f6cdadc1314$var$Layout = $ea076f6cdadc1314$var$generator({
    suffixCls: 'layout',
    tagName: 'section',
    displayName: 'Layout'
})($ea076f6cdadc1314$var$BasicLayout);
var $ea076f6cdadc1314$var$Header = module.exports.Header = $ea076f6cdadc1314$var$generator({
    suffixCls: 'layout-header',
    tagName: 'header',
    displayName: 'Header'
})($ea076f6cdadc1314$var$Basic);
var $ea076f6cdadc1314$var$Footer = module.exports.Footer = $ea076f6cdadc1314$var$generator({
    suffixCls: 'layout-footer',
    tagName: 'footer',
    displayName: 'Footer'
})($ea076f6cdadc1314$var$Basic);
var $ea076f6cdadc1314$var$Content = module.exports.Content = $ea076f6cdadc1314$var$generator({
    suffixCls: 'layout-content',
    tagName: 'main',
    displayName: 'Content'
})($ea076f6cdadc1314$var$Basic);
var $ea076f6cdadc1314$var$_default = module.exports["default"] = $ea076f6cdadc1314$var$Layout;

});


parcelRegister("6whPS", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4bf3910dcc9ab898$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4bf3910dcc9ab898$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4bf3910dcc9ab898$var$useItems;

var $4bf3910dcc9ab898$var$_extends2 = $4bf3910dcc9ab898$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $4bf3910dcc9ab898$var$_typeof2 = $4bf3910dcc9ab898$var$_interopRequireDefault((parcelRequire("41YNz")));
parcelRequire("feYPt");
var $9TcXG = parcelRequire("9TcXG");

var $4bf3910dcc9ab898$var$React = $4bf3910dcc9ab898$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4bf3910dcc9ab898$var$_MenuDivider = $4bf3910dcc9ab898$var$_interopRequireDefault((parcelRequire("eJjh0")));

var $4bf3910dcc9ab898$var$_MenuItem = $4bf3910dcc9ab898$var$_interopRequireDefault((parcelRequire("cAk2t")));

var $4bf3910dcc9ab898$var$_SubMenu = $4bf3910dcc9ab898$var$_interopRequireDefault((parcelRequire("feMq6")));
var $4bf3910dcc9ab898$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $4bf3910dcc9ab898$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && (0, $4bf3910dcc9ab898$var$_typeof2["default"])(opt) === 'object') {
            var _a = opt, label = _a.label, children = _a.children, key = _a.key, type = _a.type, restProps = $4bf3910dcc9ab898$var$__rest(_a, [
                "label",
                "children",
                "key",
                "type"
            ]);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $4bf3910dcc9ab898$var$React.createElement($9TcXG.default, (0, $4bf3910dcc9ab898$var$_extends2["default"])({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $4bf3910dcc9ab898$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $4bf3910dcc9ab898$var$React.createElement($4bf3910dcc9ab898$var$_SubMenu["default"], (0, $4bf3910dcc9ab898$var$_extends2["default"])({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $4bf3910dcc9ab898$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $4bf3910dcc9ab898$var$React.createElement($4bf3910dcc9ab898$var$_MenuDivider["default"], (0, $4bf3910dcc9ab898$var$_extends2["default"])({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $4bf3910dcc9ab898$var$React.createElement($4bf3910dcc9ab898$var$_MenuItem["default"], (0, $4bf3910dcc9ab898$var$_extends2["default"])({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
// FIXME: Move logic here in v5
/**
 * We simply convert `items` to ReactNode for reuse origin component logic. But we need move all the
 * logic from component into this hooks when in v5
 */ function $4bf3910dcc9ab898$var$useItems(items) {
    return $4bf3910dcc9ab898$var$React.useMemo(function() {
        if (!items) return items;
        return $4bf3910dcc9ab898$var$convertItemsToNodes(items);
    }, [
        items
    ]);
}

});
parcelRegister("eJjh0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ab9437ead3a0c518$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ab9437ead3a0c518$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ab9437ead3a0c518$var$_extends2 = $ab9437ead3a0c518$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $ab9437ead3a0c518$var$_defineProperty2 = $ab9437ead3a0c518$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $ab9437ead3a0c518$var$_classnames = $ab9437ead3a0c518$var$_interopRequireDefault((parcelRequire("8g1PZ")));
parcelRequire("feYPt");
var $iPQJN = parcelRequire("iPQJN");

var $ab9437ead3a0c518$var$React = $ab9437ead3a0c518$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");
var $ab9437ead3a0c518$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ab9437ead3a0c518$var$MenuDivider = function MenuDivider(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, dashed = _a.dashed, restProps = $ab9437ead3a0c518$var$__rest(_a, [
        "prefixCls",
        "className",
        "dashed"
    ]);
    var _React$useContext = $ab9437ead3a0c518$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('menu', customizePrefixCls);
    var classString = (0, $ab9437ead3a0c518$var$_classnames["default"])((0, $ab9437ead3a0c518$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-item-divider-dashed"), !!dashed), className);
    return /*#__PURE__*/ $ab9437ead3a0c518$var$React.createElement($iPQJN.default, (0, $ab9437ead3a0c518$var$_extends2["default"])({
        className: classString
    }, restProps));
};
var $ab9437ead3a0c518$var$_default = module.exports["default"] = $ab9437ead3a0c518$var$MenuDivider;

});

parcelRegister("cAk2t", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9298642722b27e72$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9298642722b27e72$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9298642722b27e72$var$_defineProperty2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $9298642722b27e72$var$_extends2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $9298642722b27e72$var$_classCallCheck2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("fu0YK")));

var $9298642722b27e72$var$_createClass2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("lR7jo")));

var $9298642722b27e72$var$_possibleConstructorReturn2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("eN9hz")));

var $9298642722b27e72$var$_isNativeReflectConstruct2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("5HCVq")));

var $9298642722b27e72$var$_getPrototypeOf2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("cGTaw")));

var $9298642722b27e72$var$_inherits2 = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("f8wIT")));

var $9298642722b27e72$var$_classnames = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("8g1PZ")));
parcelRequire("feYPt");
var $gXR8t = parcelRequire("gXR8t");

var $9298642722b27e72$var$_toArray = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("13r7s")));

var $9298642722b27e72$var$React = $9298642722b27e72$var$_interopRequireWildcard((parcelRequire("acw62")));

var $91G8f = parcelRequire("91G8f");

var $9298642722b27e72$var$_tooltip = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("2Jxu6")));

var $8hTO8 = parcelRequire("8hTO8");

var $9298642722b27e72$var$_MenuContext = $9298642722b27e72$var$_interopRequireDefault((parcelRequire("9UAmG")));
function $9298642722b27e72$var$_callSuper(t, o, e) {
    return o = (0, $9298642722b27e72$var$_getPrototypeOf2["default"])(o), (0, $9298642722b27e72$var$_possibleConstructorReturn2["default"])(t, (0, $9298642722b27e72$var$_isNativeReflectConstruct2["default"])() ? Reflect.construct(o, e || [], (0, $9298642722b27e72$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
var $9298642722b27e72$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9298642722b27e72$var$MenuItem = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    (0, $9298642722b27e72$var$_inherits2["default"])(MenuItem, _React$Component);
    function MenuItem() {
        var _this;
        (0, $9298642722b27e72$var$_classCallCheck2["default"])(this, MenuItem);
        _this = $9298642722b27e72$var$_callSuper(this, MenuItem, arguments);
        _this.renderItem = function(_ref) {
            var siderCollapsed = _ref.siderCollapsed;
            var _a;
            var _this$context = _this.context, prefixCls = _this$context.prefixCls, firstLevel = _this$context.firstLevel, inlineCollapsed = _this$context.inlineCollapsed, direction = _this$context.direction, disableMenuItemTitleTooltip = _this$context.disableMenuItemTitleTooltip;
            var _this$props = _this.props, className = _this$props.className, children = _this$props.children;
            var _b = _this.props, title = _b.title, icon = _b.icon, danger = _b.danger, rest = $9298642722b27e72$var$__rest(_b, [
                "title",
                "icon",
                "danger"
            ]);
            var tooltipTitle = title;
            if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
            else if (title === false) tooltipTitle = '';
            var tooltipProps = {
                title: tooltipTitle
            };
            if (!siderCollapsed && !inlineCollapsed) {
                tooltipProps.title = null;
                // Reset `open` to fix control mode tooltip display not correct
                // ref: https://github.com/ant-design/ant-design/issues/16742
                tooltipProps.open = false;
            }
            var childrenLength = (0, $9298642722b27e72$var$_toArray["default"])(children).length;
            var returnNode = /*#__PURE__*/ $9298642722b27e72$var$React.createElement($gXR8t.default, (0, $9298642722b27e72$var$_extends2["default"])({}, rest, {
                className: (0, $9298642722b27e72$var$_classnames["default"])((0, $9298642722b27e72$var$_defineProperty2["default"])((0, $9298642722b27e72$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-item-danger"), danger), "".concat(prefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), className),
                title: typeof title === 'string' ? title : undefined
            }), (0, $8hTO8.cloneElement)(icon, {
                className: (0, $9298642722b27e72$var$_classnames["default"])((0, $8hTO8.isValidElement)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
            }), _this.renderItemChildren(inlineCollapsed));
            if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $9298642722b27e72$var$React.createElement($9298642722b27e72$var$_tooltip["default"], (0, $9298642722b27e72$var$_extends2["default"])({}, tooltipProps, {
                placement: direction === 'rtl' ? 'left' : 'right',
                overlayClassName: "".concat(prefixCls, "-inline-collapsed-tooltip")
            }), returnNode);
            return returnNode;
        };
        return _this;
    }
    (0, $9298642722b27e72$var$_createClass2["default"])(MenuItem, [
        {
            key: "renderItemChildren",
            value: function renderItemChildren(inlineCollapsed) {
                var _this$context2 = this.context, prefixCls = _this$context2.prefixCls, firstLevel = _this$context2.firstLevel;
                var _this$props2 = this.props, icon = _this$props2.icon, children = _this$props2.children;
                var wrapNode = /*#__PURE__*/ $9298642722b27e72$var$React.createElement("span", {
                    className: "".concat(prefixCls, "-title-content")
                }, children);
                // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
                // ref: https://github.com/ant-design/ant-design/pull/23456
                if (!icon || (0, $8hTO8.isValidElement)(children) && children.type === 'span') {
                    if (children && inlineCollapsed && firstLevel && typeof children === 'string') return /*#__PURE__*/ $9298642722b27e72$var$React.createElement("div", {
                        className: "".concat(prefixCls, "-inline-collapsed-noicon")
                    }, children.charAt(0));
                }
                return wrapNode;
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $9298642722b27e72$var$React.createElement($91G8f.SiderContext.Consumer, null, this.renderItem);
            }
        }
    ]);
    return MenuItem;
}($9298642722b27e72$var$React.Component);
$9298642722b27e72$var$MenuItem.contextType = $9298642722b27e72$var$_MenuContext["default"];

});
parcelRegister("2Jxu6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1fd9c20f0ad1eb86$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1fd9c20f0ad1eb86$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1fd9c20f0ad1eb86$var$_defineProperty2 = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $1fd9c20f0ad1eb86$var$_slicedToArray2 = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $1fd9c20f0ad1eb86$var$_extends2 = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $1fd9c20f0ad1eb86$var$_classnames = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $1fd9c20f0ad1eb86$var$_rcTooltip = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("hRA8u")));

var $1fd9c20f0ad1eb86$var$_useMergedState3 = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("7CJZj")));

var $1fd9c20f0ad1eb86$var$React = $1fd9c20f0ad1eb86$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $3f57q = parcelRequire("3f57q");

var $2F6xM = parcelRequire("2F6xM");

var $1fd9c20f0ad1eb86$var$_placements = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("9D74w")));

var $8hTO8 = parcelRequire("8hTO8");

var $1fd9c20f0ad1eb86$var$_warning = $1fd9c20f0ad1eb86$var$_interopRequireDefault((parcelRequire("3bEAF")));
var $1fd9c20f0ad1eb86$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1fd9c20f0ad1eb86$var$splitObject = function splitObject(obj, keys) {
    var picked = {};
    var omitted = (0, $1fd9c20f0ad1eb86$var$_extends2["default"])({}, obj);
    keys.forEach(function(key) {
        if (obj && key in obj) {
            picked[key] = obj[key];
            delete omitted[key];
        }
    });
    return {
        picked: picked,
        omitted: omitted
    };
};
var $1fd9c20f0ad1eb86$var$PresetColorRegex = new RegExp("^(".concat($3f57q.PresetColorTypes.join('|'), ")(-inverse)?$"));
// Fix Tooltip won't hide at disabled button
// mouse events don't trigger at disabled button in Chrome
// https://github.com/react-component/tooltip/issues/18
function $1fd9c20f0ad1eb86$var$getDisabledCompatibleChildren(element, prefixCls) {
    var elementType = element.type;
    if ((elementType.__ANT_BUTTON === true || element.type === 'button') && element.props.disabled || elementType.__ANT_SWITCH === true && (element.props.disabled || element.props.loading) || elementType.__ANT_RADIO === true && element.props.disabled) {
        // Pick some layout related style properties up to span
        // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
        var _splitObject = $1fd9c20f0ad1eb86$var$splitObject(element.props.style, [
            'position',
            'left',
            'right',
            'top',
            'bottom',
            'float',
            'display',
            'zIndex'
        ]), picked = _splitObject.picked, omitted = _splitObject.omitted;
        var spanStyle = (0, $1fd9c20f0ad1eb86$var$_extends2["default"])((0, $1fd9c20f0ad1eb86$var$_extends2["default"])({
            display: 'inline-block'
        }, picked), {
            cursor: 'not-allowed',
            width: element.props.block ? '100%' : undefined
        });
        var buttonStyle = (0, $1fd9c20f0ad1eb86$var$_extends2["default"])((0, $1fd9c20f0ad1eb86$var$_extends2["default"])({}, omitted), {
            pointerEvents: 'none'
        });
        var child = (0, $8hTO8.cloneElement)(element, {
            style: buttonStyle,
            className: null
        });
        return /*#__PURE__*/ $1fd9c20f0ad1eb86$var$React.createElement("span", {
            style: spanStyle,
            className: (0, $1fd9c20f0ad1eb86$var$_classnames["default"])(element.props.className, "".concat(prefixCls, "-disabled-compatible-wrapper"))
        }, child);
    }
    return element;
}
var $1fd9c20f0ad1eb86$var$Tooltip = /*#__PURE__*/ $1fd9c20f0ad1eb86$var$React.forwardRef(function(props, ref) {
    var _React$useContext = $1fd9c20f0ad1eb86$var$React.useContext($qBua1.ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _useMergedState = (0, $1fd9c20f0ad1eb86$var$_useMergedState3["default"])(false, {
        value: props.open !== undefined ? props.open : props.visible,
        defaultValue: props.defaultOpen !== undefined ? props.defaultOpen : props.defaultVisible
    }), _useMergedState2 = (0, $1fd9c20f0ad1eb86$var$_slicedToArray2["default"])(_useMergedState, 2), open = _useMergedState2[0], setOpen = _useMergedState2[1];
    var isNoTitle = function isNoTitle() {
        var title = props.title, overlay = props.overlay;
        return !title && !overlay && title !== 0; // overlay for old version compatibility
    };
    var onOpenChange = function onOpenChange(vis) {
        var _a, _b;
        setOpen(isNoTitle() ? false : vis);
        if (!isNoTitle()) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    var getTooltipPlacements = function getTooltipPlacements() {
        var builtinPlacements = props.builtinPlacements, _props$arrowPointAtCe = props.arrowPointAtCenter, arrowPointAtCenter = _props$arrowPointAtCe === void 0 ? false : _props$arrowPointAtCe, _props$autoAdjustOver = props.autoAdjustOverflow, autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver;
        return builtinPlacements || (0, $1fd9c20f0ad1eb86$var$_placements["default"])({
            arrowPointAtCenter: arrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow
        });
    };
    // 动态设置动画点
    var onPopupAlign = function onPopupAlign(domNode, align) {
        var placements = getTooltipPlacements();
        // 当前返回的位置
        var placement = Object.keys(placements).find(function(key) {
            var _a, _b;
            return placements[key].points[0] === ((_a = align.points) === null || _a === void 0 ? void 0 : _a[0]) && placements[key].points[1] === ((_b = align.points) === null || _b === void 0 ? void 0 : _b[1]);
        });
        if (!placement) return;
        // 根据当前坐标设置动画点
        var rect = domNode.getBoundingClientRect();
        var transformOrigin = {
            top: '50%',
            left: '50%'
        };
        if (/top|Bottom/.test(placement)) transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
        else if (/Top|bottom/.test(placement)) transformOrigin.top = "".concat(-align.offset[1], "px");
        if (/left|Right/.test(placement)) transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
        else if (/right|Left/.test(placement)) transformOrigin.left = "".concat(-align.offset[0], "px");
        domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };
    var getOverlay = function getOverlay() {
        var title = props.title, overlay = props.overlay;
        if (title === 0) return title;
        return overlay || title || '';
    };
    var getPopupContainer = props.getPopupContainer, _props$placement = props.placement, placement = _props$placement === void 0 ? 'top' : _props$placement, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.1 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, otherProps = $1fd9c20f0ad1eb86$var$__rest(props, [
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay"
    ]);
    var customizePrefixCls = props.prefixCls, openClassName = props.openClassName, getTooltipContainer = props.getTooltipContainer, overlayClassName = props.overlayClassName, color = props.color, overlayInnerStyle = props.overlayInnerStyle, children = props.children;
    var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && !('visible' in props) && isNoTitle()) tempOpen = false;
    var child = $1fd9c20f0ad1eb86$var$getDisabledCompatibleChildren((0, $8hTO8.isValidElement)(children) && !(0, $8hTO8.isFragment)(children) ? children : /*#__PURE__*/ $1fd9c20f0ad1eb86$var$React.createElement("span", null, children), prefixCls);
    var childProps = child.props;
    var childCls = !childProps.className || typeof childProps.className === 'string' ? (0, $1fd9c20f0ad1eb86$var$_classnames["default"])(childProps.className, (0, $1fd9c20f0ad1eb86$var$_defineProperty2["default"])({}, openClassName || "".concat(prefixCls, "-open"), true)) : childProps.className;
    var customOverlayClassName = (0, $1fd9c20f0ad1eb86$var$_classnames["default"])(overlayClassName, (0, $1fd9c20f0ad1eb86$var$_defineProperty2["default"])((0, $1fd9c20f0ad1eb86$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(color), color && $1fd9c20f0ad1eb86$var$PresetColorRegex.test(color)));
    var formattedOverlayInnerStyle = overlayInnerStyle;
    var arrowContentStyle = {};
    if (color && !$1fd9c20f0ad1eb86$var$PresetColorRegex.test(color)) {
        formattedOverlayInnerStyle = (0, $1fd9c20f0ad1eb86$var$_extends2["default"])((0, $1fd9c20f0ad1eb86$var$_extends2["default"])({}, overlayInnerStyle), {
            background: color
        });
        // @ts-ignore
        arrowContentStyle = {
            '--antd-arrow-background-color': color
        };
    }
    return /*#__PURE__*/ $1fd9c20f0ad1eb86$var$React.createElement($1fd9c20f0ad1eb86$var$_rcTooltip["default"], (0, $1fd9c20f0ad1eb86$var$_extends2["default"])({}, otherProps, {
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        overlayClassName: customOverlayClassName,
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: ref,
        builtinPlacements: getTooltipPlacements(),
        overlay: getOverlay(),
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        onPopupAlign: onPopupAlign,
        overlayInnerStyle: formattedOverlayInnerStyle,
        arrowContent: /*#__PURE__*/ $1fd9c20f0ad1eb86$var$React.createElement("span", {
            className: "".concat(prefixCls, "-arrow-content"),
            style: arrowContentStyle
        }),
        motion: {
            motionName: (0, $2F6xM.getTransitionName)(rootPrefixCls, 'zoom-big-fast', props.transitionName),
            motionDeadline: 1000
        }
    }), tempOpen ? (0, $8hTO8.cloneElement)(child, {
        className: childCls
    }) : child);
});
var $1fd9c20f0ad1eb86$var$_default = module.exports["default"] = $1fd9c20f0ad1eb86$var$Tooltip;

});
parcelRegister("3f57q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PresetStatusColorTypes = module.exports.PresetColorTypes = void 0;

var $3YGhB = parcelRequire("3YGhB");
var $25c6be49574759ef$var$PresetStatusColorTypes = module.exports.PresetStatusColorTypes = (0, $3YGhB.tuple)('success', 'processing', 'error', 'default', 'warning');
// eslint-disable-next-line import/prefer-default-export
var $25c6be49574759ef$var$PresetColorTypes = module.exports.PresetColorTypes = (0, $3YGhB.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');

});

parcelRegister("9D74w", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $702d3de6063304cd$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $702d3de6063304cd$var$getPlacements;
module.exports.getOverflowOptions = $702d3de6063304cd$var$getOverflowOptions;

var $702d3de6063304cd$var$_extends2 = $702d3de6063304cd$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $jgaJw = parcelRequire("jgaJw");
var $702d3de6063304cd$var$autoAdjustOverflowEnabled = {
    adjustX: 1,
    adjustY: 1
};
var $702d3de6063304cd$var$autoAdjustOverflowDisabled = {
    adjustX: 0,
    adjustY: 0
};
var $702d3de6063304cd$var$targetOffset = [
    0,
    0
];
function $702d3de6063304cd$var$getOverflowOptions(autoAdjustOverflow) {
    if (typeof autoAdjustOverflow === 'boolean') return autoAdjustOverflow ? $702d3de6063304cd$var$autoAdjustOverflowEnabled : $702d3de6063304cd$var$autoAdjustOverflowDisabled;
    return (0, $702d3de6063304cd$var$_extends2["default"])((0, $702d3de6063304cd$var$_extends2["default"])({}, $702d3de6063304cd$var$autoAdjustOverflowDisabled), autoAdjustOverflow);
}
function $702d3de6063304cd$var$getPlacements(config) {
    var _config$arrowWidth = config.arrowWidth, arrowWidth = _config$arrowWidth === void 0 ? 4 : _config$arrowWidth, _config$horizontalArr = config.horizontalArrowShift, horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr, _config$verticalArrow = config.verticalArrowShift, verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow, autoAdjustOverflow = config.autoAdjustOverflow, arrowPointAtCenter = config.arrowPointAtCenter;
    var placementMap = {
        left: {
            points: [
                'cr',
                'cl'
            ],
            offset: [
                -4,
                0
            ]
        },
        right: {
            points: [
                'cl',
                'cr'
            ],
            offset: [
                4,
                0
            ]
        },
        top: {
            points: [
                'bc',
                'tc'
            ],
            offset: [
                0,
                -4
            ]
        },
        bottom: {
            points: [
                'tc',
                'bc'
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            points: [
                'bl',
                'tc'
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                -4
            ]
        },
        leftTop: {
            points: [
                'tr',
                'cl'
            ],
            offset: [
                -4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        topRight: {
            points: [
                'br',
                'tc'
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                -4
            ]
        },
        rightTop: {
            points: [
                'tl',
                'cr'
            ],
            offset: [
                4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        bottomRight: {
            points: [
                'tr',
                'bc'
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                4
            ]
        },
        rightBottom: {
            points: [
                'bl',
                'cr'
            ],
            offset: [
                4,
                verticalArrowShift + arrowWidth
            ]
        },
        bottomLeft: {
            points: [
                'tl',
                'bc'
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                4
            ]
        },
        leftBottom: {
            points: [
                'br',
                'cl'
            ],
            offset: [
                -4,
                verticalArrowShift + arrowWidth
            ]
        }
    };
    Object.keys(placementMap).forEach(function(key) {
        placementMap[key] = arrowPointAtCenter ? (0, $702d3de6063304cd$var$_extends2["default"])((0, $702d3de6063304cd$var$_extends2["default"])({}, placementMap[key]), {
            overflow: $702d3de6063304cd$var$getOverflowOptions(autoAdjustOverflow),
            targetOffset: $702d3de6063304cd$var$targetOffset
        }) : (0, $702d3de6063304cd$var$_extends2["default"])((0, $702d3de6063304cd$var$_extends2["default"])({}, $jgaJw.placements[key]), {
            overflow: $702d3de6063304cd$var$getOverflowOptions(autoAdjustOverflow)
        });
        placementMap[key].ignoreShake = true;
    });
    return placementMap;
}

});
parcelRegister("jgaJw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.placements = void 0;
var $e057d659b52de46f$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $e057d659b52de46f$var$targetOffset = [
    0,
    0
];
var $e057d659b52de46f$var$placements = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $e057d659b52de46f$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $e057d659b52de46f$var$targetOffset
    }
};
module.exports.placements = $e057d659b52de46f$var$placements;
var $e057d659b52de46f$var$_default = $e057d659b52de46f$var$placements;
module.exports.default = $e057d659b52de46f$var$_default;

});



parcelRegister("9UAmG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $acw62 = parcelRequire("acw62");
var $73758d4ed6efcb39$var$MenuContext = /*#__PURE__*/ (0, $acw62.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false
});
var $73758d4ed6efcb39$var$_default = module.exports["default"] = $73758d4ed6efcb39$var$MenuContext;

});


parcelRegister("feMq6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b17db9027934afef$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b17db9027934afef$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b17db9027934afef$var$_extends2 = $b17db9027934afef$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $b17db9027934afef$var$_classnames = $b17db9027934afef$var$_interopRequireDefault((parcelRequire("8g1PZ")));
parcelRequire("feYPt");
var $gASnm = parcelRequire("gASnm");
var $a8XZl = parcelRequire("a8XZl");

var $b17db9027934afef$var$_omit = $b17db9027934afef$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $b17db9027934afef$var$React = $b17db9027934afef$var$_interopRequireWildcard((parcelRequire("acw62")));

var $8hTO8 = parcelRequire("8hTO8");

var $b17db9027934afef$var$_MenuContext = $b17db9027934afef$var$_interopRequireDefault((parcelRequire("9UAmG")));
function $b17db9027934afef$var$SubMenu(props) {
    var _a;
    var popupClassName = props.popupClassName, icon = props.icon, title = props.title, theme = props.theme;
    var context = $b17db9027934afef$var$React.useContext($b17db9027934afef$var$_MenuContext["default"]);
    var prefixCls = context.prefixCls, inlineCollapsed = context.inlineCollapsed, antdMenuTheme = context.antdMenuTheme;
    var parentPath = (0, $a8XZl.useFullPath)();
    var titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $b17db9027934afef$var$React.createElement("div", {
        className: "".concat(prefixCls, "-inline-collapsed-noicon")
    }, title.charAt(0)) : /*#__PURE__*/ $b17db9027934afef$var$React.createElement("span", {
        className: "".concat(prefixCls, "-title-content")
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        var titleIsSpan = (0, $8hTO8.isValidElement)(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $b17db9027934afef$var$React.createElement($b17db9027934afef$var$React.Fragment, null, (0, $8hTO8.cloneElement)(icon, {
            className: (0, $b17db9027934afef$var$_classnames["default"])((0, $8hTO8.isValidElement)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
        }), titleIsSpan ? title : /*#__PURE__*/ $b17db9027934afef$var$React.createElement("span", {
            className: "".concat(prefixCls, "-title-content")
        }, title));
    }
    var contextValue = $b17db9027934afef$var$React.useMemo(function() {
        return (0, $b17db9027934afef$var$_extends2["default"])((0, $b17db9027934afef$var$_extends2["default"])({}, context), {
            firstLevel: false
        });
    }, [
        context
    ]);
    return /*#__PURE__*/ $b17db9027934afef$var$React.createElement($b17db9027934afef$var$_MenuContext["default"].Provider, {
        value: contextValue
    }, /*#__PURE__*/ $b17db9027934afef$var$React.createElement($gASnm.default, (0, $b17db9027934afef$var$_extends2["default"])({}, (0, $b17db9027934afef$var$_omit["default"])(props, [
        'icon'
    ]), {
        title: titleNode,
        popupClassName: (0, $b17db9027934afef$var$_classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(theme || antdMenuTheme), popupClassName)
    })));
}
var $b17db9027934afef$var$_default = module.exports["default"] = $b17db9027934afef$var$SubMenu;

});


parcelRegister("jYLoz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e8b862a87abafd23$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e8b862a87abafd23$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.OverrideProvider = void 0;

var $e8b862a87abafd23$var$_extends2 = $e8b862a87abafd23$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $e8b862a87abafd23$var$React = $e8b862a87abafd23$var$_interopRequireWildcard((parcelRequire("acw62")));
var $e8b862a87abafd23$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/** @internal Only used for Dropdown component. Do not use this in your production. */ var $e8b862a87abafd23$var$OverrideContext = /*#__PURE__*/ $e8b862a87abafd23$var$React.createContext(null);
/** @internal Only used for Dropdown component. Do not use this in your production. */ var $e8b862a87abafd23$var$OverrideProvider = module.exports.OverrideProvider = function OverrideProvider(_a) {
    var children = _a.children, restProps = $e8b862a87abafd23$var$__rest(_a, [
        "children"
    ]);
    var override = $e8b862a87abafd23$var$React.useContext($e8b862a87abafd23$var$OverrideContext);
    var context = $e8b862a87abafd23$var$React.useMemo(function() {
        return (0, $e8b862a87abafd23$var$_extends2["default"])((0, $e8b862a87abafd23$var$_extends2["default"])({}, override), restProps);
    }, [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable
    ]);
    return /*#__PURE__*/ $e8b862a87abafd23$var$React.createElement($e8b862a87abafd23$var$OverrideContext.Provider, {
        value: context
    }, children);
};
var $e8b862a87abafd23$var$_default = module.exports["default"] = $e8b862a87abafd23$var$OverrideContext;

});


parcelRegister("lJ7by", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fd135fca3ec32e8d$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fd135fca3ec32e8d$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $fd135fca3ec32e8d$var$_extends2 = $fd135fca3ec32e8d$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $fd135fca3ec32e8d$var$_slicedToArray2 = $fd135fca3ec32e8d$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $fd135fca3ec32e8d$var$_EllipsisOutlined = $fd135fca3ec32e8d$var$_interopRequireDefault((parcelRequire("4B3PS")));

var $fd135fca3ec32e8d$var$_classnames = $fd135fca3ec32e8d$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $fd135fca3ec32e8d$var$React = $fd135fca3ec32e8d$var$_interopRequireWildcard((parcelRequire("acw62")));

var $fd135fca3ec32e8d$var$_button = $fd135fca3ec32e8d$var$_interopRequireDefault((parcelRequire("efUnK")));

var $qBua1 = parcelRequire("qBua1");

var $hvVUy = parcelRequire("hvVUy");

var $fd135fca3ec32e8d$var$_dropdown = $fd135fca3ec32e8d$var$_interopRequireDefault((parcelRequire("11Ahf")));

var $fd135fca3ec32e8d$var$_space = $fd135fca3ec32e8d$var$_interopRequireDefault((parcelRequire("hgBDa")));
var $fd135fca3ec32e8d$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fd135fca3ec32e8d$var$DropdownButton = function DropdownButton(props) {
    var _React$useContext = $fd135fca3ec32e8d$var$React.useContext($qBua1.ConfigContext), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? 'default' : _props$type, danger = props.danger, disabled = props.disabled, loading = props.loading, onClick = props.onClick, htmlType = props.htmlType, children = props.children, className = props.className, menu = props.menu, arrow = props.arrow, autoFocus = props.autoFocus, overlay = props.overlay, trigger = props.trigger, align = props.align, visible = props.visible, open = props.open, onVisibleChange = props.onVisibleChange, onOpenChange = props.onOpenChange, placement = props.placement, getPopupContainer = props.getPopupContainer, href = props.href, _props$icon = props.icon, icon = _props$icon === void 0 ? /*#__PURE__*/ $fd135fca3ec32e8d$var$React.createElement($fd135fca3ec32e8d$var$_EllipsisOutlined["default"], null) : _props$icon, title = props.title, _props$buttonsRender = props.buttonsRender, buttonsRender = _props$buttonsRender === void 0 ? function(buttons) {
        return buttons;
    } : _props$buttonsRender, mouseEnterDelay = props.mouseEnterDelay, mouseLeaveDelay = props.mouseLeaveDelay, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, destroyPopupOnHide = props.destroyPopupOnHide, restProps = $fd135fca3ec32e8d$var$__rest(props, [
        "prefixCls",
        "type",
        "danger",
        "disabled",
        "loading",
        "onClick",
        "htmlType",
        "children",
        "className",
        "menu",
        "arrow",
        "autoFocus",
        "overlay",
        "trigger",
        "align",
        "visible",
        "open",
        "onVisibleChange",
        "onOpenChange",
        "placement",
        "getPopupContainer",
        "href",
        "icon",
        "title",
        "buttonsRender",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayClassName",
        "overlayStyle",
        "destroyPopupOnHide"
    ]);
    var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
    var dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange || onVisibleChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayClassName: overlayClassName,
        overlayStyle: overlayStyle,
        destroyPopupOnHide: destroyPopupOnHide
    };
    var _useCompactItemContex = (0, $hvVUy.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var classes = (0, $fd135fca3ec32e8d$var$_classnames["default"])(prefixCls, compactItemClassnames, className);
    if ('overlay' in props) dropdownProps.overlay = overlay;
    if ('open' in props) dropdownProps.open = open;
    else if ('visible' in props) dropdownProps.open = visible;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    var leftButton = /*#__PURE__*/ $fd135fca3ec32e8d$var$React.createElement($fd135fca3ec32e8d$var$_button["default"], {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    var rightButton = /*#__PURE__*/ $fd135fca3ec32e8d$var$React.createElement($fd135fca3ec32e8d$var$_button["default"], {
        type: type,
        danger: danger,
        icon: icon
    });
    var _buttonsRender = buttonsRender([
        leftButton,
        rightButton
    ]), _buttonsRender2 = (0, $fd135fca3ec32e8d$var$_slicedToArray2["default"])(_buttonsRender, 2), leftButtonToRender = _buttonsRender2[0], rightButtonToRender = _buttonsRender2[1];
    return /*#__PURE__*/ $fd135fca3ec32e8d$var$React.createElement($fd135fca3ec32e8d$var$_space["default"].Compact, (0, $fd135fca3ec32e8d$var$_extends2["default"])({
        className: classes,
        size: compactSize,
        block: true
    }, restProps), leftButtonToRender, /*#__PURE__*/ $fd135fca3ec32e8d$var$React.createElement($fd135fca3ec32e8d$var$_dropdown["default"], (0, $fd135fca3ec32e8d$var$_extends2["default"])({}, dropdownProps), rightButtonToRender));
};
$fd135fca3ec32e8d$var$DropdownButton.__ANT_BUTTON = true;
var $fd135fca3ec32e8d$var$_default = module.exports["default"] = $fd135fca3ec32e8d$var$DropdownButton;

});
parcelRegister("hgBDa", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c9211ef74c778ec0$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c9211ef74c778ec0$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.SpaceContext = void 0;

var $c9211ef74c778ec0$var$_extends2 = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $c9211ef74c778ec0$var$_defineProperty2 = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $c9211ef74c778ec0$var$_slicedToArray2 = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $c9211ef74c778ec0$var$_classnames = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $c9211ef74c778ec0$var$_toArray = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("13r7s")));

var $c9211ef74c778ec0$var$React = $c9211ef74c778ec0$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $c9211ef74c778ec0$var$_useFlexGapSupport = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("e8xav")));

var $c9211ef74c778ec0$var$_Item = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("l6tMh")));

var $c9211ef74c778ec0$var$_Compact = $c9211ef74c778ec0$var$_interopRequireDefault((parcelRequire("hvVUy")));
var $c9211ef74c778ec0$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c9211ef74c778ec0$var$SpaceContext = module.exports.SpaceContext = /*#__PURE__*/ $c9211ef74c778ec0$var$React.createContext({
    latestIndex: 0,
    horizontalSize: 0,
    verticalSize: 0,
    supportFlexGap: false
});
var $c9211ef74c778ec0$var$spaceSize = {
    small: 8,
    middle: 16,
    large: 24
};
function $c9211ef74c778ec0$var$getNumberSize(size) {
    return typeof size === 'string' ? $c9211ef74c778ec0$var$spaceSize[size] : size || 0;
}
var $c9211ef74c778ec0$var$Space = function Space(props) {
    var _React$useContext = $c9211ef74c778ec0$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, space = _React$useContext.space, directionConfig = _React$useContext.direction;
    var _props$size = props.size, size = _props$size === void 0 ? (space === null || space === void 0 ? void 0 : space.size) || 'small' : _props$size, align = props.align, className = props.className, children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'horizontal' : _props$direction, customizePrefixCls = props.prefixCls, split = props.split, style = props.style, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? false : _props$wrap, otherProps = $c9211ef74c778ec0$var$__rest(props, [
        "size",
        "align",
        "className",
        "children",
        "direction",
        "prefixCls",
        "split",
        "style",
        "wrap"
    ]);
    var supportFlexGap = (0, $c9211ef74c778ec0$var$_useFlexGapSupport["default"])();
    var _React$useMemo = $c9211ef74c778ec0$var$React.useMemo(function() {
        return (Array.isArray(size) ? size : [
            size,
            size
        ]).map(function(item) {
            return $c9211ef74c778ec0$var$getNumberSize(item);
        });
    }, [
        size
    ]), _React$useMemo2 = (0, $c9211ef74c778ec0$var$_slicedToArray2["default"])(_React$useMemo, 2), horizontalSize = _React$useMemo2[0], verticalSize = _React$useMemo2[1];
    var childNodes = (0, $c9211ef74c778ec0$var$_toArray["default"])(children, {
        keepEmpty: true
    });
    var mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
    var prefixCls = getPrefixCls('space', customizePrefixCls);
    var cn = (0, $c9211ef74c778ec0$var$_classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(direction), (0, $c9211ef74c778ec0$var$_defineProperty2["default"])((0, $c9211ef74c778ec0$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), directionConfig === 'rtl'), "".concat(prefixCls, "-align-").concat(mergedAlign), mergedAlign), className);
    var itemClassName = "".concat(prefixCls, "-item");
    var marginDirection = directionConfig === 'rtl' ? 'marginLeft' : 'marginRight';
    // Calculate latest one
    var latestIndex = 0;
    var nodes = childNodes.map(function(child, i) {
        if (child !== null && child !== undefined) latestIndex = i;
        var key = child && child.key || "".concat(itemClassName, "-").concat(i);
        return /*#__PURE__*/ $c9211ef74c778ec0$var$React.createElement($c9211ef74c778ec0$var$_Item["default"], {
            className: itemClassName,
            key: key,
            direction: direction,
            index: i,
            marginDirection: marginDirection,
            split: split,
            wrap: wrap
        }, child);
    });
    var spaceContext = $c9211ef74c778ec0$var$React.useMemo(function() {
        return {
            horizontalSize: horizontalSize,
            verticalSize: verticalSize,
            latestIndex: latestIndex,
            supportFlexGap: supportFlexGap
        };
    }, [
        horizontalSize,
        verticalSize,
        latestIndex,
        supportFlexGap
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    var gapStyle = {};
    if (wrap) {
        gapStyle.flexWrap = 'wrap';
        // Patch for gap not support
        if (!supportFlexGap) gapStyle.marginBottom = -verticalSize;
    }
    if (supportFlexGap) {
        gapStyle.columnGap = horizontalSize;
        gapStyle.rowGap = verticalSize;
    }
    return /*#__PURE__*/ $c9211ef74c778ec0$var$React.createElement("div", (0, $c9211ef74c778ec0$var$_extends2["default"])({
        className: cn,
        style: (0, $c9211ef74c778ec0$var$_extends2["default"])((0, $c9211ef74c778ec0$var$_extends2["default"])({}, gapStyle), style)
    }, otherProps), /*#__PURE__*/ $c9211ef74c778ec0$var$React.createElement($c9211ef74c778ec0$var$SpaceContext.Provider, {
        value: spaceContext
    }, nodes));
};
var $c9211ef74c778ec0$var$CompoundedSpace = $c9211ef74c778ec0$var$Space;
$c9211ef74c778ec0$var$CompoundedSpace.Compact = $c9211ef74c778ec0$var$_Compact["default"];
var $c9211ef74c778ec0$var$_default = module.exports["default"] = $c9211ef74c778ec0$var$CompoundedSpace;

});
parcelRegister("e8xav", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a4ab8a9bd9a5a7c8$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a4ab8a9bd9a5a7c8$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a4ab8a9bd9a5a7c8$var$_slicedToArray2 = $a4ab8a9bd9a5a7c8$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $a4ab8a9bd9a5a7c8$var$React = $a4ab8a9bd9a5a7c8$var$_interopRequireWildcard((parcelRequire("acw62")));

var $2wqJe = parcelRequire("2wqJe");
var $a4ab8a9bd9a5a7c8$var$_default = module.exports["default"] = function _default() {
    var _React$useState = $a4ab8a9bd9a5a7c8$var$React.useState(false), _React$useState2 = (0, $a4ab8a9bd9a5a7c8$var$_slicedToArray2["default"])(_React$useState, 2), flexible = _React$useState2[0], setFlexible = _React$useState2[1];
    $a4ab8a9bd9a5a7c8$var$React.useEffect(function() {
        setFlexible((0, $2wqJe.detectFlexGapSupported)());
    }, []);
    return flexible;
};

});
parcelRegister("2wqJe", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1d634daa2cfed02a$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.detectFlexGapSupported = module.exports.canUseDocElement = void 0;
Object.defineProperty(module.exports, "isStyleSupport", {
    enumerable: true,
    get: function get() {
        return $cHasD.isStyleSupport;
    }
});

var $1d634daa2cfed02a$var$_canUseDom = $1d634daa2cfed02a$var$_interopRequireDefault((parcelRequire("fpCN2")));

var $cHasD = parcelRequire("cHasD");
var $1d634daa2cfed02a$var$canUseDocElement = module.exports.canUseDocElement = function canUseDocElement() {
    return (0, $1d634daa2cfed02a$var$_canUseDom["default"])() && window.document.documentElement;
};
var $1d634daa2cfed02a$var$flexGapSupported;
var $1d634daa2cfed02a$var$detectFlexGapSupported = module.exports.detectFlexGapSupported = function detectFlexGapSupported() {
    if (!$1d634daa2cfed02a$var$canUseDocElement()) return false;
    if ($1d634daa2cfed02a$var$flexGapSupported !== undefined) return $1d634daa2cfed02a$var$flexGapSupported;
    // create flex container with row-gap set
    var flex = document.createElement('div');
    flex.style.display = 'flex';
    flex.style.flexDirection = 'column';
    flex.style.rowGap = '1px';
    // create two, elements inside it
    flex.appendChild(document.createElement('div'));
    flex.appendChild(document.createElement('div'));
    // append to the DOM (needed to obtain scrollHeight)
    document.body.appendChild(flex);
    $1d634daa2cfed02a$var$flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
    document.body.removeChild(flex);
    return $1d634daa2cfed02a$var$flexGapSupported;
};

});


parcelRegister("l6tMh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f5d141c560f5ca3a$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f5d141c560f5ca3a$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f5d141c560f5ca3a$var$Item;

var $f5d141c560f5ca3a$var$_defineProperty2 = $f5d141c560f5ca3a$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $f5d141c560f5ca3a$var$_extends2 = $f5d141c560f5ca3a$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $f5d141c560f5ca3a$var$React = $f5d141c560f5ca3a$var$_interopRequireWildcard((parcelRequire("acw62")));

var $hgBDa = parcelRequire("hgBDa");
function $f5d141c560f5ca3a$var$Item(_ref) {
    var className = _ref.className, direction = _ref.direction, index = _ref.index, marginDirection = _ref.marginDirection, children = _ref.children, split = _ref.split, wrap = _ref.wrap;
    var _React$useContext = $f5d141c560f5ca3a$var$React.useContext($hgBDa.SpaceContext), horizontalSize = _React$useContext.horizontalSize, verticalSize = _React$useContext.verticalSize, latestIndex = _React$useContext.latestIndex, supportFlexGap = _React$useContext.supportFlexGap;
    var style = {};
    if (!supportFlexGap) {
        if (direction === 'vertical') {
            if (index < latestIndex) style = {
                marginBottom: horizontalSize / (split ? 2 : 1)
            };
        } else style = (0, $f5d141c560f5ca3a$var$_extends2["default"])((0, $f5d141c560f5ca3a$var$_extends2["default"])({}, index < latestIndex && (0, $f5d141c560f5ca3a$var$_defineProperty2["default"])({}, marginDirection, horizontalSize / (split ? 2 : 1))), wrap && {
            paddingBottom: verticalSize
        });
    }
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $f5d141c560f5ca3a$var$React.createElement($f5d141c560f5ca3a$var$React.Fragment, null, /*#__PURE__*/ $f5d141c560f5ca3a$var$React.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && split && /*#__PURE__*/ $f5d141c560f5ca3a$var$React.createElement("span", {
        className: "".concat(className, "-split"),
        style: style
    }, split));
}

});





parcelRegister("9wjAb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $01c9e86f21b6a6b0$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function get() {
        return $01c9e86f21b6a6b0$var$_radioButton["default"];
    }
});
Object.defineProperty(module.exports, "Group", {
    enumerable: true,
    get: function get() {
        return $01c9e86f21b6a6b0$var$_group["default"];
    }
});
module.exports["default"] = void 0;

var $01c9e86f21b6a6b0$var$_group = $01c9e86f21b6a6b0$var$_interopRequireDefault((parcelRequire("TXYAn")));

var $01c9e86f21b6a6b0$var$_radio = $01c9e86f21b6a6b0$var$_interopRequireDefault((parcelRequire("1w030")));

var $01c9e86f21b6a6b0$var$_radioButton = $01c9e86f21b6a6b0$var$_interopRequireDefault((parcelRequire("fAxHY")));
var $01c9e86f21b6a6b0$var$Radio = $01c9e86f21b6a6b0$var$_radio["default"];
$01c9e86f21b6a6b0$var$Radio.Button = $01c9e86f21b6a6b0$var$_radioButton["default"];
$01c9e86f21b6a6b0$var$Radio.Group = $01c9e86f21b6a6b0$var$_group["default"];
$01c9e86f21b6a6b0$var$Radio.__ANT_RADIO = true;
var $01c9e86f21b6a6b0$var$_default = module.exports["default"] = $01c9e86f21b6a6b0$var$Radio;

});
parcelRegister("TXYAn", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0a83a930ca8e0461$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0a83a930ca8e0461$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0a83a930ca8e0461$var$_extends2 = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $0a83a930ca8e0461$var$_defineProperty2 = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $0a83a930ca8e0461$var$_slicedToArray2 = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $0a83a930ca8e0461$var$_classnames = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0a83a930ca8e0461$var$_useMergedState3 = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("7CJZj")));

var $0a83a930ca8e0461$var$React = $0a83a930ca8e0461$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $0a83a930ca8e0461$var$_SizeContext = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("lGUuX")));

var $0a83a930ca8e0461$var$_getDataOrAriaProps = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("aEAUe")));

var $iyK2w = parcelRequire("iyK2w");

var $0a83a930ca8e0461$var$_radio = $0a83a930ca8e0461$var$_interopRequireDefault((parcelRequire("1w030")));
var $0a83a930ca8e0461$var$RadioGroup = /*#__PURE__*/ $0a83a930ca8e0461$var$React.forwardRef(function(props, ref) {
    var _React$useContext = $0a83a930ca8e0461$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $0a83a930ca8e0461$var$React.useContext($0a83a930ca8e0461$var$_SizeContext["default"]);
    var _useMergedState = (0, $0a83a930ca8e0461$var$_useMergedState3["default"])(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $0a83a930ca8e0461$var$_slicedToArray2["default"])(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var onRadioChange = function onRadioChange(ev) {
        var lastValue = value;
        var val = ev.target.value;
        if (!('value' in props)) setValue(val);
        var onChange = props.onChange;
        if (onChange && val !== lastValue) onChange(ev);
    };
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, options = props.options, _props$buttonStyle = props.buttonStyle, buttonStyle = _props$buttonStyle === void 0 ? 'outline' : _props$buttonStyle, disabled = props.disabled, children = props.children, customizeSize = props.size, style = props.style, id = props.id, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onFocus = props.onFocus, onBlur = props.onBlur;
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map(function(option) {
        if (typeof option === 'string' || typeof option === 'number') // 此处类型自动推导为 string
        return /*#__PURE__*/ $0a83a930ca8e0461$var$React.createElement($0a83a930ca8e0461$var$_radio["default"], {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $0a83a930ca8e0461$var$React.createElement($0a83a930ca8e0461$var$_radio["default"], {
            key: "radio-group-value-options-".concat(option.value),
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            style: option.style
        }, option.label);
    });
    var mergedSize = customizeSize || size;
    var classString = (0, $0a83a930ca8e0461$var$_classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (0, $0a83a930ca8e0461$var$_defineProperty2["default"])((0, $0a83a930ca8e0461$var$_defineProperty2["default"])({}, "".concat(groupPrefixCls, "-").concat(mergedSize), mergedSize), "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $0a83a930ca8e0461$var$React.createElement("div", (0, $0a83a930ca8e0461$var$_extends2["default"])({}, (0, $0a83a930ca8e0461$var$_getDataOrAriaProps["default"])(props), {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }), /*#__PURE__*/ $0a83a930ca8e0461$var$React.createElement($iyK2w.RadioGroupContextProvider, {
        value: {
            onChange: onRadioChange,
            value: value,
            disabled: props.disabled,
            name: props.name,
            optionType: props.optionType
        }
    }, childrenToRender));
});
var $0a83a930ca8e0461$var$_default = module.exports["default"] = /*#__PURE__*/ $0a83a930ca8e0461$var$React.memo($0a83a930ca8e0461$var$RadioGroup);

});
parcelRegister("aEAUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $7c1a44935d11c2ab$var$getDataOrAriaProps;
function $7c1a44935d11c2ab$var$getDataOrAriaProps(props) {
    return Object.keys(props).reduce(function(prev, key) {
        if ((key.startsWith('data-') || key.startsWith('aria-') || key === 'role') && !key.startsWith('data-__')) prev[key] = props[key];
        return prev;
    }, {});
}

});

parcelRegister("iyK2w", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d82f1d77ec8a2a2a$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.RadioOptionTypeContextProvider = module.exports.RadioOptionTypeContext = module.exports.RadioGroupContextProvider = void 0;

var $d82f1d77ec8a2a2a$var$React = $d82f1d77ec8a2a2a$var$_interopRequireWildcard((parcelRequire("acw62")));
var $d82f1d77ec8a2a2a$var$RadioGroupContext = /*#__PURE__*/ $d82f1d77ec8a2a2a$var$React.createContext(null);
var $d82f1d77ec8a2a2a$var$RadioGroupContextProvider = module.exports.RadioGroupContextProvider = $d82f1d77ec8a2a2a$var$RadioGroupContext.Provider;
var $d82f1d77ec8a2a2a$var$_default = module.exports["default"] = $d82f1d77ec8a2a2a$var$RadioGroupContext;
var $d82f1d77ec8a2a2a$var$RadioOptionTypeContext = module.exports.RadioOptionTypeContext = /*#__PURE__*/ $d82f1d77ec8a2a2a$var$React.createContext(null);
var $d82f1d77ec8a2a2a$var$RadioOptionTypeContextProvider = module.exports.RadioOptionTypeContextProvider = $d82f1d77ec8a2a2a$var$RadioOptionTypeContext.Provider;

});

parcelRegister("1w030", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $11a8d10b78502a39$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $11a8d10b78502a39$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $11a8d10b78502a39$var$_defineProperty2 = $11a8d10b78502a39$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $11a8d10b78502a39$var$_extends2 = $11a8d10b78502a39$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $11a8d10b78502a39$var$_classnames = $11a8d10b78502a39$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $11a8d10b78502a39$var$_rcCheckbox = $11a8d10b78502a39$var$_interopRequireDefault((parcelRequire("fAiwY")));

var $1XVSR = parcelRequire("1XVSR");

var $11a8d10b78502a39$var$_react = $11a8d10b78502a39$var$_interopRequireWildcard((parcelRequire("acw62")));
var $11a8d10b78502a39$var$React = $11a8d10b78502a39$var$_react;

var $qBua1 = parcelRequire("qBua1");

var $11a8d10b78502a39$var$_DisabledContext = $11a8d10b78502a39$var$_interopRequireDefault((parcelRequire("bzUGe")));

var $gJD51 = parcelRequire("gJD51");

var $11a8d10b78502a39$var$_warning = $11a8d10b78502a39$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $11a8d10b78502a39$var$_context2 = $11a8d10b78502a39$var$_interopRequireWildcard((parcelRequire("iyK2w")));
var $11a8d10b78502a39$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $11a8d10b78502a39$var$InternalRadio = function InternalRadio(props, ref) {
    var _a, _b;
    var groupContext = $11a8d10b78502a39$var$React.useContext($11a8d10b78502a39$var$_context2["default"]);
    var radioOptionTypeContext = $11a8d10b78502a39$var$React.useContext($11a8d10b78502a39$var$_context2.RadioOptionTypeContext);
    var _React$useContext = $11a8d10b78502a39$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var innerRef = $11a8d10b78502a39$var$React.useRef();
    var mergedRef = (0, $1XVSR.composeRef)(ref, innerRef);
    var _useContext = (0, $11a8d10b78502a39$var$_react.useContext)($gJD51.FormItemInputContext), isFormItemInput = _useContext.isFormItemInput;
    var onChange = function onChange(e) {
        var _a, _b;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e);
        (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b === void 0 || _b.call(groupContext, e);
    };
    var customizePrefixCls = props.prefixCls, className = props.className, children = props.children, style = props.style, restProps = $11a8d10b78502a39$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "style"
    ]);
    var radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    var prefixCls = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === 'button' ? "".concat(radioPrefixCls, "-button") : radioPrefixCls;
    var radioProps = (0, $11a8d10b78502a39$var$_extends2["default"])({}, restProps);
    // ===================== Disabled =====================
    var disabled = $11a8d10b78502a39$var$React.useContext($11a8d10b78502a39$var$_DisabledContext["default"]);
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
    }
    radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
    var wrapperClassString = (0, $11a8d10b78502a39$var$_classnames["default"])("".concat(prefixCls, "-wrapper"), (0, $11a8d10b78502a39$var$_defineProperty2["default"])((0, $11a8d10b78502a39$var$_defineProperty2["default"])((0, $11a8d10b78502a39$var$_defineProperty2["default"])((0, $11a8d10b78502a39$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $11a8d10b78502a39$var$React.createElement("label", {
        className: wrapperClassString,
        style: style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
    }, /*#__PURE__*/ $11a8d10b78502a39$var$React.createElement($11a8d10b78502a39$var$_rcCheckbox["default"], (0, $11a8d10b78502a39$var$_extends2["default"])({}, radioProps, {
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef
    })), children !== undefined ? /*#__PURE__*/ $11a8d10b78502a39$var$React.createElement("span", null, children) : null));
};
var $11a8d10b78502a39$var$Radio = /*#__PURE__*/ $11a8d10b78502a39$var$React.forwardRef($11a8d10b78502a39$var$InternalRadio);
var $11a8d10b78502a39$var$_default = module.exports["default"] = $11a8d10b78502a39$var$Radio;

});


parcelRegister("fAxHY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b5945d8f36d0b5f8$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b5945d8f36d0b5f8$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b5945d8f36d0b5f8$var$_extends2 = $b5945d8f36d0b5f8$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $b5945d8f36d0b5f8$var$React = $b5945d8f36d0b5f8$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $iyK2w = parcelRequire("iyK2w");

var $b5945d8f36d0b5f8$var$_radio = $b5945d8f36d0b5f8$var$_interopRequireDefault((parcelRequire("1w030")));
var $b5945d8f36d0b5f8$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b5945d8f36d0b5f8$var$RadioButton = function RadioButton(props, ref) {
    var _React$useContext = $b5945d8f36d0b5f8$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls;
    var customizePrefixCls = props.prefixCls, radioProps = $b5945d8f36d0b5f8$var$__rest(props, [
        "prefixCls"
    ]);
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ $b5945d8f36d0b5f8$var$React.createElement($iyK2w.RadioOptionTypeContextProvider, {
        value: "button"
    }, /*#__PURE__*/ $b5945d8f36d0b5f8$var$React.createElement($b5945d8f36d0b5f8$var$_radio["default"], (0, $b5945d8f36d0b5f8$var$_extends2["default"])({
        prefixCls: prefixCls
    }, radioProps, {
        type: "radio",
        ref: ref
    })));
};
var $b5945d8f36d0b5f8$var$_default = module.exports["default"] = /*#__PURE__*/ $b5945d8f36d0b5f8$var$React.forwardRef($b5945d8f36d0b5f8$var$RadioButton);

});


parcelRegister("hgdOL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c90ea632d54b560b$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
parcelRequire("8rHfe");
var $5BDlo = parcelRequire("5BDlo");

var $c90ea632d54b560b$var$_Tree = $c90ea632d54b560b$var$_interopRequireDefault((parcelRequire("11K1l")));

var $c90ea632d54b560b$var$_DirectoryTree = $c90ea632d54b560b$var$_interopRequireDefault((parcelRequire("9sLES")));
var $c90ea632d54b560b$var$Tree = $c90ea632d54b560b$var$_Tree["default"];
$c90ea632d54b560b$var$Tree.DirectoryTree = $c90ea632d54b560b$var$_DirectoryTree["default"];
$c90ea632d54b560b$var$Tree.TreeNode = $5BDlo.default;
var $c90ea632d54b560b$var$_default = module.exports["default"] = $c90ea632d54b560b$var$Tree;

});
parcelRegister("11K1l", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0bf9952b0ffa4b7d$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0bf9952b0ffa4b7d$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0bf9952b0ffa4b7d$var$_defineProperty2 = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $0bf9952b0ffa4b7d$var$_typeof2 = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("41YNz")));

var $0bf9952b0ffa4b7d$var$_extends2 = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $0bf9952b0ffa4b7d$var$_HolderOutlined = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("4F03V")));

var $0bf9952b0ffa4b7d$var$_classnames = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $0bf9952b0ffa4b7d$var$_rcTree = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("8rHfe")));

var $0bf9952b0ffa4b7d$var$React = $0bf9952b0ffa4b7d$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $0bf9952b0ffa4b7d$var$_motion = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("2F6xM")));

var $0bf9952b0ffa4b7d$var$_dropIndicator = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("hHcVB")));

var $0bf9952b0ffa4b7d$var$_iconUtil = $0bf9952b0ffa4b7d$var$_interopRequireDefault((parcelRequire("eQzf9")));
var $0bf9952b0ffa4b7d$var$Tree = /*#__PURE__*/ $0bf9952b0ffa4b7d$var$React.forwardRef(function(props, ref) {
    var _React$useContext = $0bf9952b0ffa4b7d$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, virtual = _React$useContext.virtual;
    var customizePrefixCls = props.prefixCls, className = props.className, _props$showIcon = props.showIcon, showIcon = _props$showIcon === void 0 ? false : _props$showIcon, showLine = props.showLine, _switcherIcon = props.switcherIcon, _props$blockNode = props.blockNode, blockNode = _props$blockNode === void 0 ? false : _props$blockNode, children = props.children, _props$checkable = props.checkable, checkable = _props$checkable === void 0 ? false : _props$checkable, _props$selectable = props.selectable, selectable = _props$selectable === void 0 ? true : _props$selectable, draggable = props.draggable, _props$motion = props.motion, motion = _props$motion === void 0 ? (0, $0bf9952b0ffa4b7d$var$_extends2["default"])((0, $0bf9952b0ffa4b7d$var$_extends2["default"])({}, $0bf9952b0ffa4b7d$var$_motion["default"]), {
        motionAppear: false
    }) : _props$motion;
    var prefixCls = getPrefixCls('tree', customizePrefixCls);
    var newProps = (0, $0bf9952b0ffa4b7d$var$_extends2["default"])((0, $0bf9952b0ffa4b7d$var$_extends2["default"])({}, props), {
        checkable: checkable,
        selectable: selectable,
        showIcon: showIcon,
        motion: motion,
        blockNode: blockNode,
        showLine: Boolean(showLine),
        dropIndicatorRender: $0bf9952b0ffa4b7d$var$_dropIndicator["default"]
    });
    var draggableConfig = $0bf9952b0ffa4b7d$var$React.useMemo(function() {
        if (!draggable) return false;
        var mergedDraggable = {};
        switch((0, $0bf9952b0ffa4b7d$var$_typeof2["default"])(draggable)){
            case 'function':
                mergedDraggable.nodeDraggable = draggable;
                break;
            case 'object':
                mergedDraggable = (0, $0bf9952b0ffa4b7d$var$_extends2["default"])({}, draggable);
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ $0bf9952b0ffa4b7d$var$React.createElement($0bf9952b0ffa4b7d$var$_HolderOutlined["default"], null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    return /*#__PURE__*/ $0bf9952b0ffa4b7d$var$React.createElement($0bf9952b0ffa4b7d$var$_rcTree["default"], (0, $0bf9952b0ffa4b7d$var$_extends2["default"])({
        itemHeight: 20,
        ref: ref,
        virtual: virtual
    }, newProps, {
        prefixCls: prefixCls,
        className: (0, $0bf9952b0ffa4b7d$var$_classnames["default"])((0, $0bf9952b0ffa4b7d$var$_defineProperty2["default"])((0, $0bf9952b0ffa4b7d$var$_defineProperty2["default"])((0, $0bf9952b0ffa4b7d$var$_defineProperty2["default"])((0, $0bf9952b0ffa4b7d$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-icon-hide"), !showIcon), "".concat(prefixCls, "-block-node"), blockNode), "".concat(prefixCls, "-unselectable"), !selectable), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className),
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ $0bf9952b0ffa4b7d$var$React.createElement("span", {
            className: "".concat(prefixCls, "-checkbox-inner")
        }) : checkable,
        selectable: selectable,
        switcherIcon: function switcherIcon(nodeProps) {
            return (0, $0bf9952b0ffa4b7d$var$_iconUtil["default"])(prefixCls, _switcherIcon, showLine, nodeProps);
        },
        draggable: draggableConfig
    }), children);
});
var $0bf9952b0ffa4b7d$var$_default = module.exports["default"] = $0bf9952b0ffa4b7d$var$Tree;

});
parcelRegister("4F03V", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $364b0a1ba7be0fdd$var$_HolderOutlined = $364b0a1ba7be0fdd$var$_interopRequireDefault((parcelRequire("6Liyn")));
function $364b0a1ba7be0fdd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $364b0a1ba7be0fdd$var$_default = $364b0a1ba7be0fdd$var$_HolderOutlined;
module.exports.default = $364b0a1ba7be0fdd$var$_default;
module.exports = $364b0a1ba7be0fdd$var$_default;

});
parcelRegister("6Liyn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ec5863521785a33$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $4ec5863521785a33$var$React = $4ec5863521785a33$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4ec5863521785a33$var$_HolderOutlined = $1jnue((parcelRequire("gVi04")));

var $4ec5863521785a33$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $4ec5863521785a33$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4ec5863521785a33$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4ec5863521785a33$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $4ec5863521785a33$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $4ec5863521785a33$var$HolderOutlined = function HolderOutlined(props, ref) {
    return /*#__PURE__*/ $4ec5863521785a33$var$React.createElement($4ec5863521785a33$var$_AntdIcon.default, (0, $4ec5863521785a33$var$_objectSpread2.default)((0, $4ec5863521785a33$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $4ec5863521785a33$var$_HolderOutlined.default
    }));
};
var $4ec5863521785a33$var$RefIcon = /*#__PURE__*/ $4ec5863521785a33$var$React.forwardRef($4ec5863521785a33$var$HolderOutlined);
var $4ec5863521785a33$var$_default = module.exports.default = $4ec5863521785a33$var$RefIcon;

});
parcelRegister("gVi04", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c51feea7ec7f3ef0$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
module.exports.default = $c51feea7ec7f3ef0$var$HolderOutlined;

});



parcelRegister("hHcVB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ce207b15051e879e$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ce207b15051e879e$var$dropIndicatorRender;
module.exports.offset = void 0;

var $ce207b15051e879e$var$_defineProperty2 = $ce207b15051e879e$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $ce207b15051e879e$var$_react = $ce207b15051e879e$var$_interopRequireDefault((parcelRequire("acw62")));
var $ce207b15051e879e$var$offset = module.exports.offset = 4;
function $ce207b15051e879e$var$dropIndicatorRender(props) {
    var dropPosition = props.dropPosition, dropLevelOffset = props.dropLevelOffset, prefixCls = props.prefixCls, indent = props.indent, _props$direction = props.direction, direction = _props$direction === void 0 ? 'ltr' : _props$direction;
    var startPosition = direction === 'ltr' ? 'left' : 'right';
    var endPosition = direction === 'ltr' ? 'right' : 'left';
    var style = (0, $ce207b15051e879e$var$_defineProperty2["default"])((0, $ce207b15051e879e$var$_defineProperty2["default"])({}, startPosition, -dropLevelOffset * indent + $ce207b15051e879e$var$offset), endPosition, 0);
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $ce207b15051e879e$var$offset;
            break;
    }
    return /*#__PURE__*/ $ce207b15051e879e$var$_react["default"].createElement("div", {
        style: style,
        className: "".concat(prefixCls, "-drop-indicator")
    });
}

});

parcelRegister("eQzf9", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $acf142a427584e9c$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $acf142a427584e9c$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $acf142a427584e9c$var$renderSwitcherIcon;

var $acf142a427584e9c$var$_typeof2 = $acf142a427584e9c$var$_interopRequireDefault((parcelRequire("41YNz")));

var $acf142a427584e9c$var$_CaretDownFilled = $acf142a427584e9c$var$_interopRequireDefault((parcelRequire("a8ujn")));

var $acf142a427584e9c$var$_FileOutlined = $acf142a427584e9c$var$_interopRequireDefault((parcelRequire("eMNn0")));

var $acf142a427584e9c$var$_LoadingOutlined = $acf142a427584e9c$var$_interopRequireDefault((parcelRequire("53y9T")));

var $acf142a427584e9c$var$_MinusSquareOutlined = $acf142a427584e9c$var$_interopRequireDefault((parcelRequire("6WThv")));

var $acf142a427584e9c$var$_PlusSquareOutlined = $acf142a427584e9c$var$_interopRequireDefault((parcelRequire("j2fVO")));

var $acf142a427584e9c$var$_classnames = $acf142a427584e9c$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $acf142a427584e9c$var$React = $acf142a427584e9c$var$_interopRequireWildcard((parcelRequire("acw62")));

var $8hTO8 = parcelRequire("8hTO8");
function $acf142a427584e9c$var$renderSwitcherIcon(prefixCls, switcherIcon, showLine, treeNodeProps) {
    var isLeaf = treeNodeProps.isLeaf, expanded = treeNodeProps.expanded, loading = treeNodeProps.loading;
    if (loading) return /*#__PURE__*/ $acf142a427584e9c$var$React.createElement($acf142a427584e9c$var$_LoadingOutlined["default"], {
        className: "".concat(prefixCls, "-switcher-loading-icon")
    });
    var showLeafIcon;
    if (showLine && (0, $acf142a427584e9c$var$_typeof2["default"])(showLine) === 'object') showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            var leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            var leafCls = "".concat(prefixCls, "-switcher-line-custom-icon");
            if ((0, $8hTO8.isValidElement)(leafIcon)) return (0, $8hTO8.cloneElement)(leafIcon, {
                className: (0, $acf142a427584e9c$var$_classnames["default"])(leafIcon.props.className || '', leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $acf142a427584e9c$var$React.createElement($acf142a427584e9c$var$_FileOutlined["default"], {
            className: "".concat(prefixCls, "-switcher-line-icon")
        }) : /*#__PURE__*/ $acf142a427584e9c$var$React.createElement("span", {
            className: "".concat(prefixCls, "-switcher-leaf-line")
        });
    }
    var switcherCls = "".concat(prefixCls, "-switcher-icon");
    var switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if ((0, $8hTO8.isValidElement)(switcher)) return (0, $8hTO8.cloneElement)(switcher, {
        className: (0, $acf142a427584e9c$var$_classnames["default"])(switcher.props.className || '', switcherCls)
    });
    if (switcher) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $acf142a427584e9c$var$React.createElement($acf142a427584e9c$var$_MinusSquareOutlined["default"], {
        className: "".concat(prefixCls, "-switcher-line-icon")
    }) : /*#__PURE__*/ $acf142a427584e9c$var$React.createElement($acf142a427584e9c$var$_PlusSquareOutlined["default"], {
        className: "".concat(prefixCls, "-switcher-line-icon")
    });
    return /*#__PURE__*/ $acf142a427584e9c$var$React.createElement($acf142a427584e9c$var$_CaretDownFilled["default"], {
        className: switcherCls
    });
}

});
parcelRegister("a8ujn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76122a0005d851fa$var$_CaretDownFilled = $76122a0005d851fa$var$_interopRequireDefault((parcelRequire("eaakW")));
function $76122a0005d851fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $76122a0005d851fa$var$_default = $76122a0005d851fa$var$_CaretDownFilled;
module.exports.default = $76122a0005d851fa$var$_default;
module.exports = $76122a0005d851fa$var$_default;

});
parcelRegister("eaakW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4fa048173527ffb$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $a4fa048173527ffb$var$React = $a4fa048173527ffb$var$_interopRequireWildcard((parcelRequire("acw62")));

var $a4fa048173527ffb$var$_CaretDownFilled = $1jnue((parcelRequire("7CxxA")));

var $a4fa048173527ffb$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $a4fa048173527ffb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a4fa048173527ffb$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a4fa048173527ffb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $a4fa048173527ffb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $a4fa048173527ffb$var$CaretDownFilled = function CaretDownFilled(props, ref) {
    return /*#__PURE__*/ $a4fa048173527ffb$var$React.createElement($a4fa048173527ffb$var$_AntdIcon.default, (0, $a4fa048173527ffb$var$_objectSpread2.default)((0, $a4fa048173527ffb$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $a4fa048173527ffb$var$_CaretDownFilled.default
    }));
};
var $a4fa048173527ffb$var$RefIcon = /*#__PURE__*/ $a4fa048173527ffb$var$React.forwardRef($a4fa048173527ffb$var$CaretDownFilled);
var $a4fa048173527ffb$var$_default = module.exports.default = $a4fa048173527ffb$var$RefIcon;

});
parcelRegister("7CxxA", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $58c61985daea3592$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
module.exports.default = $58c61985daea3592$var$CaretDownFilled;

});



parcelRegister("eMNn0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac3bd83ccfb2a859$var$_FileOutlined = $ac3bd83ccfb2a859$var$_interopRequireDefault((parcelRequire("7yy2G")));
function $ac3bd83ccfb2a859$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $ac3bd83ccfb2a859$var$_default = $ac3bd83ccfb2a859$var$_FileOutlined;
module.exports.default = $ac3bd83ccfb2a859$var$_default;
module.exports = $ac3bd83ccfb2a859$var$_default;

});
parcelRegister("7yy2G", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58061d72db20524e$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $58061d72db20524e$var$React = $58061d72db20524e$var$_interopRequireWildcard((parcelRequire("acw62")));

var $58061d72db20524e$var$_FileOutlined = $1jnue((parcelRequire("jRCNO")));

var $58061d72db20524e$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $58061d72db20524e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($58061d72db20524e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $58061d72db20524e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $58061d72db20524e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $58061d72db20524e$var$FileOutlined = function FileOutlined(props, ref) {
    return /*#__PURE__*/ $58061d72db20524e$var$React.createElement($58061d72db20524e$var$_AntdIcon.default, (0, $58061d72db20524e$var$_objectSpread2.default)((0, $58061d72db20524e$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $58061d72db20524e$var$_FileOutlined.default
    }));
};
var $58061d72db20524e$var$RefIcon = /*#__PURE__*/ $58061d72db20524e$var$React.forwardRef($58061d72db20524e$var$FileOutlined);
var $58061d72db20524e$var$_default = module.exports.default = $58061d72db20524e$var$RefIcon;

});
parcelRegister("jRCNO", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e76110ea9b245411$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
module.exports.default = $e76110ea9b245411$var$FileOutlined;

});



parcelRegister("6WThv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50f30a9a581d4215$var$_MinusSquareOutlined = $50f30a9a581d4215$var$_interopRequireDefault((parcelRequire("6ttNY")));
function $50f30a9a581d4215$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $50f30a9a581d4215$var$_default = $50f30a9a581d4215$var$_MinusSquareOutlined;
module.exports.default = $50f30a9a581d4215$var$_default;
module.exports = $50f30a9a581d4215$var$_default;

});
parcelRegister("6ttNY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b6c922a7aa740aa$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $4b6c922a7aa740aa$var$React = $4b6c922a7aa740aa$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4b6c922a7aa740aa$var$_MinusSquareOutlined = $1jnue((parcelRequire("126uw")));

var $4b6c922a7aa740aa$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $4b6c922a7aa740aa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4b6c922a7aa740aa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4b6c922a7aa740aa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $4b6c922a7aa740aa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $4b6c922a7aa740aa$var$MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $4b6c922a7aa740aa$var$React.createElement($4b6c922a7aa740aa$var$_AntdIcon.default, (0, $4b6c922a7aa740aa$var$_objectSpread2.default)((0, $4b6c922a7aa740aa$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $4b6c922a7aa740aa$var$_MinusSquareOutlined.default
    }));
};
var $4b6c922a7aa740aa$var$RefIcon = /*#__PURE__*/ $4b6c922a7aa740aa$var$React.forwardRef($4b6c922a7aa740aa$var$MinusSquareOutlined);
var $4b6c922a7aa740aa$var$_default = module.exports.default = $4b6c922a7aa740aa$var$RefIcon;

});
parcelRegister("126uw", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0c0b0363d4279a38$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
module.exports.default = $0c0b0363d4279a38$var$MinusSquareOutlined;

});



parcelRegister("j2fVO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddba8fdca337b02b$var$_PlusSquareOutlined = $ddba8fdca337b02b$var$_interopRequireDefault((parcelRequire("1WRqw")));
function $ddba8fdca337b02b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $ddba8fdca337b02b$var$_default = $ddba8fdca337b02b$var$_PlusSquareOutlined;
module.exports.default = $ddba8fdca337b02b$var$_default;
module.exports = $ddba8fdca337b02b$var$_default;

});
parcelRegister("1WRqw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16b4a6b0835ffc5e$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $16b4a6b0835ffc5e$var$React = $16b4a6b0835ffc5e$var$_interopRequireWildcard((parcelRequire("acw62")));

var $16b4a6b0835ffc5e$var$_PlusSquareOutlined = $1jnue((parcelRequire("dwGA2")));

var $16b4a6b0835ffc5e$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $16b4a6b0835ffc5e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($16b4a6b0835ffc5e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $16b4a6b0835ffc5e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $16b4a6b0835ffc5e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $16b4a6b0835ffc5e$var$PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $16b4a6b0835ffc5e$var$React.createElement($16b4a6b0835ffc5e$var$_AntdIcon.default, (0, $16b4a6b0835ffc5e$var$_objectSpread2.default)((0, $16b4a6b0835ffc5e$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $16b4a6b0835ffc5e$var$_PlusSquareOutlined.default
    }));
};
var $16b4a6b0835ffc5e$var$RefIcon = /*#__PURE__*/ $16b4a6b0835ffc5e$var$React.forwardRef($16b4a6b0835ffc5e$var$PlusSquareOutlined);
var $16b4a6b0835ffc5e$var$_default = module.exports.default = $16b4a6b0835ffc5e$var$RefIcon;

});
parcelRegister("dwGA2", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9d8f4b0e3d17e9c5$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
module.exports.default = $9d8f4b0e3d17e9c5$var$PlusSquareOutlined;

});





parcelRegister("9sLES", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6e3bb285f10a6626$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6e3bb285f10a6626$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6e3bb285f10a6626$var$_defineProperty2 = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $6e3bb285f10a6626$var$_toConsumableArray2 = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $6e3bb285f10a6626$var$_extends2 = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $6e3bb285f10a6626$var$_slicedToArray2 = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $6e3bb285f10a6626$var$_FileOutlined = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("eMNn0")));

var $6e3bb285f10a6626$var$_FolderOpenOutlined = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("2sUcK")));

var $6e3bb285f10a6626$var$_FolderOutlined = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("1N6HE")));

var $6e3bb285f10a6626$var$_classnames = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $1ZsBP = parcelRequire("1ZsBP");

var $eYM7h = parcelRequire("eYM7h");

var $6e3bb285f10a6626$var$React = $6e3bb285f10a6626$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $6e3bb285f10a6626$var$_Tree = $6e3bb285f10a6626$var$_interopRequireDefault((parcelRequire("11K1l")));

var $7f6uA = parcelRequire("7f6uA");
var $6e3bb285f10a6626$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6e3bb285f10a6626$var$getIcon(props) {
    var isLeaf = props.isLeaf, expanded = props.expanded;
    if (isLeaf) return /*#__PURE__*/ $6e3bb285f10a6626$var$React.createElement($6e3bb285f10a6626$var$_FileOutlined["default"], null);
    return expanded ? /*#__PURE__*/ $6e3bb285f10a6626$var$React.createElement($6e3bb285f10a6626$var$_FolderOpenOutlined["default"], null) : /*#__PURE__*/ $6e3bb285f10a6626$var$React.createElement($6e3bb285f10a6626$var$_FolderOutlined["default"], null);
}
function $6e3bb285f10a6626$var$getTreeData(_ref) {
    var treeData = _ref.treeData, children = _ref.children;
    return treeData || (0, $eYM7h.convertTreeToData)(children);
}
var $6e3bb285f10a6626$var$DirectoryTree = function DirectoryTree(_a, ref) {
    var defaultExpandAll = _a.defaultExpandAll, defaultExpandParent = _a.defaultExpandParent, defaultExpandedKeys = _a.defaultExpandedKeys, props = $6e3bb285f10a6626$var$__rest(_a, [
        "defaultExpandAll",
        "defaultExpandParent",
        "defaultExpandedKeys"
    ]);
    // Shift click usage
    var lastSelectedKey = $6e3bb285f10a6626$var$React.useRef();
    var cachedSelectedKeys = $6e3bb285f10a6626$var$React.useRef();
    var getInitExpandedKeys = function getInitExpandedKeys() {
        var _convertDataToEntitie = (0, $eYM7h.convertDataToEntities)($6e3bb285f10a6626$var$getTreeData(props)), keyEntities = _convertDataToEntitie.keyEntities;
        var initExpandedKeys;
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $1ZsBP.conductExpandParent)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
        else initExpandedKeys = props.expandedKeys || defaultExpandedKeys;
        return initExpandedKeys;
    };
    var _React$useState = $6e3bb285f10a6626$var$React.useState(props.selectedKeys || props.defaultSelectedKeys || []), _React$useState2 = (0, $6e3bb285f10a6626$var$_slicedToArray2["default"])(_React$useState, 2), selectedKeys = _React$useState2[0], setSelectedKeys = _React$useState2[1];
    var _React$useState3 = $6e3bb285f10a6626$var$React.useState(function() {
        return getInitExpandedKeys();
    }), _React$useState4 = (0, $6e3bb285f10a6626$var$_slicedToArray2["default"])(_React$useState3, 2), expandedKeys = _React$useState4[0], setExpandedKeys = _React$useState4[1];
    $6e3bb285f10a6626$var$React.useEffect(function() {
        if ('selectedKeys' in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $6e3bb285f10a6626$var$React.useEffect(function() {
        if ('expandedKeys' in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    var onExpand = function onExpand(keys, info) {
        var _a;
        if (!('expandedKeys' in props)) setExpandedKeys(keys);
        // Call origin function
        return (_a = props.onExpand) === null || _a === void 0 ? void 0 : _a.call(props, keys, info);
    };
    var onSelect = function onSelect(keys, event) {
        var _a;
        var multiple = props.multiple;
        var node = event.node, nativeEvent = event.nativeEvent;
        var _node$key = node.key, key = _node$key === void 0 ? '' : _node$key;
        var treeData = $6e3bb285f10a6626$var$getTreeData(props);
        // const newState: DirectoryTreeState = {};
        // We need wrap this event since some value is not same
        var newEvent = (0, $6e3bb285f10a6626$var$_extends2["default"])((0, $6e3bb285f10a6626$var$_extends2["default"])({}, event), {
            selected: true
        });
        // Windows / Mac single pick
        var ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
        var shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
        // Generate new selected keys
        var newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $7f6uA.convertDirectoryKeysToNodes)(treeData, newSelectedKeys);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $6e3bb285f10a6626$var$_toConsumableArray2["default"])(cachedSelectedKeys.current || []), (0, $6e3bb285f10a6626$var$_toConsumableArray2["default"])((0, $7f6uA.calcRangeKeys)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKey.current
            })))));
            newEvent.selectedNodes = (0, $7f6uA.convertDirectoryKeysToNodes)(treeData, newSelectedKeys);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $7f6uA.convertDirectoryKeysToNodes)(treeData, newSelectedKeys);
        }
        (_a = props.onSelect) === null || _a === void 0 || _a.call(props, newSelectedKeys, newEvent);
        if (!('selectedKeys' in props)) setSelectedKeys(newSelectedKeys);
    };
    var _React$useContext = $6e3bb285f10a6626$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, className = props.className, _props$showIcon = props.showIcon, showIcon = _props$showIcon === void 0 ? true : _props$showIcon, _props$expandAction = props.expandAction, expandAction = _props$expandAction === void 0 ? 'click' : _props$expandAction, otherProps = $6e3bb285f10a6626$var$__rest(props, [
        "prefixCls",
        "className",
        "showIcon",
        "expandAction"
    ]);
    var prefixCls = getPrefixCls('tree', customizePrefixCls);
    var connectClassName = (0, $6e3bb285f10a6626$var$_classnames["default"])("".concat(prefixCls, "-directory"), (0, $6e3bb285f10a6626$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-directory-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6e3bb285f10a6626$var$React.createElement($6e3bb285f10a6626$var$_Tree["default"], (0, $6e3bb285f10a6626$var$_extends2["default"])({
        icon: $6e3bb285f10a6626$var$getIcon,
        ref: ref,
        blockNode: true
    }, otherProps, {
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    }));
};
var $6e3bb285f10a6626$var$ForwardDirectoryTree = /*#__PURE__*/ $6e3bb285f10a6626$var$React.forwardRef($6e3bb285f10a6626$var$DirectoryTree);
var $6e3bb285f10a6626$var$_default = module.exports["default"] = $6e3bb285f10a6626$var$ForwardDirectoryTree;

});
parcelRegister("2sUcK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1cb9cb60e4c3de0c$var$_FolderOpenOutlined = $1cb9cb60e4c3de0c$var$_interopRequireDefault((parcelRequire("5BUDD")));
function $1cb9cb60e4c3de0c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $1cb9cb60e4c3de0c$var$_default = $1cb9cb60e4c3de0c$var$_FolderOpenOutlined;
module.exports.default = $1cb9cb60e4c3de0c$var$_default;
module.exports = $1cb9cb60e4c3de0c$var$_default;

});
parcelRegister("5BUDD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $415c57a1591de9e4$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $415c57a1591de9e4$var$React = $415c57a1591de9e4$var$_interopRequireWildcard((parcelRequire("acw62")));

var $415c57a1591de9e4$var$_FolderOpenOutlined = $1jnue((parcelRequire("70g6M")));

var $415c57a1591de9e4$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $415c57a1591de9e4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($415c57a1591de9e4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $415c57a1591de9e4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $415c57a1591de9e4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $415c57a1591de9e4$var$FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
    return /*#__PURE__*/ $415c57a1591de9e4$var$React.createElement($415c57a1591de9e4$var$_AntdIcon.default, (0, $415c57a1591de9e4$var$_objectSpread2.default)((0, $415c57a1591de9e4$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $415c57a1591de9e4$var$_FolderOpenOutlined.default
    }));
};
var $415c57a1591de9e4$var$RefIcon = /*#__PURE__*/ $415c57a1591de9e4$var$React.forwardRef($415c57a1591de9e4$var$FolderOpenOutlined);
var $415c57a1591de9e4$var$_default = module.exports.default = $415c57a1591de9e4$var$RefIcon;

});
parcelRegister("70g6M", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5195074abfb52b26$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
module.exports.default = $5195074abfb52b26$var$FolderOpenOutlined;

});



parcelRegister("1N6HE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14df91273a27fd87$var$_FolderOutlined = $14df91273a27fd87$var$_interopRequireDefault((parcelRequire("cQyuC")));
function $14df91273a27fd87$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $14df91273a27fd87$var$_default = $14df91273a27fd87$var$_FolderOutlined;
module.exports.default = $14df91273a27fd87$var$_default;
module.exports = $14df91273a27fd87$var$_default;

});
parcelRegister("cQyuC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95a518f30a82762a$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $95a518f30a82762a$var$React = $95a518f30a82762a$var$_interopRequireWildcard((parcelRequire("acw62")));

var $95a518f30a82762a$var$_FolderOutlined = $1jnue((parcelRequire("Ut3h6")));

var $95a518f30a82762a$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $95a518f30a82762a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($95a518f30a82762a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $95a518f30a82762a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $95a518f30a82762a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $95a518f30a82762a$var$FolderOutlined = function FolderOutlined(props, ref) {
    return /*#__PURE__*/ $95a518f30a82762a$var$React.createElement($95a518f30a82762a$var$_AntdIcon.default, (0, $95a518f30a82762a$var$_objectSpread2.default)((0, $95a518f30a82762a$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $95a518f30a82762a$var$_FolderOutlined.default
    }));
};
var $95a518f30a82762a$var$RefIcon = /*#__PURE__*/ $95a518f30a82762a$var$React.forwardRef($95a518f30a82762a$var$FolderOutlined);
var $95a518f30a82762a$var$_default = module.exports.default = $95a518f30a82762a$var$RefIcon;

});
parcelRegister("Ut3h6", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0a9bc429d7b8fb22$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
module.exports.default = $0a9bc429d7b8fb22$var$FolderOutlined;

});



parcelRegister("1ZsBP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrAdd = $1731ae21ce365c33$var$arrAdd;
module.exports.arrDel = $1731ae21ce365c33$var$arrDel;
module.exports.calcDropPosition = $1731ae21ce365c33$var$calcDropPosition;
module.exports.calcSelectedKeys = $1731ae21ce365c33$var$calcSelectedKeys;
module.exports.conductExpandParent = $1731ae21ce365c33$var$conductExpandParent;
module.exports.convertDataToTree = $1731ae21ce365c33$var$convertDataToTree;
module.exports.getDragChildrenKeys = $1731ae21ce365c33$var$getDragChildrenKeys;
Object.defineProperty(module.exports, "getPosition", {
    enumerable: true,
    get: function get() {
        return $eYM7h.getPosition;
    }
});
module.exports.isFirstChild = $1731ae21ce365c33$var$isFirstChild;
module.exports.isLastChild = $1731ae21ce365c33$var$isLastChild;
Object.defineProperty(module.exports, "isTreeNode", {
    enumerable: true,
    get: function get() {
        return $eYM7h.isTreeNode;
    }
});
module.exports.parseCheckedKeys = $1731ae21ce365c33$var$parseCheckedKeys;
module.exports.posToArr = $1731ae21ce365c33$var$posToArr;

var $1731ae21ce365c33$var$_toConsumableArray2 = $1jnue((parcelRequire("fUHKi")));

var $1731ae21ce365c33$var$_typeof2 = $1jnue((parcelRequire("41YNz")));

var $1731ae21ce365c33$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $1731ae21ce365c33$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $1731ae21ce365c33$var$_warning = $1jnue((parcelRequire("dtSXD")));

var $1731ae21ce365c33$var$_react = $1jnue((parcelRequire("acw62")));

var $1731ae21ce365c33$var$_TreeNode = $1jnue((parcelRequire("30Odp")));

var $1731ae21ce365c33$var$_keyUtil = $1jnue((parcelRequire("aJWOC")));

var $eYM7h = parcelRequire("eYM7h");
var $1731ae21ce365c33$var$_excluded = [
    "children"
];
/* eslint-disable no-lonely-if */ /**
 * Legacy code. Should avoid to use if you are new to import these code.
 */ function $1731ae21ce365c33$var$arrDel(list, value) {
    if (!list) return [];
    var clone = list.slice();
    var index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $1731ae21ce365c33$var$arrAdd(list, value) {
    var clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $1731ae21ce365c33$var$posToArr(pos) {
    return pos.split('-');
}
function $1731ae21ce365c33$var$getDragChildrenKeys(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    var dragChildrenKeys = [];
    var entity = (0, $1731ae21ce365c33$var$_keyUtil.default)(keyEntities, dragNodeKey);
    function dig() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        list.forEach(function(_ref) {
            var key = _ref.key, children = _ref.children;
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $1731ae21ce365c33$var$isLastChild(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        var posArr = $1731ae21ce365c33$var$posToArr(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $1731ae21ce365c33$var$isFirstChild(treeNodeEntity) {
    var posArr = $1731ae21ce365c33$var$posToArr(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
// Only used when drag, not affect SSR.
function $1731ae21ce365c33$var$calcDropPosition(event, dragNode, targetNode, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    var _abstractDropNodeEnti;
    var clientX = event.clientX, clientY = event.clientY;
    var _event$target$getBoun = event.target.getBoundingClientRect(), top = _event$target$getBoun.top, height = _event$target$getBoun.height;
    // optional chain for testing
    var horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
    var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // find abstract drop node by horizontal offset
    var abstractDropNodeEntity = (0, $1731ae21ce365c33$var$_keyUtil.default)(keyEntities, targetNode.props.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
            return flattenedNode.key === abstractDropNodeEntity.key;
        });
        var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        var prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $1731ae21ce365c33$var$_keyUtil.default)(keyEntities, prevNodeKey);
    }
    var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    var abstractDragOverEntity = abstractDropNodeEntity;
    var dragOverNodeKey = abstractDropNodeEntity.key;
    var dropPosition = 0;
    var dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!expandKeys.includes(initialAbstractDropNodeKey)) for(var i = 0; i < rawDropLevelOffset; i += 1){
        if ($1731ae21ce365c33$var$isLastChild(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    var abstractDragDataNode = dragNode.props.data;
    var abstractDropDataNode = abstractDropNodeEntity.node;
    var dropAllowed = true;
    if ($1731ae21ce365c33$var$isFirstChild(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNode.props.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && expandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
        dropAllowed: dropAllowed
    };
}
/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */ function $1731ae21ce365c33$var$calcSelectedKeys(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    var multiple = props.multiple;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
var $1731ae21ce365c33$var$internalProcessProps = function internalProcessProps(props) {
    return props;
};
function $1731ae21ce365c33$var$convertDataToTree(treeData, processor) {
    if (!treeData) return [];
    var _ref2 = processor || {}, _ref2$processProps = _ref2.processProps, processProps = _ref2$processProps === void 0 ? $1731ae21ce365c33$var$internalProcessProps : _ref2$processProps;
    var list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(function(_ref3) {
        var children = _ref3.children, props = (0, $1731ae21ce365c33$var$_objectWithoutProperties2.default)(_ref3, $1731ae21ce365c33$var$_excluded);
        var childrenNodes = $1731ae21ce365c33$var$convertDataToTree(children, processor);
        return /*#__PURE__*/ $1731ae21ce365c33$var$_react.default.createElement($1731ae21ce365c33$var$_TreeNode.default, (0, $1731ae21ce365c33$var$_extends2.default)({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */ function $1731ae21ce365c33$var$parseCheckedKeys(keys) {
    if (!keys) return null;
    // Convert keys to object format
    var keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if ((0, $1731ae21ce365c33$var$_typeof2.default)(keys) === 'object') keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $1731ae21ce365c33$var$_warning.default)(false, '`checkedKeys` is not an array or an object');
        return null;
    }
    return keyProps;
}
/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */ function $1731ae21ce365c33$var$conductExpandParent(keyList, keyEntities) {
    var expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        var entity = (0, $1731ae21ce365c33$var$_keyUtil.default)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        var parent = entity.parent, node = entity.node;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach(function(key) {
        conductUp(key);
    });
    return (0, $1731ae21ce365c33$var$_toConsumableArray2.default)(expandedKeys);
}

});
parcelRegister("30Odp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $231852e5f4a94593$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $231852e5f4a94593$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $231852e5f4a94593$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $231852e5f4a94593$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $231852e5f4a94593$var$_classCallCheck2 = $1jnue((parcelRequire("fu0YK")));

var $231852e5f4a94593$var$_createClass2 = $1jnue((parcelRequire("lR7jo")));

var $231852e5f4a94593$var$_assertThisInitialized2 = $1jnue((parcelRequire("6zC7B")));

var $231852e5f4a94593$var$_inherits2 = $1jnue((parcelRequire("f8wIT")));

var $231852e5f4a94593$var$_createSuper2 = $1jnue((parcelRequire("9jKhT")));

var $231852e5f4a94593$var$_classnames = $1jnue((parcelRequire("8g1PZ")));

var $231852e5f4a94593$var$_pickAttrs = $1jnue((parcelRequire("7ev53")));

var $231852e5f4a94593$var$React = $231852e5f4a94593$var$_interopRequireWildcard((parcelRequire("acw62")));

var $2jc10 = parcelRequire("2jc10");

var $231852e5f4a94593$var$_Indent = $1jnue((parcelRequire("70qQP")));

var $231852e5f4a94593$var$_keyUtil = $1jnue((parcelRequire("aJWOC")));

var $eYM7h = parcelRequire("eYM7h");
var $231852e5f4a94593$var$_excluded = [
    "eventKey",
    "className",
    "style",
    "dragOver",
    "dragOverGapTop",
    "dragOverGapBottom",
    "isLeaf",
    "isStart",
    "isEnd",
    "expanded",
    "selected",
    "checked",
    "halfChecked",
    "loading",
    "domRef",
    "active",
    "data",
    "onMouseMove",
    "selectable"
]; // @ts-ignore
function $231852e5f4a94593$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($231852e5f4a94593$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $231852e5f4a94593$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $231852e5f4a94593$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $231852e5f4a94593$var$ICON_OPEN = 'open';
var $231852e5f4a94593$var$ICON_CLOSE = 'close';
var $231852e5f4a94593$var$defaultTitle = '---';
var $231852e5f4a94593$var$InternalTreeNode = /*#__PURE__*/ function(_React$Component) {
    (0, $231852e5f4a94593$var$_inherits2.default)(InternalTreeNode, _React$Component);
    var _super = (0, $231852e5f4a94593$var$_createSuper2.default)(InternalTreeNode);
    function InternalTreeNode() {
        var _this;
        (0, $231852e5f4a94593$var$_classCallCheck2.default)(this, InternalTreeNode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            dragNodeHighlight: false
        };
        _this.selectHandle = void 0;
        _this.cacheIndent = void 0;
        _this.onSelectorClick = function(e) {
            // Click trigger before select/check operation
            var onNodeClick = _this.props.context.onNodeClick;
            onNodeClick(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props));
            if (_this.isSelectable()) _this.onSelect(e);
            else _this.onCheck(e);
        };
        _this.onSelectorDoubleClick = function(e) {
            var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
            onNodeDoubleClick(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props));
        };
        _this.onSelect = function(e) {
            if (_this.isDisabled()) return;
            var onNodeSelect = _this.props.context.onNodeSelect;
            onNodeSelect(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props));
        };
        _this.onCheck = function(e) {
            if (_this.isDisabled()) return;
            var _this$props = _this.props, disableCheckbox = _this$props.disableCheckbox, checked = _this$props.checked;
            var onNodeCheck = _this.props.context.onNodeCheck;
            if (!_this.isCheckable() || disableCheckbox) return;
            var targetChecked = !checked;
            onNodeCheck(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props), targetChecked);
        };
        _this.onMouseEnter = function(e) {
            var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
            onNodeMouseEnter(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props));
        };
        _this.onMouseLeave = function(e) {
            var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
            onNodeMouseLeave(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props));
        };
        _this.onContextMenu = function(e) {
            var onNodeContextMenu = _this.props.context.onNodeContextMenu;
            onNodeContextMenu(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props));
        };
        _this.onDragStart = function(e) {
            var onNodeDragStart = _this.props.context.onNodeDragStart;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: true
            });
            onNodeDragStart(e, (0, $231852e5f4a94593$var$_assertThisInitialized2.default)(_this));
            try {
                // ie throw error
                // firefox-need-it
                e.dataTransfer.setData('text/plain', '');
            } catch (error) {
            // empty
            }
        };
        _this.onDragEnter = function(e) {
            var onNodeDragEnter = _this.props.context.onNodeDragEnter;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragEnter(e, (0, $231852e5f4a94593$var$_assertThisInitialized2.default)(_this));
        };
        _this.onDragOver = function(e) {
            var onNodeDragOver = _this.props.context.onNodeDragOver;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragOver(e, (0, $231852e5f4a94593$var$_assertThisInitialized2.default)(_this));
        };
        _this.onDragLeave = function(e) {
            var onNodeDragLeave = _this.props.context.onNodeDragLeave;
            e.stopPropagation();
            onNodeDragLeave(e, (0, $231852e5f4a94593$var$_assertThisInitialized2.default)(_this));
        };
        _this.onDragEnd = function(e) {
            var onNodeDragEnd = _this.props.context.onNodeDragEnd;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDragEnd(e, (0, $231852e5f4a94593$var$_assertThisInitialized2.default)(_this));
        };
        _this.onDrop = function(e) {
            var onNodeDrop = _this.props.context.onNodeDrop;
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDrop(e, (0, $231852e5f4a94593$var$_assertThisInitialized2.default)(_this));
        };
        // Disabled item still can be switch
        _this.onExpand = function(e) {
            var _this$props2 = _this.props, loading = _this$props2.loading, onNodeExpand = _this$props2.context.onNodeExpand;
            if (loading) return;
            onNodeExpand(e, (0, $eYM7h.convertNodePropsToEventData)(_this.props));
        };
        // Drag usage
        _this.setSelectHandle = function(node) {
            _this.selectHandle = node;
        };
        _this.getNodeState = function() {
            var expanded = _this.props.expanded;
            if (_this.isLeaf()) return null;
            return expanded ? $231852e5f4a94593$var$ICON_OPEN : $231852e5f4a94593$var$ICON_CLOSE;
        };
        _this.hasChildren = function() {
            var eventKey = _this.props.eventKey;
            var keyEntities = _this.props.context.keyEntities;
            var _ref = (0, $231852e5f4a94593$var$_keyUtil.default)(keyEntities, eventKey) || {}, children = _ref.children;
            return !!(children || []).length;
        };
        _this.isLeaf = function() {
            var _this$props3 = _this.props, isLeaf = _this$props3.isLeaf, loaded = _this$props3.loaded;
            var loadData = _this.props.context.loadData;
            var hasChildren = _this.hasChildren();
            if (isLeaf === false) return false;
            return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
        };
        _this.isDisabled = function() {
            var disabled = _this.props.disabled;
            var treeDisabled = _this.props.context.disabled;
            return !!(treeDisabled || disabled);
        };
        _this.isCheckable = function() {
            var checkable = _this.props.checkable;
            var treeCheckable = _this.props.context.checkable;
            // Return false if tree or treeNode is not checkable
            if (!treeCheckable || checkable === false) return false;
            return treeCheckable;
        };
        // Load data to avoid default expanded tree without data
        _this.syncLoadData = function(props) {
            var expanded = props.expanded, loading = props.loading, loaded = props.loaded;
            var _this$props$context = _this.props.context, loadData = _this$props$context.loadData, onNodeLoad = _this$props$context.onNodeLoad;
            if (loading) return;
            // read from state to avoid loadData at same time
            if (loadData && expanded && !_this.isLeaf()) // We needn't reload data when has children in sync logic
            // It's only needed in node expanded
            {
                if (!_this.hasChildren() && !loaded) onNodeLoad((0, $eYM7h.convertNodePropsToEventData)(_this.props));
            }
        };
        _this.isDraggable = function() {
            var _this$props4 = _this.props, data = _this$props4.data, draggable = _this$props4.context.draggable;
            return !!(draggable && (!draggable.nodeDraggable || draggable.nodeDraggable(data)));
        };
        // ==================== Render: Drag Handler ====================
        _this.renderDragHandler = function() {
            var _this$props$context2 = _this.props.context, draggable = _this$props$context2.draggable, prefixCls = _this$props$context2.prefixCls;
            return (draggable === null || draggable === void 0 ? void 0 : draggable.icon) ? /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                className: "".concat(prefixCls, "-draggable-icon")
            }, draggable.icon) : null;
        };
        // ====================== Render: Switcher ======================
        _this.renderSwitcherIconDom = function(isLeaf) {
            var switcherIconFromProps = _this.props.switcherIcon;
            var switcherIconFromCtx = _this.props.context.switcherIcon;
            var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
            // if switcherIconDom is null, no render switcher span
            if (typeof switcherIcon === 'function') return switcherIcon((0, $231852e5f4a94593$var$_objectSpread2.default)((0, $231852e5f4a94593$var$_objectSpread2.default)({}, _this.props), {}, {
                isLeaf: isLeaf
            }));
            return switcherIcon;
        };
        // Switcher
        _this.renderSwitcher = function() {
            var expanded = _this.props.expanded;
            var prefixCls = _this.props.context.prefixCls;
            if (_this.isLeaf()) {
                // if switcherIconDom is null, no render switcher span
                var _switcherIconDom = _this.renderSwitcherIconDom(true);
                return _switcherIconDom !== false ? /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                    className: (0, $231852e5f4a94593$var$_classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
                }, _switcherIconDom) : null;
            }
            var switcherCls = (0, $231852e5f4a94593$var$_classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? $231852e5f4a94593$var$ICON_OPEN : $231852e5f4a94593$var$ICON_CLOSE));
            var switcherIconDom = _this.renderSwitcherIconDom(false);
            return switcherIconDom !== false ? /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                onClick: _this.onExpand,
                className: switcherCls
            }, switcherIconDom) : null;
        };
        // ====================== Render: Checkbox ======================
        // Checkbox
        _this.renderCheckbox = function() {
            var _this$props5 = _this.props, checked = _this$props5.checked, halfChecked = _this$props5.halfChecked, disableCheckbox = _this$props5.disableCheckbox;
            var prefixCls = _this.props.context.prefixCls;
            var disabled = _this.isDisabled();
            var checkable = _this.isCheckable();
            if (!checkable) return null;
            // [Legacy] Custom element should be separate with `checkable` in future
            var $custom = typeof checkable !== 'boolean' ? checkable : null;
            return /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                className: (0, $231852e5f4a94593$var$_classnames.default)("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
                onClick: _this.onCheck
            }, $custom);
        };
        // ==================== Render: Title + Icon ====================
        _this.renderIcon = function() {
            var loading = _this.props.loading;
            var prefixCls = _this.props.context.prefixCls;
            return /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                className: (0, $231852e5f4a94593$var$_classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || 'docu'), loading && "".concat(prefixCls, "-icon_loading"))
            });
        };
        // Icon + Title
        _this.renderSelector = function() {
            var dragNodeHighlight = _this.state.dragNodeHighlight;
            var _this$props6 = _this.props, _this$props6$title = _this$props6.title, title = _this$props6$title === void 0 ? $231852e5f4a94593$var$defaultTitle : _this$props6$title, selected = _this$props6.selected, icon = _this$props6.icon, loading = _this$props6.loading, data = _this$props6.data;
            var _this$props$context3 = _this.props.context, prefixCls = _this$props$context3.prefixCls, showIcon = _this$props$context3.showIcon, treeIcon = _this$props$context3.icon, loadData = _this$props$context3.loadData, titleRender = _this$props$context3.titleRender;
            var disabled = _this.isDisabled();
            var wrapClass = "".concat(prefixCls, "-node-content-wrapper");
            // Icon - Still show loading icon when loading without showIcon
            var $icon;
            if (showIcon) {
                var currentIcon = icon || treeIcon;
                $icon = currentIcon ? /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                    className: (0, $231852e5f4a94593$var$_classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
                }, typeof currentIcon === 'function' ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
            } else if (loadData && loading) $icon = _this.renderIcon();
            // Title
            var titleNode;
            if (typeof title === 'function') titleNode = title(data);
            else if (titleRender) titleNode = titleRender(data);
            else titleNode = title;
            var $title = /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                className: "".concat(prefixCls, "-title")
            }, titleNode);
            return /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("span", {
                ref: _this.setSelectHandle,
                title: typeof title === 'string' ? title : '',
                className: (0, $231852e5f4a94593$var$_classnames.default)("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected")),
                onMouseEnter: _this.onMouseEnter,
                onMouseLeave: _this.onMouseLeave,
                onContextMenu: _this.onContextMenu,
                onClick: _this.onSelectorClick,
                onDoubleClick: _this.onSelectorDoubleClick
            }, $icon, $title, _this.renderDropIndicator());
        };
        // =================== Render: Drop Indicator ===================
        _this.renderDropIndicator = function() {
            var _this$props7 = _this.props, disabled = _this$props7.disabled, eventKey = _this$props7.eventKey;
            var _this$props$context4 = _this.props.context, draggable = _this$props$context4.draggable, dropLevelOffset = _this$props$context4.dropLevelOffset, dropPosition = _this$props$context4.dropPosition, prefixCls = _this$props$context4.prefixCls, indent = _this$props$context4.indent, dropIndicatorRender = _this$props$context4.dropIndicatorRender, dragOverNodeKey = _this$props$context4.dragOverNodeKey, direction = _this$props$context4.direction;
            var rootDraggable = !!draggable;
            // allowDrop is calculated in Tree.tsx, there is no need for calc it here
            var showIndicator = !disabled && rootDraggable && dragOverNodeKey === eventKey;
            // This is a hot fix which is already fixed in
            // https://github.com/react-component/tree/pull/743/files
            // But some case need break point so we hack on this
            // ref https://github.com/ant-design/ant-design/issues/43493
            var mergedIndent = indent !== null && indent !== void 0 ? indent : _this.cacheIndent;
            _this.cacheIndent = indent;
            return showIndicator ? dropIndicatorRender({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                indent: mergedIndent,
                prefixCls: prefixCls,
                direction: direction
            }) : null;
        };
        return _this;
    }
    (0, $231852e5f4a94593$var$_createClass2.default)(InternalTreeNode, [
        {
            key: "componentDidMount",
            value: // Isomorphic needn't load data in server side
            function componentDidMount() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "isSelectable",
            value: function isSelectable() {
                var selectable = this.props.selectable;
                var treeSelectable = this.props.context.selectable;
                // Ignore when selectable is undefined or null
                if (typeof selectable === 'boolean') return selectable;
                return treeSelectable;
            }
        },
        {
            key: "render",
            value: // =========================== Render ===========================
            function render() {
                var _classNames;
                var _this$props8 = this.props, eventKey = _this$props8.eventKey, className = _this$props8.className, style = _this$props8.style, dragOver = _this$props8.dragOver, dragOverGapTop = _this$props8.dragOverGapTop, dragOverGapBottom = _this$props8.dragOverGapBottom, isLeaf = _this$props8.isLeaf, isStart = _this$props8.isStart, isEnd = _this$props8.isEnd, expanded = _this$props8.expanded, selected = _this$props8.selected, checked = _this$props8.checked, halfChecked = _this$props8.halfChecked, loading = _this$props8.loading, domRef = _this$props8.domRef, active = _this$props8.active, data = _this$props8.data, onMouseMove = _this$props8.onMouseMove, selectable = _this$props8.selectable, otherProps = (0, $231852e5f4a94593$var$_objectWithoutProperties2.default)(_this$props8, $231852e5f4a94593$var$_excluded);
                var _this$props$context5 = this.props.context, prefixCls = _this$props$context5.prefixCls, filterTreeNode = _this$props$context5.filterTreeNode, keyEntities = _this$props$context5.keyEntities, dropContainerKey = _this$props$context5.dropContainerKey, dropTargetKey = _this$props$context5.dropTargetKey, draggingNodeKey = _this$props$context5.draggingNodeKey;
                var disabled = this.isDisabled();
                var dataOrAriaAttributeProps = (0, $231852e5f4a94593$var$_pickAttrs.default)(otherProps, {
                    aria: true,
                    data: true
                });
                var _ref2 = (0, $231852e5f4a94593$var$_keyUtil.default)(keyEntities, eventKey) || {}, level = _ref2.level;
                var isEndNode = isEnd[isEnd.length - 1];
                var mergedDraggable = this.isDraggable();
                var draggableWithoutDisabled = !disabled && mergedDraggable;
                var dragging = draggingNodeKey === eventKey;
                var ariaSelected = selectable !== undefined ? {
                    'aria-selected': !!selectable
                } : undefined;
                return /*#__PURE__*/ $231852e5f4a94593$var$React.createElement("div", (0, $231852e5f4a94593$var$_extends2.default)({
                    ref: domRef,
                    className: (0, $231852e5f4a94593$var$_classnames.default)(className, "".concat(prefixCls, "-treenode"), (_classNames = {}, (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-active"), active), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-leaf-last"), isEndNode), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-draggable"), mergedDraggable), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, "dragging", dragging), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, 'drop-target', dropTargetKey === eventKey), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, 'drop-container', dropContainerKey === eventKey), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, 'drag-over', !disabled && dragOver), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), (0, $231852e5f4a94593$var$_defineProperty2.default)(_classNames, 'filter-node', filterTreeNode && filterTreeNode((0, $eYM7h.convertNodePropsToEventData)(this.props))), _classNames)),
                    style: style,
                    draggable: draggableWithoutDisabled,
                    "aria-grabbed": dragging,
                    onDragStart: draggableWithoutDisabled ? this.onDragStart : undefined,
                    onDragEnter: mergedDraggable ? this.onDragEnter : undefined,
                    onDragOver: mergedDraggable ? this.onDragOver : undefined,
                    onDragLeave: mergedDraggable ? this.onDragLeave : undefined,
                    onDrop: mergedDraggable ? this.onDrop : undefined,
                    onDragEnd: mergedDraggable ? this.onDragEnd : undefined,
                    onMouseMove: onMouseMove
                }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/ $231852e5f4a94593$var$React.createElement($231852e5f4a94593$var$_Indent.default, {
                    prefixCls: prefixCls,
                    level: level,
                    isStart: isStart,
                    isEnd: isEnd
                }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
            }
        }
    ]);
    return InternalTreeNode;
}($231852e5f4a94593$var$React.Component);
var $231852e5f4a94593$var$ContextTreeNode = function ContextTreeNode(props) {
    return /*#__PURE__*/ $231852e5f4a94593$var$React.createElement($2jc10.TreeContext.Consumer, null, function(context) {
        return /*#__PURE__*/ $231852e5f4a94593$var$React.createElement($231852e5f4a94593$var$InternalTreeNode, (0, $231852e5f4a94593$var$_extends2.default)({}, props, {
            context: context
        }));
    });
};
$231852e5f4a94593$var$ContextTreeNode.displayName = 'TreeNode';
$231852e5f4a94593$var$ContextTreeNode.isTreeNode = 1;
var $231852e5f4a94593$var$_default = $231852e5f4a94593$var$ContextTreeNode;
module.exports.default = $231852e5f4a94593$var$_default;

});
parcelRegister("2jc10", function(module, exports) {
"use strict";

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TreeContext = void 0;

var $1ae6ad1a5a218a14$var$React = $1ae6ad1a5a218a14$var$_interopRequireWildcard((parcelRequire("acw62")));
function $1ae6ad1a5a218a14$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1ae6ad1a5a218a14$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1ae6ad1a5a218a14$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1ae6ad1a5a218a14$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ var $1ae6ad1a5a218a14$var$TreeContext = /*#__PURE__*/ $1ae6ad1a5a218a14$var$React.createContext(null);
module.exports.TreeContext = $1ae6ad1a5a218a14$var$TreeContext;

});

parcelRegister("70qQP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $519d5c8ef3fb6feb$var$_defineProperty2 = $1jnue((parcelRequire("g5Zhu")));

var $519d5c8ef3fb6feb$var$React = $519d5c8ef3fb6feb$var$_interopRequireWildcard((parcelRequire("acw62")));

var $519d5c8ef3fb6feb$var$_classnames = $1jnue((parcelRequire("8g1PZ")));
function $519d5c8ef3fb6feb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($519d5c8ef3fb6feb$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $519d5c8ef3fb6feb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $41YNz(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $519d5c8ef3fb6feb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $519d5c8ef3fb6feb$var$Indent = function Indent(_ref) {
    var prefixCls = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
    var baseClassName = "".concat(prefixCls, "-indent-unit");
    var list = [];
    for(var i = 0; i < level; i += 1){
        var _classNames;
        list.push(/*#__PURE__*/ $519d5c8ef3fb6feb$var$React.createElement("span", {
            key: i,
            className: (0, $519d5c8ef3fb6feb$var$_classnames.default)(baseClassName, (_classNames = {}, (0, $519d5c8ef3fb6feb$var$_defineProperty2.default)(_classNames, "".concat(baseClassName, "-start"), isStart[i]), (0, $519d5c8ef3fb6feb$var$_defineProperty2.default)(_classNames, "".concat(baseClassName, "-end"), isEnd[i]), _classNames))
        }));
    }
    return /*#__PURE__*/ $519d5c8ef3fb6feb$var$React.createElement("span", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-indent")
    }, list);
};
var $519d5c8ef3fb6feb$var$_default = /*#__PURE__*/ $519d5c8ef3fb6feb$var$React.memo($519d5c8ef3fb6feb$var$Indent);
module.exports.default = $519d5c8ef3fb6feb$var$_default;

});

parcelRegister("aJWOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d1bbadcd7f7cfa0$var$getEntity;
function $7d1bbadcd7f7cfa0$var$getEntity(keyEntities, key) {
    return keyEntities[key];
}

});

parcelRegister("eYM7h", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertDataToEntities = $ae7bfe2fc249e2f6$var$convertDataToEntities;
module.exports.convertNodePropsToEventData = $ae7bfe2fc249e2f6$var$convertNodePropsToEventData;
module.exports.convertTreeToData = $ae7bfe2fc249e2f6$var$convertTreeToData;
module.exports.fillFieldNames = $ae7bfe2fc249e2f6$var$fillFieldNames;
module.exports.flattenTreeData = $ae7bfe2fc249e2f6$var$flattenTreeData;
module.exports.getKey = $ae7bfe2fc249e2f6$var$getKey;
module.exports.getPosition = $ae7bfe2fc249e2f6$var$getPosition;
module.exports.getTreeNodeProps = $ae7bfe2fc249e2f6$var$getTreeNodeProps;
module.exports.isTreeNode = $ae7bfe2fc249e2f6$var$isTreeNode;
module.exports.traverseDataNodes = $ae7bfe2fc249e2f6$var$traverseDataNodes;
module.exports.warningWithoutKey = $ae7bfe2fc249e2f6$var$warningWithoutKey;

var $ae7bfe2fc249e2f6$var$_typeof2 = $1jnue((parcelRequire("41YNz")));

var $ae7bfe2fc249e2f6$var$_toConsumableArray2 = $1jnue((parcelRequire("fUHKi")));

var $ae7bfe2fc249e2f6$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $ae7bfe2fc249e2f6$var$_objectWithoutProperties2 = $1jnue((parcelRequire("gZU1N")));

var $ae7bfe2fc249e2f6$var$_toArray = $1jnue((parcelRequire("13r7s")));

var $ae7bfe2fc249e2f6$var$_omit = $1jnue((parcelRequire("cPSVu")));

var $ae7bfe2fc249e2f6$var$_warning = $1jnue((parcelRequire("dtSXD")));

var $ae7bfe2fc249e2f6$var$_keyUtil = $1jnue((parcelRequire("aJWOC")));
var $ae7bfe2fc249e2f6$var$_excluded = [
    "children"
];
function $ae7bfe2fc249e2f6$var$getPosition(level, index) {
    return "".concat(level, "-").concat(index);
}
function $ae7bfe2fc249e2f6$var$isTreeNode(node) {
    return node && node.type && node.type.isTreeNode;
}
function $ae7bfe2fc249e2f6$var$getKey(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $ae7bfe2fc249e2f6$var$fillFieldNames(fieldNames) {
    var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key = _ref.key, children = _ref.children;
    var mergedTitle = title || 'title';
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || 'key',
        children: children || 'children'
    };
}
/**
 * Warning if TreeNode do not provides key
 */ function $ae7bfe2fc249e2f6$var$warningWithoutKey(treeData, fieldNames) {
    var keys = new Map();
    function dig(list) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        (list || []).forEach(function(treeNode) {
            var key = treeNode[fieldNames.key];
            var children = treeNode[fieldNames.children];
            (0, $ae7bfe2fc249e2f6$var$_warning.default)(key !== null && key !== undefined, "Tree node must have a certain key: [".concat(path).concat(key, "]"));
            var recordKey = String(key);
            (0, $ae7bfe2fc249e2f6$var$_warning.default)(!keys.has(recordKey) || key === null || key === undefined, "Same 'key' exist in the Tree: ".concat(recordKey));
            keys.set(recordKey, true);
            dig(children, "".concat(path).concat(recordKey, " > "));
        });
    }
    dig(treeData);
}
/**
 * Convert `children` of Tree into `treeData` structure.
 */ function $ae7bfe2fc249e2f6$var$convertTreeToData(rootNodes) {
    function dig(node) {
        var treeNodes = (0, $ae7bfe2fc249e2f6$var$_toArray.default)(node);
        return treeNodes.map(function(treeNode) {
            // Filter invalidate node
            if (!$ae7bfe2fc249e2f6$var$isTreeNode(treeNode)) {
                (0, $ae7bfe2fc249e2f6$var$_warning.default)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
                return null;
            }
            var key = treeNode.key;
            var _treeNode$props = treeNode.props, children = _treeNode$props.children, rest = (0, $ae7bfe2fc249e2f6$var$_objectWithoutProperties2.default)(_treeNode$props, $ae7bfe2fc249e2f6$var$_excluded);
            var dataNode = (0, $ae7bfe2fc249e2f6$var$_objectSpread2.default)({
                key: key
            }, rest);
            var parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter(function(dataNode) {
            return dataNode;
        });
    }
    return dig(rootNodes);
}
/**
 * Flat nest tree data into flatten list. This is used for virtual list render.
 * @param treeNodeList Origin data node list
 * @param expandedKeys
 * need expanded keys, provides `true` means all expanded (used in `rc-tree-select`).
 */ function $ae7bfe2fc249e2f6$var$flattenTreeData(treeNodeList, expandedKeys, fieldNames) {
    var _fillFieldNames = $ae7bfe2fc249e2f6$var$fillFieldNames(fieldNames), fieldTitles = _fillFieldNames._title, fieldKey = _fillFieldNames.key, fieldChildren = _fillFieldNames.children;
    var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    var flattenList = [];
    function dig(list) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return list.map(function(treeNode, index) {
            var pos = $ae7bfe2fc249e2f6$var$getPosition(parent ? parent.pos : '0', index);
            var mergedKey = $ae7bfe2fc249e2f6$var$getKey(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            var mergedTitle;
            for(var i = 0; i < fieldTitles.length; i += 1){
                var fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            var flattenNode = (0, $ae7bfe2fc249e2f6$var$_objectSpread2.default)((0, $ae7bfe2fc249e2f6$var$_objectSpread2.default)({}, (0, $ae7bfe2fc249e2f6$var$_omit.default)(treeNode, [].concat((0, $ae7bfe2fc249e2f6$var$_toConsumableArray2.default)(fieldTitles), [
                fieldKey,
                fieldChildren
            ]))), {}, {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [].concat((0, $ae7bfe2fc249e2f6$var$_toConsumableArray2.default)(parent ? parent.isStart : []), [
                    index === 0
                ]),
                isEnd: [].concat((0, $ae7bfe2fc249e2f6$var$_toConsumableArray2.default)(parent ? parent.isEnd : []), [
                    index === list.length - 1
                ])
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
/**
 * Traverse all the data by `treeData`.
 * Please not use it out of the `rc-tree` since we may refactor this code.
 */ function $ae7bfe2fc249e2f6$var$traverseDataNodes(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    var mergedConfig = {};
    if ((0, $ae7bfe2fc249e2f6$var$_typeof2.default)(config) === 'object') mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
    var _fillFieldNames2 = $ae7bfe2fc249e2f6$var$fillFieldNames(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
    var mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    var syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === 'string') syntheticGetKey = function syntheticGetKey(node) {
            return node[externalGetKey];
        };
        else if (typeof externalGetKey === 'function') syntheticGetKey = function syntheticGetKey(node) {
            return externalGetKey(node);
        };
    } else syntheticGetKey = function syntheticGetKey(node, pos) {
        return $ae7bfe2fc249e2f6$var$getKey(node[fieldKey], pos);
    };
    // Process
    function processNode(node, index, parent, pathNodes) {
        var children = node ? node[mergeChildrenPropName] : dataNodes;
        var pos = node ? $ae7bfe2fc249e2f6$var$getPosition(parent.pos, index) : '0';
        var connectNodes = node ? [].concat((0, $ae7bfe2fc249e2f6$var$_toConsumableArray2.default)(pathNodes), [
            node
        ]) : [];
        // Process node if is not root
        if (node) {
            var key = syntheticGetKey(node, pos);
            var data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(data);
        }
        // Process children node
        if (children) children.forEach(function(subNode, subIndex) {
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
/**
 * Convert `treeData` into entity records.
 */ function $ae7bfe2fc249e2f6$var$convertDataToEntities(dataNodes) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
    var /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey = arguments.length > 2 ? arguments[2] : undefined;
    // Init config
    var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    var posEntities = {};
    var keyEntities = {};
    var wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $ae7bfe2fc249e2f6$var$traverseDataNodes(dataNodes, function(item) {
        var node = item.node, index = item.index, pos = item.pos, key = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
        var entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        var mergedKey = $ae7bfe2fc249e2f6$var$getKey(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
/**
 * Get TreeNode props with Tree props.
 */ function $ae7bfe2fc249e2f6$var$getTreeNodeProps(key, _ref3) {
    var expandedKeys = _ref3.expandedKeys, selectedKeys = _ref3.selectedKeys, loadedKeys = _ref3.loadedKeys, loadingKeys = _ref3.loadingKeys, checkedKeys = _ref3.checkedKeys, halfCheckedKeys = _ref3.halfCheckedKeys, dragOverNodeKey = _ref3.dragOverNodeKey, dropPosition = _ref3.dropPosition, keyEntities = _ref3.keyEntities;
    var entity = (0, $ae7bfe2fc249e2f6$var$_keyUtil.default)(keyEntities, key);
    var treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ''),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $ae7bfe2fc249e2f6$var$convertNodePropsToEventData(props) {
    var data = props.data, expanded = props.expanded, selected = props.selected, checked = props.checked, loaded = props.loaded, loading = props.loading, halfChecked = props.halfChecked, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, pos = props.pos, active = props.active, eventKey = props.eventKey;
    var eventData = (0, $ae7bfe2fc249e2f6$var$_objectSpread2.default)((0, $ae7bfe2fc249e2f6$var$_objectSpread2.default)({}, data), {}, {
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    });
    if (!('props' in eventData)) Object.defineProperty(eventData, 'props', {
        get: function get() {
            (0, $ae7bfe2fc249e2f6$var$_warning.default)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
            return props;
        }
    });
    return eventData;
}

});



parcelRegister("7f6uA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $545ef8590397bab8$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcRangeKeys = $545ef8590397bab8$var$calcRangeKeys;
module.exports.convertDirectoryKeysToNodes = $545ef8590397bab8$var$convertDirectoryKeysToNodes;

var $545ef8590397bab8$var$_toConsumableArray2 = $545ef8590397bab8$var$_interopRequireDefault((parcelRequire("fUHKi")));
var $545ef8590397bab8$var$Record;
(function(Record) {
    Record[Record["None"] = 0] = "None";
    Record[Record["Start"] = 1] = "Start";
    Record[Record["End"] = 2] = "End";
})($545ef8590397bab8$var$Record || ($545ef8590397bab8$var$Record = {}));
function $545ef8590397bab8$var$traverseNodesKey(treeData, callback) {
    function processNode(dataNode) {
        var key = dataNode.key, children = dataNode.children;
        if (callback(key, dataNode) !== false) $545ef8590397bab8$var$traverseNodesKey(children || [], callback);
    }
    treeData.forEach(processNode);
}
/** 计算选中范围，只考虑expanded情况以优化性能 */ function $545ef8590397bab8$var$calcRangeKeys(_ref) {
    var treeData = _ref.treeData, expandedKeys = _ref.expandedKeys, startKey = _ref.startKey, endKey = _ref.endKey;
    var keys = [];
    var record = $545ef8590397bab8$var$Record.None;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $545ef8590397bab8$var$traverseNodesKey(treeData, function(key) {
        if (record === $545ef8590397bab8$var$Record.End) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $545ef8590397bab8$var$Record.None) record = $545ef8590397bab8$var$Record.Start;
            else if (record === $545ef8590397bab8$var$Record.Start) {
                record = $545ef8590397bab8$var$Record.End;
                return false;
            }
        } else if (record === $545ef8590397bab8$var$Record.Start) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    });
    return keys;
}
function $545ef8590397bab8$var$convertDirectoryKeysToNodes(treeData, keys) {
    var restKeys = (0, $545ef8590397bab8$var$_toConsumableArray2["default"])(keys);
    var nodes = [];
    $545ef8590397bab8$var$traverseNodesKey(treeData, function(key, node) {
        var index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    });
    return nodes;
}

});



parcelRegister("avewK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7a58117405c25853$var$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7a58117405c25853$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $7a58117405c25853$var$useSyncState;

var $7a58117405c25853$var$React = $7a58117405c25853$var$_interopRequireWildcard((parcelRequire("acw62")));

var $7a58117405c25853$var$_useForceUpdate = $7a58117405c25853$var$_interopRequireDefault((parcelRequire("dnwR1")));
function $7a58117405c25853$var$useSyncState(initialValue) {
    var ref = $7a58117405c25853$var$React.useRef(initialValue);
    var forceUpdate = (0, $7a58117405c25853$var$_useForceUpdate["default"])();
    return [
        function() {
            return ref.current;
        },
        function(newValue) {
            ref.current = newValue;
            // re-render
            forceUpdate();
        }
    ];
}

});

parcelRegister("gWOpQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c5692ba97170f7f8$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c5692ba97170f7f8$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c5692ba97170f7f8$var$_SearchOutlined = $c5692ba97170f7f8$var$_interopRequireDefault((parcelRequire("cDmoh")));

var $c5692ba97170f7f8$var$React = $c5692ba97170f7f8$var$_interopRequireWildcard((parcelRequire("acw62")));

var $c5692ba97170f7f8$var$_input = $c5692ba97170f7f8$var$_interopRequireDefault((parcelRequire("fan4K")));
function $c5692ba97170f7f8$var$FilterSearch(_ref) {
    var value = _ref.value, onChange = _ref.onChange, filterSearch = _ref.filterSearch, tablePrefixCls = _ref.tablePrefixCls, locale = _ref.locale;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $c5692ba97170f7f8$var$React.createElement("div", {
        className: "".concat(tablePrefixCls, "-filter-dropdown-search")
    }, /*#__PURE__*/ $c5692ba97170f7f8$var$React.createElement($c5692ba97170f7f8$var$_input["default"], {
        prefix: /*#__PURE__*/ $c5692ba97170f7f8$var$React.createElement($c5692ba97170f7f8$var$_SearchOutlined["default"], null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: "".concat(tablePrefixCls, "-filter-dropdown-search-input")
    }));
}
var $c5692ba97170f7f8$var$_default = module.exports["default"] = $c5692ba97170f7f8$var$FilterSearch;

});
parcelRegister("fan4K", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b0a9b0845f934962$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b0a9b0845f934962$var$_Group = $b0a9b0845f934962$var$_interopRequireDefault((parcelRequire("fa7IP")));

var $b0a9b0845f934962$var$_Input = $b0a9b0845f934962$var$_interopRequireDefault((parcelRequire("jXMvA")));

var $b0a9b0845f934962$var$_Password = $b0a9b0845f934962$var$_interopRequireDefault((parcelRequire("6LfKN")));

var $b0a9b0845f934962$var$_Search = $b0a9b0845f934962$var$_interopRequireDefault((parcelRequire("dh65r")));

var $b0a9b0845f934962$var$_TextArea = $b0a9b0845f934962$var$_interopRequireDefault((parcelRequire("b72uu")));
var $b0a9b0845f934962$var$Input = $b0a9b0845f934962$var$_Input["default"];
$b0a9b0845f934962$var$Input.Group = $b0a9b0845f934962$var$_Group["default"];
$b0a9b0845f934962$var$Input.Search = $b0a9b0845f934962$var$_Search["default"];
$b0a9b0845f934962$var$Input.TextArea = $b0a9b0845f934962$var$_TextArea["default"];
$b0a9b0845f934962$var$Input.Password = $b0a9b0845f934962$var$_Password["default"];
var $b0a9b0845f934962$var$_default = module.exports["default"] = $b0a9b0845f934962$var$Input;

});
parcelRegister("fa7IP", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b09dc79ba49a2f57$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b09dc79ba49a2f57$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b09dc79ba49a2f57$var$_extends2 = $b09dc79ba49a2f57$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $b09dc79ba49a2f57$var$_defineProperty2 = $b09dc79ba49a2f57$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $b09dc79ba49a2f57$var$_classnames = $b09dc79ba49a2f57$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $b09dc79ba49a2f57$var$_react = $b09dc79ba49a2f57$var$_interopRequireWildcard((parcelRequire("acw62")));
var $b09dc79ba49a2f57$var$React = $b09dc79ba49a2f57$var$_react;

var $qBua1 = parcelRequire("qBua1");

var $gJD51 = parcelRequire("gJD51");
var $b09dc79ba49a2f57$var$Group = function Group(props) {
    var _useContext = (0, $b09dc79ba49a2f57$var$_react.useContext)($qBua1.ConfigContext), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, $b09dc79ba49a2f57$var$_classnames["default"])(prefixCls, (0, $b09dc79ba49a2f57$var$_defineProperty2["default"])((0, $b09dc79ba49a2f57$var$_defineProperty2["default"])((0, $b09dc79ba49a2f57$var$_defineProperty2["default"])((0, $b09dc79ba49a2f57$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-lg"), props.size === 'large'), "".concat(prefixCls, "-sm"), props.size === 'small'), "".concat(prefixCls, "-compact"), props.compact), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var formItemContext = (0, $b09dc79ba49a2f57$var$_react.useContext)($gJD51.FormItemInputContext);
    var groupFormItemContext = (0, $b09dc79ba49a2f57$var$_react.useMemo)(function() {
        return (0, $b09dc79ba49a2f57$var$_extends2["default"])((0, $b09dc79ba49a2f57$var$_extends2["default"])({}, formItemContext), {
            isFormItemInput: false
        });
    }, [
        formItemContext
    ]);
    return /*#__PURE__*/ $b09dc79ba49a2f57$var$React.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $b09dc79ba49a2f57$var$React.createElement($gJD51.FormItemInputContext.Provider, {
        value: groupFormItemContext
    }, props.children));
};
var $b09dc79ba49a2f57$var$_default = module.exports["default"] = $b09dc79ba49a2f57$var$Group;

});

parcelRegister("jXMvA", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e88927c83d424f2b$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e88927c83d424f2b$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
module.exports.fixControlledValue = $e88927c83d424f2b$var$fixControlledValue;
module.exports.resolveOnChange = $e88927c83d424f2b$var$resolveOnChange;
module.exports.triggerFocus = $e88927c83d424f2b$var$triggerFocus;

var $e88927c83d424f2b$var$_defineProperty2 = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $e88927c83d424f2b$var$_extends2 = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $e88927c83d424f2b$var$_typeof2 = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("41YNz")));

var $e88927c83d424f2b$var$_CloseCircleFilled = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("coSzL")));

var $e88927c83d424f2b$var$_classnames = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $e88927c83d424f2b$var$_rcInput = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("cGjF0")));

var $1XVSR = parcelRequire("1XVSR");

var $e88927c83d424f2b$var$_react = $e88927c83d424f2b$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $e88927c83d424f2b$var$_DisabledContext = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("bzUGe")));

var $e88927c83d424f2b$var$_SizeContext = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("lGUuX")));

var $gJD51 = parcelRequire("gJD51");

var $hvVUy = parcelRequire("hvVUy");

var $fFWOB = parcelRequire("fFWOB");

var $e88927c83d424f2b$var$_warning = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("3bEAF")));

var $e88927c83d424f2b$var$_useRemovePasswordTimeout = $e88927c83d424f2b$var$_interopRequireDefault((parcelRequire("8gjrB")));

var $bEwTg = parcelRequire("bEwTg");
var $e88927c83d424f2b$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e88927c83d424f2b$var$fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) return '';
    return String(value);
}
function $e88927c83d424f2b$var$resolveOnChange(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true);
        // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = '';
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $e88927c83d424f2b$var$triggerFocus(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
                break;
        }
    }
}
var $e88927c83d424f2b$var$Input = /*#__PURE__*/ (0, $e88927c83d424f2b$var$_react.forwardRef)(function(props, ref) {
    var customizePrefixCls = props.prefixCls, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, customStatus = props.status, customSize = props.size, customDisabled = props.disabled, onBlur = props.onBlur, onFocus = props.onFocus, suffix = props.suffix, allowClear = props.allowClear, addonAfter = props.addonAfter, addonBefore = props.addonBefore, className = props.className, onChange = props.onChange, rest = $e88927c83d424f2b$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "onChange"
    ]);
    var _React$useContext = $e88927c83d424f2b$var$_react["default"].useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, input = _React$useContext.input;
    var prefixCls = getPrefixCls('input', customizePrefixCls);
    var inputRef = (0, $e88927c83d424f2b$var$_react.useRef)(null);
    // ===================== Compact Item =====================
    var _useCompactItemContex = (0, $hvVUy.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    // ===================== Size =====================
    var size = $e88927c83d424f2b$var$_react["default"].useContext($e88927c83d424f2b$var$_SizeContext["default"]);
    var mergedSize = compactSize || customSize || size;
    // ===================== Disabled =====================
    var disabled = $e88927c83d424f2b$var$_react["default"].useContext($e88927c83d424f2b$var$_DisabledContext["default"]);
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    var _useContext = (0, $e88927c83d424f2b$var$_react.useContext)($gJD51.FormItemInputContext), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $fFWOB.getMergedStatus)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    var inputHasPrefixSuffix = (0, $bEwTg.hasPrefixSuffix)(props) || !!hasFeedback;
    var prevHasPrefixSuffix = (0, $e88927c83d424f2b$var$_react.useRef)(inputHasPrefixSuffix);
    (0, $e88927c83d424f2b$var$_react.useEffect)(function() {
        var _a;
        inputHasPrefixSuffix && prevHasPrefixSuffix.current;
        prevHasPrefixSuffix.current = inputHasPrefixSuffix;
    }, [
        inputHasPrefixSuffix
    ]);
    // ===================== Remove Password value =====================
    var removePasswordTimeout = (0, $e88927c83d424f2b$var$_useRemovePasswordTimeout["default"])(inputRef, true);
    var handleBlur = function handleBlur(e) {
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleChange = function handleChange(e) {
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    var suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ $e88927c83d424f2b$var$_react["default"].createElement($e88927c83d424f2b$var$_react["default"].Fragment, null, suffix, hasFeedback && feedbackIcon);
    // Allow clear
    var mergedAllowClear;
    if ((0, $e88927c83d424f2b$var$_typeof2["default"])(allowClear) === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ $e88927c83d424f2b$var$_react["default"].createElement($e88927c83d424f2b$var$_CloseCircleFilled["default"], null)
    };
    return /*#__PURE__*/ $e88927c83d424f2b$var$_react["default"].createElement($e88927c83d424f2b$var$_rcInput["default"], (0, $e88927c83d424f2b$var$_extends2["default"])({
        ref: (0, $1XVSR.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled || undefined,
        onBlur: handleBlur,
        onFocus: handleFocus,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, $e88927c83d424f2b$var$_classnames["default"])(className, compactItemClassnames),
        onChange: handleChange,
        addonAfter: addonAfter && /*#__PURE__*/ $e88927c83d424f2b$var$_react["default"].createElement($hvVUy.NoCompactStyle, null, /*#__PURE__*/ $e88927c83d424f2b$var$_react["default"].createElement($gJD51.NoFormStyle, {
            override: true,
            status: true
        }, addonAfter)),
        addonBefore: addonBefore && /*#__PURE__*/ $e88927c83d424f2b$var$_react["default"].createElement($hvVUy.NoCompactStyle, null, /*#__PURE__*/ $e88927c83d424f2b$var$_react["default"].createElement($gJD51.NoFormStyle, {
            override: true,
            status: true
        }, addonBefore)),
        inputClassName: (0, $e88927c83d424f2b$var$_classnames["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-sm"), mergedSize === 'small'), "".concat(prefixCls, "-lg"), mergedSize === 'large'), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-borderless"), !bordered), !inputHasPrefixSuffix && (0, $fFWOB.getStatusClassNames)(prefixCls, mergedStatus)),
        affixWrapperClassName: (0, $e88927c83d424f2b$var$_classnames["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-affix-wrapper-sm"), mergedSize === 'small'), "".concat(prefixCls, "-affix-wrapper-lg"), mergedSize === 'large'), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), (0, $fFWOB.getStatusClassNames)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback)),
        wrapperClassName: (0, $e88927c83d424f2b$var$_classnames["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-group-rtl"), direction === 'rtl')),
        groupClassName: (0, $e88927c83d424f2b$var$_classnames["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])((0, $e88927c83d424f2b$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-group-wrapper-sm"), mergedSize === 'small'), "".concat(prefixCls, "-group-wrapper-lg"), mergedSize === 'large'), "".concat(prefixCls, "-group-wrapper-rtl"), direction === 'rtl'), (0, $fFWOB.getStatusClassNames)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback))
    }));
});
var $e88927c83d424f2b$var$_default = module.exports["default"] = $e88927c83d424f2b$var$Input;

});
parcelRegister("8gjrB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $603ee68dde7d6f3c$var$useRemovePasswordTimeout;

var $acw62 = parcelRequire("acw62");
function $603ee68dde7d6f3c$var$useRemovePasswordTimeout(inputRef, triggerOnMount) {
    var removePasswordTimeoutRef = (0, $acw62.useRef)([]);
    var removePasswordTimeout = function removePasswordTimeout() {
        removePasswordTimeoutRef.current.push(setTimeout(function() {
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute('value');
        }));
    };
    (0, $acw62.useEffect)(function() {
        if (triggerOnMount) removePasswordTimeout();
        return function() {
            return removePasswordTimeoutRef.current.forEach(function(timer) {
                if (timer) clearTimeout(timer);
            });
        };
    }, []);
    return removePasswordTimeout;
}

});

parcelRegister("bEwTg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasPrefixSuffix = $87bcf1747be08b5b$var$hasPrefixSuffix;
// eslint-disable-next-line import/prefer-default-export
function $87bcf1747be08b5b$var$hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}

});


parcelRegister("6LfKN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4ec35a399963508b$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4ec35a399963508b$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4ec35a399963508b$var$_extends2 = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $4ec35a399963508b$var$_defineProperty2 = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $4ec35a399963508b$var$_slicedToArray2 = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $4ec35a399963508b$var$_typeof2 = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("41YNz")));

var $4ec35a399963508b$var$_EyeInvisibleOutlined = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("aQH83")));

var $4ec35a399963508b$var$_EyeOutlined = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("e2nTk")));

var $4ec35a399963508b$var$_classnames = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $4ec35a399963508b$var$_omit = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $1XVSR = parcelRequire("1XVSR");

var $4ec35a399963508b$var$_react = $4ec35a399963508b$var$_interopRequireWildcard((parcelRequire("acw62")));
var $4ec35a399963508b$var$React = $4ec35a399963508b$var$_react;

var $qBua1 = parcelRequire("qBua1");

var $4ec35a399963508b$var$_useRemovePasswordTimeout = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("8gjrB")));

var $4ec35a399963508b$var$_Input = $4ec35a399963508b$var$_interopRequireDefault((parcelRequire("jXMvA")));
var $4ec35a399963508b$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4ec35a399963508b$var$defaultIconRender = function defaultIconRender(visible) {
    return visible ? /*#__PURE__*/ $4ec35a399963508b$var$React.createElement($4ec35a399963508b$var$_EyeOutlined["default"], null) : /*#__PURE__*/ $4ec35a399963508b$var$React.createElement($4ec35a399963508b$var$_EyeInvisibleOutlined["default"], null);
};
var $4ec35a399963508b$var$ActionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
var $4ec35a399963508b$var$Password = /*#__PURE__*/ $4ec35a399963508b$var$React.forwardRef(function(props, ref) {
    var _props$visibilityTogg = props.visibilityToggle, visibilityToggle = _props$visibilityTogg === void 0 ? true : _props$visibilityTogg;
    var visibilityControlled = (0, $4ec35a399963508b$var$_typeof2["default"])(visibilityToggle) === 'object' && visibilityToggle.visible !== undefined;
    var _useState = (0, $4ec35a399963508b$var$_react.useState)(function() {
        return visibilityControlled ? visibilityToggle.visible : false;
    }), _useState2 = (0, $4ec35a399963508b$var$_slicedToArray2["default"])(_useState, 2), visible = _useState2[0], setVisible = _useState2[1];
    var inputRef = (0, $4ec35a399963508b$var$_react.useRef)(null);
    $4ec35a399963508b$var$React.useEffect(function() {
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    var removePasswordTimeout = (0, $4ec35a399963508b$var$_useRemovePasswordTimeout["default"])(inputRef);
    var onVisibleChange = function onVisibleChange() {
        var disabled = props.disabled;
        if (disabled) return;
        if (visible) removePasswordTimeout();
        setVisible(function(prevState) {
            var _a;
            var newState = !prevState;
            if ((0, $4ec35a399963508b$var$_typeof2["default"])(visibilityToggle) === 'object') (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, newState);
            return newState;
        });
    };
    var getIcon = function getIcon(prefixCls) {
        var _props$action = props.action, action = _props$action === void 0 ? 'click' : _props$action, _props$iconRender = props.iconRender, iconRender = _props$iconRender === void 0 ? $4ec35a399963508b$var$defaultIconRender : _props$iconRender;
        var iconTrigger = $4ec35a399963508b$var$ActionMap[action] || '';
        var icon = iconRender(visible);
        var iconProps = (0, $4ec35a399963508b$var$_defineProperty2["default"])((0, $4ec35a399963508b$var$_defineProperty2["default"])((0, $4ec35a399963508b$var$_defineProperty2["default"])((0, $4ec35a399963508b$var$_defineProperty2["default"])((0, $4ec35a399963508b$var$_defineProperty2["default"])({}, iconTrigger, onVisibleChange), "className", "".concat(prefixCls, "-icon")), "key", 'passwordIcon'), "onMouseDown", function onMouseDown(e) {
            // Prevent focused state lost
            // https://github.com/ant-design/ant-design/issues/15173
            e.preventDefault();
        }), "onMouseUp", function onMouseUp(e) {
            // Prevent caret position change
            // https://github.com/ant-design/ant-design/issues/23524
            e.preventDefault();
        });
        return /*#__PURE__*/ $4ec35a399963508b$var$React.cloneElement(/*#__PURE__*/ $4ec35a399963508b$var$React.isValidElement(icon) ? icon : /*#__PURE__*/ $4ec35a399963508b$var$React.createElement("span", null, icon), iconProps);
    };
    var renderPassword = function renderPassword(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var className = props.className, customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, size = props.size, restProps = $4ec35a399963508b$var$__rest(props, [
            "className",
            "prefixCls",
            "inputPrefixCls",
            "size"
        ]);
        var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
        var prefixCls = getPrefixCls('input-password', customizePrefixCls);
        var suffixIcon = visibilityToggle && getIcon(prefixCls);
        var inputClassName = (0, $4ec35a399963508b$var$_classnames["default"])(prefixCls, className, (0, $4ec35a399963508b$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-").concat(size), !!size));
        var omittedProps = (0, $4ec35a399963508b$var$_extends2["default"])((0, $4ec35a399963508b$var$_extends2["default"])({}, (0, $4ec35a399963508b$var$_omit["default"])(restProps, [
            'suffix',
            'iconRender',
            'visibilityToggle'
        ])), {
            type: visible ? 'text' : 'password',
            className: inputClassName,
            prefixCls: inputPrefixCls,
            suffix: suffixIcon
        });
        if (size) omittedProps.size = size;
        return /*#__PURE__*/ $4ec35a399963508b$var$React.createElement($4ec35a399963508b$var$_Input["default"], (0, $4ec35a399963508b$var$_extends2["default"])({
            ref: (0, $1XVSR.composeRef)(ref, inputRef)
        }, omittedProps));
    };
    return /*#__PURE__*/ $4ec35a399963508b$var$React.createElement($qBua1.ConfigConsumer, null, renderPassword);
});
var $4ec35a399963508b$var$_default = module.exports["default"] = $4ec35a399963508b$var$Password;

});
parcelRegister("aQH83", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e603734d38a2bd6$var$_EyeInvisibleOutlined = $7e603734d38a2bd6$var$_interopRequireDefault((parcelRequire("c9In5")));
function $7e603734d38a2bd6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $7e603734d38a2bd6$var$_default = $7e603734d38a2bd6$var$_EyeInvisibleOutlined;
module.exports.default = $7e603734d38a2bd6$var$_default;
module.exports = $7e603734d38a2bd6$var$_default;

});
parcelRegister("c9In5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d98be894db4cf28$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $8d98be894db4cf28$var$React = $8d98be894db4cf28$var$_interopRequireWildcard((parcelRequire("acw62")));

var $8d98be894db4cf28$var$_EyeInvisibleOutlined = $1jnue((parcelRequire("8YWgd")));

var $8d98be894db4cf28$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $8d98be894db4cf28$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8d98be894db4cf28$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8d98be894db4cf28$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $8d98be894db4cf28$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $8d98be894db4cf28$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $8d98be894db4cf28$var$React.createElement($8d98be894db4cf28$var$_AntdIcon.default, (0, $8d98be894db4cf28$var$_objectSpread2.default)((0, $8d98be894db4cf28$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $8d98be894db4cf28$var$_EyeInvisibleOutlined.default
    }));
};
var $8d98be894db4cf28$var$RefIcon = /*#__PURE__*/ $8d98be894db4cf28$var$React.forwardRef($8d98be894db4cf28$var$EyeInvisibleOutlined);
var $8d98be894db4cf28$var$_default = module.exports.default = $8d98be894db4cf28$var$RefIcon;

});
parcelRegister("8YWgd", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68a11ea78bff4ff4$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
module.exports.default = $68a11ea78bff4ff4$var$EyeInvisibleOutlined;

});



parcelRegister("e2nTk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a383c8e745f2ce71$var$_EyeOutlined = $a383c8e745f2ce71$var$_interopRequireDefault((parcelRequire("5tASM")));
function $a383c8e745f2ce71$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $a383c8e745f2ce71$var$_default = $a383c8e745f2ce71$var$_EyeOutlined;
module.exports.default = $a383c8e745f2ce71$var$_default;
module.exports = $a383c8e745f2ce71$var$_default;

});
parcelRegister("5tASM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fcc4546171f5955$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $3fcc4546171f5955$var$React = $3fcc4546171f5955$var$_interopRequireWildcard((parcelRequire("acw62")));

var $3fcc4546171f5955$var$_EyeOutlined = $1jnue((parcelRequire("kolgs")));

var $3fcc4546171f5955$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $3fcc4546171f5955$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3fcc4546171f5955$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3fcc4546171f5955$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $3fcc4546171f5955$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $3fcc4546171f5955$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $3fcc4546171f5955$var$React.createElement($3fcc4546171f5955$var$_AntdIcon.default, (0, $3fcc4546171f5955$var$_objectSpread2.default)((0, $3fcc4546171f5955$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $3fcc4546171f5955$var$_EyeOutlined.default
    }));
};
var $3fcc4546171f5955$var$RefIcon = /*#__PURE__*/ $3fcc4546171f5955$var$React.forwardRef($3fcc4546171f5955$var$EyeOutlined);
var $3fcc4546171f5955$var$_default = module.exports.default = $3fcc4546171f5955$var$RefIcon;

});
parcelRegister("kolgs", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ed868b3932e00a5b$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
module.exports.default = $ed868b3932e00a5b$var$EyeOutlined;

});




parcelRegister("dh65r", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9aa19592f8beebee$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9aa19592f8beebee$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9aa19592f8beebee$var$_defineProperty2 = $9aa19592f8beebee$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $9aa19592f8beebee$var$_extends2 = $9aa19592f8beebee$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $9aa19592f8beebee$var$_SearchOutlined = $9aa19592f8beebee$var$_interopRequireDefault((parcelRequire("cDmoh")));

var $9aa19592f8beebee$var$_classnames = $9aa19592f8beebee$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $1XVSR = parcelRequire("1XVSR");

var $9aa19592f8beebee$var$React = $9aa19592f8beebee$var$_interopRequireWildcard((parcelRequire("acw62")));

var $9aa19592f8beebee$var$_button = $9aa19592f8beebee$var$_interopRequireDefault((parcelRequire("efUnK")));

var $qBua1 = parcelRequire("qBua1");

var $9aa19592f8beebee$var$_SizeContext = $9aa19592f8beebee$var$_interopRequireDefault((parcelRequire("lGUuX")));

var $hvVUy = parcelRequire("hvVUy");

var $8hTO8 = parcelRequire("8hTO8");

var $9aa19592f8beebee$var$_Input = $9aa19592f8beebee$var$_interopRequireDefault((parcelRequire("jXMvA")));
var $9aa19592f8beebee$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9aa19592f8beebee$var$Search = /*#__PURE__*/ $9aa19592f8beebee$var$React.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, className = props.className, customizeSize = props.size, suffix = props.suffix, _props$enterButton = props.enterButton, enterButton = _props$enterButton === void 0 ? false : _props$enterButton, addonAfter = props.addonAfter, loading = props.loading, disabled = props.disabled, customOnSearch = props.onSearch, customOnChange = props.onChange, onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, restProps = $9aa19592f8beebee$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    var _React$useContext = $9aa19592f8beebee$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var contextSize = $9aa19592f8beebee$var$React.useContext($9aa19592f8beebee$var$_SizeContext["default"]);
    var composedRef = $9aa19592f8beebee$var$React.useRef(false);
    var prefixCls = getPrefixCls('input-search', customizePrefixCls);
    var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    var _useCompactItemContex = (0, $hvVUy.useCompactItemContext)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize;
    var size = compactSize || customizeSize || contextSize;
    var inputRef = $9aa19592f8beebee$var$React.useRef(null);
    var onChange = function onChange(e) {
        if (e && e.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e);
        if (customOnChange) customOnChange(e);
    };
    var onMouseDown = function onMouseDown(e) {
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    var onSearch = function onSearch(e) {
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e);
    };
    var onPressEnter = function onPressEnter(e) {
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    var searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $9aa19592f8beebee$var$React.createElement($9aa19592f8beebee$var$_SearchOutlined["default"], null) : null;
    var btnClassName = "".concat(prefixCls, "-button");
    var button;
    var enterButtonAsElement = enterButton || {};
    var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $8hTO8.cloneElement)(enterButtonAsElement, (0, $9aa19592f8beebee$var$_extends2["default"])({
        onMouseDown: onMouseDown,
        onClick: function onClick(e) {
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: 'enterButton'
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $9aa19592f8beebee$var$React.createElement($9aa19592f8beebee$var$_button["default"], {
        className: btnClassName,
        type: enterButton ? 'primary' : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $8hTO8.cloneElement)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    var cls = (0, $9aa19592f8beebee$var$_classnames["default"])(prefixCls, (0, $9aa19592f8beebee$var$_defineProperty2["default"])((0, $9aa19592f8beebee$var$_defineProperty2["default"])((0, $9aa19592f8beebee$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(size), !!size), "".concat(prefixCls, "-with-button"), !!enterButton), className);
    var handleOnCompositionStart = function handleOnCompositionStart(e) {
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var handleOnCompositionEnd = function handleOnCompositionEnd(e) {
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $9aa19592f8beebee$var$React.createElement($9aa19592f8beebee$var$_Input["default"], (0, $9aa19592f8beebee$var$_extends2["default"])({
        ref: (0, $1XVSR.composeRef)(inputRef, ref),
        onPressEnter: onPressEnter
    }, restProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        prefixCls: inputPrefixCls,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        className: cls,
        disabled: disabled
    }));
});
var $9aa19592f8beebee$var$_default = module.exports["default"] = $9aa19592f8beebee$var$Search;

});

parcelRegister("b72uu", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $817247c79f24cf04$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $817247c79f24cf04$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $817247c79f24cf04$var$_typeof2 = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("41YNz")));

var $817247c79f24cf04$var$_defineProperty2 = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $817247c79f24cf04$var$_extends2 = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $817247c79f24cf04$var$_slicedToArray2 = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $817247c79f24cf04$var$_toConsumableArray2 = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $817247c79f24cf04$var$_classnames = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $817247c79f24cf04$var$_rcTextarea = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("4GwQn")));

var $817247c79f24cf04$var$_useMergedState3 = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("7CJZj")));

var $817247c79f24cf04$var$_omit = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("cPSVu")));

var $817247c79f24cf04$var$React = $817247c79f24cf04$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qBua1 = parcelRequire("qBua1");

var $817247c79f24cf04$var$_DisabledContext = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("bzUGe")));

var $817247c79f24cf04$var$_SizeContext = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("lGUuX")));

var $gJD51 = parcelRequire("gJD51");

var $fFWOB = parcelRequire("fFWOB");

var $817247c79f24cf04$var$_ClearableLabeledInput = $817247c79f24cf04$var$_interopRequireDefault((parcelRequire("2UUUg")));

var $jXMvA = parcelRequire("jXMvA");
var $817247c79f24cf04$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $817247c79f24cf04$var$fixEmojiLength(value, maxLength) {
    return (0, $817247c79f24cf04$var$_toConsumableArray2["default"])(value || '').slice(0, maxLength).join('');
}
function $817247c79f24cf04$var$setTriggerValue(isCursorInEnd, preValue, triggerValue, maxLength) {
    var newTriggerValue = triggerValue;
    if (isCursorInEnd) // 光标在尾部，直接截断
    newTriggerValue = $817247c79f24cf04$var$fixEmojiLength(triggerValue, maxLength);
    else if ((0, $817247c79f24cf04$var$_toConsumableArray2["default"])(preValue || '').length < triggerValue.length && (0, $817247c79f24cf04$var$_toConsumableArray2["default"])(triggerValue || '').length > maxLength) // 光标在中间，如果最后的值超过最大值，则采用原先的值
    newTriggerValue = preValue;
    return newTriggerValue;
}
var $817247c79f24cf04$var$TextArea = /*#__PURE__*/ $817247c79f24cf04$var$React.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, _a$showCount = _a.showCount, showCount = _a$showCount === void 0 ? false : _a$showCount, maxLength = _a.maxLength, className = _a.className, style = _a.style, customizeSize = _a.size, customDisabled = _a.disabled, onCompositionStart = _a.onCompositionStart, onCompositionEnd = _a.onCompositionEnd, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, customStatus = _a.status, props = $817247c79f24cf04$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "showCount",
        "maxLength",
        "className",
        "style",
        "size",
        "disabled",
        "onCompositionStart",
        "onCompositionEnd",
        "onChange",
        "onFocus",
        "onBlur",
        "status"
    ]);
    var _React$useContext = $817247c79f24cf04$var$React.useContext($qBua1.ConfigContext), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $817247c79f24cf04$var$React.useContext($817247c79f24cf04$var$_SizeContext["default"]);
    // ===================== Disabled =====================
    var disabled = $817247c79f24cf04$var$React.useContext($817247c79f24cf04$var$_DisabledContext["default"]);
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var _React$useContext2 = $817247c79f24cf04$var$React.useContext($gJD51.FormItemInputContext), contextStatus = _React$useContext2.status, hasFeedback = _React$useContext2.hasFeedback, isFormItemInput = _React$useContext2.isFormItemInput, feedbackIcon = _React$useContext2.feedbackIcon;
    var mergedStatus = (0, $fFWOB.getMergedStatus)(contextStatus, customStatus);
    var innerRef = $817247c79f24cf04$var$React.useRef(null);
    var clearableInputRef = $817247c79f24cf04$var$React.useRef(null);
    var _React$useState = $817247c79f24cf04$var$React.useState(false), _React$useState2 = (0, $817247c79f24cf04$var$_slicedToArray2["default"])(_React$useState, 2), compositing = _React$useState2[0], setCompositing = _React$useState2[1];
    var _React$useState3 = $817247c79f24cf04$var$React.useState(false), _React$useState4 = (0, $817247c79f24cf04$var$_slicedToArray2["default"])(_React$useState3, 2), focused = _React$useState4[0], setFocused = _React$useState4[1];
    var oldCompositionValueRef = $817247c79f24cf04$var$React.useRef();
    var oldSelectionStartRef = $817247c79f24cf04$var$React.useRef(0);
    var _useMergedState = (0, $817247c79f24cf04$var$_useMergedState3["default"])(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $817247c79f24cf04$var$_slicedToArray2["default"])(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var hidden = props.hidden;
    var handleSetValue = function handleSetValue(val, callback) {
        if (props.value === undefined) {
            setValue(val);
            callback === null || callback === void 0 || callback();
        }
    };
    // =========================== Value Update ===========================
    // Max length value
    var hasMaxLength = Number(maxLength) > 0;
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        setCompositing(true);
        // 拼音输入前保存一份旧值
        oldCompositionValueRef.current = value;
        // 保存旧的光标位置
        oldSelectionStartRef.current = e.currentTarget.selectionStart;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        var _a;
        setCompositing(false);
        var triggerValue = e.currentTarget.value;
        if (hasMaxLength) {
            var isCursorInEnd = oldSelectionStartRef.current >= maxLength + 1 || oldSelectionStartRef.current === ((_a = oldCompositionValueRef.current) === null || _a === void 0 ? void 0 : _a.length);
            triggerValue = $817247c79f24cf04$var$setTriggerValue(isCursorInEnd, oldCompositionValueRef.current, triggerValue, maxLength);
        }
        // Patch composition onChange when value changed
        if (triggerValue !== value) {
            handleSetValue(triggerValue);
            (0, $jXMvA.resolveOnChange)(e.currentTarget, e, onChange, triggerValue);
        }
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleChange = function handleChange(e) {
        var triggerValue = e.target.value;
        if (!compositing && hasMaxLength) {
            // 1. 复制粘贴超过maxlength的情况 2.未超过maxlength的情况
            var isCursorInEnd = e.target.selectionStart >= maxLength + 1 || e.target.selectionStart === triggerValue.length || !e.target.selectionStart;
            triggerValue = $817247c79f24cf04$var$setTriggerValue(isCursorInEnd, value, triggerValue, maxLength);
        }
        handleSetValue(triggerValue);
        (0, $jXMvA.resolveOnChange)(e.currentTarget, e, onChange, triggerValue);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    $817247c79f24cf04$var$React.useEffect(function() {
        setFocused(function(prev) {
            return !mergedDisabled && prev;
        });
    }, [
        mergedDisabled
    ]);
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        var _a, _b, _c;
        handleSetValue('');
        (_a = innerRef.current) === null || _a === void 0 || _a.focus();
        (0, $jXMvA.resolveOnChange)((_c = (_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.resizableTextArea) === null || _c === void 0 ? void 0 : _c.textArea, e, onChange);
    };
    var prefixCls = getPrefixCls('input', customizePrefixCls);
    $817247c79f24cf04$var$React.useImperativeHandle(ref, function() {
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: function focus(option) {
                var _a, _b;
                (0, $jXMvA.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: function blur() {
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    var textArea = /*#__PURE__*/ $817247c79f24cf04$var$React.createElement($817247c79f24cf04$var$_rcTextarea["default"], (0, $817247c79f24cf04$var$_extends2["default"])({}, (0, $817247c79f24cf04$var$_omit["default"])(props, [
        'allowClear'
    ]), {
        disabled: mergedDisabled,
        className: (0, $817247c79f24cf04$var$_classnames["default"])((0, $817247c79f24cf04$var$_defineProperty2["default"])((0, $817247c79f24cf04$var$_defineProperty2["default"])((0, $817247c79f24cf04$var$_defineProperty2["default"])((0, $817247c79f24cf04$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-borderless"), !bordered), className, className && !showCount), "".concat(prefixCls, "-sm"), size === 'small' || customizeSize === 'small'), "".concat(prefixCls, "-lg"), size === 'large' || customizeSize === 'large'), (0, $fFWOB.getStatusClassNames)(prefixCls, mergedStatus)),
        style: showCount ? {
            resize: style === null || style === void 0 ? void 0 : style.resize
        } : style,
        prefixCls: prefixCls,
        onCompositionStart: onInternalCompositionStart,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onCompositionEnd: onInternalCompositionEnd,
        ref: innerRef
    }));
    var val = (0, $jXMvA.fixControlledValue)(value);
    if (!compositing && hasMaxLength && (props.value === null || props.value === undefined)) // fix #27612 将value转为数组进行截取，解决 '😂'.length === 2 等emoji表情导致的截取乱码的问题
    val = $817247c79f24cf04$var$fixEmojiLength(val, maxLength);
    // TextArea
    var textareaNode = /*#__PURE__*/ $817247c79f24cf04$var$React.createElement($817247c79f24cf04$var$_ClearableLabeledInput["default"], (0, $817247c79f24cf04$var$_extends2["default"])({
        disabled: mergedDisabled,
        focused: focused
    }, props, {
        prefixCls: prefixCls,
        direction: direction,
        inputType: "text",
        value: val,
        element: textArea,
        handleReset: handleReset,
        ref: clearableInputRef,
        bordered: bordered,
        status: customStatus,
        style: showCount ? undefined : style
    }));
    // Only show text area wrapper when needed
    if (showCount || hasFeedback) {
        var valueLength = (0, $817247c79f24cf04$var$_toConsumableArray2["default"])(val).length;
        var dataCount = '';
        if ((0, $817247c79f24cf04$var$_typeof2["default"])(showCount) === 'object') dataCount = showCount.formatter({
            value: val,
            count: valueLength,
            maxLength: maxLength
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : '');
        return /*#__PURE__*/ $817247c79f24cf04$var$React.createElement("div", {
            hidden: hidden,
            className: (0, $817247c79f24cf04$var$_classnames["default"])("".concat(prefixCls, "-textarea"), (0, $817247c79f24cf04$var$_defineProperty2["default"])((0, $817247c79f24cf04$var$_defineProperty2["default"])((0, $817247c79f24cf04$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-textarea-rtl"), direction === 'rtl'), "".concat(prefixCls, "-textarea-show-count"), showCount), "".concat(prefixCls, "-textarea-in-form-item"), isFormItemInput), (0, $fFWOB.getStatusClassNames)("".concat(prefixCls, "-textarea"), mergedStatus, hasFeedback), className),
            style: style,
            "data-count": dataCount
        }, textareaNode, hasFeedback && /*#__PURE__*/ $817247c79f24cf04$var$React.createElement("span", {
            className: "".concat(prefixCls, "-textarea-suffix")
        }, feedbackIcon));
    }
    return textareaNode;
});
var $817247c79f24cf04$var$_default = module.exports["default"] = $817247c79f24cf04$var$TextArea;

});
parcelRegister("2UUUg", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $21fcf42cf4650760$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $21fcf42cf4650760$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $21fcf42cf4650760$var$_defineProperty2 = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $21fcf42cf4650760$var$_classCallCheck2 = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("fu0YK")));

var $21fcf42cf4650760$var$_createClass2 = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("lR7jo")));

var $21fcf42cf4650760$var$_possibleConstructorReturn2 = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("eN9hz")));

var $21fcf42cf4650760$var$_isNativeReflectConstruct2 = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("5HCVq")));

var $21fcf42cf4650760$var$_getPrototypeOf2 = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("cGTaw")));

var $21fcf42cf4650760$var$_inherits2 = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("f8wIT")));

var $21fcf42cf4650760$var$_CloseCircleFilled = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("coSzL")));

var $21fcf42cf4650760$var$_classnames = $21fcf42cf4650760$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $21fcf42cf4650760$var$React = $21fcf42cf4650760$var$_interopRequireWildcard((parcelRequire("acw62")));

var $gJD51 = parcelRequire("gJD51");

var $8hTO8 = parcelRequire("8hTO8");

var $fFWOB = parcelRequire("fFWOB");

var $3YGhB = parcelRequire("3YGhB");
function $21fcf42cf4650760$var$_callSuper(t, o, e) {
    return o = (0, $21fcf42cf4650760$var$_getPrototypeOf2["default"])(o), (0, $21fcf42cf4650760$var$_possibleConstructorReturn2["default"])(t, (0, $21fcf42cf4650760$var$_isNativeReflectConstruct2["default"])() ? Reflect.construct(o, e || [], (0, $21fcf42cf4650760$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
var $21fcf42cf4650760$var$ClearableInputType = (0, $3YGhB.tuple)('text', 'input');
function $21fcf42cf4650760$var$hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
var $21fcf42cf4650760$var$ClearableLabeledInput = /*#__PURE__*/ function(_React$Component) {
    (0, $21fcf42cf4650760$var$_inherits2["default"])(ClearableLabeledInput, _React$Component);
    function ClearableLabeledInput() {
        (0, $21fcf42cf4650760$var$_classCallCheck2["default"])(this, ClearableLabeledInput);
        return $21fcf42cf4650760$var$_callSuper(this, ClearableLabeledInput, arguments);
    }
    (0, $21fcf42cf4650760$var$_createClass2["default"])(ClearableLabeledInput, [
        {
            key: "renderClearIcon",
            value: function renderClearIcon(prefixCls) {
                var _this$props = this.props, value = _this$props.value, disabled = _this$props.disabled, readOnly = _this$props.readOnly, handleReset = _this$props.handleReset, suffix = _this$props.suffix;
                var needClear = !disabled && !readOnly && value;
                var className = "".concat(prefixCls, "-clear-icon");
                return /*#__PURE__*/ $21fcf42cf4650760$var$React.createElement($21fcf42cf4650760$var$_CloseCircleFilled["default"], {
                    onClick: handleReset,
                    // Do not trigger onBlur when clear input
                    // https://github.com/ant-design/ant-design/issues/31200
                    onMouseDown: function onMouseDown(e) {
                        return e.preventDefault();
                    },
                    className: (0, $21fcf42cf4650760$var$_classnames["default"])((0, $21fcf42cf4650760$var$_defineProperty2["default"])((0, $21fcf42cf4650760$var$_defineProperty2["default"])({}, "".concat(className, "-hidden"), !needClear), "".concat(className, "-has-suffix"), !!suffix), className),
                    role: "button"
                });
            }
        },
        {
            key: "renderTextAreaWithClearIcon",
            value: function renderTextAreaWithClearIcon(prefixCls, element, statusContext) {
                var _this$props2 = this.props, value = _this$props2.value, allowClear = _this$props2.allowClear, className = _this$props2.className, focused = _this$props2.focused, style = _this$props2.style, direction = _this$props2.direction, bordered = _this$props2.bordered, hidden = _this$props2.hidden, customStatus = _this$props2.status;
                var contextStatus = statusContext.status, hasFeedback = statusContext.hasFeedback;
                if (!allowClear) return (0, $8hTO8.cloneElement)(element, {
                    value: value
                });
                var affixWrapperCls = (0, $21fcf42cf4650760$var$_classnames["default"])("".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"), (0, $fFWOB.getStatusClassNames)("".concat(prefixCls, "-affix-wrapper"), (0, $fFWOB.getMergedStatus)(contextStatus, customStatus), hasFeedback), (0, $21fcf42cf4650760$var$_defineProperty2["default"])((0, $21fcf42cf4650760$var$_defineProperty2["default"])((0, $21fcf42cf4650760$var$_defineProperty2["default"])((0, $21fcf42cf4650760$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-affix-wrapper-focused"), focused), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), "".concat(className), !$21fcf42cf4650760$var$hasAddon(this.props) && className));
                return /*#__PURE__*/ $21fcf42cf4650760$var$React.createElement("span", {
                    className: affixWrapperCls,
                    style: style,
                    hidden: hidden
                }, (0, $8hTO8.cloneElement)(element, {
                    style: null,
                    value: value
                }), this.renderClearIcon(prefixCls));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ $21fcf42cf4650760$var$React.createElement($gJD51.FormItemInputContext.Consumer, null, function(statusContext) {
                    var _this$props3 = _this.props, prefixCls = _this$props3.prefixCls, inputType = _this$props3.inputType, element = _this$props3.element;
                    if (inputType === $21fcf42cf4650760$var$ClearableInputType[0]) return _this.renderTextAreaWithClearIcon(prefixCls, element, statusContext);
                });
            }
        }
    ]);
    return ClearableLabeledInput;
}($21fcf42cf4650760$var$React.Component);
var $21fcf42cf4650760$var$_default = module.exports["default"] = $21fcf42cf4650760$var$ClearableLabeledInput;

});




parcelRegister("dpKMn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c41e58cb6c2d0f4$var$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9c41e58cb6c2d0f4$var$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9c41e58cb6c2d0f4$var$React = $9c41e58cb6c2d0f4$var$_interopRequireWildcard((parcelRequire("acw62")));

var $9c41e58cb6c2d0f4$var$_KeyCode = $9c41e58cb6c2d0f4$var$_interopRequireDefault((parcelRequire("cfElf")));
var $9c41e58cb6c2d0f4$var$onKeyDown = function onKeyDown(event) {
    var keyCode = event.keyCode;
    if (keyCode === $9c41e58cb6c2d0f4$var$_KeyCode["default"].ENTER) event.stopPropagation();
};
var $9c41e58cb6c2d0f4$var$FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
    return /*#__PURE__*/ $9c41e58cb6c2d0f4$var$React.createElement("div", {
        className: props.className,
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        onKeyDown: $9c41e58cb6c2d0f4$var$onKeyDown
    }, props.children);
};
var $9c41e58cb6c2d0f4$var$_default = module.exports["default"] = $9c41e58cb6c2d0f4$var$FilterDropdownMenuWrapper;

});
parcelRegister("cfElf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $8eb62dc9fbcbae2e$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $8eb62dc9fbcbae2e$var$KeyCode.F1 && keyCode <= $8eb62dc9fbcbae2e$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $8eb62dc9fbcbae2e$var$KeyCode.ALT:
            case $8eb62dc9fbcbae2e$var$KeyCode.CAPS_LOCK:
            case $8eb62dc9fbcbae2e$var$KeyCode.CONTEXT_MENU:
            case $8eb62dc9fbcbae2e$var$KeyCode.CTRL:
            case $8eb62dc9fbcbae2e$var$KeyCode.DOWN:
            case $8eb62dc9fbcbae2e$var$KeyCode.END:
            case $8eb62dc9fbcbae2e$var$KeyCode.ESC:
            case $8eb62dc9fbcbae2e$var$KeyCode.HOME:
            case $8eb62dc9fbcbae2e$var$KeyCode.INSERT:
            case $8eb62dc9fbcbae2e$var$KeyCode.LEFT:
            case $8eb62dc9fbcbae2e$var$KeyCode.MAC_FF_META:
            case $8eb62dc9fbcbae2e$var$KeyCode.META:
            case $8eb62dc9fbcbae2e$var$KeyCode.NUMLOCK:
            case $8eb62dc9fbcbae2e$var$KeyCode.NUM_CENTER:
            case $8eb62dc9fbcbae2e$var$KeyCode.PAGE_DOWN:
            case $8eb62dc9fbcbae2e$var$KeyCode.PAGE_UP:
            case $8eb62dc9fbcbae2e$var$KeyCode.PAUSE:
            case $8eb62dc9fbcbae2e$var$KeyCode.PRINT_SCREEN:
            case $8eb62dc9fbcbae2e$var$KeyCode.RIGHT:
            case $8eb62dc9fbcbae2e$var$KeyCode.SHIFT:
            case $8eb62dc9fbcbae2e$var$KeyCode.UP:
            case $8eb62dc9fbcbae2e$var$KeyCode.WIN_KEY:
            case $8eb62dc9fbcbae2e$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $8eb62dc9fbcbae2e$var$KeyCode.ZERO && keyCode <= $8eb62dc9fbcbae2e$var$KeyCode.NINE) return true;
        if (keyCode >= $8eb62dc9fbcbae2e$var$KeyCode.NUM_ZERO && keyCode <= $8eb62dc9fbcbae2e$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $8eb62dc9fbcbae2e$var$KeyCode.A && keyCode <= $8eb62dc9fbcbae2e$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $8eb62dc9fbcbae2e$var$KeyCode.SPACE:
            case $8eb62dc9fbcbae2e$var$KeyCode.QUESTION_MARK:
            case $8eb62dc9fbcbae2e$var$KeyCode.NUM_PLUS:
            case $8eb62dc9fbcbae2e$var$KeyCode.NUM_MINUS:
            case $8eb62dc9fbcbae2e$var$KeyCode.NUM_PERIOD:
            case $8eb62dc9fbcbae2e$var$KeyCode.NUM_DIVISION:
            case $8eb62dc9fbcbae2e$var$KeyCode.SEMICOLON:
            case $8eb62dc9fbcbae2e$var$KeyCode.DASH:
            case $8eb62dc9fbcbae2e$var$KeyCode.EQUALS:
            case $8eb62dc9fbcbae2e$var$KeyCode.COMMA:
            case $8eb62dc9fbcbae2e$var$KeyCode.PERIOD:
            case $8eb62dc9fbcbae2e$var$KeyCode.SLASH:
            case $8eb62dc9fbcbae2e$var$KeyCode.APOSTROPHE:
            case $8eb62dc9fbcbae2e$var$KeyCode.SINGLE_QUOTE:
            case $8eb62dc9fbcbae2e$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $8eb62dc9fbcbae2e$var$KeyCode.BACKSLASH:
            case $8eb62dc9fbcbae2e$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $8eb62dc9fbcbae2e$var$_default = module.exports.default = $8eb62dc9fbcbae2e$var$KeyCode;

});




parcelRegister("dNMvG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a0c57b073de6da0e$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a0c57b073de6da0e$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a0c57b073de6da0e$var$useLazyKVMap;

var $a0c57b073de6da0e$var$_typeof2 = $a0c57b073de6da0e$var$_interopRequireDefault((parcelRequire("41YNz")));

var $a0c57b073de6da0e$var$React = $a0c57b073de6da0e$var$_interopRequireWildcard((parcelRequire("acw62")));
function $a0c57b073de6da0e$var$useLazyKVMap(data, childrenColumnName, getRowKey) {
    var mapCacheRef = $a0c57b073de6da0e$var$React.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            var kvMap = new Map();
            /* eslint-disable no-inner-declarations */ function dig(records) {
                records.forEach(function(record, index) {
                    var rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if (record && (0, $a0c57b073de6da0e$var$_typeof2["default"])(record) === 'object' && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            /* eslint-enable */ dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap.get(key);
    }
    return [
        getRecordByKey
    ];
}

});

parcelRegister("lPwfn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fe4760002304098c$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_PAGE_SIZE = void 0;
module.exports["default"] = $fe4760002304098c$var$usePagination;
module.exports.getPaginationParam = $fe4760002304098c$var$getPaginationParam;

var $fe4760002304098c$var$_extends2 = $fe4760002304098c$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $fe4760002304098c$var$_slicedToArray2 = $fe4760002304098c$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $fe4760002304098c$var$_typeof2 = $fe4760002304098c$var$_interopRequireDefault((parcelRequire("41YNz")));

var $acw62 = parcelRequire("acw62");
var $fe4760002304098c$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fe4760002304098c$var$DEFAULT_PAGE_SIZE = module.exports.DEFAULT_PAGE_SIZE = 10;
function $fe4760002304098c$var$getPaginationParam(pagination, mergedPagination) {
    var param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    var paginationObj = pagination && (0, $fe4760002304098c$var$_typeof2["default"])(pagination) === 'object' ? pagination : {};
    Object.keys(paginationObj).forEach(function(pageProp) {
        var value = mergedPagination[pageProp];
        if (typeof value !== 'function') param[pageProp] = value;
    });
    return param;
}
function $fe4760002304098c$var$extendsObject() {
    var result = {};
    for(var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++)list[_key] = arguments[_key];
    list.forEach(function(obj) {
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) result[key] = val;
        });
    });
    return result;
}
function $fe4760002304098c$var$usePagination(total, pagination, onChange) {
    var _a = pagination && (0, $fe4760002304098c$var$_typeof2["default"])(pagination) === 'object' ? pagination : {}, _a$total = _a.total, paginationTotal = _a$total === void 0 ? 0 : _a$total, paginationObj = $fe4760002304098c$var$__rest(_a, [
        "total"
    ]);
    var _useState = (0, $acw62.useState)(function() {
        return {
            current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : $fe4760002304098c$var$DEFAULT_PAGE_SIZE
        };
    }), _useState2 = (0, $fe4760002304098c$var$_slicedToArray2["default"])(_useState, 2), innerPagination = _useState2[0], setInnerPagination = _useState2[1];
    // ============ Basic Pagination Config ============
    var mergedPagination = $fe4760002304098c$var$extendsObject(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    var maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    var refreshPagination = function refreshPagination(current, pageSize) {
        setInnerPagination({
            current: current !== null && current !== void 0 ? current : 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    var onInternalChange = function onInternalChange(current, pageSize) {
        var _a;
        if (pagination) (_a = pagination.onChange) === null || _a === void 0 || _a.call(pagination, current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize));
    };
    if (pagination === false) return [
        {},
        function() {}
    ];
    return [
        (0, $fe4760002304098c$var$_extends2["default"])((0, $fe4760002304098c$var$_extends2["default"])({}, mergedPagination), {
            onChange: onInternalChange
        }),
        refreshPagination
    ];
}

});

parcelRegister("6MYux", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4f162624d58974f1$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4f162624d58974f1$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SELECTION_NONE = module.exports.SELECTION_INVERT = module.exports.SELECTION_COLUMN = module.exports.SELECTION_ALL = void 0;
module.exports["default"] = $4f162624d58974f1$var$useSelection;

var $4f162624d58974f1$var$_defineProperty2 = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $4f162624d58974f1$var$_toArray2 = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("6PNir")));

var $4f162624d58974f1$var$_extends2 = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $4f162624d58974f1$var$_slicedToArray2 = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $4f162624d58974f1$var$_toConsumableArray2 = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $4f162624d58974f1$var$_typeof2 = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("41YNz")));

var $4f162624d58974f1$var$_DownOutlined = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("3TR7r")));
parcelRequire("4XkeF");
var $aLkKv = parcelRequire("aLkKv");

var $1ZsBP = parcelRequire("1ZsBP");

var $hLXwx = parcelRequire("hLXwx");

var $eYM7h = parcelRequire("eYM7h");

var $4f162624d58974f1$var$_useMergedState3 = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("7CJZj")));

var $4f162624d58974f1$var$_react = $4f162624d58974f1$var$_interopRequireWildcard((parcelRequire("acw62")));
var $4f162624d58974f1$var$React = $4f162624d58974f1$var$_react;

var $4f162624d58974f1$var$_checkbox = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("kycNO")));

var $4f162624d58974f1$var$_dropdown = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("lVObl")));

var $4f162624d58974f1$var$_radio = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("9wjAb")));

var $4f162624d58974f1$var$_warning = $4f162624d58974f1$var$_interopRequireDefault((parcelRequire("3bEAF")));
// TODO: warning if use ajax!!!
var $4f162624d58974f1$var$SELECTION_COLUMN = module.exports.SELECTION_COLUMN = {};
var $4f162624d58974f1$var$SELECTION_ALL = module.exports.SELECTION_ALL = 'SELECT_ALL';
var $4f162624d58974f1$var$SELECTION_INVERT = module.exports.SELECTION_INVERT = 'SELECT_INVERT';
var $4f162624d58974f1$var$SELECTION_NONE = module.exports.SELECTION_NONE = 'SELECT_NONE';
var $4f162624d58974f1$var$EMPTY_LIST = [];
function $4f162624d58974f1$var$flattenData(data, childrenColumnName) {
    var list = [];
    (data || []).forEach(function(record) {
        list.push(record);
        if (record && (0, $4f162624d58974f1$var$_typeof2["default"])(record) === 'object' && childrenColumnName in record) list = [].concat((0, $4f162624d58974f1$var$_toConsumableArray2["default"])(list), (0, $4f162624d58974f1$var$_toConsumableArray2["default"])($4f162624d58974f1$var$flattenData(record[childrenColumnName], childrenColumnName)));
    });
    return list;
}
function $4f162624d58974f1$var$useSelection(rowSelection, config) {
    var _ref = rowSelection || {}, preserveSelectedRowKeys = _ref.preserveSelectedRowKeys, selectedRowKeys = _ref.selectedRowKeys, defaultSelectedRowKeys = _ref.defaultSelectedRowKeys, getCheckboxProps = _ref.getCheckboxProps, onSelectionChange = _ref.onChange, onSelect = _ref.onSelect, onSelectAll = _ref.onSelectAll, onSelectInvert = _ref.onSelectInvert, onSelectNone = _ref.onSelectNone, onSelectMultiple = _ref.onSelectMultiple, selectionColWidth = _ref.columnWidth, selectionType = _ref.type, selections = _ref.selections, fixed = _ref.fixed, customizeRenderCell = _ref.renderCell, hideSelectAll = _ref.hideSelectAll, _ref$checkStrictly = _ref.checkStrictly, checkStrictly = _ref$checkStrictly === void 0 ? true : _ref$checkStrictly;
    var prefixCls = config.prefixCls, data = config.data, pageData = config.pageData, getRecordByKey = config.getRecordByKey, getRowKey = config.getRowKey, expandType = config.expandType, childrenColumnName = config.childrenColumnName, tableLocale = config.locale, getPopupContainer = config.getPopupContainer;
    // ========================= Keys =========================
    var _useMergedState = (0, $4f162624d58974f1$var$_useMergedState3["default"])(selectedRowKeys || defaultSelectedRowKeys || $4f162624d58974f1$var$EMPTY_LIST, {
        value: selectedRowKeys
    }), _useMergedState2 = (0, $4f162624d58974f1$var$_slicedToArray2["default"])(_useMergedState, 2), mergedSelectedKeys = _useMergedState2[0], setMergedSelectedKeys = _useMergedState2[1];
    // ======================== Caches ========================
    var preserveRecordsRef = $4f162624d58974f1$var$React.useRef(new Map());
    var updatePreserveRecordsCache = (0, $4f162624d58974f1$var$_react.useCallback)(function(keys) {
        if (preserveSelectedRowKeys) {
            var newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach(function(key) {
                var record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $4f162624d58974f1$var$React.useEffect(function() {
        updatePreserveRecordsCache(mergedSelectedKeys);
    }, [
        mergedSelectedKeys
    ]);
    var _useMemo = (0, $4f162624d58974f1$var$_react.useMemo)(function() {
        return checkStrictly ? {
            keyEntities: null
        } : (0, $eYM7h.convertDataToEntities)(data, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName
    ]), keyEntities = _useMemo.keyEntities;
    // Get flatten data
    var flattedData = (0, $4f162624d58974f1$var$_react.useMemo)(function() {
        return $4f162624d58974f1$var$flattenData(pageData, childrenColumnName);
    }, [
        pageData,
        childrenColumnName
    ]);
    // Get all checkbox props
    var checkboxPropsMap = (0, $4f162624d58974f1$var$_react.useMemo)(function() {
        var map = new Map();
        flattedData.forEach(function(record, index) {
            var key = getRowKey(record, index);
            var checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    var isCheckboxDisabled = (0, $4f162624d58974f1$var$_react.useCallback)(function(r) {
        var _a;
        return !!((_a = checkboxPropsMap.get(getRowKey(r))) === null || _a === void 0 ? void 0 : _a.disabled);
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    var _useMemo2 = (0, $4f162624d58974f1$var$_react.useMemo)(function() {
        if (checkStrictly) return [
            mergedSelectedKeys || [],
            []
        ];
        var _conductCheck = (0, $hLXwx.conductCheck)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled), checkedKeys = _conductCheck.checkedKeys, halfCheckedKeys = _conductCheck.halfCheckedKeys;
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeys,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]), _useMemo3 = (0, $4f162624d58974f1$var$_slicedToArray2["default"])(_useMemo2, 2), derivedSelectedKeys = _useMemo3[0], derivedHalfSelectedKeys = _useMemo3[1];
    var derivedSelectedKeySet = (0, $4f162624d58974f1$var$_react.useMemo)(function() {
        var keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    var derivedHalfSelectedKeySet = (0, $4f162624d58974f1$var$_react.useMemo)(function() {
        return selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys);
    }, [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Save last selected key to enable range selection
    var _useState = (0, $4f162624d58974f1$var$_react.useState)(null), _useState2 = (0, $4f162624d58974f1$var$_slicedToArray2["default"])(_useState, 2), lastSelectedKey = _useState2[0], setLastSelectedKey = _useState2[1];
    // Reset if rowSelection reset
    $4f162624d58974f1$var$React.useEffect(function() {
        if (!rowSelection) setMergedSelectedKeys($4f162624d58974f1$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    var setSelectedKeys = (0, $4f162624d58974f1$var$_react.useCallback)(function(keys, method) {
        var availableKeys;
        var records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map(function(key) {
                return preserveRecordsRef.current.get(key);
            });
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach(function(key) {
                var record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    var triggerSingleSelection = (0, $4f162624d58974f1$var$_react.useCallback)(function(key, selected, keys, event) {
        if (onSelect) {
            var rows = keys.map(function(k) {
                return getRecordByKey(k);
            });
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, 'single');
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    var mergedSelections = (0, $4f162624d58974f1$var$_react.useMemo)(function() {
        if (!selections || hideSelectAll) return null;
        var selectionList = selections === true ? [
            $4f162624d58974f1$var$SELECTION_ALL,
            $4f162624d58974f1$var$SELECTION_INVERT,
            $4f162624d58974f1$var$SELECTION_NONE
        ] : selections;
        return selectionList.map(function(selection) {
            if (selection === $4f162624d58974f1$var$SELECTION_ALL) return {
                key: 'all',
                text: tableLocale.selectionAll,
                onSelect: function onSelect() {
                    setSelectedKeys(data.map(function(record, index) {
                        return getRowKey(record, index);
                    }).filter(function(key) {
                        var checkProps = checkboxPropsMap.get(key);
                        return !(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled) || derivedSelectedKeySet.has(key);
                    }), 'all');
                }
            };
            if (selection === $4f162624d58974f1$var$SELECTION_INVERT) return {
                key: 'invert',
                text: tableLocale.selectInvert,
                onSelect: function onSelect() {
                    var keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach(function(record, index) {
                        var key = getRowKey(record, index);
                        var checkProps = checkboxPropsMap.get(key);
                        if (!(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled)) {
                            if (keySet.has(key)) keySet["delete"](key);
                            else keySet.add(key);
                        }
                    });
                    var keys = Array.from(keySet);
                    if (onSelectInvert) onSelectInvert(keys);
                    setSelectedKeys(keys, 'invert');
                }
            };
            if (selection === $4f162624d58974f1$var$SELECTION_NONE) return {
                key: 'none',
                text: tableLocale.selectNone,
                onSelect: function onSelect() {
                    onSelectNone === null || onSelectNone === void 0 || onSelectNone();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter(function(key) {
                        var checkProps = checkboxPropsMap.get(key);
                        return checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled;
                    }), 'none');
                }
            };
            return selection;
        }).map(function(selection) {
            return (0, $4f162624d58974f1$var$_extends2["default"])((0, $4f162624d58974f1$var$_extends2["default"])({}, selection), {
                onSelect: function onSelect() {
                    var _a2;
                    var _a;
                    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
                    (_a = selection.onSelect) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        selection
                    ].concat(rest));
                    setLastSelectedKey(null);
                }
            });
        });
    }, [
        selections,
        derivedSelectedKeySet,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    var transformColumns = (0, $4f162624d58974f1$var$_react.useCallback)(function(columns) {
        var _a;
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter(function(col) {
            return col !== $4f162624d58974f1$var$SELECTION_COLUMN;
        });
        // >>>>>>>>>>> Support selection
        var cloneColumns = (0, $4f162624d58974f1$var$_toConsumableArray2["default"])(columns);
        var keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        var recordKeys = flattedData.map(getRowKey).filter(function(key) {
            return !checkboxPropsMap.get(key).disabled;
        });
        var checkedCurrentAll = recordKeys.every(function(key) {
            return keySet.has(key);
        });
        var checkedCurrentSome = recordKeys.some(function(key) {
            return keySet.has(key);
        });
        var onSelectAllChange = function onSelectAllChange() {
            var changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach(function(key) {
                keySet["delete"](key);
                changeKeys.push(key);
            });
            else recordKeys.forEach(function(key) {
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            var keys = Array.from(keySet);
            onSelectAll === null || onSelectAll === void 0 || onSelectAll(!checkedCurrentAll, keys.map(function(k) {
                return getRecordByKey(k);
            }), changeKeys.map(function(k) {
                return getRecordByKey(k);
            }));
            setSelectedKeys(keys, 'all');
            setLastSelectedKey(null);
        };
        // ===================== Render =====================
        // Title Cell
        var title;
        if (selectionType !== 'radio') {
            var customizeSelections;
            if (mergedSelections) {
                var menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map(function(selection, index) {
                        var key = selection.key, text = selection.text, onSelectionClick = selection.onSelect;
                        return {
                            key: key || index,
                            onClick: function onClick() {
                                onSelectionClick === null || onSelectionClick === void 0 || onSelectionClick(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $4f162624d58974f1$var$React.createElement("div", {
                    className: "".concat(prefixCls, "-selection-extra")
                }, /*#__PURE__*/ $4f162624d58974f1$var$React.createElement($4f162624d58974f1$var$_dropdown["default"], {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $4f162624d58974f1$var$React.createElement("span", null, /*#__PURE__*/ $4f162624d58974f1$var$React.createElement($4f162624d58974f1$var$_DownOutlined["default"], null))));
            }
            var allDisabledData = flattedData.map(function(record, index) {
                var key = getRowKey(record, index);
                var checkboxProps = checkboxPropsMap.get(key) || {};
                return (0, $4f162624d58974f1$var$_extends2["default"])({
                    checked: keySet.has(key)
                }, checkboxProps);
            }).filter(function(_ref2) {
                var disabled = _ref2.disabled;
                return disabled;
            });
            var allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            var allDisabledAndChecked = allDisabled && allDisabledData.every(function(_ref3) {
                var checked = _ref3.checked;
                return checked;
            });
            var allDisabledSomeChecked = allDisabled && allDisabledData.some(function(_ref4) {
                var checked = _ref4.checked;
                return checked;
            });
            title = !hideSelectAll && /*#__PURE__*/ $4f162624d58974f1$var$React.createElement("div", {
                className: "".concat(prefixCls, "-selection")
            }, /*#__PURE__*/ $4f162624d58974f1$var$React.createElement($4f162624d58974f1$var$_checkbox["default"], {
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: onSelectAllChange,
                disabled: flattedData.length === 0 || allDisabled,
                "aria-label": customizeSelections ? 'Custom selection' : 'Select all',
                skipGroup: true
            }), customizeSelections);
        }
        // Body Cell
        var renderCell;
        if (selectionType === 'radio') renderCell = function renderCell(_, record, index) {
            var key = getRowKey(record, index);
            var checked = keySet.has(key);
            return {
                node: /*#__PURE__*/ $4f162624d58974f1$var$React.createElement($4f162624d58974f1$var$_radio["default"], (0, $4f162624d58974f1$var$_extends2["default"])({}, checkboxPropsMap.get(key), {
                    checked: checked,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    onChange: function onChange(event) {
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                    }
                })),
                checked: checked
            };
        };
        else renderCell = function renderCell(_, record, index) {
            var _a;
            var key = getRowKey(record, index);
            var checked = keySet.has(key);
            var indeterminate = derivedHalfSelectedKeySet.has(key);
            var checkboxProps = checkboxPropsMap.get(key);
            var mergedIndeterminate;
            if (expandType === 'nest') mergedIndeterminate = indeterminate;
            else mergedIndeterminate = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a !== void 0 ? _a : indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $4f162624d58974f1$var$React.createElement($4f162624d58974f1$var$_checkbox["default"], (0, $4f162624d58974f1$var$_extends2["default"])({}, checkboxProps, {
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    onChange: function onChange(_ref5) {
                        var nativeEvent = _ref5.nativeEvent;
                        var shiftKey = nativeEvent.shiftKey;
                        var startIndex = -1;
                        var endIndex = -1;
                        // Get range of this
                        if (shiftKey && checkStrictly) {
                            var pointKeys = new Set([
                                lastSelectedKey,
                                key
                            ]);
                            recordKeys.some(function(recordKey, recordIndex) {
                                if (pointKeys.has(recordKey)) {
                                    if (startIndex === -1) startIndex = recordIndex;
                                    else {
                                        endIndex = recordIndex;
                                        return true;
                                    }
                                }
                                return false;
                            });
                        }
                        if (endIndex !== -1 && startIndex !== endIndex && checkStrictly) {
                            // Batch update selections
                            var rangeKeys = recordKeys.slice(startIndex, endIndex + 1);
                            var changedKeys = [];
                            if (checked) rangeKeys.forEach(function(recordKey) {
                                if (keySet.has(recordKey)) {
                                    changedKeys.push(recordKey);
                                    keySet["delete"](recordKey);
                                }
                            });
                            else rangeKeys.forEach(function(recordKey) {
                                if (!keySet.has(recordKey)) {
                                    changedKeys.push(recordKey);
                                    keySet.add(recordKey);
                                }
                            });
                            var keys = Array.from(keySet);
                            onSelectMultiple === null || onSelectMultiple === void 0 || onSelectMultiple(!checked, keys.map(function(recordKey) {
                                return getRecordByKey(recordKey);
                            }), changedKeys.map(function(recordKey) {
                                return getRecordByKey(recordKey);
                            }));
                            setSelectedKeys(keys, 'multiple');
                        } else {
                            // Single record selected
                            var originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                var checkedKeys = checked ? (0, $1ZsBP.arrDel)(originCheckedKeys, key) : (0, $1ZsBP.arrAdd)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                var result = (0, $hLXwx.conductCheck)([].concat((0, $4f162624d58974f1$var$_toConsumableArray2["default"])(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                var _checkedKeys = result.checkedKeys, halfCheckedKeys = result.halfCheckedKeys;
                                var nextCheckedKeys = _checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    var tempKeySet = new Set(_checkedKeys);
                                    tempKeySet["delete"](key);
                                    nextCheckedKeys = (0, $hLXwx.conductCheck)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) setLastSelectedKey(null);
                        else setLastSelectedKey(key);
                    }
                })),
                checked: checked
            };
        };
        var renderSelectionCell = function renderSelectionCell(_, record, index) {
            var _renderCell = renderCell(_, record, index), node = _renderCell.node, checked = _renderCell.checked;
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($4f162624d58974f1$var$SELECTION_COLUMN)) {
            // Always after expand icon
            if (cloneColumns.findIndex(function(col) {
                var _a;
                return ((_a = col[$aLkKv.INTERNAL_COL_DEFINE]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN';
            }) === 0) {
                var _cloneColumns = cloneColumns, _cloneColumns2 = (0, $4f162624d58974f1$var$_toArray2["default"])(_cloneColumns), expandColumn = _cloneColumns2[0], restColumns = _cloneColumns2.slice(1);
                cloneColumns = [
                    expandColumn,
                    $4f162624d58974f1$var$SELECTION_COLUMN
                ].concat((0, $4f162624d58974f1$var$_toConsumableArray2["default"])(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $4f162624d58974f1$var$SELECTION_COLUMN
            ].concat((0, $4f162624d58974f1$var$_toConsumableArray2["default"])(cloneColumns));
        }
        // Deduplicate selection column
        var selectionColumnIndex = cloneColumns.indexOf($4f162624d58974f1$var$SELECTION_COLUMN);
        cloneColumns = cloneColumns.filter(function(column, index) {
            return column !== $4f162624d58974f1$var$SELECTION_COLUMN || index === selectionColumnIndex;
        });
        // Fixed column logic
        var prevCol = cloneColumns[selectionColumnIndex - 1];
        var nextCol = cloneColumns[selectionColumnIndex + 1];
        var mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== undefined) mergedFixed = nextCol.fixed;
            else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && ((_a = prevCol[$aLkKv.INTERNAL_COL_DEFINE]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN' && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        // Replace with real selection column
        var selectionColumn = (0, $4f162624d58974f1$var$_defineProperty2["default"])({
            fixed: mergedFixed,
            width: selectionColWidth,
            className: "".concat(prefixCls, "-selection-column"),
            title: rowSelection.columnTitle || title,
            render: renderSelectionCell
        }, $aLkKv.INTERNAL_COL_DEFINE, {
            className: "".concat(prefixCls, "-selection-col")
        });
        return cloneColumns.map(function(col) {
            return col === $4f162624d58974f1$var$SELECTION_COLUMN ? selectionColumn : col;
        });
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        lastSelectedKey,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
}

});
parcelRegister("hLXwx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.conductCheck = $cf04ffa67643862c$var$conductCheck;
module.exports.isCheckDisabled = $cf04ffa67643862c$var$isCheckDisabled;

var $cf04ffa67643862c$var$_warning = $1jnue((parcelRequire("dtSXD")));

var $cf04ffa67643862c$var$_keyUtil = $1jnue((parcelRequire("aJWOC")));
function $cf04ffa67643862c$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    var filteredKeys = new Set();
    halfCheckedKeys.forEach(function(key) {
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $cf04ffa67643862c$var$isCheckDisabled(node) {
    var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $cf04ffa67643862c$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    var visitedKeys = new Set();
    for(var _level = maxLevel; _level >= 0; _level -= 1){
        var _entities = levelEntities.get(_level) || new Set();
        _entities.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref2) {
                var key = _ref2.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($cf04ffa67643862c$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $cf04ffa67643862c$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    var visitedKeys = new Set();
    for(var _level2 = maxLevel; _level2 >= 0; _level2 -= 1){
        var _entities2 = levelEntities.get(_level2) || new Set();
        _entities2.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref3) {
                var key = _ref3.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($cf04ffa67643862c$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
/**
 * Conduct with keys.
 * @param keyList current key list
 * @param keyEntities key - dataEntity map
 * @param mode `fill` to fill missing key, `clean` to remove useless key
 */ function $cf04ffa67643862c$var$conductCheck(keyList, checked, keyEntities, getCheckDisabled) {
    var warningMissKeys = [];
    var syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $cf04ffa67643862c$var$isCheckDisabled;
    // We only handle exist keys
    var keys = new Set(keyList.filter(function(key) {
        var hasEntity = !!(0, $cf04ffa67643862c$var$_keyUtil.default)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    var levelEntities = new Map();
    var maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach(function(key) {
        var entity = keyEntities[key];
        var level = entity.level;
        var levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $cf04ffa67643862c$var$_warning.default)(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function(key) {
        return "'".concat(key, "'");
    }).join(', ')));
    var result;
    if (checked === true) result = $cf04ffa67643862c$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $cf04ffa67643862c$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}

});


parcelRegister("jeA0l", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e00b40e75125d4e1$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e00b40e75125d4e1$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e00b40e75125d4e1$var$useFilterSorter;
module.exports.getSortData = $e00b40e75125d4e1$var$getSortData;

var $e00b40e75125d4e1$var$_slicedToArray2 = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("02Ztr")));

var $e00b40e75125d4e1$var$_defineProperty2 = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $e00b40e75125d4e1$var$_extends3 = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $e00b40e75125d4e1$var$_toConsumableArray2 = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $e00b40e75125d4e1$var$_typeof2 = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("41YNz")));

var $e00b40e75125d4e1$var$_CaretDownOutlined = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("dwGxE")));

var $e00b40e75125d4e1$var$_CaretUpOutlined = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("32lzZ")));

var $e00b40e75125d4e1$var$_classnames = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $e00b40e75125d4e1$var$_KeyCode = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("cfElf")));

var $e00b40e75125d4e1$var$React = $e00b40e75125d4e1$var$_interopRequireWildcard((parcelRequire("acw62")));

var $e00b40e75125d4e1$var$_tooltip = $e00b40e75125d4e1$var$_interopRequireDefault((parcelRequire("2Jxu6")));

var $ciy96 = parcelRequire("ciy96");
var $e00b40e75125d4e1$var$ASCEND = 'ascend';
var $e00b40e75125d4e1$var$DESCEND = 'descend';
function $e00b40e75125d4e1$var$getMultiplePriority(column) {
    if ((0, $e00b40e75125d4e1$var$_typeof2["default"])(column.sorter) === 'object' && typeof column.sorter.multiple === 'number') return column.sorter.multiple;
    return false;
}
function $e00b40e75125d4e1$var$getSortFunction(sorter) {
    if (typeof sorter === 'function') return sorter;
    if (sorter && (0, $e00b40e75125d4e1$var$_typeof2["default"])(sorter) === 'object' && sorter.compare) return sorter.compare;
    return false;
}
function $e00b40e75125d4e1$var$nextSortDirection(sortDirections, current) {
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
}
function $e00b40e75125d4e1$var$collectSortStates(columns, init, pos) {
    var sortStates = [];
    function pushState(column, columnPos) {
        sortStates.push({
            column: column,
            key: (0, $ciy96.getColumnKey)(column, columnPos),
            multiplePriority: $e00b40e75125d4e1$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    }
    (columns || []).forEach(function(column, index) {
        var columnPos = (0, $ciy96.getColumnPos)(index, pos);
        if (column.children) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $e00b40e75125d4e1$var$_toConsumableArray2["default"])(sortStates), (0, $e00b40e75125d4e1$var$_toConsumableArray2["default"])($e00b40e75125d4e1$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $ciy96.getColumnKey)(column, columnPos),
                multiplePriority: $e00b40e75125d4e1$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
}
function $e00b40e75125d4e1$var$injectSorter(prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) {
    return (columns || []).map(function(column, index) {
        var columnPos = (0, $ciy96.getColumnPos)(index, pos);
        var newColumn = column;
        if (newColumn.sorter) {
            var sortDirections = newColumn.sortDirections || defaultSortDirections;
            var showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            var columnKey = (0, $ciy96.getColumnKey)(newColumn, columnPos);
            var sorterState = sorterStates.find(function(_ref) {
                var key = _ref.key;
                return key === columnKey;
            });
            var sorterOrder = sorterState ? sorterState.sortOrder : null;
            var nextSortOrder = $e00b40e75125d4e1$var$nextSortDirection(sortDirections, sorterOrder);
            var upNode = sortDirections.includes($e00b40e75125d4e1$var$ASCEND) && /*#__PURE__*/ $e00b40e75125d4e1$var$React.createElement($e00b40e75125d4e1$var$_CaretUpOutlined["default"], {
                className: (0, $e00b40e75125d4e1$var$_classnames["default"])("".concat(prefixCls, "-column-sorter-up"), {
                    active: sorterOrder === $e00b40e75125d4e1$var$ASCEND
                }),
                role: "presentation"
            });
            var downNode = sortDirections.includes($e00b40e75125d4e1$var$DESCEND) && /*#__PURE__*/ $e00b40e75125d4e1$var$React.createElement($e00b40e75125d4e1$var$_CaretDownOutlined["default"], {
                className: (0, $e00b40e75125d4e1$var$_classnames["default"])("".concat(prefixCls, "-column-sorter-down"), {
                    active: sorterOrder === $e00b40e75125d4e1$var$DESCEND
                }),
                role: "presentation"
            });
            var _ref2 = tableLocale || {}, cancelSort = _ref2.cancelSort, triggerAsc = _ref2.triggerAsc, triggerDesc = _ref2.triggerDesc;
            var sortTip = cancelSort;
            if (nextSortOrder === $e00b40e75125d4e1$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $e00b40e75125d4e1$var$ASCEND) sortTip = triggerAsc;
            var tooltipProps = (0, $e00b40e75125d4e1$var$_typeof2["default"])(showSorterTooltip) === 'object' ? showSorterTooltip : {
                title: sortTip
            };
            newColumn = (0, $e00b40e75125d4e1$var$_extends3["default"])((0, $e00b40e75125d4e1$var$_extends3["default"])({}, newColumn), {
                className: (0, $e00b40e75125d4e1$var$_classnames["default"])(newColumn.className, (0, $e00b40e75125d4e1$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-column-sort"), sorterOrder)),
                title: function title(renderProps) {
                    var renderSortTitle = /*#__PURE__*/ $e00b40e75125d4e1$var$React.createElement("div", {
                        className: "".concat(prefixCls, "-column-sorters")
                    }, /*#__PURE__*/ $e00b40e75125d4e1$var$React.createElement("span", {
                        className: "".concat(prefixCls, "-column-title")
                    }, (0, $ciy96.renderColumnTitle)(column.title, renderProps)), /*#__PURE__*/ $e00b40e75125d4e1$var$React.createElement("span", {
                        className: (0, $e00b40e75125d4e1$var$_classnames["default"])("".concat(prefixCls, "-column-sorter"), (0, $e00b40e75125d4e1$var$_defineProperty2["default"])({}, "".concat(prefixCls, "-column-sorter-full"), !!(upNode && downNode)))
                    }, /*#__PURE__*/ $e00b40e75125d4e1$var$React.createElement("span", {
                        className: "".concat(prefixCls, "-column-sorter-inner")
                    }, upNode, downNode)));
                    return showSorterTooltip ? /*#__PURE__*/ $e00b40e75125d4e1$var$React.createElement($e00b40e75125d4e1$var$_tooltip["default"], (0, $e00b40e75125d4e1$var$_extends3["default"])({}, tooltipProps), renderSortTitle) : renderSortTitle;
                },
                onHeaderCell: function onHeaderCell(col) {
                    var cell = column.onHeaderCell && column.onHeaderCell(col) || {};
                    var originOnClick = cell.onClick;
                    var originOKeyDown = cell.onKeyDown;
                    cell.onClick = function(event) {
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $e00b40e75125d4e1$var$getMultiplePriority(column)
                        });
                        originOnClick === null || originOnClick === void 0 || originOnClick(event);
                    };
                    cell.onKeyDown = function(event) {
                        if (event.keyCode === $e00b40e75125d4e1$var$_KeyCode["default"].ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $e00b40e75125d4e1$var$getMultiplePriority(column)
                            });
                            originOKeyDown === null || originOKeyDown === void 0 || originOKeyDown(event);
                        }
                    };
                    var renderTitle = (0, $ciy96.safeColumnTitle)(column.title, {});
                    var displayTitle = renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sorterOrder) cell['aria-sort'] = sorterOrder === 'ascend' ? 'ascending' : 'descending';
                    else cell['aria-label'] = displayTitle || '';
                    cell.className = (0, $e00b40e75125d4e1$var$_classnames["default"])(cell.className, "".concat(prefixCls, "-column-has-sorters"));
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle !== null && renderTitle !== void 0 ? renderTitle : '').toString();
                    return cell;
                }
            });
        }
        if ('children' in newColumn) newColumn = (0, $e00b40e75125d4e1$var$_extends3["default"])((0, $e00b40e75125d4e1$var$_extends3["default"])({}, newColumn), {
            children: $e00b40e75125d4e1$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
        });
        return newColumn;
    });
}
function $e00b40e75125d4e1$var$stateToInfo(sorterStates) {
    var column = sorterStates.column, sortOrder = sorterStates.sortOrder;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
}
function $e00b40e75125d4e1$var$generateSorterInfo(sorterStates) {
    var list = sorterStates.filter(function(_ref3) {
        var sortOrder = _ref3.sortOrder;
        return sortOrder;
    }).map($e00b40e75125d4e1$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (list.length === 0 && sorterStates.length) return (0, $e00b40e75125d4e1$var$_extends3["default"])((0, $e00b40e75125d4e1$var$_extends3["default"])({}, $e00b40e75125d4e1$var$stateToInfo(sorterStates[sorterStates.length - 1])), {
        column: undefined
    });
    if (list.length <= 1) return list[0] || {};
    return list;
}
function $e00b40e75125d4e1$var$getSortData(data, sortStates, childrenColumnName) {
    var innerSorterStates = sortStates.slice().sort(function(a, b) {
        return b.multiplePriority - a.multiplePriority;
    });
    var cloneData = data.slice();
    var runningSorters = innerSorterStates.filter(function(_ref4) {
        var sorter = _ref4.column.sorter, sortOrder = _ref4.sortOrder;
        return $e00b40e75125d4e1$var$getSortFunction(sorter) && sortOrder;
    });
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort(function(record1, record2) {
        for(var i = 0; i < runningSorters.length; i += 1){
            var sorterState = runningSorters[i];
            var sorter = sorterState.column.sorter, sortOrder = sorterState.sortOrder;
            var compareFn = $e00b40e75125d4e1$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                var compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $e00b40e75125d4e1$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map(function(record) {
        var subRecords = record[childrenColumnName];
        if (subRecords) return (0, $e00b40e75125d4e1$var$_extends3["default"])((0, $e00b40e75125d4e1$var$_extends3["default"])({}, record), (0, $e00b40e75125d4e1$var$_defineProperty2["default"])({}, childrenColumnName, $e00b40e75125d4e1$var$getSortData(subRecords, sortStates, childrenColumnName)));
        return record;
    });
}
function $e00b40e75125d4e1$var$useFilterSorter(_ref5) {
    var prefixCls = _ref5.prefixCls, mergedColumns = _ref5.mergedColumns, onSorterChange = _ref5.onSorterChange, sortDirections = _ref5.sortDirections, tableLocale = _ref5.tableLocale, showSorterTooltip = _ref5.showSorterTooltip;
    var _React$useState = $e00b40e75125d4e1$var$React.useState($e00b40e75125d4e1$var$collectSortStates(mergedColumns, true)), _React$useState2 = (0, $e00b40e75125d4e1$var$_slicedToArray2["default"])(_React$useState, 2), sortStates = _React$useState2[0], setSortStates = _React$useState2[1];
    var mergedSorterStates = $e00b40e75125d4e1$var$React.useMemo(function() {
        var validate = true;
        var collectedStates = $e00b40e75125d4e1$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) return sortStates;
        var validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push((0, $e00b40e75125d4e1$var$_extends3["default"])((0, $e00b40e75125d4e1$var$_extends3["default"])({}, state), {
                sortOrder: null
            }));
        }
        var multipleMode = null;
        collectedStates.forEach(function(state) {
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    var columnTitleSorterProps = $e00b40e75125d4e1$var$React.useMemo(function() {
        var sortColumns = mergedSorterStates.map(function(_ref6) {
            var column = _ref6.column, sortOrder = _ref6.sortOrder;
            return {
                column: column,
                order: sortOrder
            };
        });
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: sortColumns[0] && sortColumns[0].column,
            sortOrder: sortColumns[0] && sortColumns[0].order
        };
    }, [
        mergedSorterStates
    ]);
    function triggerSorter(sortState) {
        var newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $e00b40e75125d4e1$var$_toConsumableArray2["default"])(mergedSorterStates.filter(function(_ref7) {
            var key = _ref7.key;
            return key !== sortState.key;
        })), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($e00b40e75125d4e1$var$generateSorterInfo(newSorterStates), newSorterStates);
    }
    var transformColumns = function transformColumns(innerColumns) {
        return $e00b40e75125d4e1$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
    };
    var getSorters = function getSorters() {
        return $e00b40e75125d4e1$var$generateSorterInfo(mergedSorterStates);
    };
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
}

});
parcelRegister("dwGxE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d8f436f77d89035$var$_CaretDownOutlined = $9d8f436f77d89035$var$_interopRequireDefault((parcelRequire("lydhV")));
function $9d8f436f77d89035$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $9d8f436f77d89035$var$_default = $9d8f436f77d89035$var$_CaretDownOutlined;
module.exports.default = $9d8f436f77d89035$var$_default;
module.exports = $9d8f436f77d89035$var$_default;

});
parcelRegister("lydhV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb0714b323502da6$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $fb0714b323502da6$var$React = $fb0714b323502da6$var$_interopRequireWildcard((parcelRequire("acw62")));

var $fb0714b323502da6$var$_CaretDownOutlined = $1jnue((parcelRequire("lsI0Y")));

var $fb0714b323502da6$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $fb0714b323502da6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fb0714b323502da6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fb0714b323502da6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $fb0714b323502da6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $fb0714b323502da6$var$CaretDownOutlined = function CaretDownOutlined(props, ref) {
    return /*#__PURE__*/ $fb0714b323502da6$var$React.createElement($fb0714b323502da6$var$_AntdIcon.default, (0, $fb0714b323502da6$var$_objectSpread2.default)((0, $fb0714b323502da6$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $fb0714b323502da6$var$_CaretDownOutlined.default
    }));
};
var $fb0714b323502da6$var$RefIcon = /*#__PURE__*/ $fb0714b323502da6$var$React.forwardRef($fb0714b323502da6$var$CaretDownOutlined);
var $fb0714b323502da6$var$_default = module.exports.default = $fb0714b323502da6$var$RefIcon;

});
parcelRegister("lsI0Y", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f9fe5aeae8bf7951$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
module.exports.default = $f9fe5aeae8bf7951$var$CaretDownOutlined;

});



parcelRegister("32lzZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23624c3f9f448558$var$_CaretUpOutlined = $23624c3f9f448558$var$_interopRequireDefault((parcelRequire("a7xt9")));
function $23624c3f9f448558$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $23624c3f9f448558$var$_default = $23624c3f9f448558$var$_CaretUpOutlined;
module.exports.default = $23624c3f9f448558$var$_default;
module.exports = $23624c3f9f448558$var$_default;

});
parcelRegister("a7xt9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $41YNz = parcelRequire("41YNz");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75e4851a5acfd5b5$var$_objectSpread2 = $1jnue((parcelRequire("cbdLd")));

var $75e4851a5acfd5b5$var$React = $75e4851a5acfd5b5$var$_interopRequireWildcard((parcelRequire("acw62")));

var $75e4851a5acfd5b5$var$_CaretUpOutlined = $1jnue((parcelRequire("6LLOk")));

var $75e4851a5acfd5b5$var$_AntdIcon = $1jnue((parcelRequire("8RiIQ")));
function $75e4851a5acfd5b5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($75e4851a5acfd5b5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $75e4851a5acfd5b5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $41YNz(e) && "function" != typeof e) return {
        default: e
    };
    var t = $75e4851a5acfd5b5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var $75e4851a5acfd5b5$var$CaretUpOutlined = function CaretUpOutlined(props, ref) {
    return /*#__PURE__*/ $75e4851a5acfd5b5$var$React.createElement($75e4851a5acfd5b5$var$_AntdIcon.default, (0, $75e4851a5acfd5b5$var$_objectSpread2.default)((0, $75e4851a5acfd5b5$var$_objectSpread2.default)({}, props), {}, {
        ref: ref,
        icon: $75e4851a5acfd5b5$var$_CaretUpOutlined.default
    }));
};
var $75e4851a5acfd5b5$var$RefIcon = /*#__PURE__*/ $75e4851a5acfd5b5$var$React.forwardRef($75e4851a5acfd5b5$var$CaretUpOutlined);
var $75e4851a5acfd5b5$var$_default = module.exports.default = $75e4851a5acfd5b5$var$RefIcon;

});
parcelRegister("6LLOk", function(module, exports) {
"use strict";
// This icon file is generated automatically.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4edc380ecc0e9f5b$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
module.exports.default = $4edc380ecc0e9f5b$var$CaretUpOutlined;

});




parcelRegister("4XvYz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $39c579d8ba373ba3$var$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $39c579d8ba373ba3$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $39c579d8ba373ba3$var$useTitleColumns;

var $39c579d8ba373ba3$var$_extends2 = $39c579d8ba373ba3$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $39c579d8ba373ba3$var$React = $39c579d8ba373ba3$var$_interopRequireWildcard((parcelRequire("acw62")));

var $ciy96 = parcelRequire("ciy96");
function $39c579d8ba373ba3$var$fillTitle(columns, columnTitleProps) {
    return columns.map(function(column) {
        var cloneColumn = (0, $39c579d8ba373ba3$var$_extends2["default"])({}, column);
        cloneColumn.title = (0, $ciy96.renderColumnTitle)(column.title, columnTitleProps);
        if ('children' in cloneColumn) cloneColumn.children = $39c579d8ba373ba3$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
}
function $39c579d8ba373ba3$var$useTitleColumns(columnTitleProps) {
    var filledColumns = $39c579d8ba373ba3$var$React.useCallback(function(columns) {
        return $39c579d8ba373ba3$var$fillTitle(columns, columnTitleProps);
    }, [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
}

});


parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("9slIK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e5b639a4b64488d4$export$2e2bcd8739ae039);
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */ function $e5b639a4b64488d4$var$Point(x, y, time) {
    this.x = x;
    this.y = y;
    this.time = time || new Date().getTime();
}
$e5b639a4b64488d4$var$Point.prototype.velocityFrom = function(start) {
    return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};
$e5b639a4b64488d4$var$Point.prototype.distanceTo = function(start) {
    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};
$e5b639a4b64488d4$var$Point.prototype.equals = function(other) {
    return this.x === other.x && this.y === other.y && this.time === other.time;
};
function $e5b639a4b64488d4$var$Bezier(startPoint, control1, control2, endPoint) {
    this.startPoint = startPoint;
    this.control1 = control1;
    this.control2 = control2;
    this.endPoint = endPoint;
}
// Returns approximated length.
$e5b639a4b64488d4$var$Bezier.prototype.length = function() {
    var steps = 10;
    var length = 0;
    var px = void 0;
    var py = void 0;
    for(var i = 0; i <= steps; i += 1){
        var t = i / steps;
        var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
        var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
        if (i > 0) {
            var xdiff = cx - px;
            var ydiff = cy - py;
            length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
        }
        px = cx;
        py = cy;
    }
    return length;
};
/* eslint-disable no-multi-spaces, space-in-parens */ $e5b639a4b64488d4$var$Bezier.prototype._point = function(t, start, c1, c2, end) {
    return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};
/* eslint-disable */ // http://stackoverflow.com/a/27078401/815507
function $e5b639a4b64488d4$var$throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function() {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
}
function $e5b639a4b64488d4$var$SignaturePad(canvas, options) {
    var self = this;
    var opts = options || {};
    this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
    this.minWidth = opts.minWidth || 0.5;
    this.maxWidth = opts.maxWidth || 2.5;
    this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
    this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;
    if (this.throttle) this._strokeMoveUpdate = $e5b639a4b64488d4$var$throttle($e5b639a4b64488d4$var$SignaturePad.prototype._strokeUpdate, this.throttle);
    else this._strokeMoveUpdate = $e5b639a4b64488d4$var$SignaturePad.prototype._strokeUpdate;
    this.dotSize = opts.dotSize || function() {
        return (this.minWidth + this.maxWidth) / 2;
    };
    this.penColor = opts.penColor || 'black';
    this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
    this.onBegin = opts.onBegin;
    this.onEnd = opts.onEnd;
    this._canvas = canvas;
    this._ctx = canvas.getContext('2d');
    this.clear();
    // We need add these inline so they are available to unbind while still having
    // access to 'self' we could use _.bind but it's not worth adding a dependency.
    this._handleMouseDown = function(event) {
        if (event.which === 1) {
            self._mouseButtonDown = true;
            self._strokeBegin(event);
        }
    };
    this._handleMouseMove = function(event) {
        if (self._mouseButtonDown) self._strokeMoveUpdate(event);
    };
    this._handleMouseUp = function(event) {
        if (event.which === 1 && self._mouseButtonDown) {
            self._mouseButtonDown = false;
            self._strokeEnd(event);
        }
    };
    this._handleTouchStart = function(event) {
        if (event.targetTouches.length === 1) {
            var touch = event.changedTouches[0];
            self._strokeBegin(touch);
        }
    };
    this._handleTouchMove = function(event) {
        // Prevent scrolling.
        event.preventDefault();
        var touch = event.targetTouches[0];
        self._strokeMoveUpdate(touch);
    };
    this._handleTouchEnd = function(event) {
        var wasCanvasTouched = event.target === self._canvas;
        if (wasCanvasTouched) {
            event.preventDefault();
            self._strokeEnd(event);
        }
    };
    // Enable mouse and touch event handlers
    this.on();
}
// Public methods
$e5b639a4b64488d4$var$SignaturePad.prototype.clear = function() {
    var ctx = this._ctx;
    var canvas = this._canvas;
    ctx.fillStyle = this.backgroundColor;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    this._data = [];
    this._reset();
    this._isEmpty = true;
};
$e5b639a4b64488d4$var$SignaturePad.prototype.fromDataURL = function(dataUrl) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var image = new Image();
    var ratio = options.ratio || window.devicePixelRatio || 1;
    var width = options.width || this._canvas.width / ratio;
    var height = options.height || this._canvas.height / ratio;
    this._reset();
    image.src = dataUrl;
    image.onload = function() {
        _this._ctx.drawImage(image, 0, 0, width, height);
    };
    this._isEmpty = false;
};
$e5b639a4b64488d4$var$SignaturePad.prototype.toDataURL = function(type) {
    var _canvas;
    switch(type){
        case 'image/svg+xml':
            return this._toSVG();
        default:
            for(var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)options[_key - 1] = arguments[_key];
            return (_canvas = this._canvas).toDataURL.apply(_canvas, [
                type
            ].concat(options));
    }
};
$e5b639a4b64488d4$var$SignaturePad.prototype.on = function() {
    this._handleMouseEvents();
    this._handleTouchEvents();
};
$e5b639a4b64488d4$var$SignaturePad.prototype.off = function() {
    this._canvas.removeEventListener('mousedown', this._handleMouseDown);
    this._canvas.removeEventListener('mousemove', this._handleMouseMove);
    document.removeEventListener('mouseup', this._handleMouseUp);
    this._canvas.removeEventListener('touchstart', this._handleTouchStart);
    this._canvas.removeEventListener('touchmove', this._handleTouchMove);
    this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};
$e5b639a4b64488d4$var$SignaturePad.prototype.isEmpty = function() {
    return this._isEmpty;
};
// Private methods
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeBegin = function(event) {
    this._data.push([]);
    this._reset();
    this._strokeUpdate(event);
    if (typeof this.onBegin === 'function') this.onBegin(event);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeUpdate = function(event) {
    var x = event.clientX;
    var y = event.clientY;
    var point = this._createPoint(x, y);
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
    var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;
    // Skip this point if it's too close to the previous one
    if (!(lastPoint && isLastPointTooClose)) {
        var _addPoint = this._addPoint(point), curve = _addPoint.curve, widths = _addPoint.widths;
        if (curve && widths) this._drawCurve(curve, widths.start, widths.end);
        this._data[this._data.length - 1].push({
            x: point.x,
            y: point.y,
            time: point.time,
            color: this.penColor
        });
    }
};
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeEnd = function(event) {
    var canDrawCurve = this.points.length > 2;
    var point = this.points[0]; // Point instance
    if (!canDrawCurve && point) this._drawDot(point);
    if (point) {
        var lastPointGroup = this._data[this._data.length - 1];
        var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object
        // When drawing a dot, there's only one point in a group, so without this check
        // such group would end up with exactly the same 2 points.
        if (!point.equals(lastPoint)) lastPointGroup.push({
            x: point.x,
            y: point.y,
            time: point.time,
            color: this.penColor
        });
    }
    if (typeof this.onEnd === 'function') this.onEnd(event);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._handleMouseEvents = function() {
    this._mouseButtonDown = false;
    this._canvas.addEventListener('mousedown', this._handleMouseDown);
    this._canvas.addEventListener('mousemove', this._handleMouseMove);
    document.addEventListener('mouseup', this._handleMouseUp);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._handleTouchEvents = function() {
    // Pass touch events to canvas element on mobile IE11 and Edge.
    this._canvas.style.msTouchAction = 'none';
    this._canvas.style.touchAction = 'none';
    this._canvas.addEventListener('touchstart', this._handleTouchStart);
    this._canvas.addEventListener('touchmove', this._handleTouchMove);
    this._canvas.addEventListener('touchend', this._handleTouchEnd);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._reset = function() {
    this.points = [];
    this._lastVelocity = 0;
    this._lastWidth = (this.minWidth + this.maxWidth) / 2;
    this._ctx.fillStyle = this.penColor;
};
$e5b639a4b64488d4$var$SignaturePad.prototype._createPoint = function(x, y, time) {
    var rect = this._canvas.getBoundingClientRect();
    return new $e5b639a4b64488d4$var$Point(x - rect.left, y - rect.top, time || new Date().getTime());
};
$e5b639a4b64488d4$var$SignaturePad.prototype._addPoint = function(point) {
    var points = this.points;
    var tmp = void 0;
    points.push(point);
    if (points.length > 2) {
        // To reduce the initial lag make it work with 3 points
        // by copying the first point to the beginning.
        if (points.length === 3) points.unshift(points[0]);
        tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
        var c2 = tmp.c2;
        tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
        var c3 = tmp.c1;
        var curve = new $e5b639a4b64488d4$var$Bezier(points[1], c2, c3, points[2]);
        var widths = this._calculateCurveWidths(curve);
        // Remove the first element from the list,
        // so that we always have no more than 4 points in points array.
        points.shift();
        return {
            curve: curve,
            widths: widths
        };
    }
    return {};
};
$e5b639a4b64488d4$var$SignaturePad.prototype._calculateCurveControlPoints = function(s1, s2, s3) {
    var dx1 = s1.x - s2.x;
    var dy1 = s1.y - s2.y;
    var dx2 = s2.x - s3.x;
    var dy2 = s2.y - s3.y;
    var m1 = {
        x: (s1.x + s2.x) / 2.0,
        y: (s1.y + s2.y) / 2.0
    };
    var m2 = {
        x: (s2.x + s3.x) / 2.0,
        y: (s2.y + s3.y) / 2.0
    };
    var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    var dxm = m1.x - m2.x;
    var dym = m1.y - m2.y;
    var k = l2 / (l1 + l2);
    var cm = {
        x: m2.x + dxm * k,
        y: m2.y + dym * k
    };
    var tx = s2.x - cm.x;
    var ty = s2.y - cm.y;
    return {
        c1: new $e5b639a4b64488d4$var$Point(m1.x + tx, m1.y + ty),
        c2: new $e5b639a4b64488d4$var$Point(m2.x + tx, m2.y + ty)
    };
};
$e5b639a4b64488d4$var$SignaturePad.prototype._calculateCurveWidths = function(curve) {
    var startPoint = curve.startPoint;
    var endPoint = curve.endPoint;
    var widths = {
        start: null,
        end: null
    };
    var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;
    var newWidth = this._strokeWidth(velocity);
    widths.start = this._lastWidth;
    widths.end = newWidth;
    this._lastVelocity = velocity;
    this._lastWidth = newWidth;
    return widths;
};
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeWidth = function(velocity) {
    return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._drawPoint = function(x, y, size) {
    var ctx = this._ctx;
    ctx.moveTo(x, y);
    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
    this._isEmpty = false;
};
$e5b639a4b64488d4$var$SignaturePad.prototype._drawCurve = function(curve, startWidth, endWidth) {
    var ctx = this._ctx;
    var widthDelta = endWidth - startWidth;
    var drawSteps = Math.floor(curve.length());
    ctx.beginPath();
    for(var i = 0; i < drawSteps; i += 1){
        // Calculate the Bezier (x, y) coordinate for this step.
        var t = i / drawSteps;
        var tt = t * t;
        var ttt = tt * t;
        var u = 1 - t;
        var uu = u * u;
        var uuu = uu * u;
        var x = uuu * curve.startPoint.x;
        x += 3 * uu * t * curve.control1.x;
        x += 3 * u * tt * curve.control2.x;
        x += ttt * curve.endPoint.x;
        var y = uuu * curve.startPoint.y;
        y += 3 * uu * t * curve.control1.y;
        y += 3 * u * tt * curve.control2.y;
        y += ttt * curve.endPoint.y;
        var width = startWidth + ttt * widthDelta;
        this._drawPoint(x, y, width);
    }
    ctx.closePath();
    ctx.fill();
};
$e5b639a4b64488d4$var$SignaturePad.prototype._drawDot = function(point) {
    var ctx = this._ctx;
    var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
    ctx.beginPath();
    this._drawPoint(point.x, point.y, width);
    ctx.closePath();
    ctx.fill();
};
$e5b639a4b64488d4$var$SignaturePad.prototype._fromData = function(pointGroups, drawCurve, drawDot) {
    for(var i = 0; i < pointGroups.length; i += 1){
        var group = pointGroups[i];
        if (group.length > 1) for(var j = 0; j < group.length; j += 1){
            var rawPoint = group[j];
            var point = new $e5b639a4b64488d4$var$Point(rawPoint.x, rawPoint.y, rawPoint.time);
            var color = rawPoint.color;
            if (j === 0) {
                // First point in a group. Nothing to draw yet.
                // All points in the group have the same color, so it's enough to set
                // penColor just at the beginning.
                this.penColor = color;
                this._reset();
                this._addPoint(point);
            } else if (j !== group.length - 1) {
                // Middle point in a group.
                var _addPoint2 = this._addPoint(point), curve = _addPoint2.curve, widths = _addPoint2.widths;
                if (curve && widths) drawCurve(curve, widths, color);
            }
        }
        else {
            this._reset();
            var _rawPoint = group[0];
            drawDot(_rawPoint);
        }
    }
};
$e5b639a4b64488d4$var$SignaturePad.prototype._toSVG = function() {
    var _this2 = this;
    var pointGroups = this._data;
    var canvas = this._canvas;
    var ratio = Math.max(window.devicePixelRatio || 1, 1);
    var minX = 0;
    var minY = 0;
    var maxX = canvas.width / ratio;
    var maxY = canvas.height / ratio;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttributeNS(null, 'width', canvas.width);
    svg.setAttributeNS(null, 'height', canvas.height);
    this._fromData(pointGroups, function(curve, widths, color) {
        var path = document.createElement('path');
        // Need to check curve for NaN values, these pop up when drawing
        // lines on the canvas that are not continuous. E.g. Sharp corners
        // or stopping mid-stroke and than continuing without lifting mouse.
        if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
            var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));
            path.setAttribute('d', attr);
            path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
            path.setAttribute('stroke', color);
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke-linecap', 'round');
            svg.appendChild(path);
        }
    }, function(rawPoint) {
        var circle = document.createElement('circle');
        var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
        circle.setAttribute('r', dotSize);
        circle.setAttribute('cx', rawPoint.x);
        circle.setAttribute('cy', rawPoint.y);
        circle.setAttribute('fill', rawPoint.color);
        svg.appendChild(circle);
    });
    var prefix = 'data:image/svg+xml;base64,';
    var header = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
    var body = svg.innerHTML;
    // IE hack for missing innerHTML property on SVGElement
    if (body === undefined) {
        var dummy = document.createElement('dummy');
        var nodes = svg.childNodes;
        dummy.innerHTML = '';
        for(var i = 0; i < nodes.length; i += 1)dummy.appendChild(nodes[i].cloneNode(true));
        body = dummy.innerHTML;
    }
    var footer = '</svg>';
    var data = header + body + footer;
    return prefix + btoa(data);
};
$e5b639a4b64488d4$var$SignaturePad.prototype.fromData = function(pointGroups) {
    var _this3 = this;
    this.clear();
    this._fromData(pointGroups, function(curve, widths) {
        return _this3._drawCurve(curve, widths.start, widths.end);
    }, function(rawPoint) {
        return _this3._drawDot(rawPoint);
    });
    this._data = pointGroups;
};
$e5b639a4b64488d4$var$SignaturePad.prototype.toData = function() {
    return this._data;
};
var $e5b639a4b64488d4$export$2e2bcd8739ae039 = $e5b639a4b64488d4$var$SignaturePad;

});

parcelRegister("7G0GL", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        function t(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                exports: {},
                id: n,
                loaded: !1
            };
            return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
        }
        var r = {};
        return t.m = e, t.c = r, t.p = "", t(0);
    }([
        function(e, t) {
            "use strict";
            function r(e) {
                var t = e.getContext("2d"), r = e.width, n = e.height, o = t.getImageData(0, 0, r, n).data, f = a(!0, r, n, o), i = a(!1, r, n, o), c = u(!0, r, n, o), d = u(!1, r, n, o), p = d - c + 1, l = i - f + 1, s = t.getImageData(c, f, p, l);
                return e.width = p, e.height = l, t.clearRect(0, 0, p, l), t.putImageData(s, 0, 0), e;
            }
            function n(e, t, r, n) {
                return {
                    red: n[4 * (r * t + e)],
                    green: n[4 * (r * t + e) + 1],
                    blue: n[4 * (r * t + e) + 2],
                    alpha: n[4 * (r * t + e) + 3]
                };
            }
            function o(e, t, r, o) {
                return n(e, t, r, o).alpha;
            }
            function a(e, t, r, n) {
                for(var a = e ? 1 : -1, u = e ? 0 : r - 1, f = u; e ? f < r : f > -1; f += a)for(var i = 0; i < t; i++)if (o(i, f, t, n)) return f;
                return null;
            }
            function u(e, t, r, n) {
                for(var a = e ? 1 : -1, u = e ? 0 : t - 1, f = u; e ? f < t : f > -1; f += a)for(var i = 0; i < r; i++)if (o(f, i, t, n)) return f;
                return null;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = r;
        }
    ]);
});

});

parcelRegister("22SFA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $17d62cf8cedcb57c$var$_default = {
    // Options.jsx
    items_per_page: "na stron\u0119",
    jump_to: "Id\u017A do",
    jump_to_confirm: "potwierd\u017A",
    page: '',
    // Pagination.jsx
    prev_page: 'Poprzednia strona',
    next_page: "Nast\u0119pna strona",
    prev_5: 'Poprzednie 5 stron',
    next_5: "Nast\u0119pne 5 stron",
    prev_3: 'Poprzednie 3 strony',
    next_3: "Nast\u0119pne 3 strony",
    page_size: 'rozmiar strony'
};
module.exports.default = $17d62cf8cedcb57c$var$_default;

});

parcelRegister("9nP8p", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6d4ded4d91d9b292$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6d4ded4d91d9b292$var$_pl_PL = $6d4ded4d91d9b292$var$_interopRequireDefault((parcelRequire("6RzbK")));
var $6d4ded4d91d9b292$var$_default = module.exports["default"] = $6d4ded4d91d9b292$var$_pl_PL["default"];

});
parcelRegister("6RzbK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ff2fd05662f98aa$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4ff2fd05662f98aa$var$_extends2 = $4ff2fd05662f98aa$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $4ff2fd05662f98aa$var$_pl_PL = $4ff2fd05662f98aa$var$_interopRequireDefault((parcelRequire("aMltv")));

var $4ff2fd05662f98aa$var$_pl_PL2 = $4ff2fd05662f98aa$var$_interopRequireDefault((parcelRequire("axa8W")));
// Merge into a locale object
var $4ff2fd05662f98aa$var$locale = {
    lang: (0, $4ff2fd05662f98aa$var$_extends2["default"])({
        placeholder: "Wybierz dat\u0119",
        rangePlaceholder: [
            "Data pocz\u0105tkowa",
            "Data ko\u0144cowa"
        ]
    }, $4ff2fd05662f98aa$var$_pl_PL["default"]),
    timePickerLocale: (0, $4ff2fd05662f98aa$var$_extends2["default"])({}, $4ff2fd05662f98aa$var$_pl_PL2["default"])
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
var $4ff2fd05662f98aa$var$_default = module.exports["default"] = $4ff2fd05662f98aa$var$locale;

});
parcelRegister("aMltv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7d8f0b88ff1a522f$var$locale = {
    locale: 'pl_PL',
    today: 'Dzisiaj',
    now: 'Teraz',
    backToToday: 'Ustaw dzisiaj',
    ok: 'OK',
    clear: "Wyczy\u015B\u0107",
    month: "Miesi\u0105c",
    year: 'Rok',
    timeSelect: 'Ustaw czas',
    dateSelect: "Ustaw dat\u0119",
    monthSelect: "Wybierz miesi\u0105c",
    yearSelect: 'Wybierz rok',
    decadeSelect: "Wybierz dekad\u0119",
    yearFormat: 'YYYY',
    dateFormat: 'D/M/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'D/M/YYYY HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: "Poprzedni miesi\u0105c (PageUp)",
    nextMonth: "Nast\u0119pny miesi\u0105c (PageDown)",
    previousYear: 'Ostatni rok (Ctrl + left)',
    nextYear: "Nast\u0119pny rok (Ctrl + right)",
    previousDecade: 'Ostatnia dekada',
    nextDecade: "Nast\u0119pna dekada",
    previousCentury: 'Ostatni wiek',
    nextCentury: "Nast\u0119pny wiek"
};
var $7d8f0b88ff1a522f$var$_default = $7d8f0b88ff1a522f$var$locale;
module.exports.default = $7d8f0b88ff1a522f$var$_default;

});

parcelRegister("axa8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $7ab4daabb851ec98$var$locale = {
    placeholder: "Wybierz godzin\u0119"
};
var $7ab4daabb851ec98$var$_default = module.exports["default"] = $7ab4daabb851ec98$var$locale;

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $18144a665bc8acf7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "8.55.0";


/** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $1a40e26460b4422e$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $1a40e26460b4422e$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = 'Sentry Logger ';
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $18144a665bc8acf7$export$16a28057038b10ef) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $1a40e26460b4422e$export$7e223ec222791509)('logger', $c9674f9e04798056$var$makeLogger);


const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



const $cccaafc2216668b2$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cccaafc2216668b2$export$c660c1f3ab49225c(selector) {
    if ($cccaafc2216668b2$var$WINDOW.document && $cccaafc2216668b2$var$WINDOW.document.querySelector) return $cccaafc2216668b2$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) return false;
    if ((0, $9a62450b4f3c2c3b$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f4dd084fe83374eb$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d)(target) ? (0, $cccaafc2216668b2$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $cee8faa76567523a$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $cee8faa76567523a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $210880305d43071a$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $210880305d43071a$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $210880305d43071a$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = 'history' in $210880305d43071a$var$WINDOW && !!$210880305d43071a$var$WINDOW.history.pushState && !!$210880305d43071a$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);


let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $3d87653da885c31c$var$instrumentHistory);
}
function $3d87653da885c31c$var$instrumentHistory() {
    if (!(0, $210880305d43071a$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate;
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}


const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $4f6ba265374890ec$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $4f6ba265374890ec$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $4f6ba265374890ec$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $4f6ba265374890ec$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $4f6ba265374890ec$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $4f6ba265374890ec$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return 0, $1a40e26460b4422e$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $b0bfa51115099518$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
}









/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496() {
    const gbl = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $cee8faa76567523a$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    if ($4f55103f4332a5b0$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4f55103f4332a5b0$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $4f55103f4332a5b0$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $dc99b4184ec29e47$export$37f0f2f9cf343e5e() {
    return {
        traceId: $dc99b4184ec29e47$export$dc6d7ea554bcce10(),
        spanId: $dc99b4184ec29e47$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $dc99b4184ec29e47$export$dc6d7ea554bcce10() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $dc99b4184ec29e47$export$295213bc4d0c54ad() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16);
}



/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $33c387bb26fe522d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
            spanId: (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)()
        };
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $33c387bb26fe522d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(newScope, (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            if (this._client) this._client.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = {
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)(),
            ...context
        };
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Holds additional event information.
 */ const $33c387bb26fe522d$export$775b6bb06e53a214 = $33c387bb26fe522d$var$ScopeClass;



/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $4354bb0fac58a6e0$export$6f1b9191db9c4d5)(), (0, $4354bb0fac58a6e0$export$de9862929b76bf57)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ab23dab597a507b7$export$329d4d4d54e42710)();
}








/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('globalScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $f106fce27ec076f7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}



/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $deb2e427fa07e3b2$var$METRICS_SPAN_FIELD = '_sentryMetrics';
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $deb2e427fa07e3b2$export$2e7205e45c58797d(span) {
    const storage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $f4dd084fe83374eb$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $deb2e427fa07e3b2$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $068c396dceb690a1$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = 'sentry.profile_id';
const $068c396dceb690a1$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $068c396dceb690a1$export$b016f89ac1066ec = 'cache.hit';
const $068c396dceb690a1$export$3110e4c3f4386399 = 'cache.key';
const $068c396dceb690a1$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = 'http.request.method';
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = 'url.full';


const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}









/**
 * @deprecated Use a `"baggage"` string directly
 */ const $bcdb7fb6cf7e08bf$export$9ca9946bd449ac06 = 'baggage';
const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = 'sentry-';
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
        spanId: (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(), spanId = (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}



// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $36b15c0d755e29f6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $36b15c0d755e29f6$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)() : spanId;
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $06e5b8314e290bf2$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
                status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
                op: attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
                origin: attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
                _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $006ad32cdaebe09b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $006ad32cdaebe09b$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $99af9a2b040631ba$export$91f063ebb8eff307)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $36b15c0d755e29f6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $36b15c0d755e29f6$export$1be426a8e585c83e();
    if (span) (0, $deb2e427fa07e3b2$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $36b15c0d755e29f6$export$d11691ff45a3e535() {
    if (!$36b15c0d755e29f6$var$hasShownSpanDropWarning) {
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.');
        });
        $36b15c0d755e29f6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $36b15c0d755e29f6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'custom',
        [(0, $068c396dceb690a1$export$165ce9a229f6f050)]: name
    });
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $2bf5ed435a4428b5$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $3ed76239c787a980$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: value,
            [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $3ed76239c787a980$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $068c396dceb690a1$export$f5f95cff026507b5];
        const value = attributes[0, $068c396dceb690a1$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




const $7f25ffc87954188c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $7f25ffc87954188c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $7f25ffc87954188c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $dd0ab4bb8fd34918$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $44a719e67f846077$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntriesByType && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntriesByType('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $087abae3f457004d$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $21249b77f35afbbd$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering || (0, $087abae3f457004d$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $dd0ab4bb8fd34918$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $3c3fb26ba7f6478b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $02a4610d4ee5af80$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') cb(event);
    };
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9bb6b2adff68632$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bf61d7f7ca9bd10a$var$firstHiddenTime = -1;
const $bf61d7f7ca9bd10a$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $bf61d7f7ca9bd10a$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && $bf61d7f7ca9bd10a$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $bf61d7f7ca9bd10a$var$removeChangeListeners();
    }
};
const $bf61d7f7ca9bd10a$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$var$removeChangeListeners = ()=>{
    removeEventListener('visibilitychange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$export$443f86b2c77012c4 = ()=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && $bf61d7f7ca9bd10a$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = $bf61d7f7ca9bd10a$var$initHiddenTime();
        $bf61d7f7ca9bd10a$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bf61d7f7ca9bd10a$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6f9bc735dd2b9313$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $c372737293087726$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $c372737293087726$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === 'first-contentful-paint') {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c372737293087726$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $c8cc3356aaa35be1$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c8cc3356aaa35be1$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $c372737293087726$export$fe3c86b74e15d5de)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('CLS', 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c8cc3356aaa35be1$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $88c48014ef58cf68$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $88c48014ef58cf68$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('FID');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('first-input', handleEntries);
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $88c48014ef58cf68$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $cc83e22cb516f528$var$interactionCountEstimate = 0;
let $cc83e22cb516f528$var$minKnownInteractionId = Infinity;
let $cc83e22cb516f528$var$maxKnownInteractionId = 0;
const $cc83e22cb516f528$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $cc83e22cb516f528$var$minKnownInteractionId = Math.min($cc83e22cb516f528$var$minKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$maxKnownInteractionId = Math.max($cc83e22cb516f528$var$maxKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$interactionCountEstimate = $cc83e22cb516f528$var$maxKnownInteractionId ? ($cc83e22cb516f528$var$maxKnownInteractionId - $cc83e22cb516f528$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $cc83e22cb516f528$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $cc83e22cb516f528$export$8a962f2683a476d1 = ()=>{
    return $cc83e22cb516f528$var$po ? $cc83e22cb516f528$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $cc83e22cb516f528$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $cc83e22cb516f528$var$po) return;
    $cc83e22cb516f528$var$po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('event', $cc83e22cb516f528$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $6ba5ec799590141e$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $6ba5ec799590141e$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $6ba5ec799590141e$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $6ba5ec799590141e$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $6ba5ec799590141e$var$getInteractionCountForNavigation = ()=>{
    return (0, $cc83e22cb516f528$export$8a962f2683a476d1)() - $6ba5ec799590141e$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $6ba5ec799590141e$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1, Math.floor($6ba5ec799590141e$var$getInteractionCountForNavigation() / 50));
    return $6ba5ec799590141e$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $6ba5ec799590141e$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $6ba5ec799590141e$export$6a7a48c2c643798f = (entry)=>{
    $6ba5ec799590141e$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === 'first-input')) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $6ba5ec799590141e$export$fbb6a65efb09cd7a[$6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $6ba5ec799590141e$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $6ba5ec799590141e$export$fbb6a65efb09cd7a.length < $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === (existingInteraction.entries[0] && existingInteraction.entries[0].startTime)) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $6ba5ec799590141e$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $6ba5ec799590141e$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $6ba5ec799590141e$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($6ba5ec799590141e$export$fbb6a65efb09cd7a.length > $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER) $6ba5ec799590141e$export$fbb6a65efb09cd7a.splice($6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$6ba5ec799590141e$export$7b86959c9ded44e2.delete(i.id));
    }
};









/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $25236b21f8c05ee3$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $955496f5d3029976$export$56d8a8a25bd48b81).requestIdleCallback || (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') cb();
    else {
        handle = rIC(cb);
        (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(cb);
    }
    return handle;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $c2ceebba2f8f4181$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c2ceebba2f8f4181$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in (0, $955496f5d3029976$export$56d8a8a25bd48b81) && 'interactionId' in PerformanceEventTiming.prototype)) return;
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $cc83e22cb516f528$export$67d90cda6b78a2eb)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $25236b21f8c05ee3$export$4d9952dcbf5b2792)(()=>{
                entries.forEach((0, $6ba5ec799590141e$export$6a7a48c2c643798f));
                const inp = (0, $6ba5ec799590141e$export$70cf089971ed4f82)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $6ba5ec799590141e$export$9cebd8cf5d8d3416)
        });
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c2ceebba2f8f4181$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};












/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $c89cf1e13796625e$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $c89cf1e13796625e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $c89cf1e13796625e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('LCP');
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c89cf1e13796625e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
                if (!$c89cf1e13796625e$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $c89cf1e13796625e$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                'keydown',
                'click'
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) addEventListener(type, ()=>(0, $25236b21f8c05ee3$export$4d9952dcbf5b2792)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $f3a7825c3a5278be$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $f3a7825c3a5278be$var$whenReady = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>$f3a7825c3a5278be$var$whenReady(callback));
    else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$f3a7825c3a5278be$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $f3a7825c3a5278be$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)('TTFB');
    const report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $f3a7825c3a5278be$export$65c59ea8064668fc, opts.reportAllChanges);
    $f3a7825c3a5278be$var$whenReady(()=>{
        const navigationEntry = (0, $44a719e67f846077$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $31f3d198369e5cbf$var$handlers = {};
const $31f3d198369e5cbf$var$instrumented = {};
let $31f3d198369e5cbf$var$_previousCls;
let $31f3d198369e5cbf$var$_previousFid;
let $31f3d198369e5cbf$var$_previousLcp;
let $31f3d198369e5cbf$var$_previousTtfb;
let $31f3d198369e5cbf$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $31f3d198369e5cbf$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver('cls', callback, $31f3d198369e5cbf$var$instrumentCls, $31f3d198369e5cbf$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $31f3d198369e5cbf$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver('lcp', callback, $31f3d198369e5cbf$var$instrumentLcp, $31f3d198369e5cbf$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$2707d7471c0b918f(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('fid', callback, $31f3d198369e5cbf$var$instrumentFid, $31f3d198369e5cbf$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $31f3d198369e5cbf$export$699d9529c099a797(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('ttfb', callback, $31f3d198369e5cbf$var$instrumentTtfb, $31f3d198369e5cbf$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$da3b76aa2022cbd7(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('inp', callback, $31f3d198369e5cbf$var$instrumentInp, $31f3d198369e5cbf$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$69816c1a049f8db6(type, callback) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        $31f3d198369e5cbf$var$instrumentPerformanceObserver(type);
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $31f3d198369e5cbf$var$triggerHandlers(type, data) {
    const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $31f3d198369e5cbf$var$instrumentCls() {
    return (0, $c8cc3356aaa35be1$export$a7873055838e5ad8)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('cls', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentFid() {
    return (0, $88c48014ef58cf68$export$39705a25c49af873)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('fid', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousFid = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentLcp() {
    return (0, $c89cf1e13796625e$export$947b1626ab8d5632)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('lcp', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentTtfb() {
    return (0, $f3a7825c3a5278be$export$33a01e6c5f2c7e33)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousTtfb = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentInp() {
    return (0, $c2ceebba2f8f4181$export$7df4b36ecaed99e1)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('inp', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousInp = metric;
    });
}
function $31f3d198369e5cbf$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    let stopListening;
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        stopListening = instrumentFn();
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $31f3d198369e5cbf$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $3c3fb26ba7f6478b$export$d1203567a167490e)(type, (entries)=>{
        $31f3d198369e5cbf$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $31f3d198369e5cbf$var$addHandler(type, handler) {
    $31f3d198369e5cbf$var$handlers[type] = $31f3d198369e5cbf$var$handlers[type] || [];
    $31f3d198369e5cbf$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $31f3d198369e5cbf$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}











/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $a328b345a75725bb$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $a328b345a75725bb$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $a328b345a75725bb$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e426c875bd1d2890$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}




const $3592a0510b526070$export$849dbeeeda01ae98 = 'production';








/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3592a0510b526070$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $dfdaf30e5fcd5fd9$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $068c396dceb690a1$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) dsc.sampled = String((0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(rootSpan));
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $bcdb7fb6cf7e08bf$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $09ada9a941cee5f6$export$2f3d84e767c9592b(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $09ada9a941cee5f6$export$b77c830667a4d630(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $c9674f9e04798056$export$af88d00dbe7f521).log(msg);
}








/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}


/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $db2bd6d2ef458b60$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)(options)) return [
        false
    ];
    // Casting this from unknown, as the type of `sdkProcessingMetadata` is only changed in v9 and `normalizedRequest` is set in SentryHttpInstrumentation
    const normalizedRequest = (0, $f106fce27ec076f7$export$68f3af03034c9e90)().getScopeData().sdkProcessingMetadata.normalizedRequest;
    const enhancedSamplingContext = {
        ...samplingContext,
        normalizedRequest: samplingContext.normalizedRequest || normalizedRequest
    };
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler(enhancedSamplingContext);
    else if (enhancedSamplingContext.parentSampled !== undefined) sampleRate = enhancedSamplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $d899755a957e1f50$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}







/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $18144a665bc8acf7$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $25eec345af6c49d3$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $25eec345af6c49d3$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $f4dd084fe83374eb$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $9a62450b4f3c2c3b$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    return (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    return (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5eb42146e0d2c9ef$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket',
    raw_security: 'security'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $f5682b06913d5b03$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(span));
        if (!spanJson) (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
        return spanJson;
    } : (span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f5682b06913d5b03$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, items);
}













const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


const $e47c8865bba9bc73$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $e47c8865bba9bc73$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
        this._attributes = {};
        this.setAttributes({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'manual',
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $36b15c0d755e29f6$export$eb571cd9b5d98de8) : (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $068c396dceb690a1$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(endTimestamp);
        (0, $09ada9a941cee5f6$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $36b15c0d755e29f6$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $068c396dceb690a1$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $068c396dceb690a1$export$fea48ba9f4550879],
            measurements: (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Adding an event to span:', name);
        const time = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
        const attributes = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $e47c8865bba9bc73$var$sendSpanEnvelope((0, $b89a3b4f1056006b$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this).scope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$e47c8865bba9bc73$var$isFullFinishedSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const client = scope.getClient() || (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$e47c8865bba9bc73$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span)).filter($e47c8865bba9bc73$var$isFullFinishedSpan);
        const source = this._attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $068c396dceb690a1$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            span.data && delete span.data[0, $068c396dceb690a1$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $36b15c0d755e29f6$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e47c8865bba9bc73$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e47c8865bba9bc73$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e47c8865bba9bc73$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $e47c8865bba9bc73$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $e47c8865bba9bc73$var$isStandaloneSpan(span) {
    return span instanceof $e47c8865bba9bc73$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $e47c8865bba9bc73$var$sendSpanEnvelope(envelope) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




const $038737f78c636108$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$a1bd95187356f372(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$c10292ad04b92aea(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$63dbba021a6b4047(options) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$038737f78c636108$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const parentSpan = $038737f78c636108$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
        return $038737f78c636108$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $038737f78c636108$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $06e5b8314e290bf2$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $038737f78c636108$export$e57ac09b143d92a2(span, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $038737f78c636108$export$869298f9835abc68(callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$038737f78c636108$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $038737f78c636108$export$f90b03291402f553(callback) {
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $038737f78c636108$export$e57ac09b143d92a2(null, callback);
    });
}
function $038737f78c636108$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $09ada9a941cee5f6$export$2f3d84e767c9592b)(span);
    (0, $4509d165411fd11c$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $038737f78c636108$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $038737f78c636108$var$getAcs() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    return (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
}
function $038737f78c636108$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {};
    const { name: name = '', attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $db2bd6d2ef458b60$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'custom',
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $068c396dceb690a1$export$ccfe0a40627cc34b), sampleRate);
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? false : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $038737f78c636108$var$getParentSpan(scope) {
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $038737f78c636108$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $038737f78c636108$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}



/**
 * Checks if a given value is a valid measurement value.
 */ function $b0d1d845a8fb2673$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $b0d1d845a8fb2673$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $038737f78c636108$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay && replay.getReplayId();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator && (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator.userAgent,
        ...passedAttributes
    };
    return (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $b0d1d845a8fb2673$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81) && (0, $955496f5d3029976$export$56d8a8a25bd48b81).addEventListener && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $b0d1d845a8fb2673$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $b0d1d845a8fb2673$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $b444d11e9edd543f$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$b444d11e9edd543f$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $b444d11e9edd543f$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on('startNavigationSpan', ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation && unsubscribeStartNavigation();
        });
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        const spanJSON = rootSpan && (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        if (spanJSON && spanJSON.op === 'pageload') pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $b444d11e9edd543f$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(((0, $4f6ba265374890ec$export$baf075a948ffc0bf) || 0) + (entry && entry.startTime || 0));
    const routeName = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $cccaafc2216668b2$export$5647df6b7814ac86)(entry.sources[0] && entry.sources[0].node) : 'Layout shift';
    const attributes = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.http.browser.cls',
        [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: 'ui.webvital.cls',
        [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: entry && entry.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId
    });
    const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: '',
            [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $b444d11e9edd543f$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes('layout-shift');
    } catch (e) {
        return false;
    }
}







const $4ca18541755f3f2c$var$MAX_INT_AS_BYTES = 2147483647;
let $4ca18541755f3f2c$var$_performanceCursor = 0;
let $4ca18541755f3f2c$var$_measurements = {};
let $4ca18541755f3f2c$var$_lcpEntry;
let $4ca18541755f3f2c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ca18541755f3f2c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $4f6ba265374890ec$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCleanupCallback = $4ca18541755f3f2c$var$_trackFID();
        const lcpCleanupCallback = $4ca18541755f3f2c$var$_trackLCP();
        const ttfbCleanupCallback = $4ca18541755f3f2c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $b444d11e9edd543f$export$585bab03c6c18c45)() : $4ca18541755f3f2c$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ca18541755f3f2c$export$f396d19077034ad2() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        const parent = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $4ca18541755f3f2c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $4ca18541755f3f2c$export$e27543e0976315e4() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        const parent = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $cccaafc2216668b2$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $cccaafc2216668b2$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $4ca18541755f3f2c$var$_trackCLS() {
    return (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $4ca18541755f3f2c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ca18541755f3f2c$var$_trackLCP() {
    return (0, $31f3d198369e5cbf$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ca18541755f3f2c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ca18541755f3f2c$var$_trackFID() {
    return (0, $31f3d198369e5cbf$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf));
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        $4ca18541755f3f2c$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ca18541755f3f2c$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $4ca18541755f3f2c$var$_trackTtfb() {
    return (0, $31f3d198369e5cbf$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $4ca18541755f3f2c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (!performance || !performance.getEntries || !(0, $4f6ba265374890ec$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    performanceEntries.slice($4ca18541755f3f2c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $4ca18541755f3f2c$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $4ca18541755f3f2c$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $4ca18541755f3f2c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ca18541755f3f2c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements($4ca18541755f3f2c$var$_measurements);
        const fidMark = $4ca18541755f3f2c$var$_measurements['mark.fid'];
        if (fidMark && $4ca18541755f3f2c$var$_measurements['fid']) {
            // create span for FID
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)($4ca18541755f3f2c$var$_measurements['fid'].value), {
                name: 'first input delay',
                op: 'ui.action',
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ca18541755f3f2c$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!('fcp' in $4ca18541755f3f2c$var$_measurements) || !options.recordClsOnPageloadSpan) delete $4ca18541755f3f2c$var$_measurements.cls;
        Object.entries($4ca18541755f3f2c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $3ed76239c787a980$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $087abae3f457004d$export$d3e828b3c7b5b845)());
        $4ca18541755f3f2c$var$_setWebVitalAttributes(span);
    }
    $4ca18541755f3f2c$var$_lcpEntry = undefined;
    $4ca18541755f3f2c$var$_clsEntry = undefined;
    $4ca18541755f3f2c$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)(false);
    const requestTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ function $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
        }
    });
}
function $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes['http.response_delivery_type'] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes['resource.render_blocking_status'] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin);
    const { name: name, version: version } = (0, $b0d1d845a8fb2673$export$57c6f824442f9fe1)(entry.nextHopProtocol);
    attributes['network.protocol.name'] = name;
    attributes['network.protocol.version'] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin, ''),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ca18541755f3f2c$var$_trackNavigator(span) {
    const navigator = (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(connection.rtt)) $4ca18541755f3f2c$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $4ca18541755f3f2c$var$_setWebVitalAttributes(span) {
    if ($4ca18541755f3f2c$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ca18541755f3f2c$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $cccaafc2216668b2$export$5647df6b7814ac86)($4ca18541755f3f2c$var$_lcpEntry.element));
        if ($4ca18541755f3f2c$var$_lcpEntry.id) span.setAttribute('lcp.id', $4ca18541755f3f2c$var$_lcpEntry.id);
        if ($4ca18541755f3f2c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $4ca18541755f3f2c$var$_lcpEntry.url.trim().slice(0, 200));
        if ($4ca18541755f3f2c$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $4ca18541755f3f2c$var$_lcpEntry.loadTime);
        if ($4ca18541755f3f2c$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $4ca18541755f3f2c$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $4ca18541755f3f2c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ca18541755f3f2c$var$_clsEntry && $4ca18541755f3f2c$var$_clsEntry.sources) $4ca18541755f3f2c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $cccaafc2216668b2$export$5647df6b7814ac86)(source.node)));
}
function $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ca18541755f3f2c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}




const $751b596e3029fa17$var$LAST_INTERACTIONS = [];
const $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $751b596e3029fa17$export$f17d06681a4744a3() {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $4f6ba265374890ec$export$baf075a948ffc0bf)) {
        const inpCallback = $751b596e3029fa17$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $751b596e3029fa17$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $751b596e3029fa17$var$_trackINP() {
    return (0, $31f3d198369e5cbf$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $4f6ba265374890ec$export$baf075a948ffc0bf) + entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $36b15c0d755e29f6$export$92d8c23565496537)(spanToUse).description : (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
        const name = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(entry.target);
        const attributes = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.http.browser.inp',
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
            [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: entry.duration
        });
        const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent('inp', {
                [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: 'millisecond',
                [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $751b596e3029fa17$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $31f3d198369e5cbf$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($751b596e3029fa17$var$LAST_INTERACTIONS.length > 10) {
                const last = $751b596e3029fa17$var$LAST_INTERACTIONS.shift();
                $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $751b596e3029fa17$var$LAST_INTERACTIONS.push(interactionId);
            $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('event', handleEntries);
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('first-input', handleEntries);
}





let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('error', handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $d4be1d52827a3f28$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $d4be1d52827a3f28$export$b0914730ee1f6c80() {
    if ($d4be1d52827a3f28$var$errorsInstrumented) return;
    $d4be1d52827a3f28$var$errorsInstrumented = true;
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)($d4be1d52827a3f28$var$errorCallback);
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)($d4be1d52827a3f28$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $d4be1d52827a3f28$var$errorCallback() {
    const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = 'internal_error';
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d4be1d52827a3f28$var$errorCallback.tag = 'sentry_tracingErrorCallback';












const $fd927ea1b5d85956$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $fd927ea1b5d85956$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client || !(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = $fd927ea1b5d85956$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $068c396dceb690a1$export$ba73f34502b7a3b3]) span.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), _finishReason);
        (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $36b15c0d755e29f6$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $36b15c0d755e29f6$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: 'deadline_exceeded'
            });
            _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $fd927ea1b5d85956$var$_startIdleSpan(options) {
    const span = (0, $038737f78c636108$export$63dbba021a6b4047)(options);
    (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), span);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('[Tracing] Started span is an idle span');
    return span;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

















/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init2.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init3.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && processor.id && result === null && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $107941ce73c7a34f$var$parsedStackResults;
let $107941ce73c7a34f$var$lastKeysCount;
let $107941ce73c7a34f$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($107941ce73c7a34f$var$cachedFilenameDebugIds && debugIdKeys.length === $107941ce73c7a34f$var$lastKeysCount) return $107941ce73c7a34f$var$cachedFilenameDebugIds;
    $107941ce73c7a34f$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $107941ce73c7a34f$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$107941ce73c7a34f$var$parsedStackResults) $107941ce73c7a34f$var$parsedStackResults = {};
        const result = $107941ce73c7a34f$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $107941ce73c7a34f$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $107941ce73c7a34f$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}










/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'extra', extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'tags', tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'user', user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$export$d7e04067a6fbc882(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f106fce27ec076f7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $29ab5181ea4a2c1b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $fa62667502ab5c7a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $3592a0510b526070$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $cee8faa76567523a$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $cee8faa76567523a$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $cee8faa76567523a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $107941ce73c7a34f$export$e069fee9c632ed00)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $33c387bb26fe522d$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $baba650ac852ba0c$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(exception, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureException(exception, (0, $baba650ac852ba0c$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $f106fce27ec076f7$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $f106fce27ec076f7$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $3592a0510b526070$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ecc06dd71ed8ff5f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ecc06dd71ed8ff5f$export$56521d9ba90f62ee)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}


const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $f4dd084fe83374eb$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}





/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $755e6178fce08d17$export$6f18f55521af71a1() {
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
            if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(header) && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $63e43e59b4196dc4$var$parseUrl(url) {
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}







const $020e060e3b422828$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return 'ReportingObserver' in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $020e060e3b422828$export$c82d238e23c40b21)()) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($da5e32477400e3c6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}














/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $1ca539d872b9359e$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!(0, $f2b90654edf2c0a1$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const span = options.span || (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const sentryTrace = span ? (0, $36b15c0d755e29f6$export$7e9f8ae9e4a328ab)(span) : $1ca539d872b9359e$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $bcdb7fb6cf7e08bf$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $06e5b8314e290bf2$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    return {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $1ca539d872b9359e$var$scopeToTraceHeader(scope) {
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, sampled: sampled, spanId: spanId } = scope.getPropagationContext();
    return (0, $06e5b8314e290bf2$export$f35d907436da45cf)(traceId, spanId, sampled);
}

















/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $0b4497afe5c251f9$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $0b4497afe5c251f9$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $0b4497afe5c251f9$var$getFullURL(url);
    const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: spanOrigin,
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */ function $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $1ca539d872b9359e$export$dec8f001b9d982cb)({
        span: span
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const headers = fetchOptionsObj.headers || ($0b4497afe5c251f9$var$isRequest(request) ? request.headers : undefined);
    if (!headers) return {
        ...traceHeaders
    };
    else if ($0b4497afe5c251f9$var$isHeaders(headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set('sentry-trace', sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set('baggage', // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
            } else newHeaders.set('baggage', baggage);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === 'sentry-trace');
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === 'baggage' && typeof header[1] === 'string') {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                'sentry-trace',
                sentryTrace
            ]
        ];
        if (baggage) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === 'string' ? $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === '');
        else if (existingBaggageHeader) newBaggageHeaders.push($0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (baggage) newBaggageHeaders.push(baggage);
        return {
            ...headers,
            'sentry-trace': sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 *
 * @deprecated This function will not be exported anymore in v9.
 */ function $0b4497afe5c251f9$export$6717acf674206871(request, _client, _scope, fetchOptionsObj, span) {
    return $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span);
}
function $0b4497afe5c251f9$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $0b4497afe5c251f9$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
        message: 'internal_error'
    });
    span.end();
}
function $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',')// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split('=')[0].startsWith((0, $bcdb7fb6cf7e08bf$export$6e69537d67fa20f))).join(',');
}
function $0b4497afe5c251f9$var$isRequest(request) {
    return typeof Request !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(request, Request);
}
function $0b4497afe5c251f9$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(headers, Headers);
}



/** Options for Request Instrumentation */ const $edec20d6c9712df6$var$responseToSpanId = new WeakMap();
const $edec20d6c9712df6$var$spanIdToEndTimestamp = new Map();
const $edec20d6c9712df6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $edec20d6c9712df6$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceXHR,
        trackFetchStreamPerformance: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.trackFetchStreamPerformance,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$edec20d6c9712df6$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $edec20d6c9712df6$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $edec20d6c9712df6$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $da5e32477400e3c6$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $edec20d6c9712df6$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $edec20d6c9712df6$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $da5e32477400e3c6$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $0b4497afe5c251f9$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $edec20d6c9712df6$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $edec20d6c9712df6$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
            }
            if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
    });
}
function $edec20d6c9712df6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $edec20d6c9712df6$var$addHTTPTimings(span) {
    const { url: url } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $31f3d198369e5cbf$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($edec20d6c9712df6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $edec20d6c9712df6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $edec20d6c9712df6$var$getAbsoluteTime(time = 0) {
    return (((0, $4f6ba265374890ec$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $edec20d6c9712df6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $b0d1d845a8fb2673$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $4f6ba265374890ec$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $edec20d6c9712df6$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $edec20d6c9712df6$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.http.browser',
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(sentryXhrData.url)) $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    return span;
}
function $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { 'sentry-trace': sentryTrace, baggage: baggage } = (0, $1ca539d872b9359e$export$dec8f001b9d982cb)({
        span: span
    });
    if (sentryTrace) $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('baggage', sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $edec20d6c9712df6$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $400f75f99113439b$export$bbd2089f30bd3708 = 'BrowserTracing';
const $400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $fd927ea1b5d85956$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {},
    ...(0, $edec20d6c9712df6$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $400f75f99113439b$export$b4109253475213e9 = (_options = {})=>{
    (0, $d4be1d52827a3f28$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $4ca18541755f3f2c$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $751b596e3029fa17$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, $4ca18541755f3f2c$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $4ca18541755f3f2c$export$f396d19077034ad2)();
    if (enableInteractions) (0, $4ca18541755f3f2c$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === 'pageload';
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $068c396dceb690a1$export$d7a7d984b0791405] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        const idleSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $4ca18541755f3f2c$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                'interactive',
                'complete'
            ].includes((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        if (isPageloadTransaction && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
            (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $400f75f99113439b$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            function maybeEndActiveSpan() {
                if (activeSpan && !(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`[Tracing] Finishing current active span with op: ${(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions)=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                activeSpan = _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $400f75f99113439b$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $400f75f99113439b$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $06e5b8314e290bf2$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on('spanEnd', (span)=>{
                const op = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
                if (span !== (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span) || op !== 'navigation' && op !== 'pageload') return;
                const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span),
                    dsc: oldPropagationContext.dsc || (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span)
                });
            });
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $400f75f99113439b$export$aa44a07f82af519f(client, {
                    name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $4f6ba265374890ec$export$baf075a948ffc0bf) ? (0, $4f6ba265374890ec$export$baf075a948ffc0bf) / 1000 : undefined,
                    attributes: {
                        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'url',
                        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.pageload.browser'
                    }
                });
                if (instrumentNavigation) (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $400f75f99113439b$export$7d159749bd9969ad(client, {
                            name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'url',
                                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: 'auto.navigation.browser'
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $755e6178fce08d17$export$6f18f55521af71a1)();
            if (enableInteractions) $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $751b596e3029fa17$export$e4e04d43e223cce2)();
            (0, $edec20d6c9712df6$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $400f75f99113439b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $400f75f99113439b$export$7d159749bd9969ad(client, spanOptions) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setPropagationContext({
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
    });
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext({
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)()
    });
    client.emit('startNavigationSpan', spanOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $400f75f99113439b$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    // eslint-disable-next-line deprecation/deprecation
    const metaTag = (0, $cccaafc2216668b2$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) addEventListener('click', registerInteractionTransaction, {
        once: false,
        capture: true
    });
}




const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $fbb22756c9507e85$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === 'Debug');
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}





const $b99d5bb3db344fdd$var$INTEGRATION_NAME = 'Dedupe';
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = 'FunctionToString';
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);


const $0e303f054920e2b1$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $67b350191b117f2b$var$INTEGRATION_NAME = 'InboundFilters';
const $67b350191b117f2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $67b350191b117f2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $67b350191b117f2b$var$_mergeOptions(options, clientOptions);
            return $67b350191b117f2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $67b350191b117f2b$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)($67b350191b117f2b$var$_inboundFiltersIntegration);
function $67b350191b117f2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $67b350191b117f2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $67b350191b117f2b$var$_isSentryError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isUselessError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$67b350191b117f2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $67b350191b117f2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $67b350191b117f2b$var$_getPossibleEventMessages(event).some((message)=>(0, $cee8faa76567523a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $67b350191b117f2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $67b350191b117f2b$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $67b350191b117f2b$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $67b350191b117f2b$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $67b350191b117f2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $67b350191b117f2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $67b350191b117f2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $67b350191b117f2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $67b350191b117f2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b776c95debaa4af0$export$16a28057038b10ef) (0, $c9674f9e04798056$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setClient(client);
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
            })),
        version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}










/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/** An error emitted by Sentry SDKs and related utilities. */ class $71e03e2f84576ceb$export$5949942ba2a7c0e2 extends Error {
    constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}









const $4f30d529f2099042$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $4f30d529f2099042$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(options.dsn);
        else (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            'enableTracing',
            'tracesSampleRate',
            'tracesSampler'
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(exception)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $f5682b06913d5b03$export$d650323442802f6f)(env, (0, $f5682b06913d5b03$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $baba650ac852ba0c$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = {
                trace: (0, $f106fce27ec076f7$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                if (reason instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2) && reason.logLevel === 'log') (0, $c9674f9e04798056$export$af88d00dbe7f521).log(reason.message);
                else (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4f30d529f2099042$var$isTransactionEvent(event);
        const isError = $4f30d529f2099042$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $4f30d529f2099042$var$processBeforeSend(this, options, prepared, hint);
            return $4f30d529f2099042$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $bbe8beff1aee2812$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9171e4713e443b9b$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $4f30d529f2099042$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $4f30d529f2099042$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($4f30d529f2099042$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($4f30d529f2099042$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
                    client.recordDroppedEvent('before_send', 'span');
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $4f30d529f2099042$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $4f30d529f2099042$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}


var $2wKOZ = parcelRequire("2wKOZ");


/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $5eb42146e0d2c9ef$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(exception) || (0, $9a62450b4f3c2c3b$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(exception) || (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $f4dd084fe83374eb$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




/**
 * Creates an envelope from a user feedback.
 */ function $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $4f30d529f2099042$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $2wKOZ.getSDKSource)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
}






const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f079126c500c7ea2$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $955496f5d3029976$export$56d8a8a25bd48b81);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(target, '_sentryId', (0, $4f55103f4332a5b0$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return;
    (0, $c9674f9e04798056$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console)) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $c9674f9e04798056$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $c9674f9e04798056$export$77c4ce905194557b)[level];
                log && log.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $197a1d16f7c0faf5$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $16d762171e064dbd$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $da5e32477400e3c6$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $4f55103f4332a5b0$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $cccaafc2216668b2$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(handlerData.level),
            message: (0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(status_code);
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http',
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(data.status_code);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http',
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setTimeout', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setInterval', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'requestAnimationFrame', $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4e018dbe28beb052$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4e018dbe28beb052$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8a5b32760c0daa50$export$1baa7880e357371c = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
                }
            });
        }
    };
});






const $3920039f2d643754$var$INTEGRATION_NAME = 'GlobalHandlers';
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $cccaafc2216668b2$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$truncateAggregateExceptions($71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $71a9151fcd5ea774$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $cee8faa76567523a$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = 'cause';
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = 'LinkedErrors';
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $71a9151fcd5ea774$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $4010ef0d9b3761f9$export$a5739666fb2d03d4)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $020e060e3b422828$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('setTimeout')(...rest);
}








/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $9ad49a0639c06d33$export$78e43115b553f358)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f3cbf180d3404fe0$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $f5682b06913d5b03$export$b11169581eeaf237)(type);
            if ((0, $5325f8e04d3d0467$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $f5682b06913d5b03$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f5682b06913d5b03$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5325f8e04d3d0467$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $edfbff9038a67171$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $67b350191b117f2b$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $8a5b32760c0daa50$export$1baa7880e357371c)());
    return integrations;
}
function $928f566aa50bb77a$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if (0, $7b8b500cb80621bc$export$16a28057038b10ef) {
        if (!(0, $020e060e3b422828$export$edf3cb81fd7d2a3e)()) (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $4010ef0d9b3761f9$export$1d5cf88b347146d4)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    return (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $f2b90654edf2c0a1$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $928f566aa50bb77a$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $acw62 = parcelRequire("acw62");
/**
 * Inits the React SDK
 */ function $07b303fd558e140e$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'react');
    (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)('react', {
        version: $acw62.version
    });
    return (0, $928f566aa50bb77a$export$2cd8252107eb640b)(opts);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $37a3ef5fa939d363$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $ed3fffa7fe0475db$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $ctISH = parcelRequire("ctISH");

/**
 * Returns true if we are in the browser.
 */ function $856a9239af1edf90$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $ctISH.isNodeEnv)() || $856a9239af1edf90$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $856a9239af1edf90$var$isElectronNodeRenderer() {
    const process = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).process;
    return !!process && process.type === 'renderer';
}

/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $e523a4dfa96cd99a$export$d92e61f5600202af(url, client) {
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $e523a4dfa96cd99a$var$checkDsn(url, dsn) || $e523a4dfa96cd99a$var$checkTunnel(url, tunnel);
}
function $e523a4dfa96cd99a$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $e523a4dfa96cd99a$var$removeTrailingSlash(url) === $e523a4dfa96cd99a$var$removeTrailingSlash(tunnel);
}
function $e523a4dfa96cd99a$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $e523a4dfa96cd99a$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $0ca4f63b79e931bd$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
const $0ca4f63b79e931bd$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $0ca4f63b79e931bd$var$REPLAY_EVENT_NAME = 'replay_event';
const $0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $0ca4f63b79e931bd$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $0ca4f63b79e931bd$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $0ca4f63b79e931bd$var$BUFFER_CHECKOUT_TIME = 60000;
const $0ca4f63b79e931bd$var$RETRY_BASE_INTERVAL = 5000;
const $0ca4f63b79e931bd$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $0ca4f63b79e931bd$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $0ca4f63b79e931bd$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $0ca4f63b79e931bd$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $0ca4f63b79e931bd$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $0ca4f63b79e931bd$var$NodeType$3;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($0ca4f63b79e931bd$var$NodeType$3 || ($0ca4f63b79e931bd$var$NodeType$3 = {}));
function $0ca4f63b79e931bd$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $0ca4f63b79e931bd$var$isShadowRoot(n) {
    const host = $0ca4f63b79e931bd$var$_optionalChain$5([
        n,
        'optionalAccess',
        (_)=>_.host
    ]);
    return Boolean($0ca4f63b79e931bd$var$_optionalChain$5([
        host,
        'optionalAccess',
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $0ca4f63b79e931bd$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $0ca4f63b79e931bd$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $0ca4f63b79e931bd$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $0ca4f63b79e931bd$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $0ca4f63b79e931bd$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $0ca4f63b79e931bd$var$fixAllCssProperty(rule) {
    let styles = '';
    for(let i = 0; i < rule.style.length; i++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ''};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $0ca4f63b79e931bd$var$stringifyRule(rule) {
    let importStringified;
    if ($0ca4f63b79e931bd$var$isCSSImportRule(rule)) try {
        importStringified = $0ca4f63b79e931bd$var$stringifyStylesheet(rule.styleSheet) || $0ca4f63b79e931bd$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($0ca4f63b79e931bd$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(':');
        const needsAllFix = typeof rule.style['all'] === 'string' && rule.style['all'];
        if (needsAllFix) cssText = $0ca4f63b79e931bd$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $0ca4f63b79e931bd$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $0ca4f63b79e931bd$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $0ca4f63b79e931bd$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $0ca4f63b79e931bd$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class $0ca4f63b79e931bd$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $0ca4f63b79e931bd$var$_optionalChain$5([
            this,
            'access',
            (_3)=>_3.getMeta,
            'call',
            (_4)=>_4(n),
            'optionalAccess',
            (_5)=>_5.id
        ]);
        return $0ca4f63b79e931bd$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $0ca4f63b79e931bd$var$createMirror() {
    return new $0ca4f63b79e931bd$var$Mirror();
}
function $0ca4f63b79e931bd$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === 'OPTION') tagName = 'SELECT';
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function $0ca4f63b79e931bd$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return '*'.repeat(text.length);
}
function $0ca4f63b79e931bd$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $0ca4f63b79e931bd$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $0ca4f63b79e931bd$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $0ca4f63b79e931bd$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $0ca4f63b79e931bd$var$toLowerCase(type) : null;
}
function $0ca4f63b79e931bd$var$getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
function $0ca4f63b79e931bd$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, $0ca4f63b79e931bd$var$_nullishCoalesce$1(baseURL, ()=>window.location.href));
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return $0ca4f63b79e931bd$var$_nullishCoalesce$1($0ca4f63b79e931bd$var$_optionalChain$5([
        match,
        'optionalAccess',
        (_6)=>_6[1]
    ]), ()=>null);
}
const $0ca4f63b79e931bd$var$cachedImplementations$1 = {};
function $0ca4f63b79e931bd$var$getImplementation$1(name) {
    const cached = $0ca4f63b79e931bd$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $0ca4f63b79e931bd$var$cachedImplementations$1[name] = impl.bind(window);
}
function $0ca4f63b79e931bd$var$setTimeout$2(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation$1('setTimeout')(...rest);
}
function $0ca4f63b79e931bd$var$clearTimeout$2(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation$1('clearTimeout')(...rest);
}
function $0ca4f63b79e931bd$var$getIframeContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e) {}
}
let $0ca4f63b79e931bd$var$_id = 1;
const $0ca4f63b79e931bd$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $0ca4f63b79e931bd$var$IGNORED_NODE = -2;
function $0ca4f63b79e931bd$var$genId() {
    return $0ca4f63b79e931bd$var$_id++;
}
function $0ca4f63b79e931bd$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = $0ca4f63b79e931bd$var$toLowerCase(element.tagName);
    if ($0ca4f63b79e931bd$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $0ca4f63b79e931bd$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $0ca4f63b79e931bd$var$canvasService;
let $0ca4f63b79e931bd$var$canvasCtx;
const $0ca4f63b79e931bd$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $0ca4f63b79e931bd$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $0ca4f63b79e931bd$var$URL_WWW_MATCH = /^www\..*/i;
const $0ca4f63b79e931bd$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($0ca4f63b79e931bd$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($0ca4f63b79e931bd$var$URL_PROTOCOL_MATCH.test(filePath) || $0ca4f63b79e931bd$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($0ca4f63b79e931bd$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$0ca4f63b79e931bd$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $0ca4f63b79e931bd$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $0ca4f63b79e931bd$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $0ca4f63b79e931bd$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while(true){
        collectCharacters($0ca4f63b79e931bd$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($0ca4f63b79e931bd$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $0ca4f63b79e931bd$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $0ca4f63b79e931bd$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
const $0ca4f63b79e931bd$var$cachedDocument = new WeakMap();
function $0ca4f63b79e931bd$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    return $0ca4f63b79e931bd$var$getHref(doc, attributeValue);
}
function $0ca4f63b79e931bd$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $0ca4f63b79e931bd$var$getHref(doc, customHref) {
    let a = $0ca4f63b79e931bd$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement('a');
        $0ca4f63b79e931bd$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = '';
    else if (customHref.startsWith('blob:') || customHref.startsWith('data:')) return customHref;
    a.setAttribute('href', customHref);
    return a.href;
}
function $0ca4f63b79e931bd$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $0ca4f63b79e931bd$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $0ca4f63b79e931bd$var$absoluteToStylesheet(value, $0ca4f63b79e931bd$var$getHref(doc));
    else if (tagName === 'object' && name === 'data') return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === 'function') return maskAttributeFn(name, value, element);
    return value;
}
function $0ca4f63b79e931bd$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $0ca4f63b79e931bd$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $0ca4f63b79e931bd$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $0ca4f63b79e931bd$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $0ca4f63b79e931bd$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $0ca4f63b79e931bd$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($0ca4f63b79e931bd$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $0ca4f63b79e931bd$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === 'INPUT') {
            const autocomplete = el.getAttribute('autocomplete');
            const disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc'
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $0ca4f63b79e931bd$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = $0ca4f63b79e931bd$var$setTimeout$2(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            $0ca4f63b79e931bd$var$clearTimeout$2(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        $0ca4f63b79e931bd$var$setTimeout$2(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $0ca4f63b79e931bd$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = $0ca4f63b79e931bd$var$setTimeout$2(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', ()=>{
        $0ca4f63b79e931bd$var$clearTimeout$2(timer);
        fired = true;
        listener();
    });
}
function $0ca4f63b79e931bd$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $0ca4f63b79e931bd$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $0ca4f63b79e931bd$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $0ca4f63b79e931bd$var$NodeType$3.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$3.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $0ca4f63b79e931bd$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $0ca4f63b79e931bd$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$3.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$3.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $0ca4f63b79e931bd$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $0ca4f63b79e931bd$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($0ca4f63b79e931bd$var$_optionalChain$5([
                n,
                'access',
                (_7)=>_7.parentNode,
                'access',
                (_8)=>_8.sheet,
                'optionalAccess',
                (_9)=>_9.cssRules
            ])) textContent = $0ca4f63b79e931bd$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $0ca4f63b79e931bd$var$absoluteToStylesheet(textContent, $0ca4f63b79e931bd$var$getHref(options.doc));
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    const forceMask = $0ca4f63b79e931bd$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
    if (parentTagName === 'OPTION' && textContent) {
        const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $0ca4f63b79e931bd$var$maskInputValue({
            isMasked: $0ca4f63b79e931bd$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $0ca4f63b79e931bd$var$NodeType$3.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $0ca4f63b79e931bd$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $0ca4f63b79e931bd$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $0ca4f63b79e931bd$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$0ca4f63b79e931bd$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $0ca4f63b79e931bd$var$transformAttribute(doc, tagName, $0ca4f63b79e931bd$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $0ca4f63b79e931bd$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes.rel = null;
            attributes.href = null;
            attributes.crossorigin = null;
            attributes._cssText = $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        const cssText = $0ca4f63b79e931bd$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, $0ca4f63b79e931bd$var$getHref(doc));
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
        const el = n;
        const type = $0ca4f63b79e931bd$var$getInputType(el);
        const value = $0ca4f63b79e931bd$var$getInputValue(el, $0ca4f63b79e931bd$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            const forceMask = $0ca4f63b79e931bd$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $0ca4f63b79e931bd$var$shouldMaskInput({
                type: type,
                tagName: $0ca4f63b79e931bd$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $0ca4f63b79e931bd$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$0ca4f63b79e931bd$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$0ca4f63b79e931bd$var$canvasService) {
            $0ca4f63b79e931bd$var$canvasService = doc.createElement('canvas');
            $0ca4f63b79e931bd$var$canvasCtx = $0ca4f63b79e931bd$var$canvasService.getContext('2d');
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute('src') || '<unknown-src>';
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener('load', recordInlineImage);
            try {
                $0ca4f63b79e931bd$var$canvasService.width = image.naturalWidth;
                $0ca4f63b79e931bd$var$canvasService.height = image.naturalHeight;
                $0ca4f63b79e931bd$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $0ca4f63b79e931bd$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== 'anonymous') {
                    image.crossOrigin = 'anonymous';
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener('load', recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === 'anonymous') priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused ? 'paused' : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!needBlock && !$0ca4f63b79e931bd$var$getIframeContentDocument(n)) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $0ca4f63b79e931bd$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $0ca4f63b79e931bd$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $0ca4f63b79e931bd$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $0ca4f63b79e931bd$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $0ca4f63b79e931bd$var$NodeType$3.Comment) return true;
    else if (sn.type === $0ca4f63b79e931bd$var$NodeType$3.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && $0ca4f63b79e931bd$var$extractFileExtension(sn.attributes.href) === 'js')) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'application-name' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === 'icon' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'robots' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'author' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'generator' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'framework' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'publisher' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'progid' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'verification' || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $0ca4f63b79e931bd$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $0ca4f63b79e931bd$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($0ca4f63b79e931bd$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $0ca4f63b79e931bd$var$NodeType$3.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $0ca4f63b79e931bd$var$IGNORED_NODE;
    else id = $0ca4f63b79e931bd$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $0ca4f63b79e931bd$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $0ca4f63b79e931bd$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $0ca4f63b79e931bd$var$NodeType$3.Document || serializedNode.type === $0ca4f63b79e931bd$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $0ca4f63b79e931bd$var$NodeType$3.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $0ca4f63b79e931bd$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($0ca4f63b79e931bd$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $0ca4f63b79e931bd$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $0ca4f63b79e931bd$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $0ca4f63b79e931bd$var$isShadowRoot(n.parentNode) && $0ca4f63b79e931bd$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $0ca4f63b79e931bd$var$NodeType$3.Element && serializedNode.tagName === 'iframe') $0ca4f63b79e931bd$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = $0ca4f63b79e931bd$var$getIframeContentDocument(n);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $0ca4f63b79e931bd$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $0ca4f63b79e931bd$var$NodeType$3.Element && serializedNode.tagName === 'link' && typeof serializedNode.attributes.rel === 'string' && (serializedNode.attributes.rel === 'stylesheet' || serializedNode.attributes.rel === 'preload' && typeof serializedNode.attributes.href === 'string' && $0ca4f63b79e931bd$var$extractFileExtension(serializedNode.attributes.href) === 'css')) $0ca4f63b79e931bd$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $0ca4f63b79e931bd$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $0ca4f63b79e931bd$var$snapshot(n, options) {
    const { mirror: mirror = new $0ca4f63b79e931bd$var$Mirror(), blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $0ca4f63b79e931bd$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $0ca4f63b79e931bd$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $0ca4f63b79e931bd$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $0ca4f63b79e931bd$var$_mirror = {
    map: {},
    getId () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $0ca4f63b79e931bd$var$_mirror = new Proxy($0ca4f63b79e931bd$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $0ca4f63b79e931bd$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $0ca4f63b79e931bd$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $0ca4f63b79e931bd$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $0ca4f63b79e931bd$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $0ca4f63b79e931bd$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$0ca4f63b79e931bd$var$hookSetter(target, key, original || {}, true);
}
function $0ca4f63b79e931bd$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $0ca4f63b79e931bd$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $0ca4f63b79e931bd$var$nowTimestamp = ()=>new Date().getTime();
function $0ca4f63b79e931bd$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_)=>_.documentElement,
            'access',
            (_2)=>_2.scrollLeft
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_3)=>_3.body,
            'optionalAccess',
            (_4)=>_4.parentElement,
            'optionalAccess',
            (_5)=>_5.scrollLeft
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_6)=>_6.body,
            'optionalAccess',
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_8)=>_8.documentElement,
            'access',
            (_9)=>_9.scrollTop
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_10)=>_10.body,
            'optionalAccess',
            (_11)=>_11.parentElement,
            'optionalAccess',
            (_12)=>_12.scrollTop
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_13)=>_13.body,
            'optionalAccess',
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $0ca4f63b79e931bd$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $0ca4f63b79e931bd$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $0ca4f63b79e931bd$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $0ca4f63b79e931bd$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $0ca4f63b79e931bd$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $0ca4f63b79e931bd$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $0ca4f63b79e931bd$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $0ca4f63b79e931bd$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $0ca4f63b79e931bd$var$IGNORED_NODE;
}
function $0ca4f63b79e931bd$var$isAncestorRemoved(target, mirror) {
    if ($0ca4f63b79e931bd$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $0ca4f63b79e931bd$var$isAncestorRemoved(target.parentNode, mirror);
}
function $0ca4f63b79e931bd$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $0ca4f63b79e931bd$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $0ca4f63b79e931bd$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $0ca4f63b79e931bd$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $0ca4f63b79e931bd$var$hasShadowRoot(n) {
    return Boolean($0ca4f63b79e931bd$var$_optionalChain$4([
        n,
        'optionalAccess',
        (_18)=>_18.shadowRoot
    ]));
}
class $0ca4f63b79e931bd$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $37a3ef5fa939d363$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $0ca4f63b79e931bd$var$getShadowHost(n) {
    let shadowHost = null;
    if ($0ca4f63b79e931bd$var$_optionalChain$4([
        n,
        'access',
        (_19)=>_19.getRootNode,
        'optionalCall',
        (_20)=>_20(),
        'optionalAccess',
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $0ca4f63b79e931bd$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $0ca4f63b79e931bd$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $0ca4f63b79e931bd$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $0ca4f63b79e931bd$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $0ca4f63b79e931bd$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $0ca4f63b79e931bd$var$shadowHostInDom(n);
}
const $0ca4f63b79e931bd$var$cachedImplementations = {};
function $0ca4f63b79e931bd$var$getImplementation(name) {
    const cached = $0ca4f63b79e931bd$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $0ca4f63b79e931bd$var$cachedImplementations[name] = impl.bind(window);
}
function $0ca4f63b79e931bd$var$onRequestAnimationFrame(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation('requestAnimationFrame')(...rest);
}
function $0ca4f63b79e931bd$var$setTimeout$1(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation('setTimeout')(...rest);
}
function $0ca4f63b79e931bd$var$clearTimeout$1(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation('clearTimeout')(...rest);
}
var $0ca4f63b79e931bd$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($0ca4f63b79e931bd$var$EventType || {});
var $0ca4f63b79e931bd$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($0ca4f63b79e931bd$var$IncrementalSource || {});
var $0ca4f63b79e931bd$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($0ca4f63b79e931bd$var$MouseInteractions || {});
var $0ca4f63b79e931bd$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($0ca4f63b79e931bd$var$PointerTypes || {});
var $0ca4f63b79e931bd$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($0ca4f63b79e931bd$var$NodeType$1 || ($0ca4f63b79e931bd$var$NodeType$1 = {}));
var $0ca4f63b79e931bd$var$NodeType$2;
(function(NodeType) {
    NodeType[NodeType["PLACEHOLDER"] = 0] = "PLACEHOLDER";
    NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType[NodeType["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
    NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType[NodeType["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
    NodeType[NodeType["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
    NodeType[NodeType["ENTITY_NODE"] = 6] = "ENTITY_NODE";
    NodeType[NodeType["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
    NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
    NodeType[NodeType["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
    NodeType[NodeType["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
    NodeType[NodeType["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
})($0ca4f63b79e931bd$var$NodeType$2 || ($0ca4f63b79e931bd$var$NodeType$2 = {}));
function $0ca4f63b79e931bd$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e) {}
}
function $0ca4f63b79e931bd$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e) {}
}
function $0ca4f63b79e931bd$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $0ca4f63b79e931bd$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $0ca4f63b79e931bd$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = $0ca4f63b79e931bd$var$_optionalChain$3([
            current,
            'optionalAccess',
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $0ca4f63b79e931bd$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $0ca4f63b79e931bd$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $0ca4f63b79e931bd$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $0ca4f63b79e931bd$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $0ca4f63b79e931bd$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $0ca4f63b79e931bd$var$IGNORED_NODE;
                while(nextId === $0ca4f63b79e931bd$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$0ca4f63b79e931bd$var$inDom(n)) return;
                const parentId = $0ca4f63b79e931bd$var$isShadowRoot(n.parentNode) ? this.mirror.getId($0ca4f63b79e931bd$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $0ca4f63b79e931bd$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($0ca4f63b79e931bd$var$isSerializedIframe(currentN, this.mirror) && !$0ca4f63b79e931bd$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($0ca4f63b79e931bd$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($0ca4f63b79e931bd$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($0ca4f63b79e931bd$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) this.canvasManager.addWindow(iframe.contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($0ca4f63b79e931bd$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$0ca4f63b79e931bd$var$isAncestorInSet(this.droppedSet, n) && !$0ca4f63b79e931bd$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($0ca4f63b79e931bd$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($0ca4f63b79e931bd$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $0ca4f63b79e931bd$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $0ca4f63b79e931bd$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            const type = $0ca4f63b79e931bd$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $0ca4f63b79e931bd$var$getInputValue(target, tagName, type);
                            const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $0ca4f63b79e931bd$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $0ca4f63b79e931bd$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $0ca4f63b79e931bd$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$0ca4f63b79e931bd$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $0ca4f63b79e931bd$var$transformAttribute(this.doc, $0ca4f63b79e931bd$var$toLowerCase(target.tagName), $0ca4f63b79e931bd$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === 'style') {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $0ca4f63b79e931bd$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $0ca4f63b79e931bd$var$isIgnored(n, this.mirror) || !$0ca4f63b79e931bd$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $0ca4f63b79e931bd$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($0ca4f63b79e931bd$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$0ca4f63b79e931bd$var$moveKey(nodeId, parentId)]) $0ca4f63b79e931bd$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $0ca4f63b79e931bd$var$isShadowRoot(m.target) && $0ca4f63b79e931bd$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($0ca4f63b79e931bd$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$0ca4f63b79e931bd$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$0ca4f63b79e931bd$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($0ca4f63b79e931bd$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskAllText',
            'maskTextClass',
            'unmaskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskAttributeFn',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $0ca4f63b79e931bd$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$0ca4f63b79e931bd$var$deepDelete(addsSet, childN));
}
function $0ca4f63b79e931bd$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $0ca4f63b79e931bd$var$_isParentRemoved(removes, n, mirror);
}
function $0ca4f63b79e931bd$var$_isParentRemoved(removes, n, mirror) {
    let node = n.parentNode;
    while(node){
        const parentId = mirror.getId(node);
        if (removes.some((r)=>r.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $0ca4f63b79e931bd$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $0ca4f63b79e931bd$var$_isAncestorInSet(set, n);
}
function $0ca4f63b79e931bd$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $0ca4f63b79e931bd$var$_isAncestorInSet(set, parentNode);
}
let $0ca4f63b79e931bd$var$errorHandler;
function $0ca4f63b79e931bd$var$registerErrorHandler(handler) {
    $0ca4f63b79e931bd$var$errorHandler = handler;
}
function $0ca4f63b79e931bd$var$unregisterErrorHandler() {
    $0ca4f63b79e931bd$var$errorHandler = undefined;
}
const $0ca4f63b79e931bd$var$callbackWrapper = (cb)=>{
    if (!$0ca4f63b79e931bd$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($0ca4f63b79e931bd$var$errorHandler && $0ca4f63b79e931bd$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $0ca4f63b79e931bd$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $0ca4f63b79e931bd$var$mutationBuffers = [];
function $0ca4f63b79e931bd$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $0ca4f63b79e931bd$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $0ca4f63b79e931bd$var$MutationBuffer();
    $0ca4f63b79e931bd$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $0ca4f63b79e931bd$var$_optionalChain$2([
        window,
        'optionalAccess',
        (_)=>_.Zone,
        'optionalAccess',
        (_2)=>_2.__symbol__,
        'optionalCall',
        (_3)=>_3('MutationObserver')
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($0ca4f63b79e931bd$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $0ca4f63b79e931bd$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((evt)=>{
        const target = $0ca4f63b79e931bd$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $0ca4f63b79e931bd$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $0ca4f63b79e931bd$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $0ca4f63b79e931bd$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $0ca4f63b79e931bd$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $0ca4f63b79e931bd$var$IncrementalSource.MouseMove : $0ca4f63b79e931bd$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $0ca4f63b79e931bd$var$on('mousemove', updatePosition, doc),
        $0ca4f63b79e931bd$var$on('touchmove', updatePosition, doc),
        $0ca4f63b79e931bd$var$on('drag', updatePosition, doc)
    ];
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $0ca4f63b79e931bd$var$getEventTarget(event);
            if ($0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $0ca4f63b79e931bd$var$PointerTypes.Touch) {
                    if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $0ca4f63b79e931bd$var$PointerTypes.Pen;
            } else if ($0ca4f63b79e931bd$var$legacy_isTouchEvent(event)) pointerType = $0ca4f63b79e931bd$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $0ca4f63b79e931bd$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $0ca4f63b79e931bd$var$PointerTypes.Mouse) pointerType = null;
            } else if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $0ca4f63b79e931bd$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $0ca4f63b79e931bd$var$callbackWrapper(mouseInteractionCb)({
                type: $0ca4f63b79e931bd$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($0ca4f63b79e931bd$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $0ca4f63b79e931bd$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($0ca4f63b79e931bd$var$MouseInteractions[eventKey]){
            case $0ca4f63b79e931bd$var$MouseInteractions.MouseDown:
            case $0ca4f63b79e931bd$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $0ca4f63b79e931bd$var$MouseInteractions.TouchStart:
            case $0ca4f63b79e931bd$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($0ca4f63b79e931bd$var$on(eventName, handler, doc));
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((evt)=>{
        const target = $0ca4f63b79e931bd$var$getEventTarget(evt);
        if (!target || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $0ca4f63b79e931bd$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $0ca4f63b79e931bd$var$on('scroll', updatePosition, doc);
}
function $0ca4f63b79e931bd$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper(()=>{
        const height = $0ca4f63b79e931bd$var$getWindowHeight();
        const width = $0ca4f63b79e931bd$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $0ca4f63b79e931bd$var$on('resize', updateDimension, win);
}
const $0ca4f63b79e931bd$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $0ca4f63b79e931bd$var$lastInputValueMap = new WeakMap();
function $0ca4f63b79e931bd$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $0ca4f63b79e931bd$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $0ca4f63b79e931bd$var$toUpperCase(target.tagName);
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $0ca4f63b79e931bd$var$INPUT_TAGS.indexOf(tagName) < 0 || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $0ca4f63b79e931bd$var$getInputType(target);
        let text = $0ca4f63b79e931bd$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $0ca4f63b79e931bd$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        text = $0ca4f63b79e931bd$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $0ca4f63b79e931bd$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $0ca4f63b79e931bd$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $0ca4f63b79e931bd$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $0ca4f63b79e931bd$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $0ca4f63b79e931bd$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$0ca4f63b79e931bd$var$on(eventName, $0ca4f63b79e931bd$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$0ca4f63b79e931bd$var$hookSetter(p[0], p[1], {
            set () {
                $0ca4f63b79e931bd$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($0ca4f63b79e931bd$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $0ca4f63b79e931bd$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $0ca4f63b79e931bd$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $0ca4f63b79e931bd$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $0ca4f63b79e931bd$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $0ca4f63b79e931bd$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document' ? $0ca4f63b79e931bd$var$_optionalChain$2([
        host,
        'access',
        (_4)=>_4.defaultView,
        'optionalAccess',
        (_5)=>_5.Document
    ]) : $0ca4f63b79e931bd$var$_optionalChain$2([
        host,
        'access',
        (_6)=>_6.ownerDocument,
        'optionalAccess',
        (_7)=>_7.defaultView,
        'optionalAccess',
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $0ca4f63b79e931bd$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($0ca4f63b79e931bd$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_10)=>_10.prototype
    ]), 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $0ca4f63b79e931bd$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_11)=>_11.get,
                'optionalAccess',
                (_12)=>_12.call,
                'call',
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $0ca4f63b79e931bd$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_14)=>_14.set,
                'optionalAccess',
                (_15)=>_15.call,
                'call',
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $0ca4f63b79e931bd$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId($0ca4f63b79e931bd$var$_optionalChain$2([
                thisArg,
                'access',
                (_17)=>_17.parentRule,
                'optionalAccess',
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId($0ca4f63b79e931bd$var$_optionalChain$2([
                thisArg,
                'access',
                (_19)=>_19.parentRule,
                'optionalAccess',
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $0ca4f63b79e931bd$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $0ca4f63b79e931bd$var$callbackWrapper((type)=>$0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((event)=>{
            const target = $0ca4f63b79e931bd$var$getEventTarget(event);
            if (!target || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $0ca4f63b79e931bd$var$on('play', handler(0), doc),
        $0ca4f63b79e931bd$var$on('pause', handler(1), doc),
        $0ca4f63b79e931bd$var$on('seeked', handler(2), doc),
        $0ca4f63b79e931bd$var$on('volumechange', handler(3), doc),
        $0ca4f63b79e931bd$var$on('ratechange', handler(4), doc)
    ];
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $0ca4f63b79e931bd$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            $0ca4f63b79e931bd$var$setTimeout$1($0ca4f63b79e931bd$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $0ca4f63b79e931bd$var$_optionalChain$2([
            selection,
            'optionalAccess',
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $0ca4f63b79e931bd$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $0ca4f63b79e931bd$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $0ca4f63b79e931bd$var$on('selectionchange', updateSelection);
}
function $0ca4f63b79e931bd$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $0ca4f63b79e931bd$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $0ca4f63b79e931bd$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o.recordDOM) mutationObserver = $0ca4f63b79e931bd$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $0ca4f63b79e931bd$var$initMoveObserver(o);
    const mouseInteractionHandler = $0ca4f63b79e931bd$var$initMouseInteractionObserver(o);
    const scrollHandler = $0ca4f63b79e931bd$var$initScrollObserver(o);
    const viewportResizeHandler = $0ca4f63b79e931bd$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $0ca4f63b79e931bd$var$initInputObserver(o);
    const mediaInteractionHandler = $0ca4f63b79e931bd$var$initMediaInteractionObserver(o);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o.recordDOM) {
        styleSheetObserver = $0ca4f63b79e931bd$var$initStyleSheetObserver(o, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver(o, o.doc);
        styleDeclarationObserver = $0ca4f63b79e931bd$var$initStyleDeclarationObserver(o, {
            win: currentWindow
        });
        if (o.collectFonts) fontObserver = $0ca4f63b79e931bd$var$initFontObserver(o);
    }
    const selectionObserver = $0ca4f63b79e931bd$var$initSelectionObserver(o);
    const customElementObserver = $0ca4f63b79e931bd$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((b)=>b.reset());
        $0ca4f63b79e931bd$var$_optionalChain$2([
            mutationObserver,
            'optionalAccess',
            (_22)=>_22.disconnect,
            'call',
            (_23)=>_23()
        ]);
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $0ca4f63b79e931bd$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number') return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $0ca4f63b79e931bd$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $0ca4f63b79e931bd$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror($0ca4f63b79e931bd$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $0ca4f63b79e931bd$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror($0ca4f63b79e931bd$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $0ca4f63b79e931bd$var$_optionalChain$1([
            this,
            'access',
            (_)=>_.loadListener,
            'optionalCall',
            (_2)=>_2(iframeEl)
        ]);
        const iframeDoc = $0ca4f63b79e931bd$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $0ca4f63b79e931bd$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $0ca4f63b79e931bd$var$EventType.Meta:
            case $0ca4f63b79e931bd$var$EventType.Load:
            case $0ca4f63b79e931bd$var$EventType.DomContentLoaded:
                return false;
            case $0ca4f63b79e931bd$var$EventType.Plugin:
                return e;
            case $0ca4f63b79e931bd$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    'id',
                    'parentId',
                    'previousId',
                    'nextId'
                ]);
                return e;
            case $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $0ca4f63b79e931bd$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId'
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'id'
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Drag:
                    case $0ca4f63b79e931bd$var$IncrementalSource.TouchMove:
                    case $0ca4f63b79e931bd$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.ViewportResize:
                        return false;
                    case $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction:
                    case $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction:
                    case $0ca4f63b79e931bd$var$IncrementalSource.Scroll:
                    case $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation:
                    case $0ca4f63b79e931bd$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule:
                    case $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleId'
                        ]);
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Font:
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                'start',
                                'end'
                            ]);
                        });
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleIds'
                        ]);
                        $0ca4f63b79e931bd$var$_optionalChain$1([
                            e,
                            'access',
                            (_3)=>_3.data,
                            'access',
                            (_4)=>_4.styles,
                            'optionalAccess',
                            (_5)=>_5.forEach,
                            'call',
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        'styleId'
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            'id',
            'rootId'
        ]);
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $0ca4f63b79e931bd$var$NodeType$3.Document && !node.rootId) node.rootId = rootId;
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $0ca4f63b79e931bd$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $0ca4f63b79e931bd$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $0ca4f63b79e931bd$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($0ca4f63b79e931bd$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $0ca4f63b79e931bd$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        const iframeDoc = $0ca4f63b79e931bd$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $0ca4f63b79e931bd$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($0ca4f63b79e931bd$var$patch(element.prototype, 'attachShadow', function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $0ca4f63b79e931bd$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $0ca4f63b79e931bd$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
class $0ca4f63b79e931bd$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $0ca4f63b79e931bd$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $0ca4f63b79e931bd$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $0ca4f63b79e931bd$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $0ca4f63b79e931bd$var$onRequestAnimationFrame(()=>{
                this.nodeMap = new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    destroy() {}
}
let $0ca4f63b79e931bd$var$wrappedEmit;
let $0ca4f63b79e931bd$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement('iframe');
        document.body.appendChild(cleanFrame);
        Array.from = (0, $ed3fffa7fe0475db$export$3cc482e6b02f32f7)([
            cleanFrame,
            'access',
            (_)=>_.contentWindow,
            'optionalAccess',
            (_2)=>_2.Array,
            'access',
            (_3)=>_3.from
        ]) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug('Unable to override Array.from', err);
}
const $0ca4f63b79e931bd$var$mirror = $0ca4f63b79e931bd$var$createMirror();
function $0ca4f63b79e931bd$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load', userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $0ca4f63b79e931bd$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $0ca4f63b79e931bd$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $0ca4f63b79e931bd$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $0ca4f63b79e931bd$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $0ca4f63b79e931bd$var$nowTimestamp();
        if ((0, $ed3fffa7fe0475db$export$3cc482e6b02f32f7)([
            $0ca4f63b79e931bd$var$mutationBuffers,
            'access',
            (_4)=>_4[0],
            'optionalAccess',
            (_5)=>_5.isFrozen,
            'call',
            (_6)=>_6()
        ]) && e.type !== $0ca4f63b79e931bd$var$EventType.FullSnapshot && !(e.type === $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot && e.data.source === $0ca4f63b79e931bd$var$IncrementalSource.Mutation)) $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $ed3fffa7fe0475db$export$3cc482e6b02f32f7)([
            emit,
            'optionalCall',
            (_7)=>_7(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $0ca4f63b79e931bd$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $0ca4f63b79e931bd$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $0ca4f63b79e931bd$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new $0ca4f63b79e931bd$var$IframeManagerNoop() : new $0ca4f63b79e931bd$var$IframeManager({
        mirror: $0ca4f63b79e931bd$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $0ca4f63b79e931bd$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $0ca4f63b79e931bd$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $0ca4f63b79e931bd$var$ProcessedNodeManager();
    const canvasManager = $0ca4f63b79e931bd$var$_getCanvasManager(getCanvasManager, {
        mirror: $0ca4f63b79e931bd$var$mirror,
        win: window,
        mutationCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                data: {
                    source: $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $0ca4f63b79e931bd$var$ShadowDomManagerNoop() : new $0ca4f63b79e931bd$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $0ca4f63b79e931bd$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        if (!recordDOM) return;
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $0ca4f63b79e931bd$var$getWindowWidth(),
                height: $0ca4f63b79e931bd$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $0ca4f63b79e931bd$var$snapshot(document, {
            mirror: $0ca4f63b79e931bd$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($0ca4f63b79e931bd$var$isSerializedIframe(n, $0ca4f63b79e931bd$var$mirror)) iframeManager.addIframe(n);
                if ($0ca4f63b79e931bd$var$isSerializedStylesheet(n, $0ca4f63b79e931bd$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($0ca4f63b79e931bd$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $0ca4f63b79e931bd$var$getWindowScroll(window)
            }
        });
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $0ca4f63b79e931bd$var$mirror.getId(document));
    };
    $0ca4f63b79e931bd$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $0ca4f63b79e931bd$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $ed3fffa7fe0475db$export$3cc482e6b02f32f7)([
                    plugins,
                    'optionalAccess',
                    (_8)=>_8.filter,
                    'call',
                    (_9)=>_9((p)=>p.observer),
                    'optionalAccess',
                    (_10)=>_10.map,
                    'call',
                    (_11)=>_11((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$0ca4f63b79e931bd$var$wrappedEmit({
                                        type: $0ca4f63b79e931bd$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($0ca4f63b79e931bd$var$on('DOMContentLoaded', ()=>{
                $0ca4f63b79e931bd$var$wrappedEmit({
                    type: $0ca4f63b79e931bd$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($0ca4f63b79e931bd$var$on('load', ()=>{
                $0ca4f63b79e931bd$var$wrappedEmit({
                    type: $0ca4f63b79e931bd$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === 'load') init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $0ca4f63b79e931bd$var$_takeFullSnapshot = undefined;
            $0ca4f63b79e931bd$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $0ca4f63b79e931bd$var$takeFullSnapshot(isCheckout) {
    if (!$0ca4f63b79e931bd$var$_takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $0ca4f63b79e931bd$var$_takeFullSnapshot(isCheckout);
}
$0ca4f63b79e931bd$var$record.mirror = $0ca4f63b79e931bd$var$mirror;
$0ca4f63b79e931bd$var$record.takeFullSnapshot = $0ca4f63b79e931bd$var$takeFullSnapshot;
function $0ca4f63b79e931bd$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $0ca4f63b79e931bd$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new $0ca4f63b79e931bd$var$CanvasManagerNoop();
    }
}
const $0ca4f63b79e931bd$var$ReplayEventTypeIncrementalSnapshot = 3;
const $0ca4f63b79e931bd$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $0ca4f63b79e931bd$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $0ca4f63b79e931bd$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $0ca4f63b79e931bd$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $0ca4f63b79e931bd$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($0ca4f63b79e931bd$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $0ca4f63b79e931bd$var$getClickTargetNode(event) {
    const target = $0ca4f63b79e931bd$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $0ca4f63b79e931bd$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $0ca4f63b79e931bd$var$getTargetNode(event) {
    if ($0ca4f63b79e931bd$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $0ca4f63b79e931bd$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $0ca4f63b79e931bd$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $0ca4f63b79e931bd$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$0ca4f63b79e931bd$var$handlers) {
        $0ca4f63b79e931bd$var$handlers = [];
        $0ca4f63b79e931bd$var$monkeyPatchWindowOpen();
    }
    $0ca4f63b79e931bd$var$handlers.push(cb);
    return ()=>{
        const pos = $0ca4f63b79e931bd$var$handlers ? $0ca4f63b79e931bd$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $0ca4f63b79e931bd$var$handlers.splice(pos, 1);
    };
}
function $0ca4f63b79e931bd$var$monkeyPatchWindowOpen() {
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)($0ca4f63b79e931bd$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($0ca4f63b79e931bd$var$handlers) try {
                $0ca4f63b79e931bd$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($0ca4f63b79e931bd$var$WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ const $0ca4f63b79e931bd$var$IncrementalMutationSources = new Set([
    $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
    $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule,
    $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration,
    $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet,
    $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
    $0ca4f63b79e931bd$var$IncrementalSource.Selection,
    $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function $0ca4f63b79e931bd$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $0ca4f63b79e931bd$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $0ca4f63b79e931bd$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $0ca4f63b79e931bd$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $0ca4f63b79e931bd$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($0ca4f63b79e931bd$var$ignoreElement(node, this._ignoreSelector) || !$0ca4f63b79e931bd$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $0ca4f63b79e931bd$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $0ca4f63b79e931bd$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $0ca4f63b79e931bd$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $0ca4f63b79e931bd$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $0ca4f63b79e931bd$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $0ca4f63b79e931bd$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $0ca4f63b79e931bd$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1000);
    }
}
const $0ca4f63b79e931bd$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $0ca4f63b79e931bd$var$ignoreElement(node, ignoreSelector) {
    if (!$0ca4f63b79e931bd$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $0ca4f63b79e931bd$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $0ca4f63b79e931bd$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $0ca4f63b79e931bd$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$0ca4f63b79e931bd$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($0ca4f63b79e931bd$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $0ca4f63b79e931bd$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($0ca4f63b79e931bd$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $0ca4f63b79e931bd$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $0ca4f63b79e931bd$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $0ca4f63b79e931bd$var$isIncrementalEvent(event) {
    return event.type === $0ca4f63b79e931bd$var$ReplayEventTypeIncrementalSnapshot;
}
function $0ca4f63b79e931bd$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $0ca4f63b79e931bd$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($0ca4f63b79e931bd$var$NodeType || ($0ca4f63b79e931bd$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $0ca4f63b79e931bd$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $0ca4f63b79e931bd$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) attributes['data-sentry-component'] = attributes['data-sentry-element'];
    for(const key in attributes)if ($0ca4f63b79e931bd$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $0ca4f63b79e931bd$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0ca4f63b79e931bd$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $0ca4f63b79e931bd$var$handleClick(replay.clickDetector, result, $0ca4f63b79e931bd$var$getClickTargetNode(handlerData.event));
        $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $0ca4f63b79e931bd$var$record.mirror.getId(target);
    const node = nodeId && $0ca4f63b79e931bd$var$record.mirror.getNode(nodeId);
    const meta = node && $0ca4f63b79e931bd$var$record.mirror.getMeta(node);
    const element = meta && $0ca4f63b79e931bd$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $0ca4f63b79e931bd$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $0ca4f63b79e931bd$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $0ca4f63b79e931bd$var$handleDom(handlerData) {
    const { target: target, message: message } = $0ca4f63b79e931bd$var$getDomTarget(handlerData);
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message)
    });
}
function $0ca4f63b79e931bd$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $0ca4f63b79e931bd$var$getClickTargetNode(handlerData.event) : $0ca4f63b79e931bd$var$getTargetNode(handlerData.event);
        message = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $0ca4f63b79e931bd$var$isElement(node) {
    return node.type === $0ca4f63b79e931bd$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $0ca4f63b79e931bd$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $0ca4f63b79e931bd$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $0ca4f63b79e931bd$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $0ca4f63b79e931bd$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message);
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $0ca4f63b79e931bd$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $0ca4f63b79e931bd$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $0ca4f63b79e931bd$var$createResourceEntry,
    paint: $0ca4f63b79e931bd$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $0ca4f63b79e931bd$var$createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function $0ca4f63b79e931bd$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function $0ca4f63b79e931bd$var$createPerformanceEntries(entries) {
    return entries.map($0ca4f63b79e931bd$var$createPerformanceEntry).filter(Boolean);
}
function $0ca4f63b79e931bd$var$createPerformanceEntry(entry) {
    const entryType = $0ca4f63b79e931bd$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $0ca4f63b79e931bd$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $4f6ba265374890ec$export$baf075a948ffc0bf) || $0ca4f63b79e931bd$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $0ca4f63b79e931bd$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $0ca4f63b79e931bd$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $0ca4f63b79e931bd$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $0ca4f63b79e931bd$var$getAbsoluteTime(startTime),
        end: $0ca4f63b79e931bd$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $0ca4f63b79e931bd$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $0ca4f63b79e931bd$var$getAbsoluteTime(startTime),
        end: $0ca4f63b79e931bd$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function $0ca4f63b79e931bd$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.element ? [
        lastEntry.element
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'largest-contentful-paint', node);
}
function $0ca4f63b79e931bd$var$isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function $0ca4f63b79e931bd$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($0ca4f63b79e931bd$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $0ca4f63b79e931bd$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : undefined
        });
    }
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'cumulative-layout-shift', nodes, layoutShifts);
}
/**
 * Add a FID event to the replay based on a FID metric.
 */ function $0ca4f63b79e931bd$var$getFirstInputDelay(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'first-input-delay', node);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function $0ca4f63b79e931bd$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'interaction-to-next-paint', node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function $0ca4f63b79e931bd$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $0ca4f63b79e931bd$var$getAbsoluteTime(value);
    return {
        type: 'web-vital',
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$0ca4f63b79e931bd$var$record.mirror.getId(node)) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $0ca4f63b79e931bd$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $31f3d198369e5cbf$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $31f3d198369e5cbf$export$3fd4b53331200102)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getLargestContentfulPaint, replay)), (0, $31f3d198369e5cbf$export$861b82818b37ba5b)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getCumulativeLayoutShift, replay)), (0, $31f3d198369e5cbf$export$2707d7471c0b918f)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getFirstInputDelay, replay)), (0, $31f3d198369e5cbf$export$da3b76aa2022cbd7)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0ca4f63b79e931bd$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $0ca4f63b79e931bd$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=A(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},U=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=x(f,15),M=b.t,E=b.l,A=x(h,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=C[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(a[t]^a[t+1]<<A^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=U(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=U(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),a=0,s=function(t){i[a++]=t},o=0;o<e;++o){if(a+5>i.length){var f=new t(a+8+(e-o<<1));f.set(i),i=f}var h=n.charCodeAt(o);h<128||r?s(h):h<2048?(s(192|h>>6),s(128|63&h)):h>55295&&h<57344?(s(240|(h=65536+(1047552&h)|1023&n.charCodeAt(++o))>>18),s(128|h>>12&63),s(128|h>>6&63),s(128|63&h)):(s(224|h>>12),s(128|h>>6&63),s(128|63&h))}return b(i,0,a)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $0ca4f63b79e931bd$var$e() {
    const e = new Blob([
        $0ca4f63b79e931bd$var$r
    ]);
    return URL.createObjectURL(e);
}
const $0ca4f63b79e931bd$var$CONSOLE_LEVELS = [
    'info',
    'warn',
    'error',
    'log'
];
const $0ca4f63b79e931bd$var$PREFIX = '[Replay] ';
function $0ca4f63b79e931bd$var$_addBreadcrumb(message, level = 'info') {
    (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: level,
        message: `${$0ca4f63b79e931bd$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $0ca4f63b79e931bd$var$makeReplayLogger() {
    let _capture = false;
    let _trace = false;
    const _logger = {
        exception: ()=>undefined,
        infoTick: ()=>undefined,
        setConfig: (opts)=>{
            _capture = opts.captureExceptions;
            _trace = opts.traceInternals;
        }
    };
    if ($0ca4f63b79e931bd$var$DEBUG_BUILD) {
        $0ca4f63b79e931bd$var$CONSOLE_LEVELS.forEach((name)=>{
            _logger[name] = (...args)=>{
                (0, $c9674f9e04798056$export$af88d00dbe7f521)[name]($0ca4f63b79e931bd$var$PREFIX, ...args);
                if (_trace) $0ca4f63b79e931bd$var$_addBreadcrumb(args.join(''), (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(name));
            };
        });
        _logger.exception = (error, ...message)=>{
            if (message.length && _logger.error) _logger.error(...message);
            (0, $c9674f9e04798056$export$af88d00dbe7f521).error($0ca4f63b79e931bd$var$PREFIX, error);
            if (_capture) (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error);
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            $0ca4f63b79e931bd$var$_addBreadcrumb(error, 'error');
        };
        _logger.infoTick = (...args)=>{
            (0, $c9674f9e04798056$export$af88d00dbe7f521).info($0ca4f63b79e931bd$var$PREFIX, ...args);
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(()=>$0ca4f63b79e931bd$var$_addBreadcrumb(args[0]), 0);
        };
    } else $0ca4f63b79e931bd$var$CONSOLE_LEVELS.forEach((name)=>{
        _logger[name] = ()=>undefined;
    });
    return _logger;
}
const $0ca4f63b79e931bd$var$logger = $0ca4f63b79e931bd$var$makeReplayLogger();
/** This error indicates that the event buffer size exceeded the limit.. */ class $0ca4f63b79e931bd$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $0ca4f63b79e931bd$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $0ca4f63b79e931bd$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $0ca4f63b79e931bd$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error('Error in compression worker: ', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$EventBufferCompressionWorker {
    /** @inheritdoc */ /** @inheritdoc */ constructor(worker){
        this._worker = new $0ca4f63b79e931bd$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $0ca4f63b79e931bd$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $0ca4f63b79e931bd$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $0ca4f63b79e931bd$var$EventBufferArray();
        this._compression = new $0ca4f63b79e931bd$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
            // Can now clear fallback buffer as it's no longer necessary
            this._fallback.clear();
        } catch (error) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to add events when switching buffers.');
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $0ca4f63b79e931bd$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $0ca4f63b79e931bd$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Using simple buffer');
    return new $0ca4f63b79e931bd$var$EventBufferArray();
}
function $0ca4f63b79e931bd$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $0ca4f63b79e931bd$var$_getWorkerUrl();
        if (!workerUrl) return;
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $0ca4f63b79e931bd$var$EventBufferProxy(worker);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $0ca4f63b79e931bd$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $0ca4f63b79e931bd$var$e();
    return '';
}
/** If sessionStorage is available. */ function $0ca4f63b79e931bd$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $0ca4f63b79e931bd$var$WINDOW && !!$0ca4f63b79e931bd$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $0ca4f63b79e931bd$var$clearSession(replay) {
    $0ca4f63b79e931bd$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $0ca4f63b79e931bd$var$deleteSession() {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return;
    try {
        $0ca4f63b79e931bd$var$WINDOW.sessionStorage.removeItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $0ca4f63b79e931bd$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $0ca4f63b79e931bd$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $0ca4f63b79e931bd$var$saveSession(session) {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return;
    try {
        $0ca4f63b79e931bd$var$WINDOW.sessionStorage.setItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $0ca4f63b79e931bd$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $0ca4f63b79e931bd$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $0ca4f63b79e931bd$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $0ca4f63b79e931bd$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $0ca4f63b79e931bd$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $0ca4f63b79e931bd$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $0ca4f63b79e931bd$var$fetchSession() {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $0ca4f63b79e931bd$var$WINDOW.sessionStorage.getItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Loading existing session');
        return $0ca4f63b79e931bd$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $0ca4f63b79e931bd$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $0ca4f63b79e931bd$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $0ca4f63b79e931bd$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $0ca4f63b79e931bd$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $0ca4f63b79e931bd$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$0ca4f63b79e931bd$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $0ca4f63b79e931bd$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $0ca4f63b79e931bd$var$fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Creating new session');
        return $0ca4f63b79e931bd$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$0ca4f63b79e931bd$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Session in sessionStorage is expired, creating new one...');
    return $0ca4f63b79e931bd$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $0ca4f63b79e931bd$var$isCustomEvent(event) {
    return event.type === $0ca4f63b79e931bd$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $0ca4f63b79e931bd$var$addEventSync(replay, event, isCheckout) {
    if (!$0ca4f63b79e931bd$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $0ca4f63b79e931bd$var$addEvent(replay, event, isCheckout) {
    if (!$0ca4f63b79e931bd$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout);
}
async function $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === 'buffer';
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $0ca4f63b79e931bd$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const isExceeded = error && error instanceof $0ca4f63b79e931bd$var$EventBufferSizeExceededError;
        const reason = isExceeded ? 'addEventSizeExceeded' : 'addEvent';
        if (isExceeded && isBufferMode) {
            // Clear buffer and wait for next checkout
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/** Exported only for tests. */ function $0ca4f63b79e931bd$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $0ca4f63b79e931bd$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $0ca4f63b79e931bd$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $0ca4f63b79e931bd$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...');
        return null;
    }
    return event;
}
/** If the event is an error event */ function $0ca4f63b79e931bd$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $0ca4f63b79e931bd$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $0ca4f63b79e931bd$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $0ca4f63b79e931bd$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $0ca4f63b79e931bd$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isErrorEvent(event) && !$0ca4f63b79e931bd$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($0ca4f63b79e931bd$var$isTransactionEvent(event)) {
            $0ca4f63b79e931bd$var$handleTransactionEvent(replay, event);
            return;
        }
        $0ca4f63b79e931bd$var$handleErrorEvent(replay, event);
    };
}
function $0ca4f63b79e931bd$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $0ca4f63b79e931bd$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(async ()=>{
        try {
            // Capture current event buffer as new replay
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $0ca4f63b79e931bd$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isErrorEvent(event)) return;
        $0ca4f63b79e931bd$var$handleHydrationError(replay, event);
    };
}
function $0ca4f63b79e931bd$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
            category: 'replay.hydrate-error',
            data: {
                url: (0, $cccaafc2216668b2$export$1cfafeee2987818b)()
            }
        });
        $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $0ca4f63b79e931bd$var$handleBreadcrumbs(replay) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on('beforeAddBreadcrumb', (breadcrumb)=>$0ca4f63b79e931bd$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $0ca4f63b79e931bd$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $0ca4f63b79e931bd$var$normalizeBreadcrumb(breadcrumb);
    if (result) $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $0ca4f63b79e931bd$var$normalizeBreadcrumb(breadcrumb) {
    if (!$0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        'fetch',
        'xhr',
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        'sentry.event',
        'sentry.transaction'
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith('ui.')) return null;
    if (breadcrumb.category === 'console') return $0ca4f63b79e931bd$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $0ca4f63b79e931bd$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
function $0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $0ca4f63b79e931bd$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Reset the `replay_id` field on the DSC.
 */ function $0ca4f63b79e931bd$var$resetReplayIdOnDynamicSamplingContext() {
    // Reset DSC on the current scope, if there is one
    const dsc = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    // Clear it from frozen DSC on the active span
    const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(activeSpan);
        delete dsc.replay_id;
    }
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $0ca4f63b79e931bd$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $0ca4f63b79e931bd$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $0ca4f63b79e931bd$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $0ca4f63b79e931bd$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled or paused
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($0ca4f63b79e931bd$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$0ca4f63b79e931bd$var$isErrorEvent(event) && !$0ca4f63b79e931bd$var$isTransactionEvent(event) && !$0ca4f63b79e931bd$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // prevent exceeding replay durations by removing the expired replayId from the DSC
            $0ca4f63b79e931bd$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($0ca4f63b79e931bd$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $0ca4f63b79e931bd$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($0ca4f63b79e931bd$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.log('Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $0ca4f63b79e931bd$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $0ca4f63b79e931bd$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $0ca4f63b79e931bd$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $0ca4f63b79e931bd$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0ca4f63b79e931bd$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $0ca4f63b79e931bd$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($0ca4f63b79e931bd$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $e523a4dfa96cd99a$export$d92e61f5600202af)(url, (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $0ca4f63b79e931bd$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($0ca4f63b79e931bd$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $0ca4f63b79e931bd$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $0ca4f63b79e931bd$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $0ca4f63b79e931bd$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $0ca4f63b79e931bd$var$getBodyString(body) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $0ca4f63b79e931bd$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/** Merge a warning into an existing network request/response. */ function $0ca4f63b79e931bd$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $0ca4f63b79e931bd$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $0ca4f63b79e931bd$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $0ca4f63b79e931bd$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $0ca4f63b79e931bd$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $0ca4f63b79e931bd$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e2) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $0ca4f63b79e931bd$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $0ca4f63b79e931bd$var$urlMatches(url, urls) {
    const fullUrl = $0ca4f63b79e931bd$var$getFullUrl(url);
    return (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $0ca4f63b79e931bd$var$getFullUrl(url, baseURI = $0ca4f63b79e931bd$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($0ca4f63b79e931bd$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $0ca4f63b79e931bd$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $0ca4f63b79e931bd$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $0ca4f63b79e931bd$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to capture fetch breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $0ca4f63b79e931bd$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? $0ca4f63b79e931bd$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $0ca4f63b79e931bd$var$getBodySize(body);
    const resSize = response ? $0ca4f63b79e931bd$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $0ca4f63b79e931bd$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailAllowUrls) && !$0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $0ca4f63b79e931bd$var$_getRequestInfo(options, hint.input, requestBodySize) : $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $0ca4f63b79e931bd$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $0ca4f63b79e931bd$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $0ca4f63b79e931bd$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $0ca4f63b79e931bd$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $0ca4f63b79e931bd$var$getBodyString(requestBody);
    const data = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $0ca4f63b79e931bd$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $0ca4f63b79e931bd$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $0ca4f63b79e931bd$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $0ca4f63b79e931bd$var$_parseFetchResponseBody(response);
    const result = $0ca4f63b79e931bd$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $0ca4f63b79e931bd$var$mergeWarning(result, warning);
    return result;
}
function $0ca4f63b79e931bd$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $0ca4f63b79e931bd$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to serialize response body');
        // fallback
        return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $0ca4f63b79e931bd$var$_parseFetchResponseBody(response) {
    const res = $0ca4f63b79e931bd$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $0ca4f63b79e931bd$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf('Timeout') > -1) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn('Parsing text body from response timed out');
            return [
                undefined,
                'BODY_PARSE_TIMEOUT'
            ];
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to get text body from response');
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $0ca4f63b79e931bd$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $0ca4f63b79e931bd$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $0ca4f63b79e931bd$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $0ca4f63b79e931bd$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $0ca4f63b79e931bd$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $0ca4f63b79e931bd$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $0ca4f63b79e931bd$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $0ca4f63b79e931bd$var$getAllowedHeaders(headers, allowedHeaders);
}
function $0ca4f63b79e931bd$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to clone response body');
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $0ca4f63b79e931bd$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $0ca4f63b79e931bd$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $0ca4f63b79e931bd$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $0ca4f63b79e931bd$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $0ca4f63b79e931bd$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $0ca4f63b79e931bd$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to capture xhr breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $0ca4f63b79e931bd$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $0ca4f63b79e931bd$var$getBodySize(input);
    const resSize = xhr.getResponseHeader('content-length') ? $0ca4f63b79e931bd$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $0ca4f63b79e931bd$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $0ca4f63b79e931bd$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailAllowUrls) || $0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $0ca4f63b79e931bd$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $0ca4f63b79e931bd$var$getAllowedHeaders($0ca4f63b79e931bd$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $0ca4f63b79e931bd$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $0ca4f63b79e931bd$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $0ca4f63b79e931bd$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $0ca4f63b79e931bd$var$mergeWarning(response, responseWarning) : response
    };
}
function $0ca4f63b79e931bd$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $0ca4f63b79e931bd$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $0ca4f63b79e931bd$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn('Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $0ca4f63b79e931bd$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $0ca4f63b79e931bd$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $0ca4f63b79e931bd$var$getBodySize(bodyStr);
    } catch (e2) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $0ca4f63b79e931bd$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$0ca4f63b79e931bd$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $0ca4f63b79e931bd$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($0ca4f63b79e931bd$var$_isXhrBreadcrumb(breadcrumb) && $0ca4f63b79e931bd$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $0ca4f63b79e931bd$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $0ca4f63b79e931bd$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($0ca4f63b79e931bd$var$_isFetchBreadcrumb(breadcrumb) && $0ca4f63b79e931bd$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $0ca4f63b79e931bd$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $0ca4f63b79e931bd$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(e, 'Error when enriching network breadcrumb');
    }
}
function $0ca4f63b79e931bd$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $0ca4f63b79e931bd$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $0ca4f63b79e931bd$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $0ca4f63b79e931bd$var$_isFetchHint(hint) {
    return hint && hint.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $0ca4f63b79e931bd$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($0ca4f63b79e931bd$var$handleDomListener(replay));
    (0, $3d87653da885c31c$export$3f18c56c58114e75)($0ca4f63b79e931bd$var$handleHistorySpanListener(replay));
    $0ca4f63b79e931bd$var$handleBreadcrumbs(replay);
    $0ca4f63b79e931bd$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $0ca4f63b79e931bd$var$handleGlobalEventListener(replay);
    (0, $f2b90654edf2c0a1$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on('beforeSendEvent', $0ca4f63b79e931bd$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $0ca4f63b79e931bd$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('spanStart', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on('spanEnd', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to flush replay
        client.on('beforeSendFeedback', (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $0ca4f63b79e931bd$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $0ca4f63b79e931bd$var$createMemoryEntry($0ca4f63b79e931bd$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $0ca4f63b79e931bd$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $0ca4f63b79e931bd$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
const $0ca4f63b79e931bd$var$NAVIGATOR = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).navigator;
/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */ function $0ca4f63b79e931bd$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($0ca4f63b79e931bd$var$NAVIGATOR && $0ca4f63b79e931bd$var$NAVIGATOR.userAgent || '') || /Macintosh/i.test($0ca4f63b79e931bd$var$NAVIGATOR && $0ca4f63b79e931bd$var$NAVIGATOR.userAgent || '') && $0ca4f63b79e931bd$var$NAVIGATOR && $0ca4f63b79e931bd$var$NAVIGATOR.maxTouchPoints && $0ca4f63b79e931bd$var$NAVIGATOR.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $0ca4f63b79e931bd$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn('Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $0ca4f63b79e931bd$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$0ca4f63b79e931bd$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            const session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $0ca4f63b79e931bd$var$addSettingsEvent(replay, isCheckout);
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $0ca4f63b79e931bd$var$saveSession(session);
                }
            }
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session && session.previousSessionId) return true;
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $0ca4f63b79e931bd$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $0ca4f63b79e931bd$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $0ca4f63b79e931bd$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $0ca4f63b79e931bd$var$addEventSync(replay, $0ca4f63b79e931bd$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $0ca4f63b79e931bd$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)((0, $f5682b06913d5b03$export$92b6093782fe661b)(replayEvent, (0, $f5682b06913d5b03$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $0ca4f63b79e931bd$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $0ca4f63b79e931bd$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $baba650ac852ba0c$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $f106fce27ec076f7$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $0ca4f63b79e931bd$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $0ca4f63b79e931bd$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
    const baseEvent = {
        type: $0ca4f63b79e931bd$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $0ca4f63b79e931bd$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('An event processor returned `null`, will not send event.');
        return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $0ca4f63b79e931bd$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $0ca4f63b79e931bd$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $5325f8e04d3d0467$export$699aff705e0d49d4)({}, response);
    if ((0, $5325f8e04d3d0467$export$6c91fec22056810a)(rateLimits, 'replay')) throw new $0ca4f63b79e931bd$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $0ca4f63b79e931bd$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $0ca4f63b79e931bd$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $0ca4f63b79e931bd$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $0ca4f63b79e931bd$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $0ca4f63b79e931bd$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $0ca4f63b79e931bd$var$TransportStatusCodeError || err instanceof $0ca4f63b79e931bd$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)('Replays', {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $0ca4f63b79e931bd$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $0ca4f63b79e931bd$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $0ca4f63b79e931bd$var$THROTTLED = '__THROTTLED';
const $0ca4f63b79e931bd$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ca4f63b79e931bd$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $0ca4f63b79e931bd$var$SKIPPED : $0ca4f63b79e931bd$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $0ca4f63b79e931bd$var$ReplayContainer {
    /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init2.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init3.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init4.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init5.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $0ca4f63b79e931bd$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $0ca4f63b79e931bd$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $0ca4f63b79e931bd$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $0ca4f63b79e931bd$var$throttle((event, isCheckout)=>$0ca4f63b79e931bd$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($0ca4f63b79e931bd$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $0ca4f63b79e931bd$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $0ca4f63b79e931bd$var$ClickDetector(this, slowClickConfig);
        // Configure replay logger w/ experimental options
        if ($0ca4f63b79e931bd$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $0ca4f63b79e931bd$var$logger.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Recording is already in progress');
            return;
        }
        if (this._isEnabled && this.recordingMode === 'buffer') {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Starting replay in session mode');
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Starting replay in buffer mode');
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $0ca4f63b79e931bd$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' ? {
                    checkoutEveryNms: $0ca4f63b79e931bd$var$BUFFER_CHECKOUT_TIME
                } : // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                },
                emit: $0ca4f63b79e931bd$var$getHandleRecordingEmit(this),
                ...$0ca4f63b79e931bd$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Stopping Replay${reason ? ` triggered by ${reason}` : ''}`);
            $0ca4f63b79e931bd$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $0ca4f63b79e931bd$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Pausing replay');
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Resuming replay');
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Converting buffer to session');
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $0ca4f63b79e931bd$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$0ca4f63b79e931bd$var$WINDOW.location.pathname}${$0ca4f63b79e931bd$var$WINDOW.location.hash}${$0ca4f63b79e931bd$var$WINDOW.location.search}`;
        const url = `${$0ca4f63b79e931bd$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $0ca4f63b79e931bd$var$THROTTLED) {
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$0ca4f63b79e931bd$var$addEventSync(this, {
                    type: $0ca4f63b79e931bd$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $36b15c0d755e29f6$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $36b15c0d755e29f6$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $0ca4f63b79e931bd$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($0ca4f63b79e931bd$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $0ca4f63b79e931bd$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $0ca4f63b79e931bd$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $0ca4f63b79e931bd$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $0ca4f63b79e931bd$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($0ca4f63b79e931bd$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $0ca4f63b79e931bd$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $0ca4f63b79e931bd$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $0ca4f63b79e931bd$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $0ca4f63b79e931bd$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // If we are manually starting, we want to ensure we only include performance entries
        // that are after the initial timestamp
        // The reason for this is that we may have performance entries from the page load, but may decide to start
        // the replay later on, in which case we do not want to include these entries.
        // without this, manually started replays can have events long before the actual replay recording starts,
        // which messes with the timeline etc.
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1000;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($0ca4f63b79e931bd$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        // If replay was started manually (=no sample rate was given),
        // We do not want to back-port the initial timestamp
        if (!session || !eventBuffer || this._requiresManualStart) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error('No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $0ca4f63b79e931bd$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accommodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $0ca4f63b79e931bd$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
            if (client) {
                const dropReason = err instanceof $0ca4f63b79e931bd$var$RateLimitError ? 'ratelimit_backoff' : 'send_error';
                client.recordDroppedEvent(dropReason, 'replay');
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error('Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Flushing initial segment without checkout.');
            const _flushInProgress = !!this._flushLock;
            // this._flushLock acts as a lock so that future calls to `_flush()` will
            // be blocked until current flush is finished (i.e. this promise resolves)
            if (!this._flushLock) this._flushLock = this._runFlush();
            try {
                await this._flushLock;
            } catch (err) {
                this.handleException(err);
            } finally{
                this._flushLock = undefined;
                if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
                // `_flush()`. It's possible there are other flush requests queued and
                // waiting for it to resolve. We want to reduce all outstanding
                // requests (as well as any new flush requests that occur within a
                // second of the locked flush completing) into a single flush.
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $0ca4f63b79e931bd$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: 'mutationLimit',
                    forceFlush: this.recordingMode === 'session'
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $0ca4f63b79e931bd$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $0ca4f63b79e931bd$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base',
        'iframe[srcdoc]:not([src])'
    ];
    const maskSelector = $0ca4f63b79e931bd$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ]);
    const unmaskSelector = $0ca4f63b79e931bd$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $0ca4f63b79e931bd$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ]),
        unblockSelector: $0ca4f63b79e931bd$var$getOption(unblock, []),
        ignoreSelector: $0ca4f63b79e931bd$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $0ca4f63b79e931bd$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precedence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $0ca4f63b79e931bd$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $0ca4f63b79e931bd$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $0ca4f63b79e931bd$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $0ca4f63b79e931bd$export$d7706faf7ab354bf = (options)=>{
    return new $0ca4f63b79e931bd$var$Replay(options);
};
/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */ class $0ca4f63b79e931bd$var$Replay {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError } = {}){
        this.name = $0ca4f63b79e931bd$var$Replay.id;
        const privacyOptions = $0ca4f63b79e931bd$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$0ca4f63b79e931bd$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $0ca4f63b79e931bd$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$0ca4f63b79e931bd$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $856a9239af1edf90$export$4e09c449d6c407f7)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $0ca4f63b79e931bd$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $0ca4f63b79e931bd$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $856a9239af1edf90$export$4e09c449d6c407f7)() || this._replay) return;
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        // assuming a session should be recorded in this case
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.recordingMode;
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $0ca4f63b79e931bd$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $0ca4f63b79e931bd$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$0ca4f63b79e931bd$var$Replay.__initStatic();
/** Parse Replay-related options from SDK options */ function $0ca4f63b79e931bd$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $f4dd084fe83374eb$export$d25f2688db1bb433)(initialOptions)
    };
    const replaysSessionSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$0ca4f63b79e931bd$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $0ca4f63b79e931bd$export$b28310b2f161456b() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName('Replay');
}



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;




var $acw62 = parcelRequire("acw62");
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("acw62");
const $291e7508d6267a86$var$Container = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        children: children
    });
};
var $291e7508d6267a86$export$2e2bcd8739ae039 = $291e7508d6267a86$var$Container;



parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
var $caba883bf952ef31$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $caba883bf952ef31$export$2e2bcd8739ae039 = $caba883bf952ef31$var$IconContext;



var $3Ysvw = parcelRequire("3Ysvw");

var $acw62 = parcelRequire("acw62");

var $6vgkH = parcelRequire("6vgkH");

var $acw62 = parcelRequire("acw62");
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$efabd6732f69a6da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");
/* eslint-disable no-template-curly-in-string */ var $864f21d08855a737$export$2e2bcd8739ae039 = {
    // Options.jsx
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination.jsx
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};



var $8nd05 = parcelRequire("8nd05");
var $0309ef2dc8eb0939$var$locale = {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    yearFormat: 'YYYY',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
};
var $0309ef2dc8eb0939$export$2e2bcd8739ae039 = $0309ef2dc8eb0939$var$locale;


var $594a5cf7899ad7e1$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $594a5cf7899ad7e1$export$2e2bcd8739ae039 = $594a5cf7899ad7e1$var$locale;


// Merge into a locale object
var $74a89c57a3cfafd2$var$locale = {
    lang: (0, $8nd05.default)({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, (0, $0309ef2dc8eb0939$export$2e2bcd8739ae039)),
    timePickerLocale: (0, $8nd05.default)({}, (0, $594a5cf7899ad7e1$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$74a89c57a3cfafd2$export$2e2bcd8739ae039 = $74a89c57a3cfafd2$var$locale;


var $32ded69f6ae6c615$export$2e2bcd8739ae039 = (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039);




var $8cffcf0f0d1231b6$var$typeTemplate = '${label} is not a valid ${type}';
var $8cffcf0f0d1231b6$var$localeValues = {
    locale: 'en',
    Pagination: (0, $864f21d08855a737$export$2e2bcd8739ae039),
    DatePicker: (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039),
    TimePicker: (0, $594a5cf7899ad7e1$export$2e2bcd8739ae039),
    Calendar: (0, $32ded69f6ae6c615$export$2e2bcd8739ae039),
    global: {
        placeholder: 'Please select'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckall: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand'
    },
    PageHeader: {
        back: 'Back'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            "default": 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            "enum": '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $8cffcf0f0d1231b6$var$typeTemplate,
                method: $8cffcf0f0d1231b6$var$typeTemplate,
                array: $8cffcf0f0d1231b6$var$typeTemplate,
                object: $8cffcf0f0d1231b6$var$typeTemplate,
                number: $8cffcf0f0d1231b6$var$typeTemplate,
                date: $8cffcf0f0d1231b6$var$typeTemplate,
                "boolean": $8cffcf0f0d1231b6$var$typeTemplate,
                integer: $8cffcf0f0d1231b6$var$typeTemplate,
                "float": $8cffcf0f0d1231b6$var$typeTemplate,
                regexp: $8cffcf0f0d1231b6$var$typeTemplate,
                email: $8cffcf0f0d1231b6$var$typeTemplate,
                url: $8cffcf0f0d1231b6$var$typeTemplate,
                hex: $8cffcf0f0d1231b6$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    }
};
var $8cffcf0f0d1231b6$export$2e2bcd8739ae039 = $8cffcf0f0d1231b6$var$localeValues;


var $466e4bebfd7443ca$var$runtimeLocale = (0, $8nd05.default)({}, (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Modal);
function $466e4bebfd7443ca$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) $466e4bebfd7443ca$var$runtimeLocale = (0, $8nd05.default)((0, $8nd05.default)({}, $466e4bebfd7443ca$var$runtimeLocale), newLocale);
    else $466e4bebfd7443ca$var$runtimeLocale = (0, $8nd05.default)({}, (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Modal);
}
function $466e4bebfd7443ca$export$1b6004afda18cd51() {
    return $466e4bebfd7443ca$var$runtimeLocale;
}



var $acw62 = parcelRequire("acw62");
var $f6e1632e0da0417b$var$LocaleContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $f6e1632e0da0417b$export$2e2bcd8739ae039 = $f6e1632e0da0417b$var$LocaleContext;


var $fab4cbd3d1c845d7$export$b2f162cd5c15ea3e = 'internalMark';
var $fab4cbd3d1c845d7$var$LocaleProvider = function LocaleProvider(props) {
    var _props$locale = props.locale, locale = _props$locale === void 0 ? {} : _props$locale, children = props.children, _ANT_MARK__ = props._ANT_MARK__;
    $acw62.useEffect(function() {
        (0, $466e4bebfd7443ca$export$9485ecb9d81a550c)(locale && locale.Modal);
        return function() {
            (0, $466e4bebfd7443ca$export$9485ecb9d81a550c)();
        };
    }, [
        locale
    ]);
    var getMemoizedContextValue = $acw62.useMemo(function() {
        return (0, $8nd05.default)((0, $8nd05.default)({}, locale), {
            exist: true
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $f6e1632e0da0417b$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $fab4cbd3d1c845d7$export$2e2bcd8739ae039 = $fab4cbd3d1c845d7$var$LocaleProvider;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $55cb264146668d16$export$2e2bcd8739ae039 = (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039);


var $715b7b8518c4616e$var$LocaleReceiver = function LocaleReceiver(props) {
    var _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? 'global' : _props$componentName, defaultLocale = props.defaultLocale, children = props.children;
    var antLocale = $acw62.useContext((0, $f6e1632e0da0417b$export$2e2bcd8739ae039));
    var getLocale = $acw62.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $55cb264146668d16$export$2e2bcd8739ae039)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $8nd05.default)((0, $8nd05.default)({}, locale instanceof Function ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    var getLocaleCode = $acw62.useMemo(function() {
        var localeCode = antLocale && antLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (antLocale && antLocale.exist && !localeCode) return (0, $55cb264146668d16$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        antLocale
    ]);
    return children(getLocale, getLocaleCode, antLocale);
};
var $715b7b8518c4616e$export$2e2bcd8739ae039 = $715b7b8518c4616e$var$LocaleReceiver;
var $715b7b8518c4616e$export$52f95bab0279a481 = function useLocaleReceiver(componentName, defaultLocale) {
    var antLocale = $acw62.useContext((0, $f6e1632e0da0417b$export$2e2bcd8739ae039));
    var getLocale = $acw62.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $55cb264146668d16$export$2e2bcd8739ae039)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $8nd05.default)((0, $8nd05.default)({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    return [
        getLocale
    ];
};




var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8e7f784a29e9449d$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $8e7f784a29e9449d$export$2e2bcd8739ae039 = $8e7f784a29e9449d$var$CheckCircleFilled;



var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $kSlfw = parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


var $9X7IJ = parcelRequire("9X7IJ");

var $d49SP = parcelRequire("d49SP");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $dnPM8 = parcelRequire("dnPM8");

var $acw62 = parcelRequire("acw62");

var $u43uR = parcelRequire("u43uR");

var $4ZrBP = parcelRequire("4ZrBP");


var $ikqdL = parcelRequire("ikqdL");
function $7d443cfc098836dd$export$491112666e282270(valid, message) {
    (0, $u43uR.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $7d443cfc098836dd$export$ab652842c37578f4(target) {
    return (0, $fSwVM.default)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $fSwVM.default)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $7d443cfc098836dd$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[(0, (/*@__PURE__*/$parcel$interopDefault($ikqdL)))(key)] = val;
        }
        return acc;
    }, {});
}
function $7d443cfc098836dd$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $d49SP.default)({
        key: key
    }, $7d443cfc098836dd$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $7d443cfc098836dd$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $d49SP.default)((0, $d49SP.default)({
        key: key
    }, $7d443cfc098836dd$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $7d443cfc098836dd$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $7d443cfc098836dd$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $dnPM8.generate)(primaryColor)[0];
}
function $7d443cfc098836dd$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $7d443cfc098836dd$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $7d443cfc098836dd$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  alignItems: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $7d443cfc098836dd$export$938b1f86b61613d0 = function useInsertStyles() {
    var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $7d443cfc098836dd$export$2c99b98b77550cb4;
    var _useContext = (0, $acw62.useContext)((0, $caba883bf952ef31$export$2e2bcd8739ae039)), csp = _useContext.csp;
    (0, $acw62.useEffect)(function() {
        (0, $4ZrBP.updateCSS)(styleStr, '@ant-design-icons', {
            prepend: true,
            csp: csp
        });
    }, []);
};


var $e640271b2c8bb064$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $e640271b2c8bb064$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $e640271b2c8bb064$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $e640271b2c8bb064$var$twoToneColorPalette.primaryColor = primaryColor;
    $e640271b2c8bb064$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $7d443cfc098836dd$export$b71c93f469694483)(primaryColor);
    $e640271b2c8bb064$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $e640271b2c8bb064$var$getTwoToneColors() {
    return (0, $d49SP.default)({}, $e640271b2c8bb064$var$twoToneColorPalette);
}
var $e640271b2c8bb064$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $9X7IJ.default)(props, $e640271b2c8bb064$var$_excluded);
    var colors = $e640271b2c8bb064$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $7d443cfc098836dd$export$b71c93f469694483)(primaryColor)
    };
    (0, $7d443cfc098836dd$export$938b1f86b61613d0)();
    (0, $7d443cfc098836dd$export$491112666e282270)((0, $7d443cfc098836dd$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $7d443cfc098836dd$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $d49SP.default)((0, $d49SP.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $7d443cfc098836dd$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $d49SP.default)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps));
};
$e640271b2c8bb064$var$IconBase.displayName = 'IconReact';
$e640271b2c8bb064$var$IconBase.getTwoToneColors = $e640271b2c8bb064$var$getTwoToneColors;
$e640271b2c8bb064$var$IconBase.setTwoToneColors = $e640271b2c8bb064$var$setTwoToneColors;
var $e640271b2c8bb064$export$2e2bcd8739ae039 = $e640271b2c8bb064$var$IconBase;



var $eUqlC = parcelRequire("eUqlC");


function $1d73efd6c7b1321b$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $7d443cfc098836dd$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $eUqlC.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $e640271b2c8bb064$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $1d73efd6c7b1321b$export$abc7c554784cb4a7() {
    var colors = (0, $e640271b2c8bb064$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



var $b3ba9aff878b58fb$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $1d73efd6c7b1321b$export$8a145f34580ff02b)('#1890ff');
var $b3ba9aff878b58fb$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $9X7IJ.default)(props, $b3ba9aff878b58fb$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $caba883bf952ef31$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rootClassName, prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $7d443cfc098836dd$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $eUqlC.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $acw62.createElement("span", (0, $d49SP.default)((0, $d49SP.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps), {}, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $acw62.createElement((0, $e640271b2c8bb064$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$b3ba9aff878b58fb$var$Icon.displayName = 'AntdIcon';
$b3ba9aff878b58fb$var$Icon.getTwoToneColor = (0, $1d73efd6c7b1321b$export$abc7c554784cb4a7);
$b3ba9aff878b58fb$var$Icon.setTwoToneColor = (0, $1d73efd6c7b1321b$export$8a145f34580ff02b);
var $b3ba9aff878b58fb$export$2e2bcd8739ae039 = $b3ba9aff878b58fb$var$Icon;


var $8a880f6c24a0b77c$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8e7f784a29e9449d$export$2e2bcd8739ae039)
    }));
};
var $8a880f6c24a0b77c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($8a880f6c24a0b77c$var$CheckCircleFilled);
var $8a880f6c24a0b77c$export$2e2bcd8739ae039 = $8a880f6c24a0b77c$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0c349e8b6d22460f$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $0c349e8b6d22460f$export$2e2bcd8739ae039 = $0c349e8b6d22460f$var$CloseCircleFilled;



var $2bf1c25862f513c2$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0c349e8b6d22460f$export$2e2bcd8739ae039)
    }));
};
var $2bf1c25862f513c2$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2bf1c25862f513c2$var$CloseCircleFilled);
var $2bf1c25862f513c2$export$2e2bcd8739ae039 = $2bf1c25862f513c2$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ce0f95a23ea8b20d$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $ce0f95a23ea8b20d$export$2e2bcd8739ae039 = $ce0f95a23ea8b20d$var$ExclamationCircleFilled;



var $c94f46c32abf10c6$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $ce0f95a23ea8b20d$export$2e2bcd8739ae039)
    }));
};
var $c94f46c32abf10c6$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($c94f46c32abf10c6$var$ExclamationCircleFilled);
var $c94f46c32abf10c6$export$2e2bcd8739ae039 = $c94f46c32abf10c6$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $57a9c466662aed09$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $57a9c466662aed09$export$2e2bcd8739ae039 = $57a9c466662aed09$var$InfoCircleFilled;



var $2169dccbc27bcb86$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $57a9c466662aed09$export$2e2bcd8739ae039)
    }));
};
var $2169dccbc27bcb86$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2169dccbc27bcb86$var$InfoCircleFilled);
var $2169dccbc27bcb86$export$2e2bcd8739ae039 = $2169dccbc27bcb86$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2b0f3084756e08d0$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $2b0f3084756e08d0$export$2e2bcd8739ae039 = $2b0f3084756e08d0$var$LoadingOutlined;



var $43383ed7d2a91124$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2b0f3084756e08d0$export$2e2bcd8739ae039)
    }));
};
var $43383ed7d2a91124$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($43383ed7d2a91124$var$LoadingOutlined);
var $43383ed7d2a91124$export$2e2bcd8739ae039 = $43383ed7d2a91124$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $3DXWh = parcelRequire("3DXWh");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $fytPh = parcelRequire("fytPh");

var $acw62 = parcelRequire("acw62");


function $c44e7f7175cd2535$export$2e2bcd8739ae039(getRcNotificationInstance, getRCNoticeProps) {
    var useMessage = function useMessage() {
        // We can only get content by render
        var getPrefixCls;
        var getPopupContainer;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $fytPh.default)(proxy), _useRCNotification2 = (0, $eUqlC.default)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls('message', customizePrefixCls);
            var rootPrefixCls = getPrefixCls();
            var target = args.key || (0, $dc31f36873c2f472$export$ab227b2024307500)();
            var closePromise = new Promise(function(resolve) {
                var callback = function callback() {
                    if (typeof args.onClose === 'function') args.onClose();
                    return resolve(true);
                };
                getRcNotificationInstance((0, $8nd05.default)((0, $8nd05.default)({}, args), {
                    prefixCls: mergedPrefixCls,
                    rootPrefixCls: rootPrefixCls,
                    getPopupContainer: getPopupContainer
                }), function(_ref) {
                    var prefixCls = _ref.prefixCls, instance = _ref.instance;
                    innerInstance = instance;
                    hookNotify(getRCNoticeProps((0, $8nd05.default)((0, $8nd05.default)({}, args), {
                        key: target,
                        onClose: callback
                    }), prefixCls));
                });
            });
            var result = function result() {
                if (innerInstance) innerInstance.removeNotice(target);
            };
            result.then = function(filled, rejected) {
                return closePromise.then(filled, rejected);
            };
            result.promise = closePromise;
            return result;
        }
        // Fill functions
        var hookApiRef = $acw62.useRef({});
        hookApiRef.current.open = notify;
        (0, $dc31f36873c2f472$export$37928ca2918d853b).forEach(function(type) {
            return (0, $dc31f36873c2f472$export$63b017493c112c94)(hookApiRef.current, type);
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                getPopupContainer = context.getPopupContainer;
                return holder;
            })
        ];
    };
    return useMessage;
}


var $dc31f36873c2f472$var$messageInstance;
var $dc31f36873c2f472$var$defaultDuration = 3;
var $dc31f36873c2f472$var$defaultTop;
var $dc31f36873c2f472$var$key = 1;
var $dc31f36873c2f472$var$localPrefixCls = '';
var $dc31f36873c2f472$var$transitionName = 'move-up';
var $dc31f36873c2f472$var$hasTransitionName = false;
var $dc31f36873c2f472$var$getContainer;
var $dc31f36873c2f472$var$maxCount;
var $dc31f36873c2f472$var$rtl = false;
function $dc31f36873c2f472$export$ab227b2024307500() {
    return $dc31f36873c2f472$var$key++;
}
function $dc31f36873c2f472$var$setMessageConfig(options) {
    if (options.top !== undefined) {
        $dc31f36873c2f472$var$defaultTop = options.top;
        $dc31f36873c2f472$var$messageInstance = null; // delete messageInstance for new defaultTop
    }
    if (options.duration !== undefined) $dc31f36873c2f472$var$defaultDuration = options.duration;
    if (options.prefixCls !== undefined) $dc31f36873c2f472$var$localPrefixCls = options.prefixCls;
    if (options.getContainer !== undefined) {
        $dc31f36873c2f472$var$getContainer = options.getContainer;
        $dc31f36873c2f472$var$messageInstance = null; // delete messageInstance for new getContainer
    }
    if (options.transitionName !== undefined) {
        $dc31f36873c2f472$var$transitionName = options.transitionName;
        $dc31f36873c2f472$var$messageInstance = null; // delete messageInstance for new transitionName
        $dc31f36873c2f472$var$hasTransitionName = true;
    }
    if (options.maxCount !== undefined) {
        $dc31f36873c2f472$var$maxCount = options.maxCount;
        $dc31f36873c2f472$var$messageInstance = null;
    }
    if (options.rtl !== undefined) $dc31f36873c2f472$var$rtl = options.rtl;
}
function $dc31f36873c2f472$var$getRCNotificationInstance(args, callback) {
    var customizePrefixCls = args.prefixCls, getContextPopupContainer = args.getPopupContainer;
    var _globalConfig = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getRootPrefixCls = _globalConfig.getRootPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls('message', customizePrefixCls || $dc31f36873c2f472$var$localPrefixCls);
    var rootPrefixCls = getRootPrefixCls(args.rootPrefixCls, prefixCls);
    var iconPrefixCls = getIconPrefixCls();
    if ($dc31f36873c2f472$var$messageInstance) {
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: $dc31f36873c2f472$var$messageInstance
        });
        return;
    }
    var instanceConfig = {
        prefixCls: prefixCls,
        transitionName: $dc31f36873c2f472$var$hasTransitionName ? $dc31f36873c2f472$var$transitionName : "".concat(rootPrefixCls, "-").concat($dc31f36873c2f472$var$transitionName),
        style: {
            top: $dc31f36873c2f472$var$defaultTop
        },
        getContainer: $dc31f36873c2f472$var$getContainer || getContextPopupContainer,
        maxCount: $dc31f36873c2f472$var$maxCount
    };
    (0, $3DXWh.default).newInstance(instanceConfig, function(instance) {
        if ($dc31f36873c2f472$var$messageInstance) {
            callback({
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                instance: $dc31f36873c2f472$var$messageInstance
            });
            return;
        }
        $dc31f36873c2f472$var$messageInstance = instance;
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: instance
        });
    });
}
var $dc31f36873c2f472$var$typeToIcon = {
    info: (0, $2169dccbc27bcb86$export$2e2bcd8739ae039),
    success: (0, $8a880f6c24a0b77c$export$2e2bcd8739ae039),
    error: (0, $2bf1c25862f513c2$export$2e2bcd8739ae039),
    warning: (0, $c94f46c32abf10c6$export$2e2bcd8739ae039),
    loading: (0, $43383ed7d2a91124$export$2e2bcd8739ae039)
};
var $dc31f36873c2f472$export$37928ca2918d853b = Object.keys($dc31f36873c2f472$var$typeToIcon);
function $dc31f36873c2f472$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var duration = args.duration !== undefined ? args.duration : $dc31f36873c2f472$var$defaultDuration;
    var IconComponent = $dc31f36873c2f472$var$typeToIcon[args.type];
    var messageClass = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-custom-content"), (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(args.type), args.type), "".concat(prefixCls, "-rtl"), $dc31f36873c2f472$var$rtl === true));
    return {
        key: args.key,
        duration: duration,
        style: args.style || {},
        className: args.className,
        content: /*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: messageClass
        }, args.icon || IconComponent && /*#__PURE__*/ $acw62.createElement(IconComponent, null), /*#__PURE__*/ $acw62.createElement("span", null, args.content))),
        onClose: args.onClose,
        onClick: args.onClick
    };
}
function $dc31f36873c2f472$var$notice(args) {
    var target = args.key || $dc31f36873c2f472$export$ab227b2024307500();
    var closePromise = new Promise(function(resolve) {
        var callback = function callback() {
            if (typeof args.onClose === 'function') args.onClose();
            return resolve(true);
        };
        $dc31f36873c2f472$var$getRCNotificationInstance(args, function(_ref) {
            var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
            instance.notice($dc31f36873c2f472$var$getRCNoticeProps((0, $8nd05.default)((0, $8nd05.default)({}, args), {
                key: target,
                onClose: callback
            }), prefixCls, iconPrefixCls));
        });
    });
    var result = function result() {
        var _a;
        if ($dc31f36873c2f472$var$messageInstance) {
            $dc31f36873c2f472$var$messageInstance.removeNotice(target);
            (_a = args.onClose) === null || _a === void 0 || _a.call(args);
        }
    };
    result.then = function(filled, rejected) {
        return closePromise.then(filled, rejected);
    };
    result.promise = closePromise;
    return result;
}
function $dc31f36873c2f472$var$isArgsProps(content) {
    return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}
var $dc31f36873c2f472$var$api = {
    open: $dc31f36873c2f472$var$notice,
    config: $dc31f36873c2f472$var$setMessageConfig,
    destroy: function destroy(messageKey) {
        if ($dc31f36873c2f472$var$messageInstance) {
            if (messageKey) {
                var _messageInstance = $dc31f36873c2f472$var$messageInstance, removeNotice = _messageInstance.removeNotice;
                removeNotice(messageKey);
            } else {
                var _messageInstance2 = $dc31f36873c2f472$var$messageInstance, destroy = _messageInstance2.destroy;
                destroy();
                $dc31f36873c2f472$var$messageInstance = null;
            }
        }
    }
};
function $dc31f36873c2f472$export$63b017493c112c94(originalApi, type) {
    originalApi[type] = function(content, duration, onClose) {
        if ($dc31f36873c2f472$var$isArgsProps(content)) return originalApi.open((0, $8nd05.default)((0, $8nd05.default)({}, content), {
            type: type
        }));
        if (typeof duration === 'function') {
            onClose = duration;
            duration = undefined;
        }
        return originalApi.open({
            content: content,
            duration: duration,
            type: type,
            onClose: onClose
        });
    };
}
$dc31f36873c2f472$export$37928ca2918d853b.forEach(function(type) {
    return $dc31f36873c2f472$export$63b017493c112c94($dc31f36873c2f472$var$api, type);
});
$dc31f36873c2f472$var$api.warn = $dc31f36873c2f472$var$api.warning;
$dc31f36873c2f472$var$api.useMessage = (0, $c44e7f7175cd2535$export$2e2bcd8739ae039)($dc31f36873c2f472$var$getRCNotificationInstance, $dc31f36873c2f472$var$getRCNoticeProps);
var $dc31f36873c2f472$export$8bedcca5bbd73999 = function getInstance() {
    return null;
};
var $dc31f36873c2f472$export$2e2bcd8739ae039 = $dc31f36873c2f472$var$api;



var $cqPKg = parcelRequire("cqPKg");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $915890149dc0569a$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
var $915890149dc0569a$export$2e2bcd8739ae039 = $915890149dc0569a$var$CheckCircleOutlined;



var $99a2d8a3991a4b46$var$CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $915890149dc0569a$export$2e2bcd8739ae039)
    }));
};
var $99a2d8a3991a4b46$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($99a2d8a3991a4b46$var$CheckCircleOutlined);
var $99a2d8a3991a4b46$export$2e2bcd8739ae039 = $99a2d8a3991a4b46$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $f986f8662437b397$var$CloseCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "outlined"
};
var $f986f8662437b397$export$2e2bcd8739ae039 = $f986f8662437b397$var$CloseCircleOutlined;



var $e59ec99fdd4bd915$var$CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $f986f8662437b397$export$2e2bcd8739ae039)
    }));
};
var $e59ec99fdd4bd915$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($e59ec99fdd4bd915$var$CloseCircleOutlined);
var $e59ec99fdd4bd915$export$2e2bcd8739ae039 = $e59ec99fdd4bd915$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $91321edc6c28da63$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $91321edc6c28da63$export$2e2bcd8739ae039 = $91321edc6c28da63$var$CloseOutlined;



var $31b8ddc4065205d5$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $91321edc6c28da63$export$2e2bcd8739ae039)
    }));
};
var $31b8ddc4065205d5$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($31b8ddc4065205d5$var$CloseOutlined);
var $31b8ddc4065205d5$export$2e2bcd8739ae039 = $31b8ddc4065205d5$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $fd02a96d61da437a$var$ExclamationCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "outlined"
};
var $fd02a96d61da437a$export$2e2bcd8739ae039 = $fd02a96d61da437a$var$ExclamationCircleOutlined;



var $7e2f802c76c39788$var$ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fd02a96d61da437a$export$2e2bcd8739ae039)
    }));
};
var $7e2f802c76c39788$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($7e2f802c76c39788$var$ExclamationCircleOutlined);
var $7e2f802c76c39788$export$2e2bcd8739ae039 = $7e2f802c76c39788$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $a37b6e3a9f9e4b6a$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
var $a37b6e3a9f9e4b6a$export$2e2bcd8739ae039 = $a37b6e3a9f9e4b6a$var$InfoCircleOutlined;



var $7e25aa5b60711714$var$InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $a37b6e3a9f9e4b6a$export$2e2bcd8739ae039)
    }));
};
var $7e25aa5b60711714$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($7e25aa5b60711714$var$InfoCircleOutlined);
var $7e25aa5b60711714$export$2e2bcd8739ae039 = $7e25aa5b60711714$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $3DXWh = parcelRequire("3DXWh");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $fytPh = parcelRequire("fytPh");

var $acw62 = parcelRequire("acw62");

function $d6dca93a7303bb6b$export$2e2bcd8739ae039(getNotificationInstance, getRCNoticeProps) {
    var useNotification = function useNotification() {
        // We can only get content by render
        var getPrefixCls;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $fytPh.default)(proxy), _useRCNotification2 = (0, $eUqlC.default)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls('notification', customizePrefixCls);
            getNotificationInstance((0, $8nd05.default)((0, $8nd05.default)({}, args), {
                prefixCls: mergedPrefixCls
            }), function(_ref) {
                var prefixCls = _ref.prefixCls, instance = _ref.instance;
                innerInstance = instance;
                hookNotify(getRCNoticeProps(args, prefixCls));
            });
        }
        // Fill functions
        var hookApiRef = $acw62.useRef({});
        hookApiRef.current.open = notify;
        [
            'success',
            'info',
            'warning',
            'error'
        ].forEach(function(type) {
            hookApiRef.current[type] = function(args) {
                return hookApiRef.current.open((0, $8nd05.default)((0, $8nd05.default)({}, args), {
                    type: type
                }));
            };
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                return holder;
            })
        ];
    };
    return useNotification;
}


var $b5c555d97e03a3da$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b5c555d97e03a3da$var$notificationInstance = {};
var $b5c555d97e03a3da$var$defaultDuration = 4.5;
var $b5c555d97e03a3da$var$defaultTop = 24;
var $b5c555d97e03a3da$var$defaultBottom = 24;
var $b5c555d97e03a3da$var$defaultPrefixCls = '';
var $b5c555d97e03a3da$var$defaultPlacement = 'topRight';
var $b5c555d97e03a3da$var$defaultGetContainer;
var $b5c555d97e03a3da$var$defaultCloseIcon;
var $b5c555d97e03a3da$var$rtl = false;
var $b5c555d97e03a3da$var$maxCount;
function $b5c555d97e03a3da$var$setNotificationConfig(options) {
    var duration = options.duration, placement = options.placement, bottom = options.bottom, top = options.top, getContainer = options.getContainer, closeIcon = options.closeIcon, prefixCls = options.prefixCls;
    if (prefixCls !== undefined) $b5c555d97e03a3da$var$defaultPrefixCls = prefixCls;
    if (duration !== undefined) $b5c555d97e03a3da$var$defaultDuration = duration;
    if (placement !== undefined) $b5c555d97e03a3da$var$defaultPlacement = placement;
    else if (options.rtl) $b5c555d97e03a3da$var$defaultPlacement = 'topLeft';
    if (bottom !== undefined) $b5c555d97e03a3da$var$defaultBottom = bottom;
    if (top !== undefined) $b5c555d97e03a3da$var$defaultTop = top;
    if (getContainer !== undefined) $b5c555d97e03a3da$var$defaultGetContainer = getContainer;
    if (closeIcon !== undefined) $b5c555d97e03a3da$var$defaultCloseIcon = closeIcon;
    if (options.rtl !== undefined) $b5c555d97e03a3da$var$rtl = options.rtl;
    if (options.maxCount !== undefined) $b5c555d97e03a3da$var$maxCount = options.maxCount;
}
function $b5c555d97e03a3da$var$getPlacementStyle(placement) {
    var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b5c555d97e03a3da$var$defaultTop;
    var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $b5c555d97e03a3da$var$defaultBottom;
    var style;
    switch(placement){
        case 'top':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topLeft':
            style = {
                left: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'bottom':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: 'auto',
                bottom: bottom
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
    }
    return style;
}
function $b5c555d97e03a3da$var$getNotificationInstance(args, callback) {
    var _args$placement = args.placement, placement = _args$placement === void 0 ? $b5c555d97e03a3da$var$defaultPlacement : _args$placement, top = args.top, bottom = args.bottom, _args$getContainer = args.getContainer, getContainer = _args$getContainer === void 0 ? $b5c555d97e03a3da$var$defaultGetContainer : _args$getContainer, customizePrefixCls = args.prefixCls;
    var _globalConfig = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls('notification', customizePrefixCls || $b5c555d97e03a3da$var$defaultPrefixCls);
    var iconPrefixCls = getIconPrefixCls();
    var cacheKey = "".concat(prefixCls, "-").concat(placement);
    var cacheInstance = $b5c555d97e03a3da$var$notificationInstance[cacheKey];
    if (cacheInstance) {
        Promise.resolve(cacheInstance).then(function(instance) {
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: instance
            });
        });
        return;
    }
    var notificationClass = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-").concat(placement), (0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), $b5c555d97e03a3da$var$rtl === true));
    $b5c555d97e03a3da$var$notificationInstance[cacheKey] = new Promise(function(resolve) {
        (0, $3DXWh.default).newInstance({
            prefixCls: prefixCls,
            className: notificationClass,
            style: $b5c555d97e03a3da$var$getPlacementStyle(placement, top, bottom),
            getContainer: getContainer,
            maxCount: $b5c555d97e03a3da$var$maxCount
        }, function(notification) {
            resolve(notification);
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: notification
            });
        });
    });
}
var $b5c555d97e03a3da$var$typeToIcon = {
    success: (0, $99a2d8a3991a4b46$export$2e2bcd8739ae039),
    info: (0, $7e25aa5b60711714$export$2e2bcd8739ae039),
    error: (0, $e59ec99fdd4bd915$export$2e2bcd8739ae039),
    warning: (0, $7e2f802c76c39788$export$2e2bcd8739ae039)
};
function $b5c555d97e03a3da$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var durationArg = args.duration, icon = args.icon, type = args.type, description = args.description, message = args.message, btn = args.btn, onClose = args.onClose, onClick = args.onClick, key = args.key, style = args.style, className = args.className, _args$closeIcon = args.closeIcon, closeIcon = _args$closeIcon === void 0 ? $b5c555d97e03a3da$var$defaultCloseIcon : _args$closeIcon, props = args.props;
    var duration = durationArg === undefined ? $b5c555d97e03a3da$var$defaultDuration : durationArg;
    var iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, args.icon);
    else if (type) iconNode = /*#__PURE__*/ $acw62.createElement($b5c555d97e03a3da$var$typeToIcon[type] || null, {
        className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(type)
    });
    var closeIconToRender = typeof closeIcon === 'undefined' ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, /*#__PURE__*/ $acw62.createElement((0, $31b8ddc4065205d5$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-close-icon")
    })) : closeIcon;
    var autoMarginTag = !description && iconNode ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-message-single-line-auto-margin")
    }) : null;
    return {
        content: /*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: iconNode ? "".concat(prefixCls, "-with-icon") : '',
            role: "alert"
        }, iconNode, /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, autoMarginTag, message), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description), btn ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-btn")
        }, btn) : null)),
        duration: duration,
        closable: true,
        closeIcon: closeIconToRender,
        onClose: onClose,
        onClick: onClick,
        key: key,
        style: style || {},
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, (0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(type), !!type)),
        props: props
    };
}
function $b5c555d97e03a3da$var$notice(args) {
    $b5c555d97e03a3da$var$getNotificationInstance(args, function(_ref) {
        var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
        instance.notice($b5c555d97e03a3da$var$getRCNoticeProps(args, prefixCls, iconPrefixCls));
    });
}
var $b5c555d97e03a3da$var$api = {
    open: $b5c555d97e03a3da$var$notice,
    close: function close(key) {
        Object.keys($b5c555d97e03a3da$var$notificationInstance).forEach(function(cacheKey) {
            return Promise.resolve($b5c555d97e03a3da$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.removeNotice(key);
            });
        });
    },
    config: $b5c555d97e03a3da$var$setNotificationConfig,
    destroy: function destroy() {
        Object.keys($b5c555d97e03a3da$var$notificationInstance).forEach(function(cacheKey) {
            Promise.resolve($b5c555d97e03a3da$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.destroy();
            });
            delete $b5c555d97e03a3da$var$notificationInstance[cacheKey]; // lgtm[js/missing-await]
        });
    }
};
[
    'success',
    'info',
    'warning',
    'error'
].forEach(function(type) {
    $b5c555d97e03a3da$var$api[type] = function(args) {
        return $b5c555d97e03a3da$var$api.open((0, $8nd05.default)((0, $8nd05.default)({}, args), {
            type: type
        }));
    };
});
$b5c555d97e03a3da$var$api.warn = $b5c555d97e03a3da$var$api.warning;
$b5c555d97e03a3da$var$api.useNotification = (0, $d6dca93a7303bb6b$export$2e2bcd8739ae039)($b5c555d97e03a3da$var$getNotificationInstance, $b5c555d97e03a3da$var$getRCNoticeProps);
var $b5c555d97e03a3da$export$8bedcca5bbd73999 = function getInstance(cacheKey) {
    return $b5c555d97e03a3da$var$__awaiter(void 0, void 0, void 0, /*#__PURE__*/ (0, $cqPKg.default)().mark(function _callee() {
        return (0, $cqPKg.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", null);
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
};
var $b5c555d97e03a3da$export$2e2bcd8739ae039 = $b5c555d97e03a3da$var$api;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
var $a18b2f6f56546238$var$defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : 'ant';
};
var $a18b2f6f56546238$export$a92f85ab3e9ad68b = /*#__PURE__*/ $acw62.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $a18b2f6f56546238$var$defaultGetPrefixCls
});
var $a18b2f6f56546238$export$cd5442f2b8da7663 = $a18b2f6f56546238$export$a92f85ab3e9ad68b.Consumer;
function $a18b2f6f56546238$export$ac719629fc076fcb(config) {
    return function withConfigConsumerFunc(Component) {
        // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
        var SFC = function SFC(props) {
            return /*#__PURE__*/ $acw62.createElement($a18b2f6f56546238$export$cd5442f2b8da7663, null, function(configProps) {
                var basicPrefixCls = config.prefixCls;
                var getPrefixCls = configProps.getPrefixCls;
                var customizePrefixCls = props.prefixCls;
                var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
                return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({}, configProps, props, {
                    prefixCls: prefixCls
                }));
            });
        };
        var cons = Component.constructor;
        var name = cons && cons.displayName || Component.name || 'Component';
        return SFC;
    };
}


/* eslint-disable import/prefer-default-export, prefer-destructuring */ 
var $dnPM8 = parcelRequire("dnPM8");

var $9nbKF = parcelRequire("9nbKF");

var $h4v51 = parcelRequire("h4v51");

var $4ZrBP = parcelRequire("4ZrBP");

var $e1ca56936d2d2b32$var$dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    var variables = {};
    var formatColor = function formatColor(color, updater) {
        var clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    var fillColor = function fillColor(colorVal, type) {
        var baseColor = new (0, $9nbKF.TinyColor)(colorVal);
        var colorPalettes = (0, $dnPM8.generate)(baseColor.toRgbString());
        variables["".concat(type, "-color")] = formatColor(baseColor);
        variables["".concat(type, "-color-disabled")] = colorPalettes[1];
        variables["".concat(type, "-color-hover")] = colorPalettes[4];
        variables["".concat(type, "-color-active")] = colorPalettes[6];
        variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[0];
        variables["".concat(type, "-color-deprecated-border")] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        var primaryColor = new (0, $9nbKF.TinyColor)(theme.primaryColor);
        var primaryColors = (0, $dnPM8.generate)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach(function(color, index) {
            variables["primary-".concat(index + 1)] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, function(c) {
            return c.lighten(35);
        });
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, function(c) {
            return c.lighten(20);
        });
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, function(c) {
            return c.tint(20);
        });
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, function(c) {
            return c.tint(50);
        });
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.12);
        });
        var primaryActiveColor = new (0, $9nbKF.TinyColor)(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.3);
        });
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, function(c) {
            return c.darken(2);
        });
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    var cssList = Object.keys(variables).map(function(key) {
        return "--".concat(globalPrefixCls, "-").concat(key, ": ").concat(variables[key], ";");
    });
    return "\n  :root {\n    ".concat(cssList.join('\n'), "\n  }\n  ").trim();
}
function $e1ca56936d2d2b32$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    var style = $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $h4v51.default)()) (0, $4ZrBP.updateCSS)(style, "".concat($e1ca56936d2d2b32$var$dynamicStyleMark, "-dynamic-theme"));
}



var $acw62 = parcelRequire("acw62");
var $6ba6819805fb0a44$var$DisabledContext = /*#__PURE__*/ $acw62.createContext(false);
var $6ba6819805fb0a44$export$6adb5f3b918b11bb = function DisabledContextProvider(_ref) {
    var children = _ref.children, disabled = _ref.disabled;
    var originDisabled = $acw62.useContext($6ba6819805fb0a44$var$DisabledContext);
    return /*#__PURE__*/ $acw62.createElement($6ba6819805fb0a44$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $6ba6819805fb0a44$export$2e2bcd8739ae039 = $6ba6819805fb0a44$var$DisabledContext;



var $acw62 = parcelRequire("acw62");
var $3e100f55cf8f3689$var$SizeContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $3e100f55cf8f3689$export$dbc92d89fabc8ebe = function SizeContextProvider(_ref) {
    var children = _ref.children, size = _ref.size;
    return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Consumer, null, function(originSize) {
        return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Provider, {
            value: size || originSize
        }, children);
    });
};
var $3e100f55cf8f3689$export$2e2bcd8739ae039 = $3e100f55cf8f3689$var$SizeContext;


var $7ed5e10e08c170f8$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale',
    'pageHeader'
];
// These props is used by `useContext` directly in sub component
var $7ed5e10e08c170f8$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'pageHeader',
    'input',
    'pagination',
    'form'
];
var $7ed5e10e08c170f8$export$e4ec87ea71f29b41 = 'ant';
var $7ed5e10e08c170f8$export$eaca8ee5ed21b4e9 = 'anticon';
var $7ed5e10e08c170f8$var$globalPrefixCls;
var $7ed5e10e08c170f8$var$globalIconPrefixCls;
function $7ed5e10e08c170f8$var$getGlobalPrefixCls() {
    return $7ed5e10e08c170f8$var$globalPrefixCls || $7ed5e10e08c170f8$export$e4ec87ea71f29b41;
}
function $7ed5e10e08c170f8$var$getGlobalIconPrefixCls() {
    return $7ed5e10e08c170f8$var$globalIconPrefixCls || $7ed5e10e08c170f8$export$eaca8ee5ed21b4e9;
}
var $7ed5e10e08c170f8$var$setGlobalConfig = function setGlobalConfig(_ref) {
    var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, theme = _ref.theme;
    if (prefixCls !== undefined) $7ed5e10e08c170f8$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $7ed5e10e08c170f8$var$globalIconPrefixCls = iconPrefixCls;
    if (theme) (0, $e1ca56936d2d2b32$export$f9c59eed5de5ff80)($7ed5e10e08c170f8$var$getGlobalPrefixCls(), theme);
};
var $7ed5e10e08c170f8$export$f9cd1e43211d8a4a = function globalConfig() {
    return {
        getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? "".concat($7ed5e10e08c170f8$var$getGlobalPrefixCls(), "-").concat(suffixCls) : $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $7ed5e10e08c170f8$var$getGlobalIconPrefixCls,
        getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
            // Customize rootPrefixCls is first priority
            if (rootPrefixCls) return rootPrefixCls;
            // If Global prefixCls provided, use this
            if ($7ed5e10e08c170f8$var$globalPrefixCls) return $7ed5e10e08c170f8$var$globalPrefixCls;
            // [Legacy] If customize prefixCls provided, we cut it to get the prefixCls
            if (customizePrefixCls && customizePrefixCls.includes('-')) return customizePrefixCls.replace(/^(.*)-[^-]*$/, '$1');
            // Fallback to default prefixCls
            return $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        }
    };
};
var $7ed5e10e08c170f8$var$ProviderChildren = function ProviderChildren(props) {
    var children = props.children, csp = props.csp, autoInsertSpaceInButton = props.autoInsertSpaceInButton, form = props.form, locale = props.locale, componentSize = props.componentSize, direction = props.direction, space = props.space, virtual = props.virtual, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, legacyLocale = props.legacyLocale, parentContext = props.parentContext, iconPrefixCls = props.iconPrefixCls, componentDisabled = props.componentDisabled;
    var getPrefixCls = $acw62.useCallback(function(suffixCls, customizePrefixCls) {
        var prefixCls = props.prefixCls;
        if (customizePrefixCls) return customizePrefixCls;
        var mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    var config = (0, $8nd05.default)((0, $8nd05.default)({}, parentContext), {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        getPrefixCls: getPrefixCls
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $7ed5e10e08c170f8$var$PASSED_PROPS.forEach(function(propName) {
        var propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    // https://github.com/ant-design/ant-design/issues/27617
    var memoedConfig = (0, $3Ysvw.default)(function() {
        return config;
    }, config, function(prevConfig, currentConfig) {
        var prevKeys = Object.keys(prevConfig);
        var currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some(function(key) {
            return prevConfig[key] !== currentConfig[key];
        });
    });
    var memoIconContextValue = $acw62.useMemo(function() {
        return {
            prefixCls: iconPrefixCls,
            csp: csp
        };
    }, [
        iconPrefixCls,
        csp
    ]);
    var childNode = children;
    var validateMessages = $acw62.useMemo(function() {
        var _a, _b, _c, _d;
        return (0, $6vgkH.merge)(((_a = (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $acw62.createElement((0, $efabd6732f69a6da$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, children);
    if (locale) childNode = /*#__PURE__*/ $acw62.createElement((0, $fab4cbd3d1c845d7$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $fab4cbd3d1c845d7$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $acw62.createElement((0, $caba883bf952ef31$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
var $7ed5e10e08c170f8$var$ConfigProvider = function ConfigProvider(props) {
    $acw62.useEffect(function() {
        if (props.direction) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).config({
                rtl: props.direction === 'rtl'
            });
            (0, $b5c555d97e03a3da$export$2e2bcd8739ae039).config({
                rtl: props.direction === 'rtl'
            });
        }
    }, [
        props.direction
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), null, function(_, __, legacyLocale) {
        return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), null, function(context) {
            return /*#__PURE__*/ $acw62.createElement($7ed5e10e08c170f8$var$ProviderChildren, (0, $8nd05.default)({
                parentContext: context,
                legacyLocale: legacyLocale
            }, props));
        });
    });
};
/** @private internal Usage. do not use in your production */ $7ed5e10e08c170f8$var$ConfigProvider.ConfigContext = (0, $a18b2f6f56546238$export$a92f85ab3e9ad68b);
$7ed5e10e08c170f8$var$ConfigProvider.SizeContext = (0, $3e100f55cf8f3689$export$2e2bcd8739ae039);
$7ed5e10e08c170f8$var$ConfigProvider.config = $7ed5e10e08c170f8$var$setGlobalConfig;
var $7ed5e10e08c170f8$export$2e2bcd8739ae039 = $7ed5e10e08c170f8$var$ConfigProvider;





var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $jWR62 = parcelRequire("jWR62");

var $acw62 = parcelRequire("acw62");

var $26050ef76e24a749$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $26050ef76e24a749$export$8d1c486ac0db0a7d = /*#__PURE__*/ $acw62.createContext(null);
var $26050ef76e24a749$export$cd8cf9d7bab8dd4 = function useCompactItemContext(prefixCls, direction) {
    var compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    var compactItemClassnames = $acw62.useMemo(function() {
        if (!compactItemContext) return '';
        var compactDirection = compactItemContext.compactDirection, isFirstItem = compactItemContext.isFirstItem, isLastItem = compactItemContext.isLastItem;
        var separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-compact").concat(separator, "item"), true), "".concat(prefixCls, "-compact").concat(separator, "first-item"), isFirstItem), "".concat(prefixCls, "-compact").concat(separator, "last-item"), isLastItem), "".concat(prefixCls, "-compact").concat(separator, "item-rtl"), direction === 'rtl'));
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
var $26050ef76e24a749$export$5f56e610a4afb685 = function NoCompactStyle(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
var $26050ef76e24a749$var$CompactItem = function CompactItem(_a) {
    var children = _a.children, otherProps = $26050ef76e24a749$var$__rest(_a, [
        "children"
    ]);
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: otherProps
    }, children);
};
var $26050ef76e24a749$var$Compact = function Compact(props) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, directionConfig = _React$useContext.direction;
    var _props$size = props.size, size = _props$size === void 0 ? 'middle' : _props$size, direction = props.direction, block = props.block, customizePrefixCls = props.prefixCls, className = props.className, children = props.children, restProps = $26050ef76e24a749$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "children"
    ]);
    var prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    var clx = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), directionConfig === 'rtl'), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-vertical"), direction === 'vertical'), className);
    var compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    var childNodes = (0, $jWR62.default)(children);
    var nodes = $acw62.useMemo(function() {
        return childNodes.map(function(child, i) {
            var key = child && child.key || "".concat(prefixCls, "-item-").concat(i);
            return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$var$CompactItem, {
                key: key,
                compactSize: size,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        });
    }, [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: clx
    }, restProps), nodes);
};
var $26050ef76e24a749$export$2e2bcd8739ae039 = $26050ef76e24a749$var$Compact;



var $acw62 = parcelRequire("acw62");
var $30796c32f374b477$export$a8257692ac88316c = $acw62.isValidElement;
function $30796c32f374b477$export$9522e17588c12572(child) {
    return child && $30796c32f374b477$export$a8257692ac88316c(child) && child.type === $acw62.Fragment;
}
function $30796c32f374b477$export$2dfe578f95754f6a(element, replacement, props) {
    if (!$30796c32f374b477$export$a8257692ac88316c(element)) return replacement;
    return /*#__PURE__*/ $acw62.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
function $30796c32f374b477$export$e530037191fcd5d7(element, props) {
    return $30796c32f374b477$export$2dfe578f95754f6a(element, element, props);
}


// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var $1ee8868d1993c67b$export$65e3907585753458 = function tuple() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args;
};
var $1ee8868d1993c67b$export$1ada10640a0e4dad = function tupleNum() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return args;
};




var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $9715X = parcelRequire("9715X");

var $fhGLX = parcelRequire("fhGLX");

var $jDKKo = parcelRequire("jDKKo");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $4ZrBP = parcelRequire("4ZrBP");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");


var $dTiBu = parcelRequire("dTiBu");
var $0758d3b0f0caa119$var$id = 0;
var $0758d3b0f0caa119$var$ids = {};
function $0758d3b0f0caa119$export$2e2bcd8739ae039(callback) {
    var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var myId = $0758d3b0f0caa119$var$id++;
    var restFrames = delayFrames;
    function internalCallback() {
        restFrames -= 1;
        if (restFrames <= 0) {
            callback();
            delete $0758d3b0f0caa119$var$ids[myId];
        } else $0758d3b0f0caa119$var$ids[myId] = (0, $dTiBu.default)(internalCallback);
    }
    $0758d3b0f0caa119$var$ids[myId] = (0, $dTiBu.default)(internalCallback);
    return myId;
}
$0758d3b0f0caa119$export$2e2bcd8739ae039.cancel = function cancel(pid) {
    if (pid === undefined) return;
    (0, $dTiBu.default).cancel($0758d3b0f0caa119$var$ids[pid]);
    delete $0758d3b0f0caa119$var$ids[pid];
};
$0758d3b0f0caa119$export$2e2bcd8739ae039.ids = $0758d3b0f0caa119$var$ids; // export this for test usage



function $4efa89abfa6bbc97$var$_callSuper(t, o, e) {
    return o = (0, $jDKKo.default)(o), (0, $9715X.default)(t, (0, $fhGLX.default)() ? Reflect.construct(o, e || [], (0, $jDKKo.default)(t).constructor) : o.apply(t, e));
}
var $4efa89abfa6bbc97$var$styleForPseudo;
// Where el is the DOM element you'd like to test for visibility
function $4efa89abfa6bbc97$var$isHidden(element) {
    return !element || element.offsetParent === null || element.hidden;
}
function $4efa89abfa6bbc97$var$getValidateContainer(nodeRoot) {
    if (nodeRoot instanceof Document) return nodeRoot.body;
    return Array.from(nodeRoot.childNodes).find(function(ele) {
        return (ele === null || ele === void 0 ? void 0 : ele.nodeType) === Node.ELEMENT_NODE;
    });
}
function $4efa89abfa6bbc97$var$isNotGrey(color) {
    // eslint-disable-next-line no-useless-escape
    var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
    if (match && match[1] && match[2] && match[3]) return !(match[1] === match[2] && match[2] === match[3]);
    return true;
}
var $4efa89abfa6bbc97$var$Wave = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Wave, _React$Component);
    function Wave() {
        var _this;
        (0, $6CZeq.default)(this, Wave);
        _this = $4efa89abfa6bbc97$var$_callSuper(this, Wave, arguments);
        _this.containerRef = /*#__PURE__*/ $acw62.createRef();
        _this.animationStart = false;
        _this.destroyed = false;
        _this.onClick = function(node, waveColor) {
            var _a, _b;
            var _this$props = _this.props, insertExtraNode = _this$props.insertExtraNode, disabled = _this$props.disabled;
            if (disabled || !node || $4efa89abfa6bbc97$var$isHidden(node) || node.className.includes('-leave')) return;
            _this.extraNode = document.createElement('div');
            var _assertThisInitialize = (0, $hDpcU.default)(_this), extraNode = _assertThisInitialize.extraNode;
            var getPrefixCls = _this.context.getPrefixCls;
            extraNode.className = "".concat(getPrefixCls(''), "-click-animating-node");
            var attributeName = _this.getAttributeName();
            node.setAttribute(attributeName, 'true');
            // Not white or transparent or grey
            if (waveColor && waveColor !== '#fff' && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && waveColor !== 'rgba(255, 255, 255, 1)' && $4efa89abfa6bbc97$var$isNotGrey(waveColor) && !/rgba\((?:\d*, ){3}0\)/.test(waveColor) && // any transparent rgba color
            waveColor !== 'transparent') {
                extraNode.style.borderColor = waveColor;
                var nodeRoot = ((_a = node.getRootNode) === null || _a === void 0 ? void 0 : _a.call(node)) || node.ownerDocument;
                var nodeBody = (_b = $4efa89abfa6bbc97$var$getValidateContainer(nodeRoot)) !== null && _b !== void 0 ? _b : nodeRoot;
                $4efa89abfa6bbc97$var$styleForPseudo = (0, $4ZrBP.updateCSS)("\n      [".concat(getPrefixCls(''), "-click-animating-without-extra-node='true']::after, .").concat(getPrefixCls(''), "-click-animating-node {\n        --antd-wave-shadow-color: ").concat(waveColor, ";\n      }"), 'antd-wave', {
                    csp: _this.csp,
                    attachTo: nodeBody
                });
            }
            if (insertExtraNode) node.appendChild(extraNode);
            [
                'transition',
                'animation'
            ].forEach(function(name) {
                node.addEventListener("".concat(name, "start"), _this.onTransitionStart);
                node.addEventListener("".concat(name, "end"), _this.onTransitionEnd);
            });
        };
        _this.onTransitionStart = function(e) {
            if (_this.destroyed) return;
            var node = _this.containerRef.current;
            if (!e || e.target !== node || _this.animationStart) return;
            _this.resetEffect(node);
        };
        _this.onTransitionEnd = function(e) {
            if (!e || e.animationName !== 'fadeEffect') return;
            _this.resetEffect(e.target);
        };
        _this.bindAnimationEvent = function(node) {
            if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.includes('disabled')) return;
            var onClick = function onClick(e) {
                // Fix radio button click twice
                if (e.target.tagName === 'INPUT' || $4efa89abfa6bbc97$var$isHidden(e.target)) return;
                _this.resetEffect(node);
                // Get wave color from target
                var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
                getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
                _this.clickWaveTimeoutId = window.setTimeout(function() {
                    return _this.onClick(node, waveColor);
                }, 0);
                (0, $0758d3b0f0caa119$export$2e2bcd8739ae039).cancel(_this.animationStartId);
                _this.animationStart = true;
                // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
                _this.animationStartId = (0, $0758d3b0f0caa119$export$2e2bcd8739ae039)(function() {
                    _this.animationStart = false;
                }, 10);
            };
            node.addEventListener('click', onClick, true);
            return {
                cancel: function cancel() {
                    node.removeEventListener('click', onClick, true);
                }
            };
        };
        _this.renderWave = function(_ref) {
            var csp = _ref.csp;
            var children = _this.props.children;
            _this.csp = csp;
            if (!/*#__PURE__*/ $acw62.isValidElement(children)) return children;
            var ref = _this.containerRef;
            if ((0, $85dLH.supportRef)(children)) ref = (0, $85dLH.composeRef)(children.ref, _this.containerRef);
            return (0, $30796c32f374b477$export$e530037191fcd5d7)(children, {
                ref: ref
            });
        };
        return _this;
    }
    (0, $cHPF9.default)(Wave, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                var node = this.containerRef.current;
                if (!node || node.nodeType !== 1) return;
                this.instance = this.bindAnimationEvent(node);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.instance) this.instance.cancel();
                if (this.clickWaveTimeoutId) clearTimeout(this.clickWaveTimeoutId);
                this.destroyed = true;
            }
        },
        {
            key: "getAttributeName",
            value: function getAttributeName() {
                var getPrefixCls = this.context.getPrefixCls;
                var insertExtraNode = this.props.insertExtraNode;
                return insertExtraNode ? "".concat(getPrefixCls(''), "-click-animating") : "".concat(getPrefixCls(''), "-click-animating-without-extra-node");
            }
        },
        {
            key: "resetEffect",
            value: function resetEffect(node) {
                var _this2 = this;
                if (!node || node === this.extraNode || !(node instanceof Element)) return;
                var insertExtraNode = this.props.insertExtraNode;
                var attributeName = this.getAttributeName();
                node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
                if ($4efa89abfa6bbc97$var$styleForPseudo) $4efa89abfa6bbc97$var$styleForPseudo.innerHTML = '';
                if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) node.removeChild(this.extraNode);
                [
                    'transition',
                    'animation'
                ].forEach(function(name) {
                    node.removeEventListener("".concat(name, "start"), _this2.onTransitionStart);
                    node.removeEventListener("".concat(name, "end"), _this2.onTransitionEnd);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), null, this.renderWave);
            }
        }
    ]);
    return Wave;
}($acw62.Component);
$4efa89abfa6bbc97$var$Wave.contextType = (0, $a18b2f6f56546238$export$a92f85ab3e9ad68b);
var $4efa89abfa6bbc97$export$2e2bcd8739ae039 = $4efa89abfa6bbc97$var$Wave;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $981d7d04085c8929$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $981d7d04085c8929$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $acw62.createContext(undefined);
var $981d7d04085c8929$var$ButtonGroup = function ButtonGroup(props) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, size = props.size, className = props.className, others = $981d7d04085c8929$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    var prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    // large => lg
    // small => sm
    var sizeCls = '';
    switch(size){
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        case 'middle':
        case undefined:
            break;
        default:
    }
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $acw62.createElement($981d7d04085c8929$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, others, {
        className: classes
    })));
};
var $981d7d04085c8929$export$2e2bcd8739ae039 = $981d7d04085c8929$var$ButtonGroup;




var $8iiJy = parcelRequire("8iiJy");

var $acw62 = parcelRequire("acw62");
var $7597853c34b57de5$var$getCollapsedWidth = function getCollapsedWidth() {
    return {
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    };
};
var $7597853c34b57de5$var$getRealWidth = function getRealWidth(node) {
    return {
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    };
};
var $7597853c34b57de5$var$LoadingIcon = function LoadingIcon(_ref) {
    var prefixCls = _ref.prefixCls, loading = _ref.loading, existIcon = _ref.existIcon;
    var visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "".concat(prefixCls, "-loading-icon")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $43383ed7d2a91124$export$2e2bcd8739ae039), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8iiJy.default), {
        visible: visible,
        // We do not really use this motionName
        motionName: "".concat(prefixCls, "-loading-icon-motion"),
        removeOnLeave: true,
        onAppearStart: $7597853c34b57de5$var$getCollapsedWidth,
        onAppearActive: $7597853c34b57de5$var$getRealWidth,
        onEnterStart: $7597853c34b57de5$var$getCollapsedWidth,
        onEnterActive: $7597853c34b57de5$var$getRealWidth,
        onLeaveStart: $7597853c34b57de5$var$getRealWidth,
        onLeaveActive: $7597853c34b57de5$var$getCollapsedWidth
    }, function(_ref2, ref) {
        var className = _ref2.className, style = _ref2.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(prefixCls, "-loading-icon"),
            style: style,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $43383ed7d2a91124$export$2e2bcd8739ae039), {
            className: className
        }));
    });
};
var $7597853c34b57de5$export$2e2bcd8739ae039 = $7597853c34b57de5$var$LoadingIcon;


var $c6609c7ee777e096$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c6609c7ee777e096$var$rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var $c6609c7ee777e096$var$isTwoCNChar = $c6609c7ee777e096$var$rxTwoCNChar.test.bind($c6609c7ee777e096$var$rxTwoCNChar);
function $c6609c7ee777e096$var$isString(str) {
    return typeof str === 'string';
}
function $c6609c7ee777e096$var$isUnBorderedButtonType(type) {
    return type === 'text' || type === 'link';
}
// Insert one space between two chinese characters automatically.
function $c6609c7ee777e096$var$insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child === null || child === undefined) return;
    var SPACE = needInserted ? ' ' : '';
    // strictNullChecks oops.
    if (typeof child !== 'string' && typeof child !== 'number' && $c6609c7ee777e096$var$isString(child.type) && $c6609c7ee777e096$var$isTwoCNChar(child.props.children)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        children: child.props.children.split('').join(SPACE)
    });
    if (typeof child === 'string') return $c6609c7ee777e096$var$isTwoCNChar(child) ? /*#__PURE__*/ $acw62.createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/ $acw62.createElement("span", null, child);
    if ((0, $30796c32f374b477$export$9522e17588c12572)(child)) return /*#__PURE__*/ $acw62.createElement("span", null, child);
    return child;
}
function $c6609c7ee777e096$var$spaceChildren(children, needInserted) {
    var isPrevChildPure = false;
    var childList = [];
    $acw62.Children.forEach(children, function(child) {
        var type = (0, $fSwVM.default)(child);
        var isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            var lastIndex = childList.length - 1;
            var lastChild = childList[lastIndex];
            childList[lastIndex] = "".concat(lastChild).concat(child);
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    // Pass to React.Children.map to auto fill key
    return $acw62.Children.map(childList, function(child) {
        return $c6609c7ee777e096$var$insertSpace(child, needInserted);
    });
}
var $c6609c7ee777e096$var$ButtonTypes = (0, $1ee8868d1993c67b$export$65e3907585753458)('default', 'primary', 'ghost', 'dashed', 'link', 'text');
var $c6609c7ee777e096$var$ButtonShapes = (0, $1ee8868d1993c67b$export$65e3907585753458)('default', 'circle', 'round');
var $c6609c7ee777e096$var$ButtonHTMLTypes = (0, $1ee8868d1993c67b$export$65e3907585753458)('submit', 'button', 'reset');
function $c6609c7ee777e096$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
var $c6609c7ee777e096$var$InternalButton = function InternalButton(props, ref) {
    var _classNames;
    var _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? 'default' : _props$type, danger = props.danger, _props$shape = props.shape, shape = _props$shape === void 0 ? 'default' : _props$shape, customizeSize = props.size, customDisabled = props.disabled, className = props.className, children = props.children, icon = props.icon, _props$ghost = props.ghost, ghost = _props$ghost === void 0 ? false : _props$ghost, _props$block = props.block, block = _props$block === void 0 ? false : _props$block, _props$htmlType = props.htmlType, htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType, rest = $c6609c7ee777e096$var$__rest(props, [
        "loading",
        "prefixCls",
        "type",
        "danger",
        "shape",
        "size",
        "disabled",
        "className",
        "children",
        "icon",
        "ghost",
        "block",
        "htmlType"
    ]);
    var size = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    // ===================== Disabled =====================
    var disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var groupSize = $acw62.useContext((0, $981d7d04085c8929$export$ed0cc8bd1f617d6d));
    var _React$useState = $acw62.useState(!!loading), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerLoading = _React$useState2[0], setLoading = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), hasTwoCNChar = _React$useState4[0], setHasTwoCNChar = _React$useState4[1];
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, autoInsertSpaceInButton = _React$useContext.autoInsertSpaceInButton, direction = _React$useContext.direction;
    var buttonRef = ref || /*#__PURE__*/ $acw62.createRef();
    var isNeedInserted = function isNeedInserted() {
        return $acw62.Children.count(children) === 1 && !icon && !$c6609c7ee777e096$var$isUnBorderedButtonType(type);
    };
    var fixTwoCNChar = function fixTwoCNChar() {
        // Fix for HOC usage like <FormatMessage />
        if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) return;
        var buttonText = buttonRef.current.textContent;
        if (isNeedInserted() && $c6609c7ee777e096$var$isTwoCNChar(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    };
    // =============== Update Loading ===============
    var loadingOrDelay = typeof loading === 'boolean' ? loading : (loading === null || loading === void 0 ? void 0 : loading.delay) || true;
    $acw62.useEffect(function() {
        var delayTimer = null;
        if (typeof loadingOrDelay === 'number') delayTimer = window.setTimeout(function() {
            delayTimer = null;
            setLoading(loadingOrDelay);
        }, loadingOrDelay);
        else setLoading(loadingOrDelay);
        return function() {
            if (delayTimer) {
                // in order to not perform a React state update on an unmounted component
                // and clear timer after 'loadingOrDelay' updated.
                window.clearTimeout(delayTimer);
                delayTimer = null;
            }
        };
    }, [
        loadingOrDelay
    ]);
    $acw62.useEffect(fixTwoCNChar, [
        buttonRef
    ]);
    var handleClick = function handleClick(e) {
        var onClick = props.onClick;
        // https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    var prefixCls = getPrefixCls('btn', customizePrefixCls);
    var autoInsertSpace = autoInsertSpaceInButton !== false;
    var _useCompactItemContex = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    var sizeFullname = compactSize || groupSize || customizeSize || size;
    var sizeCls = sizeFullname ? sizeClassNameMap[sizeFullname] || '' : '';
    var iconType = innerLoading ? 'loading' : icon;
    var linkButtonRestProps = (0, $1pcHX.default)(rest, [
        'navigate'
    ]);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (_classNames = {}, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-").concat(shape), shape !== 'default' && shape), "".concat(prefixCls, "-").concat(type), type), "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-icon-only"), !children && children !== 0 && !!iconType), "".concat(prefixCls, "-background-ghost"), ghost && !$c6609c7ee777e096$var$isUnBorderedButtonType(type)), "".concat(prefixCls, "-loading"), innerLoading), "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace && !innerLoading), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-dangerous"), !!danger), "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-disabled"), linkButtonRestProps.href !== undefined && mergedDisabled)), compactItemClassnames, className);
    var iconNode = icon && !innerLoading ? icon : /*#__PURE__*/ $acw62.createElement((0, $7597853c34b57de5$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: !!innerLoading
    });
    var kids = children || children === 0 ? $c6609c7ee777e096$var$spaceChildren(children, isNeedInserted() && autoInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ $acw62.createElement("a", (0, $8nd05.default)({}, linkButtonRestProps, {
        className: classes,
        onClick: handleClick,
        ref: buttonRef
    }), iconNode, kids);
    var buttonNode = /*#__PURE__*/ $acw62.createElement("button", (0, $8nd05.default)({}, rest, {
        type: htmlType,
        className: classes,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: buttonRef
    }), iconNode, kids);
    if ($c6609c7ee777e096$var$isUnBorderedButtonType(type)) return buttonNode;
    return /*#__PURE__*/ $acw62.createElement((0, $4efa89abfa6bbc97$export$2e2bcd8739ae039), {
        disabled: !!innerLoading
    }, buttonNode);
};
var $c6609c7ee777e096$var$Button = /*#__PURE__*/ $acw62.forwardRef($c6609c7ee777e096$var$InternalButton);
$c6609c7ee777e096$var$Button.Group = (0, $981d7d04085c8929$export$2e2bcd8739ae039);
$c6609c7ee777e096$var$Button.__ANT_BUTTON = true;
var $c6609c7ee777e096$export$2e2bcd8739ae039 = $c6609c7ee777e096$var$Button;


var $3929aafb948ac62c$export$2e2bcd8739ae039 = (0, $c6609c7ee777e096$export$2e2bcd8739ae039);


var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");
parcelRequire("8a8Nr");
var $144QO = parcelRequire("144QO");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");
var $ad5d550b51ac8abd$export$c24727297075ec6a = /*#__PURE__*/ $acw62.createContext({
    labelAlign: 'right',
    vertical: false,
    itemRef: function itemRef() {}
});
var $ad5d550b51ac8abd$export$d718247e9f9b0b9e = /*#__PURE__*/ $acw62.createContext(null);
var $ad5d550b51ac8abd$export$8ce1ff4f94d08846 = function FormProvider(props) {
    var providerProps = (0, $1pcHX.default)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $144QO.FormProvider), (0, $8nd05.default)({}, providerProps));
};
var $ad5d550b51ac8abd$export$fb6582d3042cc879 = /*#__PURE__*/ $acw62.createContext({
    prefixCls: ''
});
var $ad5d550b51ac8abd$export$bbb5553c6c7a14ed = /*#__PURE__*/ $acw62.createContext({});
var $ad5d550b51ac8abd$export$80e4c53cb85dcab1 = function NoFormStyle(_ref) {
    var children = _ref.children, status = _ref.status, override = _ref.override;
    var formItemInputContext = (0, $acw62.useContext)($ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
    var newFormItemInputContext = (0, $acw62.useMemo)(function() {
        var newContext = (0, $8nd05.default)({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $acw62.createElement($ad5d550b51ac8abd$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};


var $ae15c91e7f32cbed$var$Group = function Group(props) {
    var _useContext = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-lg"), props.size === 'large'), "".concat(prefixCls, "-sm"), props.size === 'small'), "".concat(prefixCls, "-compact"), props.compact), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var formItemContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    var groupFormItemContext = (0, $acw62.useMemo)(function() {
        return (0, $8nd05.default)((0, $8nd05.default)({}, formItemContext), {
            isFormItemInput: false
        });
    }, [
        formItemContext
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, props.children));
};
var $ae15c91e7f32cbed$export$2e2bcd8739ae039 = $ae15c91e7f32cbed$var$Group;



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");


var $8g1PZ = parcelRequire("8g1PZ");

var $cGjF0 = parcelRequire("cGjF0");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");






var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $67f89d06f52454a6$var$InputStatuses = (0, $1ee8868d1993c67b$export$65e3907585753458)('warning', 'error', '');
function $67f89d06f52454a6$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-status-success"), status === 'success'), "".concat(prefixCls, "-status-warning"), status === 'warning'), "".concat(prefixCls, "-status-error"), status === 'error'), "".concat(prefixCls, "-status-validating"), status === 'validating'), "".concat(prefixCls, "-has-feedback"), hasFeedback));
}
var $67f89d06f52454a6$export$314e193082d7ba49 = function getMergedStatus(contextStatus, customStatus) {
    return customStatus || contextStatus;
};




var $acw62 = parcelRequire("acw62");
function $e424ea760f35b51a$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    var removePasswordTimeoutRef = (0, $acw62.useRef)([]);
    var removePasswordTimeout = function removePasswordTimeout() {
        removePasswordTimeoutRef.current.push(setTimeout(function() {
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute('value');
        }));
    };
    (0, $acw62.useEffect)(function() {
        if (triggerOnMount) removePasswordTimeout();
        return function() {
            return removePasswordTimeoutRef.current.forEach(function(timer) {
                if (timer) clearTimeout(timer);
            });
        };
    }, []);
    return removePasswordTimeout;
}


// eslint-disable-next-line import/prefer-default-export
function $23144ccd376634c7$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}


var $538df197b854e6d1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $538df197b854e6d1$export$ef94f7f24276a29c(value) {
    if (typeof value === 'undefined' || value === null) return '';
    return String(value);
}
function $538df197b854e6d1$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true);
        // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = '';
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $538df197b854e6d1$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
                break;
        }
    }
}
var $538df197b854e6d1$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var customizePrefixCls = props.prefixCls, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, customStatus = props.status, customSize = props.size, customDisabled = props.disabled, onBlur = props.onBlur, onFocus = props.onFocus, suffix = props.suffix, allowClear = props.allowClear, addonAfter = props.addonAfter, addonBefore = props.addonBefore, className = props.className, onChange = props.onChange, rest = $538df197b854e6d1$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "onChange"
    ]);
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, input = _React$useContext.input;
    var prefixCls = getPrefixCls('input', customizePrefixCls);
    var inputRef = (0, $acw62.useRef)(null);
    // ===================== Compact Item =====================
    var _useCompactItemContex = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    // ===================== Size =====================
    var size = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    var mergedSize = compactSize || customSize || size;
    // ===================== Disabled =====================
    var disabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    var _useContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed)), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    var inputHasPrefixSuffix = (0, $23144ccd376634c7$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    var prevHasPrefixSuffix = (0, $acw62.useRef)(inputHasPrefixSuffix);
    (0, $acw62.useEffect)(function() {
        var _a;
        inputHasPrefixSuffix && prevHasPrefixSuffix.current;
        prevHasPrefixSuffix.current = inputHasPrefixSuffix;
    }, [
        inputHasPrefixSuffix
    ]);
    // ===================== Remove Password value =====================
    var removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef, true);
    var handleBlur = function handleBlur(e) {
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleChange = function handleChange(e) {
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    var suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    // Allow clear
    var mergedAllowClear;
    if ((0, $fSwVM.default)(allowClear) === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2bf1c25862f513c2$export$2e2bcd8739ae039), null)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cGjF0.default), (0, $8nd05.default)({
        ref: (0, $85dLH.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled || undefined,
        onBlur: handleBlur,
        onFocus: handleFocus,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, compactItemClassnames),
        onChange: handleChange,
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26050ef76e24a749$export$5f56e610a4afb685), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad5d550b51ac8abd$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonAfter)),
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26050ef76e24a749$export$5f56e610a4afb685), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad5d550b51ac8abd$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonBefore)),
        inputClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-sm"), mergedSize === 'small'), "".concat(prefixCls, "-lg"), mergedSize === 'large'), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-borderless"), !bordered), !inputHasPrefixSuffix && (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
        affixWrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-affix-wrapper-sm"), mergedSize === 'small'), "".concat(prefixCls, "-affix-wrapper-lg"), mergedSize === 'large'), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), (0, $67f89d06f52454a6$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback)),
        wrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-group-rtl"), direction === 'rtl')),
        groupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-group-wrapper-sm"), mergedSize === 'small'), "".concat(prefixCls, "-group-wrapper-lg"), mergedSize === 'large'), "".concat(prefixCls, "-group-wrapper-rtl"), direction === 'rtl'), (0, $67f89d06f52454a6$export$b08e7b47149942a2)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback))
    }));
});
var $538df197b854e6d1$export$2e2bcd8739ae039 = $538df197b854e6d1$var$Input;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $70c4e92fea0b3f8a$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $70c4e92fea0b3f8a$export$2e2bcd8739ae039 = $70c4e92fea0b3f8a$var$EyeInvisibleOutlined;



var $5a167f01f9ec60a8$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $70c4e92fea0b3f8a$export$2e2bcd8739ae039)
    }));
};
var $5a167f01f9ec60a8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($5a167f01f9ec60a8$var$EyeInvisibleOutlined);
var $5a167f01f9ec60a8$export$2e2bcd8739ae039 = $5a167f01f9ec60a8$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b7bc758130af6b02$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $b7bc758130af6b02$export$2e2bcd8739ae039 = $b7bc758130af6b02$var$EyeOutlined;



var $427c1c236575f44d$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $b7bc758130af6b02$export$2e2bcd8739ae039)
    }));
};
var $427c1c236575f44d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($427c1c236575f44d$var$EyeOutlined);
var $427c1c236575f44d$export$2e2bcd8739ae039 = $427c1c236575f44d$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");



var $27b11b4fcd97a00b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $27b11b4fcd97a00b$var$defaultIconRender = function defaultIconRender(visible) {
    return visible ? /*#__PURE__*/ $acw62.createElement((0, $427c1c236575f44d$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $5a167f01f9ec60a8$export$2e2bcd8739ae039), null);
};
var $27b11b4fcd97a00b$var$ActionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
var $27b11b4fcd97a00b$var$Password = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _props$visibilityTogg = props.visibilityToggle, visibilityToggle = _props$visibilityTogg === void 0 ? true : _props$visibilityTogg;
    var visibilityControlled = (0, $fSwVM.default)(visibilityToggle) === 'object' && visibilityToggle.visible !== undefined;
    var _useState = (0, $acw62.useState)(function() {
        return visibilityControlled ? visibilityToggle.visible : false;
    }), _useState2 = (0, $eUqlC.default)(_useState, 2), visible = _useState2[0], setVisible = _useState2[1];
    var inputRef = (0, $acw62.useRef)(null);
    $acw62.useEffect(function() {
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    var removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef);
    var onVisibleChange = function onVisibleChange() {
        var disabled = props.disabled;
        if (disabled) return;
        if (visible) removePasswordTimeout();
        setVisible(function(prevState) {
            var _a;
            var newState = !prevState;
            if ((0, $fSwVM.default)(visibilityToggle) === 'object') (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, newState);
            return newState;
        });
    };
    var getIcon = function getIcon(prefixCls) {
        var _props$action = props.action, action = _props$action === void 0 ? 'click' : _props$action, _props$iconRender = props.iconRender, iconRender = _props$iconRender === void 0 ? $27b11b4fcd97a00b$var$defaultIconRender : _props$iconRender;
        var iconTrigger = $27b11b4fcd97a00b$var$ActionMap[action] || '';
        var icon = iconRender(visible);
        var iconProps = (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, iconTrigger, onVisibleChange), "className", "".concat(prefixCls, "-icon")), "key", 'passwordIcon'), "onMouseDown", function onMouseDown(e) {
            // Prevent focused state lost
            // https://github.com/ant-design/ant-design/issues/15173
            e.preventDefault();
        }), "onMouseUp", function onMouseUp(e) {
            // Prevent caret position change
            // https://github.com/ant-design/ant-design/issues/23524
            e.preventDefault();
        });
        return /*#__PURE__*/ $acw62.cloneElement(/*#__PURE__*/ $acw62.isValidElement(icon) ? icon : /*#__PURE__*/ $acw62.createElement("span", null, icon), iconProps);
    };
    var renderPassword = function renderPassword(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var className = props.className, customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, size = props.size, restProps = $27b11b4fcd97a00b$var$__rest(props, [
            "className",
            "prefixCls",
            "inputPrefixCls",
            "size"
        ]);
        var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
        var prefixCls = getPrefixCls('input-password', customizePrefixCls);
        var suffixIcon = visibilityToggle && getIcon(prefixCls);
        var inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(size), !!size));
        var omittedProps = (0, $8nd05.default)((0, $8nd05.default)({}, (0, $1pcHX.default)(restProps, [
            'suffix',
            'iconRender',
            'visibilityToggle'
        ])), {
            type: visible ? 'text' : 'password',
            className: inputClassName,
            prefixCls: inputPrefixCls,
            suffix: suffixIcon
        });
        if (size) omittedProps.size = size;
        return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), (0, $8nd05.default)({
            ref: (0, $85dLH.composeRef)(ref, inputRef)
        }, omittedProps));
    };
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), null, renderPassword);
});
var $27b11b4fcd97a00b$export$2e2bcd8739ae039 = $27b11b4fcd97a00b$var$Password;



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $86af1367b2b71ab8$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $86af1367b2b71ab8$export$2e2bcd8739ae039 = $86af1367b2b71ab8$var$SearchOutlined;



var $2917d4d4b4ce8eca$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $86af1367b2b71ab8$export$2e2bcd8739ae039)
    }));
};
var $2917d4d4b4ce8eca$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2917d4d4b4ce8eca$var$SearchOutlined);
var $2917d4d4b4ce8eca$export$2e2bcd8739ae039 = $2917d4d4b4ce8eca$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");






var $22717f99dfeb0b1a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $22717f99dfeb0b1a$var$Search = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, className = props.className, customizeSize = props.size, suffix = props.suffix, _props$enterButton = props.enterButton, enterButton = _props$enterButton === void 0 ? false : _props$enterButton, addonAfter = props.addonAfter, loading = props.loading, disabled = props.disabled, customOnSearch = props.onSearch, customOnChange = props.onChange, onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, restProps = $22717f99dfeb0b1a$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var contextSize = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    var composedRef = $acw62.useRef(false);
    var prefixCls = getPrefixCls('input-search', customizePrefixCls);
    var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    var _useCompactItemContex = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize;
    var size = compactSize || customizeSize || contextSize;
    var inputRef = $acw62.useRef(null);
    var onChange = function onChange(e) {
        if (e && e.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e);
        if (customOnChange) customOnChange(e);
    };
    var onMouseDown = function onMouseDown(e) {
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    var onSearch = function onSearch(e) {
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e);
    };
    var onPressEnter = function onPressEnter(e) {
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    var searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $acw62.createElement((0, $2917d4d4b4ce8eca$export$2e2bcd8739ae039), null) : null;
    var btnClassName = "".concat(prefixCls, "-button");
    var button;
    var enterButtonAsElement = enterButton || {};
    var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $30796c32f374b477$export$e530037191fcd5d7)(enterButtonAsElement, (0, $8nd05.default)({
        onMouseDown: onMouseDown,
        onClick: function onClick(e) {
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: 'enterButton'
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        className: btnClassName,
        type: enterButton ? 'primary' : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $30796c32f374b477$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(size), !!size), "".concat(prefixCls, "-with-button"), !!enterButton), className);
    var handleOnCompositionStart = function handleOnCompositionStart(e) {
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var handleOnCompositionEnd = function handleOnCompositionEnd(e) {
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), (0, $8nd05.default)({
        ref: (0, $85dLH.composeRef)(inputRef, ref),
        onPressEnter: onPressEnter
    }, restProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        prefixCls: inputPrefixCls,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        className: cls,
        disabled: disabled
    }));
});
var $22717f99dfeb0b1a$export$2e2bcd8739ae039 = $22717f99dfeb0b1a$var$Search;



var $fSwVM = parcelRequire("fSwVM");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $8g1PZ = parcelRequire("8g1PZ");

var $4GwQn = parcelRequire("4GwQn");

var $iSQh8 = parcelRequire("iSQh8");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");






var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $9715X = parcelRequire("9715X");

var $fhGLX = parcelRequire("fhGLX");

var $jDKKo = parcelRequire("jDKKo");

var $1gYAD = parcelRequire("1gYAD");


var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");




function $3c9de83923f7c273$var$_callSuper(t, o, e) {
    return o = (0, $jDKKo.default)(o), (0, $9715X.default)(t, (0, $fhGLX.default)() ? Reflect.construct(o, e || [], (0, $jDKKo.default)(t).constructor) : o.apply(t, e));
}
var $3c9de83923f7c273$var$ClearableInputType = (0, $1ee8868d1993c67b$export$65e3907585753458)('text', 'input');
function $3c9de83923f7c273$var$hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
var $3c9de83923f7c273$var$ClearableLabeledInput = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(ClearableLabeledInput, _React$Component);
    function ClearableLabeledInput() {
        (0, $6CZeq.default)(this, ClearableLabeledInput);
        return $3c9de83923f7c273$var$_callSuper(this, ClearableLabeledInput, arguments);
    }
    (0, $cHPF9.default)(ClearableLabeledInput, [
        {
            key: "renderClearIcon",
            value: function renderClearIcon(prefixCls) {
                var _this$props = this.props, value = _this$props.value, disabled = _this$props.disabled, readOnly = _this$props.readOnly, handleReset = _this$props.handleReset, suffix = _this$props.suffix;
                var needClear = !disabled && !readOnly && value;
                var className = "".concat(prefixCls, "-clear-icon");
                return /*#__PURE__*/ $acw62.createElement((0, $2bf1c25862f513c2$export$2e2bcd8739ae039), {
                    onClick: handleReset,
                    // Do not trigger onBlur when clear input
                    // https://github.com/ant-design/ant-design/issues/31200
                    onMouseDown: function onMouseDown(e) {
                        return e.preventDefault();
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(className, "-hidden"), !needClear), "".concat(className, "-has-suffix"), !!suffix), className),
                    role: "button"
                });
            }
        },
        {
            key: "renderTextAreaWithClearIcon",
            value: function renderTextAreaWithClearIcon(prefixCls, element, statusContext) {
                var _this$props2 = this.props, value = _this$props2.value, allowClear = _this$props2.allowClear, className = _this$props2.className, focused = _this$props2.focused, style = _this$props2.style, direction = _this$props2.direction, bordered = _this$props2.bordered, hidden = _this$props2.hidden, customStatus = _this$props2.status;
                var contextStatus = statusContext.status, hasFeedback = statusContext.hasFeedback;
                if (!allowClear) return (0, $30796c32f374b477$export$e530037191fcd5d7)(element, {
                    value: value
                });
                var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"), (0, $67f89d06f52454a6$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-affix-wrapper-focused"), focused), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), "".concat(className), !$3c9de83923f7c273$var$hasAddon(this.props) && className));
                return /*#__PURE__*/ $acw62.createElement("span", {
                    className: affixWrapperCls,
                    style: style,
                    hidden: hidden
                }, (0, $30796c32f374b477$export$e530037191fcd5d7)(element, {
                    style: null,
                    value: value
                }), this.renderClearIcon(prefixCls));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Consumer, null, function(statusContext) {
                    var _this$props3 = _this.props, prefixCls = _this$props3.prefixCls, inputType = _this$props3.inputType, element = _this$props3.element;
                    if (inputType === $3c9de83923f7c273$var$ClearableInputType[0]) return _this.renderTextAreaWithClearIcon(prefixCls, element, statusContext);
                });
            }
        }
    ]);
    return ClearableLabeledInput;
}($acw62.Component);
var $3c9de83923f7c273$export$2e2bcd8739ae039 = $3c9de83923f7c273$var$ClearableLabeledInput;



var $fc29eec8796e8593$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $fc29eec8796e8593$var$fixEmojiLength(value, maxLength) {
    return (0, $kbxxf.default)(value || '').slice(0, maxLength).join('');
}
function $fc29eec8796e8593$var$setTriggerValue(isCursorInEnd, preValue, triggerValue, maxLength) {
    var newTriggerValue = triggerValue;
    if (isCursorInEnd) // 光标在尾部，直接截断
    newTriggerValue = $fc29eec8796e8593$var$fixEmojiLength(triggerValue, maxLength);
    else if ((0, $kbxxf.default)(preValue || '').length < triggerValue.length && (0, $kbxxf.default)(triggerValue || '').length > maxLength) // 光标在中间，如果最后的值超过最大值，则采用原先的值
    newTriggerValue = preValue;
    return newTriggerValue;
}
var $fc29eec8796e8593$var$TextArea = /*#__PURE__*/ $acw62.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, _a$showCount = _a.showCount, showCount = _a$showCount === void 0 ? false : _a$showCount, maxLength = _a.maxLength, className = _a.className, style = _a.style, customizeSize = _a.size, customDisabled = _a.disabled, onCompositionStart = _a.onCompositionStart, onCompositionEnd = _a.onCompositionEnd, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, customStatus = _a.status, props = $fc29eec8796e8593$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "showCount",
        "maxLength",
        "className",
        "style",
        "size",
        "disabled",
        "onCompositionStart",
        "onCompositionEnd",
        "onChange",
        "onFocus",
        "onBlur",
        "status"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    // ===================== Disabled =====================
    var disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var _React$useContext2 = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed)), contextStatus = _React$useContext2.status, hasFeedback = _React$useContext2.hasFeedback, isFormItemInput = _React$useContext2.isFormItemInput, feedbackIcon = _React$useContext2.feedbackIcon;
    var mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    var innerRef = $acw62.useRef(null);
    var clearableInputRef = $acw62.useRef(null);
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), compositing = _React$useState2[0], setCompositing = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), focused = _React$useState4[0], setFocused = _React$useState4[1];
    var oldCompositionValueRef = $acw62.useRef();
    var oldSelectionStartRef = $acw62.useRef(0);
    var _useMergedState = (0, $iSQh8.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var hidden = props.hidden;
    var handleSetValue = function handleSetValue(val, callback) {
        if (props.value === undefined) {
            setValue(val);
            callback === null || callback === void 0 || callback();
        }
    };
    // =========================== Value Update ===========================
    // Max length value
    var hasMaxLength = Number(maxLength) > 0;
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        setCompositing(true);
        // 拼音输入前保存一份旧值
        oldCompositionValueRef.current = value;
        // 保存旧的光标位置
        oldSelectionStartRef.current = e.currentTarget.selectionStart;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        var _a;
        setCompositing(false);
        var triggerValue = e.currentTarget.value;
        if (hasMaxLength) {
            var isCursorInEnd = oldSelectionStartRef.current >= maxLength + 1 || oldSelectionStartRef.current === ((_a = oldCompositionValueRef.current) === null || _a === void 0 ? void 0 : _a.length);
            triggerValue = $fc29eec8796e8593$var$setTriggerValue(isCursorInEnd, oldCompositionValueRef.current, triggerValue, maxLength);
        }
        // Patch composition onChange when value changed
        if (triggerValue !== value) {
            handleSetValue(triggerValue);
            (0, $538df197b854e6d1$export$c28984794956ddc0)(e.currentTarget, e, onChange, triggerValue);
        }
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleChange = function handleChange(e) {
        var triggerValue = e.target.value;
        if (!compositing && hasMaxLength) {
            // 1. 复制粘贴超过maxlength的情况 2.未超过maxlength的情况
            var isCursorInEnd = e.target.selectionStart >= maxLength + 1 || e.target.selectionStart === triggerValue.length || !e.target.selectionStart;
            triggerValue = $fc29eec8796e8593$var$setTriggerValue(isCursorInEnd, value, triggerValue, maxLength);
        }
        handleSetValue(triggerValue);
        (0, $538df197b854e6d1$export$c28984794956ddc0)(e.currentTarget, e, onChange, triggerValue);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    $acw62.useEffect(function() {
        setFocused(function(prev) {
            return !mergedDisabled && prev;
        });
    }, [
        mergedDisabled
    ]);
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        var _a, _b, _c;
        handleSetValue('');
        (_a = innerRef.current) === null || _a === void 0 || _a.focus();
        (0, $538df197b854e6d1$export$c28984794956ddc0)((_c = (_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.resizableTextArea) === null || _c === void 0 ? void 0 : _c.textArea, e, onChange);
    };
    var prefixCls = getPrefixCls('input', customizePrefixCls);
    $acw62.useImperativeHandle(ref, function() {
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: function focus(option) {
                var _a, _b;
                (0, $538df197b854e6d1$export$2b92016deb0b7aad)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: function blur() {
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    var textArea = /*#__PURE__*/ $acw62.createElement((0, $4GwQn.default), (0, $8nd05.default)({}, (0, $1pcHX.default)(props, [
        'allowClear'
    ]), {
        disabled: mergedDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-borderless"), !bordered), className, className && !showCount), "".concat(prefixCls, "-sm"), size === 'small' || customizeSize === 'small'), "".concat(prefixCls, "-lg"), size === 'large' || customizeSize === 'large'), (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
        style: showCount ? {
            resize: style === null || style === void 0 ? void 0 : style.resize
        } : style,
        prefixCls: prefixCls,
        onCompositionStart: onInternalCompositionStart,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onCompositionEnd: onInternalCompositionEnd,
        ref: innerRef
    }));
    var val = (0, $538df197b854e6d1$export$ef94f7f24276a29c)(value);
    if (!compositing && hasMaxLength && (props.value === null || props.value === undefined)) // fix #27612 将value转为数组进行截取，解决 '😂'.length === 2 等emoji表情导致的截取乱码的问题
    val = $fc29eec8796e8593$var$fixEmojiLength(val, maxLength);
    // TextArea
    var textareaNode = /*#__PURE__*/ $acw62.createElement((0, $3c9de83923f7c273$export$2e2bcd8739ae039), (0, $8nd05.default)({
        disabled: mergedDisabled,
        focused: focused
    }, props, {
        prefixCls: prefixCls,
        direction: direction,
        inputType: "text",
        value: val,
        element: textArea,
        handleReset: handleReset,
        ref: clearableInputRef,
        bordered: bordered,
        status: customStatus,
        style: showCount ? undefined : style
    }));
    // Only show text area wrapper when needed
    if (showCount || hasFeedback) {
        var valueLength = (0, $kbxxf.default)(val).length;
        var dataCount = '';
        if ((0, $fSwVM.default)(showCount) === 'object') dataCount = showCount.formatter({
            value: val,
            count: valueLength,
            maxLength: maxLength
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : '');
        return /*#__PURE__*/ $acw62.createElement("div", {
            hidden: hidden,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-textarea"), (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-textarea-rtl"), direction === 'rtl'), "".concat(prefixCls, "-textarea-show-count"), showCount), "".concat(prefixCls, "-textarea-in-form-item"), isFormItemInput), (0, $67f89d06f52454a6$export$b08e7b47149942a2)("".concat(prefixCls, "-textarea"), mergedStatus, hasFeedback), className),
            style: style,
            "data-count": dataCount
        }, textareaNode, hasFeedback && /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-textarea-suffix")
        }, feedbackIcon));
    }
    return textareaNode;
});
var $fc29eec8796e8593$export$2e2bcd8739ae039 = $fc29eec8796e8593$var$TextArea;


var $ad70426818bb52aa$var$Input = (0, $538df197b854e6d1$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Group = (0, $ae15c91e7f32cbed$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Search = (0, $22717f99dfeb0b1a$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.TextArea = (0, $fc29eec8796e8593$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Password = (0, $27b11b4fcd97a00b$export$2e2bcd8739ae039);
var $ad70426818bb52aa$export$2e2bcd8739ae039 = $ad70426818bb52aa$var$Input;


var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $jWR62 = parcelRequire("jWR62");

var $acw62 = parcelRequire("acw62");


var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $h4v51 = parcelRequire("h4v51");

var $7N6Vd = parcelRequire("7N6Vd");
var $ebcf30cec053af5e$export$7dbdadf5e9653129 = function canUseDocElement() {
    return (0, $h4v51.default)() && window.document.documentElement;
};
var $ebcf30cec053af5e$var$flexGapSupported;
var $ebcf30cec053af5e$export$bb61d27183d1477 = function detectFlexGapSupported() {
    if (!$ebcf30cec053af5e$export$7dbdadf5e9653129()) return false;
    if ($ebcf30cec053af5e$var$flexGapSupported !== undefined) return $ebcf30cec053af5e$var$flexGapSupported;
    // create flex container with row-gap set
    var flex = document.createElement('div');
    flex.style.display = 'flex';
    flex.style.flexDirection = 'column';
    flex.style.rowGap = '1px';
    // create two, elements inside it
    flex.appendChild(document.createElement('div'));
    flex.appendChild(document.createElement('div'));
    // append to the DOM (needed to obtain scrollHeight)
    document.body.appendChild(flex);
    $ebcf30cec053af5e$var$flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
    document.body.removeChild(flex);
    return $ebcf30cec053af5e$var$flexGapSupported;
};


var $b8b58c41c88f1d25$export$2e2bcd8739ae039 = function() {
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), flexible = _React$useState2[0], setFlexible = _React$useState2[1];
    $acw62.useEffect(function() {
        setFlexible((0, $ebcf30cec053af5e$export$bb61d27183d1477)());
    }, []);
    return flexible;
};



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

function $a9129d7ad0e59df6$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, direction = _ref.direction, index = _ref.index, marginDirection = _ref.marginDirection, children = _ref.children, split = _ref.split, wrap = _ref.wrap;
    var _React$useContext = $acw62.useContext((0, $8f666b0c5cd58c95$export$853f607fd5cc208b)), horizontalSize = _React$useContext.horizontalSize, verticalSize = _React$useContext.verticalSize, latestIndex = _React$useContext.latestIndex, supportFlexGap = _React$useContext.supportFlexGap;
    var style = {};
    if (!supportFlexGap) {
        if (direction === 'vertical') {
            if (index < latestIndex) style = {
                marginBottom: horizontalSize / (split ? 2 : 1)
            };
        } else style = (0, $8nd05.default)((0, $8nd05.default)({}, index < latestIndex && (0, $kSlfw.default)({}, marginDirection, horizontalSize / (split ? 2 : 1))), wrap && {
            paddingBottom: verticalSize
        });
    }
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && split && /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(className, "-split"),
        style: style
    }, split));
}



var $8f666b0c5cd58c95$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8f666b0c5cd58c95$export$853f607fd5cc208b = /*#__PURE__*/ $acw62.createContext({
    latestIndex: 0,
    horizontalSize: 0,
    verticalSize: 0,
    supportFlexGap: false
});
var $8f666b0c5cd58c95$var$spaceSize = {
    small: 8,
    middle: 16,
    large: 24
};
function $8f666b0c5cd58c95$var$getNumberSize(size) {
    return typeof size === 'string' ? $8f666b0c5cd58c95$var$spaceSize[size] : size || 0;
}
var $8f666b0c5cd58c95$var$Space = function Space(props) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, space = _React$useContext.space, directionConfig = _React$useContext.direction;
    var _props$size = props.size, size = _props$size === void 0 ? (space === null || space === void 0 ? void 0 : space.size) || 'small' : _props$size, align = props.align, className = props.className, children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'horizontal' : _props$direction, customizePrefixCls = props.prefixCls, split = props.split, style = props.style, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? false : _props$wrap, otherProps = $8f666b0c5cd58c95$var$__rest(props, [
        "size",
        "align",
        "className",
        "children",
        "direction",
        "prefixCls",
        "split",
        "style",
        "wrap"
    ]);
    var supportFlexGap = (0, $b8b58c41c88f1d25$export$2e2bcd8739ae039)();
    var _React$useMemo = $acw62.useMemo(function() {
        return (Array.isArray(size) ? size : [
            size,
            size
        ]).map(function(item) {
            return $8f666b0c5cd58c95$var$getNumberSize(item);
        });
    }, [
        size
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), horizontalSize = _React$useMemo2[0], verticalSize = _React$useMemo2[1];
    var childNodes = (0, $jWR62.default)(children, {
        keepEmpty: true
    });
    var mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
    var prefixCls = getPrefixCls('space', customizePrefixCls);
    var cn = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-").concat(direction), (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), directionConfig === 'rtl'), "".concat(prefixCls, "-align-").concat(mergedAlign), mergedAlign), className);
    var itemClassName = "".concat(prefixCls, "-item");
    var marginDirection = directionConfig === 'rtl' ? 'marginLeft' : 'marginRight';
    // Calculate latest one
    var latestIndex = 0;
    var nodes = childNodes.map(function(child, i) {
        if (child !== null && child !== undefined) latestIndex = i;
        var key = child && child.key || "".concat(itemClassName, "-").concat(i);
        return /*#__PURE__*/ $acw62.createElement((0, $a9129d7ad0e59df6$export$2e2bcd8739ae039), {
            className: itemClassName,
            key: key,
            direction: direction,
            index: i,
            marginDirection: marginDirection,
            split: split,
            wrap: wrap
        }, child);
    });
    var spaceContext = $acw62.useMemo(function() {
        return {
            horizontalSize: horizontalSize,
            verticalSize: verticalSize,
            latestIndex: latestIndex,
            supportFlexGap: supportFlexGap
        };
    }, [
        horizontalSize,
        verticalSize,
        latestIndex,
        supportFlexGap
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    var gapStyle = {};
    if (wrap) {
        gapStyle.flexWrap = 'wrap';
        // Patch for gap not support
        if (!supportFlexGap) gapStyle.marginBottom = -verticalSize;
    }
    if (supportFlexGap) {
        gapStyle.columnGap = horizontalSize;
        gapStyle.rowGap = verticalSize;
    }
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: cn,
        style: (0, $8nd05.default)((0, $8nd05.default)({}, gapStyle), style)
    }, otherProps), /*#__PURE__*/ $acw62.createElement($8f666b0c5cd58c95$export$853f607fd5cc208b.Provider, {
        value: spaceContext
    }, nodes));
};
var $8f666b0c5cd58c95$var$CompoundedSpace = $8f666b0c5cd58c95$var$Space;
$8f666b0c5cd58c95$var$CompoundedSpace.Compact = (0, $26050ef76e24a749$export$2e2bcd8739ae039);
var $8f666b0c5cd58c95$export$2e2bcd8739ae039 = $8f666b0c5cd58c95$var$CompoundedSpace;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
// 36 Hex to reduce the size of the file
var $13d3254d016dc8f1$export$2e2bcd8739ae039 = {
    aliceblue: '9ehhb',
    antiquewhite: '9sgk7',
    aqua: '1ekf',
    aquamarine: '4zsno',
    azure: '9eiv3',
    beige: '9lhp8',
    bisque: '9zg04',
    black: '0',
    blanchedalmond: '9zhe5',
    blue: '73',
    blueviolet: '5e31e',
    brown: '6g016',
    burlywood: '8ouiv',
    cadetblue: '3qba8',
    chartreuse: '4zshs',
    chocolate: '87k0u',
    coral: '9yvyo',
    cornflowerblue: '3xael',
    cornsilk: '9zjz0',
    crimson: '8l4xo',
    cyan: '1ekf',
    darkblue: '3v',
    darkcyan: 'rkb',
    darkgoldenrod: '776yz',
    darkgray: '6mbhl',
    darkgreen: 'jr4',
    darkgrey: '6mbhl',
    darkkhaki: '7ehkb',
    darkmagenta: '5f91n',
    darkolivegreen: '3bzfz',
    darkorange: '9yygw',
    darkorchid: '5z6x8',
    darkred: '5f8xs',
    darksalmon: '9441m',
    darkseagreen: '5lwgf',
    darkslateblue: '2th1n',
    darkslategray: '1ugcv',
    darkslategrey: '1ugcv',
    darkturquoise: '14up',
    darkviolet: '5rw7n',
    deeppink: '9yavn',
    deepskyblue: '11xb',
    dimgray: '442g9',
    dimgrey: '442g9',
    dodgerblue: '16xof',
    firebrick: '6y7tu',
    floralwhite: '9zkds',
    forestgreen: '1cisi',
    fuchsia: '9y70f',
    gainsboro: '8m8kc',
    ghostwhite: '9pq0v',
    goldenrod: '8j4f4',
    gold: '9zda8',
    gray: '50i2o',
    green: 'pa8',
    greenyellow: '6senj',
    grey: '50i2o',
    honeydew: '9eiuo',
    hotpink: '9yrp0',
    indianred: '80gnw',
    indigo: '2xcoy',
    ivory: '9zldc',
    khaki: '9edu4',
    lavenderblush: '9ziet',
    lavender: '90c8q',
    lawngreen: '4vk74',
    lemonchiffon: '9zkct',
    lightblue: '6s73a',
    lightcoral: '9dtog',
    lightcyan: '8s1rz',
    lightgoldenrodyellow: '9sjiq',
    lightgray: '89jo3',
    lightgreen: '5nkwg',
    lightgrey: '89jo3',
    lightpink: '9z6wx',
    lightsalmon: '9z2ii',
    lightseagreen: '19xgq',
    lightskyblue: '5arju',
    lightslategray: '4nwk9',
    lightslategrey: '4nwk9',
    lightsteelblue: '6wau6',
    lightyellow: '9zlcw',
    lime: '1edc',
    limegreen: '1zcxe',
    linen: '9shk6',
    magenta: '9y70f',
    maroon: '4zsow',
    mediumaquamarine: '40eju',
    mediumblue: '5p',
    mediumorchid: '79qkz',
    mediumpurple: '5r3rv',
    mediumseagreen: '2d9ip',
    mediumslateblue: '4tcku',
    mediumspringgreen: '1di2',
    mediumturquoise: '2uabw',
    mediumvioletred: '7rn9h',
    midnightblue: 'z980',
    mintcream: '9ljp6',
    mistyrose: '9zg0x',
    moccasin: '9zfzp',
    navajowhite: '9zest',
    navy: '3k',
    oldlace: '9wq92',
    olive: '50hz4',
    olivedrab: '472ub',
    orange: '9z3eo',
    orangered: '9ykg0',
    orchid: '8iu3a',
    palegoldenrod: '9bl4a',
    palegreen: '5yw0o',
    paleturquoise: '6v4ku',
    palevioletred: '8k8lv',
    papayawhip: '9zi6t',
    peachpuff: '9ze0p',
    peru: '80oqn',
    pink: '9z8wb',
    plum: '8nba5',
    powderblue: '6wgdi',
    purple: '4zssg',
    rebeccapurple: '3zk49',
    red: '9y6tc',
    rosybrown: '7cv4f',
    royalblue: '2jvtt',
    saddlebrown: '5fmkz',
    salmon: '9rvci',
    sandybrown: '9jn1c',
    seagreen: '1tdnb',
    seashell: '9zje6',
    sienna: '6973h',
    silver: '7ir40',
    skyblue: '5arjf',
    slateblue: '45e4t',
    slategray: '4e100',
    slategrey: '4e100',
    snow: '9zke2',
    springgreen: '1egv',
    steelblue: '2r1kk',
    tan: '87yx8',
    teal: 'pds',
    thistle: '8ggk8',
    tomato: '9yqfb',
    turquoise: '2j4r4',
    violet: '9b10u',
    wheat: '9ld4j',
    white: '9zldr',
    whitesmoke: '9lhpx',
    yellow: '9zl6o',
    yellowgreen: '61fzm'
};


const $ea19b77d77fd8663$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $ea19b77d77fd8663$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $ea19b77d77fd8663$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $ea19b77d77fd8663$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $ea19b77d77fd8663$export$2c4f38d6c0ecc25a {
    /**
   * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
   */ isValid = true;
    /**
   * Red, R in RGB
   */ r = 0;
    /**
   * Green, G in RGB
   */ g = 0;
    /**
   * Blue, B in RGB
   */ b = 0;
    /**
   * Alpha/Opacity, A in RGBA/HSLA
   */ a = 1;
    // HSV privates
    _h;
    _s;
    _l;
    _v;
    // intermediate variables to calculate HSL/HSV
    _max;
    _min;
    _brightness;
    constructor(input){
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
            else {
                // From preset color
                const presetColor = (0, $13d3254d016dc8f1$export$2e2bcd8739ae039)[trimStr.toLowerCase()];
                if (presetColor) this.fromHexString(// Convert 36 hex to 16 hex
                parseInt(presetColor, 36).toString(16).padStart(6, '0'));
            }
        } else if (input instanceof $ea19b77d77fd8663$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $ea19b77d77fd8663$var$limitRange(input.r);
            this.g = $ea19b77d77fd8663$var$limitRange(input.g);
            this.b = $ea19b77d77fd8663$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $ea19b77d77fd8663$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $ea19b77d77fd8663$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $ea19b77d77fd8663$var$round(calc('r')),
            g: $ea19b77d77fd8663$var$round(calc('g')),
            b: $ea19b77d77fd8663$var$round(calc('b')),
            a: $ea19b77d77fd8663$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $ea19b77d77fd8663$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $ea19b77d77fd8663$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $ea19b77d77fd8663$var$round(this.getSaturation() * 100);
        const l = $ea19b77d77fd8663$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $ea19b77d77fd8663$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: h, s: s, l: l, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $ea19b77d77fd8663$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $ea19b77d77fd8663$var$round((r + lightnessModification) * 255);
        this.g = $ea19b77d77fd8663$var$round((g + lightnessModification) * 255);
        this.b = $ea19b77d77fd8663$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: h, s: s, v: v, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $ea19b77d77fd8663$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $ea19b77d77fd8663$var$round(v * (1.0 - s) * 255);
        const q = $ea19b77d77fd8663$var$round(v * (1.0 - s * ff) * 255);
        const t = $ea19b77d77fd8663$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, $ea19b77d77fd8663$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, $ea19b77d77fd8663$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $ea19b77d77fd8663$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






const $d1dea01cb419bab7$var$hueStep = 2; // 色相阶梯
const $d1dea01cb419bab7$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
const $d1dea01cb419bab7$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
const $d1dea01cb419bab7$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
const $d1dea01cb419bab7$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
const $d1dea01cb419bab7$var$lightColorCount = 5; // 浅色数量，主色上
const $d1dea01cb419bab7$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
const $d1dea01cb419bab7$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $d1dea01cb419bab7$var$getHue(hsv, i, light) {
    let hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $d1dea01cb419bab7$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    let saturation;
    if (light) saturation = hsv.s - $d1dea01cb419bab7$var$saturationStep * i;
    else if (i === $d1dea01cb419bab7$var$darkColorCount) saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep;
    else saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $d1dea01cb419bab7$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $d1dea01cb419bab7$var$getValue(hsv, i, light) {
    let value;
    if (light) value = hsv.v + $d1dea01cb419bab7$var$brightnessStep1 * i;
    else value = hsv.v - $d1dea01cb419bab7$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $d1dea01cb419bab7$export$2e2bcd8739ae039(color, opts = {}) {
    const patterns = [];
    const pColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(color);
    const hsv = pColor.toHsv();
    for(let i = $d1dea01cb419bab7$var$lightColorCount; i > 0; i -= 1){
        const c = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            h: $d1dea01cb419bab7$var$getHue(hsv, i, true),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, i, true),
            v: $d1dea01cb419bab7$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(let i = 1; i <= $d1dea01cb419bab7$var$darkColorCount; i += 1){
        const c = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            h: $d1dea01cb419bab7$var$getHue(hsv, i),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, i),
            v: $d1dea01cb419bab7$var$getValue(hsv, i)
        });
        patterns.push(c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $d1dea01cb419bab7$var$darkColorMap.map(({ index: index, amount: amount })=>new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString());
    return patterns.map((c)=>c.toHexString());
}


// Generated by script. Do NOT modify!
const $0b4842326956570d$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
const $0b4842326956570d$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$0b4842326956570d$export$a90204d1394caf30.primary = $0b4842326956570d$export$a90204d1394caf30[5];
const $0b4842326956570d$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$0b4842326956570d$export$e63a1643b2f79b16.primary = $0b4842326956570d$export$e63a1643b2f79b16[5];
const $0b4842326956570d$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$0b4842326956570d$export$ad766f34ace1cafd.primary = $0b4842326956570d$export$ad766f34ace1cafd[5];
const $0b4842326956570d$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$0b4842326956570d$export$c24201f7fe3571d8.primary = $0b4842326956570d$export$c24201f7fe3571d8[5];
const $0b4842326956570d$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$0b4842326956570d$export$594c5a8758200c32.primary = $0b4842326956570d$export$594c5a8758200c32[5];
const $0b4842326956570d$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$0b4842326956570d$export$221d31baf2636aad.primary = $0b4842326956570d$export$221d31baf2636aad[5];
const $0b4842326956570d$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$0b4842326956570d$export$955a2ebd2fb142ae.primary = $0b4842326956570d$export$955a2ebd2fb142ae[5];
const $0b4842326956570d$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$0b4842326956570d$export$7474046f446842ee.primary = $0b4842326956570d$export$7474046f446842ee[5];
const $0b4842326956570d$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$0b4842326956570d$export$2aa0182783e7e9de.primary = $0b4842326956570d$export$2aa0182783e7e9de[5];
const $0b4842326956570d$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$0b4842326956570d$export$4138d3aeddcbf415.primary = $0b4842326956570d$export$4138d3aeddcbf415[5];
const $0b4842326956570d$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$0b4842326956570d$export$e13cce2a2d16a9d4.primary = $0b4842326956570d$export$e13cce2a2d16a9d4[5];
const $0b4842326956570d$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$0b4842326956570d$export$2a9ca2e383622e18.primary = $0b4842326956570d$export$2a9ca2e383622e18[5];
const $0b4842326956570d$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$0b4842326956570d$export$e4c89085febbc618.primary = $0b4842326956570d$export$e4c89085febbc618[5];
const $0b4842326956570d$export$3e2c219d3ab79d01 = $0b4842326956570d$export$e4c89085febbc618;
const $0b4842326956570d$export$36ad6df0f83f284d = {
    red: $0b4842326956570d$export$a90204d1394caf30,
    volcano: $0b4842326956570d$export$e63a1643b2f79b16,
    orange: $0b4842326956570d$export$ad766f34ace1cafd,
    gold: $0b4842326956570d$export$c24201f7fe3571d8,
    yellow: $0b4842326956570d$export$594c5a8758200c32,
    lime: $0b4842326956570d$export$221d31baf2636aad,
    green: $0b4842326956570d$export$955a2ebd2fb142ae,
    cyan: $0b4842326956570d$export$7474046f446842ee,
    blue: $0b4842326956570d$export$2aa0182783e7e9de,
    geekblue: $0b4842326956570d$export$4138d3aeddcbf415,
    purple: $0b4842326956570d$export$e13cce2a2d16a9d4,
    magenta: $0b4842326956570d$export$2a9ca2e383622e18,
    grey: $0b4842326956570d$export$e4c89085febbc618
};
const $0b4842326956570d$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$0b4842326956570d$export$e984d34fc144caa1.primary = $0b4842326956570d$export$e984d34fc144caa1[5];
const $0b4842326956570d$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$0b4842326956570d$export$360e10f78e17a865.primary = $0b4842326956570d$export$360e10f78e17a865[5];
const $0b4842326956570d$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$0b4842326956570d$export$d5a12c698b31fa45.primary = $0b4842326956570d$export$d5a12c698b31fa45[5];
const $0b4842326956570d$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$0b4842326956570d$export$2330427fb6a6af6f.primary = $0b4842326956570d$export$2330427fb6a6af6f[5];
const $0b4842326956570d$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$0b4842326956570d$export$67d203119f0ecec.primary = $0b4842326956570d$export$67d203119f0ecec[5];
const $0b4842326956570d$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$0b4842326956570d$export$51ed2a10d86576ed.primary = $0b4842326956570d$export$51ed2a10d86576ed[5];
const $0b4842326956570d$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$0b4842326956570d$export$76a3d804058f9b5f.primary = $0b4842326956570d$export$76a3d804058f9b5f[5];
const $0b4842326956570d$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$0b4842326956570d$export$dee6c7c6683c0d88.primary = $0b4842326956570d$export$dee6c7c6683c0d88[5];
const $0b4842326956570d$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$0b4842326956570d$export$10e0fd027e632624.primary = $0b4842326956570d$export$10e0fd027e632624[5];
const $0b4842326956570d$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$0b4842326956570d$export$abdd57ab473bba66.primary = $0b4842326956570d$export$abdd57ab473bba66[5];
const $0b4842326956570d$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$0b4842326956570d$export$7a65e68792738764.primary = $0b4842326956570d$export$7a65e68792738764[5];
const $0b4842326956570d$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$0b4842326956570d$export$d260a9321db4ab86.primary = $0b4842326956570d$export$d260a9321db4ab86[5];
const $0b4842326956570d$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$0b4842326956570d$export$515283ba400ffa6c.primary = $0b4842326956570d$export$515283ba400ffa6c[5];
const $0b4842326956570d$export$24617255e4daf647 = {
    red: $0b4842326956570d$export$e984d34fc144caa1,
    volcano: $0b4842326956570d$export$360e10f78e17a865,
    orange: $0b4842326956570d$export$d5a12c698b31fa45,
    gold: $0b4842326956570d$export$2330427fb6a6af6f,
    yellow: $0b4842326956570d$export$67d203119f0ecec,
    lime: $0b4842326956570d$export$51ed2a10d86576ed,
    green: $0b4842326956570d$export$76a3d804058f9b5f,
    cyan: $0b4842326956570d$export$dee6c7c6683c0d88,
    blue: $0b4842326956570d$export$10e0fd027e632624,
    geekblue: $0b4842326956570d$export$abdd57ab473bba66,
    purple: $0b4842326956570d$export$7a65e68792738764,
    magenta: $0b4842326956570d$export$d260a9321db4ab86,
    grey: $0b4842326956570d$export$515283ba400ffa6c
};







var $acw62 = parcelRequire("acw62");
const $6bacc63174d40f3c$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $6bacc63174d40f3c$export$2e2bcd8739ae039 = $6bacc63174d40f3c$var$IconContext;



var $acw62 = parcelRequire("acw62");

function $f8a3b4c093d33025$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


function $30506d5d40a63398$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    let node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


const $d16d9ce8cc85ed9d$var$APPEND_ORDER = 'data-rc-order';
const $d16d9ce8cc85ed9d$var$APPEND_PRIORITY = 'data-rc-priority';
const $d16d9ce8cc85ed9d$var$MARK_KEY = `rc-util-key`;
const $d16d9ce8cc85ed9d$var$containerCache = new Map();
function $d16d9ce8cc85ed9d$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return $d16d9ce8cc85ed9d$var$MARK_KEY;
}
function $d16d9ce8cc85ed9d$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function $d16d9ce8cc85ed9d$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $d16d9ce8cc85ed9d$var$findStyles(container) {
    return Array.from(($d16d9ce8cc85ed9d$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function $d16d9ce8cc85ed9d$export$1ab5838465dbd10a(css, option = {}) {
    if (!(0, $f8a3b4c093d33025$export$2e2bcd8739ae039)()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $d16d9ce8cc85ed9d$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute($d16d9ce8cc85ed9d$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($d16d9ce8cc85ed9d$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp?.nonce;
    styleNode.innerHTML = css;
    const container = $d16d9ce8cc85ed9d$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            const existStyle = (option.styles || $d16d9ce8cc85ed9d$var$findStyles(container)).filter((node)=>{
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($d16d9ce8cc85ed9d$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                const nodePriority = Number(node.getAttribute($d16d9ce8cc85ed9d$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $d16d9ce8cc85ed9d$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $d16d9ce8cc85ed9d$var$findStyles($d16d9ce8cc85ed9d$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($d16d9ce8cc85ed9d$var$getMark(option)) === key);
}
function $d16d9ce8cc85ed9d$export$2232e336aecaa80a(key, option = {}) {
    const existNode = $d16d9ce8cc85ed9d$var$findExistNode(key, option);
    if (existNode) {
        const container = $d16d9ce8cc85ed9d$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $d16d9ce8cc85ed9d$var$syncRealContainer(container, option) {
    const cachedRealContainer = $d16d9ce8cc85ed9d$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $30506d5d40a63398$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        const placeholderStyle = $d16d9ce8cc85ed9d$export$1ab5838465dbd10a('', option);
        const { parentNode: parentNode } = placeholderStyle;
        $d16d9ce8cc85ed9d$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $d16d9ce8cc85ed9d$export$f80df667f2f5a272() {
    $d16d9ce8cc85ed9d$var$containerCache.clear();
}
function $d16d9ce8cc85ed9d$export$4d99a2890bb989f0(css, key, originOption = {}) {
    const container = $d16d9ce8cc85ed9d$var$getContainer(originOption);
    const styles = $d16d9ce8cc85ed9d$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    // Sync real parent
    $d16d9ce8cc85ed9d$var$syncRealContainer(container, option);
    const existNode = $d16d9ce8cc85ed9d$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) existNode.nonce = option.csp?.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $d16d9ce8cc85ed9d$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($d16d9ce8cc85ed9d$var$getMark(option), key);
    return newNode;
}


function $a29ec0f581de149f$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $a29ec0f581de149f$export$cca82218ea4431a(ele) {
    return $a29ec0f581de149f$var$getRoot(ele) instanceof ShadowRoot;
}
function $a29ec0f581de149f$export$70e8259662bb498b(ele) {
    return $a29ec0f581de149f$export$cca82218ea4431a(ele) ? $a29ec0f581de149f$var$getRoot(ele) : null;
}


/* eslint-disable no-console */ let $659b9b927c9c1865$var$warned = {};
const $659b9b927c9c1865$var$preWarningFns = [];
const $659b9b927c9c1865$export$61616f168f0e5a05 = (fn)=>{
    $659b9b927c9c1865$var$preWarningFns.push(fn);
};
function $659b9b927c9c1865$export$491112666e282270(valid, message) {}
function $659b9b927c9c1865$export$a92e4c44d367d0af(valid, message) {}
function $659b9b927c9c1865$export$60eef1277fe463e4() {
    $659b9b927c9c1865$var$warned = {};
}
function $659b9b927c9c1865$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$659b9b927c9c1865$var$warned[message]) {
        method(false, message);
        $659b9b927c9c1865$var$warned[message] = true;
    }
}
function $659b9b927c9c1865$export$82934adf09101657(valid, message) {
    $659b9b927c9c1865$export$848feb93d8f32b9b($659b9b927c9c1865$export$491112666e282270, valid, message);
}
function $659b9b927c9c1865$export$89ff31684837bbbf(valid, message) {
    $659b9b927c9c1865$export$848feb93d8f32b9b($659b9b927c9c1865$export$a92e4c44d367d0af, valid, message);
}
$659b9b927c9c1865$export$82934adf09101657.preMessage = $659b9b927c9c1865$export$61616f168f0e5a05;
$659b9b927c9c1865$export$82934adf09101657.resetWarned = $659b9b927c9c1865$export$60eef1277fe463e4;
$659b9b927c9c1865$export$82934adf09101657.noteOnce = $659b9b927c9c1865$export$89ff31684837bbbf;
var $659b9b927c9c1865$export$2e2bcd8739ae039 = $659b9b927c9c1865$export$82934adf09101657;



var $acw62 = parcelRequire("acw62");

function $1beccdf56290315b$var$camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function $1beccdf56290315b$export$491112666e282270(valid, message) {
    (0, $659b9b927c9c1865$export$2e2bcd8739ae039)(valid, `[@ant-design/icons] ${message}`);
}
function $1beccdf56290315b$export$ab652842c37578f4(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function $1beccdf56290315b$export$9f5073e7201cc21c(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$1beccdf56290315b$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $1beccdf56290315b$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, {
        key: key,
        ...$1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)
    }, (node.children || []).map((child, index)=>$1beccdf56290315b$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, {
        key: key,
        ...$1beccdf56290315b$export$9f5073e7201cc21c(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>$1beccdf56290315b$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
}
function $1beccdf56290315b$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $1beccdf56290315b$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
const $1beccdf56290315b$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
const $1beccdf56290315b$export$2c99b98b77550cb4 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const $1beccdf56290315b$export$938b1f86b61613d0 = (eleRef)=>{
    const { csp: csp, prefixCls: prefixCls, layer: layer } = (0, $acw62.useContext)((0, $6bacc63174d40f3c$export$2e2bcd8739ae039));
    let mergedStyleStr = $1beccdf56290315b$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, $acw62.useEffect)(()=>{
        const ele = eleRef.current;
        const shadowRoot = (0, $a29ec0f581de149f$export$70e8259662bb498b)(ele);
        (0, $d16d9ce8cc85ed9d$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


const $c52e7cd4d4f30fad$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $c52e7cd4d4f30fad$var$setTwoToneColors({ primaryColor: primaryColor, secondaryColor: secondaryColor }) {
    $c52e7cd4d4f30fad$var$twoToneColorPalette.primaryColor = primaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor);
    $c52e7cd4d4f30fad$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $c52e7cd4d4f30fad$var$getTwoToneColors() {
    return {
        ...$c52e7cd4d4f30fad$var$twoToneColorPalette
    };
}
const $c52e7cd4d4f30fad$var$IconBase = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: primaryColor, secondaryColor: secondaryColor, ...restProps } = props;
    const svgRef = $acw62.useRef();
    let colors = $c52e7cd4d4f30fad$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor)
    };
    (0, $1beccdf56290315b$export$938b1f86b61613d0)(svgRef);
    (0, $1beccdf56290315b$export$491112666e282270)((0, $1beccdf56290315b$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${icon}`);
    if (!(0, $1beccdf56290315b$export$ab652842c37578f4)(icon)) return null;
    let target = icon;
    if (target && typeof target.icon === 'function') target = {
        ...target,
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    };
    return (0, $1beccdf56290315b$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
$c52e7cd4d4f30fad$var$IconBase.displayName = 'IconReact';
$c52e7cd4d4f30fad$var$IconBase.getTwoToneColors = $c52e7cd4d4f30fad$var$getTwoToneColors;
$c52e7cd4d4f30fad$var$IconBase.setTwoToneColors = $c52e7cd4d4f30fad$var$setTwoToneColors;
var $c52e7cd4d4f30fad$export$2e2bcd8739ae039 = $c52e7cd4d4f30fad$var$IconBase;




function $27dd37ce58e7c6e8$export$8a145f34580ff02b(twoToneColor) {
    const [primaryColor, secondaryColor] = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor);
    return (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $27dd37ce58e7c6e8$export$abc7c554784cb4a7() {
    const colors = (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
function $7714637e9c1f1f3f$var$_extends() {
    $7714637e9c1f1f3f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7714637e9c1f1f3f$var$_extends.apply(this, arguments);
}
// Initial setting
// should move it to antd main repo?
(0, $27dd37ce58e7c6e8$export$8a145f34580ff02b)((0, $0b4842326956570d$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
const $7714637e9c1f1f3f$var$Icon = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: // other
    twoToneColor, ...restProps } = props;
    const { prefixCls: prefixCls = 'anticon', rootClassName: rootClassName } = $acw62.useContext((0, $6bacc63174d40f3c$export$2e2bcd8739ae039));
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    const [primaryColor, secondaryColor] = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor);
    return /*#__PURE__*/ $acw62.createElement("span", $7714637e9c1f1f3f$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $acw62.createElement((0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$7714637e9c1f1f3f$var$Icon.displayName = 'AntdIcon';
$7714637e9c1f1f3f$var$Icon.getTwoToneColor = (0, $27dd37ce58e7c6e8$export$abc7c554784cb4a7);
$7714637e9c1f1f3f$var$Icon.setTwoToneColor = (0, $27dd37ce58e7c6e8$export$8a145f34580ff02b);
var $7714637e9c1f1f3f$export$2e2bcd8739ae039 = $7714637e9c1f1f3f$var$Icon;


function $d8a9efd7a074f5f5$var$_extends() {
    $d8a9efd7a074f5f5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8a9efd7a074f5f5$var$_extends.apply(this, arguments);
}
const $d8a9efd7a074f5f5$var$EyeOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $d8a9efd7a074f5f5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b7bc758130af6b02$export$2e2bcd8739ae039)
    }));
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ const $d8a9efd7a074f5f5$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d8a9efd7a074f5f5$var$EyeOutlined);
var $d8a9efd7a074f5f5$export$2e2bcd8739ae039 = $d8a9efd7a074f5f5$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $6e76cea51e9e411c$var$LockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "outlined"
};
var $6e76cea51e9e411c$export$2e2bcd8739ae039 = $6e76cea51e9e411c$var$LockOutlined;



function $90bdf3d9d7ea52d2$var$_extends() {
    $90bdf3d9d7ea52d2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $90bdf3d9d7ea52d2$var$_extends.apply(this, arguments);
}
const $90bdf3d9d7ea52d2$var$LockOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $90bdf3d9d7ea52d2$var$_extends({}, props, {
        ref: ref,
        icon: (0, $6e76cea51e9e411c$export$2e2bcd8739ae039)
    }));
/**![lock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRoLTY4VjI0MGMwLTcwLjctNTcuMy0xMjgtMTI4LTEyOEgzODhjLTcwLjcgMC0xMjggNTcuMy0xMjggMTI4djIyNGgtNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjM4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWNDk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek0zMzIgMjQwYzAtMzAuOSAyNS4xLTU2IDU2LTU2aDI0OGMzMC45IDAgNTYgMjUuMSA1NiA1NnYyMjRIMzMyVjI0MHptNDYwIDYwMEgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ const $90bdf3d9d7ea52d2$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($90bdf3d9d7ea52d2$var$LockOutlined);
var $90bdf3d9d7ea52d2$export$2e2bcd8739ae039 = $90bdf3d9d7ea52d2$var$RefIcon;



var $acw62 = parcelRequire("acw62");

var $a472eec1c89e43a3$export$2e2bcd8739ae039 = {
    encode: (data, separator = '&')=>data ? Object.entries(data).filter(([k, v])=>v !== undefined).map(([k, v])=>(Array.isArray(v) ? v : [
                v
            ]).map((e)=>`${encodeURIComponent(k)}=${encodeURIComponent(e)}`).join(separator)).join(separator) : '',
    decode: (query, separator = '&')=>query ? query.replace(/^\?/, '').split(separator).reduce((acc, e)=>{
            const [k, v] = e.split('=');
            if (acc[k] !== undefined) {
                if (Array.isArray(acc[k])) acc[k].push(v);
                else acc[k] = [
                    acc[k],
                    v
                ];
            } else acc[k] = v;
            return acc;
        }, {}) : {}
};


const $4c9b1d6031e12121$var$Formatting = {
    insertSpaces: (v)=>v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0'),
    money: (v, suffix = "z\u0142")=>$4c9b1d6031e12121$var$Formatting.insertSpaces(parseFloat(v).toFixed(2).replace(/\./g, ',')) + '\u00A0' + suffix,
    epochToDate: (epoch, noTime, chart)=>{
        const d = new Date(epoch);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        const hour = d.getHours().toString().padStart(2, '0');
        const minute = d.getMinutes().toString().padStart(2, '0');
        const second = d.getSeconds().toString().padStart(2, '0');
        return chart ? `${year}-${month}-${day}` + (noTime === true ? '' : ` ${hour}:${minute}:${second}`) : `${day}.${month}.${year}` + (noTime === true ? '' : ` ${hour}:${minute}:${second}`);
    }
};
var $4c9b1d6031e12121$export$2e2bcd8739ae039 = $4c9b1d6031e12121$var$Formatting;


function $d0d47524147cc5b7$export$2e2bcd8739ae039(email) {
    return email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}


function $003e9077a98b5853$export$2e2bcd8739ae039(nip) {
    if (!nip) return false;
    nip = nip.replace(/-/g, '');
    if (nip.length !== 10) return false;
    const digits = nip.toString().split('');
    const sum = digits.reduce((acc, e, i)=>{
        switch(i){
            case 0:
                return acc + e * 6;
            case 1:
                return acc + e * 5;
            case 2:
                return acc + e * 7;
            case 3:
                return acc + e * 2;
            case 4:
                return acc + e * 3;
            case 5:
                return acc + e * 4;
            case 6:
                return acc + e * 5;
            case 7:
                return acc + e * 6;
            case 8:
                return acc + e * 7;
            default:
                return acc;
        }
    }, 0);
    return sum % 11 === parseInt(digits[9]);
}



var $45fvw = parcelRequire("45fvw");
function $82a8ecd62f76e2e9$export$2e2bcd8739ae039(date) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().year(2499).isBefore(date);
}


function $28bd3ebc12014be7$export$2e2bcd8739ae039(date, start, end) {
    const d = new Date(date);
    return d >= new Date(start) && d <= new Date(end);
}


/**
 * Converts a phone number string into a clean `tel:` href value.
 * Keeps a leading `+` for international prefixes and strips everything else
 * that is not a digit.
 */ const $30eeeb9bc1cd6f03$export$8045d8ca670cb8a4 = (phone)=>{
    const digits = phone.replace(/[^\d+]/g, '');
    return `tel:${digits}`;
};





var $45fvw = parcelRequire("45fvw");
async function $4c992464a65faeac$var$send(method, endpoint, data, query) {
    const response = await fetch(`${"https://papaj.hexagonale.net/api"}/${endpoint}${query ? '?' + (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).encode(query) : ''}`, {
        method: method,
        headers: {
            'Content-Type': data ? 'application/json' : 'plain/text'
        },
        body: data ? JSON.stringify(data) : null,
        credentials: 'include'
    });
    if (endpoint !== 'logout' && (response.status === 401 || response.status === 403)) {
        window.location = '/logout';
        throw "Sesja wygas\u0142a";
    }
    if (response.headers.get('content-type')?.match(/application\/json/g)) {
        if (response.status !== 200) throw await response.json();
        return await response.json();
    } else {
        if (response.status !== 200) throw await response.text();
        return await response.text();
    }
}
var $4c992464a65faeac$export$2e2bcd8739ae039 = {
    login: async (username, password)=>{
        try {
            return await $4c992464a65faeac$var$send('POST', 'login', {
                username: username,
                password: password
            });
        } catch (e) {
            switch(e.error){
                case 1:
                    throw 'Niepoprawne dane logowania';
                default:
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    logout: async ()=>{
        try {
            return await $4c992464a65faeac$var$send('GET', 'logout');
        } catch (e) {
            e.error;
            throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
        }
    },
    users: {
        get: async (id, unsettled)=>{
            try {
                const result = await $4c992464a65faeac$var$send('GET', `users/${id}`, undefined, unsettled ? {
                    unsettled: unsettled
                } : undefined);
                return result;
            } catch (e) {
                switch(e.error){
                    case 3:
                        throw 3;
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        getAll: async (unsettled)=>{
            try {
                const result = await $4c992464a65faeac$var$send('GET', `users`, undefined, unsettled ? {
                    unsettled: unsettled
                } : undefined);
                return result;
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        create: async (user_data)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', `users`, user_data);
            } catch (e) {
                switch(e.error){
                    case 1:
                        throw "Nazwa u\u017Cytkownika jest zaj\u0119ta";
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        patch: async (id, data)=>{
            try {
                return await $4c992464a65faeac$var$send('PATCH', `users/${id}`, data);
            } catch (e) {
                switch(e.error){
                    case 1:
                        throw "Nazwa u\u017Cytkownika zaj\u0119ta";
                    case 2:
                        throw "Has\u0142o zbyt kr\xf3tkie";
                    case 3:
                        throw "Stare has\u0142o jest nieprawid\u0142owe";
                    case 4:
                        throw "Nowe has\u0142o nie mo\u017Ce by\u0107 takie samo jak stare";
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        delete: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('DELETE', `users/${id}`);
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        history: async (id, limit)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `users/${id}/history`, undefined, {
                    limit: limit
                });
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        cards: {
            getAll: async ({ after: after, before: before, user_id: user_id })=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `users/cards`, undefined, {
                        after: after,
                        before: before,
                        user_id: user_id
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            put: async ({ mileage_start: mileage_start, mileage_end: mileage_end, time: time, plate: plate, date: date })=>{
                try {
                    return await $4c992464a65faeac$var$send('PUT', `users/cards`, {
                        mileage_start: mileage_start,
                        mileage_end: mileage_end,
                        time: time,
                        plate: plate,
                        date: date
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        }
    },
    containers: {
        sizes: {
            getAll: async ()=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', 'containers/sizes');
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            create: async (name)=>{
                try {
                    return await $4c992464a65faeac$var$send('PUT', 'containers/sizes', {
                        name: name
                    });
                } catch (e) {
                    switch(e.error){
                        case 1:
                            throw "Taki rozmiar kontenera ju\u017C istnieje";
                        default:
                            throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                    }
                }
            },
            change: async (id, name)=>{
                try {
                    return await $4c992464a65faeac$var$send('PATCH', `containers/sizes/${id}`, {
                        name: name
                    });
                } catch (e) {
                    switch(e.error){
                        case 1:
                            throw "Taki rozmiar kontenera ju\u017C istnieje";
                        default:
                            throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                    }
                }
            },
            delete: async (id)=>{
                try {
                    return await $4c992464a65faeac$var$send('DELETE', `containers/sizes/${id}`);
                } catch (e) {
                    switch(e.error){
                        case 1:
                            throw 'Nie ma takiego rozmiaru';
                        case 2:
                            throw 'Rozmiar jest przypisany do kontenera';
                        case 3:
                            throw "Rozmiar jest przypisany do zam\xf3wienia";
                        default:
                            throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                    }
                }
            }
        },
        get: async (id)=>{
            try {
                const result = await $4c992464a65faeac$var$send('GET', `containers/${id}`);
                return result;
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        getAll: async (states)=>{
            try {
                const result = await $4c992464a65faeac$var$send('GET', 'containers', undefined, states ? {
                    states: states
                } : undefined);
                return result;
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        create: async (user_data)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', `containers`, user_data);
            } catch (e) {
                switch(e.error){
                    case 4:
                        throw "Numer kontenera ju\u017C zaj\u0119ty";
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        patch: async (id, data)=>{
            try {
                return await $4c992464a65faeac$var$send('PATCH', `containers/${id}`, data);
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        delete: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('DELETE', `containers/${id}`);
            } catch (e) {
                switch(e.error){
                    case 3:
                        throw 'Kontener jest przypisany do zadania';
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        history: async (id, limit)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `containers/${id}/history`, undefined, {
                    limit: limit
                });
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    clients: {
        getAll: async ()=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `clients`);
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        get: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `clients/${id}`);
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        create: async (data)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', `clients`, data);
            } catch (e) {
                if (e.error?.includes('name already exists')) throw "Nazwa klienta jest zaj\u0119ta";
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        patch: async (id, data)=>{
            try {
                return await $4c992464a65faeac$var$send('PATCH', `clients/${id}`, data);
            } catch (e) {
                if (e.error?.includes('name already exists')) throw "Nazwa klienta jest zaj\u0119ta";
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        delete: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('DELETE', `clients/${id}`);
            } catch (e) {
                if (e.contains('Client has unclosed orders')) throw 'Klient ma co najmniej jedno otwarte zlecenie';
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        history: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `clients/${id}/history`);
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    client: (id)=>({
            patch: async (data)=>{
                try {
                    return await $4c992464a65faeac$var$send('PATCH', `clients/${id}`, data);
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            delete: async ()=>{
                try {
                    return await $4c992464a65faeac$var$send('DELETE', `clients/${id}`);
                } catch (e) {
                    switch(e.error){
                        case 2:
                            throw 'Klient ma co najmniej jedno otwarte zlecenie';
                        default:
                            throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                    }
                }
            }
        }),
    expenses: {
        getAll: async ({ user_id: user_id, before: before, after: after, company: company })=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `expenses`, undefined, {
                    user_id: user_id,
                    before: before,
                    after: after,
                    company: company
                });
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        create: async (expense_data)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', `expenses`, expense_data);
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        settle: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('PATCH', `expenses/${id}`, {
                    settled: 1
                });
            } catch (e) {
                switch(e.error){
                    case 2:
                        throw `Wydatek jest ju\u{17C} rozliczony`;
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        expenseTypes: {
            getAll: async ()=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `expenseTypes`);
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            put: async (name)=>{
                try {
                    return await $4c992464a65faeac$var$send('PUT', `expenseTypes`, {
                        name: name
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        settlements: {
            getAll: async ({ user_id: user_id, before: before, after: after })=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `settlements`, undefined, {
                        user_id: user_id,
                        before: before,
                        after: after
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            create: async (settlement)=>{
                try {
                    return await $4c992464a65faeac$var$send('PUT', `settlements`, settlement);
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        }
    },
    payments: {
        put: async (data)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', `payments`, data);
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    orders: {
        getAll: async ({ client_id: client_id, after: after, before: before, closed: closed, advances: advances })=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `orders`, undefined, {
                    client_id: client_id,
                    after: after,
                    before: before,
                    closed: closed,
                    advances: advances
                });
            } catch (e) {
                switch(e.error){
                    case 3:
                        throw 3;
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        getByRelatedId: async (relatedId)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', 'orders', undefined, {
                    related_id: relatedId
                });
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        get: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `orders/${id}`);
            } catch (e) {
                switch(e.error){
                    case 3:
                        throw 3;
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        create: async (order_data)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', 'orders', order_data);
            } catch (e) {
                switch(e.error){
                    case 5:
                        throw "Nie mo\u017Cna doda\u0107 zam\xf3wienia, poniewa\u017C inna wymiana zosta\u0142a ju\u017C dodana";
                    default:
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        patch: async (id, data)=>{
            try {
                return await $4c992464a65faeac$var$send('PATCH', `orders/${id}`, data);
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        delete: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('DELETE', `orders/${id}`);
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        owns: {
            getAll: async ({ after: after, before: before, client_id: client_id, to: to })=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', 'owns', undefined, {
                        before: before,
                        after: after,
                        client_id: client_id,
                        to: to
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            get: async (id)=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `owns/${id}`);
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            put: async ({ client_id: client_id, address: address, to: to, date: date })=>{
                try {
                    return await $4c992464a65faeac$var$send('PUT', 'owns', {
                        client_id: client_id,
                        address: address,
                        to: to,
                        date: date
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            patch: async (id, { weight: weight, date: date })=>{
                try {
                    return await $4c992464a65faeac$var$send('PATCH', `owns/${id}`, {
                        weight: weight,
                        date: date
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            contractors: {
                getAll: async ()=>{
                    try {
                        return await $4c992464a65faeac$var$send('GET', `owns/contractors`);
                    } catch (e) {
                        e.error;
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                    }
                }
            }
        },
        incomes: {
            getAll: async ({ after: after, before: before, client_id: client_id })=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', 'incomes', undefined, {
                        before: before,
                        after: after,
                        client_id: client_id
                    });
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            get: async (id)=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `incomes/${id}`);
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            put: async ({ client_id: client_id, name: name, value: value, value_type: value_type, comments: comments, date: date })=>{
                try {
                    return await $4c992464a65faeac$var$send('PUT', 'incomes', {
                        client_id: client_id,
                        name: name,
                        value: value,
                        value_type: value_type,
                        comments: comments,
                        date: date
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            patch: async (id, { name: name, value: value, value_type: value_type, comments: comments, date: date })=>{
                try {
                    return await $4c992464a65faeac$var$send('PATCH', `incomes/${id}`, {
                        name: name,
                        value: value,
                        value_type: value_type,
                        comments: comments,
                        date: date
                    });
                } catch (e) {
                    e.error;
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        }
    },
    tasks: {
        getAll: async ({ after: after, before: before, assignee: assignee })=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `tasks`, undefined, {
                    after: after.toISOString(),
                    before: before.toISOString(),
                    assignee: assignee
                });
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        get: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `tasks/${id}`);
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        patch: async (id, data)=>{
            try {
                return await $4c992464a65faeac$var$send('PATCH', `tasks/${id}`, {
                    ...data,
                    date: data.date?.toISOString()
                });
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        put: async (taskData)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', `tasks`, {
                    ...taskData,
                    date: taskData.date.toISOString()
                });
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        close: async (id, dto)=>{
            try {
                return await $4c992464a65faeac$var$send('POST', `tasks/${id}/close`, dto);
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        delete: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('DELETE', `tasks/${id}`);
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    stats: {
        panel: async ()=>{
            try {
                return await $4c992464a65faeac$var$send('GET', 'stats/panel', undefined, {
                    day_start: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().hours(0).minutes(0).seconds(0).subtract(1, 'second').unix() * 1000,
                    day_end: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().hours(23).minutes(59).seconds(59).unix() * 1000
                });
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        summary: async (from, to)=>{
            try {
                return await $4c992464a65faeac$var$send('GET', 'stats/summary', undefined, {
                    from: from,
                    to: to
                });
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        incomes: async ({ after: after, before: before })=>{
            try {
                return await $4c992464a65faeac$var$send('GET', 'stats/incomes', undefined, {
                    after: after,
                    before: before
                });
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    addresses: {
        getAll: async ({ clientId: clientId })=>{
            try {
                const result = await $4c992464a65faeac$var$send('GET', 'addresses', undefined, {
                    client_id: clientId
                });
                return result;
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        add: async ({ name: name, clientId: clientId })=>{
            try {
                const result = await $4c992464a65faeac$var$send('PUT', 'addresses', {
                    name: name,
                    client_id: clientId
                });
                return result;
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        delete: async (id)=>{
            try {
                return await $4c992464a65faeac$var$send('DELETE', `addresses/${id}`);
            } catch (e) {
                e.error;
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    looseOrders: {
        create: async (dto)=>{
            try {
                return await $4c992464a65faeac$var$send('PUT', 'v2/orders/loose', {
                    ...dto,
                    deliveryDate: dto.deliveryDate.toISOString(),
                    claimingDate: dto.claimingDate?.toISOString()
                });
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        getDelivered: async ()=>{
            try {
                return await $4c992464a65faeac$var$send('GET', 'v2/orders/loose/delivered');
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    },
    looseOrder: (id)=>({
            get: async ()=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `v2/orders/loose/${id}`);
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            patch: async (data)=>{
                try {
                    return await $4c992464a65faeac$var$send('PATCH', `v2/orders/loose/${id}`, {
                        ...data
                    });
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            take: async ()=>{
                try {
                    const result = await $4c992464a65faeac$var$send('POST', `v2/orders/loose/${id}/take`);
                    return result;
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            resign: async ()=>{
                try {
                    const result = await $4c992464a65faeac$var$send('POST', `v2/orders/loose/${id}/resign`);
                    return result;
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            execute: async (paid)=>{
                try {
                    const result = await $4c992464a65faeac$var$send('POST', `v2/orders/loose/${id}/execute`, {
                        paid: paid
                    });
                    return result;
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            assign: async (assignee)=>{
                try {
                    const result = await $4c992464a65faeac$var$send('POST', `v2/orders/loose/${id}/assign`, {
                        assignee: assignee
                    });
                    return result;
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            delete: async ()=>{
                try {
                    return await $4c992464a65faeac$var$send('DELETE', `v2/orders/loose/${id}`);
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        }),
    orders2: {
        client: {
            get: async (id)=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `v2/orders/client/${id}`);
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            },
            toPay: async (id)=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', `v2/orders/client/${id}/to_pay`);
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        finances: {
            get: async (data)=>{
                try {
                    return await $4c992464a65faeac$var$send('GET', 'v2/orders/finances', undefined, {
                        ...data,
                        after: data.after.toISOString(),
                        before: data.before.toISOString()
                    });
                } catch (e) {
                    throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                }
            }
        },
        getAll: async ({ clientId: clientId, after: after, before: before, done: done })=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `v2/orders`, undefined, {
                    client_id: clientId,
                    after: after?.toISOString(),
                    before: before?.toISOString(),
                    done: done
                });
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        },
        order: (orderType, orderId)=>({
                priceChanges: async ()=>{
                    try {
                        return await $4c992464a65faeac$var$send('GET', `v2/orders/${orderType}/${orderId}/price_changes`);
                    } catch (e) {
                        throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
                    }
                }
            }),
        priceChanges: async ({ after: after, before: before })=>{
            try {
                return await $4c992464a65faeac$var$send('GET', `v2/orders/price_changes`, undefined, {
                    after: after.toISOString(),
                    before: before.toISOString()
                });
            } catch (e) {
                throw `Nieznany b\u{142}\u{105}d ${e.message || e.error || e}`;
            }
        }
    }
};


function $3213bd22d6b87309$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [password, setPassword] = (0, $acw62.useState)('');
    const [passwordRepeat, setPasswordRepeat] = (0, $acw62.useState)('');
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const [inputType, setInputType] = (0, $acw62.useState)('password');
    const changePassword = async (e)=>{
        e.preventDefault();
        const oldPassword = location.state;
        if (password.length <= 6) return setError("Has\u0142o musi mie\u0107 co najmniej 6 znak\xf3w");
        else if (password !== passwordRepeat) return setError("Has\u0142a nie s\u0105 takie same");
        else if (password === oldPassword) return setError("Has\u0142o musi by\u0107 inne ni\u017C poprzednie");
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.patch(window.sessionStorage.getItem('id'), {
                password: password,
                oldPassword: oldPassword
            });
            setLoading(false);
            navigate('/panel');
        } catch (e) {
            setLoading(false);
            console.trace(e);
            setError(`${e}`);
        }
    };
    return [
        {
            password: password,
            passwordRepeat: passwordRepeat,
            inputType: inputType,
            loading: loading,
            error: error
        },
        {
            passwordChanged: (e)=>setPassword(e.target.value),
            passwordRepeatChanged: (e)=>setPasswordRepeat(e.target.value),
            newPassword: changePassword,
            touchStart: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                setInputType('text');
            },
            touchMove: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                setInputType('password');
            },
            touchEnd: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                setInputType('password');
            }
        }
    ];
}




parcelRequire("acw62");
const $a225b11ef63dbd27$var$SvgBlob = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 355,
        height: 321,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M327.997 243.619c-21.667 36.667-50.833 60-87.5 70s-72.833 9.5-108.5-1.5-70-34.333-103-70-37.833-76.167-14.5-121.5 57.667-78.833 103-100.5 94.833-25.833 148.5-12.5c53.667 13.333 82.833 46.833 87.5 100.5 4.667 53.667-3.833 98.833-25.5 135.5Z",
            fill: "#000",
            fillOpacity: 0.02
        })
    });
var $a225b11ef63dbd27$export$2e2bcd8739ae039 = $a225b11ef63dbd27$var$SvgBlob;



parcelRequire("acw62");
const $e832b40abd16ae8e$var$SvgBlob2 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 161,
        height: 321,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M310 259.5c-10 39.667-34.833 65.333-74.5 77-39.667 11.667-88.333 20.667-146 27-57.667 6.333-87.167-19.333-88.5-77-1.333-57.667 11-103 37-136s55.5-72 88.5-117S191-10 221 38s54.833 87 74.5 117S320 219.833 310 259.5Z",
            fill: "#000",
            fillOpacity: 0.02
        })
    });
var $e832b40abd16ae8e$export$2e2bcd8739ae039 = $e832b40abd16ae8e$var$SvgBlob2;



parcelRequire("acw62");
const $50e00d398a2de8e8$var$SvgStarBlob = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 403,
        height: 380,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M342.354 223.36c-72.96 18.24-101.232 52.44-84.816 102.6 16.416 50.16 4.104 71.364-36.936 63.612-41.04-7.752-80.94 12.996-119.7 62.244-38.76 49.248-77.748 59.28-116.964 30.096-39.216-29.184-46.512-74.556-21.888-136.116 24.624-61.56 13.224-101.916-34.2-121.068-47.424-19.152-54.036-41.496-19.836-67.032 34.2-25.536 57.228-51.072 69.084-76.608C-11.046 55.552 9.702 43.24 39.342 44.152c29.64.912 54.036 9.348 73.188 25.308 19.152 15.96 55.176 3.192 108.072-38.304S291.054-3.5 273.27 51.676s7.524 93.024 75.924 113.544c68.4 20.52 66.12 39.9-6.84 58.14Z",
            stroke: "#000",
            strokeOpacity: 0.02,
            strokeWidth: 7
        })
    });
var $50e00d398a2de8e8$export$2e2bcd8739ae039 = $50e00d398a2de8e8$var$SvgStarBlob;


const $822e291ecc8d53b6$var$Login = ()=>{
    const [{ password: password, passwordRepeat: passwordRepeat, inputType: inputType, loading: loading, error: error }, { passwordChanged: passwordChanged, passwordRepeatChanged: passwordRepeatChanged, newPassword: newPassword, touchStart: touchStart, touchMove: touchMove, touchEnd: touchEnd }] = (0, $3213bd22d6b87309$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "login-wrapper flex flex-ac",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a225b11ef63dbd27$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: newPassword,
                        className: "login flex flex-dir flex-ac",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: "Witaj"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Wpisz nowe has\u0142o"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "h5 flex flex-jc",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                    children: error
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                direction: 'vertical',
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        size: "large",
                                        type: inputType,
                                        placeholder: "Nowe has\u0142o",
                                        prefix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90bdf3d9d7ea52d2$export$2e2bcd8739ae039), {
                                            style: {
                                                color: '#bfbfbf'
                                            }
                                        }),
                                        suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {
                                            onClick: (e)=>e.preventDefault(),
                                            onMouseDown: touchStart,
                                            onMouseMove: touchMove,
                                            onMouseUp: touchEnd,
                                            onTouchStart: touchStart,
                                            onTouchMove: touchMove,
                                            onTouchEnd: touchEnd,
                                            style: {
                                                color: '#8c8c8c'
                                            }
                                        }),
                                        value: password,
                                        onChange: passwordChanged
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        size: "large",
                                        type: "password",
                                        placeholder: "Powt\xf3rz nowe has\u0142o",
                                        prefix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90bdf3d9d7ea52d2$export$2e2bcd8739ae039), {
                                            style: {
                                                color: '#bfbfbf'
                                            }
                                        }),
                                        value: passwordRepeat,
                                        onChange: passwordRepeatChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "submit",
                                style: {
                                    display: 'none'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                type: "primary",
                                size: "large",
                                loading: loading,
                                onClick: newPassword,
                                children: "Ustaw nowe has\u0142o"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50e00d398a2de8e8$export$2e2bcd8739ae039), {
                className: "starblob"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e832b40abd16ae8e$export$2e2bcd8739ae039), {
                className: "blob2"
            })
        ]
    });
};
var $822e291ecc8d53b6$export$2e2bcd8739ae039 = $822e291ecc8d53b6$var$Login;



parcelRequire("acw62");



const $3a750ae9c83aadfd$var$NotFound = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-dir flex-jc flex-ac not-found",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "404 - Nie znaleziono strony"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "lost",
                children: "Zgubi\u0142e\u015B si\u0119?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Nie przejmuj si\u0119 zawsze mo\u017Cesz wr\xf3ci\u0107 na stron\u0119 g\u0142\xf3wn\u0105"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "/",
                children: "Zabierz mnie spowrotem do strony g\u0142\xf3wnej"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50e00d398a2de8e8$export$2e2bcd8739ae039), {
                className: "starblob"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e832b40abd16ae8e$export$2e2bcd8739ae039), {
                className: "blob2"
            })
        ]
    });
};
var $3a750ae9c83aadfd$export$2e2bcd8739ae039 = $3a750ae9c83aadfd$var$NotFound;



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


function $f7392a88184334dd$var$_extends() {
    $f7392a88184334dd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7392a88184334dd$var$_extends.apply(this, arguments);
}
const $f7392a88184334dd$var$SearchOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $f7392a88184334dd$var$_extends({}, props, {
        ref: ref,
        icon: (0, $86af1367b2b71ab8$export$2e2bcd8739ae039)
    }));
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ const $f7392a88184334dd$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f7392a88184334dd$var$SearchOutlined);
var $f7392a88184334dd$export$2e2bcd8739ae039 = $f7392a88184334dd$var$RefIcon;




var $acw62 = parcelRequire("acw62");


const $8cc094a24187a8da$export$b610c6a0e5e099e9 = (clientId)=>{
    const [addresses, setAddresses] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (!clientId) {
            setAddresses(undefined);
            return;
        }
        fetchAddresses(clientId);
    }, [
        clientId
    ]);
    const fetchAddresses = async (clientId)=>{
        try {
            const addresses = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).addresses.getAll({
                clientId: clientId
            });
            setAddresses(addresses);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    return addresses;
};




var $acw62 = parcelRequire("acw62");
const $0319b4c0960b4d6f$export$210f35bcf0632b1a = (fetchFunction)=>{
    return (id)=>{
        const [data, setData] = (0, $acw62.useState)();
        const fetchData = async (id)=>{
            try {
                const result = await fetchFunction(id);
                setData(result);
            } catch (e) {
                console.error(e);
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
            }
        };
        (0, $acw62.useEffect)(()=>{
            if (!id) return;
            fetchData(id);
        }, [
            id
        ]);
        return [
            data,
            async ()=>id && fetchData(id)
        ];
    };
};



const $73567ed6b001db2f$export$95f99d327bc8fbbd = (0, $0319b4c0960b4d6f$export$210f35bcf0632b1a)((0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.get);



var $acw62 = parcelRequire("acw62");


const $1455449f1630f2df$export$4823a6cc022cca16 = (filters)=>{
    const [clients, setClients] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        fetchClients();
    }, []);
    const filtered = (0, $acw62.useMemo)(()=>{
        if (!clients) return undefined;
        return clients.filter((c)=>{
            if (!filters.showRemoved && c.removedDate) return false;
            const search = filters.search?.trim().toLocaleLowerCase();
            if (search) {
                if (c.name.toLocaleLowerCase().includes(search)) return true;
                if (c.phone.toLocaleLowerCase().includes(search)) return true;
                if (c.nip?.toLocaleLowerCase().includes(search)) return true;
                if (c.bdo?.toLocaleLowerCase().includes(search)) return true;
                if (c.email?.toLocaleLowerCase().includes(search)) return true;
                return false;
            }
            return true;
        });
    }, [
        filters,
        clients
    ]);
    const fetchClients = async ()=>{
        try {
            const clients = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.getAll();
            setClients(clients);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    return filtered;
};



var $acw62 = parcelRequire("acw62");


const $ae6dd32a564409fa$export$c71c85be78428942 = (_)=>{
    const [containers, setContainers] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        fetchContainers();
    }, []);
    const fetchContainers = async ()=>{
        try {
            const containers = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.getAll();
            setContainers(containers);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    return containers;
};




const $612618a84cedafbf$export$37d0bd824120f782 = (0, $0319b4c0960b4d6f$export$210f35bcf0632b1a)((id)=>(0, $4c992464a65faeac$export$2e2bcd8739ae039).looseOrder(id).get());



var $acw62 = parcelRequire("acw62");


const $340411795f50fc0d$export$75635297fe14ef93 = (orderId, orderType, enabled = true)=>{
    const [priceChanges, setPriceChanges] = (0, $acw62.useState)();
    const fetchPriceChanges = async ()=>{
        if (!orderId || !enabled) return;
        try {
            const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders2.order(orderType, orderId).priceChanges();
            setPriceChanges(result);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (orderId && enabled) fetchPriceChanges();
    }, [
        orderId,
        enabled
    ]);
    return [
        priceChanges,
        fetchPriceChanges
    ];
};



var $acw62 = parcelRequire("acw62");


const $a2b9c4ff64663a18$export$8d857bf7f8fdc1d8 = (params)=>{
    const [orders, setOrders] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        fetchOrders();
    }, [
        params.after?.unix(),
        params.before?.unix(),
        params.clientId,
        params.done
    ]);
    const fetchOrders = async ()=>{
        try {
            const orders = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders2.getAll({
                after: params.after,
                before: params.before,
                clientId: params.clientId,
                done: params.done
            });
            setOrders(orders);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    const filtered = orders?.filter((o)=>{
        if (!params.search) return true;
        const search = params.search.toLocaleLowerCase();
        if (o.client.name.toLocaleLowerCase().includes(search)) return true;
        if (o.client.phone.toLocaleLowerCase().includes(search)) return true;
        if (o.contact?.toLocaleLowerCase().includes(search)) return true;
        if (o.address.toLocaleLowerCase().includes(search)) return true;
        if (o.wasteType.toLocaleLowerCase().includes(search)) return true;
        return false;
    });
    return [
        filtered,
        fetchOrders
    ];
};




const $0110ece14d6be25d$export$cb218309e6e395bf = (0, $0319b4c0960b4d6f$export$210f35bcf0632b1a)((0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.get);




const $ac789bea2a0ba498$export$23bbbc4533528f03 = (0, $0319b4c0960b4d6f$export$210f35bcf0632b1a)((0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get);



var $acw62 = parcelRequire("acw62");


const $0df0903efbca6a2f$export$90f4370c54dd43c9 = (filters)=>{
    const [users, setUsers] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        fetchUsers();
    }, []);
    const filtered = (0, $acw62.useMemo)(()=>{
        if (!users) return undefined;
        return users.filter((u)=>{
            const search = filters.search?.trim().toLocaleLowerCase();
            if (search) {
                if (`${u.name} ${u.surname}`.toLocaleLowerCase().includes(search)) return true;
                return false;
            }
            if (filters.showRemoved === false && u.removed) return false;
            return true;
        });
    }, [
        filters,
        users
    ]);
    const fetchUsers = async ()=>{
        try {
            const users = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.getAll(true);
            setUsers(users);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    return filtered;
};





var $acw62 = parcelRequire("acw62");





var $45fvw = parcelRequire("45fvw");


var $be5cd62013d5cc71$export$4cd8cc03ec8c034a = /*#__PURE__*/ function(ClientType) {
    ClientType[ClientType["company"] = 0] = "company";
    ClientType[ClientType["private"] = 1] = "private";
    return ClientType;
}({});






var $99be6b3f30de3bdd$export$22b9ccd16748bd76 = /*#__PURE__*/ function(ClientOrderPaymentState) {
    ClientOrderPaymentState["unpaid"] = "unpaid";
    ClientOrderPaymentState["overdue"] = "overdue";
    ClientOrderPaymentState["paid"] = "paid";
    return ClientOrderPaymentState;
}({});
const $99be6b3f30de3bdd$export$aa2d18194c47b2f4 = (state)=>{
    switch(state){
        case "unpaid":
            return "Nieop\u0142acone";
        case "overdue":
            return "Zaleg\u0142e";
        case "paid":
            return "Op\u0142acone";
        default:
            return 'Nieznany';
    }
};
const $99be6b3f30de3bdd$export$e4bbcb8f9590e757 = (order)=>{
    if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).classic) {
        if (order.onPlace) return (0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5];
        if (order.wasReplacement) return (0, $0b4842326956570d$export$c24201f7fe3571d8)[5];
        return (0, $0b4842326956570d$export$a90204d1394caf30)[5];
    }
    if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).loose) {
        if (order.onPlace) return (0, $0b4842326956570d$export$2a9ca2e383622e18)[3];
        return (0, $0b4842326956570d$export$2a9ca2e383622e18)[3];
    }
    return (0, $0b4842326956570d$export$e63a1643b2f79b16)[5];
};








var $5635f57e16062a6d$export$23fbb8b25ca69f0b = /*#__PURE__*/ function(LooseOrderSubtype) {
    LooseOrderSubtype["BigBag"] = "big-bag";
    return LooseOrderSubtype;
}({});
const $5635f57e16062a6d$export$89a944183c3f9be6 = (type)=>{
    switch(type){
        case "big-bag":
            return 'Big Bag';
        default:
            return 'Nieznany';
    }
};
var $5635f57e16062a6d$export$31b3d5f55c6e1017 = /*#__PURE__*/ function(BDO) {
    BDO["BDO"] = "bdo";
    BDO["producing"] = "producing";
    return BDO;
}({});
const $5635f57e16062a6d$export$b6098f7faad3052e = (bdo)=>{
    switch(bdo){
        case "bdo":
            return 'BDO';
        case "producing":
            return "Wytwarzaj\u0105cy";
        default:
            return 'Nieznany';
    }
};
var $5635f57e16062a6d$export$9f1cd706473c7ca4 = /*#__PURE__*/ function(PriceType) {
    PriceType["net"] = "net";
    PriceType["gross"] = "gross";
    return PriceType;
}({});
const $5635f57e16062a6d$export$50833b9f5b13ee6f = (priceType)=>{
    switch(priceType){
        case "net":
            return 'Netto';
        case "gross":
            return 'Brutto';
        default:
            return 'Nieznany';
    }
};


var $83530e2bf16dcece$export$439d2d6c03747598 = /*#__PURE__*/ function(PaymentType) {
    PaymentType["cash"] = "cash";
    PaymentType["transfer"] = "transfer";
    return PaymentType;
}({});
const $83530e2bf16dcece$export$a90a64e69a78f544 = (paymentType)=>{
    switch(paymentType){
        case "cash":
            return "Got\xf3wka";
        case "transfer":
            return 'Przelew';
        default:
            return 'Nieznany';
    }
};




var $5372e6ed6731fb34$export$819724757aafc79 = /*#__PURE__*/ function(OrderState) {
    OrderState["inProgress"] = "in-progress";
    OrderState["done"] = "done";
    OrderState["paid"] = "paid";
    OrderState["invoiced"] = "invoiced";
    return OrderState;
}({});


var $b9894ce465f84cba$export$168ff345f0815589 = /*#__PURE__*/ function(OrderType) {
    OrderType["loose"] = "loose";
    OrderType["classic"] = "classic";
    OrderType["own"] = "own";
    OrderType["other"] = "other";
    return OrderType;
}({});






var $749850eb3cb705e4$export$1f8b1cab05cab788 = /*#__PURE__*/ function(TaskType) {
    TaskType["delivery"] = "delivery";
    TaskType["claiming"] = "claiming";
    TaskType["replacement"] = "replacement";
    return TaskType;
}({});




const $59a068ffb8407501$export$f361f96a4091c414 = 0;
const $59a068ffb8407501$export$604a068d1c631781 = 2;
var $59a068ffb8407501$export$96b5c95c11dc6e9a = /*#__PURE__*/ function(UserLevel) {
    UserLevel[UserLevel["driver"] = 0] = "driver";
    UserLevel[UserLevel["admin"] = 1] = "admin";
    UserLevel[UserLevel["superAdmin"] = 2] = "superAdmin";
    return UserLevel;
}({});




var $f698c1a64cb76360$export$5824bf5f78b5c2c4 = /*#__PURE__*/ function(InternalTaskType) {
    InternalTaskType[InternalTaskType["classicDelivery"] = 0] = "classicDelivery";
    InternalTaskType[InternalTaskType["classicReplacement"] = 1] = "classicReplacement";
    InternalTaskType[InternalTaskType["classicClaiming"] = 2] = "classicClaiming";
    InternalTaskType[InternalTaskType["own"] = 3] = "own";
    InternalTaskType[InternalTaskType["looseDelivery"] = 4] = "looseDelivery";
    InternalTaskType[InternalTaskType["looseClaiming"] = 5] = "looseClaiming";
    InternalTaskType[InternalTaskType["other"] = 6] = "other";
    return InternalTaskType;
}({});
const $f698c1a64cb76360$var$getTaskInternalType = (task)=>{
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic) switch(task.type){
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery:
            return 0;
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).replacement:
            return 1;
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).claiming:
            return 2;
    }
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).own) return 3;
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).loose) switch(task.type){
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery:
            return 4;
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).replacement:
            throw new Error('Replacement tasks are not allowed for loose orders');
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).claiming:
            return 5;
    }
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).other) return 6;
    return undefined;
};
const $f698c1a64cb76360$export$ed5c3368304694 = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [offset, setOffset] = (0, $acw62.useState)(parseInt((0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search)?.offset ?? '0') ?? 0);
    const [tasks, setTasks] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            const users = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.getAll();
            const tasks = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.getAll({
                after: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(offset, 'days').startOf('day'),
                before: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(offset, 'days').endOf('day')
            }).then((tasks)=>tasks.map((task)=>({
                        ...task,
                        internalType: $f698c1a64cb76360$var$getTaskInternalType(task),
                        assignedUser: task.assignedTo ? users.find((u)=>u.id === task.assignedTo) : undefined
                    })));
            tasks.sort((a, b)=>{
                if (a.internalType !== b.internalType) return (a.internalType ?? 7) - (b.internalType ?? 7);
                if (a.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic && b.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic && a.order.onPlace !== b.order.onPlace) return a.order.onPlace ? -1 : 1;
                const aDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(a.date);
                const bDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(b.date);
                return aDate.isBefore(bDate) ? -1 : 1;
            });
            setTasks(tasks);
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(fetch, 30000);
        fetch();
        navigate(`?offset=${offset}`, {
            replace: true
        });
        return ()=>clearInterval(interval);
    }, [
        offset
    ]);
    return {
        tasks: tasks,
        offset: offset,
        setOffset: setOffset
    };
};



var $1c66380376aa2c89$exports = {};
'use strict';
var $e5dd19a945a45bbb$exports = {};
'use strict';
var $08e53d4ef2e1f8ef$exports = {};
'use strict';
var $aaa4be976b2d27a3$exports = {};
'use strict';
/** @type {import('./type')} */ $aaa4be976b2d27a3$exports = TypeError;


var $b6ecc995adbd1b2b$exports = {};
var $b6ecc995adbd1b2b$var$hasMap = typeof Map === 'function' && Map.prototype;
var $b6ecc995adbd1b2b$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $b6ecc995adbd1b2b$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $b6ecc995adbd1b2b$var$mapSize = $b6ecc995adbd1b2b$var$hasMap && $b6ecc995adbd1b2b$var$mapSizeDescriptor && typeof $b6ecc995adbd1b2b$var$mapSizeDescriptor.get === 'function' ? $b6ecc995adbd1b2b$var$mapSizeDescriptor.get : null;
var $b6ecc995adbd1b2b$var$mapForEach = $b6ecc995adbd1b2b$var$hasMap && Map.prototype.forEach;
var $b6ecc995adbd1b2b$var$hasSet = typeof Set === 'function' && Set.prototype;
var $b6ecc995adbd1b2b$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $b6ecc995adbd1b2b$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $b6ecc995adbd1b2b$var$setSize = $b6ecc995adbd1b2b$var$hasSet && $b6ecc995adbd1b2b$var$setSizeDescriptor && typeof $b6ecc995adbd1b2b$var$setSizeDescriptor.get === 'function' ? $b6ecc995adbd1b2b$var$setSizeDescriptor.get : null;
var $b6ecc995adbd1b2b$var$setForEach = $b6ecc995adbd1b2b$var$hasSet && Set.prototype.forEach;
var $b6ecc995adbd1b2b$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $b6ecc995adbd1b2b$var$weakMapHas = $b6ecc995adbd1b2b$var$hasWeakMap ? WeakMap.prototype.has : null;
var $b6ecc995adbd1b2b$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $b6ecc995adbd1b2b$var$weakSetHas = $b6ecc995adbd1b2b$var$hasWeakSet ? WeakSet.prototype.has : null;
var $b6ecc995adbd1b2b$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $b6ecc995adbd1b2b$var$weakRefDeref = $b6ecc995adbd1b2b$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $b6ecc995adbd1b2b$var$booleanValueOf = Boolean.prototype.valueOf;
var $b6ecc995adbd1b2b$var$objectToString = Object.prototype.toString;
var $b6ecc995adbd1b2b$var$functionToString = Function.prototype.toString;
var $b6ecc995adbd1b2b$var$$match = String.prototype.match;
var $b6ecc995adbd1b2b$var$$slice = String.prototype.slice;
var $b6ecc995adbd1b2b$var$$replace = String.prototype.replace;
var $b6ecc995adbd1b2b$var$$toUpperCase = String.prototype.toUpperCase;
var $b6ecc995adbd1b2b$var$$toLowerCase = String.prototype.toLowerCase;
var $b6ecc995adbd1b2b$var$$test = RegExp.prototype.test;
var $b6ecc995adbd1b2b$var$$concat = Array.prototype.concat;
var $b6ecc995adbd1b2b$var$$join = Array.prototype.join;
var $b6ecc995adbd1b2b$var$$arrSlice = Array.prototype.slice;
var $b6ecc995adbd1b2b$var$$floor = Math.floor;
var $b6ecc995adbd1b2b$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $b6ecc995adbd1b2b$var$gOPS = Object.getOwnPropertySymbols;
var $b6ecc995adbd1b2b$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $b6ecc995adbd1b2b$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $b6ecc995adbd1b2b$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $b6ecc995adbd1b2b$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $b6ecc995adbd1b2b$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $b6ecc995adbd1b2b$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $b6ecc995adbd1b2b$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $b6ecc995adbd1b2b$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$b6ecc995adbd1b2b$var$$floor(-num) : $b6ecc995adbd1b2b$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $b6ecc995adbd1b2b$var$$slice.call(str, intStr.length + 1);
            return $b6ecc995adbd1b2b$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $b6ecc995adbd1b2b$var$$replace.call($b6ecc995adbd1b2b$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $b6ecc995adbd1b2b$var$$replace.call(str, sepRegex, '$&_');
}
var $eca075ad100d834d$exports = {};
"use strict";


var $b6ecc995adbd1b2b$var$inspectCustom = $eca075ad100d834d$exports.custom;
var $b6ecc995adbd1b2b$var$inspectSymbol = $b6ecc995adbd1b2b$var$isSymbol($b6ecc995adbd1b2b$var$inspectCustom) ? $b6ecc995adbd1b2b$var$inspectCustom : null;
var $b6ecc995adbd1b2b$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $b6ecc995adbd1b2b$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$b6ecc995adbd1b2b$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($b6ecc995adbd1b2b$var$has(opts, 'quoteStyle') && !$b6ecc995adbd1b2b$var$has($b6ecc995adbd1b2b$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($b6ecc995adbd1b2b$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $b6ecc995adbd1b2b$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($b6ecc995adbd1b2b$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($b6ecc995adbd1b2b$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $b6ecc995adbd1b2b$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $b6ecc995adbd1b2b$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $b6ecc995adbd1b2b$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $b6ecc995adbd1b2b$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $b6ecc995adbd1b2b$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($b6ecc995adbd1b2b$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $b6ecc995adbd1b2b$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($b6ecc995adbd1b2b$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$b6ecc995adbd1b2b$var$isRegExp(obj)) {
        var name = $b6ecc995adbd1b2b$var$nameOf(obj);
        var keys = $b6ecc995adbd1b2b$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $b6ecc995adbd1b2b$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($b6ecc995adbd1b2b$var$isSymbol(obj)) {
        var symString = $b6ecc995adbd1b2b$var$hasShammedSymbols ? $b6ecc995adbd1b2b$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $b6ecc995adbd1b2b$var$symToString.call(obj);
        return typeof obj === 'object' && !$b6ecc995adbd1b2b$var$hasShammedSymbols ? $b6ecc995adbd1b2b$var$markBoxed(symString) : symString;
    }
    if ($b6ecc995adbd1b2b$var$isElement(obj)) {
        var s = '<' + $b6ecc995adbd1b2b$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $b6ecc995adbd1b2b$var$wrapQuotes($b6ecc995adbd1b2b$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $b6ecc995adbd1b2b$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($b6ecc995adbd1b2b$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $b6ecc995adbd1b2b$var$arrObjKeys(obj, inspect);
        if (indent && !$b6ecc995adbd1b2b$var$singleLineValues(xs)) return '[' + $b6ecc995adbd1b2b$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $b6ecc995adbd1b2b$var$$join.call(xs, ', ') + ' ]';
    }
    if ($b6ecc995adbd1b2b$var$isError(obj)) {
        var parts = $b6ecc995adbd1b2b$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$b6ecc995adbd1b2b$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $b6ecc995adbd1b2b$var$$join.call($b6ecc995adbd1b2b$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $b6ecc995adbd1b2b$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($b6ecc995adbd1b2b$var$inspectSymbol && typeof obj[$b6ecc995adbd1b2b$var$inspectSymbol] === 'function' && $eca075ad100d834d$exports) return $eca075ad100d834d$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($b6ecc995adbd1b2b$var$isMap(obj)) {
        var mapParts = [];
        if ($b6ecc995adbd1b2b$var$mapForEach) $b6ecc995adbd1b2b$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $b6ecc995adbd1b2b$var$collectionOf('Map', $b6ecc995adbd1b2b$var$mapSize.call(obj), mapParts, indent);
    }
    if ($b6ecc995adbd1b2b$var$isSet(obj)) {
        var setParts = [];
        if ($b6ecc995adbd1b2b$var$setForEach) $b6ecc995adbd1b2b$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $b6ecc995adbd1b2b$var$collectionOf('Set', $b6ecc995adbd1b2b$var$setSize.call(obj), setParts, indent);
    }
    if ($b6ecc995adbd1b2b$var$isWeakMap(obj)) return $b6ecc995adbd1b2b$var$weakCollectionOf('WeakMap');
    if ($b6ecc995adbd1b2b$var$isWeakSet(obj)) return $b6ecc995adbd1b2b$var$weakCollectionOf('WeakSet');
    if ($b6ecc995adbd1b2b$var$isWeakRef(obj)) return $b6ecc995adbd1b2b$var$weakCollectionOf('WeakRef');
    if ($b6ecc995adbd1b2b$var$isNumber(obj)) return $b6ecc995adbd1b2b$var$markBoxed(inspect(Number(obj)));
    if ($b6ecc995adbd1b2b$var$isBigInt(obj)) return $b6ecc995adbd1b2b$var$markBoxed(inspect($b6ecc995adbd1b2b$var$bigIntValueOf.call(obj)));
    if ($b6ecc995adbd1b2b$var$isBoolean(obj)) return $b6ecc995adbd1b2b$var$markBoxed($b6ecc995adbd1b2b$var$booleanValueOf.call(obj));
    if ($b6ecc995adbd1b2b$var$isString(obj)) return $b6ecc995adbd1b2b$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$b6ecc995adbd1b2b$var$isDate(obj) && !$b6ecc995adbd1b2b$var$isRegExp(obj)) {
        var ys = $b6ecc995adbd1b2b$var$arrObjKeys(obj, inspect);
        var isPlainObject = $b6ecc995adbd1b2b$var$gPO ? $b6ecc995adbd1b2b$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $b6ecc995adbd1b2b$var$toStringTag && Object(obj) === obj && $b6ecc995adbd1b2b$var$toStringTag in obj ? $b6ecc995adbd1b2b$var$$slice.call($b6ecc995adbd1b2b$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $b6ecc995adbd1b2b$var$$join.call($b6ecc995adbd1b2b$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $b6ecc995adbd1b2b$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $b6ecc995adbd1b2b$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $b6ecc995adbd1b2b$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $b6ecc995adbd1b2b$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $b6ecc995adbd1b2b$var$quote(s) {
    return $b6ecc995adbd1b2b$var$$replace.call(String(s), /"/g, '&quot;');
}
function $b6ecc995adbd1b2b$var$canTrustToString(obj) {
    return !$b6ecc995adbd1b2b$var$toStringTag || !(typeof obj === 'object' && ($b6ecc995adbd1b2b$var$toStringTag in obj || typeof obj[$b6ecc995adbd1b2b$var$toStringTag] !== 'undefined'));
}
function $b6ecc995adbd1b2b$var$isArray(obj) {
    return $b6ecc995adbd1b2b$var$toStr(obj) === '[object Array]' && $b6ecc995adbd1b2b$var$canTrustToString(obj);
}
function $b6ecc995adbd1b2b$var$isDate(obj) {
    return $b6ecc995adbd1b2b$var$toStr(obj) === '[object Date]' && $b6ecc995adbd1b2b$var$canTrustToString(obj);
}
function $b6ecc995adbd1b2b$var$isRegExp(obj) {
    return $b6ecc995adbd1b2b$var$toStr(obj) === '[object RegExp]' && $b6ecc995adbd1b2b$var$canTrustToString(obj);
}
function $b6ecc995adbd1b2b$var$isError(obj) {
    return $b6ecc995adbd1b2b$var$toStr(obj) === '[object Error]' && $b6ecc995adbd1b2b$var$canTrustToString(obj);
}
function $b6ecc995adbd1b2b$var$isString(obj) {
    return $b6ecc995adbd1b2b$var$toStr(obj) === '[object String]' && $b6ecc995adbd1b2b$var$canTrustToString(obj);
}
function $b6ecc995adbd1b2b$var$isNumber(obj) {
    return $b6ecc995adbd1b2b$var$toStr(obj) === '[object Number]' && $b6ecc995adbd1b2b$var$canTrustToString(obj);
}
function $b6ecc995adbd1b2b$var$isBoolean(obj) {
    return $b6ecc995adbd1b2b$var$toStr(obj) === '[object Boolean]' && $b6ecc995adbd1b2b$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $b6ecc995adbd1b2b$var$isSymbol(obj) {
    if ($b6ecc995adbd1b2b$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$b6ecc995adbd1b2b$var$symToString) return false;
    try {
        $b6ecc995adbd1b2b$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $b6ecc995adbd1b2b$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$b6ecc995adbd1b2b$var$bigIntValueOf) return false;
    try {
        $b6ecc995adbd1b2b$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $b6ecc995adbd1b2b$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $b6ecc995adbd1b2b$var$has(obj, key) {
    return $b6ecc995adbd1b2b$var$hasOwn.call(obj, key);
}
function $b6ecc995adbd1b2b$var$toStr(obj) {
    return $b6ecc995adbd1b2b$var$objectToString.call(obj);
}
function $b6ecc995adbd1b2b$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $b6ecc995adbd1b2b$var$$match.call($b6ecc995adbd1b2b$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $b6ecc995adbd1b2b$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $b6ecc995adbd1b2b$var$isMap(x) {
    if (!$b6ecc995adbd1b2b$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $b6ecc995adbd1b2b$var$mapSize.call(x);
        try {
            $b6ecc995adbd1b2b$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b6ecc995adbd1b2b$var$isWeakMap(x) {
    if (!$b6ecc995adbd1b2b$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $b6ecc995adbd1b2b$var$weakMapHas.call(x, $b6ecc995adbd1b2b$var$weakMapHas);
        try {
            $b6ecc995adbd1b2b$var$weakSetHas.call(x, $b6ecc995adbd1b2b$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b6ecc995adbd1b2b$var$isWeakRef(x) {
    if (!$b6ecc995adbd1b2b$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $b6ecc995adbd1b2b$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $b6ecc995adbd1b2b$var$isSet(x) {
    if (!$b6ecc995adbd1b2b$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $b6ecc995adbd1b2b$var$setSize.call(x);
        try {
            $b6ecc995adbd1b2b$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b6ecc995adbd1b2b$var$isWeakSet(x) {
    if (!$b6ecc995adbd1b2b$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $b6ecc995adbd1b2b$var$weakSetHas.call(x, $b6ecc995adbd1b2b$var$weakSetHas);
        try {
            $b6ecc995adbd1b2b$var$weakMapHas.call(x, $b6ecc995adbd1b2b$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $b6ecc995adbd1b2b$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $b6ecc995adbd1b2b$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $b6ecc995adbd1b2b$var$inspectString($b6ecc995adbd1b2b$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $b6ecc995adbd1b2b$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $b6ecc995adbd1b2b$var$$replace.call($b6ecc995adbd1b2b$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $b6ecc995adbd1b2b$var$lowbyte);
    return $b6ecc995adbd1b2b$var$wrapQuotes(s, 'single', opts);
}
function $b6ecc995adbd1b2b$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $b6ecc995adbd1b2b$var$$toUpperCase.call(n.toString(16));
}
function $b6ecc995adbd1b2b$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $b6ecc995adbd1b2b$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $b6ecc995adbd1b2b$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $b6ecc995adbd1b2b$var$indentedJoin(entries, indent) : $b6ecc995adbd1b2b$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $b6ecc995adbd1b2b$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($b6ecc995adbd1b2b$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $b6ecc995adbd1b2b$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $b6ecc995adbd1b2b$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $b6ecc995adbd1b2b$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $b6ecc995adbd1b2b$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $b6ecc995adbd1b2b$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $b6ecc995adbd1b2b$var$arrObjKeys(obj, inspect) {
    var isArr = $b6ecc995adbd1b2b$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $b6ecc995adbd1b2b$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $b6ecc995adbd1b2b$var$gOPS === 'function' ? $b6ecc995adbd1b2b$var$gOPS(obj) : [];
    var symMap;
    if ($b6ecc995adbd1b2b$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$b6ecc995adbd1b2b$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($b6ecc995adbd1b2b$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($b6ecc995adbd1b2b$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $b6ecc995adbd1b2b$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($b6ecc995adbd1b2b$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $52bc36570c76608b$exports = {};
'use strict';
var $9ba23b7b2d4a102c$exports = {};
var $9ba23b7b2d4a102c$var$hasMap = typeof Map === 'function' && Map.prototype;
var $9ba23b7b2d4a102c$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $9ba23b7b2d4a102c$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $9ba23b7b2d4a102c$var$mapSize = $9ba23b7b2d4a102c$var$hasMap && $9ba23b7b2d4a102c$var$mapSizeDescriptor && typeof $9ba23b7b2d4a102c$var$mapSizeDescriptor.get === 'function' ? $9ba23b7b2d4a102c$var$mapSizeDescriptor.get : null;
var $9ba23b7b2d4a102c$var$mapForEach = $9ba23b7b2d4a102c$var$hasMap && Map.prototype.forEach;
var $9ba23b7b2d4a102c$var$hasSet = typeof Set === 'function' && Set.prototype;
var $9ba23b7b2d4a102c$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $9ba23b7b2d4a102c$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $9ba23b7b2d4a102c$var$setSize = $9ba23b7b2d4a102c$var$hasSet && $9ba23b7b2d4a102c$var$setSizeDescriptor && typeof $9ba23b7b2d4a102c$var$setSizeDescriptor.get === 'function' ? $9ba23b7b2d4a102c$var$setSizeDescriptor.get : null;
var $9ba23b7b2d4a102c$var$setForEach = $9ba23b7b2d4a102c$var$hasSet && Set.prototype.forEach;
var $9ba23b7b2d4a102c$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $9ba23b7b2d4a102c$var$weakMapHas = $9ba23b7b2d4a102c$var$hasWeakMap ? WeakMap.prototype.has : null;
var $9ba23b7b2d4a102c$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $9ba23b7b2d4a102c$var$weakSetHas = $9ba23b7b2d4a102c$var$hasWeakSet ? WeakSet.prototype.has : null;
var $9ba23b7b2d4a102c$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $9ba23b7b2d4a102c$var$weakRefDeref = $9ba23b7b2d4a102c$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $9ba23b7b2d4a102c$var$booleanValueOf = Boolean.prototype.valueOf;
var $9ba23b7b2d4a102c$var$objectToString = Object.prototype.toString;
var $9ba23b7b2d4a102c$var$functionToString = Function.prototype.toString;
var $9ba23b7b2d4a102c$var$$match = String.prototype.match;
var $9ba23b7b2d4a102c$var$$slice = String.prototype.slice;
var $9ba23b7b2d4a102c$var$$replace = String.prototype.replace;
var $9ba23b7b2d4a102c$var$$toUpperCase = String.prototype.toUpperCase;
var $9ba23b7b2d4a102c$var$$toLowerCase = String.prototype.toLowerCase;
var $9ba23b7b2d4a102c$var$$test = RegExp.prototype.test;
var $9ba23b7b2d4a102c$var$$concat = Array.prototype.concat;
var $9ba23b7b2d4a102c$var$$join = Array.prototype.join;
var $9ba23b7b2d4a102c$var$$arrSlice = Array.prototype.slice;
var $9ba23b7b2d4a102c$var$$floor = Math.floor;
var $9ba23b7b2d4a102c$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $9ba23b7b2d4a102c$var$gOPS = Object.getOwnPropertySymbols;
var $9ba23b7b2d4a102c$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $9ba23b7b2d4a102c$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $9ba23b7b2d4a102c$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $9ba23b7b2d4a102c$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $9ba23b7b2d4a102c$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $9ba23b7b2d4a102c$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $9ba23b7b2d4a102c$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $9ba23b7b2d4a102c$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$9ba23b7b2d4a102c$var$$floor(-num) : $9ba23b7b2d4a102c$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $9ba23b7b2d4a102c$var$$slice.call(str, intStr.length + 1);
            return $9ba23b7b2d4a102c$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $9ba23b7b2d4a102c$var$$replace.call($9ba23b7b2d4a102c$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $9ba23b7b2d4a102c$var$$replace.call(str, sepRegex, '$&_');
}

var $9ba23b7b2d4a102c$var$inspectCustom = $eca075ad100d834d$exports.custom;
var $9ba23b7b2d4a102c$var$inspectSymbol = $9ba23b7b2d4a102c$var$isSymbol($9ba23b7b2d4a102c$var$inspectCustom) ? $9ba23b7b2d4a102c$var$inspectCustom : null;
var $9ba23b7b2d4a102c$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $9ba23b7b2d4a102c$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$9ba23b7b2d4a102c$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($9ba23b7b2d4a102c$var$has(opts, 'quoteStyle') && !$9ba23b7b2d4a102c$var$has($9ba23b7b2d4a102c$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($9ba23b7b2d4a102c$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $9ba23b7b2d4a102c$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($9ba23b7b2d4a102c$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($9ba23b7b2d4a102c$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $9ba23b7b2d4a102c$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $9ba23b7b2d4a102c$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $9ba23b7b2d4a102c$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $9ba23b7b2d4a102c$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $9ba23b7b2d4a102c$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($9ba23b7b2d4a102c$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $9ba23b7b2d4a102c$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($9ba23b7b2d4a102c$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$9ba23b7b2d4a102c$var$isRegExp(obj)) {
        var name = $9ba23b7b2d4a102c$var$nameOf(obj);
        var keys = $9ba23b7b2d4a102c$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $9ba23b7b2d4a102c$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($9ba23b7b2d4a102c$var$isSymbol(obj)) {
        var symString = $9ba23b7b2d4a102c$var$hasShammedSymbols ? $9ba23b7b2d4a102c$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $9ba23b7b2d4a102c$var$symToString.call(obj);
        return typeof obj === 'object' && !$9ba23b7b2d4a102c$var$hasShammedSymbols ? $9ba23b7b2d4a102c$var$markBoxed(symString) : symString;
    }
    if ($9ba23b7b2d4a102c$var$isElement(obj)) {
        var s = '<' + $9ba23b7b2d4a102c$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $9ba23b7b2d4a102c$var$wrapQuotes($9ba23b7b2d4a102c$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $9ba23b7b2d4a102c$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($9ba23b7b2d4a102c$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $9ba23b7b2d4a102c$var$arrObjKeys(obj, inspect);
        if (indent && !$9ba23b7b2d4a102c$var$singleLineValues(xs)) return '[' + $9ba23b7b2d4a102c$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $9ba23b7b2d4a102c$var$$join.call(xs, ', ') + ' ]';
    }
    if ($9ba23b7b2d4a102c$var$isError(obj)) {
        var parts = $9ba23b7b2d4a102c$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$9ba23b7b2d4a102c$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $9ba23b7b2d4a102c$var$$join.call($9ba23b7b2d4a102c$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $9ba23b7b2d4a102c$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($9ba23b7b2d4a102c$var$inspectSymbol && typeof obj[$9ba23b7b2d4a102c$var$inspectSymbol] === 'function' && $eca075ad100d834d$exports) return $eca075ad100d834d$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($9ba23b7b2d4a102c$var$isMap(obj)) {
        var mapParts = [];
        if ($9ba23b7b2d4a102c$var$mapForEach) $9ba23b7b2d4a102c$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $9ba23b7b2d4a102c$var$collectionOf('Map', $9ba23b7b2d4a102c$var$mapSize.call(obj), mapParts, indent);
    }
    if ($9ba23b7b2d4a102c$var$isSet(obj)) {
        var setParts = [];
        if ($9ba23b7b2d4a102c$var$setForEach) $9ba23b7b2d4a102c$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $9ba23b7b2d4a102c$var$collectionOf('Set', $9ba23b7b2d4a102c$var$setSize.call(obj), setParts, indent);
    }
    if ($9ba23b7b2d4a102c$var$isWeakMap(obj)) return $9ba23b7b2d4a102c$var$weakCollectionOf('WeakMap');
    if ($9ba23b7b2d4a102c$var$isWeakSet(obj)) return $9ba23b7b2d4a102c$var$weakCollectionOf('WeakSet');
    if ($9ba23b7b2d4a102c$var$isWeakRef(obj)) return $9ba23b7b2d4a102c$var$weakCollectionOf('WeakRef');
    if ($9ba23b7b2d4a102c$var$isNumber(obj)) return $9ba23b7b2d4a102c$var$markBoxed(inspect(Number(obj)));
    if ($9ba23b7b2d4a102c$var$isBigInt(obj)) return $9ba23b7b2d4a102c$var$markBoxed(inspect($9ba23b7b2d4a102c$var$bigIntValueOf.call(obj)));
    if ($9ba23b7b2d4a102c$var$isBoolean(obj)) return $9ba23b7b2d4a102c$var$markBoxed($9ba23b7b2d4a102c$var$booleanValueOf.call(obj));
    if ($9ba23b7b2d4a102c$var$isString(obj)) return $9ba23b7b2d4a102c$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$9ba23b7b2d4a102c$var$isDate(obj) && !$9ba23b7b2d4a102c$var$isRegExp(obj)) {
        var ys = $9ba23b7b2d4a102c$var$arrObjKeys(obj, inspect);
        var isPlainObject = $9ba23b7b2d4a102c$var$gPO ? $9ba23b7b2d4a102c$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $9ba23b7b2d4a102c$var$toStringTag && Object(obj) === obj && $9ba23b7b2d4a102c$var$toStringTag in obj ? $9ba23b7b2d4a102c$var$$slice.call($9ba23b7b2d4a102c$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $9ba23b7b2d4a102c$var$$join.call($9ba23b7b2d4a102c$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $9ba23b7b2d4a102c$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $9ba23b7b2d4a102c$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $9ba23b7b2d4a102c$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $9ba23b7b2d4a102c$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $9ba23b7b2d4a102c$var$quote(s) {
    return $9ba23b7b2d4a102c$var$$replace.call(String(s), /"/g, '&quot;');
}
function $9ba23b7b2d4a102c$var$canTrustToString(obj) {
    return !$9ba23b7b2d4a102c$var$toStringTag || !(typeof obj === 'object' && ($9ba23b7b2d4a102c$var$toStringTag in obj || typeof obj[$9ba23b7b2d4a102c$var$toStringTag] !== 'undefined'));
}
function $9ba23b7b2d4a102c$var$isArray(obj) {
    return $9ba23b7b2d4a102c$var$toStr(obj) === '[object Array]' && $9ba23b7b2d4a102c$var$canTrustToString(obj);
}
function $9ba23b7b2d4a102c$var$isDate(obj) {
    return $9ba23b7b2d4a102c$var$toStr(obj) === '[object Date]' && $9ba23b7b2d4a102c$var$canTrustToString(obj);
}
function $9ba23b7b2d4a102c$var$isRegExp(obj) {
    return $9ba23b7b2d4a102c$var$toStr(obj) === '[object RegExp]' && $9ba23b7b2d4a102c$var$canTrustToString(obj);
}
function $9ba23b7b2d4a102c$var$isError(obj) {
    return $9ba23b7b2d4a102c$var$toStr(obj) === '[object Error]' && $9ba23b7b2d4a102c$var$canTrustToString(obj);
}
function $9ba23b7b2d4a102c$var$isString(obj) {
    return $9ba23b7b2d4a102c$var$toStr(obj) === '[object String]' && $9ba23b7b2d4a102c$var$canTrustToString(obj);
}
function $9ba23b7b2d4a102c$var$isNumber(obj) {
    return $9ba23b7b2d4a102c$var$toStr(obj) === '[object Number]' && $9ba23b7b2d4a102c$var$canTrustToString(obj);
}
function $9ba23b7b2d4a102c$var$isBoolean(obj) {
    return $9ba23b7b2d4a102c$var$toStr(obj) === '[object Boolean]' && $9ba23b7b2d4a102c$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $9ba23b7b2d4a102c$var$isSymbol(obj) {
    if ($9ba23b7b2d4a102c$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$9ba23b7b2d4a102c$var$symToString) return false;
    try {
        $9ba23b7b2d4a102c$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $9ba23b7b2d4a102c$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$9ba23b7b2d4a102c$var$bigIntValueOf) return false;
    try {
        $9ba23b7b2d4a102c$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $9ba23b7b2d4a102c$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $9ba23b7b2d4a102c$var$has(obj, key) {
    return $9ba23b7b2d4a102c$var$hasOwn.call(obj, key);
}
function $9ba23b7b2d4a102c$var$toStr(obj) {
    return $9ba23b7b2d4a102c$var$objectToString.call(obj);
}
function $9ba23b7b2d4a102c$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $9ba23b7b2d4a102c$var$$match.call($9ba23b7b2d4a102c$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $9ba23b7b2d4a102c$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $9ba23b7b2d4a102c$var$isMap(x) {
    if (!$9ba23b7b2d4a102c$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $9ba23b7b2d4a102c$var$mapSize.call(x);
        try {
            $9ba23b7b2d4a102c$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9ba23b7b2d4a102c$var$isWeakMap(x) {
    if (!$9ba23b7b2d4a102c$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $9ba23b7b2d4a102c$var$weakMapHas.call(x, $9ba23b7b2d4a102c$var$weakMapHas);
        try {
            $9ba23b7b2d4a102c$var$weakSetHas.call(x, $9ba23b7b2d4a102c$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9ba23b7b2d4a102c$var$isWeakRef(x) {
    if (!$9ba23b7b2d4a102c$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $9ba23b7b2d4a102c$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $9ba23b7b2d4a102c$var$isSet(x) {
    if (!$9ba23b7b2d4a102c$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $9ba23b7b2d4a102c$var$setSize.call(x);
        try {
            $9ba23b7b2d4a102c$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9ba23b7b2d4a102c$var$isWeakSet(x) {
    if (!$9ba23b7b2d4a102c$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $9ba23b7b2d4a102c$var$weakSetHas.call(x, $9ba23b7b2d4a102c$var$weakSetHas);
        try {
            $9ba23b7b2d4a102c$var$weakMapHas.call(x, $9ba23b7b2d4a102c$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $9ba23b7b2d4a102c$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $9ba23b7b2d4a102c$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $9ba23b7b2d4a102c$var$inspectString($9ba23b7b2d4a102c$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $9ba23b7b2d4a102c$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $9ba23b7b2d4a102c$var$$replace.call($9ba23b7b2d4a102c$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $9ba23b7b2d4a102c$var$lowbyte);
    return $9ba23b7b2d4a102c$var$wrapQuotes(s, 'single', opts);
}
function $9ba23b7b2d4a102c$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $9ba23b7b2d4a102c$var$$toUpperCase.call(n.toString(16));
}
function $9ba23b7b2d4a102c$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $9ba23b7b2d4a102c$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $9ba23b7b2d4a102c$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $9ba23b7b2d4a102c$var$indentedJoin(entries, indent) : $9ba23b7b2d4a102c$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $9ba23b7b2d4a102c$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($9ba23b7b2d4a102c$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $9ba23b7b2d4a102c$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $9ba23b7b2d4a102c$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $9ba23b7b2d4a102c$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $9ba23b7b2d4a102c$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $9ba23b7b2d4a102c$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $9ba23b7b2d4a102c$var$arrObjKeys(obj, inspect) {
    var isArr = $9ba23b7b2d4a102c$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $9ba23b7b2d4a102c$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $9ba23b7b2d4a102c$var$gOPS === 'function' ? $9ba23b7b2d4a102c$var$gOPS(obj) : [];
    var symMap;
    if ($9ba23b7b2d4a102c$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$9ba23b7b2d4a102c$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($9ba23b7b2d4a102c$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($9ba23b7b2d4a102c$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $9ba23b7b2d4a102c$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($9ba23b7b2d4a102c$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}



/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $52bc36570c76608b$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $52bc36570c76608b$var$listSet = function(objects, key, value) {
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $52bc36570c76608b$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$52bc36570c76608b$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listDelete = function(objects, key) {
    if (objects) return $52bc36570c76608b$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $52bc36570c76608b$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $9ba23b7b2d4a102c$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $52bc36570c76608b$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $52bc36570c76608b$var$listGet($o, key);
        },
        has: function(key) {
            return $52bc36570c76608b$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $52bc36570c76608b$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $8043468335131548$exports = {};
'use strict';
var $1258b452ecf218a1$exports = {};
'use strict';
var $1258b452ecf218a1$var$undefined1;
var $68f77cfee0d91ea0$exports = {};
'use strict';
/** @type {import('.')} */ $68f77cfee0d91ea0$exports = Object;


var $41038844aec6eaa2$exports = {};
'use strict';
/** @type {import('.')} */ $41038844aec6eaa2$exports = Error;


var $cd6d4b204c89f4f4$exports = {};
'use strict';
/** @type {import('./eval')} */ $cd6d4b204c89f4f4$exports = EvalError;


var $72e6a4e026a755bb$exports = {};
'use strict';
/** @type {import('./range')} */ $72e6a4e026a755bb$exports = RangeError;


var $1e478fcc3e34e216$exports = {};
'use strict';
/** @type {import('./ref')} */ $1e478fcc3e34e216$exports = ReferenceError;


var $43bb4ccdc6568bcf$exports = {};
'use strict';
/** @type {import('./syntax')} */ $43bb4ccdc6568bcf$exports = SyntaxError;



var $cde0c3ef12944098$exports = {};
'use strict';
/** @type {import('./uri')} */ $cde0c3ef12944098$exports = URIError;


var $829c6ad74b893335$exports = {};
'use strict';
/** @type {import('./abs')} */ $829c6ad74b893335$exports = Math.abs;


var $a0167fb8027efc6c$exports = {};
'use strict';
/** @type {import('./floor')} */ $a0167fb8027efc6c$exports = Math.floor;


var $59437e5dc9fc2c61$exports = {};
'use strict';
/** @type {import('./max')} */ $59437e5dc9fc2c61$exports = Math.max;


var $328f401f1e19f003$exports = {};
'use strict';
/** @type {import('./min')} */ $328f401f1e19f003$exports = Math.min;


var $8560e7c6d4e34f2f$exports = {};
'use strict';
/** @type {import('./pow')} */ $8560e7c6d4e34f2f$exports = Math.pow;


var $10e5f4d8a4a1ed83$exports = {};
'use strict';
/** @type {import('./round')} */ $10e5f4d8a4a1ed83$exports = Math.round;


var $37113bd5f1fb3cc6$exports = {};
'use strict';
var $3327ce1cf537a5ae$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $3327ce1cf537a5ae$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $37113bd5f1fb3cc6$exports = function sign(number) {
    if ($3327ce1cf537a5ae$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $a2d7d74e83f6c3ed$exports = {};
'use strict';
var $985031ced66f900d$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $985031ced66f900d$exports = Object.getOwnPropertyDescriptor;


var $a2d7d74e83f6c3ed$require$$gOPD = $985031ced66f900d$exports;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
$a2d7d74e83f6c3ed$exports = $a2d7d74e83f6c3ed$require$$gOPD;


var $e42bccb64e3fb3fd$exports = {};
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
$e42bccb64e3fb3fd$exports = $e42bccb64e3fb3fd$var$$defineProperty;


var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $aaa4be976b2d27a3$exports();
};
var $1258b452ecf218a1$var$ThrowTypeError = $a2d7d74e83f6c3ed$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $a2d7d74e83f6c3ed$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();
var $2a9ec54411859bd9$exports = {};
'use strict';
var $0a6f5f26ef0609b6$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $0a6f5f26ef0609b6$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $a683e9a1df37ed0e$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $a683e9a1df37ed0e$exports = $68f77cfee0d91ea0$exports.getPrototypeOf || null;


var $55566fcac2c38fe4$exports = {};
'use strict';
var $e3cb45ba87de93fe$exports = {};
'use strict';
var $c0378745895dc03c$exports = {};
'use strict';
var $efd80b1d7fbb2850$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$efd80b1d7fbb2850$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$c0378745895dc03c$exports = Function.prototype.bind || $efd80b1d7fbb2850$exports;



var $6da1bf1c46eb4156$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $6da1bf1c46eb4156$exports = Function.prototype.call;


var $2e4f98706b21e7c9$exports = {};
'use strict';

var $0658b6e5d2101996$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $0658b6e5d2101996$exports = Function.prototype.apply;



var $623e642332342b72$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $623e642332342b72$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $2e4f98706b21e7c9$exports = $623e642332342b72$exports || $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, $0658b6e5d2101996$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $e3cb45ba87de93fe$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $aaa4be976b2d27a3$exports('a function is required');
    return $2e4f98706b21e7c9$exports($c0378745895dc03c$exports, $6da1bf1c46eb4156$exports, args);
};



var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $a2d7d74e83f6c3ed$exports && $a2d7d74e83f6c3ed$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $55566fcac2c38fe4$exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $e3cb45ba87de93fe$exports([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;


/** @type {import('.')} */ $2a9ec54411859bd9$exports = $0a6f5f26ef0609b6$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $0a6f5f26ef0609b6$exports(O);
} : $a683e9a1df37ed0e$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $a683e9a1df37ed0e$exports(O);
} : $55566fcac2c38fe4$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $55566fcac2c38fe4$exports(O);
} : null;






var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $41038844aec6eaa2$exports,
    '%eval%': eval,
    '%EvalError%': $cd6d4b204c89f4f4$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $68f77cfee0d91ea0$exports,
    '%Object.getOwnPropertyDescriptor%': $a2d7d74e83f6c3ed$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $72e6a4e026a755bb$exports,
    '%ReferenceError%': $1e478fcc3e34e216$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $43bb4ccdc6568bcf$exports,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $aaa4be976b2d27a3$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $cde0c3ef12944098$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6da1bf1c46eb4156$exports,
    '%Function.prototype.apply%': $0658b6e5d2101996$exports,
    '%Object.defineProperty%': $e42bccb64e3fb3fd$exports,
    '%Object.getPrototypeOf%': $a683e9a1df37ed0e$exports,
    '%Math.abs%': $829c6ad74b893335$exports,
    '%Math.floor%': $a0167fb8027efc6c$exports,
    '%Math.max%': $59437e5dc9fc2c61$exports,
    '%Math.min%': $328f401f1e19f003$exports,
    '%Math.pow%': $8560e7c6d4e34f2f$exports,
    '%Math.round%': $10e5f4d8a4a1ed83$exports,
    '%Math.sign%': $37113bd5f1fb3cc6$exports,
    '%Reflect.getPrototypeOf%': $0a6f5f26ef0609b6$exports
};
if ($2a9ec54411859bd9$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $2a9ec54411859bd9$exports) value = $2a9ec54411859bd9$exports(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $30dbf79dbae6c725$exports = {};
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $30dbf79dbae6c725$exports = $c0378745895dc03c$exports.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);


var $1258b452ecf218a1$var$$concat = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $c0378745895dc03c$exports.call($0658b6e5d2101996$exports, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aaa4be976b2d27a3$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $43bb4ccdc6568bcf$exports('intrinsic ' + name + ' does not exist!');
};
$1258b452ecf218a1$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aaa4be976b2d27a3$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aaa4be976b2d27a3$exports('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $43bb4ccdc6568bcf$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $43bb4ccdc6568bcf$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aaa4be976b2d27a3$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($a2d7d74e83f6c3ed$exports && i + 1 >= parts.length) {
                var desc = $a2d7d74e83f6c3ed$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $30dbf79dbae6c725$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $adf8ebd7229df60a$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $e3cb45ba87de93fe$exports([
    $1258b452ecf218a1$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $adf8ebd7229df60a$exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1258b452ecf218a1$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $e3cb45ba87de93fe$exports(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};


var $7bd0ce8a53424863$exports = {};
var $7bd0ce8a53424863$var$hasMap = typeof Map === 'function' && Map.prototype;
var $7bd0ce8a53424863$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $7bd0ce8a53424863$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $7bd0ce8a53424863$var$mapSize = $7bd0ce8a53424863$var$hasMap && $7bd0ce8a53424863$var$mapSizeDescriptor && typeof $7bd0ce8a53424863$var$mapSizeDescriptor.get === 'function' ? $7bd0ce8a53424863$var$mapSizeDescriptor.get : null;
var $7bd0ce8a53424863$var$mapForEach = $7bd0ce8a53424863$var$hasMap && Map.prototype.forEach;
var $7bd0ce8a53424863$var$hasSet = typeof Set === 'function' && Set.prototype;
var $7bd0ce8a53424863$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $7bd0ce8a53424863$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $7bd0ce8a53424863$var$setSize = $7bd0ce8a53424863$var$hasSet && $7bd0ce8a53424863$var$setSizeDescriptor && typeof $7bd0ce8a53424863$var$setSizeDescriptor.get === 'function' ? $7bd0ce8a53424863$var$setSizeDescriptor.get : null;
var $7bd0ce8a53424863$var$setForEach = $7bd0ce8a53424863$var$hasSet && Set.prototype.forEach;
var $7bd0ce8a53424863$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $7bd0ce8a53424863$var$weakMapHas = $7bd0ce8a53424863$var$hasWeakMap ? WeakMap.prototype.has : null;
var $7bd0ce8a53424863$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $7bd0ce8a53424863$var$weakSetHas = $7bd0ce8a53424863$var$hasWeakSet ? WeakSet.prototype.has : null;
var $7bd0ce8a53424863$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $7bd0ce8a53424863$var$weakRefDeref = $7bd0ce8a53424863$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $7bd0ce8a53424863$var$booleanValueOf = Boolean.prototype.valueOf;
var $7bd0ce8a53424863$var$objectToString = Object.prototype.toString;
var $7bd0ce8a53424863$var$functionToString = Function.prototype.toString;
var $7bd0ce8a53424863$var$$match = String.prototype.match;
var $7bd0ce8a53424863$var$$slice = String.prototype.slice;
var $7bd0ce8a53424863$var$$replace = String.prototype.replace;
var $7bd0ce8a53424863$var$$toUpperCase = String.prototype.toUpperCase;
var $7bd0ce8a53424863$var$$toLowerCase = String.prototype.toLowerCase;
var $7bd0ce8a53424863$var$$test = RegExp.prototype.test;
var $7bd0ce8a53424863$var$$concat = Array.prototype.concat;
var $7bd0ce8a53424863$var$$join = Array.prototype.join;
var $7bd0ce8a53424863$var$$arrSlice = Array.prototype.slice;
var $7bd0ce8a53424863$var$$floor = Math.floor;
var $7bd0ce8a53424863$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $7bd0ce8a53424863$var$gOPS = Object.getOwnPropertySymbols;
var $7bd0ce8a53424863$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $7bd0ce8a53424863$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $7bd0ce8a53424863$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $7bd0ce8a53424863$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $7bd0ce8a53424863$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $7bd0ce8a53424863$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $7bd0ce8a53424863$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $7bd0ce8a53424863$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$7bd0ce8a53424863$var$$floor(-num) : $7bd0ce8a53424863$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $7bd0ce8a53424863$var$$slice.call(str, intStr.length + 1);
            return $7bd0ce8a53424863$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $7bd0ce8a53424863$var$$replace.call($7bd0ce8a53424863$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $7bd0ce8a53424863$var$$replace.call(str, sepRegex, '$&_');
}

var $7bd0ce8a53424863$var$inspectCustom = $eca075ad100d834d$exports.custom;
var $7bd0ce8a53424863$var$inspectSymbol = $7bd0ce8a53424863$var$isSymbol($7bd0ce8a53424863$var$inspectCustom) ? $7bd0ce8a53424863$var$inspectCustom : null;
var $7bd0ce8a53424863$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $7bd0ce8a53424863$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$7bd0ce8a53424863$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($7bd0ce8a53424863$var$has(opts, 'quoteStyle') && !$7bd0ce8a53424863$var$has($7bd0ce8a53424863$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($7bd0ce8a53424863$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $7bd0ce8a53424863$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($7bd0ce8a53424863$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($7bd0ce8a53424863$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $7bd0ce8a53424863$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $7bd0ce8a53424863$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $7bd0ce8a53424863$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $7bd0ce8a53424863$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $7bd0ce8a53424863$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($7bd0ce8a53424863$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $7bd0ce8a53424863$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($7bd0ce8a53424863$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$7bd0ce8a53424863$var$isRegExp(obj)) {
        var name = $7bd0ce8a53424863$var$nameOf(obj);
        var keys = $7bd0ce8a53424863$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $7bd0ce8a53424863$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($7bd0ce8a53424863$var$isSymbol(obj)) {
        var symString = $7bd0ce8a53424863$var$hasShammedSymbols ? $7bd0ce8a53424863$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $7bd0ce8a53424863$var$symToString.call(obj);
        return typeof obj === 'object' && !$7bd0ce8a53424863$var$hasShammedSymbols ? $7bd0ce8a53424863$var$markBoxed(symString) : symString;
    }
    if ($7bd0ce8a53424863$var$isElement(obj)) {
        var s = '<' + $7bd0ce8a53424863$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $7bd0ce8a53424863$var$wrapQuotes($7bd0ce8a53424863$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $7bd0ce8a53424863$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($7bd0ce8a53424863$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $7bd0ce8a53424863$var$arrObjKeys(obj, inspect);
        if (indent && !$7bd0ce8a53424863$var$singleLineValues(xs)) return '[' + $7bd0ce8a53424863$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $7bd0ce8a53424863$var$$join.call(xs, ', ') + ' ]';
    }
    if ($7bd0ce8a53424863$var$isError(obj)) {
        var parts = $7bd0ce8a53424863$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$7bd0ce8a53424863$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $7bd0ce8a53424863$var$$join.call($7bd0ce8a53424863$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $7bd0ce8a53424863$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($7bd0ce8a53424863$var$inspectSymbol && typeof obj[$7bd0ce8a53424863$var$inspectSymbol] === 'function' && $eca075ad100d834d$exports) return $eca075ad100d834d$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($7bd0ce8a53424863$var$isMap(obj)) {
        var mapParts = [];
        if ($7bd0ce8a53424863$var$mapForEach) $7bd0ce8a53424863$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $7bd0ce8a53424863$var$collectionOf('Map', $7bd0ce8a53424863$var$mapSize.call(obj), mapParts, indent);
    }
    if ($7bd0ce8a53424863$var$isSet(obj)) {
        var setParts = [];
        if ($7bd0ce8a53424863$var$setForEach) $7bd0ce8a53424863$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $7bd0ce8a53424863$var$collectionOf('Set', $7bd0ce8a53424863$var$setSize.call(obj), setParts, indent);
    }
    if ($7bd0ce8a53424863$var$isWeakMap(obj)) return $7bd0ce8a53424863$var$weakCollectionOf('WeakMap');
    if ($7bd0ce8a53424863$var$isWeakSet(obj)) return $7bd0ce8a53424863$var$weakCollectionOf('WeakSet');
    if ($7bd0ce8a53424863$var$isWeakRef(obj)) return $7bd0ce8a53424863$var$weakCollectionOf('WeakRef');
    if ($7bd0ce8a53424863$var$isNumber(obj)) return $7bd0ce8a53424863$var$markBoxed(inspect(Number(obj)));
    if ($7bd0ce8a53424863$var$isBigInt(obj)) return $7bd0ce8a53424863$var$markBoxed(inspect($7bd0ce8a53424863$var$bigIntValueOf.call(obj)));
    if ($7bd0ce8a53424863$var$isBoolean(obj)) return $7bd0ce8a53424863$var$markBoxed($7bd0ce8a53424863$var$booleanValueOf.call(obj));
    if ($7bd0ce8a53424863$var$isString(obj)) return $7bd0ce8a53424863$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$7bd0ce8a53424863$var$isDate(obj) && !$7bd0ce8a53424863$var$isRegExp(obj)) {
        var ys = $7bd0ce8a53424863$var$arrObjKeys(obj, inspect);
        var isPlainObject = $7bd0ce8a53424863$var$gPO ? $7bd0ce8a53424863$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $7bd0ce8a53424863$var$toStringTag && Object(obj) === obj && $7bd0ce8a53424863$var$toStringTag in obj ? $7bd0ce8a53424863$var$$slice.call($7bd0ce8a53424863$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $7bd0ce8a53424863$var$$join.call($7bd0ce8a53424863$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $7bd0ce8a53424863$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $7bd0ce8a53424863$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $7bd0ce8a53424863$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $7bd0ce8a53424863$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $7bd0ce8a53424863$var$quote(s) {
    return $7bd0ce8a53424863$var$$replace.call(String(s), /"/g, '&quot;');
}
function $7bd0ce8a53424863$var$canTrustToString(obj) {
    return !$7bd0ce8a53424863$var$toStringTag || !(typeof obj === 'object' && ($7bd0ce8a53424863$var$toStringTag in obj || typeof obj[$7bd0ce8a53424863$var$toStringTag] !== 'undefined'));
}
function $7bd0ce8a53424863$var$isArray(obj) {
    return $7bd0ce8a53424863$var$toStr(obj) === '[object Array]' && $7bd0ce8a53424863$var$canTrustToString(obj);
}
function $7bd0ce8a53424863$var$isDate(obj) {
    return $7bd0ce8a53424863$var$toStr(obj) === '[object Date]' && $7bd0ce8a53424863$var$canTrustToString(obj);
}
function $7bd0ce8a53424863$var$isRegExp(obj) {
    return $7bd0ce8a53424863$var$toStr(obj) === '[object RegExp]' && $7bd0ce8a53424863$var$canTrustToString(obj);
}
function $7bd0ce8a53424863$var$isError(obj) {
    return $7bd0ce8a53424863$var$toStr(obj) === '[object Error]' && $7bd0ce8a53424863$var$canTrustToString(obj);
}
function $7bd0ce8a53424863$var$isString(obj) {
    return $7bd0ce8a53424863$var$toStr(obj) === '[object String]' && $7bd0ce8a53424863$var$canTrustToString(obj);
}
function $7bd0ce8a53424863$var$isNumber(obj) {
    return $7bd0ce8a53424863$var$toStr(obj) === '[object Number]' && $7bd0ce8a53424863$var$canTrustToString(obj);
}
function $7bd0ce8a53424863$var$isBoolean(obj) {
    return $7bd0ce8a53424863$var$toStr(obj) === '[object Boolean]' && $7bd0ce8a53424863$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $7bd0ce8a53424863$var$isSymbol(obj) {
    if ($7bd0ce8a53424863$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$7bd0ce8a53424863$var$symToString) return false;
    try {
        $7bd0ce8a53424863$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $7bd0ce8a53424863$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$7bd0ce8a53424863$var$bigIntValueOf) return false;
    try {
        $7bd0ce8a53424863$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $7bd0ce8a53424863$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $7bd0ce8a53424863$var$has(obj, key) {
    return $7bd0ce8a53424863$var$hasOwn.call(obj, key);
}
function $7bd0ce8a53424863$var$toStr(obj) {
    return $7bd0ce8a53424863$var$objectToString.call(obj);
}
function $7bd0ce8a53424863$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $7bd0ce8a53424863$var$$match.call($7bd0ce8a53424863$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $7bd0ce8a53424863$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $7bd0ce8a53424863$var$isMap(x) {
    if (!$7bd0ce8a53424863$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $7bd0ce8a53424863$var$mapSize.call(x);
        try {
            $7bd0ce8a53424863$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7bd0ce8a53424863$var$isWeakMap(x) {
    if (!$7bd0ce8a53424863$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $7bd0ce8a53424863$var$weakMapHas.call(x, $7bd0ce8a53424863$var$weakMapHas);
        try {
            $7bd0ce8a53424863$var$weakSetHas.call(x, $7bd0ce8a53424863$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7bd0ce8a53424863$var$isWeakRef(x) {
    if (!$7bd0ce8a53424863$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $7bd0ce8a53424863$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $7bd0ce8a53424863$var$isSet(x) {
    if (!$7bd0ce8a53424863$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $7bd0ce8a53424863$var$setSize.call(x);
        try {
            $7bd0ce8a53424863$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7bd0ce8a53424863$var$isWeakSet(x) {
    if (!$7bd0ce8a53424863$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $7bd0ce8a53424863$var$weakSetHas.call(x, $7bd0ce8a53424863$var$weakSetHas);
        try {
            $7bd0ce8a53424863$var$weakMapHas.call(x, $7bd0ce8a53424863$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7bd0ce8a53424863$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $7bd0ce8a53424863$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $7bd0ce8a53424863$var$inspectString($7bd0ce8a53424863$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $7bd0ce8a53424863$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $7bd0ce8a53424863$var$$replace.call($7bd0ce8a53424863$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $7bd0ce8a53424863$var$lowbyte);
    return $7bd0ce8a53424863$var$wrapQuotes(s, 'single', opts);
}
function $7bd0ce8a53424863$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $7bd0ce8a53424863$var$$toUpperCase.call(n.toString(16));
}
function $7bd0ce8a53424863$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $7bd0ce8a53424863$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $7bd0ce8a53424863$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $7bd0ce8a53424863$var$indentedJoin(entries, indent) : $7bd0ce8a53424863$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $7bd0ce8a53424863$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($7bd0ce8a53424863$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $7bd0ce8a53424863$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $7bd0ce8a53424863$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $7bd0ce8a53424863$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $7bd0ce8a53424863$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $7bd0ce8a53424863$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $7bd0ce8a53424863$var$arrObjKeys(obj, inspect) {
    var isArr = $7bd0ce8a53424863$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $7bd0ce8a53424863$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $7bd0ce8a53424863$var$gOPS === 'function' ? $7bd0ce8a53424863$var$gOPS(obj) : [];
    var symMap;
    if ($7bd0ce8a53424863$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$7bd0ce8a53424863$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($7bd0ce8a53424863$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($7bd0ce8a53424863$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $7bd0ce8a53424863$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($7bd0ce8a53424863$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}



var $8043468335131548$var$$Map = $1258b452ecf218a1$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $8043468335131548$var$$mapGet = $adf8ebd7229df60a$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $8043468335131548$var$$mapSet = $adf8ebd7229df60a$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapHas = $adf8ebd7229df60a$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapDelete = $adf8ebd7229df60a$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $8043468335131548$var$$mapSize = $adf8ebd7229df60a$exports('Map.prototype.size', true);
/** @type {import('.')} */ $8043468335131548$exports = !!$8043468335131548$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $7bd0ce8a53424863$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $8043468335131548$var$$mapDelete($m, key);
                if ($8043468335131548$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $8043468335131548$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $8043468335131548$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $8043468335131548$var$$Map();
            $8043468335131548$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $591d8612c5fec170$exports = {};
'use strict';


var $6883c9cbaa16a0d2$exports = {};
var $6883c9cbaa16a0d2$var$hasMap = typeof Map === 'function' && Map.prototype;
var $6883c9cbaa16a0d2$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $6883c9cbaa16a0d2$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $6883c9cbaa16a0d2$var$mapSize = $6883c9cbaa16a0d2$var$hasMap && $6883c9cbaa16a0d2$var$mapSizeDescriptor && typeof $6883c9cbaa16a0d2$var$mapSizeDescriptor.get === 'function' ? $6883c9cbaa16a0d2$var$mapSizeDescriptor.get : null;
var $6883c9cbaa16a0d2$var$mapForEach = $6883c9cbaa16a0d2$var$hasMap && Map.prototype.forEach;
var $6883c9cbaa16a0d2$var$hasSet = typeof Set === 'function' && Set.prototype;
var $6883c9cbaa16a0d2$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $6883c9cbaa16a0d2$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $6883c9cbaa16a0d2$var$setSize = $6883c9cbaa16a0d2$var$hasSet && $6883c9cbaa16a0d2$var$setSizeDescriptor && typeof $6883c9cbaa16a0d2$var$setSizeDescriptor.get === 'function' ? $6883c9cbaa16a0d2$var$setSizeDescriptor.get : null;
var $6883c9cbaa16a0d2$var$setForEach = $6883c9cbaa16a0d2$var$hasSet && Set.prototype.forEach;
var $6883c9cbaa16a0d2$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $6883c9cbaa16a0d2$var$weakMapHas = $6883c9cbaa16a0d2$var$hasWeakMap ? WeakMap.prototype.has : null;
var $6883c9cbaa16a0d2$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $6883c9cbaa16a0d2$var$weakSetHas = $6883c9cbaa16a0d2$var$hasWeakSet ? WeakSet.prototype.has : null;
var $6883c9cbaa16a0d2$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $6883c9cbaa16a0d2$var$weakRefDeref = $6883c9cbaa16a0d2$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $6883c9cbaa16a0d2$var$booleanValueOf = Boolean.prototype.valueOf;
var $6883c9cbaa16a0d2$var$objectToString = Object.prototype.toString;
var $6883c9cbaa16a0d2$var$functionToString = Function.prototype.toString;
var $6883c9cbaa16a0d2$var$$match = String.prototype.match;
var $6883c9cbaa16a0d2$var$$slice = String.prototype.slice;
var $6883c9cbaa16a0d2$var$$replace = String.prototype.replace;
var $6883c9cbaa16a0d2$var$$toUpperCase = String.prototype.toUpperCase;
var $6883c9cbaa16a0d2$var$$toLowerCase = String.prototype.toLowerCase;
var $6883c9cbaa16a0d2$var$$test = RegExp.prototype.test;
var $6883c9cbaa16a0d2$var$$concat = Array.prototype.concat;
var $6883c9cbaa16a0d2$var$$join = Array.prototype.join;
var $6883c9cbaa16a0d2$var$$arrSlice = Array.prototype.slice;
var $6883c9cbaa16a0d2$var$$floor = Math.floor;
var $6883c9cbaa16a0d2$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $6883c9cbaa16a0d2$var$gOPS = Object.getOwnPropertySymbols;
var $6883c9cbaa16a0d2$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $6883c9cbaa16a0d2$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $6883c9cbaa16a0d2$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $6883c9cbaa16a0d2$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $6883c9cbaa16a0d2$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $6883c9cbaa16a0d2$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $6883c9cbaa16a0d2$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $6883c9cbaa16a0d2$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$6883c9cbaa16a0d2$var$$floor(-num) : $6883c9cbaa16a0d2$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $6883c9cbaa16a0d2$var$$slice.call(str, intStr.length + 1);
            return $6883c9cbaa16a0d2$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $6883c9cbaa16a0d2$var$$replace.call($6883c9cbaa16a0d2$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $6883c9cbaa16a0d2$var$$replace.call(str, sepRegex, '$&_');
}

var $6883c9cbaa16a0d2$var$inspectCustom = $eca075ad100d834d$exports.custom;
var $6883c9cbaa16a0d2$var$inspectSymbol = $6883c9cbaa16a0d2$var$isSymbol($6883c9cbaa16a0d2$var$inspectCustom) ? $6883c9cbaa16a0d2$var$inspectCustom : null;
var $6883c9cbaa16a0d2$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $6883c9cbaa16a0d2$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$6883c9cbaa16a0d2$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($6883c9cbaa16a0d2$var$has(opts, 'quoteStyle') && !$6883c9cbaa16a0d2$var$has($6883c9cbaa16a0d2$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($6883c9cbaa16a0d2$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $6883c9cbaa16a0d2$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($6883c9cbaa16a0d2$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($6883c9cbaa16a0d2$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $6883c9cbaa16a0d2$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $6883c9cbaa16a0d2$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $6883c9cbaa16a0d2$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $6883c9cbaa16a0d2$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $6883c9cbaa16a0d2$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($6883c9cbaa16a0d2$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $6883c9cbaa16a0d2$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($6883c9cbaa16a0d2$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$6883c9cbaa16a0d2$var$isRegExp(obj)) {
        var name = $6883c9cbaa16a0d2$var$nameOf(obj);
        var keys = $6883c9cbaa16a0d2$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $6883c9cbaa16a0d2$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($6883c9cbaa16a0d2$var$isSymbol(obj)) {
        var symString = $6883c9cbaa16a0d2$var$hasShammedSymbols ? $6883c9cbaa16a0d2$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $6883c9cbaa16a0d2$var$symToString.call(obj);
        return typeof obj === 'object' && !$6883c9cbaa16a0d2$var$hasShammedSymbols ? $6883c9cbaa16a0d2$var$markBoxed(symString) : symString;
    }
    if ($6883c9cbaa16a0d2$var$isElement(obj)) {
        var s = '<' + $6883c9cbaa16a0d2$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $6883c9cbaa16a0d2$var$wrapQuotes($6883c9cbaa16a0d2$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $6883c9cbaa16a0d2$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($6883c9cbaa16a0d2$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $6883c9cbaa16a0d2$var$arrObjKeys(obj, inspect);
        if (indent && !$6883c9cbaa16a0d2$var$singleLineValues(xs)) return '[' + $6883c9cbaa16a0d2$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $6883c9cbaa16a0d2$var$$join.call(xs, ', ') + ' ]';
    }
    if ($6883c9cbaa16a0d2$var$isError(obj)) {
        var parts = $6883c9cbaa16a0d2$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$6883c9cbaa16a0d2$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $6883c9cbaa16a0d2$var$$join.call($6883c9cbaa16a0d2$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $6883c9cbaa16a0d2$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($6883c9cbaa16a0d2$var$inspectSymbol && typeof obj[$6883c9cbaa16a0d2$var$inspectSymbol] === 'function' && $eca075ad100d834d$exports) return $eca075ad100d834d$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($6883c9cbaa16a0d2$var$isMap(obj)) {
        var mapParts = [];
        if ($6883c9cbaa16a0d2$var$mapForEach) $6883c9cbaa16a0d2$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $6883c9cbaa16a0d2$var$collectionOf('Map', $6883c9cbaa16a0d2$var$mapSize.call(obj), mapParts, indent);
    }
    if ($6883c9cbaa16a0d2$var$isSet(obj)) {
        var setParts = [];
        if ($6883c9cbaa16a0d2$var$setForEach) $6883c9cbaa16a0d2$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $6883c9cbaa16a0d2$var$collectionOf('Set', $6883c9cbaa16a0d2$var$setSize.call(obj), setParts, indent);
    }
    if ($6883c9cbaa16a0d2$var$isWeakMap(obj)) return $6883c9cbaa16a0d2$var$weakCollectionOf('WeakMap');
    if ($6883c9cbaa16a0d2$var$isWeakSet(obj)) return $6883c9cbaa16a0d2$var$weakCollectionOf('WeakSet');
    if ($6883c9cbaa16a0d2$var$isWeakRef(obj)) return $6883c9cbaa16a0d2$var$weakCollectionOf('WeakRef');
    if ($6883c9cbaa16a0d2$var$isNumber(obj)) return $6883c9cbaa16a0d2$var$markBoxed(inspect(Number(obj)));
    if ($6883c9cbaa16a0d2$var$isBigInt(obj)) return $6883c9cbaa16a0d2$var$markBoxed(inspect($6883c9cbaa16a0d2$var$bigIntValueOf.call(obj)));
    if ($6883c9cbaa16a0d2$var$isBoolean(obj)) return $6883c9cbaa16a0d2$var$markBoxed($6883c9cbaa16a0d2$var$booleanValueOf.call(obj));
    if ($6883c9cbaa16a0d2$var$isString(obj)) return $6883c9cbaa16a0d2$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$6883c9cbaa16a0d2$var$isDate(obj) && !$6883c9cbaa16a0d2$var$isRegExp(obj)) {
        var ys = $6883c9cbaa16a0d2$var$arrObjKeys(obj, inspect);
        var isPlainObject = $6883c9cbaa16a0d2$var$gPO ? $6883c9cbaa16a0d2$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $6883c9cbaa16a0d2$var$toStringTag && Object(obj) === obj && $6883c9cbaa16a0d2$var$toStringTag in obj ? $6883c9cbaa16a0d2$var$$slice.call($6883c9cbaa16a0d2$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $6883c9cbaa16a0d2$var$$join.call($6883c9cbaa16a0d2$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $6883c9cbaa16a0d2$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $6883c9cbaa16a0d2$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $6883c9cbaa16a0d2$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $6883c9cbaa16a0d2$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $6883c9cbaa16a0d2$var$quote(s) {
    return $6883c9cbaa16a0d2$var$$replace.call(String(s), /"/g, '&quot;');
}
function $6883c9cbaa16a0d2$var$canTrustToString(obj) {
    return !$6883c9cbaa16a0d2$var$toStringTag || !(typeof obj === 'object' && ($6883c9cbaa16a0d2$var$toStringTag in obj || typeof obj[$6883c9cbaa16a0d2$var$toStringTag] !== 'undefined'));
}
function $6883c9cbaa16a0d2$var$isArray(obj) {
    return $6883c9cbaa16a0d2$var$toStr(obj) === '[object Array]' && $6883c9cbaa16a0d2$var$canTrustToString(obj);
}
function $6883c9cbaa16a0d2$var$isDate(obj) {
    return $6883c9cbaa16a0d2$var$toStr(obj) === '[object Date]' && $6883c9cbaa16a0d2$var$canTrustToString(obj);
}
function $6883c9cbaa16a0d2$var$isRegExp(obj) {
    return $6883c9cbaa16a0d2$var$toStr(obj) === '[object RegExp]' && $6883c9cbaa16a0d2$var$canTrustToString(obj);
}
function $6883c9cbaa16a0d2$var$isError(obj) {
    return $6883c9cbaa16a0d2$var$toStr(obj) === '[object Error]' && $6883c9cbaa16a0d2$var$canTrustToString(obj);
}
function $6883c9cbaa16a0d2$var$isString(obj) {
    return $6883c9cbaa16a0d2$var$toStr(obj) === '[object String]' && $6883c9cbaa16a0d2$var$canTrustToString(obj);
}
function $6883c9cbaa16a0d2$var$isNumber(obj) {
    return $6883c9cbaa16a0d2$var$toStr(obj) === '[object Number]' && $6883c9cbaa16a0d2$var$canTrustToString(obj);
}
function $6883c9cbaa16a0d2$var$isBoolean(obj) {
    return $6883c9cbaa16a0d2$var$toStr(obj) === '[object Boolean]' && $6883c9cbaa16a0d2$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $6883c9cbaa16a0d2$var$isSymbol(obj) {
    if ($6883c9cbaa16a0d2$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$6883c9cbaa16a0d2$var$symToString) return false;
    try {
        $6883c9cbaa16a0d2$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $6883c9cbaa16a0d2$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$6883c9cbaa16a0d2$var$bigIntValueOf) return false;
    try {
        $6883c9cbaa16a0d2$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $6883c9cbaa16a0d2$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $6883c9cbaa16a0d2$var$has(obj, key) {
    return $6883c9cbaa16a0d2$var$hasOwn.call(obj, key);
}
function $6883c9cbaa16a0d2$var$toStr(obj) {
    return $6883c9cbaa16a0d2$var$objectToString.call(obj);
}
function $6883c9cbaa16a0d2$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $6883c9cbaa16a0d2$var$$match.call($6883c9cbaa16a0d2$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $6883c9cbaa16a0d2$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $6883c9cbaa16a0d2$var$isMap(x) {
    if (!$6883c9cbaa16a0d2$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $6883c9cbaa16a0d2$var$mapSize.call(x);
        try {
            $6883c9cbaa16a0d2$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6883c9cbaa16a0d2$var$isWeakMap(x) {
    if (!$6883c9cbaa16a0d2$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $6883c9cbaa16a0d2$var$weakMapHas.call(x, $6883c9cbaa16a0d2$var$weakMapHas);
        try {
            $6883c9cbaa16a0d2$var$weakSetHas.call(x, $6883c9cbaa16a0d2$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6883c9cbaa16a0d2$var$isWeakRef(x) {
    if (!$6883c9cbaa16a0d2$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $6883c9cbaa16a0d2$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $6883c9cbaa16a0d2$var$isSet(x) {
    if (!$6883c9cbaa16a0d2$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $6883c9cbaa16a0d2$var$setSize.call(x);
        try {
            $6883c9cbaa16a0d2$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6883c9cbaa16a0d2$var$isWeakSet(x) {
    if (!$6883c9cbaa16a0d2$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $6883c9cbaa16a0d2$var$weakSetHas.call(x, $6883c9cbaa16a0d2$var$weakSetHas);
        try {
            $6883c9cbaa16a0d2$var$weakMapHas.call(x, $6883c9cbaa16a0d2$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6883c9cbaa16a0d2$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $6883c9cbaa16a0d2$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $6883c9cbaa16a0d2$var$inspectString($6883c9cbaa16a0d2$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $6883c9cbaa16a0d2$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $6883c9cbaa16a0d2$var$$replace.call($6883c9cbaa16a0d2$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $6883c9cbaa16a0d2$var$lowbyte);
    return $6883c9cbaa16a0d2$var$wrapQuotes(s, 'single', opts);
}
function $6883c9cbaa16a0d2$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $6883c9cbaa16a0d2$var$$toUpperCase.call(n.toString(16));
}
function $6883c9cbaa16a0d2$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $6883c9cbaa16a0d2$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $6883c9cbaa16a0d2$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $6883c9cbaa16a0d2$var$indentedJoin(entries, indent) : $6883c9cbaa16a0d2$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $6883c9cbaa16a0d2$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($6883c9cbaa16a0d2$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $6883c9cbaa16a0d2$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $6883c9cbaa16a0d2$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $6883c9cbaa16a0d2$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $6883c9cbaa16a0d2$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $6883c9cbaa16a0d2$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $6883c9cbaa16a0d2$var$arrObjKeys(obj, inspect) {
    var isArr = $6883c9cbaa16a0d2$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $6883c9cbaa16a0d2$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $6883c9cbaa16a0d2$var$gOPS === 'function' ? $6883c9cbaa16a0d2$var$gOPS(obj) : [];
    var symMap;
    if ($6883c9cbaa16a0d2$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$6883c9cbaa16a0d2$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($6883c9cbaa16a0d2$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($6883c9cbaa16a0d2$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $6883c9cbaa16a0d2$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($6883c9cbaa16a0d2$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}




var $591d8612c5fec170$var$$WeakMap = $1258b452ecf218a1$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $591d8612c5fec170$var$$weakMapGet = $adf8ebd7229df60a$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $591d8612c5fec170$var$$weakMapSet = $adf8ebd7229df60a$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapHas = $adf8ebd7229df60a$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapDelete = $adf8ebd7229df60a$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $591d8612c5fec170$exports = $591d8612c5fec170$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $6883c9cbaa16a0d2$exports(key));
        },
        'delete': function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapDelete($wm, key);
            } else if ($8043468335131548$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $591d8612c5fec170$var$$WeakMap();
                $591d8612c5fec170$var$$weakMapSet($wm, key, value);
            } else if ($8043468335131548$exports) {
                if (!$m) $m = $8043468335131548$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $8043468335131548$exports;


var $08e53d4ef2e1f8ef$var$makeChannel = $591d8612c5fec170$exports || $8043468335131548$exports || $52bc36570c76608b$exports;
/** @type {import('.')} */ $08e53d4ef2e1f8ef$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $b6ecc995adbd1b2b$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $08e53d4ef2e1f8ef$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $d8a7e190fdc9c6e7$exports = {};
'use strict';
var $d1f90adf4e1eece6$exports = {};
'use strict';
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$d1f90adf4e1eece6$exports = {
    'default': $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};



var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $d8a7e190fdc9c6e7$var$overflowChannel = $08e53d4ef2e1f8ef$exports();
var $d8a7e190fdc9c6e7$var$markOverflow = function markOverflow(obj, maxIndex) {
    $d8a7e190fdc9c6e7$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $d8a7e190fdc9c6e7$var$isOverflow = function isOverflow(obj) {
    return $d8a7e190fdc9c6e7$var$overflowChannel.has(obj);
};
var $d8a7e190fdc9c6e7$var$getMaxIndex = function getMaxIndex(obj) {
    return $d8a7e190fdc9c6e7$var$overflowChannel.get(obj);
};
var $d8a7e190fdc9c6e7$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $d8a7e190fdc9c6e7$var$overflowChannel.set(obj, maxIndex);
};
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(target.concat(source), options), nextIndex);
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($d8a7e190fdc9c6e7$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $d8a7e190fdc9c6e7$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $d8a7e190fdc9c6e7$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($d8a7e190fdc9c6e7$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $d8a7e190fdc9c6e7$var$markOverflow(result, $d8a7e190fdc9c6e7$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(combined, options), combined.length - 1);
        return combined;
    }
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        if ($d8a7e190fdc9c6e7$var$isOverflow(source) && !$d8a7e190fdc9c6e7$var$isOverflow(acc)) $d8a7e190fdc9c6e7$var$markOverflow(acc, $d8a7e190fdc9c6e7$var$getMaxIndex(source));
        if ($d8a7e190fdc9c6e7$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $d8a7e190fdc9c6e7$var$getMaxIndex(acc)) $d8a7e190fdc9c6e7$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $d1f90adf4e1eece6$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs[refs.length] = val;
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if ($d8a7e190fdc9c6e7$var$isOverflow(a)) {
        var newIndex = $d8a7e190fdc9c6e7$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $d8a7e190fdc9c6e7$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
$d8a7e190fdc9c6e7$exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isOverflow: $d8a7e190fdc9c6e7$var$isOverflow,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    markOverflow: $d8a7e190fdc9c6e7$var$markOverflow,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};



var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $d1f90adf4e1eece6$exports.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $d8a7e190fdc9c6e7$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $d1f90adf4e1eece6$exports.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) obj = $d8a7e190fdc9c6e7$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $d8a7e190fdc9c6e7$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $d8a7e190fdc9c6e7$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $08e53d4ef2e1f8ef$exports();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $d1f90adf4e1eece6$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$e5dd19a945a45bbb$var$has.call($d1f90adf4e1eece6$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $d1f90adf4e1eece6$exports.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === 'function' || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
$e5dd19a945a45bbb$exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $08e53d4ef2e1f8ef$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $8ec5fc0fdc198ba4$exports = {};
'use strict';

var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $d8a7e190fdc9c6e7$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $d8a7e190fdc9c6e7$exports.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options, $8ec5fc0fdc198ba4$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $8ec5fc0fdc198ba4$var$isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            val = $d8a7e190fdc9c6e7$exports.combine([], val, options.arrayLimit, options.plainObjects);
        }
        if (key !== null) {
            var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $d8a7e190fdc9c6e7$exports.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($d8a7e190fdc9c6e7$exports.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $d8a7e190fdc9c6e7$exports.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $d8a7e190fdc9c6e7$exports.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    if (options.depth <= 0) {
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys = [];
    if (parent) {
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = parent;
    }
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = segment[1];
    }
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }
    return keys;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $8ec5fc0fdc198ba4$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $d8a7e190fdc9c6e7$exports.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $8ec5fc0fdc198ba4$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $8ec5fc0fdc198ba4$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$8ec5fc0fdc198ba4$exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $d8a7e190fdc9c6e7$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $d8a7e190fdc9c6e7$exports.compact(obj);
};



$1c66380376aa2c89$exports = {
    formats: $d1f90adf4e1eece6$exports,
    parse: $8ec5fc0fdc198ba4$exports,
    stringify: $e5dd19a945a45bbb$exports
};



var $acw62 = parcelRequire("acw62");
function $106621f36f239263$export$973ca22476b0e05f(initialValue) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        const q = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).stringify(initialValue, {
            addQueryPrefix: true,
            skipNulls: true
        });
        navigate(q);
    }, []);
    const filters = (0, $acw62.useMemo)(()=>{
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).parse(location.search, {
            ignoreQueryPrefix: true
        });
        return parsed;
    }, [
        location.search
    ]);
    const setFilter = (key, value)=>{
        const q = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).stringify({
            ...filters,
            [key]: value
        }, {
            addQueryPrefix: true,
            skipNulls: true
        });
        navigate(q);
    };
    return [
        filters,
        setFilter
    ];
}




var $acw62 = parcelRequire("acw62");



const $958d708ab8b7e198$export$432f698644f45d1 = async (location)=>{
    const stats = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).stats.panel();
    if (location.state?.stats) location.state.stats = stats;
    return stats;
};




const $b836f40bcd41dcd0$export$d4e22f05f73ea56b = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [username, setUsername] = (0, $acw62.useState)(window.localStorage.getItem('username'));
    const [password, setPassword] = (0, $acw62.useState)('');
    const [inputType, setInputType] = (0, $acw62.useState)('password');
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if (location.pathname !== '/logout') return;
        (0, $4c992464a65faeac$export$2e2bcd8739ae039).logout();
    }, [
        location.pathname
    ]);
    const message = location.pathname === '/logout' ? 'Wylogowano' : '';
    const passwordChange = ()=>{
        setLoading(false);
        navigate('/passchange', {
            state: password
        });
    };
    const enter = async ()=>{
        const stats = await (0, $958d708ab8b7e198$export$432f698644f45d1)(location);
        // await import('../pages/panel');
        setLoading(false);
        navigate('/panel', {
            state: {
                stats: stats
            }
        });
    };
    const validate = ()=>{
        setError('');
        if (!username) {
            setError('Podaj login');
            return false;
        }
        if (!password) {
            setError("Podaj has\u0142o");
            return false;
        }
        return true;
    };
    const handleLogin = async (e)=>{
        e.preventDefault();
        if (!validate()) return;
        try {
            setLoading(true);
            const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).login(username, password);
            sessionStorage.setItem('level', result.level);
            sessionStorage.setItem('id', result.id);
            localStorage.setItem('username', username);
            $f2b90654edf2c0a1$export$8b6bb3dd62a01be2({
                id: result.id,
                username: username
            });
            if (result.passwordChange === true) return passwordChange();
            else return await enter();
        } catch (e) {
            setLoading(false);
            console.trace(e);
            setError(`${e}`);
        }
    };
    return {
        username: username,
        password: password,
        inputType: inputType,
        loading: loading,
        message: error || message,
        error: error,
        usernameChanged: (e)=>setUsername(e.target.value),
        passwordChanged: (e)=>setPassword(e.target.value),
        touchStart: (e)=>{
            e.stopPropagation();
            setInputType('text');
        },
        touchMove: (e)=>{
            e.stopPropagation();
            setInputType('password');
        },
        touchEnd: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            setInputType('password');
        },
        login: handleLogin
    };
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


function $f99ae66c06c40ef9$var$_extends() {
    $f99ae66c06c40ef9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f99ae66c06c40ef9$var$_extends.apply(this, arguments);
}
const $f99ae66c06c40ef9$var$CloseCircleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $f99ae66c06c40ef9$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f986f8662437b397$export$2e2bcd8739ae039)
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMCA3NmMtMjA1LjQgMC0zNzIgMTY2LjYtMzcyIDM3MnMxNjYuNiAzNzIgMzcyIDM3MiAzNzItMTY2LjYgMzcyLTM3Mi0xNjYuNi0zNzItMzcyLTM3MnptMTI4LjAxIDE5OC44M2MuMDMgMCAuMDUuMDEuMDkuMDZsNDUuMDIgNDUuMDFhLjIuMiAwIDAxLjA1LjA5LjEyLjEyIDAgMDEwIC4wN2MwIC4wMi0uMDEuMDQtLjA1LjA4TDU1Ny4yNSA1MTJsMTI3Ljg3IDEyNy44NmEuMjcuMjcgMCAwMS4wNS4wNnYuMDJhLjEyLjEyIDAgMDEwIC4wN2MwIC4wMy0uMDEuMDUtLjA1LjA5bC00NS4wMiA0NS4wMmEuMi4yIDAgMDEtLjA5LjA1LjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDEtLjA4LS4wNUw1MTIgNTU3LjI1IDM4NC4xNCA2ODUuMTJjLS4wNC4wNC0uMDYuMDUtLjA4LjA1YS4xMi4xMiAwIDAxLS4wNyAwYy0uMDMgMC0uMDUtLjAxLS4wOS0uMDVsLTQ1LjAyLTQ1LjAyYS4yLjIgMCAwMS0uMDUtLjA5LjEyLjEyIDAgMDEwLS4wN2MwLS4wMi4wMS0uMDQuMDYtLjA4TDQ2Ni43NSA1MTIgMzM4Ljg4IDM4NC4xNGEuMjcuMjcgMCAwMS0uMDUtLjA2bC0uMDEtLjAyYS4xMi4xMiAwIDAxMC0uMDdjMC0uMDMuMDEtLjA1LjA1LS4wOWw0NS4wMi00NS4wMmEuMi4yIDAgMDEuMDktLjA1LjEyLjEyIDAgMDEuMDcgMGMuMDIgMCAuMDQuMDEuMDguMDZMNTEyIDQ2Ni43NWwxMjcuODYtMTI3Ljg2Yy4wNC0uMDUuMDYtLjA2LjA4LS4wNmEuMTIuMTIgMCAwMS4wNyAweiIgLz48L3N2Zz4=) */ const $f99ae66c06c40ef9$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f99ae66c06c40ef9$var$CloseCircleOutlined);
var $f99ae66c06c40ef9$export$2e2bcd8739ae039 = $f99ae66c06c40ef9$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $110ae44dee1288af$var$ExportOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM770.87 199.13l-52.2-52.2a8.01 8.01 0 014.7-13.6l179.4-21c5.1-.6 9.5 3.7 8.9 8.9l-21 179.4c-.8 6.6-8.9 9.4-13.6 4.7l-52.4-52.4-256.2 256.2a8.03 8.03 0 01-11.3 0l-42.4-42.4a8.03 8.03 0 010-11.3l256.1-256.3z"
                }
            }
        ]
    },
    "name": "export",
    "theme": "outlined"
};
var $110ae44dee1288af$export$2e2bcd8739ae039 = $110ae44dee1288af$var$ExportOutlined;



function $1a82a141ad01d80f$var$_extends() {
    $1a82a141ad01d80f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a82a141ad01d80f$var$_extends.apply(this, arguments);
}
const $1a82a141ad01d80f$var$ExportOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $1a82a141ad01d80f$var$_extends({}, props, {
        ref: ref,
        icon: (0, $110ae44dee1288af$export$2e2bcd8739ae039)
    }));
/**![export](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNODgwIDkxMkgxNDRjLTE3LjcgMC0zMi0xNC4zLTMyLTMyVjE0NGMwLTE3LjcgMTQuMy0zMiAzMi0zMmgzNjBjNC40IDAgOCAzLjYgOCA4djU2YzAgNC40LTMuNiA4LTggOEgxODR2NjU2aDY1NlY1MjBjMC00LjQgMy42LTggOC04aDU2YzQuNCAwIDggMy42IDggOHYzNjBjMCAxNy43LTE0LjMgMzItMzIgMzJ6TTc3MC44NyAxOTkuMTNsLTUyLjItNTIuMmE4LjAxIDguMDEgMCAwMTQuNy0xMy42bDE3OS40LTIxYzUuMS0uNiA5LjUgMy43IDguOSA4LjlsLTIxIDE3OS40Yy0uOCA2LjYtOC45IDkuNC0xMy42IDQuN2wtNTIuNC01Mi40LTI1Ni4yIDI1Ni4yYTguMDMgOC4wMyAwIDAxLTExLjMgMGwtNDIuNC00Mi40YTguMDMgOC4wMyAwIDAxMC0xMS4zbDI1Ni4xLTI1Ni4zeiIgLz48L3N2Zz4=) */ const $1a82a141ad01d80f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1a82a141ad01d80f$var$ExportOutlined);
var $1a82a141ad01d80f$export$2e2bcd8739ae039 = $1a82a141ad01d80f$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2eb6fa0d90a78772$var$ImportOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM653.3 424.6l52.2 52.2a8.01 8.01 0 01-4.7 13.6l-179.4 21c-5.1.6-9.5-3.7-8.9-8.9l21-179.4c.8-6.6 8.9-9.4 13.6-4.7l52.4 52.4 256.2-256.2c3.1-3.1 8.2-3.1 11.3 0l42.4 42.4c3.1 3.1 3.1 8.2 0 11.3L653.3 424.6z"
                }
            }
        ]
    },
    "name": "import",
    "theme": "outlined"
};
var $2eb6fa0d90a78772$export$2e2bcd8739ae039 = $2eb6fa0d90a78772$var$ImportOutlined;



function $c091335ea63c232a$var$_extends() {
    $c091335ea63c232a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c091335ea63c232a$var$_extends.apply(this, arguments);
}
const $c091335ea63c232a$var$ImportOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $c091335ea63c232a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2eb6fa0d90a78772$export$2e2bcd8739ae039)
    }));
/**![import](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNODgwIDkxMkgxNDRjLTE3LjcgMC0zMi0xNC4zLTMyLTMyVjE0NGMwLTE3LjcgMTQuMy0zMiAzMi0zMmgzNjBjNC40IDAgOCAzLjYgOCA4djU2YzAgNC40LTMuNiA4LTggOEgxODR2NjU2aDY1NlY1MjBjMC00LjQgMy42LTggOC04aDU2YzQuNCAwIDggMy42IDggOHYzNjBjMCAxNy43LTE0LjMgMzItMzIgMzJ6TTY1My4zIDQyNC42bDUyLjIgNTIuMmE4LjAxIDguMDEgMCAwMS00LjcgMTMuNmwtMTc5LjQgMjFjLTUuMS42LTkuNS0zLjctOC45LTguOWwyMS0xNzkuNGMuOC02LjYgOC45LTkuNCAxMy42LTQuN2w1Mi40IDUyLjQgMjU2LjItMjU2LjJjMy4xLTMuMSA4LjItMy4xIDExLjMgMGw0Mi40IDQyLjRjMy4xIDMuMSAzLjEgOC4yIDAgMTEuM0w2NTMuMyA0MjQuNnoiIC8+PC9zdmc+) */ const $c091335ea63c232a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($c091335ea63c232a$var$ImportOutlined);
var $c091335ea63c232a$export$2e2bcd8739ae039 = $c091335ea63c232a$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $288493daa41b912a$var$RedoOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z"
                }
            }
        ]
    },
    "name": "redo",
    "theme": "outlined"
};
var $288493daa41b912a$export$2e2bcd8739ae039 = $288493daa41b912a$var$RedoOutlined;



function $1089d062458492a5$var$_extends() {
    $1089d062458492a5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1089d062458492a5$var$_extends.apply(this, arguments);
}
const $1089d062458492a5$var$RedoOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $1089d062458492a5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $288493daa41b912a$export$2e2bcd8739ae039)
    }));
/**![redo](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc1OC4yIDgzOS4xQzg1MS44IDc2NS45IDkxMiA2NTEuOSA5MTIgNTIzLjkgOTEyIDMwMyA3MzMuNSAxMjQuMyA1MTIuNiAxMjQgMjkxLjQgMTIzLjcgMTEyIDMwMi44IDExMiA1MjMuOWMwIDEyNS4yIDU3LjUgMjM2LjkgMTQ3LjYgMzEwLjIgMy41IDIuOCA4LjYgMi4yIDExLjQtMS4zbDM5LjQtNTAuNWMyLjctMy40IDIuMS04LjMtMS4yLTExLjEtOC4xLTYuNi0xNS45LTEzLjctMjMuNC0yMS4yYTMxOC42NCAzMTguNjQgMCAwMS02OC42LTEwMS43QzIwMC40IDYwOSAxOTIgNTY3LjEgMTkyIDUyMy45czguNC04NS4xIDI1LjEtMTI0LjVjMTYuMS0zOC4xIDM5LjItNzIuMyA2OC42LTEwMS43IDI5LjQtMjkuNCA2My42LTUyLjUgMTAxLjctNjguNkM0MjYuOSAyMTIuNCA0NjguOCAyMDQgNTEyIDIwNHM4NS4xIDguNCAxMjQuNSAyNS4xYzM4LjEgMTYuMSA3Mi4zIDM5LjIgMTAxLjcgNjguNiAyOS40IDI5LjQgNTIuNSA2My42IDY4LjYgMTAxLjcgMTYuNyAzOS40IDI1LjEgODEuMyAyNS4xIDEyNC41cy04LjQgODUuMS0yNS4xIDEyNC41YTMxOC42NCAzMTguNjQgMCAwMS02OC42IDEwMS43Yy05LjMgOS4zLTE5LjEgMTgtMjkuMyAyNkw2NjguMiA3MjRhOCA4IDAgMDAtMTQuMSAzbC0zOS42IDE2Mi4yYy0xLjIgNSAyLjYgOS45IDcuNyA5LjlsMTY3IC44YzYuNyAwIDEwLjUtNy43IDYuMy0xMi45bC0zNy4zLTQ3Ljl6IiAvPjwvc3ZnPg==) */ const $1089d062458492a5$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1089d062458492a5$var$RedoOutlined);
var $1089d062458492a5$export$2e2bcd8739ae039 = $1089d062458492a5$var$RefIcon;






const $a015f0677c32bcd8$export$31ec1cd5c4003f04 = ()=>{
    const userLevelRaw = sessionStorage.getItem('level');
    if (!userLevelRaw) return undefined;
    const userLevel = parseInt(userLevelRaw);
    if (Number.isNaN(userLevel)) return undefined;
    if (userLevel < (0, $59a068ffb8407501$export$f361f96a4091c414) || userLevel > (0, $59a068ffb8407501$export$604a068d1c631781)) return undefined;
    return userLevel;
};


const $1012416fae3565dd$export$a5c2098c02d2840a = ()=>{
    const userIdRaw = sessionStorage.getItem('id');
    if (!userIdRaw) return undefined;
    const userId = parseInt(userIdRaw);
    if (Number.isNaN(userId)) return undefined;
    return userId;
};


const $f9e7a1c210f4369c$export$9168a42f32e3d071 = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [stats, setStats] = (0, $acw62.useState)(location.state?.stats);
    const [showToClaim, setShowToClaim] = (0, $acw62.useState)(false);
    const [showToClaimLoose, setShowToClaimLoose] = (0, $acw62.useState)(false);
    const [showUnclosed, setShowUnclosed] = (0, $acw62.useState)(false);
    const [balance, setBalance] = (0, $acw62.useState)(0);
    const [deliveredLooseOrders, setDeliveredLooseOrders] = (0, $acw62.useState)();
    const userId = (0, $1012416fae3565dd$export$a5c2098c02d2840a)();
    const level = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)();
    const fetch = async ()=>{
        if (!userId) {
            navigate('/logout', {
                replace: true
            });
            return;
        }
        setStats(await (0, $958d708ab8b7e198$export$432f698644f45d1)(location));
        setDeliveredLooseOrders(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).looseOrders.getDelivered());
        const user = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(userId, undefined);
        setBalance(user.balance);
    };
    (0, $acw62.useEffect)(()=>{
        if (location.pathname !== '/panel') return;
        fetch();
        const interval = setInterval(fetch, 30000);
        return ()=>clearInterval(interval);
    }, [
        location,
        userId
    ]);
    const getTaskIcon = (task)=>{
        if (!task) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {
            style: {
                color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[5]
            }
        });
        switch(task.type){
            // Delivery
            case 0:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c091335ea63c232a$export$2e2bcd8739ae039), {
                    style: {
                        color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[5]
                    }
                });
            // Replacement
            case 1:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1089d062458492a5$export$2e2bcd8739ae039), {
                    style: {
                        color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[5]
                    }
                });
            // Claiming
            case 2:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a82a141ad01d80f$export$2e2bcd8739ae039), {
                    style: {
                        color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[5]
                    }
                });
        }
        throw new Error('Invalid task type');
    };
    const getTaskDescription = (task)=>{
        switch(task.type){
            // Delivery
            case 0:
                return `Podstawienie ${task.order.street}`;
            // Replacement
            case 1:
                return `Wymiana ${task.order.street}`;
            // Claiming
            case 2:
                return `Odbi\xf3r ${task.order.street}`;
        }
        throw new Error('Invalid task type');
    };
    return {
        stats: stats,
        deliveredLooseOrders: deliveredLooseOrders,
        balance: balance,
        admin: level > 0,
        level: level,
        showToClaim: showToClaim,
        showToClaimLoose: showToClaimLoose,
        showUnclosed: showUnclosed,
        getTaskIcon: getTaskIcon,
        getTaskDescription: getTaskDescription,
        setShowToClaim: setShowToClaim,
        setShowToClaimLoose: setShowToClaimLoose,
        setShowUnclosed: setShowUnclosed
    };
};





var $acw62 = parcelRequire("acw62");


const $d2d35d9e12279cc3$export$f721b343fdbe81e0 = (queryKey, initialValue)=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).parse(location.search, {
        ignoreQueryPrefix: true
    });
    const value = query[queryKey];
    (0, $acw62.useEffect)(()=>{
        if (initialValue !== undefined) setValue(initialValue);
    }, [
        initialValue
    ]);
    const setValue = (newValue)=>{
        const newQuery = {
            ...query,
            [queryKey]: newValue
        };
        if (newValue === undefined) delete newQuery[queryKey];
        const newSearch = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).stringify(newQuery, {
            addQueryPrefix: true,
            arrayFormat: 'repeat'
        });
        navigate({
            search: newSearch
        }, {
            replace: true
        });
    };
    return [
        value,
        setValue
    ];
};








const $401fc7c7dcb14efc$var$Login = ()=>{
    const { username: username, password: password, inputType: inputType, loading: loading, message: message, error: error, usernameChanged: usernameChanged, passwordChanged: passwordChanged, touchStart: touchStart, touchMove: touchMove, touchEnd: touchEnd, login: login } = (0, $b836f40bcd41dcd0$export$d4e22f05f73ea56b)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "login-wrapper flex flex-dir flex-jc",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a225b11ef63dbd27$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: login,
                        className: "login flex flex-dir flex-ac",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                children: "Zaloguj si\u0119"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    color: error ? (0, $0b4842326956570d$export$a90204d1394caf30)[5] : undefined
                                },
                                children: message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                direction: 'vertical',
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        size: "large",
                                        placeholder: "Nazwa u\u017Cytkownika",
                                        prefix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                                            style: {
                                                color: '#bfbfbf'
                                            }
                                        }),
                                        value: username ?? '',
                                        onChange: usernameChanged
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        size: "large",
                                        type: inputType,
                                        placeholder: "Has\u0142o",
                                        prefix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90bdf3d9d7ea52d2$export$2e2bcd8739ae039), {
                                            style: {
                                                color: '#bfbfbf'
                                            }
                                        }),
                                        suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {
                                            onClick: (e)=>e.preventDefault(),
                                            onMouseDown: touchStart,
                                            onMouseMove: touchMove,
                                            onMouseUp: touchEnd,
                                            onTouchStart: touchStart,
                                            onTouchMove: touchMove,
                                            onTouchEnd: touchEnd,
                                            style: {
                                                color: '#8c8c8c'
                                            }
                                        }),
                                        value: password,
                                        onChange: passwordChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "submit",
                                style: {
                                    display: 'none'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                type: "primary",
                                size: "large",
                                loading: loading,
                                onClick: login,
                                children: "Zaloguj si\u0119"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "version flex flex-jc flex-ac",
                        children: "v2.10.4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50e00d398a2de8e8$export$2e2bcd8739ae039), {
                className: "starblob"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e832b40abd16ae8e$export$2e2bcd8739ae039), {
                className: "blob2"
            })
        ]
    });
};
var $401fc7c7dcb14efc$export$2e2bcd8739ae039 = $401fc7c7dcb14efc$var$Login;



parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $kSlfw = parcelRequire("kSlfw");










var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $acw62 = parcelRequire("acw62");

function $7e9c3441b3ad589e$export$2e2bcd8739ae039(props) {
    return Object.keys(props).reduce(function(prev, key) {
        if ((key.startsWith('data-') || key.startsWith('aria-') || key === 'role') && !key.startsWith('data-__')) prev[key] = props[key];
        return prev;
    }, {});
}




var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $9715X = parcelRequire("9715X");

var $fhGLX = parcelRequire("fhGLX");

var $jDKKo = parcelRequire("jDKKo");

var $1gYAD = parcelRequire("1gYAD");

var $acw62 = parcelRequire("acw62");

function $f468648e848f8622$var$_callSuper(t, o, e) {
    return o = (0, $jDKKo.default)(o), (0, $9715X.default)(t, (0, $fhGLX.default)() ? Reflect.construct(o, e || [], (0, $jDKKo.default)(t).constructor) : o.apply(t, e));
}
var $f468648e848f8622$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        (0, $6CZeq.default)(this, ErrorBoundary);
        _this = $f468648e848f8622$var$_callSuper(this, ErrorBoundary, arguments);
        _this.state = {
            error: undefined,
            info: {
                componentStack: ''
            }
        };
        return _this;
    }
    (0, $cHPF9.default)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, message = _this$props.message, description = _this$props.description, children = _this$props.children;
                var _this$state = this.state, error = _this$state.error, info = _this$state.info;
                var componentStack = info && info.componentStack ? info.componentStack : null;
                var errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
                var errorDescription = typeof description === 'undefined' ? componentStack : description;
                if (error) return /*#__PURE__*/ $acw62.createElement((0, $572a64029912a579$export$2e2bcd8739ae039), {
                    type: "error",
                    message: errorMessage,
                    description: /*#__PURE__*/ $acw62.createElement("pre", null, errorDescription)
                });
                return children;
            }
        }
    ]);
    return ErrorBoundary;
}($acw62.Component);
var $f468648e848f8622$export$2e2bcd8739ae039 = $f468648e848f8622$var$ErrorBoundary;


var $572a64029912a579$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $572a64029912a579$var$iconMapFilled = {
    success: (0, $8a880f6c24a0b77c$export$2e2bcd8739ae039),
    info: (0, $2169dccbc27bcb86$export$2e2bcd8739ae039),
    error: (0, $2bf1c25862f513c2$export$2e2bcd8739ae039),
    warning: (0, $c94f46c32abf10c6$export$2e2bcd8739ae039)
};
var $572a64029912a579$var$iconMapOutlined = {
    success: (0, $99a2d8a3991a4b46$export$2e2bcd8739ae039),
    info: (0, $7e25aa5b60711714$export$2e2bcd8739ae039),
    error: (0, $e59ec99fdd4bd915$export$2e2bcd8739ae039),
    warning: (0, $7e2f802c76c39788$export$2e2bcd8739ae039)
};
var $572a64029912a579$var$IconNode = function IconNode(props) {
    var description = props.description, icon = props.icon, prefixCls = props.prefixCls, type = props.type;
    var iconType = (description ? $572a64029912a579$var$iconMapOutlined : $572a64029912a579$var$iconMapFilled)[type] || null;
    if (icon) return (0, $30796c32f374b477$export$2dfe578f95754f6a)(icon, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, icon), function() {
        return {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-icon"), (0, $kSlfw.default)({}, icon.props.className, icon.props.className))
        };
    });
    return /*#__PURE__*/ $acw62.createElement(iconType, {
        className: "".concat(prefixCls, "-icon")
    });
};
var $572a64029912a579$var$CloseIcon = function CloseIcon(props) {
    var isClosable = props.isClosable, closeText = props.closeText, prefixCls = props.prefixCls, closeIcon = props.closeIcon, handleClose = props.handleClose;
    return isClosable ? /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: handleClose,
        className: "".concat(prefixCls, "-close-icon"),
        tabIndex: 0
    }, closeText ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-close-text")
    }, closeText) : closeIcon) : null;
};
var $572a64029912a579$var$Alert = function Alert(_a) {
    var description = _a.description, customizePrefixCls = _a.prefixCls, message = _a.message, banner = _a.banner, _a$className = _a.className, className = _a$className === void 0 ? '' : _a$className, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick, afterClose = _a.afterClose, showIcon = _a.showIcon, closable = _a.closable, closeText = _a.closeText, _a$closeIcon = _a.closeIcon, closeIcon = _a$closeIcon === void 0 ? /*#__PURE__*/ $acw62.createElement((0, $31b8ddc4065205d5$export$2e2bcd8739ae039), null) : _a$closeIcon, action = _a.action, props = $572a64029912a579$var$__rest(_a, [
        "description",
        "prefixCls",
        "message",
        "banner",
        "className",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "onClick",
        "afterClose",
        "showIcon",
        "closable",
        "closeText",
        "closeIcon",
        "action"
    ]);
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), closed = _React$useState2[0], setClosed = _React$useState2[1];
    var ref = $acw62.useRef();
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('alert', customizePrefixCls);
    var handleClose = function handleClose(e) {
        var _a;
        setClosed(true);
        (_a = props.onClose) === null || _a === void 0 || _a.call(props, e);
    };
    var getType = function getType() {
        var type = props.type;
        if (type !== undefined) return type;
        // banner 模式默认为警告
        return banner ? 'warning' : 'info';
    };
    // closeable when closeText is assigned
    var isClosable = closeText ? true : closable;
    var type = getType();
    // banner 模式默认有 Icon
    var isShowIcon = banner && showIcon === undefined ? true : showIcon;
    var alertCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-").concat(type), (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-with-description"), !!description), "".concat(prefixCls, "-no-icon"), !isShowIcon), "".concat(prefixCls, "-banner"), !!banner), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var dataOrAriaProps = (0, $7e9c3441b3ad589e$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), {
        visible: !closed,
        motionName: "".concat(prefixCls, "-motion"),
        motionAppear: false,
        motionEnter: false,
        onLeaveStart: function onLeaveStart(node) {
            return {
                maxHeight: node.offsetHeight
            };
        },
        onLeaveEnd: afterClose
    }, function(_ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
            ref: ref,
            "data-show": !closed,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(alertCls, motionClassName),
            style: (0, $8nd05.default)((0, $8nd05.default)({}, style), motionStyle),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            role: "alert"
        }, dataOrAriaProps), isShowIcon ? /*#__PURE__*/ $acw62.createElement($572a64029912a579$var$IconNode, {
            description: description,
            icon: props.icon,
            prefixCls: prefixCls,
            type: type
        }) : null, /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-content")
        }, message ? /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, message) : null, description ? /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description) : null), action ? /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-action")
        }, action) : null, /*#__PURE__*/ $acw62.createElement($572a64029912a579$var$CloseIcon, {
            isClosable: !!isClosable,
            closeText: closeText,
            prefixCls: prefixCls,
            closeIcon: closeIcon,
            handleClose: handleClose
        }));
    });
};
$572a64029912a579$var$Alert.ErrorBoundary = (0, $f468648e848f8622$export$2e2bcd8739ae039);
var $572a64029912a579$export$2e2bcd8739ae039 = $572a64029912a579$var$Alert;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $89717f77fcb1cda1$var$BookOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z"
                }
            }
        ]
    },
    "name": "book",
    "theme": "outlined"
};
var $89717f77fcb1cda1$export$2e2bcd8739ae039 = $89717f77fcb1cda1$var$BookOutlined;



function $21ff6f7f2894ecea$var$_extends() {
    $21ff6f7f2894ecea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21ff6f7f2894ecea$var$_extends.apply(this, arguments);
}
const $21ff6f7f2894ecea$var$BookOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $21ff6f7f2894ecea$var$_extends({}, props, {
        ref: ref,
        icon: (0, $89717f77fcb1cda1$export$2e2bcd8739ae039)
    }));
/**![book](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWOTZjMC0xNy43LTE0LjMtMzItMzItMzJ6bS0yNjAgNzJoOTZ2MjA5LjlMNjIxLjUgMzEyIDU3MiAzNDcuNFYxMzZ6bTIyMCA3NTJIMjMyVjEzNmgyODB2Mjk2LjljMCAzLjMgMSA2LjYgMyA5LjNhMTUuOSAxNS45IDAgMDAyMi4zIDMuN2w4My44LTU5LjkgODEuNCA1OS40YzIuNyAyIDYgMy4xIDkuNCAzLjEgOC44IDAgMTYtNy4yIDE2LTE2VjEzNmg2NHY3NTJ6IiAvPjwvc3ZnPg==) */ const $21ff6f7f2894ecea$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($21ff6f7f2894ecea$var$BookOutlined);
var $21ff6f7f2894ecea$export$2e2bcd8739ae039 = $21ff6f7f2894ecea$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $f594554ffb3fd13b$var$CarryOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    },
    "name": "carry-out",
    "theme": "outlined"
};
var $f594554ffb3fd13b$export$2e2bcd8739ae039 = $f594554ffb3fd13b$var$CarryOutOutlined;



function $f5a6b5c7d90a4e65$var$_extends() {
    $f5a6b5c7d90a4e65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f5a6b5c7d90a4e65$var$_extends.apply(this, arguments);
}
const $f5a6b5c7d90a4e65$var$CarryOutOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $f5a6b5c7d90a4e65$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f594554ffb3fd13b$export$2e2bcd8739ae039)
    }));
/**![carry-out](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxODRINzEydi02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMzg0di02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY2NjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIxNmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDY1NkgxODRWMjU2aDEyOHY0OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di00OGgyNTZ2NDhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNDhoMTI4djU4NHpNNjg4IDQyMGgtNTUuMmMtNS4xIDAtMTAgMi41LTEzIDYuNkw0NjguOSA2MzQuNGwtNjQuNy04OWMtMy00LjEtNy44LTYuNi0xMy02LjZIMzM2Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjYuNCAxNzRhMTYuMSAxNi4xIDAgMDAyNiAwbDIxMi42LTI5Mi43YzMuOC01LjQgMC0xMi44LTYuNS0xMi44eiIgLz48L3N2Zz4=) */ const $f5a6b5c7d90a4e65$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f5a6b5c7d90a4e65$var$CarryOutOutlined);
var $f5a6b5c7d90a4e65$export$2e2bcd8739ae039 = $f5a6b5c7d90a4e65$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0547876b5ff7348a$var$CreditCardOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "credit-card",
    "theme": "outlined"
};
var $0547876b5ff7348a$export$2e2bcd8739ae039 = $0547876b5ff7348a$var$CreditCardOutlined;



function $2f8ce45decd122a2$var$_extends() {
    $2f8ce45decd122a2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2f8ce45decd122a2$var$_extends.apply(this, arguments);
}
const $2f8ce45decd122a2$var$CreditCardOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $2f8ce45decd122a2$var$_extends({}, props, {
        ref: ref,
        icon: (0, $0547876b5ff7348a$export$2e2bcd8739ae039)
    }));
/**![credit-card](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNzkyIDcyaDc1MnYxMjBIMTM2VjIzMnptNzUyIDU2MEgxMzZWNDQwaDc1MnYzNTJ6bS0yMzctNjRoMTY1YzQuNCAwIDgtMy42IDgtOHYtNzJjMC00LjQtMy42LTgtOC04SDY1MWMtNC40IDAtOCAzLjYtOCA4djcyYzAgNC40IDMuNiA4IDggOHoiIC8+PC9zdmc+) */ const $2f8ce45decd122a2$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2f8ce45decd122a2$var$CreditCardOutlined);
var $2f8ce45decd122a2$export$2e2bcd8739ae039 = $2f8ce45decd122a2$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $e9ce0fac880e8881$var$DeleteColumnOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M651.1 641.9a7.84 7.84 0 00-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H378c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L474.2 776 371.8 898.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zm556-256h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z"
                }
            }
        ]
    },
    "name": "delete-column",
    "theme": "outlined"
};
var $e9ce0fac880e8881$export$2e2bcd8739ae039 = $e9ce0fac880e8881$var$DeleteColumnOutlined;



function $92f281659fda605f$var$_extends() {
    $92f281659fda605f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $92f281659fda605f$var$_extends.apply(this, arguments);
}
const $92f281659fda605f$var$DeleteColumnOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $92f281659fda605f$var$_extends({}, props, {
        ref: ref,
        icon: (0, $e9ce0fac880e8881$export$2e2bcd8739ae039)
    }));
/**![delete-column](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik02NTEuMSA2NDEuOWE3Ljg0IDcuODQgMCAwMC01LjEtMS45aC01NC43Yy0yLjQgMC00LjYgMS4xLTYuMSAyLjlMNTEyIDczMC43bC03My4xLTg3LjhhOC4xIDguMSAwIDAwLTYuMS0yLjlIMzc4Yy0xLjkgMC0zLjcuNy01LjEgMS45YTcuOTcgNy45NyAwIDAwLTEgMTEuM0w0NzQuMiA3NzYgMzcxLjggODk4LjlhOC4wNiA4LjA2IDAgMDA2LjEgMTMuMmg1NC43YzIuNCAwIDQuNi0xLjEgNi4xLTIuOWw3My4xLTg3LjggNzMuMSA4Ny44YTguMSA4LjEgMCAwMDYuMSAyLjloNTVjMS45IDAgMy43LS43IDUuMS0xLjkgMy40LTIuOCAzLjktNy45IDEtMTEuM0w1NDkuOCA3NzZsMTAyLjQtMTIyLjljMi44LTMuNCAyLjMtOC40LTEuMS0xMS4yek00NzIgNTQ0aDgwYzQuNCAwIDgtMy42IDgtOFYxMjBjMC00LjQtMy42LTgtOC04aC04MGMtNC40IDAtOCAzLjYtOCA4djQxNmMwIDQuNCAzLjYgOCA4IDh6TTM1MCAzODZIMTg0VjEzNmMwLTMuMy0yLjctNi02LTZoLTYwYy0zLjMgMC02IDIuNy02IDZ2MjkyYzAgMTYuNiAxMy40IDMwIDMwIDMwaDIwOGMzLjMgMCA2LTIuNyA2LTZ2LTYwYzAtMy4zLTIuNy02LTYtNnptNTU2LTI1NmgtNjBjLTMuMyAwLTYgMi43LTYgNnYyNTBINjc0Yy0zLjMgMC02IDIuNy02IDZ2NjBjMCAzLjMgMi43IDYgNiA2aDIwOGMxNi42IDAgMzAtMTMuNCAzMC0zMFYxMzZjMC0zLjMtMi43LTYtNi02eiIgLz48L3N2Zz4=) */ const $92f281659fda605f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($92f281659fda605f$var$DeleteColumnOutlined);
var $92f281659fda605f$export$2e2bcd8739ae039 = $92f281659fda605f$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $cba0ab55c45ed945$var$DollarCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    },
    "name": "dollar-circle",
    "theme": "outlined"
};
var $cba0ab55c45ed945$export$2e2bcd8739ae039 = $cba0ab55c45ed945$var$DollarCircleOutlined;



function $0cdd5a58cfa55afe$var$_extends() {
    $0cdd5a58cfa55afe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0cdd5a58cfa55afe$var$_extends.apply(this, arguments);
}
const $0cdd5a58cfa55afe$var$DollarCircleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $0cdd5a58cfa55afe$var$_extends({}, props, {
        ref: ref,
        icon: (0, $cba0ab55c45ed945$export$2e2bcd8739ae039)
    }));
/**![dollar-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnptNDcuNy0zOTUuMmwtMjUuNC01LjlWMzQ4LjZjMzggNS4yIDYxLjUgMjkgNjUuNSA1OC4yLjUgNCAzLjkgNi45IDcuOSA2LjloNDQuOWM0LjcgMCA4LjQtNC4xIDgtOC44LTYuMS02Mi4zLTU3LjQtMTAyLjMtMTI1LjktMTA5LjJWMjYzYzAtNC40LTMuNi04LTgtOGgtMjguMWMtNC40IDAtOCAzLjYtOCA4djMzYy03MC44IDYuOS0xMjYuMiA0Ni0xMjYuMiAxMTkgMCA2Ny42IDQ5LjggMTAwLjIgMTAyLjEgMTEyLjdsMjQuNyA2LjN2MTQyLjdjLTQ0LjItNS45LTY5LTI5LjUtNzQuMS02MS4zLS42LTMuOC00LTYuNi03LjktNi42SDM2M2MtNC43IDAtOC40IDQtOCA4LjcgNC41IDU1IDQ2LjIgMTA1LjYgMTM1LjIgMTEyLjFWNzYxYzAgNC40IDMuNiA4IDggOGgyOC40YzQuNCAwIDgtMy42IDgtOC4xbC0uMi0zMS43Yzc4LjMtNi45IDEzNC4zLTQ4LjggMTM0LjMtMTI0LS4xLTY5LjQtNDQuMi0xMDAuNC0xMDktMTE2LjR6bS02OC42LTE2LjJjLTUuNi0xLjYtMTAuMy0zLjEtMTUtNS0zMy44LTEyLjItNDkuNS0zMS45LTQ5LjUtNTcuMyAwLTM2LjMgMjcuNS01NyA2NC41LTYxLjd2MTI0ek01MzQuMyA2NzdWNTQzLjNjMy4xLjkgNS45IDEuNiA4LjggMi4yIDQ3LjMgMTQuNCA2My4yIDM0LjQgNjMuMiA2NS4xIDAgMzkuMS0yOS40IDYyLjYtNzIgNjYuNHoiIC8+PC9zdmc+) */ const $0cdd5a58cfa55afe$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($0cdd5a58cfa55afe$var$DollarCircleOutlined);
var $0cdd5a58cfa55afe$export$2e2bcd8739ae039 = $0cdd5a58cfa55afe$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $fc99a386109651e1$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
var $fc99a386109651e1$export$2e2bcd8739ae039 = $fc99a386109651e1$var$FolderOutlined;



function $7413288a2bacf616$var$_extends() {
    $7413288a2bacf616$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7413288a2bacf616$var$_extends.apply(this, arguments);
}
const $7413288a2bacf616$var$FolderOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $7413288a2bacf616$var$_extends({}, props, {
        ref: ref,
        icon: (0, $fc99a386109651e1$export$2e2bcd8739ae039)
    }));
/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */ const $7413288a2bacf616$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($7413288a2bacf616$var$FolderOutlined);
var $7413288a2bacf616$export$2e2bcd8739ae039 = $7413288a2bacf616$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $bd514564d8a202fa$var$IdcardOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    },
    "name": "idcard",
    "theme": "outlined"
};
var $bd514564d8a202fa$export$2e2bcd8739ae039 = $bd514564d8a202fa$var$IdcardOutlined;



function $1585dc47f665cba4$var$_extends() {
    $1585dc47f665cba4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1585dc47f665cba4$var$_extends.apply(this, arguments);
}
const $1585dc47f665cba4$var$IdcardOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $1585dc47f665cba4$var$_extends({}, props, {
        ref: ref,
        icon: (0, $bd514564d8a202fa$export$2e2bcd8739ae039)
    }));
/**![idcard](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNlYyMzJoNzUydjU2MHpNNjEwLjMgNDc2aDEyMy40YzEuMyAwIDIuMy0zLjYgMi4zLTh2LTQ4YzAtNC40LTEtOC0yLjMtOEg2MTAuM2MtMS4zIDAtMi4zIDMuNi0yLjMgOHY0OGMwIDQuNCAxIDggMi4zIDh6bTQuOCAxNDRoMTg1LjdjMy45IDAgNy4xLTMuNiA3LjEtOHYtNDhjMC00LjQtMy4yLTgtNy4xLThINjE1LjFjLTMuOSAwLTcuMSAzLjYtNy4xIDh2NDhjMCA0LjQgMy4yIDggNy4xIDh6TTIyNCA2NzNoNDMuOWM0LjIgMCA3LjYtMy4zIDcuOS03LjUgMy44LTUwLjUgNDYtOTAuNSA5Ny4yLTkwLjVzOTMuNCA0MCA5Ny4yIDkwLjVjLjMgNC4yIDMuNyA3LjUgNy45IDcuNUg1MjJhOCA4IDAgMDA4LTguNGMtMi44LTUzLjMtMzItOTkuNy03NC42LTEyNi4xYTExMS44IDExMS44IDAgMDAyOS4xLTc1LjVjMC02MS45LTQ5LjktMTEyLTExMS40LTExMnMtMTExLjQgNTAuMS0xMTEuNCAxMTJjMCAyOS4xIDExIDU1LjUgMjkuMSA3NS41YTE1OC4wOSAxNTguMDkgMCAwMC03NC42IDEyNi4xYy0uNCA0LjYgMy4yIDguNCA3LjggOC40em0xNDktMjYyYzI4LjUgMCA1MS43IDIzLjMgNTEuNyA1MnMtMjMuMiA1Mi01MS43IDUyLTUxLjctMjMuMy01MS43LTUyIDIzLjItNTIgNTEuNy01MnoiIC8+PC9zdmc+) */ const $1585dc47f665cba4$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1585dc47f665cba4$var$IdcardOutlined);
var $1585dc47f665cba4$export$2e2bcd8739ae039 = $1585dc47f665cba4$var$RefIcon;


var $acw62 = parcelRequire("acw62");


function $f40f87e4967cd996$var$_extends() {
    $f40f87e4967cd996$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f40f87e4967cd996$var$_extends.apply(this, arguments);
}
const $f40f87e4967cd996$var$InfoCircleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $f40f87e4967cd996$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a37b6e3a9f9e4b6a$export$2e2bcd8739ae039)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTQ2NCAzMzZhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem03MiAxMTJoLTQ4Yy00LjQgMC04IDMuNi04IDh2MjcyYzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDU2YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $f40f87e4967cd996$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f40f87e4967cd996$var$InfoCircleOutlined);
var $f40f87e4967cd996$export$2e2bcd8739ae039 = $f40f87e4967cd996$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ae2fdcfdecd38ee1$var$LineChartOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 00-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 00-11.3 0L266.3 586.7a8.03 8.03 0 000 11.3l39.5 39.7z"
                }
            }
        ]
    },
    "name": "line-chart",
    "theme": "outlined"
};
var $ae2fdcfdecd38ee1$export$2e2bcd8739ae039 = $ae2fdcfdecd38ee1$var$LineChartOutlined;



function $6f887ca94eb88b31$var$_extends() {
    $6f887ca94eb88b31$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f887ca94eb88b31$var$_extends.apply(this, arguments);
}
const $6f887ca94eb88b31$var$LineChartOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $6f887ca94eb88b31$var$_extends({}, props, {
        ref: ref,
        icon: (0, $ae2fdcfdecd38ee1$export$2e2bcd8739ae039)
    }));
/**![line-chart](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4OCA3OTJIMjAwVjE2OGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2Njg4YzAgNC40IDMuNiA4IDggOGg3NTJjNC40IDAgOC0zLjYgOC04di01NmMwLTQuNC0zLjYtOC04LTh6TTMwNS44IDYzNy43YzMuMSAzLjEgOC4xIDMuMSAxMS4zIDBsMTM4LjMtMTM3LjZMNTgzIDYyOC41YzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBsMjc1LjQtMjc1LjNjMy4xLTMuMSAzLjEtOC4yIDAtMTEuM2wtMzkuNi0zOS42YTguMDMgOC4wMyAwIDAwLTExLjMgMGwtMjMwIDIyOS45TDQ2MS40IDQwNGE4LjAzIDguMDMgMCAwMC0xMS4zIDBMMjY2LjMgNTg2LjdhOC4wMyA4LjAzIDAgMDAwIDExLjNsMzkuNSAzOS43eiIgLz48L3N2Zz4=) */ const $6f887ca94eb88b31$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($6f887ca94eb88b31$var$LineChartOutlined);
var $6f887ca94eb88b31$export$2e2bcd8739ae039 = $6f887ca94eb88b31$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b06d6f3c4936653b$var$LogoutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 01-112.7 75.9A352.8 352.8 0 01512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 01-112.7-75.9 353.28 353.28 0 01-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z"
                }
            }
        ]
    },
    "name": "logout",
    "theme": "outlined"
};
var $b06d6f3c4936653b$export$2e2bcd8739ae039 = $b06d6f3c4936653b$var$LogoutOutlined;



function $bdd26ad7c91dfa21$var$_extends() {
    $bdd26ad7c91dfa21$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bdd26ad7c91dfa21$var$_extends.apply(this, arguments);
}
const $bdd26ad7c91dfa21$var$LogoutOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $bdd26ad7c91dfa21$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b06d6f3c4936653b$export$2e2bcd8739ae039)
    }));
/**![logout](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2OCA3MzJoLTcwLjNjLTQuOCAwLTkuMyAyLjEtMTIuMyA1LjgtNyA4LjUtMTQuNSAxNi43LTIyLjQgMjQuNWEzNTMuODQgMzUzLjg0IDAgMDEtMTEyLjcgNzUuOUEzNTIuOCAzNTIuOCAwIDAxNTEyLjQgODY2Yy00Ny45IDAtOTQuMy05LjQtMTM3LjktMjcuOGEzNTMuODQgMzUzLjg0IDAgMDEtMTEyLjctNzUuOSAzNTMuMjggMzUzLjI4IDAgMDEtNzYtMTEyLjVDMTY3LjMgNjA2LjIgMTU4IDU1OS45IDE1OCA1MTJzOS40LTk0LjIgMjcuOC0xMzcuOGMxNy44LTQyLjEgNDMuNC04MCA3Ni0xMTIuNXM3MC41LTU4LjEgMTEyLjctNzUuOWM0My42LTE4LjQgOTAtMjcuOCAxMzcuOS0yNy44IDQ3LjkgMCA5NC4zIDkuMyAxMzcuOSAyNy44IDQyLjIgMTcuOCA4MC4xIDQzLjQgMTEyLjcgNzUuOSA3LjkgNy45IDE1LjMgMTYuMSAyMi40IDI0LjUgMyAzLjcgNy42IDUuOCAxMi4zIDUuOEg4NjhjNi4zIDAgMTAuMi03IDYuNy0xMi4zQzc5OCAxNjAuNSA2NjMuOCA4MS42IDUxMS4zIDgyIDI3MS43IDgyLjYgNzkuNiAyNzcuMSA4MiA1MTYuNCA4NC40IDc1MS45IDI3Ni4yIDk0MiA1MTIuNCA5NDJjMTUyLjEgMCAyODUuNy03OC44IDM2Mi4zLTE5Ny43IDMuNC01LjMtLjQtMTIuMy02LjctMTIuM3ptODguOS0yMjYuM0w4MTUgMzkzLjdjLTUuMy00LjItMTMtLjQtMTMgNi4zdjc2SDQ4OGMtNC40IDAtOCAzLjYtOCA4djU2YzAgNC40IDMuNiA4IDggOGgzMTR2NzZjMCA2LjcgNy44IDEwLjUgMTMgNi4zbDE0MS45LTExMmE4IDggMCAwMDAtMTIuNnoiIC8+PC9zdmc+) */ const $bdd26ad7c91dfa21$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($bdd26ad7c91dfa21$var$LogoutOutlined);
var $bdd26ad7c91dfa21$export$2e2bcd8739ae039 = $bdd26ad7c91dfa21$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $9778202bd5767bbc$var$SettingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "setting",
    "theme": "outlined"
};
var $9778202bd5767bbc$export$2e2bcd8739ae039 = $9778202bd5767bbc$var$SettingOutlined;



function $1caa9be48b381e9f$var$_extends() {
    $1caa9be48b381e9f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1caa9be48b381e9f$var$_extends.apply(this, arguments);
}
const $1caa9be48b381e9f$var$SettingOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $1caa9be48b381e9f$var$_extends({}, props, {
        ref: ref,
        icon: (0, $9778202bd5767bbc$export$2e2bcd8739ae039)
    }));
/**![setting](data:image/svg+xml;base64,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) */ const $1caa9be48b381e9f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1caa9be48b381e9f$var$SettingOutlined);
var $1caa9be48b381e9f$export$2e2bcd8739ae039 = $1caa9be48b381e9f$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $62848aec8eee7d48$var$SolutionOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            }
        ]
    },
    "name": "solution",
    "theme": "outlined"
};
var $62848aec8eee7d48$export$2e2bcd8739ae039 = $62848aec8eee7d48$var$SolutionOutlined;



function $24ec3343da8a417c$var$_extends() {
    $24ec3343da8a417c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24ec3343da8a417c$var$_extends.apply(this, arguments);
}
const $24ec3343da8a417c$var$SolutionOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $24ec3343da8a417c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $62848aec8eee7d48$export$2e2bcd8739ae039)
    }));
/**![solution](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY4OCAyNjRjMC00LjQtMy42LTgtOC04SDI5NmMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OHptLTggMTM2SDI5NmMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LTh6TTQ4MCA1NDRIMjk2Yy00LjQgMC04IDMuNi04IDh2NDhjMCA0LjQgMy42IDggOCA4aDE4NGM0LjQgMCA4LTMuNiA4LTh2LTQ4YzAtNC40LTMuNi04LTgtOHptLTQ4IDMwOEgyMDhWMTQ4aDU2MHYzNDRjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOFYxMDhjMC0xNy43LTE0LjMtMzItMzItMzJIMTY4Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3ODRjMCAxNy43IDE0LjMgMzIgMzIgMzJoMjY0YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04em0zNTYuOC03NC40YzI5LTI2LjMgNDcuMi02NC4zIDQ3LjItMTA2LjYgMC03OS41LTY0LjUtMTQ0LTE0NC0xNDRzLTE0NCA2NC41LTE0NCAxNDRjMCA0Mi4zIDE4LjIgODAuMyA0Ny4yIDEwNi42LTU3IDMyLjUtOTYuMiA5Mi43LTk5LjIgMTYyLjEtLjIgNC41IDMuNSA4LjMgOCA4LjNoNDguMWM0LjIgMCA3LjctMy4zIDgtNy42QzU2NCA4NzEuMiA2MjEuNyA4MTYgNjkyIDgxNnMxMjggNTUuMiAxMzEuOSAxMjQuNGMuMiA0LjIgMy43IDcuNiA4IDcuNkg4ODBjNC42IDAgOC4yLTMuOCA4LTguMy0yLjktNjkuNS00Mi4yLTEyOS42LTk5LjItMTYyLjF6TTY5MiA1OTFjNDQuMiAwIDgwIDM1LjggODAgODBzLTM1LjggODAtODAgODAtODAtMzUuOC04MC04MCAzNS44LTgwIDgwLTgweiIgLz48L3N2Zz4=) */ const $24ec3343da8a417c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($24ec3343da8a417c$var$SolutionOutlined);
var $24ec3343da8a417c$export$2e2bcd8739ae039 = $24ec3343da8a417c$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $023923c9edd631fe$var$UserOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    },
    "name": "user",
    "theme": "outlined"
};
var $023923c9edd631fe$export$2e2bcd8739ae039 = $023923c9edd631fe$var$UserOutlined;



function $84e9ccff1d32837e$var$_extends() {
    $84e9ccff1d32837e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84e9ccff1d32837e$var$_extends.apply(this, arguments);
}
const $84e9ccff1d32837e$var$UserOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $84e9ccff1d32837e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $023923c9edd631fe$export$2e2bcd8739ae039)
    }));
/**![user](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC41IDc2My42YTM3NCAzNzQgMCAwMC04MC42LTExOS41IDM3NS42MyAzNzUuNjMgMCAwMC0xMTkuNS04MC42Yy0uNC0uMi0uOC0uMy0xLjItLjVDNzE5LjUgNTE4IDc2MCA0NDQuNyA3NjAgMzYyYzAtMTM3LTExMS0yNDgtMjQ4LTI0OFMyNjQgMjI1IDI2NCAzNjJjMCA4Mi43IDQwLjUgMTU2IDEwMi44IDIwMS4xLS40LjItLjguMy0xLjIuNS00NC44IDE4LjktODUgNDYtMTE5LjUgODAuNmEzNzUuNjMgMzc1LjYzIDAgMDAtODAuNiAxMTkuNUEzNzEuNyAzNzEuNyAwIDAwMTM2IDkwMS44YTggOCAwIDAwOCA4LjJoNjBjNC40IDAgNy45LTMuNSA4LTcuOCAyLTc3LjIgMzMtMTQ5LjUgODcuOC0yMDQuMyA1Ni43LTU2LjcgMTMyLTg3LjkgMjEyLjItODcuOXMxNTUuNSAzMS4yIDIxMi4yIDg3LjlDNzc5IDc1Mi43IDgxMCA4MjUgODEyIDkwMi4yYy4xIDQuNCAzLjYgNy44IDggNy44aDYwYTggOCAwIDAwOC04LjJjLTEtNDcuOC0xMC45LTk0LjMtMjkuNS0xMzguMnpNNTEyIDUzNGMtNDUuOSAwLTg5LjEtMTcuOS0xMjEuNi01MC40UzM0MCA0MDcuOSAzNDAgMzYyYzAtNDUuOSAxNy45LTg5LjEgNTAuNC0xMjEuNlM0NjYuMSAxOTAgNTEyIDE5MHM4OS4xIDE3LjkgMTIxLjYgNTAuNFM2ODQgMzE2LjEgNjg0IDM2MmMwIDQ1LjktMTcuOSA4OS4xLTUwLjQgMTIxLjZTNTU3LjkgNTM0IDUxMiA1MzR6IiAvPjwvc3ZnPg==) */ const $84e9ccff1d32837e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($84e9ccff1d32837e$var$UserOutlined);
var $84e9ccff1d32837e$export$2e2bcd8739ae039 = $84e9ccff1d32837e$var$RefIcon;




parcelRequire("acw62");


var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $8KbLt = parcelRequire("8KbLt");
var $hrhZj = parcelRequire("hrhZj");
var $44Iii = parcelRequire("44Iii");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $148bd952cb1a5a76$var$Empty = function Empty() {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('empty-img-default');
    return /*#__PURE__*/ $acw62.createElement("svg", {
        className: prefixCls,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        className: "".concat(prefixCls, "-path-1"),
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        className: "".concat(prefixCls, "-path-2"),
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        className: "".concat(prefixCls, "-path-3"),
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        className: "".concat(prefixCls, "-path-4"),
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
    })), /*#__PURE__*/ $acw62.createElement("path", {
        className: "".concat(prefixCls, "-path-5"),
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        transform: "translate(149.65 15.383)"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $148bd952cb1a5a76$export$2e2bcd8739ae039 = $148bd952cb1a5a76$var$Empty;



var $acw62 = parcelRequire("acw62");

var $ae7f97f0fd68830c$var$Simple = function Simple() {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('empty-img-simple');
    return /*#__PURE__*/ $acw62.createElement("svg", {
        className: prefixCls,
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        fillRule: "nonzero"
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        className: "".concat(prefixCls, "-path")
    }))));
};
var $ae7f97f0fd68830c$export$2e2bcd8739ae039 = $ae7f97f0fd68830c$var$Simple;


var $ec66348328372da5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ec66348328372da5$var$defaultEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $148bd952cb1a5a76$export$2e2bcd8739ae039), null);
var $ec66348328372da5$var$simpleEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $ae7f97f0fd68830c$export$2e2bcd8739ae039), null);
var $ec66348328372da5$var$Empty = function Empty(_a) {
    var className = _a.className, customizePrefixCls = _a.prefixCls, _a$image = _a.image, image = _a$image === void 0 ? $ec66348328372da5$var$defaultEmptyImg : _a$image, description = _a.description, children = _a.children, imageStyle = _a.imageStyle, restProps = $ec66348328372da5$var$__rest(_a, [
        "className",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    return /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), {
        componentName: "Empty"
    }, function(contextLocale) {
        var prefixCls = getPrefixCls('empty', customizePrefixCls);
        var des = typeof description !== 'undefined' ? description : contextLocale.description;
        var alt = typeof des === 'string' ? des : 'empty';
        var imageNode = null;
        if (typeof image === 'string') imageNode = /*#__PURE__*/ $acw62.createElement("img", {
            alt: alt,
            src: image
        });
        else imageNode = image;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-normal"), image === $ec66348328372da5$var$simpleEmptyImg), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className)
        }, restProps), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-image"),
            style: imageStyle
        }, imageNode), des && /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, des), children && /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-footer")
        }, children));
    });
};
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_DEFAULT = $ec66348328372da5$var$defaultEmptyImg;
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_SIMPLE = $ec66348328372da5$var$simpleEmptyImg;
var $ec66348328372da5$export$2e2bcd8739ae039 = $ec66348328372da5$var$Empty;


var $3feb83783705e448$var$defaultRenderEmpty = function defaultRenderEmpty(componentName) {
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), null, function(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefix = getPrefixCls('empty');
        switch(componentName){
            case 'Table':
            case 'List':
                return /*#__PURE__*/ $acw62.createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                    image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
                });
            case 'Select':
            case 'TreeSelect':
            case 'Cascader':
            case 'Transfer':
            case 'Mentions':
                return /*#__PURE__*/ $acw62.createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                    image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                    className: "".concat(prefix, "-small")
                });
            /* istanbul ignore next */ default:
                // Should never hit if we take all the component into consider.
                return /*#__PURE__*/ $acw62.createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), null);
        }
    });
};
var $3feb83783705e448$export$2e2bcd8739ae039 = $3feb83783705e448$var$defaultRenderEmpty;






// ================== Collapse Motion ==================
var $2efb522a5615f01e$var$getCollapsedHeight = function getCollapsedHeight() {
    return {
        height: 0,
        opacity: 0
    };
};
var $2efb522a5615f01e$var$getRealHeight = function getRealHeight(node) {
    var scrollHeight = node.scrollHeight;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
var $2efb522a5615f01e$var$getCurrentHeight = function getCurrentHeight(node) {
    return {
        height: node ? node.offsetHeight : 0
    };
};
var $2efb522a5615f01e$var$skipOpacityTransition = function skipOpacityTransition(_, event) {
    return (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
};
var $2efb522a5615f01e$var$collapseMotion = {
    motionName: 'ant-motion-collapse',
    onAppearStart: $2efb522a5615f01e$var$getCollapsedHeight,
    onEnterStart: $2efb522a5615f01e$var$getCollapsedHeight,
    onAppearActive: $2efb522a5615f01e$var$getRealHeight,
    onEnterActive: $2efb522a5615f01e$var$getRealHeight,
    onLeaveStart: $2efb522a5615f01e$var$getCurrentHeight,
    onLeaveActive: $2efb522a5615f01e$var$getCollapsedHeight,
    onAppearEnd: $2efb522a5615f01e$var$skipOpacityTransition,
    onEnterEnd: $2efb522a5615f01e$var$skipOpacityTransition,
    onLeaveEnd: $2efb522a5615f01e$var$skipOpacityTransition,
    motionDeadline: 500
};
var $2efb522a5615f01e$var$SelectPlacements = (0, $1ee8868d1993c67b$export$65e3907585753458)('bottomLeft', 'bottomRight', 'topLeft', 'topRight');
var $2efb522a5615f01e$export$b2382d4a41c58fef = function getTransitionDirection(placement) {
    if (placement !== undefined && (placement === 'topLeft' || placement === 'topRight')) return "slide-down";
    return "slide-up";
};
var $2efb522a5615f01e$export$27c72201b1d09951 = function getTransitionName(rootPrefixCls, motion, transitionName) {
    if (transitionName !== undefined) return transitionName;
    return "".concat(rootPrefixCls, "-").concat(motion);
};
var $2efb522a5615f01e$export$2e2bcd8739ae039 = $2efb522a5615f01e$var$collapseMotion;




var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $94b215ba0d5fdf99$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $94b215ba0d5fdf99$export$2e2bcd8739ae039 = $94b215ba0d5fdf99$var$CheckOutlined;



var $4f16321102503449$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $94b215ba0d5fdf99$export$2e2bcd8739ae039)
    }));
};
var $4f16321102503449$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($4f16321102503449$var$CheckOutlined);
var $4f16321102503449$export$2e2bcd8739ae039 = $4f16321102503449$var$RefIcon;





var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4785c2fd6b878d9a$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $4785c2fd6b878d9a$export$2e2bcd8739ae039 = $4785c2fd6b878d9a$var$DownOutlined;



var $07345ef74b4fd657$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $4785c2fd6b878d9a$export$2e2bcd8739ae039)
    }));
};
var $07345ef74b4fd657$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($07345ef74b4fd657$var$DownOutlined);
var $07345ef74b4fd657$export$2e2bcd8739ae039 = $07345ef74b4fd657$var$RefIcon;





var $acw62 = parcelRequire("acw62");
function $f03b38f767ce7782$export$2e2bcd8739ae039(_ref) {
    var suffixIcon = _ref.suffixIcon, clearIcon = _ref.clearIcon, menuItemSelectedIcon = _ref.menuItemSelectedIcon, removeIcon = _ref.removeIcon, loading = _ref.loading, multiple = _ref.multiple, hasFeedback = _ref.hasFeedback, prefixCls = _ref.prefixCls, showArrow = _ref.showArrow, feedbackIcon = _ref.feedbackIcon;
    // Clear Icon
    var mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $acw62.createElement((0, $2bf1c25862f513c2$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    var getSuffixIconNode = function getSuffixIconNode(arrowIcon) {
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showArrow !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    var mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $43383ed7d2a91124$export$2e2bcd8739ae039), {
        spin: true
    }));
    else {
        var iconCls = "".concat(prefixCls, "-suffix");
        mergedSuffixIcon = function mergedSuffixIcon(_ref2) {
            var open = _ref2.open, showSearch = _ref2.showSearch;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $2917d4d4b4ce8eca$export$2e2bcd8739ae039), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $07345ef74b4fd657$export$2e2bcd8739ae039), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    var mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $acw62.createElement((0, $4f16321102503449$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    var mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $acw62.createElement((0, $31b8ddc4065205d5$export$2e2bcd8739ae039), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}




// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
var $1b56c179e5783cdb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
var $1b56c179e5783cdb$var$InternalSelect = function InternalSelect(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, className = _a.className, getPopupContainer = _a.getPopupContainer, dropdownClassName = _a.dropdownClassName, popupClassName = _a.popupClassName, _a$listHeight = _a.listHeight, listHeight = _a$listHeight === void 0 ? 256 : _a$listHeight, placement = _a.placement, _a$listItemHeight = _a.listItemHeight, listItemHeight = _a$listItemHeight === void 0 ? 32 : _a$listItemHeight, customizeSize = _a.size, customDisabled = _a.disabled, notFoundContent = _a.notFoundContent, customStatus = _a.status, showArrow = _a.showArrow, props = $1b56c179e5783cdb$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "className",
        "getPopupContainer",
        "dropdownClassName",
        "popupClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "showArrow"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction, virtual = _React$useContext.virtual, dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;
    var size = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    var prefixCls = getPrefixCls('select', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var _useCompactItemContex = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var mode = $acw62.useMemo(function() {
        var m = props.mode;
        if (m === 'combobox') return undefined;
        if (m === $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    var isMultiple = mode === 'multiple' || mode === 'tags';
    var mergedShowArrow = showArrow !== undefined ? showArrow : props.loading || !(isMultiple || mode === 'combobox');
    // ===================== Form Status =====================
    var _useContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed)), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, isFormItemInput = _useContext.isFormItemInput, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    var mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = (renderEmpty || (0, $3feb83783705e448$export$2e2bcd8739ae039))('Select');
    // ===================== Icons =====================
    var _getIcons = (0, $f03b38f767ce7782$export$2e2bcd8739ae039)((0, $8nd05.default)((0, $8nd05.default)({}, props), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showArrow: mergedShowArrow,
        prefixCls: prefixCls
    })), suffixIcon = _getIcons.suffixIcon, itemIcon = _getIcons.itemIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
    var selectProps = (0, $1pcHX.default)(props, [
        'suffixIcon',
        'itemIcon'
    ]);
    var rcSelectRtlDropdownClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(popupClassName || dropdownClassName, (0, $kSlfw.default)({}, "".concat(prefixCls, "-dropdown-").concat(direction), direction === 'rtl'));
    var mergedSize = compactSize || customizeSize || size;
    // ===================== Disabled =====================
    var disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-lg"), mergedSize === 'large'), "".concat(prefixCls, "-sm"), mergedSize === 'small'), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-borderless"), !bordered), "".concat(prefixCls, "-in-form-item"), isFormItemInput), (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, className);
    // ===================== Placement =====================
    var getPlacement = function getPlacement() {
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    };
    return /*#__PURE__*/ $acw62.createElement((0, $8KbLt.default), (0, $8nd05.default)({
        ref: ref,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }, selectProps, {
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, (0, $2efb522a5615f01e$export$b2382d4a41c58fef)(placement), props.transitionName),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: getPlacement(),
        direction: direction,
        inputIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        clearIcon: clearIcon,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: rcSelectRtlDropdownClassName,
        showArrow: hasFeedback || showArrow,
        disabled: mergedDisabled
    }));
};
var $1b56c179e5783cdb$var$Select = /*#__PURE__*/ $acw62.forwardRef($1b56c179e5783cdb$var$InternalSelect);
$1b56c179e5783cdb$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$1b56c179e5783cdb$var$Select.Option = (0, $44Iii.default);
$1b56c179e5783cdb$var$Select.OptGroup = (0, $hrhZj.default);
var $1b56c179e5783cdb$export$2e2bcd8739ae039 = $1b56c179e5783cdb$var$Select;


var $fSwVM = parcelRequire("fSwVM");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $4XkeF = parcelRequire("4XkeF");
var $64oV2 = parcelRequire("64oV2");

var $89kiB = parcelRequire("89kiB");

var $lLawD = parcelRequire("lLawD");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $dcbb6d0bd42650d6$export$2e2bcd8739ae039() {
    var _React$useReducer = $acw62.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $eUqlC.default)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    return forceUpdate;
}



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");
var $3aa4647e26f3ae33$export$74c1bf8296b1541f = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $3aa4647e26f3ae33$export$7d16f0c74495c67 = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1600px)'
};
var $3aa4647e26f3ae33$var$subscribers = new Map();
var $3aa4647e26f3ae33$var$subUid = -1;
var $3aa4647e26f3ae33$var$screens = {};
var $3aa4647e26f3ae33$var$responsiveObserve = {
    matchHandlers: {},
    dispatch: function dispatch(pointMap) {
        $3aa4647e26f3ae33$var$screens = pointMap;
        $3aa4647e26f3ae33$var$subscribers.forEach(function(func) {
            return func($3aa4647e26f3ae33$var$screens);
        });
        return $3aa4647e26f3ae33$var$subscribers.size >= 1;
    },
    subscribe: function subscribe(func) {
        if (!$3aa4647e26f3ae33$var$subscribers.size) this.register();
        $3aa4647e26f3ae33$var$subUid += 1;
        $3aa4647e26f3ae33$var$subscribers.set($3aa4647e26f3ae33$var$subUid, func);
        func($3aa4647e26f3ae33$var$screens);
        return $3aa4647e26f3ae33$var$subUid;
    },
    unsubscribe: function unsubscribe(token) {
        $3aa4647e26f3ae33$var$subscribers["delete"](token);
        if (!$3aa4647e26f3ae33$var$subscribers.size) this.unregister();
    },
    unregister: function unregister() {
        var _this = this;
        Object.keys($3aa4647e26f3ae33$export$7d16f0c74495c67).forEach(function(screen) {
            var matchMediaQuery = $3aa4647e26f3ae33$export$7d16f0c74495c67[screen];
            var handler = _this.matchHandlers[matchMediaQuery];
            handler === null || handler === void 0 || handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        $3aa4647e26f3ae33$var$subscribers.clear();
    },
    register: function register() {
        var _this2 = this;
        Object.keys($3aa4647e26f3ae33$export$7d16f0c74495c67).forEach(function(screen) {
            var matchMediaQuery = $3aa4647e26f3ae33$export$7d16f0c74495c67[screen];
            var listener = function listener(_ref) {
                var matches = _ref.matches;
                _this2.dispatch((0, $8nd05.default)((0, $8nd05.default)({}, $3aa4647e26f3ae33$var$screens), (0, $kSlfw.default)({}, screen, matches)));
            };
            var mql = window.matchMedia(matchMediaQuery);
            mql.addListener(listener);
            _this2.matchHandlers[matchMediaQuery] = {
                mql: mql,
                listener: listener
            };
            listener(mql);
        });
    }
};
var $3aa4647e26f3ae33$export$2e2bcd8739ae039 = $3aa4647e26f3ae33$var$responsiveObserve;


function $b8c04e47cb65d6a9$var$useBreakpoint() {
    var refreshOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var screensRef = (0, $acw62.useRef)({});
    var forceUpdate = (0, $dcbb6d0bd42650d6$export$2e2bcd8739ae039)();
    (0, $acw62.useEffect)(function() {
        var token = (0, $3aa4647e26f3ae33$export$2e2bcd8739ae039).subscribe(function(supportScreens) {
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return function() {
            return (0, $3aa4647e26f3ae33$export$2e2bcd8739ae039).unsubscribe(token);
        };
    }, []);
    return screensRef.current;
}
var $b8c04e47cb65d6a9$export$2e2bcd8739ae039 = $b8c04e47cb65d6a9$var$useBreakpoint;



var $c7d8dfeaf08e9faa$export$2e2bcd8739ae039 = (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039);



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $50e767e4968fb94a$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $50e767e4968fb94a$export$2e2bcd8739ae039 = $50e767e4968fb94a$var$DoubleLeftOutlined;



var $52bbcff7c992f863$var$DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $50e767e4968fb94a$export$2e2bcd8739ae039)
    }));
};
var $52bbcff7c992f863$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($52bbcff7c992f863$var$DoubleLeftOutlined);
var $52bbcff7c992f863$export$2e2bcd8739ae039 = $52bbcff7c992f863$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $6ce95b223b6e0f50$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $6ce95b223b6e0f50$export$2e2bcd8739ae039 = $6ce95b223b6e0f50$var$DoubleRightOutlined;



var $ff2129e701f4f9ae$var$DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $6ce95b223b6e0f50$export$2e2bcd8739ae039)
    }));
};
var $ff2129e701f4f9ae$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ff2129e701f4f9ae$var$DoubleRightOutlined);
var $ff2129e701f4f9ae$export$2e2bcd8739ae039 = $ff2129e701f4f9ae$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $766a51baf3f136aa$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $766a51baf3f136aa$export$2e2bcd8739ae039 = $766a51baf3f136aa$var$LeftOutlined;



var $1fcda680496f4b4e$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $766a51baf3f136aa$export$2e2bcd8739ae039)
    }));
};
var $1fcda680496f4b4e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1fcda680496f4b4e$var$LeftOutlined);
var $1fcda680496f4b4e$export$2e2bcd8739ae039 = $1fcda680496f4b4e$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $73624b371df38195$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $73624b371df38195$export$2e2bcd8739ae039 = $73624b371df38195$var$RightOutlined;



var $e2b36e2640287638$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $73624b371df38195$export$2e2bcd8739ae039)
    }));
};
var $e2b36e2640287638$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($e2b36e2640287638$var$RightOutlined);
var $e2b36e2640287638$export$2e2bcd8739ae039 = $e2b36e2640287638$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("kERhB");
var $2Hl7n = parcelRequire("2Hl7n");


var $acw62 = parcelRequire("acw62");




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $4a2c5bf3f536e529$export$40e3292f13ea8c60 = function MiniSelect(props) {
    return /*#__PURE__*/ $acw62.createElement((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        size: "small"
    }));
};
var $4a2c5bf3f536e529$export$c1344b3dabe19d01 = function MiddleSelect(props) {
    return /*#__PURE__*/ $acw62.createElement((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        size: "middle"
    }));
};
$4a2c5bf3f536e529$export$40e3292f13ea8c60.Option = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option;
$4a2c5bf3f536e529$export$c1344b3dabe19d01.Option = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option;


var $41bb1cf6e4b63275$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $41bb1cf6e4b63275$var$Pagination = function Pagination(_a) {
    var customizePrefixCls = _a.prefixCls, customizeSelectPrefixCls = _a.selectPrefixCls, className = _a.className, size = _a.size, customLocale = _a.locale, selectComponentClass = _a.selectComponentClass, responsive = _a.responsive, showSizeChanger = _a.showSizeChanger, restProps = $41bb1cf6e4b63275$var$__rest(_a, [
        "prefixCls",
        "selectPrefixCls",
        "className",
        "size",
        "locale",
        "selectComponentClass",
        "responsive",
        "showSizeChanger"
    ]);
    var _useBreakpoint = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(responsive), xs = _useBreakpoint.xs;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, _React$useContext$pag = _React$useContext.pagination, pagination = _React$useContext$pag === void 0 ? {} : _React$useContext$pag;
    var prefixCls = getPrefixCls('pagination', customizePrefixCls);
    var mergedShowSizeChanger = showSizeChanger !== null && showSizeChanger !== void 0 ? showSizeChanger : pagination.showSizeChanger;
    var getIconsProps = function getIconsProps() {
        var ellipsis = /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-item-ellipsis")
        }, "\u2022\u2022\u2022");
        var prevIcon = /*#__PURE__*/ $acw62.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, /*#__PURE__*/ $acw62.createElement((0, $1fcda680496f4b4e$export$2e2bcd8739ae039), null));
        var nextIcon = /*#__PURE__*/ $acw62.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, /*#__PURE__*/ $acw62.createElement((0, $e2b36e2640287638$export$2e2bcd8739ae039), null));
        var jumpPrevIcon = /*#__PURE__*/ $acw62.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, /*#__PURE__*/ $acw62.createElement((0, $52bbcff7c992f863$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        var jumpNextIcon = /*#__PURE__*/ $acw62.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, /*#__PURE__*/ $acw62.createElement((0, $ff2129e701f4f9ae$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        // change arrows direction in right-to-left direction
        if (direction === 'rtl') {
            var _ref = [
                nextIcon,
                prevIcon
            ];
            prevIcon = _ref[0];
            nextIcon = _ref[1];
            var _ref2 = [
                jumpNextIcon,
                jumpPrevIcon
            ];
            jumpPrevIcon = _ref2[0];
            jumpNextIcon = _ref2[1];
        }
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    };
    return /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), {
        componentName: "Pagination",
        defaultLocale: (0, $864f21d08855a737$export$2e2bcd8739ae039)
    }, function(contextLocale) {
        var locale = (0, $8nd05.default)((0, $8nd05.default)({}, contextLocale), customLocale);
        var isSmall = size === 'small' || !!(xs && !size && responsive);
        var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        var extendedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-mini"), isSmall), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
        return /*#__PURE__*/ $acw62.createElement((0, $2Hl7n.default), (0, $8nd05.default)({}, getIconsProps(), restProps, {
            prefixCls: prefixCls,
            selectPrefixCls: selectPrefixCls,
            className: extendedClassName,
            selectComponentClass: selectComponentClass || (isSmall ? (0, $4a2c5bf3f536e529$export$40e3292f13ea8c60) : (0, $4a2c5bf3f536e529$export$c1344b3dabe19d01)),
            locale: locale,
            showSizeChanger: mergedShowSizeChanger
        }));
    });
};
var $41bb1cf6e4b63275$export$2e2bcd8739ae039 = $41bb1cf6e4b63275$var$Pagination;


var $457c0f7bc166788c$export$2e2bcd8739ae039 = (0, $41bb1cf6e4b63275$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $iI6LB = parcelRequire("iI6LB");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");



var $26f1cf19d4dd7058$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $26f1cf19d4dd7058$var$SpinSizes = (0, $1ee8868d1993c67b$export$65e3907585753458)('small', 'default', 'large');
// Render indicator
var $26f1cf19d4dd7058$var$defaultIndicator = null;
function $26f1cf19d4dd7058$var$renderIndicator(prefixCls, props) {
    var indicator = props.indicator;
    var dotClassName = "".concat(prefixCls, "-dot");
    // should not be render default indicator when indicator value is null
    if (indicator === null) return null;
    if ((0, $30796c32f374b477$export$a8257692ac88316c)(indicator)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(indicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(indicator.props.className, dotClassName)
    });
    if ((0, $30796c32f374b477$export$a8257692ac88316c)($26f1cf19d4dd7058$var$defaultIndicator)) return (0, $30796c32f374b477$export$e530037191fcd5d7)($26f1cf19d4dd7058$var$defaultIndicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))($26f1cf19d4dd7058$var$defaultIndicator.props.className, dotClassName)
    });
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dotClassName, "".concat(prefixCls, "-dot-spin"))
    }, /*#__PURE__*/ $acw62.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $acw62.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $acw62.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $acw62.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }));
}
function $26f1cf19d4dd7058$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
}
var $26f1cf19d4dd7058$var$Spin = function Spin(props) {
    var prefixCls = props.spinPrefixCls, _props$spinning = props.spinning, customSpinning = _props$spinning === void 0 ? true : _props$spinning, delay = props.delay, className = props.className, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size, tip = props.tip, wrapperClassName = props.wrapperClassName, style = props.style, children = props.children, restProps = $26f1cf19d4dd7058$var$__rest(props, [
        "spinPrefixCls",
        "spinning",
        "delay",
        "className",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children"
    ]);
    var _React$useState = $acw62.useState(function() {
        return customSpinning && !$26f1cf19d4dd7058$var$shouldDelay(customSpinning, delay);
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), spinning = _React$useState2[0], setSpinning = _React$useState2[1];
    $acw62.useEffect(function() {
        var updateSpinning = (0, (/*@__PURE__*/$parcel$interopDefault($iI6LB)))(function() {
            setSpinning(customSpinning);
        }, delay);
        updateSpinning();
        return function() {
            var _a;
            (_a = updateSpinning === null || updateSpinning === void 0 ? void 0 : updateSpinning.cancel) === null || _a === void 0 || _a.call(updateSpinning);
        };
    }, [
        delay,
        customSpinning
    ]);
    var isNestedPattern = function isNestedPattern() {
        return typeof children !== 'undefined';
    };
    var renderSpin = function renderSpin(_ref) {
        var direction = _ref.direction;
        var spinClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-spinning"), spinning), "".concat(prefixCls, "-show-text"), !!tip), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
        // fix https://fb.me/react-unknown-prop
        var divProps = (0, $1pcHX.default)(restProps, [
            'indicator',
            'prefixCls'
        ]);
        var spinElement = /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, divProps, {
            style: style,
            className: spinClassName,
            "aria-live": "polite",
            "aria-busy": spinning
        }), $26f1cf19d4dd7058$var$renderIndicator(prefixCls, props), tip ? /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-text")
        }, tip) : null);
        if (isNestedPattern()) {
            var containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-container"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-blur"), spinning));
            return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, divProps, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-nested-loading"), wrapperClassName)
            }), spinning && /*#__PURE__*/ $acw62.createElement("div", {
                key: "loading"
            }, spinElement), /*#__PURE__*/ $acw62.createElement("div", {
                className: containerClassName,
                key: "container"
            }, children));
        }
        return spinElement;
    };
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), null, renderSpin);
};
var $26f1cf19d4dd7058$var$SpinFC = function SpinFC(props) {
    var customizePrefixCls = props.prefixCls;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var spinPrefixCls = getPrefixCls('spin', customizePrefixCls);
    var spinClassProps = (0, $8nd05.default)((0, $8nd05.default)({}, props), {
        spinPrefixCls: spinPrefixCls
    });
    return /*#__PURE__*/ $acw62.createElement($26f1cf19d4dd7058$var$Spin, (0, $8nd05.default)({}, spinClassProps));
};
$26f1cf19d4dd7058$var$SpinFC.setDefaultIndicator = function(indicator) {
    $26f1cf19d4dd7058$var$defaultIndicator = indicator;
};
var $26f1cf19d4dd7058$export$2e2bcd8739ae039 = $26f1cf19d4dd7058$var$SpinFC;



var $dTiBu = parcelRequire("dTiBu");
// eslint-disable-next-line import/prefer-default-export
function $a8ca81d24930dc06$export$24656b269d8df7d6(t, b, c, d) {
    var cc = c - b;
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // eslint-disable-next-line no-return-assign
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}


function $bf032ca2c6c444c9$export$5a096129d439f843(obj) {
    return obj !== null && obj !== undefined && obj === obj.window;
}
function $bf032ca2c6c444c9$export$2e2bcd8739ae039(target, top) {
    var _a, _b;
    if (typeof window === 'undefined') return 0;
    var method = top ? 'scrollTop' : 'scrollLeft';
    var result = 0;
    if ($bf032ca2c6c444c9$export$5a096129d439f843(target)) result = target[top ? 'pageYOffset' : 'pageXOffset'];
    else if (target instanceof Document) result = target.documentElement[method];
    else if (target instanceof HTMLElement) result = target[method];
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    result = target[method];
    if (target && !$bf032ca2c6c444c9$export$5a096129d439f843(target) && typeof result !== 'number') result = (_b = ((_a = target.ownerDocument) !== null && _a !== void 0 ? _a : target).documentElement) === null || _b === void 0 ? void 0 : _b[method];
    return result;
}


function $4262b79604674a3c$export$2e2bcd8739ae039(y) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$getContainer = options.getContainer, getContainer = _options$getContainer === void 0 ? function() {
        return window;
    } : _options$getContainer, callback = options.callback, _options$duration = options.duration, duration = _options$duration === void 0 ? 450 : _options$duration;
    var container = getContainer();
    var scrollTop = (0, $bf032ca2c6c444c9$export$2e2bcd8739ae039)(container, true);
    var startTime = Date.now();
    var frameFunc = function frameFunc() {
        var timestamp = Date.now();
        var time = timestamp - startTime;
        var nextScrollTop = (0, $a8ca81d24930dc06$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $bf032ca2c6c444c9$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === 'HTMLDocument') container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) (0, $dTiBu.default)(frameFunc);
        else if (typeof callback === 'function') callback();
    };
    (0, $dTiBu.default)(frameFunc);
}



/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $fad2a96b4c8bbab5$var$Column(_) {
    return null;
}
var $fad2a96b4c8bbab5$export$2e2bcd8739ae039 = $fad2a96b4c8bbab5$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $836a2b733f2d0243$var$ColumnGroup(_) {
    return null;
}
var $836a2b733f2d0243$export$2e2bcd8739ae039 = $836a2b733f2d0243$var$ColumnGroup;



var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
function $8f25299cf0da5780$var$renderExpandIcon(locale) {
    return function expandIcon(_ref) {
        var prefixCls = _ref.prefixCls, onExpand = _ref.onExpand, record = _ref.record, expanded = _ref.expanded, expandable = _ref.expandable;
        var iconPrefix = "".concat(prefixCls, "-row-expand-icon");
        return /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            onClick: function onClick(e) {
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(iconPrefix, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(iconPrefix, "-spaced"), !expandable), "".concat(iconPrefix, "-expanded"), expandable && expanded), "".concat(iconPrefix, "-collapsed"), expandable && !expanded)),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $8f25299cf0da5780$export$2e2bcd8739ae039 = $8f25299cf0da5780$var$renderExpandIcon;



var $eUqlC = parcelRequire("eUqlC");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

function $10b8a922ada6c9c1$export$480219a02f196e72(column, defaultKey) {
    if ('key' in column && column.key !== undefined && column.key !== null) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
    return defaultKey;
}
function $10b8a922ada6c9c1$export$7e4db04adce9b4db(index, pos) {
    return pos ? "".concat(pos, "-").concat(index) : "".concat(index);
}
function $10b8a922ada6c9c1$export$cfda450db2088de7(title, props) {
    if (typeof title === 'function') return title(props);
    return title;
}
function $10b8a922ada6c9c1$export$1c24e0676a106839(title, props) {
    var res = $10b8a922ada6c9c1$export$cfda450db2088de7(title, props);
    if (Object.prototype.toString.call(res) === '[object Object]') return '';
    return res;
}



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5dc9c75e7259b2a6$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
var $5dc9c75e7259b2a6$export$2e2bcd8739ae039 = $5dc9c75e7259b2a6$var$FilterFilled;



var $65f5300600a63436$var$FilterFilled = function FilterFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $5dc9c75e7259b2a6$export$2e2bcd8739ae039)
    }));
};
var $65f5300600a63436$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($65f5300600a63436$var$FilterFilled);
var $65f5300600a63436$export$2e2bcd8739ae039 = $65f5300600a63436$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $4UXHD = parcelRequire("4UXHD");

var $acw62 = parcelRequire("acw62");



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $fAiwY = parcelRequire("fAiwY");

var $acw62 = parcelRequire("acw62");




var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");


var $727f72b27c7ab10d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $727f72b27c7ab10d$export$f9c6924e160136d1 = /*#__PURE__*/ $acw62.createContext(null);
var $727f72b27c7ab10d$var$InternalCheckboxGroup = function InternalCheckboxGroup(_a, ref) {
    var defaultValue = _a.defaultValue, children = _a.children, _a$options = _a.options, options = _a$options === void 0 ? [] : _a$options, customizePrefixCls = _a.prefixCls, className = _a.className, style = _a.style, onChange = _a.onChange, restProps = $727f72b27c7ab10d$var$__rest(_a, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState = $acw62.useState(restProps.value || defaultValue || []), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState([]), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), registeredValues = _React$useState4[0], setRegisteredValues = _React$useState4[1];
    $acw62.useEffect(function() {
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    var getOptions = function getOptions() {
        return options.map(function(option) {
            if (typeof option === 'string' || typeof option === 'number') return {
                label: option,
                value: option
            };
            return option;
        });
    };
    var cancelValue = function cancelValue(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function registerValue(val) {
        setRegisteredValues(function(prevValues) {
            return [].concat((0, $kbxxf.default)(prevValues), [
                val
            ]);
        });
    };
    var toggleOption = function toggleOption(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0, $kbxxf.default)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        var opts = getOptions();
        onChange === null || onChange === void 0 || onChange(newValue.filter(function(val) {
            return registeredValues.includes(val);
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0, $1pcHX.default)(restProps, [
        'value',
        'disabled'
    ]);
    if (options && options.length > 0) children = getOptions().map(function(option) {
        return /*#__PURE__*/ $acw62.createElement((0, $04e12b22f131287e$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: "".concat(groupPrefixCls, "-item"),
            style: option.style
        }, option.label);
    });
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(groupPrefixCls, (0, $kSlfw.default)({}, "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: classString,
        style: style
    }, domProps, {
        ref: ref
    }), /*#__PURE__*/ $acw62.createElement($727f72b27c7ab10d$export$f9c6924e160136d1.Provider, {
        value: context
    }, children));
};
var $727f72b27c7ab10d$var$CheckboxGroup = /*#__PURE__*/ $acw62.forwardRef($727f72b27c7ab10d$var$InternalCheckboxGroup);
var $727f72b27c7ab10d$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($727f72b27c7ab10d$var$CheckboxGroup);



var $04e12b22f131287e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $04e12b22f131287e$var$InternalCheckbox = function InternalCheckbox(_a, ref) {
    var _b;
    var customizePrefixCls = _a.prefixCls, className = _a.className, children = _a.children, _a$indeterminate = _a.indeterminate, indeterminate = _a$indeterminate === void 0 ? false : _a$indeterminate, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _a$skipGroup = _a.skipGroup, skipGroup = _a$skipGroup === void 0 ? false : _a$skipGroup, disabled = _a.disabled, restProps = $04e12b22f131287e$var$__rest(_a, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "disabled"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var checkboxGroup = $acw62.useContext((0, $727f72b27c7ab10d$export$f9c6924e160136d1));
    var _useContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed)), isFormItemInput = _useContext.isFormItemInput;
    var contextDisabled = (0, $acw62.useContext)((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    var mergedDisabled = (_b = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _b !== void 0 ? _b : contextDisabled;
    var prevValue = $acw62.useRef(restProps.value);
    $acw62.useEffect(function() {
        checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
    }, []);
    $acw62.useEffect(function() {
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        restProps.value
    ]);
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var checkboxProps = (0, $8nd05.default)({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            if (restProps.onChange) restProps.onChange.apply(restProps, arguments);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-wrapper"), true), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), "".concat(prefixCls, "-wrapper-disabled"), mergedDisabled), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    var checkboxClass = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    var ariaChecked = indeterminate ? 'mixed' : undefined;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $acw62.createElement("label", {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ $acw62.createElement((0, $fAiwY.default), (0, $8nd05.default)({
        "aria-checked": ariaChecked
    }, checkboxProps, {
        prefixCls: prefixCls,
        className: checkboxClass,
        disabled: mergedDisabled,
        ref: ref
    })), children !== undefined && /*#__PURE__*/ $acw62.createElement("span", null, children)));
};
var $04e12b22f131287e$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef($04e12b22f131287e$var$InternalCheckbox);
var $04e12b22f131287e$export$2e2bcd8739ae039 = $04e12b22f131287e$var$Checkbox;



var $da237ba92f78ed9a$var$Checkbox = (0, $04e12b22f131287e$export$2e2bcd8739ae039);
$da237ba92f78ed9a$var$Checkbox.Group = (0, $727f72b27c7ab10d$export$2e2bcd8739ae039);
$da237ba92f78ed9a$var$Checkbox.__ANT_CHECKBOX = true;
var $da237ba92f78ed9a$export$2e2bcd8739ae039 = $da237ba92f78ed9a$var$Checkbox;




var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");


var $8g1PZ = parcelRequire("8g1PZ");

var $jtXXN = parcelRequire("jtXXN");

var $a4gyP = parcelRequire("a4gyP");

var $iSQh8 = parcelRequire("iSQh8");

var $acw62 = parcelRequire("acw62");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $9715X = parcelRequire("9715X");

var $fhGLX = parcelRequire("fhGLX");

var $jDKKo = parcelRequire("jDKKo");

var $1gYAD = parcelRequire("1gYAD");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $bf122e88db242cab$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $bf122e88db242cab$export$2e2bcd8739ae039 = $bf122e88db242cab$var$EllipsisOutlined;



var $09defd2fd47a1b8f$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $bf122e88db242cab$export$2e2bcd8739ae039)
    }));
};
var $09defd2fd47a1b8f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($09defd2fd47a1b8f$var$EllipsisOutlined);
var $09defd2fd47a1b8f$export$2e2bcd8739ae039 = $09defd2fd47a1b8f$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $feYPt = parcelRequire("feYPt");
var $9TcXG = parcelRequire("9TcXG");

var $a4gyP = parcelRequire("a4gyP");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");


var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b54d53674fa39ea0$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $b54d53674fa39ea0$export$2e2bcd8739ae039 = $b54d53674fa39ea0$var$BarsOutlined;



var $ef0dd5674d92d799$var$BarsOutlined = function BarsOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $b54d53674fa39ea0$export$2e2bcd8739ae039)
    }));
};
var $ef0dd5674d92d799$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ef0dd5674d92d799$var$BarsOutlined);
var $ef0dd5674d92d799$export$2e2bcd8739ae039 = $ef0dd5674d92d799$var$RefIcon;





var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");

var $b951a1015ade6f8d$var$isNumeric = function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
var $b951a1015ade6f8d$export$2e2bcd8739ae039 = $b951a1015ade6f8d$var$isNumeric;



var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $ea0a526399f02a88$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ea0a526399f02a88$export$964282a2c3979546 = /*#__PURE__*/ $acw62.createContext({
    siderHook: {
        addSider: function addSider() {
            return null;
        },
        removeSider: function removeSider() {
            return null;
        }
    }
});
function $ea0a526399f02a88$var$generator(_ref) {
    var suffixCls = _ref.suffixCls, tagName = _ref.tagName, displayName = _ref.displayName;
    return function(BasicComponent) {
        var Adapter = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
            var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
            var customizePrefixCls = props.prefixCls;
            var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
            return /*#__PURE__*/ $acw62.createElement(BasicComponent, (0, $8nd05.default)({
                ref: ref,
                prefixCls: prefixCls,
                tagName: tagName
            }, props));
        });
        return Adapter;
    };
}
var $ea0a526399f02a88$var$Basic = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, children = props.children, tagName = props.tagName, others = $ea0a526399f02a88$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "tagName"
    ]);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className);
    return /*#__PURE__*/ $acw62.createElement(tagName, (0, $8nd05.default)((0, $8nd05.default)({
        className: classString
    }, others), {
        ref: ref
    }), children);
});
var $ea0a526399f02a88$var$BasicLayout = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _React$useContext2 = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), direction = _React$useContext2.direction;
    var _React$useState = $acw62.useState([]), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), siders = _React$useState2[0], setSiders = _React$useState2[1];
    var prefixCls = props.prefixCls, className = props.className, children = props.children, hasSider = props.hasSider, Tag = props.tagName, others = $ea0a526399f02a88$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "hasSider",
        "tagName"
    ]);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : siders.length > 0), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var contextValue = $acw62.useMemo(function() {
        return {
            siderHook: {
                addSider: function addSider(id) {
                    setSiders(function(prev) {
                        return [].concat((0, $kbxxf.default)(prev), [
                            id
                        ]);
                    });
                },
                removeSider: function removeSider(id) {
                    setSiders(function(prev) {
                        return prev.filter(function(currentId) {
                            return currentId !== id;
                        });
                    });
                }
            }
        };
    }, []);
    return /*#__PURE__*/ $acw62.createElement($ea0a526399f02a88$export$964282a2c3979546.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement(Tag, (0, $8nd05.default)({
        ref: ref,
        className: classString
    }, others), children));
});
var $ea0a526399f02a88$var$Layout = $ea0a526399f02a88$var$generator({
    suffixCls: 'layout',
    tagName: 'section',
    displayName: 'Layout'
})($ea0a526399f02a88$var$BasicLayout);
var $ea0a526399f02a88$export$8b251419efc915eb = $ea0a526399f02a88$var$generator({
    suffixCls: 'layout-header',
    tagName: 'header',
    displayName: 'Header'
})($ea0a526399f02a88$var$Basic);
var $ea0a526399f02a88$export$a06f1c675e846f6f = $ea0a526399f02a88$var$generator({
    suffixCls: 'layout-footer',
    tagName: 'footer',
    displayName: 'Footer'
})($ea0a526399f02a88$var$Basic);
var $ea0a526399f02a88$export$7c6e2c02157bb7d2 = $ea0a526399f02a88$var$generator({
    suffixCls: 'layout-content',
    tagName: 'main',
    displayName: 'Content'
})($ea0a526399f02a88$var$Basic);
var $ea0a526399f02a88$export$2e2bcd8739ae039 = $ea0a526399f02a88$var$Layout;


var $f4e67dbf2453f541$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f4e67dbf2453f541$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
var $f4e67dbf2453f541$export$63554aebd2a6d54c = /*#__PURE__*/ $acw62.createContext({});
var $f4e67dbf2453f541$var$generateId = function() {
    var i = 0;
    return function() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        i += 1;
        return "".concat(prefix).concat(i);
    };
}();
var $f4e67dbf2453f541$var$Sider = /*#__PURE__*/ $acw62.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, trigger = _a.trigger, children = _a.children, _a$defaultCollapsed = _a.defaultCollapsed, defaultCollapsed = _a$defaultCollapsed === void 0 ? false : _a$defaultCollapsed, _a$theme = _a.theme, theme = _a$theme === void 0 ? 'dark' : _a$theme, _a$style = _a.style, style = _a$style === void 0 ? {} : _a$style, _a$collapsible = _a.collapsible, collapsible = _a$collapsible === void 0 ? false : _a$collapsible, _a$reverseArrow = _a.reverseArrow, reverseArrow = _a$reverseArrow === void 0 ? false : _a$reverseArrow, _a$width = _a.width, width = _a$width === void 0 ? 200 : _a$width, _a$collapsedWidth = _a.collapsedWidth, collapsedWidth = _a$collapsedWidth === void 0 ? 80 : _a$collapsedWidth, zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle, breakpoint = _a.breakpoint, onCollapse = _a.onCollapse, onBreakpoint = _a.onBreakpoint, props = $f4e67dbf2453f541$var$__rest(_a, [
        "prefixCls",
        "className",
        "trigger",
        "children",
        "defaultCollapsed",
        "theme",
        "style",
        "collapsible",
        "reverseArrow",
        "width",
        "collapsedWidth",
        "zeroWidthTriggerStyle",
        "breakpoint",
        "onCollapse",
        "onBreakpoint"
    ]);
    var _useContext = (0, $acw62.useContext)((0, $ea0a526399f02a88$export$964282a2c3979546)), siderHook = _useContext.siderHook;
    var _useState = (0, $acw62.useState)('collapsed' in props ? props.collapsed : defaultCollapsed), _useState2 = (0, $eUqlC.default)(_useState, 2), collapsed = _useState2[0], setCollapsed = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $eUqlC.default)(_useState3, 2), below = _useState4[0], setBelow = _useState4[1];
    (0, $acw62.useEffect)(function() {
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    var handleSetCollapsed = function handleSetCollapsed(value, type) {
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse === null || onCollapse === void 0 || onCollapse(value, type);
    };
    // ========================= Responsive =========================
    var responsiveHandlerRef = (0, $acw62.useRef)();
    responsiveHandlerRef.current = function(mql) {
        setBelow(mql.matches);
        onBreakpoint === null || onBreakpoint === void 0 || onBreakpoint(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $acw62.useEffect)(function() {
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current(mql);
        }
        var mql;
        if (typeof window !== 'undefined') {
            var _window = window, matchMedia = _window.matchMedia;
            if (matchMedia && breakpoint && breakpoint in $f4e67dbf2453f541$var$dimensionMaxMap) {
                mql = matchMedia("(max-width: ".concat($f4e67dbf2453f541$var$dimensionMaxMap[breakpoint], ")"));
                try {
                    mql.addEventListener('change', responsiveHandler);
                } catch (error) {
                    mql.addListener(responsiveHandler);
                }
                responsiveHandler(mql);
            }
        }
        return function() {
            try {
                mql === null || mql === void 0 || mql.removeEventListener('change', responsiveHandler);
            } catch (error) {
                mql === null || mql === void 0 || mql.removeListener(responsiveHandler);
            }
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $acw62.useEffect)(function() {
        var uniqueId = $f4e67dbf2453f541$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return function() {
            return siderHook.removeSider(uniqueId);
        };
    }, []);
    var toggle = function toggle() {
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    var _useContext2 = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext2.getPrefixCls;
    var renderSider = function renderSider() {
        var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
        var divProps = (0, $1pcHX.default)(props, [
            'collapsed'
        ]);
        var rawWidth = collapsed ? collapsedWidth : width;
        // use "px" as fallback unit for width
        var siderWidth = (0, $b951a1015ade6f8d$export$2e2bcd8739ae039)(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth);
        // special trigger when collapsedWidth == 0
        var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $acw62.createElement("span", {
            onClick: toggle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-zero-width-trigger"), "".concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left')),
            style: zeroWidthTriggerStyle
        }, trigger || /*#__PURE__*/ $acw62.createElement((0, $ef0dd5674d92d799$export$2e2bcd8739ae039), null)) : null;
        var iconObj = {
            expanded: reverseArrow ? /*#__PURE__*/ $acw62.createElement((0, $e2b36e2640287638$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $1fcda680496f4b4e$export$2e2bcd8739ae039), null),
            collapsed: reverseArrow ? /*#__PURE__*/ $acw62.createElement((0, $1fcda680496f4b4e$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $e2b36e2640287638$export$2e2bcd8739ae039), null)
        };
        var status = collapsed ? 'collapsed' : 'expanded';
        var defaultTrigger = iconObj[status];
        var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-trigger"),
            onClick: toggle,
            style: {
                width: siderWidth
            }
        }, trigger || defaultTrigger) : null;
        var divStyle = (0, $8nd05.default)((0, $8nd05.default)({}, style), {
            flex: "0 0 ".concat(siderWidth),
            maxWidth: siderWidth,
            minWidth: siderWidth,
            width: siderWidth
        });
        var siderCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-").concat(theme), (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-collapsed"), !!collapsed), "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), "".concat(prefixCls, "-below"), !!below), "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), className);
        return /*#__PURE__*/ $acw62.createElement("aside", (0, $8nd05.default)({
            className: siderCls
        }, divProps, {
            style: divStyle,
            ref: ref
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-children")
        }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null);
    };
    var contextValue = $acw62.useMemo(function() {
        return {
            siderCollapsed: collapsed
        };
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ $acw62.createElement($f4e67dbf2453f541$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, renderSider());
});
var $f4e67dbf2453f541$export$2e2bcd8739ae039 = $f4e67dbf2453f541$var$Sider;






var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");
parcelRequire("feYPt");
var $9TcXG = parcelRequire("9TcXG");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("feYPt");
var $iPQJN = parcelRequire("iPQJN");

var $acw62 = parcelRequire("acw62");

var $d26f09d6992ff5d8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d26f09d6992ff5d8$var$MenuDivider = function MenuDivider(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, dashed = _a.dashed, restProps = $d26f09d6992ff5d8$var$__rest(_a, [
        "prefixCls",
        "className",
        "dashed"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('menu', customizePrefixCls);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-item-divider-dashed"), !!dashed), className);
    return /*#__PURE__*/ $acw62.createElement((0, $iPQJN.default), (0, $8nd05.default)({
        className: classString
    }, restProps));
};
var $d26f09d6992ff5d8$export$2e2bcd8739ae039 = $d26f09d6992ff5d8$var$MenuDivider;



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $9715X = parcelRequire("9715X");

var $fhGLX = parcelRequire("fhGLX");

var $jDKKo = parcelRequire("jDKKo");

var $1gYAD = parcelRequire("1gYAD");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("feYPt");
var $gXR8t = parcelRequire("gXR8t");

var $jWR62 = parcelRequire("jWR62");

var $acw62 = parcelRequire("acw62");


var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $hRA8u = parcelRequire("hRA8u");

var $iSQh8 = parcelRequire("iSQh8");

var $acw62 = parcelRequire("acw62");


var $1513ceb924eda9b6$export$bb684163c94c55ae = (0, $1ee8868d1993c67b$export$65e3907585753458)('success', 'processing', 'error', 'default', 'warning');
var $1513ceb924eda9b6$export$37ea70cc324d3d0e = (0, $1ee8868d1993c67b$export$65e3907585753458)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');




var $8nd05 = parcelRequire("8nd05");

var $9jtir = parcelRequire("9jtir");
var $aa2151c32cec40fb$var$autoAdjustOverflowEnabled = {
    adjustX: 1,
    adjustY: 1
};
var $aa2151c32cec40fb$var$autoAdjustOverflowDisabled = {
    adjustX: 0,
    adjustY: 0
};
var $aa2151c32cec40fb$var$targetOffset = [
    0,
    0
];
function $aa2151c32cec40fb$export$fde75e5b410c093f(autoAdjustOverflow) {
    if (typeof autoAdjustOverflow === 'boolean') return autoAdjustOverflow ? $aa2151c32cec40fb$var$autoAdjustOverflowEnabled : $aa2151c32cec40fb$var$autoAdjustOverflowDisabled;
    return (0, $8nd05.default)((0, $8nd05.default)({}, $aa2151c32cec40fb$var$autoAdjustOverflowDisabled), autoAdjustOverflow);
}
function $aa2151c32cec40fb$export$2e2bcd8739ae039(config) {
    var _config$arrowWidth = config.arrowWidth, arrowWidth = _config$arrowWidth === void 0 ? 4 : _config$arrowWidth, _config$horizontalArr = config.horizontalArrowShift, horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr, _config$verticalArrow = config.verticalArrowShift, verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow, autoAdjustOverflow = config.autoAdjustOverflow, arrowPointAtCenter = config.arrowPointAtCenter;
    var placementMap = {
        left: {
            points: [
                'cr',
                'cl'
            ],
            offset: [
                -4,
                0
            ]
        },
        right: {
            points: [
                'cl',
                'cr'
            ],
            offset: [
                4,
                0
            ]
        },
        top: {
            points: [
                'bc',
                'tc'
            ],
            offset: [
                0,
                -4
            ]
        },
        bottom: {
            points: [
                'tc',
                'bc'
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            points: [
                'bl',
                'tc'
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                -4
            ]
        },
        leftTop: {
            points: [
                'tr',
                'cl'
            ],
            offset: [
                -4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        topRight: {
            points: [
                'br',
                'tc'
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                -4
            ]
        },
        rightTop: {
            points: [
                'tl',
                'cr'
            ],
            offset: [
                4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        bottomRight: {
            points: [
                'tr',
                'bc'
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                4
            ]
        },
        rightBottom: {
            points: [
                'bl',
                'cr'
            ],
            offset: [
                4,
                verticalArrowShift + arrowWidth
            ]
        },
        bottomLeft: {
            points: [
                'tl',
                'bc'
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                4
            ]
        },
        leftBottom: {
            points: [
                'br',
                'cl'
            ],
            offset: [
                -4,
                verticalArrowShift + arrowWidth
            ]
        }
    };
    Object.keys(placementMap).forEach(function(key) {
        placementMap[key] = arrowPointAtCenter ? (0, $8nd05.default)((0, $8nd05.default)({}, placementMap[key]), {
            overflow: $aa2151c32cec40fb$export$fde75e5b410c093f(autoAdjustOverflow),
            targetOffset: $aa2151c32cec40fb$var$targetOffset
        }) : (0, $8nd05.default)((0, $8nd05.default)({}, (0, $9jtir.placements)[key]), {
            overflow: $aa2151c32cec40fb$export$fde75e5b410c093f(autoAdjustOverflow)
        });
        placementMap[key].ignoreShake = true;
    });
    return placementMap;
}




var $0ac88bf86814a6e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0ac88bf86814a6e5$var$splitObject = function splitObject(obj, keys) {
    var picked = {};
    var omitted = (0, $8nd05.default)({}, obj);
    keys.forEach(function(key) {
        if (obj && key in obj) {
            picked[key] = obj[key];
            delete omitted[key];
        }
    });
    return {
        picked: picked,
        omitted: omitted
    };
};
var $0ac88bf86814a6e5$var$PresetColorRegex = new RegExp("^(".concat((0, $1513ceb924eda9b6$export$37ea70cc324d3d0e).join('|'), ")(-inverse)?$"));
// Fix Tooltip won't hide at disabled button
// mouse events don't trigger at disabled button in Chrome
// https://github.com/react-component/tooltip/issues/18
function $0ac88bf86814a6e5$var$getDisabledCompatibleChildren(element, prefixCls) {
    var elementType = element.type;
    if ((elementType.__ANT_BUTTON === true || element.type === 'button') && element.props.disabled || elementType.__ANT_SWITCH === true && (element.props.disabled || element.props.loading) || elementType.__ANT_RADIO === true && element.props.disabled) {
        // Pick some layout related style properties up to span
        // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
        var _splitObject = $0ac88bf86814a6e5$var$splitObject(element.props.style, [
            'position',
            'left',
            'right',
            'top',
            'bottom',
            'float',
            'display',
            'zIndex'
        ]), picked = _splitObject.picked, omitted = _splitObject.omitted;
        var spanStyle = (0, $8nd05.default)((0, $8nd05.default)({
            display: 'inline-block'
        }, picked), {
            cursor: 'not-allowed',
            width: element.props.block ? '100%' : undefined
        });
        var buttonStyle = (0, $8nd05.default)((0, $8nd05.default)({}, omitted), {
            pointerEvents: 'none'
        });
        var child = (0, $30796c32f374b477$export$e530037191fcd5d7)(element, {
            style: buttonStyle,
            className: null
        });
        return /*#__PURE__*/ $acw62.createElement("span", {
            style: spanStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(element.props.className, "".concat(prefixCls, "-disabled-compatible-wrapper"))
        }, child);
    }
    return element;
}
var $0ac88bf86814a6e5$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _useMergedState = (0, $iSQh8.default)(false, {
        value: props.open !== undefined ? props.open : props.visible,
        defaultValue: props.defaultOpen !== undefined ? props.defaultOpen : props.defaultVisible
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), open = _useMergedState2[0], setOpen = _useMergedState2[1];
    var isNoTitle = function isNoTitle() {
        var title = props.title, overlay = props.overlay;
        return !title && !overlay && title !== 0; // overlay for old version compatibility
    };
    var onOpenChange = function onOpenChange(vis) {
        var _a, _b;
        setOpen(isNoTitle() ? false : vis);
        if (!isNoTitle()) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    var getTooltipPlacements = function getTooltipPlacements() {
        var builtinPlacements = props.builtinPlacements, _props$arrowPointAtCe = props.arrowPointAtCenter, arrowPointAtCenter = _props$arrowPointAtCe === void 0 ? false : _props$arrowPointAtCe, _props$autoAdjustOver = props.autoAdjustOverflow, autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver;
        return builtinPlacements || (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
            arrowPointAtCenter: arrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow
        });
    };
    // 动态设置动画点
    var onPopupAlign = function onPopupAlign(domNode, align) {
        var placements = getTooltipPlacements();
        // 当前返回的位置
        var placement = Object.keys(placements).find(function(key) {
            var _a, _b;
            return placements[key].points[0] === ((_a = align.points) === null || _a === void 0 ? void 0 : _a[0]) && placements[key].points[1] === ((_b = align.points) === null || _b === void 0 ? void 0 : _b[1]);
        });
        if (!placement) return;
        // 根据当前坐标设置动画点
        var rect = domNode.getBoundingClientRect();
        var transformOrigin = {
            top: '50%',
            left: '50%'
        };
        if (/top|Bottom/.test(placement)) transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
        else if (/Top|bottom/.test(placement)) transformOrigin.top = "".concat(-align.offset[1], "px");
        if (/left|Right/.test(placement)) transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
        else if (/right|Left/.test(placement)) transformOrigin.left = "".concat(-align.offset[0], "px");
        domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };
    var getOverlay = function getOverlay() {
        var title = props.title, overlay = props.overlay;
        if (title === 0) return title;
        return overlay || title || '';
    };
    var getPopupContainer = props.getPopupContainer, _props$placement = props.placement, placement = _props$placement === void 0 ? 'top' : _props$placement, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.1 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, otherProps = $0ac88bf86814a6e5$var$__rest(props, [
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay"
    ]);
    var customizePrefixCls = props.prefixCls, openClassName = props.openClassName, getTooltipContainer = props.getTooltipContainer, overlayClassName = props.overlayClassName, color = props.color, overlayInnerStyle = props.overlayInnerStyle, children = props.children;
    var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && !('visible' in props) && isNoTitle()) tempOpen = false;
    var child = $0ac88bf86814a6e5$var$getDisabledCompatibleChildren((0, $30796c32f374b477$export$a8257692ac88316c)(children) && !(0, $30796c32f374b477$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $acw62.createElement("span", null, children), prefixCls);
    var childProps = child.props;
    var childCls = !childProps.className || typeof childProps.className === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(childProps.className, (0, $kSlfw.default)({}, openClassName || "".concat(prefixCls, "-open"), true)) : childProps.className;
    var customOverlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(color), color && $0ac88bf86814a6e5$var$PresetColorRegex.test(color)));
    var formattedOverlayInnerStyle = overlayInnerStyle;
    var arrowContentStyle = {};
    if (color && !$0ac88bf86814a6e5$var$PresetColorRegex.test(color)) {
        formattedOverlayInnerStyle = (0, $8nd05.default)((0, $8nd05.default)({}, overlayInnerStyle), {
            background: color
        });
        // @ts-ignore
        arrowContentStyle = {
            '--antd-arrow-background-color': color
        };
    }
    return /*#__PURE__*/ $acw62.createElement((0, $hRA8u.default), (0, $8nd05.default)({}, otherProps, {
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        overlayClassName: customOverlayClassName,
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: ref,
        builtinPlacements: getTooltipPlacements(),
        overlay: getOverlay(),
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        onPopupAlign: onPopupAlign,
        overlayInnerStyle: formattedOverlayInnerStyle,
        arrowContent: /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-arrow-content"),
            style: arrowContentStyle
        }),
        motion: {
            motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', props.transitionName),
            motionDeadline: 1000
        }
    }), tempOpen ? (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
});
var $0ac88bf86814a6e5$export$2e2bcd8739ae039 = $0ac88bf86814a6e5$var$Tooltip;




var $acw62 = parcelRequire("acw62");
var $f1be9e89e34926b1$var$MenuContext = /*#__PURE__*/ (0, $acw62.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false
});
var $f1be9e89e34926b1$export$2e2bcd8739ae039 = $f1be9e89e34926b1$var$MenuContext;


function $8955a62aec0d8484$var$_callSuper(t, o, e) {
    return o = (0, $jDKKo.default)(o), (0, $9715X.default)(t, (0, $fhGLX.default)() ? Reflect.construct(o, e || [], (0, $jDKKo.default)(t).constructor) : o.apply(t, e));
}
var $8955a62aec0d8484$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8955a62aec0d8484$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(MenuItem, _React$Component);
    function MenuItem() {
        var _this;
        (0, $6CZeq.default)(this, MenuItem);
        _this = $8955a62aec0d8484$var$_callSuper(this, MenuItem, arguments);
        _this.renderItem = function(_ref) {
            var siderCollapsed = _ref.siderCollapsed;
            var _a;
            var _this$context = _this.context, prefixCls = _this$context.prefixCls, firstLevel = _this$context.firstLevel, inlineCollapsed = _this$context.inlineCollapsed, direction = _this$context.direction, disableMenuItemTitleTooltip = _this$context.disableMenuItemTitleTooltip;
            var _this$props = _this.props, className = _this$props.className, children = _this$props.children;
            var _b = _this.props, title = _b.title, icon = _b.icon, danger = _b.danger, rest = $8955a62aec0d8484$var$__rest(_b, [
                "title",
                "icon",
                "danger"
            ]);
            var tooltipTitle = title;
            if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
            else if (title === false) tooltipTitle = '';
            var tooltipProps = {
                title: tooltipTitle
            };
            if (!siderCollapsed && !inlineCollapsed) {
                tooltipProps.title = null;
                // Reset `open` to fix control mode tooltip display not correct
                // ref: https://github.com/ant-design/ant-design/issues/16742
                tooltipProps.open = false;
            }
            var childrenLength = (0, $jWR62.default)(children).length;
            var returnNode = /*#__PURE__*/ $acw62.createElement((0, $gXR8t.default), (0, $8nd05.default)({}, rest, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-item-danger"), danger), "".concat(prefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), className),
                title: typeof title === 'string' ? title : undefined
            }), (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $30796c32f374b477$export$a8257692ac88316c)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
            }), _this.renderItemChildren(inlineCollapsed));
            if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), (0, $8nd05.default)({}, tooltipProps, {
                placement: direction === 'rtl' ? 'left' : 'right',
                overlayClassName: "".concat(prefixCls, "-inline-collapsed-tooltip")
            }), returnNode);
            return returnNode;
        };
        return _this;
    }
    (0, $cHPF9.default)(MenuItem, [
        {
            key: "renderItemChildren",
            value: function renderItemChildren(inlineCollapsed) {
                var _this$context2 = this.context, prefixCls = _this$context2.prefixCls, firstLevel = _this$context2.firstLevel;
                var _this$props2 = this.props, icon = _this$props2.icon, children = _this$props2.children;
                var wrapNode = /*#__PURE__*/ $acw62.createElement("span", {
                    className: "".concat(prefixCls, "-title-content")
                }, children);
                // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
                // ref: https://github.com/ant-design/ant-design/pull/23456
                if (!icon || (0, $30796c32f374b477$export$a8257692ac88316c)(children) && children.type === 'span') {
                    if (children && inlineCollapsed && firstLevel && typeof children === 'string') return /*#__PURE__*/ $acw62.createElement("div", {
                        className: "".concat(prefixCls, "-inline-collapsed-noicon")
                    }, children.charAt(0));
                }
                return wrapNode;
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement((0, $f4e67dbf2453f541$export$63554aebd2a6d54c).Consumer, null, this.renderItem);
            }
        }
    ]);
    return MenuItem;
}($acw62.Component);
$8955a62aec0d8484$export$2e2bcd8739ae039.contextType = (0, $f1be9e89e34926b1$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("feYPt");
var $gASnm = parcelRequire("gASnm");
var $a8XZl = parcelRequire("a8XZl");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");


function $14bdbe2126091cad$var$SubMenu(props) {
    var _a;
    var popupClassName = props.popupClassName, icon = props.icon, title = props.title, theme = props.theme;
    var context = $acw62.useContext((0, $f1be9e89e34926b1$export$2e2bcd8739ae039));
    var prefixCls = context.prefixCls, inlineCollapsed = context.inlineCollapsed, antdMenuTheme = context.antdMenuTheme;
    var parentPath = (0, $a8XZl.useFullPath)();
    var titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-inline-collapsed-noicon")
    }, title.charAt(0)) : /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-title-content")
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        var titleIsSpan = (0, $30796c32f374b477$export$a8257692ac88316c)(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $30796c32f374b477$export$a8257692ac88316c)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
        }), titleIsSpan ? title : /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-title-content")
        }, title));
    }
    var contextValue = $acw62.useMemo(function() {
        return (0, $8nd05.default)((0, $8nd05.default)({}, context), {
            firstLevel: false
        });
    }, [
        context
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $f1be9e89e34926b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $gASnm.default), (0, $8nd05.default)({}, (0, $1pcHX.default)(props, [
        'icon'
    ]), {
        title: titleNode,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-").concat(theme || antdMenuTheme), popupClassName)
    })));
}
var $14bdbe2126091cad$export$2e2bcd8739ae039 = $14bdbe2126091cad$var$SubMenu;


var $74e6d83cfac16cf1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $74e6d83cfac16cf1$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && (0, $fSwVM.default)(opt) === 'object') {
            var _a = opt, label = _a.label, children = _a.children, key = _a.key, type = _a.type, restProps = $74e6d83cfac16cf1$var$__rest(_a, [
                "label",
                "children",
                "key",
                "type"
            ]);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $acw62.createElement((0, $9TcXG.default), (0, $8nd05.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $74e6d83cfac16cf1$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $acw62.createElement((0, $14bdbe2126091cad$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $74e6d83cfac16cf1$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $acw62.createElement((0, $d26f09d6992ff5d8$export$2e2bcd8739ae039), (0, $8nd05.default)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $acw62.createElement((0, $8955a62aec0d8484$export$2e2bcd8739ae039), (0, $8nd05.default)({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $74e6d83cfac16cf1$export$2e2bcd8739ae039(items) {
    return $acw62.useMemo(function() {
        if (!items) return items;
        return $74e6d83cfac16cf1$var$convertItemsToNodes(items);
    }, [
        items
    ]);
}






var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
var $798e9781cc841bf2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/** @internal Only used for Dropdown component. Do not use this in your production. */ var $798e9781cc841bf2$var$OverrideContext = /*#__PURE__*/ $acw62.createContext(null);
var $798e9781cc841bf2$export$9bd434816b0530d0 = function OverrideProvider(_a) {
    var children = _a.children, restProps = $798e9781cc841bf2$var$__rest(_a, [
        "children"
    ]);
    var override = $acw62.useContext($798e9781cc841bf2$var$OverrideContext);
    var context = $acw62.useMemo(function() {
        return (0, $8nd05.default)((0, $8nd05.default)({}, override), restProps);
    }, [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable
    ]);
    return /*#__PURE__*/ $acw62.createElement($798e9781cc841bf2$var$OverrideContext.Provider, {
        value: context
    }, children);
};
var $798e9781cc841bf2$export$2e2bcd8739ae039 = $798e9781cc841bf2$var$OverrideContext;



function $47077f34c49bbd52$var$_callSuper(t, o, e) {
    return o = (0, $jDKKo.default)(o), (0, $9715X.default)(t, (0, $fhGLX.default)() ? Reflect.construct(o, e || [], (0, $jDKKo.default)(t).constructor) : o.apply(t, e));
}
var $47077f34c49bbd52$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $47077f34c49bbd52$var$InternalMenu = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var _a;
    var override = $acw62.useContext((0, $798e9781cc841bf2$export$2e2bcd8739ae039)) || {};
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, getPopupContainer = _React$useContext.getPopupContainer, direction = _React$useContext.direction;
    var rootPrefixCls = getPrefixCls();
    var customizePrefixCls = props.prefixCls, className = props.className, _props$theme = props.theme, theme = _props$theme === void 0 ? 'light' : _props$theme, expandIcon = props.expandIcon, _internalDisableMenuItemTitleTooltip = props._internalDisableMenuItemTitleTooltip, inlineCollapsed = props.inlineCollapsed, siderCollapsed = props.siderCollapsed, items = props.items, children = props.children, mode = props.mode, selectable = props.selectable, onClick = props.onClick, restProps = $47077f34c49bbd52$var$__rest(props, [
        "prefixCls",
        "className",
        "theme",
        "expandIcon",
        "_internalDisableMenuItemTitleTooltip",
        "inlineCollapsed",
        "siderCollapsed",
        "items",
        "children",
        "mode",
        "selectable",
        "onClick"
    ]);
    var passedProps = (0, $1pcHX.default)(restProps, [
        'collapsedWidth'
    ]);
    // ========================= Items ===========================
    var mergedChildren = (0, $74e6d83cfac16cf1$export$2e2bcd8739ae039)(items) || children;
    (_a = override.validator) === null || _a === void 0 || _a.call(override, {
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    var onItemClick = (0, $a4gyP.default)(function() {
        var _a;
        onClick === null || onClick === void 0 || onClick.apply(void 0, arguments);
        (_a = override === null || override === void 0 ? void 0 : override.onClick) === null || _a === void 0 || _a.call(override);
    });
    // ========================== Mode ===========================
    var mergedMode = override.mode || mode;
    // ======================= Selectable ========================
    var mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : override.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    var mergedInlineCollapsed = $acw62.useMemo(function() {
        if (siderCollapsed !== undefined) return siderCollapsed;
        return inlineCollapsed;
    }, [
        inlineCollapsed,
        siderCollapsed
    ]);
    var defaultMotions = {
        horizontal: {
            motionName: "".concat(rootPrefixCls, "-slide-up")
        },
        inline: (0, $2efb522a5615f01e$export$2e2bcd8739ae039),
        other: {
            motionName: "".concat(rootPrefixCls, "-zoom-big")
        }
    };
    var prefixCls = getPrefixCls('menu', customizePrefixCls || override.prefixCls);
    var menuClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-").concat(theme), className);
    // ====================== Expand Icon ========================
    var mergedExpandIcon;
    if (typeof expandIcon === 'function') mergedExpandIcon = expandIcon;
    else mergedExpandIcon = (0, $30796c32f374b477$export$e530037191fcd5d7)(expandIcon || override.expandIcon, {
        className: "".concat(prefixCls, "-submenu-expand-icon")
    });
    // ======================== Context ==========================
    var contextValue = $acw62.useMemo(function() {
        return {
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            antdMenuTheme: theme,
            direction: direction,
            firstLevel: true,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
        };
    }, [
        prefixCls,
        mergedInlineCollapsed,
        theme,
        direction,
        _internalDisableMenuItemTitleTooltip
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $f1be9e89e34926b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $feYPt.default), (0, $8nd05.default)({
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $acw62.createElement((0, $09defd2fd47a1b8f$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: "".concat(prefixCls, "-").concat(theme),
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick
    }, passedProps, {
        inlineCollapsed: mergedInlineCollapsed,
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref
    }), mergedChildren)));
});
// We should keep this as ref-able
var $47077f34c49bbd52$var$Menu = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Menu, _React$Component);
    function Menu() {
        var _this;
        (0, $6CZeq.default)(this, Menu);
        _this = $47077f34c49bbd52$var$_callSuper(this, Menu, arguments);
        _this.focus = function(options) {
            var _a;
            (_a = _this.menu) === null || _a === void 0 || _a.focus(options);
        };
        return _this;
    }
    (0, $cHPF9.default)(Menu, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                return /*#__PURE__*/ $acw62.createElement((0, $f4e67dbf2453f541$export$63554aebd2a6d54c).Consumer, null, function(context) {
                    return /*#__PURE__*/ $acw62.createElement($47077f34c49bbd52$var$InternalMenu, (0, $8nd05.default)({
                        ref: function ref(node) {
                            _this2.menu = node;
                        }
                    }, _this2.props, context));
                });
            }
        }
    ]);
    return Menu;
}($acw62.Component);
$47077f34c49bbd52$var$Menu.Divider = (0, $d26f09d6992ff5d8$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.Item = (0, $8955a62aec0d8484$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.SubMenu = (0, $14bdbe2126091cad$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.ItemGroup = (0, $9TcXG.default);
var $47077f34c49bbd52$export$2e2bcd8739ae039 = $47077f34c49bbd52$var$Menu;









var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");


var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");





var $87bdca50cc18044d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $87bdca50cc18044d$var$DropdownButton = function DropdownButton(props) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? 'default' : _props$type, danger = props.danger, disabled = props.disabled, loading = props.loading, onClick = props.onClick, htmlType = props.htmlType, children = props.children, className = props.className, menu = props.menu, arrow = props.arrow, autoFocus = props.autoFocus, overlay = props.overlay, trigger = props.trigger, align = props.align, visible = props.visible, open = props.open, onVisibleChange = props.onVisibleChange, onOpenChange = props.onOpenChange, placement = props.placement, getPopupContainer = props.getPopupContainer, href = props.href, _props$icon = props.icon, icon = _props$icon === void 0 ? /*#__PURE__*/ $acw62.createElement((0, $09defd2fd47a1b8f$export$2e2bcd8739ae039), null) : _props$icon, title = props.title, _props$buttonsRender = props.buttonsRender, buttonsRender = _props$buttonsRender === void 0 ? function(buttons) {
        return buttons;
    } : _props$buttonsRender, mouseEnterDelay = props.mouseEnterDelay, mouseLeaveDelay = props.mouseLeaveDelay, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, destroyPopupOnHide = props.destroyPopupOnHide, restProps = $87bdca50cc18044d$var$__rest(props, [
        "prefixCls",
        "type",
        "danger",
        "disabled",
        "loading",
        "onClick",
        "htmlType",
        "children",
        "className",
        "menu",
        "arrow",
        "autoFocus",
        "overlay",
        "trigger",
        "align",
        "visible",
        "open",
        "onVisibleChange",
        "onOpenChange",
        "placement",
        "getPopupContainer",
        "href",
        "icon",
        "title",
        "buttonsRender",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayClassName",
        "overlayStyle",
        "destroyPopupOnHide"
    ]);
    var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
    var dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange || onVisibleChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayClassName: overlayClassName,
        overlayStyle: overlayStyle,
        destroyPopupOnHide: destroyPopupOnHide
    };
    var _useCompactItemContex = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, compactItemClassnames, className);
    if ('overlay' in props) dropdownProps.overlay = overlay;
    if ('open' in props) dropdownProps.open = open;
    else if ('visible' in props) dropdownProps.open = visible;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    var leftButton = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    var rightButton = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    var _buttonsRender = buttonsRender([
        leftButton,
        rightButton
    ]), _buttonsRender2 = (0, $eUqlC.default)(_buttonsRender, 2), leftButtonToRender = _buttonsRender2[0], rightButtonToRender = _buttonsRender2[1];
    return /*#__PURE__*/ $acw62.createElement((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039).Compact, (0, $8nd05.default)({
        className: classes,
        size: compactSize,
        block: true
    }, restProps), leftButtonToRender, /*#__PURE__*/ $acw62.createElement((0, $c311d16d3fa9262a$export$2e2bcd8739ae039), (0, $8nd05.default)({}, dropdownProps), rightButtonToRender));
};
$87bdca50cc18044d$var$DropdownButton.__ANT_BUTTON = true;
var $87bdca50cc18044d$export$2e2bcd8739ae039 = $87bdca50cc18044d$var$DropdownButton;



var $c311d16d3fa9262a$var$Placements = (0, $1ee8868d1993c67b$export$65e3907585753458)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight', 'top', 'bottom');
var $c311d16d3fa9262a$var$Dropdown = function Dropdown(props) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var getTransitionName = function getTransitionName() {
        var rootPrefixCls = getPrefixCls();
        var _props$placement = props.placement, placement = _props$placement === void 0 ? '' : _props$placement, transitionName = props.transitionName;
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return "".concat(rootPrefixCls, "-slide-down");
        return "".concat(rootPrefixCls, "-slide-up");
    };
    var getPlacement = function getPlacement() {
        var placement = props.placement;
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) {
            var newPlacement = placement.slice(0, placement.indexOf('Center'));
            return newPlacement;
        }
        return placement;
    };
    var menu = props.menu, arrow = props.arrow, customizePrefixCls = props.prefixCls, children = props.children, trigger = props.trigger, disabled = props.disabled, dropdownRender = props.dropdownRender, getPopupContainer = props.getPopupContainer, overlayClassName = props.overlayClassName, visible = props.visible, open = props.open, onVisibleChange = props.onVisibleChange, onOpenChange = props.onOpenChange, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.15 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, _props$autoAdjustOver = props.autoAdjustOverflow, autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver;
    var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    var child = $acw62.Children.only(children);
    var dropdownTrigger = (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-trigger"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), child.props.className),
        disabled: disabled
    });
    var triggerActions = disabled ? [] : trigger;
    var alignPoint;
    if (triggerActions && triggerActions.includes('contextMenu')) alignPoint = true;
    // =========================== Visible ============================
    var _useMergedState = (0, $iSQh8.default)(false, {
        value: open !== undefined ? open : visible
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedOpen = _useMergedState2[0], setOpen = _useMergedState2[1];
    var onInnerOpenChange = (0, $a4gyP.default)(function(nextOpen) {
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(nextOpen);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen);
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    var overlayClassNameCustomized = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, (0, $kSlfw.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'));
    var builtinPlacements = (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
        arrowPointAtCenter: (0, $fSwVM.default)(arrow) === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow
    });
    var onMenuClick = $acw62.useCallback(function() {
        setOpen(false);
    }, []);
    var renderOverlay = function renderOverlay() {
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        var overlay = props.overlay;
        var overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) overlayNode = /*#__PURE__*/ $acw62.createElement((0, $47077f34c49bbd52$export$2e2bcd8739ae039), (0, $8nd05.default)({}, menu));
        else if (typeof overlay === 'function') overlayNode = overlay();
        else overlayNode = overlay;
        if (dropdownRender) overlayNode = dropdownRender(overlayNode);
        overlayNode = $acw62.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $acw62.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$9bd434816b0530d0), {
            prefixCls: "".concat(prefixCls, "-menu"),
            expandIcon: /*#__PURE__*/ $acw62.createElement("span", {
                className: "".concat(prefixCls, "-menu-submenu-arrow")
            }, /*#__PURE__*/ $acw62.createElement((0, $e2b36e2640287638$export$2e2bcd8739ae039), {
                className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: function validator(_ref3) {
                var mode = _ref3.mode;
            }
        }, /*#__PURE__*/ $acw62.createElement((0, $26050ef76e24a749$export$5f56e610a4afb685), null, overlayNode));
    };
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $jtXXN.default), (0, $8nd05.default)({
        alignPoint: alignPoint
    }, props, {
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: getTransitionName(),
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: getPlacement(),
        onVisibleChange: onInnerOpenChange
    }), dropdownTrigger);
};
$c311d16d3fa9262a$var$Dropdown.Button = (0, $87bdca50cc18044d$export$2e2bcd8739ae039);
var $c311d16d3fa9262a$export$2e2bcd8739ae039 = $c311d16d3fa9262a$var$Dropdown;


var $9df091eb5002c0d1$export$2e2bcd8739ae039 = (0, $c311d16d3fa9262a$export$2e2bcd8739ae039);






var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $iSQh8 = parcelRequire("iSQh8");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $5d2deff95d42cf3f$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(null);
var $5d2deff95d42cf3f$export$67d4730aee04efd2 = $5d2deff95d42cf3f$var$RadioGroupContext.Provider;
var $5d2deff95d42cf3f$export$2e2bcd8739ae039 = $5d2deff95d42cf3f$var$RadioGroupContext;
var $5d2deff95d42cf3f$export$4fbd9581b41e971f = /*#__PURE__*/ $acw62.createContext(null);
var $5d2deff95d42cf3f$export$1b5d1f64a577990e = $5d2deff95d42cf3f$export$4fbd9581b41e971f.Provider;



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $fAiwY = parcelRequire("fAiwY");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");





var $9248626bdf467aa3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9248626bdf467aa3$var$InternalRadio = function InternalRadio(props, ref) {
    var _a, _b;
    var groupContext = $acw62.useContext((0, $5d2deff95d42cf3f$export$2e2bcd8739ae039));
    var radioOptionTypeContext = $acw62.useContext((0, $5d2deff95d42cf3f$export$4fbd9581b41e971f));
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var innerRef = $acw62.useRef();
    var mergedRef = (0, $85dLH.composeRef)(ref, innerRef);
    var _useContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed)), isFormItemInput = _useContext.isFormItemInput;
    var onChange = function onChange(e) {
        var _a, _b;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e);
        (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b === void 0 || _b.call(groupContext, e);
    };
    var customizePrefixCls = props.prefixCls, className = props.className, children = props.children, style = props.style, restProps = $9248626bdf467aa3$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "style"
    ]);
    var radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    var prefixCls = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === 'button' ? "".concat(radioPrefixCls, "-button") : radioPrefixCls;
    var radioProps = (0, $8nd05.default)({}, restProps);
    // ===================== Disabled =====================
    var disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
    }
    radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
    var wrapperClassString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-wrapper"), (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $acw62.createElement("label", {
        className: wrapperClassString,
        style: style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
    }, /*#__PURE__*/ $acw62.createElement((0, $fAiwY.default), (0, $8nd05.default)({}, radioProps, {
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef
    })), children !== undefined ? /*#__PURE__*/ $acw62.createElement("span", null, children) : null));
};
var $9248626bdf467aa3$var$Radio = /*#__PURE__*/ $acw62.forwardRef($9248626bdf467aa3$var$InternalRadio);
var $9248626bdf467aa3$export$2e2bcd8739ae039 = $9248626bdf467aa3$var$Radio;


var $61a2b39e6d97013d$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    var _useMergedState = (0, $iSQh8.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var onRadioChange = function onRadioChange(ev) {
        var lastValue = value;
        var val = ev.target.value;
        if (!('value' in props)) setValue(val);
        var onChange = props.onChange;
        if (onChange && val !== lastValue) onChange(ev);
    };
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, options = props.options, _props$buttonStyle = props.buttonStyle, buttonStyle = _props$buttonStyle === void 0 ? 'outline' : _props$buttonStyle, disabled = props.disabled, children = props.children, customizeSize = props.size, style = props.style, id = props.id, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onFocus = props.onFocus, onBlur = props.onBlur;
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map(function(option) {
        if (typeof option === 'string' || typeof option === 'number') // 此处类型自动推导为 string
        return /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), {
            key: "radio-group-value-options-".concat(option.value),
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            style: option.style
        }, option.label);
    });
    var mergedSize = customizeSize || size;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(groupPrefixCls, "-").concat(mergedSize), mergedSize), "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, (0, $7e9c3441b3ad589e$export$2e2bcd8739ae039)(props), {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }), /*#__PURE__*/ $acw62.createElement((0, $5d2deff95d42cf3f$export$67d4730aee04efd2), {
        value: {
            onChange: onRadioChange,
            value: value,
            disabled: props.disabled,
            name: props.name,
            optionType: props.optionType
        }
    }, childrenToRender));
});
var $61a2b39e6d97013d$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($61a2b39e6d97013d$var$RadioGroup);




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $26603fe9919115f7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $26603fe9919115f7$var$RadioButton = function RadioButton(props, ref) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var customizePrefixCls = props.prefixCls, radioProps = $26603fe9919115f7$var$__rest(props, [
        "prefixCls"
    ]);
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ $acw62.createElement((0, $5d2deff95d42cf3f$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), (0, $8nd05.default)({
        prefixCls: prefixCls
    }, radioProps, {
        type: "radio",
        ref: ref
    })));
};
var $26603fe9919115f7$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($26603fe9919115f7$var$RadioButton);


var $c1fe26c11c01fc5f$var$Radio = (0, $9248626bdf467aa3$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.Button = (0, $26603fe9919115f7$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.Group = (0, $61a2b39e6d97013d$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.__ANT_RADIO = true;
var $c1fe26c11c01fc5f$export$2e2bcd8739ae039 = $c1fe26c11c01fc5f$var$Radio;


parcelRequire("8rHfe");
var $5BDlo = parcelRequire("5BDlo");

var $kSlfw = parcelRequire("kSlfw");

var $fSwVM = parcelRequire("fSwVM");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8c209b42de494af1$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
var $8c209b42de494af1$export$2e2bcd8739ae039 = $8c209b42de494af1$var$HolderOutlined;



var $b1244a1d9049af48$var$HolderOutlined = function HolderOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8c209b42de494af1$export$2e2bcd8739ae039)
    }));
};
var $b1244a1d9049af48$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($b1244a1d9049af48$var$HolderOutlined);
var $b1244a1d9049af48$export$2e2bcd8739ae039 = $b1244a1d9049af48$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $8rHfe = parcelRequire("8rHfe");

var $acw62 = parcelRequire("acw62");



var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");
var $1dfbc26739217dee$export$cc800923e997bb8 = 4;
function $1dfbc26739217dee$export$2e2bcd8739ae039(props) {
    var dropPosition = props.dropPosition, dropLevelOffset = props.dropLevelOffset, prefixCls = props.prefixCls, indent = props.indent, _props$direction = props.direction, direction = _props$direction === void 0 ? 'ltr' : _props$direction;
    var startPosition = direction === 'ltr' ? 'left' : 'right';
    var endPosition = direction === 'ltr' ? 'right' : 'left';
    var style = (0, $kSlfw.default)((0, $kSlfw.default)({}, startPosition, -dropLevelOffset * indent + $1dfbc26739217dee$export$cc800923e997bb8), endPosition, 0);
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $1dfbc26739217dee$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: "".concat(prefixCls, "-drop-indicator")
    });
}



var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d18b58b25958afc6$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
var $d18b58b25958afc6$export$2e2bcd8739ae039 = $d18b58b25958afc6$var$CaretDownFilled;



var $890ea0f4cd030795$var$CaretDownFilled = function CaretDownFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $d18b58b25958afc6$export$2e2bcd8739ae039)
    }));
};
var $890ea0f4cd030795$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($890ea0f4cd030795$var$CaretDownFilled);
var $890ea0f4cd030795$export$2e2bcd8739ae039 = $890ea0f4cd030795$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5b173e35d737c62d$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $5b173e35d737c62d$export$2e2bcd8739ae039 = $5b173e35d737c62d$var$FileOutlined;



var $1e5bbb60d9bde893$var$FileOutlined = function FileOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $5b173e35d737c62d$export$2e2bcd8739ae039)
    }));
};
var $1e5bbb60d9bde893$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1e5bbb60d9bde893$var$FileOutlined);
var $1e5bbb60d9bde893$export$2e2bcd8739ae039 = $1e5bbb60d9bde893$var$RefIcon;




var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c39dba0bbe13c0cc$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
var $c39dba0bbe13c0cc$export$2e2bcd8739ae039 = $c39dba0bbe13c0cc$var$MinusSquareOutlined;



var $772eb9863ecb1362$var$MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $c39dba0bbe13c0cc$export$2e2bcd8739ae039)
    }));
};
var $772eb9863ecb1362$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($772eb9863ecb1362$var$MinusSquareOutlined);
var $772eb9863ecb1362$export$2e2bcd8739ae039 = $772eb9863ecb1362$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0bd4c0466d4aa550$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
var $0bd4c0466d4aa550$export$2e2bcd8739ae039 = $0bd4c0466d4aa550$var$PlusSquareOutlined;



var $f3519212d7915f5c$var$PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0bd4c0466d4aa550$export$2e2bcd8739ae039)
    }));
};
var $f3519212d7915f5c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f3519212d7915f5c$var$PlusSquareOutlined);
var $f3519212d7915f5c$export$2e2bcd8739ae039 = $f3519212d7915f5c$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

function $587d94115e84e73e$export$2e2bcd8739ae039(prefixCls, switcherIcon, showLine, treeNodeProps) {
    var isLeaf = treeNodeProps.isLeaf, expanded = treeNodeProps.expanded, loading = treeNodeProps.loading;
    if (loading) return /*#__PURE__*/ $acw62.createElement((0, $43383ed7d2a91124$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-switcher-loading-icon")
    });
    var showLeafIcon;
    if (showLine && (0, $fSwVM.default)(showLine) === 'object') showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            var leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            var leafCls = "".concat(prefixCls, "-switcher-line-custom-icon");
            if ((0, $30796c32f374b477$export$a8257692ac88316c)(leafIcon)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(leafIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(leafIcon.props.className || '', leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $acw62.createElement((0, $1e5bbb60d9bde893$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-switcher-line-icon")
        }) : /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-switcher-leaf-line")
        });
    }
    var switcherCls = "".concat(prefixCls, "-switcher-icon");
    var switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if ((0, $30796c32f374b477$export$a8257692ac88316c)(switcher)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(switcher, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(switcher.props.className || '', switcherCls)
    });
    if (switcher) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $acw62.createElement((0, $772eb9863ecb1362$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-switcher-line-icon")
    }) : /*#__PURE__*/ $acw62.createElement((0, $f3519212d7915f5c$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-switcher-line-icon")
    });
    return /*#__PURE__*/ $acw62.createElement((0, $890ea0f4cd030795$export$2e2bcd8739ae039), {
        className: switcherCls
    });
}


var $71445890cbc611bb$var$Tree = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, virtual = _React$useContext.virtual;
    var customizePrefixCls = props.prefixCls, className = props.className, _props$showIcon = props.showIcon, showIcon = _props$showIcon === void 0 ? false : _props$showIcon, showLine = props.showLine, _switcherIcon = props.switcherIcon, _props$blockNode = props.blockNode, blockNode = _props$blockNode === void 0 ? false : _props$blockNode, children = props.children, _props$checkable = props.checkable, checkable = _props$checkable === void 0 ? false : _props$checkable, _props$selectable = props.selectable, selectable = _props$selectable === void 0 ? true : _props$selectable, draggable = props.draggable, _props$motion = props.motion, motion = _props$motion === void 0 ? (0, $8nd05.default)((0, $8nd05.default)({}, (0, $2efb522a5615f01e$export$2e2bcd8739ae039)), {
        motionAppear: false
    }) : _props$motion;
    var prefixCls = getPrefixCls('tree', customizePrefixCls);
    var newProps = (0, $8nd05.default)((0, $8nd05.default)({}, props), {
        checkable: checkable,
        selectable: selectable,
        showIcon: showIcon,
        motion: motion,
        blockNode: blockNode,
        showLine: Boolean(showLine),
        dropIndicatorRender: (0, $1dfbc26739217dee$export$2e2bcd8739ae039)
    });
    var draggableConfig = $acw62.useMemo(function() {
        if (!draggable) return false;
        var mergedDraggable = {};
        switch((0, $fSwVM.default)(draggable)){
            case 'function':
                mergedDraggable.nodeDraggable = draggable;
                break;
            case 'object':
                mergedDraggable = (0, $8nd05.default)({}, draggable);
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ $acw62.createElement((0, $b1244a1d9049af48$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $8rHfe.default), (0, $8nd05.default)({
        itemHeight: 20,
        ref: ref,
        virtual: virtual
    }, newProps, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-icon-hide"), !showIcon), "".concat(prefixCls, "-block-node"), blockNode), "".concat(prefixCls, "-unselectable"), !selectable), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className),
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-checkbox-inner")
        }) : checkable,
        selectable: selectable,
        switcherIcon: function switcherIcon(nodeProps) {
            return (0, $587d94115e84e73e$export$2e2bcd8739ae039)(prefixCls, _switcherIcon, showLine, nodeProps);
        },
        draggable: draggableConfig
    }), children);
});
var $71445890cbc611bb$export$2e2bcd8739ae039 = $71445890cbc611bb$var$Tree;



var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");


var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $682105b8f0090055$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $682105b8f0090055$export$2e2bcd8739ae039 = $682105b8f0090055$var$FolderOpenOutlined;



var $1f6ab2fb5a69eb9f$var$FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $682105b8f0090055$export$2e2bcd8739ae039)
    }));
};
var $1f6ab2fb5a69eb9f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1f6ab2fb5a69eb9f$var$FolderOpenOutlined);
var $1f6ab2fb5a69eb9f$export$2e2bcd8739ae039 = $1f6ab2fb5a69eb9f$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");


var $7d2286fc7cddf0d4$var$FolderOutlined = function FolderOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fc99a386109651e1$export$2e2bcd8739ae039)
    }));
};
var $7d2286fc7cddf0d4$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($7d2286fc7cddf0d4$var$FolderOutlined);
var $7d2286fc7cddf0d4$export$2e2bcd8739ae039 = $7d2286fc7cddf0d4$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $f4FkX = parcelRequire("f4FkX");

var $jh8Np = parcelRequire("jh8Np");

var $acw62 = parcelRequire("acw62");



var $kbxxf = parcelRequire("kbxxf");
var $b87075829d49fe5e$var$Record;
(function(Record) {
    Record[Record["None"] = 0] = "None";
    Record[Record["Start"] = 1] = "Start";
    Record[Record["End"] = 2] = "End";
})($b87075829d49fe5e$var$Record || ($b87075829d49fe5e$var$Record = {}));
function $b87075829d49fe5e$var$traverseNodesKey(treeData, callback) {
    function processNode(dataNode) {
        var key = dataNode.key, children = dataNode.children;
        if (callback(key, dataNode) !== false) $b87075829d49fe5e$var$traverseNodesKey(children || [], callback);
    }
    treeData.forEach(processNode);
}
function $b87075829d49fe5e$export$aad0b800290b42ab(_ref) {
    var treeData = _ref.treeData, expandedKeys = _ref.expandedKeys, startKey = _ref.startKey, endKey = _ref.endKey;
    var keys = [];
    var record = $b87075829d49fe5e$var$Record.None;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $b87075829d49fe5e$var$traverseNodesKey(treeData, function(key) {
        if (record === $b87075829d49fe5e$var$Record.End) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $b87075829d49fe5e$var$Record.None) record = $b87075829d49fe5e$var$Record.Start;
            else if (record === $b87075829d49fe5e$var$Record.Start) {
                record = $b87075829d49fe5e$var$Record.End;
                return false;
            }
        } else if (record === $b87075829d49fe5e$var$Record.Start) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    });
    return keys;
}
function $b87075829d49fe5e$export$7d40a46ab3886826(treeData, keys) {
    var restKeys = (0, $kbxxf.default)(keys);
    var nodes = [];
    $b87075829d49fe5e$var$traverseNodesKey(treeData, function(key, node) {
        var index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    });
    return nodes;
}


var $6fd2de76bf4211ba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6fd2de76bf4211ba$var$getIcon(props) {
    var isLeaf = props.isLeaf, expanded = props.expanded;
    if (isLeaf) return /*#__PURE__*/ $acw62.createElement((0, $1e5bbb60d9bde893$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $acw62.createElement((0, $1f6ab2fb5a69eb9f$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $7d2286fc7cddf0d4$export$2e2bcd8739ae039), null);
}
function $6fd2de76bf4211ba$var$getTreeData(_ref) {
    var treeData = _ref.treeData, children = _ref.children;
    return treeData || (0, $jh8Np.convertTreeToData)(children);
}
var $6fd2de76bf4211ba$var$DirectoryTree = function DirectoryTree(_a, ref) {
    var defaultExpandAll = _a.defaultExpandAll, defaultExpandParent = _a.defaultExpandParent, defaultExpandedKeys = _a.defaultExpandedKeys, props = $6fd2de76bf4211ba$var$__rest(_a, [
        "defaultExpandAll",
        "defaultExpandParent",
        "defaultExpandedKeys"
    ]);
    // Shift click usage
    var lastSelectedKey = $acw62.useRef();
    var cachedSelectedKeys = $acw62.useRef();
    var getInitExpandedKeys = function getInitExpandedKeys() {
        var _convertDataToEntitie = (0, $jh8Np.convertDataToEntities)($6fd2de76bf4211ba$var$getTreeData(props)), keyEntities = _convertDataToEntitie.keyEntities;
        var initExpandedKeys;
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $f4FkX.conductExpandParent)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
        else initExpandedKeys = props.expandedKeys || defaultExpandedKeys;
        return initExpandedKeys;
    };
    var _React$useState = $acw62.useState(props.selectedKeys || props.defaultSelectedKeys || []), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), selectedKeys = _React$useState2[0], setSelectedKeys = _React$useState2[1];
    var _React$useState3 = $acw62.useState(function() {
        return getInitExpandedKeys();
    }), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), expandedKeys = _React$useState4[0], setExpandedKeys = _React$useState4[1];
    $acw62.useEffect(function() {
        if ('selectedKeys' in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $acw62.useEffect(function() {
        if ('expandedKeys' in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    var onExpand = function onExpand(keys, info) {
        var _a;
        if (!('expandedKeys' in props)) setExpandedKeys(keys);
        // Call origin function
        return (_a = props.onExpand) === null || _a === void 0 ? void 0 : _a.call(props, keys, info);
    };
    var onSelect = function onSelect(keys, event) {
        var _a;
        var multiple = props.multiple;
        var node = event.node, nativeEvent = event.nativeEvent;
        var _node$key = node.key, key = _node$key === void 0 ? '' : _node$key;
        var treeData = $6fd2de76bf4211ba$var$getTreeData(props);
        // const newState: DirectoryTreeState = {};
        // We need wrap this event since some value is not same
        var newEvent = (0, $8nd05.default)((0, $8nd05.default)({}, event), {
            selected: true
        });
        // Windows / Mac single pick
        var ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
        var shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
        // Generate new selected keys
        var newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $kbxxf.default)(cachedSelectedKeys.current || []), (0, $kbxxf.default)((0, $b87075829d49fe5e$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKey.current
            })))));
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys);
        }
        (_a = props.onSelect) === null || _a === void 0 || _a.call(props, newSelectedKeys, newEvent);
        if (!('selectedKeys' in props)) setSelectedKeys(newSelectedKeys);
    };
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, className = props.className, _props$showIcon = props.showIcon, showIcon = _props$showIcon === void 0 ? true : _props$showIcon, _props$expandAction = props.expandAction, expandAction = _props$expandAction === void 0 ? 'click' : _props$expandAction, otherProps = $6fd2de76bf4211ba$var$__rest(props, [
        "prefixCls",
        "className",
        "showIcon",
        "expandAction"
    ]);
    var prefixCls = getPrefixCls('tree', customizePrefixCls);
    var connectClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-directory"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-directory-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $acw62.createElement((0, $71445890cbc611bb$export$2e2bcd8739ae039), (0, $8nd05.default)({
        icon: $6fd2de76bf4211ba$var$getIcon,
        ref: ref,
        blockNode: true
    }, otherProps, {
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    }));
};
var $6fd2de76bf4211ba$var$ForwardDirectoryTree = /*#__PURE__*/ $acw62.forwardRef($6fd2de76bf4211ba$var$DirectoryTree);
var $6fd2de76bf4211ba$export$2e2bcd8739ae039 = $6fd2de76bf4211ba$var$ForwardDirectoryTree;


var $214c2d233474e3a9$var$Tree = (0, $71445890cbc611bb$export$2e2bcd8739ae039);
$214c2d233474e3a9$var$Tree.DirectoryTree = (0, $6fd2de76bf4211ba$export$2e2bcd8739ae039);
$214c2d233474e3a9$var$Tree.TreeNode = (0, $5BDlo.default);
var $214c2d233474e3a9$export$2e2bcd8739ae039 = $214c2d233474e3a9$var$Tree;



var $acw62 = parcelRequire("acw62");

function $1f7b7badb410ab86$export$2e2bcd8739ae039(initialValue) {
    var ref = $acw62.useRef(initialValue);
    var forceUpdate = (0, $dcbb6d0bd42650d6$export$2e2bcd8739ae039)();
    return [
        function() {
            return ref.current;
        },
        function(newValue) {
            ref.current = newValue;
            // re-render
            forceUpdate();
        }
    ];
}




var $acw62 = parcelRequire("acw62");

function $c1d7c8bb2fcfceb3$var$FilterSearch(_ref) {
    var value = _ref.value, onChange = _ref.onChange, filterSearch = _ref.filterSearch, tablePrefixCls = _ref.tablePrefixCls, locale = _ref.locale;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(tablePrefixCls, "-filter-dropdown-search")
    }, /*#__PURE__*/ $acw62.createElement((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $acw62.createElement((0, $2917d4d4b4ce8eca$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: "".concat(tablePrefixCls, "-filter-dropdown-search-input")
    }));
}
var $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039 = $c1d7c8bb2fcfceb3$var$FilterSearch;



var $acw62 = parcelRequire("acw62");

var $iCi4s = parcelRequire("iCi4s");
var $93969139f956c4b8$var$onKeyDown = function onKeyDown(event) {
    var keyCode = event.keyCode;
    if (keyCode === (0, $iCi4s.default).ENTER) event.stopPropagation();
};
var $93969139f956c4b8$var$FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: props.className,
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        onKeyDown: $93969139f956c4b8$var$onKeyDown
    }, props.children);
};
var $93969139f956c4b8$export$2e2bcd8739ae039 = $93969139f956c4b8$var$FilterDropdownMenuWrapper;


function $e2c4fb76408c4dec$var$hasSubMenu(filters) {
    return filters.some(function(_ref) {
        var children = _ref.children;
        return children;
    });
}
function $e2c4fb76408c4dec$var$searchValueMatched(searchValue, text) {
    if (typeof text === 'string' || typeof text === 'number') return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    return false;
}
function $e2c4fb76408c4dec$var$renderFilterItems(_ref2) {
    var filters = _ref2.filters, prefixCls = _ref2.prefixCls, filteredKeys = _ref2.filteredKeys, filterMultiple = _ref2.filterMultiple, searchValue = _ref2.searchValue, filterSearch = _ref2.filterSearch;
    return filters.map(function(filter, index) {
        var key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: "".concat(prefixCls, "-dropdown-submenu"),
            children: $e2c4fb76408c4dec$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                filterSearch: filterSearch
            })
        };
        var Component = filterMultiple ? (0, $da237ba92f78ed9a$export$2e2bcd8739ae039) : (0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039);
        var item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $acw62.createElement("span", null, filter.text))
        };
        if (searchValue.trim()) {
            if (typeof filterSearch === 'function') return filterSearch(searchValue, filter) ? item : null;
            return $e2c4fb76408c4dec$var$searchValueMatched(searchValue, filter.text) ? item : null;
        }
        return item;
    });
}
function $e2c4fb76408c4dec$var$wrapStringListType(keys) {
    return keys || [];
}
function $e2c4fb76408c4dec$var$FilterDropdown(props) {
    var _a;
    var tablePrefixCls = props.tablePrefixCls, prefixCls = props.prefixCls, column = props.column, dropdownPrefixCls = props.dropdownPrefixCls, columnKey = props.columnKey, filterMultiple = props.filterMultiple, _props$filterMode = props.filterMode, filterMode = _props$filterMode === void 0 ? 'menu' : _props$filterMode, _props$filterSearch = props.filterSearch, filterSearch = _props$filterSearch === void 0 ? false : _props$filterSearch, filterState = props.filterState, triggerFilter = props.triggerFilter, locale = props.locale, children = props.children, getPopupContainer = props.getPopupContainer;
    var filterDropdownOpen = column.filterDropdownOpen, onFilterDropdownOpenChange = column.onFilterDropdownOpenChange, filterDropdownVisible = column.filterDropdownVisible, onFilterDropdownVisibleChange = column.onFilterDropdownVisibleChange, filterResetToDefaultFilteredValue = column.filterResetToDefaultFilteredValue, defaultFilteredValue = column.defaultFilteredValue;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    var filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
    var triggerVisible = function triggerVisible(newVisible) {
        setVisible(newVisible);
        onFilterDropdownOpenChange === null || onFilterDropdownOpenChange === void 0 || onFilterDropdownOpenChange(newVisible);
        onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 || onFilterDropdownVisibleChange(newVisible);
    };
    var mergedVisible;
    if (typeof filterDropdownOpen === 'boolean') mergedVisible = filterDropdownOpen;
    else mergedVisible = typeof filterDropdownVisible === 'boolean' ? filterDropdownVisible : visible;
    // ===================== Select Keys =====================
    var propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
    var _useSyncState = (0, $1f7b7badb410ab86$export$2e2bcd8739ae039)($e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys)), _useSyncState2 = (0, $eUqlC.default)(_useSyncState, 2), getFilteredKeysSync = _useSyncState2[0], setFilteredKeysSync = _useSyncState2[1];
    var onSelectKeys = function onSelectKeys(_ref3) {
        var selectedKeys = _ref3.selectedKeys;
        setFilteredKeysSync(selectedKeys);
    };
    var onCheck = function onCheck(keys, _ref4) {
        var node = _ref4.node, checked = _ref4.checked;
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $acw62.useEffect(function() {
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    var _React$useState3 = $acw62.useState([]), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), openKeys = _React$useState4[0], setOpenKeys = _React$useState4[1];
    var onOpenChange = function onOpenChange(keys) {
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    var _React$useState5 = $acw62.useState(''), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), searchValue = _React$useState6[0], setSearchValue = _React$useState6[1];
    var onSearch = function onSearch(e) {
        var value = e.target.value;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $acw62.useEffect(function() {
        if (!visible) setSearchValue('');
    }, [
        visible
    ]);
    // ======================= Submit ========================
    var internalTriggerFilter = function internalTriggerFilter(keys) {
        var mergedKeys = keys && keys.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4UXHD)))(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    var onConfirm = function onConfirm() {
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onReset = function onReset() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            confirm: false,
            closeDropdown: false
        }, confirm = _ref5.confirm, closeDropdown = _ref5.closeDropdown;
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue('');
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map(function(key) {
            return String(key);
        }));
        else setFilteredKeysSync([]);
    };
    var doFilter = function doFilter() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            closeDropdown: true
        }, closeDropdown = _ref6.closeDropdown;
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onVisibleChange = function onVisibleChange(newVisible) {
        if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefiend)
        setFilteredKeysSync($e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys));
        triggerVisible(newVisible);
        // Default will filter when closed
        if (!newVisible && !column.filterDropdown) onConfirm();
    };
    // ======================== Style ========================
    var dropdownMenuClass = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !$e2c4fb76408c4dec$var$hasSubMenu(column.filters || [])));
    var onCheckAll = function onCheckAll(e) {
        if (e.target.checked) {
            var allFilterKeys = (0, $498593f51893a533$export$50792ddeed01ab0a)(column === null || column === void 0 ? void 0 : column.filters).map(function(key) {
                return String(key);
            });
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    var getTreeData = function getTreeData(_ref7) {
        var filters = _ref7.filters;
        return (filters || []).map(function(filter, index) {
            var key = String(filter.value);
            var item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    };
    var getFilterData = function getFilterData(node) {
        var _a;
        return (0, $8nd05.default)((0, $8nd05.default)({}, node), {
            text: node.title,
            value: node.key,
            children: ((_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function(item) {
                return getFilterData(item);
            })) || []
        });
    };
    var dropdownContent;
    if (typeof column.filterDropdown === 'function') dropdownContent = column.filterDropdown({
        prefixCls: "".concat(dropdownPrefixCls, "-custom"),
        setSelectedKeys: function setSelectedKeys(selectedKeys) {
            return onSelectKeys({
                selectedKeys: selectedKeys
            });
        },
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: function close() {
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        var selectedKeys = getFilteredKeysSync() || [];
        var getFilterComponent = function getFilterComponent() {
            if ((column.filters || []).length === 0) return /*#__PURE__*/ $acw62.createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                imageStyle: {
                    height: 24
                },
                style: {
                    margin: 0,
                    padding: '16px 0'
                }
            });
            if (filterMode === 'tree') return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $acw62.createElement("div", {
                className: "".concat(tablePrefixCls, "-filter-dropdown-tree")
            }, filterMultiple ? /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === (0, $498593f51893a533$export$50792ddeed01ab0a)(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < (0, $498593f51893a533$export$50792ddeed01ab0a)(column.filters).length,
                className: "".concat(tablePrefixCls, "-filter-dropdown-checkall"),
                onChange: onCheckAll
            }, locale.filterCheckall) : null, /*#__PURE__*/ $acw62.createElement((0, $214c2d233474e3a9$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: "".concat(dropdownPrefixCls, "-menu"),
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: searchValue.trim() ? function(node) {
                    if (typeof filterSearch === 'function') return filterSearch(searchValue, getFilterData(node));
                    return $e2c4fb76408c4dec$var$searchValueMatched(searchValue, node.title);
                } : undefined
            })));
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $acw62.createElement((0, $47077f34c49bbd52$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: "".concat(dropdownPrefixCls, "-menu"),
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: $e2c4fb76408c4dec$var$renderFilterItems({
                    filters: column.filters || [],
                    filterSearch: filterSearch,
                    prefixCls: prefixCls,
                    filteredKeys: getFilteredKeysSync(),
                    filterMultiple: filterMultiple,
                    searchValue: searchValue
                })
            }));
        };
        var getResetDisabled = function getResetDisabled() {
            if (filterResetToDefaultFilteredValue) return (0, (/*@__PURE__*/$parcel$interopDefault($4UXHD)))((defaultFilteredValue || []).map(function(key) {
                return String(key);
            }), selectedKeys);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, getFilterComponent(), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-dropdown-btns")
        }, /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: function onClick() {
                return onReset();
            }
        }, locale.filterReset), /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    var menu = function menu() {
        return /*#__PURE__*/ $acw62.createElement((0, $93969139f956c4b8$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-dropdown")
        }, dropdownContent);
    };
    var filterIcon;
    if (typeof column.filterIcon === 'function') filterIcon = column.filterIcon(filtered);
    else if (column.filterIcon) filterIcon = column.filterIcon;
    else filterIcon = /*#__PURE__*/ $acw62.createElement((0, $65f5300600a63436$export$2e2bcd8739ae039), null);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), direction = _React$useContext.direction;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-column")
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(tablePrefixCls, "-column-title")
    }, children), /*#__PURE__*/ $acw62.createElement((0, $9df091eb5002c0d1$export$2e2bcd8739ae039), {
        dropdownRender: menu,
        trigger: [
            'click'
        ],
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        getPopupContainer: getPopupContainer,
        placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight'
    }, /*#__PURE__*/ $acw62.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-trigger"), {
            active: filtered
        }),
        onClick: function onClick(e) {
            e.stopPropagation();
        }
    }, filterIcon)));
}
var $e2c4fb76408c4dec$export$2e2bcd8739ae039 = $e2c4fb76408c4dec$var$FilterDropdown;


function $498593f51893a533$var$collectFilterStates(columns, init, pos) {
    var filterStates = [];
    (columns || []).forEach(function(column, index) {
        var _a;
        var columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        if (column.filters || 'filterDropdown' in column || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                var filteredValues = column.filteredValue;
                if (!('filterDropdown' in column)) filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ('children' in column) filterStates = [].concat((0, $kbxxf.default)(filterStates), (0, $kbxxf.default)($498593f51893a533$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
}
function $498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, triggerFilter, getPopupContainer, locale, pos) {
    return columns.map(function(column, index) {
        var columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        var _column$filterMultipl = column.filterMultiple, filterMultiple = _column$filterMultipl === void 0 ? true : _column$filterMultipl, filterMode = column.filterMode, filterSearch = column.filterSearch;
        var newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            var columnKey = (0, $10b8a922ada6c9c1$export$480219a02f196e72)(newColumn, columnPos);
            var filterState = filterStates.find(function(_ref) {
                var key = _ref.key;
                return columnKey === key;
            });
            newColumn = (0, $8nd05.default)((0, $8nd05.default)({}, newColumn), {
                title: function title(renderProps) {
                    return /*#__PURE__*/ $acw62.createElement((0, $e2c4fb76408c4dec$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: "".concat(prefixCls, "-filter"),
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer
                    }, (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, renderProps));
                }
            });
        }
        if ('children' in newColumn) newColumn = (0, $8nd05.default)((0, $8nd05.default)({}, newColumn), {
            children: $498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, triggerFilter, getPopupContainer, locale, columnPos)
        });
        return newColumn;
    });
}
function $498593f51893a533$export$50792ddeed01ab0a(filters) {
    var keys = [];
    (filters || []).forEach(function(_ref2) {
        var value = _ref2.value, children = _ref2.children;
        keys.push(value);
        if (children) keys = [].concat((0, $kbxxf.default)(keys), (0, $kbxxf.default)($498593f51893a533$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $498593f51893a533$var$generateFilterInfo(filterStates) {
    var currentFilters = {};
    filterStates.forEach(function(_ref3) {
        var key = _ref3.key, filteredKeys = _ref3.filteredKeys, column = _ref3.column;
        var keyAsString = key;
        var filters = column.filters, filterDropdown = column.filterDropdown;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            var keys = $498593f51893a533$export$50792ddeed01ab0a(filters);
            currentFilters[keyAsString] = keys.filter(function(originKey) {
                return filteredKeys.includes(String(originKey));
            });
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
}
function $498593f51893a533$export$37643bb40f4c1c56(data, filterStates) {
    return filterStates.reduce(function(currentData, filterState) {
        var _filterState$column = filterState.column, onFilter = _filterState$column.onFilter, filters = _filterState$column.filters, filteredKeys = filterState.filteredKeys;
        if (onFilter && filteredKeys && filteredKeys.length) return currentData.filter(function(record) {
            return filteredKeys.some(function(key) {
                var keys = $498593f51893a533$export$50792ddeed01ab0a(filters);
                var keyIndex = keys.findIndex(function(k) {
                    return String(k) === String(key);
                });
                var realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                return onFilter(realKey, record);
            });
        });
        return currentData;
    }, data);
}
function $498593f51893a533$var$useFilter(_ref4) {
    var prefixCls = _ref4.prefixCls, dropdownPrefixCls = _ref4.dropdownPrefixCls, mergedColumns = _ref4.mergedColumns, onFilterChange = _ref4.onFilterChange, getPopupContainer = _ref4.getPopupContainer, tableLocale = _ref4.locale;
    var _React$useState = $acw62.useState(function() {
        return $498593f51893a533$var$collectFilterStates(mergedColumns, true);
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), filterStates = _React$useState2[0], setFilterStates = _React$useState2[1];
    var mergedFilterStates = $acw62.useMemo(function() {
        var collectedStates = $498593f51893a533$var$collectFilterStates(mergedColumns, false);
        var filteredKeysIsAllNotControlled = true;
        var filteredKeysIsAllControlled = true;
        collectedStates.forEach(function(_ref5) {
            var filteredKeys = _ref5.filteredKeys;
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) return filterStates;
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    var filters = $acw62.useMemo(function() {
        return $498593f51893a533$var$generateFilterInfo(mergedFilterStates);
    }, [
        mergedFilterStates
    ]);
    var triggerFilter = function triggerFilter(filterState) {
        var newFilterStates = mergedFilterStates.filter(function(_ref6) {
            var key = _ref6.key;
            return key !== filterState.key;
        });
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($498593f51893a533$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    var transformColumns = function transformColumns(innerColumns) {
        return $498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, triggerFilter, getPopupContainer, tableLocale);
    };
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
}
var $498593f51893a533$export$2e2bcd8739ae039 = $498593f51893a533$var$useFilter;



var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");
function $e2770d04bc76b8cc$export$2e2bcd8739ae039(data, childrenColumnName, getRowKey) {
    var mapCacheRef = $acw62.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            var kvMap = new Map();
            /* eslint-disable no-inner-declarations */ function dig(records) {
                records.forEach(function(record, index) {
                    var rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if (record && (0, $fSwVM.default)(record) === 'object' && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            /* eslint-enable */ dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap.get(key);
    }
    return [
        getRecordByKey
    ];
}



var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");
var $b37c5a68d8297fb7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b37c5a68d8297fb7$export$5716e8bcb003888d = 10;
function $b37c5a68d8297fb7$export$27eceeed7bf0f4c2(pagination, mergedPagination) {
    var param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    var paginationObj = pagination && (0, $fSwVM.default)(pagination) === 'object' ? pagination : {};
    Object.keys(paginationObj).forEach(function(pageProp) {
        var value = mergedPagination[pageProp];
        if (typeof value !== 'function') param[pageProp] = value;
    });
    return param;
}
function $b37c5a68d8297fb7$var$extendsObject() {
    var result = {};
    for(var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++)list[_key] = arguments[_key];
    list.forEach(function(obj) {
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) result[key] = val;
        });
    });
    return result;
}
function $b37c5a68d8297fb7$export$2e2bcd8739ae039(total, pagination, onChange) {
    var _a = pagination && (0, $fSwVM.default)(pagination) === 'object' ? pagination : {}, _a$total = _a.total, paginationTotal = _a$total === void 0 ? 0 : _a$total, paginationObj = $b37c5a68d8297fb7$var$__rest(_a, [
        "total"
    ]);
    var _useState = (0, $acw62.useState)(function() {
        return {
            current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : $b37c5a68d8297fb7$export$5716e8bcb003888d
        };
    }), _useState2 = (0, $eUqlC.default)(_useState, 2), innerPagination = _useState2[0], setInnerPagination = _useState2[1];
    // ============ Basic Pagination Config ============
    var mergedPagination = $b37c5a68d8297fb7$var$extendsObject(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    var maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    var refreshPagination = function refreshPagination(current, pageSize) {
        setInnerPagination({
            current: current !== null && current !== void 0 ? current : 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    var onInternalChange = function onInternalChange(current, pageSize) {
        var _a;
        if (pagination) (_a = pagination.onChange) === null || _a === void 0 || _a.call(pagination, current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize));
    };
    if (pagination === false) return [
        {},
        function() {}
    ];
    return [
        (0, $8nd05.default)((0, $8nd05.default)({}, mergedPagination), {
            onChange: onInternalChange
        }),
        refreshPagination
    ];
}



var $kSlfw = parcelRequire("kSlfw");

var $aJJ3v = parcelRequire("aJJ3v");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

parcelRequire("4XkeF");
var $aLkKv = parcelRequire("aLkKv");

var $f4FkX = parcelRequire("f4FkX");

var $6EgAF = parcelRequire("6EgAF");

var $jh8Np = parcelRequire("jh8Np");

var $iSQh8 = parcelRequire("iSQh8");

var $acw62 = parcelRequire("acw62");




var $e201eb08b7050f4b$export$ed10248435b8f218 = {};
var $e201eb08b7050f4b$export$14159cd9e2a500c8 = 'SELECT_ALL';
var $e201eb08b7050f4b$export$625c4f68eaaf8cfd = 'SELECT_INVERT';
var $e201eb08b7050f4b$export$c1a725540f5a63bd = 'SELECT_NONE';
var $e201eb08b7050f4b$var$EMPTY_LIST = [];
function $e201eb08b7050f4b$var$flattenData(data, childrenColumnName) {
    var list = [];
    (data || []).forEach(function(record) {
        list.push(record);
        if (record && (0, $fSwVM.default)(record) === 'object' && childrenColumnName in record) list = [].concat((0, $kbxxf.default)(list), (0, $kbxxf.default)($e201eb08b7050f4b$var$flattenData(record[childrenColumnName], childrenColumnName)));
    });
    return list;
}
function $e201eb08b7050f4b$export$2e2bcd8739ae039(rowSelection, config) {
    var _ref = rowSelection || {}, preserveSelectedRowKeys = _ref.preserveSelectedRowKeys, selectedRowKeys = _ref.selectedRowKeys, defaultSelectedRowKeys = _ref.defaultSelectedRowKeys, getCheckboxProps = _ref.getCheckboxProps, onSelectionChange = _ref.onChange, onSelect = _ref.onSelect, onSelectAll = _ref.onSelectAll, onSelectInvert = _ref.onSelectInvert, onSelectNone = _ref.onSelectNone, onSelectMultiple = _ref.onSelectMultiple, selectionColWidth = _ref.columnWidth, selectionType = _ref.type, selections = _ref.selections, fixed = _ref.fixed, customizeRenderCell = _ref.renderCell, hideSelectAll = _ref.hideSelectAll, _ref$checkStrictly = _ref.checkStrictly, checkStrictly = _ref$checkStrictly === void 0 ? true : _ref$checkStrictly;
    var prefixCls = config.prefixCls, data = config.data, pageData = config.pageData, getRecordByKey = config.getRecordByKey, getRowKey = config.getRowKey, expandType = config.expandType, childrenColumnName = config.childrenColumnName, tableLocale = config.locale, getPopupContainer = config.getPopupContainer;
    // ========================= Keys =========================
    var _useMergedState = (0, $iSQh8.default)(selectedRowKeys || defaultSelectedRowKeys || $e201eb08b7050f4b$var$EMPTY_LIST, {
        value: selectedRowKeys
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedSelectedKeys = _useMergedState2[0], setMergedSelectedKeys = _useMergedState2[1];
    // ======================== Caches ========================
    var preserveRecordsRef = $acw62.useRef(new Map());
    var updatePreserveRecordsCache = (0, $acw62.useCallback)(function(keys) {
        if (preserveSelectedRowKeys) {
            var newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach(function(key) {
                var record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $acw62.useEffect(function() {
        updatePreserveRecordsCache(mergedSelectedKeys);
    }, [
        mergedSelectedKeys
    ]);
    var _useMemo = (0, $acw62.useMemo)(function() {
        return checkStrictly ? {
            keyEntities: null
        } : (0, $jh8Np.convertDataToEntities)(data, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName
    ]), keyEntities = _useMemo.keyEntities;
    // Get flatten data
    var flattedData = (0, $acw62.useMemo)(function() {
        return $e201eb08b7050f4b$var$flattenData(pageData, childrenColumnName);
    }, [
        pageData,
        childrenColumnName
    ]);
    // Get all checkbox props
    var checkboxPropsMap = (0, $acw62.useMemo)(function() {
        var map = new Map();
        flattedData.forEach(function(record, index) {
            var key = getRowKey(record, index);
            var checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    var isCheckboxDisabled = (0, $acw62.useCallback)(function(r) {
        var _a;
        return !!((_a = checkboxPropsMap.get(getRowKey(r))) === null || _a === void 0 ? void 0 : _a.disabled);
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    var _useMemo2 = (0, $acw62.useMemo)(function() {
        if (checkStrictly) return [
            mergedSelectedKeys || [],
            []
        ];
        var _conductCheck = (0, $6EgAF.conductCheck)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled), checkedKeys = _conductCheck.checkedKeys, halfCheckedKeys = _conductCheck.halfCheckedKeys;
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeys,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]), _useMemo3 = (0, $eUqlC.default)(_useMemo2, 2), derivedSelectedKeys = _useMemo3[0], derivedHalfSelectedKeys = _useMemo3[1];
    var derivedSelectedKeySet = (0, $acw62.useMemo)(function() {
        var keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    var derivedHalfSelectedKeySet = (0, $acw62.useMemo)(function() {
        return selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys);
    }, [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Save last selected key to enable range selection
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $eUqlC.default)(_useState, 2), lastSelectedKey = _useState2[0], setLastSelectedKey = _useState2[1];
    // Reset if rowSelection reset
    $acw62.useEffect(function() {
        if (!rowSelection) setMergedSelectedKeys($e201eb08b7050f4b$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    var setSelectedKeys = (0, $acw62.useCallback)(function(keys, method) {
        var availableKeys;
        var records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map(function(key) {
                return preserveRecordsRef.current.get(key);
            });
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach(function(key) {
                var record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    var triggerSingleSelection = (0, $acw62.useCallback)(function(key, selected, keys, event) {
        if (onSelect) {
            var rows = keys.map(function(k) {
                return getRecordByKey(k);
            });
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, 'single');
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    var mergedSelections = (0, $acw62.useMemo)(function() {
        if (!selections || hideSelectAll) return null;
        var selectionList = selections === true ? [
            $e201eb08b7050f4b$export$14159cd9e2a500c8,
            $e201eb08b7050f4b$export$625c4f68eaaf8cfd,
            $e201eb08b7050f4b$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map(function(selection) {
            if (selection === $e201eb08b7050f4b$export$14159cd9e2a500c8) return {
                key: 'all',
                text: tableLocale.selectionAll,
                onSelect: function onSelect() {
                    setSelectedKeys(data.map(function(record, index) {
                        return getRowKey(record, index);
                    }).filter(function(key) {
                        var checkProps = checkboxPropsMap.get(key);
                        return !(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled) || derivedSelectedKeySet.has(key);
                    }), 'all');
                }
            };
            if (selection === $e201eb08b7050f4b$export$625c4f68eaaf8cfd) return {
                key: 'invert',
                text: tableLocale.selectInvert,
                onSelect: function onSelect() {
                    var keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach(function(record, index) {
                        var key = getRowKey(record, index);
                        var checkProps = checkboxPropsMap.get(key);
                        if (!(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled)) {
                            if (keySet.has(key)) keySet["delete"](key);
                            else keySet.add(key);
                        }
                    });
                    var keys = Array.from(keySet);
                    if (onSelectInvert) onSelectInvert(keys);
                    setSelectedKeys(keys, 'invert');
                }
            };
            if (selection === $e201eb08b7050f4b$export$c1a725540f5a63bd) return {
                key: 'none',
                text: tableLocale.selectNone,
                onSelect: function onSelect() {
                    onSelectNone === null || onSelectNone === void 0 || onSelectNone();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter(function(key) {
                        var checkProps = checkboxPropsMap.get(key);
                        return checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled;
                    }), 'none');
                }
            };
            return selection;
        }).map(function(selection) {
            return (0, $8nd05.default)((0, $8nd05.default)({}, selection), {
                onSelect: function onSelect() {
                    var _a2;
                    var _a;
                    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
                    (_a = selection.onSelect) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        selection
                    ].concat(rest));
                    setLastSelectedKey(null);
                }
            });
        });
    }, [
        selections,
        derivedSelectedKeySet,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    var transformColumns = (0, $acw62.useCallback)(function(columns) {
        var _a;
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter(function(col) {
            return col !== $e201eb08b7050f4b$export$ed10248435b8f218;
        });
        // >>>>>>>>>>> Support selection
        var cloneColumns = (0, $kbxxf.default)(columns);
        var keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        var recordKeys = flattedData.map(getRowKey).filter(function(key) {
            return !checkboxPropsMap.get(key).disabled;
        });
        var checkedCurrentAll = recordKeys.every(function(key) {
            return keySet.has(key);
        });
        var checkedCurrentSome = recordKeys.some(function(key) {
            return keySet.has(key);
        });
        var onSelectAllChange = function onSelectAllChange() {
            var changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach(function(key) {
                keySet["delete"](key);
                changeKeys.push(key);
            });
            else recordKeys.forEach(function(key) {
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            var keys = Array.from(keySet);
            onSelectAll === null || onSelectAll === void 0 || onSelectAll(!checkedCurrentAll, keys.map(function(k) {
                return getRecordByKey(k);
            }), changeKeys.map(function(k) {
                return getRecordByKey(k);
            }));
            setSelectedKeys(keys, 'all');
            setLastSelectedKey(null);
        };
        // ===================== Render =====================
        // Title Cell
        var title;
        if (selectionType !== 'radio') {
            var customizeSelections;
            if (mergedSelections) {
                var menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map(function(selection, index) {
                        var key = selection.key, text = selection.text, onSelectionClick = selection.onSelect;
                        return {
                            key: key || index,
                            onClick: function onClick() {
                                onSelectionClick === null || onSelectionClick === void 0 || onSelectionClick(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $acw62.createElement("div", {
                    className: "".concat(prefixCls, "-selection-extra")
                }, /*#__PURE__*/ $acw62.createElement((0, $9df091eb5002c0d1$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $acw62.createElement("span", null, /*#__PURE__*/ $acw62.createElement((0, $07345ef74b4fd657$export$2e2bcd8739ae039), null))));
            }
            var allDisabledData = flattedData.map(function(record, index) {
                var key = getRowKey(record, index);
                var checkboxProps = checkboxPropsMap.get(key) || {};
                return (0, $8nd05.default)({
                    checked: keySet.has(key)
                }, checkboxProps);
            }).filter(function(_ref2) {
                var disabled = _ref2.disabled;
                return disabled;
            });
            var allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            var allDisabledAndChecked = allDisabled && allDisabledData.every(function(_ref3) {
                var checked = _ref3.checked;
                return checked;
            });
            var allDisabledSomeChecked = allDisabled && allDisabledData.some(function(_ref4) {
                var checked = _ref4.checked;
                return checked;
            });
            title = !hideSelectAll && /*#__PURE__*/ $acw62.createElement("div", {
                className: "".concat(prefixCls, "-selection")
            }, /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: onSelectAllChange,
                disabled: flattedData.length === 0 || allDisabled,
                "aria-label": customizeSelections ? 'Custom selection' : 'Select all',
                skipGroup: true
            }), customizeSelections);
        }
        // Body Cell
        var renderCell;
        if (selectionType === 'radio') renderCell = function renderCell(_, record, index) {
            var key = getRowKey(record, index);
            var checked = keySet.has(key);
            return {
                node: /*#__PURE__*/ $acw62.createElement((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), (0, $8nd05.default)({}, checkboxPropsMap.get(key), {
                    checked: checked,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    onChange: function onChange(event) {
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                    }
                })),
                checked: checked
            };
        };
        else renderCell = function renderCell(_, record, index) {
            var _a;
            var key = getRowKey(record, index);
            var checked = keySet.has(key);
            var indeterminate = derivedHalfSelectedKeySet.has(key);
            var checkboxProps = checkboxPropsMap.get(key);
            var mergedIndeterminate;
            if (expandType === 'nest') mergedIndeterminate = indeterminate;
            else mergedIndeterminate = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a !== void 0 ? _a : indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), (0, $8nd05.default)({}, checkboxProps, {
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    onChange: function onChange(_ref5) {
                        var nativeEvent = _ref5.nativeEvent;
                        var shiftKey = nativeEvent.shiftKey;
                        var startIndex = -1;
                        var endIndex = -1;
                        // Get range of this
                        if (shiftKey && checkStrictly) {
                            var pointKeys = new Set([
                                lastSelectedKey,
                                key
                            ]);
                            recordKeys.some(function(recordKey, recordIndex) {
                                if (pointKeys.has(recordKey)) {
                                    if (startIndex === -1) startIndex = recordIndex;
                                    else {
                                        endIndex = recordIndex;
                                        return true;
                                    }
                                }
                                return false;
                            });
                        }
                        if (endIndex !== -1 && startIndex !== endIndex && checkStrictly) {
                            // Batch update selections
                            var rangeKeys = recordKeys.slice(startIndex, endIndex + 1);
                            var changedKeys = [];
                            if (checked) rangeKeys.forEach(function(recordKey) {
                                if (keySet.has(recordKey)) {
                                    changedKeys.push(recordKey);
                                    keySet["delete"](recordKey);
                                }
                            });
                            else rangeKeys.forEach(function(recordKey) {
                                if (!keySet.has(recordKey)) {
                                    changedKeys.push(recordKey);
                                    keySet.add(recordKey);
                                }
                            });
                            var keys = Array.from(keySet);
                            onSelectMultiple === null || onSelectMultiple === void 0 || onSelectMultiple(!checked, keys.map(function(recordKey) {
                                return getRecordByKey(recordKey);
                            }), changedKeys.map(function(recordKey) {
                                return getRecordByKey(recordKey);
                            }));
                            setSelectedKeys(keys, 'multiple');
                        } else {
                            // Single record selected
                            var originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                var checkedKeys = checked ? (0, $f4FkX.arrDel)(originCheckedKeys, key) : (0, $f4FkX.arrAdd)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                var result = (0, $6EgAF.conductCheck)([].concat((0, $kbxxf.default)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                var _checkedKeys = result.checkedKeys, halfCheckedKeys = result.halfCheckedKeys;
                                var nextCheckedKeys = _checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    var tempKeySet = new Set(_checkedKeys);
                                    tempKeySet["delete"](key);
                                    nextCheckedKeys = (0, $6EgAF.conductCheck)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) setLastSelectedKey(null);
                        else setLastSelectedKey(key);
                    }
                })),
                checked: checked
            };
        };
        var renderSelectionCell = function renderSelectionCell(_, record, index) {
            var _renderCell = renderCell(_, record, index), node = _renderCell.node, checked = _renderCell.checked;
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($e201eb08b7050f4b$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex(function(col) {
                var _a;
                return ((_a = col[0, $aLkKv.INTERNAL_COL_DEFINE]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN';
            }) === 0) {
                var _cloneColumns = cloneColumns, _cloneColumns2 = (0, $aJJ3v.default)(_cloneColumns), expandColumn = _cloneColumns2[0], restColumns = _cloneColumns2.slice(1);
                cloneColumns = [
                    expandColumn,
                    $e201eb08b7050f4b$export$ed10248435b8f218
                ].concat((0, $kbxxf.default)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $e201eb08b7050f4b$export$ed10248435b8f218
            ].concat((0, $kbxxf.default)(cloneColumns));
        }
        // Deduplicate selection column
        var selectionColumnIndex = cloneColumns.indexOf($e201eb08b7050f4b$export$ed10248435b8f218);
        cloneColumns = cloneColumns.filter(function(column, index) {
            return column !== $e201eb08b7050f4b$export$ed10248435b8f218 || index === selectionColumnIndex;
        });
        // Fixed column logic
        var prevCol = cloneColumns[selectionColumnIndex - 1];
        var nextCol = cloneColumns[selectionColumnIndex + 1];
        var mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== undefined) mergedFixed = nextCol.fixed;
            else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && ((_a = prevCol[0, $aLkKv.INTERNAL_COL_DEFINE]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN' && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        // Replace with real selection column
        var selectionColumn = (0, $kSlfw.default)({
            fixed: mergedFixed,
            width: selectionColWidth,
            className: "".concat(prefixCls, "-selection-column"),
            title: rowSelection.columnTitle || title,
            render: renderSelectionCell
        }, (0, $aLkKv.INTERNAL_COL_DEFINE), {
            className: "".concat(prefixCls, "-selection-col")
        });
        return cloneColumns.map(function(col) {
            return col === $e201eb08b7050f4b$export$ed10248435b8f218 ? selectionColumn : col;
        });
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        lastSelectedKey,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
}



var $eUqlC = parcelRequire("eUqlC");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $749787560a770a62$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
var $749787560a770a62$export$2e2bcd8739ae039 = $749787560a770a62$var$CaretDownOutlined;



var $652126080848e9cc$var$CaretDownOutlined = function CaretDownOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $749787560a770a62$export$2e2bcd8739ae039)
    }));
};
var $652126080848e9cc$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($652126080848e9cc$var$CaretDownOutlined);
var $652126080848e9cc$export$2e2bcd8739ae039 = $652126080848e9cc$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $478fce407c73001f$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
var $478fce407c73001f$export$2e2bcd8739ae039 = $478fce407c73001f$var$CaretUpOutlined;



var $8f7437cd9364c832$var$CaretUpOutlined = function CaretUpOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $478fce407c73001f$export$2e2bcd8739ae039)
    }));
};
var $8f7437cd9364c832$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($8f7437cd9364c832$var$CaretUpOutlined);
var $8f7437cd9364c832$export$2e2bcd8739ae039 = $8f7437cd9364c832$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");


var $71f5389ed963960f$var$ASCEND = 'ascend';
var $71f5389ed963960f$var$DESCEND = 'descend';
function $71f5389ed963960f$var$getMultiplePriority(column) {
    if ((0, $fSwVM.default)(column.sorter) === 'object' && typeof column.sorter.multiple === 'number') return column.sorter.multiple;
    return false;
}
function $71f5389ed963960f$var$getSortFunction(sorter) {
    if (typeof sorter === 'function') return sorter;
    if (sorter && (0, $fSwVM.default)(sorter) === 'object' && sorter.compare) return sorter.compare;
    return false;
}
function $71f5389ed963960f$var$nextSortDirection(sortDirections, current) {
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
}
function $71f5389ed963960f$var$collectSortStates(columns, init, pos) {
    var sortStates = [];
    function pushState(column, columnPos) {
        sortStates.push({
            column: column,
            key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    }
    (columns || []).forEach(function(column, index) {
        var columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $kbxxf.default)(sortStates), (0, $kbxxf.default)($71f5389ed963960f$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
}
function $71f5389ed963960f$var$injectSorter(prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) {
    return (columns || []).map(function(column, index) {
        var columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        var newColumn = column;
        if (newColumn.sorter) {
            var sortDirections = newColumn.sortDirections || defaultSortDirections;
            var showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            var columnKey = (0, $10b8a922ada6c9c1$export$480219a02f196e72)(newColumn, columnPos);
            var sorterState = sorterStates.find(function(_ref) {
                var key = _ref.key;
                return key === columnKey;
            });
            var sorterOrder = sorterState ? sorterState.sortOrder : null;
            var nextSortOrder = $71f5389ed963960f$var$nextSortDirection(sortDirections, sorterOrder);
            var upNode = sortDirections.includes($71f5389ed963960f$var$ASCEND) && /*#__PURE__*/ $acw62.createElement((0, $8f7437cd9364c832$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-column-sorter-up"), {
                    active: sorterOrder === $71f5389ed963960f$var$ASCEND
                }),
                role: "presentation"
            });
            var downNode = sortDirections.includes($71f5389ed963960f$var$DESCEND) && /*#__PURE__*/ $acw62.createElement((0, $652126080848e9cc$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-column-sorter-down"), {
                    active: sorterOrder === $71f5389ed963960f$var$DESCEND
                }),
                role: "presentation"
            });
            var _ref2 = tableLocale || {}, cancelSort = _ref2.cancelSort, triggerAsc = _ref2.triggerAsc, triggerDesc = _ref2.triggerDesc;
            var sortTip = cancelSort;
            if (nextSortOrder === $71f5389ed963960f$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $71f5389ed963960f$var$ASCEND) sortTip = triggerAsc;
            var tooltipProps = (0, $fSwVM.default)(showSorterTooltip) === 'object' ? showSorterTooltip : {
                title: sortTip
            };
            newColumn = (0, $8nd05.default)((0, $8nd05.default)({}, newColumn), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(newColumn.className, (0, $kSlfw.default)({}, "".concat(prefixCls, "-column-sort"), sorterOrder)),
                title: function title(renderProps) {
                    var renderSortTitle = /*#__PURE__*/ $acw62.createElement("div", {
                        className: "".concat(prefixCls, "-column-sorters")
                    }, /*#__PURE__*/ $acw62.createElement("span", {
                        className: "".concat(prefixCls, "-column-title")
                    }, (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, renderProps)), /*#__PURE__*/ $acw62.createElement("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-column-sorter"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-column-sorter-full"), !!(upNode && downNode)))
                    }, /*#__PURE__*/ $acw62.createElement("span", {
                        className: "".concat(prefixCls, "-column-sorter-inner")
                    }, upNode, downNode)));
                    return showSorterTooltip ? /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), (0, $8nd05.default)({}, tooltipProps), renderSortTitle) : renderSortTitle;
                },
                onHeaderCell: function onHeaderCell(col) {
                    var cell = column.onHeaderCell && column.onHeaderCell(col) || {};
                    var originOnClick = cell.onClick;
                    var originOKeyDown = cell.onKeyDown;
                    cell.onClick = function(event) {
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column)
                        });
                        originOnClick === null || originOnClick === void 0 || originOnClick(event);
                    };
                    cell.onKeyDown = function(event) {
                        if (event.keyCode === (0, $iCi4s.default).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column)
                            });
                            originOKeyDown === null || originOKeyDown === void 0 || originOKeyDown(event);
                        }
                    };
                    var renderTitle = (0, $10b8a922ada6c9c1$export$1c24e0676a106839)(column.title, {});
                    var displayTitle = renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sorterOrder) cell['aria-sort'] = sorterOrder === 'ascend' ? 'ascending' : 'descending';
                    else cell['aria-label'] = displayTitle || '';
                    cell.className = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(cell.className, "".concat(prefixCls, "-column-has-sorters"));
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle !== null && renderTitle !== void 0 ? renderTitle : '').toString();
                    return cell;
                }
            });
        }
        if ('children' in newColumn) newColumn = (0, $8nd05.default)((0, $8nd05.default)({}, newColumn), {
            children: $71f5389ed963960f$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
        });
        return newColumn;
    });
}
function $71f5389ed963960f$var$stateToInfo(sorterStates) {
    var column = sorterStates.column, sortOrder = sorterStates.sortOrder;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
}
function $71f5389ed963960f$var$generateSorterInfo(sorterStates) {
    var list = sorterStates.filter(function(_ref3) {
        var sortOrder = _ref3.sortOrder;
        return sortOrder;
    }).map($71f5389ed963960f$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (list.length === 0 && sorterStates.length) return (0, $8nd05.default)((0, $8nd05.default)({}, $71f5389ed963960f$var$stateToInfo(sorterStates[sorterStates.length - 1])), {
        column: undefined
    });
    if (list.length <= 1) return list[0] || {};
    return list;
}
function $71f5389ed963960f$export$594b2c8da4a70ee(data, sortStates, childrenColumnName) {
    var innerSorterStates = sortStates.slice().sort(function(a, b) {
        return b.multiplePriority - a.multiplePriority;
    });
    var cloneData = data.slice();
    var runningSorters = innerSorterStates.filter(function(_ref4) {
        var sorter = _ref4.column.sorter, sortOrder = _ref4.sortOrder;
        return $71f5389ed963960f$var$getSortFunction(sorter) && sortOrder;
    });
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort(function(record1, record2) {
        for(var i = 0; i < runningSorters.length; i += 1){
            var sorterState = runningSorters[i];
            var sorter = sorterState.column.sorter, sortOrder = sorterState.sortOrder;
            var compareFn = $71f5389ed963960f$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                var compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $71f5389ed963960f$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map(function(record) {
        var subRecords = record[childrenColumnName];
        if (subRecords) return (0, $8nd05.default)((0, $8nd05.default)({}, record), (0, $kSlfw.default)({}, childrenColumnName, $71f5389ed963960f$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)));
        return record;
    });
}
function $71f5389ed963960f$export$2e2bcd8739ae039(_ref5) {
    var prefixCls = _ref5.prefixCls, mergedColumns = _ref5.mergedColumns, onSorterChange = _ref5.onSorterChange, sortDirections = _ref5.sortDirections, tableLocale = _ref5.tableLocale, showSorterTooltip = _ref5.showSorterTooltip;
    var _React$useState = $acw62.useState($71f5389ed963960f$var$collectSortStates(mergedColumns, true)), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), sortStates = _React$useState2[0], setSortStates = _React$useState2[1];
    var mergedSorterStates = $acw62.useMemo(function() {
        var validate = true;
        var collectedStates = $71f5389ed963960f$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) return sortStates;
        var validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push((0, $8nd05.default)((0, $8nd05.default)({}, state), {
                sortOrder: null
            }));
        }
        var multipleMode = null;
        collectedStates.forEach(function(state) {
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    var columnTitleSorterProps = $acw62.useMemo(function() {
        var sortColumns = mergedSorterStates.map(function(_ref6) {
            var column = _ref6.column, sortOrder = _ref6.sortOrder;
            return {
                column: column,
                order: sortOrder
            };
        });
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: sortColumns[0] && sortColumns[0].column,
            sortOrder: sortColumns[0] && sortColumns[0].order
        };
    }, [
        mergedSorterStates
    ]);
    function triggerSorter(sortState) {
        var newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $kbxxf.default)(mergedSorterStates.filter(function(_ref7) {
            var key = _ref7.key;
            return key !== sortState.key;
        })), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($71f5389ed963960f$var$generateSorterInfo(newSorterStates), newSorterStates);
    }
    var transformColumns = function transformColumns(innerColumns) {
        return $71f5389ed963960f$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
    };
    var getSorters = function getSorters() {
        return $71f5389ed963960f$var$generateSorterInfo(mergedSorterStates);
    };
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

function $6bcbe2fbe72fb80a$var$fillTitle(columns, columnTitleProps) {
    return columns.map(function(column) {
        var cloneColumn = (0, $8nd05.default)({}, column);
        cloneColumn.title = (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ('children' in cloneColumn) cloneColumn.children = $6bcbe2fbe72fb80a$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
}
function $6bcbe2fbe72fb80a$export$2e2bcd8739ae039(columnTitleProps) {
    var filledColumns = $acw62.useCallback(function(columns) {
        return $6bcbe2fbe72fb80a$var$fillTitle(columns, columnTitleProps);
    }, [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
}


var $57b3d2664e78424f$var$EMPTY_LIST = [];
function $57b3d2664e78424f$var$InternalTable(props, ref) {
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, customizeSize = props.size, bordered = props.bordered, customizeDropdownPrefixCls = props.dropdownPrefixCls, dataSource = props.dataSource, pagination = props.pagination, rowSelection = props.rowSelection, _props$rowKey = props.rowKey, rowKey = _props$rowKey === void 0 ? 'key' : _props$rowKey, rowClassName = props.rowClassName, columns = props.columns, children = props.children, legacyChildrenColumnName = props.childrenColumnName, onChange = props.onChange, getPopupContainer = props.getPopupContainer, loading = props.loading, expandIcon = props.expandIcon, expandable = props.expandable, expandedRowRender = props.expandedRowRender, expandIconColumnIndex = props.expandIconColumnIndex, indentSize = props.indentSize, scroll = props.scroll, sortDirections = props.sortDirections, locale = props.locale, _props$showSorterTool = props.showSorterTooltip, showSorterTooltip = _props$showSorterTool === void 0 ? true : _props$showSorterTool;
    [
        [
            'filterDropdownVisible',
            'filterDropdownOpen'
        ],
        [
            'onFilterDropdownVisibleChange',
            'onFilterDropdownOpenChange'
        ]
    ].forEach(function(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 2), deprecatedName = _ref2[0], newName = _ref2[1];
    });
    var baseColumns = $acw62.useMemo(function() {
        return columns || (0, $89kiB.convertChildrenToColumns)(children);
    }, [
        columns,
        children
    ]);
    var needResponsive = $acw62.useMemo(function() {
        return baseColumns.some(function(col) {
            return col.responsive;
        });
    }, [
        baseColumns
    ]);
    var screens = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(needResponsive);
    var mergedColumns = $acw62.useMemo(function() {
        var matched = new Set(Object.keys(screens).filter(function(m) {
            return screens[m];
        }));
        return baseColumns.filter(function(c) {
            return !c.responsive || c.responsive.some(function(r) {
                return matched.has(r);
            });
        });
    }, [
        baseColumns,
        screens
    ]);
    var tableProps = (0, $1pcHX.default)(props, [
        'className',
        'style',
        'columns'
    ]);
    var size = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), _React$useContext$loc = _React$useContext.locale, contextLocale = _React$useContext$loc === void 0 ? (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039) : _React$useContext$loc, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction;
    var mergedSize = customizeSize || size;
    var tableLocale = (0, $8nd05.default)((0, $8nd05.default)({}, contextLocale.Table), locale);
    var rawData = dataSource || $57b3d2664e78424f$var$EMPTY_LIST;
    var _React$useContext2 = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext2.getPrefixCls;
    var prefixCls = getPrefixCls('table', customizePrefixCls);
    var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
    var mergedExpandable = (0, $8nd05.default)({
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex
    }, expandable);
    var _mergedExpandable$chi = mergedExpandable.childrenColumnName, childrenColumnName = _mergedExpandable$chi === void 0 ? 'children' : _mergedExpandable$chi;
    var expandType = $acw62.useMemo(function() {
        if (rawData.some(function(item) {
            return item === null || item === void 0 ? void 0 : item[childrenColumnName];
        })) return 'nest';
        if (expandedRowRender || expandable && expandable.expandedRowRender) return 'row';
        return null;
    }, [
        rawData
    ]);
    var internalRefs = {
        body: $acw62.useRef()
    };
    // ============================ RowKey ============================
    var getRowKey = $acw62.useMemo(function() {
        if (typeof rowKey === 'function') return rowKey;
        return function(record) {
            return record === null || record === void 0 ? void 0 : record[rowKey];
        };
    }, [
        rowKey
    ]);
    var _useLazyKVMap = (0, $e2770d04bc76b8cc$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey), _useLazyKVMap2 = (0, $eUqlC.default)(_useLazyKVMap, 1), getRecordByKey = _useLazyKVMap2[0];
    // ============================ Events =============================
    var changeEventInfo = {};
    var triggerOnChange = function triggerOnChange(info, action) {
        var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var changeInfo = (0, $8nd05.default)((0, $8nd05.default)({}, changeEventInfo), info);
        if (reset) {
            changeEventInfo.resetPagination();
            // Reset event param
            if (changeInfo.pagination.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination && pagination.onChange) pagination.onChange(1, changeInfo.pagination.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) (0, $4262b79604674a3c$export$2e2bcd8739ae039)(0, {
            getContainer: function getContainer() {
                return internalRefs.body.current;
            }
        });
        onChange === null || onChange === void 0 || onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $498593f51893a533$export$37643bb40f4c1c56)((0, $71f5389ed963960f$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    var onSorterChange = function onSorterChange(sorter, sorterStates) {
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, 'sort', false);
    };
    var _useSorter = (0, $71f5389ed963960f$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            'ascend',
            'descend'
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip
    }), _useSorter2 = (0, $eUqlC.default)(_useSorter, 4), transformSorterColumns = _useSorter2[0], sortStates = _useSorter2[1], sorterTitleProps = _useSorter2[2], getSorters = _useSorter2[3];
    var sortedData = $acw62.useMemo(function() {
        return (0, $71f5389ed963960f$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName);
    }, [
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    var onFilterChange = function onFilterChange(filters, filterStates) {
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, 'filter', true);
    };
    var _useFilter = (0, $498593f51893a533$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer
    }), _useFilter2 = (0, $eUqlC.default)(_useFilter, 3), transformFilterColumns = _useFilter2[0], filterStates = _useFilter2[1], filters = _useFilter2[2];
    var mergedData = (0, $498593f51893a533$export$37643bb40f4c1c56)(sortedData, filterStates);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    var columnTitleProps = $acw62.useMemo(function() {
        var mergedFilters = {};
        Object.keys(filters).forEach(function(filterKey) {
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return (0, $8nd05.default)((0, $8nd05.default)({}, sorterTitleProps), {
            filters: mergedFilters
        });
    }, [
        sorterTitleProps,
        filters
    ]);
    var _useTitleColumns = (0, $6bcbe2fbe72fb80a$export$2e2bcd8739ae039)(columnTitleProps), _useTitleColumns2 = (0, $eUqlC.default)(_useTitleColumns, 1), transformTitleColumns = _useTitleColumns2[0];
    // ========================== Pagination ==========================
    var onPaginationChange = function onPaginationChange(current, pageSize) {
        triggerOnChange({
            pagination: (0, $8nd05.default)((0, $8nd05.default)({}, changeEventInfo.pagination), {
                current: current,
                pageSize: pageSize
            })
        }, 'paginate');
    };
    var _usePagination = (0, $b37c5a68d8297fb7$export$2e2bcd8739ae039)(mergedData.length, pagination, onPaginationChange), _usePagination2 = (0, $eUqlC.default)(_usePagination, 2), mergedPagination = _usePagination2[0], resetPagination = _usePagination2[1];
    changeEventInfo.pagination = pagination === false ? {} : (0, $b37c5a68d8297fb7$export$27eceeed7bf0f4c2)(pagination, mergedPagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    var pageData = $acw62.useMemo(function() {
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        var _mergedPagination$cur = mergedPagination.current, current = _mergedPagination$cur === void 0 ? 1 : _mergedPagination$cur, total = mergedPagination.total, _mergedPagination$pag = mergedPagination.pageSize, pageSize = _mergedPagination$pag === void 0 ? (0, $b37c5a68d8297fb7$export$5716e8bcb003888d) : _mergedPagination$pag;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination && mergedPagination.current,
        mergedPagination && mergedPagination.pageSize,
        mergedPagination && mergedPagination.total
    ]);
    // ========================== Selections ==========================
    var _useSelection = (0, $e201eb08b7050f4b$export$2e2bcd8739ae039)(rowSelection, {
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer
    }), _useSelection2 = (0, $eUqlC.default)(_useSelection, 2), transformSelectionColumns = _useSelection2[0], selectedKeySet = _useSelection2[1];
    var internalRowClassName = function internalRowClassName(record, index, indent) {
        var mergedRowClassName;
        if (typeof rowClassName === 'function') mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rowClassName(record, index, indent));
        else mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rowClassName);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-row-selected"), selectedKeySet.has(getRowKey(record, index))), mergedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `rc-table`, this can be removed when refactor with `rc-table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $8f25299cf0da5780$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== 'number') mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
    // ============================ Render ============================
    var transformColumns = $acw62.useCallback(function(innerColumns) {
        return transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns))));
    }, [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    var topPaginationNode;
    var bottomPaginationNode;
    if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
        var paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
        var renderPagination = function renderPagination(position) {
            return /*#__PURE__*/ $acw62.createElement((0, $457c0f7bc166788c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, mergedPagination, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-pagination ").concat(prefixCls, "-pagination-").concat(position), mergedPagination.className),
                size: paginationSize
            }));
        };
        var defaultPosition = direction === 'rtl' ? 'left' : 'right';
        var position = mergedPagination.position;
        if (position !== null && Array.isArray(position)) {
            var topPos = position.find(function(p) {
                return p.includes('top');
            });
            var bottomPos = position.find(function(p) {
                return p.includes('bottom');
            });
            var isDisable = position.every(function(p) {
                return "".concat(p) === 'none';
            });
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination(defaultPosition);
            if (topPos) topPaginationNode = renderPagination(topPos.toLowerCase().replace('top', ''));
            if (bottomPos) bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace('bottom', ''));
        } else bottomPaginationNode = renderPagination(defaultPosition);
    }
    // >>>>>>>>> Spinning
    var spinProps;
    if (typeof loading === 'boolean') spinProps = {
        spinning: loading
    };
    else if ((0, $fSwVM.default)(loading) === 'object') spinProps = (0, $8nd05.default)({
        spinning: true
    }, loading);
    var wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-wrapper"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref,
        className: wrapperClassNames,
        style: style
    }, /*#__PURE__*/ $acw62.createElement((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), (0, $8nd05.default)({
        spinning: false
    }, spinProps), topPaginationNode, /*#__PURE__*/ $acw62.createElement((0, $4XkeF.default), (0, $8nd05.default)({}, tableProps, {
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-middle"), mergedSize === 'middle'), "".concat(prefixCls, "-small"), mergedSize === 'small'), "".concat(prefixCls, "-bordered"), bordered), "".concat(prefixCls, "-empty"), rawData.length === 0)),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: locale && locale.emptyText || (renderEmpty || (0, $3feb83783705e448$export$2e2bcd8739ae039))('Table'),
        // Internal
        internalHooks: (0, $lLawD.INTERNAL_HOOKS),
        internalRefs: internalRefs,
        transformColumns: transformColumns
    })), bottomPaginationNode));
}
var $57b3d2664e78424f$var$ForwardTable = /*#__PURE__*/ $acw62.forwardRef($57b3d2664e78424f$var$InternalTable);
var $57b3d2664e78424f$var$Table = $57b3d2664e78424f$var$ForwardTable;
$57b3d2664e78424f$var$Table.SELECTION_COLUMN = (0, $e201eb08b7050f4b$export$ed10248435b8f218);
$57b3d2664e78424f$var$Table.EXPAND_COLUMN = (0, $4XkeF.default).EXPAND_COLUMN;
$57b3d2664e78424f$var$Table.SELECTION_ALL = (0, $e201eb08b7050f4b$export$14159cd9e2a500c8);
$57b3d2664e78424f$var$Table.SELECTION_INVERT = (0, $e201eb08b7050f4b$export$625c4f68eaaf8cfd);
$57b3d2664e78424f$var$Table.SELECTION_NONE = (0, $e201eb08b7050f4b$export$c1a725540f5a63bd);
$57b3d2664e78424f$var$Table.Column = (0, $fad2a96b4c8bbab5$export$2e2bcd8739ae039);
$57b3d2664e78424f$var$Table.ColumnGroup = (0, $836a2b733f2d0243$export$2e2bcd8739ae039);
$57b3d2664e78424f$var$Table.Summary = (0, $64oV2.FooterComponents);
var $57b3d2664e78424f$export$2e2bcd8739ae039 = $57b3d2664e78424f$var$Table;


var $de80f58eedfd6ef7$export$2e2bcd8739ae039 = (0, $57b3d2664e78424f$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");


function $48f4fe50ff6ca9c8$var$_extends() {
    $48f4fe50ff6ca9c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f4fe50ff6ca9c8$var$_extends.apply(this, arguments);
}
const $48f4fe50ff6ca9c8$var$EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $48f4fe50ff6ca9c8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $70c4e92fea0b3f8a$export$2e2bcd8739ae039)
    }));
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ const $48f4fe50ff6ca9c8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($48f4fe50ff6ca9c8$var$EyeInvisibleOutlined);
var $48f4fe50ff6ca9c8$export$2e2bcd8739ae039 = $48f4fe50ff6ca9c8$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c28f15ff238136d1$var$PlusCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "plus-circle",
    "theme": "outlined"
};
var $c28f15ff238136d1$export$2e2bcd8739ae039 = $c28f15ff238136d1$var$PlusCircleOutlined;



function $70557e7c8fc4335b$var$_extends() {
    $70557e7c8fc4335b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70557e7c8fc4335b$var$_extends.apply(this, arguments);
}
const $70557e7c8fc4335b$var$PlusCircleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $70557e7c8fc4335b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c28f15ff238136d1$export$2e2bcd8739ae039)
    }));
/**![plus-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY5NiA0ODBINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgxNTJ2MTUyYzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNTQ0aDE1MmM0LjQgMCA4LTMuNiA4LTh2LTQ4YzAtNC40LTMuNi04LTgtOHoiIC8+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PC9zdmc+) */ const $70557e7c8fc4335b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($70557e7c8fc4335b$var$PlusCircleOutlined);
var $70557e7c8fc4335b$export$2e2bcd8739ae039 = $70557e7c8fc4335b$var$RefIcon;




var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");

var $u43uR = parcelRequire("u43uR");
var $e25928f3c37eefb3$var$generateConfig = {
    // get
    getNow: function getNow() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
    },
    getFixedDate: function getFixedDate(string) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(string, 'YYYY-MM-DD');
    },
    getEndDate: function getEndDate(date) {
        var clone = date.clone();
        return clone.endOf('month');
    },
    getWeekDay: function getWeekDay(date) {
        var clone = date.clone().locale('en_US');
        return clone.weekday() + clone.localeData().firstDayOfWeek();
    },
    getYear: function getYear(date) {
        return date.year();
    },
    getMonth: function getMonth(date) {
        return date.month();
    },
    getDate: function getDate(date) {
        return date.date();
    },
    getHour: function getHour(date) {
        return date.hour();
    },
    getMinute: function getMinute(date) {
        return date.minute();
    },
    getSecond: function getSecond(date) {
        return date.second();
    },
    // set
    addYear: function addYear(date, diff) {
        var clone = date.clone();
        return clone.add(diff, 'year');
    },
    addMonth: function addMonth(date, diff) {
        var clone = date.clone();
        return clone.add(diff, 'month');
    },
    addDate: function addDate(date, diff) {
        var clone = date.clone();
        return clone.add(diff, 'day');
    },
    setYear: function setYear(date, year) {
        var clone = date.clone();
        return clone.year(year);
    },
    setMonth: function setMonth(date, month) {
        var clone = date.clone();
        return clone.month(month);
    },
    setDate: function setDate(date, num) {
        var clone = date.clone();
        return clone.date(num);
    },
    setHour: function setHour(date, hour) {
        var clone = date.clone();
        return clone.hour(hour);
    },
    setMinute: function setMinute(date, minute) {
        var clone = date.clone();
        return clone.minute(minute);
    },
    setSecond: function setSecond(date, second) {
        var clone = date.clone();
        return clone.second(second);
    },
    // Compare
    isAfter: function isAfter(date1, date2) {
        return date1.isAfter(date2);
    },
    isValidate: function isValidate(date) {
        return date.isValid();
    },
    locale: {
        getWeekFirstDay: function getWeekFirstDay(locale) {
            var date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().locale(locale);
            return date.localeData().firstDayOfWeek();
        },
        getWeekFirstDate: function getWeekFirstDate(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.weekday(0);
        },
        getWeek: function getWeek(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.week();
        },
        getShortWeekDays: function getShortWeekDays(locale) {
            var date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().locale(locale);
            return date.localeData().weekdaysMin();
        },
        getShortMonths: function getShortMonths(locale) {
            var date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().locale(locale);
            return date.localeData().monthsShort();
        },
        format: function format(locale, date, _format) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.format(_format);
        },
        parse: function parse(locale, text, formats) {
            var fallbackFormatList = [];
            for(var i = 0; i < formats.length; i += 1){
                var format = formats[i];
                var formatText = text;
                if (format.includes('wo') || format.includes('Wo')) {
                    format = format.replace(/wo/g, 'w').replace(/Wo/g, 'W');
                    var matchFormat = format.match(/[-YyMmDdHhSsWwGg]+/g);
                    var matchText = formatText.match(/[-\d]+/g);
                    if (matchFormat && matchText) {
                        format = matchFormat.join('');
                        formatText = matchText.join('');
                    } else fallbackFormatList.push(format.replace(/o/g, ''));
                }
                var date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(formatText, format, locale, true);
                if (date.isValid()) return date;
            }
            // Fallback to fuzzy matching, this should always not reach match or need fire a issue
            for(var _i = 0; _i < fallbackFormatList.length; _i += 1){
                var _date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(text, fallbackFormatList[_i], locale, false);
                /* istanbul ignore next */ if (_date.isValid()) {
                    (0, $u43uR.noteOnce)(false, 'Not match any format strictly and fallback to fuzzy match. Please help to fire a issue about this.');
                    return _date;
                }
            }
            return null;
        }
    }
};
var $e25928f3c37eefb3$export$2e2bcd8739ae039 = $e25928f3c37eefb3$var$generateConfig;



var $8nd05 = parcelRequire("8nd05");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

function $120fea39506aac9a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), (0, $8nd05.default)({
        size: "small",
        type: "primary"
    }, props));
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");


var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");





var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8aa648d8fa6484b7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8aa648d8fa6484b7$var$CheckableTag = function CheckableTag(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, checked = _a.checked, onChange = _a.onChange, onClick = _a.onClick, restProps = $8aa648d8fa6484b7$var$__rest(_a, [
        "prefixCls",
        "className",
        "checked",
        "onChange",
        "onClick"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var handleClick = function handleClick(e) {
        onChange === null || onChange === void 0 || onChange(!checked);
        onClick === null || onClick === void 0 || onClick(e);
    };
    var prefixCls = getPrefixCls('tag', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-checkable"), true), "".concat(prefixCls, "-checkable-checked"), checked), className);
    return /*#__PURE__*/ $acw62.createElement("span", (0, $8nd05.default)({}, restProps, {
        className: cls,
        onClick: handleClick
    }));
};
var $8aa648d8fa6484b7$export$2e2bcd8739ae039 = $8aa648d8fa6484b7$var$CheckableTag;


var $91f0876852f6510f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $91f0876852f6510f$var$PresetColorRegex = new RegExp("^(".concat((0, $1513ceb924eda9b6$export$37ea70cc324d3d0e).join('|'), ")(-inverse)?$"));
var $91f0876852f6510f$var$PresetStatusColorRegex = new RegExp("^(".concat((0, $1513ceb924eda9b6$export$bb684163c94c55ae).join('|'), ")$"));
var $91f0876852f6510f$var$InternalTag = function InternalTag(_a, ref) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, icon = _a.icon, color = _a.color, onClose = _a.onClose, closeIcon = _a.closeIcon, _a$closable = _a.closable, closable = _a$closable === void 0 ? false : _a$closable, props = $91f0876852f6510f$var$__rest(_a, [
        "prefixCls",
        "className",
        "style",
        "children",
        "icon",
        "color",
        "onClose",
        "closeIcon",
        "closable"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState = $acw62.useState(true), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    $acw62.useEffect(function() {
        if ('visible' in props) setVisible(props.visible);
    }, [
        props.visible
    ]);
    var isPresetColor = function isPresetColor() {
        if (!color) return false;
        return $91f0876852f6510f$var$PresetColorRegex.test(color) || $91f0876852f6510f$var$PresetStatusColorRegex.test(color);
    };
    var tagStyle = (0, $8nd05.default)({
        backgroundColor: color && !isPresetColor() ? color : undefined
    }, style);
    var presetColor = isPresetColor();
    var prefixCls = getPrefixCls('tag', customizePrefixCls);
    var tagClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(color), presetColor), "".concat(prefixCls, "-has-color"), color && !presetColor), "".concat(prefixCls, "-hidden"), !visible), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var handleCloseClick = function handleCloseClick(e) {
        e.stopPropagation();
        onClose === null || onClose === void 0 || onClose(e);
        if (e.defaultPrevented) return;
        if (!('visible' in props)) setVisible(false);
    };
    var renderCloseIcon = function renderCloseIcon() {
        if (closable) return closeIcon ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-close-icon"),
            onClick: handleCloseClick
        }, closeIcon) : /*#__PURE__*/ $acw62.createElement((0, $31b8ddc4065205d5$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-close-icon"),
            onClick: handleCloseClick
        });
        return null;
    };
    var isNeedWave = 'onClick' in props || children && children.type === 'a';
    var tagProps = (0, $1pcHX.default)(props, [
        'visible'
    ]);
    var iconNode = icon || null;
    var kids = iconNode ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, iconNode, /*#__PURE__*/ $acw62.createElement("span", null, children)) : children;
    var tagNode = /*#__PURE__*/ $acw62.createElement("span", (0, $8nd05.default)({}, tagProps, {
        ref: ref,
        className: tagClassName,
        style: tagStyle
    }), kids, renderCloseIcon());
    return isNeedWave ? /*#__PURE__*/ $acw62.createElement((0, $4efa89abfa6bbc97$export$2e2bcd8739ae039), null, tagNode) : tagNode;
};
var $91f0876852f6510f$var$Tag = /*#__PURE__*/ $acw62.forwardRef($91f0876852f6510f$var$InternalTag);
$91f0876852f6510f$var$Tag.CheckableTag = (0, $8aa648d8fa6484b7$export$2e2bcd8739ae039);
var $91f0876852f6510f$export$2e2bcd8739ae039 = $91f0876852f6510f$var$Tag;


function $d7b6d277775e8147$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ $acw62.createElement((0, $91f0876852f6510f$export$2e2bcd8739ae039), (0, $8nd05.default)({
        color: "blue"
    }, props));
}



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8c67ef127e0e71f8$var$CalendarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    },
    "name": "calendar",
    "theme": "outlined"
};
var $8c67ef127e0e71f8$export$2e2bcd8739ae039 = $8c67ef127e0e71f8$var$CalendarOutlined;



var $d851d821d19b0360$var$CalendarOutlined = function CalendarOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8c67ef127e0e71f8$export$2e2bcd8739ae039)
    }));
};
var $d851d821d19b0360$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d851d821d19b0360$var$CalendarOutlined);
var $d851d821d19b0360$export$2e2bcd8739ae039 = $d851d821d19b0360$var$RefIcon;



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $beb0f4a2bf4b9d4a$var$ClockCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    },
    "name": "clock-circle",
    "theme": "outlined"
};
var $beb0f4a2bf4b9d4a$export$2e2bcd8739ae039 = $beb0f4a2bf4b9d4a$var$ClockCircleOutlined;



var $287c658c921bcb82$var$ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $beb0f4a2bf4b9d4a$export$2e2bcd8739ae039)
    }));
};
var $287c658c921bcb82$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($287c658c921bcb82$var$ClockCircleOutlined);
var $287c658c921bcb82$export$2e2bcd8739ae039 = $287c658c921bcb82$var$RefIcon;




var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $77391dbfa9c13c1b$var$SwapRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    },
    "name": "swap-right",
    "theme": "outlined"
};
var $77391dbfa9c13c1b$export$2e2bcd8739ae039 = $77391dbfa9c13c1b$var$SwapRightOutlined;



var $a5709050fb04d86d$var$SwapRightOutlined = function SwapRightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $77391dbfa9c13c1b$export$2e2bcd8739ae039)
    }));
};
var $a5709050fb04d86d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($a5709050fb04d86d$var$SwapRightOutlined);
var $a5709050fb04d86d$export$2e2bcd8739ae039 = $a5709050fb04d86d$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $u43uR = parcelRequire("u43uR");

var $iSQh8 = parcelRequire("iSQh8");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $u43uR = parcelRequire("u43uR");

var $iSQh8 = parcelRequire("iSQh8");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $cb588b5e3538bcc3$var$PanelContext = /*#__PURE__*/ $acw62.createContext({});
var $cb588b5e3538bcc3$export$2e2bcd8739ae039 = $cb588b5e3538bcc3$var$PanelContext;


var $535ef290f7dfaebe$var$HIDDEN_STYLE = {
    visibility: 'hidden'
};
function $535ef290f7dfaebe$var$Header(_ref) {
    var prefixCls = _ref.prefixCls, _ref$prevIcon = _ref.prevIcon, prevIcon = _ref$prevIcon === void 0 ? "\u2039" : _ref$prevIcon, _ref$nextIcon = _ref.nextIcon, nextIcon = _ref$nextIcon === void 0 ? "\u203A" : _ref$nextIcon, _ref$superPrevIcon = _ref.superPrevIcon, superPrevIcon = _ref$superPrevIcon === void 0 ? "\xAB" : _ref$superPrevIcon, _ref$superNextIcon = _ref.superNextIcon, superNextIcon = _ref$superNextIcon === void 0 ? "\xBB" : _ref$superNextIcon, onSuperPrev = _ref.onSuperPrev, onSuperNext = _ref.onSuperNext, onPrev = _ref.onPrev, onNext = _ref.onNext, children = _ref.children;
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), hideNextBtn = _React$useContext.hideNextBtn, hidePrevBtn = _React$useContext.hidePrevBtn;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: prefixCls
    }, onSuperPrev && /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: onSuperPrev,
        tabIndex: -1,
        className: "".concat(prefixCls, "-super-prev-btn"),
        style: hidePrevBtn ? $535ef290f7dfaebe$var$HIDDEN_STYLE : {}
    }, superPrevIcon), onPrev && /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: onPrev,
        tabIndex: -1,
        className: "".concat(prefixCls, "-prev-btn"),
        style: hidePrevBtn ? $535ef290f7dfaebe$var$HIDDEN_STYLE : {}
    }, prevIcon), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-view")
    }, children), onNext && /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: onNext,
        tabIndex: -1,
        className: "".concat(prefixCls, "-next-btn"),
        style: hideNextBtn ? $535ef290f7dfaebe$var$HIDDEN_STYLE : {}
    }, nextIcon), onSuperNext && /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: onSuperNext,
        tabIndex: -1,
        className: "".concat(prefixCls, "-super-next-btn"),
        style: hideNextBtn ? $535ef290f7dfaebe$var$HIDDEN_STYLE : {}
    }, superNextIcon));
}
var $535ef290f7dfaebe$export$2e2bcd8739ae039 = $535ef290f7dfaebe$var$Header;




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



function $e53dbe8c79d2cb01$var$DecadeHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, viewDate = props.viewDate, onPrevDecades = props.onPrevDecades, onNextDecades = props.onNextDecades;
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var yearNumber = generateConfig.getYear(viewDate);
    var startYear = Math.floor(yearNumber / (0, $e32ba469ff7ad7ff$export$cd67ebcccd286127)) * (0, $e32ba469ff7ad7ff$export$cd67ebcccd286127);
    var endYear = startYear + (0, $e32ba469ff7ad7ff$export$cd67ebcccd286127) - 1;
    return /*#__PURE__*/ $acw62.createElement((0, $535ef290f7dfaebe$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevDecades,
        onSuperNext: onNextDecades
    }), startYear, "-", endYear);
}
var $e53dbe8c79d2cb01$export$2e2bcd8739ae039 = $e53dbe8c79d2cb01$var$DecadeHeader;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");


var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

function $c1ef9d3a4d96e3db$export$e5d5e1c1822b6e56(generateConfig, date, hour, minute, second) {
    var nextTime = generateConfig.setHour(date, hour);
    nextTime = generateConfig.setMinute(nextTime, minute);
    nextTime = generateConfig.setSecond(nextTime, second);
    return nextTime;
}
function $c1ef9d3a4d96e3db$export$3a84b9eda98e95dc(generateConfig, date, defaultDate) {
    if (!defaultDate) return date;
    var newDate = date;
    newDate = generateConfig.setHour(newDate, generateConfig.getHour(defaultDate));
    newDate = generateConfig.setMinute(newDate, generateConfig.getMinute(defaultDate));
    newDate = generateConfig.setSecond(newDate, generateConfig.getSecond(defaultDate));
    return newDate;
}
function $c1ef9d3a4d96e3db$export$6ebc74d7e616149(hour, minute, second, hourStep, minuteStep, secondStep) {
    var lowerBoundHour = Math.floor(hour / hourStep) * hourStep;
    if (lowerBoundHour < hour) return [
        lowerBoundHour,
        60 - minuteStep,
        60 - secondStep
    ];
    var lowerBoundMinute = Math.floor(minute / minuteStep) * minuteStep;
    if (lowerBoundMinute < minute) return [
        lowerBoundHour,
        lowerBoundMinute,
        60 - secondStep
    ];
    var lowerBoundSecond = Math.floor(second / secondStep) * secondStep;
    return [
        lowerBoundHour,
        lowerBoundMinute,
        lowerBoundSecond
    ];
}
function $c1ef9d3a4d96e3db$export$6c3baea86681d743(generateConfig, date) {
    var year = generateConfig.getYear(date);
    var month = generateConfig.getMonth(date) + 1;
    var endDate = generateConfig.getEndDate(generateConfig.getFixedDate("".concat(year, "-").concat(month, "-01")));
    var lastDay = generateConfig.getDate(endDate);
    var monthShow = month < 10 ? "0".concat(month) : "".concat(month);
    return "".concat(year, "-").concat(monthShow, "-").concat(lastDay);
}



function $9660a21fda1f017c$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, disabledDate = _ref.disabledDate, onSelect = _ref.onSelect, picker = _ref.picker, rowNum = _ref.rowNum, colNum = _ref.colNum, prefixColumn = _ref.prefixColumn, rowClassName = _ref.rowClassName, baseDate = _ref.baseDate, getCellClassName = _ref.getCellClassName, getCellText = _ref.getCellText, getCellNode = _ref.getCellNode, getCellDate = _ref.getCellDate, generateConfig = _ref.generateConfig, titleCell = _ref.titleCell, headerCells = _ref.headerCells;
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), onDateMouseEnter = _React$useContext.onDateMouseEnter, onDateMouseLeave = _React$useContext.onDateMouseLeave, mode = _React$useContext.mode;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    // =============================== Body ===============================
    var rows = [];
    for(var i = 0; i < rowNum; i += 1){
        var row = [];
        var rowStartDate = void 0;
        var _loop = function _loop() {
            var _objectSpread2;
            var offset = i * colNum + j;
            var currentDate = getCellDate(baseDate, offset);
            var disabled = (0, $5c7b8a0508ac8191$export$c503c160691b0dfe)({
                cellDate: currentDate,
                mode: mode,
                disabledDate: disabledDate,
                generateConfig: generateConfig
            });
            if (j === 0) {
                rowStartDate = currentDate;
                if (prefixColumn) row.push(prefixColumn(rowStartDate));
            }
            var title = titleCell && titleCell(currentDate);
            row.push(/*#__PURE__*/ $acw62.createElement("td", {
                key: j,
                title: title,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(cellPrefixCls, (0, $d49SP.default)((_objectSpread2 = {}, (0, $kSlfw.default)(_objectSpread2, "".concat(cellPrefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_objectSpread2, "".concat(cellPrefixCls, "-start"), getCellText(currentDate) === 1 || picker === 'year' && Number(title) % 10 === 0), (0, $kSlfw.default)(_objectSpread2, "".concat(cellPrefixCls, "-end"), title === (0, $c1ef9d3a4d96e3db$export$6c3baea86681d743)(generateConfig, currentDate) || picker === 'year' && Number(title) % 10 === 9), _objectSpread2), getCellClassName(currentDate))),
                onClick: function onClick() {
                    if (!disabled) onSelect(currentDate);
                },
                onMouseEnter: function onMouseEnter() {
                    if (!disabled && onDateMouseEnter) onDateMouseEnter(currentDate);
                },
                onMouseLeave: function onMouseLeave() {
                    if (!disabled && onDateMouseLeave) onDateMouseLeave(currentDate);
                }
            }, getCellNode ? getCellNode(currentDate) : /*#__PURE__*/ $acw62.createElement("div", {
                className: "".concat(cellPrefixCls, "-inner")
            }, getCellText(currentDate))));
        };
        for(var j = 0; j < colNum; j += 1)_loop();
        rows.push(/*#__PURE__*/ $acw62.createElement("tr", {
            key: i,
            className: rowClassName && rowClassName(rowStartDate)
        }, row));
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-body")
    }, /*#__PURE__*/ $acw62.createElement("table", {
        className: "".concat(prefixCls, "-content")
    }, headerCells && /*#__PURE__*/ $acw62.createElement("thead", null, /*#__PURE__*/ $acw62.createElement("tr", null, headerCells)), /*#__PURE__*/ $acw62.createElement("tbody", null, rows)));
}


var $fc588ade888c955f$export$dfe66ab72640953 = 3;
var $fc588ade888c955f$var$DECADE_ROW_COUNT = 4;
function $fc588ade888c955f$var$DecadeBody(props) {
    var DECADE_UNIT_DIFF_DES = (0, $e32ba469ff7ad7ff$export$2714f720f9350aa) - 1;
    var prefixCls = props.prefixCls, viewDate = props.viewDate, generateConfig = props.generateConfig;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var yearNumber = generateConfig.getYear(viewDate);
    var decadeYearNumber = Math.floor(yearNumber / (0, $e32ba469ff7ad7ff$export$2714f720f9350aa)) * (0, $e32ba469ff7ad7ff$export$2714f720f9350aa);
    var startDecadeYear = Math.floor(yearNumber / (0, $e32ba469ff7ad7ff$export$cd67ebcccd286127)) * (0, $e32ba469ff7ad7ff$export$cd67ebcccd286127);
    var endDecadeYear = startDecadeYear + (0, $e32ba469ff7ad7ff$export$cd67ebcccd286127) - 1;
    var baseDecadeYear = generateConfig.setYear(viewDate, startDecadeYear - Math.ceil(($fc588ade888c955f$export$dfe66ab72640953 * $fc588ade888c955f$var$DECADE_ROW_COUNT * (0, $e32ba469ff7ad7ff$export$2714f720f9350aa) - (0, $e32ba469ff7ad7ff$export$cd67ebcccd286127)) / 2));
    var getCellClassName = function getCellClassName(date) {
        var _ref;
        var startDecadeNumber = generateConfig.getYear(date);
        var endDecadeNumber = startDecadeNumber + DECADE_UNIT_DIFF_DES;
        return _ref = {}, (0, $kSlfw.default)(_ref, "".concat(cellPrefixCls, "-in-view"), startDecadeYear <= startDecadeNumber && endDecadeNumber <= endDecadeYear), (0, $kSlfw.default)(_ref, "".concat(cellPrefixCls, "-selected"), startDecadeNumber === decadeYearNumber), _ref;
    };
    return /*#__PURE__*/ $acw62.createElement((0, $9660a21fda1f017c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        rowNum: $fc588ade888c955f$var$DECADE_ROW_COUNT,
        colNum: $fc588ade888c955f$export$dfe66ab72640953,
        baseDate: baseDecadeYear,
        getCellText: function getCellText(date) {
            var startDecadeNumber = generateConfig.getYear(date);
            return "".concat(startDecadeNumber, "-").concat(startDecadeNumber + DECADE_UNIT_DIFF_DES);
        },
        getCellClassName: getCellClassName,
        getCellDate: function getCellDate(date, offset) {
            return generateConfig.addYear(date, offset * (0, $e32ba469ff7ad7ff$export$2714f720f9350aa));
        }
    }));
}
var $fc588ade888c955f$export$2e2bcd8739ae039 = $fc588ade888c955f$var$DecadeBody;



var $kbxxf = parcelRequire("kbxxf");

var $iCi4s = parcelRequire("iCi4s");

var $dTiBu = parcelRequire("dTiBu");

var $7klNq = parcelRequire("7klNq");
var $3af8fe10d0cc7265$var$scrollIds = new Map();
function $3af8fe10d0cc7265$export$55c3897747695e9b(element, callback) {
    var id;
    function tryOrNextFrame() {
        if ((0, $7klNq.default)(element)) callback();
        else id = (0, $dTiBu.default)(function() {
            tryOrNextFrame();
        });
    }
    tryOrNextFrame();
    return function() {
        (0, $dTiBu.default).cancel(id);
    };
}
function $3af8fe10d0cc7265$export$3f99968195accfaf(element, to, duration) {
    if ($3af8fe10d0cc7265$var$scrollIds.get(element)) cancelAnimationFrame($3af8fe10d0cc7265$var$scrollIds.get(element));
    // jump to target if duration zero
    if (duration <= 0) {
        $3af8fe10d0cc7265$var$scrollIds.set(element, requestAnimationFrame(function() {
            element.scrollTop = to;
        }));
        return;
    }
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;
    $3af8fe10d0cc7265$var$scrollIds.set(element, requestAnimationFrame(function() {
        element.scrollTop += perTick;
        if (element.scrollTop !== to) $3af8fe10d0cc7265$export$3f99968195accfaf(element, to, duration - 10);
    }));
}
function $3af8fe10d0cc7265$export$a507db46d3f03278(event, _ref) {
    var onLeftRight = _ref.onLeftRight, onCtrlLeftRight = _ref.onCtrlLeftRight, onUpDown = _ref.onUpDown, onPageUpDown = _ref.onPageUpDown, onEnter = _ref.onEnter;
    var which = event.which, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
    switch(which){
        case (0, $iCi4s.default).LEFT:
            if (ctrlKey || metaKey) {
                if (onCtrlLeftRight) {
                    onCtrlLeftRight(-1);
                    return true;
                }
            } else if (onLeftRight) {
                onLeftRight(-1);
                return true;
            }
            break;
        case (0, $iCi4s.default).RIGHT:
            if (ctrlKey || metaKey) {
                if (onCtrlLeftRight) {
                    onCtrlLeftRight(1);
                    return true;
                }
            } else if (onLeftRight) {
                onLeftRight(1);
                return true;
            }
            break;
        case (0, $iCi4s.default).UP:
            if (onUpDown) {
                onUpDown(-1);
                return true;
            }
            break;
        case (0, $iCi4s.default).DOWN:
            if (onUpDown) {
                onUpDown(1);
                return true;
            }
            break;
        case (0, $iCi4s.default).PAGE_UP:
            if (onPageUpDown) {
                onPageUpDown(-1);
                return true;
            }
            break;
        case (0, $iCi4s.default).PAGE_DOWN:
            if (onPageUpDown) {
                onPageUpDown(1);
                return true;
            }
            break;
        case (0, $iCi4s.default).ENTER:
            if (onEnter) {
                onEnter();
                return true;
            }
            break;
    }
    return false;
}
function $3af8fe10d0cc7265$export$3e0385bd234197e6(format, picker, showTime, use12Hours) {
    var mergedFormat = format;
    if (!mergedFormat) switch(picker){
        case 'time':
            mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
            break;
        case 'week':
            mergedFormat = 'gggg-wo';
            break;
        case 'month':
            mergedFormat = 'YYYY-MM';
            break;
        case 'quarter':
            mergedFormat = 'YYYY-[Q]Q';
            break;
        case 'year':
            mergedFormat = 'YYYY';
            break;
        default:
            mergedFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
    return mergedFormat;
}
function $3af8fe10d0cc7265$export$c4929e7560bc7c3e(picker, format, generateConfig) {
    var defaultSize = picker === 'time' ? 8 : 10;
    var length = typeof format === 'function' ? format(generateConfig.getNow()).length : format.length;
    return Math.max(defaultSize, length) + 2;
}
var $3af8fe10d0cc7265$var$globalClickFunc = null;
var $3af8fe10d0cc7265$var$clickCallbacks = new Set();
function $3af8fe10d0cc7265$export$1ccf549497681f00(callback) {
    if (!$3af8fe10d0cc7265$var$globalClickFunc && typeof window !== 'undefined' && window.addEventListener) {
        $3af8fe10d0cc7265$var$globalClickFunc = function globalClickFunc(e) {
            // Clone a new list to avoid repeat trigger events
            (0, $kbxxf.default)($3af8fe10d0cc7265$var$clickCallbacks).forEach(function(queueFunc) {
                queueFunc(e);
            });
        };
        window.addEventListener('mousedown', $3af8fe10d0cc7265$var$globalClickFunc);
    }
    $3af8fe10d0cc7265$var$clickCallbacks.add(callback);
    return function() {
        $3af8fe10d0cc7265$var$clickCallbacks.delete(callback);
        if ($3af8fe10d0cc7265$var$clickCallbacks.size === 0) {
            window.removeEventListener('mousedown', $3af8fe10d0cc7265$var$globalClickFunc);
            $3af8fe10d0cc7265$var$globalClickFunc = null;
        }
    };
}
function $3af8fe10d0cc7265$export$2fb4f2d524461006(e) {
    var target = e.target;
    // get target if in shadow dom
    if (e.composed && target.shadowRoot) {
        var _e$composedPath;
        return ((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath.call(e)[0]) || target;
    }
    return target;
}
// ====================== Mode ======================
var $3af8fe10d0cc7265$var$getYearNextMode = function getYearNextMode(next) {
    if (next === 'month' || next === 'date') return 'year';
    return next;
};
var $3af8fe10d0cc7265$var$getMonthNextMode = function getMonthNextMode(next) {
    if (next === 'date') return 'month';
    return next;
};
var $3af8fe10d0cc7265$var$getQuarterNextMode = function getQuarterNextMode(next) {
    if (next === 'month' || next === 'date') return 'quarter';
    return next;
};
var $3af8fe10d0cc7265$var$getWeekNextMode = function getWeekNextMode(next) {
    if (next === 'date') return 'week';
    return next;
};
var $3af8fe10d0cc7265$export$6b35bb792c096c09 = {
    year: $3af8fe10d0cc7265$var$getYearNextMode,
    month: $3af8fe10d0cc7265$var$getMonthNextMode,
    quarter: $3af8fe10d0cc7265$var$getQuarterNextMode,
    week: $3af8fe10d0cc7265$var$getWeekNextMode,
    time: null,
    date: null
};
function $3af8fe10d0cc7265$export$9350e4ea4b8364(elements, target) {
    return elements.some(function(ele) {
        return ele && ele.contains(target);
    });
}


var $e32ba469ff7ad7ff$export$2714f720f9350aa = 10;
var $e32ba469ff7ad7ff$export$cd67ebcccd286127 = $e32ba469ff7ad7ff$export$2714f720f9350aa * 10;
function $e32ba469ff7ad7ff$var$DecadePanel(props) {
    var prefixCls = props.prefixCls, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, viewDate = props.viewDate, operationRef = props.operationRef, onSelect = props.onSelect, onPanelChange = props.onPanelChange;
    var panelPrefixCls = "".concat(prefixCls, "-decade-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $3af8fe10d0cc7265$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    onSelect(generateConfig.addYear(viewDate, diff * $e32ba469ff7ad7ff$export$2714f720f9350aa), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    onSelect(generateConfig.addYear(viewDate, diff * $e32ba469ff7ad7ff$export$cd67ebcccd286127), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    onSelect(generateConfig.addYear(viewDate, diff * $e32ba469ff7ad7ff$export$2714f720f9350aa * (0, $fc588ade888c955f$export$dfe66ab72640953)), 'key');
                },
                onEnter: function onEnter() {
                    onPanelChange('year', viewDate);
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onDecadesChange = function onDecadesChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff * $e32ba469ff7ad7ff$export$cd67ebcccd286127);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    var onInternalSelect = function onInternalSelect(date) {
        onSelect(date, 'mouse');
        onPanelChange('year', date);
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $acw62.createElement((0, $e53dbe8c79d2cb01$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onPrevDecades: function onPrevDecades() {
            onDecadesChange(-1);
        },
        onNextDecades: function onNextDecades() {
            onDecadesChange(1);
        }
    })), /*#__PURE__*/ $acw62.createElement((0, $fc588ade888c955f$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: onInternalSelect
    })));
}
var $e32ba469ff7ad7ff$export$2e2bcd8739ae039 = $e32ba469ff7ad7ff$var$DecadePanel;


var $5c7b8a0508ac8191$export$fe62c2dddb4d77ea = 7;
function $5c7b8a0508ac8191$export$e523b58b4eb7fe76(value1, value2) {
    if (!value1 && !value2) return true;
    if (!value1 || !value2) return false;
    return undefined;
}
function $5c7b8a0508ac8191$export$22ab546651b3be18(generateConfig, decade1, decade2) {
    var equal = $5c7b8a0508ac8191$export$e523b58b4eb7fe76(decade1, decade2);
    if (typeof equal === 'boolean') return equal;
    var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
    var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
    return num1 === num2;
}
function $5c7b8a0508ac8191$export$5841f9eb9773f25f(generateConfig, year1, year2) {
    var equal = $5c7b8a0508ac8191$export$e523b58b4eb7fe76(year1, year2);
    if (typeof equal === 'boolean') return equal;
    return generateConfig.getYear(year1) === generateConfig.getYear(year2);
}
function $5c7b8a0508ac8191$export$de90a4bb31c25221(generateConfig, date) {
    var quota = Math.floor(generateConfig.getMonth(date) / 3);
    return quota + 1;
}
function $5c7b8a0508ac8191$export$5c60e4190867161c(generateConfig, quarter1, quarter2) {
    var equal = $5c7b8a0508ac8191$export$e523b58b4eb7fe76(quarter1, quarter2);
    if (typeof equal === 'boolean') return equal;
    return $5c7b8a0508ac8191$export$5841f9eb9773f25f(generateConfig, quarter1, quarter2) && $5c7b8a0508ac8191$export$de90a4bb31c25221(generateConfig, quarter1) === $5c7b8a0508ac8191$export$de90a4bb31c25221(generateConfig, quarter2);
}
function $5c7b8a0508ac8191$export$a18c89cbd24170ff(generateConfig, month1, month2) {
    var equal = $5c7b8a0508ac8191$export$e523b58b4eb7fe76(month1, month2);
    if (typeof equal === 'boolean') return equal;
    return $5c7b8a0508ac8191$export$5841f9eb9773f25f(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
}
function $5c7b8a0508ac8191$export$a8b2a21161763694(generateConfig, date1, date2) {
    var equal = $5c7b8a0508ac8191$export$e523b58b4eb7fe76(date1, date2);
    if (typeof equal === 'boolean') return equal;
    return generateConfig.getYear(date1) === generateConfig.getYear(date2) && generateConfig.getMonth(date1) === generateConfig.getMonth(date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
}
function $5c7b8a0508ac8191$export$dd2b4b46b4a2f5c9(generateConfig, time1, time2) {
    var equal = $5c7b8a0508ac8191$export$e523b58b4eb7fe76(time1, time2);
    if (typeof equal === 'boolean') return equal;
    return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
}
function $5c7b8a0508ac8191$export$6ea683876c36b8d2(generateConfig, locale, date1, date2) {
    var equal = $5c7b8a0508ac8191$export$e523b58b4eb7fe76(date1, date2);
    if (typeof equal === 'boolean') return equal;
    return $5c7b8a0508ac8191$export$5841f9eb9773f25f(generateConfig, date1, date2) && generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
}
function $5c7b8a0508ac8191$export$248d38f6296296c5(generateConfig, value1, value2) {
    return $5c7b8a0508ac8191$export$a8b2a21161763694(generateConfig, value1, value2) && $5c7b8a0508ac8191$export$dd2b4b46b4a2f5c9(generateConfig, value1, value2);
}
function $5c7b8a0508ac8191$export$6dabbcb26357acf4(generateConfig, startDate, endDate, current) {
    if (!startDate || !endDate || !current) return false;
    return !$5c7b8a0508ac8191$export$a8b2a21161763694(generateConfig, startDate, current) && !$5c7b8a0508ac8191$export$a8b2a21161763694(generateConfig, endDate, current) && generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function $5c7b8a0508ac8191$export$e91829c600881133(locale, generateConfig, value) {
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
    var monthStartDate = generateConfig.setDate(value, 1);
    var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
    var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
    if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) alignStartDate = generateConfig.addDate(alignStartDate, -7);
    return alignStartDate;
}
function $5c7b8a0508ac8191$export$d9ec313bf7ad18e1(viewDate, picker, generateConfig) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    switch(picker){
        case 'year':
            return generateConfig.addYear(viewDate, offset * 10);
        case 'quarter':
        case 'month':
            return generateConfig.addYear(viewDate, offset);
        default:
            return generateConfig.addMonth(viewDate, offset);
    }
}
function $5c7b8a0508ac8191$export$7c4d25c0c3217d8c(value, _ref) {
    var generateConfig = _ref.generateConfig, locale = _ref.locale, format = _ref.format;
    return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
function $5c7b8a0508ac8191$export$5303528d1070ff6f(value, _ref2) {
    var generateConfig = _ref2.generateConfig, locale = _ref2.locale, formatList = _ref2.formatList;
    if (!value || typeof formatList[0] === 'function') return null;
    return generateConfig.locale.parse(locale.locale, value, formatList);
}
function $5c7b8a0508ac8191$export$c503c160691b0dfe(_ref3) {
    var cellDate = _ref3.cellDate, mode = _ref3.mode, disabledDate = _ref3.disabledDate, generateConfig = _ref3.generateConfig;
    if (!disabledDate) return false;
    // Whether cellDate is disabled in range
    var getDisabledFromRange = function getDisabledFromRange(currentMode, start, end) {
        var current = start;
        while(current <= end){
            var date = void 0;
            switch(currentMode){
                case 'date':
                    date = generateConfig.setDate(cellDate, current);
                    if (!disabledDate(date)) return false;
                    break;
                case 'month':
                    date = generateConfig.setMonth(cellDate, current);
                    if (!$5c7b8a0508ac8191$export$c503c160691b0dfe({
                        cellDate: date,
                        mode: 'month',
                        generateConfig: generateConfig,
                        disabledDate: disabledDate
                    })) return false;
                    break;
                case 'year':
                    date = generateConfig.setYear(cellDate, current);
                    if (!$5c7b8a0508ac8191$export$c503c160691b0dfe({
                        cellDate: date,
                        mode: 'year',
                        generateConfig: generateConfig,
                        disabledDate: disabledDate
                    })) return false;
                    break;
            }
            current += 1;
        }
        return true;
    };
    switch(mode){
        case 'date':
        case 'week':
            return disabledDate(cellDate);
        case 'month':
            var startDate = 1;
            var endDate = generateConfig.getDate(generateConfig.getEndDate(cellDate));
            return getDisabledFromRange('date', startDate, endDate);
        case 'quarter':
            var startMonth = Math.floor(generateConfig.getMonth(cellDate) / 3) * 3;
            var endMonth = startMonth + 2;
            return getDisabledFromRange('month', startMonth, endMonth);
        case 'year':
            return getDisabledFromRange('month', 0, 11);
        case 'decade':
            var year = generateConfig.getYear(cellDate);
            var startYear = Math.floor(year / (0, $e32ba469ff7ad7ff$export$2714f720f9350aa)) * (0, $e32ba469ff7ad7ff$export$2714f720f9350aa);
            var endYear = startYear + (0, $e32ba469ff7ad7ff$export$2714f720f9350aa) - 1;
            return getDisabledFromRange('year', startYear, endYear);
    }
}


function $c7768525c69485c8$var$TimeHeader(props) {
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, value = props.value, format = props.format;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    return /*#__PURE__*/ $acw62.createElement((0, $535ef290f7dfaebe$export$2e2bcd8739ae039), {
        prefixCls: headerPrefixCls
    }, value ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(value, {
        locale: locale,
        format: format,
        generateConfig: generateConfig
    }) : "\xA0");
}
var $c7768525c69485c8$export$2e2bcd8739ae039 = $c7768525c69485c8$var$TimeHeader;



var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $3Ysvw = parcelRequire("3Ysvw");

var $acw62 = parcelRequire("acw62");

function $37e90842b7ab6c60$export$2e2bcd8739ae039(_ref) {
    var value = _ref.value, generateConfig = _ref.generateConfig, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds, minutes = _ref.minutes, seconds = _ref.seconds, use12Hours = _ref.use12Hours;
    var setTime = function setTime(isNewPM, newHour, newMinute, newSecond) {
        var newDate = value || generateConfig.getNow();
        var mergedHour = Math.max(0, newHour);
        var mergedMinute = Math.max(0, newMinute);
        var mergedSecond = Math.max(0, newSecond);
        var newDisabledMinutes = disabledMinutes && disabledMinutes(mergedHour);
        if (newDisabledMinutes === null || newDisabledMinutes === void 0 ? void 0 : newDisabledMinutes.includes(mergedMinute)) {
            // find the first available minute in minutes
            var availableMinute = minutes.find(function(i) {
                return !newDisabledMinutes.includes(i.value);
            });
            if (availableMinute) mergedMinute = availableMinute.value;
            else return null;
        }
        var newDisabledSeconds = disabledSeconds && disabledSeconds(mergedHour, mergedMinute);
        if (newDisabledSeconds === null || newDisabledSeconds === void 0 ? void 0 : newDisabledSeconds.includes(mergedSecond)) {
            // find the first available second in seconds
            var availableSecond = seconds.find(function(i) {
                return !newDisabledSeconds.includes(i.value);
            });
            if (availableSecond) mergedSecond = availableSecond.value;
            else return null;
        }
        newDate = (0, $c1ef9d3a4d96e3db$export$e5d5e1c1822b6e56)(generateConfig, newDate, !use12Hours || !isNewPM ? mergedHour : mergedHour + 12, mergedMinute, mergedSecond);
        return newDate;
    };
    return setTime;
}


function $0ae673be6dd1ab39$export$cbb503201166aab7(str, length) {
    var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    var current = String(str);
    while(current.length < length)current = "".concat(fill).concat(str);
    return current;
}
var $0ae673be6dd1ab39$export$65e3907585753458 = function tuple() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args;
};
function $0ae673be6dd1ab39$export$45b10814cc054894(val) {
    if (val === null || val === undefined) return [];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $0ae673be6dd1ab39$export$2e2bcd8739ae039(props) {
    var retProps = {};
    Object.keys(props).forEach(function(key) {
        if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role' || key === 'name') && key.substr(0, 7) !== 'data-__') retProps[key] = props[key];
    });
    return retProps;
}
function $0ae673be6dd1ab39$export$bf7199a9ebcb84a9(values, index) {
    return values ? values[index] : null;
}
function $0ae673be6dd1ab39$export$1af566b8db6b8ac2(values, value, index) {
    var newValues = [
        $0ae673be6dd1ab39$export$bf7199a9ebcb84a9(values, 0),
        $0ae673be6dd1ab39$export$bf7199a9ebcb84a9(values, 1)
    ];
    newValues[index] = typeof value === 'function' ? value(newValues[index]) : value;
    if (!newValues[0] && !newValues[1]) return null;
    return newValues;
}



var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


function $123e98564694bd18$var$TimeUnitColumn(props) {
    var prefixCls = props.prefixCls, units = props.units, onSelect = props.onSelect, value = props.value, active = props.active, hideDisabledOptions = props.hideDisabledOptions;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), open = _React$useContext.open;
    var ulRef = (0, $acw62.useRef)(null);
    var liRefs = (0, $acw62.useRef)(new Map());
    var scrollRef = (0, $acw62.useRef)();
    // `useLayoutEffect` here to avoid blink by duration is 0
    (0, $acw62.useLayoutEffect)(function() {
        var li = liRefs.current.get(value);
        if (li && open !== false) (0, $3af8fe10d0cc7265$export$3f99968195accfaf)(ulRef.current, li.offsetTop, 120);
    }, [
        value
    ]);
    (0, $acw62.useLayoutEffect)(function() {
        if (open) {
            var li = liRefs.current.get(value);
            if (li) scrollRef.current = (0, $3af8fe10d0cc7265$export$55c3897747695e9b)(li, function() {
                (0, $3af8fe10d0cc7265$export$3f99968195accfaf)(ulRef.current, li.offsetTop, 0);
            });
        }
        return function() {
            var _scrollRef$current;
            (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.call(scrollRef);
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-column"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-column-active"), active)),
        ref: ulRef,
        style: {
            position: 'relative'
        }
    }, units.map(function(unit) {
        var _classNames2;
        if (hideDisabledOptions && unit.disabled) return null;
        return /*#__PURE__*/ $acw62.createElement("li", {
            key: unit.value,
            ref: function ref(element) {
                liRefs.current.set(unit.value, element);
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(cellPrefixCls, (_classNames2 = {}, (0, $kSlfw.default)(_classNames2, "".concat(cellPrefixCls, "-disabled"), unit.disabled), (0, $kSlfw.default)(_classNames2, "".concat(cellPrefixCls, "-selected"), value === unit.value), _classNames2)),
            onClick: function onClick() {
                if (unit.disabled) return;
                onSelect(unit.value);
            }
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(cellPrefixCls, "-inner")
        }, unit.label));
    }));
}
var $123e98564694bd18$export$2e2bcd8739ae039 = $123e98564694bd18$var$TimeUnitColumn;


function $e9b80d1b83fd5de7$var$shouldUnitsUpdate(prevUnits, nextUnits) {
    if (prevUnits.length !== nextUnits.length) return true;
    // if any unit's disabled status is different, the units should be re-evaluted
    for(var i = 0; i < prevUnits.length; i += 1){
        if (prevUnits[i].disabled !== nextUnits[i].disabled) return true;
    }
    return false;
}
function $e9b80d1b83fd5de7$var$generateUnits(start, end, step, disabledUnits) {
    var units = [];
    var integerStep = step >= 1 ? step | 0 : 1;
    for(var i = start; i <= end; i += integerStep)units.push({
        label: (0, $0ae673be6dd1ab39$export$cbb503201166aab7)(i, 2),
        value: i,
        disabled: (disabledUnits || []).includes(i)
    });
    return units;
}
function $e9b80d1b83fd5de7$var$TimeBody(props) {
    var generateConfig = props.generateConfig, prefixCls = props.prefixCls, operationRef = props.operationRef, activeColumnIndex = props.activeColumnIndex, value = props.value, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, use12Hours = props.use12Hours, _props$hourStep = props.hourStep, hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep, _props$minuteStep = props.minuteStep, minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep, _props$secondStep = props.secondStep, secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep, disabledHours = props.disabledHours, disabledMinutes = props.disabledMinutes, disabledSeconds = props.disabledSeconds, disabledTime = props.disabledTime, hideDisabledOptions = props.hideDisabledOptions, onSelect = props.onSelect;
    // Misc
    var columns = [];
    var contentPrefixCls = "".concat(prefixCls, "-content");
    var columnPrefixCls = "".concat(prefixCls, "-time-panel");
    var isPM;
    var originHour = value ? generateConfig.getHour(value) : -1;
    var hour = originHour;
    var minute = value ? generateConfig.getMinute(value) : -1;
    var second = value ? generateConfig.getSecond(value) : -1;
    // Disabled Time
    var now = generateConfig.getNow();
    var _React$useMemo = $acw62.useMemo(function() {
        if (disabledTime) {
            var disabledConfig = disabledTime(now);
            return [
                disabledConfig.disabledHours,
                disabledConfig.disabledMinutes,
                disabledConfig.disabledSeconds
            ];
        }
        return [
            disabledHours,
            disabledMinutes,
            disabledSeconds
        ];
    }, [
        disabledHours,
        disabledMinutes,
        disabledSeconds,
        disabledTime,
        now
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 3), mergedDisabledHours = _React$useMemo2[0], mergedDisabledMinutes = _React$useMemo2[1], mergedDisabledSeconds = _React$useMemo2[2];
    // ========================= Unit =========================
    var rawHours = $e9b80d1b83fd5de7$var$generateUnits(0, 23, hourStep, mergedDisabledHours && mergedDisabledHours());
    var memorizedRawHours = (0, $3Ysvw.default)(function() {
        return rawHours;
    }, rawHours, $e9b80d1b83fd5de7$var$shouldUnitsUpdate);
    // Should additional logic to handle 12 hours
    if (use12Hours) {
        isPM = hour >= 12; // -1 means should display AM
        hour %= 12;
    }
    var _React$useMemo3 = $acw62.useMemo(function() {
        if (!use12Hours) return [
            false,
            false
        ];
        var AMPMDisabled = [
            true,
            true
        ];
        memorizedRawHours.forEach(function(_ref) {
            var disabled = _ref.disabled, hourValue = _ref.value;
            if (disabled) return;
            if (hourValue >= 12) AMPMDisabled[1] = false;
            else AMPMDisabled[0] = false;
        });
        return AMPMDisabled;
    }, [
        use12Hours,
        memorizedRawHours
    ]), _React$useMemo4 = (0, $eUqlC.default)(_React$useMemo3, 2), AMDisabled = _React$useMemo4[0], PMDisabled = _React$useMemo4[1];
    var hours = $acw62.useMemo(function() {
        if (!use12Hours) return memorizedRawHours;
        return memorizedRawHours.filter(isPM ? function(hourMeta) {
            return hourMeta.value >= 12;
        } : function(hourMeta) {
            return hourMeta.value < 12;
        }).map(function(hourMeta) {
            var hourValue = hourMeta.value % 12;
            var hourLabel = hourValue === 0 ? '12' : (0, $0ae673be6dd1ab39$export$cbb503201166aab7)(hourValue, 2);
            return (0, $d49SP.default)((0, $d49SP.default)({}, hourMeta), {}, {
                label: hourLabel,
                value: hourValue
            });
        });
    }, [
        use12Hours,
        isPM,
        memorizedRawHours
    ]);
    var minutes = $e9b80d1b83fd5de7$var$generateUnits(0, 59, minuteStep, mergedDisabledMinutes && mergedDisabledMinutes(originHour));
    var seconds = $e9b80d1b83fd5de7$var$generateUnits(0, 59, secondStep, mergedDisabledSeconds && mergedDisabledSeconds(originHour, minute));
    // Set Time
    var setTime = (0, $37e90842b7ab6c60$export$2e2bcd8739ae039)({
        value: value,
        generateConfig: generateConfig,
        disabledMinutes: mergedDisabledMinutes,
        disabledSeconds: mergedDisabledSeconds,
        minutes: minutes,
        seconds: seconds,
        use12Hours: use12Hours
    });
    // ====================== Operations ======================
    operationRef.current = {
        onUpDown: function onUpDown(diff) {
            var column = columns[activeColumnIndex];
            if (column) {
                var valueIndex = column.units.findIndex(function(unit) {
                    return unit.value === column.value;
                });
                var unitLen = column.units.length;
                for(var i = 1; i < unitLen; i += 1){
                    var nextUnit = column.units[(valueIndex + diff * i + unitLen) % unitLen];
                    if (nextUnit.disabled !== true) {
                        column.onSelect(nextUnit.value);
                        break;
                    }
                }
            }
        }
    };
    // ======================== Render ========================
    function addColumnNode(condition, node, columnValue, units, onColumnSelect) {
        if (condition !== false) columns.push({
            node: /*#__PURE__*/ $acw62.cloneElement(node, {
                prefixCls: columnPrefixCls,
                value: columnValue,
                active: activeColumnIndex === columns.length,
                onSelect: onColumnSelect,
                units: units,
                hideDisabledOptions: hideDisabledOptions
            }),
            onSelect: onColumnSelect,
            value: columnValue,
            units: units
        });
    }
    // Hour
    addColumnNode(showHour, /*#__PURE__*/ $acw62.createElement((0, $123e98564694bd18$export$2e2bcd8739ae039), {
        key: "hour"
    }), hour, hours, function(num) {
        onSelect(setTime(isPM, num, minute, second), 'mouse');
    });
    // Minute
    addColumnNode(showMinute, /*#__PURE__*/ $acw62.createElement((0, $123e98564694bd18$export$2e2bcd8739ae039), {
        key: "minute"
    }), minute, minutes, function(num) {
        onSelect(setTime(isPM, hour, num, second), 'mouse');
    });
    // Second
    addColumnNode(showSecond, /*#__PURE__*/ $acw62.createElement((0, $123e98564694bd18$export$2e2bcd8739ae039), {
        key: "second"
    }), second, seconds, function(num) {
        onSelect(setTime(isPM, hour, minute, num), 'mouse');
    });
    // 12 Hours
    var PMIndex = -1;
    if (typeof isPM === 'boolean') PMIndex = isPM ? 1 : 0;
    addColumnNode(use12Hours === true, /*#__PURE__*/ $acw62.createElement((0, $123e98564694bd18$export$2e2bcd8739ae039), {
        key: "12hours"
    }), PMIndex, [
        {
            label: 'AM',
            value: 0,
            disabled: AMDisabled
        },
        {
            label: 'PM',
            value: 1,
            disabled: PMDisabled
        }
    ], function(num) {
        onSelect(setTime(!!num, hour, minute, second), 'mouse');
    });
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: contentPrefixCls
    }, columns.map(function(_ref2) {
        var node = _ref2.node;
        return node;
    }));
}
var $e9b80d1b83fd5de7$export$2e2bcd8739ae039 = $e9b80d1b83fd5de7$var$TimeBody;



var $bcd52c381f181056$var$countBoolean = function countBoolean(boolList) {
    return boolList.filter(function(bool) {
        return bool !== false;
    }).length;
};
function $bcd52c381f181056$var$TimePanel(props) {
    var generateConfig = props.generateConfig, _props$format = props.format, format = _props$format === void 0 ? 'HH:mm:ss' : _props$format, prefixCls = props.prefixCls, active = props.active, operationRef = props.operationRef, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, _props$use12Hours = props.use12Hours, use12Hours = _props$use12Hours === void 0 ? false : _props$use12Hours, onSelect = props.onSelect, value = props.value;
    var panelPrefixCls = "".concat(prefixCls, "-time-panel");
    var bodyOperationRef = $acw62.useRef();
    // ======================= Keyboard =======================
    var _React$useState = $acw62.useState(-1), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), activeColumnIndex = _React$useState2[0], setActiveColumnIndex = _React$useState2[1];
    var columnsCount = $bcd52c381f181056$var$countBoolean([
        showHour,
        showMinute,
        showSecond,
        use12Hours
    ]);
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $3af8fe10d0cc7265$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    setActiveColumnIndex((activeColumnIndex + diff + columnsCount) % columnsCount);
                },
                onUpDown: function onUpDown(diff) {
                    if (activeColumnIndex === -1) setActiveColumnIndex(0);
                    else if (bodyOperationRef.current) bodyOperationRef.current.onUpDown(diff);
                },
                onEnter: function onEnter() {
                    onSelect(value || generateConfig.getNow(), 'key');
                    setActiveColumnIndex(-1);
                }
            });
        },
        onBlur: function onBlur() {
            setActiveColumnIndex(-1);
        }
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(panelPrefixCls, (0, $kSlfw.default)({}, "".concat(panelPrefixCls, "-active"), active))
    }, /*#__PURE__*/ $acw62.createElement((0, $c7768525c69485c8$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        format: format,
        prefixCls: prefixCls
    })), /*#__PURE__*/ $acw62.createElement((0, $e9b80d1b83fd5de7$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        activeColumnIndex: activeColumnIndex,
        operationRef: bodyOperationRef
    })));
}
var $bcd52c381f181056$export$2e2bcd8739ae039 = $bcd52c381f181056$var$TimePanel;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $ad011b5d5dcecbe5$var$RangeContext = /*#__PURE__*/ $acw62.createContext({});
var $ad011b5d5dcecbe5$export$2e2bcd8739ae039 = $ad011b5d5dcecbe5$var$RangeContext;



var $kSlfw = parcelRequire("kSlfw");


function $5ba36c8d11bcff41$export$2e2bcd8739ae039(_ref) {
    var cellPrefixCls = _ref.cellPrefixCls, generateConfig = _ref.generateConfig, rangedValue = _ref.rangedValue, hoverRangedValue = _ref.hoverRangedValue, isInView = _ref.isInView, isSameCell = _ref.isSameCell, offsetCell = _ref.offsetCell, today = _ref.today, value = _ref.value;
    function getClassName(currentDate) {
        var _ref2;
        var prevDate = offsetCell(currentDate, -1);
        var nextDate = offsetCell(currentDate, 1);
        var rangeStart = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(rangedValue, 0);
        var rangeEnd = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(rangedValue, 1);
        var hoverStart = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(hoverRangedValue, 0);
        var hoverEnd = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(hoverRangedValue, 1);
        var isRangeHovered = (0, $5c7b8a0508ac8191$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, currentDate);
        function isRangeStart(date) {
            return isSameCell(rangeStart, date);
        }
        function isRangeEnd(date) {
            return isSameCell(rangeEnd, date);
        }
        var isHoverStart = isSameCell(hoverStart, currentDate);
        var isHoverEnd = isSameCell(hoverEnd, currentDate);
        var isHoverEdgeStart = (isRangeHovered || isHoverEnd) && (!isInView(prevDate) || isRangeEnd(prevDate));
        var isHoverEdgeEnd = (isRangeHovered || isHoverStart) && (!isInView(nextDate) || isRangeStart(nextDate));
        return _ref2 = {}, (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-in-view"), isInView(currentDate)), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-in-range"), (0, $5c7b8a0508ac8191$export$6dabbcb26357acf4)(generateConfig, rangeStart, rangeEnd, currentDate)), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-start"), isRangeStart(currentDate)), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-end"), isRangeEnd(currentDate)), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-start-single"), isRangeStart(currentDate) && !rangeEnd), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-end-single"), isRangeEnd(currentDate) && !rangeStart), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-start-near-hover"), isRangeStart(currentDate) && (isSameCell(prevDate, hoverStart) || (0, $5c7b8a0508ac8191$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, prevDate))), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-end-near-hover"), isRangeEnd(currentDate) && (isSameCell(nextDate, hoverEnd) || (0, $5c7b8a0508ac8191$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, nextDate))), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-hover"), isRangeHovered), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-start"), isHoverStart), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-end"), isHoverEnd), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start"), isHoverEdgeStart), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end"), isHoverEdgeEnd), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start-near-range"), isHoverEdgeStart && isSameCell(prevDate, rangeEnd)), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end-near-range"), isHoverEdgeEnd && isSameCell(nextDate, rangeStart)), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-today"), isSameCell(today, currentDate)), (0, $kSlfw.default)(_ref2, "".concat(cellPrefixCls, "-selected"), isSameCell(value, currentDate)), _ref2;
    }
    return getClassName;
}



function $56669640309bba5a$var$DateBody(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, prefixColumn = props.prefixColumn, locale = props.locale, rowCount = props.rowCount, viewDate = props.viewDate, value = props.value, dateRender = props.dateRender;
    var _React$useContext = $acw62.useContext((0, $ad011b5d5dcecbe5$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var baseDate = (0, $5c7b8a0508ac8191$export$e91829c600881133)(locale.locale, generateConfig, viewDate);
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
    var today = generateConfig.getNow();
    // ============================== Header ==============================
    var headerCells = [];
    var weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);
    if (prefixColumn) headerCells.push(/*#__PURE__*/ $acw62.createElement("th", {
        key: "empty",
        "aria-label": "empty cell"
    }));
    for(var i = 0; i < (0, $5c7b8a0508ac8191$export$fe62c2dddb4d77ea); i += 1)headerCells.push(/*#__PURE__*/ $acw62.createElement("th", {
        key: i
    }, weekDaysLocale[(i + weekFirstDay) % (0, $5c7b8a0508ac8191$export$fe62c2dddb4d77ea)]));
    // =============================== Body ===============================
    var getCellClassName = (0, $5ba36c8d11bcff41$export$2e2bcd8739ae039)({
        cellPrefixCls: cellPrefixCls,
        today: today,
        value: value,
        generateConfig: generateConfig,
        rangedValue: prefixColumn ? null : rangedValue,
        hoverRangedValue: prefixColumn ? null : hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $5c7b8a0508ac8191$export$a8b2a21161763694)(generateConfig, current, target);
        },
        isInView: function isInView(date) {
            return (0, $5c7b8a0508ac8191$export$a18c89cbd24170ff)(generateConfig, date, viewDate);
        },
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addDate(date, offset);
        }
    });
    var getCellNode = dateRender ? function(date) {
        return dateRender(date, today);
    } : undefined;
    return /*#__PURE__*/ $acw62.createElement((0, $9660a21fda1f017c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        rowNum: rowCount,
        colNum: (0, $5c7b8a0508ac8191$export$fe62c2dddb4d77ea),
        baseDate: baseDate,
        getCellNode: getCellNode,
        getCellText: generateConfig.getDate,
        getCellClassName: getCellClassName,
        getCellDate: generateConfig.addDate,
        titleCell: function titleCell(date) {
            return (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY-MM-DD',
                generateConfig: generateConfig
            });
        },
        headerCells: headerCells
    }));
}
var $56669640309bba5a$export$2e2bcd8739ae039 = $56669640309bba5a$var$DateBody;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



function $59ffdeb452cc4773$var$DateHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, viewDate = props.viewDate, onNextMonth = props.onNextMonth, onPrevMonth = props.onPrevMonth, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick, onMonthClick = props.onMonthClick;
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    var month = generateConfig.getMonth(viewDate);
    // =================== Month & Year ===================
    var yearNode = /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        key: "year",
        onClick: onYearClick,
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    var monthNode = /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        key: "month",
        onClick: onMonthClick,
        tabIndex: -1,
        className: "".concat(prefixCls, "-month-btn")
    }, locale.monthFormat ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.monthFormat,
        generateConfig: generateConfig
    }) : monthsLocale[month]);
    var monthYearNodes = locale.monthBeforeYear ? [
        monthNode,
        yearNode
    ] : [
        yearNode,
        monthNode
    ];
    return /*#__PURE__*/ $acw62.createElement((0, $535ef290f7dfaebe$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevYear,
        onPrev: onPrevMonth,
        onNext: onNextMonth,
        onSuperNext: onNextYear
    }), monthYearNodes);
}
var $59ffdeb452cc4773$export$2e2bcd8739ae039 = $59ffdeb452cc4773$var$DateHeader;




var $bf00cfccc8d5e82e$var$DATE_ROW_COUNT = 6;
function $bf00cfccc8d5e82e$var$DatePanel(props) {
    var prefixCls = props.prefixCls, _props$panelName = props.panelName, panelName = _props$panelName === void 0 ? 'date' : _props$panelName, keyboardConfig = props.keyboardConfig, active = props.active, operationRef = props.operationRef, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, onViewDateChange = props.onViewDateChange, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $3af8fe10d0cc7265$export$a507db46d3f03278)(event, (0, $d49SP.default)({
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addDate(value || viewDate, diff), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addDate(value || viewDate, diff * (0, $5c7b8a0508ac8191$export$fe62c2dddb4d77ea)), 'key');
                },
                onPageUpDown: function onPageUpDown(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
                }
            }, keyboardConfig));
        }
    };
    // ==================== View Operation ====================
    var onYearChange = function onYearChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    var onMonthChange = function onMonthChange(diff) {
        var newDate = generateConfig.addMonth(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(panelPrefixCls, (0, $kSlfw.default)({}, "".concat(panelPrefixCls, "-active"), active))
    }, /*#__PURE__*/ $acw62.createElement((0, $59ffdeb452cc4773$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        value: value,
        viewDate: viewDate,
        onPrevYear: function onPrevYear() {
            onYearChange(-1);
        },
        onNextYear: function onNextYear() {
            onYearChange(1);
        },
        onPrevMonth: function onPrevMonth() {
            onMonthChange(-1);
        },
        onNextMonth: function onNextMonth() {
            onMonthChange(1);
        },
        onMonthClick: function onMonthClick() {
            onPanelChange('month', viewDate);
        },
        onYearClick: function onYearClick() {
            onPanelChange('year', viewDate);
        }
    })), /*#__PURE__*/ $acw62.createElement((0, $56669640309bba5a$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        onSelect: function onSelect(date) {
            return _onSelect(date, 'mouse');
        },
        prefixCls: prefixCls,
        value: value,
        viewDate: viewDate,
        rowCount: $bf00cfccc8d5e82e$var$DATE_ROW_COUNT
    })));
}
var $bf00cfccc8d5e82e$export$2e2bcd8739ae039 = $bf00cfccc8d5e82e$var$DatePanel;





var $49937232925287a6$var$ACTIVE_PANEL = (0, $0ae673be6dd1ab39$export$65e3907585753458)('date', 'time');
function $49937232925287a6$var$DatetimePanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, generateConfig = props.generateConfig, value = props.value, defaultValue = props.defaultValue, disabledTime = props.disabledTime, showTime = props.showTime, onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), activePanel = _React$useState2[0], setActivePanel = _React$useState2[1];
    var dateOperationRef = $acw62.useRef({});
    var timeOperationRef = $acw62.useRef({});
    var timeProps = (0, $fSwVM.default)(showTime) === 'object' ? (0, $d49SP.default)({}, showTime) : {};
    // ======================= Keyboard =======================
    function getNextActive(offset) {
        var activeIndex = $49937232925287a6$var$ACTIVE_PANEL.indexOf(activePanel) + offset;
        var nextActivePanel = $49937232925287a6$var$ACTIVE_PANEL[activeIndex] || null;
        return nextActivePanel;
    }
    var onBlur = function onBlur(e) {
        if (timeOperationRef.current.onBlur) timeOperationRef.current.onBlur(e);
        setActivePanel(null);
    };
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            // Switch active panel
            if (event.which === (0, $iCi4s.default).TAB) {
                var nextActivePanel = getNextActive(event.shiftKey ? -1 : 1);
                setActivePanel(nextActivePanel);
                if (nextActivePanel) event.preventDefault();
                return true;
            }
            // Operate on current active panel
            if (activePanel) {
                var ref = activePanel === 'date' ? dateOperationRef : timeOperationRef;
                if (ref.current && ref.current.onKeyDown) ref.current.onKeyDown(event);
                return true;
            }
            // Switch first active panel if operate without panel
            if ([
                (0, $iCi4s.default).LEFT,
                (0, $iCi4s.default).RIGHT,
                (0, $iCi4s.default).UP,
                (0, $iCi4s.default).DOWN
            ].includes(event.which)) {
                setActivePanel('date');
                return true;
            }
            return false;
        },
        onBlur: onBlur,
        onClose: onBlur
    };
    // ======================== Events ========================
    var onInternalSelect = function onInternalSelect(date, source) {
        var selectedDate = date;
        if (source === 'date' && !value && timeProps.defaultValue) {
            // Date with time defaultValue
            selectedDate = generateConfig.setHour(selectedDate, generateConfig.getHour(timeProps.defaultValue));
            selectedDate = generateConfig.setMinute(selectedDate, generateConfig.getMinute(timeProps.defaultValue));
            selectedDate = generateConfig.setSecond(selectedDate, generateConfig.getSecond(timeProps.defaultValue));
        } else if (source === 'time' && !value && defaultValue) {
            selectedDate = generateConfig.setYear(selectedDate, generateConfig.getYear(defaultValue));
            selectedDate = generateConfig.setMonth(selectedDate, generateConfig.getMonth(defaultValue));
            selectedDate = generateConfig.setDate(selectedDate, generateConfig.getDate(defaultValue));
        }
        if (onSelect) onSelect(selectedDate, 'mouse');
    };
    // ======================== Render ========================
    var disabledTimes = disabledTime ? disabledTime(value || null) : {};
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(panelPrefixCls, (0, $kSlfw.default)({}, "".concat(panelPrefixCls, "-active"), activePanel))
    }, /*#__PURE__*/ $acw62.createElement((0, $bf00cfccc8d5e82e$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        operationRef: dateOperationRef,
        active: activePanel === 'date',
        onSelect: function onSelect(date) {
            onInternalSelect((0, $c1ef9d3a4d96e3db$export$3a84b9eda98e95dc)(generateConfig, date, !value && (0, $fSwVM.default)(showTime) === 'object' ? showTime.defaultValue : null), 'date');
        }
    })), /*#__PURE__*/ $acw62.createElement((0, $bcd52c381f181056$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        format: undefined
    }, timeProps, disabledTimes, {
        disabledTime: null,
        defaultValue: undefined,
        operationRef: timeOperationRef,
        active: activePanel === 'time',
        onSelect: function onSelect(date) {
            onInternalSelect(date, 'time');
        }
    })));
}
var $49937232925287a6$export$2e2bcd8739ae039 = $49937232925287a6$var$DatetimePanel;




var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


function $b30413e96fd433c0$var$WeekPanel(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, value = props.value;
    // Render additional column
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var prefixColumn = function prefixColumn(date) {
        return /*#__PURE__*/ $acw62.createElement("td", {
            key: "week",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(cellPrefixCls, "".concat(cellPrefixCls, "-week"))
        }, generateConfig.locale.getWeek(locale.locale, date));
    };
    // Add row className
    var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");
    var rowClassName = function rowClassName(date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(rowPrefixCls, (0, $kSlfw.default)({}, "".concat(rowPrefixCls, "-selected"), (0, $5c7b8a0508ac8191$export$6ea683876c36b8d2)(generateConfig, locale.locale, value, date)));
    };
    return /*#__PURE__*/ $acw62.createElement((0, $bf00cfccc8d5e82e$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        panelName: "week",
        prefixColumn: prefixColumn,
        rowClassName: rowClassName,
        keyboardConfig: {
            onLeftRight: null
        }
    }));
}
var $b30413e96fd433c0$export$2e2bcd8739ae039 = $b30413e96fd433c0$var$WeekPanel;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



function $97ac379a4f486080$var$MonthHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, viewDate = props.viewDate, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick;
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    return /*#__PURE__*/ $acw62.createElement((0, $535ef290f7dfaebe$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevYear,
        onSuperNext: onNextYear
    }), /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: onYearClick,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    })));
}
var $97ac379a4f486080$export$2e2bcd8739ae039 = $97ac379a4f486080$var$MonthHeader;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");




var $7da216c8e08371bd$export$49f80bd546511120 = 3;
var $7da216c8e08371bd$var$MONTH_ROW_COUNT = 4;
function $7da216c8e08371bd$var$MonthBody(props) {
    var prefixCls = props.prefixCls, locale = props.locale, value = props.value, viewDate = props.viewDate, generateConfig = props.generateConfig, monthCellRender = props.monthCellRender;
    var _React$useContext = $acw62.useContext((0, $ad011b5d5dcecbe5$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var getCellClassName = (0, $5ba36c8d11bcff41$export$2e2bcd8739ae039)({
        cellPrefixCls: cellPrefixCls,
        value: value,
        generateConfig: generateConfig,
        rangedValue: rangedValue,
        hoverRangedValue: hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $5c7b8a0508ac8191$export$a18c89cbd24170ff)(generateConfig, current, target);
        },
        isInView: function isInView() {
            return true;
        },
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addMonth(date, offset);
        }
    });
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    var baseMonth = generateConfig.setMonth(viewDate, 0);
    var getCellNode = monthCellRender ? function(date) {
        return monthCellRender(date, locale);
    } : undefined;
    return /*#__PURE__*/ $acw62.createElement((0, $9660a21fda1f017c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        rowNum: $7da216c8e08371bd$var$MONTH_ROW_COUNT,
        colNum: $7da216c8e08371bd$export$49f80bd546511120,
        baseDate: baseMonth,
        getCellNode: getCellNode,
        getCellText: function getCellText(date) {
            return locale.monthFormat ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: locale.monthFormat,
                generateConfig: generateConfig
            }) : monthsLocale[generateConfig.getMonth(date)];
        },
        getCellClassName: getCellClassName,
        getCellDate: generateConfig.addMonth,
        titleCell: function titleCell(date) {
            return (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY-MM',
                generateConfig: generateConfig
            });
        }
    }));
}
var $7da216c8e08371bd$export$2e2bcd8739ae039 = $7da216c8e08371bd$var$MonthBody;



function $387ec3f740e3ebd6$var$MonthPanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-month-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $3af8fe10d0cc7265$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff * (0, $7da216c8e08371bd$export$49f80bd546511120)), 'key');
                },
                onEnter: function onEnter() {
                    onPanelChange('date', value || viewDate);
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onYearChange = function onYearChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $acw62.createElement((0, $97ac379a4f486080$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onPrevYear: function onPrevYear() {
            onYearChange(-1);
        },
        onNextYear: function onNextYear() {
            onYearChange(1);
        },
        onYearClick: function onYearClick() {
            onPanelChange('year', viewDate);
        }
    })), /*#__PURE__*/ $acw62.createElement((0, $7da216c8e08371bd$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: function onSelect(date) {
            _onSelect(date, 'mouse');
            onPanelChange('date', date);
        }
    })));
}
var $387ec3f740e3ebd6$export$2e2bcd8739ae039 = $387ec3f740e3ebd6$var$MonthPanel;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



function $45f2818829d664fc$var$QuarterHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, viewDate = props.viewDate, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick;
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    return /*#__PURE__*/ $acw62.createElement((0, $535ef290f7dfaebe$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevYear,
        onSuperNext: onNextYear
    }), /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: onYearClick,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    })));
}
var $45f2818829d664fc$export$2e2bcd8739ae039 = $45f2818829d664fc$var$QuarterHeader;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");




var $bddd6ab17fc7d772$export$ea79b61dfefe9355 = 4;
var $bddd6ab17fc7d772$var$QUARTER_ROW_COUNT = 1;
function $bddd6ab17fc7d772$var$QuarterBody(props) {
    var prefixCls = props.prefixCls, locale = props.locale, value = props.value, viewDate = props.viewDate, generateConfig = props.generateConfig;
    var _React$useContext = $acw62.useContext((0, $ad011b5d5dcecbe5$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var getCellClassName = (0, $5ba36c8d11bcff41$export$2e2bcd8739ae039)({
        cellPrefixCls: cellPrefixCls,
        value: value,
        generateConfig: generateConfig,
        rangedValue: rangedValue,
        hoverRangedValue: hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $5c7b8a0508ac8191$export$5c60e4190867161c)(generateConfig, current, target);
        },
        isInView: function isInView() {
            return true;
        },
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addMonth(date, offset * 3);
        }
    });
    var baseQuarter = generateConfig.setDate(generateConfig.setMonth(viewDate, 0), 1);
    return /*#__PURE__*/ $acw62.createElement((0, $9660a21fda1f017c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        rowNum: $bddd6ab17fc7d772$var$QUARTER_ROW_COUNT,
        colNum: $bddd6ab17fc7d772$export$ea79b61dfefe9355,
        baseDate: baseQuarter,
        getCellText: function getCellText(date) {
            return (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: locale.quarterFormat || '[Q]Q',
                generateConfig: generateConfig
            });
        },
        getCellClassName: getCellClassName,
        getCellDate: function getCellDate(date, offset) {
            return generateConfig.addMonth(date, offset * 3);
        },
        titleCell: function titleCell(date) {
            return (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY-[Q]Q',
                generateConfig: generateConfig
            });
        }
    }));
}
var $bddd6ab17fc7d772$export$2e2bcd8739ae039 = $bddd6ab17fc7d772$var$QuarterBody;



function $061ce97247677754$var$QuarterPanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-quarter-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $3af8fe10d0cc7265$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff * 3), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onYearChange = function onYearChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $acw62.createElement((0, $45f2818829d664fc$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onPrevYear: function onPrevYear() {
            onYearChange(-1);
        },
        onNextYear: function onNextYear() {
            onYearChange(1);
        },
        onYearClick: function onYearClick() {
            onPanelChange('year', viewDate);
        }
    })), /*#__PURE__*/ $acw62.createElement((0, $bddd6ab17fc7d772$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: function onSelect(date) {
            _onSelect(date, 'mouse');
        }
    })));
}
var $061ce97247677754$export$2e2bcd8739ae039 = $061ce97247677754$var$QuarterPanel;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



function $06dc8488ae8126c2$var$YearHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, viewDate = props.viewDate, onPrevDecade = props.onPrevDecade, onNextDecade = props.onNextDecade, onDecadeClick = props.onDecadeClick;
    var _React$useContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var yearNumber = generateConfig.getYear(viewDate);
    var startYear = Math.floor(yearNumber / (0, $dc431bb9f1f9cf09$export$7e6e0078f5dd4028)) * (0, $dc431bb9f1f9cf09$export$7e6e0078f5dd4028);
    var endYear = startYear + (0, $dc431bb9f1f9cf09$export$7e6e0078f5dd4028) - 1;
    return /*#__PURE__*/ $acw62.createElement((0, $535ef290f7dfaebe$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevDecade,
        onSuperNext: onNextDecade
    }), /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        onClick: onDecadeClick,
        className: "".concat(prefixCls, "-decade-btn")
    }, startYear, "-", endYear));
}
var $06dc8488ae8126c2$export$2e2bcd8739ae039 = $06dc8488ae8126c2$var$YearHeader;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");





var $82aada7bc15ed137$export$608dede485114b93 = 3;
var $82aada7bc15ed137$var$YEAR_ROW_COUNT = 4;
function $82aada7bc15ed137$var$YearBody(props) {
    var prefixCls = props.prefixCls, value = props.value, viewDate = props.viewDate, locale = props.locale, generateConfig = props.generateConfig;
    var _React$useContext = $acw62.useContext((0, $ad011b5d5dcecbe5$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var yearPrefixCls = "".concat(prefixCls, "-cell");
    // =============================== Year ===============================
    var yearNumber = generateConfig.getYear(viewDate);
    var startYear = Math.floor(yearNumber / (0, $dc431bb9f1f9cf09$export$7e6e0078f5dd4028)) * (0, $dc431bb9f1f9cf09$export$7e6e0078f5dd4028);
    var endYear = startYear + (0, $dc431bb9f1f9cf09$export$7e6e0078f5dd4028) - 1;
    var baseYear = generateConfig.setYear(viewDate, startYear - Math.ceil(($82aada7bc15ed137$export$608dede485114b93 * $82aada7bc15ed137$var$YEAR_ROW_COUNT - (0, $dc431bb9f1f9cf09$export$7e6e0078f5dd4028)) / 2));
    var isInView = function isInView(date) {
        var currentYearNumber = generateConfig.getYear(date);
        return startYear <= currentYearNumber && currentYearNumber <= endYear;
    };
    var getCellClassName = (0, $5ba36c8d11bcff41$export$2e2bcd8739ae039)({
        cellPrefixCls: yearPrefixCls,
        value: value,
        generateConfig: generateConfig,
        rangedValue: rangedValue,
        hoverRangedValue: hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $5c7b8a0508ac8191$export$5841f9eb9773f25f)(generateConfig, current, target);
        },
        isInView: isInView,
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addYear(date, offset);
        }
    });
    return /*#__PURE__*/ $acw62.createElement((0, $9660a21fda1f017c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        rowNum: $82aada7bc15ed137$var$YEAR_ROW_COUNT,
        colNum: $82aada7bc15ed137$export$608dede485114b93,
        baseDate: baseYear,
        getCellText: generateConfig.getYear,
        getCellClassName: getCellClassName,
        getCellDate: generateConfig.addYear,
        titleCell: function titleCell(date) {
            return (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY',
                generateConfig: generateConfig
            });
        }
    }));
}
var $82aada7bc15ed137$export$2e2bcd8739ae039 = $82aada7bc15ed137$var$YearBody;



var $dc431bb9f1f9cf09$export$7e6e0078f5dd4028 = 10;
function $dc431bb9f1f9cf09$var$YearPanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, sourceMode = props.sourceMode, _onSelect = props.onSelect, onPanelChange = props.onPanelChange;
    var panelPrefixCls = "".concat(prefixCls, "-year-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $3af8fe10d0cc7265$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff * $dc431bb9f1f9cf09$export$7e6e0078f5dd4028), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff * (0, $82aada7bc15ed137$export$608dede485114b93)), 'key');
                },
                onEnter: function onEnter() {
                    onPanelChange(sourceMode === 'date' ? 'date' : 'month', value || viewDate);
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onDecadeChange = function onDecadeChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff * 10);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $acw62.createElement((0, $06dc8488ae8126c2$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onPrevDecade: function onPrevDecade() {
            onDecadeChange(-1);
        },
        onNextDecade: function onNextDecade() {
            onDecadeChange(1);
        },
        onDecadeClick: function onDecadeClick() {
            onPanelChange('decade', viewDate);
        }
    })), /*#__PURE__*/ $acw62.createElement((0, $82aada7bc15ed137$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: function onSelect(date) {
            onPanelChange(sourceMode === 'date' ? 'date' : 'month', date);
            _onSelect(date, 'mouse');
        }
    })));
}
var $dc431bb9f1f9cf09$export$2e2bcd8739ae039 = $dc431bb9f1f9cf09$var$YearPanel;









var $acw62 = parcelRequire("acw62");
function $7fee307d6842180e$export$2e2bcd8739ae039(prefixCls, mode, renderExtraFooter) {
    if (!renderExtraFooter) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
    }, renderExtraFooter(mode));
}



var $acw62 = parcelRequire("acw62");
function $a8e10f6fa0ffb7a7$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, _ref$rangeList = _ref.rangeList, rangeList = _ref$rangeList === void 0 ? [] : _ref$rangeList, _ref$components = _ref.components, components = _ref$components === void 0 ? {} : _ref$components, needConfirmButton = _ref.needConfirmButton, onNow = _ref.onNow, onOk = _ref.onOk, okDisabled = _ref.okDisabled, showNow = _ref.showNow, locale = _ref.locale;
    var presetNode;
    var okNode;
    if (rangeList.length) {
        var Item = components.rangeItem || 'span';
        presetNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, rangeList.map(function(_ref2) {
            var label = _ref2.label, onClick = _ref2.onClick, onMouseEnter = _ref2.onMouseEnter, onMouseLeave = _ref2.onMouseLeave;
            return /*#__PURE__*/ $acw62.createElement("li", {
                key: label,
                className: "".concat(prefixCls, "-preset")
            }, /*#__PURE__*/ $acw62.createElement(Item, {
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            }, label));
        }));
    }
    if (needConfirmButton) {
        var Button = components.button || 'button';
        if (onNow && !presetNode && showNow !== false) presetNode = /*#__PURE__*/ $acw62.createElement("li", {
            className: "".concat(prefixCls, "-now")
        }, /*#__PURE__*/ $acw62.createElement("a", {
            className: "".concat(prefixCls, "-now-btn"),
            onClick: onNow
        }, locale.now));
        okNode = needConfirmButton && /*#__PURE__*/ $acw62.createElement("li", {
            className: "".concat(prefixCls, "-ok")
        }, /*#__PURE__*/ $acw62.createElement(Button, {
            disabled: okDisabled,
            onClick: onOk
        }, locale.ok));
    }
    if (!presetNode && !okNode) return null;
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: "".concat(prefixCls, "-ranges")
    }, presetNode, okNode);
}



// Calendar picker type
var $3cd39e0593b856e7$var$CALENDAR_PANEL_MODE = [
    'date',
    'month'
];
function $3cd39e0593b856e7$var$PickerPanel(props) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, className = props.className, style = props.style, locale = props.locale, generateConfig = props.generateConfig, value = props.value, defaultValue = props.defaultValue, pickerValue = props.pickerValue, defaultPickerValue = props.defaultPickerValue, disabledDate = props.disabledDate, mode = props.mode, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, showNow = props.showNow, showTime = props.showTime, showToday = props.showToday, renderExtraFooter = props.renderExtraFooter, hideHeader = props.hideHeader, onSelect = props.onSelect, onChange = props.onChange, onPanelChange = props.onPanelChange, onMouseDown = props.onMouseDown, onPickerValueChange = props.onPickerValueChange, _onOk = props.onOk, components = props.components, direction = props.direction, _props$hourStep = props.hourStep, hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep, _props$minuteStep = props.minuteStep, minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep, _props$secondStep = props.secondStep, secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep;
    var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
    var isHourStepValid = 24 % hourStep === 0;
    var isMinuteStepValid = 60 % minuteStep === 0;
    var isSecondStepValid = 60 % secondStep === 0;
    // ============================ State =============================
    var panelContext = $acw62.useContext((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039));
    var operationRef = panelContext.operationRef, panelDivRef = panelContext.panelRef, onContextSelect = panelContext.onSelect, hideRanges = panelContext.hideRanges, defaultOpenValue = panelContext.defaultOpenValue;
    var _React$useContext = $acw62.useContext((0, $ad011b5d5dcecbe5$export$2e2bcd8739ae039)), inRange = _React$useContext.inRange, panelPosition = _React$useContext.panelPosition, rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var panelRef = $acw62.useRef({});
    // Handle init logic
    var initRef = $acw62.useRef(true);
    // Value
    var _useMergedState = (0, $iSQh8.default)(null, {
        value: value,
        defaultValue: defaultValue,
        postState: function postState(val) {
            if (!val && defaultOpenValue && picker === 'time') return defaultOpenValue;
            return val;
        }
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
    // View date control
    var _useMergedState3 = (0, $iSQh8.default)(null, {
        value: pickerValue,
        defaultValue: defaultPickerValue || mergedValue,
        postState: function postState(date) {
            var now = generateConfig.getNow();
            if (!date) return now;
            // When value is null and set showTime
            if (!mergedValue && showTime) {
                var defaultDateObject = (0, $fSwVM.default)(showTime) === 'object' ? showTime.defaultValue : defaultValue;
                return (0, $c1ef9d3a4d96e3db$export$3a84b9eda98e95dc)(generateConfig, Array.isArray(date) ? date[0] : date, defaultDateObject || now);
            }
            return Array.isArray(date) ? date[0] : date;
        }
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), viewDate = _useMergedState4[0], setInnerViewDate = _useMergedState4[1];
    var setViewDate = function setViewDate(date) {
        setInnerViewDate(date);
        if (onPickerValueChange) onPickerValueChange(date);
    };
    // Panel control
    var getInternalNextMode = function getInternalNextMode(nextMode) {
        var getNextMode = (0, $3af8fe10d0cc7265$export$6b35bb792c096c09)[picker];
        if (getNextMode) return getNextMode(nextMode);
        return nextMode;
    };
    // Save panel is changed from which panel
    var _useMergedState5 = (0, $iSQh8.default)(function() {
        if (picker === 'time') return 'time';
        return getInternalNextMode('date');
    }, {
        value: mode
    }), _useMergedState6 = (0, $eUqlC.default)(_useMergedState5, 2), mergedMode = _useMergedState6[0], setInnerMode = _useMergedState6[1];
    $acw62.useEffect(function() {
        setInnerMode(picker);
    }, [
        picker
    ]);
    var _React$useState = $acw62.useState(function() {
        return mergedMode;
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), sourceMode = _React$useState2[0], setSourceMode = _React$useState2[1];
    var onInternalPanelChange = function onInternalPanelChange(newMode, viewValue) {
        var nextMode = getInternalNextMode(newMode || mergedMode);
        setSourceMode(mergedMode);
        setInnerMode(nextMode);
        if (onPanelChange && (mergedMode !== nextMode || (0, $5c7b8a0508ac8191$export$248d38f6296296c5)(generateConfig, viewDate, viewDate))) onPanelChange(viewValue, nextMode);
    };
    var triggerSelect = function triggerSelect(date, type) {
        var forceTriggerSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (mergedMode === picker || forceTriggerSelect) {
            setInnerValue(date);
            if (onSelect) onSelect(date);
            if (onContextSelect) onContextSelect(date, type);
            if (onChange && !(0, $5c7b8a0508ac8191$export$248d38f6296296c5)(generateConfig, date, mergedValue) && !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date))) onChange(date);
        }
    };
    var isSelectable = function isSelectable(key) {
        if ($3cd39e0593b856e7$var$CALENDAR_PANEL_MODE.includes(mergedMode)) {
            var date;
            var operationFnc;
            var isDateMode = mergedMode === 'date';
            if (key === (0, $iCi4s.default).PAGE_UP || key === (0, $iCi4s.default).PAGE_DOWN) operationFnc = isDateMode ? generateConfig.addMonth : generateConfig.addYear;
            else operationFnc = isDateMode ? generateConfig.addDate : generateConfig.addMonth;
            switch(key){
                case (0, $iCi4s.default).LEFT:
                case (0, $iCi4s.default).PAGE_UP:
                    date = operationFnc(viewDate, -1);
                    break;
                case (0, $iCi4s.default).RIGHT:
                case (0, $iCi4s.default).PAGE_DOWN:
                    date = operationFnc(viewDate, 1);
                    break;
                case (0, $iCi4s.default).UP:
                case (0, $iCi4s.default).DOWN:
                    date = operationFnc(viewDate, Number("".concat(key === (0, $iCi4s.default).UP ? '-' : '').concat(isDateMode ? (0, $5c7b8a0508ac8191$export$fe62c2dddb4d77ea) : (0, $7da216c8e08371bd$export$49f80bd546511120))));
                    break;
            }
            if (date) return !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date));
        }
        return true;
    };
    // ========================= Interactive ==========================
    var onInternalKeyDown = function onInternalKeyDown(e) {
        if (panelRef.current && panelRef.current.onKeyDown) {
            var selectable = true;
            var which = e.which;
            if ([
                (0, $iCi4s.default).LEFT,
                (0, $iCi4s.default).RIGHT,
                (0, $iCi4s.default).UP,
                (0, $iCi4s.default).DOWN,
                (0, $iCi4s.default).PAGE_UP,
                (0, $iCi4s.default).PAGE_DOWN,
                (0, $iCi4s.default).ENTER
            ].includes(which)) {
                e.preventDefault();
                if (which !== (0, $iCi4s.default).ENTER && tabIndex === 0) selectable = isSelectable(which);
            }
            // Cannot use keyboard to select disabled date
            if (selectable) return panelRef.current.onKeyDown(e);
        }
        (0, $u43uR.default)(false, 'Panel not correct handle keyDown event. Please help to fire issue about this.');
        return false;
    /* eslint-enable no-lone-blocks */ };
    var onInternalBlur = function onInternalBlur(e) {
        if (panelRef.current && panelRef.current.onBlur) panelRef.current.onBlur(e);
    };
    if (operationRef && panelPosition !== 'right') operationRef.current = {
        onKeyDown: onInternalKeyDown,
        onClose: function onClose() {
            if (panelRef.current && panelRef.current.onClose) panelRef.current.onClose();
        }
    };
    // ============================ Effect ============================
    $acw62.useEffect(function() {
        if (value && !initRef.current) setInnerViewDate(value);
    }, [
        value
    ]);
    $acw62.useEffect(function() {
        initRef.current = false;
    }, []);
    // ============================ Panels ============================
    var panelNode;
    var pickerProps = (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        operationRef: panelRef,
        prefixCls: prefixCls,
        viewDate: viewDate,
        value: mergedValue,
        onViewDateChange: setViewDate,
        sourceMode: sourceMode,
        onPanelChange: onInternalPanelChange,
        disabledDate: disabledDate
    });
    delete pickerProps.onChange;
    delete pickerProps.onSelect;
    switch(mergedMode){
        case 'decade':
            panelNode = /*#__PURE__*/ $acw62.createElement((0, $e32ba469ff7ad7ff$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'year':
            panelNode = /*#__PURE__*/ $acw62.createElement((0, $dc431bb9f1f9cf09$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'month':
            panelNode = /*#__PURE__*/ $acw62.createElement((0, $387ec3f740e3ebd6$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'quarter':
            panelNode = /*#__PURE__*/ $acw62.createElement((0, $061ce97247677754$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'week':
            panelNode = /*#__PURE__*/ $acw62.createElement((0, $b30413e96fd433c0$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'time':
            delete pickerProps.showTime;
            panelNode = /*#__PURE__*/ $acw62.createElement((0, $bcd52c381f181056$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, (0, $fSwVM.default)(showTime) === 'object' ? showTime : null, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        default:
            if (showTime) panelNode = /*#__PURE__*/ $acw62.createElement((0, $49937232925287a6$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            else panelNode = /*#__PURE__*/ $acw62.createElement((0, $bf00cfccc8d5e82e$export$2e2bcd8739ae039), (0, $8nd05.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
    }
    // ============================ Footer ============================
    var extraFooter;
    var rangesNode;
    var onNow = function onNow() {
        var now = generateConfig.getNow();
        var lowerBoundTime = (0, $c1ef9d3a4d96e3db$export$6ebc74d7e616149)(generateConfig.getHour(now), generateConfig.getMinute(now), generateConfig.getSecond(now), isHourStepValid ? hourStep : 1, isMinuteStepValid ? minuteStep : 1, isSecondStepValid ? secondStep : 1);
        var adjustedNow = (0, $c1ef9d3a4d96e3db$export$e5d5e1c1822b6e56)(generateConfig, now, lowerBoundTime[0], // hour
        lowerBoundTime[1], // minute
        lowerBoundTime[2]);
        triggerSelect(adjustedNow, 'submit');
    };
    if (!hideRanges) {
        extraFooter = (0, $7fee307d6842180e$export$2e2bcd8739ae039)(prefixCls, mergedMode, renderExtraFooter);
        rangesNode = (0, $a8e10f6fa0ffb7a7$export$2e2bcd8739ae039)({
            prefixCls: prefixCls,
            components: components,
            needConfirmButton: needConfirmButton,
            okDisabled: !mergedValue || disabledDate && disabledDate(mergedValue),
            locale: locale,
            showNow: showNow,
            onNow: needConfirmButton && onNow,
            onOk: function onOk() {
                if (mergedValue) {
                    triggerSelect(mergedValue, 'submit', true);
                    if (_onOk) _onOk(mergedValue);
                }
            }
        });
    }
    var todayNode;
    if (showToday && mergedMode === 'date' && picker === 'date' && !showTime) {
        var now = generateConfig.getNow();
        var todayCls = "".concat(prefixCls, "-today-btn");
        var disabled = disabledDate && disabledDate(now);
        todayNode = /*#__PURE__*/ $acw62.createElement("a", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(todayCls, disabled && "".concat(todayCls, "-disabled")),
            "aria-disabled": disabled,
            onClick: function onClick() {
                if (!disabled) triggerSelect(now, 'mouse', true);
            }
        }, locale.today);
    }
    return /*#__PURE__*/ $acw62.createElement((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039).Provider, {
        value: (0, $d49SP.default)((0, $d49SP.default)({}, panelContext), {}, {
            mode: mergedMode,
            hideHeader: 'hideHeader' in props ? hideHeader : panelContext.hideHeader,
            hidePrevBtn: inRange && panelPosition === 'right',
            hideNextBtn: inRange && panelPosition === 'left'
        })
    }, /*#__PURE__*/ $acw62.createElement("div", {
        tabIndex: tabIndex,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-panel"), className, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-panel-has-range"), rangedValue && rangedValue[0] && rangedValue[1]), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-panel-has-range-hover"), hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1]), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-panel-rtl"), direction === 'rtl'), _classNames)),
        style: style,
        onKeyDown: onInternalKeyDown,
        onBlur: onInternalBlur,
        onMouseDown: onMouseDown,
        ref: panelDivRef
    }, panelNode, extraFooter || rangesNode || todayNode ? /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, extraFooter, rangesNode, todayNode) : null));
}
var $3cd39e0593b856e7$export$2e2bcd8739ae039 /* eslint-enable */  = $3cd39e0593b856e7$var$PickerPanel;



var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $grQtM = parcelRequire("grQtM");
var $9e7a3f80f93f6451$var$BUILT_IN_PLACEMENTS = {
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    }
};
function $9e7a3f80f93f6451$var$PickerTrigger(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, popupElement = _ref.popupElement, popupStyle = _ref.popupStyle, visible = _ref.visible, dropdownClassName = _ref.dropdownClassName, dropdownAlign = _ref.dropdownAlign, transitionName = _ref.transitionName, getPopupContainer = _ref.getPopupContainer, children = _ref.children, range = _ref.range, popupPlacement = _ref.popupPlacement, direction = _ref.direction;
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var getPopupPlacement = function getPopupPlacement() {
        if (popupPlacement !== undefined) return popupPlacement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    };
    return /*#__PURE__*/ $acw62.createElement((0, $grQtM.default), {
        showAction: [],
        hideAction: [],
        popupPlacement: getPopupPlacement(),
        builtinPlacements: $9e7a3f80f93f6451$var$BUILT_IN_PLACEMENTS,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: transitionName,
        popup: popupElement,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dropdownClassName, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(dropdownPrefixCls, "-range"), range), (0, $kSlfw.default)(_classNames, "".concat(dropdownPrefixCls, "-rtl"), direction === 'rtl'), _classNames)),
        popupStyle: popupStyle,
        getPopupContainer: getPopupContainer
    }, children);
}
var $9e7a3f80f93f6451$export$2e2bcd8739ae039 = $9e7a3f80f93f6451$var$PickerTrigger;







var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $iCi4s = parcelRequire("iCi4s");

function $58d8dfa310cd09e6$export$2e2bcd8739ae039(_ref) {
    var open = _ref.open, value = _ref.value, isClickOutside = _ref.isClickOutside, triggerOpen = _ref.triggerOpen, forwardKeyDown = _ref.forwardKeyDown, _onKeyDown = _ref.onKeyDown, blurToCancel = _ref.blurToCancel, onSubmit = _ref.onSubmit, onCancel = _ref.onCancel, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur, currentFocusedKey = _ref.currentFocusedKey, _ref$key = _ref.key, key = _ref$key === void 0 ? 'start' : _ref$key;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), typing = _useState2[0], setTyping = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $eUqlC.default)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var delayBlurTimer = (0, $acw62.useRef)();
    /**
   * We will prevent blur to handle open event when user click outside,
   * since this will repeat trigger `onOpenChange` event.
   */ var preventBlurRef = (0, $acw62.useRef)(false);
    var valueChangedRef = (0, $acw62.useRef)(false);
    var preventDefaultRef = (0, $acw62.useRef)(false);
    var inputProps = {
        onMouseDown: function onMouseDown() {
            setTyping(true);
            triggerOpen(true);
        },
        onKeyDown: function onKeyDown(e) {
            var preventDefault = function preventDefault() {
                preventDefaultRef.current = true;
            };
            _onKeyDown(e, preventDefault);
            if (preventDefaultRef.current) return;
            switch(e.which){
                case (0, $iCi4s.default).ENTER:
                    if (!open) triggerOpen(true);
                    else if (onSubmit() !== false) setTyping(true);
                    e.preventDefault();
                    return;
                case (0, $iCi4s.default).TAB:
                    if (typing && open && !e.shiftKey) {
                        setTyping(false);
                        e.preventDefault();
                    } else if (!typing && open) {
                        if (!forwardKeyDown(e) && e.shiftKey) {
                            setTyping(true);
                            e.preventDefault();
                        }
                    }
                    return;
                case (0, $iCi4s.default).ESC:
                    setTyping(true);
                    onCancel();
                    return;
            }
            if (!open && ![
                (0, $iCi4s.default).SHIFT
            ].includes(e.which)) triggerOpen(true);
            else if (!typing) // Let popup panel handle keyboard
            forwardKeyDown(e);
        },
        onFocus: function onFocus(e) {
            setTyping(true);
            setFocused(true);
            if (currentFocusedKey) currentFocusedKey.current = key;
            clearTimeout(delayBlurTimer.current);
            if (_onFocus) _onFocus(e);
        },
        onBlur: function onBlur(e) {
            if (preventBlurRef.current || !isClickOutside(document.activeElement)) {
                preventBlurRef.current = false;
                return;
            }
            if (blurToCancel) setTimeout(function() {
                var _document = document, activeElement = _document.activeElement;
                while(activeElement && activeElement.shadowRoot)activeElement = activeElement.shadowRoot.activeElement;
                if (isClickOutside(activeElement)) onCancel();
            }, 0);
            else if (open) {
                triggerOpen(false);
                if (valueChangedRef.current) onSubmit();
            }
            setFocused(false);
            if (currentFocusedKey) {
                currentFocusedKey.current = '';
                // Delay to prevent 'range' focus transitions from firing resulting in incorrect out-of-focus events
                delayBlurTimer.current = setTimeout(function() {
                    // Prevent the 'blur' event from firing when there is currently a focused input
                    if (currentFocusedKey.current) return;
                    _onBlur === null || _onBlur === void 0 || _onBlur(e);
                }, 100);
            } else _onBlur === null || _onBlur === void 0 || _onBlur(e);
        }
    };
    // check if value changed
    (0, $acw62.useEffect)(function() {
        valueChangedRef.current = false;
    }, [
        open
    ]);
    (0, $acw62.useEffect)(function() {
        valueChangedRef.current = true;
    }, [
        value
    ]);
    // Global click handler
    (0, $acw62.useEffect)(function() {
        return (0, $3af8fe10d0cc7265$export$1ccf549497681f00)(function(e) {
            var target = (0, $3af8fe10d0cc7265$export$2fb4f2d524461006)(e);
            var clickedOutside = isClickOutside(target);
            if (open) {
                if (!clickedOutside) {
                    preventBlurRef.current = true;
                    // Always set back in case `onBlur` prevented by user
                    requestAnimationFrame(function() {
                        preventBlurRef.current = false;
                    });
                } else if (!focused || clickedOutside) triggerOpen(false);
            } else if (focused && !clickedOutside) preventBlurRef.current = true;
        });
    });
    (0, $acw62.useEffect)(function() {
        return function() {
            return clearTimeout(delayBlurTimer.current);
        };
    }, []);
    return [
        inputProps,
        {
            focused: focused,
            typing: typing
        }
    ];
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $1fbbc159ab8192b4$export$2e2bcd8739ae039(_ref) {
    var valueTexts = _ref.valueTexts, onTextChange = _ref.onTextChange;
    var _React$useState = $acw62.useState(''), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), text = _React$useState2[0], setInnerText = _React$useState2[1];
    var valueTextsRef = $acw62.useRef([]);
    valueTextsRef.current = valueTexts;
    function triggerTextChange(value) {
        setInnerText(value);
        onTextChange(value);
    }
    function resetText() {
        setInnerText(valueTextsRef.current[0]);
    }
    $acw62.useEffect(function() {
        if (valueTexts.every(function(valText) {
            return valText !== text;
        })) resetText();
    }, [
        valueTexts.join('||')
    ]);
    return [
        text,
        triggerTextChange,
        resetText
    ];
}



var $3Ysvw = parcelRequire("3Ysvw");

var $4AFGH = parcelRequire("4AFGH");

function $9d6eb9d7ffbf50e1$export$2e2bcd8739ae039(value, _ref) {
    var formatList = _ref.formatList, generateConfig = _ref.generateConfig, locale = _ref.locale;
    return (0, $3Ysvw.default)(function() {
        if (!value) return [
            [
                ''
            ],
            ''
        ];
        // We will convert data format back to first format
        var firstValueText = '';
        var fullValueTexts = [];
        for(var i = 0; i < formatList.length; i += 1){
            var format = formatList[i];
            var formatStr = (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(value, {
                generateConfig: generateConfig,
                locale: locale,
                format: format
            });
            fullValueTexts.push(formatStr);
            if (i === 0) firstValueText = formatStr;
        }
        return [
            fullValueTexts,
            firstValueText
        ];
    }, [
        value,
        formatList,
        locale
    ], function(prev, next) {
        return(// Not Same Date
        !(0, $5c7b8a0508ac8191$export$248d38f6296296c5)(generateConfig, prev[0], next[0]) || // Not Same format
        !(0, $4AFGH.default)(prev[1], next[1], true) || // Not Same locale
        !(0, $4AFGH.default)(prev[2], next[2], true));
    });
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

function $4d1945ae4e4a5fce$export$2e2bcd8739ae039(valueText, _ref) {
    var formatList = _ref.formatList, generateConfig = _ref.generateConfig, locale = _ref.locale;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $eUqlC.default)(_useState, 2), value = _useState2[0], internalSetValue = _useState2[1];
    var raf = (0, $acw62.useRef)(null);
    function setValue(val) {
        var immediately = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        cancelAnimationFrame(raf.current);
        if (immediately) {
            internalSetValue(val);
            return;
        }
        raf.current = requestAnimationFrame(function() {
            internalSetValue(val);
        });
    }
    var _useValueTexts = (0, $9d6eb9d7ffbf50e1$export$2e2bcd8739ae039)(value, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useValueTexts2 = (0, $eUqlC.default)(_useValueTexts, 2), firstText = _useValueTexts2[1];
    function onEnter(date) {
        setValue(date);
    }
    function onLeave() {
        var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        setValue(null, immediately);
    }
    (0, $acw62.useEffect)(function() {
        onLeave(true);
    }, [
        valueText
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            return cancelAnimationFrame(raf.current);
        };
    }, []);
    return [
        firstText,
        onEnter,
        onLeave
    ];
}



var $u43uR = parcelRequire("u43uR");
function $22a38e3e56b3866c$export$cfe7369d67de3234(props) {
    var picker = props.picker, disabledHours = props.disabledHours, disabledMinutes = props.disabledMinutes, disabledSeconds = props.disabledSeconds;
    if (picker === 'time' && (disabledHours || disabledMinutes || disabledSeconds)) (0, $u43uR.default)(false, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
}


function $09e62d4b02aa648b$var$InnerPicker(props) {
    var _classNames2;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, id = props.id, tabIndex = props.tabIndex, style = props.style, className = props.className, dropdownClassName = props.dropdownClassName, dropdownAlign = props.dropdownAlign, popupStyle = props.popupStyle, transitionName = props.transitionName, generateConfig = props.generateConfig, locale = props.locale, inputReadOnly = props.inputReadOnly, allowClear = props.allowClear, autoFocus = props.autoFocus, showTime = props.showTime, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, format = props.format, use12Hours = props.use12Hours, value = props.value, defaultValue = props.defaultValue, open = props.open, defaultOpen = props.defaultOpen, defaultOpenValue = props.defaultOpenValue, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, disabled = props.disabled, disabledDate = props.disabledDate, placeholder = props.placeholder, getPopupContainer = props.getPopupContainer, pickerRef = props.pickerRef, panelRender = props.panelRender, onChange = props.onChange, onOpenChange = props.onOpenChange, onFocus = props.onFocus, onBlur = props.onBlur, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onContextMenu = props.onContextMenu, onClick = props.onClick, _onKeyDown = props.onKeyDown, _onSelect = props.onSelect, direction = props.direction, _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete, inputRender = props.inputRender;
    var inputRef = $acw62.useRef(null);
    var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
    // ============================= State =============================
    var formatList = (0, $0ae673be6dd1ab39$export$45b10814cc054894)((0, $3af8fe10d0cc7265$export$3e0385bd234197e6)(format, picker, showTime, use12Hours));
    // Panel ref
    var panelDivRef = $acw62.useRef(null);
    var inputDivRef = $acw62.useRef(null);
    var containerRef = $acw62.useRef(null);
    // Real value
    var _useMergedState = (0, $iSQh8.default)(null, {
        value: value,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
    // Selected value
    var _React$useState = $acw62.useState(mergedValue), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), selectedValue = _React$useState2[0], setSelectedValue = _React$useState2[1];
    // Operation ref
    var operationRef = $acw62.useRef(null);
    // Open
    var _useMergedState3 = (0, $iSQh8.default)(false, {
        value: open,
        defaultValue: defaultOpen,
        postState: function postState(postOpen) {
            return disabled ? false : postOpen;
        },
        onChange: function onChange(newOpen) {
            if (onOpenChange) onOpenChange(newOpen);
            if (!newOpen && operationRef.current && operationRef.current.onClose) operationRef.current.onClose();
        }
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), mergedOpen = _useMergedState4[0], triggerInnerOpen = _useMergedState4[1];
    // ============================= Text ==============================
    var _useValueTexts = (0, $9d6eb9d7ffbf50e1$export$2e2bcd8739ae039)(selectedValue, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useValueTexts2 = (0, $eUqlC.default)(_useValueTexts, 2), valueTexts = _useValueTexts2[0], firstValueText = _useValueTexts2[1];
    var _useTextValueMapping = (0, $1fbbc159ab8192b4$export$2e2bcd8739ae039)({
        valueTexts: valueTexts,
        onTextChange: function onTextChange(newText) {
            var inputDate = (0, $5c7b8a0508ac8191$export$5303528d1070ff6f)(newText, {
                locale: locale,
                formatList: formatList,
                generateConfig: generateConfig
            });
            if (inputDate && (!disabledDate || !disabledDate(inputDate))) setSelectedValue(inputDate);
        }
    }), _useTextValueMapping2 = (0, $eUqlC.default)(_useTextValueMapping, 3), text = _useTextValueMapping2[0], triggerTextChange = _useTextValueMapping2[1], resetText = _useTextValueMapping2[2];
    // ============================ Trigger ============================
    var triggerChange = function triggerChange(newValue) {
        setSelectedValue(newValue);
        setInnerValue(newValue);
        if (onChange && !(0, $5c7b8a0508ac8191$export$248d38f6296296c5)(generateConfig, mergedValue, newValue)) onChange(newValue, newValue ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(newValue, {
            generateConfig: generateConfig,
            locale: locale,
            format: formatList[0]
        }) : '');
    };
    var triggerOpen = function triggerOpen(newOpen) {
        if (disabled && newOpen) return;
        triggerInnerOpen(newOpen);
    };
    var forwardKeyDown = function forwardKeyDown(e) {
        if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) // Let popup panel handle keyboard
        return operationRef.current.onKeyDown(e);
        (0, $u43uR.default)(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
        return false;
    };
    var onInternalClick = function onInternalClick() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        onClick === null || onClick === void 0 || onClick.apply(void 0, args);
        if (inputRef.current) {
            inputRef.current.focus();
            triggerOpen(true);
        }
    };
    // ============================= Input =============================
    var _usePickerInput = (0, $58d8dfa310cd09e6$export$2e2bcd8739ae039)({
        blurToCancel: needConfirmButton,
        open: mergedOpen,
        value: text,
        triggerOpen: triggerOpen,
        forwardKeyDown: forwardKeyDown,
        isClickOutside: function isClickOutside(target) {
            return !(0, $3af8fe10d0cc7265$export$9350e4ea4b8364)([
                panelDivRef.current,
                inputDivRef.current,
                containerRef.current
            ], target);
        },
        onSubmit: function onSubmit() {
            if (// When user typing disabledDate with keyboard and enter, this value will be empty
            !selectedValue || // Normal disabled check
            disabledDate && disabledDate(selectedValue)) return false;
            triggerChange(selectedValue);
            triggerOpen(false);
            resetText();
            return true;
        },
        onCancel: function onCancel() {
            triggerOpen(false);
            setSelectedValue(mergedValue);
            resetText();
        },
        onKeyDown: function onKeyDown(e, preventDefault) {
            _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, preventDefault);
        },
        onFocus: onFocus,
        onBlur: onBlur
    }), _usePickerInput2 = (0, $eUqlC.default)(_usePickerInput, 2), inputProps = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], focused = _usePickerInput2$.focused, typing = _usePickerInput2$.typing;
    // ============================= Sync ==============================
    // Close should sync back with text value
    $acw62.useEffect(function() {
        if (!mergedOpen) {
            setSelectedValue(mergedValue);
            if (!valueTexts.length || valueTexts[0] === '') triggerTextChange('');
            else if (firstValueText !== text) resetText();
        }
    }, [
        mergedOpen,
        valueTexts
    ]);
    // Change picker should sync back with text value
    $acw62.useEffect(function() {
        if (!mergedOpen) resetText();
    }, [
        picker
    ]);
    // Sync innerValue with control mode
    $acw62.useEffect(function() {
        // Sync select value
        setSelectedValue(mergedValue);
    }, [
        mergedValue
    ]);
    // ============================ Private ============================
    if (pickerRef) pickerRef.current = {
        focus: function focus() {
            if (inputRef.current) inputRef.current.focus();
        },
        blur: function blur() {
            if (inputRef.current) inputRef.current.blur();
        }
    };
    var _useHoverValue = (0, $4d1945ae4e4a5fce$export$2e2bcd8739ae039)(text, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useHoverValue2 = (0, $eUqlC.default)(_useHoverValue, 3), hoverValue = _useHoverValue2[0], onEnter = _useHoverValue2[1], onLeave = _useHoverValue2[2];
    // ============================= Panel =============================
    var panelProps = (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        className: undefined,
        style: undefined,
        pickerValue: undefined,
        onPickerValueChange: undefined,
        onChange: null
    });
    var panelNode = /*#__PURE__*/ $acw62.createElement((0, $3cd39e0593b856e7$export$2e2bcd8739ae039), (0, $8nd05.default)({}, panelProps, {
        generateConfig: generateConfig,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-panel-focused"), !typing)),
        value: selectedValue,
        locale: locale,
        tabIndex: -1,
        onSelect: function onSelect(date) {
            _onSelect === null || _onSelect === void 0 || _onSelect(date);
            setSelectedValue(date);
        },
        direction: direction,
        onPanelChange: function onPanelChange(viewDate, mode) {
            var onPanelChange = props.onPanelChange;
            onLeave(true);
            onPanelChange === null || onPanelChange === void 0 || onPanelChange(viewDate, mode);
        }
    }));
    if (panelRender) panelNode = panelRender(panelNode);
    var panel = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-panel-container"),
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
        }
    }, panelNode);
    var suffixNode;
    if (suffixIcon) suffixNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
    var clearNode;
    if (allowClear && mergedValue && !disabled) clearNode = /*#__PURE__*/ $acw62.createElement("span", {
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onMouseUp: function onMouseUp(e) {
            e.preventDefault();
            e.stopPropagation();
            triggerChange(null);
            triggerOpen(false);
        },
        className: "".concat(prefixCls, "-clear"),
        role: "button"
    }, clearIcon || /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn")
    }));
    var mergedInputProps = (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
        id: id,
        tabIndex: tabIndex,
        disabled: disabled,
        readOnly: inputReadOnly || typeof formatList[0] === 'function' || !typing,
        value: hoverValue || text,
        onChange: function onChange(e) {
            triggerTextChange(e.target.value);
        },
        autoFocus: autoFocus,
        placeholder: placeholder,
        ref: inputRef,
        title: text
    }, inputProps), {}, {
        size: (0, $3af8fe10d0cc7265$export$c4929e7560bc7c3e)(picker, formatList[0], generateConfig)
    }, (0, $0ae673be6dd1ab39$export$2e2bcd8739ae039)(props)), {}, {
        autoComplete: autoComplete
    });
    var inputNode = inputRender ? inputRender(mergedInputProps) : /*#__PURE__*/ $acw62.createElement("input", mergedInputProps);
    // ============================ Return =============================
    var onContextSelect = function onContextSelect(date, type) {
        if (type === 'submit' || type !== 'key' && !needConfirmButton) {
            // triggerChange will also update selected values
            triggerChange(date);
            triggerOpen(false);
        }
    };
    var popupPlacement = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    return /*#__PURE__*/ $acw62.createElement((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039).Provider, {
        value: {
            operationRef: operationRef,
            hideHeader: picker === 'time',
            panelRef: panelDivRef,
            onSelect: onContextSelect,
            open: mergedOpen,
            defaultOpenValue: defaultOpenValue,
            onDateMouseEnter: onEnter,
            onDateMouseLeave: onLeave
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $9e7a3f80f93f6451$export$2e2bcd8739ae039), {
        visible: mergedOpen,
        popupElement: panel,
        popupStyle: popupStyle,
        prefixCls: prefixCls,
        dropdownClassName: dropdownClassName,
        dropdownAlign: dropdownAlign,
        getPopupContainer: getPopupContainer,
        transitionName: transitionName,
        popupPlacement: popupPlacement,
        direction: direction
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className, (_classNames2 = {}, (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-focused"), focused), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
        style: style,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onContextMenu: onContextMenu,
        onClick: onInternalClick
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-input"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-input-placeholder"), !!hoverValue)),
        ref: inputDivRef
    }, inputNode, suffixNode, clearNode))));
}
// Wrap with class component to enable pass generic with instance method
var $09e62d4b02aa648b$var$Picker = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(Picker, _React$Component);
    var _super = (0, $enfmq.default)(Picker);
    function Picker() {
        var _this;
        (0, $6CZeq.default)(this, Picker);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.pickerRef = /*#__PURE__*/ $acw62.createRef();
        _this.focus = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.focus();
        };
        _this.blur = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.blur();
        };
        return _this;
    }
    (0, $cHPF9.default)(Picker, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement($09e62d4b02aa648b$var$InnerPicker, (0, $8nd05.default)({}, this.props, {
                    pickerRef: this.pickerRef
                }));
            }
        }
    ]);
    return Picker;
}($acw62.Component);
var $09e62d4b02aa648b$export$2e2bcd8739ae039 = $09e62d4b02aa648b$var$Picker;




var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $u43uR = parcelRequire("u43uR");

var $iSQh8 = parcelRequire("iSQh8");











var $acw62 = parcelRequire("acw62");


function $4aa01c8918f8feb6$export$2e2bcd8739ae039(_ref, disabledStart, disabledEnd) {
    var picker = _ref.picker, locale = _ref.locale, selectedValue = _ref.selectedValue, disabledDate = _ref.disabledDate, disabled = _ref.disabled, generateConfig = _ref.generateConfig;
    var startDate = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, 0);
    var endDate = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, 1);
    function weekFirstDate(date) {
        return generateConfig.locale.getWeekFirstDate(locale.locale, date);
    }
    function monthNumber(date) {
        var year = generateConfig.getYear(date);
        var month = generateConfig.getMonth(date);
        return year * 100 + month;
    }
    function quarterNumber(date) {
        var year = generateConfig.getYear(date);
        var quarter = (0, $5c7b8a0508ac8191$export$de90a4bb31c25221)(generateConfig, date);
        return year * 10 + quarter;
    }
    var disabledStartDate = $acw62.useCallback(function(date) {
        if (disabledDate && disabledDate(date)) return true;
        // Disabled range
        if (disabled[1] && endDate) return !(0, $5c7b8a0508ac8191$export$a8b2a21161763694)(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
        // Disabled part
        if (disabledStart && endDate) switch(picker){
            case 'quarter':
                return quarterNumber(date) > quarterNumber(endDate);
            case 'month':
                return monthNumber(date) > monthNumber(endDate);
            case 'week':
                return weekFirstDate(date) > weekFirstDate(endDate);
            default:
                return !(0, $5c7b8a0508ac8191$export$a8b2a21161763694)(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
        }
        return false;
    }, [
        disabledDate,
        disabled[1],
        endDate,
        disabledStart
    ]);
    var disabledEndDate = $acw62.useCallback(function(date) {
        if (disabledDate && disabledDate(date)) return true;
        // Disabled range
        if (disabled[0] && startDate) return !(0, $5c7b8a0508ac8191$export$a8b2a21161763694)(generateConfig, date, endDate) && generateConfig.isAfter(startDate, date);
        // Disabled part
        if (disabledEnd && startDate) switch(picker){
            case 'quarter':
                return quarterNumber(date) < quarterNumber(startDate);
            case 'month':
                return monthNumber(date) < monthNumber(startDate);
            case 'week':
                return weekFirstDate(date) < weekFirstDate(startDate);
            default:
                return !(0, $5c7b8a0508ac8191$export$a8b2a21161763694)(generateConfig, date, startDate) && generateConfig.isAfter(startDate, date);
        }
        return false;
    }, [
        disabledDate,
        disabled[0],
        startDate,
        disabledEnd
    ]);
    return [
        disabledStartDate,
        disabledEndDate
    ];
}





var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");


function $5a73de665e754b42$var$getStartEndDistance(startDate, endDate, picker, generateConfig) {
    var startNext = (0, $5c7b8a0508ac8191$export$d9ec313bf7ad18e1)(startDate, picker, generateConfig, 1);
    function getDistance(compareFunc) {
        if (compareFunc(startDate, endDate)) return 'same';
        if (compareFunc(startNext, endDate)) return 'closing';
        return 'far';
    }
    switch(picker){
        case 'year':
            return getDistance(function(start, end) {
                return (0, $5c7b8a0508ac8191$export$22ab546651b3be18)(generateConfig, start, end);
            });
        case 'quarter':
        case 'month':
            return getDistance(function(start, end) {
                return (0, $5c7b8a0508ac8191$export$5841f9eb9773f25f)(generateConfig, start, end);
            });
        default:
            return getDistance(function(start, end) {
                return (0, $5c7b8a0508ac8191$export$a18c89cbd24170ff)(generateConfig, start, end);
            });
    }
}
function $5a73de665e754b42$var$getRangeViewDate(values, index, picker, generateConfig) {
    var startDate = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, 0);
    var endDate = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, 1);
    if (index === 0) return startDate;
    if (startDate && endDate) {
        var distance = $5a73de665e754b42$var$getStartEndDistance(startDate, endDate, picker, generateConfig);
        switch(distance){
            case 'same':
                return startDate;
            case 'closing':
                return startDate;
            default:
                return (0, $5c7b8a0508ac8191$export$d9ec313bf7ad18e1)(endDate, picker, generateConfig, -1);
        }
    }
    return startDate;
}
function $5a73de665e754b42$export$2e2bcd8739ae039(_ref) {
    var values = _ref.values, picker = _ref.picker, defaultDates = _ref.defaultDates, generateConfig = _ref.generateConfig;
    var _React$useState = $acw62.useState(function() {
        return [
            (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(defaultDates, 0),
            (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(defaultDates, 1)
        ];
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), defaultViewDates = _React$useState2[0], setDefaultViewDates = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), viewDates = _React$useState4[0], setInternalViewDates = _React$useState4[1];
    var startDate = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, 0);
    var endDate = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, 1);
    function getViewDate(index) {
        // If set default view date, use it
        if (defaultViewDates[index]) return defaultViewDates[index];
        return (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(viewDates, index) || $5a73de665e754b42$var$getRangeViewDate(values, index, picker, generateConfig) || startDate || endDate || generateConfig.getNow();
    }
    function setViewDate(viewDate, index) {
        if (viewDate) {
            var newViewDates = (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(viewDates, viewDate, index);
            // Set view date will clean up default one
            setDefaultViewDates(// Should always be an array
            (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(defaultViewDates, null, index) || [
                null,
                null
            ]);
            // Reset another one when not have value
            var anotherIndex = (index + 1) % 2;
            if (!(0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, anotherIndex)) newViewDates = (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(newViewDates, viewDate, anotherIndex);
            setInternalViewDates(newViewDates);
        } else if (startDate || endDate) // Reset all when has values when `viewDate` is `null` which means from open trigger
        setInternalViewDates(null);
    }
    return [
        getViewDate,
        setViewDate
    ];
}




function $93ab6db210f70bd7$var$reorderValues(values, generateConfig) {
    if (values && values[0] && values[1] && generateConfig.isAfter(values[0], values[1])) return [
        values[1],
        values[0]
    ];
    return values;
}
function $93ab6db210f70bd7$var$canValueTrigger(value, index, disabled, allowEmpty) {
    if (value) return true;
    if (allowEmpty && allowEmpty[index]) return true;
    if (disabled[(index + 1) % 2]) return true;
    return false;
}
function $93ab6db210f70bd7$var$InnerRangePicker(props) {
    var _classNames2, _classNames3, _classNames4;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, id = props.id, style = props.style, className = props.className, popupStyle = props.popupStyle, dropdownClassName = props.dropdownClassName, transitionName = props.transitionName, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, generateConfig = props.generateConfig, locale = props.locale, placeholder = props.placeholder, autoFocus = props.autoFocus, disabled = props.disabled, format = props.format, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, showTime = props.showTime, use12Hours = props.use12Hours, _props$separator = props.separator, separator = _props$separator === void 0 ? '~' : _props$separator, value = props.value, defaultValue = props.defaultValue, defaultPickerValue = props.defaultPickerValue, open = props.open, defaultOpen = props.defaultOpen, disabledDate = props.disabledDate, _disabledTime = props.disabledTime, dateRender = props.dateRender, panelRender = props.panelRender, ranges = props.ranges, allowEmpty = props.allowEmpty, allowClear = props.allowClear, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, pickerRef = props.pickerRef, inputReadOnly = props.inputReadOnly, mode = props.mode, renderExtraFooter = props.renderExtraFooter, onChange = props.onChange, onOpenChange = props.onOpenChange, onPanelChange = props.onPanelChange, onCalendarChange = props.onCalendarChange, _onFocus = props.onFocus, onBlur = props.onBlur, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, _onOk = props.onOk, _onKeyDown = props.onKeyDown, components = props.components, order = props.order, direction = props.direction, activePickerIndex = props.activePickerIndex, _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete;
    var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
    // We record opened status here in case repeat open with picker
    var openRecordsRef = (0, $acw62.useRef)({});
    var containerRef = (0, $acw62.useRef)(null);
    var panelDivRef = (0, $acw62.useRef)(null);
    var startInputDivRef = (0, $acw62.useRef)(null);
    var endInputDivRef = (0, $acw62.useRef)(null);
    var separatorRef = (0, $acw62.useRef)(null);
    var startInputRef = (0, $acw62.useRef)(null);
    var endInputRef = (0, $acw62.useRef)(null);
    var arrowRef = (0, $acw62.useRef)(null);
    // ============================= Misc ==============================
    var formatList = (0, $0ae673be6dd1ab39$export$45b10814cc054894)((0, $3af8fe10d0cc7265$export$3e0385bd234197e6)(format, picker, showTime, use12Hours));
    // Active picker
    var _useMergedState = (0, $iSQh8.default)(0, {
        value: activePickerIndex
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedActivePickerIndex = _useMergedState2[0], setMergedActivePickerIndex = _useMergedState2[1];
    // Operation ref
    var operationRef = (0, $acw62.useRef)(null);
    var mergedDisabled = $acw62.useMemo(function() {
        if (Array.isArray(disabled)) return disabled;
        return [
            disabled || false,
            disabled || false
        ];
    }, [
        disabled
    ]);
    // ============================= Value =============================
    var _useMergedState3 = (0, $iSQh8.default)(null, {
        value: value,
        defaultValue: defaultValue,
        postState: function postState(values) {
            return picker === 'time' && !order ? values : $93ab6db210f70bd7$var$reorderValues(values, generateConfig);
        }
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), mergedValue = _useMergedState4[0], setInnerValue = _useMergedState4[1];
    // =========================== View Date ===========================
    // Config view panel
    var _useRangeViewDates = (0, $5a73de665e754b42$export$2e2bcd8739ae039)({
        values: mergedValue,
        picker: picker,
        defaultDates: defaultPickerValue,
        generateConfig: generateConfig
    }), _useRangeViewDates2 = (0, $eUqlC.default)(_useRangeViewDates, 2), getViewDate = _useRangeViewDates2[0], setViewDate = _useRangeViewDates2[1];
    // ========================= Select Values =========================
    var _useMergedState5 = (0, $iSQh8.default)(mergedValue, {
        postState: function postState(values) {
            var postValues = values;
            if (mergedDisabled[0] && mergedDisabled[1]) return postValues;
            // Fill disabled unit
            for(var i = 0; i < 2; i += 1)if (mergedDisabled[i] && !postValues && !(0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(postValues, i) && !(0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(allowEmpty, i)) postValues = (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(postValues, generateConfig.getNow(), i);
            return postValues;
        }
    }), _useMergedState6 = (0, $eUqlC.default)(_useMergedState5, 2), selectedValue = _useMergedState6[0], setSelectedValue = _useMergedState6[1];
    // ============================= Modes =============================
    var _useMergedState7 = (0, $iSQh8.default)([
        picker,
        picker
    ], {
        value: mode
    }), _useMergedState8 = (0, $eUqlC.default)(_useMergedState7, 2), mergedModes = _useMergedState8[0], setInnerModes = _useMergedState8[1];
    (0, $acw62.useEffect)(function() {
        setInnerModes([
            picker,
            picker
        ]);
    }, [
        picker
    ]);
    var triggerModesChange = function triggerModesChange(modes, values) {
        setInnerModes(modes);
        if (onPanelChange) onPanelChange(values, modes);
    };
    // ========================= Disable Date ==========================
    var _useRangeDisabled = (0, $4aa01c8918f8feb6$export$2e2bcd8739ae039)({
        picker: picker,
        selectedValue: selectedValue,
        locale: locale,
        disabled: mergedDisabled,
        disabledDate: disabledDate,
        generateConfig: generateConfig
    }, openRecordsRef.current[1], openRecordsRef.current[0]), _useRangeDisabled2 = (0, $eUqlC.default)(_useRangeDisabled, 2), disabledStartDate = _useRangeDisabled2[0], disabledEndDate = _useRangeDisabled2[1];
    // ============================= Open ==============================
    var _useMergedState9 = (0, $iSQh8.default)(false, {
        value: open,
        defaultValue: defaultOpen,
        postState: function postState(postOpen) {
            return mergedDisabled[mergedActivePickerIndex] ? false : postOpen;
        },
        onChange: function onChange(newOpen) {
            if (onOpenChange) onOpenChange(newOpen);
            if (!newOpen && operationRef.current && operationRef.current.onClose) operationRef.current.onClose();
        }
    }), _useMergedState10 = (0, $eUqlC.default)(_useMergedState9, 2), mergedOpen = _useMergedState10[0], triggerInnerOpen = _useMergedState10[1];
    var startOpen = mergedOpen && mergedActivePickerIndex === 0;
    var endOpen = mergedOpen && mergedActivePickerIndex === 1;
    // ============================= Popup =============================
    // Popup min width
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $eUqlC.default)(_useState, 2), popupMinWidth = _useState2[0], setPopupMinWidth = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!mergedOpen && containerRef.current) setPopupMinWidth(containerRef.current.offsetWidth);
    }, [
        mergedOpen
    ]);
    // ============================ Trigger ============================
    var triggerRef = $acw62.useRef();
    function _triggerOpen(newOpen, index) {
        if (newOpen) {
            clearTimeout(triggerRef.current);
            openRecordsRef.current[index] = true;
            setMergedActivePickerIndex(index);
            triggerInnerOpen(newOpen);
            // Open to reset view date
            if (!mergedOpen) setViewDate(null, index);
        } else if (mergedActivePickerIndex === index) {
            triggerInnerOpen(newOpen);
            // Clean up async
            // This makes ref not quick refresh in case user open another input with blur trigger
            var openRecords = openRecordsRef.current;
            triggerRef.current = setTimeout(function() {
                if (openRecords === openRecordsRef.current) openRecordsRef.current = {};
            });
        }
    }
    function triggerOpenAndFocus(index) {
        _triggerOpen(true, index);
        // Use setTimeout to make sure panel DOM exists
        setTimeout(function() {
            var inputRef = [
                startInputRef,
                endInputRef
            ][index];
            if (inputRef.current) inputRef.current.focus();
        }, 0);
    }
    function triggerChange(newValue, sourceIndex) {
        var values = newValue;
        var startValue = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, 0);
        var endValue = (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, 1);
        // >>>>> Format start & end values
        if (startValue && endValue && generateConfig.isAfter(startValue, endValue)) {
            if (// WeekPicker only compare week
            picker === 'week' && !(0, $5c7b8a0508ac8191$export$6ea683876c36b8d2)(generateConfig, locale.locale, startValue, endValue) || // QuotaPicker only compare week
            picker === 'quarter' && !(0, $5c7b8a0508ac8191$export$5c60e4190867161c)(generateConfig, startValue, endValue) || // Other non-TimePicker compare date
            picker !== 'week' && picker !== 'quarter' && picker !== 'time' && !(0, $5c7b8a0508ac8191$export$a8b2a21161763694)(generateConfig, startValue, endValue)) {
                // Clean up end date when start date is after end date
                if (sourceIndex === 0) {
                    values = [
                        startValue,
                        null
                    ];
                    endValue = null;
                } else {
                    startValue = null;
                    values = [
                        null,
                        endValue
                    ];
                }
                // Clean up cache since invalidate
                openRecordsRef.current = (0, $kSlfw.default)({}, sourceIndex, true);
            } else if (picker !== 'time' || order !== false) // Reorder when in same date
            values = $93ab6db210f70bd7$var$reorderValues(values, generateConfig);
        }
        setSelectedValue(values);
        var startStr = values && values[0] ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(values[0], {
            generateConfig: generateConfig,
            locale: locale,
            format: formatList[0]
        }) : '';
        var endStr = values && values[1] ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(values[1], {
            generateConfig: generateConfig,
            locale: locale,
            format: formatList[0]
        }) : '';
        if (onCalendarChange) {
            var info = {
                range: sourceIndex === 0 ? 'start' : 'end'
            };
            onCalendarChange(values, [
                startStr,
                endStr
            ], info);
        }
        // >>>>> Trigger `onChange` event
        var canStartValueTrigger = $93ab6db210f70bd7$var$canValueTrigger(startValue, 0, mergedDisabled, allowEmpty);
        var canEndValueTrigger = $93ab6db210f70bd7$var$canValueTrigger(endValue, 1, mergedDisabled, allowEmpty);
        var canTrigger = values === null || canStartValueTrigger && canEndValueTrigger;
        if (canTrigger) {
            // Trigger onChange only when value is validate
            setInnerValue(values);
            if (onChange && (!(0, $5c7b8a0508ac8191$export$248d38f6296296c5)(generateConfig, (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(mergedValue, 0), startValue) || !(0, $5c7b8a0508ac8191$export$248d38f6296296c5)(generateConfig, (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(mergedValue, 1), endValue))) onChange(values, [
                startStr,
                endStr
            ]);
        }
        // >>>>> Open picker when
        // Always open another picker if possible
        var nextOpenIndex = null;
        if (sourceIndex === 0 && !mergedDisabled[1]) nextOpenIndex = 1;
        else if (sourceIndex === 1 && !mergedDisabled[0]) nextOpenIndex = 0;
        if (nextOpenIndex !== null && nextOpenIndex !== mergedActivePickerIndex && (!openRecordsRef.current[nextOpenIndex] || !(0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, nextOpenIndex)) && (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(values, sourceIndex)) // Delay to focus to avoid input blur trigger expired selectedValues
        triggerOpenAndFocus(nextOpenIndex);
        else _triggerOpen(false, sourceIndex);
    }
    var forwardKeyDown = function forwardKeyDown(e) {
        if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) // Let popup panel handle keyboard
        return operationRef.current.onKeyDown(e);
        (0, $u43uR.default)(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
        return false;
    };
    // ============================= Text ==============================
    var sharedTextHooksProps = {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    };
    var _useValueTexts = (0, $9d6eb9d7ffbf50e1$export$2e2bcd8739ae039)((0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, 0), sharedTextHooksProps), _useValueTexts2 = (0, $eUqlC.default)(_useValueTexts, 2), startValueTexts = _useValueTexts2[0], firstStartValueText = _useValueTexts2[1];
    var _useValueTexts3 = (0, $9d6eb9d7ffbf50e1$export$2e2bcd8739ae039)((0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, 1), sharedTextHooksProps), _useValueTexts4 = (0, $eUqlC.default)(_useValueTexts3, 2), endValueTexts = _useValueTexts4[0], firstEndValueText = _useValueTexts4[1];
    var _onTextChange = function onTextChange(newText, index) {
        var inputDate = (0, $5c7b8a0508ac8191$export$5303528d1070ff6f)(newText, {
            locale: locale,
            formatList: formatList,
            generateConfig: generateConfig
        });
        var disabledFunc = index === 0 ? disabledStartDate : disabledEndDate;
        if (inputDate && !disabledFunc(inputDate)) {
            setSelectedValue((0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(selectedValue, inputDate, index));
            setViewDate(inputDate, index);
        }
    };
    var _useTextValueMapping = (0, $1fbbc159ab8192b4$export$2e2bcd8739ae039)({
        valueTexts: startValueTexts,
        onTextChange: function onTextChange(newText) {
            return _onTextChange(newText, 0);
        }
    }), _useTextValueMapping2 = (0, $eUqlC.default)(_useTextValueMapping, 3), startText = _useTextValueMapping2[0], triggerStartTextChange = _useTextValueMapping2[1], resetStartText = _useTextValueMapping2[2];
    var _useTextValueMapping3 = (0, $1fbbc159ab8192b4$export$2e2bcd8739ae039)({
        valueTexts: endValueTexts,
        onTextChange: function onTextChange(newText) {
            return _onTextChange(newText, 1);
        }
    }), _useTextValueMapping4 = (0, $eUqlC.default)(_useTextValueMapping3, 3), endText = _useTextValueMapping4[0], triggerEndTextChange = _useTextValueMapping4[1], resetEndText = _useTextValueMapping4[2];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), rangeHoverValue = _useState4[0], setRangeHoverValue = _useState4[1];
    // ========================== Hover Range ==========================
    var _useState5 = (0, $acw62.useState)(null), _useState6 = (0, $eUqlC.default)(_useState5, 2), hoverRangedValue = _useState6[0], setHoverRangedValue = _useState6[1];
    var _useHoverValue = (0, $4d1945ae4e4a5fce$export$2e2bcd8739ae039)(startText, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useHoverValue2 = (0, $eUqlC.default)(_useHoverValue, 3), startHoverValue = _useHoverValue2[0], onStartEnter = _useHoverValue2[1], onStartLeave = _useHoverValue2[2];
    var _useHoverValue3 = (0, $4d1945ae4e4a5fce$export$2e2bcd8739ae039)(endText, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useHoverValue4 = (0, $eUqlC.default)(_useHoverValue3, 3), endHoverValue = _useHoverValue4[0], onEndEnter = _useHoverValue4[1], onEndLeave = _useHoverValue4[2];
    var onDateMouseEnter = function onDateMouseEnter(date) {
        setHoverRangedValue((0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(selectedValue, date, mergedActivePickerIndex));
        if (mergedActivePickerIndex === 0) onStartEnter(date);
        else onEndEnter(date);
    };
    var onDateMouseLeave = function onDateMouseLeave() {
        setHoverRangedValue((0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(selectedValue, null, mergedActivePickerIndex));
        if (mergedActivePickerIndex === 0) onStartLeave();
        else onEndLeave();
    };
    // ============================= Input =============================
    var getSharedInputHookProps = function getSharedInputHookProps(index, resetText) {
        return {
            blurToCancel: needConfirmButton,
            forwardKeyDown: forwardKeyDown,
            onBlur: onBlur,
            isClickOutside: function isClickOutside(target) {
                return !(0, $3af8fe10d0cc7265$export$9350e4ea4b8364)([
                    panelDivRef.current,
                    startInputDivRef.current,
                    endInputDivRef.current,
                    containerRef.current
                ], target);
            },
            onFocus: function onFocus(e) {
                setMergedActivePickerIndex(index);
                if (_onFocus) _onFocus(e);
            },
            triggerOpen: function triggerOpen(newOpen) {
                _triggerOpen(newOpen, index);
            },
            onSubmit: function onSubmit() {
                if (// When user typing disabledDate with keyboard and enter, this value will be empty
                !selectedValue || // Normal disabled check
                disabledDate && disabledDate(selectedValue[index])) return false;
                triggerChange(selectedValue, index);
                resetText();
            },
            onCancel: function onCancel() {
                _triggerOpen(false, index);
                setSelectedValue(mergedValue);
                resetText();
            }
        };
    };
    var currentFocusedKey = (0, $acw62.useRef)('');
    var _usePickerInput = (0, $58d8dfa310cd09e6$export$2e2bcd8739ae039)((0, $d49SP.default)((0, $d49SP.default)({}, getSharedInputHookProps(0, resetStartText)), {}, {
        open: startOpen,
        value: startText,
        currentFocusedKey: currentFocusedKey,
        key: 'start',
        onKeyDown: function onKeyDown(e, preventDefault) {
            _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, preventDefault);
        }
    })), _usePickerInput2 = (0, $eUqlC.default)(_usePickerInput, 2), startInputProps = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], startFocused = _usePickerInput2$.focused, startTyping = _usePickerInput2$.typing;
    var _usePickerInput3 = (0, $58d8dfa310cd09e6$export$2e2bcd8739ae039)((0, $d49SP.default)((0, $d49SP.default)({}, getSharedInputHookProps(1, resetEndText)), {}, {
        open: endOpen,
        value: endText,
        currentFocusedKey: currentFocusedKey,
        key: 'end',
        onKeyDown: function onKeyDown(e, preventDefault) {
            _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, preventDefault);
        }
    })), _usePickerInput4 = (0, $eUqlC.default)(_usePickerInput3, 2), endInputProps = _usePickerInput4[0], _usePickerInput4$ = _usePickerInput4[1], endFocused = _usePickerInput4$.focused, endTyping = _usePickerInput4$.typing;
    // ========================== Click Picker ==========================
    var onPickerClick = function onPickerClick(e) {
        // When click inside the picker & outside the picker's input elements
        // the panel should still be opened
        if (onClick) onClick(e);
        if (!mergedOpen && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
            if (!mergedDisabled[0]) triggerOpenAndFocus(0);
            else if (!mergedDisabled[1]) triggerOpenAndFocus(1);
        }
    };
    var onPickerMouseDown = function onPickerMouseDown(e) {
        // shouldn't affect input elements if picker is active
        if (onMouseDown) onMouseDown(e);
        if (mergedOpen && (startFocused || endFocused) && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) e.preventDefault();
    };
    // ============================= Sync ==============================
    // Close should sync back with text value
    var startStr = mergedValue && mergedValue[0] ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(mergedValue[0], {
        locale: locale,
        format: 'YYYYMMDDHHmmss',
        generateConfig: generateConfig
    }) : '';
    var endStr = mergedValue && mergedValue[1] ? (0, $5c7b8a0508ac8191$export$7c4d25c0c3217d8c)(mergedValue[1], {
        locale: locale,
        format: 'YYYYMMDDHHmmss',
        generateConfig: generateConfig
    }) : '';
    (0, $acw62.useEffect)(function() {
        if (!mergedOpen) {
            setSelectedValue(mergedValue);
            if (!startValueTexts.length || startValueTexts[0] === '') triggerStartTextChange('');
            else if (firstStartValueText !== startText) resetStartText();
            if (!endValueTexts.length || endValueTexts[0] === '') triggerEndTextChange('');
            else if (firstEndValueText !== endText) resetEndText();
        }
    }, [
        mergedOpen,
        startValueTexts,
        endValueTexts
    ]);
    // Sync innerValue with control mode
    (0, $acw62.useEffect)(function() {
        setSelectedValue(mergedValue);
    }, [
        startStr,
        endStr
    ]);
    // ============================ Private ============================
    if (pickerRef) pickerRef.current = {
        focus: function focus() {
            if (startInputRef.current) startInputRef.current.focus();
        },
        blur: function blur() {
            if (startInputRef.current) startInputRef.current.blur();
            if (endInputRef.current) endInputRef.current.blur();
        }
    };
    // ============================ Ranges =============================
    var rangeLabels = Object.keys(ranges || {});
    var rangeList = rangeLabels.map(function(label) {
        var range = ranges[label];
        var newValues = typeof range === 'function' ? range() : range;
        return {
            label: label,
            onClick: function onClick() {
                triggerChange(newValues, null);
                _triggerOpen(false, mergedActivePickerIndex);
            },
            onMouseEnter: function onMouseEnter() {
                setRangeHoverValue(newValues);
            },
            onMouseLeave: function onMouseLeave() {
                setRangeHoverValue(null);
            }
        };
    });
    // ============================= Panel =============================
    function renderPanel() {
        var panelPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var panelProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var panelHoverRangedValue = null;
        if (mergedOpen && hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1] && generateConfig.isAfter(hoverRangedValue[1], hoverRangedValue[0])) panelHoverRangedValue = hoverRangedValue;
        var panelShowTime = showTime;
        if (showTime && (0, $fSwVM.default)(showTime) === 'object' && showTime.defaultValue) {
            var timeDefaultValues = showTime.defaultValue;
            panelShowTime = (0, $d49SP.default)((0, $d49SP.default)({}, showTime), {}, {
                defaultValue: (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(timeDefaultValues, mergedActivePickerIndex) || undefined
            });
        }
        var panelDateRender = null;
        if (dateRender) panelDateRender = function panelDateRender(date, today) {
            return dateRender(date, today, {
                range: mergedActivePickerIndex ? 'end' : 'start'
            });
        };
        return /*#__PURE__*/ $acw62.createElement((0, $ad011b5d5dcecbe5$export$2e2bcd8739ae039).Provider, {
            value: {
                inRange: true,
                panelPosition: panelPosition,
                rangedValue: rangeHoverValue || selectedValue,
                hoverRangedValue: panelHoverRangedValue
            }
        }, /*#__PURE__*/ $acw62.createElement((0, $3cd39e0593b856e7$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, panelProps, {
            dateRender: panelDateRender,
            showTime: panelShowTime,
            mode: mergedModes[mergedActivePickerIndex],
            generateConfig: generateConfig,
            style: undefined,
            direction: direction,
            disabledDate: mergedActivePickerIndex === 0 ? disabledStartDate : disabledEndDate,
            disabledTime: function disabledTime(date) {
                if (_disabledTime) return _disabledTime(date, mergedActivePickerIndex === 0 ? 'start' : 'end');
                return false;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(prefixCls, "-panel-focused"), mergedActivePickerIndex === 0 ? !startTyping : !endTyping)),
            value: (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, mergedActivePickerIndex),
            locale: locale,
            tabIndex: -1,
            onPanelChange: function onPanelChange(date, newMode) {
                // clear hover value when panel change
                if (mergedActivePickerIndex === 0) onStartLeave(true);
                if (mergedActivePickerIndex === 1) onEndLeave(true);
                triggerModesChange((0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(mergedModes, newMode, mergedActivePickerIndex), (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(selectedValue, date, mergedActivePickerIndex));
                var viewDate = date;
                if (panelPosition === 'right' && mergedModes[mergedActivePickerIndex] === newMode) viewDate = (0, $5c7b8a0508ac8191$export$d9ec313bf7ad18e1)(viewDate, newMode, generateConfig, -1);
                setViewDate(viewDate, mergedActivePickerIndex);
            },
            onOk: null,
            onSelect: undefined,
            onChange: undefined,
            defaultValue: mergedActivePickerIndex === 0 ? (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, 1) : (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, 0)
        })));
    }
    var arrowLeft = 0;
    var panelLeft = 0;
    if (mergedActivePickerIndex && startInputDivRef.current && separatorRef.current && panelDivRef.current) {
        // Arrow offset
        arrowLeft = startInputDivRef.current.offsetWidth + separatorRef.current.offsetWidth;
        // If panelWidth - arrowWidth - arrowMarginLeft < arrowLeft, panel should move to right side.
        // If arrowOffsetLeft > arrowLeft, arrowMarginLeft = arrowOffsetLeft - arrowLeft
        var arrowMarginLeft = arrowRef.current.offsetLeft > arrowLeft ? arrowRef.current.offsetLeft - arrowLeft : arrowRef.current.offsetLeft;
        if (panelDivRef.current.offsetWidth && arrowRef.current.offsetWidth && arrowLeft > panelDivRef.current.offsetWidth - arrowRef.current.offsetWidth - (direction === 'rtl' ? 0 : arrowMarginLeft)) panelLeft = arrowLeft;
    }
    var arrowPositionStyle = direction === 'rtl' ? {
        right: arrowLeft
    } : {
        left: arrowLeft
    };
    function renderPanels() {
        var panels;
        var extraNode = (0, $7fee307d6842180e$export$2e2bcd8739ae039)(prefixCls, mergedModes[mergedActivePickerIndex], renderExtraFooter);
        var rangesNode = (0, $a8e10f6fa0ffb7a7$export$2e2bcd8739ae039)({
            prefixCls: prefixCls,
            components: components,
            needConfirmButton: needConfirmButton,
            okDisabled: !(0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, mergedActivePickerIndex) || disabledDate && disabledDate(selectedValue[mergedActivePickerIndex]),
            locale: locale,
            rangeList: rangeList,
            onOk: function onOk() {
                if ((0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(selectedValue, mergedActivePickerIndex)) {
                    // triggerChangeOld(selectedValue);
                    triggerChange(selectedValue, mergedActivePickerIndex);
                    if (_onOk) _onOk(selectedValue);
                }
            }
        });
        if (picker !== 'time' && !showTime) {
            var viewDate = getViewDate(mergedActivePickerIndex);
            var nextViewDate = (0, $5c7b8a0508ac8191$export$d9ec313bf7ad18e1)(viewDate, picker, generateConfig);
            var currentMode = mergedModes[mergedActivePickerIndex];
            var showDoublePanel = currentMode === picker;
            var leftPanel = renderPanel(showDoublePanel ? 'left' : false, {
                pickerValue: viewDate,
                onPickerValueChange: function onPickerValueChange(newViewDate) {
                    setViewDate(newViewDate, mergedActivePickerIndex);
                }
            });
            var rightPanel = renderPanel('right', {
                pickerValue: nextViewDate,
                onPickerValueChange: function onPickerValueChange(newViewDate) {
                    setViewDate((0, $5c7b8a0508ac8191$export$d9ec313bf7ad18e1)(newViewDate, picker, generateConfig, -1), mergedActivePickerIndex);
                }
            });
            if (direction === 'rtl') panels = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, rightPanel, showDoublePanel && leftPanel);
            else panels = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, leftPanel, showDoublePanel && rightPanel);
        } else panels = renderPanel();
        var mergedNodes = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-panels")
        }, panels), (extraNode || rangesNode) && /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-footer")
        }, extraNode, rangesNode));
        if (panelRender) mergedNodes = panelRender(mergedNodes);
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-panel-container"),
            style: {
                marginLeft: panelLeft
            },
            ref: panelDivRef,
            onMouseDown: function onMouseDown(e) {
                e.preventDefault();
            }
        }, mergedNodes);
    }
    var rangePanel = /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper")),
        style: {
            minWidth: popupMinWidth
        }
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: arrowRef,
        className: "".concat(prefixCls, "-range-arrow"),
        style: arrowPositionStyle
    }), renderPanels());
    // ============================= Icons =============================
    var suffixNode;
    if (suffixIcon) suffixNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
    var clearNode;
    if (allowClear && ((0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(mergedValue, 0) && !mergedDisabled[0] || (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(mergedValue, 1) && !mergedDisabled[1])) clearNode = /*#__PURE__*/ $acw62.createElement("span", {
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onMouseUp: function onMouseUp(e) {
            e.preventDefault();
            e.stopPropagation();
            var values = mergedValue;
            if (!mergedDisabled[0]) values = (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(values, null, 0);
            if (!mergedDisabled[1]) values = (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(values, null, 1);
            triggerChange(values, null);
            _triggerOpen(false, mergedActivePickerIndex);
        },
        className: "".concat(prefixCls, "-clear")
    }, clearIcon || /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn")
    }));
    var inputSharedProps = {
        size: (0, $3af8fe10d0cc7265$export$c4929e7560bc7c3e)(picker, formatList[0], generateConfig)
    };
    var activeBarLeft = 0;
    var activeBarWidth = 0;
    if (startInputDivRef.current && endInputDivRef.current && separatorRef.current) {
        if (mergedActivePickerIndex === 0) activeBarWidth = startInputDivRef.current.offsetWidth;
        else {
            activeBarLeft = arrowLeft;
            activeBarWidth = endInputDivRef.current.offsetWidth;
        }
    }
    var activeBarPositionStyle = direction === 'rtl' ? {
        right: activeBarLeft
    } : {
        left: activeBarLeft
    };
    // ============================ Return =============================
    var onContextSelect = function onContextSelect(date, type) {
        var values = (0, $0ae673be6dd1ab39$export$1af566b8db6b8ac2)(selectedValue, date, mergedActivePickerIndex);
        if (type === 'submit' || type !== 'key' && !needConfirmButton) {
            // triggerChange will also update selected values
            triggerChange(values, mergedActivePickerIndex);
            // clear hover value style
            if (mergedActivePickerIndex === 0) onStartLeave();
            else onEndLeave();
        } else setSelectedValue(values);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $cb588b5e3538bcc3$export$2e2bcd8739ae039).Provider, {
        value: {
            operationRef: operationRef,
            hideHeader: picker === 'time',
            onDateMouseEnter: onDateMouseEnter,
            onDateMouseLeave: onDateMouseLeave,
            hideRanges: true,
            onSelect: onContextSelect,
            open: mergedOpen
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $9e7a3f80f93f6451$export$2e2bcd8739ae039), {
        visible: mergedOpen,
        popupElement: rangePanel,
        popupStyle: popupStyle,
        prefixCls: prefixCls,
        dropdownClassName: dropdownClassName,
        dropdownAlign: dropdownAlign,
        getPopupContainer: getPopupContainer,
        transitionName: transitionName,
        range: true,
        direction: direction
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-range"), className, (_classNames2 = {}, (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-disabled"), mergedDisabled[0] && mergedDisabled[1]), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-focused"), mergedActivePickerIndex === 0 ? startFocused : endFocused), (0, $kSlfw.default)(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
        style: style,
        onClick: onPickerClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onPickerMouseDown,
        onMouseUp: onMouseUp
    }, (0, $0ae673be6dd1ab39$export$2e2bcd8739ae039)(props)), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-input"), (_classNames3 = {}, (0, $kSlfw.default)(_classNames3, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 0), (0, $kSlfw.default)(_classNames3, "".concat(prefixCls, "-input-placeholder"), !!startHoverValue), _classNames3)),
        ref: startInputDivRef
    }, /*#__PURE__*/ $acw62.createElement("input", (0, $8nd05.default)({
        id: id,
        disabled: mergedDisabled[0],
        readOnly: inputReadOnly || typeof formatList[0] === 'function' || !startTyping,
        value: startHoverValue || startText,
        onChange: function onChange(e) {
            triggerStartTextChange(e.target.value);
        },
        autoFocus: autoFocus,
        placeholder: (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(placeholder, 0) || '',
        ref: startInputRef
    }, startInputProps, inputSharedProps, {
        autoComplete: autoComplete
    }))), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-range-separator"),
        ref: separatorRef
    }, separator), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-input"), (_classNames4 = {}, (0, $kSlfw.default)(_classNames4, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 1), (0, $kSlfw.default)(_classNames4, "".concat(prefixCls, "-input-placeholder"), !!endHoverValue), _classNames4)),
        ref: endInputDivRef
    }, /*#__PURE__*/ $acw62.createElement("input", (0, $8nd05.default)({
        disabled: mergedDisabled[1],
        readOnly: inputReadOnly || typeof formatList[0] === 'function' || !endTyping,
        value: endHoverValue || endText,
        onChange: function onChange(e) {
            triggerEndTextChange(e.target.value);
        },
        placeholder: (0, $0ae673be6dd1ab39$export$bf7199a9ebcb84a9)(placeholder, 1) || '',
        ref: endInputRef
    }, endInputProps, inputSharedProps, {
        autoComplete: autoComplete
    }))), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-active-bar"),
        style: (0, $d49SP.default)((0, $d49SP.default)({}, activeBarPositionStyle), {}, {
            width: activeBarWidth,
            position: 'absolute'
        })
    }), suffixNode, clearNode)));
}
// Wrap with class component to enable pass generic with instance method
var $93ab6db210f70bd7$var$RangePicker = /*#__PURE__*/ function(_React$Component) {
    (0, $1gYAD.default)(RangePicker, _React$Component);
    var _super = (0, $enfmq.default)(RangePicker);
    function RangePicker() {
        var _this;
        (0, $6CZeq.default)(this, RangePicker);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.pickerRef = /*#__PURE__*/ $acw62.createRef();
        _this.focus = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.focus();
        };
        _this.blur = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.blur();
        };
        return _this;
    }
    (0, $cHPF9.default)(RangePicker, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement($93ab6db210f70bd7$var$InnerRangePicker, (0, $8nd05.default)({}, this.props, {
                    pickerRef: this.pickerRef
                }));
            }
        }
    ]);
    return RangePicker;
}($acw62.Component);
var $93ab6db210f70bd7$export$2e2bcd8739ae039 = $93ab6db210f70bd7$var$RangePicker;


var $b680b5fe5e1ba7b0$export$2e2bcd8739ae039 = (0, $09e62d4b02aa648b$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");









function $743db7050869a030$export$d3f5c5e0a5023fa0(picker, locale, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.yearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.quarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.monthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.weekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.placeholder;
    return locale.lang.placeholder;
}
function $743db7050869a030$export$9793711a144eaeae(picker, locale, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.rangeYearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.rangeQuarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.rangeMonthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.rangeWeekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.rangePlaceholder;
    return locale.lang.rangePlaceholder;
}
function $743db7050869a030$export$eb66ca17c6a72c49(direction, placement) {
    var overflow = {
        adjustX: 1,
        adjustY: 1
    };
    switch(placement){
        case 'bottomLeft':
            return {
                points: [
                    'tl',
                    'bl'
                ],
                offset: [
                    0,
                    4
                ],
                overflow: overflow
            };
        case 'bottomRight':
            return {
                points: [
                    'tr',
                    'br'
                ],
                offset: [
                    0,
                    4
                ],
                overflow: overflow
            };
        case 'topLeft':
            return {
                points: [
                    'bl',
                    'tl'
                ],
                offset: [
                    0,
                    -4
                ],
                overflow: overflow
            };
        case 'topRight':
            return {
                points: [
                    'br',
                    'tr'
                ],
                offset: [
                    0,
                    -4
                ],
                overflow: overflow
            };
        default:
            return {
                points: direction === 'rtl' ? [
                    'tr',
                    'br'
                ] : [
                    'tl',
                    'bl'
                ],
                offset: [
                    0,
                    4
                ],
                overflow: overflow
            };
    }
}



var $30ca1b0880de6cf8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $30ca1b0880de6cf8$export$2e2bcd8739ae039(generateConfig) {
    var RangePicker = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        var customizePrefixCls = props.prefixCls, customGetPopupContainer = props.getPopupContainer, className = props.className, placement = props.placement, customizeSize = props.size, customDisabled = props.disabled, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, placeholder = props.placeholder, popupClassName = props.popupClassName, dropdownClassName = props.dropdownClassName, customStatus = props.status, restProps = $30ca1b0880de6cf8$var$__rest(props, [
            "prefixCls",
            "getPopupContainer",
            "className",
            "placement",
            "size",
            "disabled",
            "bordered",
            "placeholder",
            "popupClassName",
            "dropdownClassName",
            "status"
        ]);
        var innerRef = $acw62.useRef(null);
        var _useContext = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction, getPopupContainer = _useContext.getPopupContainer;
        var prefixCls = getPrefixCls('picker', customizePrefixCls);
        var _useCompactItemContex = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
        var format = props.format, showTime = props.showTime, picker = props.picker;
        var rootPrefixCls = getPrefixCls();
        var additionalOverrideProps = {};
        additionalOverrideProps = (0, $8nd05.default)((0, $8nd05.default)((0, $8nd05.default)({}, additionalOverrideProps), showTime ? (0, $c1dc9dc64bb71ced$export$6c7e3619a08d795a)((0, $8nd05.default)({
            format: format,
            picker: picker
        }, showTime)) : {}), picker === 'time' ? (0, $c1dc9dc64bb71ced$export$6c7e3619a08d795a)((0, $8nd05.default)((0, $8nd05.default)({
            format: format
        }, props), {
            picker: picker
        })) : {});
        // ===================== Size =====================
        var size = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
        var mergedSize = compactSize || customizeSize || size;
        // ===================== Disabled =====================
        var disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
        var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
        // ===================== FormItemInput =====================
        var formItemContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
        var hasFeedback = formItemContext.hasFeedback, contextStatus = formItemContext.status, feedbackIcon = formItemContext.feedbackIcon;
        var suffixNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, picker === 'time' ? /*#__PURE__*/ $acw62.createElement((0, $287c658c921bcb82$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $d851d821d19b0360$export$2e2bcd8739ae039), null), hasFeedback && feedbackIcon);
        (0, $acw62.useImperativeHandle)(ref, function() {
            return {
                focus: function focus() {
                    var _a;
                    return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                },
                blur: function blur() {
                    var _a;
                    return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                }
            };
        });
        return /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), {
            componentName: "DatePicker",
            defaultLocale: (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039)
        }, function(contextLocale) {
            var locale = (0, $8nd05.default)((0, $8nd05.default)({}, contextLocale), props.locale);
            return /*#__PURE__*/ $acw62.createElement((0, $93ab6db210f70bd7$export$2e2bcd8739ae039), (0, $8nd05.default)({
                separator: /*#__PURE__*/ $acw62.createElement("span", {
                    "aria-label": "to",
                    className: "".concat(prefixCls, "-separator")
                }, /*#__PURE__*/ $acw62.createElement((0, $a5709050fb04d86d$export$2e2bcd8739ae039), null)),
                disabled: mergedDisabled,
                ref: innerRef,
                dropdownAlign: (0, $743db7050869a030$export$eb66ca17c6a72c49)(direction, placement),
                placeholder: (0, $743db7050869a030$export$9793711a144eaeae)(picker, locale, placeholder),
                suffixIcon: suffixNode,
                clearIcon: /*#__PURE__*/ $acw62.createElement((0, $2bf1c25862f513c2$export$2e2bcd8739ae039), null),
                prevIcon: /*#__PURE__*/ $acw62.createElement("span", {
                    className: "".concat(prefixCls, "-prev-icon")
                }),
                nextIcon: /*#__PURE__*/ $acw62.createElement("span", {
                    className: "".concat(prefixCls, "-next-icon")
                }),
                superPrevIcon: /*#__PURE__*/ $acw62.createElement("span", {
                    className: "".concat(prefixCls, "-super-prev-icon")
                }),
                superNextIcon: /*#__PURE__*/ $acw62.createElement("span", {
                    className: "".concat(prefixCls, "-super-next-icon")
                }),
                allowClear: true,
                transitionName: "".concat(rootPrefixCls, "-slide-up")
            }, restProps, additionalOverrideProps, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), "".concat(prefixCls, "-borderless"), !bordered), (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, className),
                locale: locale.lang,
                prefixCls: prefixCls,
                getPopupContainer: customGetPopupContainer || getPopupContainer,
                generateConfig: generateConfig,
                components: (0, $c1dc9dc64bb71ced$export$cdb8a2fe02a819d9),
                direction: direction,
                dropdownClassName: popupClassName || dropdownClassName
            }));
        });
    });
    return RangePicker;
}



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");




var $8g1PZ = parcelRequire("8g1PZ");


var $acw62 = parcelRequire("acw62");











var $6ad55698b5bc7f6f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6ad55698b5bc7f6f$export$2e2bcd8739ae039(generateConfig) {
    function getPicker(picker, displayName) {
        var Picker = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
            var customizePrefixCls = props.prefixCls, customizeGetPopupContainer = props.getPopupContainer, className = props.className, customizeSize = props.size, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, placement = props.placement, placeholder = props.placeholder, popupClassName = props.popupClassName, dropdownClassName = props.dropdownClassName, customDisabled = props.disabled, customStatus = props.status, restProps = $6ad55698b5bc7f6f$var$__rest(props, [
                "prefixCls",
                "getPopupContainer",
                "className",
                "size",
                "bordered",
                "placement",
                "placeholder",
                "popupClassName",
                "dropdownClassName",
                "disabled",
                "status"
            ]);
            var _useContext = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction, getPopupContainer = _useContext.getPopupContainer;
            var prefixCls = getPrefixCls('picker', customizePrefixCls);
            var _useCompactItemContex = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
            var innerRef = $acw62.useRef(null);
            var format = props.format, showTime = props.showTime;
            (0, $acw62.useImperativeHandle)(ref, function() {
                return {
                    focus: function focus() {
                        var _a;
                        return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    },
                    blur: function blur() {
                        var _a;
                        return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                    }
                };
            });
            var additionalProps = {
                showToday: true
            };
            var additionalOverrideProps = {};
            if (picker) additionalOverrideProps.picker = picker;
            var mergedPicker = picker || props.picker;
            additionalOverrideProps = (0, $8nd05.default)((0, $8nd05.default)((0, $8nd05.default)({}, additionalOverrideProps), showTime ? (0, $c1dc9dc64bb71ced$export$6c7e3619a08d795a)((0, $8nd05.default)({
                format: format,
                picker: mergedPicker
            }, showTime)) : {}), mergedPicker === 'time' ? (0, $c1dc9dc64bb71ced$export$6c7e3619a08d795a)((0, $8nd05.default)((0, $8nd05.default)({
                format: format
            }, props), {
                picker: mergedPicker
            })) : {});
            var rootPrefixCls = getPrefixCls();
            // ===================== Size =====================
            var size = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
            var mergedSize = compactSize || customizeSize || size;
            // ===================== Disabled =====================
            var disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
            var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
            // ===================== FormItemInput =====================
            var formItemContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
            var hasFeedback = formItemContext.hasFeedback, contextStatus = formItemContext.status, feedbackIcon = formItemContext.feedbackIcon;
            var suffixNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, mergedPicker === 'time' ? /*#__PURE__*/ $acw62.createElement((0, $287c658c921bcb82$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $d851d821d19b0360$export$2e2bcd8739ae039), null), hasFeedback && feedbackIcon);
            return /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), {
                componentName: "DatePicker",
                defaultLocale: (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039)
            }, function(contextLocale) {
                var locale = (0, $8nd05.default)((0, $8nd05.default)({}, contextLocale), props.locale);
                return /*#__PURE__*/ $acw62.createElement((0, $b680b5fe5e1ba7b0$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    ref: innerRef,
                    placeholder: (0, $743db7050869a030$export$d3f5c5e0a5023fa0)(mergedPicker, locale, placeholder),
                    suffixIcon: suffixNode,
                    dropdownAlign: (0, $743db7050869a030$export$eb66ca17c6a72c49)(direction, placement),
                    clearIcon: /*#__PURE__*/ $acw62.createElement((0, $2bf1c25862f513c2$export$2e2bcd8739ae039), null),
                    prevIcon: /*#__PURE__*/ $acw62.createElement("span", {
                        className: "".concat(prefixCls, "-prev-icon")
                    }),
                    nextIcon: /*#__PURE__*/ $acw62.createElement("span", {
                        className: "".concat(prefixCls, "-next-icon")
                    }),
                    superPrevIcon: /*#__PURE__*/ $acw62.createElement("span", {
                        className: "".concat(prefixCls, "-super-prev-icon")
                    }),
                    superNextIcon: /*#__PURE__*/ $acw62.createElement("span", {
                        className: "".concat(prefixCls, "-super-next-icon")
                    }),
                    allowClear: true,
                    transitionName: "".concat(rootPrefixCls, "-slide-up")
                }, additionalProps, restProps, additionalOverrideProps, {
                    locale: locale.lang,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), "".concat(prefixCls, "-borderless"), !bordered), (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, className),
                    prefixCls: prefixCls,
                    getPopupContainer: customizeGetPopupContainer || getPopupContainer,
                    generateConfig: generateConfig,
                    components: (0, $c1dc9dc64bb71ced$export$cdb8a2fe02a819d9),
                    direction: direction,
                    disabled: mergedDisabled,
                    dropdownClassName: popupClassName || dropdownClassName
                }));
            });
        });
        if (displayName) Picker.displayName = displayName;
        return Picker;
    }
    var DatePicker = getPicker();
    var WeekPicker = getPicker('week', 'WeekPicker');
    var MonthPicker = getPicker('month', 'MonthPicker');
    var YearPicker = getPicker('year', 'YearPicker');
    var TimePicker = getPicker('time', 'TimePicker');
    var QuarterPicker = getPicker('quarter', 'QuarterPicker');
    return {
        DatePicker: DatePicker,
        WeekPicker: WeekPicker,
        MonthPicker: MonthPicker,
        YearPicker: YearPicker,
        TimePicker: TimePicker,
        QuarterPicker: QuarterPicker
    };
}


var $c1dc9dc64bb71ced$export$cdb8a2fe02a819d9 = {
    button: (0, $120fea39506aac9a$export$2e2bcd8739ae039),
    rangeItem: (0, $d7b6d277775e8147$export$2e2bcd8739ae039)
};
function $c1dc9dc64bb71ced$var$toArray(list) {
    if (!list) return [];
    return Array.isArray(list) ? list : [
        list
    ];
}
function $c1dc9dc64bb71ced$export$6c7e3619a08d795a(props) {
    var format = props.format, picker = props.picker, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, use12Hours = props.use12Hours;
    var firstFormat = $c1dc9dc64bb71ced$var$toArray(format)[0];
    var showTimeObj = (0, $8nd05.default)({}, props);
    if (firstFormat && typeof firstFormat === 'string') {
        if (!firstFormat.includes('s') && showSecond === undefined) showTimeObj.showSecond = false;
        if (!firstFormat.includes('m') && showMinute === undefined) showTimeObj.showMinute = false;
        if (!firstFormat.includes('H') && !firstFormat.includes('h') && showHour === undefined) showTimeObj.showHour = false;
        if ((firstFormat.includes('a') || firstFormat.includes('A')) && use12Hours === undefined) showTimeObj.use12Hours = true;
    }
    if (picker === 'time') return showTimeObj;
    if (typeof firstFormat === 'function') // format of showTime should use default when format is custom format function
    delete showTimeObj.format;
    return {
        showTime: showTimeObj
    };
}
var $c1dc9dc64bb71ced$var$DataPickerPlacements = (0, $1ee8868d1993c67b$export$65e3907585753458)('bottomLeft', 'bottomRight', 'topLeft', 'topRight');
function $c1dc9dc64bb71ced$var$generatePicker(generateConfig) {
    // =========================== Picker ===========================
    var _generateSinglePicker = (0, $6ad55698b5bc7f6f$export$2e2bcd8739ae039)(generateConfig), DatePicker = _generateSinglePicker.DatePicker, WeekPicker = _generateSinglePicker.WeekPicker, MonthPicker = _generateSinglePicker.MonthPicker, YearPicker = _generateSinglePicker.YearPicker, TimePicker = _generateSinglePicker.TimePicker, QuarterPicker = _generateSinglePicker.QuarterPicker;
    // ======================== Range Picker ========================
    var RangePicker = (0, $30ca1b0880de6cf8$export$2e2bcd8739ae039)(generateConfig);
    var MergedDatePicker = DatePicker;
    MergedDatePicker.WeekPicker = WeekPicker;
    MergedDatePicker.MonthPicker = MonthPicker;
    MergedDatePicker.YearPicker = YearPicker;
    MergedDatePicker.RangePicker = RangePicker;
    MergedDatePicker.TimePicker = TimePicker;
    MergedDatePicker.QuarterPicker = QuarterPicker;
    return MergedDatePicker;
}
var $c1dc9dc64bb71ced$export$2e2bcd8739ae039 = $c1dc9dc64bb71ced$var$generatePicker;


var $870653b3a8a06c8b$var$DatePicker = (0, $c1dc9dc64bb71ced$export$2e2bcd8739ae039)((0, $e25928f3c37eefb3$export$2e2bcd8739ae039));
var $870653b3a8a06c8b$export$2e2bcd8739ae039 = $870653b3a8a06c8b$var$DatePicker;



var $acw62 = parcelRequire("acw62");


function $1e62197f718e4845$var$_extends() {
    $1e62197f718e4845$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e62197f718e4845$var$_extends.apply(this, arguments);
}
const $1e62197f718e4845$var$LeftOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $1e62197f718e4845$var$_extends({}, props, {
        ref: ref,
        icon: (0, $766a51baf3f136aa$export$2e2bcd8739ae039)
    }));
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ const $1e62197f718e4845$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1e62197f718e4845$var$LeftOutlined);
var $1e62197f718e4845$export$2e2bcd8739ae039 = $1e62197f718e4845$var$RefIcon;


var $acw62 = parcelRequire("acw62");


function $ae197ef38b34eab8$var$_extends() {
    $ae197ef38b34eab8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ae197ef38b34eab8$var$_extends.apply(this, arguments);
}
const $ae197ef38b34eab8$var$RightOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $ae197ef38b34eab8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $73624b371df38195$export$2e2bcd8739ae039)
    }));
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ const $ae197ef38b34eab8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ae197ef38b34eab8$var$RightOutlined);
var $ae197ef38b34eab8$export$2e2bcd8739ae039 = $ae197ef38b34eab8$var$RefIcon;



var $45fvw = parcelRequire("45fvw");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");

var $i5C3F = parcelRequire("i5C3F");
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(z += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $298fb931ed4fbf8b$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(z) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(k = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $298fb931ed4fbf8b$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, p + 1, p = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span", 0) ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch", 0) ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $f8dbcd8598db1f0b$var$f = "data-styled", $f8dbcd8598db1f0b$var$m = "active", $f8dbcd8598db1f0b$var$y = "data-styled-version", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.1.17", $f8dbcd8598db1f0b$var$g = "/*!sc*/\n", $f8dbcd8598db1f0b$var$S = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $f8dbcd8598db1f0b$var$b = {}, $f8dbcd8598db1f0b$var$E = /invalid hook call/i, $f8dbcd8598db1f0b$var$N = new Set, $f8dbcd8598db1f0b$var$P = function(t, n) {
    var o, s, i, a, e;
}, $f8dbcd8598db1f0b$var$_ = Object.freeze([]), $f8dbcd8598db1f0b$var$C = Object.freeze({});
function $f8dbcd8598db1f0b$var$I(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $f8dbcd8598db1f0b$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$D = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$R(e) {
    return e.replace($f8dbcd8598db1f0b$var$O, "-").replace($f8dbcd8598db1f0b$var$D, "");
}
var $f8dbcd8598db1f0b$var$T = /(a)(d)/gi, $f8dbcd8598db1f0b$var$k = 52, $f8dbcd8598db1f0b$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $f8dbcd8598db1f0b$var$k; t = t / $f8dbcd8598db1f0b$var$k | 0)n = $f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n;
    return ($f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n).replace($f8dbcd8598db1f0b$var$T, "$1-$2");
}
var $f8dbcd8598db1f0b$var$V, $f8dbcd8598db1f0b$var$F = 5381, $f8dbcd8598db1f0b$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$z = function(e) {
    return $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$F, e);
};
function $f8dbcd8598db1f0b$var$$(e) {
    return $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$z(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$B(e) {
    return e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$L(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$G = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$Y = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$W = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$J = (($f8dbcd8598db1f0b$var$V = {})[$f8dbcd8598db1f0b$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$V[$f8dbcd8598db1f0b$var$Y] = $f8dbcd8598db1f0b$var$U, $f8dbcd8598db1f0b$var$V);
function $f8dbcd8598db1f0b$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$Y ? $f8dbcd8598db1f0b$var$U : "$$typeof" in e ? $f8dbcd8598db1f0b$var$J[e.$$typeof] : $f8dbcd8598db1f0b$var$q;
}
var $f8dbcd8598db1f0b$var$Z = Object.defineProperty, $f8dbcd8598db1f0b$var$K = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$Q = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$ee = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$te = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$ne = Object.prototype;
function $f8dbcd8598db1f0b$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$ne) {
            var o = $f8dbcd8598db1f0b$var$te(t);
            o && o !== $f8dbcd8598db1f0b$var$ne && $f8dbcd8598db1f0b$var$oe(e, o, n);
        }
        var r = $f8dbcd8598db1f0b$var$K(t);
        $f8dbcd8598db1f0b$var$Q && (r = r.concat($f8dbcd8598db1f0b$var$Q(t)));
        for(var s = $f8dbcd8598db1f0b$var$X(e), i = $f8dbcd8598db1f0b$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $f8dbcd8598db1f0b$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $f8dbcd8598db1f0b$var$ee(t, c);
                try {
                    $f8dbcd8598db1f0b$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$re(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $f8dbcd8598db1f0b$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    else if ($f8dbcd8598db1f0b$var$ce(t)) for(var o in t)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    return e;
}
function $f8dbcd8598db1f0b$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $f8dbcd8598db1f0b$var$pe = {};
function $f8dbcd8598db1f0b$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $f8dbcd8598db1f0b$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($f8dbcd8598db1f0b$var$g);
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$me = 1073741824, $f8dbcd8598db1f0b$var$ye = new Map, $f8dbcd8598db1f0b$var$ve = new Map, $f8dbcd8598db1f0b$var$ge = 1, $f8dbcd8598db1f0b$var$Se = function(e) {
    if ($f8dbcd8598db1f0b$var$ye.has(e)) return $f8dbcd8598db1f0b$var$ye.get(e);
    for(; $f8dbcd8598db1f0b$var$ve.has($f8dbcd8598db1f0b$var$ge);)$f8dbcd8598db1f0b$var$ge++;
    var t = $f8dbcd8598db1f0b$var$ge++;
    return $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e), t;
}, $f8dbcd8598db1f0b$var$we = function(e, t) {
    $f8dbcd8598db1f0b$var$ge = t + 1, $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e);
}, $f8dbcd8598db1f0b$var$be = "style[".concat($f8dbcd8598db1f0b$var$f, "][").concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"]'), $f8dbcd8598db1f0b$var$Ee = new RegExp("^".concat($f8dbcd8598db1f0b$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $f8dbcd8598db1f0b$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f8dbcd8598db1f0b$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($f8dbcd8598db1f0b$var$we(u, l), $f8dbcd8598db1f0b$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $f8dbcd8598db1f0b$var$_e = function(e) {
    for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($f8dbcd8598db1f0b$var$f) !== $f8dbcd8598db1f0b$var$m && ($f8dbcd8598db1f0b$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $f8dbcd8598db1f0b$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($f8dbcd8598db1f0b$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($f8dbcd8598db1f0b$var$f, $f8dbcd8598db1f0b$var$m), o.setAttribute($f8dbcd8598db1f0b$var$y, $f8dbcd8598db1f0b$export$83d89fbfd8236492);
    var i = $f8dbcd8598db1f0b$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $f8dbcd8598db1f0b$var$Ae = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $f8dbcd8598db1f0b$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Oe = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Re = $f8dbcd8598db1f0b$var$S, $f8dbcd8598db1f0b$var$Te = {
    isServer: !$f8dbcd8598db1f0b$var$S,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$w
}, $f8dbcd8598db1f0b$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$S && $f8dbcd8598db1f0b$var$Re && ($f8dbcd8598db1f0b$var$Re = !1, $f8dbcd8598db1f0b$var$_e(this)), $f8dbcd8598db1f0b$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $f8dbcd8598db1f0b$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($f8dbcd8598db1f0b$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($f8dbcd8598db1f0b$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $f8dbcd8598db1f0b$var$S && $f8dbcd8598db1f0b$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$De(n) : t ? new $f8dbcd8598db1f0b$var$Ae(n) : new $f8dbcd8598db1f0b$var$Oe(n);
        }(this.options), new $f8dbcd8598db1f0b$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $f8dbcd8598db1f0b$var$je = /&/g, $f8dbcd8598db1f0b$var$xe = /^\s*\/\/.*$/gm;
function $f8dbcd8598db1f0b$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$Ve(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $f8dbcd8598db1f0b$var$C : e, s = r.options, i = void 0 === s ? $f8dbcd8598db1f0b$var$C : s, a = r.plugins, c = void 0 === a ? $f8dbcd8598db1f0b$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $298fb931ed4fbf8b$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$je, n).replace(o, l));
    }), i.prefix && u.push($298fb931ed4fbf8b$export$e08c7d021b829b7a), u.push($298fb931ed4fbf8b$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($f8dbcd8598db1f0b$var$xe, ""), l = $298fb931ed4fbf8b$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $f8dbcd8598db1f0b$var$Ve(l, i.namespace));
        var p = [];
        return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(l, $298fb931ed4fbf8b$export$5a7767152ae0305f(u.concat($298fb931ed4fbf8b$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$he(15), $f8dbcd8598db1f0b$var$M(e, t.name);
    }, $f8dbcd8598db1f0b$var$F).toString() : "", p;
}
var $f8dbcd8598db1f0b$var$Me = new $f8dbcd8598db1f0b$var$ke, $f8dbcd8598db1f0b$var$ze = $f8dbcd8598db1f0b$var$Fe(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Me,
    stylis: $f8dbcd8598db1f0b$var$ze
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$Ge() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $f8dbcd8598db1f0b$var$Ge().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($i5C3F)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $acw62.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$Le.Provider, {
        value: u
    }, e.children));
}
var $f8dbcd8598db1f0b$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $f8dbcd8598db1f0b$var$ue(this, function() {
            throw $f8dbcd8598db1f0b$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$ze), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$f8dbcd8598db1f0b$var$Ue(i) && (Array.isArray(i) && i.isCss || $f8dbcd8598db1f0b$var$re(i) ? r.push("".concat($f8dbcd8598db1f0b$var$He(s), ":"), i, ";") : $f8dbcd8598db1f0b$var$ce(i) ? r.push.apply(r, (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $f8dbcd8598db1f0b$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($f8dbcd8598db1f0b$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $936be3b045ab836e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $f8dbcd8598db1f0b$var$Xe(e, t, n, o) {
    if ($f8dbcd8598db1f0b$var$Ue(e)) return [];
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($f8dbcd8598db1f0b$var$re(e)) {
        if (!$f8dbcd8598db1f0b$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $f8dbcd8598db1f0b$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $f8dbcd8598db1f0b$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $f8dbcd8598db1f0b$var$ce(e) ? $f8dbcd8598db1f0b$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($f8dbcd8598db1f0b$var$_, e.map(function(e) {
        return $f8dbcd8598db1f0b$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $f8dbcd8598db1f0b$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$re(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$Ke = $f8dbcd8598db1f0b$var$z($f8dbcd8598db1f0b$export$83d89fbfd8236492), $f8dbcd8598db1f0b$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$Ze(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$Ke, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $f8dbcd8598db1f0b$var$ie(o, this.staticRulesId);
            else {
                var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $f8dbcd8598db1f0b$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(u, e, t, n));
                    a = $f8dbcd8598db1f0b$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $f8dbcd8598db1f0b$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $f8dbcd8598db1f0b$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    var e = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$he(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$he(14);
            if ($f8dbcd8598db1f0b$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$he(8);
            return n ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$rt = {}, $f8dbcd8598db1f0b$var$st = new Set;
function $f8dbcd8598db1f0b$var$it(e, r, s) {
    var i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), a = e, c = !$f8dbcd8598db1f0b$var$L(e), p = r.attrs, d = void 0 === p ? $f8dbcd8598db1f0b$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$R(e);
        $f8dbcd8598db1f0b$var$rt[n] = ($f8dbcd8598db1f0b$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$$($f8dbcd8598db1f0b$export$83d89fbfd8236492 + n + $f8dbcd8598db1f0b$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $f8dbcd8598db1f0b$var$L(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($f8dbcd8598db1f0b$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $f8dbcd8598db1f0b$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), m = $f8dbcd8598db1f0b$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $f8dbcd8598db1f0b$var$I(r, f, c) || $f8dbcd8598db1f0b$var$C, g = function(e, n, o) {
                for(var r, s = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $f8dbcd8598db1f0b$var$ie(s[c], a[c]) : "style" === c ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $f8dbcd8598db1f0b$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $f8dbcd8598db1f0b$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $f8dbcd8598db1f0b$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$f8dbcd8598db1f0b$var$L(S) && !$f8dbcd8598db1f0b$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $acw62.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$f8dbcd8598db1f0b$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $f8dbcd8598db1f0b$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $f8dbcd8598db1f0b$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($f8dbcd8598db1f0b$var$re(t) || $f8dbcd8598db1f0b$var$ce(t)) return $f8dbcd8598db1f0b$var$ct($f8dbcd8598db1f0b$var$Xe($f8dbcd8598db1f0b$var$at($f8dbcd8598db1f0b$var$_, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $f8dbcd8598db1f0b$var$Xe(r) : $f8dbcd8598db1f0b$var$ct($f8dbcd8598db1f0b$var$Xe($f8dbcd8598db1f0b$var$at(r, n)));
}
function $f8dbcd8598db1f0b$var$ut(n, o, r) {
    if (void 0 === r && (r = $f8dbcd8598db1f0b$var$C), !o) throw $f8dbcd8598db1f0b$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$ut(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$ut(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $f8dbcd8598db1f0b$var$pt = function(e) {
    return $f8dbcd8598db1f0b$var$ut($f8dbcd8598db1f0b$var$it, e);
}, $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$pt;
$f8dbcd8598db1f0b$var$A.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$pt(e);
});
var $f8dbcd8598db1f0b$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$Ze(e), $f8dbcd8598db1f0b$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $f8dbcd8598db1f0b$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$$(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$ht(i, a);
    var l = function(e) {
        var t = $f8dbcd8598db1f0b$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$b, o, s);
        else {
            var i = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$$(r);
    return new $f8dbcd8598db1f0b$var$We(s, r);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $f8dbcd8598db1f0b$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($f8dbcd8598db1f0b$var$B(e), ")"), $f8dbcd8598db1f0b$var$oe(n, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$Ce(), o = $f8dbcd8598db1f0b$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$f, '="true"'),
                "".concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$f8dbcd8598db1f0b$var$f] = "", n[$f8dbcd8598db1f0b$var$y] = $f8dbcd8598db1f0b$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $f8dbcd8598db1f0b$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$he(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$ke,
    mainSheet: $f8dbcd8598db1f0b$var$Me
};
var $f8dbcd8598db1f0b$var$St = "__sc-".concat($f8dbcd8598db1f0b$var$f, "__");


const $a724bbfbe7fdfe75$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	flex: 1;
	height: 1px;

	display: flex;
	flex-direction: column;

	overflow: hidden;

	#heading {
		display: flex;
		align-items: center;

		width: 100%;

		background: $white;
		box-shadow: 0 7px 10px -4px rgba(0, 0, 0, 0.3);

		margin-bottom: 8px;

		> button {
			width: 56px;
			height: 56px;
			justify-content: center;

			&:first-child {
				margin-right: 25px;
			}
		}

		> .date {
			min-height: 100px;
			min-width: 350px;
			min-height: 150px;
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			> h4 {
				color: $gray-9;
				font-weight: 500;
				font-size: 24px;
				margin-bottom: 0;
			}

			> span {
				color: $gray-8;
				font-size: 18px;
			}

			> .ant-picker {
				width: 300px;
				max-width: 100%;
				margin: 10px 0 20px 0;
			}
		}
	}

	.calendar-wrapper {
		flex: 1;
		overflow-y: auto;
		display: flex;
		height: 1px;
		width: 100%;
	}
`;
const $a724bbfbe7fdfe75$var$Head = ({ offset: offset, setOffset: setOffset })=>{
    const start = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(offset, 'days').startOf('day'), [
        offset
    ]);
    const dayName = start.format('dddd');
    const monthName = start.format('MMMM');
    const dayNum = start.date();
    const onChange = (date)=>setOffset(()=>date.startOf('day').diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('day'), 'days'));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        id: "heading",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                shape: "circle",
                size: "large",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e62197f718e4845$export$2e2bcd8739ae039), {}),
                onClick: ()=>setOffset((offset)=>--offset)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "date",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: dayName.charAt(0).toUpperCase() + dayName.slice(1)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            dayNum,
                            " ",
                            monthName
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                        size: "large",
                        value: start,
                        onChange: onChange,
                        allowClear: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                shape: "circle",
                size: "large",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), {}),
                onClick: ()=>setOffset((offset)=>++offset)
            })
        ]
    });
};
const $a724bbfbe7fdfe75$var$Calendar = ({ children: children, offset: offset, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a724bbfbe7fdfe75$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a724bbfbe7fdfe75$var$Head, {
                offset: offset,
                setOffset: onChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "calendar-wrapper",
                children: children
            })
        ]
    });
};
var $a724bbfbe7fdfe75$export$2e2bcd8739ae039 = $a724bbfbe7fdfe75$var$Calendar;




parcelRequire("acw62");


const $04b0b217cbf992c9$var$Icon = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	width: 150px;
	height: 150px;
	border-radius: 100%;
	background-color: white;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
	position: relative;

	&:hover {
		cursor: pointer;
	}

	span {
		color: #003a8c;
	}

	svg {
		font-size: 80px;
	}

	& + p {
		text-align: center;
		margin: 0;
		margin-top: 10px;
		font-size: 20px;
		font-weight: 500;
		color: $gray-8;

		&:hover {
			cursor: pointer;
		}
	}

	&::after {
		${(props)=>props.notifications != undefined ? (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
						content: '${props.notifications}';
				  ` : null}
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		right: 0;
		width: 47px;
		height: 47px;
		background-color: #f5222d;
		font-size: 24px;
		font-weight: 700;
		color: white;
		border-radius: 100%;
	}
`;
const $04b0b217cbf992c9$var$IconCircle = ({ children: children, label: label, onClick: onClick, notifications: notifications })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-dir flex-jc flex-ac",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($04b0b217cbf992c9$var$Icon, {
                className: "flex flex-jc flex-ac",
                onClick: onClick,
                notifications: notifications,
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: label
            })
        ]
    });
};
var $04b0b217cbf992c9$export$2e2bcd8739ae039 = $04b0b217cbf992c9$var$IconCircle;



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4f8539149c3257cf$var$ArrowLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "arrow-left",
    "theme": "outlined"
};
var $4f8539149c3257cf$export$2e2bcd8739ae039 = $4f8539149c3257cf$var$ArrowLeftOutlined;



function $9540ed9c9b119e24$var$_extends() {
    $9540ed9c9b119e24$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9540ed9c9b119e24$var$_extends.apply(this, arguments);
}
const $9540ed9c9b119e24$var$ArrowLeftOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $9540ed9c9b119e24$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4f8539149c3257cf$export$2e2bcd8739ae039)
    }));
/**![arrow-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiA0NzRIMjg2LjlsMzUwLjItMzA0YzUuNi00LjkgMi4yLTE0LTUuMi0xNGgtODguNWMtMy45IDAtNy42IDEuNC0xMC41IDMuOUwxNTUgNDg3LjhhMzEuOTYgMzEuOTYgMCAwMDAgNDguM0w1MzUuMSA4NjZjMS41IDEuMyAzLjMgMiA1LjIgMmg5MS41YzcuNCAwIDEwLjgtOS4yIDUuMi0xNEwyODYuOSA1NTBIODcyYzQuNCAwIDgtMy42IDgtOHYtNjBjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $9540ed9c9b119e24$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9540ed9c9b119e24$var$ArrowLeftOutlined);
var $9540ed9c9b119e24$export$2e2bcd8739ae039 = $9540ed9c9b119e24$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $a0dd0cca1d1791b4$var$HomeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    },
    "name": "home",
    "theme": "outlined"
};
var $a0dd0cca1d1791b4$export$2e2bcd8739ae039 = $a0dd0cca1d1791b4$var$HomeOutlined;



function $74292ff659d43756$var$_extends() {
    $74292ff659d43756$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $74292ff659d43756$var$_extends.apply(this, arguments);
}
const $74292ff659d43756$var$HomeOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $74292ff659d43756$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a0dd0cca1d1791b4$export$2e2bcd8739ae039)
    }));
/**![home](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Ni41IDUwNUw1NjAuMSAxMTguOGwtMjUuOS0yNS45YTMxLjUgMzEuNSAwIDAwLTQ0LjQgMEw3Ny41IDUwNWE2My45IDYzLjkgMCAwMC0xOC44IDQ2Yy40IDM1LjIgMjkuNyA2My4zIDY0LjkgNjMuM2g0Mi41Vjk0MGg2OTEuOFY2MTQuM2g0My40YzE3LjEgMCAzMy4yLTYuNyA0NS4zLTE4LjhhNjMuNiA2My42IDAgMDAxOC43LTQ1LjNjMC0xNy02LjctMzMuMS0xOC44LTQ1LjJ6TTU2OCA4NjhINDU2VjY2NGgxMTJ2MjA0em0yMTcuOS0zMjUuN1Y4NjhINjMyVjY0MGMwLTIyLjEtMTcuOS00MC00MC00MEg0MzJjLTIyLjEgMC00MCAxNy45LTQwIDQwdjIyOEgyMzguMVY1NDIuM2gtOTZsMzcwLTM2OS43IDIzLjEgMjMuMUw4ODIgNTQyLjNoLTk2LjF6IiAvPjwvc3ZnPg==) */ const $74292ff659d43756$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($74292ff659d43756$var$HomeOutlined);
var $74292ff659d43756$export$2e2bcd8739ae039 = $74292ff659d43756$var$RefIcon;



const $c4988417e977609c$var$Page = ({ title: title, children: children, actions: actions, bottomTitle: bottomTitle, number: number, footer: footer })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "wrapper",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "page flex flex-dir",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "header flex flex-ac",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "back flex flex-jc flex-ac",
                            onClick: ()=>navigate(-1),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9540ed9c9b119e24$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "home flex flex-jc flex-ac",
                            onClick: ()=>navigate('/panel'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74292ff659d43756$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "content flex flex-dir",
                    children: [
                        children,
                        (actions || bottomTitle || number || footer) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "footer flex flex-jsb flex-jc",
                            children: footer ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: actions
                                    }),
                                    (bottomTitle || number) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: bottomTitle
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: number
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $c4988417e977609c$export$2e2bcd8739ae039 = $c4988417e977609c$var$Page;



parcelRequire("acw62");

const $2bf34c14753bba3f$var$Section = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	flex: ${({ width: width })=>width};
	height: 100%;
	overflow-y: auto;

	> ul {
		padding-top: 5px;
		height: 90%;
		overflow-y: auto;
	}
`;
const $2bf34c14753bba3f$var$P = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
	font-size: 24px;
	font-weight: 500;
	color: #096dd9;
`;
const $2bf34c14753bba3f$var$HeaderWrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	border-bottom: 1px solid #bfbfbf;
	margin-bottom: 45px;
	align-items: flex-end;

	> .ant-select {
		width: 300px;
		margin-bottom: 3px;
	}
`;
const $2bf34c14753bba3f$var$PageSection = ({ title: title, width: width, children: children, select: select })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($2bf34c14753bba3f$var$Section, {
        width: width,
        className: "page-section",
        children: [
            title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($2bf34c14753bba3f$var$HeaderWrapper, {
                className: "flex flex-jsb",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2bf34c14753bba3f$var$P, {
                        children: title
                    }),
                    select
                ]
            }),
            children
        ]
    });
};
var $2bf34c14753bba3f$export$2e2bcd8739ae039 = $2bf34c14753bba3f$var$PageSection;



parcelRequire("acw62");

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");





var $iORrr = parcelRequire("iORrr");

var $acw62 = parcelRequire("acw62");



var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $3fDfx = parcelRequire("3fDfx");

var $acw62 = parcelRequire("acw62");


function $4c53afaea8b9c117$var$isThenable(thing) {
    return !!(thing && !!thing.then);
}
var $4c53afaea8b9c117$var$ActionButton = function ActionButton(props) {
    var clickedRef = $acw62.useRef(false);
    var ref = $acw62.useRef(null);
    var _useState = (0, $3fDfx.default)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), loading = _useState2[0], setLoading = _useState2[1];
    var close = props.close;
    var onInternalClose = function onInternalClose() {
        close === null || close === void 0 || close.apply(void 0, arguments);
    };
    $acw62.useEffect(function() {
        var timeoutId = null;
        if (props.autoFocus) timeoutId = setTimeout(function() {
            var _a;
            (_a = ref.current) === null || _a === void 0 || _a.focus();
        });
        return function() {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    var handlePromiseOnOk = function handlePromiseOnOk(returnValueOfOnOk) {
        if (!$4c53afaea8b9c117$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then(function() {
            setLoading(false, true);
            onInternalClose.apply(void 0, arguments);
            clickedRef.current = false;
        }, function(e) {
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            return Promise.reject(e);
        });
    };
    var onClick = function onClick(e) {
        var actionFn = props.actionFn;
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        var returnValueOfOnOk;
        if (props.emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (props.quitOnNullishReturnValue && !$4c53afaea8b9c117$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    var type = props.type, children = props.children, prefixCls = props.prefixCls, buttonProps = props.buttonProps;
    return /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, (0, $c6609c7ee777e096$export$19bc9a290855952)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: ref
    }), children);
};
var $4c53afaea8b9c117$export$2e2bcd8739ae039 = $4c53afaea8b9c117$var$ActionButton;





var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");


var $8g1PZ = parcelRequire("8g1PZ");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $h4v51 = parcelRequire("h4v51");
parcelRequire("u43uR");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");
var $b422cebf586837cd$var$OrderContext = /*#__PURE__*/ $acw62.createContext(null);
var $b422cebf586837cd$export$2e2bcd8739ae039 = $b422cebf586837cd$var$OrderContext;



var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $6hDTM = parcelRequire("6hDTM");

var $h4v51 = parcelRequire("h4v51");

var $172bd5bc03f91d44$var$EMPTY_LIST = [];
function $172bd5bc03f91d44$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $acw62.useState(function() {
        if (!(0, $h4v51.default)()) return null;
        var defaultEle = document.createElement('div');
        return defaultEle;
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $acw62.useRef(false);
    var queueCreate = $acw62.useContext((0, $b422cebf586837cd$export$2e2bcd8739ae039));
    var _React$useState3 = $acw62.useState($172bd5bc03f91d44$var$EMPTY_LIST), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $kbxxf.default)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $6hDTM.default)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $6hDTM.default)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($172bd5bc03f91d44$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $4ZrBP = parcelRequire("4ZrBP");

var $6hDTM = parcelRequire("6hDTM");

var $2SjmF = parcelRequire("2SjmF");
/**
 * Test usage export. Do not use in your production
 */ function $c9634f2c2418b2d0$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $66bc1eccb2a603c3$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $66bc1eccb2a603c3$var$uuid = 0;
function $66bc1eccb2a603c3$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $acw62.useState(function() {
        $66bc1eccb2a603c3$var$uuid += 1;
        return "".concat($66bc1eccb2a603c3$var$UNIQUE_ID, "_").concat($66bc1eccb2a603c3$var$uuid);
    }), _React$useState2 = (0, $eUqlC.default)(_React$useState, 1), id = _React$useState2[0];
    (0, $6hDTM.default)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $2SjmF.getTargetScrollBarSize)(document.body).width;
            var isOverflow = (0, $c9634f2c2418b2d0$export$31b5c8f1131a3a52)();
            (0, $4ZrBP.updateCSS)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
        } else (0, $4ZrBP.removeCSS)(id);
        return function() {
            (0, $4ZrBP.removeCSS)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = false;
function $2ccc34741b4bb73f$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = nextInline;
    return $2ccc34741b4bb73f$export$18c8ad048e32c7d5;
}


var $ae492a4c7ad9d4f3$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $h4v51.default)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
var $ae492a4c7ad9d4f3$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $acw62.useState(open), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $acw62.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $acw62.useState(function() {
        return $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $acw62.useEffect(function() {
        var customizeContainer = $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $172bd5bc03f91d44$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $eUqlC.default)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $66bc1eccb2a603c3$export$2e2bcd8739ae039)(autoLock && open && (0, $h4v51.default)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $85dLH.supportRef)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $85dLH.useComposeRef)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $h4v51.default)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $2ccc34741b4bb73f$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $acw62.createElement((0, $b422cebf586837cd$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $1u0KT.createPortal)(reffedChildren, mergedContainer));
});
var $ae492a4c7ad9d4f3$export$2e2bcd8739ae039 = $ae492a4c7ad9d4f3$var$Portal;



var $5b46218595a40828$export$2e2bcd8739ae039 = (0, $ae492a4c7ad9d4f3$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $eUqlC = parcelRequire("eUqlC");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
function $d23d006593dfab9c$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $d49SP.default)({}, $acw62);
    return fullClone.useId;
}
var $d23d006593dfab9c$var$uuid = 0;
function $d23d006593dfab9c$export$2f0435a662835942() {}
var $d23d006593dfab9c$var$useOriginId = $d23d006593dfab9c$var$getUseId();
var $d23d006593dfab9c$export$2e2bcd8739ae039 = $d23d006593dfab9c$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $d23d006593dfab9c$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState('ssr-id'), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        var nextId = $d23d006593dfab9c$var$uuid;
        $d23d006593dfab9c$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};



var $d1wDM = parcelRequire("d1wDM");

var $3ryW7 = parcelRequire("3ryW7");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");
function $e10e3c44c896dc47$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName;
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
            ref: ref,
            style: (0, $d49SP.default)((0, $d49SP.default)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-mask"), motionClassName)
        }, maskProps));
    });
}


// =============================== Motion ===============================
function $90c55518cdbfc131$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $90c55518cdbfc131$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $90c55518cdbfc131$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $90c55518cdbfc131$var$getScroll(w);
    pos.top += $90c55518cdbfc131$var$getScroll(w, true);
    return pos;
}



var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");


var $d49SP = parcelRequire("d49SP");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $112494d152ccd867$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});


var $d87bfeabd0b3848d$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
var $d87bfeabd0b3848d$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height;
    // ================================= Refs =================================
    var sentinelStartRef = (0, $acw62.useRef)();
    var sentinelEndRef = (0, $acw62.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                    preventScroll: true
                });
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode;
    if (footer) footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, footer);
    var headerNode;
    if (title) headerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-header")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title));
    var closer;
    if (closable) closer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": "Close",
        className: "".concat(prefixCls, "-close")
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }));
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, closer, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $8nd05.default)({
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: holderRef,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $112494d152ccd867$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle
    }));
});
var $d87bfeabd0b3848d$export$2e2bcd8739ae039 = $d87bfeabd0b3848d$var$Panel;


var $b02b23d234e320c9$var$Content = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $acw62.useRef)();
    // ============================= Style ==============================
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $90c55518cdbfc131$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement((0, $d87bfeabd0b3848d$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, motionClassName)
        }));
    });
});
$b02b23d234e320c9$var$Content.displayName = 'Content';
var $b02b23d234e320c9$export$2e2bcd8739ae039 = $b02b23d234e320c9$var$Content;


function $850025f1cddd8729$export$2e2bcd8739ae039(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName;
    var lastOutSideActiveElementRef = (0, $acw62.useRef)();
    var wrapperRef = (0, $acw62.useRef)();
    var contentRef = (0, $acw62.useRef)();
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $d23d006593dfab9c$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $d1wDM.default)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $d1wDM.default)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $acw62.useRef)(false);
    var contentTimeoutRef = (0, $acw62.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $iCi4s.default).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $iCi4s.default).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $acw62.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $acw62.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $3ryW7.default)(props, {
        data: true
    })), /*#__PURE__*/ $acw62.createElement((0, $e10e3c44c896dc47$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $d49SP.default)({
            zIndex: zIndex
        }, maskStyle),
        maskProps: maskProps
    }), /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-wrap"), wrapClassName),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: (0, $d49SP.default)((0, $d49SP.default)({
            zIndex: zIndex
        }, wrapStyle), {}, {
            display: !animatedVisible ? 'none' : null
        })
    }, wrapProps), /*#__PURE__*/ $acw62.createElement((0, $b02b23d234e320c9$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
}


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $08b45dfd0eb11827$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose;
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    $acw62.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // // 渲染在当前 dom 里；
    // if (getContainer === false) {
    //   return (
    //     <Dialog
    //       {...props}
    //       getOpenCount={() => 2} // 不对 body 做任何操作。。
    //     />
    //   );
    // }
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $5b46218595a40828$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $acw62.createElement((0, $850025f1cddd8729$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    })));
};
$08b45dfd0eb11827$var$DialogWrap.displayName = 'Dialog';
var $08b45dfd0eb11827$export$2e2bcd8739ae039 = $08b45dfd0eb11827$var$DialogWrap;



var $fc48b5916203bd39$export$2e2bcd8739ae039 = (0, $08b45dfd0eb11827$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");










var $e567711acbe5f453$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e567711acbe5f453$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
var $e567711acbe5f453$var$getClickPosition = function getClickPosition(e) {
    $e567711acbe5f453$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(function() {
        $e567711acbe5f453$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $ebcf30cec053af5e$export$7dbdadf5e9653129)()) document.documentElement.addEventListener('click', $e567711acbe5f453$var$getClickPosition, true);
var $e567711acbe5f453$var$Modal = function Modal(props) {
    var _a;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var handleCancel = function handleCancel(e) {
        var onCancel = props.onCancel;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    var handleOk = function handleOk(e) {
        var onOk = props.onOk;
        onOk === null || onOk === void 0 || onOk(e);
    };
    var customizePrefixCls = props.prefixCls, footer = props.footer, visible = props.visible, _props$open = props.open, open = _props$open === void 0 ? false : _props$open, wrapClassName = props.wrapClassName, centered = props.centered, getContainer = props.getContainer, closeIcon = props.closeIcon, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, _props$width = props.width, width = _props$width === void 0 ? 520 : _props$width, restProps = $e567711acbe5f453$var$__rest(props, [
        "prefixCls",
        "footer",
        "visible",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "closeIcon",
        "focusTriggerAfterClose",
        "width"
    ]);
    var prefixCls = getPrefixCls('modal', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var defaultFooter = /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), {
        componentName: "Modal",
        defaultLocale: (0, $466e4bebfd7443ca$export$1b6004afda18cd51)()
    }, function(contextLocale) {
        var okText = props.okText, _props$okType = props.okType, okType = _props$okType === void 0 ? 'primary' : _props$okType, cancelText = props.cancelText, _props$confirmLoading = props.confirmLoading, confirmLoading = _props$confirmLoading === void 0 ? false : _props$confirmLoading;
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), (0, $8nd05.default)({
            onClick: handleCancel
        }, props.cancelButtonProps), cancelText || contextLocale.cancelText), /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), (0, $8nd05.default)({}, (0, $c6609c7ee777e096$export$19bc9a290855952)(okType), {
            loading: confirmLoading,
            onClick: handleOk
        }, props.okButtonProps), okText !== null && okText !== void 0 ? okText : contextLocale.okText));
    });
    var closeIconToRender = /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, closeIcon || /*#__PURE__*/ $acw62.createElement((0, $31b8ddc4065205d5$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-close-icon")
    }));
    var wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(wrapClassName, (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-centered"), !!centered), "".concat(prefixCls, "-wrap-rtl"), direction === 'rtl'));
    return /*#__PURE__*/ $acw62.createElement((0, $26050ef76e24a749$export$5f56e610a4afb685), null, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$80e4c53cb85dcab1), {
        status: true,
        override: true
    }, /*#__PURE__*/ $acw62.createElement((0, $fc48b5916203bd39$export$2e2bcd8739ae039), (0, $8nd05.default)({
        width: width
    }, restProps, {
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        wrapClassName: wrapClassNameExtended,
        footer: footer === undefined ? defaultFooter : footer,
        visible: open || visible,
        mousePosition: (_a = restProps.mousePosition) !== null && _a !== void 0 ? _a : $e567711acbe5f453$var$mousePosition,
        onClose: handleCancel,
        closeIcon: closeIconToRender,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName)
    }))));
};
var $e567711acbe5f453$export$2e2bcd8739ae039 = $e567711acbe5f453$var$Modal;


var $e57a817b0bed94b2$var$ConfirmDialog = function ConfirmDialog(props) {
    var icon = props.icon, onCancel = props.onCancel, onOk = props.onOk, close = props.close, zIndex = props.zIndex, afterClose = props.afterClose, visible = props.visible, open = props.open, keyboard = props.keyboard, centered = props.centered, getContainer = props.getContainer, maskStyle = props.maskStyle, okText = props.okText, okButtonProps = props.okButtonProps, cancelText = props.cancelText, cancelButtonProps = props.cancelButtonProps, direction = props.direction, prefixCls = props.prefixCls, wrapClassName = props.wrapClassName, rootPrefixCls = props.rootPrefixCls, iconPrefixCls = props.iconPrefixCls, bodyStyle = props.bodyStyle, _props$closable = props.closable, closable = _props$closable === void 0 ? false : _props$closable, closeIcon = props.closeIcon, modalRender = props.modalRender, focusTriggerAfterClose = props.focusTriggerAfterClose;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    var okType = props.okType || 'primary';
    var contentPrefixCls = "".concat(prefixCls, "-confirm");
    // 默认为 true，保持向下兼容
    var okCancel = 'okCancel' in props ? props.okCancel : true;
    var width = props.width || 416;
    var style = props.style || {};
    var mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), (0, $kSlfw.default)({}, "".concat(contentPrefixCls, "-rtl"), direction === 'rtl'), props.className);
    var cancelButton = okCancel && /*#__PURE__*/ $acw62.createElement((0, $4c53afaea8b9c117$export$2e2bcd8739ae039), {
        actionFn: onCancel,
        close: close,
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: "".concat(rootPrefixCls, "-btn")
    }, cancelText);
    return /*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction
    }, /*#__PURE__*/ $acw62.createElement((0, $e567711acbe5f453$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(contentPrefixCls, "-centered"), !!props.centered), wrapClassName),
        onCancel: function onCancel() {
            return close === null || close === void 0 ? void 0 : close({
                triggerCancel: true
            });
        },
        open: open || visible,
        title: "",
        footer: "",
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        maskStyle: maskStyle,
        style: style,
        bodyStyle: bodyStyle,
        width: width,
        zIndex: zIndex,
        afterClose: afterClose,
        keyboard: keyboard,
        centered: centered,
        getContainer: getContainer,
        closable: closable,
        closeIcon: closeIcon,
        modalRender: modalRender,
        focusTriggerAfterClose: focusTriggerAfterClose
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(contentPrefixCls, "-body-wrapper")
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(contentPrefixCls, "-body")
    }, icon, props.title === undefined ? null : /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(contentPrefixCls, "-title")
    }, props.title), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(contentPrefixCls, "-content")
    }, props.content)), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(contentPrefixCls, "-btns")
    }, cancelButton, /*#__PURE__*/ $acw62.createElement((0, $4c53afaea8b9c117$export$2e2bcd8739ae039), {
        type: okType,
        actionFn: onOk,
        close: close,
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: "".concat(rootPrefixCls, "-btn")
    }, okText)))));
};
var $e57a817b0bed94b2$export$2e2bcd8739ae039 = $e57a817b0bed94b2$var$ConfirmDialog;


var $2077bf4ca69b0fef$var$destroyFns = [];
var $2077bf4ca69b0fef$export$2e2bcd8739ae039 = $2077bf4ca69b0fef$var$destroyFns;



var $31d3fb1111bc089d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $31d3fb1111bc089d$var$defaultRootPrefixCls = '';
function $31d3fb1111bc089d$var$getRootPrefixCls() {
    return $31d3fb1111bc089d$var$defaultRootPrefixCls;
}
function $31d3fb1111bc089d$export$2e2bcd8739ae039(config) {
    var container = document.createDocumentFragment();
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    var currentConfig = (0, $8nd05.default)((0, $8nd05.default)({}, config), {
        close: close,
        open: true
    });
    var timeoutId;
    function destroy() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var triggerCancel = args.some(function(param) {
            return param && param.triggerCancel;
        });
        if (config.onCancel && triggerCancel) config.onCancel.apply(config, [
            function() {}
        ].concat((0, $kbxxf.default)(args.slice(1))));
        for(var i = 0; i < (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).length; i++){
            var fn = (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039)[i];
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (fn === close) {
                (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $iORrr.unmount)(container);
    }
    function render(_a) {
        var okText = _a.okText, cancelText = _a.cancelText, customizePrefixCls = _a.prefixCls, props = $31d3fb1111bc089d$var$__rest(_a, [
            "okText",
            "cancelText",
            "prefixCls"
        ]);
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(function() {
            var runtimeLocale = (0, $466e4bebfd7443ca$export$1b6004afda18cd51)();
            var _globalConfig = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
            // because Modal.config  set rootPrefixCls, which is different from other components
            var rootPrefixCls = getPrefixCls(undefined, $31d3fb1111bc089d$var$getRootPrefixCls());
            var prefixCls = customizePrefixCls || "".concat(rootPrefixCls, "-modal");
            var iconPrefixCls = getIconPrefixCls();
            (0, $iORrr.render)(/*#__PURE__*/ $acw62.createElement((0, $e57a817b0bed94b2$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                okText: okText || (props.okCancel ? runtimeLocale.okText : runtimeLocale.justOkText),
                cancelText: cancelText || runtimeLocale.cancelText
            })), container);
        });
    }
    function close() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        currentConfig = (0, $8nd05.default)((0, $8nd05.default)({}, currentConfig), {
            open: false,
            afterClose: function afterClose() {
                if (typeof config.afterClose === 'function') config.afterClose();
                destroy.apply(_this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = (0, $8nd05.default)((0, $8nd05.default)({}, currentConfig), configUpdate);
        render(currentConfig);
    }
    render(currentConfig);
    (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $31d3fb1111bc089d$export$503fa8fed137d104(props) {
    return (0, $8nd05.default)((0, $8nd05.default)({
        icon: /*#__PURE__*/ $acw62.createElement((0, $7e2f802c76c39788$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'warning'
    });
}
function $31d3fb1111bc089d$export$2f728eab0dacbb2e(props) {
    return (0, $8nd05.default)((0, $8nd05.default)({
        icon: /*#__PURE__*/ $acw62.createElement((0, $7e25aa5b60711714$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'info'
    });
}
function $31d3fb1111bc089d$export$2b5f8d7f29c805d4(props) {
    return (0, $8nd05.default)((0, $8nd05.default)({
        icon: /*#__PURE__*/ $acw62.createElement((0, $99a2d8a3991a4b46$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'success'
    });
}
function $31d3fb1111bc089d$export$60e9e0884ce12b55(props) {
    return (0, $8nd05.default)((0, $8nd05.default)({
        icon: /*#__PURE__*/ $acw62.createElement((0, $e59ec99fdd4bd915$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'error'
    });
}
function $31d3fb1111bc089d$export$665b64399d4af99c(props) {
    return (0, $8nd05.default)((0, $8nd05.default)({
        icon: /*#__PURE__*/ $acw62.createElement((0, $7e2f802c76c39788$export$2e2bcd8739ae039), null),
        okCancel: true
    }, props), {
        type: 'confirm'
    });
}
function $31d3fb1111bc089d$export$ff0b30c638ae2396(_ref) {
    var rootPrefixCls = _ref.rootPrefixCls;
    $31d3fb1111bc089d$var$defaultRootPrefixCls = rootPrefixCls;
}





var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $36203fe8ea319954$export$2e2bcd8739ae039() {
    var _React$useState = $acw62.useState([]), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
    var patchElement = $acw62.useCallback(function(element) {
        // append a new element to elements (and create a new ref)
        setElements(function(originElements) {
            return [].concat((0, $kbxxf.default)(originElements), [
                element
            ]);
        });
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return function() {
            setElements(function(originElements) {
                return originElements.filter(function(ele) {
                    return ele !== element;
                });
            });
        };
    }, []);
    return [
        elements,
        patchElement
    ];
}




var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");




var $f743e93ee4f7840b$var$HookModal = function HookModal(_ref, ref) {
    var afterClose = _ref.afterClose, config = _ref.config;
    var _React$useState = $acw62.useState(true), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _React$useState3 = $acw62.useState(config), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), innerConfig = _React$useState4[0], setInnerConfig = _React$useState4[1];
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), direction = _React$useContext.direction, getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('modal');
    var rootPrefixCls = getPrefixCls();
    var close = function close() {
        setOpen(false);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var triggerCancel = args.some(function(param) {
            return param && param.triggerCancel;
        });
        if (innerConfig.onCancel && triggerCancel) innerConfig.onCancel.apply(innerConfig, [
            function() {}
        ].concat((0, $kbxxf.default)(args.slice(1))));
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            destroy: close,
            update: function update(newConfig) {
                setInnerConfig(function(originConfig) {
                    return (0, $8nd05.default)((0, $8nd05.default)({}, originConfig), newConfig);
                });
            }
        };
    });
    return /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), {
        componentName: "Modal",
        defaultLocale: (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Modal
    }, function(contextLocale) {
        return /*#__PURE__*/ $acw62.createElement((0, $e57a817b0bed94b2$export$2e2bcd8739ae039), (0, $8nd05.default)({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls
        }, innerConfig, {
            close: close,
            open: open,
            afterClose: afterClose,
            okText: innerConfig.okText || (innerConfig.okCancel ? contextLocale.okText : contextLocale.justOkText),
            direction: direction,
            cancelText: innerConfig.cancelText || contextLocale.cancelText
        }));
    });
};
var $f743e93ee4f7840b$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f743e93ee4f7840b$var$HookModal);


var $b16aece18eefbd47$var$uuid = 0;
var $b16aece18eefbd47$var$ElementsHolder = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function(_props, ref) {
    var _usePatchElement = (0, $36203fe8ea319954$export$2e2bcd8739ae039)(), _usePatchElement2 = (0, $eUqlC.default)(_usePatchElement, 2), elements = _usePatchElement2[0], patchElement = _usePatchElement2[1];
    $acw62.useImperativeHandle(ref, function() {
        return {
            patchElement: patchElement
        };
    }, []);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, elements);
}));
function $b16aece18eefbd47$export$2e2bcd8739ae039() {
    var holderRef = $acw62.useRef(null);
    // ========================== Effect ==========================
    var _React$useState = $acw62.useState([]), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), actionQueue = _React$useState2[0], setActionQueue = _React$useState2[1];
    $acw62.useEffect(function() {
        if (actionQueue.length) {
            var cloneQueue = (0, $kbxxf.default)(actionQueue);
            cloneQueue.forEach(function(action) {
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    var getConfirmFunc = $acw62.useCallback(function(withFunc) {
        return function hookConfirm(config) {
            var _a;
            $b16aece18eefbd47$var$uuid += 1;
            var modalRef = /*#__PURE__*/ $acw62.createRef();
            var closeFunc;
            var modal = /*#__PURE__*/ $acw62.createElement((0, $f743e93ee4f7840b$export$2e2bcd8739ae039), {
                key: "modal-".concat($b16aece18eefbd47$var$uuid),
                config: withFunc(config),
                ref: modalRef,
                afterClose: function afterClose() {
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            return {
                destroy: function destroy() {
                    function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue(function(prev) {
                        return [].concat((0, $kbxxf.default)(prev), [
                            destroyAction
                        ]);
                    });
                },
                update: function update(newConfig) {
                    function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue(function(prev) {
                        return [].concat((0, $kbxxf.default)(prev), [
                            updateAction
                        ]);
                    });
                }
            };
        };
    }, []);
    var fns = $acw62.useMemo(function() {
        return {
            info: getConfirmFunc((0, $31d3fb1111bc089d$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $31d3fb1111bc089d$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $31d3fb1111bc089d$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $31d3fb1111bc089d$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $31d3fb1111bc089d$export$665b64399d4af99c))
        };
    }, []);
    // eslint-disable-next-line react/jsx-key
    return [
        fns,
        /*#__PURE__*/ $acw62.createElement($b16aece18eefbd47$var$ElementsHolder, {
            ref: holderRef
        })
    ];
}


function $e47cb76d58815cb1$var$modalWarn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$503fa8fed137d104)(props));
}
var $e47cb76d58815cb1$var$Modal = (0, $e567711acbe5f453$export$2e2bcd8739ae039);
$e47cb76d58815cb1$var$Modal.useModal = (0, $b16aece18eefbd47$export$2e2bcd8739ae039);
$e47cb76d58815cb1$var$Modal.info = function infoFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$2f728eab0dacbb2e)(props));
};
$e47cb76d58815cb1$var$Modal.success = function successFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$2b5f8d7f29c805d4)(props));
};
$e47cb76d58815cb1$var$Modal.error = function errorFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$60e9e0884ce12b55)(props));
};
$e47cb76d58815cb1$var$Modal.warning = $e47cb76d58815cb1$var$modalWarn;
$e47cb76d58815cb1$var$Modal.warn = $e47cb76d58815cb1$var$modalWarn;
$e47cb76d58815cb1$var$Modal.confirm = function confirmFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$665b64399d4af99c)(props));
};
$e47cb76d58815cb1$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).length){
        var close = (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$e47cb76d58815cb1$var$Modal.config = (0, $31d3fb1111bc089d$export$ff0b30c638ae2396);
var $e47cb76d58815cb1$export$2e2bcd8739ae039 = $e47cb76d58815cb1$var$Modal;



var $acw62 = parcelRequire("acw62");


function $b5d5d018bfa4ba6e$var$_extends() {
    $b5d5d018bfa4ba6e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b5d5d018bfa4ba6e$var$_extends.apply(this, arguments);
}
const $b5d5d018bfa4ba6e$var$InfoCircleFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $b5d5d018bfa4ba6e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $57a9c466662aed09$export$2e2bcd8739ae039)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $b5d5d018bfa4ba6e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($b5d5d018bfa4ba6e$var$InfoCircleFilled);
var $b5d5d018bfa4ba6e$export$2e2bcd8739ae039 = $b5d5d018bfa4ba6e$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8a1557d9f9123afe$var$PlusCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    },
    "name": "plus-circle",
    "theme": "filled"
};
var $8a1557d9f9123afe$export$2e2bcd8739ae039 = $8a1557d9f9123afe$var$PlusCircleFilled;



function $9e1167a67a71696c$var$_extends() {
    $9e1167a67a71696c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e1167a67a71696c$var$_extends.apply(this, arguments);
}
const $9e1167a67a71696c$var$PlusCircleFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $9e1167a67a71696c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $8a1557d9f9123afe$export$2e2bcd8739ae039)
    }));
/**![plus-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTIgNDcyYzAgNC40LTMuNiA4LTggOEg1NDR2MTUyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFY1NDRIMzI4Yy00LjQgMC04LTMuNi04LTh2LTQ4YzAtNC40IDMuNi04IDgtOGgxNTJWMzI4YzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MTUyaDE1MmM0LjQgMCA4IDMuNiA4IDh2NDh6IiAvPjwvc3ZnPg==) */ const $9e1167a67a71696c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9e1167a67a71696c$var$PlusCircleFilled);
var $9e1167a67a71696c$export$2e2bcd8739ae039 = $9e1167a67a71696c$var$RefIcon;



const $fc69d8460bb1eda3$var$InfoModal = ({ visible: visible, onCancel: onCancel, onOk: onOk, children: children, width: width, height: height, cancelText: cancelText, okText: okText, icon: icon, disabled: disabled, loading: loading })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
        title: "",
        open: visible,
        onCancel: onCancel,
        closable: false,
        onOk: onOk,
        width: width ? width : 1000,
        height: height ? height : 489,
        cancelText: cancelText ? cancelText : 'Nie',
        okText: okText ? okText : 'Tak',
        cancelButtonProps: {
            size: 'large'
        },
        okButtonProps: {
            size: 'large',
            type: 'primary',
            disabled: disabled,
            loading: loading
        },
        children: [
            icon == 'plus' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e1167a67a71696c$export$2e2bcd8739ae039), {
                style: {
                    color: '#1890FF'
                }
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039), {
                style: {
                    color: '#1890FF'
                }
            }),
            children
        ]
    });
};
var $fc69d8460bb1eda3$export$2e2bcd8739ae039 = $fc69d8460bb1eda3$var$InfoModal;



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2dbdfa039f5e9286$var$WarningFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "filled"
};
var $2dbdfa039f5e9286$export$2e2bcd8739ae039 = $2dbdfa039f5e9286$var$WarningFilled;



function $3f0d8fd9f57ea6fb$var$_extends() {
    $3f0d8fd9f57ea6fb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f0d8fd9f57ea6fb$var$_extends.apply(this, arguments);
}
const $3f0d8fd9f57ea6fb$var$WarningFilled = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $3f0d8fd9f57ea6fb$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2dbdfa039f5e9286$export$2e2bcd8739ae039)
    }));
/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1NS43IDg1NmwtNDE2LTcyMGMtNi4yLTEwLjctMTYuOS0xNi0yNy43LTE2cy0yMS42IDUuMy0yNy43IDE2bC00MTYgNzIwQzU2IDg3Ny40IDcxLjQgOTA0IDk2IDkwNGg4MzJjMjQuNiAwIDQwLTI2LjYgMjcuNy00OHpNNDgwIDQxNmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djE4NGMwIDQuNC0zLjYgOC04IDhoLTQ4Yy00LjQgMC04LTMuNi04LThWNDE2em0zMiAzNTJhNDguMDEgNDguMDEgMCAwMTAtOTYgNDguMDEgNDguMDEgMCAwMTAgOTZ6IiAvPjwvc3ZnPg==) */ const $3f0d8fd9f57ea6fb$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($3f0d8fd9f57ea6fb$var$WarningFilled);
var $3f0d8fd9f57ea6fb$export$2e2bcd8739ae039 = $3f0d8fd9f57ea6fb$var$RefIcon;



const $6fd0b816bbe13d58$var$WarningModal = ({ visible: visible, onCancel: onCancel, onOk: onOk, okColor: okColor, children: children, loading: loading, height: height, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
        title: "",
        open: visible,
        // onCancel={onCancel}
        width: 700,
        height: height ? height : 489,
        closable: false,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
            size: 50,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    type: "secondary",
                    size: "large",
                    onClick: onCancel,
                    children: "Nie"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    type: "primary",
                    size: "large",
                    onClick: onOk,
                    loading: loading,
                    style: {
                        backgroundColor: okColor ?? '#f5222d'
                    },
                    disabled: disabled,
                    children: "Tak"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f0d8fd9f57ea6fb$export$2e2bcd8739ae039), {
                style: {
                    color: '#FAAD14'
                }
            }),
            children
        ]
    });
};
var $6fd0b816bbe13d58$export$2e2bcd8739ae039 = $6fd0b816bbe13d58$var$WarningModal;




var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");
const $36a81de199cd8a95$var$DateModal = ({ visible: visible, onCancel: onCancel, onOk: onOk, loading: loading, deadline: deadline })=>{
    const [date, setDate] = (0, $acw62.useState)();
    const [time, setTime] = (0, $acw62.useState)();
    const approve = async ()=>{
        const d = date?.clone();
        if (d) {
            if (!time) {
                d.hours(0);
                d.minutes(0);
            } else {
                d.hours(time.get('hour'));
                d.minutes(time.get('minute'));
            }
            d.seconds(0);
        }
        const success = await onOk(d ?? null);
        if (success) {
            setDate();
            setTime();
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fc69d8460bb1eda3$export$2e2bcd8739ae039), {
        visible: visible,
        closable: false,
        cancelText: "Anuluj",
        okText: "Edytuj",
        onCancel: onCancel,
        onOk: approve,
        disabled: date === undefined,
        loading: loading,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Edytuj dat\u0119?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "input",
                children: [
                    date !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Data:",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 20,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                        size: "large",
                                        placeholder: "Wybierz dat\u0119",
                                        value: date,
                                        onChange: setDate
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                        size: "large",
                                        format: "HH:mm",
                                        placeholder: "Wybierz godzin\u0119",
                                        value: time,
                                        onChange: setTime
                                    })
                                ]
                            })
                        ]
                    }),
                    !deadline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                        checked: date === null,
                        onChange: (e)=>setDate(e.target.checked ? null : (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))()),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            onClick: ()=>setDate(date === null ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))() : null),
                            children: "Bez terminu odbioru"
                        })
                    })
                ]
            })
        ]
    });
};
var $36a81de199cd8a95$export$2e2bcd8739ae039 = $36a81de199cd8a95$var$DateModal;





var $acw62 = parcelRequire("acw62");



function $7fc92eee42f07c5c$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [user, setUser] = (0, $acw62.useState)();
    const [changes, setChanges] = (0, $acw62.useState)({});
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [resetting, setResetting] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [password, setPassword] = (0, $acw62.useState)('');
    const [timeline, setTimeline] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            try {
                setChanges();
                const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(id);
                setTimeline(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.history(id, 30));
                setUser({
                    ...result,
                    created_by: await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(result.created_by),
                    removed_by: result.removed_by ? await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(result.removed_by) : {}
                });
            } catch (e) {
                if (e === 3) navigate('/404', {
                    replace: true
                });
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
                console.trace(e);
            }
        };
        fetch();
    }, [
        id
    ]);
    const checkChanges = ()=>{
        const diff = {
            ...changes
        };
        Object.entries(diff).forEach(([key, value])=>{
            if (value === user[key]) delete diff[key];
        });
        return Object.keys(diff).length === 0;
    };
    const saveChanges = async ()=>{
        try {
            setSaving(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.patch(id, changes);
            setSaving(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zapisano zmiany');
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setSaving(false);
            console.trace(e);
        }
    };
    const resetPassword = async (close)=>{
        try {
            setResetting(true);
            const { password: password } = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.patch(id, {
                password: null
            });
            setPassword(password);
            close();
            setResetting(false);
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setResetting(false);
            console.trace(e);
        }
    };
    const deleteUser = async (close)=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.delete(id);
            close();
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Usuni\u0119to u\u017Cytkownika");
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const restoreUser = async ()=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.patch(id, {
                removed: null
            });
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Przywr\xf3cono u\u017Cytkownika");
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading(false);
            console.trace(e);
        }
    };
    return [
        {
            user: user,
            removed: user?.removed !== null,
            saving: saving,
            resetting: resetting,
            loading: loading,
            password: password,
            timeline: timeline,
            saveDisabled: checkChanges(),
            deleteDisabled: id === sessionStorage.getItem('id')
        },
        {
            userNameChanged: (e)=>setChanges({
                    ...changes,
                    name: e.target.value
                }),
            userSurnameChanged: (e)=>setChanges({
                    ...changes,
                    surname: e.target.value
                }),
            userLevelChanged: (e)=>setChanges({
                    ...changes,
                    level: e.value
                }),
            typeChanged: (e)=>setChanges({
                    ...changes,
                    type: e.target.value
                }),
            saveChanges: saveChanges,
            resetPassword: resetPassword,
            deleteUser: deleteUser,
            restoreUser: restoreUser
        }
    ];
}



var $acw62 = parcelRequire("acw62");



function $5255c5ca5eb3b7e0$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [user, setUser] = (0, $acw62.useState)({
        level: 0,
        type: 'Kierowca'
    });
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const disabled = !user.username || !user.name || !user.surname || !user.type;
    const generatePassword = ()=>{
        const array = new Uint32Array(8);
        let password = '';
        do {
            window.crypto.getRandomValues(array);
            password += btoa(array).replace(/[\=\-\+\/]/g, '');
        }while (password.length < 10);
        return password.substr(0, 10);
    };
    (0, $acw62.useEffect)(()=>{
        if (location.pathname !== '/panel/new-driver') return;
        setUser({
            ...user,
            password: generatePassword()
        });
    }, [
        location.pathname
    ]);
    const createUser = async ()=>{
        if (disabled) return setError('Podaj wszystkie dane');
        try {
            setLoading(true);
            const u = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.create(user);
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Stworzono u\u017Cytkownika");
            navigate(`/panel/drivers/${u.id}`, {
                replace: true
            });
        } catch (e) {
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    return [
        {
            user: user,
            disabled: disabled,
            loading: loading
        },
        {
            usernameChanged: (e)=>setUser({
                    ...user,
                    username: e.target.value
                }),
            nameChanged: (e)=>setUser({
                    ...user,
                    name: e.target.value
                }),
            typeChanged: (e)=>setUser({
                    ...user,
                    type: e.target.value
                }),
            surnameChanged: (e)=>setUser({
                    ...user,
                    surname: e.target.value
                }),
            adminChecked: (e)=>setUser({
                    ...user,
                    level: e.target.checked ? 1 : 0
                }),
            superadminChecked: (e)=>setUser({
                    ...user,
                    level: e.target.checked ? 2 : 1
                }),
            createUser: createUser
        }
    ];
}



var $acw62 = parcelRequire("acw62");




function $696f261154e92a27$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const visible = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search).visible === '1';
    const [data, setData] = (0, $acw62.useState)();
    const [filtered, setFiltered] = (0, $acw62.useState)();
    const [filters, setFilters] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            try {
                const data = (await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.getAll(true)).map((user, i, users)=>({
                        ...user,
                        key: user.id,
                        created_by: users.filter((u)=>user.created_by === u.id)[0],
                        removed_by: user.removed_by && users.filter((u)=>user.removed_by === u.id)[0]
                    })).sort((a, b)=>new Date(b.removed || b.created) - new Date(a.removed || a.created));
                setData(data);
            } catch (e) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
                console.error(e);
            }
        };
        fetch();
    }, [
        location.pathname
    ]);
    (0, $acw62.useEffect)(()=>{
        setFiltered(data?.filter((u)=>{
            if (filters.search) {
                if (!`${u.name} ${u.surname}`.toLowerCase().includes(filters.search.toLowerCase())) return false;
            }
            if (filters.level != undefined && u.level !== filters.level) return false;
            return true;
        }));
    }, [
        data,
        filters
    ]);
    const removeUser = async (id)=>{
        try {
            setLoading(id);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.delete(id);
            const user = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(id, 1);
            user.key = id;
            user.created_by = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(user.created_by);
            user.removed_by = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(user.removed_by);
            setLoading();
            setData((data)=>[
                    ...data.filter((e)=>e.id !== id),
                    user
                ].sort((a, b)=>new Date(b.removed || b.created) - new Date(a.removed || a.created)));
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Usuni\u0119to u\u017Cytkownika");
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
            console.trace(e);
        }
    };
    const restoreUser = async (id)=>{
        try {
            setLoading(id);
            const user = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.patch(id, {
                removed: null
            });
            user.key = id;
            user.created_by = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(user.created_by);
            setLoading();
            setData((data)=>[
                    ...data.filter((e)=>e.id !== id),
                    user
                ].sort((a, b)=>new Date(b.removed || b.created) - new Date(a.removed || a.created)));
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Przywr\xf3cono u\u017Cytkownika");
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
            console.trace(e);
        }
    };
    return [
        {
            data: visible ? filtered : filtered?.filter((e)=>e.removed === null),
            visible: visible,
            filters: filters,
            loading: loading
        },
        {
            toggleVisible: ()=>navigate(`?visible=${visible ? 0 : 1}`, {
                    replace: true
                }),
            removeUser: removeUser,
            restoreUser: restoreUser,
            searchChanged: (e)=>setFilters({
                    ...filters,
                    search: e.target.value
                }),
            levelChanged: (v)=>setFilters({
                    ...filters,
                    level: v
                }),
            clearFilters: ()=>setFilters({})
        }
    ];
}



var $acw62 = parcelRequire("acw62");




function $048b27f6d6ad34a1$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [data, setData] = (0, $acw62.useState)();
    const [sizes, setSizes] = (0, $acw62.useState)();
    const [filters, setFilters] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)();
    const visible = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search).visible === '1';
    const admin = window.sessionStorage.getItem('level') > 0;
    const fetch = async ()=>{
        try {
            const sizes = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll();
            setSizes(sizes);
            const data = (await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.getAll(true)).map((container, i)=>({
                    ...container,
                    key: i,
                    size: sizes.filter((e)=>e.id === container.size)[0]
                })).sort((a, b)=>new Date(b.changed) - new Date(a.changed));
            setData(data);
        } catch (e) {
            console.error(e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const deleteContainer = async (id)=>{
        try {
            setLoading(id);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.delete(id);
            await fetch();
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Usuni\u0119to kontener");
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
            console.trace(e);
        }
    };
    const restoreContainer = async (id)=>{
        try {
            setLoading(id);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.patch(id, {
                state: 0
            });
            await fetch();
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Przywr\xf3cono kontener");
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
            console.trace(e);
        }
    };
    const filtered = (0, $acw62.useMemo)(()=>{
        if (!data) return;
        return data.filter((c)=>{
            if (!visible && c.state.state === 6) return false;
            if (filters.search) {
                if (!`${c.name}`.toLowerCase().includes(filters.search.toLowerCase())) {
                    if (!`${c.type}`.toLowerCase().includes(filters.search.toLowerCase())) {
                        if (!`${c.order?.client?.name}`.toLowerCase().includes(filters.search.toLowerCase())) return false;
                    }
                }
            }
            if (filters.size != undefined && c.size.id !== filters.size) return false;
            if (filters.state != undefined && c.state.state !== filters.state) return false;
            return true;
        });
    }, [
        data,
        filters,
        visible
    ]);
    return [
        {
            sizes: sizes,
            data: filtered,
            visible: visible,
            filters: filters,
            loading: loading,
            admin: admin
        },
        {
            toggleVisible: ()=>navigate(`?visible=${visible ? 0 : 1}`, {
                    replace: true
                }),
            deleteContainer: deleteContainer,
            restoreContainer: restoreContainer,
            searchChanged: (e)=>setFilters({
                    ...filters,
                    search: e.target.value
                }),
            sizeChanged: (v)=>setFilters({
                    ...filters,
                    size: v
                }),
            stateChanged: (v)=>setFilters({
                    ...filters,
                    state: v
                }),
            clearFilters: ()=>setFilters({})
        }
    ];
}



var $acw62 = parcelRequire("acw62");



function $f96a0f0e61d6aad7$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [container, setContainer] = (0, $acw62.useState)({});
    const [sizes, setSizes] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [adding, setAdding] = (0, $acw62.useState)(false);
    const disabled = !container.name || !container.size;
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll();
            setSizes(result);
        };
        fetch();
    }, []);
    const createContainer = async ()=>{
        if (disabled) return setError('Podaj wszystkie dane');
        try {
            setLoading(true);
            const c = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.create(container);
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Utworzono kontener');
            navigate(`/panel/containers/${c.id}`, {
                replace: true
            });
        } catch (e) {
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const addContainerSize = async (size)=>{
        try {
            setAdding(true);
            const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.create(size);
            setSizes([
                ...sizes,
                result
            ]);
            setContainer({
                ...container,
                size: result.id
            });
            setAdding(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Dodano rozmiar');
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setAdding(false);
            console.trace(e);
        }
    };
    return [
        {
            container: container,
            disabled: disabled,
            loading: loading,
            sizes: sizes,
            adding: adding
        },
        {
            nameChanged: (e)=>setContainer({
                    ...container,
                    name: e.target.value
                }),
            sizeChanged: (value)=>setContainer({
                    ...container,
                    size: value
                }),
            typeChanged: (e)=>setContainer({
                    ...container,
                    type: e.target.value
                }),
            createContainer: createContainer,
            addContainerSize: addContainerSize
        }
    ];
}



var $acw62 = parcelRequire("acw62");



function $033c8b8bdf6243a5$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [container, setContainer] = (0, $acw62.useState)();
    const [sizes, setSizes] = (0, $acw62.useState)();
    const [changes, setChanges] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [lend, setLend] = (0, $acw62.useState)({});
    const [lending, setLending] = (0, $acw62.useState)(false);
    const [adding, setAdding] = (0, $acw62.useState)(false);
    const [timeline, setTimeline] = (0, $acw62.useState)();
    const admin = window.sessionStorage.getItem('level') > 0;
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            try {
                setChanges();
                const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.get(id);
                const sizes = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll();
                setSizes(sizes);
                setTimeline(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.history(id, 30));
                setContainer({
                    ...result,
                    size: sizes.filter((s)=>s.id === result.size)[0],
                    changed_by: admin && await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(result.added_by),
                    added_by: admin && await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(result.added_by)
                });
            } catch (e) {
                console.trace(e);
            }
        };
        fetch();
    }, [
        id
    ]);
    const checkChanges = ()=>{
        const diff = {
            ...changes
        };
        Object.entries(diff).forEach(([key, value])=>{
            if (value === container[key]) delete diff[key];
        });
        return Object.keys(diff).length === 0;
    };
    const saveChanges = async ()=>{
        try {
            setSaving(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.patch(id, {
                name: changes.name,
                size: changes.size,
                type: changes.type
            });
            setSaving(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zapisano zmiany');
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setSaving(false);
            console.trace(e);
        }
    };
    const deleteContainer = async (close)=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.delete(id);
            close();
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Usuni\u0119to kontener");
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const restoreContainer = async ()=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.patch(id, {
                state: 0
            });
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Przywr\xf3cono kontener");
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading(false);
            console.trace(e);
        }
    };
    const lendContainer = async ()=>{
        if (lend.postal && !lend.postal.match(/^[0-9]{2}\-[0-9]{3}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Kod pocztowy niepoprawny');
        try {
            setLending(true);
            const lendDiff = {
                ...lend
            };
            Object.entries(lendDiff).forEach(([key, value])=>{
                if (!value) delete lendDiff[key];
            });
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.patch(id, {
                state: 5,
                lend: lendDiff
            });
            setLending(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Wypo\u017Cyczono kontener");
            setLend({});
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLending(false);
            console.trace(e);
        }
    };
    const unlendContainer = async ()=>{
        try {
            setLending(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.patch(id, {
                state: 0
            });
            setLending(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Wr\xf3cono kontener");
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLending(false);
            console.trace(e);
        }
    };
    const addContainerSize = async (size)=>{
        try {
            setAdding(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.create(size);
            setAdding(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Dodano rozmiar');
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setAdding(false);
            console.trace(e);
        }
    };
    return [
        {
            container: container,
            sizes: sizes,
            timeline: timeline,
            saveDisabled: checkChanges(),
            removed: false,
            loading: loading,
            saving: saving,
            lending: lending,
            adding: adding,
            canLend: lend.name,
            deleteDisabled: container?.state !== 0
        },
        {
            numberChanged: (e)=>setChanges({
                    ...changes,
                    name: e.target.value
                }),
            typeChanged: (e)=>setChanges({
                    ...changes,
                    type: e.target.value
                }),
            sizeChanged: (value)=>setChanges({
                    ...changes,
                    size: value
                }),
            nameChanged: (e)=>setLend({
                    ...lend,
                    name: e.target.value
                }),
            streetChanged: (e)=>setLend({
                    ...lend,
                    street: e.target.value
                }),
            postalChanged: (e)=>setLend({
                    ...lend,
                    postal: e.target.value
                }),
            cityChanged: (e)=>setLend({
                    ...lend,
                    city: e.target.value
                }),
            saveChanges: saveChanges,
            deleteContainer: deleteContainer,
            restoreContainer: restoreContainer,
            lendContainer: lendContainer,
            unlendContainer: unlendContainer,
            addContainerSize: addContainerSize
        }
    ];
}



var $acw62 = parcelRequire("acw62");




function $17d2d17574419c34$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [client, setClient] = (0, $acw62.useState)();
    const [orders, setOrders] = (0, $acw62.useState)();
    const [changes, setChanges] = (0, $acw62.useState)({});
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const { unpaid: unpaid = '0', address: rawAddress } = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search);
    const address = (0, $acw62.useMemo)(()=>{
        if (!rawAddress) return null;
        if (rawAddress == 'null') return null;
        return decodeURIComponent(rawAddress);
    });
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, [
        id
    ]);
    const fetch = async ()=>{
        try {
            setChanges();
            const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.get(id);
            setClient({
                ...result,
                created_by: await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(result.created_by),
                removed_by: result.removed_by ? await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(result.removed_by) : {}
            });
            setOrders(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.getAll({
                client_id: id
            }));
        } catch (e) {
            if (e === 3) navigate('/404', {
                replace: true
            });
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const checkChanges = ()=>{
        const diff = {
            ...changes
        };
        Object.entries(diff).forEach(([key, value])=>{
            if (value === client[key]) delete diff[key];
        });
        return Object.keys(diff).length === 0;
    };
    const saveChanges = async ()=>{
        if (changes.name === '') return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Podaj nazw\u0119");
        if (changes.phone === '') return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Podaj telefon');
        if (changes.phone && !changes.phone.match(/^(\+[0-9]{2} ?)?([0-9] ?){9}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Telefon jest niepoprawny');
        if (changes.email && !(0, $d0d47524147cc5b7$export$2e2bcd8739ae039)(changes.email)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Email jest niepoprawny');
        // if (changes.nip && !isNip(changes.nip)) return message.error('NIP jest niepoprawny');
        if (changes.bdo?.length > 14) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("BDO jest za d\u0142ugi");
        try {
            setSaving(true);
            changes.type && (changes.type = changes.type.value);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.patch(id, changes);
            setSaving(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zapisano zmiany');
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setSaving(false);
            console.trace(e);
        }
    };
    const deleteClient = async (close)=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.delete(id);
            close();
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Usuni\u0119to klienta");
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            setLoading(false);
            close();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const restoreClient = async ()=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.patch(id, {
                removed: null
            });
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Przywr\xf3cono klienta");
            navigate(`${id}`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading(false);
            console.trace(e);
        }
    };
    const payOrder = async (id)=>{
        if (loading) return;
        try {
            setLoading('paid');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                payment: 1
            });
            await fetch();
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Oznaczono jako zap\u0142acone");
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const filtered = (0, $acw62.useMemo)(()=>{
        if (!orders) return;
        const o = orders.sort((a, b)=>new Date(b.claiming_done ?? b.delivery_date) - new Date(a.claiming_done ?? a.delivery_date));
        const searchAddress = address?.trim().toLowerCase();
        return o.filter((order)=>{
            if (unpaid !== '0' && order.payment) // We want only unpaid orders.
            return false;
            if (searchAddress) {
                const orderAddress = order.address.trim().toLowerCase();
                if (orderAddress !== searchAddress) return false;
            }
            return true;
        });
    }, [
        orders,
        unpaid,
        address
    ]);
    const addresses = (0, $acw62.useMemo)(()=>{
        if (!orders) return [];
        const addresses = {};
        for (const order of orders){
            const key = order.address.trim().toLowerCase();
            if (addresses[key]) continue;
            addresses[key] = order.address;
        }
        return [
            ...Object.values(addresses)
        ];
    }, [
        orders
    ]);
    const onAddressChange = (address)=>{
        const query = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).encode({
            unpaid: unpaid,
            address: address
        });
        navigate(`?${query}`, {
            replace: true
        });
    };
    return [
        {
            client: client,
            orders: orders,
            address: address,
            addresses: addresses,
            timeline: filtered,
            unpaid: unpaid,
            removed: client?.removed !== null,
            saveDisabled: checkChanges(),
            saving: saving,
            loading: loading
        },
        {
            onAddressChange: onAddressChange,
            nameChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        name: e.target.value
                    })),
            phoneChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        phone: e.target.value
                    })),
            typeChanged: (value)=>setChanges((changes)=>({
                        ...changes,
                        type: value
                    })),
            emailChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        email: e.target.value
                    })),
            nipChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        nip: e.target.value
                    })),
            bdoChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        bdo: e.target.value
                    })),
            streetChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        street: e.target.value
                    })),
            cityChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        city: e.target.value
                    })),
            postalChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        postal: e.target.value
                    })),
            descriptionChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        description: e.target.value
                    })),
            saveChanges: saveChanges,
            deleteClient: deleteClient,
            restoreClient: restoreClient,
            toggleUnpaid: ()=>navigate(`?unpaid=${unpaid === '0' ? '1' : '0'}`, {
                    replace: true
                }),
            payOrder: payOrder
        }
    ];
}



var $acw62 = parcelRequire("acw62");



const $528eec0198c20a54$var$resolvers = {};
const $528eec0198c20a54$var$setPopResult = (state, value)=>{
    const intentId = state?.intentId;
    const resolver = intentId && $528eec0198c20a54$var$resolvers[intentId];
    if (!resolver) return;
    resolver(value);
};
const $528eec0198c20a54$export$4762a55173472f42 = (navigate, to)=>{
    const intentId = Math.random().toString(36).substring(2, 15);
    navigate(to, {
        state: {
            intentId: intentId
        }
    });
    return new Promise((resolve)=>$528eec0198c20a54$var$resolvers[intentId] = resolve);
};
const $528eec0198c20a54$export$a5372e7ccf584641 = (navigate, state, value)=>{
    $528eec0198c20a54$var$setPopResult(state, value);
    navigate(-1);
};



function $dbdcaac76c7accfa$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [client, setClient] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const disabled = !client.name?.trim() || client.type == undefined || !client.phone?.trim();
    const state = location.state;
    const intent = state !== null;
    const createClient = async ()=>{
        if (disabled) return;
        if (!client.phone.match(/^(\+[0-9]{2} ?)?([0-9] ?){9}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Telefon jest niepoprawny');
        if (client.email && !(0, $d0d47524147cc5b7$export$2e2bcd8739ae039)(client.email)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Email jest niepoprawny');
        // if (client.nip && !isNip(client.nip)) return message.error('NIP jest niepoprawny');
        if (client.bdo?.length > 14) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("BDO jest za d\u0142ugi");
        if (!client.email) delete client.email;
        if (!client.nip) delete client.nip;
        if (!client.bdo) delete client.bdo;
        if (!client.street) delete client.street;
        if (!client.city) delete client.city;
        if (!client.postal) delete client.postal;
        if (!client.description) delete client.description;
        try {
            setLoading(true);
            const c = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.create(client);
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Stworzono klienta');
            if (intent) (0, $528eec0198c20a54$export$a5372e7ccf584641)(navigate, location.state, c);
            else navigate(`/panel/clients/${c.id}`, {
                replace: true
            });
        } catch (e) {
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    return [
        {
            client: client,
            disabled: disabled,
            loading: loading,
            intent: intent
        },
        {
            nameChanged: (e)=>setClient((client)=>({
                        ...client,
                        name: e.target.value
                    })),
            phoneChanged: (e)=>setClient((client)=>({
                        ...client,
                        phone: e.target.value
                    })),
            typeChanged: (value)=>setClient((client)=>({
                        ...client,
                        type: value.value
                    })),
            emailChanged: (e)=>setClient((client)=>({
                        ...client,
                        email: e.target.value
                    })),
            nipChanged: (e)=>setClient((client)=>({
                        ...client,
                        nip: e.target.value
                    })),
            bdoChanged: (e)=>setClient((client)=>({
                        ...client,
                        bdo: e.target.value
                    })),
            streetChanged: (e)=>setClient((client)=>({
                        ...client,
                        street: e.target.value
                    })),
            cityChanged: (e)=>setClient((client)=>({
                        ...client,
                        city: e.target.value
                    })),
            postalChanged: (e)=>setClient((client)=>({
                        ...client,
                        postal: e.target.value
                    })),
            descriptionChanged: (e)=>setClient((client)=>({
                        ...client,
                        description: e.target.value
                    })),
            createClient: createClient
        }
    ];
}



var $acw62 = parcelRequire("acw62");





var $45fvw = parcelRequire("45fvw");
function $cbe377727b462555$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const query = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search);
    const visible = query.visible === '1';
    const advances = query.advances === '1';
    const admin = window.sessionStorage.getItem('level') > 0;
    const [user, setUser] = (0, $acw62.useState)();
    const [data, setData] = (0, $acw62.useState)();
    const [filters, setFilters] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)();
    const [month, setMonth] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))());
    const fetch = async ()=>{
        try {
            const filters = {
                after: Math.min(month.startOf('month').unix() * 1000, Date.now()),
                before: Math.max(month.endOf('month').unix() * 1000, 0),
                company: admin ? 1 : undefined
            };
            if (admin) {
                const userId = window.sessionStorage.getItem('id');
                if (!userId) throw "B\u0142\u0105d";
                setUser(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(userId));
            }
            if (!visible) filters.user_id = window.sessionStorage.getItem('id');
            const users = admin && await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.getAll();
            const data = (await (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.getAll(filters)).map((expense)=>({
                    ...expense,
                    key: `0-${expense.id}`,
                    settled_by: admin && expense.settled && users.filter((u)=>expense.settled_by === u.id)[0],
                    created_by: admin && users.filter((u)=>expense.user_id === u.id)[0],
                    _type: 0
                }));
            const settlements = (await (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.settlements.getAll(filters)).map((settlement)=>({
                    ...settlement,
                    key: `1-${settlement.id}`,
                    created_by: admin && users.filter((u)=>settlement.user_id === u.id)[0],
                    _type: 1
                }));
            const advs = advances ? (await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.getAll({
                ...filters,
                advances: 1
            })).filter((order)=>order.advance).map((order)=>({
                    ...order,
                    key: `2-${order.id}`,
                    value: order.advance,
                    created: order.delivery_done,
                    created_by: admin && users.filter((u)=>order.delivery_by?.id === u.id)[0],
                    _type: 2
                })) : [];
            setData([
                ...data,
                ...settlements,
                ...advs
            ]);
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (id !== undefined) setFilters({
            id: id
        });
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, [
        location.pathname,
        visible,
        advances,
        month
    ]);
    const getValue = (element)=>{
        switch(element._type){
            // Expenses
            case 0:
                return -element.value;
            // Settlements
            case 1:
                return -element.value;
            // Advances
            case 2:
                return element.value;
        }
    };
    const filtered = (0, $acw62.useMemo)(()=>{
        if (!data) return;
        return data.filter((exp)=>{
            if (!isNaN(filters.id)) return parseInt(filters.id) === exp.id;
            if (filters.search) {
                if (`${exp.name ?? 'Tankowanie'}`.toLowerCase().includes(filters.search.toLowerCase())) ;
                else if (`${exp.invoice}`.toLowerCase().includes(filters.search.toLowerCase())) ;
                else return false;
            }
            if (filters.car) {
                if (!`${exp.car}`.toLowerCase().includes(filters.car.toLowerCase())) return false;
            }
            if (filters.settled !== undefined) {
                if (filters.settled === 1 && exp.settled) return false;
                if (filters.settled === 0 && !exp.settled) return false;
            }
            return true;
        });
    }, [
        data,
        filters
    ]);
    const settle = async (id)=>{
        if (loading) return;
        try {
            setLoading(id);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.settle(id);
            await fetch();
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Rozliczono wydatek');
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    return [
        {
            user: user,
            data: filtered,
            filters: filters,
            visible: visible,
            advances: advances,
            admin: admin,
            loading: loading,
            month: month
        },
        {
            toggleVisible: ()=>navigate(`?visible=${visible ? 0 : 1}&advances=${advances ? 1 : 0}`, {
                    replace: true
                }),
            toggleAdvances: ()=>navigate(`?visible=${visible ? 1 : 0}&advances=${advances ? 0 : 1}`, {
                    replace: true
                }),
            searchChanged: (e)=>setFilters({
                    ...filters,
                    search: e.target.value
                }),
            carChanged: (e)=>setFilters({
                    ...filters,
                    car: e.target.value
                }),
            settledChanged: (value)=>setFilters({
                    ...filters,
                    settled: value
                }),
            clearFilters: ()=>{
                if (!isNaN(filters.id)) navigate('/panel/expenses', {
                    replace: true
                });
                setFilters({});
            },
            settle: settle,
            setMonth: setMonth
        }
    ];
}



var $acw62 = parcelRequire("acw62");





var $45fvw = parcelRequire("45fvw");
function $4f72e13be9124676$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { company: company } = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search);
    const [expense, setExpense] = (0, $acw62.useState)({
        date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(),
        company: company
    });
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [types, setTypes] = (0, $acw62.useState)();
    const [type, setType] = (0, $acw62.useState)();
    const type_id = (0, $acw62.useMemo)(()=>{
        if (!isNaN(expense.type_id)) return expense.type_id;
        return types?.find((t)=>t.name === type)?.id;
    }, [
        expense,
        types,
        type
    ]);
    const isFuelExpense = type_id == 5;
    const disabled = (0, $acw62.useMemo)(()=>{
        if (!expense.type_id && !type) return true;
        if (!expense.date) return true;
        if (!expense.value?.trim()) return true;
        if (isNaN(expense.value_type)) return true;
        if (isNaN(expense.tax)) return true;
        if (isFuelExpense) {
            if (!expense.car?.trim()) return true;
            if (!expense.mileage?.trim()) return true;
            if (isNaN(expense.mileage)) return true;
            if (!expense.fuel_liters) return true;
            if (isNaN(expense.fuel_liters)) return true;
        }
        return false;
    }, [
        expense,
        type
    ]);
    const fetch = async ()=>{
        setTypes(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.expenseTypes.getAll());
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const createExpense = async ()=>{
        if (disabled) return;
        try {
            setLoading(true);
            const e = {
                ...expense
            };
            let t = types.filter((t)=>t.name === type)[0];
            if (!t) t = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.expenseTypes.put(type);
            e.type_id = t.id;
            e.date = e.date.unix() * 1000;
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.create(e);
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Stworzono wydatek');
            navigate(-1);
        } catch (e) {
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    return [
        {
            expense: expense,
            isFuelExpense: isFuelExpense,
            disabled: disabled,
            loading: loading,
            types: types,
            type: type,
            admin: window.sessionStorage.getItem('level') > 0,
            superAdmin: window.sessionStorage.getItem('level') > 1
        },
        {
            nameChanged: (e)=>setExpense((expense)=>({
                        ...expense,
                        name: e.target.value
                    })),
            typeChanged: (value)=>setExpense((expense)=>({
                        ...expense,
                        type: value
                    })),
            typeChanged: (value)=>setType(value),
            carChanged: (e)=>setExpense((expense)=>({
                        ...expense,
                        car: e.target.value
                    })),
            mileageChanged: (e)=>setExpense((expense)=>({
                        ...expense,
                        mileage: e.target.value
                    })),
            fuelLitersChanged: (e)=>setExpense((expense)=>({
                        ...expense,
                        fuel_liters: e.target.value
                    })),
            valueChanged: (e)=>setExpense((expense)=>({
                        ...expense,
                        value: e.target.value
                    })),
            dateChanged: (date)=>setExpense((expense)=>({
                        ...expense,
                        date: date
                    })),
            valueTypeChanged: (value_type)=>setExpense((expense)=>({
                        ...expense,
                        value_type: value_type
                    })),
            taxChanged: (tax)=>setExpense((expense)=>({
                        ...expense,
                        tax: tax
                    })),
            invoiceChanged: (e)=>setExpense((expense)=>({
                        ...expense,
                        invoice: e.target.value
                    })),
            companyChanged: (e)=>setExpense((expense)=>({
                        ...expense,
                        company: e.target.checked
                    })),
            createExpense: createExpense
        }
    ];
}



var $acw62 = parcelRequire("acw62");



function $c3e65aa1149dbf67$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [settlement, setSettlement] = (0, $acw62.useState)({});
    const [drivers, setDrivers] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const disabled = isNaN(settlement.user_id) || !settlement.value?.trim();
    const fetch = async ()=>{
        try {
            setDrivers((await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.getAll()).filter((d)=>!d.removed));
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const createSettlement = async ()=>{
        if (disabled) return;
        try {
            setLoading(true);
            settlement.value.replace(/\,/g, '.');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.settlements.create(settlement);
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Pobrano got\xf3wk\u0119");
            navigate(`/panel/expenses`, {
                replace: true
            });
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
            setLoading();
        }
    };
    const driver = (0, $acw62.useMemo)(()=>drivers?.filter((d)=>d.id === settlement.user_id)[0], [
        settlement.user_id
    ]);
    return [
        {
            drivers: drivers,
            disabled: disabled,
            loading: loading,
            driver: driver
        },
        {
            driverChanged: (value)=>setSettlement({
                    ...settlement,
                    user_id: drivers.filter((d)=>value === `${d.name} ${d.surname}`)[0]?.id
                }),
            valueChanged: (e)=>setSettlement({
                    ...settlement,
                    value: e.target.value
                }),
            createSettlement: createSettlement
        }
    ];
}



var $acw62 = parcelRequire("acw62");



function $fad51db97ae8fa5d$export$2e2bcd8739ae039() {
    const { id: id, type: type } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [order, setOrder] = (0, $acw62.useState)();
    const [previousOrder, setPreviousOrder] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const [drivers, setDrivers] = (0, $acw62.useState)();
    const [assignee, setAssignee] = (0, $acw62.useState)();
    const admin = window.sessionStorage.getItem('level') > 0;
    const fetch = async ()=>{
        try {
            const order = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(id);
            if (order.related_id) {
                order.related = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(order.related_id);
                if (order.related_id > order.id) setPreviousOrder(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.getByRelatedId(order.id).then((res)=>res[0]));
                else setPreviousOrder(order.related);
            }
            switch(type){
                case '0':
                case '1':
                    order.date = order.delivery_date;
                    order.taken = order.delivery_taken;
                    order.taken_by = order.delivery_by;
                    order.done = order.delivery_done;
                    break;
                case '2':
                    order.date = order.claiming_date;
                    order.taken = order.claiming_taken;
                    order.taken_by = order.claiming_by;
                    order.done = order.claiming_done;
                    break;
            }
            admin && setDrivers((await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.getAll()).filter((d)=>!d.removed));
            setOrder(order);
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
            console.trace(e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        id && !isNaN(type) && fetch();
    }, [
        id,
        type
    ]);
    const takeTask = async ()=>{
        if (loading) return;
        try {
            setLoading('taking');
            // TODO(Hexagonale): Take replacement
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                claiming_taken: 1
            });
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zg\u0142oszono do realizacji");
            setLoading();
        } catch (e) {
            setLoading();
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const assignTask = async ()=>{
        if (loading) return;
        try {
            setLoading('assign');
            if (type === '0') // Delivery
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                delivery_by: assignee
            });
            else if (type === '1') {
                // Replacement
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(order.related_id, {
                    delivery_by: assignee
                });
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                    claiming_by: assignee
                });
            } else if (type === '2') // Claiming
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                claiming_by: assignee
            });
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Przypisano zadanie');
            setLoading();
        } catch (e) {
            setLoading();
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const unassignTask = async ()=>{
        if (loading) return;
        try {
            setLoading('unassign');
            if (type === '0') // Delivery
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                delivery_taken: 0
            });
            else if (type === '1') {
                // Replacement
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(order.related_id, {
                    claiming_taken: 0
                });
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                    delivery_taken: 0
                });
            } else if (type === '2') // Claiming
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                claiming_taken: 0
            });
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zg\u0142oszono do realizacji");
            setLoading();
        } catch (e) {
            setLoading();
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    return [
        {
            order: order,
            previousOrder: previousOrder,
            type: type,
            admin: admin,
            loading: loading,
            drivers: drivers,
            assignee: assignee
        },
        {
            takeTask: takeTask,
            assigneeChanged: setAssignee,
            assignTask: assignTask,
            unassignTask: unassignTask
        }
    ];
}




var $acw62 = parcelRequire("acw62");


function $ec06c438df5fe127$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [id, setId] = (0, $acw62.useState)();
    const [type, setType] = (0, $acw62.useState)();
    const [order, setOrder] = (0, $acw62.useState)();
    const [orders, setOrders] = (0, $acw62.useState)();
    const [paid, setPaid] = (0, $acw62.useState)();
    const [ordersPaid, setOrdersPaid] = (0, $acw62.useState)([]);
    const [paymentDone, setPaymentDone] = (0, $acw62.useState)();
    const [advance, setAdvance] = (0, $acw62.useState)();
    const [wz, setWz] = (0, $acw62.useState)();
    const [signName, setSignName] = (0, $acw62.useState)();
    const [signSurname, setSignSurname] = (0, $acw62.useState)();
    const [signDocument, setSignDocument] = (0, $acw62.useState)();
    const [sign, setSign] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            const order = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(id);
            if (order.related_id !== null && order.id > order.related_id) order.related = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(order.related_id);
            setOrder(order);
            const orders = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.getAll({
                client_id: order.client.id
            });
            setOrders(orders.filter((o)=>{
                // Same order
                if (o.id === order.id) return false;
                // Replacement
                if (type === 1 && order.related_id === o.id) return false;
                // Paid or not cash
                if (o.payment || o.payment_type !== 1) return false;
                return true;
            }).map((o)=>({
                    ...o,
                    key: o.id
                })));
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        id && type && fetch();
    }, [
        id,
        type
    ]);
    const finishTask = async ()=>{
        try {
            const data = {};
            if (advance) data.advance = advance;
            if (wz) {
                data.sign_name = signName;
                data.sign_surname = signSurname;
                data.sign_document = signDocument;
                data.sign = JSON.stringify(sign);
            }
            if (paid !== undefined) data.payment = paid ? 1 : 0;
            if (type === '0') {
                if (!paymentDone) delete data.payment;
                else data.payment = 1;
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                    delivery_done: 1,
                    ...data
                });
                if (order.on_place) {
                    data.payment = paid ? 1 : 0;
                    await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                        claiming_done: 1,
                        ...data
                    });
                }
            } else if (type === '1') {
                const order = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(id);
                const d = {
                    delivery_done: 1,
                    ...data
                };
                if (!paymentDone) delete d.payment;
                else d.payment = 1;
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, d);
                const c = {
                    claiming_done: 1,
                    ...data
                };
                delete c.advance;
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(order.related_id, c);
            } else if (type === '2') await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                claiming_done: 1,
                ...data
            });
            if (ordersPaid.length) for (const id of ordersPaid)await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                payment: 1
            });
            navigate(-1);
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const clear = ()=>{
        setAdvance();
    };
    const finishDisabled = (0, $acw62.useMemo)(()=>{
        if (wz) return !signName || !signSurname || !signDocument || !sign;
    }, [
        wz,
        signName,
        signSurname,
        signDocument,
        sign
    ]);
    return [
        {
            id: id,
            type: type,
            orders: orders,
            order: order,
            ordersPaid: ordersPaid,
            paid: paid,
            paymentDone: paymentDone,
            advance: advance,
            wz: wz,
            signName: signName,
            signSurname: signSurname,
            signDocument: signDocument,
            sign: sign,
            finishDisabled: finishDisabled
        },
        {
            setId: setId,
            setType: setType,
            setPaid: setPaid,
            setOrderAsPaid: (id)=>setOrdersPaid((paid)=>[
                        ...paid,
                        id
                    ]),
            setOrderAsUnpaid: (id)=>setOrdersPaid((paid)=>[
                        ...paid.filter((i)=>i !== id)
                    ]),
            paymentDoneChanged: (e)=>setPaymentDone(e.target.checked),
            advanceChanged: (e)=>setAdvance(e.target.value),
            clear: clear,
            setWz: setWz,
            signNameChanged: (e)=>setSignName(e.target.value),
            signSurnameChanged: (e)=>setSignSurname(e.target.value),
            signDocumentChanged: (e)=>setSignDocument(e.target.value),
            setSign: setSign,
            finishTask: finishTask
        }
    ];
}




var $acw62 = parcelRequire("acw62");

const $eb56a1dc306fa6ba$var$useSettings = ()=>{
    const [sizes, setSizes] = (0, $acw62.useState)();
    const [newSize, setNewSize] = (0, $acw62.useState)();
    const [newUsername, setNewUsername] = (0, $acw62.useState)();
    const [user, setUser] = (0, $acw62.useState)();
    const [newPassword, setNewPassword] = (0, $acw62.useState)();
    const [repeatPassword, setRepeatPassword] = (0, $acw62.useState)();
    const [oldPassword, setOldPassword] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(null);
    const id = sessionStorage.getItem('id');
    const admin = window.sessionStorage.getItem('level') > 0;
    const fetch = async ()=>{
        try {
            const sizes = (await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll()).map((size, i)=>({
                    ...size,
                    key: i
                }));
            const user = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.get(id);
            setNewUsername(user.username);
            setUser(user);
            setSizes(sizes);
            setLoading();
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const changeLogin = async ()=>{
        if (loading) return;
        try {
            if (!newUsername || newUsername === user.username) throw 'Podaj nowy login';
            setLoading('username');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.patch(id, {
                username: newUsername
            });
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zmieniono login');
            setLoading();
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const changePassword = async ()=>{
        if (loading) return;
        try {
            if (newPassword !== repeatPassword) throw "Has\u0142a nie s\u0105 takie same";
            if (newPassword === oldPassword) throw "Podaj nowe has\u0142o";
            setLoading('password');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.patch(id, {
                password: newPassword,
                oldPassword: oldPassword
            });
            await fetch();
            setNewPassword();
            setRepeatPassword();
            setOldPassword();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zmieniono has\u0142o");
            setLoading();
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const deleteSize = async (id)=>{
        if (loading) return;
        try {
            setLoading(id);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.delete(id);
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Usuni\u0119to rozmiar");
            setLoading();
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const addSize = async ()=>{
        if (loading) return;
        try {
            setLoading('size');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.create(newSize);
            await fetch();
            setNewSize();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Dodano rozmiar');
            setLoading();
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    return [
        {
            sizes: sizes,
            newUsername: newUsername,
            newPassword: newPassword,
            repeatPassword: repeatPassword,
            oldPassword: oldPassword,
            newSize: newSize,
            loading: loading,
            admin: admin,
            user: user
        },
        {
            setNewUsername: (e)=>setNewUsername(e.target.value),
            setNewPassword: (e)=>setNewPassword(e.target.value),
            setRepeatPassword: (e)=>setRepeatPassword(e.target.value),
            setOldPassword: (e)=>setOldPassword(e.target.value),
            setNewSize: (e)=>setNewSize(e.target.value),
            changeLogin: changeLogin,
            changePassword: changePassword,
            deleteSize: deleteSize,
            addSize: addSize
        }
    ];
};
var $eb56a1dc306fa6ba$export$2e2bcd8739ae039 = $eb56a1dc306fa6ba$var$useSettings;




var $acw62 = parcelRequire("acw62");

function $473175eef259fb82$export$2e2bcd8739ae039() {
    const [containers, setContainers] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const [search, setSearch] = (0, $acw62.useState)();
    const [dateModal, setDateModal] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            const sizes = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll();
            const data = (await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.getAll(1)).filter((c)=>c.state.state !== 0 && c.state.state !== 6 && c.state.state !== 5).map((container, i)=>({
                    ...container,
                    key: i,
                    id: container.id,
                    size: sizes.filter((e)=>e.id === container.size)[0]
                })).sort((a, b)=>new Date(b.changed) - new Date(a.changed));
            setContainers(data);
        } catch (e) {
            console.error(e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const filtered = (0, $acw62.useMemo)(()=>{
        if (!search) return containers;
        return containers.filter((c)=>{
            if (`${c.name}`.toLowerCase().includes(search.toLowerCase())) return true;
            if (`${c.order?.client?.name}`.toLowerCase().includes(search.toLowerCase())) return true;
            if (`${c.order?.address}`.toLowerCase().includes(search.toLowerCase())) return true;
            return false;
        });
    }, [
        containers,
        search
    ]);
    const changeDate = async (row, date)=>{
        try {
            setLoading('date');
            if (row.order.related_id > row.order.id) {
                // Replacement
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(row.order.id, {
                    delivery_date: date.unix() * 1000
                });
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(row.order.related_id, {
                    claiming_date: date.unix() * 1000
                });
            } else // Claiming
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(row.order.id, {
                claiming_date: date === null ? null : date.unix() * 1000
            });
            await fetch();
            setDateModal();
            setLoading();
            return true;
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    return [
        {
            containers: filtered,
            loading: loading,
            search: search,
            dateModal: dateModal
        },
        {
            searchChanged: (e)=>setSearch(e.target.value),
            clearSearch: ()=>setSearch(),
            setDateModal: setDateModal,
            changeDate: changeDate
        }
    ];
}






const { Option: $547f8c0c0db6fb68$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $547f8c0c0db6fb68$var$Drivers = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [{ data: data, visible: visible, filters: filters, loading: loading }, { toggleVisible: toggleVisible, removeUser: removeUser, restoreUser: restoreUser, searchChanged: searchChanged, levelChanged: levelChanged, clearFilters: clearFilters }] = (0, $696f261154e92a27$export$2e2bcd8739ae039)();
    const columns = [
        {
            title: "Imi\u0119 i nazwisko",
            dataIndex: 'name',
            key: 'name',
            render: (_, row)=>`${row.name} ${row.surname}`
        },
        {
            title: visible ? "Usuni\u0119ty - przez" : 'Stan konta (do rozliczenia)',
            dataIndex: visible ? 'removed' : 'balance',
            key: 'balance',
            render: (v, row)=>{
                let removedBy = '-';
                if (v) removedBy = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(v),
                        " -",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "",
                            onClick: (e)=>navigate(`/panel/drivers/${row.removed_by?.id}`),
                            children: row.removed_by?.name
                        })
                    ]
                });
                return visible ? removedBy : `${(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(v)} ${(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(row.unsettled)}`;
            }
        },
        {
            title: 'Dodany - przez',
            dataIndex: 'created',
            key: 'created',
            render: (v, row)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(v),
                                " - "
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "",
                            onClick: (e)=>navigate(`/panel/drivers/${row.created_by.id}`),
                            children: row.created_by.name
                        })
                    ]
                });
            }
        },
        {
            title: 'Ostatnio zalogowany',
            dataIndex: 'logged',
            key: 'logged',
            render: (v)=>v === null ? '-' : (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(v)
        },
        {
            title: 'Typ',
            dataIndex: 'level',
            key: 'level',
            render: (level)=>{
                switch(level){
                    case 0:
                        return 'Pracownik';
                    case 1:
                        return 'Administrator';
                    case 2:
                        return 'Superadministrator';
                }
            }
        },
        {
            title: 'Akcje',
            key: 'action',
            render: (_, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    size: 5,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            onClick: ()=>navigate(`/panel/drivers/${row.id}`),
                            children: "Szczeg\xf3\u0142y"
                        }),
                        row.id == sessionStorage.getItem('id') ? '' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "|"
                        }),
                        row.removed_by ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            style: {
                                color: loading === row.id ? '#8c8c8c' : '#52C41A'
                            },
                            onClick: ()=>loading === row.id ? undefined : restoreUser(row.id),
                            children: "Przywr\xf3\u0107"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            style: {
                                color: loading === row.id ? '#8c8c8c' : '#f5222d'
                            },
                            onClick: ()=>loading === row.id ? undefined : removeUser(row.id),
                            children: row.id == sessionStorage.getItem('id') ? '' : "Usu\u0144"
                        })
                    ]
                })
        }
    ];
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate('/panel/new-driver'),
            children: "Dodaj nowego pracownika"
        }, 0),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: visible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {}),
            onClick: toggleVisible,
            children: [
                visible ? 'Ukryj' : "Poka\u017C",
                " usuni\u0119tych pracownik\xf3w"
            ]
        }, 1)
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Pracownicy",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "drivers flex flex-dir flex-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inputs flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            placeholder: "Wyszukaj",
                            size: "large",
                            suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                                style: {
                                    color: '#8C8C8C'
                                }
                            }),
                            value: filters.search,
                            onChange: searchChanged
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                            placeholder: "Typ konta",
                            size: "large",
                            value: filters.level,
                            onSelect: levelChanged,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($547f8c0c0db6fb68$var$Option, {
                                    value: 0,
                                    children: "Pracownik"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($547f8c0c0db6fb68$var$Option, {
                                    value: 1,
                                    children: "Administrator"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($547f8c0c0db6fb68$var$Option, {
                                    value: 2,
                                    children: "Superadministrator"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                            onClick: clearFilters,
                            children: "Wyczy\u015B\u0107"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                    columns: columns,
                    dataSource: data,
                    loading: data === undefined,
                    pagination: false,
                    scroll: {
                        x: 'max-content'
                    }
                })
            ]
        })
    });
};
var $547f8c0c0db6fb68$export$2e2bcd8739ae039 = $547f8c0c0db6fb68$var$Drivers;




var $acw62 = parcelRequire("acw62");


var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $7c41d3edfd4df78b$var$Element = function Element(props) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, size = props.size, shape = props.shape;
    var sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-sm"), size === 'small'));
    var shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-circle"), shape === 'circle'), "".concat(prefixCls, "-square"), shape === 'square'), "".concat(prefixCls, "-round"), shape === 'round'));
    var sizeStyle = $acw62.useMemo(function() {
        return typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: "".concat(size, "px")
        } : {};
    }, [
        size
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, sizeCls, shapeCls, className),
        style: (0, $8nd05.default)((0, $8nd05.default)({}, sizeStyle), style)
    });
};
var $7c41d3edfd4df78b$export$2e2bcd8739ae039 = $7c41d3edfd4df78b$var$Element;


var $febf367e4c351696$var$SkeletonAvatar = function SkeletonAvatar(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active, _props$shape = props.shape, shape = _props$shape === void 0 ? 'circle' : _props$shape, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, $1pcHX.default)(props, [
        'prefixCls',
        'className'
    ]);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-element"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), (0, $8nd05.default)({
        prefixCls: "".concat(prefixCls, "-avatar"),
        shape: shape,
        size: size
    }, otherProps)));
};
var $febf367e4c351696$export$2e2bcd8739ae039 = $febf367e4c351696$var$SkeletonAvatar;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");


var $13df8eca828a64aa$var$SkeletonButton = function SkeletonButton(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active, _props$block = props.block, block = _props$block === void 0 ? false : _props$block, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, $1pcHX.default)(props, [
        'prefixCls'
    ]);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-element"), (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-block"), block), className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), (0, $8nd05.default)({
        prefixCls: "".concat(prefixCls, "-button"),
        size: size
    }, otherProps)));
};
var $13df8eca828a64aa$export$2e2bcd8739ae039 = $13df8eca828a64aa$var$SkeletonButton;



var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4af4b6581042791c$var$DotChartOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "dot-chart",
    "theme": "outlined"
};
var $4af4b6581042791c$export$2e2bcd8739ae039 = $4af4b6581042791c$var$DotChartOutlined;



var $5fc35ea60cf4e8a7$var$DotChartOutlined = function DotChartOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $4af4b6581042791c$export$2e2bcd8739ae039)
    }));
};
var $5fc35ea60cf4e8a7$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($5fc35ea60cf4e8a7$var$DotChartOutlined);
var $5fc35ea60cf4e8a7$export$2e2bcd8739ae039 = $5fc35ea60cf4e8a7$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $28cf1b1f35f23ace$var$SkeletonNode = function SkeletonNode(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, active = props.active, children = props.children;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-element"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-active"), active), className);
    var content = children !== null && children !== void 0 ? children : /*#__PURE__*/ $acw62.createElement((0, $5fc35ea60cf4e8a7$export$2e2bcd8739ae039), null);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-image"), className),
        style: style
    }, content));
};
var $28cf1b1f35f23ace$export$2e2bcd8739ae039 = $28cf1b1f35f23ace$var$SkeletonNode;




var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $2d15da232c1f201d$var$path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
var $2d15da232c1f201d$var$SkeletonImage = function SkeletonImage(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, active = props.active;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-element"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-image"), className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: "".concat(prefixCls, "-image-svg")
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: $2d15da232c1f201d$var$path,
        className: "".concat(prefixCls, "-image-path")
    }))));
};
var $2d15da232c1f201d$export$2e2bcd8739ae039 = $2d15da232c1f201d$var$SkeletonImage;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");


var $91e87c3cdd7d215d$var$SkeletonInput = function SkeletonInput(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active, block = props.block, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, $1pcHX.default)(props, [
        'prefixCls'
    ]);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-element"), (0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-block"), block), className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), (0, $8nd05.default)({
        prefixCls: "".concat(prefixCls, "-input"),
        size: size
    }, otherProps)));
};
var $91e87c3cdd7d215d$export$2e2bcd8739ae039 = $91e87c3cdd7d215d$var$SkeletonInput;



var $kbxxf = parcelRequire("kbxxf");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $df381a499592442b$var$Paragraph = function Paragraph(props) {
    var getWidth = function getWidth(index) {
        var width = props.width, _props$rows = props.rows, rows = _props$rows === void 0 ? 2 : _props$rows;
        if (Array.isArray(width)) return width[index];
        // last paragraph
        if (rows - 1 === index) return width;
        return undefined;
    };
    var prefixCls = props.prefixCls, className = props.className, style = props.style, rows = props.rows;
    var rowList = (0, $kbxxf.default)(Array(rows)).map(function(_, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $acw62.createElement("li", {
            key: index,
            style: {
                width: getWidth(index)
            }
        }));
    });
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className),
        style: style
    }, rowList);
};
var $df381a499592442b$export$2e2bcd8739ae039 = $df381a499592442b$var$Paragraph;



var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $d644e5b233ba4700$var$Title = function Title(_ref) {
    var prefixCls = _ref.prefixCls, className = _ref.className, width = _ref.width, style = _ref.style;
    return /*#__PURE__*/ $acw62.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, className),
        style: (0, $8nd05.default)({
            width: width
        }, style)
    });
};
var $d644e5b233ba4700$export$2e2bcd8739ae039 = $d644e5b233ba4700$var$Title;


function $186852cf13bfcae4$var$getComponentProps(prop) {
    if (prop && (0, $fSwVM.default)(prop) === 'object') return prop;
    return {};
}
function $186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    var basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
var $186852cf13bfcae4$var$Skeleton = function Skeleton(props) {
    var customizePrefixCls = props.prefixCls, loading = props.loading, className = props.className, style = props.style, children = props.children, _props$avatar = props.avatar, avatar = _props$avatar === void 0 ? false : _props$avatar, _props$title = props.title, title = _props$title === void 0 ? true : _props$title, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? true : _props$paragraph, active = props.active, round = props.round;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    if (loading || !('loading' in props)) {
        var hasAvatar = !!avatar;
        var hasTitle = !!title;
        var hasParagraph = !!paragraph;
        // Avatar
        var avatarNode;
        if (hasAvatar) {
            var avatarProps = (0, $8nd05.default)((0, $8nd05.default)({
                prefixCls: "".concat(prefixCls, "-avatar")
            }, $186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph)), $186852cf13bfcae4$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: "".concat(prefixCls, "-header")
            }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), (0, $8nd05.default)({}, avatarProps)));
        }
        var contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            var $title;
            if (hasTitle) {
                var titleProps = (0, $8nd05.default)((0, $8nd05.default)({
                    prefixCls: "".concat(prefixCls, "-title")
                }, $186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph)), $186852cf13bfcae4$var$getComponentProps(title));
                $title = /*#__PURE__*/ $acw62.createElement((0, $d644e5b233ba4700$export$2e2bcd8739ae039), (0, $8nd05.default)({}, titleProps));
            }
            // Paragraph
            var paragraphNode;
            if (hasParagraph) {
                var paragraphProps = (0, $8nd05.default)((0, $8nd05.default)({
                    prefixCls: "".concat(prefixCls, "-paragraph")
                }, $186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle)), $186852cf13bfcae4$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $acw62.createElement((0, $df381a499592442b$export$2e2bcd8739ae039), (0, $8nd05.default)({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: "".concat(prefixCls, "-content")
            }, $title, paragraphNode);
        }
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-with-avatar"), hasAvatar), "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-round"), round), className);
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: cls,
            style: style
        }, avatarNode, contentNode);
    }
    return typeof children !== 'undefined' ? children : null;
};
$186852cf13bfcae4$var$Skeleton.Button = (0, $13df8eca828a64aa$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Avatar = (0, $febf367e4c351696$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Input = (0, $91e87c3cdd7d215d$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Image = (0, $2d15da232c1f201d$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Node = (0, $28cf1b1f35f23ace$export$2e2bcd8739ae039);
var $186852cf13bfcae4$export$2e2bcd8739ae039 = $186852cf13bfcae4$var$Skeleton;


var $b9eb1d5949d003b0$export$2e2bcd8739ae039 = (0, $186852cf13bfcae4$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");


function $731042e70a6ddd3b$var$_extends() {
    $731042e70a6ddd3b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $731042e70a6ddd3b$var$_extends.apply(this, arguments);
}
const $731042e70a6ddd3b$var$CheckOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $731042e70a6ddd3b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $94b215ba0d5fdf99$export$2e2bcd8739ae039)
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const $731042e70a6ddd3b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($731042e70a6ddd3b$var$CheckOutlined);
var $731042e70a6ddd3b$export$2e2bcd8739ae039 = $731042e70a6ddd3b$var$RefIcon;


var $acw62 = parcelRequire("acw62");


function $2628771293840a7d$var$_extends() {
    $2628771293840a7d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2628771293840a7d$var$_extends.apply(this, arguments);
}
const $2628771293840a7d$var$ClockCircleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $2628771293840a7d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $beb0f4a2bf4b9d4a$export$2e2bcd8739ae039)
    }));
/**![clock-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTY4Ni43IDYzOC42TDU0NC4xIDUzNS41VjI4OGMwLTQuNC0zLjYtOC04LThINDg4Yy00LjQgMC04IDMuNi04IDh2Mjc1LjRjMCAyLjYgMS4yIDUgMy4zIDYuNWwxNjUuNCAxMjAuNmMzLjYgMi42IDguNiAxLjggMTEuMi0xLjdsMjguNi0zOWMyLjYtMy43IDEuOC04LjctMS44LTExLjJ6IiAvPjwvc3ZnPg==) */ const $2628771293840a7d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2628771293840a7d$var$ClockCircleOutlined);
var $2628771293840a7d$export$2e2bcd8739ae039 = $2628771293840a7d$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $1f7080d7f45398b4$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
var $1f7080d7f45398b4$export$2e2bcd8739ae039 = $1f7080d7f45398b4$var$DeleteOutlined;



function $66758f779ccbee67$var$_extends() {
    $66758f779ccbee67$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $66758f779ccbee67$var$_extends.apply(this, arguments);
}
const $66758f779ccbee67$var$DeleteOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $66758f779ccbee67$var$_extends({}, props, {
        ref: ref,
        icon: (0, $1f7080d7f45398b4$export$2e2bcd8739ae039)
    }));
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ const $66758f779ccbee67$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($66758f779ccbee67$var$DeleteOutlined);
var $66758f779ccbee67$export$2e2bcd8739ae039 = $66758f779ccbee67$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2a4300d3ef4ba319$var$UndoOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"
                }
            }
        ]
    },
    "name": "undo",
    "theme": "outlined"
};
var $2a4300d3ef4ba319$export$2e2bcd8739ae039 = $2a4300d3ef4ba319$var$UndoOutlined;



function $eaf43360a8ccea7a$var$_extends() {
    $eaf43360a8ccea7a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eaf43360a8ccea7a$var$_extends.apply(this, arguments);
}
const $eaf43360a8ccea7a$var$UndoOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $eaf43360a8ccea7a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2a4300d3ef4ba319$export$2e2bcd8739ae039)
    }));
/**![undo](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMS40IDEyNEMyOTAuNSAxMjQuMyAxMTIgMzAzIDExMiA1MjMuOWMwIDEyOCA2MC4yIDI0MiAxNTMuOCAzMTUuMmwtMzcuNSA0OGMtNC4xIDUuMy0uMyAxMyA2LjMgMTIuOWwxNjctLjhjNS4yIDAgOS00LjkgNy43LTkuOUwzNjkuOCA3MjdhOCA4IDAgMDAtMTQuMS0zTDMxNSA3NzYuMWMtMTAuMi04LTIwLTE2LjctMjkuMy0yNmEzMTguNjQgMzE4LjY0IDAgMDEtNjguNi0xMDEuN0MyMDAuNCA2MDkgMTkyIDU2Ny4xIDE5MiA1MjMuOXM4LjQtODUuMSAyNS4xLTEyNC41YzE2LjEtMzguMSAzOS4yLTcyLjMgNjguNi0xMDEuNyAyOS40LTI5LjQgNjMuNi01Mi41IDEwMS43LTY4LjZDNDI2LjkgMjEyLjQgNDY4LjggMjA0IDUxMiAyMDRzODUuMSA4LjQgMTI0LjUgMjUuMWMzOC4xIDE2LjEgNzIuMyAzOS4yIDEwMS43IDY4LjYgMjkuNCAyOS40IDUyLjUgNjMuNiA2OC42IDEwMS43IDE2LjcgMzkuNCAyNS4xIDgxLjMgMjUuMSAxMjQuNXMtOC40IDg1LjEtMjUuMSAxMjQuNWEzMTguNjQgMzE4LjY0IDAgMDEtNjguNiAxMDEuN2MtNy41IDcuNS0xNS4zIDE0LjUtMjMuNCAyMS4yYTcuOTMgNy45MyAwIDAwLTEuMiAxMS4xbDM5LjQgNTAuNWMyLjggMy41IDcuOSA0LjEgMTEuNCAxLjNDODU0LjUgNzYwLjggOTEyIDY0OS4xIDkxMiA1MjMuOWMwLTIyMS4xLTE3OS40LTQwMC4yLTQwMC42LTM5OS45eiIgLz48L3N2Zz4=) */ const $eaf43360a8ccea7a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($eaf43360a8ccea7a$var$UndoOutlined);
var $eaf43360a8ccea7a$export$2e2bcd8739ae039 = $eaf43360a8ccea7a$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $7f9bdeb11da6e1b1$var$UnlockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "unlock",
    "theme": "outlined"
};
var $7f9bdeb11da6e1b1$export$2e2bcd8739ae039 = $7f9bdeb11da6e1b1$var$UnlockOutlined;



function $31596fffcf1abc57$var$_extends() {
    $31596fffcf1abc57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $31596fffcf1abc57$var$_extends.apply(this, arguments);
}
const $31596fffcf1abc57$var$UnlockOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $31596fffcf1abc57$var$_extends({}, props, {
        ref: ref,
        icon: (0, $7f9bdeb11da6e1b1$export$2e2bcd8739ae039)
    }));
/**![unlock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRIMzMyVjI0MGMwLTMwLjkgMjUuMS01NiA1Ni01NmgyNDhjMzAuOSAwIDU2IDI1LjEgNTYgNTZ2NjhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNjhjMC03MC43LTU3LjMtMTI4LTEyOC0xMjhIMzg4Yy03MC43IDAtMTI4IDU3LjMtMTI4IDEyOHYyMjRoLTY4Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzODRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjQ5NmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDM3NkgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ const $31596fffcf1abc57$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($31596fffcf1abc57$var$UnlockOutlined);
var $31596fffcf1abc57$export$2e2bcd8739ae039 = $31596fffcf1abc57$var$RefIcon;






const { Option: $2eb35577cc000d87$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $2eb35577cc000d87$var$DriverDetails = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [deleteModal, setDeleteModal] = (0, $acw62.useState)(false);
    const [passwordModal, setPasswordModal] = (0, $acw62.useState)(false);
    const [infoModal, setInfoModal] = (0, $acw62.useState)(false);
    const [{ user: user, removed: removed, saveDisabled: saveDisabled, saving: saving, resetting: resetting, loading: loading, password: password, timeline: timeline, deleteDisabled: deleteDisabled }, { userNameChanged: userNameChanged, userSurnameChanged: userSurnameChanged, userLevelChanged: userLevelChanged, saveChanges: saveChanges, resetPassword: resetPassword, deleteUser: deleteUser, restoreUser: restoreUser, typeChanged: typeChanged }] = (0, $7fc92eee42f07c5c$export$2e2bcd8739ae039)();
    const actions = removed ? [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaf43360a8ccea7a$export$2e2bcd8739ae039), {}),
            loading: loading,
            onClick: restoreUser,
            children: "Przywr\xf3\u0107 pracownika"
        }, 0),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2628771293840a7d$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate(`/panel/drivers/${user?.id}/card`),
            children: "Poka\u017C kart\u0119 pracownika"
        }, 1)
    ] : [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "danger",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
            onClick: ()=>setDeleteModal(true),
            disabled: deleteDisabled,
            children: "Usu\u0144 pracownika"
        }, 2),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2628771293840a7d$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate(`/panel/drivers/${user?.id}/card`),
            children: "Poka\u017C kart\u0119 pracownika"
        }, 3)
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: user != undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
            title: `Pracownicy / ${user.name} ${user.surname}`,
            actions: actions,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "driver-details flex",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        title: "Informacje",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                className: "inputs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Imi\u0119"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "text",
                                                size: "large",
                                                defaultValue: user.name,
                                                onChange: userNameChanged,
                                                disabled: removed
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Nazwisko"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "text",
                                                size: "large",
                                                defaultValue: user.surname,
                                                onChange: userSurnameChanged,
                                                disabled: removed
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                className: "inputs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                        placeholder: "Typ konta",
                                        size: "large",
                                        labelInValue: true,
                                        defaultValue: {
                                            value: user.level
                                        },
                                        onChange: userLevelChanged,
                                        disabled: removed,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2eb35577cc000d87$var$Option, {
                                                value: 0,
                                                children: "U\u017Cytkownik"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2eb35577cc000d87$var$Option, {
                                                value: 1,
                                                children: "Administrator"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2eb35577cc000d87$var$Option, {
                                                value: 2,
                                                children: "Superadministrator"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Stanowisko"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "text",
                                                size: "large",
                                                defaultValue: user.type,
                                                onChange: typeChanged,
                                                disabled: removed
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                className: "inputs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        size: "large",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {}),
                                        disabled: saveDisabled,
                                        onClick: saveChanges,
                                        loading: saving,
                                        children: "Zapisz zmiany"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Stan konta:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "user-data",
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(user.balance)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-dir",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Zalogowany:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "user-data",
                                                        children: [
                                                            " ",
                                                            user.logged === null ? '-' : (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(user.logged)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                type: "primary",
                                                size: "large",
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31596fffcf1abc57$export$2e2bcd8739ae039), {}),
                                                onClick: ()=>setPasswordModal(true),
                                                disabled: deleteDisabled || removed,
                                                children: "Resetuj has\u0142o"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            "Utworzony:",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(user.created)
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            "Przez:",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                    to: `/panel/drivers/${user.created_by.id}`,
                                                                    children: [
                                                                        user.created_by.name,
                                                                        " ",
                                                                        user.created_by.surname
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    removed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            "Usuni\u0119ty: ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(user.removed)
                                                            }),
                                                            ' '
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            "Przez:",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                    to: `/panel/drivers/${user.removed_by.id}`,
                                                                    children: [
                                                                        user.removed_by.name,
                                                                        " ",
                                                                        user.removed_by.surname
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6fd0b816bbe13d58$export$2e2bcd8739ae039), {
                    visible: deleteModal,
                    onCancel: ()=>setDeleteModal(false),
                    onOk: ()=>deleteUser(()=>setDeleteModal(false)),
                    loading: loading,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Czy na pewno chcesz usun\u0105\u0107 pracownika?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "Spowoduje to odebranie mu dost\u0119pu do portalu"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6fd0b816bbe13d58$export$2e2bcd8739ae039), {
                    visible: passwordModal,
                    onCancel: ()=>setPasswordModal(false),
                    onOk: ()=>resetPassword(()=>{
                            setPasswordModal(false);
                            setInfoModal(true);
                        }),
                    loading: resetting,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Czy na pewno zresetowa\u0107 has\u0142o?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "pracownika b\u0119dzie musia\u0142 zalogowa\u0107 si\u0119 u\u017Cywacj\u0105c nowego has\u0142a"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fc69d8460bb1eda3$export$2e2bcd8739ae039), {
                    visible: infoModal,
                    onCancel: ()=>{},
                    onOk: ()=>setInfoModal(false),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: password
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "Podaj to has\u0142o pracownika, pozwoli mu ono na ustawienie nowego."
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
                active: true
            })
        })
    });
};
var $2eb35577cc000d87$export$2e2bcd8739ae039 = $2eb35577cc000d87$var$DriverDetails;



parcelRequire("acw62");





const $f910fc0cf9ce236f$var$NewDriver = ()=>{
    const [{ user: user, disabled: disabled, loading: loading }, { usernameChanged: usernameChanged, nameChanged: nameChanged, surnameChanged: surnameChanged, adminChecked: adminChecked, superadminChecked: superadminChecked, createUser: createUser, typeChanged: typeChanged }] = (0, $5255c5ca5eb3b7e0$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            disabled: disabled,
            loading: loading,
            onClick: createUser,
            children: "Dodaj pracownika"
        }, "1")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Pracownicy / Nowy",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "new-driver flex",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                title: "Informacje",
                width: 878,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 19,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Nazwa u\u017Cytkownika"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: user.username,
                                        onChange: usernameChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "info",
                                        children: "Mo\u017Cesz j\u0105 zmieni\u0107 w ka\u017Cdym momencie"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 19,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Imi\u0119"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: user.name,
                                        onChange: nameChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Nazwisko"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: user.surname,
                                        onChange: surnameChanged
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 19,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stanowisko"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: user.type,
                                        onChange: typeChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 19,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                checked: user.level >= 1,
                                onChange: adminChecked,
                                children: "Pracownik jest administratorem"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                checked: user.level === 2,
                                onChange: superadminChecked,
                                disabled: user.level < 1,
                                children: "Pracownik mo\u017Ce zmienia\u0107 uprawnienia"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "password",
                        children: [
                            "Tymczasowe has\u0142o pracownika: ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: user.password
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "info",
                        children: "Pracownik zostanie poproszony o zmian\u0119 has\u0142a przy pierwszym logowaniu"
                    })
                ]
            })
        })
    });
};
var $f910fc0cf9ce236f$export$2e2bcd8739ae039 = $f910fc0cf9ce236f$var$NewDriver;



parcelRequire("acw62");






const { Option: $2f77e55c227ae33e$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $2f77e55c227ae33e$var$Containers = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [{ sizes: sizes, data: data, visible: visible, filters: filters, loading: loading, admin: admin }, { toggleVisible: toggleVisible, clearFilters: clearFilters, searchChanged: searchChanged, sizeChanged: sizeChanged, stateChanged: stateChanged, deleteContainer: deleteContainer, restoreContainer: restoreContainer }] = (0, $048b27f6d6ad34a1$export$2e2bcd8739ae039)();
    const getContainerStateName = (state, row)=>{
        switch(state){
            case 0:
                return 'Wolny';
            case 1:
                if (row?.order?.claiming_date && new Date(row.order.claiming_date) < new Date()) {
                    if (row.order.related_id > row.order.id) return 'Do wymiany';
                    return 'Do odbioru';
                }
                return 'Podstawiony';
            case 4:
                return 'W transporcie';
            case 5:
                return "Wypo\u017Cyczony";
            case 6:
                return "Usuni\u0119ty";
            default:
                return 'Nieznany';
        }
    };
    const columns = [
        {
            title: 'Numer',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Rozmiar',
            dataIndex: 'size',
            key: 'size',
            render: (s)=>s.name
        },
        {
            title: 'Typ',
            dataIndex: 'type',
            key: 'type',
            render: (type)=>type ?? '-'
        },
        {
            title: 'Stan',
            dataIndex: 'state',
            key: 'state',
            render: (state, row)=>getContainerStateName(state.state, row)
        },
        {
            title: 'Klient',
            dataIndex: 'order',
            key: 'client',
            render: (order)=>order?.client?.name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/clients/${order.client.id}`,
                    children: order.client.name
                }) : '-'
        },
        {
            title: !visible && 'Aktualna lokalizacja',
            dataIndex: !visible && 'order',
            key: 'location',
            render: (order)=>!visible && (order?.street ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${order}`,
                    children: order.address
                }) : '-')
        },
        {
            title: 'Akcje',
            key: 'action',
            render: (_, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    size: 5,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/containers/${row.id}`,
                            children: "Szczeg\xf3\u0142y"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "|"
                        }),
                        row.state === 6 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            style: {
                                color: loading === row.id ? '#8c8c8c' : '#52C41A'
                            },
                            onClick: ()=>loading === row.id ? undefined : restoreContainer(row.id),
                            children: "Przywr\xf3\u0107"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            style: {
                                color: loading === row.id ? '#8c8c8c' : '#f5222d'
                            },
                            onClick: ()=>loading === row.id ? undefined : deleteContainer(row.id),
                            children: "Usu\u0144"
                        })
                    ]
                })
        }
    ].filter((c)=>admin || c.key !== 'action');
    const actions = [
        admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate('/panel/new-container'),
            children: "Dodaj nowy kontener"
        }, 0),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: visible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {}),
            onClick: toggleVisible,
            children: [
                visible ? 'Ukryj' : "Poka\u017C",
                " usuni\u0119te kontenery"
            ]
        }, 1)
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Kontenery",
        actions: actions,
        number: data?.length,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "containers flex flex-dir flex-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inputs flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            placeholder: "Wyszukaj",
                            size: "large",
                            suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                                style: {
                                    color: '#8C8C8C'
                                }
                            }),
                            value: filters.search,
                            onChange: searchChanged
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                            placeholder: "Rozmiar",
                            size: "large",
                            value: filters.size,
                            onChange: sizeChanged,
                            children: sizes?.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2f77e55c227ae33e$var$Option, {
                                    value: id,
                                    children: name
                                }, id))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                            placeholder: "Stan kontenera",
                            size: "large",
                            value: filters.state,
                            onSelect: stateChanged,
                            children: Array(7).fill(0).map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2f77e55c227ae33e$var$Option, {
                                    value: i,
                                    children: getContainerStateName(i)
                                }, i))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                            onClick: clearFilters,
                            children: "Wyczy\u015B\u0107"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                    columns: columns,
                    dataSource: data,
                    pagination: false,
                    scroll: {
                        x: 'max-content'
                    }
                })
            ]
        })
    });
};
var $2f77e55c227ae33e$export$2e2bcd8739ae039 = $2f77e55c227ae33e$var$Containers;




var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");


var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $d10f1cf9148842a7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d10f1cf9148842a7$var$TimelineItem = function TimelineItem(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, _a$color = _a.color, color = _a$color === void 0 ? 'blue' : _a$color, dot = _a.dot, _a$pending = _a.pending, pending = _a$pending === void 0 ? false : _a$pending, position = _a.position, label = _a.label, children = _a.children, restProps = $d10f1cf9148842a7$var$__rest(_a, [
        "prefixCls",
        "className",
        "color",
        "dot",
        "pending",
        "position",
        "label",
        "children"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('timeline', customizePrefixCls);
    var itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-item"), true), "".concat(prefixCls, "-item-pending"), pending), className);
    var dotClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-item-head"), true), "".concat(prefixCls, "-item-head-custom"), !!dot), "".concat(prefixCls, "-item-head-").concat(color), true));
    var customColor = /blue|red|green|gray/.test(color || '') ? undefined : color;
    return /*#__PURE__*/ $acw62.createElement("li", (0, $8nd05.default)({}, restProps, {
        className: itemClassName
    }), label && /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-label")
    }, label), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-tail")
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: dotClassName,
        style: {
            borderColor: customColor,
            color: customColor
        }
    }, dot), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-content")
    }, children));
};
var $d10f1cf9148842a7$export$2e2bcd8739ae039 = $d10f1cf9148842a7$var$TimelineItem;


var $4de5361c1e1a2a27$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4de5361c1e1a2a27$var$Timeline = function Timeline(props) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$pending = props.pending, pending = _props$pending === void 0 ? null : _props$pending, pendingDot = props.pendingDot, children = props.children, className = props.className, _props$reverse = props.reverse, reverse = _props$reverse === void 0 ? false : _props$reverse, _props$mode = props.mode, mode = _props$mode === void 0 ? '' : _props$mode, restProps = $4de5361c1e1a2a27$var$__rest(props, [
        "prefixCls",
        "pending",
        "pendingDot",
        "children",
        "className",
        "reverse",
        "mode"
    ]);
    var prefixCls = getPrefixCls('timeline', customizePrefixCls);
    var pendingNode = typeof pending === 'boolean' ? null : pending;
    var pendingItem = pending ? /*#__PURE__*/ $acw62.createElement((0, $d10f1cf9148842a7$export$2e2bcd8739ae039), {
        pending: !!pending,
        dot: pendingDot || /*#__PURE__*/ $acw62.createElement((0, $43383ed7d2a91124$export$2e2bcd8739ae039), null)
    }, pendingNode) : null;
    var timeLineItems = $acw62.Children.toArray(children);
    timeLineItems.push(pendingItem);
    if (reverse) timeLineItems.reverse();
    var getPositionCls = function getPositionCls(ele, idx) {
        if (mode === 'alternate') {
            if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
            if (ele.props.position === 'left') return "".concat(prefixCls, "-item-left");
            return idx % 2 === 0 ? "".concat(prefixCls, "-item-left") : "".concat(prefixCls, "-item-right");
        }
        if (mode === 'left') return "".concat(prefixCls, "-item-left");
        if (mode === 'right') return "".concat(prefixCls, "-item-right");
        if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
        return '';
    };
    // Remove falsy items
    var truthyItems = timeLineItems.filter(function(item) {
        return !!item;
    });
    var itemsCount = $acw62.Children.count(truthyItems);
    var lastCls = "".concat(prefixCls, "-item-last");
    var items = $acw62.Children.map(truthyItems, function(ele, idx) {
        var pendingClass = idx === itemsCount - 2 ? lastCls : '';
        var readyClass = idx === itemsCount - 1 ? lastCls : '';
        return (0, $30796c32f374b477$export$e530037191fcd5d7)(ele, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))([
                ele.props.className,
                !reverse && !!pending ? pendingClass : readyClass,
                getPositionCls(ele, idx)
            ])
        });
    });
    var hasLabelItem = timeLineItems.some(function(item) {
        var _a;
        return !!((_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.label);
    });
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-pending"), !!pending), "".concat(prefixCls, "-reverse"), !!reverse), "".concat(prefixCls, "-").concat(mode), !!mode && !hasLabelItem), "".concat(prefixCls, "-label"), hasLabelItem), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $acw62.createElement("ul", (0, $8nd05.default)({}, restProps, {
        className: classString
    }), items);
};
$4de5361c1e1a2a27$var$Timeline.Item = (0, $d10f1cf9148842a7$export$2e2bcd8739ae039);
var $4de5361c1e1a2a27$export$2e2bcd8739ae039 = $4de5361c1e1a2a27$var$Timeline;


var $8165f182d4056084$export$2e2bcd8739ae039 = (0, $4de5361c1e1a2a27$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $704623e394bc0578$var$FlagOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"
                }
            }
        ]
    },
    "name": "flag",
    "theme": "outlined"
};
var $704623e394bc0578$export$2e2bcd8739ae039 = $704623e394bc0578$var$FlagOutlined;



function $68369c637afb54bb$var$_extends() {
    $68369c637afb54bb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68369c637afb54bb$var$_extends.apply(this, arguments);
}
const $68369c637afb54bb$var$FlagOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $68369c637afb54bb$var$_extends({}, props, {
        ref: ref,
        icon: (0, $704623e394bc0578$export$2e2bcd8739ae039)
    }));
/**![flag](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAzMDVINjI0VjE5MmMwLTE3LjctMTQuMy0zMi0zMi0zMkgxODR2LTQwYzAtNC40LTMuNi04LTgtOGgtNTZjLTQuNCAwLTggMy42LTggOHY3ODRjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOFY2NDBoMjQ4djExM2MwIDE3LjcgMTQuMyAzMiAzMiAzMmg0MTZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzM3YzAtMTcuNy0xNC4zLTMyLTMyLTMyek0xODQgNTY4VjIzMmgzNjh2MzM2SDE4NHptNjU2IDE0NUg1MDR2LTczaDExMmM0LjQgMCA4LTMuNiA4LThWMzc3aDIxNnYzMzZ6IiAvPjwvc3ZnPg==) */ const $68369c637afb54bb$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($68369c637afb54bb$var$FlagOutlined);
var $68369c637afb54bb$export$2e2bcd8739ae039 = $68369c637afb54bb$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $e47334c4803252a7$var$HistoryOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 003 14.1zm167.7 301.1l-56.7-19.5a8 8 0 00-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 01-112.5 75.9 352.18 352.18 0 01-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 01-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 01171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 01112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 01775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z"
                }
            }
        ]
    },
    "name": "history",
    "theme": "outlined"
};
var $e47334c4803252a7$export$2e2bcd8739ae039 = $e47334c4803252a7$var$HistoryOutlined;



function $fe6306538b66c213$var$_extends() {
    $fe6306538b66c213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fe6306538b66c213$var$_extends.apply(this, arguments);
}
const $fe6306538b66c213$var$HistoryOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $fe6306538b66c213$var$_extends({}, props, {
        ref: ref,
        icon: (0, $e47334c4803252a7$export$2e2bcd8739ae039)
    }));
/**![history](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzNi4xIDI3M0g0ODhjLTQuNCAwLTggMy42LTggOHYyNzUuM2MwIDIuNiAxLjIgNSAzLjMgNi41bDE2NS4zIDEyMC43YzMuNiAyLjYgOC42IDEuOSAxMS4yLTEuN2wyOC42LTM5YzIuNy0zLjcgMS45LTguNy0xLjctMTEuMkw1NDQuMSA1MjguNVYyODFjMC00LjQtMy42LTgtOC04em0yMTkuOCA3NS4ybDE1Ni44IDM4LjNjNSAxLjIgOS45LTIuNiA5LjktNy43bC44LTE2MS41YzAtNi43LTcuNy0xMC41LTEyLjktNi4zTDc1Mi45IDMzNC4xYTggOCAwIDAwMyAxNC4xem0xNjcuNyAzMDEuMWwtNTYuNy0xOS41YTggOCAwIDAwLTEwLjEgNC44Yy0xLjkgNS4xLTMuOSAxMC4xLTYgMTUuMS0xNy44IDQyLjEtNDMuMyA4MC03NS45IDExMi41YTM1MyAzNTMgMCAwMS0xMTIuNSA3NS45IDM1Mi4xOCAzNTIuMTggMCAwMS0xMzcuNyAyNy44Yy00Ny44IDAtOTQuMS05LjMtMTM3LjctMjcuOGEzNTMgMzUzIDAgMDEtMTEyLjUtNzUuOWMtMzIuNS0zMi41LTU4LTcwLjQtNzUuOS0xMTIuNUEzNTMuNDQgMzUzLjQ0IDAgMDExNzEgNTEyYzAtNDcuOCA5LjMtOTQuMiAyNy44LTEzNy44IDE3LjgtNDIuMSA0My4zLTgwIDc1LjktMTEyLjVhMzUzIDM1MyAwIDAxMTEyLjUtNzUuOUM0MzAuNiAxNjcuMyA0NzcgMTU4IDUyNC44IDE1OHM5NC4xIDkuMyAxMzcuNyAyNy44QTM1MyAzNTMgMCAwMTc3NSAyNjEuN2MxMC4yIDEwLjMgMTkuOCAyMSAyOC42IDMyLjNsNTkuOC00Ni44Qzc4NC43IDE0Ni42IDY2Mi4yIDgxLjkgNTI0LjYgODIgMjg1IDgyLjEgOTIuNiAyNzYuNyA5NSA1MTYuNCA5Ny40IDc1MS45IDI4OC45IDk0MiA1MjQuOCA5NDJjMTg1LjUgMCAzNDMuNS0xMTcuNiA0MDMuNy0yODIuMyAxLjUtNC4yLS43LTguOS00LjktMTAuNHoiIC8+PC9zdmc+) */ const $fe6306538b66c213$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($fe6306538b66c213$var$HistoryOutlined);
var $fe6306538b66c213$export$2e2bcd8739ae039 = $fe6306538b66c213$var$RefIcon;








const { Option: $38b2872f002a5ac7$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $38b2872f002a5ac7$var$ContainerDetails = ()=>{
    const [deleteModal, setDeleteModal] = (0, $acw62.useState)(false);
    const [infoModal, setInfoModal] = (0, $acw62.useState)(false);
    const [size, setSize] = (0, $acw62.useState)();
    const [{ container: container, sizes: sizes, timeline: timeline, saveDisabled: saveDisabled, loading: loading, saving: saving, lending: lending, canLend: canLend, deleteDisabled: deleteDisabled }, { numberChanged: numberChanged, sizeChanged: sizeChanged, typeChanged: typeChanged, deleteContainer: deleteContainer, restoreContainer: restoreContainer, saveChanges: saveChanges, nameChanged: nameChanged, streetChanged: streetChanged, postalChanged: postalChanged, cityChanged: cityChanged, lendContainer: lendContainer, unlendContainer: unlendContainer, addContainerSize: addContainerSize }] = (0, $033c8b8bdf6243a5$export$2e2bcd8739ae039)();
    const actions = container?.state === 6 ? [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaf43360a8ccea7a$export$2e2bcd8739ae039), {}),
            loading: loading,
            onClick: restoreContainer,
            children: "Przywr\xf3\u0107 kontener"
        }, 0)
    ] : [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {}),
            loading: saving,
            onClick: saveChanges,
            disabled: saveDisabled,
            children: "Zapisz zmiany"
        }, 1),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "danger",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
            onClick: ()=>setDeleteModal(true),
            disabled: deleteDisabled,
            children: "Usu\u0144 kontener"
        }, 2)
    ];
    const getTimelineEvent = (event, i, arr)=>{
        const data = {};
        data.icon = i === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68369c637afb54bb$export$2e2bcd8739ae039), {
            style: {
                color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[5]
            }
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe6306538b66c213$export$2e2bcd8739ae039), {
            style: {
                color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[5]
            }
        });
        data.date = event.changed;
        switch(event.state){
            // Free
            case 0:
                if (i !== arr.length - 1 && arr[i + 1].state === 6) data.title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Przywr\xf3cony przez ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/drivers/${event.changed_by.id}`,
                            children: event.changed_by.name
                        }),
                        " - Baza"
                    ]
                });
                else if (event.date === container.created) data.title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Stworzony przez ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/drivers/${event.changed_by.id}`,
                            children: event.changed_by.name
                        }),
                        " - Baza"
                    ]
                });
                else data.title = 'Baza';
                break;
            // Delivered
            case 1:
                data.title = `W zam\xf3wieniu ${event.name} ${event.street}`;
                data.link = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${event.order_id}`,
                    children: "Szczeg\xf3\u0142y"
                });
                break;
            // Lended
            case 5:
                data.title = `Wypo\u{17C}yczony do ${event.name}${event.street ? ` na ${event.street}` : ''}`;
                break;
            // Deleted
            case 6:
                data.title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        "Usuniety przez ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/drivers/${event.changed_by.id}`,
                            children: event.changed_by.name
                        })
                    ]
                });
                break;
            default:
                data.title = 'Nieznane wydarzenie';
                break;
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8165f182d4056084$export$2e2bcd8739ae039).Item, {
            dot: data.icon,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(data.date)
                }),
                " - ",
                data.title,
                ". ",
                data.link
            ]
        }, `${i}`);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: container != undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
            actions: actions,
            title: `Kontenery / ${container.name}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "container-details flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Informacje",
                            width: 878,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                            size: 25,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Numer"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                            defaultValue: container.name,
                                                            type: "text",
                                                            size: "large",
                                                            disabled: container.state == 6,
                                                            onChange: numberChanged
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Rozmiar"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            defaultValue: container.size.id,
                                                            disabled: container.state === 6,
                                                            onChange: sizeChanged,
                                                            children: sizes?.map((size)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($38b2872f002a5ac7$var$Option, {
                                                                    value: size.id,
                                                                    children: size.name
                                                                }, size.id))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                            className: "circle flex flex-ac",
                                            type: "primary",
                                            size: "large",
                                            shape: "circle",
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
                                            onClick: ()=>setInfoModal(true)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                        size: 25,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Rodzaj"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        defaultValue: container.type,
                                                        type: "text",
                                                        size: "large",
                                                        disabled: container.state == 6,
                                                        onChange: typeChanged
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: "Utworzony:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "user-data",
                                                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(container.added)
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: "Przez:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `/panel/drivers/${container.added_by.id}`,
                                                                        children: [
                                                                            container.added_by.name,
                                                                            " ",
                                                                            container.added_by.surname
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            container.state === 6 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: "Usuni\u0119ty:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "user-data",
                                                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(container.changed)
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: "Przez:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `/panel/drivers/${container.changed_by.id}`,
                                                                        children: [
                                                                            container.changed_by.name,
                                                                            " ",
                                                                            container.changed_by.surname
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                container.state !== 6 && (container.state === 5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                                        title: "Wypo\u017Cyczanie",
                                        width: 878,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-aend",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: "Nazwa odbiorcy"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "lend",
                                                                                    children: container.lend.name
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: "Ulica i numer"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "lend",
                                                                                    children: container.lend.street ?? '-'
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: "Kod pocztowy"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "lend",
                                                                                    children: container.lend.postal ?? '-'
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: "Miasto"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                    className: "lend",
                                                                                    children: container.lend.city ?? '-'
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c091335ea63c232a$export$2e2bcd8739ae039), {}),
                                                    onClick: unlendContainer,
                                                    loading: lending,
                                                    children: "Wr\xf3\u0107 z wypo\u017Cyczenia"
                                                })
                                            ]
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                                    title: "Wypo\u017Cyczanie",
                                    width: 878,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                            size: 25,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Nazwa odbiorcy"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                            type: "text",
                                                            size: "large",
                                                            onChange: nameChanged
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Ulica i numer"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                            type: "text",
                                                            size: "large",
                                                            onChange: streetChanged
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                                    size: 25,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    children: "Kod pocztowy"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                                    type: "text",
                                                                    size: "large",
                                                                    onChange: postalChanged
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    children: "Miasto"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                                    type: "text",
                                                                    size: "large",
                                                                    onChange: cityChanged
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a82a141ad01d80f$export$2e2bcd8739ae039), {}),
                                                    onClick: lendContainer,
                                                    loading: lending,
                                                    disabled: !canLend,
                                                    children: "Wypo\u017Cycz kontener"
                                                })
                                            ]
                                        })
                                    ]
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Historia",
                            width: 878,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8165f182d4056084$export$2e2bcd8739ae039), {
                                children: timeline?.map(getTimelineEvent)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6fd0b816bbe13d58$export$2e2bcd8739ae039), {
                    visible: deleteModal,
                    onCancel: ()=>setDeleteModal(false),
                    onOk: ()=>deleteContainer(()=>setDeleteModal(false)),
                    loading: loading,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Czy na pewno chcesz usun\u0105\u0107 kontener"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "B\u0119dzie go mo\u017Cna p\xf3\u017Aniej przywr\xf3ci\u0107"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fc69d8460bb1eda3$export$2e2bcd8739ae039), {
                    width: 560,
                    visible: infoModal,
                    closable: false,
                    cancelText: "Anuluj",
                    okText: "Dodaj",
                    onCancel: ()=>setInfoModal(false),
                    onOk: ()=>{
                        addContainerSize(size);
                        setInfoModal(false);
                    },
                    icon: "plus",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Podaj nowy rozmiar"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            type: "text",
                            size: "large",
                            placeholder: "Nazwa",
                            value: size,
                            onChange: (e)=>setSize(e.target.value)
                        })
                    ]
                })
            ]
        }) : null
    });
};
var $38b2872f002a5ac7$export$2e2bcd8739ae039 = $38b2872f002a5ac7$var$ContainerDetails;




var $acw62 = parcelRequire("acw62");





const { Option: $1c340ea3a8de46d9$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $1c340ea3a8de46d9$var$NewContainer = ()=>{
    const [infoModal, setInfoModal] = (0, $acw62.useState)(false);
    const [{ container: container, disabled: disabled, loading: loading, sizes: sizes }, { nameChanged: nameChanged, sizeChanged: sizeChanged, typeChanged: typeChanged, createContainer: createContainer, addContainerSize: addContainerSize }] = (0, $f96a0f0e61d6aad7$export$2e2bcd8739ae039)();
    const [size, setSize] = (0, $acw62.useState)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            disabled: disabled,
            loading: loading,
            onClick: createContainer,
            children: "Dodaj kontener"
        }, "1")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Kontenery / Nowy",
        actions: actions,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "new-container flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Informacje",
                    width: 878,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 19,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Numer"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: container.name,
                                                    onChange: nameChanged
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Rozmiar"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    value: container.size,
                                                    onChange: sizeChanged,
                                                    children: sizes?.map((size)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1c340ea3a8de46d9$var$Option, {
                                                            value: size.id,
                                                            children: size.name
                                                        }, size.name))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    className: "flex flex-ac",
                                    type: "primary",
                                    size: "large",
                                    shape: "circle",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>setInfoModal(true)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 19,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-dir",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Rodzaj"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            size: "large",
                                            value: container.type,
                                            onChange: typeChanged
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fc69d8460bb1eda3$export$2e2bcd8739ae039), {
                width: 560,
                visible: infoModal,
                closable: false,
                cancelText: "Anuluj",
                okText: "Dodaj",
                onCancel: ()=>setInfoModal(false),
                onOk: ()=>{
                    addContainerSize(size);
                    setInfoModal(false);
                },
                icon: "plus",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Podaj nowy rozmiar"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                        type: "text",
                        size: "large",
                        placeholder: "Nazwa",
                        value: size,
                        onChange: (e)=>setSize(e.target.value)
                    })
                ]
            })
        ]
    });
};
var $1c340ea3a8de46d9$export$2e2bcd8739ae039 = $1c340ea3a8de46d9$var$NewContainer;



parcelRequire("acw62");





const { Option: $3454e82fe1769fcb$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $3454e82fe1769fcb$var$NewClient = ()=>{
    const [{ client: client, disabled: disabled, loading: loading, intent: intent }, { nameChanged: nameChanged, phoneChanged: phoneChanged, typeChanged: typeChanged, emailChanged: emailChanged, nipChanged: nipChanged, bdoChanged: bdoChanged, streetChanged: streetChanged, cityChanged: cityChanged, postalChanged: postalChanged, descriptionChanged: descriptionChanged, createClient: createClient }] = (0, $dbdcaac76c7accfa$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: createClient,
            disabled: disabled,
            loading: loading,
            children: [
                "Dodaj klienta",
                intent ? " i wr\xf3\u0107 do zamowienia" : ''
            ]
        }, 0)
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: 'Klienci / Nowy',
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "new-client flex",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                title: "Informacje",
                width: 902,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        className: "inputs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Nazwa"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: client.name,
                                        onChange: nameChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Typ"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                        size: "large",
                                        labelInValue: true,
                                        value: {
                                            value: client.type
                                        },
                                        onChange: typeChanged,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3454e82fe1769fcb$var$Option, {
                                                value: 0,
                                                children: "Firma"
                                            }, 0),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3454e82fe1769fcb$var$Option, {
                                                value: 1,
                                                children: "Osoba prywatna"
                                            }, 1)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        className: "inputs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Numer telefonu"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: client.phone,
                                        onChange: phoneChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: client.email,
                                        onChange: emailChanged
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        className: "inputs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Numer NIP"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: client.nip,
                                        onChange: nipChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Numer BDO"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: client.bdo,
                                        onChange: bdoChanged
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        className: "inputs",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Ulica"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                    type: "text",
                                    size: "large",
                                    value: client.street,
                                    onChange: streetChanged
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        className: "inputs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Miasto"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: client.city,
                                        onChange: cityChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Kod pocztowy"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: client.postal,
                                        onChange: postalChanged
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        children: "Opis"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).TextArea, {
                        rows: 3,
                        value: client.description,
                        onChange: descriptionChanged
                    })
                ]
            })
        })
    });
};
var $3454e82fe1769fcb$export$2e2bcd8739ae039 = $3454e82fe1769fcb$var$NewClient;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $1f1996d09b211a93$var$FileDoneOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 00-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "file-done",
    "theme": "outlined"
};
var $1f1996d09b211a93$export$2e2bcd8739ae039 = $1f1996d09b211a93$var$FileDoneOutlined;



function $eed06595af8fdbfa$var$_extends() {
    $eed06595af8fdbfa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eed06595af8fdbfa$var$_extends.apply(this, arguments);
}
const $eed06595af8fdbfa$var$FileDoneOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $eed06595af8fdbfa$var$_extends({}, props, {
        ref: ref,
        icon: (0, $1f1996d09b211a93$export$2e2bcd8739ae039)
    }));
/**![file-done](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY4OCAzMTJ2LTQ4YzAtNC40LTMuNi04LTgtOEgyOTZjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMzg0YzQuNCAwIDgtMy42IDgtOHptLTM5MiA4OGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgxODRjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThIMjk2em0zNzYgMTE2Yy0xMTkuMyAwLTIxNiA5Ni43LTIxNiAyMTZzOTYuNyAyMTYgMjE2IDIxNiAyMTYtOTYuNyAyMTYtMjE2LTk2LjctMjE2LTIxNi0yMTZ6bTEwNy41IDMyMy41Qzc1MC44IDg2OC4yIDcxMi42IDg4NCA2NzIgODg0cy03OC44LTE1LjgtMTA3LjUtNDQuNUM1MzUuOCA4MTAuOCA1MjAgNzcyLjYgNTIwIDczMnMxNS44LTc4LjggNDQuNS0xMDcuNUM1OTMuMiA1OTUuOCA2MzEuNCA1ODAgNjcyIDU4MHM3OC44IDE1LjggMTA3LjUgNDQuNUM4MDguMiA2NTMuMiA4MjQgNjkxLjQgODI0IDczMnMtMTUuOCA3OC44LTQ0LjUgMTA3LjV6TTc2MSA2NTZoLTQ0LjNjLTIuNiAwLTUgMS4yLTYuNSAzLjNsLTYzLjUgODcuOC0yMy4xLTMxLjlhNy45MiA3LjkyIDAgMDAtNi41LTMuM0g1NzNjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDczLjggMTAyLjFjMy4yIDQuNCA5LjcgNC40IDEyLjkgMGwxMTQuMi0xNThjMy45LTUuMy4xLTEyLjctNi40LTEyLjd6TTQ0MCA4NTJIMjA4VjE0OGg1NjB2MzQ0YzAgNC40IDMuNiA4IDggOGg1NmM0LjQgMCA4LTMuNiA4LThWMTA4YzAtMTcuNy0xNC4zLTMyLTMyLTMySDE2OGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2Nzg0YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDI3MmM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $eed06595af8fdbfa$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($eed06595af8fdbfa$var$FileDoneOutlined);
var $eed06595af8fdbfa$export$2e2bcd8739ae039 = $eed06595af8fdbfa$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d2aae9c70f95b598$var$PrinterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            }
        ]
    },
    "name": "printer",
    "theme": "outlined"
};
var $d2aae9c70f95b598$export$2e2bcd8739ae039 = $d2aae9c70f95b598$var$PrinterOutlined;



function $2a66bc520ace0c83$var$_extends() {
    $2a66bc520ace0c83$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a66bc520ace0c83$var$_extends.apply(this, arguments);
}
const $2a66bc520ace0c83$var$PrinterOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $2a66bc520ace0c83$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d2aae9c70f95b598$export$2e2bcd8739ae039)
    }));
/**![printer](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgyMCA0MzZoLTQwYy00LjQgMC04IDMuNi04IDh2NDBjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNDBjMC00LjQtMy42LTgtOC04em0zMi0xMDRINzMyVjEyMGMwLTQuNC0zLjYtOC04LThIMzAwYy00LjQgMC04IDMuNi04IDh2MjEySDE3MmMtNDQuMiAwLTgwIDM1LjgtODAgODB2MzI4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDE2OHYxMzJjMCA0LjQgMy42IDggOCA4aDQyNGM0LjQgMCA4LTMuNiA4LThWNzcyaDE2OGMxNy43IDAgMzItMTQuMyAzMi0zMlY0MTJjMC00NC4yLTM1LjgtODAtODAtODB6TTM2MCAxODBoMzA0djE1MkgzNjBWMTgwem0zMDQgNjY0SDM2MFY1NjhoMzA0djI3NnptMjAwLTE0MEg3MzJWNTAwSDI5MnYyMDRIMTYwVjQxMmMwLTYuNiA1LjQtMTIgMTItMTJoNjgwYzYuNiAwIDEyIDUuNCAxMiAxMnYyOTJ6IiAvPjwvc3ZnPg==) */ const $2a66bc520ace0c83$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2a66bc520ace0c83$var$PrinterOutlined);
var $2a66bc520ace0c83$export$2e2bcd8739ae039 = $2a66bc520ace0c83$var$RefIcon;








var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");
const $2a51a7764ef6b376$var$PrintTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
	width: 100%;
	page-break-inside: auto;

	tr {
		page-break-inside: avoid;
		page-break-after: auto;

		&.data:nth-child(2n) {
			background: #eee;
		}

		&.sectionHeader > th {
			font-size: 12px;
			font-weight: 500;
		}

		> td,
		> th {
			padding: 4px 8px;
			text-align: center;
			border: 1px solid #000;
		}

		> th {
			font-size: 14px;
		}

		> td {
			font-size: 10px;
		}
	}
`;
const $2a51a7764ef6b376$var$CardPrint = ({ user: user, events: events, card: card, summary: summary, date: date })=>{
    if (!user || !events || !card || !summary || !date) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    const { advances: advances, payments: payments, expenses: expenses, settlements: settlements } = summary;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "print",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2a51a7764ef6b376$var$PrintTable, {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                children: card.plate
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                colSpan: "4",
                                children: [
                                    "Karta Drogowa - ",
                                    user.name,
                                    " ",
                                    user.surname
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(date, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            colSpan: "6",
                            children: "Podstawienia"
                        })
                    }),
                    events.filter((e)=>e._type >= 0 && e._type <= 1).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        className: "sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "L.P."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Godzina"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Adres"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "P\u0142atno\u015B\u0107"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Kwota"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Zaliczka"
                            })
                        ]
                    }),
                    events.filter((e)=>e._type === 0).map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: i + 1
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.delivery_taken).format('HH:mm'),
                                        " - ",
                                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.delivery_done).format('HH:mm')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: e.address
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: e.payment_type ? `Got\xf3wka - ${e.payment === e.delivery_done ? 'pobrana' : 'niepobrana'}` : 'Przelew'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(e.price),
                                        " ",
                                        e.price_type ? 'Brutto' : 'Netto'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: e.advance ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(e.advance) : 'Brak'
                                })
                            ]
                        })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            colSpan: "6",
                            children: "Odbiory"
                        })
                    }),
                    events.filter((e)=>e._type === 1).map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: i + 1
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.claiming_taken).format('HH:mm'),
                                        " - ",
                                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.claiming_done).format('HH:mm')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: e.address
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: e.payment_type ? `Got\xf3wka - ${e.payment === e.claiming_done ? 'pobrana' : 'niepobrana'}` : 'Przelew'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(e.price),
                                        " ",
                                        e.price_type ? 'Brutto' : 'Netto'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: e.advance ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(e.advance) : 'Brak'
                                })
                            ]
                        })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            colSpan: "6",
                            children: "Wydatki"
                        })
                    }),
                    events.filter((e)=>e._type === 2).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        className: "sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "L.P."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Godzina"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Typ i nazwa"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Kwota"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Podatek"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Przebieg"
                            })
                        ]
                    }),
                    events.filter((e)=>e._type === 2).map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: i + 1
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.created).format('HH:mm')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        e.type.name,
                                        " - ",
                                        e.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(e.value),
                                        " ",
                                        e.value_type ? 'Brutto' : 'Netto'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        e.tax,
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: e.mileage ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(e.mileage) : '-'
                                })
                            ]
                        })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            colSpan: "6",
                            children: "Wydania got\xf3wki"
                        })
                    }),
                    events.filter((e)=>e._type === 3).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        className: "sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "L.P."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Godzina"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Kwota"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                colSpan: "3",
                                children: "Odebra\u0142"
                            })
                        ]
                    }),
                    events.filter((e)=>e._type === 3).map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: i + 1
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.created).format('HH:mm')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(e.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "3",
                                    children: [
                                        e.created_by.name,
                                        " ",
                                        e.created_by.surname
                                    ]
                                })
                            ]
                        })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            colSpan: "6",
                            children: "Podsumowanie"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                colSpan: "3",
                                children: [
                                    "Pobrane od klient\xf3w: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(advances + payments)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                colSpan: "3",
                                children: [
                                    "Wydane: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(expenses + settlements)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    "Zaliczki: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(advances)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                colSpan: "2",
                                children: [
                                    "Zap\u0142aty: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(payments)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    "Wydatki: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(expenses)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                colSpan: "2",
                                children: [
                                    "Pobrania got\xf3wki: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(settlements)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                            colSpan: "6",
                            children: [
                                "Balans: ",
                                (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(advances + payments - expenses - settlements)
                            ]
                        })
                    }),
                    card.id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    colSpan: "6",
                                    children: "Karta"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: "2",
                                        children: [
                                            "Licznik pocz\u0105tek: ",
                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(card.mileage_start)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: "2",
                                        children: [
                                            "Licznik koniec: ",
                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(card.mileage_end)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: "2",
                                        children: [
                                            "Suma km: ",
                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(card.mileage_end - card.mileage_start)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: "3",
                                        children: [
                                            "Czas jazdy: ",
                                            card.time
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: "3",
                                        children: [
                                            "Karta zamkni\u0119ta: ",
                                            card.plate
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
class $2a51a7764ef6b376$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2a51a7764ef6b376$var$CardPrint, {
            ...this.props
        });
    }
}




var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");

const $037cb49b99387dc8$var$PrintTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
	width: 100%;
	page-break-inside: auto;

	tr {
		page-break-inside: avoid;
		page-break-after: auto;

		&:nth-child(2n) {
			background: #eee;
		}

		> td,
		> th {
			padding: 4px 8px;
			text-align: center;
		}

		> th {
			font-size: 14px;

			> div {
				display: flex;
				flex-direction: column;

				> h5 {
					font-weight: 600;
					margin-bottom: 4px;
				}

				> span {
					font-weight: 400;
					font-size: 8px;
				}
			}
		}

		> td {
			font-size: 10px;

			> div {
				display: flex;
				flex-direction: column;

				> h6 {
					font-weight: 600;
					font-size: 12px;
					margin-bottom: 2px;
				}
			}
		}
	}
`;
const $037cb49b99387dc8$var$PrintTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h2`
	width: 100%;
	margin-top: 16px;
	margin-bottom: 8px;
	text-align: center;
	font-size: 18px;
`;
const $037cb49b99387dc8$var$PrintSubtitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h3`
	width: 100%;
	margin-top: 16px;
	margin-bottom: 32px;
	text-align: center;
	font-size: 14px;
`;
const $037cb49b99387dc8$var$DayTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($037cb49b99387dc8$var$PrintSubtitle)`
	margin-top: 48px;
`;
const $037cb49b99387dc8$var$Summary = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h4`
	text-align: center;
	margin: 0;
	font-weight: 400;

	&:first-of-type {
		margin-top: 32px;
	}
`;
const $037cb49b99387dc8$var$ClientOrdersPrint = ({ client: client, orders: orders })=>{
    if (!orders) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    const days = orders.reduce((acc, order)=>{
        const date = order.date;
        const dateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format('DD.MM.YYYY');
        if (!acc[dateString]) acc[dateString] = [];
        acc[dateString].push(order);
        return acc;
    }, {});
    const totalSum = orders.reduce((acc, order)=>acc + order.grossPrice, 0);
    const unpaidSum = orders.reduce((acc, order)=>{
        if (order.paymentState !== (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).unpaid) return acc;
        const leftToPay = order.grossPrice - order.alreadyPaid;
        return acc + Math.max(0, leftToPay);
    }, 0);
    const overdueSum = orders.reduce((acc, order)=>{
        if (order.paymentState !== (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).overdue) return acc;
        const leftToPay = order.grossPrice - order.alreadyPaid;
        return acc + Math.max(0, leftToPay);
    }, 0);
    let k = 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "print",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($037cb49b99387dc8$var$PrintTitle, {
                children: [
                    "Wydruk zam\xf3wie\u0144 dla klienta ",
                    client.name,
                    client.street && client.city && client.postal && ` - ${client.street}, ${client.city} ${client.postal}`
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($037cb49b99387dc8$var$PrintSubtitle, {
                children: [
                    "Stan z dnia ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(new Date())
                ]
            }),
            Object.entries(days).map(([day, orders])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($037cb49b99387dc8$var$DayTitle, {
                            children: day
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($037cb49b99387dc8$var$PrintTable, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "LP"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "w grupie"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Klient"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Nazwa"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "NIP"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Email"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Cena"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Brutto / Netto"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Typ p\u0142atno\u015Bci"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Adres"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "BDO"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Rodzaj odpad\xf3w"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Faktura"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Data"
                                            })
                                        ]
                                    }),
                                    orders.map((order, j)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    style: {
                                                        background: (0, $99be6b3f30de3bdd$export$e4bbcb8f9590e757)(order),
                                                        minWidth: '100px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: ++k
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: j + 1
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: client.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: client.nip
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: client.email
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net ? order.netPrice : order.grossPrice)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(order.priceType)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $83530e2bf16dcece$export$a90a64e69a78f544)(order.wantedPaymentType)
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: order.address
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $5635f57e16062a6d$export$b6098f7faad3052e)(order.bdo)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.wasteType
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: order.invoiceDate ?? '-'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.date, true)
                                                })
                                            ]
                                        }, order.id))
                                ]
                            })
                        })
                    ]
                }, day)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($037cb49b99387dc8$var$Summary, {
                children: [
                    "Nieop\u0142acone (minus zaliczki): ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(unpaidSum)
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($037cb49b99387dc8$var$Summary, {
                children: [
                    "Zaleg\u0142e (minus zaliczki): ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(overdueSum)
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($037cb49b99387dc8$var$Summary, {
                children: [
                    "\u0141\u0105czna kwota zam\xf3wie\u0144 brutto: ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalSum)
                ]
            })
        ]
    }, client.id);
};
class $037cb49b99387dc8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($037cb49b99387dc8$var$ClientOrdersPrint, {
            ...this.props
        });
    }
}




var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");
const $c36868b44170ec8a$var$Print = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div``;
const $c36868b44170ec8a$var$PrintTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
	width: 100%;
	page-break-inside: auto;

	tr {
		page-break-inside: avoid;
		page-break-after: auto;

		&:nth-child(2n) {
			background: #eee;
		}

		> td,
		> th {
			padding: 4px 8px;
			text-align: center;
		}

		> th {
			font-size: 14px;

			> div {
				display: flex;
				flex-direction: column;

				> h5 {
					font-weight: 600;
					margin-bottom: 4px;
				}

				> span {
					font-weight: 400;
					font-size: 8px;
				}
			}
		}

		> td {
			font-size: 10px;

			> div {
				display: flex;
				flex-direction: column;

				> h6 {
					font-weight: 600;
					font-size: 12px;
					margin-bottom: 2px;
				}
			}
		}
	}
`;
const $c36868b44170ec8a$var$PrintTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h2`
	width: 100%;
	margin-top: 16px;
	margin-bottom: 8px;
	text-align: center;
	font-size: 18px;
`;
const $c36868b44170ec8a$var$PrintSubtitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h3`
	width: 100%;
	margin-top: 16px;
	margin-bottom: 32px;
	text-align: center;
	font-size: 14px;
`;
const $c36868b44170ec8a$var$DayTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c36868b44170ec8a$var$PrintSubtitle)`
	margin-top: 48px;
`;
const $c36868b44170ec8a$var$Summary = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h4`
	text-align: center;
	margin: ${({ first: first })=>first ? '24px' : '0'} 0 0 0;
	font-weight: 400;
`;
const $c36868b44170ec8a$var$SummaryTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h3`
	text-align: center;
	margin: 32px 0 0 0;
	font-weight: 500;
`;
const $c36868b44170ec8a$var$ExpensesPrint = ({ expenses: expenses, month: month })=>{
    if (!expenses) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    const getName = (expense)=>{
        switch(expense._type){
            // Expenses
            case 0:
                return expense.name;
            // Settlements
            case 1:
                return "Pobranie got\xf3wki";
            // Advances
            case 2:
                return `Zaliczka - ${expense.address}`;
            // Owns
            case 3:
                return `Zam\xf3wienie w\u{142}asne - ${expense.to}`;
        }
    };
    const getValue = (expense)=>{
        if (expense._type === 3) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            children: [
                (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(expense.weight ?? ''),
                " kg"
            ]
        });
        return (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(expense.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c36868b44170ec8a$var$Print, {
        className: "print",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c36868b44170ec8a$var$PrintTitle, {
                children: [
                    "Wydruk wydatk\xf3w na miesi\u0105c ",
                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(month).startOf('month').format('MMMM yyyy')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c36868b44170ec8a$var$PrintSubtitle, {
                children: [
                    "Stan z dnia ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(Date.now())
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c36868b44170ec8a$var$PrintTable, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Data"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Nazwa"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Kwota"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                children: "Dodane przez"
                            })
                        ]
                    }),
                    expenses.map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(e.created)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: getName(e)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    children: getValue(e)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    children: [
                                        e.created_by?.name,
                                        " ",
                                        e.created_by?.surname
                                    ]
                                })
                            ]
                        }))
                ]
            })
        ]
    });
};
class $c36868b44170ec8a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c36868b44170ec8a$var$ExpensesPrint, {
            ...this.props
        });
    }
}




var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");


const $c556ec38436a7840$var$Print = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div``;
const $c556ec38436a7840$var$PrintTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
	width: 100%;
	page-break-inside: auto;

	tr {
		page-break-inside: avoid;
		page-break-after: auto;

		&:nth-child(2n) {
			background: #eee;
		}

		> td,
		> th {
			padding: 4px 8px;
			text-align: center;
		}

		> th {
			font-size: 14px;

			> div {
				display: flex;
				flex-direction: column;

				> h5 {
					font-weight: 600;
					margin-bottom: 4px;
				}

				> span {
					font-weight: 400;
					font-size: 8px;
				}
			}
		}

		> td {
			font-size: 10px;

			> div {
				display: flex;
				flex-direction: column;

				> h6 {
					font-weight: 600;
					font-size: 12px;
					margin-bottom: 2px;
				}
			}
		}
	}
`;
const $c556ec38436a7840$var$PrintTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h2`
	width: 100%;
	margin-top: 16px;
	margin-bottom: 8px;
	text-align: center;
	font-size: 18px;
`;
const $c556ec38436a7840$var$PrintSubtitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h3`
	width: 100%;
	margin-top: 16px;
	margin-bottom: 32px;
	text-align: center;
	font-size: 14px;
`;
const $c556ec38436a7840$var$DayTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c556ec38436a7840$var$PrintSubtitle)`
	margin-top: 48px;
`;
const $c556ec38436a7840$var$Summary = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h4`
	text-align: center;
	margin: ${({ first: first })=>first ? '24px' : '0'} 0 0 0;
	font-weight: 400;
`;
const $c556ec38436a7840$var$SummaryTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h3`
	text-align: center;
	margin: 32px 0 0 0;
	font-weight: 500;
`;
const $c556ec38436a7840$var$PageBreak = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	&:not(:last-of-type) {
		page-break-after: always;
	}
`;
const $c556ec38436a7840$var$PriceChangeOrderTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).tr`
	margin-top: 24px;

	> td {
		padding: 6px 8px;
		font-size: 10px;
		vertical-align: middle;

		&:first-child {
			font-weight: 700;
			font-size: 11px;
			width: 80px;
			text-align: center;
			color: white;
		}

		> strong {
			display: block;
			font-size: 12px;
			margin-bottom: 2px;
		}
	}
`;
const $c556ec38436a7840$var$getColor = (order, type)=>{
    if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).classic) {
        if (order.onPlace) return (0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5];
        switch(type){
            case 'delivery':
                return (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5];
            case 'replacement':
                return (0, $0b4842326956570d$export$c24201f7fe3571d8)[5];
            case 'claiming':
                return (0, $0b4842326956570d$export$a90204d1394caf30)[5];
        }
    }
    if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).loose) {
        if (order.onPlace) return (0, $0b4842326956570d$export$2a9ca2e383622e18)[3];
        switch(type){
            case 'delivery':
                return (0, $0b4842326956570d$export$7474046f446842ee)[4];
            case 'replacement':
                return (0, $0b4842326956570d$export$2a9ca2e383622e18)[3];
            case 'claiming':
                return (0, $0b4842326956570d$export$2a9ca2e383622e18)[3];
        }
    }
    return (0, $0b4842326956570d$export$e63a1643b2f79b16)[5];
};
const $c556ec38436a7840$var$getReadableType = (order, type)=>{
    if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).classic) {
        if (order.onPlace) return "Za\u0142adunek";
        switch(type){
            case 'delivery':
                return 'Podstawienie';
            case 'replacement':
                return 'Wymiana';
            case 'claiming':
                return "Odbi\xf3r";
        }
    }
    if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).loose) {
        if (order.onPlace) return "Za\u0142adunek";
        switch(type){
            case 'delivery':
                return 'Podstawienie';
            case 'claiming':
                return "Odbi\xf3r";
        }
    }
    return 'Nieznany typ';
};
const $c556ec38436a7840$var$FinancesPrint = ({ from: from, to: to, orders: orders, priceChanges: priceChanges, users: users })=>{
    if (!orders) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    const deliveriesByDay = orders.reduce((acc, order)=>{
        const dateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.deliveryDate).format('DD.MM.YYYY');
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.deliveryDate).isBetween(from, to)) return acc;
        const entry = acc[dateString] ?? [];
        entry.push(order);
        return {
            ...acc,
            [dateString]: entry
        };
    }, {});
    const claimingsByDay = orders.reduce((acc, order)=>{
        if (!order.claimingDate) return acc;
        if (order.onPlace) return acc;
        if (order.relatedId && order.relatedId > order.id) // Skip orders that were replaced by another order
        return acc;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.claimingDate).isBetween(from, to)) return acc;
        const dateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.claimingDate).format('DD.MM.YYYY');
        const entry = acc[dateString] ?? [];
        entry.push(order);
        return {
            ...acc,
            [dateString]: entry
        };
    }, {});
    const allDays = new Set([
        ...Object.keys(deliveriesByDay),
        ...Object.keys(claimingsByDay)
    ]);
    const ordersByDay = Object.fromEntries(Array.from(allDays).map((day)=>{
        const deliveries = deliveriesByDay[day] ?? [];
        const claimings = claimingsByDay[day] ?? [];
        return [
            day,
            {
                deliveries: deliveries,
                claimings: claimings
            }
        ];
    }));
    const totalNetIncome = orders.reduce((acc, order)=>acc + order.netPrice, 0);
    const totalNetCashIncome = orders.reduce((acc, order)=>order.wantedPaymentType === (0, $83530e2bf16dcece$export$439d2d6c03747598).cash ? acc + order.netPrice : acc, 0);
    const totalGrossIncome = orders.reduce((acc, order)=>acc + order.grossPrice, 0);
    const totalGrossCashIncome = orders.reduce((acc, order)=>order.wantedPaymentType === (0, $83530e2bf16dcece$export$439d2d6c03747598).cash ? acc + order.grossPrice : acc, 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$Print, {
        className: "print",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$PrintTitle, {
                children: [
                    "Wydruk zam\xf3wie\u0144 mi\u0119dzy ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(from, true),
                    " a ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(to, true)
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$PrintSubtitle, {
                children: [
                    "Stan z dnia ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(Date.now())
                ]
            }),
            Object.entries(ordersByDay).map(([day, orders])=>{
                // const netIncome = orders.reduce<number>((acc, order) => acc + order.netPrice, 0);
                // const netCashIncome = orders.reduce<number>(
                // 	(acc, order) => (order.wantedPaymentType === PaymentType.cash ? acc + order.netPrice : acc),
                // 	0
                // );
                // const grossIncome = orders.reduce<number>((acc, order) => acc + order.grossPrice, 0);
                // const grossCashIncome = orders.reduce<number>(
                // 	(acc, order) => (order.wantedPaymentType === PaymentType.cash ? acc + order.grossPrice : acc),
                // 	0
                // );
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$DayTitle, {
                            children: [
                                "Podstawienia ",
                                day,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c556ec38436a7840$var$PrintTable, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Rodzaj"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Klient"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Nazwa"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "NIP"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Email"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Cena"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Brutto / Netto"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Typ p\u0142atno\u015Bci"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Adres"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "BDO"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Rodzaj odpad\xf3w"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Faktura"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Data"
                                            })
                                        ]
                                    }),
                                    orders.deliveries.map((order, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    style: {
                                                        background: $c556ec38436a7840$var$getColor(order, order.wasReplacement ? 'replacement' : 'delivery'),
                                                        minWidth: '100px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: i + 1
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: order.type == (0, $b9894ce465f84cba$export$168ff345f0815589).classic ? 'Kontener' : 'Big Bag'
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: $c556ec38436a7840$var$getReadableType(order, order.wasReplacement ? 'replacement' : 'delivery')
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.client.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.client.nip
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.client.email
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net ? order.netPrice : order.grossPrice)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(order.priceType)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $83530e2bf16dcece$export$a90a64e69a78f544)(order.wantedPaymentType)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.grossPrice > order.paid ? "Nieop\u0142acone" : "Op\u0142acone"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: order.address
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $5635f57e16062a6d$export$b6098f7faad3052e)(order.bdo)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.wasteType
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: order.invoice ?? '-'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.deliveryDate, true)
                                                })
                                            ]
                                        }, `delivery-${order.id}-${order.type}`))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$DayTitle, {
                            children: [
                                "Odbiory ",
                                day,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c556ec38436a7840$var$PrintTable, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Rodzaj"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Klient"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Nazwa"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "NIP"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Email"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Cena"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Brutto / Netto"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Typ p\u0142atno\u015Bci"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                            children: "Adres"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "BDO"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: "Rodzaj odpad\xf3w"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Faktura"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Data"
                                            })
                                        ]
                                    }),
                                    orders.claimings.map((order, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    style: {
                                                        background: $c556ec38436a7840$var$getColor(order, 'claiming'),
                                                        minWidth: '100px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: i + 1
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: order.type == (0, $b9894ce465f84cba$export$168ff345f0815589).classic ? 'Kontener' : 'Big Bag'
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: $c556ec38436a7840$var$getReadableType(order, 'claiming')
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.client.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.client.nip
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.client.email
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net ? order.netPrice : order.grossPrice)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(order.priceType)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $83530e2bf16dcece$export$a90a64e69a78f544)(order.wantedPaymentType)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.grossPrice > order.paid ? "Nieop\u0142acone" : "Op\u0142acone"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: order.address
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: (0, $5635f57e16062a6d$export$b6098f7faad3052e)(order.bdo)
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.wasteType
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: order.invoice ?? '-'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claimingDate, true)
                                                })
                                            ]
                                        }, `claiming-${order.id}-${order.type}`))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c556ec38436a7840$var$PageBreak, {})
                    ]
                }, day);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c556ec38436a7840$var$SummaryTitle, {
                children: "Sumarycznie:"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$Summary, {
                children: [
                    "Przych\xf3d brutto: ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalGrossIncome),
                    " (",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalGrossCashIncome),
                    " got\xf3wka)",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "Przych\xf3d netto: ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalNetIncome),
                    " (",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalNetCashIncome),
                    " got\xf3wka)"
                ]
            }),
            priceChanges && priceChanges.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$SummaryTitle, {
                        children: [
                            "Zmiany cen (",
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(from, true),
                            " \u2014 ",
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(to, true),
                            "):"
                        ]
                    }),
                    priceChanges.map((order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c556ec38436a7840$var$PrintTable, {
                                style: {
                                    marginTop: '24px'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c556ec38436a7840$var$PriceChangeOrderTitle, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    style: {
                                                        background: order.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic ? (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5] : (0, $0b4842326956570d$export$7474046f446842ee)[4]
                                                    },
                                                    children: order.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic ? 'Kontener' : 'Big Bag'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: order.client
                                                        }),
                                                        order.address
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: order.wasteType
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net ? order.netPrice : order.grossPrice)
                                                        }),
                                                        (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(order.priceType)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Data podstawienia"
                                                        }),
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.deliveryDate, true)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    style: {
                                                        width: '24px',
                                                        padding: 0
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    style: {
                                                        fontSize: '8px'
                                                    },
                                                    children: "Data zmiany"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    style: {
                                                        fontSize: '8px'
                                                    },
                                                    children: "Przez"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    style: {
                                                        fontSize: '8px'
                                                    },
                                                    children: "Stara cena"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    style: {
                                                        fontSize: '8px'
                                                    },
                                                    children: "Nowa cena"
                                                })
                                            ]
                                        }),
                                        order.priceChanges.map((change)=>{
                                            const user = users?.find((u)=>u.id === change.createdBy);
                                            const oldPrice = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(change.oldPriceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? change.oldGrossPrice : change.oldNetPrice);
                                            const newPrice = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(change.newPriceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? change.newGrossPrice : change.newNetPrice);
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            width: '24px',
                                                            padding: 0
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            fontSize: '8px'
                                                        },
                                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(change.createdAt)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        style: {
                                                            fontSize: '8px'
                                                        },
                                                        children: user ? `${user.name} ${user.surname}` : `ID: ${change.createdBy}`
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        style: {
                                                            fontSize: '8px'
                                                        },
                                                        children: [
                                                            oldPrice,
                                                            " (",
                                                            (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(change.oldPriceType),
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        style: {
                                                            fontSize: '8px'
                                                        },
                                                        children: [
                                                            newPrice,
                                                            " (",
                                                            (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(change.newPriceType),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }, change.id);
                                        })
                                    ]
                                })
                            })
                        }, `${order.orderType}-${order.orderId}`))
                ]
            })
        ]
    });
};
class $c556ec38436a7840$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c556ec38436a7840$var$FinancesPrint, {
            ...this.props
        });
    }
}




var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");
const $02f12f5ef8a84097$var$PrintTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
	width: 100%;
	page-break-inside: auto;
	font-size: ${({ print: print })=>print ? '14px' : '18px'};

	tr {
		page-break-inside: avoid;
		page-break-after: auto;

		&.data:nth-child(2n) {
			background: #eee;
		}

		&.sectionHeader > th {
			font-size: 0.85em;
			font-weight: 500;
		}

		> td,
		> th {
			padding: 4px 8px;
			text-align: center;
			border: 1px solid #000;
		}

		> th {
			font-size: 1em;
		}

		> td {
			font-size: 0.7em;

			&.expense-sum {
				font-weight: 600;
			}
		}
	}
`;
const $02f12f5ef8a84097$var$Title = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h2`
	&&& {
		text-align: center;
		margin-bottom: 16px;
	}
`;
const $02f12f5ef8a84097$var$StatsPrint = ({ expenseTypes: expenseTypes, stats: stats, after: after, before: before, print: print })=>{
    if (!after || !before || !expenseTypes || !stats) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `print ${print ? '' : 'visible'}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($02f12f5ef8a84097$var$Title, {
                children: [
                    "Statystyki dochod\xf3w: ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(after, true),
                    " - ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(before, true),
                    ".",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "Stan z dnia ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(), true)
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($02f12f5ef8a84097$var$PrintTable, {
                print: print,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                colSpan: "6",
                                children: "Przychody z zam\xf3wie\u0144:"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "2",
                                    children: [
                                        "Got\xf3wka: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.orders.cash)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "2",
                                    children: [
                                        "Przelew: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.orders.transfer)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "2",
                                    children: [
                                        "Suma: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.orders.cash + stats.orders.transfer)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "3",
                                    children: [
                                        "Netto: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.orders.net)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "3",
                                    children: [
                                        "Brutto: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.orders.gross)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                colSpan: "6",
                                children: [
                                    "Przych\xf3d z zam\xf3wie\u0144 innych: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.incomes.sum)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                colSpan: "6",
                                children: "Wydatki:"
                            })
                        }),
                        Object.entries(stats.expenses.sum).map(([k, v])=>{
                            const typeName = expenseTypes.filter((e)=>e.id == k)[0]?.name;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                colSpan: "3",
                                                children: [
                                                    typeName,
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "3",
                                                children: v.expenses.length
                                            })
                                        ]
                                    }, `${k}-0`),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                colSpan: "2",
                                                className: "expense-sum",
                                                children: [
                                                    "Netto: ",
                                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(v.net)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                colSpan: "2",
                                                className: "expense-sum",
                                                children: [
                                                    "Brutto: ",
                                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(v.gross)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                colSpan: "2",
                                                className: "expense-sum",
                                                children: [
                                                    "Podatek: ",
                                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(v.gross - v.net)
                                                ]
                                            })
                                        ]
                                    }, `${k}-1`),
                                    v.expenses.map((expense)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "2",
                                                    children: expense.name ?? '-'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    colSpan: "2",
                                                    children: [
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(expense.value),
                                                        " (",
                                                        expense.value_type ? 'Brutto' : 'Netto',
                                                        " ",
                                                        expense.tax,
                                                        "%)"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: "2",
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(expense.created)
                                                })
                                            ]
                                        }, `${k}-${expense.id}`))
                                ]
                            });
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                colSpan: "6",
                                children: "Podsumowanie:"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                colSpan: "6",
                                children: [
                                    "\u0141\u0105czny przych\xf3d: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.orders.cash + stats.orders.transfer + stats.incomes.sum)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "2",
                                    children: [
                                        "Wydatki netto: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.expenses.net)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "2",
                                    children: [
                                        "Wydatki brutto: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.expenses.gross)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                    colSpan: "2",
                                    children: [
                                        "Podatek: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(stats.expenses.gross - stats.expenses.net)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                colSpan: "6",
                                children: "Rodzaje kontener\xf3w:"
                            })
                        }),
                        Object.entries(stats.containers).sort((a, b)=>b[1] - a[1]).map(([name, { count: count, net: net, gross: gross }])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "3",
                                        children: name.charAt(0).toUpperCase() + name.slice(1)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        children: [
                                            "Netto: ",
                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(net),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Brutto: ",
                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(gross)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: "3",
                                        children: [
                                            "Ilo\u015B\u0107: ",
                                            count
                                        ]
                                    })
                                ]
                            })),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                colSpan: "6",
                                children: "Rodzaje work\xf3w:"
                            })
                        }),
                        Object.entries(stats.bags).sort((a, b)=>b[1] - a[1]).map(([name, { count: count, net: net, gross: gross }])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "3",
                                        children: name.charAt(0).toUpperCase() + name.slice(1)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        children: [
                                            "Netto: ",
                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(net),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Brutto: ",
                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(gross)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        colSpan: "2",
                                        children: [
                                            "Ilo\u015B\u0107: ",
                                            count
                                        ]
                                    })
                                ]
                            }))
                    ]
                })
            })
        ]
    });
};
class $02f12f5ef8a84097$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($02f12f5ef8a84097$var$StatsPrint, {
            ...this.props
        });
    }
}





var $06d61c41acc2a072$exports = {};


!function(e, t) {
    $06d61c41acc2a072$exports = t((parcelRequire("acw62")), (parcelRequire("1u0KT")));
}("undefined" != typeof self ? self : $06d61c41acc2a072$exports, function(e, t) {
    return function() {
        "use strict";
        var r = {
            328: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PrintContextConsumer = t.PrintContext = void 0;
                var n = r(496), o = Object.prototype.hasOwnProperty.call(n, "createContext");
                t.PrintContext = o ? n.createContext({}) : null, t.PrintContextConsumer = t.PrintContext ? t.PrintContext.Consumer : function() {
                    return null;
                };
            },
            428: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ReactToPrint = void 0;
                var n = r(316), o = r(496), i = r(190), a = r(328), c = r(940), s = function(e) {
                    function t() {
                        var t = e.apply(this, n.__spreadArray([], n.__read(arguments), !1)) || this;
                        return t.startPrint = function(e) {
                            var r = t.props, n = r.onAfterPrint, o = r.onPrintError, i = r.print, a = r.documentTitle;
                            setTimeout(function() {
                                var r, c;
                                if (e.contentWindow) {
                                    if (e.contentWindow.focus(), i) i(e).then(function() {
                                        return null == n ? void 0 : n();
                                    }).then(function() {
                                        return t.handleRemoveIframe();
                                    }).catch(function(e) {
                                        o ? o("print", e) : t.logMessages([
                                            "An error was thrown by the specified `print` function"
                                        ]);
                                    });
                                    else {
                                        if (e.contentWindow.print) {
                                            var s = null !== (c = null === (r = e.contentDocument) || void 0 === r ? void 0 : r.title) && void 0 !== c ? c : "", u = e.ownerDocument.title;
                                            a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = s));
                                        } else t.logMessages([
                                            "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
                                        ]);
                                        null == n || n(), t.handleRemoveIframe();
                                    }
                                } else t.logMessages([
                                    "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"
                                ]);
                            }, 500);
                        }, t.triggerPrint = function(e) {
                            var r = t.props, n = r.onBeforePrint, o = r.onPrintError;
                            if (n) {
                                var i = n();
                                i && "function" == typeof i.then ? i.then(function() {
                                    t.startPrint(e);
                                }).catch(function(e) {
                                    o && o("onBeforePrint", e);
                                }) : t.startPrint(e);
                            } else t.startPrint(e);
                        }, t.handlePrint = function(e) {
                            var r = t.props, o = r.bodyClass, a = r.content, c = r.copyStyles, s = r.fonts, u = r.pageStyle, l = r.nonce, f = "function" == typeof e ? e() : null;
                            if (f && "function" == typeof a && t.logMessages([
                                '"react-to-print" received a `content` prop and a content param passed the callback return by `useReactToPrint. The `content` prop will be ignored.'
                            ], "warning"), f || "function" != typeof a || (f = a()), void 0 !== f) {
                                if (null !== f) {
                                    var d = document.createElement("iframe");
                                    d.width = "".concat(document.documentElement.clientWidth, "px"), d.height = "".concat(document.documentElement.clientHeight, "px"), d.style.position = "absolute", d.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), d.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), d.id = "printWindow", d.srcdoc = "<!DOCTYPE html>";
                                    var p = (0, i.findDOMNode)(f);
                                    if (p) {
                                        var h = p.cloneNode(!0), y = h instanceof Text, b = document.querySelectorAll("link[rel~='stylesheet'], link[as='style']"), v = y ? [] : h.querySelectorAll("img"), g = y ? [] : h.querySelectorAll("video"), m = s ? s.length : 0;
                                        t.numResourcesToLoad = b.length + v.length + g.length + m, t.resourcesLoaded = [], t.resourcesErrored = [];
                                        var _ = function(e, r) {
                                            t.resourcesLoaded.includes(e) ? t.logMessages([
                                                "Tried to mark a resource that has already been handled",
                                                e
                                            ], "debug") : (r ? (t.logMessages(n.__spreadArray([
                                                '"react-to-print" was unable to load a resource but will continue attempting to print the page'
                                            ], n.__read(r), !1)), t.resourcesErrored.push(e)) : t.resourcesLoaded.push(e), t.resourcesLoaded.length + t.resourcesErrored.length === t.numResourcesToLoad && t.triggerPrint(d));
                                        };
                                        d.onload = function() {
                                            var e, r, i, a;
                                            d.onload = null;
                                            var f = d.contentDocument || (null === (r = d.contentWindow) || void 0 === r ? void 0 : r.document);
                                            if (f) {
                                                f.body.appendChild(h), s && ((null === (i = d.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (a = d.contentWindow) || void 0 === a ? void 0 : a.FontFace) ? s.forEach(function(e) {
                                                    var t = new FontFace(e.family, e.source, {
                                                        weight: e.weight,
                                                        style: e.style
                                                    });
                                                    d.contentDocument.fonts.add(t), t.loaded.then(function() {
                                                        _(t);
                                                    }).catch(function(e) {
                                                        _(t, [
                                                            "Failed loading the font:",
                                                            t,
                                                            "Load error:",
                                                            e
                                                        ]);
                                                    });
                                                }) : (s.forEach(function(e) {
                                                    return _(e);
                                                }), t.logMessages([
                                                    '"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'
                                                ])));
                                                var b = "function" == typeof u ? u() : u;
                                                if ("string" != typeof b) t.logMessages([
                                                    '"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof b, '". Styles from `pageStyle` will not be applied.')
                                                ]);
                                                else {
                                                    var m = f.createElement("style");
                                                    l && (m.setAttribute("nonce", l), f.head.setAttribute("nonce", l)), m.appendChild(f.createTextNode(b)), f.head.appendChild(m);
                                                }
                                                if (o && (e = f.body.classList).add.apply(e, n.__spreadArray([], n.__read(o.split(" ")), !1)), !y) {
                                                    for(var w = y ? [] : p.querySelectorAll("canvas"), P = f.querySelectorAll("canvas"), O = 0; O < w.length; ++O){
                                                        var x = w[O], S = P[O].getContext("2d");
                                                        S && S.drawImage(x, 0, 0);
                                                    }
                                                    var E = function(e) {
                                                        var t = v[e], r = t.getAttribute("src");
                                                        if (r) {
                                                            var n = new Image;
                                                            n.onload = function() {
                                                                return _(t);
                                                            }, n.onerror = function(e, r, n, o, i) {
                                                                return _(t, [
                                                                    "Error loading <img>",
                                                                    t,
                                                                    "Error",
                                                                    i
                                                                ]);
                                                            }, n.src = r;
                                                        } else _(t, [
                                                            'Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:',
                                                            t
                                                        ]);
                                                    };
                                                    for(O = 0; O < v.length; O++)E(O);
                                                    var T = function(e) {
                                                        var t = g[e];
                                                        t.preload = "auto";
                                                        var r = t.getAttribute("poster");
                                                        if (r) {
                                                            var n = new Image;
                                                            n.onload = function() {
                                                                return _(t);
                                                            }, n.onerror = function(e, n, o, i, a) {
                                                                return _(t, [
                                                                    "Error loading video poster",
                                                                    r,
                                                                    "for video",
                                                                    t,
                                                                    "Error:",
                                                                    a
                                                                ]);
                                                            }, n.src = r;
                                                        } else t.readyState >= 2 ? _(t) : (t.onloadeddata = function() {
                                                            return _(t);
                                                        }, t.onerror = function(e, r, n, o, i) {
                                                            return _(t, [
                                                                "Error loading video",
                                                                t,
                                                                "Error",
                                                                i
                                                            ]);
                                                        }, t.onstalled = function() {
                                                            return _(t, [
                                                                "Loading video stalled, skipping",
                                                                t
                                                            ]);
                                                        });
                                                    };
                                                    for(O = 0; O < g.length; O++)T(O);
                                                    var j = "input", C = p.querySelectorAll(j), A = f.querySelectorAll(j);
                                                    for(O = 0; O < C.length; O++)A[O].value = C[O].value;
                                                    var k = "input[type=checkbox],input[type=radio]", R = p.querySelectorAll(k), M = f.querySelectorAll(k);
                                                    for(O = 0; O < R.length; O++)M[O].checked = R[O].checked;
                                                    var D = "select", I = p.querySelectorAll(D), q = f.querySelectorAll(D);
                                                    for(O = 0; O < I.length; O++)q[O].value = I[O].value;
                                                }
                                                if (c) for(var F = document.querySelectorAll("style, link[rel~='stylesheet'], link[as='style']"), W = function(e, r) {
                                                    var n = F[e];
                                                    if ("style" === n.tagName.toLowerCase()) {
                                                        var o = f.createElement(n.tagName), i = n.sheet;
                                                        if (i) {
                                                            var a = "";
                                                            try {
                                                                for(var c = i.cssRules.length, s = 0; s < c; ++s)"string" == typeof i.cssRules[s].cssText && (a += "".concat(i.cssRules[s].cssText, "\r\n"));
                                                            } catch (e) {
                                                                t.logMessages([
                                                                    "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                                                                    n
                                                                ], "warning");
                                                            }
                                                            o.setAttribute("id", "react-to-print-".concat(e)), l && o.setAttribute("nonce", l), o.appendChild(f.createTextNode(a)), f.head.appendChild(o);
                                                        }
                                                    } else if (n.getAttribute("href")) {
                                                        if (n.hasAttribute("disabled")) t.logMessages([
                                                            "`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                                                            n
                                                        ], "warning"), _(n);
                                                        else {
                                                            for(var u = f.createElement(n.tagName), d = (s = 0, n.attributes.length); s < d; ++s){
                                                                var p = n.attributes[s];
                                                                p && u.setAttribute(p.nodeName, p.nodeValue || "");
                                                            }
                                                            u.onload = function() {
                                                                return _(u);
                                                            }, u.onerror = function(e, t, r, n, o) {
                                                                return _(u, [
                                                                    "Failed to load",
                                                                    u,
                                                                    "Error:",
                                                                    o
                                                                ]);
                                                            }, l && u.setAttribute("nonce", l), f.head.appendChild(u);
                                                        }
                                                    } else t.logMessages([
                                                        "`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                                                        n
                                                    ], "warning"), _(n);
                                                }, L = (O = 0, F.length); O < L; ++O)W(O);
                                            }
                                            0 !== t.numResourcesToLoad && c || t.triggerPrint(d);
                                        }, t.handleRemoveIframe(!0), document.body.appendChild(d);
                                    } else t.logMessages([
                                        '"react-to-print" could not locate the DOM node corresponding with the `content` prop'
                                    ]);
                                } else t.logMessages([
                                    'There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.'
                                ]);
                            } else t.logMessages([
                                "To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"
                            ]);
                        }, t.handleRemoveIframe = function(e) {
                            var r = t.props.removeAfterPrint;
                            if (e || r) {
                                var n = document.getElementById("printWindow");
                                n && document.body.removeChild(n);
                            }
                        }, t.logMessages = function(e, r) {
                            void 0 === r && (r = "error"), t.props.suppressErrors || ("error" === r ? console.error(e) : "warning" === r ? console.warn(e) : "debug" === r && console.debug(e));
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.handleClick = function(e, t) {
                        var r = this, n = this.props, o = n.onBeforeGetContent, i = n.onPrintError;
                        if (o) {
                            var a = o();
                            a && "function" == typeof a.then ? a.then(function() {
                                return r.handlePrint(t);
                            }).catch(function(e) {
                                i && i("onBeforeGetContent", e);
                            }) : this.handlePrint(t);
                        } else this.handlePrint(t);
                    }, t.prototype.render = function() {
                        var e = this.props, t = e.children, r = e.trigger;
                        if (r) return o.cloneElement(r(), {
                            onClick: this.handleClick.bind(this)
                        });
                        if (!a.PrintContext) return this.logMessages([
                            '"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'
                        ]), null;
                        var n = {
                            handlePrint: this.handleClick.bind(this)
                        };
                        return o.createElement(a.PrintContext.Provider, {
                            value: n
                        }, t);
                    }, t.defaultProps = c.defaultProps, t;
                }(o.Component);
                t.ReactToPrint = s;
            },
            940: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.defaultProps = void 0, t.defaultProps = {
                    copyStyles: !0,
                    pageStyle: "\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",
                    removeAfterPrint: !1,
                    suppressErrors: !1
                };
            },
            892: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useReactToPrint = void 0;
                var n = r(316), o = r(496), i = r(428), a = r(940), c = r(860), s = Object.prototype.hasOwnProperty.call(o, "useMemo") && Object.prototype.hasOwnProperty.call(o, "useCallback");
                t.useReactToPrint = function(e) {
                    if (!s) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function() {
                        throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
                    };
                    var t = o.useMemo(function() {
                        return new i.ReactToPrint(n.__assign(n.__assign({}, a.defaultProps), e));
                    }, [
                        e
                    ]);
                    return o.useCallback(function(e, r) {
                        return (0, c.wrapCallbackWithArgs)(t, t.handleClick, r)(e);
                    }, [
                        t
                    ]);
                };
            },
            860: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wrapCallbackWithArgs = void 0;
                var n = r(316);
                t.wrapCallbackWithArgs = function(e, t) {
                    for(var r = [], o = 2; o < arguments.length; o++)r[o - 2] = arguments[o];
                    return function() {
                        for(var o = [], i = 0; i < arguments.length; i++)o[i] = arguments[i];
                        return t.apply(e, n.__spreadArray(n.__spreadArray([], n.__read(o), !1), n.__read(r), !1));
                    };
                };
            },
            496: function(t) {
                t.exports = e;
            },
            190: function(e) {
                e.exports = t;
            },
            316: function(e, t, r) {
                r.r(t), r.d(t, {
                    __addDisposableResource: function() {
                        return D;
                    },
                    __assign: function() {
                        return i;
                    },
                    __asyncDelegator: function() {
                        return S;
                    },
                    __asyncGenerator: function() {
                        return x;
                    },
                    __asyncValues: function() {
                        return E;
                    },
                    __await: function() {
                        return O;
                    },
                    __awaiter: function() {
                        return h;
                    },
                    __classPrivateFieldGet: function() {
                        return k;
                    },
                    __classPrivateFieldIn: function() {
                        return M;
                    },
                    __classPrivateFieldSet: function() {
                        return R;
                    },
                    __createBinding: function() {
                        return b;
                    },
                    __decorate: function() {
                        return c;
                    },
                    __disposeResources: function() {
                        return q;
                    },
                    __esDecorate: function() {
                        return u;
                    },
                    __exportStar: function() {
                        return v;
                    },
                    __extends: function() {
                        return o;
                    },
                    __generator: function() {
                        return y;
                    },
                    __importDefault: function() {
                        return A;
                    },
                    __importStar: function() {
                        return C;
                    },
                    __makeTemplateObject: function() {
                        return T;
                    },
                    __metadata: function() {
                        return p;
                    },
                    __param: function() {
                        return s;
                    },
                    __propKey: function() {
                        return f;
                    },
                    __read: function() {
                        return m;
                    },
                    __rest: function() {
                        return a;
                    },
                    __runInitializers: function() {
                        return l;
                    },
                    __setFunctionName: function() {
                        return d;
                    },
                    __spread: function() {
                        return _;
                    },
                    __spreadArray: function() {
                        return P;
                    },
                    __spreadArrays: function() {
                        return w;
                    },
                    __values: function() {
                        return g;
                    }
                });
                var n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }, n(e, t);
                };
                function o(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }
                var i = function() {
                    return i = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                        return e;
                    }, i.apply(this, arguments);
                };
                function a(e, t) {
                    var r = {};
                    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var o = 0;
                        for(n = Object.getOwnPropertySymbols(e); o < n.length; o++)t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
                    }
                    return r;
                }
                function c(e, t, r, n) {
                    var o, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, r, n);
                    else for(var c = e.length - 1; c >= 0; c--)(o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, r, a) : o(t, r)) || a);
                    return i > 3 && a && Object.defineProperty(t, r, a), a;
                }
                function s(e, t) {
                    return function(r, n) {
                        t(r, n, e);
                    };
                }
                function u(e, t, r, n, o, i) {
                    function a(e) {
                        if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
                        return e;
                    }
                    for(var c, s = n.kind, u = "getter" === s ? "get" : "setter" === s ? "set" : "value", l = !t && e ? n.static ? e : e.prototype : null, f = t || (l ? Object.getOwnPropertyDescriptor(l, n.name) : {}), d = !1, p = r.length - 1; p >= 0; p--){
                        var h = {};
                        for(var y in n)h[y] = "access" === y ? {} : n[y];
                        for(var y in n.access)h.access[y] = n.access[y];
                        h.addInitializer = function(e) {
                            if (d) throw new TypeError("Cannot add initializers after decoration has completed");
                            i.push(a(e || null));
                        };
                        var b = (0, r[p])("accessor" === s ? {
                            get: f.get,
                            set: f.set
                        } : f[u], h);
                        if ("accessor" === s) {
                            if (void 0 === b) continue;
                            if (null === b || "object" != typeof b) throw new TypeError("Object expected");
                            (c = a(b.get)) && (f.get = c), (c = a(b.set)) && (f.set = c), (c = a(b.init)) && o.unshift(c);
                        } else (c = a(b)) && ("field" === s ? o.unshift(c) : f[u] = c);
                    }
                    l && Object.defineProperty(l, n.name, f), d = !0;
                }
                function l(e, t, r) {
                    for(var n = arguments.length > 2, o = 0; o < t.length; o++)r = n ? t[o].call(e, r) : t[o].call(e);
                    return n ? r : void 0;
                }
                function f(e) {
                    return "symbol" == typeof e ? e : "".concat(e);
                }
                function d(e, t, r) {
                    return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
                        configurable: !0,
                        value: r ? "".concat(r, " ", t) : t
                    });
                }
                function p(e, t) {
                    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
                }
                function h(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function a(e) {
                            try {
                                s(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            try {
                                s(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function s(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(a, c);
                        }
                        s((n = n.apply(e, t || [])).next());
                    });
                }
                function y(e, t) {
                    var r, n, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: c(0),
                        throw: c(1),
                        return: c(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function c(c) {
                        return function(s) {
                            return function(c) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, c[0] && (a = 0)), a;)try {
                                    if (r = 1, n && (o = 2 & c[0] ? n.return : c[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, c[1])).done) return o;
                                    switch(n = 0, o && (c = [
                                        2 & c[0],
                                        o.value
                                    ]), c[0]){
                                        case 0:
                                        case 1:
                                            o = c;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: c[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = c[1], c = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            c = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === c[0] && (!o || c[1] > o[0] && c[1] < o[3])) {
                                                a.label = c[1];
                                                break;
                                            }
                                            if (6 === c[0] && a.label < o[1]) {
                                                a.label = o[1], o = c;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(c);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    c = t.call(e, a);
                                } catch (e) {
                                    c = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    r = o = 0;
                                }
                                if (5 & c[0]) throw c[1];
                                return {
                                    value: c[0] ? c[1] : void 0,
                                    done: !0
                                };
                            }([
                                c,
                                s
                            ]);
                        };
                    }
                }
                var b = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                };
                function v(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || b(t, e, r);
                }
                function g(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                    if (r) return r.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && n >= e.length && (e = void 0), {
                                value: e && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }
                function m(e, t) {
                    var r = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!r) return e;
                    var n, o, i = r.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(n = i.next()).done;)a.push(n.value);
                    } catch (e) {
                        o = {
                            error: e
                        };
                    } finally{
                        try {
                            n && !n.done && (r = i.return) && r.call(i);
                        } finally{
                            if (o) throw o.error;
                        }
                    }
                    return a;
                }
                function _() {
                    for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(m(arguments[t]));
                    return e;
                }
                function w() {
                    for(var e = 0, t = 0, r = arguments.length; t < r; t++)e += arguments[t].length;
                    var n = Array(e), o = 0;
                    for(t = 0; t < r; t++)for(var i = arguments[t], a = 0, c = i.length; a < c; a++, o++)n[o] = i[a];
                    return n;
                }
                function P(e, t, r) {
                    if (r || 2 === arguments.length) for(var n, o = 0, i = t.length; o < i; o++)!n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
                    return e.concat(n || Array.prototype.slice.call(t));
                }
                function O(e) {
                    return this instanceof O ? (this.v = e, this) : new O(e);
                }
                function x(e, t, r) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var n, o = r.apply(e, t || []), i = [];
                    return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
                        return this;
                    }, n;
                    function a(e) {
                        o[e] && (n[e] = function(t) {
                            return new Promise(function(r, n) {
                                i.push([
                                    e,
                                    t,
                                    r,
                                    n
                                ]) > 1 || c(e, t);
                            });
                        });
                    }
                    function c(e, t) {
                        try {
                            (r = o[e](t)).value instanceof O ? Promise.resolve(r.value.v).then(s, u) : l(i[0][2], r);
                        } catch (e) {
                            l(i[0][3], e);
                        }
                        var r;
                    }
                    function s(e) {
                        c("next", e);
                    }
                    function u(e) {
                        c("throw", e);
                    }
                    function l(e, t) {
                        e(t), i.shift(), i.length && c(i[0][0], i[0][1]);
                    }
                }
                function S(e) {
                    var t, r;
                    return t = {}, n("next"), n("throw", function(e) {
                        throw e;
                    }), n("return"), t[Symbol.iterator] = function() {
                        return this;
                    }, t;
                    function n(n, o) {
                        t[n] = e[n] ? function(t) {
                            return (r = !r) ? {
                                value: O(e[n](t)),
                                done: !1
                            } : o ? o(t) : t;
                        } : o;
                    }
                }
                function E(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t, r = e[Symbol.asyncIterator];
                    return r ? r.call(e) : (e = g(e), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
                        return this;
                    }, t);
                    function n(r) {
                        t[r] = e[r] && function(t) {
                            return new Promise(function(n, o) {
                                !function(e, t, r, n) {
                                    Promise.resolve(n).then(function(t) {
                                        e({
                                            value: t,
                                            done: r
                                        });
                                    }, t);
                                }(n, o, (t = e[r](t)).done, t.value);
                            });
                        };
                    }
                }
                function T(e, t) {
                    return Object.defineProperty ? Object.defineProperty(e, "raw", {
                        value: t
                    }) : e.raw = t, e;
                }
                var j = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                function C(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && b(t, e, r);
                    return j(t, e), t;
                }
                function A(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function k(e, t, r, n) {
                    if ("a" === r && !n) throw new TypeError("Private accessor was defined without a getter");
                    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
                }
                function R(e, t, r, n, o) {
                    if ("m" === n) throw new TypeError("Private method is not writable");
                    if ("a" === n && !o) throw new TypeError("Private accessor was defined without a setter");
                    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                    return "a" === n ? o.call(e, r) : o ? o.value = r : t.set(e, r), r;
                }
                function M(e, t) {
                    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
                    return "function" == typeof e ? t === e : e.has(t);
                }
                function D(e, t, r) {
                    if (null != t) {
                        if ("object" != typeof t && "function" != typeof t) throw new TypeError("Object expected.");
                        var n;
                        if (r) {
                            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
                            n = t[Symbol.asyncDispose];
                        }
                        if (void 0 === n) {
                            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
                            n = t[Symbol.dispose];
                        }
                        if ("function" != typeof n) throw new TypeError("Object not disposable.");
                        e.stack.push({
                            value: t,
                            dispose: n,
                            async: r
                        });
                    } else r && e.stack.push({
                        async: !0
                    });
                    return t;
                }
                var I = "function" == typeof SuppressedError ? SuppressedError : function(e, t, r) {
                    var n = new Error(r);
                    return n.name = "SuppressedError", n.error = e, n.suppressed = t, n;
                };
                function q(e) {
                    function t(t) {
                        e.error = e.hasError ? new I(t, e.error, "An error was suppressed during disposal.") : t, e.hasError = !0;
                    }
                    return function r() {
                        for(; e.stack.length;){
                            var n = e.stack.pop();
                            try {
                                var o = n.dispose && n.dispose.call(n.value);
                                if (n.async) return Promise.resolve(o).then(r, function(e) {
                                    return t(e), r();
                                });
                            } catch (e) {
                                t(e);
                            }
                        }
                        if (e.hasError) throw e.error;
                    }();
                }
                t.default = {
                    __extends: o,
                    __assign: i,
                    __rest: a,
                    __decorate: c,
                    __param: s,
                    __metadata: p,
                    __awaiter: h,
                    __generator: y,
                    __createBinding: b,
                    __exportStar: v,
                    __values: g,
                    __read: m,
                    __spread: _,
                    __spreadArrays: w,
                    __spreadArray: P,
                    __await: O,
                    __asyncGenerator: x,
                    __asyncDelegator: S,
                    __asyncValues: E,
                    __makeTemplateObject: T,
                    __importStar: C,
                    __importDefault: A,
                    __classPrivateFieldGet: k,
                    __classPrivateFieldSet: R,
                    __classPrivateFieldIn: M,
                    __addDisposableResource: D,
                    __disposeResources: q
                };
            }
        }, n = {};
        function o(e) {
            var t = n[e];
            if (void 0 !== t) return t.exports;
            var i = n[e] = {
                exports: {}
            };
            return r[e](i, i.exports, o), i.exports;
        }
        o.d = function(e, t) {
            for(var r in t)o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, o.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, o.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var i = {};
        return function() {
            var e = i;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.useReactToPrint = e.ReactToPrint = e.PrintContextConsumer = void 0;
            var t = o(328);
            Object.defineProperty(e, "PrintContextConsumer", {
                enumerable: !0,
                get: function() {
                    return t.PrintContextConsumer;
                }
            });
            var r = o(428);
            Object.defineProperty(e, "ReactToPrint", {
                enumerable: !0,
                get: function() {
                    return r.ReactToPrint;
                }
            });
            var n = o(892);
            Object.defineProperty(e, "useReactToPrint", {
                enumerable: !0,
                get: function() {
                    return n.useReactToPrint;
                }
            });
            var a = o(428);
            e.default = a.ReactToPrint;
        }(), i;
    }();
});


const { Option: $42cf18882dd80726$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $42cf18882dd80726$var$Expenses = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [{ user: user, data: data, filters: filters, visible: visible, advances: advances, admin: admin, loading: loading, month: month }, { searchChanged: searchChanged, carChanged: carChanged, settledChanged: settledChanged, clearFilters: clearFilters, toggleVisible: toggleVisible, toggleAdvances: toggleAdvances, settle: settle, setMonth: setMonth }] = (0, $cbe377727b462555$export$2e2bcd8739ae039)();
    const added = visible ? {
        title: 'Dodane - przez',
        dataIndex: 'created',
        key: 'created',
        render: (v, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(v),
                    " -",
                    ' ',
                    row.user_id === null ? 'Firmowy' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/panel/drivers/${row.created_by?.id}`,
                        children: row.created_by?.name
                    })
                ]
            })
    } : {
        title: 'Dodane',
        dataIndex: 'created',
        key: 'created',
        render: (v)=>(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(v)
    };
    const settled = admin ? {
        title: 'Rozliczone - przez',
        dataIndex: 'settled',
        key: 'settled',
        render: (settled, row)=>{
            if (row.user_id === null) return visible ? '-' : 'Firmowy';
            return settled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(settled),
                    " -",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/panel/drivers/${row.settled_by.id}`,
                        children: row.settled_by.name
                    })
                ]
            }) : '-';
        }
    } : {
        title: 'Rozliczone',
        dataIndex: 'settled',
        key: 'settled',
        render: (settled, row)=>{
            if (row.user_id === null) return visible ? '-' : 'Firmowy';
            return settled ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(settled) : '-';
        }
    };
    const getColor = (type)=>{
        switch(type){
            // Expenses
            case 0:
                return (0, $0b4842326956570d$export$a90204d1394caf30)[5];
            // Settlements
            case 1:
                return (0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5];
            // Advances
            case 2:
                return (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5];
        }
    };
    const columns = [
        {
            title: 'Typ',
            dataIndex: 'type',
            key: 'type',
            render: (type, row)=>{
                switch(row._type){
                    // Expenses
                    case 0:
                        return `${type.name} - ${row.name}`;
                    // Settlements
                    case 1:
                        return "Pobranie got\xf3wki";
                    // Advances
                    case 2:
                        return `Zaliczka - ${row.address}`;
                    // Owns
                    case 3:
                        return `Zam\xf3wienie w\u{142}asne - ${row.to}`;
                }
            }
        },
        {
            title: 'Kwota',
            dataIndex: 'value',
            key: 'value',
            render: (v, row)=>{
                if (row._type === 3) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        color: (0, $0b4842326956570d$export$7474046f446842ee)[5]
                    },
                    children: [
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(row.weight ?? ''),
                        " kg"
                    ]
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        color: getColor(row._type)
                    },
                    children: [
                        row._type === 0 ? '-' : '',
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(v)
                    ]
                });
            }
        },
        {
            title: 'Podatek',
            dataIndex: 'value_type',
            key: 'value_type',
            render: (type, row)=>{
                if (row._type == 2 || row._type == 3) return '-';
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        type ? 'Brutto' : 'Netto',
                        row.tax ? ` - ${row.tax}%` : ''
                    ]
                });
            }
        },
        {
            title: 'Numer FV',
            dataIndex: 'invoice',
            key: 'invoice',
            render: (invoice)=>invoice ?? '-'
        },
        {
            title: 'Nr rejestracyjny',
            dataIndex: 'car',
            key: 'car',
            render: (car)=>car ?? '-'
        },
        {
            title: 'Przebieg',
            dataIndex: 'mileage',
            key: 'mileage',
            render: (mileage)=>mileage ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(mileage) : '-'
        },
        added,
        settled,
        {
            title: 'Akcje',
            dataIndex: 'settled',
            key: 'actions',
            render: (settled, row)=>settled === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    style: {
                        color: loading === row.id ? (0, $0b4842326956570d$export$e4c89085febbc618)[5] : (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5]
                    },
                    onClick: ()=>settle(row.id),
                    children: "Rozlicz"
                }) : '-'
        }
    ].filter((c)=>visible || c.key !== 'actions');
    const printRef = (0, $acw62.useRef)();
    const handlePrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: ()=>printRef.current
    });
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate('/panel/new-expense'),
            children: "Dodaj wydatek"
        }, 0),
        admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate('/panel/new-expense?company=1'),
            children: "Dodaj wydatek firmowy"
        }, 1),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: advances ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f8ce45decd122a2$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eed06595af8fdbfa$export$2e2bcd8739ae039), {}),
            onClick: toggleAdvances,
            children: advances ? "Poka\u017C tylko wydatki" : "Poka\u017C te\u017C zaliczki"
        }, 2),
        admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: visible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {}),
            onClick: toggleVisible,
            children: [
                visible ? 'Ukryj' : "Poka\u017C",
                " wydatki innych pracownik\xf3w"
            ]
        }, 3),
        admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cdd5a58cfa55afe$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate('/panel/expenses/get-money'),
            children: "Pobierz got\xf3wk\u0119 od pracownika"
        }, 4),
        admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a66bc520ace0c83$export$2e2bcd8739ae039), {}),
            onClick: handlePrint,
            children: "Wydrukuj list\u0119 wydatk\xf3w"
        }, 5)
    ];
    const bottomTitle = admin ? undefined : 'Saldo:';
    const number = admin ? undefined : (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(user?.balance);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Wydatki",
        actions: actions,
        bottomTitle: bottomTitle,
        number: number,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "expenses flex flex-dir",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "inputs flex",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                placeholder: "Wyszukaj",
                                size: "large",
                                suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                                    style: {
                                        color: '#8C8C8C'
                                    }
                                }),
                                value: filters.search,
                                onChange: searchChanged
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                placeholder: "Nr rejestracyjny",
                                size: "large",
                                suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                                    style: {
                                        color: '#8C8C8C'
                                    }
                                }),
                                value: filters.car,
                                onChange: carChanged
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                size: "large",
                                placeholder: "Status",
                                value: filters.settled,
                                onChange: settledChanged,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($42cf18882dd80726$var$Option, {
                                        value: 0,
                                        children: "Rozliczone"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($42cf18882dd80726$var$Option, {
                                        value: 1,
                                        children: "Nierozliczone"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                type: "primary",
                                size: "large",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                                onClick: clearFilters,
                                children: "Wyczy\u015B\u0107"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).MonthPicker, {
                                size: "large",
                                value: month,
                                onChange: setMonth,
                                allowClear: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                        columns: columns,
                        dataSource: data,
                        pagination: false,
                        scroll: {
                            x: 'max-content'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c36868b44170ec8a$export$2e2bcd8739ae039), {
                ref: printRef,
                expenses: data,
                month: month
            })
        ]
    });
};
var $42cf18882dd80726$export$2e2bcd8739ae039 = $42cf18882dd80726$var$Expenses;



parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $jWR62 = parcelRequire("jWR62");

var $1pcHX = parcelRequire("1pcHX");

var $acw62 = parcelRequire("acw62");




var $77d977e4e7aca4c0$var$Option = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option;
function $77d977e4e7aca4c0$var$isSelectOptionOrSelectOptGroup(child) {
    return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
var $77d977e4e7aca4c0$var$AutoComplete = function AutoComplete(props, ref) {
    var customizePrefixCls = props.prefixCls, className = props.className, popupClassName = props.popupClassName, dropdownClassName = props.dropdownClassName, children = props.children, dataSource = props.dataSource;
    var childNodes = (0, $jWR62.default)(children);
    // ============================= Input =============================
    var customizeInput;
    if (childNodes.length === 1 && (0, $30796c32f374b477$export$a8257692ac88316c)(childNodes[0]) && !$77d977e4e7aca4c0$var$isSelectOptionOrSelectOptGroup(childNodes[0])) {
        var _childNodes = (0, $eUqlC.default)(childNodes, 1);
        customizeInput = _childNodes[0];
    }
    var getInputElement = customizeInput ? function() {
        return customizeInput;
    } : undefined;
    // ============================ Options ============================
    var optionChildren;
    // [Legacy] convert `children` or `dataSource` into option children
    if (childNodes.length && $77d977e4e7aca4c0$var$isSelectOptionOrSelectOptGroup(childNodes[0])) optionChildren = children;
    else optionChildren = dataSource ? dataSource.map(function(item) {
        if ((0, $30796c32f374b477$export$a8257692ac88316c)(item)) return item;
        switch((0, $fSwVM.default)(item)){
            case 'string':
                return /*#__PURE__*/ $acw62.createElement($77d977e4e7aca4c0$var$Option, {
                    key: item,
                    value: item
                }, item);
            case 'object':
                var optionValue = item.value;
                return /*#__PURE__*/ $acw62.createElement($77d977e4e7aca4c0$var$Option, {
                    key: optionValue,
                    value: optionValue
                }, item.text);
            default:
                return undefined;
        }
    }) : [];
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), null, function(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefixCls = getPrefixCls('select', customizePrefixCls);
        return /*#__PURE__*/ $acw62.createElement((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), (0, $8nd05.default)({
            ref: ref
        }, (0, $1pcHX.default)(props, [
            'dataSource'
        ]), {
            prefixCls: prefixCls,
            popupClassName: popupClassName || dropdownClassName,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-auto-complete"), className),
            mode: (0, $1b56c179e5783cdb$export$2e2bcd8739ae039).SECRET_COMBOBOX_MODE_DO_NOT_USE
        }, {
            // Internal api
            getInputElement: getInputElement
        }), optionChildren);
    });
};
var $77d977e4e7aca4c0$var$RefAutoComplete = /*#__PURE__*/ $acw62.forwardRef($77d977e4e7aca4c0$var$AutoComplete);
$77d977e4e7aca4c0$var$RefAutoComplete.Option = $77d977e4e7aca4c0$var$Option;
var $77d977e4e7aca4c0$export$2e2bcd8739ae039 = $77d977e4e7aca4c0$var$RefAutoComplete;






var $45fvw = parcelRequire("45fvw");

const { Option: $6fc0896c29a9a5d0$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $6fc0896c29a9a5d0$var$NewExpense = ()=>{
    const [{ expense: expense, isFuelExpense: isFuelExpense, disabled: disabled, loading: loading, types: types, type: type, admin: admin, superAdmin: superAdmin }, { nameChanged: nameChanged, typeChanged: typeChanged, carChanged: carChanged, mileageChanged: mileageChanged, fuelLitersChanged: fuelLitersChanged, valueChanged: valueChanged, dateChanged: dateChanged, valueTypeChanged: valueTypeChanged, taxChanged: taxChanged, invoiceChanged: invoiceChanged, companyChanged: companyChanged, createExpense: createExpense }] = (0, $4f72e13be9124676$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            disabled: disabled,
            loading: loading,
            onClick: createExpense,
            children: "Dodaj wydatek"
        }, 0)
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Wydatki / Nowy",
        actions: actions,
        children: types && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "new-expense flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Informacje",
                    width: 902,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Typ"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                            size: "large",
                                            options: types.map((option)=>({
                                                    value: option.name
                                                })),
                                            filterOption: (inputValue, option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1,
                                            onSelect: typeChanged,
                                            onChange: typeChanged,
                                            value: type
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Nazwa"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            size: "large",
                                            value: expense.name,
                                            onChange: nameChanged,
                                            disabled: expense.type
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Kwota"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "pln flex flex-ac",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "number",
                                                    size: "large",
                                                    value: expense.value,
                                                    onChange: valueChanged
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "PLN"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Numer FV"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            size: "large",
                                            value: expense.invoice,
                                            onChange: invoiceChanged
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Data"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                            size: "large",
                                            value: expense.date,
                                            onChange: dateChanged,
                                            allowClear: false,
                                            disabledDate: (date)=>{
                                                if (superAdmin) return false;
                                                const minDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('day').subtract(1, 'day');
                                                if (date < minDate) return true;
                                                const maxDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('day');
                                                if (date > maxDate) return true;
                                                return false;
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 10,
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Netto / Brutto"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    value: expense.value_type,
                                                    onChange: valueTypeChanged,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6fc0896c29a9a5d0$var$Option, {
                                                            value: 0,
                                                            children: "Netto"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6fc0896c29a9a5d0$var$Option, {
                                                            value: 1,
                                                            children: "Brutto"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Stopa podatku"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    value: expense.tax,
                                                    onChange: taxChanged,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6fc0896c29a9a5d0$var$Option, {
                                                            value: 0,
                                                            children: "0%"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6fc0896c29a9a5d0$var$Option, {
                                                            value: 8,
                                                            children: "8%"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6fc0896c29a9a5d0$var$Option, {
                                                            value: 23,
                                                            children: "23%"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Numer rejestracyjny pojazdu"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            size: "large",
                                            value: expense.car,
                                            onChange: carChanged
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 10,
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Przebieg"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "number",
                                                    size: "large",
                                                    value: expense.mileage,
                                                    onChange: mileageChanged
                                                })
                                            ]
                                        }),
                                        isFuelExpense && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Litry paliwa"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "number",
                                                    size: "large",
                                                    value: expense.fuel_liters,
                                                    onChange: fuelLitersChanged
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "\xa0"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                            checked: expense.company,
                                            onChange: companyChanged,
                                            children: "Wydatek firmowy"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $6fc0896c29a9a5d0$export$2e2bcd8739ae039 = $6fc0896c29a9a5d0$var$NewExpense;



parcelRequire("acw62");






const $13356b0b3a888c94$var$GetMoney = ()=>{
    const [{ drivers: drivers, disabled: disabled, loading: loading, driver: driver }, { driverChanged: driverChanged, valueChanged: valueChanged, createSettlement: createSettlement }] = (0, $c3e65aa1149dbf67$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cdd5a58cfa55afe$export$2e2bcd8739ae039), {}),
            loading: loading,
            disabled: disabled,
            onClick: createSettlement,
            children: "Pobierz got\xf3wk\u0119"
        }, "0")
    ];
    return drivers ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Wydatki / Pobierz got\xf3wk\u0119 od pracownika",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "expenses__get-money flex",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                title: "Informacje",
                width: 902,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Pracownik"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                        size: "large",
                                        options: drivers.map((d)=>({
                                                value: `${d.name} ${d.surname}`
                                            })),
                                        filterOption: (inputValue, option)=>option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1,
                                        onSelect: driverChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Kwota"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "text",
                                                size: "large",
                                                onChange: valueChanged
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "flex flex-dir flex-jc flex-ac",
                                                children: "PLN"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    driver && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Stan konta:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "data",
                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(driver.balance)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                        ]
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $13356b0b3a888c94$export$2e2bcd8739ae039 = $13356b0b3a888c94$var$GetMoney;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $c65875392bff9feb$export$c8df679eea5b0938 = ()=>{
    const [orders, setOrders] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const fetch = async ()=>{
        try {
            const fetchedOrders = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).looseOrders.getDelivered();
            setOrders(fetchedOrders);
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych ${e}`);
        }
    };
    return {
        orders: orders
    };
};



var $e446ba5d777c4273$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e446ba5d777c4273$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e446ba5d777c4273$exports, "__esModule", {
    value: true
});
$e446ba5d777c4273$exports["default"] = void 0;

var $e446ba5d777c4273$var$_Table = $e446ba5d777c4273$var$_interopRequireDefault((parcelRequire("95Dw3")));
var $e446ba5d777c4273$var$_default = $e446ba5d777c4273$exports["default"] = $e446ba5d777c4273$var$_Table["default"];









var $acw62 = parcelRequire("acw62");
const $b7de0527e6d4b726$export$3956658c2d361270 = ({ children: children, icon: icon, disabled: disabled, danger: danger, onClick: onClick })=>{
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const _onClick = async ()=>{
        if (loading || disabled) return;
        try {
            setLoading(true);
            await onClick();
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        type: "primary",
        size: "large",
        danger: danger ?? false,
        icon: icon,
        onClick: _onClick,
        loading: loading,
        disabled: disabled ?? false,
        children: children
    });
};




var $acw62 = parcelRequire("acw62");

const $fe4fe7ed96759354$export$4a414f5357d5343 = ({ children: children, color: color, loadingColor: loadingColor = (0, $0b4842326956570d$export$e4c89085febbc618)[5], onClick: onClick })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const _onClick = async ()=>{
        if (loading) return;
        try {
            setLoading(true);
            await onClick();
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        onClick: _onClick,
        style: {
            color: loading ? loadingColor : color,
            fontWeight: 500
        },
        children: children
    });
};




var $acw62 = parcelRequire("acw62");


const $9ba307cd85047917$export$ef072eb865b4b720 = ({ visible: visible, onCancel: onCancel, onOk: onOk })=>{
    const [date, setDate] = (0, $acw62.useState)();
    const [time, setTime] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const approve = async ()=>{
        if (!date) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie wybrano daty');
            return;
        }
        const d = date?.clone().seconds(0).milliseconds(0);
        if (!time) d.hours(0).minutes(0);
        else d.hours(time.hours()).minutes(time.minutes());
        try {
            setLoading(true);
            await onOk(d);
            setDate(undefined);
            setTime(undefined);
        } finally{
            setLoading(false);
        }
    };
    const cancel = ()=>{
        setDate(undefined);
        setTime(undefined);
        onCancel();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fc69d8460bb1eda3$export$2e2bcd8739ae039), {
        visible: visible,
        closable: false,
        cancelText: "Anuluj",
        okText: "Edytuj",
        onCancel: cancel,
        onOk: approve,
        disabled: date === undefined,
        loading: loading,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Edytuj dat\u0119?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "input",
                children: [
                    "Data:",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 20,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                size: "large",
                                placeholder: "Wybierz dat\u0119",
                                value: date ?? null,
                                onChange: (m)=>m && setDate(m)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                size: "large",
                                format: "HH:mm",
                                placeholder: "Wybierz godzin\u0119",
                                value: time ?? null,
                                onChange: (m)=>setTime(m ?? undefined)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("8iiJy");
var $eGxZY = parcelRequire("eGxZY");
var $8iiJy = parcelRequire("8iiJy");

var $acw62 = parcelRequire("acw62");




var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $9ffe1c2756854ba4$export$2e2bcd8739ae039(value) {
    var _React$useState = $acw62.useState(value), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), cacheValue = _React$useState2[0], setCacheValue = _React$useState2[1];
    $acw62.useEffect(function() {
        var timeout = setTimeout(function() {
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}


var $2cd7502dce089e1a$var$EMPTY_LIST = [];
function $2cd7502dce089e1a$var$toErrorEntity(error, errorStatus, prefix) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return {
        key: typeof error === 'string' ? error : "".concat(prefix, "-").concat(index),
        error: error,
        errorStatus: errorStatus
    };
}
function $2cd7502dce089e1a$export$2e2bcd8739ae039(_ref) {
    var help = _ref.help, helpStatus = _ref.helpStatus, _ref$errors = _ref.errors, errors = _ref$errors === void 0 ? $2cd7502dce089e1a$var$EMPTY_LIST : _ref$errors, _ref$warnings = _ref.warnings, warnings = _ref$warnings === void 0 ? $2cd7502dce089e1a$var$EMPTY_LIST : _ref$warnings, rootClassName = _ref.className, fieldId = _ref.fieldId, onVisibleChanged = _ref.onVisibleChanged;
    var _React$useContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$fb6582d3042cc879)), prefixCls = _React$useContext.prefixCls;
    var _React$useContext2 = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext2.getPrefixCls;
    var baseClassName = "".concat(prefixCls, "-item-explain");
    var rootPrefixCls = getPrefixCls();
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    var debounceErrors = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(errors);
    var debounceWarnings = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(warnings);
    var fullKeyList = $acw62.useMemo(function() {
        if (help !== undefined && help !== null) return [
            $2cd7502dce089e1a$var$toErrorEntity(help, helpStatus, 'help')
        ];
        return [].concat((0, $kbxxf.default)(debounceErrors.map(function(error, index) {
            return $2cd7502dce089e1a$var$toErrorEntity(error, 'error', 'error', index);
        })), (0, $kbxxf.default)(debounceWarnings.map(function(warning, index) {
            return $2cd7502dce089e1a$var$toErrorEntity(warning, 'warning', 'warning', index);
        })));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    var helpProps = {};
    if (fieldId) helpProps.id = "".concat(fieldId, "_help");
    return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), {
        motionDeadline: (0, $2efb522a5615f01e$export$2e2bcd8739ae039).motionDeadline,
        motionName: "".concat(rootPrefixCls, "-show-help"),
        visible: !!fullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, function(holderProps) {
        var holderClassName = holderProps.className, holderStyle = holderProps.style;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, helpProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(baseClassName, holderClassName, rootClassName),
            style: holderStyle,
            role: "alert"
        }), /*#__PURE__*/ $acw62.createElement((0, $eGxZY.default), (0, $8nd05.default)({
            keys: fullKeyList
        }, (0, $2efb522a5615f01e$export$2e2bcd8739ae039), {
            motionName: "".concat(rootPrefixCls, "-show-help-item"),
            component: false
        }), function(itemProps) {
            var key = itemProps.key, error = itemProps.error, errorStatus = itemProps.errorStatus, itemClassName = itemProps.className, itemStyle = itemProps.style;
            return /*#__PURE__*/ $acw62.createElement("div", {
                key: key,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemClassName, (0, $kSlfw.default)({}, "".concat(baseClassName, "-").concat(errorStatus), errorStatus)),
                style: itemStyle
            }, error);
        }));
    });
}



var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $8a8Nr = parcelRequire("8a8Nr");
var $gPDhi = parcelRequire("gPDhi");

var $acw62 = parcelRequire("acw62");






var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");
parcelRequire("8a8Nr");
var $dRl3b = parcelRequire("dRl3b");

var $acw62 = parcelRequire("acw62");
function $a7a25358838dbf3f$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $a7a25358838dbf3f$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $a7a25358838dbf3f$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $a7a25358838dbf3f$var$e(r.overflowY, n) || $a7a25358838dbf3f$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $a7a25358838dbf3f$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
function $a7a25358838dbf3f$export$2e2bcd8739ae039(e, i) {
    var o = window, l = i.scrollMode, d = i.block, u = i.inline, h = i.boundary, a = i.skipOverflowHiddenElements, c = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$a7a25358838dbf3f$var$t(e)) throw new TypeError("Invalid target");
    for(var f = document.scrollingElement || document.documentElement, s = [], p = e; $a7a25358838dbf3f$var$t(p) && c(p);){
        if ((p = p.parentElement) === f) {
            s.push(p);
            break;
        }
        null != p && p === document.body && $a7a25358838dbf3f$var$n(p) && !$a7a25358838dbf3f$var$n(document.documentElement) || null != p && $a7a25358838dbf3f$var$n(p, a) && s.push(p);
    }
    for(var m = o.visualViewport ? o.visualViewport.width : innerWidth, g = o.visualViewport ? o.visualViewport.height : innerHeight, w = window.scrollX || pageXOffset, v = window.scrollY || pageYOffset, W = e.getBoundingClientRect(), b = W.height, H = W.width, y = W.top, E = W.right, M = W.bottom, V = W.left, x = "start" === d || "nearest" === d ? y : "end" === d ? M : y + b / 2, I = "center" === u ? V + H / 2 : "end" === u ? E : V, C = [], T = 0; T < s.length; T++){
        var k = s[T], B = k.getBoundingClientRect(), D = B.height, O = B.width, R = B.top, X = B.right, Y = B.bottom, L = B.left;
        if ("if-needed" === l && y >= 0 && V >= 0 && M <= g && E <= m && y >= R && M <= Y && V >= L && E <= X) return C;
        var S = getComputedStyle(k), j = parseInt(S.borderLeftWidth, 10), q = parseInt(S.borderTopWidth, 10), z = parseInt(S.borderRightWidth, 10), A = parseInt(S.borderBottomWidth, 10), F = 0, G = 0, J = "offsetWidth" in k ? k.offsetWidth - k.clientWidth - j - z : 0, K = "offsetHeight" in k ? k.offsetHeight - k.clientHeight - q - A : 0;
        if (f === k) F = "start" === d ? x : "end" === d ? x - g : "nearest" === d ? $a7a25358838dbf3f$var$r(v, v + g, g, q, A, v + x, v + x + b, b) : x - g / 2, G = "start" === u ? I : "center" === u ? I - m / 2 : "end" === u ? I - m : $a7a25358838dbf3f$var$r(w, w + m, m, j, z, w + I, w + I + H, H), F = Math.max(0, F + v), G = Math.max(0, G + w);
        else {
            F = "start" === d ? x - R - q : "end" === d ? x - Y + A + K : "nearest" === d ? $a7a25358838dbf3f$var$r(R, Y, D, q, A + K, x, x + b, b) : x - (R + D / 2) + K / 2, G = "start" === u ? I - L - j : "center" === u ? I - (L + O / 2) + J / 2 : "end" === u ? I - X + z + J : $a7a25358838dbf3f$var$r(L, X, O, j, z + J, I, I + H, H);
            var N = k.scrollLeft, P = k.scrollTop;
            x += P - (F = Math.max(0, Math.min(P + F, k.scrollHeight - D + K))), I += N - (G = Math.max(0, Math.min(N + G, k.scrollWidth - O + J)));
        }
        C.push({
            el: k,
            top: F,
            left: G
        });
    }
    return C;
}


function $189be1e22a64ff06$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $189be1e22a64ff06$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $189be1e22a64ff06$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($189be1e22a64ff06$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $189be1e22a64ff06$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($189be1e22a64ff06$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $a7a25358838dbf3f$export$2e2bcd8739ae039)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $189be1e22a64ff06$var$getOptions(options);
    return $189be1e22a64ff06$var$defaultBehavior((0, $a7a25358838dbf3f$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $189be1e22a64ff06$export$2e2bcd8739ae039 = $189be1e22a64ff06$var$scrollIntoView;


// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
var $43291396832d20f3$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
var $43291396832d20f3$var$defaultItemNamePrefixCls = 'form_item';
function $43291396832d20f3$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $43291396832d20f3$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    var mergedId = namePath.join('_');
    if (formName) return "".concat(formName, "_").concat(mergedId);
    var isIllegalName = $43291396832d20f3$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? "".concat($43291396832d20f3$var$defaultItemNamePrefixCls, "_").concat(mergedId) : mergedId;
}


function $4c36311913591211$var$toNamePathStr(name) {
    var namePath = (0, $43291396832d20f3$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $4c36311913591211$export$2e2bcd8739ae039(form) {
    var _useRcForm = (0, $dRl3b.default)(), _useRcForm2 = (0, $eUqlC.default)(_useRcForm, 1), rcForm = _useRcForm2[0];
    var itemsRef = $acw62.useRef({});
    var wrapForm = $acw62.useMemo(function() {
        return form !== null && form !== void 0 ? form : (0, $8nd05.default)((0, $8nd05.default)({}, rcForm), {
            __INTERNAL__: {
                itemRef: function itemRef(name) {
                    return function(node) {
                        var namePathStr = $4c36311913591211$var$toNamePathStr(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    };
                }
            },
            scrollToField: function scrollToField(name) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var namePath = (0, $43291396832d20f3$export$45b10814cc054894)(name);
                var fieldId = (0, $43291396832d20f3$export$f4457e83c74ac000)(namePath, wrapForm.__INTERNAL__.name);
                var node = fieldId ? document.getElementById(fieldId) : null;
                if (node) (0, $189be1e22a64ff06$export$2e2bcd8739ae039)(node, (0, $8nd05.default)({
                    scrollMode: 'if-needed',
                    block: 'nearest'
                }, options));
            },
            getFieldInstance: function getFieldInstance(name) {
                var namePathStr = $4c36311913591211$var$toNamePathStr(name);
                return itemsRef.current[namePathStr];
            }
        });
    }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}


var $69a0bf7fe3d99aff$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $69a0bf7fe3d99aff$var$InternalForm = function InternalForm(props, ref) {
    var contextSize = $acw62.useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    var contextDisabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, contextForm = _React$useContext.form;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, _props$size = props.size, size = _props$size === void 0 ? contextSize : _props$size, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? contextDisabled : _props$disabled, form = props.form, colon = props.colon, labelAlign = props.labelAlign, labelWrap = props.labelWrap, labelCol = props.labelCol, wrapperCol = props.wrapperCol, hideRequiredMark = props.hideRequiredMark, _props$layout = props.layout, layout = _props$layout === void 0 ? 'horizontal' : _props$layout, scrollToFirstError = props.scrollToFirstError, requiredMark = props.requiredMark, onFinishFailed = props.onFinishFailed, name = props.name, restFormProps = $69a0bf7fe3d99aff$var$__rest(props, [
        "prefixCls",
        "className",
        "size",
        "disabled",
        "form",
        "colon",
        "labelAlign",
        "labelWrap",
        "labelCol",
        "wrapperCol",
        "hideRequiredMark",
        "layout",
        "scrollToFirstError",
        "requiredMark",
        "onFinishFailed",
        "name"
    ]);
    var contextValidateMessages = $acw62.useContext((0, $efabd6732f69a6da$export$2e2bcd8739ae039));
    var mergedRequiredMark = (0, $acw62.useMemo)(function() {
        if (requiredMark !== undefined) return requiredMark;
        if (contextForm && contextForm.requiredMark !== undefined) return contextForm.requiredMark;
        if (hideRequiredMark) return false;
        return true;
    }, [
        hideRequiredMark,
        requiredMark,
        contextForm
    ]);
    var mergedColon = colon !== null && colon !== void 0 ? colon : contextForm === null || contextForm === void 0 ? void 0 : contextForm.colon;
    var prefixCls = getPrefixCls('form', customizePrefixCls);
    var formClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(layout), true), "".concat(prefixCls, "-hide-required-mark"), mergedRequiredMark === false), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(size), size), className);
    var _useForm = (0, $4c36311913591211$export$2e2bcd8739ae039)(form), _useForm2 = (0, $eUqlC.default)(_useForm, 1), wrapForm = _useForm2[0];
    var __INTERNAL__ = wrapForm.__INTERNAL__;
    __INTERNAL__.name = name;
    var formContextValue = (0, $acw62.useMemo)(function() {
        return {
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            vertical: layout === 'vertical',
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm
        };
    }, [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm
    ]);
    $acw62.useImperativeHandle(ref, function() {
        return wrapForm;
    });
    var onInternalFinishFailed = function onInternalFinishFailed(errorInfo) {
        onFinishFailed === null || onFinishFailed === void 0 || onFinishFailed(errorInfo);
        var defaultScrollToFirstError = {
            block: 'nearest'
        };
        if (scrollToFirstError && errorInfo.errorFields.length) {
            if ((0, $fSwVM.default)(scrollToFirstError) === 'object') defaultScrollToFirstError = scrollToFirstError;
            wrapForm.scrollToField(errorInfo.errorFields[0].name, defaultScrollToFirstError);
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$dbc92d89fabc8ebe), {
        size: size
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$8ce1ff4f94d08846), (0, $8nd05.default)({}, {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }), /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $8a8Nr.default), (0, $8nd05.default)({
        id: name
    }, restFormProps, {
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        className: formClassName
    }))))));
};
var $69a0bf7fe3d99aff$var$Form = /*#__PURE__*/ $acw62.forwardRef($69a0bf7fe3d99aff$var$InternalForm);
var $69a0bf7fe3d99aff$export$2e2bcd8739ae039 = $69a0bf7fe3d99aff$var$Form;

parcelRequire("8a8Nr");
var $gPDhi = parcelRequire("gPDhi");

var $fSwVM = parcelRequire("fSwVM");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");
parcelRequire("8a8Nr");
var $4llrF = parcelRequire("4llrF");
var $260BS = parcelRequire("260BS");
var $livSf = parcelRequire("livSf");

var $3fDfx = parcelRequire("3fDfx");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $c23052ca479f865f$var$useFormItemStatus = function useFormItemStatus() {
    var _useContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed)), status = _useContext.status;
    return {
        status: status
    };
};
var $c23052ca479f865f$export$2e2bcd8739ae039 = $c23052ca479f865f$var$useFormItemStatus;








var $eUqlC = parcelRequire("eUqlC");

var $dTiBu = parcelRequire("dTiBu");

var $acw62 = parcelRequire("acw62");
function $bc695e48262f4f73$export$2e2bcd8739ae039(defaultValue) {
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    var frameRef = (0, $acw62.useRef)(null);
    var batchRef = (0, $acw62.useRef)([]);
    var destroyRef = (0, $acw62.useRef)(false);
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
            (0, $dTiBu.default).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $dTiBu.default)(function() {
                frameRef.current = null;
                setValue(function(prevValue) {
                    var current = prevValue;
                    batchRef.current.forEach(function(func) {
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $fSwVM = parcelRequire("fSwVM");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

function $3c7d21c38713ea5c$export$2e2bcd8739ae039() {
    var _React$useContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a)), itemRef = _React$useContext.itemRef;
    var cacheRef = $acw62.useRef({});
    function getRef(name, children) {
        var childrenRef = children && (0, $fSwVM.default)(children) === 'object' && children.ref;
        var nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $85dLH.composeRef)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}




var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");





var $6hDTM = parcelRequire("6hDTM");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $1pcHX = parcelRequire("1pcHX");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $fSwVM = parcelRequire("fSwVM");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
var $0664da0d06972591$var$RowContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $0664da0d06972591$export$2e2bcd8739ae039 = $0664da0d06972591$var$RowContext;


var $50bd634b7bc091a8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $50bd634b7bc091a8$var$RowAligns = (0, $1ee8868d1993c67b$export$65e3907585753458)('top', 'middle', 'bottom', 'stretch');
var $50bd634b7bc091a8$var$RowJustify = (0, $1ee8868d1993c67b$export$65e3907585753458)('start', 'end', 'center', 'space-around', 'space-between', 'space-evenly');
function $50bd634b7bc091a8$var$useMergePropByScreen(oriProp, screen) {
    var _React$useState = $acw62.useState(typeof oriProp === 'string' ? oriProp : ''), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), prop = _React$useState2[0], setProp = _React$useState2[1];
    var clacMergeAlignOrJustify = function clacMergeAlignOrJustify() {
        if (typeof oriProp === 'string') setProp(oriProp);
        if ((0, $fSwVM.default)(oriProp) !== 'object') return;
        for(var i = 0; i < (0, $3aa4647e26f3ae33$export$74c1bf8296b1541f).length; i++){
            var breakpoint = (0, $3aa4647e26f3ae33$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen[breakpoint]) continue;
            var curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $acw62.useEffect(function() {
        clacMergeAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
var $50bd634b7bc091a8$var$Row = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, justify = props.justify, align = props.align, className = props.className, style = props.style, children = props.children, _props$gutter = props.gutter, gutter = _props$gutter === void 0 ? 0 : _props$gutter, wrap = props.wrap, others = $50bd634b7bc091a8$var$__rest(props, [
        "prefixCls",
        "justify",
        "align",
        "className",
        "style",
        "children",
        "gutter",
        "wrap"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState3 = $acw62.useState({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    }), _React$useState4 = (0, $eUqlC.default)(_React$useState3, 2), screens = _React$useState4[0], setScreens = _React$useState4[1];
    // to save screens info when responsiveObserve callback had been call
    var _React$useState5 = $acw62.useState({
        xs: false,
        sm: false,
        md: false,
        lg: false,
        xl: false,
        xxl: false
    }), _React$useState6 = (0, $eUqlC.default)(_React$useState5, 2), curScreens = _React$useState6[0], setCurScreens = _React$useState6[1];
    // ================================== calc reponsive data ==================================
    var mergeAlign = $50bd634b7bc091a8$var$useMergePropByScreen(align, curScreens);
    var mergeJustify = $50bd634b7bc091a8$var$useMergePropByScreen(justify, curScreens);
    var supportFlexGap = (0, $b8b58c41c88f1d25$export$2e2bcd8739ae039)();
    var gutterRef = $acw62.useRef(gutter);
    // ================================== Effect ==================================
    $acw62.useEffect(function() {
        var token = (0, $3aa4647e26f3ae33$export$2e2bcd8739ae039).subscribe(function(screen) {
            setCurScreens(screen);
            var currentGutter = gutterRef.current || 0;
            if (!Array.isArray(currentGutter) && (0, $fSwVM.default)(currentGutter) === 'object' || Array.isArray(currentGutter) && ((0, $fSwVM.default)(currentGutter[0]) === 'object' || (0, $fSwVM.default)(currentGutter[1]) === 'object')) setScreens(screen);
        });
        return function() {
            return (0, $3aa4647e26f3ae33$export$2e2bcd8739ae039).unsubscribe(token);
        };
    }, []);
    // ================================== Render ==================================
    var getGutter = function getGutter() {
        var results = [
            undefined,
            undefined
        ];
        var normalizedGutter = Array.isArray(gutter) ? gutter : [
            gutter,
            undefined
        ];
        normalizedGutter.forEach(function(g, index) {
            if ((0, $fSwVM.default)(g) === 'object') for(var i = 0; i < (0, $3aa4647e26f3ae33$export$74c1bf8296b1541f).length; i++){
                var breakpoint = (0, $3aa4647e26f3ae33$export$74c1bf8296b1541f)[i];
                if (screens[breakpoint] && g[breakpoint] !== undefined) {
                    results[index] = g[breakpoint];
                    break;
                }
            }
            else results[index] = g;
        });
        return results;
    };
    var prefixCls = getPrefixCls('row', customizePrefixCls);
    var gutters = getGutter();
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-no-wrap"), wrap === false), "".concat(prefixCls, "-").concat(mergeJustify), mergeJustify), "".concat(prefixCls, "-").concat(mergeAlign), mergeAlign), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    // Add gutter related style
    var rowStyle = {};
    var horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
    var verticalGutter = gutters[1] != null && gutters[1] > 0 ? gutters[1] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    if (supportFlexGap) {
        // Set gap direct if flex gap support
        var _gutters = (0, $eUqlC.default)(gutters, 2);
        rowStyle.rowGap = _gutters[1];
    } else if (verticalGutter) {
        rowStyle.marginTop = verticalGutter;
        rowStyle.marginBottom = verticalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    var _gutters2 = (0, $eUqlC.default)(gutters, 2), gutterH = _gutters2[0], gutterV = _gutters2[1];
    var rowContext = $acw62.useMemo(function() {
        return {
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap,
            supportFlexGap: supportFlexGap
        };
    }, [
        gutterH,
        gutterV,
        wrap,
        supportFlexGap
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $0664da0d06972591$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, others, {
        className: classes,
        style: (0, $8nd05.default)((0, $8nd05.default)({}, rowStyle), style),
        ref: ref
    }), children));
});
var $50bd634b7bc091a8$export$2e2bcd8739ae039 = $50bd634b7bc091a8$var$Row;



var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $62cc23852a32c921$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $62cc23852a32c921$export$2e2bcd8739ae039 = $62cc23852a32c921$var$QuestionCircleOutlined;



var $5156a02f6f6a5710$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $62cc23852a32c921$export$2e2bcd8739ae039)
    }));
};
var $5156a02f6f6a5710$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($5156a02f6f6a5710$var$QuestionCircleOutlined);
var $5156a02f6f6a5710$export$2e2bcd8739ae039 = $5156a02f6f6a5710$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $d153d21e77ee9427$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d153d21e77ee9427$var$parseFlex(flex) {
    if (typeof flex === 'number') return "".concat(flex, " ").concat(flex, " auto");
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return "0 0 ".concat(flex);
    return flex;
}
var $d153d21e77ee9427$var$sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
var $d153d21e77ee9427$var$Col = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useContext2 = $acw62.useContext((0, $0664da0d06972591$export$2e2bcd8739ae039)), gutter = _React$useContext2.gutter, wrap = _React$useContext2.wrap, supportFlexGap = _React$useContext2.supportFlexGap;
    var customizePrefixCls = props.prefixCls, span = props.span, order = props.order, offset = props.offset, push = props.push, pull = props.pull, className = props.className, children = props.children, flex = props.flex, style = props.style, others = $d153d21e77ee9427$var$__rest(props, [
        "prefixCls",
        "span",
        "order",
        "offset",
        "push",
        "pull",
        "className",
        "children",
        "flex",
        "style"
    ]);
    var prefixCls = getPrefixCls('col', customizePrefixCls);
    var sizeClassObj = {};
    $d153d21e77ee9427$var$sizes.forEach(function(size) {
        var sizeProps = {};
        var propSize = props[size];
        if (typeof propSize === 'number') sizeProps.span = propSize;
        else if ((0, $fSwVM.default)(propSize) === 'object') sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = (0, $8nd05.default)((0, $8nd05.default)({}, sizeClassObj), (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), "".concat(prefixCls, "-rtl"), direction === 'rtl'));
    });
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(span), span !== undefined), "".concat(prefixCls, "-order-").concat(order), order), "".concat(prefixCls, "-offset-").concat(offset), offset), "".concat(prefixCls, "-push-").concat(push), push), "".concat(prefixCls, "-pull-").concat(pull), pull), className, sizeClassObj);
    var mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        var horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    // Vertical gutter use padding when gap not support
    if (gutter && gutter[1] > 0 && !supportFlexGap) {
        var verticalGutter = gutter[1] / 2;
        mergedStyle.paddingTop = verticalGutter;
        mergedStyle.paddingBottom = verticalGutter;
    }
    if (flex) {
        mergedStyle.flex = $d153d21e77ee9427$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, others, {
        style: (0, $8nd05.default)((0, $8nd05.default)({}, mergedStyle), style),
        className: classes,
        ref: ref
    }), children);
});
var $d153d21e77ee9427$export$2e2bcd8739ae039 = $d153d21e77ee9427$var$Col;






var $e49ae3442c8737f4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e49ae3442c8737f4$var$toTooltipProps(tooltip) {
    if (!tooltip) return null;
    if ((0, $fSwVM.default)(tooltip) === 'object' && !/*#__PURE__*/ $acw62.isValidElement(tooltip)) return tooltip;
    return {
        title: tooltip
    };
}
var $e49ae3442c8737f4$var$FormItemLabel = function FormItemLabel(_ref) {
    var prefixCls = _ref.prefixCls, label = _ref.label, htmlFor = _ref.htmlFor, labelCol = _ref.labelCol, labelAlign = _ref.labelAlign, colon = _ref.colon, required = _ref.required, requiredMark = _ref.requiredMark, tooltip = _ref.tooltip;
    var _useLocaleReceiver = (0, $715b7b8518c4616e$export$52f95bab0279a481)('Form'), _useLocaleReceiver2 = (0, $eUqlC.default)(_useLocaleReceiver, 1), formLocale = _useLocaleReceiver2[0];
    if (!label) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$c24727297075ec6a).Consumer, {
        key: "label"
    }, function(_ref2) {
        var vertical = _ref2.vertical, contextLabelAlign = _ref2.labelAlign, contextLabelCol = _ref2.labelCol, labelWrap = _ref2.labelWrap, contextColon = _ref2.colon;
        var _a;
        var mergedLabelCol = labelCol || contextLabelCol || {};
        var mergedLabelAlign = labelAlign || contextLabelAlign;
        var labelClsBasic = "".concat(prefixCls, "-item-label");
        var labelColClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className, (0, $kSlfw.default)({}, "".concat(labelClsBasic, "-wrap"), !!labelWrap));
        var labelChildren = label;
        // Keep label is original where there should have no colon
        var computedColon = colon === true || contextColon !== false && colon !== false;
        var haveColon = computedColon && !vertical;
        // Remove duplicated user input colon
        if (haveColon && typeof label === 'string' && label.trim() !== '') labelChildren = label.replace(/[:|：]\s*$/, '');
        // Tooltip
        var tooltipProps = $e49ae3442c8737f4$var$toTooltipProps(tooltip);
        if (tooltipProps) {
            var _tooltipProps$icon = tooltipProps.icon, icon = _tooltipProps$icon === void 0 ? /*#__PURE__*/ $acw62.createElement((0, $5156a02f6f6a5710$export$2e2bcd8739ae039), null) : _tooltipProps$icon, restTooltipProps = $e49ae3442c8737f4$var$__rest(tooltipProps, [
                "icon"
            ]);
            var tooltipNode = /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), (0, $8nd05.default)({}, restTooltipProps), /*#__PURE__*/ $acw62.cloneElement(icon, {
                className: "".concat(prefixCls, "-item-tooltip"),
                title: '',
                onClick: function onClick(e) {
                    // Prevent label behavior in tooltip icon
                    // https://github.com/ant-design/ant-design/issues/46154
                    e.preventDefault();
                },
                tabIndex: null
            }));
            labelChildren = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, labelChildren, tooltipNode);
        }
        // Add required mark if optional
        if (requiredMark === 'optional' && !required) labelChildren = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, labelChildren, /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-item-optional"),
            title: ""
        }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.optional)));
        var labelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-item-required"), required), "".concat(prefixCls, "-item-required-mark-optional"), requiredMark === 'optional'), "".concat(prefixCls, "-item-no-colon"), !computedColon));
        return /*#__PURE__*/ $acw62.createElement((0, $d153d21e77ee9427$export$2e2bcd8739ae039), (0, $8nd05.default)({}, mergedLabelCol, {
            className: labelColClassName
        }), /*#__PURE__*/ $acw62.createElement("label", {
            htmlFor: htmlFor,
            className: labelClassName,
            title: typeof label === 'string' ? label : ''
        }, labelChildren));
    });
};
var $e49ae3442c8737f4$export$2e2bcd8739ae039 = $e49ae3442c8737f4$var$FormItemLabel;



var $8nd05 = parcelRequire("8nd05");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



var $1c2fb1c8dfed9a89$var$FormItemInput = function FormItemInput(props) {
    var prefixCls = props.prefixCls, status = props.status, wrapperCol = props.wrapperCol, children = props.children, errors = props.errors, warnings = props.warnings, formItemRender = props._internalItemRender, extra = props.extra, help = props.help, fieldId = props.fieldId, marginBottom = props.marginBottom, onErrorVisibleChanged = props.onErrorVisibleChanged;
    var baseClassName = "".concat(prefixCls, "-item");
    var formContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    var mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
    var className = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(baseClassName, "-control"), mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    var subFormContext = $acw62.useMemo(function() {
        return (0, $8nd05.default)({}, formContext);
    }, [
        formContext
    ]);
    delete subFormContext.labelCol;
    delete subFormContext.wrapperCol;
    var inputDom = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(baseClassName, "-control-input")
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(baseClassName, "-control-input-content")
    }, children));
    var formItemContext = $acw62.useMemo(function() {
        return {
            prefixCls: prefixCls,
            status: status
        };
    }, [
        prefixCls,
        status
    ]);
    var errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'nowrap'
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $acw62.createElement((0, $2cd7502dce089e1a$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: "".concat(baseClassName, "-explain-connected"),
        onVisibleChanged: onErrorVisibleChanged
    })), !!marginBottom && /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            width: 0,
            height: marginBottom
        }
    })) : null;
    var extraProps = {};
    if (fieldId) extraProps.id = "".concat(fieldId, "_extra");
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    var extraDom = extra ? /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({}, extraProps, {
        className: "".concat(baseClassName, "-extra")
    }), extra) : null;
    var dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, inputDom, errorListDom, extraDom);
    return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $acw62.createElement((0, $d153d21e77ee9427$export$2e2bcd8739ae039), (0, $8nd05.default)({}, mergedWrapperCol, {
        className: className
    }), dom));
};
var $1c2fb1c8dfed9a89$export$2e2bcd8739ae039 = $1c2fb1c8dfed9a89$var$FormItemInput;




var $046eb12d049399e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $046eb12d049399e0$var$iconMap = {
    success: (0, $8a880f6c24a0b77c$export$2e2bcd8739ae039),
    warning: (0, $c94f46c32abf10c6$export$2e2bcd8739ae039),
    error: (0, $2bf1c25862f513c2$export$2e2bcd8739ae039),
    validating: (0, $43383ed7d2a91124$export$2e2bcd8739ae039)
};
function $046eb12d049399e0$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, help = props.help, errors = props.errors, warnings = props.warnings, validateStatus = props.validateStatus, meta = props.meta, hasFeedback = props.hasFeedback, hidden = props.hidden, children = props.children, fieldId = props.fieldId, isRequired = props.isRequired, onSubItemMetaChange = props.onSubItemMetaChange, restProps = $046eb12d049399e0$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "help",
        "errors",
        "warnings",
        "validateStatus",
        "meta",
        "hasFeedback",
        "hidden",
        "children",
        "fieldId",
        "isRequired",
        "onSubItemMetaChange"
    ]);
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var _React$useContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a)), requiredMark = _React$useContext.requiredMark;
    // ======================== Margin ========================
    var itemRef = $acw62.useRef(null);
    var debounceErrors = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(errors);
    var debounceWarnings = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(warnings);
    var hasHelp = help !== undefined && help !== null;
    var hasError = !!(hasHelp || errors.length || warnings.length);
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), marginBottom = _React$useState2[0], setMarginBottom = _React$useState2[1];
    (0, $6hDTM.default)(function() {
        if (hasError && itemRef.current) {
            var itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError
    ]);
    var onErrorVisibleChanged = function onErrorVisibleChanged(nextVisible) {
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    var mergedValidateStatus = '';
    if (validateStatus !== undefined) mergedValidateStatus = validateStatus;
    else if (meta.validating) mergedValidateStatus = 'validating';
    else if (debounceErrors.length) mergedValidateStatus = 'error';
    else if (debounceWarnings.length) mergedValidateStatus = 'warning';
    else if (meta.touched) mergedValidateStatus = 'success';
    var formItemStatusContext = $acw62.useMemo(function() {
        var feedbackIcon;
        if (hasFeedback) {
            var IconNode = mergedValidateStatus && $046eb12d049399e0$var$iconMap[mergedValidateStatus];
            feedbackIcon = IconNode ? /*#__PURE__*/ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(itemPrefixCls, "-feedback-icon"), "".concat(itemPrefixCls, "-feedback-icon-").concat(mergedValidateStatus))
            }, /*#__PURE__*/ $acw62.createElement(IconNode, null)) : null;
        }
        return {
            status: mergedValidateStatus,
            hasFeedback: hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true
        };
    }, [
        mergedValidateStatus,
        hasFeedback
    ]);
    // ======================== Render ========================
    var itemClassName = (0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, itemPrefixCls, true), "".concat(itemPrefixCls, "-with-help"), hasHelp || debounceErrors.length || debounceWarnings.length), "".concat(className), !!className), "".concat(itemPrefixCls, "-has-feedback"), mergedValidateStatus && hasFeedback), "".concat(itemPrefixCls, "-has-success"), mergedValidateStatus === 'success'), "".concat(itemPrefixCls, "-has-warning"), mergedValidateStatus === 'warning'), "".concat(itemPrefixCls, "-has-error"), mergedValidateStatus === 'error'), "".concat(itemPrefixCls, "-is-validating"), mergedValidateStatus === 'validating'), "".concat(itemPrefixCls, "-hidden"), hidden);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(itemClassName),
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $acw62.createElement((0, $50bd634b7bc091a8$export$2e2bcd8739ae039), (0, $8nd05.default)({
        className: "".concat(itemPrefixCls, "-row")
    }, (0, $1pcHX.default)(restProps, [
        '_internalItemRender',
        'colon',
        'dependencies',
        'extra',
        'fieldKey',
        'getValueFromEvent',
        'getValueProps',
        'htmlFor',
        'id',
        'initialValue',
        'isListField',
        'label',
        'labelAlign',
        'labelCol',
        'labelWrap',
        'messageVariables',
        'name',
        'normalize',
        'noStyle',
        'preserve',
        'required',
        'requiredMark',
        'rules',
        'shouldUpdate',
        'trigger',
        'tooltip',
        'validateFirst',
        'validateTrigger',
        'valuePropName',
        'wrapperCol'
    ])), /*#__PURE__*/ $acw62.createElement((0, $e49ae3442c8737f4$export$2e2bcd8739ae039), (0, $8nd05.default)({
        htmlFor: fieldId,
        required: isRequired,
        requiredMark: requiredMark
    }, props, {
        prefixCls: prefixCls
    })), /*#__PURE__*/ $acw62.createElement((0, $1c2fb1c8dfed9a89$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, meta, {
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }), /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children)))), !!marginBottom && /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(itemPrefixCls, "-margin-offset"),
        style: {
            marginBottom: -marginBottom
        }
    }));
}


var $8713ccd60b7fb61a$var$NAME_SPLIT = '__SPLIT__';
var $8713ccd60b7fb61a$var$ValidateStatuses = (0, $1ee8868d1993c67b$export$65e3907585753458)('success', 'warning', 'error', 'validating', '');
var $8713ccd60b7fb61a$var$MemoInput = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(prev, next) {
    return prev.value === next.value && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every(function(value, index) {
        return value === next.childProps[index];
    });
});
function $8713ccd60b7fb61a$var$hasValidName(name) {
    name;
    return !(name === undefined || name === null);
}
function $8713ccd60b7fb61a$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        validated: false,
        name: []
    };
}
function $8713ccd60b7fb61a$var$InternalFormItem(props) {
    var name = props.name, noStyle = props.noStyle, dependencies = props.dependencies, customizePrefixCls = props.prefixCls, shouldUpdate = props.shouldUpdate, rules = props.rules, children = props.children, required = props.required, label = props.label, messageVariables = props.messageVariables, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? 'onChange' : _props$trigger, validateTrigger = props.validateTrigger, hidden = props.hidden;
    var _useContext = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls;
    var _useContext2 = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$c24727297075ec6a)), formName = _useContext2.name;
    var isRenderProps = typeof children === 'function';
    var notifyParentMetaChange = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$d718247e9f9b0b9e));
    var _useContext3 = (0, $acw62.useContext)((0, $260BS.default)), contextValidateTrigger = _useContext3.validateTrigger;
    var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
    var hasName = $8713ccd60b7fb61a$var$hasValidName(name);
    var prefixCls = getPrefixCls('form', customizePrefixCls);
    // ========================= MISC =========================
    // Get `noStyle` required info
    var listContext = $acw62.useContext((0, $livSf.default));
    var fieldKeyPathRef = $acw62.useRef();
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    var _useFrameState = (0, $bc695e48262f4f73$export$2e2bcd8739ae039)({}), _useFrameState2 = (0, $eUqlC.default)(_useFrameState, 2), subFieldErrors = _useFrameState2[0], setSubFieldErrors = _useFrameState2[1];
    // >>>>> Current field errors
    var _useState = (0, $3fDfx.default)(function() {
        return $8713ccd60b7fb61a$var$genEmptyMeta();
    }), _useState2 = (0, $eUqlC.default)(_useState, 2), meta = _useState2[0], setMeta = _useState2[1];
    var onMetaChange = function onMetaChange(nextMeta) {
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        var keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $8713ccd60b7fb61a$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && notifyParentMetaChange) {
            var namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    var _keyInfo = (0, $eUqlC.default)(keyInfo, 2), fieldKey = _keyInfo[0], restPath = _keyInfo[1];
                    namePath = [
                        fieldKey
                    ].concat((0, $kbxxf.default)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    var onSubItemMetaChange = function onSubItemMetaChange(subMeta, uniqueKeys) {
        // Only `noStyle` sub item will trigger
        setSubFieldErrors(function(prevSubFieldErrors) {
            var clone = (0, $8nd05.default)({}, prevSubFieldErrors);
            // name: ['user', 1] + key: [4] = ['user', 4]
            var mergedNamePath = [].concat((0, $kbxxf.default)(subMeta.name.slice(0, -1)), (0, $kbxxf.default)(uniqueKeys));
            var mergedNameKey = mergedNamePath.join($8713ccd60b7fb61a$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    var _React$useMemo = $acw62.useMemo(function() {
        var errorList = (0, $kbxxf.default)(meta.errors);
        var warningList = (0, $kbxxf.default)(meta.warnings);
        Object.values(subFieldErrors).forEach(function(subFieldError) {
            errorList.push.apply(errorList, (0, $kbxxf.default)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $kbxxf.default)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]), _React$useMemo2 = (0, $eUqlC.default)(_React$useMemo, 2), mergedErrors = _React$useMemo2[0], mergedWarnings = _React$useMemo2[1];
    // ===================== Children Ref =====================
    var getItemRef = (0, $3c7d21c38713ea5c$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return baseChildren;
        return /*#__PURE__*/ $acw62.createElement((0, $046eb12d049399e0$export$2e2bcd8739ae039), (0, $8nd05.default)({
            key: "row"
        }, props, {
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange
        }), baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return renderLayout(children);
    var variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = (0, $8nd05.default)((0, $8nd05.default)({}, variables), messageVariables);
    // >>>>> With Field
    return /*#__PURE__*/ $acw62.createElement((0, $4llrF.default), (0, $8nd05.default)({}, props, {
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }), function(control, renderMeta, context) {
        var mergedName = (0, $43291396832d20f3$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        var fieldId = (0, $43291396832d20f3$export$f4457e83c74ac000)(mergedName, formName);
        var isRequired = required !== undefined ? required : !!(rules && rules.some(function(rule) {
            if (rule && (0, $fSwVM.default)(rule) === 'object' && rule.required && !rule.warningOnly) return true;
            if (typeof rule === 'function') {
                var ruleEntity = rule(context);
                return ruleEntity && ruleEntity.required && !ruleEntity.warningOnly;
            }
            return false;
        }));
        // ======================= Children =======================
        var mergedControl = (0, $8nd05.default)({}, control);
        var childNode = null;
        if (Array.isArray(children) && hasName) childNode = children;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if ((0, $30796c32f374b477$export$a8257692ac88316c)(children)) {
            var childProps = (0, $8nd05.default)((0, $8nd05.default)({}, children.props), mergedControl);
            if (!childProps.id) childProps.id = fieldId;
            if (props.help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                var describedbyArr = [];
                if (props.help || mergedErrors.length > 0) describedbyArr.push("".concat(fieldId, "_help"));
                if (props.extra) describedbyArr.push("".concat(fieldId, "_extra"));
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $85dLH.supportRef)(children)) childProps.ref = getItemRef(mergedName, children);
            // We should keep user origin event handler
            var triggers = new Set([].concat((0, $kbxxf.default)((0, $43291396832d20f3$export$45b10814cc054894)(trigger)), (0, $kbxxf.default)((0, $43291396832d20f3$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach(function(eventName) {
                childProps[eventName] = function() {
                    var _a2, _c2;
                    var _a, _b, _c;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    (_a = mergedControl[eventName]) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        mergedControl
                    ].concat(args));
                    (_c = (_b = children.props)[eventName]) === null || _c === void 0 || (_c2 = _c).call.apply(_c2, [
                        _b
                    ].concat(args));
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            var watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $acw62.createElement($8713ccd60b7fb61a$var$MemoInput, {
                value: mergedControl[props.valuePropName || 'value'],
                update: children,
                childProps: watchingChildProps
            }, (0, $30796c32f374b477$export$e530037191fcd5d7)(children, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = children(context);
        else childNode = children;
        return renderLayout(childNode, fieldId, isRequired);
    });
}
var $8713ccd60b7fb61a$var$FormItem = $8713ccd60b7fb61a$var$InternalFormItem;
$8713ccd60b7fb61a$var$FormItem.useStatus = (0, $c23052ca479f865f$export$2e2bcd8739ae039);
var $8713ccd60b7fb61a$export$2e2bcd8739ae039 = $8713ccd60b7fb61a$var$FormItem;



var $8nd05 = parcelRequire("8nd05");
parcelRequire("8a8Nr");
var $2iMfo = parcelRequire("2iMfo");

var $acw62 = parcelRequire("acw62");



var $3a42708cb1545f12$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3a42708cb1545f12$var$FormList = function FormList(_a) {
    var customizePrefixCls = _a.prefixCls, children = _a.children, props = $3a42708cb1545f12$var$__rest(_a, [
        "prefixCls",
        "children"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('form', customizePrefixCls);
    var contextValue = $acw62.useMemo(function() {
        return {
            prefixCls: prefixCls,
            status: 'error'
        };
    }, [
        prefixCls
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $2iMfo.default), (0, $8nd05.default)({}, props), function(fields, operation, meta) {
        return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map(function(field) {
            return (0, $8nd05.default)((0, $8nd05.default)({}, field), {
                fieldKey: field.key
            });
        }), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        }));
    });
};
var $3a42708cb1545f12$export$2e2bcd8739ae039 = $3a42708cb1545f12$var$FormList;



var $acw62 = parcelRequire("acw62");

function $a4f42b2c91c59125$export$2e2bcd8739ae039() {
    var _useContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$c24727297075ec6a)), form = _useContext.form;
    return form;
}


var $38feeba41dc3d65b$var$Form = (0, $69a0bf7fe3d99aff$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.Item = (0, $8713ccd60b7fb61a$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.List = (0, $3a42708cb1545f12$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.ErrorList = (0, $2cd7502dce089e1a$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useForm = (0, $4c36311913591211$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useFormInstance = (0, $a4f42b2c91c59125$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useWatch = (0, $gPDhi.default);
$38feeba41dc3d65b$var$Form.Provider = (0, $ad5d550b51ac8abd$export$8ce1ff4f94d08846);
$38feeba41dc3d65b$var$Form.create = function() {};
var $38feeba41dc3d65b$export$2e2bcd8739ae039 = $38feeba41dc3d65b$var$Form;




const $8a4409826a128b58$export$bf7a976fef6c1b78 = ({ visible: visible, onCancel: onCancel, type: type, onOk: onOk })=>{
    const [date, setDate] = (0, $acw62.useState)();
    const [time, setTime] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const handleSubmit = async ()=>{
        if (!date) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie wybrano daty');
            return;
        }
        const taskDate = date.clone();
        if (time) taskDate.hours(time.hours()).minutes(time.minutes()).seconds(0).milliseconds(0);
        else taskDate.hours(0).minutes(0).seconds(0).milliseconds(0);
        try {
            setLoading(true);
            await onOk(taskDate);
            setDate(undefined);
            setTime(undefined);
        } catch (error) {
            console.error(error);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} utworzy\u{107} zadania: ${error}`);
        } finally{
            setLoading(false);
        }
    };
    const handleCancel = ()=>{
        setDate(undefined);
        setTime(undefined);
        onCancel();
    };
    const title = type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery ? "Utw\xf3rz zadanie dostarczenia" : "Utw\xf3rz zadanie odebrania";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fc69d8460bb1eda3$export$2e2bcd8739ae039), {
        visible: visible,
        closable: false,
        cancelText: "Anuluj",
        okText: "Utw\xf3rz",
        onCancel: handleCancel,
        onOk: handleSubmit,
        disabled: !date,
        loading: loading,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
                layout: "vertical",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                    label: "Data zadania",
                    required: true,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 20,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                size: "large",
                                placeholder: "Wybierz dat\u0119",
                                value: date ?? null,
                                onChange: (m)=>m && setDate(m),
                                format: "YYYY-MM-DD"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                size: "large",
                                format: "HH:mm",
                                placeholder: "Wybierz godzin\u0119",
                                value: time ?? null,
                                onChange: (m)=>setTime(m ?? undefined)
                            })
                        ]
                    })
                })
            })
        ]
    });
};





parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $36beee545cff913e$var$PhoneOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    },
    "name": "phone",
    "theme": "outlined"
};
var $36beee545cff913e$export$2e2bcd8739ae039 = $36beee545cff913e$var$PhoneOutlined;



function $c1a35a530b2e1d2f$var$_extends() {
    $c1a35a530b2e1d2f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c1a35a530b2e1d2f$var$_extends.apply(this, arguments);
}
const $c1a35a530b2e1d2f$var$PhoneOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $c1a35a530b2e1d2f$var$_extends({}, props, {
        ref: ref,
        icon: (0, $36beee545cff913e$export$2e2bcd8739ae039)
    }));
/**![phone](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3Ny4xIDIzOC43TDc3MC42IDEzMi4zYy0xMy0xMy0zMC40LTIwLjMtNDguOC0yMC4zcy0zNS44IDcuMi00OC44IDIwLjNMNTU4LjMgMjQ2LjhjLTEzIDEzLTIwLjMgMzAuNS0yMC4zIDQ4LjkgMCAxOC41IDcuMiAzNS44IDIwLjMgNDguOWw4OS42IDg5LjdhNDA1LjQ2IDQwNS40NiAwIDAxLTg2LjQgMTI3LjNjLTM2LjcgMzYuOS03OS42IDY2LTEyNy4yIDg2LjZsLTg5LjYtODkuN2MtMTMtMTMtMzAuNC0yMC4zLTQ4LjgtMjAuM2E2OC4yIDY4LjIgMCAwMC00OC44IDIwLjNMMTMyLjMgNjczYy0xMyAxMy0yMC4zIDMwLjUtMjAuMyA0OC45IDAgMTguNSA3LjIgMzUuOCAyMC4zIDQ4LjlsMTA2LjQgMTA2LjRjMjIuMiAyMi4yIDUyLjggMzQuOSA4NC4yIDM0LjkgNi41IDAgMTIuOC0uNSAxOS4yLTEuNiAxMzIuNC0yMS44IDI2My44LTkyLjMgMzY5LjktMTk4LjNDODE4IDYwNiA4ODguNCA0NzQuNiA5MTAuNCAzNDIuMWM2LjMtMzcuNi02LjMtNzYuMy0zMy4zLTEwMy40em0tMzcuNiA5MS41Yy0xOS41IDExNy45LTgyLjkgMjM1LjUtMTc4LjQgMzMxcy0yMTMgMTU4LjktMzMwLjkgMTc4LjRjLTE0LjggMi41LTMwLTIuNS00MC44LTEzLjJMMTg0LjkgNzIxLjkgMjk1LjcgNjExbDExOS44IDEyMCAuOS45IDIxLjYtOGE0ODEuMjkgNDgxLjI5IDAgMDAyODUuNy0yODUuOGw4LTIxLjYtMTIwLjgtMTIwLjcgMTEwLjgtMTEwLjkgMTA0LjUgMTA0LjVjMTAuOCAxMC44IDE1LjggMjYgMTMuMyA0MC44eiIgLz48L3N2Zz4=) */ const $c1a35a530b2e1d2f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($c1a35a530b2e1d2f$var$PhoneOutlined);
var $c1a35a530b2e1d2f$export$2e2bcd8739ae039 = $c1a35a530b2e1d2f$var$RefIcon;



const $790c661e8a1b7309$export$43f8c56ecaed56ba = ({ phone: phone })=>{
    if (!phone) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: "-"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
        href: (0, $30eeeb9bc1cd6f03$export$8045d8ca670cb8a4)(phone),
        style: {
            color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[4]
        },
        onClick: (e)=>e.stopPropagation(),
        children: [
            phone,
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1a35a530b2e1d2f$export$2e2bcd8739ae039), {})
        ]
    });
};





var $45fvw = parcelRequire("45fvw");
const $babfc502ba0d4a2b$export$497d7672911538dd = ()=>{
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)();
    const { orders: orders } = (0, $c65875392bff9feb$export$c8df679eea5b0938)();
    const [showPerClient, setShowPerClient] = (0, $d2d35d9e12279cc3$export$f721b343fdbe81e0)('showPerClient', 'false');
    const [search, setSearch] = (0, $d2d35d9e12279cc3$export$f721b343fdbe81e0)('search', '');
    const columns = [
        {
            title: 'Klient',
            dataIndex: 'client',
            key: 'name',
            render: (_, order)=>{
                const isAdmin = (userLevel ?? 0) >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).admin;
                if (!isAdmin) return order.client.name;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/clients/${order.client.id}`,
                    children: order.client.name
                });
            }
        },
        {
            title: 'Telefon',
            dataIndex: 'client',
            key: 'phone',
            render: (_, order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                    phone: order.contact ?? order.client.phone
                })
        },
        {
            title: "Ilo\u015B\u0107",
            dataIndex: 'count',
            key: 'count',
            render: (_, order)=>order.count
        },
        {
            title: 'Podstawiony',
            dataIndex: 'deliveryDate',
            key: 'deliveryDate',
            render: (_, order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.deliveryDate), 'days'),
                        " dni temu"
                    ]
                })
        },
        {
            title: 'Termin odbioru',
            dataIndex: 'claimingDate',
            key: 'claimingDate',
            render: (_, order)=>{
                if (!order.claimingDate) return '-';
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.claimingDate).format('DD.MM.YYYY')
                });
            }
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address',
            render: (_, order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${order.id}/loose`,
                    children: order.address
                })
        },
        {
            title: 'Rodzaj odpadu',
            dataIndex: 'wasteType',
            key: 'wasteType',
            render: (_, order)=>order.wasteType
        }
    ];
    const columnsPerClient = [
        {
            title: 'Klient',
            dataIndex: 'client',
            key: 'name',
            render: (_, orders)=>{
                const client = orders[0].client;
                const isAdmin = (userLevel ?? 0) >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).admin;
                if (!isAdmin) return client.name;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/clients/${client.id}`,
                    children: client.name
                });
            }
        },
        {
            title: 'Telefon',
            dataIndex: 'client',
            key: 'phone',
            render: (_, orders)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                    phone: orders[0].client.phone
                })
        },
        {
            title: "Ilo\u015B\u0107",
            dataIndex: 'count',
            key: 'count',
            render: (_, orders)=>orders.reduce((sum, order)=>sum + order.count, 0)
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address',
            render: (_, orders)=>orders.map((order, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/panel/orders/${order.id}/loose`,
                                children: order.address
                            }),
                            i !== orders.length - 1 ? ', ' : ''
                        ]
                    }, order.id))
        }
    ];
    const filtered = (0, $acw62.useMemo)(()=>{
        if (!orders) return undefined;
        const s = search?.toLocaleString().toLocaleLowerCase();
        if (!s) return orders;
        return orders.filter((order)=>{
            if (order.client.name.toLocaleLowerCase().includes(s)) return true;
            if (order.address.toLocaleLowerCase().includes(s)) return true;
            return false;
        });
    }, [
        search,
        orders
    ]);
    const perClient = showPerClient === 'true' && filtered?.reduce((acc, order)=>{
        const clientId = order.client.id;
        if (!acc[clientId]) acc[clientId] = [];
        acc[clientId].push(order);
        return acc;
    }, {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Podstawione bagi",
        actions: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                type: "primary",
                size: "large",
                onClick: ()=>setShowPerClient(showPerClient === 'true' ? 'false' : 'true'),
                children: showPerClient === 'true' ? "Poka\u017C zam\xf3wienia osobno" : "Poka\u017C sum\u0119 na klienta"
            }, "toggle")
        ],
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col flex-1 overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                        size: "large",
                        placeholder: "Szukaj",
                        value: search,
                        onChange: (e)=>setSearch(e.target.value.length === 0 ? undefined : e.target.value)
                    })
                }),
                showPerClient === 'true' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e446ba5d777c4273$exports))), {
                    columns: columnsPerClient,
                    dataSource: perClient ? Object.values(perClient) : [],
                    loading: !perClient,
                    pagination: false,
                    scroll: {
                        x: 'max-content'
                    },
                    rowKey: (record)=>String(record[0]?.client.id)
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e446ba5d777c4273$exports))), {
                    columns: columns,
                    dataSource: filtered ?? [],
                    loading: !filtered,
                    pagination: false,
                    scroll: {
                        x: 'max-content'
                    },
                    rowKey: "id"
                })
            ]
        })
    });
};



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");







var $45fvw = parcelRequire("45fvw");

const $3563129eed42bd13$var$DataTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
	width: 100%;

	tr {
		width: 100%;
	}

	td {
		width: 50%;
		padding-bottom: 30px;

		> p {
			padding-bottom: 5px;

			.user-data {
				font-size: 24px;
				font-weight: 400;
				color: ${(0, $0b4842326956570d$export$2aa0182783e7e9de)[6]};
			}
		}

		&:last-child {
			padding-left: 12.5px;
		}
	}
`;
const $3563129eed42bd13$export$62a054c396228590 = ({ client: client, name: name, own: own })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3563129eed42bd13$var$DataTable, {
        children: own ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                children: [
                    name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Klient"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: `/panel/clients/${own.client?.id}`,
                                                children: own.client?.name
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Do"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: own.to
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Adres"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: own.address
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Data"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(own.date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(own.date).hours() === 0)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    own.closed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Waga"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "user-data",
                                                    children: [
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(own.weight),
                                                        " kg"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Zamkni\u0119te"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "user-data",
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(own.closed)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Przez"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "user-data",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        to: `/panel/drivers/${own.closed_by?.id}`,
                                                        children: [
                                                            own.closed_by?.name,
                                                            " ",
                                                            own.closed_by?.surname
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                children: [
                    name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Klient"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: client.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Typ"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: client.type ? 'Osobna prywatna' : 'Firma'
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Numer BDO"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: client.bdo ?? '-'
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Numer telefonu"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                                                phone: client.phone
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: client.email ?? '-'
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Numer Nip"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "user-data",
                                            children: client.nip ?? '-'
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    size: "large",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>navigate(`/panel/clients/${client.id}`),
                                    children: "Szczeg\xf3\u0142y klienta"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};



var $acw62 = parcelRequire("acw62");





var $45fvw = parcelRequire("45fvw");
const $043b8b84aa7e0adb$var$newClient = {};
function $043b8b84aa7e0adb$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { related_id: related_id, client: clientId } = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search);
    const [clients, setClients] = (0, $acw62.useState)();
    const [sizes, setSizes] = (0, $acw62.useState)();
    const [client, setClient] = (0, $acw62.useState)();
    const [addresses, setAddresses] = (0, $acw62.useState)([]);
    const [order, setOrder] = (0, $acw62.useState)({
        date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(),
        claiming_date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(),
        on_place: 0
    });
    const [loading, setLoading] = (0, $acw62.useState)();
    const fetch = async (client)=>{
        try {
            client ??= clientId;
            const clients = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.getAll();
            setClients(clients.filter((c)=>!c.removed).sort((a, b)=>new Date(b.created) - new Date(a.created)));
            setSizes(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll());
            if (related_id) {
                const related = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(related_id);
                if (!related) throw "Nie mo\u017Cna za\u0142adowa\u0107 zam\xf3wienia do wymiany";
                const c = clients.filter((c)=>c.id === related.client.id)[0];
                setOrder((order)=>({
                        ...order,
                        related_id: related_id,
                        client_id: related.client.id,
                        client: c,
                        bdo: related.bdo,
                        waste_type: related.waste_type,
                        address: related.address,
                        size_id: related.size.id,
                        claiming_date: related.claiming_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(related.claiming_date) : null,
                        price: related.price,
                        price_type: related.price_type,
                        payment_type: related.payment_type
                    }));
                setClient(c?.name);
            }
            if (client) {
                const c = clients.filter((c)=>c.id == client)[0];
                setOrder((order)=>({
                        ...order,
                        client_id: client,
                        client: c
                    }));
                setClient(c?.name);
                delete $043b8b84aa7e0adb$var$newClient.client;
            }
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const fetchAddresses = async (clientId)=>{
        try {
            const addresses = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).addresses.getAll({
                clientId: clientId
            });
            setAddresses(addresses);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch($043b8b84aa7e0adb$var$newClient.client);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!order?.client_id) return;
        fetchAddresses(order.client_id);
    }, [
        order?.client_id
    ]);
    const autocompleteClient = (name)=>{
        const client = clients.filter((client)=>client.name == name)[0];
        if (!client) return;
        setOrder((order)=>({
                ...order,
                client_id: client.id,
                client: client
            }));
    };
    const clientChanged = (name)=>{
        const client = clients.filter((client)=>client.name == name)[0];
        setOrder((order)=>({
                ...order,
                client_id: client?.id,
                client: client
            }));
        setClient(name);
    };
    const createOrder = async ()=>{
        try {
            setLoading(true);
            const o = {
                ...order
            };
            const address = addresses.find((address)=>address.name == o.address);
            if (!address) await (0, $4c992464a65faeac$export$2e2bcd8739ae039).addresses.add({
                name: o.address,
                clientId: o.client_id
            });
            if (o.time) {
                o.date.hours(o.time.get('hour'));
                o.date.minutes(o.time.get('minute'));
            } else {
                o.date.hours(0);
                o.date.minutes(0);
            }
            o.date.seconds(0);
            o.date = o.date.unix() * 1000;
            if (o.claiming_date === null) o.claiming = null;
            else {
                o.claiming = o.claiming_date;
                if (o.claiming_time) {
                    o.claiming.hours(o.claiming_time.get('hour'));
                    o.claiming.minutes(o.claiming_time.get('minute'));
                } else {
                    o.claiming.hours(0);
                    o.claiming.minutes(0);
                }
                o.claiming.seconds(0);
                o.claiming = o.claiming_date.unix() * 1000;
            }
            delete o.client;
            delete o.time;
            delete o.claiming_date;
            delete o.claiming_time;
            const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.create(o);
            setLoading(false);
            navigate(`/panel/orders/${result.id}`, {
                replace: true
            });
        } catch (e) {
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const disabled = (0, $acw62.useMemo)(()=>{
        if (!order.client_id) return true;
        if (order.client?.lockedDate) return true;
        if (isNaN(order.bdo)) return true;
        if (!order.waste_type) return true;
        if (!order.address) return true;
        if (isNaN(order.size_id)) return true;
        if (!order.date) return true;
        if (order.claiming_date === undefined) return true;
        if (isNaN(order.on_place)) return true;
        if (isNaN(order.price)) return true;
        if (isNaN(order.price_type)) return true;
        if (isNaN(order.payment_type)) return true;
    }, [
        order
    ]);
    return [
        {
            related_id: related_id,
            order: order,
            clients: clients,
            client: client,
            addresses: addresses,
            newClient: $043b8b84aa7e0adb$var$newClient,
            sizes: sizes,
            loading: loading,
            disabled: disabled
        },
        {
            autocompleteClient: autocompleteClient,
            clientChanged: clientChanged,
            bdoChanged: (bdo)=>setOrder((order)=>({
                        ...order,
                        bdo: bdo
                    })),
            typeChanged: (waste_type)=>setOrder((order)=>({
                        ...order,
                        waste_type: waste_type
                    })),
            addressChanged: (address)=>setOrder((order)=>({
                        ...order,
                        address: address
                    })),
            contactChanged: (e)=>setOrder((order)=>({
                        ...order,
                        contact: e.target.value
                    })),
            dateChanged: (date)=>setOrder((order)=>({
                        ...order,
                        date: date
                    })),
            timeChanged: (time)=>setOrder((order)=>({
                        ...order,
                        time: time
                    })),
            claimingDateChanged: (claiming_date)=>setOrder((order)=>({
                        ...order,
                        claiming_date: claiming_date
                    })),
            claimingTimeChanged: (claiming_time)=>setOrder((order)=>({
                        ...order,
                        claiming_time: claiming_time
                    })),
            claimingChanged: (claiming)=>setOrder((order)=>({
                        ...order,
                        claiming_date: claiming ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))() : null
                    })),
            onPlaceChanged: (on_place)=>setOrder((order)=>({
                        ...order,
                        on_place: on_place,
                        claiming_date: on_place ? null : (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))()
                    })),
            sizeChanged: (size_id)=>setOrder((order)=>({
                        ...order,
                        size_id: size_id
                    })),
            priceChanged: (e)=>setOrder((order)=>({
                        ...order,
                        price: e.target.value
                    })),
            priceTypeChanged: (price_type)=>setOrder((order)=>({
                        ...order,
                        price_type: price_type
                    })),
            paymentTypeChanged: (payment_type)=>setOrder((order)=>({
                        ...order,
                        payment_type: payment_type
                    })),
            commentsChanged: (e)=>setOrder((order)=>({
                        ...order,
                        comments: e.target.value
                    })),
            createOrder: createOrder
        }
    ];
}




var $acw62 = parcelRequire("acw62");

const { Option: $7013af25856fcb54$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $7013af25856fcb54$var$SearchSelector = ({ elements: elements, value: value, id: id, onChange: onChange, buildElement: buildElement, width: width, allowCustom: allowCustom, ignoreCaseAndTrim: ignoreCaseAndTrim })=>{
    const [search, setSearch] = (0, $acw62.useState)();
    const getElementId = (element)=>{
        if (!id) return element;
        if (!element) return element;
        return element[id];
    };
    const selectedElement = (0, $acw62.useMemo)(()=>{
        const foundElement = elements?.find((element)=>{
            if (ignoreCaseAndTrim) return getElementId(element)?.trim()?.toLowerCase() == value?.trim()?.toLowerCase();
            return getElementId(element) == value;
        });
        if (foundElement) return foundElement;
        if (!allowCustom || !search) return null;
        return search;
    }, [
        elements,
        value
    ]);
    const options = (0, $acw62.useMemo)(()=>{
        const options = elements?.map((element)=>{
            const id = getElementId(element);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7013af25856fcb54$var$Option, {
                value: id,
                children: buildElement(element)
            }, id);
        });
        if (allowCustom && search) {
            const child = `${search} (nowy)`;
            options?.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7013af25856fcb54$var$Option, {
                value: search,
                children: child
            }, search));
        }
        return options;
    }, [
        elements,
        search,
        allowCustom
    ]);
    const onSearch = (value)=>{
        const foundElement = elements?.find((element)=>buildElement(element) == value);
        if (foundElement) setSearch();
        else setSearch(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
        showSearch: true,
        size: "large",
        onSearch: onSearch,
        style: {
            width: width
        },
        value: selectedElement && buildElement(selectedElement),
        onChange: (id)=>onChange(id),
        optionFilterProp: "children",
        filterOption: (input, option)=>option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        filterSort: (optionA, optionB)=>optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()),
        children: options
    });
};
var $7013af25856fcb54$export$2e2bcd8739ae039 = $7013af25856fcb54$var$SearchSelector;





const { TextArea: $1df14280bdd03c65$var$TextArea } = (0, $ad70426818bb52aa$export$2e2bcd8739ae039);
const $1df14280bdd03c65$var$LockedMessage = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
	color: ${(0, $0b4842326956570d$export$a90204d1394caf30)[5]} !important;
	font-weight: 400 !important;
	font-size: 16px !important;
`;
const $1df14280bdd03c65$var$NewDelivery = ({ select: select })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [{ related_id: related_id, order: order, clients: clients, client: client, addresses: addresses, newClient: newClient, sizes: sizes, loading: loading, disabled: disabled }, { autocompleteClient: autocompleteClient, clientChanged: clientChanged, bdoChanged: bdoChanged, typeChanged: typeChanged, addressChanged: addressChanged, contactChanged: contactChanged, dateChanged: dateChanged, timeChanged: timeChanged, claimingChanged: claimingChanged, claimingDateChanged: claimingDateChanged, claimingTimeChanged: claimingTimeChanged, onPlaceChanged: onPlaceChanged, sizeChanged: sizeChanged, priceChanged: priceChanged, priceTypeChanged: priceTypeChanged, paymentTypeChanged: paymentTypeChanged, commentsChanged: commentsChanged, createOrder: createOrder }] = (0, $043b8b84aa7e0adb$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: createOrder,
            disabled: disabled,
            loading: loading,
            children: "Dodaj zam\xf3wienie"
        }, "0")
    ];
    if (order.client?.lockedDate) actions.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1df14280bdd03c65$var$LockedMessage, {
        children: "Klient zablokowany!"
    }));
    const wasteTypes = [
        'Mieszany',
        'Gruz',
        'Drewno',
        'Styropian',
        'Papa'
    ];
    const loaded = (0, $acw62.useMemo)(()=>clients && sizes, [
        clients,
        sizes
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Zam\xf3wienia / Nowe",
        actions: loaded && actions,
        children: loaded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
            title: "Klient",
            select: select,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "new-delivery",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Klient"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                        size: "large",
                                        options: clients.map((client)=>({
                                                value: client.name
                                            })),
                                        filterOption: (inputValue, option)=>{
                                            const client = clients.filter((client)=>client.name === option.value)[0];
                                            if (!client) return false;
                                            if (`${client.name}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.phone}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.nip}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.bdo}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.email}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                        },
                                        onSelect: autocompleteClient,
                                        onChange: clientChanged,
                                        value: client
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir flex-ac",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        size: "large",
                                        type: "primary",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
                                        onClick: async ()=>{
                                            const client = await (0, $528eec0198c20a54$export$4762a55173472f42)(navigate, `/panel/new-client`);
                                            if (!client) return;
                                            navigate(`.?type=0&client=${client.id}`, {
                                                replace: true
                                            });
                                        },
                                        children: "Dodaj nowego klienta"
                                    })
                                ]
                            })
                        ]
                    }),
                    order.client && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3563129eed42bd13$export$62a054c396228590), {
                        client: order.client
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        title: "Informacje",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "BDO"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: order.bdo,
                                                onChange: bdoChanged,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: 0,
                                                        children: "BDO"
                                                    }, "0"),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: 1,
                                                        children: "Wytwarzaj\u0105cy"
                                                    }, "1")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Rodzaj odpad\xf3w"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                                size: "large",
                                                options: wasteTypes.map((type)=>({
                                                        value: type
                                                    })),
                                                filterOption: (inputValue, option)=>option.value.toUpperCase().includes(inputValue.toUpperCase()),
                                                value: order.waste_type,
                                                onSelect: typeChanged,
                                                onChange: typeChanged
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Adres"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7013af25856fcb54$export$2e2bcd8739ae039), {
                                                id: "name",
                                                elements: addresses,
                                                buildElement: (address)=>typeof address === 'string' ? address : address.name,
                                                value: order.address,
                                                onChange: addressChanged,
                                                allowCustom: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Numer kontaktowy"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                size: "large",
                                                type: "text",
                                                value: order.contact,
                                                onChange: contactChanged
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !related_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-dir",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                            checked: order.on_place === 1,
                                            onChange: (e)=>onPlaceChanged(e.target.checked ? 1 : 0),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                onClick: ()=>onPlaceChanged(order.on_place === 0 ? 1 : 0),
                                                children: "Za\u0142adunek na miejscu"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        title: "Zapotrzebowanie",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Termin podstawienia"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                                size: "large",
                                                placeholder: "Wybierz dat\u0119",
                                                value: order.date,
                                                onChange: dateChanged
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                                size: "large",
                                                format: "HH:mm",
                                                placeholder: "Wybierz godzin\u0119",
                                                value: order.time,
                                                onChange: timeChanged
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Wybierz rozmiar"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: order.size_id,
                                                onChange: sizeChanged,
                                                children: sizes.map((size)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: size.id,
                                                        children: size.name
                                                    }, size.id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-dir flex-ac",
                                        children: !order.on_place && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "\xa0"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                                    checked: order.claiming_date === null,
                                                    onChange: (e)=>claimingChanged(!e.target.checked),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        onClick: ()=>claimingChanged(order.claiming_date === null),
                                                        children: "Bez terminu odbioru"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            order.claiming_date !== null && !order.on_place && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Termin odbioru"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                                size: "large",
                                                placeholder: "Wybierz dat\u0119",
                                                value: order.claiming_date,
                                                onChange: claimingDateChanged
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                                size: "large",
                                                format: "HH:mm",
                                                placeholder: "Wybierz godzin\u0119",
                                                value: order.claiming_time,
                                                onChange: claimingTimeChanged
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Cena"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        size: "large",
                                                        type: "text",
                                                        value: order.price,
                                                        onChange: priceChanged
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "pln flex flex-dir flex-jc flex-ac",
                                                        children: "PLN"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Netto / Brutto"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: order.price_type,
                                                onChange: priceTypeChanged,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: 0,
                                                        children: "Netto"
                                                    }, "0"),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: 1,
                                                        children: "Brutto"
                                                    }, "1")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Typ zap\u0142aty"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: order.payment_type,
                                                onChange: paymentTypeChanged,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: 0,
                                                        children: "Przelew"
                                                    }, "0"),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: 1,
                                                        children: "Got\xf3wka"
                                                    }, "1")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        title: "Uwagi",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1df14280bdd03c65$var$TextArea, {
                            value: order.comments,
                            onChange: commentsChanged
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $1df14280bdd03c65$export$2e2bcd8739ae039 = $1df14280bdd03c65$var$NewDelivery;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c8d5bba89dc3b725$var$AuditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z"
                }
            }
        ]
    },
    "name": "audit",
    "theme": "outlined"
};
var $c8d5bba89dc3b725$export$2e2bcd8739ae039 = $c8d5bba89dc3b725$var$AuditOutlined;



function $6600d6bed830d245$var$_extends() {
    $6600d6bed830d245$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6600d6bed830d245$var$_extends.apply(this, arguments);
}
const $6600d6bed830d245$var$AuditOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $6600d6bed830d245$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c8d5bba89dc3b725$export$2e2bcd8739ae039)
    }));
/**![audit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5NiAyNTBjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMzg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDI5NnptMTg0IDE0NEgyOTZjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0tNDggNDU4SDIwOFYxNDhoNTYwdjMyMGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04VjEwOGMwLTE3LjctMTQuMy0zMi0zMi0zMkgxNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjc4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmgyNjRjNC40IDAgOC0zLjYgOC04di01NmMwLTQuNC0zLjYtOC04LTh6bTQ0MC04OEg3Mjh2LTM2LjZjNDYuMy0xMy44IDgwLTU2LjYgODAtMTA3LjQgMC02MS45LTUwLjEtMTEyLTExMi0xMTJzLTExMiA1MC4xLTExMiAxMTJjMCA1MC43IDMzLjcgOTMuNiA4MCAxMDcuNFY3NjRINTIwYy04LjggMC0xNiA3LjItMTYgMTZ2MTUyYzAgOC44IDcuMiAxNiAxNiAxNmgzNTJjOC44IDAgMTYtNy4yIDE2LTE2Vjc4MGMwLTguOC03LjItMTYtMTYtMTZ6TTY0NiA2MjBjMC0yNy42IDIyLjQtNTAgNTAtNTBzNTAgMjIuNCA1MCA1MC0yMi40IDUwLTUwIDUwLTUwLTIyLjQtNTAtNTB6bTE4MCAyNjZINTY2di02MGgyNjB2NjB6IiAvPjwvc3ZnPg==) */ const $6600d6bed830d245$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($6600d6bed830d245$var$AuditOutlined);
var $6600d6bed830d245$export$2e2bcd8739ae039 = $6600d6bed830d245$var$RefIcon;


var $acw62 = parcelRequire("acw62");


function $f98060e25b81d381$var$_extends() {
    $f98060e25b81d381$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f98060e25b81d381$var$_extends.apply(this, arguments);
}
const $f98060e25b81d381$var$CheckCircleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $f98060e25b81d381$var$_extends({}, props, {
        ref: ref,
        icon: (0, $915890149dc0569a$export$2e2bcd8739ae039)
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY5OSAzNTNoLTQ2LjljLTEwLjIgMC0xOS45IDQuOS0yNS45IDEzLjNMNDY5IDU4NC4zbC03MS4yLTk4LjhjLTYtOC4zLTE1LjYtMTMuMy0yNS45LTEzLjNIMzI1Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjQuNiAxNzIuOGEzMS44IDMxLjggMCAwMDUxLjcgMGwyMTAuNi0yOTJjMy45LTUuMy4xLTEyLjctNi40LTEyLjd6IiAvPjxwYXRoIGQ9Ik01MTIgNjRDMjY0LjYgNjQgNjQgMjY0LjYgNjQgNTEyczIwMC42IDQ0OCA0NDggNDQ4IDQ0OC0yMDAuNiA0NDgtNDQ4Uzc1OS40IDY0IDUxMiA2NHptMCA4MjBjLTIwNS40IDAtMzcyLTE2Ni42LTM3Mi0zNzJzMTY2LjYtMzcyIDM3Mi0zNzIgMzcyIDE2Ni42IDM3MiAzNzItMTY2LjYgMzcyLTM3MiAzNzJ6IiAvPjwvc3ZnPg==) */ const $f98060e25b81d381$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f98060e25b81d381$var$CheckCircleOutlined);
var $f98060e25b81d381$export$2e2bcd8739ae039 = $f98060e25b81d381$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $20d973f7249e2921$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $20d973f7249e2921$export$2e2bcd8739ae039 = $20d973f7249e2921$var$EditOutlined;



function $498b707c3c04dc0a$var$_extends() {
    $498b707c3c04dc0a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $498b707c3c04dc0a$var$_extends.apply(this, arguments);
}
const $498b707c3c04dc0a$var$EditOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $498b707c3c04dc0a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $20d973f7249e2921$export$2e2bcd8739ae039)
    }));
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ const $498b707c3c04dc0a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($498b707c3c04dc0a$var$EditOutlined);
var $498b707c3c04dc0a$export$2e2bcd8739ae039 = $498b707c3c04dc0a$var$RefIcon;









var $acw62 = parcelRequire("acw62");







function $dbdfd2a010445c02$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [order, setOrder] = (0, $acw62.useState)();
    const [sizes, setSizes] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const [dateModal, setDateModal] = (0, $acw62.useState)();
    const [warningModal, setWarningModal] = (0, $acw62.useState)();
    const [price, setPrice] = (0, $acw62.useState)();
    const [priceType, setPriceType] = (0, $acw62.useState)();
    const [paymentType, setPaymentType] = (0, $acw62.useState)();
    const [wasteType, setWasteType] = (0, $acw62.useState)();
    const [address, setAddress] = (0, $acw62.useState)();
    const [sizeId, setSizeId] = (0, $acw62.useState)();
    const parsedId = parseInt(id);
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)() ?? -1;
    const [priceChanges, fetchPriceChanges] = (0, $340411795f50fc0d$export$75635297fe14ef93)(parsedId, (0, $b9894ce465f84cba$export$168ff345f0815589).classic, userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin);
    const users = (0, $0df0903efbca6a2f$export$90f4370c54dd43c9)({});
    const fetch = async ()=>{
        try {
            setOrder(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(id));
            setSizes(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll());
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const changePrice = async ()=>{
        try {
            setLoading('price');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                price: price ?? order.price,
                price_type: priceType ?? order.priceType
            });
            await fetch();
            await fetchPriceChanges();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zmieniono cen\u0119");
            setPrice();
            setPriceType();
            setLoading();
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const changeInvoice = async ()=>{
        try {
            setLoading('invoice');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                invoice: order.invoice
            });
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zmieniono numer faktury');
            setLoading();
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const changePaymentType = async ()=>{
        try {
            setLoading('payment_type');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                payment_type: paymentType
            });
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zmieniono typ p\u0142atno\u015Bci");
            setPaymentType();
            setLoading();
        } catch (e) {
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const changeDeliveryDate = async (date)=>{
        try {
            setLoading('date');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                delivery_date: date.unix() * 1000
            });
            await fetch();
            setDateModal();
            setLoading();
            return true;
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const changeClaimingDate = async (date)=>{
        try {
            setLoading('date');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                claiming_date: date === null ? null : date.unix() * 1000
            });
            await fetch();
            setDateModal();
            setLoading();
            return true;
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const deleteOrder = async ()=>{
        try {
            setLoading('delete');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.delete(id);
            setWarningModal();
            navigate('/panel/orders', {
                replace: true
            });
            return true;
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const changeType = async ()=>{
        try {
            setLoading('type');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                waste_type: wasteType
            });
            await fetch();
            setWasteType();
            setLoading();
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const changeAddress = async ()=>{
        try {
            setLoading('address');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                address: address
            });
            await fetch();
            setAddress();
            setLoading();
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const setAsPaid = async ()=>{
        try {
            setLoading('paid');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                payment: 1
            });
            await fetch();
            setAddress();
            setLoading();
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const changeSize = async ()=>{
        try {
            setLoading('sizeId');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                size_id: sizeId
            });
            await fetch();
            setSizeId();
            setLoading();
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    return [
        {
            order: order,
            sizes: sizes,
            loading: loading,
            dateModal: dateModal,
            warningModal: warningModal,
            price: price,
            priceType: priceType,
            paymentType: paymentType,
            wasteType: wasteType,
            address: address,
            sizeId: sizeId,
            level: sessionStorage.getItem('level'),
            priceChanges: priceChanges,
            users: users,
            userLevel: userLevel
        },
        {
            priceChanged: (e)=>setPrice(e.target.value),
            invoiceChanged: (e)=>setOrder((order)=>({
                        ...order,
                        invoice: e.target.value
                    })),
            priceTypeChanged: setPriceType,
            paymentTypeChanged: setPaymentType,
            changePrice: changePrice,
            changeInvoice: changeInvoice,
            changePaymentType: changePaymentType,
            setDateModal: setDateModal,
            changeDeliveryDate: changeDeliveryDate,
            changeClaimingDate: changeClaimingDate,
            setWarningModal: setWarningModal,
            deleteOrder: deleteOrder,
            typeChanged: setWasteType,
            changeType: changeType,
            addressChanged: (e)=>setAddress(e.target.value),
            changeAddress: changeAddress,
            setAsPaid: setAsPaid,
            setSizeId: setSizeId,
            changeSize: changeSize
        }
    ];
}



var $45fvw = parcelRequire("45fvw");

const $ff19ba13b059c548$var$DeliveryDetails = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [{ order: order, sizes: sizes, loading: loading, dateModal: dateModal, warningModal: warningModal, price: price, priceType: priceType, paymentType: paymentType, wasteType: wasteType, address: address, sizeId: sizeId, level: level, priceChanges: priceChanges, users: users, userLevel: userLevel }, { priceChanged: priceChanged, invoiceChanged: invoiceChanged, priceTypeChanged: priceTypeChanged, paymentTypeChanged: paymentTypeChanged, changePrice: changePrice, changeInvoice: changeInvoice, changePaymentType: changePaymentType, setDateModal: setDateModal, changeDeliveryDate: changeDeliveryDate, changeClaimingDate: changeClaimingDate, setWarningModal: setWarningModal, deleteOrder: deleteOrder, typeChanged: typeChanged, changeType: changeType, addressChanged: addressChanged, changeAddress: changeAddress, setAsPaid: setAsPaid, setSizeId: setSizeId, changeSize: changeSize }] = (0, $dbdfd2a010445c02$export$2e2bcd8739ae039)();
    const getStateName = (state)=>{
        if (order.claiming_done) return "Zako\u0144czono";
        if (!state) return;
        switch(state){
            case 1:
                if (order.claiming_date && new Date(order.claiming_date) < new Date()) {
                    if (order.related_id > order.id) return 'Do wymiany';
                    return 'Do odbioru';
                }
                return 'Podstawiony';
            case 4:
                return 'W transporcie';
            default:
                return 'Nieznany';
        }
    };
    const type = (0, $acw62.useMemo)(()=>{
        if (!order) return;
        if (order.related_id) {
            if (order.related_id > order.id) return 1;
            if (order.related_id < order.id) {
                if (new Date(order.claiming_date) < new Date()) return 2;
            }
        }
        if (order.claiming_done) return;
        if (order.claiming_taken) return 2;
        if (order.delivery_done) {
            if (new Date(order.claiming_date) < new Date()) return 2;
            return;
        }
        if (order.delivery_taken) return 0;
        return 0;
    }, [
        order
    ]);
    const actions = [
        order && !order.delivery_done && level >= 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            size: "large",
            type: "danger",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
            onClick: ()=>setWarningModal(1),
            children: "Usu\u0144 zam\xf3wienie"
        }, 0)
    ];
    const wasteTypes = [
        'Mieszany',
        'Gruz',
        'Drewno',
        'Styropian',
        'Papa'
    ];
    const taskDetails = (0, $acw62.useMemo)(()=>{
        if (!order) return '';
        if (type === 1 && order.related_id > order.id) return `/panel/tasks/${order.related_id}/${type}`;
        return `/panel/tasks/${order.id}/${type}`;
    }, [
        order,
        type
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Szczeg\xf3\u0142y zam\xf3wienia",
        actions: actions,
        children: order && sizes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
            title: "Klient",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "delivery-details",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3563129eed42bd13$export$62a054c396228590), {
                            client: order.client,
                            name: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Informacje",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "BDO"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: order.bdo ? "Wytwarzaj\u0105cy" : 'BDO'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Rodzaj odpad\xf3w"
                                                }),
                                                level > 0 && !order.claiming_done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex waste-type",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            options: wasteTypes.map((type)=>({
                                                                    value: type
                                                                })),
                                                            filterOption: (inputValue, option)=>option.value.toUpperCase().includes(inputValue.toUpperCase()),
                                                            value: wasteType ?? order.waste_type,
                                                            onSelect: typeChanged,
                                                            onChange: typeChanged
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                            onClick: changeType,
                                                            loading: loading === 'type',
                                                            disabled: !wasteType || wasteType === order.waste_type,
                                                            children: "Zmie\u0144"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: order.waste_type
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Adres"
                                            }),
                                            level > 0 && !order.claiming_done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex address",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        size: "large",
                                                        value: address ?? order.address,
                                                        onChange: addressChanged
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                        onClick: changeAddress,
                                                        loading: loading === 'address',
                                                        disabled: !address || address === order.address,
                                                        children: "Zmie\u0144"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: order.address
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Numer kontaktowy"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                                                phone: order.contact
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Uwagi"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: order.comments ?? '-'
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Zapotrzebowanie",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Termin podstawienia"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "flex date",
                                                    children: [
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.delivery_date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.delivery_date).hours() === 0),
                                                        !order.delivery_taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                                            onClick: ()=>setDateModal({
                                                                    callback: changeDeliveryDate,
                                                                    deadline: 1
                                                                }),
                                                            children: "Zmie\u0144"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Termin odbioru"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "flex date",
                                                    children: order.on_place ? '-' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            order.claiming_date === null ? 'Bez daty odbioru' : (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claiming_date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.claiming_date).hours() === 0),
                                                            !order.claiming_taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                                type: "primary",
                                                                size: "large",
                                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                                                onClick: ()=>setDateModal({
                                                                        callback: changeClaimingDate,
                                                                        deadline: order.related_id && order.related_id > order.id
                                                                    }),
                                                                children: "Zmie\u0144"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Rozmiar"
                                                }),
                                                sizeId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                                    size: 25,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            value: sizeId,
                                                            onChange: setSizeId,
                                                            children: sizes.map((size)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                    value: size.id,
                                                                    children: size.name
                                                                }, size.id))
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                            onClick: changeSize,
                                                            loading: loading === 'sizeId',
                                                            children: "Zapisz"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        order.size.name,
                                                        !order.delivery_taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                                            onClick: ()=>setSizeId(order.size.id),
                                                            children: "Zmie\u0144"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Za\u0142adunek na miejscu"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: order.on_place ? 'Tak' : 'Nie'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Przydzielony kontener"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: order.container?.name ?? 'Brak'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Stan"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: getStateName(order.container?.state?.state) ?? 'Do podstawienia'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        !isNaN(type) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-dir",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                                    onClick: ()=>navigate(taskDetails),
                                                    children: "Szczeg\xf3\u0142y zadania"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-dir",
                                            children: order.delivery_done && !order.claiming_taken && (order.related_id ?? -1) < order.id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1089d062458492a5$export$2e2bcd8739ae039), {}),
                                                    onClick: ()=>navigate(`/panel/new-order?type=0&related_id=${order.id}`),
                                                    children: "Oznacz do wymiany"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        order.delivery_taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Historia",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do podstawienia"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.delivery_taken)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do podstawienia przez"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        order.delivery_by.name,
                                                        " ",
                                                        order.delivery_by.surname
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.delivery_done && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Podstawione"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.delivery_done)
                                                })
                                            ]
                                        }),
                                        order.sign && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir flex-ac",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "\xa0"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                                    onClick: ()=>navigate(`/panel/orders/${order.id}/sign`, {
                                                            state: {
                                                                sign: order.sign
                                                            }
                                                        }),
                                                    children: "Zobacz podpis WZ"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.claiming_taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do odebrania"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claiming_taken)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do odebrania przez"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        order.claiming_by.name,
                                                        " ",
                                                        order.claiming_by.surname
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.claiming_done && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Odebrane"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claiming_done)
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        level > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Finanse",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    children: [
                                                        "Cena (",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "price-type",
                                                            children: order.price_type ? 'Brutto' : 'Netto'
                                                        }),
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            type: "text",
                                                            value: price ?? order.price,
                                                            onChange: priceChanged
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "pln flex flex-dir flex-jc flex-ac",
                                                            children: "PLN"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir flex-ac",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "\xa0"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "price-edit",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            value: priceType ?? order.price_type,
                                                            onChange: priceTypeChanged,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                    value: 0,
                                                                    children: "Netto"
                                                                }, "0"),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                    value: 1,
                                                                    children: "Brutto"
                                                                }, "1")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                            onClick: changePrice,
                                                            disabled: (!`${(price ?? '').trim()}` || price == order.price) && (isNaN(priceType) || priceType === order.price_type),
                                                            loading: loading === 'price',
                                                            children: "Zmie\u0144 cen\u0119"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.payment_type === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zaliczka"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: order.advance ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.advance) : '-'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Typ zaliczki"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: order.advance_type ?? '-'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Typ p\u0142atno\u015Bci"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex payment-type",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            value: paymentType ?? order.payment_type,
                                                            onChange: paymentTypeChanged,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                    value: 0,
                                                                    children: "Przelew"
                                                                }, "0"),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                    value: 1,
                                                                    children: "Got\xf3wka"
                                                                }, "1")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                            onClick: changePaymentType,
                                                            disabled: isNaN(paymentType),
                                                            loading: loading === 'payment_type',
                                                            children: "Zmie\u0144"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-dir",
                                            children: order.payment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Zap\u0142acone"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.payment)
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex flex-ac",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                            onClick: setAsPaid,
                                                            loading: loading === 'paid',
                                                            children: "Oznacz jako zap\u0142acone"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Faktura"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    type: "text",
                                                    value: order.invoice,
                                                    onChange: invoiceChanged
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir flex-ac",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "\xa0"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6600d6bed830d245$export$2e2bcd8739ae039), {}),
                                                        onClick: changeInvoice,
                                                        loading: loading === 'invoice',
                                                        children: "Wystaw faktur\u0119"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "price-change-history",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Historia zmian ceny"
                                            })
                                        }),
                                        priceChanges && priceChanges.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "price-change-table",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                children: "Data"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "text-center",
                                                                children: "Przez"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "text-right",
                                                                children: "Stara cena"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                className: "text-right",
                                                                children: "Nowa cena"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                    children: priceChanges.map((change)=>{
                                                        const user = users?.find((u)=>u.id === change.createdBy);
                                                        const oldPrice = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(change.oldPriceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? change.oldGrossPrice : change.oldNetPrice);
                                                        const newPrice = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(change.newPriceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? change.newGrossPrice : change.newNetPrice);
                                                        const oldPriceType = (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(change.oldPriceType);
                                                        const newPriceType = (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(change.newPriceType);
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(change.createdAt)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "text-center",
                                                                    children: user ? `${user.name} ${user.surname}` : '-'
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    className: "text-right",
                                                                    children: [
                                                                        oldPrice,
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "price-type",
                                                                            children: [
                                                                                "(",
                                                                                oldPriceType,
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    className: "text-right",
                                                                    children: [
                                                                        newPrice,
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "price-type",
                                                                            children: [
                                                                                "(",
                                                                                newPriceType,
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, change.id);
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            children: "Brak historii zmian ceny"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36a81de199cd8a95$export$2e2bcd8739ae039), {
                    visible: dateModal,
                    onCancel: ()=>setDateModal(),
                    onOk: dateModal?.callback,
                    loading: loading === 'date',
                    deadline: dateModal?.deadline
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fd0b816bbe13d58$export$2e2bcd8739ae039), {
                    visible: warningModal,
                    onCancel: ()=>setWarningModal(),
                    onOk: ()=>deleteOrder(),
                    loading: loading === 'delete',
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Czy na pewno chcesz usun\u0105\u0107 to zam\xf3wienie?"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $ff19ba13b059c548$export$2e2bcd8739ae039 = $ff19ba13b059c548$var$DeliveryDetails;



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



function $ec5337e84dd6b49b$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [clients, setClients] = (0, $acw62.useState)();
    const [contractors, setContractors] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const [own, setOwn] = (0, $acw62.useState)({});
    const client = (0, $acw62.useMemo)(()=>clients?.filter((c)=>c.name === own.client)[0], [
        clients,
        own.client
    ]);
    const fetch = async ()=>{
        try {
            setClients(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.getAll());
            setContractors(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.owns.contractors.getAll());
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const addOwn = async ()=>{
        try {
            setLoading(1);
            own.date.hour(own.time?.hour ?? 0).minute(own.time?.minute ?? 0).second(0);
            const { address: address, to: to, date: date } = own;
            const o = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.owns.put({
                client_id: client.id,
                address: address,
                to: to,
                date: date.unix() * 1000
            });
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Dodano zam\xf3wienie w\u0142asne");
            navigate(`/panel/orders/${o.id}/1`, {
                replace: true
            });
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const disabled = (0, $acw62.useMemo)(()=>{
        if (!client) return true;
        if (!own.address || !own.address.trim()) return true;
        if (!own.to || !own.to.trim()) return true;
        if (!own.date) return true;
        return false;
    }, [
        client,
        own.from,
        own.address,
        own.to,
        own.date
    ]);
    return [
        {
            clients: clients,
            contractors: contractors,
            own: own,
            loading: loading,
            disabled: disabled
        },
        {
            clientChanged: (client)=>setOwn((own)=>({
                        ...own,
                        client: client
                    })),
            addressChanged: (e)=>setOwn((own)=>({
                        ...own,
                        address: e.target.value
                    })),
            toChanged: (to)=>setOwn((own)=>({
                        ...own,
                        to: to
                    })),
            dateChanged: (date)=>setOwn((own)=>({
                        ...own,
                        date: date
                    })),
            timeChanged: (time)=>setOwn((own)=>({
                        ...own,
                        time: time
                    })),
            addOwn: addOwn
        }
    ];
}



const $df7f5d6b6ab3e2d8$var$NewOwn = ({ select: select })=>{
    const [{ clients: clients, contractors: contractors, own: own, loading: loading, disabled: disabled }, { clientChanged: clientChanged, addressChanged: addressChanged, toChanged: toChanged, dateChanged: dateChanged, timeChanged: timeChanged, addOwn: addOwn }] = (0, $ec5337e84dd6b49b$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: addOwn,
            disabled: disabled,
            loading: loading,
            children: "Dodaj zam\xf3wienie"
        }, "0")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Zam\xf3wienia / Nowe",
        actions: actions,
        children: clients && contractors ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
            title: "Informacje",
            select: select,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "new-own flex flex-dir",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Klient"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                        size: "large",
                                        placeholder: "Klient",
                                        options: clients.map((d)=>({
                                                value: d.name
                                            })),
                                        filterOption: (inputValue, option)=>{
                                            const client = clients.filter((client)=>client.name === option.value)[0];
                                            if (!client) return false;
                                            if (`${client.name}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.phone}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.nip}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.bdo}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.email}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                        },
                                        value: own.client,
                                        onSelect: clientChanged,
                                        onChange: clientChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Adres"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: own.address,
                                        onChange: addressChanged
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Do"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                        size: "large",
                                        options: contractors.map((c)=>({
                                                value: c
                                            })),
                                        filterOption: (inputValue, option)=>option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1,
                                        value: own.to,
                                        onSelect: toChanged,
                                        onChange: toChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-dir"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-dir",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    size: "large",
                                    placeholder: "Wybierz dat\u0119",
                                    value: own.date,
                                    onChange: dateChanged
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-dir",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                    size: "large",
                                    format: "HH:mm",
                                    placeholder: "Wybierz godzin\u0119",
                                    value: own.time,
                                    onChange: timeChanged
                                })
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $df7f5d6b6ab3e2d8$export$2e2bcd8739ae039 = $df7f5d6b6ab3e2d8$var$NewOwn;



parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



function $c12317e041b38d0f$export$2e2bcd8739ae039() {
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [own, setOwn] = (0, $acw62.useState)();
    const [weight, setWeight] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const [dateModal, setDateModal] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            setOwn(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.owns.get(id));
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const close = async ()=>{
        try {
            setLoading('closing');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.owns.patch(id, {
                weight: weight
            });
            await fetch();
            setLoading();
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const editDate = async (date)=>{
        if (loading) return;
        try {
            setLoading('date');
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.owns.patch(id, {
                date: date.unix() * 1000
            });
            await fetch();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zmieniono dat\u0119");
            setLoading();
            setDateModal();
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    return [
        {
            own: own,
            weight: weight,
            dateModal: dateModal,
            loading: loading
        },
        {
            weightChanged: (e)=>setWeight(e.target.value?.replace(/\,/g, '.')),
            setDateModal: setDateModal,
            editDate: editDate,
            close: close
        }
    ];
}



const $4d9f7cef5af6a8c1$var$Closing = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	> .ant-space {
		&:not(:last-child) {
			margin-bottom: 25px;
		}

		> div {
			flex: 1;

			> div {
				> label {
					margin-bottom: 4px;
				}

				.pln {
					margin-left: 4px;
				}
			}
		}
	}
`;
const $4d9f7cef5af6a8c1$var$DateEdit = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	margin-bottom: 45px;
`;
const $4d9f7cef5af6a8c1$var$OwnDetails = ()=>{
    const [{ own: own, weight: weight, dateModal: dateModal, loading: loading }, { weightChanged: weightChanged, setDateModal: setDateModal, editDate: editDate, close: close }] = (0, $c12317e041b38d0f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
                title: "Szczeg\xf3\u0142y zam\xf3wienia w\u0142asnego",
                children: !own ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
                    active: true
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Informacje",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3563129eed42bd13$export$62a054c396228590), {
                            name: true,
                            own: own
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4d9f7cef5af6a8c1$var$DateEdit, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                type: "primary",
                                size: "large",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                onClick: ()=>setDateModal(true),
                                children: "Edytuj dat\u0119"
                            })
                        }),
                        !own.closed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Zamkni\u0119cie",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($4d9f7cef5af6a8c1$var$Closing, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                        className: "flex",
                                        size: 25,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-dir",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        children: "Waga"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        size: "large",
                                                        value: weight,
                                                        onChange: weightChanged
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-dir"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                        className: "flex",
                                        size: 25,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                    loading: loading === 'closing',
                                                    onClick: close,
                                                    disabled: isNaN(weight),
                                                    children: "Zamknij"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-dir"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36a81de199cd8a95$export$2e2bcd8739ae039), {
                visible: dateModal,
                onCancel: ()=>setDateModal(),
                onOk: editDate,
                loading: loading === 'date',
                deadline: true
            })
        ]
    });
};
var $4d9f7cef5af6a8c1$export$2e2bcd8739ae039 = $4d9f7cef5af6a8c1$var$OwnDetails;



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");
function $c02a8d7f6302e19d$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [clients, setClients] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const [other, setOther] = (0, $acw62.useState)({
        date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(),
        value_type: 0
    });
    const client = (0, $acw62.useMemo)(()=>clients?.filter((c)=>c.name === other.client)[0], [
        clients,
        other.client
    ]);
    const fetch = async ()=>{
        try {
            setClients(await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.getAll());
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const addOther = async ()=>{
        try {
            setLoading(1);
            other.date.hour(other.time?.hour ?? 0).minute(other.time?.minute ?? 0).second(0);
            const { name: name, value: value, value_type: value_type, comments: comments, date: date } = other;
            const o = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.incomes.put({
                client_id: client.id,
                name: name,
                value: value,
                value_type: value_type,
                comments: comments,
                date: date.unix() * 1000
            });
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Dodano zam\xf3wienie");
            navigate(`/panel/orders/${o.id}/2`, {
                replace: true
            });
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const disabled = (0, $acw62.useMemo)(()=>{
        if (!client) return true;
        if (!other.name || !other.name.trim()) return true;
        if (!other.date) return true;
        if (isNaN(other.value)) return true;
        if (isNaN(other.value_type)) return true;
        return false;
    }, [
        client,
        other.name,
        other.date,
        other.value,
        other.value_type
    ]);
    return [
        {
            clients: clients,
            other: other,
            loading: loading,
            disabled: disabled
        },
        {
            clientChanged: (client)=>setOther((other)=>({
                        ...other,
                        client: client
                    })),
            nameChanged: (e)=>setOther((other)=>({
                        ...other,
                        name: e.target.value
                    })),
            dateChanged: (date)=>setOther((own)=>({
                        ...own,
                        date: date
                    })),
            timeChanged: (time)=>setOther((own)=>({
                        ...own,
                        time: time
                    })),
            valueChanged: (e)=>setOther((other)=>({
                        ...other,
                        value: e.target.value
                    })),
            valueTypeChanged: (value_type)=>setOther((other)=>({
                        ...other,
                        value_type: value_type
                    })),
            commentsChanged: (e)=>setOther((other)=>({
                        ...other,
                        comments: e.target.value
                    })),
            addOther: addOther
        }
    ];
}



const $9906e1ba81bfea3a$var$NewOther = ({ select: select })=>{
    const [{ clients: clients, other: other, loading: loading, disabled: disabled }, { clientChanged: clientChanged, nameChanged: nameChanged, dateChanged: dateChanged, timeChanged: timeChanged, valueChanged: valueChanged, valueTypeChanged: valueTypeChanged, commentsChanged: commentsChanged, addOther: addOther }] = (0, $c02a8d7f6302e19d$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: addOther,
            disabled: disabled,
            loading: loading,
            children: "Dodaj zam\xf3wienie"
        }, "0")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Zam\xf3wienia / Nowe",
        actions: actions,
        children: clients ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
            title: "Informacje",
            select: select,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "new-own flex flex-dir",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Klient"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                        size: "large",
                                        placeholder: "Klient",
                                        options: clients.map((d)=>({
                                                value: d.name
                                            })),
                                        filterOption: (inputValue, option)=>{
                                            const client = clients.filter((client)=>client.name === option.value)[0];
                                            if (!client) return false;
                                            if (`${client.name}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.phone}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.nip}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.bdo}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                            if (`${client.email}`.toLowerCase().includes(inputValue.toLowerCase())) return true;
                                        },
                                        value: other.client,
                                        onSelect: clientChanged,
                                        onChange: clientChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Nazwa"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: other.name,
                                        onChange: nameChanged
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-dir",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    size: "large",
                                    placeholder: "Wybierz dat\u0119",
                                    value: other.date,
                                    onChange: dateChanged
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-dir",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                    size: "large",
                                    format: "HH:mm",
                                    placeholder: "Wybierz godzin\u0119",
                                    value: other.time,
                                    onChange: timeChanged
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 10,
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Cena"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-ac",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        size: "large",
                                                        value: other.value,
                                                        onChange: valueChanged
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "pln",
                                                        children: "PLN"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Netto / Brutto"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: other.value_type,
                                                onChange: valueTypeChanged,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Option, {
                                                        value: 0,
                                                        children: "Netto"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Option, {
                                                        value: 1,
                                                        children: "Brutto"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).TextArea, {
                            size: "large",
                            placeholder: "Komentarze",
                            value: other.comments,
                            onChange: commentsChanged,
                            rows: 5,
                            maxLength: 127
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $9906e1ba81bfea3a$export$2e2bcd8739ae039 = $9906e1ba81bfea3a$var$NewOther;



parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");
function $95c3533afd224635$export$2e2bcd8739ae039() {
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [other, setOther] = (0, $acw62.useState)();
    const [changes, setChanges] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            const other = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.incomes.get(id);
            other.time = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(other.date);
            other.date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(other.date);
            if (other.date.hours() === 0) other.time = null;
            setOther(other);
            setChanges({});
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const save = async ()=>{
        try {
            setLoading('saving');
            const data = {
                ...changes
            };
            if (changes.date || changes.time !== undefined) {
                let date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(other.date).clone();
                if (changes.date) {
                    date = changes.date.clone();
                    date.hours((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(other.date).hour());
                    date.minutes((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(other.date).minute());
                    date.seconds(0);
                }
                if (changes.time) {
                    date.hours((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(changes.time).hour());
                    date.minutes((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(changes.time).minute());
                    date.seconds(0);
                }
                if (changes.time === null) {
                    date.hours(0);
                    date.minutes(0);
                    date.seconds(0);
                }
                data.date = date.unix() * 1000;
                delete data.time;
            }
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.incomes.patch(id, data);
            await fetch();
            setLoading();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zapisano zmiany');
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading();
        }
    };
    const saveDisabled = (0, $acw62.useMemo)(()=>{
        const entries = Object.entries(changes);
        if (!entries.length) return true;
        for (const [k, v] of entries){
            if (other[k] !== v) return false;
        }
        return true;
    }, [
        changes
    ]);
    return [
        {
            other: other,
            changes: changes,
            saveDisabled: saveDisabled,
            loading: loading
        },
        {
            weightChanged: (e)=>setWeight(e.target.value?.replace(/\,/g, '.')),
            nameChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        name: e.target.value
                    })),
            dateChanged: (date)=>setChanges((changes)=>({
                        ...changes,
                        date: date
                    })),
            timeChanged: (time)=>setChanges((changes)=>({
                        ...changes,
                        time: time
                    })),
            valueChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        value: e.target.value
                    })),
            valueTypeChanged: (value_type)=>setChanges((changes)=>({
                        ...changes,
                        value_type: value_type
                    })),
            commentsChanged: (e)=>setChanges((changes)=>({
                        ...changes,
                        comments: e.target.value
                    })),
            save: save
        }
    ];
}



const $e99acb342eb1dba5$var$OtherDetails = ()=>{
    const [{ other: other, changes: changes, saveDisabled: saveDisabled, loading: loading }, { nameChanged: nameChanged, dateChanged: dateChanged, timeChanged: timeChanged, valueChanged: valueChanged, valueTypeChanged: valueTypeChanged, commentsChanged: commentsChanged, save: save }] = (0, $95c3533afd224635$export$2e2bcd8739ae039)();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {}),
            onClick: save,
            disabled: saveDisabled,
            loading: loading === 'saving',
            children: "Zapisz zmiany"
        }, "0")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Szczeg\xf3\u0142y zam\xf3wienia",
        actions: actions,
        children: !other ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
            title: "Informacje",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "new-own flex flex-dir",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-dir",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Klient"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "user-data",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/panel/clients/${other.client?.id}`,
                                        children: other.client?.name
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-dir",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Nazwa"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                    type: "text",
                                    size: "large",
                                    value: changes.name ?? other.name,
                                    onChange: nameChanged
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Data"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                        size: "large",
                                        placeholder: "Wybierz dat\u0119",
                                        value: changes.date ?? other.date,
                                        onChange: dateChanged
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                        size: "large",
                                        format: "HH:mm",
                                        placeholder: "Wybierz godzin\u0119",
                                        value: changes.time === undefined ? other.time : changes.time,
                                        onChange: timeChanged
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 10,
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Cena"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-ac",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        size: "large",
                                                        value: changes.value ?? other.value,
                                                        onChange: valueChanged
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "pln",
                                                        children: "PLN"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Netto / Brutto"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: changes.value_type ?? other.value_type,
                                                onChange: valueTypeChanged,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Option, {
                                                        value: 0,
                                                        children: "Netto"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Option, {
                                                        value: 1,
                                                        children: "Brutto"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).TextArea, {
                            size: "large",
                            placeholder: "Komentarze",
                            value: changes.comments ?? other.comments,
                            onChange: commentsChanged,
                            rows: 5,
                            maxLength: 127
                        })
                    })
                ]
            })
        })
    });
};
var $e99acb342eb1dba5$export$2e2bcd8739ae039 = $e99acb342eb1dba5$var$OtherDetails;




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");








parcelRequire("acw62");

const { Option: $8b1f878ba009a49d$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
function $8b1f878ba009a49d$var$SearchSelector({ placeholder: placeholder, elements: elements, value: value, id: id, allowClear: allowClear, search: search, onChange: onChange, buildElement: buildElement, width: width }) {
    const selectedElement = elements?.find((element)=>element[id] == value);
    const options = elements?.map((element)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b1f878ba009a49d$var$Option, {
            value: element[id],
            children: buildElement(element)
        }, element[id] ?? 'undefined');
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
        size: "large",
        showSearch: true,
        allowClear: allowClear ?? false,
        placeholder: placeholder,
        style: {
            width: width ?? 'auto'
        },
        value: selectedElement && buildElement(selectedElement),
        onChange: (id)=>onChange(id),
        optionFilterProp: "children",
        filterOption: (input, option)=>{
            const element = elements?.find((el)=>el[id] == option?.value);
            if (!search || !element) return `${option?.children}`.toLocaleLowerCase().includes(input.toLocaleLowerCase());
            return search(input, element);
        },
        filterSort: (optionA, optionB)=>`${optionA.children}`.toLocaleLowerCase().localeCompare(`${optionB.children}`.toLocaleLowerCase()),
        children: options
    });
}
var $8b1f878ba009a49d$export$2e2bcd8739ae039 = $8b1f878ba009a49d$var$SearchSelector;





var $45fvw = parcelRequire("45fvw");
const $780fb97d07db6787$var$wasteTypes = [
    'Mieszany',
    'Gruz',
    'Drewno',
    'Styropian',
    'Papa'
];
const $780fb97d07db6787$export$efc0a2e88ebc9664 = ({ select: select, value: value, onChange: onChange })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const clients = (0, $1455449f1630f2df$export$4823a6cc022cca16)({});
    const addresses = (0, $8cc094a24187a8da$export$b610c6a0e5e099e9)(value.client?.id);
    if (!clients) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true
    });
    const onClientChange = (clientId)=>{
        const client = clients.find((client)=>client.id === clientId);
        if (!client) return;
        onChange({
            ...value,
            client: client
        });
    };
    const onBdoChange = (bdo)=>{
        if (bdo === undefined) return;
        onChange({
            ...value,
            bdo: bdo
        });
    };
    const onWasteTypeChange = (wasteType)=>{
        if (wasteType === undefined) return;
        onChange({
            ...value,
            wasteType: wasteType
        });
    };
    const onAddressChange = (address)=>{
        const existing = addresses?.find((a)=>a.name == address);
        onChange({
            ...value,
            address: address,
            isNewAddress: existing === undefined
        });
    };
    const onContactChange = (contact)=>{
        onChange({
            ...value,
            contact: contact
        });
    };
    const onOnPlaceChange = (onPlace)=>{
        onChange({
            ...value,
            onPlace: onPlace
        });
    };
    const onCountChange = (count)=>{
        onChange({
            ...value,
            count: count
        });
    };
    const onClaimingDateChange = (date)=>{
        if (!date) return;
        const claimingAt = value.claimingDate?.clone() ?? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().hours(0).minutes(0).seconds(0);
        onChange({
            ...value,
            claimingDate: claimingAt.set({
                year: date.year(),
                month: date.month(),
                date: date.date()
            })
        });
    };
    const onClaimingTimeChange = (claimingTime)=>{
        if (!claimingTime) return;
        const claimingAt = value.claimingDate?.clone() ?? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
        onChange({
            ...value,
            claimingDate: claimingAt.set({
                hours: claimingTime.hours(),
                minutes: claimingTime.minutes()
            })
        });
    };
    const onDeliveryDateChange = (date)=>{
        if (!date) return;
        const deliveryAt = value.deliveryDate?.clone() ?? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().hours(0).minutes(0).seconds(0);
        onChange({
            ...value,
            deliveryDate: deliveryAt.set({
                year: date.year(),
                month: date.month(),
                date: date.date()
            })
        });
    };
    const onDeliveryTimeChange = (deliveryTime)=>{
        if (!deliveryTime) return;
        const deliveryAt = value.deliveryDate?.clone() ?? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
        onChange({
            ...value,
            deliveryDate: deliveryAt.set({
                hours: deliveryTime.hours(),
                minutes: deliveryTime.minutes()
            })
        });
    };
    const onPriceChange = (price)=>{
        onChange({
            ...value,
            price: price
        });
    };
    const onPriceTypeChange = (priceType)=>{
        if (priceType === undefined) return;
        onChange({
            ...value,
            priceType: priceType
        });
    };
    const onPaymentTypeChange = (wantedPaymentType)=>{
        if (wantedPaymentType === undefined) return;
        onChange({
            ...value,
            wantedPaymentType: wantedPaymentType
        });
    };
    const onWantedAdvanceChange = (wantedAdvance)=>{
        if (!wantedAdvance || wantedAdvance.trim() === '') wantedAdvance = null;
        onChange({
            ...value,
            wantedAdvance: wantedAdvance
        });
    };
    const onCommentsChange = (comments)=>{
        onChange({
            ...value,
            comments: comments
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
        title: "Klient",
        select: select,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "new-delivery",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    size: 25,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-dir",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Klient"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b1f878ba009a49d$export$2e2bcd8739ae039), {
                                    placeholder: "Wybierz klienta",
                                    id: "id",
                                    elements: clients,
                                    buildElement: (client)=>client.name,
                                    value: value.client?.id ?? null,
                                    onChange: onClientChange,
                                    search: (inputValue, client)=>{
                                        const search = inputValue.toLocaleLowerCase();
                                        if (client.name.toLocaleLowerCase().includes(search)) return true;
                                        if (client.phone.toLocaleLowerCase().includes(search)) return true;
                                        if (client.nip?.toLocaleLowerCase().includes(search)) return true;
                                        if (client.bdo?.toLocaleLowerCase().includes(search)) return true;
                                        if (client.email?.toLocaleLowerCase().includes(search)) return true;
                                        return false;
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-dir flex-ac",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    size: "large",
                                    type: "primary",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
                                    onClick: async ()=>{
                                        const client = await (0, $528eec0198c20a54$export$4762a55173472f42)(navigate, `/panel/new-client`);
                                        if (!client) return;
                                        const encoded = JSON.stringify(client);
                                        navigate(`.?type=3&client=${btoa(encoded)}`, {
                                            replace: true
                                        });
                                    },
                                    children: "Dodaj nowego klienta"
                                })
                            ]
                        })
                    ]
                }),
                value.client && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3563129eed42bd13$export$62a054c396228590), {
                    client: value.client
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Informacje",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-dir",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "BDO"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                            size: "large",
                                            value: value.bdo ?? null,
                                            onChange: onBdoChange,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                    value: (0, $5635f57e16062a6d$export$31b3d5f55c6e1017).BDO,
                                                    children: "BDO"
                                                }, "0"),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                    value: (0, $5635f57e16062a6d$export$31b3d5f55c6e1017).producing,
                                                    children: "Wytwarzaj\u0105cy"
                                                }, "1")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-dir",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Rodzaj odpad\xf3w"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                            size: "large",
                                            options: $780fb97d07db6787$var$wasteTypes.map((type)=>({
                                                    value: type
                                                })),
                                            filterOption: (inputValue, option)=>option?.value.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) ?? false,
                                            value: value.wasteType ?? null,
                                            onSelect: onWasteTypeChange,
                                            onChange: onWasteTypeChange
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Adres"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7013af25856fcb54$export$2e2bcd8739ae039), {
                                            id: "name",
                                            elements: addresses,
                                            buildElement: (address)=>typeof address === 'string' ? address : address.name,
                                            value: value.address,
                                            onChange: onAddressChange,
                                            allowCustom: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Numer kontaktowy"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            size: "large",
                                            type: "text",
                                            value: value.contact,
                                            onChange: (e)=>onContactChange(e.target.value)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Zapotrzebowanie",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                    checked: !!value.onPlace,
                                    onChange: (e)=>onOnPlaceChange(e.target.checked),
                                    children: "Za\u0142adunek na miejscu"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Ilo\u015B\u0107 work\xf3w"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            size: "large",
                                            type: "number",
                                            min: 1,
                                            max: 255,
                                            value: value.count,
                                            onChange: (e)=>onCountChange(e.target.value)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-dir",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: value.onPlace ? 'Termin realizacji' : 'Termin podstawienia'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                            size: "large",
                                            placeholder: "Wybierz dat\u0119",
                                            value: value.deliveryDate ?? null,
                                            onChange: onDeliveryDateChange
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "\xa0"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                            size: "large",
                                            format: "HH:mm",
                                            placeholder: "Wybierz godzin\u0119",
                                            value: value.deliveryDate?.hours() === 0 ? null : value.deliveryDate ?? null,
                                            onChange: onDeliveryTimeChange
                                        })
                                    ]
                                })
                            ]
                        }),
                        !value.onPlace && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-dir",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Termin odbioru"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                            size: "large",
                                            placeholder: "Wybierz dat\u0119",
                                            value: value.claimingDate ?? null,
                                            onChange: onClaimingDateChange
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "\xa0"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                            size: "large",
                                            format: "HH:mm",
                                            placeholder: "Wybierz godzin\u0119",
                                            value: value.claimingDate?.hours() === 0 ? null : value.claimingDate ?? null,
                                            onChange: onClaimingTimeChange
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Cena"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    type: "text",
                                                    value: value.price,
                                                    onChange: (e)=>onPriceChange(e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "pln flex flex-dir flex-jc flex-ac",
                                                    children: "PLN"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-dir",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Netto / Brutto"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                            size: "large",
                                            value: value.priceType ?? null,
                                            onChange: onPriceTypeChange,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                    value: (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net,
                                                    children: "Netto"
                                                }, "0"),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                    value: (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross,
                                                    children: "Brutto"
                                                }, "1")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-dir",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Typ zap\u0142aty"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                            size: "large",
                                            value: value.wantedPaymentType ?? null,
                                            onChange: onPaymentTypeChange,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                    value: (0, $83530e2bf16dcece$export$439d2d6c03747598).transfer,
                                                    children: "Przelew"
                                                }, "0"),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                    value: (0, $83530e2bf16dcece$export$439d2d6c03747598).cash,
                                                    children: "Got\xf3wka"
                                                }, "1")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Zaliczka"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex gap-x-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    type: "text",
                                                    value: value.wantedAdvance ?? '',
                                                    onChange: (e)=>onWantedAdvanceChange(e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    onClick: ()=>onWantedAdvanceChange(null),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {})
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Uwagi",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).TextArea, {
                        value: value.comments,
                        onChange: (e)=>onCommentsChange(e.target.value)
                    })
                })
            ]
        })
    });
};





const $01b053db98195fff$export$e00f25366f645414 = ()=>{
    const createOrder = async (data, isNewAddress)=>{
        try {
            if (isNewAddress) await (0, $4c992464a65faeac$export$2e2bcd8739ae039).addresses.add({
                name: data.address,
                clientId: data.clientId
            });
            return await (0, $4c992464a65faeac$export$2e2bcd8739ae039).looseOrders.create({
                ...data,
                subtype: (0, $5635f57e16062a6d$export$23fbb8b25ca69f0b).BigBag
            });
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} doda\u{107} zam\xf3wienia (${e})`);
            return undefined;
        }
    };
    return {
        createOrder: createOrder
    };
};






const $23d74c100d3c3028$var$LockedMessage = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
	color: ${(0, $0b4842326956570d$export$a90204d1394caf30)[5]} !important;
	font-weight: 400 !important;
	font-size: 16px !important;
`;
const $23d74c100d3c3028$export$d17cee8cb96a8181 = ({ select: select })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).parse(location.search, {
        ignoreQueryPrefix: true
    });
    const [value, setValue] = (0, $acw62.useState)({
        count: '1'
    });
    const [adding, setAdding] = (0, $acw62.useState)(false);
    const { createOrder: createOrder } = (0, $01b053db98195fff$export$e00f25366f645414)();
    (0, $acw62.useEffect)(()=>{
        const clientRaw = query['client'];
        if (!clientRaw) return;
        const client = JSON.parse(atob(clientRaw));
        if (!client || !client.id) return;
        setValue((prev)=>({
                ...prev,
                client: client
            }));
        navigate('.?type=3', {
            replace: true
        });
    }, [
        query['client']
    ]);
    const onCreateOrder = async ()=>{
        if (!value.client) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie wybrano klienta');
            return;
        }
        if (value.bdo === undefined) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie wybrano BDO');
            return;
        }
        const wasteType = value.wasteType?.trim() ?? null;
        if (!wasteType || wasteType === '') {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie wybrano typu odpadu');
            return;
        }
        const address = value.address?.trim() ?? null;
        if (!address || address === '') {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie podano adresu');
            return;
        }
        const contact = value.contact?.trim() ?? undefined;
        const countRaw = value.count;
        if (!countRaw || countRaw === '') {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Nie podano ilo\u015Bci work\xf3w");
            return;
        }
        const count = Number.parseInt(countRaw, 10);
        if (isNaN(count)) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Ilo\u015B\u0107 work\xf3w musi by\u0107 liczb\u0105");
            return;
        }
        if (count < 1 || count > 255) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Ilo\u015B\u0107 work\xf3w musi by\u0107 z zakresu 1 - 255");
            return;
        }
        const priceRaw = value.price?.trim() ?? null;
        if (!priceRaw || priceRaw === '') {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie podano ceny');
            return;
        }
        const price = Number.parseFloat(priceRaw);
        if (Number.isNaN(price)) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Cena musi by\u0107 liczb\u0105");
            return;
        }
        if (price < 0) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Cena musi by\u0107 dodatnia");
            return;
        }
        if (price > 999999.99) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Cena nie mo\u017Ce by\u0107 wi\u0119ksza od 999 999.99 PLN");
            return;
        }
        const wantedAdvanceRaw = value.wantedAdvance?.trim() ?? null;
        const wantedAdvance = wantedAdvanceRaw ? Number.parseFloat(wantedAdvanceRaw) : null;
        if (wantedAdvance) {
            if (Number.isNaN(wantedAdvance)) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zaliczka musi by\u0107 liczb\u0105");
                return;
            }
            if (wantedAdvance < 0) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zaliczka musi by\u0107 dodatnia");
                return;
            }
            if (wantedAdvance > 999999.99) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zaliczka nie mo\u017Ce by\u0107 wi\u0119ksza od 999 999.99 PLN");
                return;
            }
            if (wantedAdvance > price) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zaliczka nie mo\u017Ce by\u0107 wi\u0119ksza od ceny");
                return;
            }
        }
        if (value.priceType === undefined) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie wybrano typu ceny');
            return;
        }
        if (value.wantedPaymentType === undefined) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Nie wybrano typu p\u0142atno\u015Bci");
            return;
        }
        const comments = value.comments?.trim() ?? undefined;
        if (!value.deliveryDate) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Nie wybrano terminu podstawienia');
            return;
        }
        setAdding(true);
        const order = await createOrder({
            clientId: value.client.id,
            bdo: value.bdo,
            wasteType: wasteType,
            address: address,
            contact: contact === '' ? undefined : contact,
            onPlace: value.onPlace ?? false,
            count: count,
            price: price,
            wantedAdvance: wantedAdvance,
            priceType: value.priceType,
            wantedPaymentType: value.wantedPaymentType,
            comments: comments === '' ? undefined : comments,
            deliveryDate: value.deliveryDate,
            claimingDate: value.claimingDate,
            assignee: undefined
        }, value.isNewAddress ?? true);
        setAdding(false);
        if (order) navigate(`/panel/orders/${order.id}/${(0, $b9894ce465f84cba$export$168ff345f0815589).loose}`, {
            replace: true
        });
    };
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: onCreateOrder,
            loading: adding,
            disabled: !!value.client?.lockedDate,
            children: "Dodaj zam\xf3wienie"
        }, "0")
    ];
    if (value.client?.lockedDate) actions.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($23d74c100d3c3028$var$LockedMessage, {
        children: "Klient zablokowany!"
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Zam\xf3wienia / Nowe",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $780fb97d07db6787$export$efc0a2e88ebc9664), {
            select: select,
            value: value,
            onChange: (n)=>setValue((o)=>({
                        ...o,
                        ...n
                    }))
        })
    });
};




var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");










const $37ce37c36f24f466$export$766ef6f9f3a0e37d = (id)=>{
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)() ?? -1;
    const [order, fetchOrder] = (0, $612618a84cedafbf$export$37d0bd824120f782)(id);
    const [client] = (0, $73567ed6b001db2f$export$95f99d327bc8fbbd)(order?.clientId);
    const users = (0, $0df0903efbca6a2f$export$90f4370c54dd43c9)({});
    const [claimingAssignee] = (0, $ac789bea2a0ba498$export$23bbbc4533528f03)(order?.claimingTask?.assignedTo ?? undefined);
    const [deliveryAssignee] = (0, $ac789bea2a0ba498$export$23bbbc4533528f03)(order?.deliveryTask?.assignedTo ?? undefined);
    const [priceChanges, fetchPriceChanges] = (0, $340411795f50fc0d$export$75635297fe14ef93)(id, (0, $b9894ce465f84cba$export$168ff345f0815589).loose, userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin);
    const editOrder = async (dto)=>{
        if (!order) return;
        try {
            const price = dto.price ?? order.grossPrice;
            const wantedAdvance = dto.wantedAdvance ?? order.wantedAdvance;
            if (wantedAdvance && wantedAdvance < 0) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zaliczka nie mo\u017Ce by\u0107 mniejsza od 0");
                return;
            }
            if (wantedAdvance && wantedAdvance >= price) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zaliczka nie mo\u017Ce by\u0107 wi\u0119ksza lub r\xf3wna cenie");
                return;
            }
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).looseOrder(id).patch(dto);
            await fetchOrder();
            await fetchPriceChanges();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zam\xf3wienie zosta\u0142o edytowane");
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} edytowa\u{107} zam\xf3wienia (${e})`);
            return false;
        }
    };
    const deleteOrder = async ()=>{
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).looseOrder(id).delete();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zam\xf3wienie zosta\u0142o usuni\u0119te");
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} usun\u{105}\u{107} zam\xf3wienia (${e})`);
            return false;
        }
    };
    const editDeliveryTask = async (dto)=>{
        try {
            if (!order?.deliveryTask) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zam\xf3wienie nie ma zadania dostawy");
                return false;
            }
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.patch(order?.deliveryTask?.id, dto);
            await fetchOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zam\xf3wienie zosta\u0142o edytowane");
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} edytowa\u{107} zam\xf3wienia (${e})`);
            return false;
        }
    };
    const editClaimingTask = async (dto)=>{
        try {
            if (!order?.claimingTask) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zam\xf3wienie nie ma zadania odbioru");
                return false;
            }
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.patch(order?.claimingTask?.id, dto);
            await fetchOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zam\xf3wienie zosta\u0142o edytowane");
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} edytowa\u{107} zam\xf3wienia (${e})`);
            return false;
        }
    };
    const deleteClaimingTask = async ()=>{
        try {
            const claimingTask = order?.claimingTask;
            if (!claimingTask) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Zam\xf3wienie nie ma terminu odbioru");
                return false;
            }
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.delete(claimingTask.id);
            await fetchOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Termin odbioru zosta\u0142 usuni\u0119ty");
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} usun\u{105}\u{107} terminu odbioru (${e})`);
            return false;
        }
    };
    const markAsPaid = async ()=>{
        try {
            if (!order) {
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Nie mo\u017Cna oznaczy\u0107 zam\xf3wienia jako op\u0142aconego, poniewa\u017C nie istnieje");
                return false;
            }
            const alreadyPaid = order.payments.reduce((acc, p)=>acc + p.amount, 0);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).payments.put({
                orderId: order.id,
                orderType: (0, $b9894ce465f84cba$export$168ff345f0815589).loose,
                amount: order.grossPrice - alreadyPaid,
                type: order.wantedPaymentType
            });
            await fetchOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zam\xf3wienie zosta\u0142o oznaczone jako op\u0142acone");
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} oznaczy\u{107} zam\xf3wienia jako op\u{142}acone (${e})`);
            return false;
        }
    };
    const createTask = async (taskData)=>{
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.put(taskData);
            await fetchOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success(`Zadanie ${taskData.type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery ? 'dostarczenia' : 'odebrania'} zosta\u{142}o utworzone`);
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} utworzy\u{107} zadania (${e})`);
            return false;
        }
    };
    return {
        order: order,
        client: client,
        claimingAssignee: claimingAssignee,
        deliveryAssignee: deliveryAssignee,
        users: users,
        priceChanges: priceChanges,
        editOrder: editOrder,
        deleteOrder: deleteOrder,
        editClaimingTask: editClaimingTask,
        editDeliveryTask: editDeliveryTask,
        deleteClaimingTask: deleteClaimingTask,
        createTask: createTask,
        markAsPaid: markAsPaid
    };
};







var $acw62 = parcelRequire("acw62");


const $354cbb15d23cb17e$export$58dc49a9b05ecec5 = ({ order: order, visible: visible, onCancel: onCancel, onOk: onOk })=>{
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)();
    const [date, setDate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [time, setTime] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [itemsToClaim, setItemsToClaim] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [price, setPrice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, $acw62.useEffect)(()=>{
        setItemsToClaim(order.count);
    }, [
        order.count
    ]);
    (0, $acw62.useEffect)(()=>{
        setPrice(order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? order.grossPrice : order.netPrice);
    }, [
        order.priceType,
        order.grossPrice,
        order.netPrice
    ]);
    const accept = async ()=>{
        if (loading) return;
        if (!date) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Wybierz dat\u0119 odbioru");
            return;
        }
        if (!itemsToClaim) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Podaj ilo\u015B\u0107 sztuk do odebrania");
            return;
        }
        if (itemsToClaim < 1 || itemsToClaim > order.count) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Ilo\u015B\u0107 sztuk do odebrania jest nieprawid\u0142owa");
            return;
        }
        if (!price || price < 1) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Podaj prawid\u0142ow\u0105 cen\u0119");
            return;
        }
        try {
            setLoading(true);
            await onOk({
                date: date,
                time: time,
                itemsToClaim: itemsToClaim,
                price: price
            });
        } catch (error) {
            console.error(error);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Wyst\u{105}pi\u{142} b\u{142}\u{105}d (${error})`);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
        title: "",
        open: visible,
        onCancel: onCancel,
        onOk: accept,
        cancelText: "Anuluj",
        okText: "Zatwierd\u017A",
        cancelButtonProps: {
            size: 'large'
        },
        okButtonProps: {
            size: 'large',
            type: 'primary',
            loading: loading
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Dodaj odbi\xf3r"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
                layout: "vertical",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Termin odbioru",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 20,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    size: "large",
                                    placeholder: "Data",
                                    value: date ?? null,
                                    onChange: (v)=>v && setDate(v),
                                    format: "YYYY-MM-DD"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039).TimePicker, {
                                    size: "large",
                                    format: "HH:mm",
                                    placeholder: "Godzina",
                                    value: time ?? null,
                                    onChange: (v)=>setTime(v ?? undefined)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Ilo\u015B\u0107 sztuk do odebrania",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 10,
                            direction: "vertical",
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                    size: "large",
                                    type: "number",
                                    value: itemsToClaim,
                                    onChange: (e)=>setItemsToClaim(e.target.value ? parseInt(e.target.value) : undefined),
                                    max: order?.count,
                                    min: 1
                                }),
                                itemsToClaim !== undefined && order?.count !== undefined && itemsToClaim > order.count && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-red-500",
                                    children: [
                                        "Ilo\u015B\u0107 nie mo\u017Ce by\u0107 wi\u0119ksza ni\u017C ",
                                        order.count
                                    ]
                                }),
                                itemsToClaim !== undefined && order?.count !== undefined && itemsToClaim < 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-red-500",
                                    children: "Ilo\u015B\u0107 nie mo\u017Ce by\u0107 mniejsza ni\u017C 1"
                                })
                            ]
                        })
                    }),
                    userLevel && userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: `Cena (${order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? 'brutto' : 'netto'})`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "number",
                            suffix: "PLN",
                            value: price,
                            onChange: (e)=>setPrice(e.target.value ? parseFloat(e.target.value) : undefined),
                            min: 1
                        })
                    })
                ]
            })
        ]
    });
};


const $aaec192fbc0fdab0$var$wasteTypes = [
    'Mieszany',
    'Gruz',
    'Drewno',
    'Styropian',
    'Papa'
];
const $aaec192fbc0fdab0$var$PaymentTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
	width: 100%;
	border-collapse: collapse;
`;
const $aaec192fbc0fdab0$var$TableHeader = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).th`
	text-align: ${(props)=>props.align || 'left'};
	padding: 8px;
	border-bottom: 1px solid #ddd;
`;
const $aaec192fbc0fdab0$var$TableCell = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).td`
	padding: 8px;
	border-bottom: 1px solid #eee;
	text-align: ${(props)=>props.align || 'left'};
`;
const $aaec192fbc0fdab0$var$FooterCell = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($aaec192fbc0fdab0$var$TableCell)`
	font-weight: bold;
	border-bottom: none;
`;
const $aaec192fbc0fdab0$export$55feea4f41906f2b = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const params = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const id = Number.parseInt(params['id'] ?? '');
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)();
    const [wasteType, setWasteType] = (0, $acw62.useState)();
    const [address, setAddress] = (0, $acw62.useState)();
    const [deliveryDateModal, setDeliveryDateModal] = (0, $acw62.useState)(false);
    const [claimingDateModal, setClaimingDateModal] = (0, $acw62.useState)(false);
    const [createDeliveryTaskModal, setCreateDeliveryTaskModal] = (0, $acw62.useState)(false);
    const [createClaimingTaskModal, setCreateClaimingTaskModal] = (0, $acw62.useState)(false);
    const [count, setCount] = (0, $acw62.useState)();
    const [price, setPrice] = (0, $acw62.useState)();
    const [priceType, setPriceType] = (0, $acw62.useState)();
    const [wantedAdvance, setWantedAdvance] = (0, $acw62.useState)();
    const [paymentType, setPaymentType] = (0, $acw62.useState)();
    const [removalModal, setRemovalModal] = (0, $acw62.useState)(false);
    const [removing, setRemoving] = (0, $acw62.useState)(false);
    const { order: order, client: client, claimingAssignee: claimingAssignee, deliveryAssignee: deliveryAssignee, users: users, priceChanges: priceChanges, editOrder: editOrder, deleteOrder: deleteOrder, editClaimingTask: editClaimingTask, editDeliveryTask: editDeliveryTask, deleteClaimingTask: deleteClaimingTask, markAsPaid: markAsPaid, createTask: createTask } = (0, $37ce37c36f24f466$export$766ef6f9f3a0e37d)(id);
    if (userLevel === undefined || !order || !client) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true
    });
    const canEdit = userLevel > (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).driver && !order.claimingTask?.doneAt;
    const alreadyPaidSum = order.payments.reduce((sum, payment)=>sum + payment.amount, 0);
    const isFullyPaid = alreadyPaidSum >= order.grossPrice;
    const actions = [
        order && !isFullyPaid && !order.deliveryTask?.takenAt && userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            size: "large",
            type: "primary",
            danger: true,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
            onClick: ()=>setRemovalModal(true),
            children: "Usu\u0144 zam\xf3wienie"
        }, 0)
    ];
    const _deleteOrder = async ()=>{
        if (!order) return;
        setRemoving(true);
        const success = await deleteOrder();
        setRemoving(false);
        if (!success) return;
        navigate('/panel/orders', {
            replace: true
        });
    };
    const _canSavePrice = ()=>{
        const realPrice = order.priceType == (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? order.grossPrice : order.netPrice;
        if ((price ?? '').trim() != '' && price != `${realPrice}`) return true;
        if (priceType !== undefined && priceType !== order.priceType) return true;
        return false;
    };
    const _changeClaiming = async ({ date: date, time: time, itemsToClaim: itemsToClaim, price: price })=>{
        if (order.claimingTask) return;
        const taskDate = date.clone().hours(time?.hours() ?? 0).minutes(time?.minutes() ?? 0).seconds(0).milliseconds(0);
        await createTask({
            orderId: order.id,
            orderType: (0, $b9894ce465f84cba$export$168ff345f0815589).loose,
            type: (0, $749850eb3cb705e4$export$1f8b1cab05cab788).claiming,
            date: taskDate,
            itemsToClaim: itemsToClaim,
            newPrice: price
        });
        setCreateClaimingTaskModal(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Szczeg\xf3\u0142y zam\xf3wienia",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
            title: "Klient",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "delivery-details",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3563129eed42bd13$export$62a054c396228590), {
                            client: client,
                            name: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Informacje",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "BDO"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $5635f57e16062a6d$export$b6098f7faad3052e)(order.bdo)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Rodzaj odpad\xf3w"
                                                }),
                                                canEdit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex waste-type",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            options: $aaec192fbc0fdab0$var$wasteTypes.map((type)=>({
                                                                    value: type
                                                                })),
                                                            filterOption: (inputValue, option)=>option?.value.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) ?? false,
                                                            value: wasteType ?? order.wasteType,
                                                            onSelect: (type)=>setWasteType(type),
                                                            onChange: (type)=>setWasteType(type)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                            onClick: async ()=>{
                                                                if (!wasteType) return;
                                                                await editOrder({
                                                                    wasteType: wasteType
                                                                });
                                                            },
                                                            disabled: !wasteType || wasteType === order.wasteType,
                                                            children: "Zmie\u0144"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: order.wasteType
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Adres"
                                            }),
                                            canEdit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex address",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        size: "large",
                                                        value: address ?? order.address,
                                                        onChange: (e)=>setAddress(e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                        onClick: async ()=>{
                                                            if (!address) return;
                                                            await editOrder({
                                                                address: address
                                                            });
                                                        },
                                                        disabled: !address || address === order.address,
                                                        children: "Zmie\u0144"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: order.address
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Numer kontaktowy"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                                                phone: order.contact
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Uwagi"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: order.comments ?? '-'
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Zapotrzebowanie",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: order.onPlace ? 'Termin realizacji (na miejscu)' : 'Termin podstawienia'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "flex date",
                                                children: [
                                                    order.deliveryTask?.date ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.deliveryTask?.date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.deliveryTask?.date).hours() === 0) : 'Brak terminu podstawienia',
                                                    !order.deliveryTask?.takenAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                                        onClick: ()=>{
                                                            if (!order.deliveryTask) setCreateDeliveryTaskModal(true);
                                                            setDeliveryDateModal(true);
                                                        },
                                                        children: "Zmie\u0144"
                                                    }),
                                                    order.deliveryTask && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                                        onClick: ()=>navigate(`/panel/v2/tasks/${order.deliveryTask.id}`),
                                                        children: "Szczeg\xf3\u0142y zadania"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                !order.onPlace && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Termin odbioru"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "flex gap-2",
                                                children: [
                                                    order.claimingTask?.date ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claimingTask?.date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.claimingTask?.date).hours() === 0) : 'Brak terminu odbioru',
                                                    order.claimingTask && !order.claimingTask?.takenAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                        danger: true,
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
                                                        onClick: deleteClaimingTask,
                                                        children: "Usu\u0144"
                                                    }),
                                                    !order.claimingTask?.takenAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                                        onClick: ()=>{
                                                            if (!order.claimingTask) setCreateClaimingTaskModal(true);
                                                            else setClaimingDateModal(true);
                                                        },
                                                        children: "Zmie\u0144"
                                                    }),
                                                    order.claimingTask && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                                        onClick: ()=>navigate(`/panel/v2/tasks/${order.claimingTask.id}`),
                                                        children: "Szczeg\xf3\u0142y zadania"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Ilo\u015B\u0107 work\xf3w"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        size: "large",
                                                        type: "number",
                                                        value: count ?? order.count,
                                                        min: 1,
                                                        max: 255,
                                                        disabled: !canEdit,
                                                        onChange: (e)=>setCount(e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            width: '10px'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                        onClick: async ()=>{
                                                            if (!count) return;
                                                            const countParsed = Number.parseInt(count);
                                                            if (isNaN(countParsed)) {
                                                                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Niepoprawna ilo\u015B\u0107 work\xf3w");
                                                                return;
                                                            }
                                                            if (countParsed < 1 || countParsed > 255) {
                                                                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Ilo\u015B\u0107 work\xf3w musi by\u0107 z zakresu 1 - 255");
                                                                return;
                                                            }
                                                            await editOrder({
                                                                count: countParsed
                                                            });
                                                        },
                                                        disabled: !canEdit || !count || Number.parseInt(count) == order.count,
                                                        children: "Zmie\u0144"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Historia",
                            children: [
                                order.createdAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-dir",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Zam\xf3wienie stworzone"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.createdAt)
                                            })
                                        ]
                                    })
                                }),
                                order.deliveryTask?.takenAt && deliveryAssignee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do podstawienia"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.deliveryTask.takenAt)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do podstawienia przez"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        deliveryAssignee.name,
                                                        " ",
                                                        deliveryAssignee.surname
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.deliveryTask?.doneAt && deliveryAssignee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Podstawione"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.deliveryTask.doneAt)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Podstawione przez"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        deliveryAssignee.name,
                                                        " ",
                                                        deliveryAssignee.surname
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.claimingTask?.takenAt && claimingAssignee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do odbioru"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claimingTask.takenAt)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zg\u0142oszone do odbioru przez"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        claimingAssignee.name,
                                                        " ",
                                                        claimingAssignee.surname
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.claimingTask?.doneAt && claimingAssignee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Odebrane"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claimingTask.doneAt)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Odebrane przez"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        claimingAssignee.name,
                                                        " ",
                                                        claimingAssignee.surname
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Finanse",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col md:flex-row gap-4 w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir w-full gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-dir",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                "Cena (",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "price-type",
                                                                    children: (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(priceType ?? order.priceType)
                                                                }),
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money((priceType ?? order.priceType) == (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? order.grossPrice : order.netPrice)
                                                        }),
                                                        userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && !isFullyPaid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-row gap-4 w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex w-full gap-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                                            size: "large",
                                                                            type: "text",
                                                                            value: price ?? ((priceType ?? order.priceType) == (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? order.grossPrice : order.netPrice),
                                                                            onChange: (e)=>setPrice(e.target.value)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "pln flex flex-dir flex-jc flex-ac",
                                                                            children: "PLN"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                                    size: "large",
                                                                    value: priceType ?? order.priceType,
                                                                    onChange: (p)=>setPriceType(p),
                                                                    className: "w-full",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                            value: (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net,
                                                                            children: "Netto"
                                                                        }, "0"),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                            value: (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross,
                                                                            children: "Brutto"
                                                                        }, "1")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                                    onClick: async ()=>{
                                                                        const newPrice = price ? Number.parseFloat(price) : undefined;
                                                                        if (newPrice && isNaN(newPrice)) {
                                                                            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Niepoprawna cena');
                                                                            return;
                                                                        }
                                                                        const newPriceType = priceType;
                                                                        if (!newPrice && !newPriceType) return;
                                                                        await editOrder({
                                                                            price: newPrice,
                                                                            priceType: newPriceType
                                                                        });
                                                                        setPrice(undefined);
                                                                        setPriceType(undefined);
                                                                    },
                                                                    disabled: !_canSavePrice(),
                                                                    children: "Zapisz zmiany"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-dir",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Zaliczka"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: wantedAdvance ?? order.wantedAdvance ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(wantedAdvance ?? order.wantedAdvance) : '-'
                                                        }),
                                                        userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && !isFullyPaid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-row gap-4 w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex w-full gap-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                                            size: "large",
                                                                            type: "text",
                                                                            value: wantedAdvance ?? order.wantedAdvance ?? '',
                                                                            onChange: (e)=>setWantedAdvance(e.target.value)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "pln flex flex-dir flex-jc flex-ac",
                                                                            children: "PLN"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                                    onClick: async ()=>{
                                                                        const wantedAdvanceRaw = wantedAdvance?.trim() ?? null;
                                                                        if (!wantedAdvanceRaw) {
                                                                            await editOrder({
                                                                                wantedAdvance: null
                                                                            });
                                                                            return;
                                                                        }
                                                                        const a = Number.parseFloat(wantedAdvanceRaw);
                                                                        if (isNaN(a)) {
                                                                            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Niepoprawna warto\u015B\u0107 zaliczki");
                                                                            return;
                                                                        }
                                                                        await editOrder({
                                                                            wantedAdvance: a
                                                                        });
                                                                    },
                                                                    disabled: wantedAdvance === undefined || wantedAdvance === order.wantedAdvance?.toString() || !wantedAdvance && order.wantedAdvance === null,
                                                                    children: "Zmie\u0144 zaliczk\u0119"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-dir",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: "Typ p\u0142atno\u015Bci"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: (0, $83530e2bf16dcece$export$a90a64e69a78f544)(order.wantedPaymentType)
                                                        }),
                                                        userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && !order.claimingTask?.doneAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-row gap-4 payment-type",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                                    size: "large",
                                                                    value: paymentType ?? order.wantedPaymentType,
                                                                    onChange: (p)=>setPaymentType(p),
                                                                    className: "w-full",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                            value: (0, $83530e2bf16dcece$export$439d2d6c03747598).transfer,
                                                                            children: "Przelew"
                                                                        }, "0"),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                            value: (0, $83530e2bf16dcece$export$439d2d6c03747598).cash,
                                                                            children: "Got\xf3wka"
                                                                        }, "1")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                                    onClick: async ()=>{
                                                                        if (!paymentType) return;
                                                                        await editOrder({
                                                                            wantedPaymentType: paymentType
                                                                        });
                                                                    },
                                                                    disabled: !paymentType || paymentType === order.wantedPaymentType,
                                                                    children: "Zmie\u0144"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && !isFullyPaid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                    onClick: ()=>markAsPaid(),
                                                    disabled: alreadyPaidSum >= order.grossPrice,
                                                    children: "Oznacz jako zap\u0142acone"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Historia p\u0142atno\u015Bci"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "mb-4",
                                                    children: order.payments.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($aaec192fbc0fdab0$var$PaymentTable, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableHeader, {
                                                                            children: "Data"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableHeader, {
                                                                            align: "center",
                                                                            children: "Przez"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableHeader, {
                                                                            align: "right",
                                                                            children: "Kwota"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                                children: order.payments.map((payment, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableCell, {
                                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(payment.date)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableCell, {
                                                                                align: "center",
                                                                                children: (()=>{
                                                                                    const user = users?.find((user)=>user.id === payment.createdBy);
                                                                                    return user ? `${user.name} ${user.surname}` : '-';
                                                                                })()
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableCell, {
                                                                                align: "right",
                                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(payment.amount)
                                                                            })
                                                                        ]
                                                                    }, index))
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tfoot", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$FooterCell, {
                                                                            children: "Razem"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$FooterCell, {}),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$FooterCell, {
                                                                            align: "right",
                                                                            children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(alreadyPaidSum)
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Brak zarejestrowanych transakcji"
                                                    })
                                                }),
                                                userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Historia zmian ceny"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "mb-4",
                                                            children: priceChanges && priceChanges.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($aaec192fbc0fdab0$var$PaymentTable, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableHeader, {
                                                                                    children: "Data"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableHeader, {
                                                                                    align: "center",
                                                                                    children: "Przez"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableHeader, {
                                                                                    align: "right",
                                                                                    children: "Stara cena"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableHeader, {
                                                                                    align: "right",
                                                                                    children: "Nowa cena"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                                        children: priceChanges.map((change)=>{
                                                                            const user = users?.find((u)=>u.id === change.createdBy);
                                                                            const oldPrice = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(change.oldPriceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? change.oldGrossPrice : change.oldNetPrice);
                                                                            const newPrice = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(change.newPriceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? change.newGrossPrice : change.newNetPrice);
                                                                            const oldPriceType = (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(change.oldPriceType);
                                                                            const newPriceType = (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(change.newPriceType);
                                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableCell, {
                                                                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(change.createdAt)
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aaec192fbc0fdab0$var$TableCell, {
                                                                                        align: "center",
                                                                                        children: user ? `${user.name} ${user.surname}` : '-'
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($aaec192fbc0fdab0$var$TableCell, {
                                                                                        align: "right",
                                                                                        children: [
                                                                                            oldPrice,
                                                                                            " ",
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                className: "price-type",
                                                                                                children: [
                                                                                                    "(",
                                                                                                    oldPriceType,
                                                                                                    ")"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($aaec192fbc0fdab0$var$TableCell, {
                                                                                        align: "right",
                                                                                        children: [
                                                                                            newPrice,
                                                                                            " ",
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                className: "price-type",
                                                                                                children: [
                                                                                                    "(",
                                                                                                    newPriceType,
                                                                                                    ")"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }, change.id);
                                                                        })
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Brak historii zmian ceny"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ba307cd85047917$export$ef072eb865b4b720), {
                    visible: deliveryDateModal,
                    onCancel: ()=>setDeliveryDateModal(false),
                    onOk: async (deliveryDate)=>{
                        const success = await editDeliveryTask({
                            date: deliveryDate
                        });
                        if (!success) throw new Error("Nie uda\u0142o si\u0119 edytowa\u0107 zam\xf3wienia");
                        setDeliveryDateModal(false);
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $354cbb15d23cb17e$export$58dc49a9b05ecec5), {
                    visible: createClaimingTaskModal,
                    order: order,
                    onOk: _changeClaiming,
                    onCancel: ()=>setCreateClaimingTaskModal(false)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ba307cd85047917$export$ef072eb865b4b720), {
                    visible: claimingDateModal,
                    onCancel: ()=>setClaimingDateModal(false),
                    onOk: async (claimingDate)=>{
                        const success = await editClaimingTask({
                            date: claimingDate
                        });
                        if (!success) throw new Error("Nie uda\u0142o si\u0119 edytowa\u0107 zam\xf3wienia");
                        setClaimingDateModal(false);
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fd0b816bbe13d58$export$2e2bcd8739ae039), {
                    visible: removalModal,
                    onCancel: ()=>setRemovalModal(false),
                    onOk: ()=>_deleteOrder(),
                    loading: removing,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Czy na pewno chcesz usun\u0105\u0107 to zam\xf3wienie?"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a4409826a128b58$export$bf7a976fef6c1b78), {
                    visible: createDeliveryTaskModal,
                    orderId: id,
                    type: (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery,
                    onCancel: ()=>setCreateDeliveryTaskModal(false),
                    onOk: async (date)=>{
                        const success = await createTask({
                            date: date,
                            type: (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery,
                            orderId: order.id,
                            orderType: (0, $b9894ce465f84cba$export$168ff345f0815589).loose
                        });
                        if (!success) throw new Error("Nie uda\u0142o si\u0119 utworzy\u0107 zadania");
                        setCreateDeliveryTaskModal(false);
                    }
                })
            ]
        })
    });
};







const $d2b9afe2e105d274$var$OrderDetails = ()=>{
    const { type: type = '0' } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    switch(type){
        case '0':
        case (0, $b9894ce465f84cba$export$168ff345f0815589).classic:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff19ba13b059c548$export$2e2bcd8739ae039), {});
        case '1':
        case (0, $b9894ce465f84cba$export$168ff345f0815589).own:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d9f7cef5af6a8c1$export$2e2bcd8739ae039), {});
        case '2':
        case (0, $b9894ce465f84cba$export$168ff345f0815589).other:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e99acb342eb1dba5$export$2e2bcd8739ae039), {});
        case '3':
        case (0, $b9894ce465f84cba$export$168ff345f0815589).loose:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aaec192fbc0fdab0$export$55feea4f41906f2b), {});
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a750ae9c83aadfd$export$2e2bcd8739ae039), {});
};
var $d2b9afe2e105d274$export$2e2bcd8739ae039 = $d2b9afe2e105d274$var$OrderDetails;




var $acw62 = parcelRequire("acw62");





const $bca8cf32cf717d2e$var$NewOrder = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const query = (0, $acw62.useMemo)(()=>(0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search), [
        location.search
    ]);
    const { type: type = '0' } = query;
    const select = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
        size: "large",
        value: type,
        onChange: (type)=>navigate(`?${(0, $a472eec1c89e43a3$export$2e2bcd8739ae039).encode({
                ...query,
                type: type
            })}`, {
                replace: true
            }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                value: "0",
                children: "Podstawienie"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                value: "1",
                children: "W\u0142asne"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                value: "2",
                children: "Inne"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                value: "3",
                children: "Big bag"
            })
        ]
    });
    switch(type){
        case '0':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1df14280bdd03c65$export$2e2bcd8739ae039), {
                select: select
            });
        case '1':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df7f5d6b6ab3e2d8$export$2e2bcd8739ae039), {
                select: select
            });
        case '2':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9906e1ba81bfea3a$export$2e2bcd8739ae039), {
                select: select
            });
        case '3':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23d74c100d3c3028$export$d17cee8cb96a8181), {
                select: select
            });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a750ae9c83aadfd$export$2e2bcd8739ae039), {});
};
var $bca8cf32cf717d2e$export$2e2bcd8739ae039 = $bca8cf32cf717d2e$var$NewOrder;




var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


function $f894f96f86da23c6$var$_extends() {
    $f894f96f86da23c6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f894f96f86da23c6$var$_extends.apply(this, arguments);
}
const $f894f96f86da23c6$var$QuestionCircleOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $f894f96f86da23c6$var$_extends({}, props, {
        ref: ref,
        icon: (0, $62cc23852a32c921$export$2e2bcd8739ae039)
    }));
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ const $f894f96f86da23c6$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f894f96f86da23c6$var$QuestionCircleOutlined);
var $f894f96f86da23c6$export$2e2bcd8739ae039 = $f894f96f86da23c6$var$RefIcon;






var $45fvw = parcelRequire("45fvw");


const $73aef2dab2d6dbfb$var$getTaskColor = (task, noGrey)=>{
    if (!noGrey && task.doneAt) return (0, $0b4842326956570d$export$e4c89085febbc618)[3];
    if (!noGrey && task.takenAt) return (0, $0b4842326956570d$export$2aa0182783e7e9de)[5];
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic && task.order.onPlace) return (0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5];
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).loose && task.order.onPlace) return (0, $0b4842326956570d$export$2a9ca2e383622e18)[3];
    switch(task.internalType){
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).classicDelivery:
            return (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5];
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).classicReplacement:
            return (0, $0b4842326956570d$export$c24201f7fe3571d8)[5];
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).classicClaiming:
            return (0, $0b4842326956570d$export$a90204d1394caf30)[5];
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).looseDelivery:
            return (0, $0b4842326956570d$export$7474046f446842ee)[4];
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).looseClaiming:
            return (0, $0b4842326956570d$export$2a9ca2e383622e18)[3];
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).own:
            return (0, $0b4842326956570d$export$4138d3aeddcbf415)[5];
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).other:
            return (0, $0b4842326956570d$export$221d31baf2636aad)[5];
    }
    return (0, $0b4842326956570d$export$e63a1643b2f79b16)[5];
};
const $73aef2dab2d6dbfb$var$getTaskIcon = (task)=>{
    switch(task.internalType){
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).classicDelivery:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c091335ea63c232a$export$2e2bcd8739ae039), {});
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).classicReplacement:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1089d062458492a5$export$2e2bcd8739ae039), {});
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).classicClaiming:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a82a141ad01d80f$export$2e2bcd8739ae039), {});
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).own:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eed06595af8fdbfa$export$2e2bcd8739ae039), {});
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).looseDelivery:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92f281659fda605f$export$2e2bcd8739ae039), {
                style: {
                    transform: 'rotate(180deg)'
                }
            });
        case (0, $f698c1a64cb76360$export$5824bf5f78b5c2c4).looseClaiming:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92f281659fda605f$export$2e2bcd8739ae039), {
                style: {
                    transform: 'rotate(180deg)'
                }
            });
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f894f96f86da23c6$export$2e2bcd8739ae039), {});
    }
};
const $73aef2dab2d6dbfb$var$classicTaskType = (task)=>{
    switch(task.type){
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery:
            return '0';
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).replacement:
            return '1';
        case (0, $749850eb3cb705e4$export$1f8b1cab05cab788).claiming:
            return '2';
    }
};
const $73aef2dab2d6dbfb$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	align-items: center;
	width: 100%;
	margin-bottom: 3px;
	padding: 10px 15px 10px 4px;
	border-radius: 5px;
	background-color: ${({ task: task })=>$73aef2dab2d6dbfb$var$getTaskColor(task)};
	border-left: 24px solid ${({ task: task })=>$73aef2dab2d6dbfb$var$getTaskColor(task, true)};

	&:last-child {
		margin-bottom: 0;
	}

	> p {
		color: white;
		font-size: 24px;
		margin-right: 8px;
	}

	> span {
		margin-right: 10px;

		svg {
			font-size: 35px;
			color: white;
		}
	}

	> div {
		flex: 1;

		p {
			color: white;
			white-space: nowrap;
			overflow: hidden;
			margin-bottom: 2px;
		}

		p:first-child {
			font-weight: 500;
			font-size: 20px;
			text-overflow: ellipsis;
		}

		p.phone {
			font-size: 20px;
		}

		p:last-child {
			font-weight: 400;
			font-size: 18px;
			margin-bottom: 0;
		}
	}
`;
const $73aef2dab2d6dbfb$export$b0343268816c9ab2 = ({ i: i, task: task })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.date);
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).other) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($73aef2dab2d6dbfb$var$Wrapper, {
        className: "flex",
        task: task,
        onClick: ()=>navigate(`/panel/orders/${task.id}/${task.orderType}`),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: i + 1
            }),
            $73aef2dab2d6dbfb$var$getTaskIcon(task),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: task.order.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: date.hours() === 0 ? "Ca\u0142y dzie\u0144" : date.format('HH:mm')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(task.order.value),
                        " (",
                        task.order.value_type === 0 ? 'netto' : 'brutto',
                        ")"
                    ]
                })
            })
        ]
    });
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).loose) {
        const paid = task.order.payments.reduce((acc, p)=>acc + p.amount, 0);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($73aef2dab2d6dbfb$var$Wrapper, {
            className: "flex",
            task: task,
            onClick: ()=>navigate(`/panel/v2/tasks/${task.id}`),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: i + 1
                }),
                $73aef2dab2d6dbfb$var$getTaskIcon(task),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: task.order.address
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: date.hours() === 0 ? "Ca\u0142y dzie\u0144" : date.format('HH:mm')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                task.assignedUser?.name,
                                " ",
                                task.assignedUser?.surname
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                (0, $83530e2bf16dcece$export$a90a64e69a78f544)(task.order.wantedPaymentType),
                                " |",
                                ' ',
                                paid >= task.order.grossPrice ? "Op\u0142acone" : "Nieop\u0142acone"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: task.client.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "phone",
                            children: task.client.phone
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "Work\xf3w: ",
                                task.order.count
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).own) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($73aef2dab2d6dbfb$var$Wrapper, {
        className: "flex",
        task: task,
        onClick: ()=>navigate(`/panel/orders/${task.id}/${task.orderType}`),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: i + 1
            }),
            $73aef2dab2d6dbfb$var$getTaskIcon(task),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: task.order.address
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: date.hours() === 0 ? "Ca\u0142y dzie\u0144" : date.format('HH:mm')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            task.client.name,
                            " | ",
                            task.order.to
                        ]
                    }),
                    task.doneAt ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(task.doneAt),
                            " | ",
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(task.order.weight),
                            " kg"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            task.order.weight ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(task.order.weight) : '-',
                            " kg"
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($73aef2dab2d6dbfb$var$Wrapper, {
        className: "flex",
        task: task,
        onClick: ()=>navigate(`/panel/tasks/${task.id}/${$73aef2dab2d6dbfb$var$classicTaskType(task)}`),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: i + 1
            }),
            $73aef2dab2d6dbfb$var$getTaskIcon(task),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: task.order.address
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            date.hours() === 0 ? "Ca\u0142y dzie\u0144" : date.format('HH:mm'),
                            " | ",
                            (0, $5635f57e16062a6d$export$b6098f7faad3052e)(task.order.bdo)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            task.assignedUser?.name,
                            " ",
                            task.assignedUser?.surname
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            (0, $83530e2bf16dcece$export$a90a64e69a78f544)(task.order.paymentType),
                            " |",
                            ' ',
                            task.order.paymentDate ? "Op\u0142acone" : task.order.advance ? 'Zaliczka' : "Nieop\u0142acone"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: task.client.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "phone",
                        children: task.client.phone
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: task.order.containerSize
                    })
                ]
            })
        ]
    });
};



const $89f6f74419ab2076$var$TasksContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $89f6f74419ab2076$var$TasksBody = ({})=>{
    const { tasks: tasks, offset: offset, setOffset: setOffset } = (0, $acw62.useContext)($89f6f74419ab2076$var$TasksContext);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: "agenda",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
            title: "Terminarz",
            children: tasks ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tasks flex flex-dir",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a724bbfbe7fdfe75$export$2e2bcd8739ae039), {
                    offset: offset,
                    onChange: setOffset,
                    children: tasks.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Brak zada\u0144 na dzi\u015B"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "body",
                        children: tasks.map((task)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73aef2dab2d6dbfb$export$b0343268816c9ab2), {
                                i: tasks.indexOf(task),
                                task: task
                            }, `${task.id}-${task.type}`))
                    })
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
                active: true
            })
        })
    });
};
const $89f6f74419ab2076$var$Tasks = ({})=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89f6f74419ab2076$var$TasksContext.Provider, {
        value: (0, $f698c1a64cb76360$export$ed5c3368304694)(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89f6f74419ab2076$var$TasksBody, {})
    });
};
var $89f6f74419ab2076$export$2e2bcd8739ae039 = $89f6f74419ab2076$var$Tasks;




var $acw62 = parcelRequire("acw62");








var $45fvw = parcelRequire("45fvw");

const { Option: $83bf2bd8b19e8a08$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $83bf2bd8b19e8a08$var$TaskDetails = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { id: id, type: type } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [{ order: order, previousOrder: previousOrder, admin: admin, loading: loading, drivers: drivers, assignee: assignee }, { takeTask: takeTask, assigneeChanged: assigneeChanged, assignTask: assignTask, unassignTask: unassignTask }] = (0, $fad51db97ae8fa5d$export$2e2bcd8739ae039)();
    const taskType = (0, $acw62.useMemo)(()=>{
        switch(type){
            case '0':
                return 'Podstawienie';
            case '1':
                return `Wymiana (Kontener nr ${previousOrder?.container?.name})`;
            case '2':
                return "Odbi\xf3r";
        }
    }, [
        type,
        order?.related?.container?.name
    ]);
    const getActions = ()=>{
        if (!order || order.done) return [];
        if (!order.taken) return [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                type: "primary",
                size: "large",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                loading: loading === 'taking',
                onClick: ()=>{
                    switch(type){
                        case '0':
                        case '1':
                            navigate(`${order.size.id}`);
                            break;
                        case '2':
                            takeTask();
                            break;
                    }
                },
                children: "Zg\u0142o\u015B si\u0119 do realizacji"
            }, "0")
        ];
        if (order.taken_by?.id == window.sessionStorage.getItem('id')) return [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                type: "primary",
                size: "large",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                onClick: ()=>navigate(`/panel/task-closing/${id}/${type}/close`),
                children: "Zrealizuj zadanie"
            }, "0"),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                type: "danger",
                size: "large",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaf43360a8ccea7a$export$2e2bcd8739ae039), {}),
                onClick: unassignTask,
                loading: loading === 'unassign',
                children: "Wycofaj z realizacji"
            }, "1")
        ];
        return [];
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Terminarz / Szczeg\xf3\u0142y zadania",
        actions: getActions(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
                active: true,
                loading: !order
            }),
            order && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "taskDetails flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-dir flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Informacje",
                            width: 854,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Adres"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.address
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Rodzaj"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: taskType
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Rozmiar kontenera"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.size.name
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Numer kontenera"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.container?.name ?? '-'
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Rodzaj kontenera"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.container?.type ?? '-'
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Rodzaj odpad\xf3w"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.waste_type
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                children: [
                                                                    "Cena (",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "price-type",
                                                                        children: order.price_type ? 'Brutto' : 'Netto'
                                                                    }),
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.price)
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Rodzaj p\u0142atno\u015Bci"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.payment_type == 0 ? 'Przelew' : "Got\xf3wka"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Termin"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "date",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "user-data",
                                                                        children: order.date === null ? 'Bezterminowo' : (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.date).hours() === 0)
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "button",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                                            onClick: ()=>navigate(`/panel/orders/${id}`),
                                                            children: "Szczeg\xf3\u0142y zam\xf3wienia"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                order.taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "table",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: "Zg\u0142oszone do realizacji:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "creation-data",
                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.taken)
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: "Zrealizowane:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "creation-data",
                                                                children: order.done ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.done) : '-'
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: "Przez:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: admin ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                to: `/panel/drivers/${order.taken_by.id}`,
                                                                children: [
                                                                    order.taken_by.name,
                                                                    " ",
                                                                    order.taken_by.surname
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: order.taken_by.name
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        order.done && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Inne",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Zaliczka"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "user-data",
                                                            children: order.advance ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.advance) : '-'
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    type: "primary",
                                                    size: "large",
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                                    disabled: !order.sign,
                                                    onClick: ()=>navigate(`/panel/tasks/${id}/sign`, {
                                                            state: {
                                                                sign: order.sign
                                                            }
                                                        }),
                                                    children: "Zobacz podpis WZ"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Klient",
                            width: 876,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Klient"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: order.client.name
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "BDO"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: order.bdo === 0 ? 'BDO' : "Wytwarzaj\u0105cy"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Typ"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: order.client.type === 0 ? 'Firma' : 'Osoba prywatna'
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Numer BDO"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: order.client.bdo ?? '-'
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Numer telefonu"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                                                                    phone: order.client.phone
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: order.client.email
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Numer NIP"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: order.client.nip
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "button",
                                                    children: admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                                        onClick: ()=>navigate(`/panel/clients/${order.client.id}`),
                                                        children: "Szczeg\xf3\u0142y klienta"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        admin && !order.taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Przypisz zadanie kierowcy",
                            width: 876,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "drivers flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Kierowca"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                        size: 25,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: order.taken_by?.id ?? assignee,
                                                onChange: assigneeChanged,
                                                children: drivers && drivers.map((driver)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($83bf2bd8b19e8a08$var$Option, {
                                                        value: driver.id,
                                                        children: [
                                                            driver.name,
                                                            " ",
                                                            driver.surname
                                                        ]
                                                    }, driver.id))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                type: "primary",
                                                size: "large",
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                onClick: assignTask,
                                                loading: loading === 'assing',
                                                disabled: !assignee,
                                                children: "Przypisz"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $83bf2bd8b19e8a08$export$2e2bcd8739ae039 = $83bf2bd8b19e8a08$var$TaskDetails;




var $acw62 = parcelRequire("acw62");






const $d680ea0c6b704b91$var$ContainerSelection = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { id: id, type: type, sizeId: sizeId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [containers, setContainers] = (0, $acw62.useState)();
    const [size, setSize] = (0, $acw62.useState)();
    const [confirmModal, setConfirmModal] = (0, $acw62.useState)();
    const [container, setContainer] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            const containers = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.getAll(true);
            const sizes = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).containers.sizes.getAll(true);
            setContainers(containers.filter((c)=>c.size == sizeId && c.state.state == 0));
            setSize(sizes.filter((s)=>s.id == sizeId)[0]);
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const options = (0, $acw62.useMemo)(()=>{
        if (!containers) return;
        return containers.map((c)=>({
                ...c,
                value: c.name
            }));
    }, [
        containers
    ]);
    const takeTask = async ()=>{
        try {
            setLoading(true);
            if (type === '0') await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                container_id: container.id,
                delivery_taken: 1
            });
            if (type === '1') {
                const order = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.get(id);
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(id, {
                    container_id: container.id,
                    delivery_taken: 1
                });
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(order.related_id, {
                    claiming_taken: 1
                });
            }
            navigate(-1);
            setLoading();
            setConfirmModal();
        } catch (e) {
            setLoading();
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    const autocompleteType = (value)=>setContainer(containers.filter((c)=>c.name == value)[0]);
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {}),
            disabled: !container,
            onClick: ()=>setConfirmModal(true),
            children: "Potwierd\u017A zg\u0142oszenie do realizacji"
        }, "0")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Terminarz / Wyb\xf3r kontenera",
        actions: actions,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container-selection flex",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        title: "Wybierz kontener",
                        width: 854,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Numer kontenera"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d977e4e7aca4c0$export$2e2bcd8739ae039), {
                                        size: "large",
                                        options: options,
                                        filterOption: (inputValue, option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1,
                                        onSelect: autocompleteType
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Rozmiar"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "user-data",
                                                            children: size && size.name
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Rodzaj"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "user-data",
                                                            children: container?.type ?? '-'
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        width: 892
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6fd0b816bbe13d58$export$2e2bcd8739ae039), {
                visible: confirmModal,
                onCancel: ()=>setConfirmModal(false),
                onOk: takeTask,
                okColor: "#1890FF",
                loading: loading,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Czy na pewno chcesz zg\u0142osi\u0107 si\u0119 do realizacji"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: "Zadanie zostanie przypisane oraz zarezerwowane dla Ciebie"
                    })
                ]
            })
        ]
    });
};
var $d680ea0c6b704b91$export$2e2bcd8739ae039 = $d680ea0c6b704b91$var$ContainerSelection;



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
const $2070010b6502d428$var$SignContext = /*#__PURE__*/ (0, $acw62.createContext)();
var $2070010b6502d428$export$2e2bcd8739ae039 = $2070010b6502d428$var$SignContext;



var $45fvw = parcelRequire("45fvw");
const $9772cb0801c4bf21$var$TaskClosingBody = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { id: id, type: type } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [{ orders: orders, order: order, ordersPaid: ordersPaid, paid: paid, wz: wz, sign: sign, signName: signName, signSurname: signSurname, signDocument: signDocument, paymentDone: paymentDone, advance: advance, finishDisabled: finishDisabled }, { setId: setId, setType: setType, setPaid: setPaid, setOrderAsPaid: setOrderAsPaid, setOrderAsUnpaid: setOrderAsUnpaid, paymentDoneChanged: paymentDoneChanged, advanceChanged: advanceChanged, clear: clear, setWz: setWz, signNameChanged: signNameChanged, signSurnameChanged: signSurnameChanged, signDocumentChanged: signDocumentChanged, finishTask: finishTask }] = (0, $acw62.useContext)((0, $2070010b6502d428$export$2e2bcd8739ae039));
    (0, $acw62.useEffect)(()=>{
        setId(id);
        setType(type);
    }, [
        id,
        type
    ]);
    const columns = [
        {
            title: "Op\u0142acone",
            dataIndex: 'id',
            key: 'id',
            render: (id)=>{
                const checked = ordersPaid.indexOf(id) !== -1;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                    checked: checked,
                    onChange: ()=>checked ? setOrderAsUnpaid(id) : setOrderAsPaid(id)
                });
            }
        },
        {
            title: 'Cena',
            dataIndex: 'price',
            key: 'price',
            render: (price, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(price),
                        " (",
                        row.price_type ? 'brutto' : 'netto',
                        ")"
                    ]
                })
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address'
        },
        {
            title: 'Data',
            dataIndex: 'delivery_date',
            key: 'date',
            render: (date)=>(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).hours() === 0)
        },
        {
            title: "Szczeg\xf3\u0142y",
            dataIndex: 'id',
            key: 'action',
            render: (id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${id}`,
                    children: "Szczeg\xf3\u0142y"
                })
        }
    ];
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
            onClick: finishTask,
            disabled: finishDisabled,
            children: "Zrealizuj zadanie"
        }, "0"),
        wz && finishDisabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: "Uzupe\u0142nij dane do WZ"
        }, "1")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Terminarz / Realizacja zadania",
        actions: actions,
        children: order && orders ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "task-closing flex flex-dir",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Finanse",
                    children: [
                        orders.length !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Nieop\u0142acone zam\xf3wienia klienta:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                                    columns: columns,
                                    dataSource: orders,
                                    pagination: false,
                                    scroll: {
                                        x: 'max-content'
                                    }
                                })
                            ]
                        }),
                        (type !== '0' || order.on_place) && !order.payment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-dir",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "finances",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            "Cena (",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "price-type",
                                                                children: order.price_type ? 'Brutto' : 'Netto'
                                                            }),
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "user-data",
                                                            children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.price)
                                                        })
                                                    }),
                                                    order.price_type === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            "(",
                                                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.price * 1.08),
                                                            " - Brutto)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            type === '1' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "checkbox",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                                        checked: paid,
                                                        onChange: (e)=>setPaid(e.target.checked),
                                                        children: "Poprzednie zam\xf3wienie op\u0142acone"
                                                    })
                                                ]
                                            }) : order.payment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: "Zam\xf3wienie zosta\u0142o ju\u017C op\u0142acone."
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                className: "checkbox",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                                        checked: paid,
                                                        onChange: (e)=>setPaid(e.target.checked),
                                                        children: "Zap\u0142acone"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-dir",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "finances",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "Cena (",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "price-type",
                                                            children: order.price_type ? 'Brutto' : 'Netto'
                                                        }),
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "user-data",
                                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.price)
                                                    })
                                                }),
                                                order.price_type === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "(",
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.price * 1.08),
                                                        " - Brutto)"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }),
                        order.related?.payment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        height: '30px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Poprzednie zam\xf3wienie zosta\u0142o op\u0142acone."
                                })
                            ]
                        }),
                        type !== '2' && order.payment_type !== 0 && !order.on_place && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        height: '45px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 45,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-dir",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                            checked: paymentDone,
                                            onChange: paymentDoneChanged,
                                            children: "Zam\xf3wienie op\u0142acone w ca\u0142o\u015Bci"
                                        })
                                    })
                                }),
                                !paymentDone && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 45,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zaliczka"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                            type: "text",
                                                            size: "large",
                                                            value: advance,
                                                            onChange: advanceChanged
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "flex flex-jc flex-ac PLN",
                                                            children: "PLN"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                            type: "primary",
                                            size: "large",
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                                            onClick: clear,
                                            disabled: !advance,
                                            children: "Wyczy\u015B\u0107"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                    className: "wz",
                    checked: wz,
                    onChange: (e)=>setWz(e.target.checked),
                    children: "WZ"
                }),
                wz && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                    title: "Dane do WZ",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Imi\u0119"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            size: "large",
                                            value: signName,
                                            onChange: signNameChanged
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Nazwisko"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            size: "large",
                                            value: signSurname,
                                            onChange: signSurnameChanged
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            children: "Nr dowodu"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            size: "large",
                                            value: signDocument,
                                            onChange: signDocumentChanged
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        size: "large",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                        onClick: ()=>navigate(`/panel/task-closing/${id}/${type}/sign`, {
                                                state: sign
                                            }),
                                        children: [
                                            sign ? 'Edytuj' : 'Pobierz',
                                            " podpis do WZ"
                                        ]
                                    }, "1")
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $9772cb0801c4bf21$export$2e2bcd8739ae039 = $9772cb0801c4bf21$var$TaskClosingBody;




var $acw62 = parcelRequire("acw62");

var $611c9a2e456cbe77$exports = {};




!function(e, t) {
    $611c9a2e456cbe77$exports = t((parcelRequire("c9Z8w")), (parcelRequire("acw62")), (parcelRequire("9slIK")), (parcelRequire("7G0GL")));
}($611c9a2e456cbe77$exports, function(e, t, n, r) {
    return function(e) {
        function t(r) {
            if (n[r]) return n[r].exports;
            var a = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return e[r].call(a.exports, a, a.exports, t), a.loaded = !0, a.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "", t(0);
    }([
        function(e, t, n) {
            "use strict";
            function r(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function a(e, t) {
                var n = {};
                for(var r in e)t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
                return n;
            }
            function o(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function i(e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }
            function u(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var s = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }, c = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                return function(t, n, r) {
                    return n && e(t.prototype, n), r && e(t, r), t;
                };
            }(), f = n(1), p = r(f), l = n(2), d = r(l), v = n(3), h = r(v), _ = n(4), g = r(_), m = function(e) {
                function t() {
                    var e, n, r, u;
                    o(this, t);
                    for(var s = arguments.length, c = Array(s), f = 0; f < s; f++)c[f] = arguments[f];
                    return n = r = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [
                        this
                    ].concat(c))), r._sigPad = null, r._excludeOurProps = function() {
                        var e = r.props, t = (e.canvasProps, e.clearOnResize, a(e, [
                            "canvasProps",
                            "clearOnResize"
                        ]));
                        return t;
                    }, r.getCanvas = function() {
                        return r._canvas;
                    }, r.getTrimmedCanvas = function() {
                        var e = document.createElement("canvas");
                        return e.width = r._canvas.width, e.height = r._canvas.height, e.getContext("2d").drawImage(r._canvas, 0, 0), (0, g.default)(e);
                    }, r.getSignaturePad = function() {
                        return r._sigPad;
                    }, r._checkClearOnResize = function() {
                        r.props.clearOnResize && r._resizeCanvas();
                    }, r._resizeCanvas = function() {
                        var e = r.props.canvasProps || {}, t = e.width, n = e.height;
                        if (!t || !n) {
                            var a = r._canvas, o = Math.max(window.devicePixelRatio || 1, 1);
                            t || (a.width = a.offsetWidth * o), n || (a.height = a.offsetHeight * o), a.getContext("2d").scale(o, o), r.clear();
                        }
                    }, r.on = function() {
                        return window.addEventListener("resize", r._checkClearOnResize), r._sigPad.on();
                    }, r.off = function() {
                        return window.removeEventListener("resize", r._checkClearOnResize), r._sigPad.off();
                    }, r.clear = function() {
                        return r._sigPad.clear();
                    }, r.isEmpty = function() {
                        return r._sigPad.isEmpty();
                    }, r.fromDataURL = function(e, t) {
                        return r._sigPad.fromDataURL(e, t);
                    }, r.toDataURL = function(e, t) {
                        return r._sigPad.toDataURL(e, t);
                    }, r.fromData = function(e) {
                        return r._sigPad.fromData(e);
                    }, r.toData = function() {
                        return r._sigPad.toData();
                    }, u = n, i(r, u);
                }
                return u(t, e), c(t, [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this._sigPad = new h.default(this._canvas, this._excludeOurProps()), this._resizeCanvas(), this.on();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.off();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            Object.assign(this._sigPad, this._excludeOurProps());
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, t = this.props.canvasProps;
                            return d.default.createElement("canvas", s({
                                ref: function(t) {
                                    e._canvas = t;
                                }
                            }, t));
                        }
                    }
                ]), t;
            }(l.Component);
            m.propTypes = {
                velocityFilterWeight: p.default.number,
                minWidth: p.default.number,
                maxWidth: p.default.number,
                minDistance: p.default.number,
                dotSize: p.default.oneOfType([
                    p.default.number,
                    p.default.func
                ]),
                penColor: p.default.string,
                throttle: p.default.number,
                onEnd: p.default.func,
                onBegin: p.default.func,
                canvasProps: p.default.object,
                clearOnResize: p.default.bool
            }, m.defaultProps = {
                clearOnResize: !0
            }, t.default = m;
        },
        function(t, n) {
            t.exports = e;
        },
        function(e, n) {
            e.exports = t;
        },
        function(e, t) {
            e.exports = n;
        },
        function(e, t) {
            e.exports = r;
        }
    ]);
});




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d37e75de06e87c36$var$ClearOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6a25.95 25.95 0 0025.6 30.4h723c1.5 0 3-.1 4.4-.4a25.88 25.88 0 0021.2-30zM204 390h272V182h72v208h272v104H204V390zm468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z"
                }
            }
        ]
    },
    "name": "clear",
    "theme": "outlined"
};
var $d37e75de06e87c36$export$2e2bcd8739ae039 = $d37e75de06e87c36$var$ClearOutlined;



function $3615ac7d76e55fd4$var$_extends() {
    $3615ac7d76e55fd4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3615ac7d76e55fd4$var$_extends.apply(this, arguments);
}
const $3615ac7d76e55fd4$var$ClearOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $3615ac7d76e55fd4$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d37e75de06e87c36$export$2e2bcd8739ae039)
    }));
/**![clear](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik04OTkuMSA4NjkuNmwtNTMtMzA1LjZIODY0YzE0LjQgMCAyNi0xMS42IDI2LTI2VjM0NmMwLTE0LjQtMTEuNi0yNi0yNi0yNkg2MThWMTM4YzAtMTQuNC0xMS42LTI2LTI2LTI2SDQzMmMtMTQuNCAwLTI2IDExLjYtMjYgMjZ2MTgySDE2MGMtMTQuNCAwLTI2IDExLjYtMjYgMjZ2MTkyYzAgMTQuNCAxMS42IDI2IDI2IDI2aDE3LjlsLTUzIDMwNS42YTI1Ljk1IDI1Ljk1IDAgMDAyNS42IDMwLjRoNzIzYzEuNSAwIDMtLjEgNC40LS40YTI1Ljg4IDI1Ljg4IDAgMDAyMS4yLTMwek0yMDQgMzkwaDI3MlYxODJoNzJ2MjA4aDI3MnYxMDRIMjA0VjM5MHptNDY4IDQ0MFY2NzRjMC00LjQtMy42LTgtOC04aC00OGMtNC40IDAtOCAzLjYtOCA4djE1Nkg0MTZWNjc0YzAtNC40LTMuNi04LTgtOGgtNDhjLTQuNCAwLTggMy42LTggOHYxNTZIMjAyLjhsNDUuMS0yNjBINzc2bDQ1LjEgMjYwSDY3MnoiIC8+PC9zdmc+) */ const $3615ac7d76e55fd4$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($3615ac7d76e55fd4$var$ClearOutlined);
var $3615ac7d76e55fd4$export$2e2bcd8739ae039 = $3615ac7d76e55fd4$var$RefIcon;





const $c29d0411c1a88c7e$var$Sign = ({})=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const canvas = (0, $acw62.useRef)();
    const sign = location.state;
    const [_, { setSign: setSign }] = (0, $acw62.useContext)((0, $2070010b6502d428$export$2e2bcd8739ae039));
    (0, $acw62.useEffect)(()=>{
        if (!canvas?.current || !sign) return;
        canvas.current.fromData(sign);
    }, [
        sign,
        canvas?.current
    ]);
    const saveSign = ()=>{
        if (!canvas?.current) return;
        setSign(canvas.current.toData());
        navigate(-1);
    };
    const clear = ()=>canvas.current.clear();
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
            onClick: saveSign,
            children: "Zatwierd\u017A podpis"
        }, "0"),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3615ac7d76e55fd4$export$2e2bcd8739ae039), {}),
            onClick: clear,
            children: "Wyczy\u015B\u0107"
        }, "1")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Terminarz / Realizacja zadania",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "sign-wrapper",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($611c9a2e456cbe77$exports))), {
                ref: canvas,
                penColor: "black",
                canvasProps: {
                    className: 'sigCanvas'
                }
            })
        })
    });
};
var $c29d0411c1a88c7e$export$2e2bcd8739ae039 = $c29d0411c1a88c7e$var$Sign;




const $ad8d5fde6b7f877a$var$TaskClosingScreen = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2070010b6502d428$export$2e2bcd8739ae039).Provider, {
        value: (0, $ec06c438df5fe127$export$2e2bcd8739ae039)(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "close",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9772cb0801c4bf21$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "sign",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c29d0411c1a88c7e$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};
var $ad8d5fde6b7f877a$export$2e2bcd8739ae039 = $ad8d5fde6b7f877a$var$TaskClosingScreen;





var $acw62 = parcelRequire("acw62");



const $088388f0b7df42f6$var$SavedSign = ({ location: location })=>{
    let signCanvas;
    (0, $acw62.useEffect)(()=>{
        signCanvas.fromData(JSON.parse(location.state.sign));
        signCanvas.off();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Terminarz / Realizacja zadania",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "sign-wrapper",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($611c9a2e456cbe77$exports))), {
                ref: (ref)=>signCanvas = ref,
                penColor: "black",
                canvasProps: {
                    className: 'sigCanvas'
                }
            })
        })
    });
};
var $088388f0b7df42f6$export$2e2bcd8739ae039 = $088388f0b7df42f6$var$SavedSign;



parcelRequire("acw62");






const $bad1039fb32e55ff$var$Settings = ()=>{
    const [{ sizes: sizes, newUsername: newUsername, newPassword: newPassword, repeatPassword: repeatPassword, oldPassword: oldPassword, newSize: newSize, loading: loading, admin: admin, user: user }, { setNewUsername: setNewUsername, setNewPassword: setNewPassword, setRepeatPassword: setRepeatPassword, setOldPassword: setOldPassword, setNewSize: setNewSize, changeLogin: changeLogin, changePassword: changePassword, deleteSize: deleteSize, addSize: addSize }] = (0, $eb56a1dc306fa6ba$export$2e2bcd8739ae039)();
    const columns = [
        {
            title: 'Rozmiar',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Akcje',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    style: {
                        color: loading === row.id ? (0, $0b4842326956570d$export$e4c89085febbc618)[5] : (0, $0b4842326956570d$export$a90204d1394caf30)[5]
                    },
                    onClick: ()=>deleteSize(row.id),
                    children: "Usu\u0144"
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Ustawienia",
        children: loading !== null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "settings flex flex-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                title: "Informacje",
                width: 878,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        size: 25,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Login"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "large",
                                        value: newUsername,
                                        onChange: setNewUsername
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    size: "large",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {}),
                                    onClick: changeLogin,
                                    disabled: !newUsername || newUsername === user?.username,
                                    loading: loading === 'username',
                                    children: "Zmie\u0144 login"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        title: "Zmie\u0144 has\u0142o",
                        width: 878,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Nowe has\u0142o"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "password",
                                                size: "large",
                                                value: newPassword,
                                                onChange: setNewPassword
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Powt\xf3rz has\u0142o"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "password",
                                                size: "large",
                                                value: repeatPassword,
                                                onChange: setRepeatPassword
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                size: 25,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Aktualne has\u0142o"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "password",
                                                size: "large",
                                                value: oldPassword,
                                                onChange: setOldPassword
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                            type: "primary",
                                            size: "large",
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {}),
                                            onClick: changePassword,
                                            disabled: !newPassword || !repeatPassword || !oldPassword,
                                            loading: loading === 'password',
                                            children: "Zmie\u0144 has\u0142o"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                        title: admin && "Rozmiary kontener\xf3w",
                        width: 852,
                        children: admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                                    columns: columns,
                                    dataSource: sizes,
                                    pagination: false
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Nazwa rozmiaru"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: newSize,
                                                    onChange: setNewSize
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                type: "primary",
                                                size: "large",
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
                                                onClick: addSize,
                                                disabled: !newSize,
                                                loading: loading === 'size',
                                                children: "Dodaj nowy rozmiar"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $bad1039fb32e55ff$export$2e2bcd8739ae039 = $bad1039fb32e55ff$var$Settings;



parcelRequire("acw62");








var $45fvw = parcelRequire("45fvw");
const $1e25eb245deca293$var$FastActions = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [{ loading: loading, containers: containers, search: search, dateModal: dateModal }, { searchChanged: searchChanged, clearSearch: clearSearch, setDateModal: setDateModal, changeDate: changeDate }] = (0, $473175eef259fb82$export$2e2bcd8739ae039)();
    const getContainerStateName = (state, row)=>{
        switch(state){
            case 0:
                return 'Wolny';
            case 1:
                if (row?.order?.claiming_date && new Date(row.order.claiming_date) < new Date()) {
                    const diff = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('day').diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(row.order.claiming_date).startOf('day'), 'days');
                    if (row.order.related_id > row.order.id) {
                        if (diff === 0) return `Do wymiany od dzisiaj`;
                        if (diff === 1) return `Do wymiany od wczoraj`;
                        return `Do wymiany (od ${diff} dni)`;
                    }
                    if (diff === 0) return `Do odbioru od dzisiaj`;
                    if (diff === 1) return `Do odbioru od wczoraj`;
                    return `Do odbioru (od ${diff} dni)`;
                }
                const diff = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('day').diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(row.order.delivery_done).startOf('day'), 'days');
                if (diff === 0) return `Podstawiony dzisiaj`;
                if (diff === 1) return `Podstawiony wczoraj`;
                return `Podstawiony (${diff} dni)`;
            case 4:
                return 'W transporcie';
            case 5:
                return "Wypo\u017Cyczony";
            case 6:
                return "Usuni\u0119ty";
            default:
                return 'Nieznany';
        }
    };
    const columns = [
        {
            title: 'Akcje',
            dataIndex: 'state',
            key: 'actions',
            render: (state, row)=>{
                if (state.state === 0 || state.state === 5 || state.state === 6) return;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    size: 5,
                    children: !row.order.claiming_taken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "noselect",
                                style: {
                                    color: loading === row ? (0, $0b4842326956570d$export$e4c89085febbc618)[5] : row.order.related_id > row.order.id ? (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5] : (0, $0b4842326956570d$export$a90204d1394caf30)[5]
                                },
                                onClick: ()=>setDateModal({
                                        callback: async (date)=>await changeDate(row, date),
                                        deadline: row.order.related_id > row.order.id
                                    }),
                                children: row.order.related_id > row.order.id ? 'Data wymiany' : "Odbi\xf3r"
                            }),
                            row.order.related_id <= row.order.id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: " | "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        className: "noselect",
                                        style: {
                                            color: loading === row ? (0, $0b4842326956570d$export$e4c89085febbc618)[5] : (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5]
                                        },
                                        onClick: ()=>navigate(`/panel/new-order?type=0&related_id=${row.order.id}`),
                                        children: "Wymiana"
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        },
        {
            title: 'Klient',
            dataIndex: 'order',
            key: 'client',
            render: (order)=>order?.client?.name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/clients/${order.client.id}`,
                    children: order.client.name
                }) : '-'
        },
        {
            title: 'Stan',
            dataIndex: 'state',
            key: 'state',
            render: (state, row)=>getContainerStateName(state.state, row)
        },
        {
            title: 'Numer',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Rozmiar',
            dataIndex: 'size',
            key: 'size',
            render: (s)=>s.name
        },
        {
            title: 'Data odbioru',
            dataIndex: 'order',
            key: 'claiming',
            render: (order)=>order?.claiming_date ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claiming_date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.claiming_date).hours() === 0) : '-'
        },
        {
            title: 'Aktualna lokalizacja',
            dataIndex: 'order',
            key: 'location',
            render: (order)=>order?.address && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${order.id}`,
                    children: order.address
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Kontenery w zam\xf3wieniach",
        children: containers ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "containers flex flex-dir flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "inputs flex",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                    placeholder: "Wyszukaj",
                                    size: "large",
                                    suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                                        style: {
                                            color: '#8C8C8C'
                                        }
                                    }),
                                    value: search,
                                    onChange: searchChanged
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    size: "large",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                                    onClick: clearSearch,
                                    children: "Wyczy\u015B\u0107"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                            columns: columns,
                            dataSource: containers,
                            pagination: false,
                            scroll: {
                                x: 'max-content'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36a81de199cd8a95$export$2e2bcd8739ae039), {
                    visible: dateModal,
                    onCancel: ()=>!loading && setDateModal(),
                    onOk: dateModal?.callback,
                    loading: loading,
                    deadline: dateModal?.deadline
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
};
var $1e25eb245deca293$export$2e2bcd8739ae039 = $1e25eb245deca293$var$FastActions;



parcelRequire("acw62");


var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");



var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $54675b4e19f0d6af$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $54675b4e19f0d6af$export$2e2bcd8739ae039 = $54675b4e19f0d6af$var$PlusOutlined;



var $b0299ce2db1ca33d$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $b3ba9aff878b58fb$export$2e2bcd8739ae039), (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        ref: ref,
        icon: (0, $54675b4e19f0d6af$export$2e2bcd8739ae039)
    }));
};
var $b0299ce2db1ca33d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($b0299ce2db1ca33d$var$PlusOutlined);
var $b0299ce2db1ca33d$export$2e2bcd8739ae039 = $b0299ce2db1ca33d$var$RefIcon;



var $8g1PZ = parcelRequire("8g1PZ");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $fSwVM = parcelRequire("fSwVM");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $ycMhT = parcelRequire("ycMhT");

var $iSQh8 = parcelRequire("iSQh8");

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8iiJy = parcelRequire("8iiJy");

var $acw62 = parcelRequire("acw62");
var $bb2ee1e3f89d10a5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
var $32b6ebe184c19bb6$var$TabPane = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, id = _ref.id, active = _ref.active, tabKey = _ref.tabKey, children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: id && "".concat(id, "-panel-").concat(tabKey),
        role: "tabpanel",
        tabIndex: active ? 0 : -1,
        "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
        "aria-hidden": !active,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, active && "".concat(prefixCls, "-active"), className),
        ref: ref
    }, children);
});
var $32b6ebe184c19bb6$export$2e2bcd8739ae039 = $32b6ebe184c19bb6$var$TabPane;


var $8a40c3051886a790$var$_excluded = [
    "key",
    "forceRender",
    "style",
    "className"
];
function $8a40c3051886a790$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, activeKey = _ref.activeKey, animated = _ref.animated, tabPosition = _ref.tabPosition, destroyInactiveTabPane = _ref.destroyInactiveTabPane;
    var _React$useContext = $acw62.useContext((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var tabPaneAnimated = animated.tabPane;
    var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content-holder"))
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), (0, $kSlfw.default)({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
    }, tabs.map(function(_ref2) {
        var key = _ref2.key, forceRender = _ref2.forceRender, paneStyle = _ref2.style, paneClassName = _ref2.className, restTabProps = (0, $9X7IJ.default)(_ref2, $8a40c3051886a790$var$_excluded);
        var active = key === activeKey;
        return /*#__PURE__*/ $acw62.createElement((0, $8iiJy.default), (0, $8nd05.default)({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!destroyInactiveTabPane,
            leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
        }, animated.tabPaneMotion), function(_ref3, ref) {
            var motionStyle = _ref3.style, motionClassName = _ref3.className;
            return /*#__PURE__*/ $acw62.createElement((0, $32b6ebe184c19bb6$export$2e2bcd8739ae039), (0, $8nd05.default)({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: (0, $d49SP.default)((0, $d49SP.default)({}, paneStyle), motionStyle),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(paneClassName, motionClassName),
                ref: ref
            }));
        });
    })));
}




var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $kbxxf = parcelRequire("kbxxf");

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $bVxlN = parcelRequire("bVxlN");

var $a4gyP = parcelRequire("a4gyP");

var $dTiBu = parcelRequire("dTiBu");

var $85dLH = parcelRequire("85dLH");

var $acw62 = parcelRequire("acw62");

var $d49SP = parcelRequire("d49SP");

var $acw62 = parcelRequire("acw62");
var $fea37cf40acfe645$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $fea37cf40acfe645$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $acw62.useMemo)(function() {
        var _tabs$;
        var map = new Map();
        var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || $fea37cf40acfe645$var$DEFAULT_SIZE;
        var rightOffset = lastOffset.left + lastOffset.width;
        for(var i = 0; i < tabs.length; i += 1){
            var key = tabs[i].key;
            var data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) {
                var _tabs;
                data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || $fea37cf40acfe645$var$DEFAULT_SIZE;
            }
            var entity = map.get(key) || (0, $d49SP.default)({}, data);
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        tabSizes,
        holderScrollWidth
    ]);
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
function $f1c0f3be6d5fa93f$export$2e2bcd8739ae039(defaultState, onChange) {
    var stateRef = $acw62.useRef(defaultState);
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $eUqlC.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    function setState(updater) {
        var newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}



var $eUqlC = parcelRequire("eUqlC");

var $acw62 = parcelRequire("acw62");
var $bd298a079d025635$var$MIN_SWIPE_DISTANCE = 0.1;
var $bd298a079d025635$var$STOP_SWIPE_DISTANCE = 0.01;
var $bd298a079d025635$var$REFRESH_INTERVAL = 20;
var $bd298a079d025635$var$SPEED_OFF_MULTIPLE = Math.pow(0.995, $bd298a079d025635$var$REFRESH_INTERVAL);
function $bd298a079d025635$export$2e2bcd8739ae039(ref, onOffset) {
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $eUqlC.default)(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
    var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $eUqlC.default)(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
    var _useState5 = (0, $acw62.useState)(0), _useState6 = (0, $eUqlC.default)(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
    var _useState7 = (0, $acw62.useState)(), _useState8 = (0, $eUqlC.default)(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
    var motionRef = (0, $acw62.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        var _e$touches$ = e.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        e.preventDefault();
        var _e$touches$2 = e.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        var offsetX = screenX - touchPosition.x;
        var offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        var now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            var distanceX = lastOffset.x / lastTimeDiff;
            var distanceY = lastOffset.y / lastTimeDiff;
            var absX = Math.abs(distanceX);
            var absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $bd298a079d025635$var$MIN_SWIPE_DISTANCE) return;
            var currentX = distanceX;
            var currentY = distanceY;
            motionRef.current = window.setInterval(function() {
                if (Math.abs(currentX) < $bd298a079d025635$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $bd298a079d025635$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $bd298a079d025635$var$SPEED_OFF_MULTIPLE;
                currentY *= $bd298a079d025635$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $bd298a079d025635$var$REFRESH_INTERVAL, currentY * $bd298a079d025635$var$REFRESH_INTERVAL);
            }, $bd298a079d025635$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    var lastWheelDirectionRef = (0, $acw62.useRef)();
    function onWheel(e) {
        var deltaX = e.deltaX, deltaY = e.deltaY;
        // Convert both to x & y since wheel only happened on PC
        var mixed = 0;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = 'x';
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = 'y';
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    var touchEventsRef = (0, $acw62.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $acw62.useEffect(function() {
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener('touchmove', onProxyTouchMove, {
            passive: false
        });
        document.addEventListener('touchend', onProxyTouchEnd, {
            passive: false
        });
        // No need to clean up since element removed
        ref.current.addEventListener('touchstart', onProxyTouchStart, {
            passive: false
        });
        ref.current.addEventListener('wheel', onProxyWheel);
        return function() {
            document.removeEventListener('touchmove', onProxyTouchMove);
            document.removeEventListener('touchend', onProxyTouchEnd);
        };
    }, []);
}



var $eUqlC = parcelRequire("eUqlC");

var $6hDTM = parcelRequire("6hDTM");

var $acw62 = parcelRequire("acw62");
function $6bb369ac1283ea97$export$2e2bcd8739ae039(callback) {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $eUqlC.default)(_useState, 2), count = _useState2[0], setCount = _useState2[1];
    var effectRef = (0, $acw62.useRef)(0);
    var callbackRef = (0, $acw62.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $6hDTM.useLayoutUpdateEffect)(function() {
        var _callbackRef$current;
        (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
    }, [
        count
    ]);
    // Trigger to update count
    return function() {
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $6bb369ac1283ea97$export$aefd2a30eb6d999e(defaultState) {
    var batchRef = (0, $acw62.useRef)([]);
    var _useState3 = (0, $acw62.useState)({}), _useState4 = (0, $eUqlC.default)(_useState3, 2), forceUpdate = _useState4[1];
    var state = (0, $acw62.useRef)(typeof defaultState === 'function' ? defaultState() : defaultState);
    var flushUpdate = $6bb369ac1283ea97$export$2e2bcd8739ae039(function() {
        var current = state.current;
        batchRef.current.forEach(function(callback) {
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $acw62 = parcelRequire("acw62");
var $1e3cbc4ab07e0147$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $1e3cbc4ab07e0147$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
    var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl = _ref.rtl;
    var charUnit;
    var position;
    var transformSize;
    if ([
        'top',
        'bottom'
    ].includes(tabPosition)) {
        charUnit = 'width';
        position = rtl ? 'right' : 'left';
        transformSize = Math.abs(transform);
    } else {
        charUnit = 'height';
        position = 'top';
        transformSize = -transform;
    }
    return (0, $acw62.useMemo)(function() {
        if (!tabs.length) return [
            0,
            0
        ];
        var len = tabs.length;
        var endIndex = len;
        for(var i = 0; i < len; i += 1){
            var offset = tabOffsets.get(tabs[i].key) || $1e3cbc4ab07e0147$var$DEFAULT_SIZE;
            if (offset[position] + offset[charUnit] > transformSize + visibleTabContentValue) {
                endIndex = i - 1;
                break;
            }
        }
        var startIndex = 0;
        for(var _i = len - 1; _i >= 0; _i -= 1){
            var _offset = tabOffsets.get(tabs[_i].key) || $1e3cbc4ab07e0147$var$DEFAULT_SIZE;
            if (_offset[position] < transformSize) {
                startIndex = _i + 1;
                break;
            }
        }
        return [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        rtl
    ]);
}



/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $099b8f1c61d35623$export$fac44ee5b035f737(obj) {
    var tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach(function(v, k) {
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
var $099b8f1c61d35623$var$RC_TABS_DOUBLE_QUOTE = 'TABS_DQ';
function $099b8f1c61d35623$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $099b8f1c61d35623$var$RC_TABS_DOUBLE_QUOTE);
}



var $acw62 = parcelRequire("acw62");
function $034d4b5b2135dc44$var$AddButton(_ref, ref) {
    var prefixCls = _ref.prefixCls, editable = _ref.editable, locale = _ref.locale, style = _ref.style;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $acw62.createElement("button", {
        ref: ref,
        type: "button",
        className: "".concat(prefixCls, "-nav-add"),
        style: style,
        "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || 'Add tab',
        onClick: function onClick(event) {
            editable.onEdit('add', {
                event: event
            });
        }
    }, editable.addIcon || '+');
}
var $034d4b5b2135dc44$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($034d4b5b2135dc44$var$AddButton);



var $fSwVM = parcelRequire("fSwVM");

var $acw62 = parcelRequire("acw62");
var $f179037cdfb41409$var$ExtraContent = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var position = _ref.position, prefixCls = _ref.prefixCls, extra = _ref.extra;
    if (!extra) return null;
    var content;
    // Parse extra
    var assertExtra = {};
    if ((0, $fSwVM.default)(extra) === 'object' && !/*#__PURE__*/ $acw62.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === 'right') content = assertExtra.right;
    if (position === 'left') content = assertExtra.left;
    return content ? /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-extra-content"),
        ref: ref
    }, content) : null;
});
var $f179037cdfb41409$export$2e2bcd8739ae039 = $f179037cdfb41409$var$ExtraContent;



var $kSlfw = parcelRequire("kSlfw");

var $eUqlC = parcelRequire("eUqlC");

var $8g1PZ = parcelRequire("8g1PZ");

var $jtXXN = parcelRequire("jtXXN");

var $feYPt = parcelRequire("feYPt");
var $gXR8t = parcelRequire("gXR8t");

var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");

function $7e96fc940147fd66$var$OperationNode(_ref, ref) {
    var prefixCls = _ref.prefixCls, id = _ref.id, tabs = _ref.tabs, locale = _ref.locale, mobile = _ref.mobile, _ref$moreIcon = _ref.moreIcon, moreIcon = _ref$moreIcon === void 0 ? 'More' : _ref$moreIcon, moreTransitionName = _ref.moreTransitionName, style = _ref.style, className = _ref.className, editable = _ref.editable, tabBarGutter = _ref.tabBarGutter, rtl = _ref.rtl, removeAriaLabel = _ref.removeAriaLabel, onTabClick = _ref.onTabClick, getPopupContainer = _ref.getPopupContainer, popupClassName = _ref.popupClassName;
    // ======================== Dropdown ========================
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
    var popupId = "".concat(id, "-more-popup");
    var dropdownPrefix = "".concat(prefixCls, "-dropdown");
    var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
    var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    var menu = /*#__PURE__*/ $acw62.createElement((0, $feYPt.default), {
        onClick: function onClick(_ref2) {
            var key = _ref2.key, domEvent = _ref2.domEvent;
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: "".concat(dropdownPrefix, "-menu"),
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
    }, tabs.map(function(tab) {
        var removable = editable && tab.closable !== false && !tab.disabled;
        return /*#__PURE__*/ $acw62.createElement((0, $gXR8t.default), {
            key: tab.key,
            id: "".concat(popupId, "-").concat(tab.key),
            role: "option",
            "aria-controls": id && "".concat(id, "-panel-").concat(tab.key),
            disabled: tab.disabled
        }, /*#__PURE__*/ $acw62.createElement("span", null, tab.label), removable && /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || 'remove',
            tabIndex: 0,
            className: "".concat(dropdownPrefix, "-menu-item-remove"),
            onClick: function onClick(e) {
                e.stopPropagation();
                onRemoveTab(e, tab.key);
            }
        }, tab.closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        var enabledTabs = tabs.filter(function(tab) {
            return !tab.disabled;
        });
        var selectedIndex = enabledTabs.findIndex(function(tab) {
            return tab.key === selectedKey;
        }) || 0;
        var len = enabledTabs.length;
        for(var i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            var tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        var which = e.which;
        if (!open) {
            if ([
                (0, $iCi4s.default).DOWN,
                (0, $iCi4s.default).SPACE,
                (0, $iCi4s.default).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $iCi4s.default).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $iCi4s.default).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $iCi4s.default).ESC:
                setOpen(false);
                break;
            case (0, $iCi4s.default).SPACE:
            case (0, $iCi4s.default).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $acw62.useEffect)(function() {
        // We use query element here to avoid React strict warning
        var ele = document.getElementById(selectedItemId);
        if (ele && ele.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedKey
    ]);
    (0, $acw62.useEffect)(function() {
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    var moreStyle = (0, $kSlfw.default)({}, rtl ? 'marginRight' : 'marginLeft', tabBarGutter);
    if (!tabs.length) {
        moreStyle.visibility = 'hidden';
        moreStyle.order = 1;
    }
    var overlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)({}, "".concat(dropdownPrefix, "-rtl"), rtl));
    var moreNode = mobile ? null : /*#__PURE__*/ $acw62.createElement((0, $jtXXN.default), {
        prefixCls: dropdownPrefix,
        overlay: menu,
        trigger: [
            'hover'
        ],
        visible: tabs.length ? open : false,
        transitionName: moreTransitionName,
        onVisibleChange: setOpen,
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlayClassName, popupClassName),
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        className: "".concat(prefixCls, "-nav-more"),
        style: moreStyle,
        tabIndex: -1,
        "aria-hidden": "true",
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: "".concat(id, "-more"),
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-nav-operations"), className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $acw62.createElement((0, $034d4b5b2135dc44$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
}
var $7e96fc940147fd66$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef($7e96fc940147fd66$var$OperationNode), function(_, next) {
    return(// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);
});



var $kSlfw = parcelRequire("kSlfw");

var $8g1PZ = parcelRequire("8g1PZ");

var $iCi4s = parcelRequire("iCi4s");

var $acw62 = parcelRequire("acw62");

function $05c6b22b26939e9e$var$TabNode(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, id = _ref.id, active = _ref.active, _ref$tab = _ref.tab, key = _ref$tab.key, label = _ref$tab.label, disabled = _ref$tab.disabled, closeIcon = _ref$tab.closeIcon, closable = _ref.closable, renderWrapper = _ref.renderWrapper, removeAriaLabel = _ref.removeAriaLabel, editable = _ref.editable, onClick = _ref.onClick, onFocus = _ref.onFocus, style = _ref.style;
    var tabPrefix = "".concat(prefixCls, "-tab");
    var removable = editable && closable !== false && !disabled;
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    var node = /*#__PURE__*/ $acw62.createElement("div", {
        key: key,
        "data-node-key": (0, $099b8f1c61d35623$export$c55417729a96230c)(key),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(tabPrefix, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(tabPrefix, "-with-remove"), removable), (0, $kSlfw.default)(_classNames, "".concat(tabPrefix, "-active"), active), (0, $kSlfw.default)(_classNames, "".concat(tabPrefix, "-disabled"), disabled), _classNames)),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $acw62.createElement("div", {
        role: "tab",
        "aria-selected": active,
        id: id && "".concat(id, "-tab-").concat(key),
        className: "".concat(tabPrefix, "-btn"),
        "aria-controls": id && "".concat(id, "-panel-").concat(key),
        "aria-disabled": disabled,
        tabIndex: disabled ? null : 0,
        onClick: function onClick(e) {
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            if ([
                (0, $iCi4s.default).SPACE,
                (0, $iCi4s.default).ENTER
            ].includes(e.which)) {
                e.preventDefault();
                onInternalClick(e);
            }
        },
        onFocus: onFocus
    }, label), removable && /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || 'remove',
        tabIndex: 0,
        className: "".concat(tabPrefix, "-remove"),
        onClick: function onClick(e) {
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
}
var $05c6b22b26939e9e$export$2e2bcd8739ae039 = $05c6b22b26939e9e$var$TabNode;


var $251c9e7122a85d75$var$getSize = function getSize(refObj) {
    var _ref = refObj.current || {}, _ref$offsetWidth = _ref.offsetWidth, offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth, _ref$offsetHeight = _ref.offsetHeight, offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ var $251c9e7122a85d75$var$getUnitValue = function getUnitValue(size, tabPositionTopOrBottom) {
    return size[tabPositionTopOrBottom ? 0 : 1];
};
function $251c9e7122a85d75$var$TabNavList(props, ref) {
    var _classNames;
    var _React$useContext = $acw62.useContext((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var className = props.className, style = props.style, id = props.id, animated = props.animated, activeKey = props.activeKey, rtl = props.rtl, extra = props.extra, editable = props.editable, locale = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll;
    var containerRef = (0, $acw62.useRef)();
    var extraLeftRef = (0, $acw62.useRef)();
    var extraRightRef = (0, $acw62.useRef)();
    var tabsWrapperRef = (0, $acw62.useRef)();
    var tabListRef = (0, $acw62.useRef)();
    var operationsRef = (0, $acw62.useRef)();
    var innerAddButtonRef = (0, $acw62.useRef)();
    // const [getBtnRef, removeBtnRef] = useRefs<HTMLDivElement>();
    var tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';
    var _useSyncState = (0, $f1c0f3be6d5fa93f$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'left' : 'right'
        });
    }), _useSyncState2 = (0, $eUqlC.default)(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
    var _useSyncState3 = (0, $f1c0f3be6d5fa93f$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'top' : 'bottom'
        });
    }), _useSyncState4 = (0, $eUqlC.default)(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
    var _useState = (0, $acw62.useState)([
        0,
        0
    ]), _useState2 = (0, $eUqlC.default)(_useState, 2), containerExcludeExtraSize = _useState2[0], setContainerExcludeExtraSize = _useState2[1];
    var _useState3 = (0, $acw62.useState)([
        0,
        0
    ]), _useState4 = (0, $eUqlC.default)(_useState3, 2), tabContentSize = _useState4[0], setTabContentSize = _useState4[1];
    var _useState5 = (0, $acw62.useState)([
        0,
        0
    ]), _useState6 = (0, $eUqlC.default)(_useState5, 2), addSize = _useState6[0], setAddSize = _useState6[1];
    var _useState7 = (0, $acw62.useState)([
        0,
        0
    ]), _useState8 = (0, $eUqlC.default)(_useState7, 2), operationSize = _useState8[0], setOperationSize = _useState8[1];
    var _useUpdateState = (0, $6bb369ac1283ea97$export$aefd2a30eb6d999e)(new Map()), _useUpdateState2 = (0, $eUqlC.default)(_useUpdateState, 2), tabSizes = _useUpdateState2[0], setTabSizes = _useUpdateState2[1];
    var tabOffsets = (0, $fea37cf40acfe645$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    var containerExcludeExtraSizeValue = $251c9e7122a85d75$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    var tabContentSizeValue = $251c9e7122a85d75$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    var addSizeValue = $251c9e7122a85d75$var$getUnitValue(addSize, tabPositionTopOrBottom);
    var operationSizeValue = $251c9e7122a85d75$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    var needScroll = containerExcludeExtraSizeValue < tabContentSizeValue + addSizeValue;
    var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
    var transformMin = 0;
    var transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    var touchMovingRef = (0, $acw62.useRef)();
    var _useState9 = (0, $acw62.useState)(), _useState10 = (0, $eUqlC.default)(_useState9, 2), lockAnimation = _useState10[0], setLockAnimation = _useState10[1];
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        window.clearTimeout(touchMovingRef.current);
    }
    (0, $bd298a079d025635$export$2e2bcd8739ae039)(tabsWrapperRef, function(offsetX, offsetY) {
        function doMove(setState, offset) {
            setState(function(value) {
                var newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $acw62.useEffect)(function() {
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = window.setTimeout(function() {
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    var _useVisibleRange = (0, $1e3cbc4ab07e0147$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        tabs: tabs
    })), _useVisibleRange2 = (0, $eUqlC.default)(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
    // ========================= Scroll ========================
    var scrollToTab = (0, $a4gyP.default)(function() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
        var tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            var newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            var _newTransform = transformTop;
            if (tabOffset.top < -transformTop) _newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(_newTransform));
        }
    });
    // ========================== Tab ==========================
    var tabNodeStyle = {};
    if (tabPosition === 'top' || tabPosition === 'bottom') tabNodeStyle[rtl ? 'marginRight' : 'marginLeft'] = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    var tabNodes = tabs.map(function(tab, i) {
        var key = tab.key;
        return /*#__PURE__*/ $acw62.createElement((0, $05c6b22b26939e9e$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            style: i === 0 ? undefined : tabNodeStyle,
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            renderWrapper: children,
            removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
            onClick: function onClick(e) {
                onTabClick(key, e);
            },
            onFocus: function onFocus() {
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            }
        });
    });
    // Update buttons records
    var updateTabSizes = function updateTabSizes() {
        return setTabSizes(function() {
            var newSizes = new Map();
            tabs.forEach(function(_ref2) {
                var _tabListRef$current;
                var key = _ref2.key;
                var btnNode = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.querySelector("[data-node-key=\"".concat((0, $099b8f1c61d35623$export$c55417729a96230c)(key), "\"]"));
                if (btnNode) newSizes.set(key, {
                    width: btnNode.offsetWidth,
                    height: btnNode.offsetHeight,
                    left: btnNode.offsetLeft,
                    top: btnNode.offsetTop
                });
            });
            return newSizes;
        });
    };
    (0, $acw62.useEffect)(function() {
        updateTabSizes();
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_')
    ]);
    var onListHolderResize = (0, $6bb369ac1283ea97$export$2e2bcd8739ae039)(function() {
        // Update wrapper records
        var containerSize = $251c9e7122a85d75$var$getSize(containerRef);
        var extraLeftSize = $251c9e7122a85d75$var$getSize(extraLeftRef);
        var extraRightSize = $251c9e7122a85d75$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        var newAddSize = $251c9e7122a85d75$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        var newOperationSize = $251c9e7122a85d75$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        var tabContentFullSize = $251c9e7122a85d75$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    var startHiddenTabs = tabs.slice(0, visibleStart);
    var endHiddenTabs = tabs.slice(visibleEnd + 1);
    var hiddenTabs = [].concat((0, $kbxxf.default)(startHiddenTabs), (0, $kbxxf.default)(endHiddenTabs));
    // =================== Link & Operations ===================
    var _useState11 = (0, $acw62.useState)(), _useState12 = (0, $eUqlC.default)(_useState11, 2), inkStyle = _useState12[0], setInkStyle = _useState12[1];
    var activeTabOffset = tabOffsets.get(activeKey);
    // Delay set ink style to avoid remove tab blink
    var inkBarRafRef = (0, $acw62.useRef)();
    function cleanInkBarRaf() {
        (0, $dTiBu.default).cancel(inkBarRafRef.current);
    }
    (0, $acw62.useEffect)(function() {
        var newInkStyle = {};
        if (activeTabOffset) {
            if (tabPositionTopOrBottom) {
                if (rtl) newInkStyle.right = activeTabOffset.right;
                else newInkStyle.left = activeTabOffset.left;
                newInkStyle.width = activeTabOffset.width;
            } else {
                newInkStyle.top = activeTabOffset.top;
                newInkStyle.height = activeTabOffset.height;
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $dTiBu.default)(function() {
            setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        activeTabOffset,
        tabPositionTopOrBottom,
        rtl
    ]);
    // ========================= Effect ========================
    (0, $acw62.useEffect)(function() {
        scrollToTab();
    // eslint-disable-next-line
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $099b8f1c61d35623$export$fac44ee5b035f737)(activeTabOffset),
        (0, $099b8f1c61d35623$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $acw62.useEffect)(function() {
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    var hasDropdown = !!hiddenTabs.length;
    var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
    var pingLeft;
    var pingRight;
    var pingTop;
    var pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: (0, $85dLH.useComposeRef)(ref, containerRef),
        role: "tablist",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-nav"), className),
        style: style,
        onKeyDown: function onKeyDown() {
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $f179037cdfb41409$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(wrapPrefix, (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-left"), pingLeft), (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-right"), pingRight), (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-top"), pingTop), (0, $kSlfw.default)(_classNames, "".concat(wrapPrefix, "-ping-bottom"), pingBottom), _classNames)),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $acw62.createElement((0, $bVxlN.default), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: tabListRef,
        className: "".concat(prefixCls, "-nav-list"),
        style: {
            transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
            transition: lockAnimation ? 'none' : undefined
        }
    }, tabNodes, /*#__PURE__*/ $acw62.createElement((0, $034d4b5b2135dc44$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: (0, $d49SP.default)((0, $d49SP.default)({}, tabNodes.length === 0 ? undefined : tabNodeStyle), {}, {
            visibility: hasDropdown ? 'hidden' : null
        })
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("".concat(prefixCls, "-ink-bar"), (0, $kSlfw.default)({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
        style: inkStyle
    })))), /*#__PURE__*/ $acw62.createElement((0, $7e96fc940147fd66$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $acw62.createElement((0, $f179037cdfb41409$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ }
var $251c9e7122a85d75$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($251c9e7122a85d75$var$TabNavList);




var $9e555564d15c1afa$var$_excluded = [
    "renderTabBar"
], $9e555564d15c1afa$var$_excluded2 = [
    "label",
    "key"
];
function $9e555564d15c1afa$export$2e2bcd8739ae039(_ref) {
    var renderTabBar = _ref.renderTabBar, restProps = (0, $9X7IJ.default)(_ref, $9e555564d15c1afa$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039)), tabs = _React$useContext.tabs;
    if (renderTabBar) {
        var tabNavBarProps = (0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
            // Legacy support. We do not use this actually
            panes: tabs.map(function(_ref2) {
                var label = _ref2.label, key = _ref2.key, restTabProps = (0, $9X7IJ.default)(_ref2, $9e555564d15c1afa$var$_excluded2);
                return /*#__PURE__*/ $acw62.createElement((0, $32b6ebe184c19bb6$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    tab: label,
                    key: key,
                    tabKey: key
                }, restTabProps));
            })
        });
        return renderTabBar(tabNavBarProps, (0, $251c9e7122a85d75$export$2e2bcd8739ae039));
    }
    return /*#__PURE__*/ $acw62.createElement((0, $251c9e7122a85d75$export$2e2bcd8739ae039), restProps);
}



var $fSwVM = parcelRequire("fSwVM");

var $d49SP = parcelRequire("d49SP");
parcelRequire("u43uR");
function $8ba1fa9e00219fcd$export$2e2bcd8739ae039() {
    var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = (0, $d49SP.default)({
        inkBar: true
    }, (0, $fSwVM.default)(animated) === 'object' ? animated : {});
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}


var $31c9762e836450cf$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "items",
    "direction",
    "activeKey",
    "defaultActiveKey",
    "editable",
    "animated",
    "tabPosition",
    "tabBarGutter",
    "tabBarStyle",
    "tabBarExtraContent",
    "locale",
    "moreIcon",
    "moreTransitionName",
    "destroyInactiveTabPane",
    "renderTabBar",
    "onChange",
    "onTabClick",
    "onTabScroll",
    "getPopupContainer",
    "popupClassName"
];
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
var $31c9762e836450cf$var$uuid = 0;
function $31c9762e836450cf$var$Tabs(_ref, ref) {
    var _classNames;
    var id = _ref.id, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-tabs' : _ref$prefixCls, className = _ref.className, items = _ref.items, direction = _ref.direction, activeKey = _ref.activeKey, defaultActiveKey = _ref.defaultActiveKey, editable = _ref.editable, animated = _ref.animated, _ref$tabPosition = _ref.tabPosition, tabPosition = _ref$tabPosition === void 0 ? 'top' : _ref$tabPosition, tabBarGutter = _ref.tabBarGutter, tabBarStyle = _ref.tabBarStyle, tabBarExtraContent = _ref.tabBarExtraContent, locale = _ref.locale, moreIcon = _ref.moreIcon, moreTransitionName = _ref.moreTransitionName, destroyInactiveTabPane = _ref.destroyInactiveTabPane, renderTabBar = _ref.renderTabBar, onChange = _ref.onChange, onTabClick = _ref.onTabClick, onTabScroll = _ref.onTabScroll, getPopupContainer = _ref.getPopupContainer, popupClassName = _ref.popupClassName, restProps = (0, $9X7IJ.default)(_ref, $31c9762e836450cf$var$_excluded);
    var tabs = $acw62.useMemo(function() {
        return (items || []).filter(function(item) {
            return item && (0, $fSwVM.default)(item) === 'object' && 'key' in item;
        });
    }, [
        items
    ]);
    var rtl = direction === 'rtl';
    var mergedAnimated = (0, $8ba1fa9e00219fcd$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $eUqlC.default)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Only update on the client side
        setMobile((0, $ycMhT.default)());
    }, []);
    // ====================== Active Key ======================
    var _useMergedState = (0, $iSQh8.default)(function() {
        var _tabs$;
        return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
    }, {
        value: activeKey,
        defaultValue: defaultActiveKey
    }), _useMergedState2 = (0, $eUqlC.default)(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
    }), _useState4 = (0, $eUqlC.default)(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
    // Reset active key if not exist anymore
    (0, $acw62.useEffect)(function() {
        var newActiveIndex = tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
        if (newActiveIndex === -1) {
            var _tabs$newActiveIndex;
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    var _useMergedState3 = (0, $iSQh8.default)(null, {
        value: id
    }), _useMergedState4 = (0, $eUqlC.default)(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
    // Async generate id to avoid ssr mapping failed
    (0, $acw62.useEffect)(function() {
        if (!id) {
            setMergedId("rc-tabs-".concat($31c9762e836450cf$var$uuid));
            $31c9762e836450cf$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick === null || onTabClick === void 0 || onTabClick(key, e);
        var isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange === null || onChange === void 0 || onChange(key);
    }
    // ======================== Render ========================
    var sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    var tabNavBar;
    var tabNavBarProps = (0, $d49SP.default)((0, $d49SP.default)({}, sharedProps), {}, {
        editable: editable,
        locale: locale,
        moreIcon: moreIcon,
        moreTransitionName: moreTransitionName,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        panes: null,
        getPopupContainer: getPopupContainer,
        popupClassName: popupClassName
    });
    return /*#__PURE__*/ $acw62.createElement((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039).Provider, {
        value: {
            tabs: tabs,
            prefixCls: prefixCls
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        ref: ref,
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), (_classNames = {}, (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-mobile"), mobile), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-editable"), editable), (0, $kSlfw.default)(_classNames, "".concat(prefixCls, "-rtl"), rtl), _classNames), className)
    }, restProps), tabNavBar, /*#__PURE__*/ $acw62.createElement((0, $9e555564d15c1afa$export$2e2bcd8739ae039), (0, $8nd05.default)({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $acw62.createElement((0, $8a40c3051886a790$export$2e2bcd8739ae039), (0, $8nd05.default)({
        destroyInactiveTabPane: destroyInactiveTabPane
    }, sharedProps, {
        animated: mergedAnimated
    }))));
}
var $31c9762e836450cf$var$ForwardTabs = /*#__PURE__*/ $acw62.forwardRef($31c9762e836450cf$var$Tabs);
var $31c9762e836450cf$export$2e2bcd8739ae039 = $31c9762e836450cf$var$ForwardTabs;


var $a66b746dc2ee365b$export$2e2bcd8739ae039 = (0, $31c9762e836450cf$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");




var $fSwVM = parcelRequire("fSwVM");

var $8nd05 = parcelRequire("8nd05");

var $eb61855ec5fb79d5$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $eb61855ec5fb79d5$export$2e2bcd8739ae039(prefixCls) {
    var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = (0, $8nd05.default)({
        inkBar: true
    }, (0, $fSwVM.default)(animated) === 'object' ? animated : {});
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = (0, $8nd05.default)((0, $8nd05.default)({}, $eb61855ec5fb79d5$var$motion), {
        motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(prefixCls, 'switch')
    });
    return mergedAnimated;
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $jWR62 = parcelRequire("jWR62");

var $364487f9f614b61c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $364487f9f614b61c$var$filter(items) {
    return items.filter(function(item) {
        return item;
    });
}
function $364487f9f614b61c$export$2e2bcd8739ae039(items, children) {
    if (items) return items;
    var childrenItems = (0, $jWR62.default)(children).map(function(node) {
        if (/*#__PURE__*/ $acw62.isValidElement(node)) {
            var key = node.key, props = node.props;
            var _a = props || {}, tab = _a.tab, restProps = $364487f9f614b61c$var$__rest(_a, [
                "tab"
            ]);
            var item = (0, $8nd05.default)((0, $8nd05.default)({
                key: String(key)
            }, restProps), {
                label: tab
            });
            return item;
        }
        return null;
    });
    return $364487f9f614b61c$var$filter(childrenItems);
}


var $4c89efaaf6882e88$var$TabPane = function TabPane() {
    return null;
};
var $4c89efaaf6882e88$export$2e2bcd8739ae039 = $4c89efaaf6882e88$var$TabPane;


var $389d763730796d58$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $389d763730796d58$var$Tabs(_a) {
    var type = _a.type, className = _a.className, propSize = _a.size, _onEdit = _a.onEdit, hideAdd = _a.hideAdd, centered = _a.centered, addIcon = _a.addIcon, children = _a.children, items = _a.items, animated = _a.animated, props = $389d763730796d58$var$__rest(_a, [
        "type",
        "className",
        "size",
        "onEdit",
        "hideAdd",
        "centered",
        "addIcon",
        "children",
        "items",
        "animated"
    ]);
    var customizePrefixCls = props.prefixCls, _props$moreIcon = props.moreIcon, moreIcon = _props$moreIcon === void 0 ? /*#__PURE__*/ $acw62.createElement((0, $09defd2fd47a1b8f$export$2e2bcd8739ae039), null) : _props$moreIcon;
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, getPopupContainer = _React$useContext.getPopupContainer;
    var prefixCls = getPrefixCls('tabs', customizePrefixCls);
    var editable;
    if (type === 'editable-card') editable = {
        onEdit: function onEdit(editType, _ref) {
            var key = _ref.key, event = _ref.event;
            _onEdit === null || _onEdit === void 0 || _onEdit(editType === 'add' ? event : key, editType);
        },
        removeIcon: /*#__PURE__*/ $acw62.createElement((0, $31b8ddc4065205d5$export$2e2bcd8739ae039), null),
        addIcon: addIcon || /*#__PURE__*/ $acw62.createElement((0, $b0299ce2db1ca33d$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    var rootPrefixCls = getPrefixCls();
    var mergedItems = (0, $364487f9f614b61c$export$2e2bcd8739ae039)(items, children);
    var mergedAnimated = (0, $eb61855ec5fb79d5$export$2e2bcd8739ae039)(prefixCls, animated);
    return /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$2e2bcd8739ae039).Consumer, null, function(contextSize) {
        var size = propSize !== undefined ? propSize : contextSize;
        return /*#__PURE__*/ $acw62.createElement((0, $a66b746dc2ee365b$export$2e2bcd8739ae039), (0, $8nd05.default)({
            direction: direction,
            getPopupContainer: getPopupContainer,
            moreTransitionName: "".concat(rootPrefixCls, "-slide-up")
        }, props, {
            items: mergedItems,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)((0, $kSlfw.default)({}, "".concat(prefixCls, "-").concat(size), size), "".concat(prefixCls, "-card"), [
                'card',
                'editable-card'
            ].includes(type)), "".concat(prefixCls, "-editable-card"), type === 'editable-card'), "".concat(prefixCls, "-centered"), centered), className),
            editable: editable,
            moreIcon: moreIcon,
            prefixCls: prefixCls,
            animated: mergedAnimated
        }));
    });
}
$389d763730796d58$var$Tabs.TabPane = (0, $4c89efaaf6882e88$export$2e2bcd8739ae039);
var $389d763730796d58$export$2e2bcd8739ae039 = $389d763730796d58$var$Tabs;





var $acw62 = parcelRequire("acw62");

function $28a7f361a7c1d203$export$2e2bcd8739ae039() {
    const [drivers, setDrivers] = (0, $acw62.useState)();
    const [clients, setClients] = (0, $acw62.useState)();
    const [contractors, setContractors] = (0, $acw62.useState)();
    const [summaries, setSummaries] = (0, $acw62.useState)({});
    const [owns, setOwns] = (0, $acw62.useState)({});
    const [orders, setOrders] = (0, $acw62.useState)({});
    const getDrivers = async ()=>{
        if (drivers) return drivers;
        const d = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).users.getAll();
        setDrivers(d);
        return d;
    };
    const getClients = async ()=>{
        if (clients) return clients;
        const c = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.getAll();
        setClients(c);
        return c;
    };
    const getContractors = async ()=>{
        if (contractors) return contractors;
        const c = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.owns.contractors.getAll();
        setContractors(c);
        return c;
    };
    const getSummary = async (from, to)=>{
        const cached = summaries[`${from}-${to}`];
        if (cached) return cached;
        const result = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).stats.summary(from, to);
        setSummaries((summaries)=>({
                ...summaries,
                [`${from}-${to}`]: result
            }));
        return result;
    };
    const getOwns = async (after, before, client_id, to)=>{
        const id = `${after}-${before}-${client_id}-${to}`;
        const cached = owns[id];
        if (cached) return cached;
        const r = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.owns.getAll({
            after: after,
            before: before,
            client_id: client_id,
            to: to
        });
        setOwns((owns)=>({
                ...owns,
                [id]: r
            }));
        return r;
    };
    const getOrders = async (after, before, client_id)=>{
        const id = `${after}-${before}-${client_id}`;
        const cached = orders[id];
        if (cached) return cached;
        const r = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.getAll({
            after: after,
            before: before,
            client_id: client_id
        });
        setOrders((orders)=>({
                ...orders,
                [id]: r
            }));
        return r;
    };
    return [
        {
            drivers: drivers,
            clients: clients,
            contractors: contractors
        },
        {
            getClients: getClients,
            getContractors: getContractors,
            getOwns: getOwns,
            getOrders: getOrders
        }
    ];
}



var $acw62 = parcelRequire("acw62");
var $4290c491fed125e9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)();




var $acw62 = parcelRequire("acw62");






var $45fvw = parcelRequire("45fvw");


const $6ebf5dbeb14009db$var$Inputs = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	> * {
		&:nth-child(1) {
			min-width: 200px;
		}

		&:nth-child(2) {
			min-width: 200px;
		}

		&:last-child {
			min-width: min-content;
		}
	}
`;
const $6ebf5dbeb14009db$var$Content = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	overflow: auto;

	> div {
		&:not(:last-child) {
			margin-bottom: 25px;
		}

		> h2,
		h3,
		h4 {
			margin: 0;
		}

		> div:not(:last-child) {
			margin-bottom: 15px;
		}

		table {
			width: 100%;
		}
	}
`;
const $6ebf5dbeb14009db$var$Incomes = ({})=>{
    const [after, setAfter] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('month'));
    const [before, setBefore] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('month'));
    const [expenseTypes, setExpenseTypes] = (0, $acw62.useState)();
    const [stats, setStats] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            setStats();
            (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.expenseTypes.getAll().then(setExpenseTypes);
            const start = after.startOf('day').unix() * 1000;
            const end = before.endOf('day').unix() * 1000;
            const stats = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).stats.incomes({
                after: start,
                before: end
            });
            let incomesSum = 0;
            for (const income of stats.incomes)incomesSum += income.value;
            // type_id: { net: 0, gross: 0, expenses: [] }
            const expensesSum = {};
            const expensesAll = {
                net: 0,
                gross: 0
            };
            for (const expense of stats.expenses){
                if (!expensesSum[expense.type_id]) expensesSum[expense.type_id] = {
                    net: 0,
                    gross: 0,
                    expenses: []
                };
                if (expense.value_type) {
                    const net = expense.value * (1 - expense.tax / 100);
                    expensesSum[expense.type_id].net += net;
                    expensesSum[expense.type_id].gross += expense.value;
                    expensesAll.net += net;
                    expensesAll.gross += expense.value;
                } else {
                    const gross = expense.value * (1 + expense.tax / 100);
                    expensesSum[expense.type_id].net += expense.value;
                    expensesSum[expense.type_id].gross += gross;
                    expensesAll.net += expense.value;
                    expensesAll.gross += gross;
                }
                expensesSum[expense.type_id].expenses.push(expense);
            }
            stats.incomes.sum = incomesSum;
            stats.expenses.sum = expensesSum;
            stats.expenses.net = expensesAll.net;
            stats.expenses.gross = expensesAll.gross;
            setStats(stats);
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (before < after) return;
        fetch();
    }, [
        after,
        before
    ]);
    const clearFilters = ()=>{
        setAfter((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('month'));
        setBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('month'));
    };
    const printRef = (0, $acw62.useRef)();
    const handlePrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: ()=>printRef.current
    });
    return expenseTypes && stats ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "overflow-y-auto",
        children: [
            before < after && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    color: (0, $0b4842326956570d$export$a90204d1394caf30)[5]
                },
                children: "Data do jest wcze\u015Bniej od daty od, dane nie s\u0105 od\u015Bwie\u017Cone!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6ebf5dbeb14009db$var$Inputs, {
                className: "inputs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                        placeholder: "Data od",
                        size: "large",
                        value: after,
                        onChange: setAfter
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                        placeholder: "Data do",
                        size: "large",
                        value: before,
                        onChange: setBefore
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                        onClick: clearFilters,
                        children: "Wyczy\u015B\u0107"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        size: "large",
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a66bc520ace0c83$export$2e2bcd8739ae039), {}),
                        onClick: ()=>handlePrint(),
                        children: "Drukuj"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6ebf5dbeb14009db$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02f12f5ef8a84097$export$2e2bcd8739ae039), {
                        after: after,
                        before: before,
                        expenseTypes: expenseTypes,
                        stats: stats
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02f12f5ef8a84097$export$2e2bcd8739ae039), {
                        ref: printRef,
                        after: after,
                        before: before,
                        expenseTypes: expenseTypes,
                        stats: stats,
                        print: true
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true
    });
};
var $6ebf5dbeb14009db$export$2e2bcd8739ae039 = $6ebf5dbeb14009db$var$Incomes;




var $acw62 = parcelRequire("acw62");







var $45fvw = parcelRequire("45fvw");
const { Option: $11e231bd374b3664$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const $11e231bd374b3664$var$Inputs = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	> * {
		&:nth-child(1) {
			min-width: 200px;
		}

		&:nth-child(2) {
			min-width: 200px;
		}

		&:nth-child(3) {
			min-width: 200px;
		}

		&:nth-child(4) {
			min-width: 200px;
		}

		&:nth-child(5) {
			min-width: min-content;
		}
	}
`;
const $11e231bd374b3664$var$Owns = ()=>{
    const [{ clients: clients, contractors: contractors }, { getClients: getClients, getContractors: getContractors, getOwns: getOwns }] = (0, $acw62.useContext)((0, $4290c491fed125e9$export$2e2bcd8739ae039));
    const [after, setAfter] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('month'));
    const [before, setBefore] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('month'));
    const [client, setClient] = (0, $acw62.useState)();
    const [to, setTo] = (0, $acw62.useState)();
    const [owns, setOwns] = (0, $acw62.useState)();
    const fetch = async ()=>{
        try {
            setOwns();
            const owns = await getOwns(after.unix() * 1000, before.unix() * 1000, client, to);
            setOwns(owns.map((o)=>({
                    ...o,
                    key: o.id
                })));
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        getClients();
        getContractors();
        fetch();
    }, [
        after,
        before,
        client,
        to
    ]);
    const clearFilters = ()=>{
        setAfter((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('month'));
        setBefore((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('month'));
        setClient();
        setTo();
    };
    const columns = [
        {
            title: 'Klient',
            dataIndex: 'client',
            key: 'client',
            render: (client)=>client && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/clients/${client.id}`,
                    children: client.name
                })
        },
        {
            title: 'Kontrahent',
            dataIndex: 'to',
            key: 'to',
            render: (to)=>to
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address'
        },
        {
            title: 'Waga',
            dataIndex: 'weight',
            key: 'weight',
            render: (weight)=>`${(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(weight)} kg`
        },
        {
            title: 'Data',
            dataIndex: 'date',
            key: 'date',
            render: (date)=>(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).hours() === 0)
        },
        {
            title: 'Akcje',
            dataIndex: 'id',
            key: 'id',
            render: (id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${id}/1`,
                    children: "Szczeg\xf3\u0142y"
                })
        }
    ];
    const summary = (0, $acw62.useMemo)(()=>{
        if (!owns) return {};
        return owns.reduce((acc, e)=>({
                weight: acc.weight + e.weight
            }), {
            weight: 0
        });
    }, [
        owns
    ]);
    return clients && contractors ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($11e231bd374b3664$var$Inputs, {
                className: "inputs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                        placeholder: "Data od",
                        size: "large",
                        value: after,
                        onChange: setAfter
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                        placeholder: "Data do",
                        size: "large",
                        value: before,
                        onChange: setBefore
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                        size: "large",
                        placeholder: "Klient",
                        value: client,
                        onChange: setClient,
                        children: clients.map((client)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11e231bd374b3664$var$Option, {
                                value: client.id,
                                children: client.name
                            }, client.id))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                        size: "large",
                        placeholder: "kontrahent",
                        value: to,
                        onChange: setTo,
                        children: contractors.map((contractor)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11e231bd374b3664$var$Option, {
                                value: contractor,
                                children: contractor
                            }, contractor))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                        onClick: clearFilters,
                        children: "Wyczy\u015B\u0107"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                columns: columns,
                dataSource: owns,
                loading: !owns,
                pagination: false,
                scroll: {
                    x: 'max-content'
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    "Sumaryczna waga: ",
                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(summary.weight ?? 0),
                    "kg"
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true
    });
};
var $11e231bd374b3664$export$2e2bcd8739ae039 = $11e231bd374b3664$var$Owns;



const { TabPane: $cd41a1e04ff57680$var$TabPane } = (0, $389d763730796d58$export$2e2bcd8739ae039);
const $cd41a1e04ff57680$var$Stats = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { tab: tab } = (0, $a472eec1c89e43a3$export$2e2bcd8739ae039).decode(location.search);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4290c491fed125e9$export$2e2bcd8739ae039).Provider, {
        value: (0, $28a7f361a7c1d203$export$2e2bcd8739ae039)(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
            title: "Statystyki",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "stats",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $389d763730796d58$export$2e2bcd8739ae039), {
                    activeKey: tab ?? '0',
                    onChange: (tab)=>navigate(`?tab=${tab}`, {
                            replace: true
                        }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd41a1e04ff57680$var$TabPane, {
                            tab: "Przychody",
                            className: "h-full",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ebf5dbeb14009db$export$2e2bcd8739ae039), {})
                        }, "0"),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd41a1e04ff57680$var$TabPane, {
                            tab: "Utylizacje",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11e231bd374b3664$export$2e2bcd8739ae039), {})
                        }, "4")
                    ]
                })
            })
        })
    });
};
var $cd41a1e04ff57680$export$2e2bcd8739ae039 = $cd41a1e04ff57680$var$Stats;




var $acw62 = parcelRequire("acw62");










const $84068d221ceff35f$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	.ant-table-row {
		&.red {
			> td:first-child {
				border-left: 8px solid ${(0, $0b4842326956570d$export$a90204d1394caf30)[5]};
			}
		}
	}
`;
const $84068d221ceff35f$var$PAGE_SIZE = 50;
const $84068d221ceff35f$export$1e6b6fbc35803959 = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [filters, setFilters] = (0, $106621f36f239263$export$973ca22476b0e05f)({
        search: null,
        removed: '0',
        page: '1'
    });
    const showRemoved = filters.removed === '1';
    const currentPage = parseInt(filters.page) || 1;
    // Reset to page 1 whenever search or removed filter changes
    (0, $acw62.useEffect)(()=>{
        if (filters.page !== '1') setFilters('page', '1');
    }, [
        filters.search,
        filters.removed
    ]);
    const clients = (0, $1455449f1630f2df$export$4823a6cc022cca16)({
        search: filters.search ?? undefined,
        showRemoved: showRemoved
    });
    const users = (0, $0df0903efbca6a2f$export$90f4370c54dd43c9)({});
    const firstIndex = (currentPage - 1) * $84068d221ceff35f$var$PAGE_SIZE;
    const lastIndex = currentPage * $84068d221ceff35f$var$PAGE_SIZE;
    const pagedClients = clients?.slice(firstIndex, lastIndex);
    const columns = [
        {
            title: 'Nazwa',
            key: 'name',
            render: (_, row)=>row.name
        },
        {
            title: 'Telefon',
            key: 'phone',
            render: (_, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                    phone: row.phone
                })
        },
        {
            title: 'NIP',
            key: 'nip',
            render: (_, row)=>row.nip
        },
        {
            title: 'BDO',
            key: 'bdo',
            render: (_, row)=>row.bdo
        },
        {
            title: 'Email',
            key: 'email',
            render: (_, row)=>row.email
        },
        {
            title: showRemoved ? "Usuni\u0119ty - przez" : 'Dodany - przez',
            key: 'created',
            render: (_, row)=>{
                if (showRemoved) {
                    if (!row.removedBy || !row.removedDate) return '-';
                    const removedBy = users?.find((user)=>user.id === row.removedBy);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(row.removedDate),
                            " -",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/panel/drivers/${row.removedBy}`,
                                children: [
                                    removedBy?.name,
                                    " ",
                                    removedBy?.surname
                                ]
                            })
                        ]
                    });
                }
                if (!row.createdBy || !row.createdDate) return '-';
                const createdBy = users?.find((user)=>user.id === row.createdBy);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(row.createdDate),
                        " -",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/drivers/${row.createdBy}`,
                            children: [
                                createdBy?.name,
                                " ",
                                createdBy?.surname
                            ]
                        })
                    ]
                });
            }
        },
        {
            title: 'Akcje',
            key: 'action',
            render: (_, row)=>{
                const actionName = row.removedBy ? "Przywr\xf3\u0107" : "Usu\u0144";
                const actionColor = row.removedBy ? '#52C41A' : '#f5222d';
                // const action = row.removedBy ? () => restoreClient(row.id) : () => deleteClient(row.id);
                const action = async ()=>{};
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    size: 5,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/clients/${row.id}`,
                            children: "Szczeg\xf3\u0142y"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "|"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4fe7ed96759354$export$4a414f5357d5343), {
                            color: actionColor,
                            onClick: action,
                            children: actionName
                        })
                    ]
                });
            }
        }
    ];
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
                        onClick: ()=>navigate('/panel/new-client'),
                        children: "Dodaj nowego Klienta"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        type: "primary",
                        size: "large",
                        icon: showRemoved ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {}),
                        onClick: ()=>setFilters('removed', showRemoved ? '0' : '1'),
                        children: [
                            showRemoved ? 'Ukryj' : "Poka\u017C",
                            " usuni\u0119tych klient\xf3w"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $457c0f7bc166788c$export$2e2bcd8739ae039), {
                    current: currentPage,
                    pageSize: $84068d221ceff35f$var$PAGE_SIZE,
                    total: clients?.length ?? 0,
                    onChange: (page)=>setFilters('page', String(page)),
                    showTotal: (total, range)=>`${range[0]}-${range[1]} z ${total}`,
                    showSizeChanger: false
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Klienci",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($84068d221ceff35f$var$Wrapper, {
            className: "clients flex flex-dir flex-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inputs flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            placeholder: "Wyszukaj",
                            size: "large",
                            suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                                style: {
                                    color: '#8C8C8C'
                                }
                            }),
                            value: filters.search ?? '',
                            onChange: (e)=>setFilters('search', e.target.value || null)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setFilters('removed', '0');
                                setFilters('search', null);
                            },
                            children: "Wyczy\u015B\u0107"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                    columns: columns,
                    rowKey: "id",
                    rowClassName: (row)=>row.lockedDate !== null ? 'red' : '',
                    dataSource: pagedClients ?? [],
                    loading: !clients || !users,
                    pagination: false,
                    scroll: {
                        x: 'max-content'
                    }
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $aa623856fc7c1813$export$47d4ff5409b1867c = (id)=>{
    const [client, fetchClient] = (0, $73567ed6b001db2f$export$95f99d327bc8fbbd)(id);
    const [orders, setOrders] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        fetchOrders();
    }, [
        id
    ]);
    const fetchOrders = async ()=>{
        try {
            const orders = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders2.client.get(id);
            setOrders(orders);
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    const [createdBy] = (0, $ac789bea2a0ba498$export$23bbbc4533528f03)(client?.createdBy);
    const [removedBy] = (0, $ac789bea2a0ba498$export$23bbbc4533528f03)(client?.removedBy ?? undefined);
    const [lockedBy] = (0, $ac789bea2a0ba498$export$23bbbc4533528f03)(client?.lockedBy ?? undefined);
    const addresses = (0, $8cc094a24187a8da$export$b610c6a0e5e099e9)(id);
    const containers = (0, $ae6dd32a564409fa$export$c71c85be78428942)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const saveChanges = async (dto)=>{
        if (!client) return;
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).clients.patch(id, dto);
            await fetchClient();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zapisano zmiany');
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} zapisa\u{107} zmian (${e})`);
            return false;
        }
    };
    const deleteClient = async (close)=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).client(id).delete();
            await fetchClient();
            close();
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Usuni\u0119to klienta");
        } catch (e) {
            setLoading(false);
            close();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            console.trace(e);
        }
    };
    const restoreClient = async ()=>{
        try {
            setLoading(true);
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).client(id).patch({
                removed: null
            });
            await fetchClient();
            setLoading(false);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Przywr\xf3cono klienta");
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
            setLoading(false);
            console.trace(e);
        }
    };
    const lockClient = async ()=>{
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).client(id).patch({
                locked: true
            });
            await fetchClient();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Zablokowano klienta');
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} zablokowa\u{107} klienta (${e})`);
        }
    };
    const unlockClient = async ()=>{
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).client(id).patch({
                locked: false
            });
            await fetchClient();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Odblokowano klienta');
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} odblokowa\u{107} klienta (${e})`);
        }
    };
    const payOrder = async (order)=>{
        try {
            if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).loose) {
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).payments.put({
                    orderId: order.id,
                    orderType: (0, $b9894ce465f84cba$export$168ff345f0815589).loose,
                    amount: order.grossPrice - order.alreadyPaid,
                    type: order.wantedPaymentType
                });
                await fetchOrders();
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zam\xf3wienie zosta\u0142o oznaczone jako op\u0142acone");
                return;
            }
            if (order.type === (0, $b9894ce465f84cba$export$168ff345f0815589).classic) {
                // TODO: Move to new endpoint
                await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders.patch(order.id, {
                    payment: 1
                });
                await fetchOrders();
                (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Oznaczono jako zap\u0142acone");
                return;
            }
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Nie mo\u017Cna op\u0142aci\u0107 tego typu zam\xf3wienia");
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} op\u{142}aci\u{107} zam\xf3wienia (${e})`);
        }
    };
    return {
        client: client,
        orders: orders,
        containers: containers,
        createdBy: createdBy,
        removedBy: removedBy,
        lockedBy: lockedBy,
        addresses: addresses,
        loading: loading,
        saveChanges: saveChanges,
        deleteClient: deleteClient,
        restoreClient: restoreClient,
        lockClient: lockClient,
        unlockClient: unlockClient,
        payOrder: payOrder
    };
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c7ba9914a9e0ea41$var$ArrowDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"
                }
            }
        ]
    },
    "name": "arrow-down",
    "theme": "outlined"
};
var $c7ba9914a9e0ea41$export$2e2bcd8739ae039 = $c7ba9914a9e0ea41$var$ArrowDownOutlined;



function $59efee6067683315$var$_extends() {
    $59efee6067683315$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59efee6067683315$var$_extends.apply(this, arguments);
}
const $59efee6067683315$var$ArrowDownOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $59efee6067683315$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c7ba9914a9e0ea41$export$2e2bcd8739ae039)
    }));
/**![arrow-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2MiA0NjUuM2gtODFjLTQuNiAwLTkgMi0xMi4xIDUuNUw1NTAgNzIzLjFWMTYwYzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHY1NjMuMUwyNTUuMSA0NzAuOGMtMy0zLjUtNy40LTUuNS0xMi4xLTUuNWgtODFjLTYuOCAwLTEwLjUgOC4xLTYgMTMuMkw0ODcuOSA4NjFhMzEuOTYgMzEuOTYgMCAwMDQ4LjMgMEw4NjggNDc4LjVjNC41LTUuMi44LTEzLjItNi0xMy4yeiIgLz48L3N2Zz4=) */ const $59efee6067683315$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($59efee6067683315$var$ArrowDownOutlined);
var $59efee6067683315$export$2e2bcd8739ae039 = $59efee6067683315$var$RefIcon;


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c65a362aa69548ea$var$ArrowUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"
                }
            }
        ]
    },
    "name": "arrow-up",
    "theme": "outlined"
};
var $c65a362aa69548ea$export$2e2bcd8739ae039 = $c65a362aa69548ea$var$ArrowUpOutlined;



function $349537e400c19e0a$var$_extends() {
    $349537e400c19e0a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $349537e400c19e0a$var$_extends.apply(this, arguments);
}
const $349537e400c19e0a$var$ArrowUpOutlined = (props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), $349537e400c19e0a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c65a362aa69548ea$export$2e2bcd8739ae039)
    }));
/**![arrow-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2OCA1NDUuNUw1MzYuMSAxNjNhMzEuOTYgMzEuOTYgMCAwMC00OC4zIDBMMTU2IDU0NS41YTcuOTcgNy45NyAwIDAwNiAxMy4yaDgxYzQuNiAwIDktMiAxMi4xLTUuNUw0NzQgMzAwLjlWODY0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWMzAwLjlsMjE4LjkgMjUyLjNjMyAzLjUgNy40IDUuNSAxMi4xIDUuNWg4MWM2LjggMCAxMC41LTggNi0xMy4yeiIgLz48L3N2Zz4=) */ const $349537e400c19e0a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($349537e400c19e0a$var$ArrowUpOutlined);
var $349537e400c19e0a$export$2e2bcd8739ae039 = $349537e400c19e0a$var$RefIcon;









var $45fvw = parcelRequire("45fvw");

parcelRequire("acw62");








var $45fvw = parcelRequire("45fvw");
const $3a0ae4e2b91fdd6b$var$markAsPaidSupportedOrderTypes = [
    (0, $b9894ce465f84cba$export$168ff345f0815589).classic,
    (0, $b9894ce465f84cba$export$168ff345f0815589).loose
];
const $3a0ae4e2b91fdd6b$var$getPaymentStateColor = (state)=>{
    switch(state){
        case (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).unpaid:
            return (0, $0b4842326956570d$export$ad766f34ace1cafd)[5];
        case (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).overdue:
            return (0, $0b4842326956570d$export$a90204d1394caf30)[4];
        case (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).paid:
            return (0, $0b4842326956570d$export$955a2ebd2fb142ae)[4];
        default:
            return undefined;
    }
};
const $3a0ae4e2b91fdd6b$export$b967deadaa6b69dc = ({ order: order, container: container, payOrder: payOrder })=>{
    const icon = order.doneDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {
        style: {
            color: (0, $99be6b3f30de3bdd$export$e4bbcb8f9590e757)(order)
        }
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2628771293840a7d$export$2e2bcd8739ae039), {
        style: {
            color: (0, $99be6b3f30de3bdd$export$e4bbcb8f9590e757)(order)
        }
    });
    const date = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.date).hours() === 0);
    const title = container ? `${order.address} - nr: ${container.name}` : order.address;
    const price = (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net ? order.netPrice : order.grossPrice);
    const priceType = (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(order.priceType);
    const paymentState = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            color: $3a0ae4e2b91fdd6b$var$getPaymentStateColor(order.paymentState)
        },
        children: (0, $99be6b3f30de3bdd$export$aa2d18194c47b2f4)(order.paymentState)
    });
    const paymentAction = order.paymentState !== (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).paid && $3a0ae4e2b91fdd6b$var$markAsPaidSupportedOrderTypes.includes(order.type) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe4fe7ed96759354$export$4a414f5357d5343), {
        color: (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5],
        onClick: ()=>payOrder(order),
        children: "Oznacz jako zap\u0142acone"
    }) : undefined;
    const detailsAction = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
        to: `/panel/orders/${order.id}/${order.type}`,
        children: "Szczeg\xf3\u0142y"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8165f182d4056084$export$2e2bcd8739ae039).Item, {
        dot: icon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: date
                    }),
                    " - ",
                    title,
                    " \u2022 ",
                    price,
                    " ",
                    priceType,
                    " (",
                    paymentState,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    paymentAction,
                    paymentAction && " \u2022 ",
                    detailsAction
                ]
            })
        ]
    }, `${order.type}#${order.id}`);
};


const $1d9c8d1432599a1b$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	> div.page-section > div {
		margin-bottom: 4px;
		padding: 4px 0;
	}
`;
const $1d9c8d1432599a1b$export$a7f864e9a31ae39c = ({ client: client, orders: orders, addresses: addresses, containers: containers, payOrder: payOrder })=>{
    const [address, setAddress] = (0, $acw62.useState)();
    const [onlyOverdue, setOnlyOverdue] = (0, $acw62.useState)(false);
    const [after, setAfter] = (0, $acw62.useState)(null);
    const [before, setBefore] = (0, $acw62.useState)(null);
    const [sort, setSort] = (0, $acw62.useState)('newest');
    const printRef = (0, $acw62.useRef)();
    const handlePrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: ()=>printRef.current
    });
    const filteredOrders = orders.filter((order)=>{
        if (address && order.address !== address) return false;
        if (onlyOverdue && order.paymentState !== (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).overdue) return false;
        if (after && (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.date).isBefore(after, 'day')) return false;
        if (before && (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.date).isAfter(before, 'day')) return false;
        return true;
    });
    if (sort === 'newest') filteredOrders.sort((a, b)=>new Date(b.date).getTime() - new Date(a.date).getTime());
    else filteredOrders.sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1d9c8d1432599a1b$var$Wrapper, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
            title: "Zam\xf3wienia",
            width: 878,
            select: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                type: "primary",
                size: "large",
                onClick: ()=>handlePrint(),
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a66bc520ace0c83$export$2e2bcd8739ae039), {}),
                children: "Drukuj wykaz"
            }),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Adres:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b1f878ba009a49d$export$2e2bcd8739ae039), {
                                    id: "name",
                                    width: "100%",
                                    allowClear: true,
                                    search: (search, e)=>{
                                        if (!e.name) return false;
                                        const s = search.toLocaleLowerCase();
                                        return e.name.toLocaleLowerCase().includes(s);
                                    },
                                    elements: [
                                        ...addresses,
                                        {
                                            name: undefined,
                                            id: 'all'
                                        }
                                    ],
                                    buildElement: (address)=>address.name ?? 'Wszystkie',
                                    value: address,
                                    onChange: (a)=>setAddress(a === 'all' ? undefined : a)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Data:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    picker: "date",
                                    placeholder: "Data od",
                                    size: "large",
                                    value: after,
                                    onChange: setAfter
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    picker: "date",
                                    placeholder: "Data do",
                                    size: "large",
                                    value: before,
                                    onChange: setBefore
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    size: "large",
                                    onClick: ()=>{
                                        setAfter(null);
                                        setBefore(null);
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex gap-2 items-stretch",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    className: "flex-1",
                                    type: "primary",
                                    size: "large",
                                    onClick: ()=>setSort(sort === 'newest' ? 'oldest' : 'newest'),
                                    icon: sort === 'newest' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59efee6067683315$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $349537e400c19e0a$export$2e2bcd8739ae039), {}),
                                    children: [
                                        "Sortowane od ",
                                        sort === 'newest' ? 'najnowszych' : 'najstarszych'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    className: "flex-1",
                                    type: "primary",
                                    size: "large",
                                    onClick: ()=>setOnlyOverdue((u)=>!u),
                                    icon: !onlyOverdue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cdd5a58cfa55afe$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {}),
                                    children: !onlyOverdue ? "Poka\u017C tylko zaleg\u0142e" : "Poka\u017C wszystkie"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $037cb49b99387dc8$export$2e2bcd8739ae039), {
                    ref: printRef,
                    client: client,
                    orders: filteredOrders.filter((o)=>!!o.doneDate)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8165f182d4056084$export$2e2bcd8739ae039), {
                    children: filteredOrders.map((order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a0ae4e2b91fdd6b$export$b967deadaa6b69dc), {
                            order: order,
                            container: order.containerId ? containers.find((c)=>c.id === order.containerId) : undefined,
                            payOrder: payOrder
                        }, `${order.type}#${order.id}`))
                })
            ]
        })
    });
};





const { Option: $03fdc25a7074e1d7$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const { TextArea: $03fdc25a7074e1d7$var$TextArea } = (0, $ad70426818bb52aa$export$2e2bcd8739ae039);
const $03fdc25a7074e1d7$export$b21872969f5a8af6 = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const params = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const id = Number.parseInt(params['id']);
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)();
    const [deleteModal, setDeleteModal] = (0, $acw62.useState)(false);
    const { client: client, orders: orders, containers: containers, createdBy: createdBy, removedBy: removedBy, lockedBy: lockedBy, addresses: addresses, loading: loading, saveChanges: saveChanges, deleteClient: deleteClient, restoreClient: restoreClient, lockClient: lockClient, unlockClient: unlockClient, payOrder: payOrder } = (0, $aa623856fc7c1813$export$47d4ff5409b1867c)(id);
    const locked = client?.lockedDate !== null;
    const [name, setName] = (0, $acw62.useState)();
    const [phone, setPhone] = (0, $acw62.useState)();
    const [type, setType] = (0, $acw62.useState)();
    const [email, setEmail] = (0, $acw62.useState)();
    const [nip, setNip] = (0, $acw62.useState)();
    const [bdo, setBdo] = (0, $acw62.useState)();
    const [street, setStreet] = (0, $acw62.useState)();
    const [city, setCity] = (0, $acw62.useState)();
    const [postal, setPostal] = (0, $acw62.useState)();
    const [description, setDescription] = (0, $acw62.useState)();
    if (!client || !orders || !createdBy || !addresses || !containers) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true
    });
    const hasAnyChanges = ()=>{
        if (name !== undefined && name.trim() != client.name) return true;
        if (type !== undefined && type != client.type) return true;
        if (phone !== undefined && phone.trim() != client.phone) return true;
        if (email !== undefined && email.trim() != client.email) return true;
        if (nip !== undefined && nip.trim() != client.nip) return true;
        if (bdo !== undefined && bdo.trim() != client.bdo) return true;
        if (street !== undefined && street.trim() != client.street) return true;
        if (city !== undefined && city.trim() != client.city) return true;
        if (postal !== undefined && postal.trim() != client.postal) return true;
        if (description !== undefined && description.trim() != client.description) return true;
        return false;
    };
    const _saveChanges = async ()=>{
        const dto = {};
        if (name !== undefined) {
            const n = name.trim();
            if (n === '') return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Podaj nazw\u0119");
            if (n.length > 64) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Nazwa jest za d\u0142uga");
            if (n !== client.name) dto.name = n;
        }
        if (type !== undefined && type !== client.type) dto.type = type;
        if (phone !== undefined) {
            const p = phone.trim();
            if (p === '') return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Podaj numer telefon');
            if (!p.match(/^(\+[0-9]{2} ?)?([0-9] ?){9}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Numer telefonu jest niepoprawny');
            if (p.length > 16) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Numer telefonu jest za d\u0142ugi");
            if (p !== client.phone) dto.phone = p;
        }
        if (email !== undefined) {
            const e = email.trim();
            if (e === '') dto.email = null;
            else if (!e.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Email jest niepoprawny');
            else if (e.length > 64) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Email jest za d\u0142ugi");
            else if (e !== client.email) dto.email = e;
        }
        if (nip !== undefined) {
            const n = nip.trim();
            if (n === '') dto.nip = null;
            else if (!n.match(/^[0-9]{10}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('NIP jest niepoprawny');
            else if (n.length > 10) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("NIP jest za d\u0142ugi");
            else if (n !== client.nip) dto.nip = n;
        }
        if (bdo !== undefined) {
            const b = bdo.trim();
            if (b === '') dto.bdo = null;
            else if (!b.match(/^[0-9]{8}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('BDO jest niepoprawny');
            else if (b.length > 14) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("BDO jest za d\u0142ugi");
            else if (b !== client.bdo) dto.bdo = b;
        }
        if (street !== undefined) {
            const s = street.trim();
            if (s === '') dto.street = null;
            else if (s.length > 64) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Ulica jest za d\u0142uga");
            else if (s !== client.street) dto.street = s;
        }
        if (city !== undefined) {
            const c = city.trim();
            if (c === '') dto.city = null;
            else if (c.length > 64) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Miasto jest za d\u0142ugie");
            else if (c !== client.city) dto.city = c;
        }
        if (postal !== undefined) {
            const p = postal.trim();
            if (p === '') dto.postal = null;
            else if (!p.match(/^[0-9]{2}-[0-9]{3}$/)) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error('Kod pocztowy jest niepoprawny');
            else if (p.length > 16) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Kod pocztowy jest za d\u0142ugi");
            else if (p !== client.postal) dto.postal = p;
        }
        if (description !== undefined) {
            const d = description.trim();
            if (d === '') dto.description = null;
            else if (d.length > 256) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Opis jest za d\u0142ugi");
            else if (d !== client.description) dto.description = d;
        }
        if (Object.keys(dto).length === 0) return (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Nie wprowadzono \u017Cadnych zmian");
        const success = await saveChanges(dto);
        if (!success) return;
    };
    const actions = client.removedDate ? [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaf43360a8ccea7a$export$2e2bcd8739ae039), {}),
            loading: loading,
            onClick: restoreClient,
            children: "Przywr\xf3\u0107 klienta"
        }, 0)
    ] : [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {}),
            onClick: _saveChanges,
            disabled: !hasAnyChanges(),
            children: "Zapisz zmiany"
        }, 1),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            danger: true,
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
            onClick: ()=>setDeleteModal(true),
            children: "Usu\u0144 klienta"
        }, 2),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "large",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: ()=>locked ? (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Nie mo\u017Cna doda\u0107 zam\xf3wienia, klient jest zablokowany.") : navigate(`/panel/new-order?client=${client?.id}`),
            children: "Dodaj zam\xf3wienie na klienta"
        }, 3)
    ];
    if (userLevel === (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).superAdmin) actions.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
        danger: !locked,
        icon: locked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31596fffcf1abc57$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90bdf3d9d7ea52d2$export$2e2bcd8739ae039), {}),
        onClick: locked ? unlockClient : lockClient,
        children: locked ? 'Odblokuj' : 'Zablokuj'
    }, locked ? 4 : 5));
    const totalOrdersSum = orders.reduce((acc, order)=>acc + order.grossPrice, 0);
    const totalUnpaidSum = orders.reduce((sum, order)=>{
        if (order.paymentState !== (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).unpaid) return sum;
        const leftToPay = order.grossPrice - order.alreadyPaid;
        return sum + Math.max(leftToPay, 0);
    }, 0);
    const totalOverdueSum = orders.reduce((sum, order)=>{
        if (order.paymentState !== (0, $99be6b3f30de3bdd$export$22b9ccd16748bd76).overdue) return sum;
        const leftToPay = order.grossPrice - order.alreadyPaid;
        return sum + Math.max(leftToPay, 0);
    }, 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: `Klienci / ${client?.name}`,
        actions: actions,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "client-details",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Informacje",
                            width: 902,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    className: "inputs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Nazwa"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: name ?? client.name,
                                                    onChange: (e)=>setName(e.target.value),
                                                    disabled: !!client.removedDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Typ"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    value: type ?? client.type,
                                                    onChange: (value)=>setType(value),
                                                    disabled: !!client.removedDate,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03fdc25a7074e1d7$var$Option, {
                                                            value: (0, $be5cd62013d5cc71$export$4cd8cc03ec8c034a).company,
                                                            children: "Firma"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03fdc25a7074e1d7$var$Option, {
                                                            value: (0, $be5cd62013d5cc71$export$4cd8cc03ec8c034a).private,
                                                            children: "Osoba prywatna"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    className: "inputs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Numer telefonu"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                            type: "text",
                                                            size: "large",
                                                            value: phone ?? client.phone,
                                                            onChange: (e)=>setPhone(e.target.value),
                                                            disabled: !!client.removedDate
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            href: (0, $30eeeb9bc1cd6f03$export$8045d8ca670cb8a4)(phone ?? client.phone),
                                                            title: "Zadzwo\u0144",
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: 22,
                                                                lineHeight: 1
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1a35a530b2e1d2f$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: email ?? client.email ?? '',
                                                    onChange: (e)=>setEmail(e.target.value),
                                                    disabled: !!client.removedDate
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    className: "inputs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Numer NIP"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: nip ?? client.nip ?? '',
                                                    onChange: (e)=>setNip(e.target.value),
                                                    disabled: !!client.removedDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Numer BDO"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: bdo ?? client.bdo ?? '',
                                                    onChange: (e)=>setBdo(e.target.value),
                                                    disabled: !!client.removedDate
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    className: "inputs",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: "Ulica"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                type: "text",
                                                size: "large",
                                                value: street ?? client.street ?? '',
                                                onChange: (e)=>setStreet(e.target.value),
                                                disabled: !!client.removedDate
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    className: "inputs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Miasto"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: city ?? client.city ?? '',
                                                    onChange: (e)=>setCity(e.target.value),
                                                    disabled: !!client.removedDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Kod pocztowy"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                    type: "text",
                                                    size: "large",
                                                    value: postal ?? client.postal ?? '',
                                                    onChange: (e)=>setPostal(e.target.value),
                                                    disabled: !!client.removedDate
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    children: "Opis"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03fdc25a7074e1d7$var$TextArea, {
                                    rows: 3,
                                    value: description ?? client.description ?? '',
                                    onChange: (e)=>setDescription(e.target.value),
                                    disabled: !!client.removedDate
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    direction: "vertical",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                "Utworzony: ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(client.createdDate)
                                                                }),
                                                                ' '
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                "Przez:",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `/panel/drivers/${createdBy.id}`,
                                                                        children: [
                                                                            createdBy.name,
                                                                            " ",
                                                                            createdBy.surname
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        locked && lockedBy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                "Zablokowany: ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(client.lockedDate)
                                                                }),
                                                                ' '
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                "Przez:",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `/panel/drivers/${lockedBy.id}`,
                                                                        children: [
                                                                            lockedBy.name,
                                                                            " ",
                                                                            lockedBy.surname
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        removedBy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                "Usuni\u0119ty: ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(client.removedDate)
                                                                }),
                                                                ' '
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            children: [
                                                                "Przez:",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `/panel/drivers/${removedBy.id}`,
                                                                        children: [
                                                                            removedBy.name,
                                                                            " ",
                                                                            removedBy.surname
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                    size: 25,
                                    className: "balance",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Nieop\u0142acone (minus zaliczki)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        color: (0, $0b4842326956570d$export$ad766f34ace1cafd)[5]
                                                    },
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalUnpaidSum)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Zaleg\u0142e (minus zaliczki)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        color: (0, $0b4842326956570d$export$a90204d1394caf30)[5]
                                                    },
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalOverdueSum)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-dir",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "\u0141\u0105czna kwota zam\xf3wie\u0144 brutto"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalOrdersSum)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d9c8d1432599a1b$export$a7f864e9a31ae39c), {
                            client: client,
                            orders: orders,
                            addresses: addresses,
                            containers: containers,
                            payOrder: payOrder
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6fd0b816bbe13d58$export$2e2bcd8739ae039), {
                visible: deleteModal,
                onCancel: ()=>setDeleteModal(false),
                onOk: ()=>deleteClient(()=>setDeleteModal(false)),
                loading: loading,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Czy na pewno chcesz usun\u0105\u0107 klienta?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: "B\u0119dzie go mo\u017Cna p\xf3\u017Aniej przywr\xf3ci\u0107"
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");



var $2e14eba014524411$export$5aa37ca9d2d05a4e = /*#__PURE__*/ function(DriverCardEventType) {
    DriverCardEventType[DriverCardEventType["classicOrder"] = 0] = "classicOrder";
    DriverCardEventType[DriverCardEventType["looseOrder"] = 1] = "looseOrder";
    DriverCardEventType[DriverCardEventType["expense"] = 2] = "expense";
    DriverCardEventType[DriverCardEventType["settlement"] = 3] = "settlement";
    return DriverCardEventType;
}({});
const $2e14eba014524411$export$38a7c68d5582815f = (driverId, daysOffset)=>{
    const [driver] = (0, $ac789bea2a0ba498$export$23bbbc4533528f03)(driverId);
    const [events, setEvents] = (0, $acw62.useState)();
    const [summary, setSummary] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        fetchEvents(driverId, daysOffset);
    }, [
        driverId,
        daysOffset
    ]);
    const getPayments = (after, before, events)=>{
        const classicPayments = events.filter((e)=>e.type === 0).reduce((acc, e)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.task.order.paymentDate).isBetween(after, before)) return acc;
            if (!e.task.order.paymentDate) return acc;
            if (e.task.order.paymentBy !== driverId) return acc;
            if (e.task.order.paymentType !== (0, $83530e2bf16dcece$export$439d2d6c03747598).cash) return acc;
            return acc + e.task.order.grossPrice;
        }, 0);
        const loosePayments = events.filter((e)=>e.type === 1).reduce((acc, e)=>{
            const payments = e.task.order.payments.filter((p)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(p.date).isBetween(after, before) && p.type === (0, $83530e2bf16dcece$export$439d2d6c03747598).cash && p.createdBy === driverId);
            return acc + payments.reduce((acc, p)=>acc + p.amount, 0);
        }, 0);
        return classicPayments + loosePayments;
    };
    const getAdvances = (events)=>events.filter((e)=>e.type === 0).reduce((acc, e)=>acc + (e.task.order.advance ?? 0), 0);
    const getSpent = (events)=>events.filter((e)=>e.type === 2).reduce((acc, e)=>acc + e.expense.value, 0);
    const getSettlements = (events)=>events.filter((e)=>e.type === 3).reduce((acc, e)=>acc + e.settlement.value, 0);
    const fetchEvents = async (driverId, daysOffset)=>{
        try {
            const after = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(daysOffset, 'days').startOf('day');
            const before = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().add(daysOffset, 'days').endOf('day');
            const [tasks, expenses, settlements] = await Promise.all([
                (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.getAll({
                    after: after,
                    before: before,
                    assignee: driverId
                }),
                (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.getAll({
                    user_id: driverId,
                    after: after.unix() * 1000,
                    before: before.unix() * 1000,
                    company: undefined
                }),
                (0, $4c992464a65faeac$export$2e2bcd8739ae039).expenses.settlements.getAll({
                    user_id: driverId,
                    after: after.unix() * 1000,
                    before: before.unix() * 1000
                })
            ]);
            const events = [];
            for (const task of tasks){
                if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic) events.push({
                    type: 0,
                    key: `classic-${task.type}-${task.id}`,
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.doneAt),
                    task: task
                });
                if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).loose) events.push({
                    type: 1,
                    key: `loose-${task.type}-${task.id}`,
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.doneAt),
                    task: task
                });
            }
            for (const expense of expenses)events.push({
                type: 2,
                key: `expense-${expense.id}`,
                date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(expense.created),
                expense: expense
            });
            for (const settlement of settlements)events.push({
                type: 3,
                key: `settlement-${settlement.id}`,
                date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(settlement.created),
                settlement: settlement
            });
            events.sort((a, b)=>a.date.unix() - b.date.unix());
            setEvents(events);
            setSummary({
                payments: getPayments(after, before, events),
                advances: getAdvances(events),
                spent: getSpent(events),
                settlements: getSettlements(events)
            });
        } catch (err) {
            console.error(err);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${err})`);
        }
    };
    return {
        driver: driver,
        events: events,
        summary: summary
    };
};









var $45fvw = parcelRequire("45fvw");
parcelRequire("acw62");





const $a999300013af2e62$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	display: flex;
	width: 100%;
	padding: 12px;
	border-radius: 6px;
	background: ${({ color: color })=>color};
	color: white;
	margin-bottom: 4px;

	> div {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	h4 {
		font-size: 18px;
		margin: 0;
		margin-bottom: 4px;
		color: white;
	}

	h5 {
		font-size: 18px;
		font-weight: 400;
		margin: 0;
		color: white;
	}

	:hover {
		cursor: pointer;
	}
`;
const $a999300013af2e62$var$getColor = (task)=>{
    if (task.orderType === (0, $b9894ce465f84cba$export$168ff345f0815589).classic && task.order.onPlace) return (0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5];
    if (task.type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery) return (0, $0b4842326956570d$export$955a2ebd2fb142ae)[5];
    if (task.type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).claiming) return (0, $0b4842326956570d$export$a90204d1394caf30)[5];
    if (task.type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).replacement) return (0, $0b4842326956570d$export$c24201f7fe3571d8)[5];
    return (0, $0b4842326956570d$export$e4c89085febbc618)[5];
};
const $a999300013af2e62$export$c332e958aea7dbe7 = ({ event: event })=>{
    if (event.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).classicOrder) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a999300013af2e62$var$ClassicOrderEventTile, {
        task: event.task
    });
    if (event.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).looseOrder) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a999300013af2e62$var$LooseOrderEventTile, {
        task: event.task
    });
    if (event.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).expense) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a999300013af2e62$var$ExpenseEventTile, {
        expense: event.expense
    });
    if (event.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).settlement) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a999300013af2e62$var$SettlementEventTile, {
        settlement: event.settlement
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
};
const $a999300013af2e62$var$ClassicOrderEventTile = ({ task: task })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const price = task.order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? task.order.grossPrice : task.order.netPrice;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a999300013af2e62$var$Wrapper, {
        color: $a999300013af2e62$var$getColor(task),
        onClick: ()=>navigate(`/panel/orders/${task.orderId}`),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                        children: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.takenAt).format('HH:mm'),
                            " - ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.doneAt).format('HH:mm')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        children: task.order.address
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "P\u0142atno\u015B\u0107:",
                            ' ',
                            task.order.paymentType === (0, $83530e2bf16dcece$export$439d2d6c03747598).cash ? `Got\xf3wka - ${task.order.paymentDate === task.doneAt ? 'pobrana' : 'niepobrana'}` : 'Przelew'
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Kwota: ",
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(price),
                            " ",
                            (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(task.order.priceType)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Zaliczka: ",
                            task.order.advance ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(task.order.advance) : 'Brak'
                        ]
                    })
                ]
            })
        ]
    });
};
const $a999300013af2e62$var$LooseOrderEventTile = ({ task: task })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const price = task.order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? task.order.grossPrice : task.order.netPrice;
    const payment = task.order.payments.find((p)=>p.date === task.doneAt);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a999300013af2e62$var$Wrapper, {
        color: $a999300013af2e62$var$getColor(task),
        onClick: ()=>navigate(`/panel/orders/${task.orderId}/loose`),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                        children: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.takenAt).format('HH:mm'),
                            " - ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.doneAt).format('HH:mm'),
                            " |",
                            ' ',
                            (0, $5635f57e16062a6d$export$89a944183c3f9be6)(task.order.subtype)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        children: task.order.address
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "P\u0142atno\u015B\u0107:",
                            ' ',
                            task.order.wantedPaymentType === (0, $83530e2bf16dcece$export$439d2d6c03747598).cash ? `Got\xf3wka - ${payment ? 'pobrana' : 'niepobrana'}` : 'Przelew'
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Kwota: ",
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(price),
                            " ",
                            (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(task.order.priceType)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Ilo\u015B\u0107: ",
                            task.order.count
                        ]
                    })
                ]
            })
        ]
    });
};
const $a999300013af2e62$var$ExpenseEventTile = ({ expense: expense })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a999300013af2e62$var$Wrapper, {
        color: (0, $0b4842326956570d$export$2aa0182783e7e9de)[5],
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(expense.created).format('HH:mm')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                        children: [
                            expense.type.name,
                            " - ",
                            expense.name
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Kwota: ",
                            (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(expense.value),
                            " ",
                            expense.value_type ? 'Brutto' : 'Netto'
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Podatek: ",
                            expense.tax,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Przebieg: ",
                            expense.mileage ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).insertSpaces(expense.mileage) : '-'
                        ]
                    })
                ]
            })
        ]
    });
};
const $a999300013af2e62$var$SettlementEventTile = ({ settlement: settlement })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a999300013af2e62$var$Wrapper, {
        color: (0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5],
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(settlement.created).format('HH:mm')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(settlement.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Odebra\u0142: ",
                        settlement.created_by.name,
                        " ",
                        settlement.created_by.surname
                    ]
                })
            })
        ]
    });
};



const $b653e08b496217a8$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	display: flex;
	flex-direction: column;
	width: 100%;

	> div {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 24px;

		> h3 {
			margin: 16px 0 8px 0;
			font-size: 20px;
			text-align: center;
		}
	}
`;
const $b653e08b496217a8$var$OrderEvent = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	display: flex;
	width: 100%;
	padding: 12px;
	border-radius: 6px;
	background: ${({ color: color })=>color};
	color: white;
	margin-bottom: 4px;

	> div {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	h4 {
		font-size: 18px;
		margin: 0;
		margin-bottom: 4px;
		color: white;
	}

	h5 {
		font-size: 18px;
		font-weight: 400;
		margin: 0;
		color: white;
	}

	:hover {
		cursor: pointer;
	}
`;
const $b653e08b496217a8$export$9baaf3d09362d11a = ()=>{
    const { id: idRaw } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)({
        offset: '0'
    });
    const id = parseInt(idRaw || '0', 10);
    const offset = parseInt(searchParams.get('offset') || '0', 10);
    const { driver: driver, events: events, summary: summary } = (0, $2e14eba014524411$export$38a7c68d5582815f)(id, offset);
    // const printRef = useRef<CardPrint>();
    // const handlePrint = useReactToPrint({
    // 	content: () => printRef.current,
    // });
    if (!driver || !events || !summary) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
            title: `Pracownicy / ${driver.name} ${driver.surname}`,
            actions: [],
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a724bbfbe7fdfe75$export$2e2bcd8739ae039), {
                offset: offset,
                onChange: (f)=>setSearchParams({
                        offset: f(offset)
                    }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b653e08b496217a8$var$Wrapper, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Podstawienia"
                                }),
                                events.filter((e)=>(e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).classicOrder || e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).looseOrder) && e.task.type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).delivery).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a999300013af2e62$export$c332e958aea7dbe7), {
                                        event: e
                                    }, e.key))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Odbiory"
                                }),
                                events.filter((e)=>(e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).classicOrder || e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).looseOrder) && e.task.type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).claiming).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a999300013af2e62$export$c332e958aea7dbe7), {
                                        event: e
                                    }, e.key))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Wymiany"
                                }),
                                events.filter((e)=>(e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).classicOrder || e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).looseOrder) && e.task.type === (0, $749850eb3cb705e4$export$1f8b1cab05cab788).replacement).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a999300013af2e62$export$c332e958aea7dbe7), {
                                        event: e
                                    }, e.key))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Wydatki"
                                }),
                                events.filter((e)=>e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).expense).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a999300013af2e62$export$c332e958aea7dbe7), {
                                        event: e
                                    }, e.key))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Wydania got\xf3wki"
                                }),
                                events.filter((e)=>e.type === (0, $2e14eba014524411$export$5aa37ca9d2d05a4e).settlement).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a999300013af2e62$export$c332e958aea7dbe7), {
                                        event: e
                                    }, e.key))
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Podsumowanie"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b653e08b496217a8$var$OrderEvent, {
                                    color: (0, $0b4842326956570d$export$e4c89085febbc618)[5],
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                    children: [
                                                        "Pobrane od klient\xf3w: ",
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(summary.advances + summary.payments)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                    children: [
                                                        "Wydane: ",
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(summary.spent + summary.settlements)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        "Zaliczki: ",
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(summary.advances)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        "Zap\u0142aty: ",
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(summary.payments)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        "Wydatki: ",
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(summary.spent)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        "Pobrania got\xf3wki: ",
                                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(summary.settlements)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                children: [
                                    "Balans: ",
                                    (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(summary.advances + summary.payments - summary.spent - summary.settlements)
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");


const $e74939174e540b7b$export$67059e4435375282 = ()=>{
    const clients = (0, $1455449f1630f2df$export$4823a6cc022cca16)({});
    const [orders, setOrders] = (0, $acw62.useState)();
    const [priceChanges, setPriceChanges] = (0, $acw62.useState)();
    const users = (0, $0df0903efbca6a2f$export$90f4370c54dd43c9)({});
    const [from, setFrom] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('month'));
    const [to, setTo] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('month'));
    const [clientId, setClientId] = (0, $acw62.useState)();
    const [paid, setPaid] = (0, $acw62.useState)();
    const [paymentType, setPaymentType] = (0, $acw62.useState)();
    const fetchData = async ()=>{
        try {
            const data = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders2.finances.get({
                after: from.hours(0).minutes(0).seconds(0),
                before: to.hours(23).minutes(59).seconds(59),
                client_id: clientId,
                paid: paid,
                payment_type: paymentType
            });
            setOrders(data);
            const changes = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders2.priceChanges({
                after: from.hours(0).minutes(0).seconds(0),
                before: to.hours(23).minutes(59).seconds(59)
            });
            setPriceChanges(changes);
        } catch (e) {
            console.trace(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`${e}`);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        from.unix(),
        to.unix(),
        clientId,
        paid,
        paymentType
    ]);
    const clearFilters = ()=>{
        setFrom((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('month'));
        setTo((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('month'));
        setClientId(undefined);
        setPaid(undefined);
        setPaymentType(undefined);
        fetchData();
    };
    return {
        clients: clients,
        orders: orders,
        from: from,
        to: to,
        clientId: clientId,
        paid: paid,
        paymentType: paymentType,
        priceChanges: priceChanges,
        users: users,
        fromChanged: setFrom,
        toChanged: setTo,
        clientIdChanged: setClientId,
        paidChanged: setPaid,
        paymentTypeChanged: setPaymentType,
        clearFilters: clearFilters
    };
};







const $749c11fc47e29de8$var$OrdersTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	flex: 1;
	height: 1px;

	> .ant-table-wrapper {
		height: 100%;

		.ant-table-row {
			&.red {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$a90204d1394caf30)[5]};
				}
			}

			&.yellow {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$c24201f7fe3571d8)[5]};
				}
			}

			&.green {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$955a2ebd2fb142ae)[5]};
				}
			}

			&.purple {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5]};
				}
			}

			&.grey {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$e4c89085febbc618)[5]};
				}
			}
		}
	}
`;
const $749c11fc47e29de8$export$700030ccc27c2c7 = ()=>{
    const { clients: clients, orders: orders, priceChanges: priceChanges, users: users, from: from, to: to, clientId: clientId, paid: paid, paymentType: paymentType, fromChanged: fromChanged, toChanged: toChanged, clientIdChanged: clientIdChanged, paidChanged: paidChanged, paymentTypeChanged: paymentTypeChanged, clearFilters: clearFilters } = (0, $e74939174e540b7b$export$67059e4435375282)();
    const columns = [
        {
            title: 'Klient',
            key: 'name',
            render: (_, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/clients/${row.client.id}`,
                    children: row.client.name
                })
        },
        {
            title: 'Cena',
            key: 'price',
            render: (_, row)=>{
                const price = row.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).gross ? row.grossPrice : row.netPrice;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(price),
                        " (",
                        (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(row.priceType),
                        ")"
                    ]
                });
            }
        },
        {
            title: 'Faktura',
            key: 'invoice',
            render: (_, row)=>row.invoice ?? '-'
        },
        {
            title: "Typ p\u0142atno\u015Bci",
            key: 'payment_type',
            render: (_, row)=>(0, $83530e2bf16dcece$export$a90a64e69a78f544)(row.wantedPaymentType)
        },
        {
            title: 'Podstawienia',
            key: 'delivered',
            render: (_, row)=>(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(row.deliveryDate, true)
        },
        {
            title: 'Odebrane',
            key: 'claimed',
            render: (_, row)=>row.claimingDate ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(row.claimingDate, true) : '-'
        },
        {
            title: 'Akcje',
            key: 'actions',
            render: (_, row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${row.id}/${row.type}`,
                    children: "Szczeg\xf3\u0142y"
                })
        }
    ];
    const getRowClassName = (row)=>{
        if (row.invoice) return 'grey';
        if (row.paid >= row.grossPrice) return 'green';
        return 'red';
    };
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            size: "large",
            type: "primary",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a66bc520ace0c83$export$2e2bcd8739ae039), {}),
            onClick: ()=>print(),
            children: "Drukuj"
        }, "2")
    ];
    const printRef = (0, $acw62.useRef)(null);
    const handlePrint = (0, $06d61c41acc2a072$exports.useReactToPrint)({
        content: ()=>printRef.current
    });
    const print = ()=>{
        handlePrint();
    };
    if (!clients) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Finanse",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
            active: true
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Finanse",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "orders flex flex-dir",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inputs flex flex-dir",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b1f878ba009a49d$export$2e2bcd8739ae039), {
                            allowClear: true,
                            placeholder: "Klient",
                            id: "id",
                            elements: clients,
                            value: clientId,
                            onChange: clientIdChanged,
                            buildElement: (client)=>client.name,
                            search: (search, client)=>client.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    size: "large",
                                    value: from,
                                    onChange: (value)=>{
                                        if (!value) return;
                                        fromChanged(value);
                                    },
                                    allowClear: false
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    size: "large",
                                    value: to,
                                    onChange: (value)=>{
                                        if (!value) return;
                                        toChanged(value);
                                    },
                                    allowClear: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    size: "large",
                                    placeholder: "Status",
                                    value: paid,
                                    onChange: paidChanged,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                            value: 1,
                                            children: "Zap\u0142acone"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                            value: 0,
                                            children: "Niezap\u0142acone"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    size: "large",
                                    placeholder: "Typ p\u0142atno\u015Bci",
                                    value: paymentType,
                                    onChange: paymentTypeChanged,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                            value: (0, $83530e2bf16dcece$export$439d2d6c03747598).transfer,
                                            children: "Przelew"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                            value: (0, $83530e2bf16dcece$export$439d2d6c03747598).cash,
                                            children: "Got\xf3wka"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                            onClick: clearFilters,
                            children: "Wyczy\u015B\u0107"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($749c11fc47e29de8$var$OrdersTable, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                        columns: columns,
                        rowKey: (row)=>`${row.id.toString()}-${row.type}`,
                        rowClassName: getRowClassName,
                        dataSource: orders,
                        pagination: false,
                        loading: !orders,
                        scroll: {
                            x: 'max-content'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c556ec38436a7840$export$2e2bcd8739ae039), {
                    ref: printRef,
                    orders: orders,
                    priceChanges: priceChanges,
                    users: users,
                    from: from,
                    to: to
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");










var $45fvw = parcelRequire("45fvw");


const $0e6ea75b1afac899$var$OrdersTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	flex: 1;
	height: 1px;

	> .ant-table-wrapper {
		height: 100%;

		.ant-table-row {
			&.red {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$a90204d1394caf30)[5]};
				}
			}

			&.yellow {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$c24201f7fe3571d8)[5]};
				}
			}

			&.green {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$955a2ebd2fb142ae)[5]};
				}
			}

			&.purple {
				> td:first-child {
					border-left: 8px solid ${(0, $0b4842326956570d$export$e13cce2a2d16a9d4)[5]};
				}
			}
		}
	}
`;
const $0e6ea75b1afac899$export$ed0df17bf864fd7b = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [search, setSearch] = (0, $acw62.useState)();
    const [clientId, setClientId] = (0, $acw62.useState)();
    const [after, setAfter] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('month'));
    const [before, setBefore] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf('month'));
    const [done, setDone] = (0, $acw62.useState)(false);
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)();
    const [orders] = (0, $a2b9c4ff64663a18$export$8d857bf7f8fdc1d8)({
        after: after,
        before: before,
        clientId: clientId,
        search: search,
        done: done ? undefined : false
    });
    const columns = [
        {
            title: 'Klient',
            dataIndex: 'client',
            key: 'name',
            render: (_, order)=>{
                const isAdmin = (userLevel ?? 0) >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).admin;
                if (!isAdmin) return order.client.name;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/clients/${order.client.id}`,
                    children: order.client.name
                });
            }
        },
        {
            title: 'Telefon',
            dataIndex: 'client',
            key: 'phone',
            render: (_, order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                    phone: order.client.phone
                })
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address',
            render: (_, order)=>order.address
        },
        {
            title: 'Podstawienie',
            dataIndex: 'deliveryDate',
            key: 'date',
            render: (_, order)=>{
                if (!order.deliveryDate) return '-';
                return (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.deliveryDate, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.deliveryDate).hours() === 0);
            }
        },
        {
            title: "Odbi\xf3r",
            dataIndex: 'claimingDate',
            key: 'claiming',
            render: (_, order)=>{
                if (!order.claimingDate) return '-';
                return (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(order.claimingDate, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.claimingDate).hours() === 0);
            }
        },
        {
            title: "Typ odpad\xf3w",
            dataIndex: 'wasteType',
            key: 'wasteType',
            render: (_, order)=>order.wasteType
        },
        {
            title: 'Akcje',
            dataIndex: 'actions',
            key: 'actions',
            render: (_, order)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/panel/orders/${order.id}/${order.type}`,
                    children: "Szczeg\xf3\u0142y"
                })
        }
    ];
    const getRowClassName = (order)=>{
        switch(order.state){
            case (0, $5372e6ed6731fb34$export$819724757aafc79).inProgress:
                return '';
            case (0, $5372e6ed6731fb34$export$819724757aafc79).done:
                return 'red';
            case (0, $5372e6ed6731fb34$export$819724757aafc79).paid:
                return 'yellow';
            case (0, $5372e6ed6731fb34$export$819724757aafc79).invoiced:
                return 'green';
        }
    };
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            size: "large",
            type: "primary",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70557e7c8fc4335b$export$2e2bcd8739ae039), {}),
            onClick: ()=>navigate('/panel/new-order'),
            children: "Dodaj zam\xf3wienie"
        }, "0"),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            size: "large",
            type: "primary",
            icon: done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), {}),
            onClick: ()=>setDone((d)=>!d),
            children: [
                done ? 'Ukryj' : "Poka\u017C",
                " zamkni\u0119te zam\xf3wienia"
            ]
        }, "1")
    ];
    const onSearchChange = (search)=>{
        const s = search.trim();
        if (s === '') setSearch(undefined);
        else setSearch(s);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Zam\xf3wienia",
        actions: actions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "orders flex flex-dir",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inputs flex flex-dir",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "text",
                            placeholder: "Wyszukaj",
                            suffix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7392a88184334dd$export$2e2bcd8739ae039), {}),
                            value: search,
                            onChange: (e)=>onSearchChange(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            size: 25,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    size: "large",
                                    value: after ?? null,
                                    onChange: (m)=>m && setAfter(m),
                                    allowClear: false
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870653b3a8a06c8b$export$2e2bcd8739ae039), {
                                    size: "large",
                                    value: before ?? null,
                                    onChange: (m)=>m && setBefore(m),
                                    allowClear: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f99ae66c06c40ef9$export$2e2bcd8739ae039), {}),
                            onClick: ()=>setClientId(undefined),
                            children: "Wyczy\u015B\u0107"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0e6ea75b1afac899$var$OrdersTable, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                        columns: columns,
                        rowClassName: getRowClassName,
                        dataSource: orders ?? [],
                        loading: !orders,
                        pagination: false,
                        scroll: {
                            x: 'max-content'
                        },
                        rowKey: (record)=>`${record.type}-${record.id}`
                    })
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");






var $45fvw = parcelRequire("45fvw");





var $45fvw = parcelRequire("45fvw");
const $044b8eba0b2bc372$export$d23e95bfe35b311c = (id)=>{
    const [task, refreshTask] = (0, $0110ece14d6be25d$export$cb218309e6e395bf)(id);
    const [order, refreshOrder] = (0, $612618a84cedafbf$export$37d0bd824120f782)(task?.orderId);
    const [client] = (0, $73567ed6b001db2f$export$95f99d327bc8fbbd)(order?.clientId);
    const [assignedUser] = (0, $ac789bea2a0ba498$export$23bbbc4533528f03)(task?.assignedTo ?? undefined);
    const drivers = (0, $0df0903efbca6a2f$export$90f4370c54dd43c9)({});
    const userId = (0, $1012416fae3565dd$export$a5c2098c02d2840a)();
    const assign = async (assignee)=>{
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.patch(id, {
                assignedTo: assignee
            });
            await refreshTask();
            await refreshOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Przypisano wykonawc\u0119");
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} przypisa\u{107} wykonawcy (${e})`);
        }
    };
    const take = async ()=>{
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.patch(id, {
                assignedTo: userId,
                takenAt: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))()
            });
            await refreshTask();
            await refreshOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zg\u0142oszono do realizacji");
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} zg\u{142}osi\u{107} do realizacji (${e})`);
        }
    };
    const resign = async ()=>{
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.patch(id, {
                assignedTo: null
            });
            await refreshTask();
            await refreshOrder();
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success('Wycofano z realizacji');
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} wycofa\u{107} z realizacji (${e})`);
        }
    };
    return {
        task: task,
        order: order,
        client: client,
        assignedUser: assignedUser,
        drivers: drivers,
        assign: assign,
        take: take,
        resign: resign
    };
};


const $513bca1133cbe0d2$export$88edfce46f7be44e = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { id: idRaw } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const id = idRaw ? parseInt(idRaw, 10) : undefined;
    const [assignee, setAssignee] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const { task: task, order: order, client: client, assignedUser: assignedUser, drivers: drivers, assign: assign, take: take, resign: resign } = (0, $044b8eba0b2bc372$export$d23e95bfe35b311c)(id);
    const userLevel = (0, $a015f0677c32bcd8$export$31ec1cd5c4003f04)() ?? (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).driver;
    const userId = (0, $1012416fae3565dd$export$a5c2098c02d2840a)();
    const getActions = ()=>{
        if (!task || task.doneAt) return [];
        if (!task.takenAt) return [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                onClick: ()=>take(),
                children: "Zg\u0142o\u015B si\u0119 do realizacji"
            }, "0")
        ];
        if (task.assignedTo === userId) return [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                type: "primary",
                size: "large",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                onClick: ()=>navigate(`/panel/v2/tasks/${task.id}/close`),
                children: "Zrealizuj zadanie"
            }, "0"),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                danger: true,
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaf43360a8ccea7a$export$2e2bcd8739ae039), {}),
                onClick: ()=>resign(),
                children: "Wycofaj z realizacji"
            }, "1")
        ];
        return [];
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Terminarz / Szczeg\xf3\u0142y zadania",
        actions: getActions(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
                active: true,
                loading: !task || !order || !client
            }),
            task && order && client && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "taskDetails flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-dir flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Zam\xf3wienie",
                            width: 854,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Adres"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.address
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Rodzaj odpad\xf3w"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: order.wasteType
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                children: [
                                                                    "Cena (",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "price-type",
                                                                        children: (0, $5635f57e16062a6d$export$50833b9f5b13ee6f)(order.priceType)
                                                                    }),
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.priceType === (0, $5635f57e16062a6d$export$9f1cd706473c7ca4).net ? order.netPrice : order.grossPrice)
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Rodzaj p\u0142atno\u015Bci"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "user-data",
                                                                    children: (0, $83530e2bf16dcece$export$a90a64e69a78f544)(order.wantedPaymentType)
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Termin"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "date",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "user-data",
                                                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(task.date, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(task.date).hours() === 0)
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "button",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            type: "primary",
                                                            size: "large",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                                            onClick: ()=>navigate(`/panel/orders/${task.orderId}/${task.orderType}`),
                                                            children: "Szczeg\xf3\u0142y zam\xf3wienia"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                task.takenAt && assignedUser && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "table",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: "Zg\u0142oszone do realizacji:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "creation-data",
                                                                children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(task.takenAt)
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: "Zrealizowane:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "creation-data",
                                                                children: task.doneAt ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(task.doneAt) : '-'
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: "Przez:"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).admin ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                to: `/panel/drivers/${assignedUser.id}`,
                                                                children: [
                                                                    assignedUser.name,
                                                                    " ",
                                                                    assignedUser.surname
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: assignedUser.name
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Klient",
                            width: 876,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Klient"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: client.name
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "BDO"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: (0, $5635f57e16062a6d$export$b6098f7faad3052e)(order.bdo)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Typ"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: client.type === 0 ? 'Firma' : 'Osoba prywatna'
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Numer BDO"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: client.bdo ?? '-'
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Numer telefonu"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $790c661e8a1b7309$export$43f8c56ecaed56ba), {
                                                                    phone: client.phone
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: client.email
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Numer NIP"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "user-data",
                                                                children: client.nip
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "button",
                                                    children: userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        type: "primary",
                                                        size: "large",
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {}),
                                                        onClick: ()=>navigate(`/panel/clients/${client.id}`),
                                                        children: "Szczeg\xf3\u0142y klienta"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        userLevel >= (0, $59a068ffb8407501$export$96b5c95c11dc6e9a).admin && !task.takenAt && drivers && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                            title: "Przypisz zadanie kierowcy",
                            width: 876,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "drivers flex flex-dir",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        children: "Kierowca"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                        size: 25,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                size: "large",
                                                value: task.assignedTo ?? assignee,
                                                onChange: (id)=>setAssignee(id),
                                                children: drivers.map((driver)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                        value: driver.id,
                                                        children: [
                                                            driver.name,
                                                            " ",
                                                            driver.surname
                                                        ]
                                                    }, driver.id))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
                                                onClick: ()=>assign(assignee),
                                                disabled: !assignee || assignee === task.assignedTo,
                                                children: "Przypisz"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {}),
                                                danger: true,
                                                onClick: ()=>assign(null).then(()=>setAssignee(undefined)),
                                                disabled: !task.assignedTo,
                                                children: "Anuluj przypisanie"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


const $7b8cf9186ef92772$export$682015456a6b99a6 = (id)=>{
    const [task] = (0, $0110ece14d6be25d$export$cb218309e6e395bf)(id);
    const [order] = (0, $612618a84cedafbf$export$37d0bd824120f782)(task?.orderId);
    const [otherOrders, setOtherOrders] = (0, $acw62.useState)([]);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        if (!order?.clientId || !task) return;
        fetchOtherOrders(order.clientId, task);
    }, [
        order?.clientId,
        task?.id
    ]);
    const fetchOtherOrders = async (clientId, task)=>{
        try {
            if (!order) return;
            const orders = await (0, $4c992464a65faeac$export$2e2bcd8739ae039).orders2.client.toPay(clientId);
            setOtherOrders(orders.filter((o)=>o.id !== task.orderId && o.type === task.orderType));
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} pobra\u{107} danych (${e})`);
        }
    };
    const closeTask = async (dto)=>{
        if (!task) return;
        try {
            await (0, $4c992464a65faeac$export$2e2bcd8739ae039).tasks.close(task.id, dto);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).success("Zadanie zosta\u0142o zamkni\u0119te");
            navigate(-1);
            return true;
        } catch (e) {
            console.error(e);
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error(`Nie uda\u{142}o si\u{119} zamkn\u{105}\u{107} zadania (${e})`);
            return false;
        }
    };
    return {
        task: task,
        order: order,
        otherOrders: otherOrders,
        closeTask: closeTask
    };
};







var $45fvw = parcelRequire("45fvw");


const $c9302e1c5d983366$var$OrdersTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
	height: fit-content;

	> .ant-table-wrapper {
		height: 100%;
	}
`;
const $c9302e1c5d983366$export$26bf47b0c57d72 = ()=>{
    const { id: idRaw } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const id = idRaw ? parseInt(idRaw, 10) : undefined;
    const { order: order, otherOrders: otherOrders, closeTask: closeTask, task: task } = (0, $7b8cf9186ef92772$export$682015456a6b99a6)(id);
    const [paid, setPaid] = (0, $acw62.useState)(false);
    const [selectedOrders, setSelectedOrders] = (0, $acw62.useState)([]);
    const [advance, setAdvance] = (0, $acw62.useState)(false);
    const isAlreadyPaid = order ? order.payments.reduce((acc, p)=>acc + p.amount, 0) >= order.grossPrice : false;
    const alreadyPaid = order ? order.payments.reduce((acc, p)=>acc + p.amount, 0) : 0;
    const otherOrdersWithSelection = (0, $acw62.useMemo)(()=>{
        return otherOrders?.map((order)=>({
                ...order,
                key: `${order.id}-${order.type}`,
                selected: selectedOrders.includes(order.id)
            })) ?? [];
    }, [
        otherOrders,
        selectedOrders
    ]);
    const handleMainOrderChange = (e)=>{
        setPaid(e.target.checked);
        // Reset deposit amount when full payment is selected
        if (e.target.checked) setAdvance(false);
    };
    const handleAdvanceChange = (e)=>{
        setAdvance(e.target.checked);
    };
    const handleOrderSelectionChange = (orderId, checked)=>{
        if (checked) setSelectedOrders((prev)=>[
                ...prev,
                orderId
            ]);
        else setSelectedOrders((prev)=>prev.filter((id)=>id !== orderId));
    };
    const totalPaymentSum = (0, $acw62.useMemo)(()=>{
        if (!order || !otherOrders) return 0;
        let sum = 0;
        // Add main order amount
        if (paid) sum += order.grossPrice - alreadyPaid;
        else if (advance && order.wantedAdvance) sum += order.wantedAdvance;
        // Add other selected orders
        otherOrders.forEach((otherOrder)=>{
            if (selectedOrders.includes(otherOrder.id)) sum += otherOrder.grossPrice - otherOrder.alreadyPaid;
        });
        return sum;
    }, [
        order,
        otherOrders,
        paid,
        selectedOrders,
        advance
    ]);
    const otherOrdersColumns = [
        {
            title: "Op\u0142acone",
            dataIndex: 'selected',
            key: 'selected',
            render: (_, record)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                    checked: selectedOrders.includes(record.id),
                    onChange: (e)=>handleOrderSelectionChange(record.id, e.target.checked)
                })
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address'
        },
        {
            title: 'Cena brutto',
            dataIndex: 'grossPrice',
            key: 'grossPrice',
            render: (_, record)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(record.grossPrice),
                        record.alreadyPaid > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-green-500 ml-2 text-sm",
                            children: [
                                "(zaliczka: ",
                                (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(record.alreadyPaid),
                                ")"
                            ]
                        })
                    ]
                })
        },
        {
            title: 'Data dostawy',
            dataIndex: 'deliveryDate',
            key: 'deliveryDate',
            render: (_, record)=>(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(record.deliveryDate, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(record.deliveryDate).hours() === 0)
        }
    ];
    const handleCloseTask = async ()=>{
        if (!order) return;
        const dto = {
            paidOrders: []
        };
        // Full payment (only for cash payments)
        if (paid && order.wantedPaymentType === (0, $83530e2bf16dcece$export$439d2d6c03747598).cash) dto.paidOrders.push({
            id: order.id,
            type: (0, $b9894ce465f84cba$export$168ff345f0815589).loose
        });
        // Add all the selected orders from otherOrders
        if (otherOrders && selectedOrders.length > 0) otherOrders.forEach((otherOrder)=>{
            if (selectedOrders.includes(otherOrder.id)) dto.paidOrders.push({
                id: otherOrder.id,
                type: otherOrder.type
            });
        });
        if (advance && order.wantedAdvance) dto.advance = order.wantedAdvance;
        return closeTask(dto);
    };
    const actions = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7de0527e6d4b726$export$3956658c2d361270), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f98060e25b81d381$export$2e2bcd8739ae039), {}),
            onClick: handleCloseTask,
            children: "Zrealizuj zadanie"
        }, "0")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c4988417e977609c$export$2e2bcd8739ae039), {
        title: "Terminarz / Realizacja zadania",
        actions: actions,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                title: "Wybrane zam\xf3wienie",
                children: order && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-dir",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-base",
                            children: [
                                "Cena brutto: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "text-blue-500",
                                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.grossPrice)
                                }),
                                alreadyPaid > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-green-500 ml-2",
                                    children: [
                                        "(zaliczka: ",
                                        (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(alreadyPaid),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-4 p-5 bg-gray-50 rounded-lg mt-4",
                            children: [
                                order.wantedPaymentType === (0, $83530e2bf16dcece$export$439d2d6c03747598).cash ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center gap-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                        disabled: isAlreadyPaid,
                                        checked: isAlreadyPaid || paid,
                                        onChange: handleMainOrderChange,
                                        children: alreadyPaid > 0 ? `Klient zap\u{142}aci\u{142}: ${(0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(order.grossPrice - alreadyPaid)}` : "Zam\xf3wienie op\u0142acone w ca\u0142o\u015Bci"
                                    })
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-base text-gray-600 m-0",
                                    children: "(P\u0142atne przelewem)"
                                }),
                                !isAlreadyPaid && !paid && task?.type != (0, $749850eb3cb705e4$export$1f8b1cab05cab788).claiming && !order.onPlace && order.wantedAdvance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-5 flex-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                            checked: advance,
                                            onChange: handleAdvanceChange,
                                            children: "Klient wp\u0142aci\u0142 zaliczk\u0119"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                            type: "text",
                                            placeholder: "0.00",
                                            value: order.wantedAdvance,
                                            // onChange={handleAdvanceChange}
                                            suffix: "PLN",
                                            disabled: paid,
                                            className: "!w-fit"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf34c14753bba3f$export$2e2bcd8739ae039), {
                title: "Zaleg\u0142e zam\xf3wienia",
                children: otherOrders && otherOrders.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9302e1c5d983366$var$OrdersTable, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                                columns: otherOrdersColumns,
                                dataSource: otherOrdersWithSelection,
                                pagination: false,
                                rowKey: "id"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-5 text-center font-bold text-base p-4 border-t border-gray-200",
                            children: [
                                "Suma do pobrania: ",
                                (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(totalPaymentSum),
                                " PLN"
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Brak zaleg\u0142ych zam\xf3wie\u0144 do zap\u0142aty."
                })
            })
        ]
    });
};







var $1d3fce8df7d2c95e$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1d3fce8df7d2c95e$var$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1d3fce8df7d2c95e$exports, "__esModule", {
    value: true
});
$1d3fce8df7d2c95e$exports["default"] = void 0;

var $1d3fce8df7d2c95e$var$_pl_PL = $1d3fce8df7d2c95e$var$_interopRequireDefault((parcelRequire("22SFA")));

var $1d3fce8df7d2c95e$var$_pl_PL2 = $1d3fce8df7d2c95e$var$_interopRequireDefault((parcelRequire("9nP8p")));

var $1d3fce8df7d2c95e$var$_pl_PL3 = $1d3fce8df7d2c95e$var$_interopRequireDefault((parcelRequire("6RzbK")));

var $1d3fce8df7d2c95e$var$_pl_PL4 = $1d3fce8df7d2c95e$var$_interopRequireDefault((parcelRequire("axa8W")));
/* eslint-disable no-template-curly-in-string */ var $1d3fce8df7d2c95e$var$typeTemplate = "${label} nie posiada poprawnej warto\u015Bci dla typu ${type}";
var $1d3fce8df7d2c95e$var$localeValues = {
    locale: 'pl',
    Pagination: $1d3fce8df7d2c95e$var$_pl_PL["default"],
    DatePicker: $1d3fce8df7d2c95e$var$_pl_PL3["default"],
    TimePicker: $1d3fce8df7d2c95e$var$_pl_PL4["default"],
    Calendar: $1d3fce8df7d2c95e$var$_pl_PL2["default"],
    global: {
        placeholder: 'Wybierz'
    },
    Table: {
        filterTitle: 'Menu filtra',
        filterConfirm: 'OK',
        filterReset: "Usu\u0144 filtry",
        filterEmptyText: "Brak filtr\xf3w",
        filterCheckall: 'Wybierz wszystkie elementy',
        filterSearchPlaceholder: 'Szukaj w filtrach',
        emptyText: 'Brak danych',
        selectAll: "Zaznacz bie\u017C\u0105c\u0105 stron\u0119",
        selectInvert: "Odwr\xf3\u0107 zaznaczenie",
        selectNone: "Wyczy\u015B\u0107",
        selectionAll: 'Wybierz wszystkie',
        sortTitle: 'Sortowanie',
        expand: "Rozwi\u0144 wiersz",
        collapse: "Zwi\u0144 wiersz",
        triggerDesc: "Sortuj malej\u0105co",
        triggerAsc: "Sortuj rosn\u0105co",
        cancelSort: "Usu\u0144 sortowanie"
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Anuluj',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Anuluj'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Szukaj',
        itemUnit: 'obiekt',
        itemsUnit: 'obiekty',
        remove: "Usu\u0144",
        selectCurrent: "Wybierz aktualn\u0105 stron\u0119",
        removeCurrent: "Usu\u0144 aktualn\u0105 stron\u0119",
        selectAll: 'Wybierz wszystkie',
        removeAll: "Usu\u0144 wszystkie",
        selectInvert: "Odwr\xf3\u0107 wyb\xf3r"
    },
    Upload: {
        uploading: "Wysy\u0142anie...",
        removeFile: "Usu\u0144 plik",
        uploadError: "B\u0142\u0105d wysy\u0142ania",
        previewFile: 'Podejrzyj plik',
        downloadFile: 'Pobieranie pliku'
    },
    Empty: {
        description: 'Brak danych'
    },
    Icon: {
        icon: 'Ikona'
    },
    Text: {
        edit: 'Edytuj',
        copy: 'Kopiuj',
        copied: 'Skopiowany',
        expand: "Rozwi\u0144"
    },
    PageHeader: {
        back: 'Wstecz'
    },
    Form: {
        optional: '(opcjonalne)',
        defaultValidateMessages: {
            "default": "B\u0142\u0105d walidacji dla pola ${label}",
            required: 'Pole ${label} jest wymagane',
            "enum": "Pole ${label} musi posiada\u0107 warto\u015B\u0107 z listy: [${enum}]",
            whitespace: "Pole ${label} nie mo\u017Ce by\u0107 puste",
            date: {
                format: "${label} posiada z\u0142y format daty",
                parse: "${label} nie mo\u017Ce zosta\u0107 zinterpretowane jako data",
                invalid: "${label} jest niepoprawn\u0105 dat\u0105"
            },
            types: {
                string: $1d3fce8df7d2c95e$var$typeTemplate,
                method: $1d3fce8df7d2c95e$var$typeTemplate,
                array: $1d3fce8df7d2c95e$var$typeTemplate,
                object: $1d3fce8df7d2c95e$var$typeTemplate,
                number: $1d3fce8df7d2c95e$var$typeTemplate,
                date: $1d3fce8df7d2c95e$var$typeTemplate,
                "boolean": $1d3fce8df7d2c95e$var$typeTemplate,
                integer: $1d3fce8df7d2c95e$var$typeTemplate,
                "float": $1d3fce8df7d2c95e$var$typeTemplate,
                regexp: $1d3fce8df7d2c95e$var$typeTemplate,
                email: $1d3fce8df7d2c95e$var$typeTemplate,
                url: $1d3fce8df7d2c95e$var$typeTemplate,
                hex: $1d3fce8df7d2c95e$var$typeTemplate
            },
            string: {
                len: "${label} musi posiada\u0107 ${len} znak\xf3w",
                min: "${label} musi posiada\u0107 co namniej ${min} znak\xf3w",
                max: "${label} musi posiada\u0107 maksymalnie ${max} znak\xf3w",
                range: "${label} musi posiada\u0107 mi\u0119dzy ${min} a ${max} znak\xf3w"
            },
            number: {
                len: "${label} musi mie\u0107 warto\u015B\u0107 o d\u0142ugo\u015Bci ${len}",
                min: "${label} musi mie\u0107 warto\u015B\u0107 wi\u0119ksz\u0105 lub r\xf3wn\u0105 ${min}",
                max: "${label} musi mie\u0107 warto\u015B\u0107 mniejsz\u0105 lub r\xf3wn\u0105 ${max}",
                range: "${label} musi mie\u0107 warto\u015B\u0107 pomi\u0119dzy ${min} a ${max}"
            },
            array: {
                len: "${label} musi posiada\u0107 ${len} element\xf3w",
                min: "${label} musi posiada\u0107 co najmniej ${min} element\xf3w",
                max: "${label} musi posiada\u0107 maksymalnie ${max} element\xf3w",
                range: "${label} musi posiada\u0107 mi\u0119dzy ${min} a ${max} element\xf3w"
            },
            pattern: {
                mismatch: "${label} nie posiada warto\u015Bci zgodnej ze wzorem ${pattern}"
            }
        }
    },
    Image: {
        preview: "Podgl\u0105d"
    }
};
var $1d3fce8df7d2c95e$var$_default = $1d3fce8df7d2c95e$exports["default"] = $1d3fce8df7d2c95e$var$localeValues;



var $45fvw = parcelRequire("45fvw");
var $3798e175c5551adb$exports = {};
//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

(function(global, factory) {
    factory((parcelRequire("45fvw")));
})($3798e175c5551adb$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var monthsNominative = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split('_'), monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split('_'), monthsParse = [
        /^sty/i,
        /^lut/i,
        /^mar/i,
        /^kwi/i,
        /^maj/i,
        /^cze/i,
        /^lip/i,
        /^sie/i,
        /^wrz/i,
        /^paź/i,
        /^lis/i,
        /^gru/i
    ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch(key){
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : "minut\u0119";
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : "godzin\u0119";
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? "miesi\u0105ce" : "miesi\u0119cy");
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }
    var pl = moment.defineLocale('pl', {
        months: function(momentToFormat, format) {
            if (!momentToFormat) return monthsNominative;
            else if (/D MMMM/.test(format)) return monthsSubjective[momentToFormat.month()];
            else return monthsNominative[momentToFormat.month()];
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split('_'),
        weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split('_'),
        weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: "[Dzi\u015B o] LT",
            nextDay: '[Jutro o] LT',
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W niedziel\u0119 o] LT";
                    case 2:
                        return '[We wtorek o] LT';
                    case 3:
                        return "[W \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W sobot\u0119 o] LT";
                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                    case 3:
                        return "[W zesz\u0142\u0105 \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                    default:
                        return "[W zesz\u0142y] dddd [o] LT";
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: "1 dzie\u0144",
            dd: '%d dni',
            w: "tydzie\u0144",
            ww: translate,
            M: "miesi\u0105c",
            MM: translate,
            y: 'rok',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    return pl;
});


const $37313d2f0e79aa0a$var$Main = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { stats: stats, deliveredLooseOrders: deliveredLooseOrders, balance: balance, level: level, admin: admin, showToClaim: showToClaim, showToClaimLoose: showToClaimLoose, showUnclosed: showUnclosed, setShowToClaim: setShowToClaim, setShowToClaimLoose: setShowToClaimLoose, setShowUnclosed: setShowUnclosed } = (0, $f9e7a1c210f4369c$export$9168a42f32e3d071)();
    const driverIcons = [
        {
            label: 'Kontenery',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7413288a2bacf616$export$2e2bcd8739ae039), {}),
            route: '/panel/containers',
            notifications: null
        },
        {
            label: 'Wydatki',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f8ce45decd122a2$export$2e2bcd8739ae039), {}),
            route: '/panel/expenses',
            notifications: null
        },
        {
            label: "Zam\xf3wienia",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24ec3343da8a417c$export$2e2bcd8739ae039), {}),
            route: '/panel/orders',
            notifications: null
        }
    ];
    const adminIcons = [
        {
            label: 'Pracownicy',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1585dc47f665cba4$export$2e2bcd8739ae039), {}),
            route: '/panel/drivers'
        },
        {
            label: 'Klienci',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84e9ccff1d32837e$export$2e2bcd8739ae039), {}),
            route: '/panel/clients'
        },
        {
            label: 'Kontenery',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7413288a2bacf616$export$2e2bcd8739ae039), {}),
            route: '/panel/containers'
        },
        {
            label: 'Wydatki',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f8ce45decd122a2$export$2e2bcd8739ae039), {}),
            route: '/panel/expenses'
        },
        {
            label: 'Terminarz',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21ff6f7f2894ecea$export$2e2bcd8739ae039), {}),
            route: '/panel/tasks',
            notifications: stats?.tasks
        },
        {
            label: "Zam\xf3wienia",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24ec3343da8a417c$export$2e2bcd8739ae039), {}),
            route: '/panel/orders'
        }
    ];
    const bottomIcons = admin ? [
        {
            label: 'Ustawienia',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1caa9be48b381e9f$export$2e2bcd8739ae039), {}),
            route: '/panel/settings'
        },
        {
            label: 'Statystyki',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f887ca94eb88b31$export$2e2bcd8739ae039), {}),
            route: '/panel/stats',
            level: 2
        },
        {
            label: 'Wyloguj',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdd26ad7c91dfa21$export$2e2bcd8739ae039), {}),
            route: '/logout'
        }
    ] : [
        {
            label: 'Ustawienia',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1caa9be48b381e9f$export$2e2bcd8739ae039), {}),
            route: '/panel/settings'
        },
        {
            label: 'Wyloguj',
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdd26ad7c91dfa21$export$2e2bcd8739ae039), {}),
            route: '/logout'
        }
    ];
    const containersToClaim = stats?.to_claim?.map((el)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
            className: "claim-entry",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: el.container.name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: el.size?.name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                    children: [
                        el.order.address,
                        " - ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/clients/${el.client?.id}`,
                            children: el.client?.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate(`/panel/tasks/${el.order.id}/2`)
                    })
                })
            ]
        }, `${el.id}`));
    const bagsToClaim = stats?.to_claim_loose?.map((el)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
            className: "claim-entry",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                    children: [
                        el.address,
                        " - ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/clients/${el.client?.id}`,
                            children: el.client?.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: el.claimingDate ? (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(new Date(el.claimingDate), (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(el.claimingDate).hours() === 0) : '-'
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate(`/panel/orders/${el.id}/${el.type}`)
                    })
                })
            ]
        }, `${el.id}`));
    const unclosed = stats?.unclosed?.map((el)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
            className: "claim-entry",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                    children: [
                        el.address,
                        " - ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/panel/clients/${el.client.id}`,
                            children: el.client.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).epochToDate(new Date(el.deliveryDate), (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(el.deliveryDate).hours() === 0)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f40f87e4967cd996$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate(`/panel/orders/${el.id}/${el.type}`)
                    })
                })
            ]
        }, `${el.id}`));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "panel flex flex-dir flex-jsb",
        children: [
            stats?.to_claim?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "claim",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $572a64029912a579$export$2e2bcd8739ae039), {
                        className: "alert",
                        message: [
                            "Kontenery czekaj\u0105ce na odbi\xf3r:",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "claim",
                                children: stats?.to_claim?.length
                            }, "0")
                        ],
                        banner: true,
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                size: "large",
                                onClick: ()=>setShowToClaim((curr)=>!curr),
                                children: [
                                    showToClaim ? 'Ukryj' : "Poka\u017C",
                                    " kontenery"
                                ]
                            })
                        }),
                        closable: true
                    }),
                    showToClaim && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "toClaim",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Numer"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Rozmiar"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Adres"
                                            })
                                        ]
                                    }),
                                    containersToClaim
                                ]
                            })
                        })
                    })
                ]
            }),
            stats?.to_claim_loose?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "claim",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $572a64029912a579$export$2e2bcd8739ae039), {
                        className: "alert",
                        message: [
                            "Bagi czekaj\u0105ce na odbi\xf3r:",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "claim",
                                children: stats?.to_claim_loose?.length
                            }, "0")
                        ],
                        banner: true,
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                size: "large",
                                onClick: ()=>setShowToClaimLoose((curr)=>!curr),
                                children: [
                                    showToClaim ? 'Ukryj' : "Poka\u017C",
                                    " bagi"
                                ]
                            })
                        }),
                        closable: true
                    }),
                    showToClaimLoose && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "toClaim",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Adres - klient"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Termin odbioru"
                                            })
                                        ]
                                    }),
                                    bagsToClaim
                                ]
                            })
                        })
                    })
                ]
            }),
            stats?.unclosed?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "claim",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $572a64029912a579$export$2e2bcd8739ae039), {
                        className: "alert",
                        message: [
                            "Niezamkni\u0119te zam\xf3wienia:",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "claim",
                                children: stats?.unclosed?.length
                            }, "0")
                        ],
                        banner: true,
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                size: "large",
                                onClick: ()=>setShowUnclosed((curr)=>!curr),
                                children: [
                                    showToClaim ? 'Ukryj' : "Poka\u017C",
                                    " zam\xf3wienia"
                                ]
                            })
                        }),
                        closable: true
                    }),
                    showUnclosed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "toClaim",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Adres - klient"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Data"
                                            })
                                        ]
                                    }),
                                    unclosed
                                ]
                            })
                        })
                    })
                ]
            }),
            admin ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    adminIcons.map((el)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-jc flex-ac",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                                label: el.label,
                                onClick: ()=>navigate(el.route),
                                notifications: el.notifications,
                                children: el.icon
                            }, el.label)
                        }, el.label)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "fast-actions flex flex-jc flex-ac",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                            label: "Kontenery w zam\xf3wieniach",
                            onClick: ()=>navigate('/panel/fast-actions'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7413288a2bacf616$export$2e2bcd8739ae039), {})
                        }, "99")
                    }, "99"),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                            label: "Podstawione bagi",
                            onClick: ()=>navigate('/panel/orders/loose/delivered'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92f281659fda605f$export$2e2bcd8739ae039), {
                                style: {
                                    transform: 'rotate(180deg)'
                                }
                            })
                        }, "999")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-jc flex-ac",
                        children: level > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                            label: "Finanse",
                            onClick: ()=>navigate('/panel/finances'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cdd5a58cfa55afe$export$2e2bcd8739ae039), {})
                        }, "100")
                    }, "100")
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    driverIcons.map((el)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-jc flex-ac",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                                label: el.label,
                                onClick: ()=>navigate(el.route),
                                notifications: el.notifications,
                                children: el.icon
                            }, el.label)
                        }, el.label)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-jc flex-ac",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                            label: "Terminarz",
                            onClick: ()=>navigate('/panel/tasks'),
                            notifications: stats?.tasks,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21ff6f7f2894ecea$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                ]
            }),
            stats && deliveredLooseOrders && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "middle-section flex flex-dir flex-ac",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                        children: [
                            !admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Stan konta:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        style: {
                                            whiteSpace: 'nowrap'
                                        },
                                        children: (0, $4c9b1d6031e12121$export$2e2bcd8739ae039).money(balance)
                                    })
                                ]
                            }, 'balance'),
                            Object.entries(stats.summary.free).map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                            children: [
                                                "Kontenery wolne ",
                                                v.name,
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            children: v.count
                                        })
                                    ]
                                }, k)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Kontenery do podstawienia:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: stats.summary.to_deliver ?? 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Kontenery podstawione:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: stats.summary.delivered ?? 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Kontener\xf3w do wymiany:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: stats.summary.to_replace ?? 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Kontener\xf3w czekaj\u0105cych na odbi\xf3r:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: stats.summary.to_claim ?? 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Kontenery w transporcie:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: stats.summary.in_transit ?? 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Kontenery wypo\u017Cyczone:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: stats.summary.lended ?? 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: "Bagi podstawione:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        children: deliveredLooseOrders.reduce((acc, o)=>acc + o.count, 0)
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            admin ? bottomIcons.map((el)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-jc flex-ac",
                    children: level >= (el.level ?? 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                        label: el.label,
                        onClick: ()=>navigate(el.route),
                        children: el.icon
                    }, el.label)
                }, el.label)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-jc flex-ac",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                            label: "Ustawienia",
                            onClick: ()=>navigate('panel/settings'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1caa9be48b381e9f$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-jc flex-ac",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                            label: "Zamknij kart\u0119",
                            onClick: ()=>navigate(`/panel/drivers/${sessionStorage.getItem('id')}/card`),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5a6b5c7d90a4e65$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-jc flex-ac",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b0b217cbf992c9$export$2e2bcd8739ae039), {
                            label: "Wyloguj",
                            onClick: ()=>navigate('/logout'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdd26ad7c91dfa21$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            })
        ]
    });
};
const $37313d2f0e79aa0a$export$2ddb90ad54e5f587 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        locale: (0, (/*@__PURE__*/$parcel$interopDefault($1d3fce8df7d2c95e$exports))),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($37313d2f0e79aa0a$var$Main, {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/drivers",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $547f8c0c0db6fb68$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/drivers/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2eb35577cc000d87$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/drivers/:id/card",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b653e08b496217a8$export$9baaf3d09362d11a), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/new-driver",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f910fc0cf9ce236f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/containers",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f77e55c227ae33e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/containers/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38b2872f002a5ac7$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/new-container",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c340ea3a8de46d9$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/clients",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84068d221ceff35f$export$1e6b6fbc35803959), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/clients/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03fdc25a7074e1d7$export$b21872969f5a8af6), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/new-client",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3454e82fe1769fcb$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/expenses",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42cf18882dd80726$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/expenses/get-money",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13356b0b3a888c94$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/expenses/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42cf18882dd80726$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/new-expense",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fc0896c29a9a5d0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/orders",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e6ea75b1afac899$export$ed0df17bf864fd7b), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/orders/loose/delivered",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $babfc502ba0d4a2b$export$497d7672911538dd), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/orders/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2b9afe2e105d274$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/orders/:id/:type",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2b9afe2e105d274$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/new-order",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bca8cf32cf717d2e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/tasks",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89f6f74419ab2076$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/tasks/:id/sign",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $088388f0b7df42f6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/tasks/:id/:type",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83bf2bd8b19e8a08$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/v2/tasks/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $513bca1133cbe0d2$export$88edfce46f7be44e), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/v2/tasks/:id/close",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9302e1c5d983366$export$26bf47b0c57d72), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/tasks/:id/:type/:sizeId",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d680ea0c6b704b91$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/task-closing/sign/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c29d0411c1a88c7e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/task-closing/:id/:type/*",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad8d5fde6b7f877a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/settings",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad1039fb32e55ff$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/stats",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd41a1e04ff57680$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/fast-actions",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e25eb245deca293$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/finances",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $749c11fc47e29de8$export$700030ccc27c2c7), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a750ae9c83aadfd$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};




const $6840e8b44f75a905$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $291e7508d6267a86$export$2e2bcd8739ae039), {
        className: "container flex flex-jc flex-ac",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "\u0141adowanie..."
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $401fc7c7dcb14efc$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/passchange",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $822e291ecc8d53b6$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/logout",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $401fc7c7dcb14efc$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/panel/*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37313d2f0e79aa0a$export$2ddb90ad54e5f587), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a750ae9c83aadfd$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        })
    });
};
var $6840e8b44f75a905$export$2e2bcd8739ae039 = $6840e8b44f75a905$var$App;


$07b303fd558e140e$export$2cd8252107eb640b({
    dsn: 'https://cd331d802ac5f9e8f9b7ce38d2b03b3f@o4507250139529216.ingest.de.sentry.io/4507555339239504',
    integrations: [
        $400f75f99113439b$export$b4109253475213e9(),
        $0ca4f63b79e931bd$export$d7706faf7ab354bf()
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    enabled: true
});
const $f85b6d3c5c511c65$var$mountNode = document.getElementById('app');
(0, $7e96a608cb33bf79$export$882461b6382ed46c)($f85b6d3c5c511c65$var$mountNode).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6840e8b44f75a905$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=public.67cd9a51.js.map
